import _assertThisInitialized from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _get from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _createClass from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "F:\\Build Agent 2024\\work\\7eb57b300b9d1525\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
/*
All of the code within the ZingChart software is developed and copyrighted by ZingChart, Inc., and may not be copied,
replicated, or used in any other software or application without prior permission from ZingChart. All usage must coincide with the
ZingChart End User License Agreement which can be requested by email at support@zingchart.com.

Build 2.9.7_ES6
*/
if (typeof ZC === "undefined") {
  window.ZC = {
    AV: function AV(e, t) {
      if (e.indexOf) return e.indexOf(t);
      for (var i = 0, a = e.length; i < a; i++) if (e[i] === t) return i;
      return -1;
    },
    VERSION: "2.9.7",
    VERSIONID: "2.9.7.2021.09.17",
    LICENSEKEY: "",
    ACE: !1,
    CHARTS: ["null", "null3d", "line", "line3d", "vline", "area", "area3d", "varea", "bar", "bar3d", "vbar", "vbar3d", "hbar", "hbar3d", "scatter", "hscatter", "bubble", "hbubble", "pie", "pie3d", "ring", "ring3d", "nestedpie", "mixed", "mixed3d", "hmixed", "radar", "bullet", "vbullet", "hbullet", "funnel", "vfunnel", "hfunnel", "piano", "heatmap", "stock", "range", "vrange", "gauge", "venn"],
    EQUIV: {
      floatbar: ["vfloatbar", "hfloatbar"],
      boxplot: ["vboxplot", "hboxplot"],
      waterfall: ["vwaterfall", "hwaterfall"],
      populationpyramid: ["population-pyramid", "pop-pyramid"],
      bubblepie: ["bubble-pie", "bubblepie"],
      bar: ["column", "vbar"],
      radar: ["polar", "radar"],
      stream: ["vstream"]
    },
    ALIAS: {
      ring: "pie"
    },
    execFn: function execFn(e, t) {
      var i = [].slice.call(arguments).splice(2);
      return ZC.evalFn(e, t).apply(t, i);
    },
    evalFn: function evalFn(e, t) {
      for (var i = e.split("."), a = i.pop(), n = 0; n < i.length; n++) t = t[i[n]];
      return t[a];
    },
    cache: {
      data: {},
      size: 0,
      add: function add(e, t) {
        ZC.cache.data[e] = t, ZC.cache.size++, ZC.cache.size > 2048 && (ZC.cache.data = {}, ZC.cache.size = 0);
      }
    },
    DEBUG: 0,
    TS: {},
    MAX: Number.MAX_VALUE,
    IMG404: [],
    BLANK: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
    TTLOCK: !1,
    REFRESH_TICK: {},
    ASYNC_TICK: [],
    COLORS: [],
    SEQ: 0,
    LOGO_ABOUT: "data:image/png;base64,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",
    IMAGES: {
      "zc.logo": "data:image/gif;base64,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"
    },
    hosted: !1,
    adapter: "",
    flash: null,
    canvas: null,
    svg: null,
    vml: null,
    move: !1,
    objmove: !1,
    compat: function compat() {
      ZC.flash = ZC.canvas = ZC.svg = ZC.vml = !1;
      var e = !!document.createElement("canvas").getContext,
        t = !1;
      e && (t = "function" == typeof document.createElement("canvas").getContext("2d").fillText);
      ZC.canvas = e && t, ZC.svg = document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1");
      var i = document.body.appendChild(document.createElement("div")),
        a = document.createElement("zcv:shape");
      a.className = "zcvml", a.setAttribute("id", "vml_flag1"), a.setAttribute("adj", new Object()), i.appendChild(a), a.style.behavior = "url(#default#VML)", ZC.vml = !a || "object" == typeof a.adj, i.parentNode.removeChild(i);
      var n = !1;
      navigator.mimeTypes && navigator.mimeTypes["application/x-shockwave-flash"] ? n = navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin : document.all && -1 === navigator.appVersion.indexOf("Mac") && (n = new Function('try { var xObj = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");if (xObj) { xObj = null; return true; } } catch (e) { return false; }')()), ZC.flash = n ? 1 : 0;
    },
    quirks: !(document.compatMode && "CSS1Compat" === document.compatMode),
    ie67: !!/MSIE (\d+\.\d+);/.test(navigator.userAgent) && parseFloat(RegExp.$1) < 8,
    ie678: !!/MSIE (\d+\.\d+);/.test(navigator.userAgent) && parseFloat(RegExp.$1) < 9,
    mobile: /Mobile|BlackBerry|Opera Mini|PPC|Windows CE|Android/.test(navigator.userAgent),
    ipad: /iPad/.test(navigator.userAgent),
    iphone: /iPhone/.test(navigator.userAgent),
    websockets: "WebSocket" in window,
    webstorage: "sessionStorage" in window,
    RZ: [],
    XE: [],
    E0: [0, 0],
    ACT: null,
    _cp_: function _cp_(e, t, i, a, n, l) {
      null === ZC._n_(i) && (i = !0), null === ZC._n_(a) && (a = !0), null === ZC._n_(n) && (n = !1);
      var r = (l = l || []).length;
      for (var o in e) if (0 === r || r > 0 && -1 === ZC.AV(l, o)) if (e[o] instanceof Array) {
        if (a) {
          (null === ZC._n_(t[o]) || "override" !== o && !n) && (t[o] = []);
          for (var s = 0, C = e[o].length; s < C; s++) t[o].push(e[o][s]);
        }
      } else e[o] instanceof Object && !(e[o] instanceof Function) ? a && (null === ZC._n_(t[o]) && (t[o] = {}), t[o] instanceof Object && !(t[o] instanceof Function) && ZC._cp_(e[o], t[o], i)) : (null === ZC._n_(t[o]) || i) && (t[o] = e[o]);
    },
    _cpa_: function _cpa_(e, t) {
      t || (t = []);
      for (var i = 0, a = e.length; i < a; i++) t.push(e[i]);
    },
    _inj_: function _inj_(e, t) {
      var i = {};
      ZC._cp_(e, i), ZC._cp_(t, e), ZC._cp_(i, e);
    },
    _todash_: function _todash_(e, t, i) {
      if ("dashed" !== zingchart.SYNTAX) {
        typeof t === ZC._[31] && (t = !0);
        var a,
          n,
          l = (i = i || []).length;
        for (var r in e) if (e.hasOwnProperty(r) && (0 === l || l > 0 && -1 === ZC.AV(i, r))) {
          var o = r.substring(0, 1);
          if ("." !== o && "#" !== o) if (e[r] instanceof Array) {
            if (ZC.VA(r) !== r) {
              for (e[ZC.VA(r)] = [], a = 0, n = e[r].length; a < n; a++) ZC._todash_(e[r][a]), e[ZC.VA(r)].push(e[r][a]);
              delete e[r];
            } else for (a = 0, n = e[r].length; a < n; a++) ZC._todash_(e[r][a]);
          } else e[r] instanceof Object && !(e[r] instanceof Function) ? (ZC.VA(r) !== r && (e[ZC.VA(r)] = {}, ZC._cp_(e[r], e[ZC.VA(r)]), delete e[r]), t && ZC._todash_(e[ZC.VA(r)], t, i)) : ZC.VA(r) !== r && (e[ZC.VA(r)] = e[r], delete e[r]);
        }
      }
    },
    A02: function A02(e, t) {
      for (var i in e) {
        var a;
        if (e.hasOwnProperty(i)) if ((a = i.replace(t + "-", "")) !== i) if (e[a] = e[i], e[i] instanceof Array) for (var n = 0, l = e[i].length; n < l; n++) ZC.A02(e[i][n], t);else e[i] instanceof Object && !(e[i] instanceof Function) && ZC.A02(e[i], t);
      }
    },
    AAN: function AAN(e) {
      for (var t = "", i = 0, a = e.length; i < a; i++) {
        var n = i % 2 == 0 ? i : e.length - i;
        t += e.substring(n, n + 1);
      }
      return t = t.replace(/\./g, "d");
    },
    AD9: function AD9(e) {
      var t = e;
      return t = (t = (t = t.replace("*", "&")).replace("9", "3")).replace("l", "1");
    },
    AA6: function AA6(e) {
      return e.replace(/[a-zA-Z]/g, function (e) {
        return String.fromCharCode((e <= "Z" ? 90 : 122) >= (e = e.charCodeAt(0) + 13) ? e : e - 26);
      });
    },
    ACM: function ACM(e, t) {
      var i = ZC.XM(ZC.ACF(e)),
        a = ZC.XM(ZC.A2T(t)),
        n = i.length;
      if (0 === n) return "";
      for (var l, r, o = i[n - 1], s = i[0], C = 2654435769, A = Math.floor(6 + 52 / n) * C; 0 !== A;) {
        r = A >>> 2 & 3;
        for (var Z = n - 1; Z > 0; Z--) l = ((o = i[Z - 1]) >>> 5 ^ s << 2) + (s >>> 3 ^ o << 4) ^ (A ^ s) + (a[3 & Z ^ r] ^ o), s = i[Z] -= l;
        l = ((o = i[n - 1]) >>> 5 ^ s << 2) + (s >>> 3 ^ o << 4) ^ (A ^ s) + (a[3 & Z ^ r] ^ o), s = i[0] -= l, A -= C;
      }
      return decodeURIComponent(ZC.AC8(ZC.A6E(i)));
    },
    AFV: function AFV(e, t) {
      e = encodeURIComponent(e);
      var i = ZC.XM(ZC.A2T(e)),
        a = ZC.XM(ZC.A2T(t)),
        n = i.length;
      if (0 === n) return "";
      1 === n && (i[n++] = 0);
      for (var l, r, o = i[n - 1], s = i[0], C = Math.floor(6 + 52 / n), A = 0; C-- > 0;) {
        r = (A += 2654435769) >>> 2 & 3;
        for (var Z = 0; Z < n - 1; Z++) l = (o >>> 5 ^ (s = i[Z + 1]) << 2) + (s >>> 3 ^ o << 4) ^ (A ^ s) + (a[3 & Z ^ r] ^ o), o = i[Z] += l;
        l = (o >>> 5 ^ (s = i[0]) << 2) + (s >>> 3 ^ o << 4) ^ (A ^ s) + (a[3 & Z ^ r] ^ o), o = i[n - 1] += l;
      }
      return ZC.AC9(ZC.A6E(i));
    },
    XM: function XM(e) {
      for (var t = new Array(Math.ceil(e.length / 4)), i = 0; i < t.length; i++) t[i] = e[4 * i] + (e[4 * i + 1] << 8) + (e[4 * i + 2] << 16) + (e[4 * i + 3] << 24);
      return t;
    },
    A6E: function A6E(e) {
      for (var t = [], i = 0; i < e.length; i++) t.push(255 & e[i], e[i] >>> 8 & 255, e[i] >>> 16 & 255, e[i] >>> 24 & 255);
      return t;
    },
    AC9: function AC9(e) {
      for (var t = "", i = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"], a = 0; a < e.length; a++) t += i[e[a] >> 4] + i[15 & e[a]];
      return t;
    },
    ACF: function ACF(e) {
      for (var t = [], i = "0x" === e.substr(0, 2) ? 2 : 0; i < e.length; i += 2) t.push(parseInt(e.substr(i, 2), 16));
      return t;
    },
    AC8: function AC8(e) {
      for (var t = "", i = 0; i < e.length; i++) 0 !== e[i] && (t += String.fromCharCode(e[i]));
      return t;
    },
    A2T: function A2T(e) {
      for (var t = [], i = 0; i < e.length; i++) t.push(e.charCodeAt(i));
      return t;
    },
    _i_: function _i_(e) {
      return -1 !== String(e).indexOf("e-") ? 0 : "" === (e = String(e).replace(/[^0-9\.\-]/gi, "")) ? 0 : Math.round(e);
    },
    _f_: function _f_(e) {
      return e = parseFloat(e), isNaN(e) ? 0 : e;
    },
    _x_: function _x_(e, t) {
      return typeof t === ZC._[31] && (t = 2), parseFloat(Number(e).toFixed(t));
    },
    _a_: function _a_(e) {
      return Math.abs(e);
    },
    _b_: function _b_(e) {
      return "false" !== e && "0" !== e && ("true" === e || "1" === e || !!e && !0);
    },
    _p_: function _p_(e) {
      var t = (e = String(e).replace(/[^0-9\.\%\-]/gi, "")).indexOf("%");
      return -1 !== t && (e = e.substring(0, t), e = ZC._f_(e) / 100), e;
    },
    _h_: function _h_(e) {
      return window.toStaticHTML ? window.toStaticHTML(e) : e;
    },
    _n_: function _n_(e) {
      return null === e || typeof e === ZC._[31] ? null : e;
    },
    _c_: function _c_(e, t) {
      return null === e || typeof e === ZC._[31] ? t : e;
    },
    _ang_: function _ang_(e) {
      return (e %= 360) < 0 && (e += 360), e;
    },
    IU: function IU(e, t) {
      return ZC._f_(e) + "" == e + "" ? t ? ZC._f_(e) : ZC._a_(e) : -1 !== (e += "").indexOf("%") ? ZC._f_(e.replace("%", "")) / 100 : -1 !== e.indexOf("px") ? ZC._f_(e.replace("px", "")) : ZC._f_(e);
    },
    R6: function R6(e) {
      return parseInt(e, 16);
    },
    P6: function P6(e) {
      return ZC._i_(e).toString(16);
    },
    _r_: function _r_(e, t) {
      return parseInt(e + (t - e) * Math.random(), 10);
    },
    _l_: function _l_(e, t, i) {
      return e = (e = e < t ? t : e) > i ? i : e;
    },
    DR: function DR(e, t, i, a) {
      return a ? t < e && e < i || i < e && e < t : t <= e && e <= i || i <= e && e <= t;
    },
    BQ: function BQ(e, t) {
      return Math.max(e, t);
    },
    CX: function CX(e, t) {
      return Math.min(e, t);
    },
    A1U: function A1U(e, t) {
      null === ZC._n_(t) && (t = !1);
      for (var i = 0, a = e.length, n = -Number.MAX_VALUE; i < a; i++) t && 0 == e[i] || (n = Math.max(n, e[i]));
      return n;
    },
    YP: function YP(e, t) {
      null === ZC._n_(t) && (t = !1);
      for (var i = 0, a = e.length, n = Number.MAX_VALUE; i < a; i++) t && 0 == e[i] || (n = Math.min(n, e[i]));
      return n;
    },
    _rcolor_: function _rcolor_() {
      for (var e = (16777215 * Math.random() + 1 << 0).toString(16); e.length < 6;) e = "0" + e;
      return "#" + e;
    },
    A9Z: function A9Z(e, t) {
      for (var i, a = ZC._f_(t), n = Number.MAX_VALUE, l = 0, r = 0, o = e.length; r < o; r++) (i = Math.abs(ZC._f_(e[r]) - a)) < n && (l = r, n = i);
      return l;
    },
    AEK: function AEK(e) {
      var t = e.split(".");
      return t[t.length - 1] || "";
    },
    GY: function GY(e) {
      return e.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    },
    G8: function G8(e, t) {
      return t = t || Math.E, isFinite(Math.log(e) / Math.log(t)) ? Math.log(e) / Math.log(t) : 0;
    },
    UE: function UE(e) {
      return 360 * e / (2 * Math.PI);
    },
    TK: function TK(e) {
      return 2 * e * Math.PI / 360;
    },
    EG: function EG(e) {
      return Math.cos(ZC.TK(e));
    },
    EN: function EN(e) {
      return Math.sin(ZC.TK(e));
    },
    PL: function PL(e) {
      return !isNaN(parseFloat(e)) && isFinite(e);
    },
    EE: function EE(e) {
      return -1 !== e.indexOf("-") ? e.replace(/(\-[a-z0-9])/g, function (e) {
        return e.toUpperCase().replace("-", "");
      }) : e;
    },
    VA: function VA(e) {
      return e.toUpperCase() !== e && -1 === e.indexOf("-") && e.substring(0, 1).toLowerCase() === e.substring(0, 1) ? e.replace(/([A-Z])/g, function (e) {
        return "-" + e.toLowerCase();
      }).replace(/([0-9]+)/g, function (e) {
        return "-" + e.toLowerCase();
      }).replace("-3d", "3d") : e;
    },
    AEL: function AEL(e) {
      return ZC.Y5.md5(e);
    },
    AK: function AK(e) {
      return document.getElementById(e);
    },
    A2G: function A2G(e, t) {
      return e[0].length < t[0].length ? 1 : e[0].length > t[0].length ? -1 : 0;
    },
    ZV: function ZV(e) {
      window.setTimeout(e, zingchart.TIMEOUT);
    },
    _fixed_: function _fixed_(e, t) {
      return t >= 0 && t <= 20 ? e.toFixed(t) : "" + e;
    },
    _nfind_: function _nfind_(e, t, i, a) {
      var n = t.S[i].BU,
        l = t.S[a].BU;
      if (e == n) return i;
      if (e == l) return a;
      var r = ZC._i_((i + a) / 2);
      if (!t.S[r]) {
        for (; !t.S[r] && r < a;) r++;
        if (r === a) {
          for (r = ZC._i_((i + a) / 2); !t.S[r] && r > i;) r--;
          if (r === i) return null;
        }
      }
      var o = t.S[r].BU;
      return r !== i && r !== a ? e == o ? r : e > o ? ZC._nfind_(e, t, r, a) : ZC._nfind_(e, t, i, r) : e == o ? r : null;
    },
    _tx_: function _tx_(e) {
      var t,
        i,
        a,
        n,
        l = [1, 1, 0, 0];
      if (zingchart.DEV.LOOKUPCSSTRANSFORM && !ZC.vml && ZC.AK(e)) {
        var r = ZC.AK(e);
        for (t = ""; r && ("" === t || "none" === t);) t = ZC.A5(r).css("transform") || "", r = r.parentNode;
        -1 !== (i = t.indexOf("matrix(")) && (a = t.indexOf(")", i), n = t.substring(i + 7, a - i).split(","), l = [ZC._f_(n[0]), ZC._f_(n[3]), ZC._f_(n[4]), ZC._f_(n[5])]);
      }
      return l;
    },
    Utils_SetupFormat: function Utils_SetupFormat(e, t) {
      return ZC.AQ.OE(e, t);
    },
    Utils_Format: function Utils_Format(e, t, i, a) {
      return ZC.AQ.G5(e, t, i, a);
    },
    Loader_Api_Loader_Info: function Loader_Api_Loader_Info(e) {
      return e.F5();
    }
  }, ZC.hasPassive = !1, ZC.SEC = 1e3, ZC.MIN = 60 * ZC.SEC, ZC.HR = 60 * ZC.MIN, ZC.DAY = 24 * ZC.HR, ZC.MON = 30 * ZC.DAY, ZC.YR = 365 * ZC.DAY, ZC.MAPTX = 0, window.JSON = window.JSON || {}, JSON.stringify = JSON.stringify || function (e) {
    var t = typeof e;
    if ("object" !== t || null === e) return "string" === t && (e = '"' + e.replace("\\", "\\\\").replace('"', '"') + '"'), String(e);
    var i,
      a,
      n = [],
      l = e && e.constructor === Array;
    for (i in e) "function" != typeof e[i] && ("string" === (t = typeof (a = e[i])) ? a = '"' + a.replace("\\", "\\\\").replace('"', '\\"') + '"' : "object" === t && null !== a && (a = JSON.stringify(a)), n.push((l ? "" : '"' + i + '":') + String(a)));
    return (l ? "[" : "{") + String(n) + (l ? "]" : "}");
  }, JSON.parse = JSON.parse || function (L4) {
    return "" === L4 && (L4 = '""'), eval("(" + L4 + ")");
  }, ZC._ = ["background-color", "angle-start", "angle-end", "graphid", "line-width", "values", "-node-area zc-node-area", "placement", "slice", "value", "labels", "series", "decimals", "thousands-separator", "decimals-separator", "-print-c", "graphset", "value-box", "outer", "width", "height", "size", "-hover-c", "enable-guide", "zc-abs zc-layer", "exponent-decimals", "3d-aspect", "x-angle", "y-angle", "z-angle", '" coords="', "undefined", "~rgba(255,255,255,0)", "~rgb(255,255,255)", "-node-area ", "-plotset-plot-", "http://www.w3.org/2000/svg", "http://www.w3.org/1999/xlink", "skip_context_menu", "skip_segment_tracking", "skip_marker_tracking", "skip_interactivity", "use_fast_mode", "use_fast_markers", "use_single_canvas", "If-Modified-Since", "Thu, 1 Jan 1970 00:00:00 GMT", "mousedown", "mousemove", "mouseup", "scale-x", "scale-y", "scale-v", "preservezoom", "toggle-action", "enable-animation", "enable-preview", "margin-top", "margin-right", "margin-bottom", "margin-left", "border-color", "border-width", "Network error", "URL Data loader", "loader.gui.context-menu", "-menu-item-exitfullscreen", "transform-date-format", "transform-date", "bg-image-width", "bg-image-height", "hover-state", "background-state", "selected-state"];
  var ZCClass = function ZCClass() {
    _classCallCheck(this, ZCClass);
  };
  if (ZC.ABB = function (e) {
    this.H = e, this.AA5 = function (e, t) {
      var i,
        a = this,
        n = a.B8.palette;
      if (null !== ZC._n_(t) && null !== ZC._n_(n[t]) && (n = n[t]), null !== ZC._n_(n[e])) {
        var l = n[e];
        return null === ZC._n_(l[2]) && (l[2] = ZC.AQ.R2(l[1], 10)), null === ZC._n_(l[3]) && (l[3] = ZC.AQ.R2(l[1], 10)), l;
      }
      var r = ["#00BAF2", "#E80C60", "#E2D51A", "#9B26AF", "#FB301E", "#00AE4D", "#20398B"];
      i = null !== ZC._n_(r[e - a.B8.palette.length]) ? r[e - a.B8.palette.length] : "#" + ZC.Y5.md5(e).substr(e % 20, 6);
      var o = ZC.AQ.R2(i, 10),
        s = ZC.AQ.R2(i, 20),
        C = "#FFF";
      return a.B8.palette && a.B8.palette[0] && a.B8.palette[0][0] && (C = a.B8.palette[0][0]), [C, i, o, s];
    }, this.A4X = function (e) {
      e && ZC._cp_(e, this.B8, !0);
    }, this.ABD = function (e) {
      var t = this;
      null !== ZC._n_(t.O9[e]) && (ZC._todash_(t.O9[e]), ZC._cp_(t.O9[e], t.B8));
    }, this.O9 = {}, ZC._cp_(zingchart.THEMES, this.O9), this.O9.classic = {
      palette: [["#fff", "#6a921f", "#a7da47", "#89b92e"], ["#fff", "#007fa3", "#00b0e1", "#0392bb"], ["#fff", "#a62b02", "#ef4810", "#cc3300"], ["#fff", "#b79007", "#f9c332", "#da9b04"], ["#fff", "#563d02", "#84680a", "#6e4503"], ["#fff", "#0b32a0", "#4d62b1", "#1540a0"]],
      graph: {
        refresh: {
          curtain: {
            alpha: .5,
            "background-color": "#999",
            color: "#000",
            "font-size": 15,
            bold: 1,
            text: "Loading..."
          }
        },
        "background-color": "#e1eaec #edf3f5",
        title: {
          "font-size": 14,
          bold: 1,
          color: "#fff",
          "background-color": "#00bbf1 #05a0cd",
          padding: 6
        },
        subtitle: {
          "font-size": 11,
          bold: 1,
          color: "#333",
          "margin-top": 30,
          padding: 6
        },
        source: {
          "font-size": 10,
          color: "#333",
          width: "100%",
          bold: 1,
          "text-align": "right",
          height: 20,
          margin: "auto 0 0 auto",
          padding: 5
        },
        nodata: {
          "font-size": 12,
          color: "#333",
          "text-align": "center",
          "vertical-align": "middle",
          text: ""
        },
        SCALE: {
          "font-size": 11,
          "line-width": 2,
          "line-color": "#3e6c7b",
          item: {
            flat: !0
          },
          "ref-line": {
            "line-width": 1,
            "line-color": "#3e6c7b"
          },
          guide: {
            visible: 1,
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#2c4a59",
            alpha: .2
          },
          "minor-guide": {
            visible: 1,
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#aaa",
            alpha: .1
          },
          tick: {
            visible: 1,
            size: 6,
            placement: ZC._[18],
            "line-width": 2,
            "line-color": "#3e6c7b"
          },
          "minor-tick": {
            visible: 1,
            size: 4,
            placement: ZC._[18],
            "line-width": 1,
            "line-color": "#3e6c7b"
          },
          label: {
            color: "#2c4a59",
            flat: !0
          }
        },
        "scroll-x": {
          bar: {
            height: 16
          },
          handle: {
            height: 16
          }
        },
        "scroll-y": {
          bar: {
            width: 16
          },
          handle: {
            width: 16
          }
        },
        legend: {
          "background-color": "#fff",
          "border-width": 1,
          alpha: .75,
          "border-alpha": .75,
          "border-color": "#666",
          "shadow-distance": 3,
          header: {
            padding: "4 6",
            color: "#fff",
            "border-width": 1,
            "border-color": "#3e6c7b",
            "background-color": "#3e6c7b"
          },
          footer: {
            padding: "2 6",
            "background-color": "#ccc",
            "border-width": 1,
            "border-color": "#666"
          },
          marker: {
            "border-color": "#333",
            "border-width": 1
          }
        },
        plot: {
          "value-box": {
            flat: !0
          },
          marker: {
            shadow: 1,
            "line-width": 1,
            "border-width": 1
          },
          "hover-marker": {
            "line-width": 1,
            "border-width": 1
          }
        },
        guide: {
          "line-width": 1,
          "line-color": "#999",
          alpha: 1,
          "scale-label": {
            text: "%l",
            padding: "3 6"
          },
          "plot-label": {
            padding: "3 6"
          }
        }
      },
      line: {
        plot: {
          "shadow-alpha": .5,
          marker: {
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        }
      },
      area: {
        plot: {
          "shadow-alpha": .5,
          marker: {
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        }
      },
      vbar: {
        plot: {
          "fill-angle": 90,
          shadow: 0
        }
      },
      hbar: {
        plot: {
          "fill-angle": 180,
          shadow: 0
        }
      },
      piano: {
        plotarea: {
          "mask-tolerance": [0, 0]
        },
        plot: {
          shadow: 0
        }
      },
      stock: {
        plot: {
          shadow: 0
        }
      },
      vbullet: {
        plot: {
          shadow: 0
        }
      },
      hbullet: {
        plot: {
          "fill-angle": 0,
          shadow: 0
        }
      },
      scatter: {
        plot: {
          marker: {
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        }
      },
      hscatter: {
        plot: {
          marker: {
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        }
      },
      bubble: {
        plot: {
          marker: {
            "border-width": 0
          },
          "hover-marker": {
            "border-width": 0
          }
        }
      },
      hbubble: {
        plot: {
          marker: {
            "border-width": 0
          },
          "hover-marker": {
            "border-width": 0
          }
        }
      },
      pie: {
        plot: {
          "border-width": 1
        }
      },
      nestedpie: {
        plot: {
          "border-width": 1
        }
      },
      radar: {
        plot: {
          marker: {
            size: 3
          },
          "hover-marker": {
            size: 4
          }
        },
        "scale-k": {
          guide: {
            alpha: .5,
            "background-color": "#eee #ddd"
          }
        }
      },
      gauge: {
        "scale-r": {
          "background-color": "-1",
          guide: {
            alpha: .5,
            "background-color": "#eee #ddd"
          },
          item: {
            "offset-r": 0
          },
          ring: {
            size: 1,
            items: [{
              "background-color": "#999",
              alpha: .8
            }, {
              "background-color": "#666",
              alpha: .8
            }]
          }
        }
      },
      vfunnel: {
        plotarea: {
          margin: "50 100"
        },
        SCALE: {
          "line-width": 0,
          tick: {
            "line-width": 0
          },
          "minor-tick": {
            "line-width": 0
          },
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        "scale-y": {
          guide: {
            alpha: .25,
            "background-color": "-1 #58595B"
          }
        },
        "scale-y-n": {
          guide: {
            alpha: .25,
            "background-color": "-1 #58595B"
          }
        },
        plot: {
          "border-width": 1
        }
      },
      hfunnel: {
        plotarea: {
          margin: "50 100"
        },
        "scale-x": {
          label: {
            "font-angle": 270
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        },
        SCALE: {
          "line-width": 0,
          tick: {
            "line-width": 0
          },
          "minor-tick": {
            "line-width": 0
          },
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          },
          guide: {
            alpha: .25,
            "background-color": "#58595B -1"
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          },
          guide: {
            alpha: .25,
            "background-color": "#58595B -1"
          }
        },
        plot: {
          "border-width": 1
        }
      },
      range: {
        plot: {
          marker: {
            type: "circle",
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        }
      },
      line3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 0,
          "line-width": 1
        }
      },
      area3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 0,
          "line-width": 1
        }
      },
      mixed3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 1
        }
      },
      vbar3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 1
        }
      },
      hbar3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 1
        }
      },
      pie3d: {
        plot: {
          "border-width": 1
        }
      },
      "-": ""
    }, this.O9.light = {
      palette: [["#fff", "#29A2CC", "#29A2CC", "#1089B3"], ["#fff", "#D31E1E", "#D31E1E", "#BA0505"], ["#fff", "#7CA82B", "#7CA82B", "#638F12"], ["#fff", "#EF8535", "#EF8535", "#D66C1C"], ["#fff", "#A14BC9", "#A14BC9", "#8832B0"], ["#fff", "#A05F18", "#A05F18", "#874600"], ["#fff", "#265E96", "#265E96", "#0D457D"], ["#fff", "#6B7075", "#6B7075", "#52575C"], ["#fff", "#96C245", "#96C245", "#7CA82B"]],
      graph: {
        refresh: {
          curtain: {
            alpha: .5,
            "background-color": "#999",
            color: "#000",
            "font-size": 15,
            bold: 1,
            text: "Loading..."
          }
        },
        "background-color": "#ffffff",
        title: {
          "font-size": 21,
          bold: 1,
          color: "#414042",
          "background-color": "none",
          padding: 6
        },
        subtitle: {
          "font-size": 11,
          bold: 1,
          color: "#414042",
          "margin-top": 30,
          padding: 6
        },
        source: {
          "font-size": 10,
          color: "#414042",
          width: "100%",
          bold: 1,
          "text-align": "right",
          height: 20,
          margin: "auto 0 0 auto",
          padding: 5
        },
        nodata: {
          "font-size": 12,
          color: "#333",
          "text-align": "center",
          "vertical-align": "middle",
          text: "No Data",
          "background-color": "#BBBBBB",
          alpha: .8
        },
        SCALE: {
          "font-size": 11,
          "line-width": 1,
          "line-color": "#8C8C8C",
          item: {
            "font-size": 12,
            flat: !0,
            color: "#808285"
          },
          "ref-line": {
            "line-width": 1,
            "line-color": "#D1D3D4"
          },
          guide: {
            visible: 1,
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#DCDCDC",
            alpha: 1
          },
          "minor-guide": {
            visible: 1,
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#aaa",
            alpha: .1
          },
          tick: {
            visible: 1,
            size: 5,
            placement: ZC._[18],
            "line-width": 1,
            "line-color": "#8C8C8C"
          },
          "minor-tick": {
            visible: 1,
            size: 3,
            placement: ZC._[18],
            "line-width": 1,
            "line-color": "#A7A9AC"
          },
          label: {
            color: "#414042",
            flat: !0
          }
        },
        "scale-x": {
          normalize: !0,
          guide: {
            visible: !1
          }
        },
        scroll: {
          bar: {
            "background-color": "#F0F1F1",
            margin: 1
          },
          handle: {
            "background-color": "#A7A9AC",
            "border-radius": 6
          }
        },
        "scroll-x": {
          bar: {
            height: 16,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          },
          handle: {
            height: 10,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          }
        },
        "scroll-y": {
          bar: {
            width: 16,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          },
          handle: {
            width: 10,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          }
        },
        "scroll-xi": {
          bar: {
            width: 16,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          },
          handle: {
            width: 10,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          }
        },
        "scroll-yi": {
          bar: {
            height: 16,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          },
          handle: {
            height: 10,
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          }
        },
        preview: {
          "background-color": "#fff",
          "border-width": 1,
          "border-color": "#A7A9AC",
          live: !0,
          mask: {
            "background-color": "#999"
          },
          active: {
            alpha: 0
          },
          handle: {
            width: 11,
            "border-width": 2,
            "border-radius": 3,
            "line-color": "#C6C6C6",
            "border-color": "#A7A9AC",
            "background-color": "#F0F1F1"
          },
          "handle-top": {
            height: 11
          },
          "handle-bottom": {
            height: 11
          }
        },
        tooltip: {
          shadow: 1,
          "shadow-angle": 45,
          "shadow-distance": 1,
          "shadow-alpha": .25,
          "border-width": 1,
          "border-color": "#fff",
          "border-alpha": 1
        },
        zoom: {
          "preserve-zoom": 1,
          "background-color": "#929497"
        },
        legend: {
          "background-color": "#fff",
          "border-width": 1,
          shadow: 0,
          "shadow-alpha": .2,
          alpha: 1,
          "border-alpha": 1,
          "border-color": "#cccccc",
          header: {
            padding: "5 0 5 10",
            color: "#222222",
            "background-color": "none",
            "border-width": 0,
            "border-top": "0px solid none",
            "border-bottom": "1px solid #cccccc"
          },
          footer: {
            padding: "5 0 5 10",
            "border-top": "1px solid #cccccc"
          },
          shader: {
            "background-color": "#F0F1F1",
            "line-color": "#C6C6C6",
            margin: 2,
            height: 8,
            "line-width": 2,
            "line-style": "dotted"
          },
          icon: {
            "line-color": "#C6C6C6",
            "line-width": 2,
            style: "small"
          },
          marker: {
            "border-color": "#fff",
            "border-width": 1
          },
          "page-on": {
            "background-color": "#929497"
          },
          "page-off": {
            "background-color": "#D1D2D3"
          },
          scroll: {
            bar: {
              "background-color": "none",
              "margin-top": 3,
              "margin-bottom": 3
            },
            handle: {
              "background-color": "#D1D2D3",
              "border-top": "none",
              "border-right": "none",
              "border-bottom": "none",
              "border-left": "none",
              "border-radius": 6,
              width: 12,
              height: 12
            }
          }
        },
        plot: {
          "value-box": {
            flat: !0
          },
          marker: {
            shadow: 0,
            "line-width": 1,
            "border-width": 1,
            "border-color": "#fff"
          },
          "hover-marker": {
            "line-width": 1,
            "border-width": 1
          },
          monotone: !0
        },
        guide: {
          "line-width": 1,
          "line-color": "#8C8C8C",
          alpha: 1,
          "scale-label": {
            text: "%l",
            padding: "3 6"
          },
          "plot-label": {
            padding: "3 6"
          }
        }
      },
      line: {
        plot: {
          "line-width": 2,
          shadow: 0,
          marker: {
            size: 4
          },
          "hover-state": {},
          "hover-marker": {
            size: 5,
            "border-width": 1,
            "border-color": "#fff"
          }
        }
      },
      area: {
        plot: {
          "line-width": 2,
          shadow: 0,
          "alpha-area": .25,
          "background-color-style": "solid",
          marker: {
            size: 4
          },
          "hover-state": {},
          "hover-marker": {
            size: 5,
            "border-width": 1,
            "border-color": "#fff"
          }
        }
      },
      vbar: {
        plot: {
          "fill-angle": 90,
          shadow: 0
        }
      },
      hbar: {
        plot: {
          "fill-angle": 180,
          shadow: 0
        }
      },
      piano: {
        plotarea: {
          "mask-tolerance": [0, 0]
        },
        plot: {
          shadow: 0
        },
        "scale-x": {
          guide: {
            visible: !0
          }
        }
      },
      stock: {
        plot: {
          shadow: 0
        }
      },
      vbullet: {
        plot: {
          shadow: 0,
          goal: {
            "border-width": 1,
            "border-color": "#fff",
            height: 8
          }
        }
      },
      hbullet: {
        plot: {
          "fill-angle": 0,
          shadow: 0,
          goal: {
            "border-width": 1,
            "border-color": "#fff",
            width: 8
          }
        }
      },
      scatter: {
        plot: {
          "line-color": "%palette-0",
          "border-color": "%palette-0",
          marker: {
            size: 5
          },
          "hover-marker": {
            size: 6
          }
        },
        "scale-x": {
          guide: {
            visible: !0
          }
        }
      },
      hscatter: {
        plot: {
          "line-color": "%palette-0",
          "border-color": "%palette-0",
          marker: {
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        },
        "scale-x": {
          guide: {
            visible: !0
          }
        }
      },
      bubble: {
        plot: {
          marker: {
            "border-width": 1,
            "border-color": "#fff"
          },
          "hover-marker": {
            "border-width": 1,
            "border-color": "#fff"
          }
        },
        "scale-x": {
          guide: {
            visible: !0
          }
        }
      },
      hbubble: {
        plot: {
          marker: {
            "border-width": 1,
            "border-color": "#fff"
          },
          "hover-marker": {
            "border-width": 1,
            "border-color": "#fff"
          }
        },
        "scale-x": {
          guide: {
            visible: !0
          }
        }
      },
      pie: {
        plot: {
          shadow: 0,
          "border-width": 1,
          "value-box": {
            placement: "in",
            "font-size": 16,
            text: "%node-percent-value%"
          }
        }
      },
      nestedpie: {
        plot: {
          "border-width": 1
        }
      },
      radar: {
        plot: {
          shadow: 0,
          "line-width": 2,
          "background-color": "%palette-1",
          "active-area": !0,
          marker: {
            size: 4
          },
          "hover-marker": {
            size: 5,
            "border-color": "#fff"
          }
        },
        "scale-k": {
          guide: {
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#8C8C8C",
            "line-segment-size": 6,
            "line-gap-size": 6,
            alpha: 1,
            "background-color": "#fff #F7F8F8"
          },
          tick: {
            "line-color": "#8C8C8C",
            "line-width": 1,
            size: 10
          }
        },
        "scale-r": {},
        "scale-v": {
          "ref-line": {
            "line-color": "#8C8C8C",
            "line-width": 1
          },
          tick: {
            "line-color": "#8C8C8C",
            "line-width": 1
          },
          guide: {
            "line-color": "#CDCDCD",
            "line-width": 1
          }
        }
      },
      gauge: {
        plot: {
          shadow: 0
        },
        scale: {
          "size-factor": 1
        },
        "scale-r": {
          aperture: 270,
          tick: {
            size: 11,
            "line-width": 2
          },
          "background-color": -1,
          guide: {
            "background-color": "#fff"
          },
          ring: {
            size: 8,
            "background-color": "#CDCDCD"
          },
          center: {
            size: 20,
            "background-color": "#fff",
            "border-width": 6,
            "border-color": "#1089B3"
          }
        }
      },
      vfunnel: {
        plotarea: {
          margin: "50 100"
        },
        SCALE: {
          "line-width": 0,
          tick: {
            "line-width": 0
          },
          "minor-tick": {
            "line-width": 0
          },
          guide: {
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#CDCDCD",
            "line-segment-size": 6,
            "line-gap-size": 6,
            alpha: 1
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        "scale-x": {
          visible: !1,
          guide: {
            visible: 0
          }
        },
        "scale-y": {
          guide: {
            "background-color": "-1",
            alpha: 1
          }
        },
        "scale-y-n": {
          guide: {
            "background-color": "-1"
          }
        },
        plot: {
          "border-width": 1,
          "border-color": "#fff",
          shadow: 0,
          "hover-state": {
            "line-color": "-1",
            "border-color": "-1"
          }
        }
      },
      hfunnel: {
        plotarea: {
          margin: "50 100"
        },
        "scale-x": {
          visible: !1,
          guide: {
            visible: 0
          },
          label: {
            "font-angle": 270
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        },
        SCALE: {
          "line-width": 0,
          tick: {
            "line-width": 0
          },
          "minor-tick": {
            "line-width": 0
          },
          guide: {
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#CDCDCD",
            "line-segment-size": 6,
            "line-gap-size": 6,
            alpha: 1
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        "scale-y": {
          guide: {
            "background-color": "-1",
            alpha: 1
          },
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          },
          guide: {
            "background-color": "-1"
          }
        },
        plot: {
          "border-width": 1,
          "border-color": "#fff",
          shadow: 0,
          "hover-state": {
            "line-color": "-1",
            "border-color": "-1"
          }
        }
      },
      range: {
        plot: {
          "background-color": "%palette-1",
          marker: {
            type: "circle",
            size: 4
          },
          "hover-marker": {
            size: 5
          }
        }
      },
      line3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 0,
          "line-width": 1
        }
      },
      area3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 0,
          "line-width": 1
        }
      },
      mixed3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 1
        }
      },
      vbar3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 1
        }
      },
      hbar3d: {
        SCALE: {
          "line-color": "#ddd",
          tick: {
            visible: !1
          }
        },
        plot: {
          "border-width": 1
        }
      },
      pie3d: {
        plot: {
          "border-width": 1
        }
      },
      venn: {
        plot: {
          "border-width": 0,
          shadow: 0,
          alpha: .75,
          "background-color": "%palette-1"
        }
      },
      root: {
        gui: {
          "context-menu": {
            visible: !0,
            width: "125px",
            padding: "5 0",
            "background-color": "#595959",
            "border-width": 0,
            "border-color": "#595959",
            position: "left",
            button: {
              visible: ZC.mobile,
              alpha: 0
            },
            gear: {
              "background-color": "#000",
              type: "hamburger",
              alpha: 1
            },
            item: {
              "background-color": "#595959",
              "text-align": "left",
              padding: "4 20 4 15",
              "border-width": 0,
              "border-color": "#595959",
              "font-size": "12px",
              color: "#fff",
              "hover-state": {
                "background-color": "#414141"
              }
            },
            separator: {
              "line-width": 1,
              "line-color": "#969696"
            }
          },
          "context-menu[mobile]": {
            item: {
              padding: "6 10 6 6"
            }
          }
        }
      },
      "-": ""
    }, this.O9.light.graph["crosshair-x"] = this.O9.light.graph["crosshair-y"] = this.O9.light.graph.guide, this.O9.dark = {}, ZC._cp_(this.O9.light, this.O9.dark, !0, !0), ZC._cp_({
      graph: {
        "background-color": "#221F1F",
        title: {
          color: "#fff"
        },
        subtitle: {
          color: "#fff"
        },
        source: {
          color: "#fff"
        },
        SCALE: {
          "line-color": "#D1D3D4",
          item: {
            color: "#D1D3D4"
          },
          "ref-line": {
            "line-color": "#D1D3D4"
          },
          guide: {
            "line-color": "#58595B"
          },
          "minor-guide": {
            "line-color": "#58595B"
          },
          tick: {
            "line-color": "#D1D3D4"
          },
          "minor-tick": {
            "line-color": "#D1D3D4"
          },
          label: {
            color: "#D1D3D4"
          }
        },
        scroll: {
          bar: {
            "background-color": "#6C6D70"
          },
          handle: {
            "background-color": "#A7A9AC"
          }
        },
        "scroll-x": {
          bar: {
            "border-top": "0px solid none",
            "border-right": "2px solid #D1D3D4",
            "border-bottom": "2px solid #D1D3D4",
            "border-left": "2px solid #D1D3D4"
          },
          handle: {
            "border-top": "none",
            "border-right": "none",
            "border-bottom": "none",
            "border-left": "none"
          }
        },
        "scroll-y": {
          bar: {
            "border-top": "2px solid #D1D3D4",
            "border-right": "0px solid none",
            "border-bottom": "2px solid #D1D3D4",
            "border-left": "2px solid #D1D3D4"
          }
        },
        preview: {
          "background-color": "#221F1F"
        },
        tooltip: {
          "border-color": "#000"
        },
        legend: {
          "background-color": "#221F1F",
          header: {
            color: "#fff",
            shader: {
              "background-color": "#414042",
              "line-color": "#676667"
            }
          },
          footer: {
            color: "#D1D3D4",
            "background-color": "#414042",
            "border-top": "0px solid none",
            "border-right": "2px solid #A7A9AC",
            "border-bottom": "2px solid #A7A9AC",
            "border-left": "2px solid #A7A9AC"
          },
          shader: {
            "background-color": "#414042",
            "line-color": "#676667"
          },
          icon: {
            "line-color": "#676667"
          },
          "page-status": {
            color: "#D1D3D4"
          },
          "page-on": {
            "background-color": "#D1D2D3"
          },
          "page-off": {
            "background-color": "#929497"
          },
          marker: {
            "border-color": "#000"
          },
          item: {
            color: "#D1D3D4"
          }
        },
        plot: {
          marker: {
            "border-color": "#221F1F"
          }
        },
        guide: {
          "line-color": "#D1D3D4",
          "scale-label": {
            "background-color": "#929497"
          },
          "plot-label": {
            "background-color": "#221F1F",
            color: "#FFF",
            "border-color": "#5a5a5a"
          }
        }
      },
      line: {
        plot: {
          "hover-marker": {
            "border-color": "#221F1F"
          }
        }
      },
      area: {
        plot: {
          "hover-marker": {
            "border-color": "#221F1F"
          }
        }
      },
      vbullet: {
        plot: {
          goal: {
            "border-color": "#221F1F"
          }
        }
      },
      hbullet: {
        plot: {
          goal: {
            "border-color": "#221F1F"
          }
        }
      },
      bubble: {
        plot: {
          marker: {
            "border-color": "#221F1F"
          },
          "hover-marker": {
            "border-color": "#221F1F"
          }
        }
      },
      hbubble: {
        plot: {
          marker: {
            "border-color": "#221F1F"
          },
          "hover-marker": {
            "border-color": "#221F1F"
          }
        }
      },
      pie: {
        plot: {
          "border-color": "#221F1F"
        }
      },
      radar: {
        plot: {
          "hover-marker": {
            "border-color": "#221F1F"
          }
        },
        "scale-k": {
          guide: {
            "line-color": "#58595B",
            "background-color": "#221F1F #312F30"
          },
          tick: {
            "line-color": "#D1D3D4"
          }
        },
        "scale-v": {
          "ref-line": {
            "line-color": "#58595B"
          },
          tick: {
            "line-color": "#58595B"
          },
          guide: {
            "line-color": "#58595B"
          }
        }
      },
      gauge: {
        "scale-r": {
          guide: {
            "background-color": "#221F1F"
          },
          ring: {
            "background-color": "#57585B"
          }
        }
      },
      vfunnel: {
        SCALE: {
          guide: {
            "line-color": "#58595B"
          }
        },
        plot: {
          "border-color": "#221F1F",
          "hover-state": {
            "line-color": "#58595B",
            "border-color": "#221F1F"
          }
        }
      },
      hfunnel: {
        SCALE: {
          guide: {
            "line-color": "#58595B"
          }
        },
        "scale-y": {
          guide: {
            alpha: .25,
            "background-color": "#b6c8cf -1"
          }
        },
        "scale-y-n": {
          guide: {
            alpha: .25,
            "background-color": "#b6c8cf -1"
          }
        },
        plot: {
          "border-color": "#221F1F",
          "hover-state": {
            "line-color": "#58595B",
            "border-color": "#221F1F"
          }
        }
      },
      root: {
        gui: {
          "context-menu": {
            gear: {
              "background-color": "#FFF"
            }
          }
        }
      },
      "-": ""
    }, this.O9.dark, !0, !0), this.O9.dark.graph["crosshair-x"] = this.O9.dark.graph["crosshair-y"] = this.O9.dark.graph.guide, this.O9.mini = {
      graph: {
        title: {
          width: "100%",
          padding: "1 2 2",
          "font-size": 10
        },
        subtitle: {
          width: "100%",
          padding: "1 2 2",
          "margin-top": 14,
          "font-size": 9
        },
        plotarea: {
          width: "100%",
          height: "100%",
          margin: "18 4 4 4"
        },
        SCALE: {
          visible: 0
        },
        tooltip: {
          shadow: 0,
          "border-radius": 7
        },
        legend: {
          visible: 0
        },
        preview: {
          visible: 0
        },
        guide: {
          "line-width": 1,
          "line-color": "#ccc",
          alpha: 1,
          "scale-label": {
            text: "%l",
            padding: "3 6"
          },
          "plot-label": {
            "border-color": "#ccc",
            "border-radius": 5,
            padding: "3 6"
          }
        },
        plot: {
          shadow: 0,
          "value-box": {
            visible: 0
          },
          "hover-state": {
            visible: 0
          },
          "hover-marker": {
            visible: 0
          },
          "max-trackers": 99999,
          "max-nodes": 99999
        }
      },
      line: {
        plot: {
          "line-width": 1,
          marker: {
            type: "none"
          }
        }
      },
      line3d: {
        "3d-aspect": {
          depth: 20,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0,
          zoom: .9
        }
      },
      area: {
        plot: {
          "line-width": 1,
          marker: {
            type: "none"
          }
        }
      },
      area3d: {
        "3d-aspect": {
          depth: 20,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0,
          zoom: .9
        }
      },
      scatter: {
        SCALE: {
          offset: 5
        },
        plot: {
          marker: {
            size: 3,
            shadow: !1,
            alpha: .8
          }
        }
      },
      hscatter: {
        SCALE: {
          offset: 5
        },
        plot: {
          marker: {
            size: 3,
            shadow: !1,
            alpha: .8
          }
        }
      },
      bubble: {
        SCALE: {
          offset: 15
        },
        plot: {
          marker: {
            "fill-type": "none",
            shadow: !1,
            alpha: .8
          },
          "min-size": 3,
          "max-size": 9
        }
      },
      hbubble: {
        SCALE: {
          offset: 15
        },
        plot: {
          marker: {
            "fill-type": "none",
            shadow: !1,
            alpha: .8
          },
          "min-size": 3,
          "max-size": 9
        }
      },
      pie: {
        plotarea: {
          margin: "18 4 4 4"
        },
        plot: {
          "value-box": {
            visible: 0
          }
        },
        scale: {
          "size-factor": .95
        }
      },
      pie3d: {
        plotarea: {
          margin: "32 4 4 4"
        },
        plot: {
          "value-box": {
            visible: 0
          }
        },
        scale: {
          "size-factor": 1
        }
      },
      nestedpie: {
        plotarea: {
          margin: "18 4 4 4"
        },
        plot: {
          "value-box": {
            visible: 0
          }
        },
        scale: {
          "size-factor": .95
        }
      },
      radar: {
        plotarea: {
          margin: "18 4 4 4"
        },
        plot: {
          "line-width": 1,
          marker: {
            shadow: 0,
            size: 2
          }
        },
        scale: {
          "size-factor": .95
        }
      },
      vbar3d: {
        "3d-aspect": {
          depth: 20,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0,
          zoom: .9
        }
      },
      hbar3d: {
        "3d-aspect": {
          depth: 20,
          angle: 45,
          "x-angle": 0,
          "y-angle": -20,
          "z-angle": 0,
          zoom: .9
        }
      },
      venn: {
        plotarea: {
          margin: "18 4 4 4"
        },
        plot: {
          "border-width": 0
        }
      },
      gauge: {
        plotarea: {
          margin: "18 4 4 4"
        },
        plot: {
          indicator: [5]
        },
        SCALE: {
          visible: 1
        },
        scale: {
          "size-factor": .9
        },
        "scale-r": {
          "background-color": "-1",
          aperture: 270,
          tick: {
            visible: 0
          },
          item: {
            visible: 0
          },
          guide: {
            visible: 0
          },
          ring: {
            size: 6,
            "background-color": "#CDCDCD",
            items: []
          },
          center: {
            "border-width": 0,
            size: 2,
            "background-color": "#fff"
          }
        }
      },
      vfunnel: {
        plotarea: {
          margin: "18 4 4 4"
        }
      },
      hfunnel: {
        plotarea: {
          margin: "18 4 4 4"
        }
      },
      vbullet: {
        plot: {
          "bar-space": .5,
          goal: {
            "border-width": 0,
            height: 4
          }
        }
      },
      hbullet: {
        plot: {
          "bar-space": .5,
          goal: {
            "border-width": 0,
            width: 4
          }
        }
      },
      range: {
        plot: {
          "line-width": 1,
          marker: {
            visible: 0
          },
          "hover-state": {
            visible: 0
          }
        }
      },
      "-": ""
    }, this.O9.negative = {
      palette: [["#000", "#909090", "#969696", "#9c9c9c"], ["#000", "#a0a0a0", "#a6a6a6", "#acacac"], ["#000", "#b0b0b0", "#b6b6b6", "#bcbcbc"], ["#000", "#c0c0c0", "#c6c6c6", "#cccccc"], ["#000", "#d0d0d0", "#d6d6d6", "#dcdcdc"], ["#000", "#e0e0e0", "#e6e6e6", "#ececec"], ["#000", "#f0f0f0", "#f6f6f6", "#fcfcfc"]],
      graph: {
        "background-color": "#111",
        title: {
          color: "#fff"
        },
        subtitle: {
          color: "#333"
        },
        SCALE: {
          "font-size": 11,
          "line-width": 2,
          "line-color": "#ccc",
          guide: {
            visible: 1,
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#ccc",
            alpha: .2
          },
          "minor-guide": {
            visible: 1,
            "line-width": 1,
            "line-style": "solid",
            "line-color": "#ccc",
            alpha: .2
          },
          tick: {
            visible: 1,
            size: 6,
            placement: ZC._[18],
            "line-width": 2,
            "line-color": "#ccc"
          },
          "minor-tick": {
            visible: 1,
            size: 4,
            placement: ZC._[18],
            "line-width": 1,
            "line-color": "#ccc"
          },
          label: {
            color: "#fff"
          },
          item: {
            color: "#fff"
          }
        }
      },
      radar: {
        "scale-k": {
          guide: {
            alpha: .5,
            "background-color": "#222 #333"
          }
        }
      },
      "-": ""
    }, this.O9.spark = this.O9.mini, this.B8 = {
      root: {
        gui: {
          behaviors: [{
            id: "PageScroll",
            enabled: "all"
          }, {
            id: "ViewSource",
            enabled: "all"
          }, {
            id: "BugReport",
            enabled: "none"
          }, {
            id: "LogScale",
            enabled: "none"
          }, {
            id: "LinScale",
            enabled: "none"
          }, {
            id: "FullScreen",
            enabled: "none"
          }, {
            id: "3D",
            enabled: "none"
          }, {
            id: "ExportData",
            enabled: "none"
          }, {
            id: "SaveAsImageJPG",
            enabled: "none"
          }, {
            id: "DownloadCSV",
            enabled: ZC.ie678 ? "none" : "all"
          }, {
            id: "DownloadXLS",
            enabled: ZC.ie678 ? "none" : "all"
          }],
          watermark: {
            type: 1,
            position: "rb"
          },
          history: {
            margin: "10 auto auto 10",
            width: 30,
            height: 22,
            padding: 4,
            item: {
              "background-color": "#369",
              "border-width": 1,
              "border-color": "#69c"
            },
            "item-off": {
              "background-color": "#eee",
              "border-color": "#ddd"
            }
          },
          progress: {
            "background-color": "#fff",
            color: "#000"
          },
          "context-menu": {
            padding: 0,
            "border-width": 1,
            "border-color": "#000",
            button: {
              visible: ZC.mobile,
              margin: "5 auto auto 5",
              alpha: .8,
              "background-color": "#333 #999",
              "border-radius": 8,
              width: 40,
              height: 40
            },
            gear: {
              "background-color": "#fff #f6f6f6",
              type: "gear6",
              alpha: .8
            },
            item: {
              "background-color": "#36393D",
              "text-align": "left",
              padding: "4 20 4 8",
              "border-width": 1,
              "border-color": "#000",
              color: "#fff",
              "hover-state": {
                "background-color": "#0084AA"
              }
            },
            separator: {
              "line-width": 1,
              "line-color": "#000000"
            }
          },
          "context-menu[mobile]": {
            item: {
              padding: "6 10 6 6"
            }
          }
        }
      },
      palette: [],
      graph: {
        title: {
          width: "100%",
          bold: 1,
          "font-size": 13
        },
        subtitle: {
          width: "100%",
          bold: 1,
          "font-size": 11
        },
        scroll: {
          bar: {
            "background-color": "#e1eaec",
            "border-color": "#ddd"
          },
          handle: {
            "background-color": "#ddd",
            "border-color": "#ccc",
            "border-width": 2,
            "border-top": "2px solid #eee",
            "border-left": "2px solid #eee",
            "border-right": "2px solid #999",
            "border-bottom": "2px solid #999"
          }
        },
        "scroll-x": {
          bar: {
            height: 16
          },
          handle: {
            height: 16
          }
        },
        "scroll-y": {
          bar: {
            width: 16
          },
          handle: {
            width: 16
          }
        },
        "scroll-xi": {
          bar: {
            width: 16
          },
          handle: {
            width: 16
          }
        },
        "scroll-yi": {
          bar: {
            height: 16
          },
          handle: {
            height: 16
          }
        },
        preview: {
          width: "100%",
          height: 50,
          margin: "auto 50 20 50",
          "border-width": 1,
          shadow: 0,
          "background-color": "#f0f0f0",
          "border-color": "#999",
          mask: {
            alpha: .5,
            "background-color": "#333"
          },
          active: {
            alpha: .1,
            "background-color": "#999"
          },
          handle: {
            width: 9,
            height: 16,
            "border-width": 1,
            "line-width": 1,
            "line-color": "#111",
            "border-color": "#444",
            "border-radius": 2,
            "background-color": "#e6e6e6"
          },
          "handle-top": {
            width: 16,
            height: 9
          },
          "handle-bottom": {
            width: 16,
            height: 9
          }
        },
        "preview[yx]": {
          width: 50,
          height: "100%",
          margin: "20 auto 50 20"
        },
        plotarea: {
          width: "100%",
          height: "100%",
          margin: "60 50 65 50"
        },
        "plotarea[preview]": {
          margin: "60 50 105 50"
        },
        SCALE: {
          "line-width": 1,
          guide: {
            "line-width": 1,
            "line-color": "#ddd"
          },
          tick: {
            size: 6,
            "line-width": 2
          },
          "minor-guide": {
            "line-width": 1,
            "line-color": "#ddd"
          },
          "minor-tick": {
            size: 4,
            "line-width": 1
          },
          label: {
            bold: 1,
            padding: 6,
            flat: !0
          },
          item: {
            padding: 2,
            "auto-align": !0,
            flat: !0
          },
          marker: {
            "line-width": 1,
            "line-color": "#000",
            "background-color": "#ccc"
          },
          "transform[date]": {
            item: {
              "font-size": 10,
              padding: 2,
              color: "#000",
              "background-color": "#fff"
            }
          }
        },
        "SCALE[3d]": {
          "background-color": "#ccc"
        },
        "scale-y[default]": {
          label: {
            "font-angle": 270
          },
          item: {
            "text-align": "right"
          }
        },
        "scale-y[opposite]": {
          label: {
            "font-angle": 90
          },
          item: {
            "text-align": "left"
          }
        },
        plot: {
          error: {
            "line-width": 1,
            "line-color": "#333",
            size: .5
          },
          "value-box": {
            flat: !0,
            text: "%v",
            bold: 1,
            placement: "auto",
            shadow: 1
          },
          "tooltip-text": "%v",
          shadow: 1,
          "line-width": 1,
          marker: {
            type: "square",
            shadow: 1
          },
          "highlight-state": {
            shadow: !0,
            "shadow-blur": 2,
            "shadow-distance": 1,
            "shadow-alpha": .91
          }
        },
        tooltip: {
          shadow: 1,
          padding: "4 8",
          "shadow-distance": 3,
          "offset-y": ZC.mobile ? -40 : -20
        },
        "tooltip[dynamic]": {
          padding: "4 8",
          "offset-y": 0
        },
        guide: {
          marker: {
            type: "circle"
          },
          "plot-label[single]": {
            text: '<b style="color:%color">%plot-text:</b> %node-value',
            padding: 10,
            "background-color": "#fff #eee",
            "border-width": 1,
            "border-color": "#999",
            color: "#000",
            "text-align": "left"
          },
          "plot-label[multiple]": {
            text: '<b style="color:%color">%plot-text:</b> %node-value',
            padding: 5,
            "background-color": "#fff #eee",
            "border-width": 1,
            "border-color": "#999",
            color: "#000",
            "text-align": "left"
          }
        },
        zoom: {
          "preserve-zoom": 1,
          "border-width": 0,
          "background-color": "#369",
          alpha: .25,
          label: {
            visible: !1,
            "background-color": "#fff",
            "font-size": 10,
            padding: 2,
            "border-width": 1,
            "border-color": "#999"
          }
        },
        arrow: {
          "border-width": 1,
          "border-color": "#000",
          "background-color": "#666",
          size: 4
        },
        "legend[position]": {
          margin: 10
        },
        legend: {
          "background-color": "#eee",
          alpha: 1,
          shadow: 1,
          margin: "10 10 auto auto",
          padding: "4 2 4 2",
          item: {
            "text-align": "left",
            margin: "2 6 2 4",
            padding: "2 4"
          },
          "item-off": {
            alpha: .25
          },
          marker: {
            shadow: 0,
            size: 6,
            "border-color": "#999",
            "border-width": 1
          },
          header: {
            "font-size": 12,
            "text-align": "left",
            bold: 1
          },
          footer: {
            "text-align": "left"
          },
          icon: {
            "line-color": "#000",
            "line-width": 1
          },
          "page-status": {
            color: "#000"
          },
          "page-on": {
            "background-color": "#f90"
          },
          "page-off": {
            "background-color": "#999"
          },
          scroll: {
            bar: {
              width: 12,
              height: 12,
              "background-color": "#e1eaec",
              "border-color": "#ddd"
            },
            handle: {
              width: 12,
              height: 12,
              "background-color": "#ddd",
              "border-color": "#ccc",
              "border-width": 2,
              "border-top": "2px solid #eee",
              "border-left": "2px solid #eee",
              "border-right": "2px solid #999",
              "border-bottom": "2px solid #999"
            }
          }
        }
      },
      vbar: {
        plot: {
          "value-box": {
            placement: "top-out"
          }
        }
      },
      vbar3d: {
        plot: {
          "value-box": {
            placement: "top-out"
          }
        },
        "3d-aspect": {
          depth: 40,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0
        }
      },
      mixed3d: {
        "3d-aspect": {
          depth: 40,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0
        }
      },
      hbar: {
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x[default]": {
          label: {
            "font-angle": 270
          }
        },
        "scale-x[opposite]": {
          label: {
            "font-angle": 90
          }
        },
        plot: {
          "value-box": {
            placement: "top-out"
          }
        }
      },
      vline: {
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x[default]": {
          label: {
            "font-angle": 270
          }
        },
        "scale-x[opposite]": {
          label: {
            "font-angle": 90
          }
        }
      },
      varea: {
        plot: {
          "fill-angle": 0
        },
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x[default]": {
          label: {
            "font-angle": 270
          }
        },
        "scale-x[opposite]": {
          label: {
            "font-angle": 90
          }
        }
      },
      hbar3d: {
        "scale-y": {
          label: {
            "font-angle": 0
          }
        },
        "scale-x": {
          label: {
            "font-angle": 270
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        },
        "3d-aspect": {
          depth: 40,
          angle: 45,
          "x-angle": 0,
          "y-angle": -20,
          "z-angle": 0
        },
        plot: {
          "value-box": {
            placement: "top-out"
          }
        }
      },
      hbullet: {
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x": {
          label: {
            "font-angle": 270
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        }
      },
      line: {
        plot: {
          "line-width": 4,
          marker: {
            type: "circle",
            size: 4
          }
        }
      },
      area: {
        plot: {
          "line-width": 4,
          marker: {
            type: "circle",
            size: 4
          },
          "value-box": {
            placement: "top"
          }
        }
      },
      line3d: {
        "3d-aspect": {
          depth: 40,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0
        },
        plot: {
          "border-width": 1,
          "line-width": 1,
          marker: {
            type: "circle",
            size: 4,
            alpha: 1,
            visible: 0
          }
        }
      },
      area3d: {
        "3d-aspect": {
          depth: 40,
          angle: 45,
          "x-angle": -20,
          "y-angle": 0,
          "z-angle": 0
        },
        plot: {
          "border-width": 1,
          "line-width": 1,
          marker: {
            type: "circle",
            size: 4,
            alpha: 1,
            visible: 0
          },
          "value-box": {
            placement: "top"
          }
        }
      },
      scatter: {
        SCALE: {
          offset: 10
        },
        plot: {
          marker: {
            type: "circle",
            size: 4
          },
          "value-box": {
            placement: "top"
          }
        }
      },
      poly: {
        SCALE: {
          offset: 10
        },
        plot: {
          "alpha-area": .4,
          marker: {
            type: "none"
          },
          "value-box": {
            placement: "top"
          }
        }
      },
      hscatter: {
        SCALE: {
          offset: 10
        },
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x": {
          label: {
            "font-angle": 270
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        },
        plot: {
          marker: {
            type: "circle",
            size: 4
          },
          "value-box": {
            placement: "top"
          }
        }
      },
      bubble: {
        SCALE: {
          offset: 40
        },
        plot: {
          marker: {
            type: "circle",
            "fill-type": "radial",
            "fill-offset-x": -.2,
            "fill-offset-y": -.2
          },
          "hover-marker": {
            "fill-type": "radial",
            "fill-offset-x": -.2,
            "fill-offset-y": -.2
          },
          "value-box": {
            placement: "middle",
            text: "%node-size-value"
          },
          "tooltip-text": "%node-size-value"
        }
      },
      hbubble: {
        SCALE: {
          offset: 40
        },
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x": {
          label: {
            "font-angle": 270
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        },
        plot: {
          marker: {
            type: "circle",
            "fill-type": "radial",
            "fill-offset-x": -.2,
            "fill-offset-y": -.2
          },
          "hover-marker": {
            "fill-type": "radial",
            "fill-offset-x": -.2,
            "fill-offset-y": -.2
          },
          "value-box": {
            placement: "middle",
            text: "%node-size-value"
          },
          "tooltip-text": "%node-size-value"
        }
      },
      hmixed: {
        "scale-y": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x": {
          label: {
            "font-angle": 270
          }
        },
        "scale-y-n": {
          label: {
            "font-angle": 0
          },
          item: {
            "text-align": "center"
          }
        },
        "scale-x-n": {
          label: {
            "font-angle": 90
          }
        }
      },
      pie: {
        plotarea: {
          margin: "35 5 5 5"
        },
        scale: {
          "size-factor": "auto",
          "line-width": 0,
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        plot: {
          "fill-type": "radial",
          "value-box": {
            connector: {
              "line-width": 1
            },
            placement: "out",
            text: "%t",
            visible: 1
          }
        }
      },
      pie3d: {
        "3d-aspect": {
          "x-angle": 38,
          "y-angle": 0,
          "z-angle": 0
        },
        plotarea: {
          margin: "25 5 5 5"
        },
        scale: {
          "size-factor": "auto",
          "line-width": 0,
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        plot: {
          "fill-type": "linear",
          "value-box": {
            connector: {
              "line-width": 1
            },
            placement: "out",
            text: "%t",
            visible: 1
          }
        }
      },
      nestedpie: {
        plotarea: {
          margin: "40 5 15 5"
        },
        scale: {
          "size-factor": .8,
          "line-width": 0,
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          }
        },
        plot: {
          "fill-type": "radial",
          "value-box": {
            connector: {
              "line-width": 1
            },
            text: "%t",
            visible: 1
          }
        }
      },
      venn: {
        plotarea: {
          margin: "30 10 10 10"
        },
        plot: {
          alpha: .5,
          "border-width": 4
        },
        scale: {
          "size-factor": .65,
          "line-width": 0,
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          }
        }
      },
      radar: {
        SCALE: {
          guide: {
            "line-width": 1,
            "line-color": "#999",
            "background-color": "-1"
          },
          tick: {
            "line-width": 1
          },
          item: {
            "auto-align": !1
          }
        },
        scale: {
          visible: 0,
          "size-factor": .7
        },
        "scale-k": {
          "ref-angle": 270
        },
        plotarea: {
          margin: "40 5 5 5"
        },
        plot: {
          "line-width": 4,
          aspect: "line",
          marker: {
            type: "circle"
          }
        }
      },
      gauge: {
        SCALE: {
          guide: {
            "border-width": 1,
            "border-color": "#999",
            "background-color": "-1"
          }
        },
        scale: {
          "line-width": 0,
          guide: {
            "line-width": 0
          },
          "minor-guide": {
            "line-width": 0
          },
          "size-factor": .7
        },
        "scale-r": {
          "ref-angle": 270,
          "background-color": "#fff",
          guide: {
            "line-width": 0
          },
          tick: {
            placement: "inner"
          },
          item: {
            "offset-r": "-45%"
          }
        },
        plot: {
          size: "85%"
        },
        plotarea: {
          margin: "40 5 5 5"
        }
      },
      stock: {
        plot: {
          "line-width": 1,
          "border-width": 1,
          "tooltip-text": "Open:&nbsp;$%open<br>High:&nbsp;$%high<br>Low:&nbsp;$%low<br>Close:&nbsp;$%close"
        }
      },
      range: {
        plot: {
          "line-width": 2,
          "value-box": {
            text: "%node-min-value - %node-max-value"
          },
          "tooltip-text": "%node-min-value - %node-max-value"
        }
      },
      "-": ""
    }, this.PX = function (e, t) {
      var i,
        a = this,
        n = !1;
      return null !== ZC._n_(i = a.B8.graph[e]) && null !== ZC._n_(i.enabled) && (n = n || ZC._b_(i.enabled)), null !== ZC._n_(a.B8[t]) && null !== ZC._n_(i = a.B8[t][e]) && null !== ZC._n_(i.enabled) && (n = n || ZC._b_(i.enabled)), n;
    }, this.load = function (e, t, i, a) {
      var n,
        l,
        r,
        o = this;
      i = null === ZC._n_(i) || ZC._b_(i), a = null !== ZC._n_(a) && ZC._b_(a), t instanceof Array || (t = new Array(t));
      var s = [],
        C = "";
      for (l = 0, r = t.length; l < r; l++) if (/(\(\w+\))(.*)/.test(t[l])) {
        var A = RegExp.$1;
        C = t[l].replace(A, "graph"), -1 === ZC.AV(s, C) && s.push(C), C = t[l].replace(A, A.substring(1, A.length - 1)), -1 === ZC.AV(s, C) && s.push(C);
      } else -1 === ZC.AV(s, t[l]) && s.push(t[l]), /root(.*)/.test(t[l]) && -1 === ZC.AV(s, t[l].replace("root", "loader")) && s.push(t[l].replace("root", "loader")), /loader(.*)/.test(t[l]) && -1 === ZC.AV(s, t[l].replace("loader", "root")) && s.push(t[l].replace("loader", "root"));
      var Z = {};
      for (l = 0, r = s.length; l < r; l++) {
        for (var c = s[l].split("."), p = o.B8, u = 0, h = c.length; u < h; u++) if (null !== ZC._n_(n = p[c[u]])) p = n;else if (null !== ZC._n_(n = p[ZC.VA(c[u])])) p = n;else {
          if (null === ZC._n_(n = p[ZC.EE(c[u])])) {
            p = null;
            break;
          }
          p = n;
        }
        if (p) for (var _ in p) null !== ZC._n_(p[_]) && (a || "object" != typeof p[_] || p[_].length) && (i || null === ZC._n_(e[_]) ? o.H.RA && null !== ZC._n_(o.H.RA[_]) || (Z[_] = p[_]) : i && "object" == typeof p[_] && (o.H.RA && null !== ZC._n_(o.H.RA[_]) || (Z[_] = p[_])));
      }
      ZC._cp_(Z, e);
    };
  }, ZC.AQ = {
    AGL: function AGL(e, t) {
      for (var i = [], a = 0, n = e.p.length; a < n; a++) if (e.p[a]) {
        var l = (e.p[a][0] - e.x) / e.w,
          r = (e.p[a][1] - e.y) / e.h;
        i.push([t.x + t.w * l, t.y + t.h * r]);
      } else i.push(null);
      return {
        l: t.w * e.l / e.w,
        r: t.w * e.r / e.w,
        p: i
      };
    },
    ACJ: function ACJ(e, t, i) {
      var a = document.getElementsByTagName("head")[0],
        n = document.createElement("script");
      n.type = "text/javascript", n.src = t + "?v" + ZC.VERSION;
      var l = !1;
      n.onload = n.onreadystatechange = function () {
        if (!(l || this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState)) {
          l = !0, n.onload = n.onreadystatechange = null, a && n.parentNode && a.removeChild(n);
          var e = new RegExp("zingchart-(.+?).min.js", "g").exec(t);
          e && ZC.XE.push(e[1]), i && i(t);
        }
      }, n.onerror = function () {
        !e && zingchart.I8[0] && (e = zingchart.I8[0]), e ? e.NG({
          name: ZC._[63],
          message: "Resource not found (" + n.src + ")"
        }, "Module loader") : alert("Resource not found (" + n.src + ")");
      }, a.insertBefore(n, a.firstChild);
    },
    _rcolor_: function _rcolor_() {
      return "#" + ZC.Y5.md5(ZC._r_(0, 99999)).substr(ZC._r_(0, 20), 6);
    },
    XC: function XC() {},
    A8I: function A8I(e, t) {
      return zingchart[e] || t && t.A1R && t.A1R[e] || zingchart.hasEvent(null, e) || t && zingchart.hasEvent(t.K, e);
    },
    BZ: function BZ(e, t, i, a, n) {
      i instanceof Array || (i = [i]);
      var l = 1;
      return null !== ZC._n_(a) && i.push(a), n && (l = 2, i.push(n)), "touchstart" === e && (e = ZC._[47]), "touchend" === e && (e = ZC._[49]), "touchmove" === e && (e = ZC._[48]), zingchart[e] && "render" !== e && (null !== ZC._n_(a) ? i[i.length - l] = zingchart[e].apply(zingchart, i) : zingchart[e].apply(zingchart, i)), t && t.A1R[e] && (null !== ZC._n_(a) ? i[i.length - l] = t.A1R[e].apply(zingchart, i) : t.A1R[e].apply(zingchart, i)), zingchart.hasEvent(null, e) && (null !== ZC._n_(a) ? i[i.length - l] = zingchart.callEvent(null, e, i, a) : zingchart.callEvent(null, e, i)), t && zingchart.hasEvent(t.K, e) && (null !== ZC._n_(a) ? i[i.length - l] = zingchart.callEvent(t.K, e, i, a) : zingchart.callEvent(t.K, e, i)), i[i.length - l];
    },
    OG: function OG(e, t) {
      if (t.A9 % 360 != 0) {
        for (var i = [[-t.I / 2, -t.F / 2], [t.I / 2, -t.F / 2], [t.I / 2, t.F / 2], [-t.I / 2, t.F / 2]], a = "", n = 0; n < 4; n++) i[n] = [t.iX + t.I / 2 + t.BM + ZC.MAPTX + i[n][0] * ZC.EG(t.A9) - i[n][1] * ZC.EN(t.A9), t.iY + t.F / 2 + t.BH + ZC.MAPTX + i[n][0] * ZC.EN(t.A9) + i[n][1] * ZC.EG(t.A9)], a += ZC._i_(i[n][0]) + "," + ZC._i_(i[n][1]) + ",";
        return t.D = i, ZC.Q.G2("poly", t.E8, t.J3) + 'class="' + e + '-label-area zc-label-area" id="' + t.K + "-area" + ZC._[30] + a.substring(0, a.length - 1) + '" />';
      }
      return ZC.Q.G2("rect", t.E8, t.J3) + 'class="' + e + '-label-area zc-label-area" id="' + t.K + "-area" + ZC._[30] + ZC._i_(t.iX + t.BM + ZC.MAPTX) + "," + ZC._i_(t.iY + t.BH + ZC.MAPTX) + "," + ZC._i_(t.iX + t.BM + t.I + ZC.MAPTX) + "," + ZC._i_(t.iY + t.BH + t.F + ZC.MAPTX) + '" />';
    },
    NC: function NC(e) {
      var t,
        i = "",
        a = e.indexOf('id="');
      if (-1 !== a) {
        var n = e.indexOf('"', a + 4);
        -1 !== n && (i = e.substring(a + 4, n));
      }
      if (ZC.cache.data["area-score-" + i]) return ZC.cache.data["area-score-" + i];
      var l = 0;
      if (-1 !== e.indexOf('shape="rect"') ? (l += 1e4, 5 === (t = /coords=\"(\-*\d+),(\-*\d+),(\-*\d+),(\-*\d+)\"/.exec(e)).length && (l += (ZC._i_(t[3]) - ZC._i_(t[1])) * (ZC._i_(t[4]) - ZC._i_(t[2])))) : -1 !== e.indexOf('shape="circle"') ? (l += 100, t = /coords=\"(\-*\d+),(\-*\d+),(\-*\d+)\"/.exec(e), null !== ZC._n_(t[3]) && (l += ZC._i_(t[3]) / 10)) : -1 !== e.indexOf('shape="poly"') ? -1 !== e.indexOf("data-map") ? l += 1e6 : l += 1e3 : l += 1, -1 !== e.indexOf("data-z-sort")) {
        var r = /data-z-sort=\"(\-*\d+)\"/.exec(e);
        r && 2 === r.length && (l *= ZC._i_(Math.pow(10, ZC._i_(r[1]))));
      }
      return "" !== i && ZC.cache.add("area-score-" + i, l), l;
    },
    A67: function A67(e, t, i) {
      for (var a = [], n = 0, l = e.length; n < l; n++) if (null !== ZC._n_(e[n])) {
        var r = e[n].slice(0);
        null !== ZC._n_(r[0]) && "string" != typeof r[0] && (r[0] += t), null !== ZC._n_(r[1]) && "string" != typeof r[1] && (r[1] += i), null !== ZC._n_(r[2]) && "string" != typeof r[2] && r.length <= 4 && (r[2] += t), null !== ZC._n_(r[3]) && "string" != typeof r[3] && r.length <= 4 && (r[3] += i), a.push(r);
      } else a.push(null);
      return a;
    },
    OE: function OE(e, t) {
      var i;
      t = t || {}, e = e || {};
      var a = {};
      if (null !== ZC._n_(i = e.negation) && (a.negation = i), null !== ZC._n_(i = e.short) && (a.short = ZC._b_(i)), null !== ZC._n_(i = e["short-unit"]) && (a["short-unit"] = i), null !== ZC._n_(i = e.exponent) && (a.exponent = ZC._b_(i)), null !== ZC._n_(i = e[ZC._[25]]) && (a[ZC._[25]] = ZC._i_(i)), null !== ZC._n_(i = e[ZC._[14]]) ? a[ZC._[14]] = i : null === ZC._n_(t[ZC._[14]]) && null !== ZC._n_(i = ZC.HQ[ZC._[14]]) && (a[ZC._[14]] = i), null !== ZC._n_(i = e[ZC._[13]]) ? a[ZC._[13]] = i : null === ZC._n_(t[ZC._[13]]) && null !== ZC._n_(i = ZC.HQ[ZC._[13]]) && (a[ZC._[13]] = i), null !== ZC._n_(i = e[ZC._[12]]) && (a[ZC._[12]] = ZC._i_(i)), null !== ZC._n_(i = e["decimals-dyn"]) && (a["decimals-dyn"] = i), null !== ZC._n_(i = e.transform) && null !== ZC._n_(i.type)) switch (i.type) {
        case "date":
          a[ZC._[68]] = !0, null !== ZC._n_(i.text) && (i.all = i.text), null !== ZC._n_(i.all) && (a[ZC._[67]] = i.all);
      }
      return a;
    },
    G5: function G5(e, t, i, a) {
      var n,
        l = e,
        r = e + "",
        o = !1;
      if (a && null !== ZC._n_(t[ZC._[68]]) && t[ZC._[68]] && "" + Number(r) === r && (r = ZC.AQ.YX(Number(r), t[ZC._[67]], t.utc, t.timezone), o = !0), null === ZC._n_(t[ZC._[14]]) && null !== ZC._n_(e = ZC.HQ[ZC._[14]]) && (t[ZC._[14]] = e), null === ZC._n_(t[ZC._[13]]) && null !== ZC._n_(e = ZC.HQ[ZC._[13]]) && (t[ZC._[13]] = e), null !== ZC._n_(t[ZC._[12]]) && -1 !== t[ZC._[12]] && typeof t["max-decimals"] !== ZC._[31] && -1 !== t["max-decimals"] && (t[ZC._[12]] = ZC.BQ(t["max-decimals"], t[ZC._[12]])), !o) if (null !== ZC._n_(t.exponent) && t.exponent) r = Number(r).toExponential(ZC.CX(20, t[ZC._[25]])), null !== ZC._n_(t[ZC._[14]]) && (r = r.replace(/\./g, t[ZC._[14]]));else {
        if (null !== ZC._n_(t.short) && t.short) {
          n = "";
          var s = t["short-unit"] || "";
          if ("string" != typeof s && s.length) {
            "" + ZC._f_(s[0]) !== s[0] && (s = [1e3].concat(s));
            for (var C = 1, A = s[0] || 1e3, Z = s.slice(1), c = null, p = 0; p < Z.length; p++) 0 === Z[p].indexOf("#") && (c = p, Z[p] = Z[p].substring(1));
            if (Z.length) {
              if (null !== c) C = c;else if (null !== ZC._n_(t["max-power"])) C = t["max-power"];else {
                var u = ZC.G8(ZC._a_(Number(r)), A);
                C = Math.floor(u), C = ZC.CX(C, Z.length - 1);
              }
              n = Z[C];
              var h = (r = "" + Number(r) / Math.pow(A, C)).split(".");
              2 === h.length && h[1].length >= 9 && (r = null !== ZC._n_(t[ZC._[12]]) && -1 !== t[ZC._[12]] ? "" + ZC._x_(r, t[ZC._[12]]) : "" + ZC._x_(r));
            }
          } else {
            var _ = ZC.G8(ZC._a_(Number(r))) / Math.LN10;
            switch (ZC._a_(Number(r))) {
              case 1e3:
                _ = 3;
                break;
              case 1e6:
                _ = 6;
                break;
              case 1e9:
                _ = 9;
            }
            if (null !== ZC._n_(t["max-power"]) && (_ = 3 * t["max-power"]), "KB" === s.toUpperCase()) r = "" + Number(r) / 1024, n = "KB";else if ("MB" === s.toUpperCase()) r = "" + Number(r) / 1048576, n = "MB";else if ("GB" === s.toUpperCase()) r = "" + Number(r) / 1073741824, n = "GB";else if ("TB" === s.toUpperCase()) r = "" + Number(r) / 1099511627776, n = "TB";else if ("PB" === s.toUpperCase()) r = "" + Number(r) / 0x4000000000000, n = "PB";else if (_ >= 0 && _ < 3) switch (s) {
              default:
                r = r, n = "";
                break;
              case "K":
                r = "" + Number(r) / 1e3, n = "K";
                break;
              case "M":
                r = "" + Number(r) / 1e6, n = "M";
                break;
              case "B":
                r = "" + Number(r) / 1e9, n = "B";
            } else _ >= 3 && _ < 6 && "" === s || "K" === s.toUpperCase() ? (r = "" + Number(r) / 1e3, n = "K") : _ >= 6 && _ < 9 && "" === s || "M" === s.toUpperCase() ? (r = "" + Number(r) / 1e6, n = "M") : (_ >= 9 && "" === s || "B" === s.toUpperCase()) && (r = "" + Number(r) / 1e9, n = "B");
          }
          if (ZC.PL(r)) if (null !== ZC._n_(t[ZC._[12]]) && -1 !== t[ZC._[12]]) r = ZC._fixed_(Number(r), ZC.BQ(0, ZC._i_(t[ZC._[12]])));else {
            var d = r.split(".")[1] || "";
            -1 !== t["max-decimals"] && t["max-decimals"] < d.length && (r = ZC._fixed_(Number(r), ZC.BQ(0, ZC._i_(t["max-decimals"]))));
          }
          null !== ZC._n_(t[ZC._[14]]) && (r = r.replace(/\./g, t[ZC._[14]]));
        }
        var f = i ? i.K : "";
        if (!isNaN(r) && ("string" != typeof l || -1 === f.indexOf("-scale-"))) {
          if (null !== ZC._n_(t[ZC._[12]]) && -1 !== t[ZC._[12]] && ZC.PL(r) && (null !== ZC._n_(t.short) && t.short || (r = ZC._fixed_(Number(r), ZC.BQ(0, ZC._i_(t[ZC._[12]]))))), null !== ZC._n_(t[ZC._[13]]) || null !== ZC._n_(t[ZC._[14]])) {
            for (var g = r.split("."), B = "", v = 0, m = g[0].length; v < m; v++) {
              var b = g[0].substring(v, v + 1);
              B += b, -1 === ZC.AV(["-", "+"], b) && (g[0].length - v - 1) % 3 == 0 && g[0].length - v - 1 != 0 && (B += t[ZC._[13]]);
            }
            r = B + (null !== ZC._n_(g[1]) ? t[ZC._[14]] + g[1] : "");
          }
          null !== ZC._n_(t.short) && t.short && (r += n);
        }
      }
      return r;
    },
    AAT: function AAT(e) {
      var t = e.indexOf("("),
        i = "",
        a = "";
      -1 !== t ? (i = ZC.GY(e.substring(0, t)), a = ZC.GY(e.substring(t + 1, e.length - 1))) : i = ZC.GY(e);
      var n = [],
        l = "";
      if ("" !== a) {
        var r = !1,
          o = !1,
          s = !1;
        l = "";
        for (var C = 0, A = a.length; C < A; C++) {
          var Z = a.substring(C, C + 1);
          switch (Z) {
            case "\\":
              s ? (l += "\\", s = !1) : s = !0;
              break;
            case '"':
              s ? (l += '"', s = !1) : o ? (n.push(l), l = "", o = !1) : r ? l += Z : o = !0;
              break;
            case "'":
              s ? (l += "'", s = !1) : r ? (n.push(l), l = "", r = !1) : o ? l += Z : r = !0;
              break;
            case " ":
              (r || o) && (l += Z);
              break;
            case ",":
              r || o ? l += Z : ("" !== l && n.push(l), l = "");
              break;
            default:
              l += Z;
          }
        }
      }
      return "" !== l && n.push(l), [i, n];
    },
    A5O: function A5O(e) {
      return e.toString().replace(/^([0-9])$/, "0$1");
    },
    YX: function YX(e, t, i, a) {
      e = ZC._i_(e), t = t || ZC.HQ["date-formats"].minute, typeof i === ZC._[31] && (i = !1), typeof a === ZC._[31] && (a = 0), i && (e += 36e5 * a);
      var n,
        l,
        r,
        o,
        s,
        C,
        A,
        Z,
        c = new Date();
      c.setTime(e), i ? (n = c.getUTCHours(), l = c.getUTCMinutes(), r = c.getUTCSeconds(), o = c.getUTCMilliseconds(), s = c.getUTCDay(), C = c.getUTCDate(), A = c.getUTCMonth(), Z = c.getUTCFullYear()) : (n = c.getHours(), l = c.getMinutes(), r = c.getSeconds(), o = c.getMilliseconds(), s = c.getDay(), C = c.getDate(), A = c.getMonth(), Z = c.getFullYear());
      for (var p = [["mm", ZC.AQ.A5O(A + 1)], ["dd", ZC.AQ.A5O(C)], ["Y", Z], ["y", Z.toString().substr(2, 2)], ["F", ZC.HQ["months-long"][A]], ["m", A + 1], ["M", ZC.HQ["months-short"][A]], ["n", A], ["d", C], ["D", ZC.HQ["days-short"][s]], ["j", C], ["l", ZC.HQ["days-long"][s]], ["N", s + 1], ["w", s], ["S", function () {
          return C % 10 == 1 ? "st" : C % 10 == 2 ? "nd" : C % 10 == 3 ? "rd" : "th";
        }], ["a", n < 12 ? "am" : "pm"], ["A", n < 12 ? "AM" : "PM"], ["g", n % 12 || 12], ["G", n], ["h", ZC.AQ.A5O(n % 12 || 12)], ["H", ZC.AQ.A5O(n)], ["i", ZC.AQ.A5O(l)], ["s", ZC.AQ.A5O(r)], ["q", o]], u = 0; u < p.length; u++) t = t.replace("%" + p[u][0], p[u][1]);
      return t;
    },
    A14: {},
    Z4: function Z4(e, t) {
      var i = null;
      if (t && t.BP ? i = t.BP : t && t.A && t.A.BP && (i = t.A.BP), "string" == typeof e && -1 !== e.indexOf("%color-") && ZC.COLORS.length > 0) for (var a = 0; a < ZC.COLORS.length; a++) -1 === e.indexOf("(+") && -1 === e.indexOf("(-") || (e = e.replace(/%color-(\d+?)\((\+|\-)(\d+?)\)/gi, function () {
        var e = ZC.AQ.GE(ZC.COLORS[ZC._i_(arguments[1])]);
        return "+" === arguments[2] ? e = ZC.AQ.R2(e, ZC._i_(arguments[3])) : "-" === arguments[2] && (e = ZC.AQ.JP(e, ZC._i_(arguments[3]))), e;
      })), e = e.replace("%color-" + a, ZC.COLORS[a]);else "string" == typeof e && i && -1 !== e.indexOf("%palette-") && (e = i[ZC._i_(e.replace("%palette-", ""))]);
      return e;
    },
    GE: function GE(e, t) {
      var i, a, n, l;
      if (null !== ZC._n_(ZC.AQ.A14[e])) return ZC.AQ.A14[e];
      var r = ZC.GY(String(e)),
        o = 1,
        s = !1;
      return 0 === r.length ? "" : ("rgba(" === (r = r.replace("0x", "#")).substring(0, 5) ? (i = new RegExp("rgba\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3}),\\s*([0-9.]+)\\)", "gi").exec(r)) && (1 === (a = ZC.P6(i[1])).length && (a = "0" + a), 1 === (n = ZC.P6(i[2])).length && (n = "0" + n), 1 === (l = ZC.P6(i[3])).length && (l = "0" + l), r = "#" + a + n + l, o = ZC.BQ(0, ZC.CX(1, parseFloat(i[4]))), s = !0) : "rgb(" === r.substring(0, 4) ? (i = new RegExp("rgb\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\)", "gi").exec(r)) && (1 === (a = ZC.P6(i[1])).length && (a = "0" + a), 1 === (n = ZC.P6(i[2])).length && (n = "0" + n), 1 === (l = ZC.P6(i[3])).length && (l = "0" + l), r = "#" + a + n + l) : "#" === r.substring(0, 1) ? 4 === r.length ? r = "#" + r.substring(1, 2) + r.substring(1, 2) + r.substring(2, 3) + r.substring(2, 3) + r.substring(3, 4) + r.substring(3, 4) : 7 !== r.length && (r = "") : null !== ZC._n_(ZC.Q.AAE[r.toUpperCase()]) && (r = "#" + ZC.Q.AAE[r.toUpperCase()]), "none" !== r && "transparent" !== r || (r = "-1"), t || (ZC.AQ.A14[e] = r), t && s ? [r, o] : r);
    },
    A24: {},
    A3D: function A3D(e, t) {
      if (-1 === e && (e = "#ffffff", t = 0), null !== ZC._n_(ZC.AQ.A24[e + "," + t])) return ZC.AQ.A24[e + "," + t];
      4 === e.length && (e = e.substring(0, 1) + e.substring(1, 2) + e.substring(1, 2) + e.substring(2, 3) + e.substring(2, 3) + e.substring(3, 4) + e.substring(3, 4));
      var i = "rgba(" + [ZC.R6(e.substring(1, 3)), ZC.R6(e.substring(3, 5)), ZC.R6(e.substring(5, 7)), t].join(",") + ")";
      return ZC.AQ.A24[e + "," + t] = i, i;
    },
    AD4: function AD4(e, t, i) {
      e /= 255, t /= 255, i /= 255;
      var a,
        n,
        l,
        r = Math.max(e, t, i),
        o = Math.min(e, t, i);
      l = r;
      var s = r - o;
      if (n = 0 === r ? 0 : s / r, r === o) a = 0;else {
        switch (r) {
          case e:
            a = (t - i) / s + (t < i ? 6 : 0);
            break;
          case t:
            a = (i - e) / s + 2;
            break;
          case i:
            a = (e - t) / s + 4;
        }
        a /= 6;
      }
      return [a, n, l];
    },
    AD5: function AD5(e, t, i) {
      var a,
        n,
        l,
        r = Math.floor(6 * e),
        o = 6 * e - r,
        s = i * (1 - t),
        C = i * (1 - o * t),
        A = i * (1 - (1 - o) * t);
      switch (r % 6) {
        case 0:
          a = i, n = A, l = s;
          break;
        case 1:
          a = C, n = i, l = s;
          break;
        case 2:
          a = s, n = i, l = A;
          break;
        case 3:
          a = s, n = C, l = i;
          break;
        case 4:
          a = A, n = s, l = i;
          break;
        case 5:
          a = i, n = s, l = C;
      }
      return [255 * a, 255 * n, 255 * l];
    },
    JP: function JP(e, t) {
      if (-1 === e) return -1;
      if (t >= 100) return "#000000";
      e = ZC.AQ.GE(e), typeof t === ZC._[31] && (t = 10);
      var i = ZC.R6(e.substring(1, 3)),
        a = ZC.R6(e.substring(3, 5)),
        n = ZC.R6(e.substring(5, 7)),
        l = ZC.AQ.AD4(i, a, n);
      l[2] = t > 0 ? Math.max(0, l[2] - l[2] * t / 100) : Math.min(1, l[2] - l[2] * t / 100);
      var r = ZC.AQ.AD5(l[0], l[1], l[2]);
      return r[0] = ZC._i_(r[0]) < 16 ? "0" + ZC.P6(r[0]) : ZC.P6(r[0]), r[1] = ZC._i_(r[1]) < 16 ? "0" + ZC.P6(r[1]) : ZC.P6(r[1]), r[2] = ZC._i_(r[2]) < 16 ? "0" + ZC.P6(r[2]) : ZC.P6(r[2]), e = "#" + r[0] + r[1] + r[2];
    },
    R2: function R2(e, t) {
      if (-1 === e) return -1;
      if (t >= 100) return "#ffffff";
      e = ZC.AQ.GE(e), typeof t === ZC._[31] && (t = 10);
      var i = parseInt(e.substr(1, 2), 16),
        a = parseInt(e.substr(3, 2), 16),
        n = parseInt(e.substr(5, 2), 16);
      return "#" + (0 | 256 + i + (256 - i) * t / 100).toString(16).substr(1) + (0 | 256 + a + (256 - a) * t / 100).toString(16).substr(1) + (0 | 256 + n + (256 - n) * t / 100).toString(16).substr(1);
    },
    _hex2rgb_: function _hex2rgb_(e, t) {
      var i = parseInt(e.substr(1, 2), 16),
        a = parseInt(e.substr(3, 2), 16),
        n = parseInt(e.substr(5, 2), 16);
      return ZC._n_(t) ? "rgb(" + i + "," + a + "," + n + ")" : {
        r: i,
        g: a,
        b: n
      };
    },
    _rgb2hex_: function _rgb2hex_(e, t, i) {
      return "#" + ((1 << 24) + (e << 16) + (t << 8) + i).toString(16).slice(1);
    },
    AA8: function AA8(e, t, i) {
      var a = ZC.AQ._hex2rgb_(e);
      return (299 * a.r + 587 * a.g + 114 * a.b) / 1e3 >= 128 ? i : t;
    },
    _colorAlpha_: function _colorAlpha_(e, t, i) {
      e = ZC.AQ.GE(e), t = ZC.AQ.GE(t);
      var a = ZC.AQ._hex2rgb_(e),
        n = ZC.AQ._hex2rgb_(t),
        l = {};
      for (var r in a) l[r] = Math.floor(i * a[r] + (1 - i) * n[r]);
      return ZC.AQ._rgb2hex_(l.r, l.g, l.b);
    },
    A48: function A48() {},
    ABX: function ABX() {},
    gc: function gc(e, t) {
      var i;
      for (i = 0; i < t.length; i++) e[t[i]] = null;
      for (i in e) 0 === i.indexOf("zc_") && "function" == typeof e[i] && (e[i] = null);
    }
  }, ZC.Q = {
    AAE: {
      BLACK: "000000",
      BLUE: "0000FF",
      BROWN: "A52A2A",
      CYAN: "00FFFF",
      FUCHSIA: "FF00FF",
      GOLD: "FFD700",
      GRAY: "808080",
      GREEN: "008000",
      INDIGO: "4B0082",
      LIME: "00FF00",
      MAGENTA: "FF00FF",
      MAROON: "800000",
      NAVY: "000080",
      ORANGE: "FFA500",
      PINK: "FFC0CB",
      PURPLE: "800080",
      RED: "FF0000",
      SILVER: "C0C0C0",
      TURQUOISE: "40E0D0",
      VIOLET: "EE82EE",
      WHITE: "FFFFFF",
      YELLOW: "FFFF00"
    },
    G2: function G2(e, t, i) {
      return "<area" + (i && !t && "hand" !== i ? ' style="cursor:' + i + '"' : "") + (t && "arrow" !== i || "hand" === i ? ' href="javascript:;"' : "") + ' shape="' + e + '" ';
    },
    ABO: function ABO(e) {
      var t;
      if (ZC.A5.browser.msie) try {
        t = document.createElement("<iframe />");
      } catch (o) {
        t = document.createElement("iframe");
      } else t = document.createElement("iframe");
      t.id = e.id + "-iframe", t.style.visibility = "hidden", e.appendChild(t);
      var i = null,
        a = t.contentWindow || t.contentDocument;
      if (!(i = a.document ? a.document : a).body) {
        var n = i.createElement("HTML");
        i.appendChild(n);
        var l = i.createElement("HEAD");
        n.appendChild(l);
        var r = i.createElement("BODY");
        n.appendChild(r);
      }
      return i;
    },
    BX: function BX(e) {
      var t;
      if (typeof ZC.TOUCHEVENTS === ZC._[31]) {
        if (ZC.ie678) t = !1;else {
          t = !0;
          try {
            document.createEvent("TouchEvent");
          } catch (i) {
            t = !1;
          }
        }
        t && !ZC.mobile && (t = !1), t && (t = "ontouchstart" in document.documentElement), ZC.TOUCHEVENTS = t;
      } else t = ZC.TOUCHEVENTS;
      if (t) switch (e) {
        case "mouseover":
        case "mousedown":
          e = "touchstart";
          break;
        case "mousemove":
          e = "touchmove";
          break;
        case "mouseout":
        case "mouseup":
          e = "touchend";
          break;
        case "click":
          e = "touchstart";
      }
      return e;
    },
    _sh_: function _sh_(e, t) {
      var i,
        a,
        n,
        l = [],
        r = t.K1,
        o = t.OS,
        s = t.PJ,
        C = r - s / 2;
      if (e.length > 0) {
        var A = 0,
          Z = 0;
        for (0 !== r && (A = ZC._i_(C * ZC.EG(o) + s), Z = ZC._i_(C * ZC.EN(o) + s)), i = 0, a = e.length; i < a; i++) if (null !== ZC._n_(e[i])) {
          var c = [];
          for (n = 0; n < e[i].length; n++) c[n] = e[i][n];
          var p = c.length;
          if (2 === p || 4 === p) for (n = 0; n < p; n++) c[n] = e[i][n] + (n % 2 ? Z + ZC._c_(t.BH, 0) : A + ZC._c_(t.BM, 0));
          l.push(c);
        } else l.push(null);
      }
      return l;
    },
    _txp_: function _txp_(e, t, i, a, n) {
      typeof n === ZC._[31] && (n = !1);
      var l,
        r,
        o = [e[0], e[1]];
      switch (e.length >= 4 && (o[2] = e[2], o[3] = e[3]), e.length >= 6 && (o[4] = e[4], o[5] = e[5]), 7 === e.length && (o[6] = e[6]), t) {
        case "canvas":
        case "svg":
          var s, C;
          if (i.CY) s = C = i.AZ % 2 == 1 ? .5 : 0, ZC.A5.browser.msie && ZC.quirks && "svg" === t && (s = i.AZ % 2 == 1 ? .5 : 0, C = i.AZ % 2 == 1 ? 0 : .5), o[0] = Math.round(o[0]) - s, o[1] = Math.round(o[1]) - C, 4 === o.length && (o[2] = Math.round(o[2]) - s, o[3] = Math.round(o[3]) - C);
          "svg" === t && (o[0] = parseFloat(o[0].toFixed(4)), o[1] = parseFloat(o[1].toFixed(4)), 4 === o.length && (o[2] = parseFloat(o[2].toFixed(4)), o[3] = parseFloat(o[3].toFixed(4)))), "canvas" !== t || a || typeof i.BM !== ZC._[31] && typeof i.BH !== ZC._[31] && (o[0] += i.BM, o[1] += i.BH, 4 === o.length && (o[2] += i.BM, o[3] += i.BH));
          break;
        case "vml":
          i.A9 % 360 == 0 ? (l = 10, r = i.AZ % 2 == 1 ? 0 : l / 2) : (l = 1, r = 0), i.CY ? (o[0] = l * ZC._i_(ZC._i_(l * o[0]) / l) - r, o[1] = l * ZC._i_(ZC._i_(l * o[1]) / l) - r, 4 !== o.length && 7 !== o.length || (o[2] = l * ZC._i_(ZC._i_(l * o[2]) / l) - r, o[3] = l * ZC._i_(ZC._i_(l * o[3]) / l) - r), 7 === o.length && (o[4] = l * ZC._i_(ZC._i_(l * o[4]) / l) - r, o[5] = l * ZC._i_(ZC._i_(l * o[5]) / l) - r)) : (o[0] = ZC._i_(l * o[0]), o[1] = ZC._i_(l * o[1]), 4 !== o.length && 7 !== o.length || (o[2] = ZC._i_(l * o[2]), o[3] = ZC._i_(l * o[3])), 7 === o.length && (o[4] = ZC._i_(l * o[4]), o[5] = ZC._i_(l * o[5])));
      }
      return o;
    },
    A3B: function A3B(e, t, i, a, n) {
      var l, r, o, s, C, A, Z;
      if (i.QY && (i.E["fast-vector-path"] = !0), !i.E["fast-vector-path"]) {
        for (l = 0, r = e.length; l < r; l++) e[l] && (e[l][0] = parseFloat(Number(e[l][0]).toFixed(2)), e[l][1] = parseFloat(Number(e[l][1]).toFixed(2)));
        if (i.OI && (Z = i.K + ":" + i.A9 + ":" + e.join("#"), ZC.cache.data["path-points-" + Z])) return ZC.cache.data["path-points-" + Z].split("#");
      }
      var c = [ZC.MAX, ZC.MAX, -ZC.MAX, -ZC.MAX],
        p = [],
        u = !1;
      for (l = 0, r = e.length; l < r; l++) if (null !== ZC._n_(e[l])) {
        if (i.E["fast-vector-path"]) {
          if (o = e[l], "vml" === t) {
            var h = i.A9 % 360 == 0 ? 10 : 1;
            o[0] = ZC._i_(h * o[0]), o[1] = ZC._i_(h * o[1]), 4 === o.length && (o[2] = ZC._i_(h * o[2]), o[3] = ZC._i_(h * o[3]));
          }
        } else o = ZC.Q._txp_(e[l], t, i, a, n);
        if (null !== ZC._n_(o) && !isNaN(o[0]) && !isNaN(o[1]) && isFinite(o[0]) && isFinite(o[1])) if (r <= 20 && a && (c[0] = ZC.CX(c[0], o[0] / ("vml" === t ? 10 : 1)), c[1] = ZC.CX(c[1], o[1] / ("vml" === t ? 10 : 1)), c[2] = ZC.BQ(c[2], o[0] / ("vml" === t ? 10 : 1)), c[3] = ZC.BQ(c[3], o[1] / ("vml" === t ? 10 : 1))), 0 === l) p.push(("svg" === t ? "M " : "m ") + o[0] + " " + o[1]);else if (u && (p.push(("svg" === t ? "M " : "m ") + o[0] + " " + o[1]), u = !1), 2 === o.length) p.push(("svg" === t ? "L " : "l ") + o[0] + " " + o[1]);else if (4 === o.length) p.push(("svg" === t ? "Q " : "qb ") + o[0] + " " + o[1] + " " + o[2] + " " + o[3]), "vml" === t && p.push("l " + o[2] + " " + o[3]);else if (6 === o.length) {
          if ("svg" === t) {
            var _ = 0;
            o[3] % 360 == o[4] % 360 && (_ = o[4] >= o[3] ? .001 : -.001), s = ZC.AR.BN(o[0], o[1], o[2], o[3] + _), C = ZC.AR.BN(o[0], o[1], o[2], o[4] - _), A = "0 0", 0 === o[5] ? o[4] - o[3] > 360 ? (A = "0 1", C[0] = s[0], C[1] = s[1]) : A = o[4] - o[3] <= 180 ? "0 1" : "1 1" : o[3] - o[4] > 360 ? (A = "0 0", C[0] = s[0], C[1] = s[1]) : A = o[3] - o[4] <= 180 ? "0 0" : "1 0", p.push("a " + o[2] + "," + o[2] + " 0 " + A + " " + (C[0] - s[0]) + "," + (C[1] - s[1]));
          } else "vml" === t && (o[2] *= 10, s = ZC.AR.BN(o[0], o[1], o[2], o[3]), C = ZC.AR.BN(o[0], o[1], o[2], o[4]), A = 1 === o[5] ? "at" : "wa", p.push(A + " " + ZC._i_(o[0] - o[2]) + "," + ZC._i_(o[1] - o[2]) + "," + ZC._i_(o[0] + o[2]) + "," + ZC._i_(o[1] + o[2]) + " " + ZC._i_(s[0]) + "," + ZC._i_(s[1]) + " " + ZC._i_(C[0]) + "," + ZC._i_(C[1])));
        } else 7 === o.length && p.push(("svg" === t ? "C " : "c ") + o[0] + " " + o[1] + " " + o[2] + " " + o[3] + " " + o[4] + " " + o[5]);
      } else u = !0;
      return i.E["fast-vector-path"] || i.OI && ZC.cache.add("path-points-" + Z, p.join("#")), i.H && r <= 20 && a && (i.H.E[i.K + "-bounds"] = c), p;
    },
    MM: function MM(e, t) {
      var i,
        a,
        n = e.originalEvent || e.originalEventZC;
      return t = ZC._i_(t || "0"), n && n.touches ? n.touches.length > 0 ? (i = n.touches[t].pageX, a = n.touches[t].pageY) : n.changedTouches.length > 0 && (i = n.changedTouches[t].pageX, a = n.changedTouches[t].pageY) : (i = e.pageX, a = e.pageY), [ZC._i_(i || "0"), ZC._i_(a || "0")];
    },
    F7: function F7(e, t, i) {
      var a;
      return i = i || document, null !== ZC._n_(t) ? i.createElementNS ? a = i.createElementNS(t, e) : (a = i.createElement(e)).setAttribute("xmlns", t) : a = i.createElement(e), "zcv:" === e.substring(0, 4) && (a.className = "zcvml"), a;
    },
    EU: function EU(e) {
      var t;
      e instanceof Array || (e = [e]);
      for (var i = 0, a = e.length; i < a; i++) "object" != typeof (t = e[i]) && (t = ZC.AK(e[i])), t && (typeof t.parentElement !== ZC._[31] ? t.parentElement.removeChild(t) : typeof t.parentNode !== ZC._[31] && t.parentNode.removeChild(t));
    },
    G4: function G4(e, t) {
      for (var i in t) if ("string" == typeof i && "object" != typeof t[i] && "function" != typeof t[i]) try {
        e.setAttribute(i, t[i]);
      } catch (a) {}
    },
    PV: function PV(e, t) {
      for (var i in t) "string" == typeof i && "object" != typeof t[i] && "function" != typeof t[i] && (e.style[i] = t[i]);
    },
    AB9: function AB9(e) {
      var t;
      if (e === document) return !0;
      if (!e) return !1;
      if (!e.parentNode) return !1;
      if (e.style) {
        if ("none" === e.style.display) return !1;
        if ("hidden" === e.style.visibility) return !1;
      }
      if (window.getComputedStyle) {
        if ("none" === (t = window.getComputedStyle(e, "")).display) return !1;
        if ("hidden" === t.visibility) return !1;
      }
      if (t = e.currentStyle) {
        if ("none" === t.display) return !1;
        if ("hidden" === t.visibility) return !1;
      }
      return ZC.Q.AB9(e.parentNode);
    },
    TG: function TG(e) {
      var t = e.className || ZC.A5(e).attr("class");
      return null !== ZC._n_(t) && "object" == typeof t && (t = typeof t.baseVal !== ZC._[31] ? t.baseVal : ""), t || "";
    },
    IT: function IT(e, t, i, a, n, l, r, o) {
      if (e) switch (r = r || "", t) {
        case "canvas":
          o ? e.getContext("2d").clearRect(i, a, n, l) : e.width = e.width;
          break;
        case "vml":
        case "svg":
          var s = e.childNodes.length;
          if (s > 1024 && typeof e.innerHTML !== ZC._[31]) return void (e.innerHTML = "");
          if (s > 0) for (var C = s - 1; C >= 0; C--) "" === r ? e.removeChild(e.childNodes[C]) : 0 === e.childNodes[C].id.indexOf(r + "-") && e.removeChild(e.childNodes[C]);
      }
    },
    E9: function E9(e, t) {
      switch ("string" == typeof e && (e = ZC.AK(e)), t) {
        case "canvas":
          return e.getContext("2d");
        case "svg":
        case "vml":
          return e;
      }
    },
    K5: function K5(e, t) {
      switch (t) {
        case "svg":
          return ZC.Q.ABV(e);
        case "vml":
        case "canvas":
          return ZC.Q.I7(e);
      }
    },
    HJ: function HJ(e, t) {
      switch (t) {
        case "svg":
          return ZC.Q.ABV(e);
        case "vml":
          return ZC.Q.I7(e);
        case "canvas":
          return ZC.Q.ADC(e);
      }
    },
    ABV: function ABV(e) {
      var t;
      if (ZC.AK(e.id)) return ZC.AK(e.id);
      var i = ZC.Q.F7("g", ZC._[36]);
      return null !== ZC._n_(t = e.id) && i.setAttribute("id", t), null !== ZC._n_(t = e.cls) && i.setAttribute("class", t), null !== ZC._n_(t = e.zidx) && i.setAttribute("z-index", t), null !== ZC._n_(t = e["clip-path"]) && i.setAttribute("clip-path", t), e.after ? e.p.insertBefore(i, e.after.nextSibling) : e.p.appendChild(i), i;
    },
    XU: function XU(e) {
      var t;
      ZC.Q.EU(e.id);
      var i = ZC.Q.F7("clipPath", ZC._[36]);
      return i.id = e.id, null !== ZC._n_(e.cx) ? ((t = ZC.Q.F7("circle", ZC._[36])).id = e.id + "-shape", ZC.Q.G4(t, {
        cx: e.cx,
        cy: e.cy,
        r: e.r
      })) : ((t = ZC.Q.F7("polygon", ZC._[36])).id = e.id + "-shape", ZC.Q.G4(t, {
        points: e.path
      })), i.appendChild(t), i;
    },
    ADC: function ADC(e) {
      var t;
      if (ZC.AK(e.id)) return ZC.AK(e.id);
      var i = document.createElement("canvas"),
        a = i.style;
      if (null !== ZC._n_(t = e.id) && (i.id = t), null !== ZC._n_(t = e.cls) && (i.className = t), null !== ZC._n_(t = e.wh)) {
        var n = ("" + t).split("/");
        e[ZC._[19]] = n[0], e[ZC._[20]] = n[1];
      }
      if (null !== ZC._n_(t = e.tl)) {
        var l = ("" + t).split("/");
        e.top = l[0], e.left = l[1];
      }
      return i.width = e[ZC._[19]], i.height = e[ZC._[20]], null !== ZC._n_(t = e.left) && (a.left = t + "px"), null !== ZC._n_(t = e.top) && (a.top = t + "px"), null !== ZC._n_(t = e.display) && (a.display = t), null !== ZC._n_(t = e.position) && (a.position = t), null !== ZC._n_(t = e.zidx) && (a.zIndex = t), e.p.appendChild(i), i;
    },
    I7: function I7(e) {
      var t, i, a, n, l, r;
      if (ZC.AK(e.id)) return a = ZC.AK(e.id), null !== ZC._n_(t = e.wh) && (l = ("" + t).split("/"), a.style.width = l[0] + "px", a.style.height = l[1] + "px"), null !== ZC._n_(t = e.tl) && (r = ("" + t).split("/"), a.style.top = r[0] + "px", a.style.left = r[1] + "px"), a;
      (n = (a = document.createElement("div")).style).whiteSpace = "nowrap", null !== ZC._n_(t = e.wh) && (l = ("" + t).split("/"), e[ZC._[19]] = l[0], e[ZC._[20]] = l[1]), null !== ZC._n_(t = e.tl) && (r = ("" + t).split("/"), e.top = r[0], e.left = r[1]), null !== ZC._n_(t = e.id) && (a.id = t), null !== ZC._n_(t = e.cls) && "" !== t && (a.className = t);
      for (var o = [["top", "", "px"], ["left", "", "px"], [ZC._[19], "", "px"], [ZC._[20], "", "px"], "position", "overflow", ["float", "cssFloat|styleFloat"], ["zidx", "zIndex"], "clip", "display", ["fontSize", "", "px"], "fontFamily", "fontWeight", "fontStyle", "textDecoration", "textAlign", "verticalAlign", "color", "border", "borderTop", "borderRight", "borderBottom", "borderLeft", "background", "cursor", ["margin", "marginTop|marginRight|marginBottom|marginLeft", "px"], ["marginTop", "", "px"], ["marginRight", "", "px"], ["marginBottom", "", "px"], ["marginLeft", "", "px"], ["padding", "paddingTop|paddingRight|paddingBottom|paddingLeft", "px"], ["paddingTop", "", "px"], ["paddingRight", "", "px"], ["paddingBottom", "", "px"], ["paddingLeft", "", "px"], "lineHeight", "filter"], s = null, C = null, A = null, Z = 0, c = o.length; Z < c; Z++) if ("string" == typeof o[Z] && (o[Z] = [o[Z]]), t = null, null !== ZC._n_(i = e[o[Z][0]]) && (t = i), null !== ZC._n_(t)) {
        null !== ZC._n_(o[Z][1]) && "" !== o[Z][1] || (o[Z][1] = o[Z][0]);
        for (var p = o[Z][1].split("|"), u = 0, h = p.length; u < h; u++) {
          var _ = t + (null === ZC._n_(o[Z][2]) ? "" : o[Z][2]);
          n[p[u]] = _, "fontFamily" === p[u] && (s = _), "fontSize" === p[u] && (C = ZC._i_(_)), "fontWeight" === p[u] && (A = _);
        }
      }
      return null !== ZC._n_(t = e.opacity) && (n.opacity = t, 1 !== ZC._f_(t) && (n.filter = "alpha(opacity = " + ZC._i_(100 * ZC._f_(t)) + ")", n.opacity = t)), null !== ZC._n_(t = e.p) && (e.after ? t.insertBefore(a, e.after.nextSibling) : t.appendChild(a)), null !== ZC._n_(t = e.html) && (a.innerHTML = ZC._h_(t), -1 !== t.indexOf("<") && -1 !== t.indexOf(">") && ZC.A5(a).children().each(function () {
        null !== ZC._n_(s) && (null !== ZC._n_(this.style.fontFamily) && "" !== this.style.fontFamily || (this.style.fontFamily = s)), null !== ZC._n_(C) && (null !== ZC._n_(this.style.fontSize) && "" !== this.style.fontSize || (this.style.fontSize = C + "px")), null !== ZC._n_(A) && (null !== ZC._n_(this.style.fontWeight) && "" !== this.style.fontWeight || (this.style.fontWeight = A));
      })), e.rtl && (a.style.unicodeBidi = "bidi-override", a.style.direction = "rtl"), e.cursor && "hand" === e.cursor && (a.style.cursor = "pointer"), a;
    },
    WW: null,
    A4S: function A4S(e, t, i, a, n, l, r) {
      var o, s, C, A;
      null === ZC._n_(r) && (r = !1);
      var Z = !1;
      "[HTMLMODE]" === t.substring(0, 10) && (Z = !0, t = t.substring(10)), A = e + "-text-ruler", -1 !== e.indexOf("-fullscreen") && (A = "zc-text-ruler");
      var c = "{{" + t + "}}" + i.replace(/[^a-z]/gi, "").toLowerCase() + a + l + n;
      if (ZC.cache.data["text-width-" + c] && !r) return ZC.cache.data["text-width-" + c];
      if (ZC.cache.data["text-height-" + c] && r) return ZC.cache.data["text-height-" + c];
      var p,
        u = t;
      return u = u.replace(/<hr>/g, '<hr style="margin:0;padding:0">'), (p = ZC.AK(A)) ? (ZC.Q.WW && ZC.Q.WW === e + i + a + l + n || (p.style.fontFamily = i, p.style.fontSize = a + "px", p.style.fontWeight = n, p.style.lineHeight = Z ? "130%" : -1 !== l ? ZC._i_(l) + "px" : "130%", ZC.Q.WW = e + i + a + l + n), p.innerHTML = u) : (p = ZC.Q.I7({
        id: A,
        p: document.body,
        tl: "-9999/-9999",
        html: u,
        position: "absolute",
        fontFamily: i,
        fontSize: a,
        cls: "zc-text-ruler",
        fontWeight: n
      })).style.lineHeight = Z ? "130%" : -1 !== l ? ZC._i_(l) + "px" : "130%", -1 === t.indexOf("<") || -1 === t.indexOf(">") || Z || ZC.A5(p).children().each(function () {
        "BR" !== this.tagName.toUpperCase() && (null !== ZC._n_(this.style.fontFamily) && "" !== this.style.fontFamily || (this.style.fontFamily = i), null !== ZC._n_(this.style.fontSize) && "" !== this.style.fontSize || (this.style.fontSize = a + "px"), this.style.lineHeight = -1 !== l ? ZC._i_(l) + "px" : "130%", "B" !== this.tagName.toUpperCase() && "STRONG" !== this.tagName.toUpperCase() && (null !== ZC._n_(this.style.fontWeight) && "" !== this.style.fontWeight || (this.style.fontWeight = n)));
      }), (o = p.getBoundingClientRect()) && o.width > 0 ? (s = o.width, r && (C = o.height)) : (s = ZC.mobile && ZC.A5.browser.webkit ? p.offsetWidth : ZC.A5(p).width(), r && (C = ZC.mobile && ZC.A5.browser.webkit ? p.offsetHeight : ZC.A5(p).height())), r ? (ZC.cache.add("text-height-" + c, C), C) : (ZC.cache.add("text-width-" + c, s), s);
    }
  }, !document.getElementsByClassName && document.querySelectorAll && (document.getElementsByClassName = function (e) {
    return document.querySelectorAll("." + e);
  }), ZC.A5 = function (e, t, i) {
    var a,
      n,
      l,
      r,
      o = this;
    if (typeof i === ZC._[31] && (i = !0), i) return new ZC.A5(e, t, !1);
    if (o.PD = [], o.QR = e, o.MS = t, o.length = 0, o.MS = o.MS || document.getElementsByTagName("body")[0], "object" == typeof o.QR) o.PD = [o.QR];else if ("string" == typeof o.QR) for (var s = o.QR.split(","), C = 0; C < s.length; C++) {
      var A = ZC.GY(s[C]),
        Z = !1;
      if (2 === (a = A.split(">")).length && (Z = !0, ZC.A5(a[0]).each(function () {
        var e = this;
        ZC.A5(a[1], this).each(function () {
          this.parentNode === e && o.PD.push(this);
        });
      })), 2 === (a = A.split(" ")).length && (Z = !0, ZC.A5(a[0]).each(function () {
        ZC.A5(a[1], this).each(function () {
          o.PD.push(this);
        });
      })), !Z) if ("#" === A.substring(0, 1)) ZC.AK(A.substring(1)) && (o.PD = [ZC.AK(A.substring(1))]);else if ("." === A.substring(0, 1)) {
        if (document.getElementsByClassName) {
          if (o.MS.getElementsByClassName) n = o.MS.getElementsByClassName(A.substring(1));else if (n = document.getElementsByClassName(A.substring(1)), o.MS !== document) {
            var c = [];
            for (l = 0, r = n.length; l < r; l++) ZC.A5.childof(n[l], o.MS) && c.push(n[l]);
            n = c;
          }
          for (l = 0, r = n.length; l < r; l++) o.PD.push(n[l]);
        } else {
          var p = new RegExp("(^|\\s)" + A.substring(1) + "(\\s|$)", "i"),
            u = o.MS.getElementsByTagName("*"),
            h = "";
          for (l = 0, r = u.length; l < r; l++) "object" == typeof (h = u[l].className) && (h = typeof h.baseVal !== ZC._[31] ? h.baseVal : ""), "" !== h && p.test(h) && o.PD.push(u[l]);
        }
      } else for (l = 0, r = (n = o.MS.getElementsByTagName(A)).length; l < r; l++) o.PD.push(n[l]);
    }
    return o.length = o.PD.length, this;
  }, ZC.A5.prototype = {
    eachfn: function eachfn() {
      for (var e, t = [], i = 0, a = this.PD.length; i < a; i++) {
        var n = [this.PD[i]];
        if ((e = arguments.length) > 1) for (var l = 1; l < e; l++) n.push(arguments[l]);
        t.push(arguments[0].apply(this, n));
      }
      return t;
    },
    each: function each() {
      for (var e, t = 0, i = this.PD.length; t < i; t++) {
        var a = [this.PD[t]];
        if ((e = arguments.length) > 1) for (var n = 1; n < e; n++) a.push(arguments[n]);
        arguments[0].apply(this.PD[t], a);
      }
      return this;
    },
    children: function children() {
      var e = [];
      return this.each(function () {
        for (var t = 0, i = this.childNodes.length; t < i; t++) 1 === this.childNodes[t].nodeType && e.push(this.childNodes[t]);
      }), this.PD = e, this;
    },
    remove: function remove() {
      this.eachfn.call(this, function (e) {
        e && e.parentNode && e.parentNode.removeChild(e);
      });
    },
    empty: function empty() {
      this.eachfn.call(this, function (e) {
        if (e) for (; e.childNodes.length;) e.removeChild(e.childNodes[e.childNodes.length - 1]);
      });
    },
    A39: function A39(e) {
      var t, i;
      typeof e === ZC._[31] && (e = !0);
      var a = this.eachfn.call(this, function (a) {
        if (!a) return null;
        if (a === window) {
          var n = document.body;
          return a.innerWidth ? (t = a.innerWidth, i = a.innerHeight) : n && n.parentElement && n.parentElement.clientWidth ? (t = n.parentElement.clientWidth, i = n.parentElement.clientHeight) : n && n.clientWidth && (t = n.clientWidth, i = n.clientHeight), {
            width: t,
            height: i
          };
        }
        var l,
          r,
          o = e ? "block" : ZC.A5(a).getstyle("display");
        if (window.getComputedStyle) {
          var s = window.getComputedStyle(a, null);
          l = s.getPropertyValue(ZC._[19]).slice(0, -2), r = s.getPropertyValue(ZC._[20]).slice(0, -2);
        } else if (a.getBoundingClientRect) {
          var C = a.getBoundingClientRect();
          l = C.width ? C.width : a.offsetWidth, r = C.height ? C.height : a.offsetHeight;
        } else l = a.offsetWidth, r = a.offsetHeight;
        if ("none" === o || "" === o || typeof o === ZC._[31]) {
          var A = a.style,
            Z = A.visibility,
            c = A.position,
            p = A.display;
          A.visibility = "hidden", A.position = "absolute", A.display = "block", t = l, i = r, A.display = p, A.position = c, A.visibility = Z;
        } else t = l || 0, i = r || 0;
        return {
          width: t,
          height: i
        };
      });
      return 1 === a.length ? a[0] : a;
    },
    getstyle: function getstyle(e) {
      var t = this.eachfn.call(this, function (e, t) {
        if ("display" === t) return e.style.display;
        var i,
          a = document;
        if (t = ZC.EE(t), !e || e === a) return undefined;
        if ("opacity" === t && typeof e.filters !== ZC._[31]) {
          var n = (ZC.A5(e).getstyle("filter") || "").match(/alpha\(opacity=(.*)\)/);
          return n && n[1] ? parseFloat(n[1]) / 100 : 1;
        }
        if (-1 !== ZC.AV(["float", "cssFloat", "styleFloat"], t)) return (i = e.style.float) ? i : (i = e.style.cssFloat) ? i : (i = e.style.styleFloat) ? i : "none";
        var l = e.style ? e.style[t] : null;
        if (!l) if (a.defaultView && a.defaultView.getComputedStyle) {
          var r = a.defaultView.getComputedStyle(e, null);
          t = t.replace(/([A-Z])/g, "-$1").toLowerCase(), l = r ? r.getPropertyValue(t) : null;
        } else if (e.currentStyle && (l = e.currentStyle[t], /^\d/.test(l) && !/px$/.test(l) && "fontWeight" !== t)) {
          var o = e.style.left,
            s = e.runtimeStyle.left;
          e.runtimeStyle.left = e.currentStyle.left, e.style.left = l || 0, l = e.style.pixelLeft + "px", e.style.left = o, e.runtimeStyle.left = s;
        }
        return "opacity" === t && (l = parseFloat(l)), /Opera/.test(navigator.userAgent) && -1 !== ZC.AV(["left", "top", "right", "bottom"], t) && "static" === ZC.A5(e).getstyle("position") && (l = "auto"), "auto" === l ? null : l;
      }, e);
      return 1 === t.length ? t[0] : t;
    },
    wh: function wh() {
      var e;
      return this.PD[0] ? null !== ZC._n_(e = ZC.A5(this.PD[0]).A39()) ? [ZC._i_(e[ZC._[19]]), ZC._i_(e[ZC._[20]])] : [0, 0] : null;
    },
    width: function width(e) {
      var t;
      if (typeof e === ZC._[31]) {
        var i = this.eachfn.call(this, function (e) {
          return null !== ZC._n_(t = ZC.A5(e).A39()) ? ZC._i_(t[ZC._[19]]) : 0;
        });
        return 1 === i.length ? i[0] : i;
      }
      return this.eachfn.call(this, function (e, t) {
        e.style.width = t + "px";
      }, e), this;
    },
    height: function height(e) {
      var t;
      if (typeof e === ZC._[31]) {
        var i = this.eachfn.call(this, function (e) {
          return null !== ZC._n_(t = ZC.A5(e).A39()) ? ZC._i_(t[ZC._[20]]) : 0;
        });
        return 1 === i.length ? i[0] : i;
      }
      return this.eachfn.call(this, function (e, t) {
        e.style.height = t + "px";
      }, e), this;
    },
    scrollLeft: function scrollLeft() {
      return ZC.A5.scroll().left;
    },
    scrollTop: function scrollTop() {
      return ZC.A5.scroll().top;
    },
    css: function css(e, t) {
      if (typeof t === ZC._[31]) {
        var i = this.eachfn.call(this, function (t) {
          var i = ZC.A5(t).getstyle(e);
          return -1 !== ("" + i).indexOf("px") ? ZC._i_(i) : i;
        });
        return 1 === i.length ? i[0] : i;
      }
      return this.eachfn.call(this, function (e, t, i) {
        e.style[t] = i;
      }, e, t), this;
    },
    attr: function attr(e, t) {
      if (typeof t === ZC._[31]) {
        var i = this.eachfn.call(this, function (t) {
          return t.getAttribute(e);
        });
        return 1 === i.length ? i[0] : i;
      }
      return this.eachfn.call(this, function (e, t, i) {
        e.setAttribute(t, i);
      }, e, t), this;
    },
    val: function val(e) {
      if (typeof e === ZC._[31]) {
        var t = this.eachfn.call(this, function (e) {
          return e.value;
        });
        return 1 === t.length ? t[0] : t;
      }
      return this.eachfn.call(this, function (e, t) {
        e.value = t;
      }, e), this;
    },
    show: function show() {
      return this.eachfn.call(this, function (e) {
        e.style.display = "block";
      }), this;
    },
    hide: function hide() {
      return this.eachfn.call(this, function (e) {
        e.style.display = "none";
      }), this;
    },
    offset: function offset() {
      var e = this.eachfn.call(this, function (e) {
        if (!(e && (e.x && e.y || null !== !e.parentNode && "none" !== ZC.A5(e).getstyle("display")))) return undefined;
        var t,
          i,
          a,
          n,
          l,
          r,
          o,
          s = {
            top: 0,
            left: 0
          },
          C = {
            top: 0,
            left: 0
          },
          A = e && e.ownerDocument;
        return A && ((i = A.body) === e && (s = {
          top: i.offsetTop,
          left: i.offsetLeft
        }), t = A.documentElement, typeof e.getBoundingClientRect !== ZC._[31] && (C = e.getBoundingClientRect()), a = A.defaultView || A.parentWindow, n = t.clientTop || i.clientTop || 0, l = t.clientLeft || i.clientLeft || 0, r = a.pageYOffset || t.scrollTop, o = a.pageXOffset || t.scrollLeft, s = {
          top: C.top + r - n,
          left: C.left + o - l
        }), s;
      });
      return 1 === e.length ? e[0] : e;
    },
    bind: function bind(e, t, i) {
      if ("" !== (e = ZC.A5.cleanTouchEvents(e))) {
        if (i || (i = !ZC.hasPassive || {
          passive: !0
        }), -1 !== e.indexOf(" ")) {
          for (var a = e.split(/\s+/), n = 0; n < a.length; n++) this.bind(a[n], t, i);
          return this;
        }
        return this.eachfn.call(this, function (e, t, a) {
          function n(e) {
            var t = (e = e || window.event).target || e.srcElement,
              i = ZC.A5.BX(e);
            null !== i && a.call(t, i);
          }
          ZC.A5.J6 || (ZC.A5.J6 = []), ZC.A5.J6.push([e, t, a, n]), e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent("on" + t, n);
        }, e, t), this;
      }
    },
    unbind: function unbind(e, t) {
      if ("" !== (e = ZC.A5.cleanTouchEvents(e))) {
        if (-1 !== e.indexOf(" ")) {
          for (var i = e.split(/\s+/), a = 0; a < i.length; a++) this.unbind(i[a], t);
          return this;
        }
        return this.eachfn.call(this, function (e, t, i) {
          if (typeof ZC.A5.J6 !== ZC._[31]) for (var a = 0, n = ZC.A5.J6.length; a < n; a++) if ((ZC.A5.J6[a][0] === e || e.tagName && "MAP" === e.tagName.toUpperCase() && e.id === ZC.A5.J6[a][0].id) && ZC.A5.J6[a][1] === t && ZC.A5.J6[a][2] === i) {
            e.removeEventListener ? e.removeEventListener(t, ZC.A5.J6[a][3], !0) : e.detachEvent("on" + t, ZC.A5.J6[a][3]), ZC.A5.J6.splice(a, 1);
            break;
          }
        }, e, t), this;
      }
    },
    live: function live(e, t, i) {
      if ("" !== (e = ZC.A5.cleanTouchEvents(e))) {
        if (i || (i = !ZC.hasPassive || {
          passive: !0
        }), -1 === e.indexOf("touch") && -1 === e.indexOf("wheel") || (i = {
          passive: !1
        }), -1 !== e.indexOf(" ")) {
          for (var a = e.split(/\s+/), n = 0; n < a.length; n++) this.live(a[n], t, i);
          return this;
        }
        var l = this.QR;
        return ZC.A5.EVENTS || (ZC.A5.EVENTS = {}), ZC.A5.EVENTS[e] || (ZC.A5.EVENTS[e] = [], document.addEventListener ? document.addEventListener(e, r, i) : document.attachEvent("on" + e, r)), ZC.A5.EVENTS[e].push([l, t]), this;
      }
      function r(t) {
        var i = (t = t || window.event).target || t.srcElement,
          a = i.className || "";
        "object" == typeof a && (a = typeof a.baseVal !== ZC._[31] && null !== ZC._n_(a.baseVal) ? a.baseVal : "");
        var l,
          r,
          o = ZC.A5.EVENTS[e],
          s = null,
          C = null,
          A = [];
        for (l = 0, r = o.length; l < r; l++) ("object" == typeof o[l][0] && i === o[n][0] || "string" == typeof o[l][0] && ("." === o[l][0].substring(0, 1) && -1 !== ZC.AV(a.split(" "), o[l][0].replace(".", "")) || "#" === o[l][0].substring(0, 1) && i.id === o[l][0].substring(1))) && (s = o[l][1], C = ZC.A5.BX(t), null !== ZC._n_(s) && null !== ZC._n_(C) && A.push([s, i, C]));
        for (l = 0, r = A.length; l < r; l++) A[l][0].call(A[l][1], A[l][2]);
      }
    },
    die: function die(e, t) {
      if ("" !== (e = ZC.A5.cleanTouchEvents(e))) {
        var i, a, n;
        if (-1 !== e.indexOf(" ")) {
          for (a = 0, n = (i = e.split(/\s+/)).length; a < n; a++) this.die(i[a], t);
          return this;
        }
        var l = this.QR;
        if (ZC.A5.EVENTS || (ZC.A5.EVENTS = {}), i = ZC.A5.EVENTS[e]) for (a = i.length - 1; a >= 0; a--) i[a][0] !== l || t && i[a][1] !== t || ZC.A5.EVENTS[e].splice(a, 1);
        return this;
      }
    }
  }, ZC.A5._list_ = function (e) {
    for (var t = [], i = 0; i < ZC.A5.EVENTS[e].length; i++) t.push(ZC.A5.EVENTS[e][i][0]);
    return t.join(",");
  }, ZC.A5.cleanTouchEvents = function (e) {
    return ZC.ie678 && (e = ZC.GY(e.replace(/touchstart|touchend|touchmove/, ""))), e;
  }, ZC.A5.cache = {}, ZC.A5.browser = {}, function () {
    var e = /(webkit)[ \/]([\w.]+)/,
      t = /(opera)(?:.*version)?[ \/]([\w.]+)/,
      i = /(msie) ([\w.]+)/,
      a = /(mozilla)(?:.*? rv:([\w.]+))?/,
      n = /(trident)(?:.*? rv:([\w.]+))?/,
      l = function (l) {
        l = l.toLowerCase();
        var r = e.exec(l) || t.exec(l) || i.exec(l) || n.exec(l) || l.indexOf("compatible") < 0 && a.exec(l) || [];
        return [r[1] || "", r[2] || "0"];
      }(navigator.userAgent);
    l[0] && ("trident" === l[0] && (l[0] = "msie"), ZC.A5.browser[l[0]] = !0, ZC.A5.browser.version = l[1]);
  }(), ZC.A5.scroll = function () {
    var e = {
        top: 0,
        left: 0
      },
      t = document,
      i = t.documentElement,
      a = t.body;
    return i && (i.scrollTop || i.scrollLeft) ? (e.left = i.scrollLeft, e.top = i.scrollTop) : a && (e.left = a.scrollLeft, e.top = a.scrollTop), e;
  }, ZC.A5.BX = function (e) {
    if (e.originalEventZC = e, e.target || (e.target = e.srcElement || document), 3 !== e.target.nodeType && 8 !== e.target.nodeType || (e.target = e.target.parentNode), null === ZC._n_(e.pageX) && null !== ZC._n_(e.clientX)) {
      var t = e.target.ownerDocument || document,
        i = t.documentElement,
        a = t.body;
      e.pageX = e.clientX + (i && i.scrollLeft || a && a.scrollLeft || 0) - (i && i.clientLeft || a && a.clientLeft || 0), e.pageY = e.clientY + (i && i.scrollTop || a && a.scrollTop || 0) - (i && i.clientTop || a && a.clientTop || 0);
    }
    return !e.which && (e.button, undefined), e.preventDefault || (e.preventDefault = function () {
      this.returnValue = !1;
    }), e.stopPropagation || (e.stopPropagation = function () {
      this.cancelBubble = !0;
    }), e;
  }, ZC.A5.childof = function (e, t) {
    if (e === t) return !0;
    for (; e !== t && e.parentNode;) if ((e = e.parentNode) === t) return !0;
    return !1;
  }, ZC.A5.ajax = function (e) {
    var t = e.url || "",
      i = e.type || "GET",
      a = e.data || "",
      n = !0;
    typeof e.async !== ZC._[31] && (n = ZC._b_(e.async)), "" === a.replace(/\&/g, "") && (a = "");
    var l = e.beforeSend || null,
      r = e.error || null,
      o = e.success || null,
      s = null;
    try {
      window.ActiveXObject ? s = new ActiveXObject("Microsoft.XMLHTTP") : window.XMLHttpRequest && (s = new XMLHttpRequest());
    } catch (A) {}
    var C = "file:" === window.location.protocol;
    if (s) {
      n && (s.onreadystatechange = function () {
        4 === s.readyState && ((C || s.status >= 200 && s.status < 300) && o && o(s.responseText, s.status, s, t), s.status >= 400 && r && r(s, s.status, s.statusText, t), s.onreadystatechange = new window.Function(), s = null);
      }), window.ActiveXObject || (s.onerror = function () {
        r && r(s, 0, "", t);
      }), "POST" === i.toUpperCase() ? (s.open("POST", t, n), s.setRequestHeader("X-Requested-With", "XMLHttpRequest"), s.setRequestHeader("Content-type", "application/x-www-form-urlencoded")) : ("" !== a && (-1 === t.indexOf("?") && (t += "?"), t += "&" + a), s.open("GET", t, n)), l && l(s);
      try {
        s.send(a), n || ((C || s.status >= 200 && s.status < 300) && o && o(s.responseText, s.status, s, t), s.status >= 400 && r && r(s, s.status, s.statusText, t), s = null);
      } catch (Z) {
        C && r && (r(s, s.status, s.statusText, t), s.onreadystatechange = new window.Function(), s = null);
      }
    }
  }, ZC.AR = {
    ACO: function ACO(e, t) {
      var i,
        a,
        n = zingchart.DEV.SPREADFACTOR,
        l = [],
        r = 0;
      function o(e, t) {
        -1 === ZC.AV(e, t) && e.push(t);
      }
      for (i = 0; i < e.length; i++) e[i] += t;
      var s = -1;
      for (i = 1; i < e.length; i++) ZC._a_(e[i] - e[i - 1]) < n ? (l[r] = l[r] || {
        min: -1,
        max: -1,
        items: []
      }, -1 === l[r].min && (l[r].min = i > 1 ? e[i - 2] : t, -1 === s && (s = l[r].min), l[r].min), o(l[r].items, i - 1), o(l[r].items, i)) : l[r] && (l[r].max = e[i], l[r].max, r++);
      l[r] && -1 === l[r].max && (l[r].max = 360 + t);
      var C = l.length;
      if (C > 1 && l[C - 1].max - l[0].min == 360) {
        for (a = 0; a < l[0].items.length; a++) e[l[0].items[a]] += 360;
        l[C - 1].items = l[C - 1].items.concat(l[0].items), l[C - 1].max += l[0].min, l = l.splice(1);
      }
      for (l.length > 1 && (l[l.length - 1].max = l[0].min + 360), i = 0; i < l.length; i++) {
        var A = l[i],
          Z = A.items.length,
          c = (A.max - A.min) / (Z + 4);
        c = ZC.CX(c, n);
        var p = 0;
        for (a = 0; a < A.items.length; a++) p += e[A.items[a]];
        p /= A.items.length;
        for (var u = !0; u;) for (u = !1, a = 1; a < A.items.length; a++) if (e[A.items[a]] - e[A.items[a - 1]] < c) {
          e[A.items[a - 1]] < p ? (e[A.items[a - 1]] -= .45, e[A.items[a]] += .05) : e[A.items[a]] += .25, u = !0;
          break;
        }
      }
      return e;
    },
    _int_: function _int_(e) {
      return Math.abs(e - ZC._i_(e)) < Math.pow(10, -10);
    },
    YG: function YG(e, t, i) {
      return i = i || 1, !(e.x > t.x + t.width + i) && !(t.x > e.x + e.width + i) && !(e.y > t.y + t.height + i) && !(t.y > e.y + e.height + i);
    },
    _boxoverlap2_: function _boxoverlap2_(e, t, i) {
      return i = i || 1, !(e.iX > t.iX + t.I + i) && !(t.iX > e.iX + e.I + i) && !(e.iY > t.iY + t.F + i) && !(t.iY > e.iY + e.F + i);
    },
    AG6: function AG6(e, t) {
      return e.iX >= t.iX && e.iX <= t.iX + t.I && e.iY >= t.iY && e.iY <= t.iY + t.F && e.iX + e.I >= t.iX && e.iX + e.I <= t.iX + t.I && e.iY + e.F >= t.iY && e.iY + e.F <= t.iY + t.F;
    },
    A6M: function A6M(e, t, i) {
      for (var a = Math.sqrt(e / Math.PI), n = Math.sqrt(t / Math.PI), l = Math.min(a, n), r = Math.max(a, n), o = ZC.MAX, s = 0, C = l + r; C > r - l; C -= l / 50) {
        var A = l * l * Math.acos((C * C + l * l - r * r) / (2 * C * l)) + r * r * Math.acos((C * C + r * r - l * l) / (2 * C * r)) - .5 * Math.sqrt((-C + l + r) * (C + l - r) * (C - l + r) * (C + l + r));
        Math.abs(A - i) < o && (o = Math.abs(A - i), s = C);
      }
      return s;
    },
    BN: function BN(e, t, i, a) {
      return [e + i * Math.cos(2 * a * Math.PI / 360), t + i * Math.sin(2 * a * Math.PI / 360)];
    },
    A64: function A64(e, t, i, a, n) {
      var l = ZC.UE(Math.atan((a - t) / (i - e)));
      return [e + ZC._i_(ZC.EG(l) * n), t + ZC._i_(ZC.EN(l) * n)];
    },
    JZ: function JZ(e, t, i, a, n, l) {
      if (n = null === ZC._n_(n) ? 0 : n, l = null === ZC._n_(l) || l, i - e != 0) {
        var r = 0,
          o = 0,
          s = Math.atan((a - t) / (i - e));
        return (n < 1 || l) && (r = n / 2.5 * Math.cos(s), o = n / 2.5 * Math.sin(s)), [(e + i) / 2 + (e < i ? r : -r), (t + a) / 2 + o];
      }
      return [e, (t + a) / 2];
    },
    ABF: function ABF(e, t) {
      var i = (e[1] - t[1]) / (e[0] - t[0]);
      return [i, e[1] - i * e[0]];
    },
    A62: function A62(e, t, i, a) {
      if (t[0] === a[0] && t[1] === a[1]) return t;
      if (e[0] === i[0] && e[1] === i[1]) return e;
      var n = ZC.AR.ABF(e, t),
        l = n[0],
        r = n[1],
        o = ZC.AR.ABF(i, a),
        s = o[0],
        C = (o[1] - r) / (l - s);
      return [C, l * C + r];
    },
    Q8: function Q8(e, t, i) {
      null === ZC._n_(t) && (t = 5);
      var a = 0,
        n = 0;
      null !== ZC._n_(i) && (a = i[0], n = i[1]);
      for (var l, r, o, s = "", C = ZC.ie67 ? ZC.MAPTX : 0, A = 0, Z = e.length; A < Z; A++) e[A] && (0 === A ? (r = e[A][0] + C + a, o = e[A][1] + C + n, l = A, s += Math.round(r, 10) + "," + Math.round(o, 10) + ",") : Math.sqrt((e[A][0] + C - r) * (e[A][0] + C - r) + (e[A][1] + C - o) * (e[A][1] + C - o)) > t && e[A - 1] && (Math.sqrt((e[A][0] - e[A - 1][0]) * (e[A][0] - e[A - 1][0]) + (e[A][1] - e[A - 1][1]) * (e[A][1] - e[A - 1][1])) > t && A - l > 1 && (s += Math.round(e[A - 1][0] + C + a, 10) + "," + Math.round(e[A - 1][1] + C + n, 10) + ","), r = e[A][0] + C + a, o = e[A][1] + C + n, l = A, s += Math.round(r, 10) + "," + Math.round(o, 10) + ","));
      return s = s.substring(0, s.length - 1);
    },
    ZJ: function ZJ(e, t) {
      if (null === ZC._n_(e) || e.length < 2) return "";
      null === ZC._n_(t) && (t = 6, ZC.mobile && (t += 10));
      var i,
        a,
        n,
        l,
        r,
        o = [];
      for (i = 0, a = e.length; i < a; i++) (0 === i || i > 0 && null !== ZC._n_(e[i]) && null !== ZC._n_(e[i - 1]) && e[i].join("/") !== e[i - 1].join("/") || null === ZC._n_(e[i])) && o.push(e[i]);
      var s = [],
        C = [],
        A = !1;
      for (i = 0, a = o.length; i < a; i++) if (o[i]) {
        var Z,
          c,
          p,
          u,
          h = o[i][0],
          _ = o[i][1];
        if (o[i - 1] && (p = o[i - 1][0], u = o[i - 1][1], p === h && (p -= .1)), o[i + 1] && (Z = o[i + 1][0], c = o[i + 1][1], Z === h && (Z += .1)), 0 === i) n = Math.atan((c - _) / (Z - h)), r = l = ZC.UE(n), Z >= h && (r += 180), s.push(ZC.AR.BN(h, _, t, l + 90), ZC.AR.BN(h, _, t, r), ZC.AR.BN(h, _, t, l + 270));else if (i === o.length - 1) n = Math.atan((u - _) / (p - h)), r = l = ZC.UE(n), p >= h && (r += 180), A ? (C.push(ZC.AR.BN(h, _, t, l + 270), ZC.AR.BN(h, _, t, r), ZC.AR.BN(h, _, t, l + 90)), A = !1) : s.push(ZC.AR.BN(h, _, t, l + 270), ZC.AR.BN(h, _, t, r), ZC.AR.BN(h, _, t, l + 90));else {
          var d = Math.atan((c - _) / (Z - h)),
            f = Math.atan((_ - u) / (h - p));
          r = ZC.UE((d + f) / 2), s.push(ZC.AR.BN(h, _, t, r + 270)), Z >= h && p >= h ? (s.push(ZC.AR.BN(h, _, t, r + 180)), s.push(ZC.AR.BN(h, _, t, r + 90)), C.push(ZC.AR.BN(h, _, t, r)), A = !0) : Z <= h && p <= h ? (s.push(ZC.AR.BN(h, _, t, r)), s.push(ZC.AR.BN(h, _, t, r + 90)), C.push(ZC.AR.BN(h, _, t, r + 180)), A = !0) : C.push(ZC.AR.BN(h, _, t, r + 90));
        }
      }
      for (i = C.length - 1; i >= 0; i--) s.push(C[i]);
      return s;
    },
    A2Y: function A2Y(e, t) {
      var i = 0,
        a = 0,
        n = [];
      switch (e += "") {
        case "horizontal":
        case "h":
          i = 1, a = t;
          break;
        case "vertical":
        case "v":
          i = t, a = 1;
          break;
        default:
          n = e.split("x"), null !== ZC._n_(n[0]) && ZC._i_(n[0]) + "" === n[0] && (i = ZC._i_(n[0])), null !== ZC._n_(n[1]) && ZC._i_(n[1]) + "" === n[1] && (a = ZC._i_(n[1])), 0 === a && 0 === i ? (i = Math.ceil(Math.sqrt(t)), a = Math.ceil(t / i)) : (0 === a && (a = Math.ceil(t / i)), 0 === i && (i = Math.ceil(t / a)));
      }
      return [i, a];
    },
    ABI: function ABI(e, t) {
      return .5 * (2 * t[1] + (-t[0] + t[2]) * e + (2 * t[0] - 5 * t[1] + 4 * t[2] - t[3]) * e * e + (-t[0] + 3 * t[1] - 3 * t[2] + t[3]) * e * e * e);
    },
    ABQ: function ABQ(e, t) {
      var i,
        a,
        n,
        l,
        r,
        o = e.length,
        s = [],
        C = [],
        A = [];
      for (i = 0; i < o - 1; i++) a = e[i + 1] - e[i], n = t[i + 1] - t[i], C.push(a), s.push(n), A.push(n / a);
      var Z = [A[0]];
      for (i = 0; i < C.length - 1; i++) {
        l = A[i];
        var c = A[i + 1];
        if (l * c <= 0) Z.push(0);else {
          a = C[i];
          var p = C[i + 1];
          r = a + p, Z.push(3 * r / ((r + p) / l + (r + a) / c));
        }
      }
      Z.push(A[A.length - 1]);
      var u = [],
        h = [];
      for (i = 0; i < Z.length - 1; i++) {
        l = A[i];
        var _ = Z[i],
          d = 1 / C[i];
        r = _ + Z[i + 1] - l - l, u.push((l - _ - r) * d), h.push(r * d * d);
      }
      return function (i) {
        var a = e.length - 1;
        if (i === e[a]) return t[a];
        for (var n, l = 0, r = h.length - 1; l <= r;) {
          n = Math.floor(.5 * (l + r));
          var o = e[n];
          if (o < i) l = n + 1;else {
            if (!(o > i)) return t[n];
            r = n - 1;
          }
        }
        a = Math.max(0, r);
        var s = i - e[a],
          C = s * s;
        return t[a] + Z[a] * s + u[a] * C + h[a] * s * C;
      };
    },
    YY: function YY(e, t, i, a) {
      null === ZC._n_(a) && (a = 1 / (i / t.length * 4));
      var n,
        l,
        r = [];
      if (e) {
        if ((n = [].concat(t))[1] && n[2]) {
          n[0] = n[0] || n[1] || n[2] || n[3], n[1] = n[1] || n[2] || n[0] || n[3], n[2] = n[2] || n[3] || n[1] || n[0], n[3] = n[3] || n[2] || n[1] || n[0];
          var o = ZC.AR.ABQ([0, 1, 2, 3], n);
          for (l = 1; l <= 2; l += a) r.push([l - 1, o(l)]);
        } else r.push([]);
      } else for (var s = 1; s < t.length - 2; s++) if (1 !== a) {
        if ((n = [t[s - 1], t[s], t[s + 1], t[s + 2]])[1] && n[2]) for (n[0] = n[0] || n[1] || n[2] || n[3], n[1] = n[1] || n[2] || n[0] || n[3], n[2] = n[2] || n[3] || n[1] || n[0], n[3] = n[3] || n[2] || n[1] || n[0], l = 0; l <= 1; l += a) {
          var C = s + l,
            A = ZC.AR.ABI(l, n);
          r.push([C - 1, A]);
        } else r.push([]);
      } else r.push([s - 1, t[s]]);
      return r;
    },
    A10: function A10(e) {
      for (var t = Math.round(ZC.G8(ZC._a_(e)) / Math.LN10), i = [1, 2, 4, 5, 6, 8, 10], a = ZC.MAX, n = 1, l = 0; l < i.length; l++) {
        var r = i[l] * Math.pow(10, t) - e;
        ZC._a_(r) < a && (n = i[l], a = ZC._a_(r));
      }
      return n * Math.pow(10, t);
    },
    _nice_number_: function _nice_number_(e, t) {
      var i, a;
      return i = Math.floor(Math.log(e) / Math.log(10)), a = e / Math.pow(10, i), (t ? a < 1.5 ? 1 : a < 3 ? 2 : a < 7 ? 5 : 10 : a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * Math.pow(10, i);
    },
    WV: function WV(e, t, i, a, n, l) {
      var r, o, s, C, A, Z;
      null === ZC._n_(n) && (n = !0), l = null === ZC._n_(l) ? 10 : Math.min(Math.max(2, l), 100), null !== ZC._n_(a) && 0 !== a || (a = 1);
      var c = Math.floor(ZC.G8(ZC._a_(t)) / Math.LN10);
      e === t && (t += Math.pow(10, c)), r = e, o = t, C = ZC.AR._nice_number_(o - r, !1), null === ZC._n_(i) ? (s = C / (l - 1), s = ZC.AR._nice_number_(s, !0), s *= a) : s = i, n ? (A = Math.floor(r / s) * s, Z = Math.ceil(o / s) * s) : (A = r, Z = o, s = null === ZC._n_(i) ? C / (l - 1) : i);
      var p = Math.floor(ZC.G8(ZC._a_(s)) / Math.LN10),
        u = p < 0 ? ZC._a_(p) : 0;
      if (0 === u) {
        var h = ("" + s).split(".");
        2 === h.length && (u = h[1].length);
      }
      return [A, Z, s, u, s];
    }
  }, ZC.Y5 = {
    md5: function md5(e) {
      return ZC.Y5.ACZ(ZC.Y5.ACW(ZC.Y5.ACV(e)));
    },
    ACW: function ACW(e) {
      return ZC.Y5.ACH(ZC.Y5.AD2(ZC.Y5.ACK(e), 8 * e.length));
    },
    ACZ: function ACZ(e) {
      for (var t, i = "", a = 0, n = e.length; a < n; a++) t = e.charCodeAt(a), i += "0123456789abcdef".charAt(t >>> 4 & 15) + "0123456789abcdef".charAt(15 & t);
      return i;
    },
    ACV: function ACV(e) {
      for (var t, i, a = "", n = -1, l = e.length; ++n < l;) t = e.charCodeAt(n), i = n + 1 < l ? e.charCodeAt(n + 1) : 0, 55296 <= t && t <= 56319 && 56320 <= i && i <= 57343 && (t = 65536 + ((1023 & t) << 10) + (1023 & i), n++), t <= 127 ? a += String.fromCharCode(t) : t <= 2047 ? a += String.fromCharCode(192 | t >>> 6 & 31, 128 | 63 & t) : t <= 65535 ? a += String.fromCharCode(224 | t >>> 12 & 15, 128 | t >>> 6 & 63, 128 | 63 & t) : t <= 2097151 && (a += String.fromCharCode(240 | t >>> 18 & 7, 128 | t >>> 12 & 63, 128 | t >>> 6 & 63, 128 | 63 & t));
      return a;
    },
    ACK: function ACK(e) {
      var t,
        i = Array(e.length >> 2);
      for (t = 0; t < i.length; t++) i[t] = 0;
      for (t = 0; t < 8 * e.length; t += 8) i[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
      return i;
    },
    ACH: function ACH(e) {
      for (var t = "", i = 0; i < 32 * e.length; i += 8) t += String.fromCharCode(e[i >> 5] >>> i % 32 & 255);
      return t;
    },
    AD2: function AD2(e, t) {
      function i(e, t, i, a, n, l) {
        return o((r = o(o(t, e), o(a, l))) << (s = n) | r >>> 32 - s, i);
        var r, s;
      }
      function a(e, t, a, n, l, r, o) {
        return i(t & a | ~t & n, e, t, l, r, o);
      }
      function n(e, t, a, n, l, r, o) {
        return i(t & n | a & ~n, e, t, l, r, o);
      }
      function l(e, t, a, n, l, r, o) {
        return i(t ^ a ^ n, e, t, l, r, o);
      }
      function r(e, t, a, n, l, r, o) {
        return i(a ^ (t | ~n), e, t, l, r, o);
      }
      function o(e, t) {
        var i = (65535 & e) + (65535 & t);
        return (e >> 16) + (t >> 16) + (i >> 16) << 16 | 65535 & i;
      }
      e[t >> 5] |= 128 << t % 32, e[14 + (t + 64 >>> 9 << 4)] = t;
      for (var s = 1732584193, C = -271733879, A = -1732584194, Z = 271733878, c = 0, p = e.length; c < p; c += 16) {
        var u = s,
          h = C,
          _ = A,
          d = Z;
        C = r(C = r(C = r(C = r(C = l(C = l(C = l(C = l(C = n(C = n(C = n(C = n(C = a(C = a(C = a(C = a(C, A = a(A, Z = a(Z, s = a(s, C, A, Z, e[c], 7, -680876936), C, A, e[c + 1], 12, -389564586), s, C, e[c + 2], 17, 606105819), Z, s, e[c + 3], 22, -1044525330), A = a(A, Z = a(Z, s = a(s, C, A, Z, e[c + 4], 7, -176418897), C, A, e[c + 5], 12, 1200080426), s, C, e[c + 6], 17, -1473231341), Z, s, e[c + 7], 22, -45705983), A = a(A, Z = a(Z, s = a(s, C, A, Z, e[c + 8], 7, 1770035416), C, A, e[c + 9], 12, -1958414417), s, C, e[c + 10], 17, -42063), Z, s, e[c + 11], 22, -1990404162), A = a(A, Z = a(Z, s = a(s, C, A, Z, e[c + 12], 7, 1804603682), C, A, e[c + 13], 12, -40341101), s, C, e[c + 14], 17, -1502002290), Z, s, e[c + 15], 22, 1236535329), A = n(A, Z = n(Z, s = n(s, C, A, Z, e[c + 1], 5, -165796510), C, A, e[c + 6], 9, -1069501632), s, C, e[c + 11], 14, 643717713), Z, s, e[c], 20, -373897302), A = n(A, Z = n(Z, s = n(s, C, A, Z, e[c + 5], 5, -701558691), C, A, e[c + 10], 9, 38016083), s, C, e[c + 15], 14, -660478335), Z, s, e[c + 4], 20, -405537848), A = n(A, Z = n(Z, s = n(s, C, A, Z, e[c + 9], 5, 568446438), C, A, e[c + 14], 9, -1019803690), s, C, e[c + 3], 14, -187363961), Z, s, e[c + 8], 20, 1163531501), A = n(A, Z = n(Z, s = n(s, C, A, Z, e[c + 13], 5, -1444681467), C, A, e[c + 2], 9, -51403784), s, C, e[c + 7], 14, 1735328473), Z, s, e[c + 12], 20, -1926607734), A = l(A, Z = l(Z, s = l(s, C, A, Z, e[c + 5], 4, -378558), C, A, e[c + 8], 11, -2022574463), s, C, e[c + 11], 16, 1839030562), Z, s, e[c + 14], 23, -35309556), A = l(A, Z = l(Z, s = l(s, C, A, Z, e[c + 1], 4, -1530992060), C, A, e[c + 4], 11, 1272893353), s, C, e[c + 7], 16, -155497632), Z, s, e[c + 10], 23, -1094730640), A = l(A, Z = l(Z, s = l(s, C, A, Z, e[c + 13], 4, 681279174), C, A, e[c], 11, -358537222), s, C, e[c + 3], 16, -722521979), Z, s, e[c + 6], 23, 76029189), A = l(A, Z = l(Z, s = l(s, C, A, Z, e[c + 9], 4, -640364487), C, A, e[c + 12], 11, -421815835), s, C, e[c + 15], 16, 530742520), Z, s, e[c + 2], 23, -995338651), A = r(A, Z = r(Z, s = r(s, C, A, Z, e[c], 6, -198630844), C, A, e[c + 7], 10, 1126891415), s, C, e[c + 14], 15, -1416354905), Z, s, e[c + 5], 21, -57434055), A = r(A, Z = r(Z, s = r(s, C, A, Z, e[c + 12], 6, 1700485571), C, A, e[c + 3], 10, -1894986606), s, C, e[c + 10], 15, -1051523), Z, s, e[c + 1], 21, -2054922799), A = r(A, Z = r(Z, s = r(s, C, A, Z, e[c + 8], 6, 1873313359), C, A, e[c + 15], 10, -30611744), s, C, e[c + 6], 15, -1560198380), Z, s, e[c + 13], 21, 1309151649), A = r(A, Z = r(Z, s = r(s, C, A, Z, e[c + 4], 6, -145523070), C, A, e[c + 11], 10, -1120210379), s, C, e[c + 2], 15, 718787259), Z, s, e[c + 9], 21, -343485551), s = o(s, u), C = o(C, h), A = o(A, _), Z = o(Z, d);
      }
      return Array(s, C, A, Z);
    }
  }, typeof zingchart === ZC._[31] && (window.zingchart = {
    ADH: !0
  }), zingchart.clipart = {}, zingchart.widgets = {}, zingchart.plugins = {}, zingchart.pool = {}, zingchart.pool.size = 0, zingchart.pool.data = {}, zingchart.pool.getInstance = function (e, t, i, a) {
    var n;
    if (null !== ZC._n_(zingchart.pool.data[i])) (n = zingchart.pool.data[i])._POOL_ = !0, ZC.SKIPOBJCOUNT = !0, a || (n.init(t), n.K = i), ZC.SKIPOBJCOUNT = !1;else {
      switch (e) {
        case "DT":
          n = new DT(t);
          break;
        case "I3":
          n = new I3(t);
          break;
        case "DW":
          n = new DW(t);
          break;
        case "QZ":
          n = new QZ(t);
          break;
        case "CZ":
          n = new CZ(t);
      }
      n.K = i, zingchart.pool.size++, zingchart.pool.size > zingchart.DEV.MAXPOOLSIZE ? (zingchart.pool.data = {}, zingchart.pool.size = 0) : zingchart.pool.data[i] = n;
    }
    return n;
  }, zingchart.i18n = {}, zingchart.THEMES = {}, zingchart.V3D = 2, zingchart.QUOTEDVALUES = !1, zingchart.EDITSOURCE = 1, zingchart.MODULESDEP = {
    line: "xy",
    line3d: "3d,line",
    area: "xy",
    area3d: "3d,area",
    vline: "yx",
    varea: "yx",
    vbar: "xy",
    vbar3d: "3d,vbar",
    hbar: "yx",
    hbar3d: "3d,hbar",
    scatter: "xy",
    bubble: "xy",
    hscatter: "yx",
    hbubble: "yx",
    pie: "r",
    pie3d: "3d,pie",
    nestedpie: "r",
    gauge: "r",
    vbullet: "vbar",
    hbullet: "hbar",
    vfunnel: "xy",
    hfunnel: "yx",
    piano: "xy",
    radar: "r",
    range: "xy",
    vrange: "yx",
    stock: "xy,vbar",
    venn: "r"
  }, zingchart.SKIP = {
    EVENT: !1,
    ANIMATION: !1,
    LEGEND: !1,
    CSV: !1,
    PARSE3D: !1
  }, zingchart.MODULESDIR = function (e) {
    for (var t = 0; t < e.length; t++) {
      if (e[t].src) if (e[t].src.indexOf("zingchart.min.js") > -1) return e[t].src.split("zingchart.min.js")[0] + "modules/";
    }
    return "./modules/";
  }(document.getElementsByTagName("head")[0].childNodes), zingchart.DEV = {
    DOMFRAGMENTS: 1,
    SORTTOKENS: 1,
    PLOTSTATS: 1,
    RESOURCES: 1,
    KEEPSOURCE: 1,
    SPREADTYPE: 0,
    SPREADFACTOR: 10,
    IGNORESUBUNIT: 0,
    DELAYEDTRACKERS: 0,
    STACKINGLOGIC: -1,
    SMARTDATELABELS: 0,
    GC: 1,
    CACHECANVASTEXT: 0,
    CHECKDECIMALS: 0,
    CACHESELECTION: 0,
    MEDIARULES: 1,
    SKIPTRACKERS: 0,
    PLOTSHLAYER: 0,
    RESIZESPEED: 250,
    DEBOUNCESPEED: 250,
    LOCALSVGEXPORT: 1,
    SKIPPROGRESS: 0,
    SKIPCONTEXTMENU: 0,
    COPYDATA: 1,
    GUIDETIMEOUT: 0,
    LOOKUPCSSTRANSFORM: 0,
    MAPSONBOTTOM: 0,
    MAXPOOLSIZE: 1024,
    MINTRACKERDIFF: 1.5
  }, zingchart.CANVASTEXT = 0, zingchart.ZINDEX = 1, zingchart.CMZINDEX = 9999, zingchart.FSZINDEX = 9998, zingchart.FSID = null, zingchart.ZCOUTPUT = 0, zingchart.ASYNC = 0, zingchart.SORTTRACKERS = 0, zingchart.TIMEOUT = 0, zingchart.USERCSS = {}, zingchart.OBJECTMODE = "normal", zingchart.SYNTAX = "mixed", zingchart.THEME = null, zingchart.EXPORTURL = ("file:" === document.location.protocol ? "http:" : document.location.protocol) + "//export.zingchart.com/", zingchart.AJAXEXPORT = !1, zingchart.TOUCHZOOM = "normal", zingchart.DEFAULT = {
    height: 480,
    width: 640
  }, zingchart.FASTWIDTH = 0, zingchart.FONTSIZE = 11, zingchart.FONTFAMILY = "Lucida Sans Unicode,Lucida Grande,Lucida Sans,Helvetica,Arial,sans-serif", ZC.mobile && (zingchart.FONTFAMILY = "Lucida Sans,Helvetica,Arial,sans-serif"), zingchart.loadModules = function (e, t) {
    for (var i = ("" + e).split(","), a = 0, n = i.length; a < n; a++) {
      var l = ZC.GY(i[a]);
      l = ZC.ALIAS[l] || l, -1 !== ZC.AV(["bar", "bar3d", "funnel", "bullet"], l) && (l = "v" + l);
      var r = zingchart.MODULESDEP[l];
      null !== ZC._n_(r) && zingchart.loadModules(r), -1 === ZC.AV(ZC.RZ, l) && ZC.RZ.push(l);
    }
    t && zingchart.A1S(null, ZC.RZ, t);
  }, zingchart.A1S = function (e, t, i) {
    var a = 0;
    if (0 === t.length) i();else {
      if (!document.getElementsByTagName("head")[0]) return void i();
      !function n() {
        var l,
          r = !0;
        function o() {
          ++a === t.length ? i() : n();
        }
        zingchart.ACU(t[a]) ? l = zingchart.MODULESDIR + "zingchart-" + t[a] + ".min.js" : r = !1, r ? ZC.AQ.ACJ(e, l, o) : o();
      }();
    }
  }, zingchart.ACU = function (e) {
    return -1 !== ZC.AV(ZC.RZ, e) && -1 === ZC.AV(ZC.XE, e);
  }, zingchart.LS = [], ZC.ie67 || function () {
    for (var e in ZC.IMAGES) ZC.IMAGES.hasOwnProperty(e) && (zingchart.LS[e] = new Image(), zingchart.LS[e].src = ZC.IMAGES[e]);
  }(), typeof Ext !== ZC._[31] && (zingchart.LS["zc.blank"] = new Image(), zingchart.LS["zc.blank"].src = ZC.BLANK), zingchart.exec = function (e, t, i) {
    return zingchart.exec_flash ? zingchart.exec_flash(e, t, i) : null;
  }, zingchart.AD8 = function (O) {
    var RC = O.dataurl || "",
      EW = "",
      G,
      MJ = null;
    null !== ZC._n_(G = O.data) && ("string" == typeof G ? EW = G : MJ = JSON.parse(JSON.stringify(G)));
    var DK = null;
    if ("" !== RC) ZC.A5.ajax({
      type: "GET",
      url: RC,
      async: !1,
      data: zingchart.ZCOUTPUT ? "zcoutput=userdef" : "",
      error: function error() {
        return !1;
      },
      success: function success(KN) {
        function _f_(e) {
          ZC.cache.data["data-" + RC] = KN, O.output = "auto", ZC._cp_(e.render, O);
        }
        try {
          DK = JSON.parse(KN), _f_(DK);
        } catch (JI) {
          try {
            DK = eval("(" + KN + ")"), _f_(DK);
          } catch (JI) {
            return !1;
          }
        }
      }
    });else {
      if ("" !== EW) try {
        DK = JSON.parse(EW);
      } catch (JI) {
        return !1;
      } else null !== MJ && (DK = MJ);
      null === ZC._n_(O.output) && (O.output = "auto"), ZC._cp_(DK.render, O);
    }
    return zingchart.render(O);
  }, zingchart.A0H = null, zingchart.params = {}, zingchart.render = function (e, t) {
    if (null === ZC._n_(t) && (t = !1), t) return zingchart.AD8(e);
    null === ZC._n_(ZC.canvas) && ZC.compat();
    var i = e.output || "auto";
    "html5" === i && (i = "auto"), ZC.mobile && "auto" === i && (i = "svg");
    var a = !1;
    if ("!" === i.substring(0, 1) && (a = !0, i = i.substring(1)), a || ("auto" === i || "canvas" === i && !ZC.canvas || "svg" === i && !ZC.svg || "vml" === i && !ZC.vml || "flash" === i && !ZC.flash) && (ZC.svg ? i = "svg" : ZC.canvas ? i = "canvas" : ZC.vml ? i = "vml" : ZC.flash && (i = "flash")), "vml" === i && null === ZC._n_(zingchart.A0H) && (zingchart.A0H = !1), "flash" !== i) return zingchart.A9M(e, i);
    zingchart.render_flash(e);
  }, document.attachEvent && ("complete" === document.readyState ? zingchart.A0H = !0 : document.attachEvent("onreadystatechange", function () {
    "complete" === document.readyState && (zingchart.A0H = !0);
  })), zingchart.setlabel = zingchart.setLabel = function (e, t) {
    ZC.HQ[e] = t;
  }, zingchart.I8 = [], zingchart.YI = {}, zingchart.ADG = 0, zingchart.AD6 = 0, zingchart.ADE = !1, zingchart.A9U = !1, zingchart.A9X = !1, zingchart.AD0 = !1, zingchart.css = null, zingchart.XK = function (e) {
    if (e.target.id) {
      for (var t = null, i = 0, a = zingchart.I8.length; i < a; i++) e.target.id.substr(0, zingchart.I8[i].K.length + 1) === zingchart.I8[i].K + "-" && (t = zingchart.I8[i]);
      return t;
    }
  }, ZC.GESTURE = {
    id: null,
    on: !1,
    ts: null,
    type: null,
    dist: -1,
    mp: [-1, -1]
  }, typeof zingchart.MW === ZC._[31] && (zingchart.MW = function (e) {
    if (e.target && e.target.tagName && "INPUT" !== e.target.tagName.toUpperCase() && "TEXTAREA" !== e.target.tagName.toUpperCase()) {
      var t;
      if ("pinch" === zingchart.TOUCHZOOM) switch (ZC.TOUCHEVENTS = !1, e.type) {
        case "touchstart":
          for (var i = !1, a = 0; a < zingchart.I8.length; a++) t = ZC.A5("#" + zingchart.I8[a].K + "-top"), ZC.DR(e.touches[0].pageX, t.offset().left, t.offset().left + t.width()) && ZC.DR(e.touches[0].pageY, t.offset().top, t.offset().top + t.height()) && (i = !0, ZC.GESTURE.id = zingchart.I8[a].K);
          i && (ZC.GESTURE.on = !0);
          break;
        case "touchmove":
          if (ZC.GESTURE.on && 2 === e.touches.length) {
            e.preventDefault();
            var n = (e.touches[0].clientX - e.touches[1].clientX) * (e.touches[0].clientX - e.touches[1].clientX) + (e.touches[0].clientY - e.touches[1].clientY) * (e.touches[0].clientY - e.touches[1].clientY);
            n = Math.round(Math.sqrt(n));
            var l = [Math.round((e.touches[0].clientX + e.touches[1].clientX) / 2), Math.round((e.touches[0].clientY + e.touches[1].clientY) / 2)];
            if (-1 === ZC.GESTURE.dist) ZC.GESTURE.dist = n, ZC.GESTURE.mp = l, ZC.GESTURE.ts = new Date().getTime();else if (new Date().getTime() - ZC.GESTURE.ts > 100) {
              if (n > ZC.GESTURE.dist + 50) ZC.GESTURE.type = "pinch-in", zingchart.exec(ZC.GESTURE.id, "zoomin");else if (n < ZC.GESTURE.dist - 50) ZC.GESTURE.type = "pinch-out", zingchart.exec(ZC.GESTURE.id, "zoomout");else {
                ZC.GESTURE.type = "panning";
                var r = {};
                l[0] > ZC.GESTURE.mp[0] + 10 ? (r["x-"] = !0, r.xdist = ZC._a_(ZC.GESTURE.mp[0] - l[0])) : l[0] < ZC.GESTURE.mp[0] - 10 && (r["x+"] = !0, r.xdist = ZC._a_(ZC.GESTURE.mp[0] - l[0])), l[1] > ZC.GESTURE.mp[1] + 10 ? (r["y+"] = !0, r.ydist = ZC._a_(ZC.GESTURE.mp[1] - l[1])) : l[1] < ZC.GESTURE.mp[1] - 10 && (r["y-"] = !0, r.ydist = ZC._a_(ZC.GESTURE.mp[1] - l[1])), ZC.GESTURE.mp = l, zingchart.exec(ZC.GESTURE.id, "pan", r);
              }
              ZC.GESTURE.ts = new Date().getTime();
            }
          }
          break;
        case "touchend":
          ZC.GESTURE.id = null, ZC.GESTURE.on = !1, ZC.GESTURE.type = null, ZC.GESTURE.ts = null, ZC.GESTURE.dist = -1, ZC.GESTURE.mp = [-1, -1];
      }
      if (window.ZC) {
        window.ZC.E0 = [e.pageX, e.pageY];
        var o = zingchart.XK(e);
        if (o) {
          if (!zingchart.SKIP.EVENT) {
            if (e.type === ZC._[47] && (window.ZC.aMDXY = [e.pageX, e.pageY]), "touchstart" === e.type && o.AG) for (var s = 0; s < o.AG.length; s++) o.AG[s].KW();
            if (-1 !== ZC.AV(["mouseover", "mouseout", "mouseover"], e.type) && "IMG" !== e.target.tagName.toUpperCase()) return;
            if ("mouseout" === e.type && (t = ZC.A5("#" + o.K + "-top"), ZC.DR(e.pageX, t.offset().left, t.offset().left + t.width(), !0) && ZC.DR(e.pageY, t.offset().top, t.offset().top + t.height(), !0))) return;
            ZC.AQ.BZ(e.type, o, zingchart.A0X(e, o));
          }
          zingchart.SKIP.EVENT = !1;
        }
      }
    }
  }, ZC.A5(document).bind(ZC.Q.BX("mouseover"), zingchart.MW).bind(ZC.Q.BX("mouseout"), zingchart.MW).bind(ZC.Q.BX(ZC._[48]), zingchart.MW).bind(ZC.Q.BX(ZC._[47]), zingchart.MW).bind(ZC.Q.BX(ZC._[49]), zingchart.MW)), zingchart.A0X = function (e, t) {
    var i = ZC.Q.MM(e),
      a = t.A26(i[0], i[1]),
      n = ZC.A5("#" + t.K + "-top"),
      l = Math.round(i[0] - n.offset().left),
      r = Math.round(i[1] - n.offset().top),
      o = "none";
    return /(.*)\-scale\_(.*)\-item\_title\-area(.*)/.test(e.target.id) && (o = "scale-title"), /(.*)\-scale\_(.*)\-item\_(\d+)\-area(.*)/.test(e.target.id) && (o = "scale-item"), /(.*)\-plotset\-plot\-(\d+)\-node\-(\d+)(.*)/.test(e.target.id) && (o = "node"), /(.*)\-legend\-item\_(\d+)\-area/.test(e.target.id) && (o = "legend-item"), /(.*)\-legend\-marker\_(\d+)\-area/.test(e.target.id) && (o = "legend-marker"), /(.*)\-legend\-(.+)\-area/.test(e.target.id) && (o = "legend-element"), /(.*)\-menu\-item\-(.*)/.test(e.target.id) && (o = "menu-item"), /(.*)\-preview\-handler\-x(.*)/.test(e.target.id) && (o = "preview"), /(.*)\-shape\-(.*?)\-area/.test(e.target.id) && (o = "shape"), /(.*)\-label\-(.*?)\-area/.test(e.target.id) && (o = "label"), {
      id: t.K,
      ev: ZC.A5.BX(e),
      targetid: e.target.id,
      graphid: a ? a.K : null,
      target: o,
      x: l,
      y: r,
      plotarea: !!a && l >= a.P.iX && l <= a.P.iX + a.P.I && r >= a.P.iY && r <= a.P.iY + a.P.F,
      touch: ZC.mobile
    };
  }, typeof zingchart.SN === ZC._[31] && (zingchart.SN = function (e) {
    for (var t = 0, i = zingchart.I8.length; t < i; t++) zingchart.I8[t].hideCM();
    if (ZC.mobile && ZC.move) ZC.move = !1;else if (ZC.mobile || !(e.which > 1)) {
      var a = zingchart.XK(e);
      if (a) {
        if ("click" === e.type && ZC.aMDXY && (ZC._a_(ZC.aMDXY[0] - e.pageX) > 2 || ZC._a_(ZC.aMDXY[1] - e.pageY) > 2)) return;
        if (!zingchart.SKIP.EVENT) {
          var n = zingchart.A0X(e, a);
          n.target = zingchart.plugins.CLICK_TARGET || n.target, zingchart.plugins.CLICK_TARGET = null, ZC.mobile && "touchend" === e.type && (a.E["click-ts"] && new Date().getTime() - a.E["click-ts"] < 500 && ZC.AQ.BZ("dblclick", a, n), a.E["click-ts"] = new Date().getTime()), ZC.AQ.BZ("dblclick" === e.type ? "dblclick" : "click", a, n);
        }
        zingchart.SKIP.EVENT = !1, e.target.id !== a.K + "-menu-area" ? a.hideCM() : zingchart.Z8(e);
      }
    }
  }, ZC.mobile ? (ZC.A5(document).bind("touchmove", function () {
    ZC.move = !0;
  }), ZC.A5(document).bind("touchend", function () {
    ZC.move = !1;
  })) : (ZC.A5(document).bind("click", zingchart.SN), ZC.A5(document).bind("dblclick", zingchart.SN))), typeof zingchart.A3R === ZC._[31] && (zingchart.A3R = function (e) {
    e.touches.length > 0 && (ZC.TOUCHEVENTS = !0);
  }, ZC.A5(document).bind("touchstart", zingchart.A3R)), typeof zingchart.Z8 === ZC._[31] && (zingchart.Z8 = function (e, t, i) {
    if (!(e && e.target && e.target.tagName && "IMG" !== e.target.tagName.toUpperCase() && "AREA" !== e.target.tagName.toUpperCase() && -1 === ZC.Q.TG(e.target).indexOf("zc-scroll") && -1 === e.target.id.indexOf("-legend-") && -1 === e.target.id.indexOf("-preview-")) || zingchart.DEV.SKIPTRACKERS) {
      var a, n, l, r, o, s;
      i = i || {};
      var C = null === ZC._n_(t) ? zingchart.XK(e) : zingchart.getLoader(t);
      if (C) {
        if (-1 !== ZC.AV(C.L0, ZC._[38])) return !1;
        if (null === ZC._n_(t) ? (n = ZC.Q.MM(e), a = C.A26(n[0], n[1])) : a = null !== ZC._n_(i[ZC._[3]]) ? C.OJ(i[ZC._[3]]) : C.AG[0], !a) return !1;
        var A = ZC.A5("#" + C.K + "-top");
        null === ZC._n_(t) ? (l = n[0] - A.offset().left, r = n[1] - A.offset().top) : (l = C.I / 2, r = C.F / 2);
        var Z = {};
        e && (Z = zingchart.A0X(e, C));
        var c = ZC.AQ.BZ("contextmenu", C, Z, !0);
        if (!c && typeof c !== ZC._[31] && (!e && !i["from-api"] || e && e.target.id !== C.K + "-menu-area")) return e.preventDefault(), !1;
        var p = ZC._tx_(C.K);
        C.A16(a ? a.L : -1, e);
        var u = -1;
        if (0 !== zingchart.CMZINDEX) u = zingchart.CMZINDEX;else for (var h = ZC.AK(C.K); -1 === u && null !== h.parentNode;) "auto" !== (u = ZC._i_(ZC.A5(h).css("zIndex"))) && "" !== u && null !== ZC._n_(u) || (u = -1), h = h.parentNode;
        u && -1 !== u && null !== ZC._n_(u) || (u = 1);
        var _ = ZC.A5("#" + C.K + "-menu");
        if (_.css("zIndex", zingchart.ZINDEX + u + 1), null === ZC._n_(t)) {
          if (e.target.id === C.K + "-print-png" || e.target.id === C.K + "-print-jpeg") return !0;
          e.preventDefault();
        }
        if (!ZC.AK(C.K + "-menu")) return !1;
        l = A.offset().left, r = A.offset().top;
        var d = A.width(),
          f = A.height();
        null === ZC._n_(t) ? (o = (n = ZC.Q.MM(e))[0] || ZC.E0[0], s = n[1] || ZC.E0[1]) : (o = l + C.I / 2, s = r + 5);
        var g = !1;
        if (C.U2("goback", !1), C.OB > 0 && (C.U2("goback", !0), g = !0), C.U2("goforward", !1), C.OB < C.QW.length - 1 && (C.U2("goforward", !0), g = !0), C.U2("history", g, !0), o >= l && o <= l + d * p[0] && s >= r && s <= r + f * p[1]) {
          ZC.A5(".zc-menu").each(function () {
            this.id !== C.K + "-menu" && C.hideCM();
          }), C.T2 = [o, s, null === ZC._n_(t) ? e.target.id : t], _.css("opacity", 0).show();
          var B,
            v,
            m = ZC._i_(_.css(ZC._[19])) + ZC._i_(_.css("paddingLeft")) + ZC._i_(_.css("paddingRight")),
            b = ZC._i_(_.css(ZC._[20])) + ZC._i_(_.css("paddingTop")) + ZC._i_(_.css("paddingBottom")),
            E = 1,
            K = !1;
          if (C.o.gui && C.o.gui["context-menu"] && C.o.gui["context-menu"] && (E = C.o.gui["context-menu"].alpha ? C.o.gui["context-menu"].alpha : 1, K = C.o.gui["context-menu"].docked), _.css("opacity", E).hide(), "classic" !== C.LY && K) {
            if (K) {
              var D = C.B8.O9[C.LY].root.gui["context-menu"];
              ZC._cp_(C.o.gui["context-menu"], D), B = "left" !== C.o.gui["context-menu"].position && ZC._n_(C.o.gui["context-menu"].position) ? A.offset().left + A.width() - m : A.offset().left;
            }
            v = A.offset().top, _.css("left", ZC.BQ(1, B) + "px").css("top", ZC.BQ(1, v) + "px").css(ZC._[20], A.height() + "px").css("box-sizing", "border-box").show(), _ = ZC.A5("#" + C.K + "-menu"), K && _.PD[0].scrollHeight > A.height() && _.css("overflow-y", "scroll");
          } else {
            if (null === ZC._n_(t) && e.target.id === C.K + "-menu-area") {
              ZC.AK(C.K + "-menu").style.paddingTop = 0;
              var F = ZC.A5("#" + C.K + "-menu-area").attr("coords").split(","),
                I = ZC._i_(F[3]) - ZC._i_(F[1]);
              ZC.AK(C.K + "-menu").style.backgroundPosition = ZC._i_(F[0]) > C.I / 2 ? "100% 0% !important" : "0% 0% !important", B = l + (ZC._i_(F[0]) > C.I / 2 ? ZC._i_(F[2]) - m : ZC._i_(F[0])), v = r + (ZC._i_(F[1]) > C.F / 1.25 ? ZC._i_(F[3]) - b - I : ZC._i_(F[3]));
            } else ZC.AK(C.K + "-menu").style.backgroundPosition = "50% 0% !important", B = C.T2[0] - m / 2, v = C.T2[1], b > C.F * p[1] ? v = r : v - r + b > C.F * p[1] && (v = ZC.BQ(v - b, C.F * p[1] - b)), B < l && (B = ZC.BQ(B, l)), B + m > l + C.I * p[0] && (B = ZC.CX(l + C.I * p[0] - m / 2, B - m / 2));
            if (i.position) switch (i.position) {
              case "top":
                break;
              case "top-left":
                B = B - (C.I * p[0] - m) / 2 + 5;
                break;
              case "top-right":
                B = B + (C.I * p[0] - m) / 2 - 5;
                break;
              case "bottom":
                v = v + (C.F * p[1] - b) - 10;
                break;
              case "bottom-left":
                v = v + (C.F * p[1] - b) - 10, B = B - (C.I * p[0] - m) / 2 + 5;
                break;
              case "bottom-right":
                v = v + (C.F * p[1] - b) - 10, B = B + (C.I * p[0] - m) / 2 - 5;
                break;
              case "left":
                v = v + (C.F * p[1] - b) / 2 - 5, B = B - (C.I * p[0] - m) / 2 + 5;
                break;
              case "right":
                v = v + (C.F * p[1] - b) / 2 - 5, B = B + (C.I * p[1] - m) / 2 - 5;
            } else null !== ZC._n_(i.x) && null !== ZC._n_(i.y) && (B = l + ZC._i_(i.x), v = r + ZC._i_(i.y));
            if (_.css("left", ZC.BQ(1, B) + "px").css("top", ZC.BQ(1, v) + "px").show(), ZC.ie67) {
              var x = ZC.A5("#" + C.K + "-menu div").width()[0] || 120;
              _.css(ZC._[19], x + "px");
            }
          }
          return C.A9Y = !0, !1;
        }
      }
    }
  }, ZC.A5(document).bind("contextmenu", zingchart.Z8)), zingchart.AAS = function (e, t) {
    if (zingchart.css) return zingchart.css.addRule ? zingchart.css.addRule(e, t) : zingchart.css.insertRule(e + "{" + t + "}", 0);
  }, zingchart.wh = function (e, t, i) {
    "auto" === t && (t = "100%"), "auto" === i && (i = "100%");
    var a = [0, 0];
    return -1 === ("" + t).indexOf("%") && -1 === ("" + i).indexOf("%") || (a = e.wh()), [-1 !== ("" + t).indexOf("%") ? a[0] * parseInt(t, 10) / 100 : parseInt(t, 10), -1 !== ("" + i).indexOf("%") ? a[1] * parseInt(i, 10) / 100 : parseInt(i, 10)];
  }, zingchart.J6 = {}, zingchart.bind = function (e, t, i) {
    e = e || "zingchart-global", zingchart.J6[e] || (zingchart.J6[e] = {}), zingchart.J6[e][t] ? zingchart.J6[e][t].push({
      fn: i
    }) : zingchart.J6[e][t] = [{
      fn: i
    }];
  }, zingchart.unbind = function (e, t, i) {
    if (e = e || "zingchart-global", zingchart.J6[e] && zingchart.J6[e][t]) if (i) {
      for (var a = 0, n = zingchart.J6[e][t].length; a < n; a++) if (zingchart.J6[e][t][a].fn === i) {
        zingchart.J6[e][t].splice(a, 1);
        break;
      }
    } else zingchart.J6[e][t] = null;
  }, zingchart.callEvent = function (e, t, i, a) {
    if (e = e || "zingchart-global", zingchart.J6[e] && zingchart.J6[e][t]) {
      for (var n = 0, l = zingchart.J6[e][t].length; n < l; n++) null !== ZC._n_(a) ? i[i.length - 1] = zingchart.J6[e][t][n].fn.apply(zingchart, i) : zingchart.J6[e][t][n].fn.apply(zingchart, i);
      if (null !== ZC._n_(a)) return i[i.length - 1];
    }
  }, zingchart.hasEvent = function (e, t) {
    return e = e || "zingchart-global", zingchart.J6[e] && zingchart.J6[e][t];
  }, zingchart.A9M = function (e, t) {
    ZC._todash_(e, !1);
    var i,
      a,
      n,
      l,
      r,
      o,
      s,
      C,
      A = [];
    if (null !== ZC._n_(i = e.flags) && (A = i.split(",")), null !== ZC._n_(i = e.mode)) switch (i) {
      case "static":
        A = [ZC._[38], ZC._[39], ZC._[40], ZC._[41], ZC._[44]];
    }
    var Z = "";
    if (null !== ZC._n_(i = e.container) && (Z = i), null !== ZC._n_(i = e.id) && (Z = i), ZC.AK(Z)) {
      var c = null;
      for (n = 0; n < zingchart.I8.length; n++) zingchart.I8[n].K === Z && (c = zingchart.I8[n].MK);
      if (null !== ZC._n_(c)) {
        if ("" !== c) return;
        zingchart.exec(Z, "destroy");
      }
      zingchart.params[Z] = {}, ZC._cp_(e, zingchart.params[Z]);
      var p = !1,
        u = null;
      for (n = 0; n < zingchart.I8.length; n++) zingchart.I8[n].K === Z && (zingchart.I8[n] = new RU(), u = zingchart.I8[n], p = !0);
      if (p || ((u = new RU()).MK = "init", zingchart.I8.push(u)), u.K = Z, zingchart.YI[Z] = !0, "vml" !== t || zingchart.A0H || zingchart.A9M(e, t), !zingchart.A9X) {
        zingchart.A9X = !0;
        var h = {
          ".zc-style": "font-family:" + zingchart.FONTFAMILY + ";font-size:" + zingchart.FONTSIZE + "px;font-weight:normal;font-style:normal;text-decoration:none;text-shadow:none;",
          ".zc-style *": "font-family:" + zingchart.FONTFAMILY + ";font-size:" + zingchart.FONTSIZE + "px;font-weight:normal;font-style:normal;text-decoration:none;text-shadow:none;",
          ".zc-top *": "text-align:left;margin:auto;text-shadow:none;",
          ".zc-menu *": "text-align:left;margin:auto;",
          ".zc-main text": "-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;",
          ".zc-img": "-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",
          ".zc-map": "-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",
          ".zc-pixmap": "-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",
          ".zc-preview-mask": "cursor:default;-webkit-user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;",
          ".zc-about": "position:absolute;overflow:hidden;border:5px solid #fff;background:#003C4F url(" + (ZC.ie67 ? "//" : ZC.LOGO_ABOUT) + ") no-repeat center 10px",
          ".zc-about-1": "padding:80px 5px 5px 5px;text-align:center !important;",
          ".zc-about-1 a": "color:#1AB6E3;font-size:17px;line-height:125%;",
          ".zc-about-2": "padding:5px;color:#fff;text-align:center !important;",
          ".zc-about-3": "padding:5px;text-align:center;line-height:125%;",
          ".zc-about-3 div": "background-color:#1AB6E3;line-height:125%;color:#fff;border:1px solid #fff;padding:5px 10px;font-weight:bold;width:60px;margin:0 auto;cursor:pointer;text-align:center",
          ".zc-about-4": "color:#fff;line-height:125%;",
          ".zc-about-4 div": "float:right;color:#fff;line-height:125%;",
          ".zc-viewsource": "border:5px solid #fff;background:#999",
          ".zc-error": "border:5px solid #fff;background:#900",
          ".zc-bugreport": "border:5px solid #fff;background:#999",
          ".zc-form-row-label": "padding:4px 10px 2px;text-align:left;color:#fff",
          ".zc-form-row-element": "padding:2px 8px",
          ".zc-form-row-last": "padding:8px 8px 2px !important",
          ".zc-form-row-element textarea": "text-align:left;background:#fff;color:#000;border:1px solid #333;",
          ".zc-form-row-label input": "color:#000;padding:2px;margin:0 5px 0 0;background-color:#999;",
          ".zc-form-row-element input": "color:#000;padding:2px;margin:0;background-color:#fff",
          ".zc-form-row-last input": "padding:4px 10px !important;margin:0 20px 0 0 !important;background-color:#eee !important;border:2px outset #ccc !important",
          ".zc-form-s0": "font-size:27px !important;letter-spacing:-1px;line-height:125%",
          ".zc-form-s1": "font-size:17px !important;line-height:125%",
          ".zc-form-s1 a": "color:#fff;padding:3px 10px;position:relative;top:4px;border:1px solid #333;border-bottom:0px solid #333",
          ".zc-tab-active": "background-color:#fff;color:#333 !important",
          ".zc-tab-inactive": "background-color:#999;color:#ddd !important",
          ".zc-bugreport label": "display:inline-block;position:relative;top:-2px",
          ".zc-viewimage div": "position:absolute;text-align:center;padding:5px;background:#999;color:#fff",
          ".zc-license-ie67": "padding:0;position:absolute;font-size:12px;font-weight:bold;font-family:" + zingchart.FONTFAMILY + ";color:#369;text-align:left",
          ".zc-license": "padding:0;position:absolute;",
          "#zc-fullscreen": "display:block;position:absolute;top:0;left:0;width:100%;height:100%;margin:0;padding:0;background:#fff;",
          ".zc-menu": "position:absolute;display:none;background-repeat:no-repeat !important;background-position:50% 0% !important;",
          ".zc-menu-sep": "font-size:1px;padding:0;line-height:1px;border-bottom:1px solid #000",
          ".zc-menu-item": "cursor:pointer;white-space:nowrap",
          ".zc-blocker": "background:#eee",
          ".zc-blocker div.zc-blocker-msg": "position:absolute;border:2px solid #ccc;padding:10px 30px;background-color:#333;color:#fff",
          ".zc-modal": "background-color:#fff;color:#000;border:2px solid #999",
          ".zc-guide-label-table": "border-collapse:collapse",
          ".zc-guide-label-table td": "padding:4px 10px 2px 2px",
          ".zc-data-table": "border-collapse:collapse",
          ".zc-data-table caption": "font-family:" + zingchart.FONTFAMILY + ";text-align:left;font-size:17px;font-weight:600;padding:6px 14px 6px 4px;background-color:#ccc;border-bottom:2px solid #666",
          ".zc-data-table th": "font-family:" + zingchart.FONTFAMILY + ";text-align:left;font-size:13px;font-weight:600;padding:2px 14px 2px 4px;background-color:#ddd;border-bottom:1px solid #666",
          ".zc-data-table td": "font-family:" + zingchart.FONTFAMILY + ";text-align:left;font-size:11px;padding:1px 14px 1px 4px;background-color:#ffffff;border-bottom:1px solid #eee;white-space:nowrap",
          ".zc-rel": "top:0;left:0;position:relative",
          ".zc-abs": "top:0;left:0;position:absolute"
        };
        ZC.ie678 || (h[".zc-data-table th:not(:last-child)"] = "border-right:1px dotted #666", h[".zc-data-table td:not(:last-child)"] = "border-right:1px solid #eee");
        var _ = document.getElementsByTagName("head")[0],
          d = document.createElement("style");
        if (d.type = "text/css", d.setAttribute("data-author", "zingchart"), _.appendChild(d), !zingchart.css) for (n = 0, l = document.styleSheets.length; n < l; n++) document.styleSheets[n].ownerNode && "zingchart" === document.styleSheets[n].ownerNode.getAttribute("data-author") && (zingchart.css = document.styleSheets[n]);
        for (var f in zingchart.css || (zingchart.css = document.styleSheets[document.styleSheets.length - 1]), h) null !== ZC._n_(zingchart.USERCSS[f]) ? zingchart.AAS(f, zingchart.USERCSS[f]) : zingchart.AAS(f, h[f]);
      }
      if ("vml" === t && !zingchart.A9U) document.namespaces.add("zcv", "urn:schemas-microsoft-com:vml"), document.createStyleSheet().cssText = ".zcvml { behavior:url(#default#VML); }", zingchart.A9U = !0;
      var g = "";
      zingchart.THEME && (g = zingchart.THEME), e.data && null !== ZC._n_(i = e.data.theme) && (g = i), null !== ZC._n_(i = e.theme) && (g = i);
      var B = {
        data: !1,
        defaults: !1,
        css: !1,
        csv: !1
      };
      if (null !== ZC._n_(i = e.cache)) for (var v in B) null !== ZC._n_(a = i[v]) && (B[v] = ZC._b_(a));
      var m = !1;
      null !== ZC._n_(i = e.fullscreen) && (m = ZC._b_(i));
      var b = !0;
      null !== ZC._n_(i = e["auto-resize"]) && (b = ZC._b_(i));
      var E = ZC.A5("#" + Z);
      r = (e[ZC._[19]] || "100%") + "", o = (e[ZC._[20]] || "" + zingchart.DEFAULT.height) + "", "auto" === r && (r = "100%"), "auto" === o && (o = "100%");
      var K = zingchart.wh(E, r, o);
      s = K[0], C = K[1], m && (s = ZC.A5(window).width(), C = ZC.A5(window).height(), document.body.style.overflow = "hidden"), s < 10 && (s = zingchart.DEFAULT.width), C < 10 && (C = zingchart.DEFAULT.height), s = 0 === s ? zingchart.DEFAULT.width : s, C = 0 === C ? zingchart.DEFAULT.height : C;
      var D = e.dataurl || "",
        F = e.defaultsurl || "",
        I = null,
        x = "",
        y = null;
      null !== ZC._n_(i = e.data) && ("string" == typeof i ? x = i : y = zingchart.DEV.COPYDATA ? JSON.parse(JSON.stringify(i)) : i), null !== ZC._n_(i = e.defaults) && ("string" == typeof i && (i = JSON.parse(i)), I = i), null !== ZC._n_(i = e.imggen) && (u.A1N = ZC._b_(i)), u.A1N && (u.G3 = null), u.JS = r + "/" + o, u.AA = t, u.A = u, u.iX = 0, u.iY = 0, u.I = s, u.F = C, u.G1 = r, u.N3 = o, u.RC = D, u.EW = x, u.MJ = y, u.RD = F, u.MY = I, u.UV = !1, null !== ZC._n_(e.fullscreenmode) && ZC._b_(e.fullscreenmode) && (u.RB = !0), u.M3 = m, u.SE = B, u.L0 = A, u.LY = g, u.H = u, u.E.hideprogresslogo = !1, null !== ZC._n_(i = e.hideprogresslogo) && (u.E.hideprogresslogo = ZC._b_(i)), null !== ZC._n_(i = e.customprogresslogo) && (u.E.customprogresslogo = i), null !== ZC._n_(i = e.customprogresstext) && (u.E.customprogresstext = i), null !== ZC._n_(i = e.exportdataurl) && (u.E.exportdataurl = i), null !== ZC._n_(i = e.exportimageurl) && (u.E.exportimageurl = i);
      var X = {};
      for (var Y in null !== ZC._n_(i = e.bgcolor) && (X[ZC._[0]] = i), null !== ZC._n_(i = e[ZC._[0]]) && (X[ZC._[0]] = i), null !== ZC._n_(i = e[ZC._[61]]) && (X[ZC._[61]] = i), null !== ZC._n_(i = e[ZC._[62]]) && (X[ZC._[62]] = i), null !== ZC._n_(i = e.color) && (X.color = i), u.E.progress = X, null !== ZC._n_(i = e["auto-load-modules"]) && (u.A72 = ZC._b_(i)), null !== ZC._n_(i = e.events) && (u.A1R = i), null !== ZC._n_(i = e.modules) && (u.A2A = i), null !== ZC._n_(i = e.format) && (u.CH = i), null !== ZC._n_(i = e.csvdata) && (u.O6 = i), null !== ZC._n_(i = e.locale) && null !== ZC._n_(zingchart.i18n[i]) && (u.A1Q = i, ZC.HQ = zingchart.i18n[i]), null !== ZC._n_(i = e["cache-control"]) && (u.NA = i), null !== ZC._n_(i = e.accessibility) && (u.bA11y = ZC._b_(i)), null !== ZC._n_(i = e.description) && (u.PC = i + ""), zingchart.params) if (!zingchart.YI[Y]) for (var w in delete zingchart.params[Y], delete ZC.TS[Y], zingchart.pool.data) 0 === w.indexOf(Y + "-") && (delete zingchart.pool.data[w], zingchart.pool.size--);
      if (u.render(), E.css("overflow", "hidden"), u.M3 && E.css("position", "absolute").css("top", 0).css("left", 0), (-1 !== u.G1.indexOf("%") || -1 !== u.N3.indexOf("%") || u.M3 || u.RB) && b) {
        var L = u.RB || u.M3 ? ZC.A5(window) : E,
          M = L.width(),
          H = L.height(),
          G = 0;
        u.A0R = !1, u.ZG = window.setInterval(function () {
          var e;
          if (ZC.AK(Z) && !u.A2Z) {
            var t = ZC.A5("#" + Z + "-top"),
              i = !1;
            if (-1 !== ("" + u.G1).indexOf("%") && t.length && L.length && t.width() !== L.width() && (i = !0), 0 !== G || L.width() === M && L.height() === H && !i) {
              if (L.width() + L.height() > 0 && (L.width() !== M || L.height() !== H) && (e = u.M3 || u.RB ? zingchart.wh(L, "" + L.width(), "" + L.height()) : zingchart.wh(L, u.G1, u.N3))[0] > 10 && e[1] > 10) {
                for (u.I = ZC._i_(e[0]), u.F = ZC._i_(e[1]), M = L.width(), H = L.height(), n = 0, l = u.AG.length; n < l; n++) u.AG[n].MN[0] = 0;
                N();
              }
            } else if (M = L.width(), H = L.height(), M > 10 && H > 10) {
              for (-1 !== ("" + u.G1).indexOf("%") ? u.I = ZC._i_(M * ZC.IU(u.G1)) : u.I = ZC._i_(M), -1 !== ("" + u.N3).indexOf("%") ? u.F = ZC._i_(H * ZC.IU(u.N3)) : u.F = ZC._i_(H), n = 0, l = u.AG.length; n < l; n++) u.AG[n].MN[0] = 0;
              N();
            }
            G++;
          } else window.clearInterval(u.ZG);
        }, zingchart.DEV.RESIZESPEED);
      }
      return u;
    }
    function P() {
      if (!u.E.wh || u.E.wh !== u.I + "/" + u.F) {
        for (var e = !1, t = 0; t < zingchart.I8.length; t++) zingchart.I8[t].K === u.K && (e = !0);
        e && u.resize();
      }
      u.A0R = !1;
    }
    function N() {
      u.A0R ? u.W3.width !== u.I && (clearTimeout(u.A6W), u.W3.width = u.I, u.W3.height = u.F, u.A6W = setTimeout(P, zingchart.DEV.DEBOUNCESPEED)) : (u.A0R = !0, u.W3 = {
        width: u.I,
        height: u.F
      }, u.A6W = setTimeout(P, zingchart.DEV.DEBOUNCESPEED));
    }
  }, window.zingchart = zingchart, ZC.A5.browser.msie && parseFloat(ZC.A5.browser.version) < 9) {
    var _window_onunload_ = window.onunload;
    window.onunload = function () {
      for (; zingchart.I8.length;) zingchart.exec(zingchart.I8[0].K, "destroy");
      ZC.A5(document).unbind(ZC.Q.BX("mouseover"), zingchart.MW).unbind(ZC.Q.BX("mouseout"), zingchart.MW).unbind(ZC.Q.BX(ZC._[48]), zingchart.MW).unbind(ZC.Q.BX(ZC._[47]), zingchart.MW).unbind(ZC.Q.BX(ZC._[49]), zingchart.MW).unbind("click", zingchart.SN).unbind("contextmenu", zingchart.Z8), zingchart.I8 = [], _window_onunload_ && _window_onunload_();
    };
  }
  zingchart.i18n.en_us = {
    rtl: !1,
    "decimals-separator": ".",
    "thousands-separator": "",
    "menu-enablepagescroll": "Enable Page Scroll",
    "menu-disablepagescroll": "Disable Page Scroll",
    "menu-reload": "Reload",
    "menu-print": "Print Chart",
    "menu-viewaspng": "View As PNG",
    "menu-viewasjpg": "View As JPG",
    "menu-downloadpdf": "Download PDF",
    "menu-downloadsvg": "Download SVG",
    "menu-downloadcsv": "Download CSV",
    "menu-downloadxls": "Download XLS",
    "menu-viewdatatable": "View Data Table",
    "menu-hidedatatable": "Hide Data Table",
    "menu-exportdata": "Export Data",
    "menu-zoomin": "Zoom In",
    "menu-zoomout": "Zoom Out",
    "menu-viewall": "View All",
    "menu-viewsource": "View Source",
    "menu-bugreport": "Submit Bug",
    "menu-switchto2d": "Switch To 2D",
    "menu-switchto3d": "Switch To 3D",
    "menu-showguide": "Show Guide",
    "menu-hideguide": "Hide Guide",
    "menu-switchtolin": "Show Linear Scale",
    "menu-switchtolog": "Show Log Scale",
    "menu-fullscreen": "Full Screen",
    "menu-exitfullscreen": "Exit Full Screen",
    "menu-goback": "Go Back",
    "menu-goforward": "Go Forward",
    "date-formats": {
      msecond: "%d %M %Y<br>%g:%i:%s %A<br>%q ms",
      second: "%d %M %Y<br>%g:%i:%s %A",
      minute: "%d %M %Y<br>%g:%i %A",
      hour: "%d %M %Y<br>%g %A",
      day: "%d %M %Y",
      month: "%M %Y",
      year: "%Y"
    },
    "days-short": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    "days-long": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    "months-short": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    "months-long": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    "sync-wait": "Wait...",
    "export-wait": "Exporting...",
    "progress-wait-long": "Wait. Loading...",
    "progress-wait-short": "Wait...",
    "progress-wait-mini": "...",
    "error-header": "An Error Has Occured",
    "error-message": "Error Message:",
    "error-close": "Close",
    "bugreport-header": "Submit Bug Report",
    "bugreport-senddata": "Send JSON Data",
    "bugreport-sendcapture": "Send Graph Capture",
    "bugreport-yourcomment": "Your Comment:",
    "bugreport-jsondata": "JSON Data:",
    "bugreport-youremail": "Your Email Address",
    "bugreport-infoemail": "if you want to receive via email our reply to your problem",
    "bugreport-emailmandatory": "Email address is mandatory...",
    "bugreport-submit": "Submit",
    "bugreport-cancel": "Cancel",
    "bugreport-confirm": "Your bug report was sent.\n\nThank you!",
    "about-close": "Close",
    "viewsource-jsonsource": "Parsed JSON",
    "viewsource-originalsource": "Original JSON",
    "viewsource-close": "Close",
    "viewsource-apply": "Apply",
    "viewimage-close": "Close",
    "legend-pagination": "Page %page% of %pages%"
  }, ZC.HQ = zingchart.i18n.en_us, zingchart.getLoader = function (e) {
    for (var t = 0; t < zingchart.I8.length; t++) if (zingchart.I8[t].K === e) return zingchart.I8[t];
    return null;
  }, zingchart.getGraph = function (e, t) {
    return e.OJ(t);
  }, zingchart.clearLayer = function (e) {
    e.A7 && e.A7.onmouseout();
    for (var t = 0; t < e.AG.length; t++) e.AG[t].KW();
  }, zingchart.getGraphInfo = function (e, t, i) {
    return e.A0C(t, i);
  }, zingchart.initThemes = function (e) {
    e && e.A61(!0);
  }, zingchart.setModule = function (e) {
    ZC.XE.push(e);
  }, zingchart.getModules = function (e) {
    return e.A2A.split(",");
  }, zingchart.defineModule = function (e, t, i) {
    switch (zingchart.setModule(e), t) {
      case "chart":
        zingchart.bind(null, "dataparse", function (t, a) {
          for (var n = a[ZC._[16]].length, l = 0; l < n; l++) if (a[ZC._[16]][l].type === e) {
            var r = a[ZC._[16]][l];
            r.id ? r.id = r.id : r.id = e.replace(/-/g, "") + l, a[ZC._[16]][l] = i(r);
          }
          return a;
        });
        break;
      case "plugin":
        zingchart.bind(null, "dataparse", function (t, a) {
          var n = zingchart.getLoader(t.id);
          if (-1 !== zingchart.getModules(n).indexOf(e)) for (var l = a[ZC._[16]].length, r = null, o = 0; o < l; o++) (r = a[ZC._[16]][o]).hasOwnProperty(e) && (a[ZC._[16]][o] = i(r, t.id));
          return a;
        });
    }
  }, zingchart.getPalette = function (e, t, i) {
    return i = i || "bar", e.B8.AA5(t, i);
  }, zingchart.getObject = function (e, t, i) {
    var a, n;
    switch (i = i || "label") {
      case "shape":
        for (a = 0, n = e.FJ.length; a < n; a++) if (e.FJ[a].HB === t || a === t) return e.FJ[a].BF;
        break;
      case "label":
        for (a = 0, n = e.BY.length; a < n; a++) if (e.BY[a].HB === t || a === t) return e.BY[a];
    }
    return null;
  }, zingchart.getInstance = function (e, t) {
    switch (t) {
      case "style":
        return new CZ(e);
      case "shape":
        return new DW(e);
      case "box":
        return new I3(e);
      case "textbox":
        return new DT(e);
    }
    return null;
  }, zingchart.normalize = function (e) {
    ZC._todash_(e);
  }, zingchart.copy = function (e, t) {
    ZC._cp_(e, t);
  }, zingchart.formatDate = function (e, t, i, a) {
    return ZC.AQ.YX(e, t, i, a);
  }, zingchart.formatNumber = function (e, t) {
    return ZC.AQ.G5(e, t);
  }, zingchart.fireEvent = function (e, t, i) {
    ZC.AQ.BZ(e, t, i);
  }, zingchart.A9O = [], zingchart.extendAPI = function (e, t) {
    zingchart.A9O.push({
      call: e,
      api: t
    });
  }, zingchart.exec = function (e, t, i) {
    return zingchart.getLoader(e) ? zingchart.ACY(e, t, i) : zingchart.exec_flash ? zingchart.exec_flash(e, t, i) : void 0;
  }, zingchart.ACY = function (e, t, i) {
    var a, n, l;
    i = i || {}, document.getElementById("zc-fullscreen") && !i.skipfs && (e = "zc-fullscreen"), "string" == typeof i && (i = JSON.parse(i));
    var r,
      o,
      s,
      C,
      A,
      Z = zingchart.getLoader(e);
    if (null !== ZC._n_(i[ZC._[53]]) && (Z.E[ZC._[53]] = ZC._b_(i[ZC._[53]])), Z) switch (t) {
      case "goback":
        Z.IJ && Z.OB > 0 && (ZC.AQ.BZ("history_back", Z, Z.F5()), Z.OB--, zingchart.exec(Z.K, "setdata", {
          data: Z.QW[Z.OB]
        }));
        break;
      case "goforward":
        Z.IJ && Z.OB < Z.QW.length - 1 && (ZC.AQ.BZ("history_forward", Z, Z.F5()), Z.OB++, zingchart.exec(Z.K, "setdata", {
          data: Z.QW[Z.OB]
        }));
        break;
      case "setmode":
        if (typeof Z.E["mode-flags"] === ZC._[31] && (Z.E["mode-flags"] = Z.L0.join(",")), "" === i.mode && typeof Z.E["mode-flags"] !== ZC._[31]) Z.L0 = Z.E["mode-flags"].split(",");else {
          Z.L0 = [];
          var c = ("" + i.mode).split(",");
          -1 !== ZC.AV(c, "static") && Z.L0.push(ZC._[38], "skip_objects_tracking", ZC._[39], ZC._[40], ZC._[41]);
        }
        break;
      case "showmenu":
        ZC.E0[0] = ZC._n_(i.x) ? i.x : ZC.E0[0], ZC.E0[1] = ZC._n_(i.y) ? i.y : ZC.E0[1], i["from-api"] = !0, zingchart.Z8(null, Z.K, i);
        break;
      case "hidemenu":
        Z.hideCM();
        break;
      case "destroy":
      case "zcdestroy":
        for (ZC.AQ.BZ("beforedestroy", Z, {
          id: e,
          loader: Z
        }), delete zingchart.YI[e], n = 0, l = Z.AG.length; n < l; n++) Z.AG[n].MN[0] = 0, Z.AG[n].B9 && (Z.AG[n].B9.IY = !1, Z.AG[n].unbind(!1, !0)), Z.H3 && (Z.H3.IY = !1);
        for (var p in ZC.move = !1, Z.YB(), Z.A5W(i, !0), zingchart.DEV.GC && Z.gc(), Z.ZG && window.clearInterval(Z.ZG), Z.ZA && window.clearInterval(Z.ZA), zingchart.J6[e] && delete zingchart.J6[e], ZC.Q.EU([e + "-wrapper", e + "-top", e + "-text-ruler", e + "-dummy", e + "-progress"]), Z.A2C || delete zingchart.params[e], delete ZC.TS[e], delete ZC.cache.data["svg-rect"], zingchart.pool.data) 0 === p.indexOf(e + "-") && (delete zingchart.pool.data[p], zingchart.pool.size--);
        var u = ZC.AV(zingchart.I8, Z);
        -1 !== u && zingchart.I8.splice(u, 1), zingchart.I8.length || (zingchart.GUIDE_EV = null, delete zingchart.LS["zc.logo"]), Z = null, ZC.AQ.BZ("destroy", null, {
          id: e
        });
        break;
      case "getrender":
        return Z.AA;
      case "clear":
        Z.A5W(i);
        break;
      case "reload":
        Z.A4Q(i);
        break;
      case "load":
        Z.AAR(i);
        break;
      case "enable":
        Z.A0U();
        break;
      case "disable":
        Z.A3O(i.text);
        break;
      case "closemodal":
        ZC.Q.EU([Z.K + "-modal", Z.K + "-blocker"]);
        break;
      case "openmodal":
        if (!ZC.AK(Z.K + "-modal")) return ZC.Q.I7({
          cls: "zc-abs zc-style zc-blocker",
          id: Z.K + "-blocker",
          p: ZC.AK(Z.K + "-top"),
          wh: Z.I + "/" + Z.F,
          opacity: .75
        }), ZC.Q.I7({
          cls: "zc-abs zc-style zc-modal",
          id: Z.K + "-modal",
          p: ZC.AK(Z.K + "-top"),
          tl: (Z.F - i[ZC._[20]]) / 2 + "/" + (Z.I - i[ZC._[19]]) / 2,
          wh: i[ZC._[19]] + "/" + i[ZC._[20]],
          opacity: 1
        }), ZC.AK(Z.K + "-modal");
        break;
      case "mapdata":
        Z.A7T(i);
        break;
      case "print":
        Z.A51();
        break;
      case "fullscreen":
        Z.A18();
        break;
      case "exitfullscreen":
        zingchart.exec("zc-fullscreen", "destroy"), ZC.Q.EU("zc-fullscreen");
        break;
      case "resize":
        Z.A2Z = !0;
        var h = Z.I,
          _ = Z.F,
          d = Z.JS.split("/"),
          f = !1,
          g = d[0],
          B = d[1];
        null !== ZC._n_(a = i[ZC._[19]]) && (g = a), null !== ZC._n_(a = i[ZC._[20]]) && (B = a), null !== ZC._n_(a = i.scale) && (f = ZC._b_(a)), Z.A2C && (zingchart.params[Z.K][ZC._[19]] = g, zingchart.params[Z.K][ZC._[20]] = B);
        var v = zingchart.wh(ZC.A5("#" + Z.K), g, B);
        (i.layout || (h !== v[0] || _ !== v[1]) && v[0] > 10 && v[1] > 10) && (Z.I = v[0], Z.F = v[1], null !== ZC._n_(a = i.layout) && (Z.o.layout = a), "" === Z.MK && (Z.E["from-api"] = !0, Z.E[ZC._[53]] = !0, Z.resize(f), Z.G1 = g, Z.N3 = B, Z.A2Z = !1));
        break;
      case "plothide":
      case "hideplot":
        (r = Z.C8(i[ZC._[3]])) && r.Z2(i, "hide");
        break;
      case "showguide":
      case "hideguide":
        ZC.E0[0] = ZC._n_(i.x) ? i.x : ZC.E0[0], ZC.E0[1] = ZC._n_(i.y) ? i.y : ZC.E0[1], (r = Z.C8(i[ZC._[3]])) && Z.W6(r.K, "showguide" === t);
        break;
      case "showtooltip":
      case "hidetooltip":
      case "clicknode":
        if (r = Z.C8(i[ZC._[3]])) {
          var m = i.ev || {};
          "showtooltip" !== t && "clicknode" !== t || ((o = r.HW(i.plotindex, i.plotid)) && o.S.length && !i.xy ? (s = o.L, C = ZC._i_(i.nodeindex || "0"), m.targetid = r.K + ZC._[35] + s + "-node-" + C, m.update = !0) : m.targetid = r.K + "-xy-" + ZC._i_(i.y || "0") + "-" + ZC._i_(i.x || "0")), "clicknode" === t ? (m.which = 0, r.TU(m)) : r.A.A7 && ("showtooltip" === t ? r.A.A7.onmouseover(m, i.data) : r.A.A7.hide());
        }
        break;
      case "locktooltip":
        ZC.TTLOCK = !0;
        break;
      case "unlocktooltip":
        ZC.TTLOCK = !1;
        break;
      case "showhoverstate":
        if (r = Z.C8(i[ZC._[3]])) {
          o = r.HW(i.plotindex, i.plotid), s = ZC._i_(o ? o.L : 0), C = ZC._i_(i.nodeindex || "0");
          var b = r.AY.A4[s].FK(C);
          r.KW(), b.HT();
        }
        break;
      case "plotshow":
      case "showplot":
        (r = Z.C8(i[ZC._[3]])) && r.Z2(i, "show");
        break;
      case "togglesource":
        ZC.AK(Z.K + "-viewsource") ? ZC.Q.EU(Z.K + "-viewsource") : Z.A1A();
        break;
      case "togglebugreport":
        ZC.AK(Z.K + "-bugreport") ? ZC.Q.EU(Z.K + "-bugreport") : Z.A28();
        break;
      case "toggleabout":
        ZC.AK(Z.K + "-about") ? ZC.Q.EU([Z.K + "-about", Z.K + "-about-mask"]) : Z.A5B();
        break;
      case "toggleplot":
        (r = Z.C8(i[ZC._[3]])) && r.PB(i);
        break;
      case "getcharttype":
        return (r = Z.C8(i[ZC._[3]])) ? r.AF : null;
      case "showversion":
      case "getversion":
        return ZC.VERSION;
      case "get3dview":
        return (r = Z.C8(i[ZC._[3]])) ? r.EZ : null;
      case "set3dview":
        (r = Z.C8(i[ZC._[3]])) && (null === ZC._n_(Z.o[ZC._[16]][r.L][ZC._[26]]) && (Z.o[ZC._[16]][r.L][ZC._[26]] = {}), ZC._cp_(i, Z.o[ZC._[16]][r.L][ZC._[26]]), null === ZC._n_(r.o[ZC._[26]]) && (r.o[ZC._[26]] = {}), ZC._cp_(i, r.o[ZC._[26]]), zingchart.SKIP.PARSE3D = !0, r.autoFit(), r.JY(!0, !0), zingchart.SKIP.PARSE3D = !1);
        break;
      case "getpage":
        return Z.LG;
      case "setpage":
        var E = 0;
        null !== ZC._n_(a = i.page) && (E = ZC._i_(a)), Z.LG = E, ZC.ZV(function () {
          Z.clear(), Z.parse(), Z.paint();
        }, !0);
        break;
      case "unbinddocument":
        ZC.A5(document).unbind(ZC.Q.BX(ZC._[48]), zingchart.MW).unbind(ZC.Q.BX(ZC._[47]), zingchart.MW).unbind(ZC.Q.BX(ZC._[49]), zingchart.MW).unbind("click", zingchart.SN).unbind("contextmenu", zingchart.Z8), Z.D6 && Z.D6.unbind();
    }
    var K = [];
    for (zingchart.AC3 && null !== (A = zingchart.AC3(e, t, i)) && (a = A), K = ["addobject", "removeobject", "updateobject", "repaintobjects", "getobjectsbyclass", "getallobjects", "getlabelinfo", "getshapeinfo", "setobjectsmode", "settweenmode"], zingchart.ABJ && -1 !== ZC.AV(K, t) && null !== (A = zingchart.ABJ(e, t, i)) && (a = A), K = ["getimagedata", "exportimage", "saveasimage", "exportdata", "downloadCSV", "downloadXLS", "downloadRAW", "viewDataTable"], zingchart.ABM && -1 !== ZC.AV(K, t) && null !== (A = zingchart.ABM(e, t, i)) && (a = A), K = ["getzoom", "pan", "zoomin", "zoomout", "zoomto", "zoomtovalues", "viewall"], zingchart.AC0 && -1 !== ZC.AV(K, t) && null !== (A = zingchart.AC0(e, t, i)) && (a = A), K = ["clearselection", "getselection", "setselection", "select", "deselect"], zingchart.AB6 && -1 !== ZC.AV(K, t) && null !== (A = zingchart.AB6(e, t, i)) && (a = A), K = ["clearfeed", "getinterval", "setinterval", "stopfeed", "startfeed"], zingchart.AC4 && -1 !== ZC.AV(K, t) && null !== (A = zingchart.AC4(e, t, i)) && (a = A), n = 0, l = zingchart.A9O.length; n < l; n++) t === zingchart.A9O[n].call && null !== (A = zingchart.A9O[n].api.call(zingchart, e, i)) && (a = A);
    return a;
  }, zingchart.extendAPI("addmenuitem", function (e, t) {
    var i = zingchart.getLoader(e);
    i.DE["context-menu"] = i.DE["context-menu"] || {}, i.DE["context-menu"]["custom-items"] = i.DE["context-menu"]["custom-items"] || [];
    for (var a = t.id || "", n = i.DE["context-menu"]["custom-items"], l = !1, r = 0; r < n.length; r++) if (n[r].id === a) {
      l = !0;
      break;
    }
    l || i.DE["context-menu"]["custom-items"].push(t);
  }), zingchart.AC3 = function (e, t, i) {
    var a;
    document.getElementById("zc-fullscreen") && (e = "zc-fullscreen"), "string" == typeof (i = i || {}) && (i = JSON.parse(i));
    var n,
      l,
      r,
      o,
      s,
      C,
      A,
      Z,
      c,
      p,
      u,
      h,
      _,
      d,
      f,
      g,
      B,
      v,
      m,
      b,
      E,
      K,
      D,
      F = zingchart.getLoader(e),
      I = !(null !== ZC._n_(i.update) && !ZC._b_(i.update)),
      x = null !== ZC._n_(i.history) && ZC._b_(i.history),
      y = typeof i.smart !== ZC._[31] && ZC._b_(i.smart);
    if (F) {
      switch (-1 === ZC.AV(["resize", "addplot", "removeplot", "modify", "modifyplot", "setnodevalue", "addnode", "removenode", "setdata"], t) && ((l = F.F5()).params = i, ZC.AQ.BZ(t, F, l)), t) {
        case "clearscroll":
          if (!(n = F.C8(i[ZC._[3]]))) return null;
          n.HZ && n.HZ.ME && (n.HZ.ME(), n.HZ.unbind()), n.HY && n.HY.ME && (n.HY.ME(), n.HY.unbind());
          break;
        case "getbubblesize":
          return (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid)) ? r.getSize(i[ZC._[9]] || 1) : null;
        case "fastlinexycoords":
          var X = (n = F.AG[0]).BJ(ZC._[50]),
            Y = n.BJ(ZC._[51]);
          return X && Y ? [X.AM(i.key), Y.AM(i.val)] : [0, 0];
        case "getscaleinfo":
          return (n = F.C8(i[ZC._[3]])) && (o = n.BJ(i.name || "")) ? null !== ZC._n_(i[ZC._[9]]) ? o.AM ? o.AM(i[ZC._[9]]) : null : null !== ZC._n_(i.coord) && o.KV ? o.KV(i.coord) : null : null;
        case "getobjectinfo":
          if (!(n = F.C8(i[ZC._[3]]))) return null;
          var w = {
            id: "K",
            x: "iX",
            y: "iY",
            width: "I",
            height: "F",
            color: "C2",
            lineColor: "B7",
            lineWidth: "AZ",
            borderColor: "BW",
            borderWidth: "AU",
            backgroundColor1: "A0",
            backgroundColor2: "AE"
          };
          switch (i.object) {
            case "graph":
              for (p in l = {}, w) l[p] = n[w[p]];
              return ZC._cp_({
                type: n.AF
              }, l), l;
            case "plotarea":
              for (p in l = {}, w) l[p] = n.P[w[p]];
              return l;
            case "legend":
              if (l = {}, n.BC) for (p in w) l[p] = n.BC[w[p]];
              return l;
            case "scale":
              if (!(o = n.BJ(i.name || ""))) return null;
              for (p in l = {}, w) l[p] = o[w[p]];
              return ZC._cp_({
                type: o.AF,
                text: o.M && o.M.AO || "",
                datetime: null !== o.FI && "date" === o.FI.o.type,
                step: o.E3,
                step_: o.SR,
                stepSize: o.AC,
                values: o.V,
                placement: o.BA,
                aperture: o.EI,
                zooming: o.GQ,
                offsetStart: o.AB,
                offsetEnd: o.BV
              }, l), o.M && "" !== o.M.AO && (l.label = {
                x: o.M.iX,
                y: o.M.iY,
                width: o.M.I,
                height: o.M.F,
                angle: o.M.A9
              }), "v" === o.AF ? ZC._cp_({
                progression: o.C1,
                logBase: o.E4,
                minValue: o.B3,
                maxValue: o.BL,
                minValue_: o.FX,
                maxValue_: o.H4
              }, l) : "scale-r" === i.name ? ZC._cp_({
                refAngle: o.DF
              }, l) : ZC._cp_({
                minValue: o.V[o.W],
                maxValue: o.V[o.A1],
                minValue_: o.V[o.DD],
                maxValue_: o.V[o.DV],
                minIndex: o.W,
                maxIndex: o.A1,
                minIndex_: o.DD,
                maxIndex_: o.DV
              }, l), l;
            case "plot":
              if (!(r = n.HW(i.plotindex, i.plotid))) return null;
              for (p in l = {}, w) l[p] = r[w[p]];
              var L = r.AN && n.E["plot" + r.L + ".visible"];
              return ZC._cp_({
                visible: L,
                id: r.HB,
                index: r.L,
                type: r.AF,
                text: r.AO,
                values: r.V,
                scales: r.BO,
                stacked: r.CB,
                stackType: r.KX,
                stack: r.DY,
                xdata: r.KJ
              }, l), r.UA && ZC._cp_({
                marker: {
                  visible: r.UA.AN,
                  size: r.UA.AI,
                  type: r.UA.DQ,
                  backgroundColor1: r.UA.A0,
                  backgroundColor2: r.UA.AE,
                  borderColor: r.UA.BW,
                  borderWidth: r.UA.AU
                }
              }, l), l;
            case "node":
              if (r = n.HW(i.plotindex, i.plotid)) {
                if (m = null !== ZC._n_(i.nodeindex) ? ZC._i_(i.nodeindex) : 0, !r.S[m]) return null;
                for (p in s = r.FK(m), (l = {}).bounds = s.H.E[s.K + "-bounds"], w) -1 !== ZC.AV(["x", "y", ZC._[19], ZC._[20]], p) ? l[p] = s[w[p]] : l[p] = s.N[w[p]];
                if (ZC._cp_({
                  plotindex: r.L,
                  index: s.L,
                  size: s.AI,
                  value: s.AD,
                  keyvalue: s.BU,
                  onviewport: s.JK
                }, l), -1 !== r.AF.indexOf("pie") && ZC._cp_({
                  angleStart: s.B4,
                  angleEnd: s.BK,
                  slice: s.A.QA,
                  npv: 100 * s.AD / s.A.A.KU[s.L]
                }, l), r.KJ) {
                  var M = {};
                  for (p in r.KJ) r.KJ[p] instanceof Array ? M[p] = r.KJ[p][m] : M[p] = r.KJ[p];
                  l.xdata = M;
                }
                return l;
              }
              return null;
          }
          break;
        case "getxyinfo":
          var H = [],
            G = i.x,
            P = i.y,
            N = ZC._tx_(F.K);
          G /= N[0], P /= N[1];
          for (var O = 0; O < F.AG.length; O++) {
            n = F.AG[O];
            for (var S = 0; S < n.AY.A4.length; S++) {
              r = n.AY.A4[S];
              var Q = n.BJ(r.BT("k")[0]),
                k = n.BJ(r.BT("v")[0]);
              if (Q && k) {
                if (Q.N0 && Q.N0) {
                  var T = Q.N0(Q.CO ? P : G),
                    z = Q.N0(Q.CO ? P : G, null, !0);
                  H.push({
                    infotype: "key-scale",
                    xydistance: ZC._a_(G - Q.H6(T)),
                    graphid: n.K,
                    plotidx: r.L,
                    scalename: Q.BG,
                    scaleidx: T,
                    scalepos: z,
                    scaletext: Q.BY[T] || "",
                    scalevalue: Q.V[T],
                    scalenumvalue: Q.KV(Q.CO ? P : G)
                  });
                }
                if (k.KV) {
                  var V = k.KV(k.CO ? G : P, !0);
                  H.push({
                    infotype: "value-scale",
                    xydistance: ZC._a_(k.CO ? G : P - k.AM(V)),
                    graphid: n.K,
                    plotidx: r.L,
                    scalename: k.BG,
                    scalevalue: V
                  });
                }
                for (var R, J = ZC.MAX, W = null, U = 0, j = r.S.length; U < j; U++) if (null !== (s = r.FK(U))) switch (n.AJ.layout) {
                  case "xy":
                  case "yx":
                    var q = !1;
                    "vbar" === s.A.AF ? (R = s.getNodeData("h") || s.F, ZC.DR(G, s.iX - s.I / 2, s.iX + s.I / 2) && ZC.DR(P, s.iY, s.iY + R) && (q = !0, J = 1)) : "hbar" === s.A.AF && (R = s.getNodeData("w") || s.I, ZC.DR(G, s.iX, s.iX + R) && ZC.DR(P, s.iY - s.F / 2, s.iY + s.F / 2) && (q = !0, J = 1)), ((a = Math.sqrt((s.iX - G) * (s.iX - G) + (s.iY - P) * (s.iY - P))) < J || q) && (W = {
                      infotype: "node",
                      xydistance: J,
                      graphid: n.K,
                      plotidx: r.L,
                      plotid: r.HB,
                      nodeidx: s.L,
                      nodevalue: s.AD,
                      nodekeyvalue: null === s.BU ? Q.V[s.L] : s.BU
                    }, q || (J = a));
                    break;
                  case "":
                    var $ = s.A6B();
                    (a = Math.sqrt(($[0] - G) * ($[0] - G) + ($[1] - P) * ($[1] - P))) < J && (W = {
                      infotype: "node",
                      xydistance: J,
                      graphid: n.K,
                      plotidx: r.L,
                      plotid: r.HB,
                      nodeidx: s.L,
                      nodevalue: s.AD,
                      nodekeyvalue: null === s.BU ? Q.V[s.L] : s.BU
                    }, J = a);
                }
                W && H.push(W);
              }
            }
          }
          return H;
        case "update":
          i.objects ? (n = F.C8(i[ZC._[3]])) && (n.OA(), n.Q1()) : null !== ZC._n_(i[ZC._[3]]) && (n = F.C8(i[ZC._[3]])) ? F.PQ(function () {
            n.JY(y, y);
          }) : F.JY();
          break;
        case "setcharttype":
          (n = F.C8(i[ZC._[3]])) && (null !== ZC._n_(i["preserve-state"]) && ZC._b_(i["preserve-state"]) ? F.E["graph-state-" + n.L] = JSON.stringify(n.E) : F.E["graph-state-" + n.L] = null, F.o[ZC._[16]][n.L].type = n.o.type = n.AF = i.type, I && F.JY());
          break;
        case "addgraph":
          F.o[ZC._[16]].push(i.data || {}), I && F.JY();
          break;
        case "addplot":
          if (zingchart.SKIP.CSV = !0, h = {}, _ = i.plotdata ? "plotdata" : "data", null !== ZC._n_(i[_]) && ("object" == typeof i[_] ? ZC._cp_(i[_], h) : h = JSON.parse(i[_])), ZC._todash_(h), n = F.C8(i[ZC._[3]])) {
            var ee = [];
            if (null === ZC._n_(n.o[ZC._[11]]) && (n.o[ZC._[11]] = []), u = (null !== ZC._n_(i.plotindex) || null !== ZC._n_(i.plotid)) && (r = n.HW(i.plotindex, i.plotid)) ? r.L : n.o[ZC._[11]].length, null !== ZC._n_(n.J4) && n.J4.splice(u, 0, !1), null !== ZC._n_(n.C9)) {
              for (E in D = {}, n.C9) (K = ZC._i_(E.replace("p", ""))) < u ? D[E] = n.C9[E] : D["p" + (K + 1)] = n.C9[E];
              D["p" + u] = {}, n.C9 = D;
            }
            for (C = 0, A = n.o[ZC._[11]].length; C <= A; C++) C === u && ee.push(h), n.o[ZC._[11]][C] && ee.push(n.o[ZC._[11]][C]);
            ZC.AQ.BZ("plot_add", F, {
              id: F.K,
              graphid: n.K,
              plotindex: u,
              data: h
            }), F.o[ZC._[16]][n.L][ZC._[11]] = n.o[ZC._[11]] = ee, F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, F.PQ(function () {
              n.JY(y, y);
            }));
          }
          break;
        case "removeplot":
          if (zingchart.SKIP.CSV = !0, (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid))) {
            if (null !== ZC._n_(n.J4) && n.J4.splice(r.L, 1), null !== ZC._n_(n.C9)) {
              for (E in D = {}, n.C9) (K = ZC._i_(E.replace("p", ""))) < r.L ? D[E] = n.C9[E] : D["p" + (K - 1)] = n.C9[E];
              n.C9 = D;
            }
            n.o[ZC._[11]].splice(r.L, 1), F.o[ZC._[16]][n.L][ZC._[11]] = n.o[ZC._[11]], F.E.json = ZC.GY(JSON.stringify(F.o)), ZC.AQ.BZ("plot_remove", F, {
              id: F.K,
              graphid: n.K,
              plotindex: r.L
            }), n.LJ("on-change"), n.JY(y, y);
          }
          break;
        case "modify":
          if (zingchart.SKIP.CSV = !0, h = {}, null !== ZC._n_(i.data) && ("object" == typeof i.data ? ZC._cp_(i.data, h) : h = JSON.parse(i.data)), ZC._todash_(h), n = F.C8(i[ZC._[3]])) {
            if (n.B9 && (n.B9.IP = !1, n.E["force-preview-parse"] = !0), null !== ZC._n_(i.object)) switch (i.object) {
              case "title":
                ZC._cp_(h, n.o.title);
                break;
              case "plotset":
              case "series":
                ZC._cp_(h, n.o[ZC._[11]]);
                break;
              case "plotarea":
                ZC._cp_(h, n.o.plotarea);
                break;
              case "legend":
                ZC._cp_(h, n.o.legend);
                break;
              case "plot":
                ZC._cp_(h, n.o.plot);
                break;
              case "map":
                ZC._cp_(h, n.o.shapes[0]);
            } else ZC._cp_(h, n.o);
            switch (i.object) {
              case "title":
                F.o[ZC._[16]][n.L].title = n.o.title;
                break;
              case "plotset":
              case "series":
                F.o[ZC._[16]][n.L][ZC._[11]] = n.o[ZC._[11]];
                break;
              case "plotarea":
                F.o[ZC._[16]][n.L].plotarea = n.o.plotarea;
                break;
              case "legend":
                F.o[ZC._[16]][n.L].legend = n.o.legend;
                break;
              case "plot":
                F.o[ZC._[16]][n.L].plot = n.o.plot;
                break;
              case "map":
                F.o[ZC._[16]][n.L].shapes[0] = n.o.shapes[0], F.VX(F.o), n.o.shapes = F.o[ZC._[16]][n.L].shapes;
                break;
              default:
                F.o[ZC._[16]][n.L] = n.o;
            }
            F.E.json = ZC.GY(JSON.stringify(F.o)), ZC.AQ.BZ("modify", F, {
              id: F.K,
              graphid: n.K,
              data: h,
              object: i.object
            }), n.LJ("on-change"), I && (n.E["from-api"] = !0, F.PQ(function () {
              n.JY(y, y);
            }));
          }
          break;
        case "modifyplot":
          zingchart.SKIP.CSV = !0, h = {}, _ = i.plotdata ? "plotdata" : "data", null !== ZC._n_(i[_]) && ("object" == typeof i[_] ? ZC._cp_(i[_], h) : h = JSON.parse(i[_])), ZC._todash_(h), (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid)) && (null === ZC._n_(F.o[ZC._[16]][n.L][ZC._[11]]) && (F.o[ZC._[16]][n.L][ZC._[11]] = []), ZC._cp_(h, n.o[ZC._[11]][r.L]), F.o[ZC._[16]][n.L][ZC._[11]][r.L] = n.o[ZC._[11]][r.L], F.E.json = ZC.GY(JSON.stringify(F.o)), ZC.AQ.BZ("plot_modify", F, {
            id: F.K,
            graphid: n.K,
            plotindex: r.L,
            data: h
          }), n.LJ("on-change"), I && (n.E["from-api"] = !0, F.PQ(function () {
            n.JY(y, y);
          })));
          break;
        case "setnodevalue":
          zingchart.SKIP.CSV = !0, (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid)) && (m = 0, null !== ZC._n_(i.nodeindex) && (m = ZC._i_(i.nodeindex)), a = 0, null !== ZC._n_(i[ZC._[9]]) && (a = i[ZC._[9]]), ZC.AQ.BZ("node_set", F, {
            id: F.K,
            graphid: n.K,
            plotindex: r.L,
            nodeindex: m,
            key: m,
            value: a,
            text: a
          }), F.o[ZC._[16]][n.L][ZC._[11]][r.L][ZC._[5]][m] = n.o[ZC._[11]][r.L][ZC._[5]][m] = a, F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, n.JY(y, y)));
          break;
        case "setscalevalues":
          if (zingchart.SKIP.CSV = !0, n = F.C8(i[ZC._[3]])) {
            for (d = i.scale || ZC._[50], f = 0, g = n.BO.length; f < g; f++) d === n.BO[f].BG && null !== ZC._n_(n.o[d]) && (n.o[d][ZC._[5]] = i[ZC._[5]], F.o[ZC._[16]][n.L][d] = F.o[ZC._[16]][n.L][d] || {}, F.o[ZC._[16]][n.L][d][ZC._[5]] = i[ZC._[5]]);
            F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, n.JY(y, y));
          }
          break;
        case "addscalevalue":
          if (zingchart.SKIP.CSV = !0, n = F.C8(i[ZC._[3]])) {
            for (d = i.scale || ZC._[50], f = 0, g = n.BO.length; f < g; f++) if (d === n.BO[f].BG && null !== ZC._n_(n.o[d]) && null !== ZC._n_(n.o[d][ZC._[5]])) {
              for (m = null === ZC._n_(i.nodeindex) ? n.o[d][ZC._[5]].length : ZC._i_(i.nodeindex), (v = n.o[d][ZC._[5]]).push(null), C = v.length - 1; C > m; C--) v[C] = v[C - 1];
              v[m] = i[ZC._[9]] || "", F.o[ZC._[16]][n.L][d][ZC._[5]] = v;
            }
            F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, n.JY(y, y));
          }
          break;
        case "removescalevalue":
          if (zingchart.SKIP.CSV = !0, n = F.C8(i[ZC._[3]])) {
            for (d = i.scale || ZC._[50], f = 0, g = n.BO.length; f < g; f++) d === n.BO[f].BG && null !== ZC._n_(n.o[d]) && null !== ZC._n_(n.o[d][ZC._[5]]) && (m = null === ZC._n_(i.nodeindex) ? n.o[d][ZC._[5]].length - 1 : ZC._i_(i.nodeindex), (v = n.o[d][ZC._[5]]).splice(m, 1), F.o[ZC._[16]][n.L][d][ZC._[5]] = v);
            F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, n.JY(y, y));
          }
          break;
        case "addnode":
          zingchart.SKIP.CSV = !0, n = F.C8(i[ZC._[3]]);
          var te = i[ZC._[9]] instanceof Array;
          if (n && (r = n.HW(i.plotindex, i.plotid))) {
            B = n.o[ZC._[11]][r.L][ZC._[5]], m = null === ZC._n_(i.nodeindex) ? B.length : i.nodeindex, B.push(null);
            var ie = B.length;
            for (m = ZC.BQ(0, ZC.CX(m, ie)), C = ie - 1; C > m; C--) B[C] = B[C - 1];
            if (B[m] = i[ZC._[9]], !te) for (f = 0, g = n.BO.length; f < g; f++) if (d = n.BO[f].BG, "k" === n.BO[f].AF && null !== ZC._n_(i[d + "-value"]) && null !== ZC._n_(n.o[d]) && null !== ZC._n_(n.o[d][ZC._[5]])) {
              for ((v = n.o[d][ZC._[5]]).push(null), C = v.length - 1; C > m; C--) v[C] = v[C - 1];
              v[m] = i[d + "-value"], F.o[ZC._[16]][n.L][d][ZC._[5]] = v;
            }
            ZC.AQ.BZ("node_add", F, {
              id: F.K,
              graphid: n.K,
              plotindex: r.L,
              nodeindex: m,
              key: m,
              value: i[ZC._[9]],
              text: i[ZC._[9]]
            }), F.o[ZC._[16]][n.L][ZC._[11]][r.L][ZC._[5]] = n.o[ZC._[11]][r.L][ZC._[5]], F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, n.JY(y, y));
          }
          break;
        case "removenode":
          if (zingchart.SKIP.CSV = !0, (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid))) {
            B = n.o[ZC._[11]][r.L][ZC._[5]], m = null === ZC._n_(i.nodeindex) ? r.S.length - 1 : ZC._i_(i.nodeindex);
            var ae = !0;
            if (null !== ZC._n_(i.nodekeyvalue)) for (ae = !1, f = 0, g = r.S.length; f < g; f++) {
              if (null === r.S[f] && f === i.nodekeyvalue) {
                ae = !0, m = f;
                break;
              }
              if (r.S[f] && null !== ZC._n_(r.S[f].BU) && r.S[f].BU === i.nodekeyvalue) {
                ae = !0, m = f;
                break;
              }
            }
            if (ae && ZC.DR(m, 0, r.S.length - 1)) {
              for (B.splice(m, 1), f = 0, g = n.BO.length; f < g; f++) d = n.BO[f].BG, "k" === n.BO[f].AF && null !== ZC._n_(i[d]) && ZC._b_(i[d]) && null !== ZC._n_(n.o[d]) && null !== ZC._n_(n.o[d][ZC._[5]]) && ((v = n.o[d][ZC._[5]]).splice(m, 1), F.o[ZC._[16]][n.L][d][ZC._[5]] = v);
              (ae || r.S[m]) && (ZC.AQ.BZ("node_remove", F, {
                id: F.K,
                graphid: n.K,
                plotindex: r.L,
                nodeindex: m,
                key: m,
                value: r.S[m] ? r.S[m].AD : null,
                text: r.S[m] ? r.S[m].AD : null
              }), F.o[ZC._[16]][n.L][ZC._[11]][r.L][ZC._[5]] = n.o[ZC._[11]][r.L][ZC._[5]], F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && (n.E["from-api"] = !0, n.JY(y, y)));
            }
          }
          break;
        case "setdata":
          if (h = {}, null !== ZC._n_(i.data)) if ("object" == typeof i.data) zingchart.DEV.COPYDATA ? h = JSON.parse(JSON.stringify(i.data)) : ZC._cp_(i.data, h);else try {
            h = JSON.parse(i.data);
          } catch (de) {
            return F.NG(de, "JSON parser"), !1;
          }
          ZC._todash_(h), null === ZC._n_(i[ZC._[53]]) && (F.E[ZC._[53]] = !1), n = null, null !== ZC._n_(i[ZC._[3]]) && (n = F.C8(i[ZC._[3]])), ZC.AQ.BZ("setdata", F, {
            id: F.K,
            graphid: n ? n.K : null,
            data: h
          });
          var ne,
            le,
            re = ["x", "y", ZC._[19], ZC._[20]];
          if (n) {
            for (ne = 0; ne < re.length; ne++) delete F.E["graph-" + n.L + "-" + re[ne]];
            F.o[ZC._[16]][n.L] = n.o = h;
            var oe = !1;
            if (h.widgets) oe = !0;else if (h.shapes) for (C = 0; C < h.shapes.length; C++) "zingchart.maps" === h.shapes[C].type && (oe = !0);
            oe && F.VX(F.o), F.E.json = ZC.GY(JSON.stringify(F.o)), I && (n.E["from-api"] = !0, x && F.OB++, F.PQ(function () {
              F.parse(n.K), F.AG[n.L].paint();
            }));
          } else {
            for (ne = 0; ne < re.length; ne++) for (le = 0; le < F.AG.length; le++) delete F.E["graph-" + le + "-" + re[ne]];
            F.o = h, F.E.json = ZC.GY(JSON.stringify(F.o)), F.VX(F.o), I && (x && F.OB++, F.JY());
          }
          break;
        case "getseriesdata":
          return (n = F.C8(i[ZC._[3]])) ? null !== ZC._n_(i.plotindex) || null !== ZC._n_(i.plotid) ? (r = n.HW(i.plotindex, i.plotid, 0)) ? n.o[ZC._[11]][r.L] : null : n.o[ZC._[11]] : null;
        case "setseriesdata":
        case "appendseriesdata":
          if (zingchart.SKIP.CSV = !0, n = F.C8(i[ZC._[3]])) {
            if (null !== ZC._n_(i.plotindex) || null !== ZC._n_(i.plotid) ? (r = n.HW(i.plotindex, i.plotid, 0), h = "setseriesdata" === t ? {} : n.o[ZC._[11]] && n.o[ZC._[11]][r.L] ? n.o[ZC._[11]][r.L] : {}) : h = "setseriesdata" === t ? [] : n.o[ZC._[11]] || [], null !== ZC._n_(i.data) && ("object" == typeof i.data ? ZC._cp_(i.data, h) : ZC._cp_(JSON.parse(i.data), h)), ZC._todash_(h), null !== ZC._n_(i.plotindex) || null !== ZC._n_(i.plotid)) r = n.HW(i.plotindex, i.plotid, 0), F.o[ZC._[16]][n.L][ZC._[11]][r.L] = n.o[ZC._[11]][r.L] = h, h.hasOwnProperty("visible") && (n.E["plot" + r.L + ".visible"] = h.visible);else for (F.o[ZC._[16]][n.L][ZC._[11]] = n.o[ZC._[11]] = h, C = 0; C < h.length; C++) h[C].hasOwnProperty("visible") && (n.E["plot" + C + ".visible"] = h[C].visible);
            F.E.json = ZC.GY(JSON.stringify(F.o)), n.LJ("on-change"), I && F.PQ(function () {
              n.JY(y, y);
            });
          }
          break;
        case "getseriesvalues":
          if (n = F.C8(i[ZC._[3]])) {
            if (null !== ZC._n_(i.plotindex) || null !== ZC._n_(i.plotid)) return (r = n.HW(i.plotindex, i.plotid, 0)) && n.o[ZC._[11]][r.L][ZC._[5]] || [];
            for (b = [], C = 0, A = n.AY.A4.length; C < A; C++) b.push(n.o[ZC._[11]][C][ZC._[5]] || []);
            return b;
          }
          return null;
        case "setseriesvalues":
        case "appendseriesvalues":
          zingchart.SKIP.CSV = !0, b = [], null !== ZC._n_(i[ZC._[5]]) && (b = "object" == typeof i[ZC._[5]] ? i[ZC._[5]] : JSON.parse(i[ZC._[5]]));
          var se = !1;
          if (n = F.C8(i[ZC._[3]])) {
            if (null === ZC._n_(i.plotindex) && null === ZC._n_(i.plotid) || (b = [b], se = !0), se || "setseriesvalues" !== t) {
              for (r = n.HW(i.plotindex, i.plotid, 0), C = 0, A = b.length; C < A; C++) if (n.AY.A4[r.L + C]) if ("setseriesvalues" === t) se && (F.o[ZC._[16]][n.L][ZC._[11]][r.L + C][ZC._[5]] = n.o[ZC._[11]][r.L + C][ZC._[5]] = b[C]);else {
                var Ce = F.o[ZC._[16]][n.L][ZC._[11]][r.L + C][ZC._[5]],
                  Ae = b[C].length > 0 && null !== ZC._n_(b[C][0]) && b[C][0].length > 1,
                  Ze = !0;
                if (null !== ZC._n_(a = i.ignoreduplicates) && (Ze = ZC._b_(a)), Ae) {
                  var ce = Ce.length;
                  for (Z = 0, c = b[C].length; Z < c; Z++) {
                    for (var pe = !1, ue = ce - 1; ue >= 0; ue--) {
                      if (b[C][Z][0] > Ce[ue][0]) {
                        Ce.push(b[C][Z]), pe = !0;
                        break;
                      }
                      if (b[C][Z][0] === Ce[ue][0]) {
                        pe = !0;
                        break;
                      }
                    }
                    pe && Ze || Ce.push(b[C][Z]);
                  }
                } else for (Z = 0, c = b[C].length; Z < c; Z++) Ce.push(b[C][Z]);
                i["max-values"] && ZC._i_(i["max-values"]) < Ce.length && (Ce = Ce.slice(-i["max-values"])), F.o[ZC._[16]][n.L][ZC._[11]][r.L + C][ZC._[5]] = n.o[ZC._[11]][r.L + C][ZC._[5]] = Ce;
              }
            } else {
              for (f = 0; f < b.length; f++) F.o[ZC._[16]][n.L][ZC._[11]][f] = F.o[ZC._[16]][n.L][ZC._[11]][f] || {}, n.o[ZC._[11]][f] = n.o[ZC._[11]][f] || {}, F.o[ZC._[16]][n.L][ZC._[11]][f][ZC._[5]] = n.o[ZC._[11]][f][ZC._[5]] = b[f];
              if (n.o[ZC._[11]].length > b.length) for (f = b.length; f < n.o[ZC._[11]].length; f++) delete F.o[ZC._[16]][n.L][ZC._[11]][f], delete n.o[ZC._[11]][f];
            }
            n.LJ("on-change"), F.E.json = ZC.GY(JSON.stringify(F.o)), I && n.JY(y, y);
          }
          break;
        case "togglelegend":
          if ((n = F.C8(i[ZC._[3]])) && n.BC) {
            var he = !0;
            typeof n.BC.o.visible === ZC._[31] || n.BC.o.visible || (he = !1), n.BC.o.visible = !he, n.BC.clear(!1), n.BC.parse(), n.BC.paint();
          }
          break;
        case "legendminimize":
        case "legendmaximize":
          (n = F.C8(i[ZC._[3]])) && n.BC && ("legendminimize" === t ? (ZC.AQ.BZ("legend_minimize", F, n.GR()), ZC.AQ.BZ("legend_hide", F, n.GR())) : (ZC.AQ.BZ("legend_maximize", F, n.GR()), ZC.AQ.BZ("legend_show", F, n.GR())), n.BC.NN = "legendminimize" === t, n.BC.VI(), n.BC.clear(!1), n.BC.parse(), n.BC.paint());
          break;
        case "legendscroll":
          (n = F.C8(i[ZC._[3]])) && n.BC && (r = n.HW(i.plotindex, i.plotid)) && (n.BC.scrollTo(ZC._i_(r.L)), n.BC.VI(), n.BC.clear(!0), n.BC.Z1 = !0, n.BC.parse(), n.BC.paint());
          break;
        case "toggledimension":
          (n = F.C8(i[ZC._[3]])) && F.A0F(n.K);
          break;
        case "getdata":
          return h = JSON.parse(F.E.json), ZC._todash_(h, !0), h;
        case "getoriginaljson":
          return h = JSON.parse(F.E.source), ZC._todash_(h, !0), h;
        case "getgraphlength":
          return F.AG.length;
        case "getplotlength":
          return (n = F.C8(i[ZC._[3]])) ? n.AY.A4.length : 0;
        case "getscales":
          if (n = F.C8(i[ZC._[3]])) {
            var _e = [];
            for (C = 0; C < n.BO.length; C++) _e.push(n.BO[C].BG);
            return _e;
          }
          return [];
        case "getnodelength":
          return (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid)) ? r.S.length : null;
        case "getnodevalue":
          return (n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid)) && null !== ZC._n_(i.nodeindex) && (s = r.S[ZC._i_(i.nodeindex)]) ? r.EF ? [s.BU, s.AD] : s.AD : null;
        case "getplotvalues":
          if ((n = F.C8(i[ZC._[3]])) && (r = n.HW(i.plotindex, i.plotid))) {
            for (b = [], C = 0, A = r.S.length; C < A; C++) r.S[C] ? r.EF ? b.push([r.S[C].BU, r.S[C].AD]) : b.push(r.S[C].AD) : b.push(null);
            return b;
          }
          return null;
      }
    }
    return null;
  };
  var ACR = /*#__PURE__*/function (_ZCClass) {
    _inherits(ACR, _ZCClass);
    function ACR(e) {
      var _this;
      _classCallCheck(this, ACR);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(ACR).call(this, e)), _this.init(e);
      return _this;
    }
    _createClass(ACR, [{
      key: "init",
      value: function init() {
        var e = this;
        e.OP = null, e.o = {}, e.ID = null, e.JG = null, e.E = {}, e.E5 = [], e.I1 = null, e.MV = "";
      }
    }, {
      key: "GN",
      value: function GN(e, t, i, a, n) {
        var l = this;
        if (e.I1) {
          n = n || l.MV;
          var r = e.I1.call(l, a, n);
          i && r && (r[i + "-state"] ? r = r[i + "-state"] : r[i + "State"] && (r = r[i + "State"]));
          var o,
            s,
            C = l.getPMap(),
            A = {},
            Z = {};
          for (var c in r) o = ZC.EE(c), s = ZC.VA(c), "backgroundColor" === o ? A.A0 = A.AE = ZC.AQ.GE(r[c]) : "borderRadius" === o ? A.F6 = A.FT = A.FH = A.F3 = r[c] : "padding" === c ? A.FO = A.FP = A.FS = A.EP = r[c] : C[o] ? A[C[o]] = r[c] : A[o] = r[c], Z[s] = r[c];
          t.o || ZC._cp_(r, A), ZC._cp_(A, t), t.o && (ZC._cp_(Z, t.o), t.KR());
        }
      }
    }, {
      key: "parse",
      value: function parse() {
        var s = this,
          G,
          i,
          oRule,
          KY;
        "dashed" !== zingchart.SYNTAX && ZC._todash_(s.o);
        var AA = "";
        if (typeof s.H !== ZC._[31] && (AA = s.H.AA), ZC.A02(s.o, "html5"), "" !== AA && ZC.A02(s.o, AA), zingchart.DEV.MEDIARULES && s.o["media-rules"] && typeof s.H !== ZC._[31]) for (i = 0; i < s.o["media-rules"].length; i++) oRule = s.o["media-rules"][i], KY = !0, null !== ZC._n_(oRule["min-width"]) && ZC._i_(oRule["min-width"]) > s.H.I && (KY = !1), null !== ZC._n_(oRule["max-width"]) && ZC._i_(oRule["max-width"]) < s.H.I && (KY = !1), null !== ZC._n_(oRule["min-height"]) && ZC._i_(oRule["min-height"]) > s.H.F && (KY = !1), null !== ZC._n_(oRule["max-height"]) && ZC._i_(oRule["max-height"]) < s.H.F && (KY = !1), KY && ZC._cp_(oRule, s.o);
        for (s.o.rules && (s.E5 = s.o.rules), i = 0; i < s.E5.length; i++) if ("*" === s.E5[i].rule && s.E5[i].js) {
          s.o["js-rule"] = s.E5[i].js, s.E5.splice(i, 1);
          break;
        }
        if (G = s.o["js-rule"]) if ("function" == typeof G) s.MV = "", s.I1 = eval(G);else if ("javascript:" === G.substring(0, 11) || G.indexOf("(") < G.indexOf(")")) try {
          s.MV = "";
          var EA = G.replace("javascript:", ""),
            iOpen = G.indexOf("("),
            iClose = G.indexOf(")");
          -1 !== iOpen && -1 !== iClose && (s.MV = EA.substr(iOpen + 1, iClose - iOpen - 1), EA = EA.substr(0, iOpen)), s.I1 = ZC.evalFn(EA, window);
        } catch (e) {}
        if (typeof s.H !== ZC._[31] && null !== s.H.RA) for (var g in s.H.RA) s.H.RA.hasOwnProperty(g) && null === ZC._n_(s.o[g]) && (s.o[g] = s.H.RA[g]);
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        return {};
      }
    }, {
      key: "addPMap",
      value: function addPMap(e, t, i) {
        for (var a = t.split(","), n = i.split(","), l = 0, r = n.length; l < r; l++) e[a[l]] = n[l];
      }
    }, {
      key: "getData",
      value: function getData() {
        return this.o;
      }
    }, {
      key: "setData",
      value: function setData(e) {
        this.o = e;
      }
    }, {
      key: "getAttributes",
      value: function getAttributes() {
        return this.E;
      }
    }, {
      key: "getAttribute",
      value: function getAttribute(e) {
        return this.E[e];
      }
    }, {
      key: "setAttribute",
      value: function setAttribute(e, t) {
        this.E[e] = t;
      }
    }, {
      key: "get",
      value: function get(e) {
        var t = this.getPMap();
        return t[e] ? this[t[e]] : null;
      }
    }, {
      key: "set",
      value: function set(e, t) {
        var i = this.getPMap();
        i[e] && (this[i[e]] = t);
      }
    }, {
      key: "append",
      value: function append(e, t, i) {
        null === t && (t = !0);
        var a = this;
        e && (a.ID || (a.ID = {}, ZC._cp_(a.o, a.ID, !0, i)), a.JG || (a.JG = {}), ZC._cp_(e, a.JG, !0, i), ZC._cp_(e, a.o, !0, i)), typeof a.A7L !== ZC._[31] && a.A7L() && e && ZC._cp_(e, a.o);
      }
    }, {
      key: "A7L",
      value: function A7L() {}
    }, {
      key: "assign_a",
      value: function assign_a(e) {
        for (var t = 0, i = e.length; t < i; t++) this.o.hasOwnProperty(e[t][0]) && this.YU(e[t][0], e[t][1], e[t][2], e[t][3], e[t][4]);
      }
    }, {
      key: "YU",
      value: function YU(e, t, i, a, n) {
        var l,
          r = this;
        if (null !== (l = r.o[e]) && typeof l !== ZC._[31]) {
          if (i) switch (-1 !== i.indexOf("p") && (l = ZC._p_(l), i = i.replace("p", "")), -1 !== i.indexOf("a") && (l = ZC._a_(l), i = i.replace("a", "")), i) {
            case "i":
              l = ZC._i_(l);
              break;
            case "f":
              l = ZC._f_(l);
              break;
            case "b":
              l = ZC._b_(l);
              break;
            case "c":
              l = ZC.AQ.Z4(l, r), (l = ZC.AQ.GE(l, r)) instanceof Array && ("color" === e || "font-color" === e ? (r.o["text-alpha"] = l[1], r.VM = l[1], r.E["text-alpha"] = l[1]) : e === ZC._[61] ? (r.o["border-alpha"] = l[1], r.O8 = l[1], r.E["b-alpha"] = l[1]) : ("line-color" === e && (r.E["l-alpha"] = l[1]), null === ZC._n_(r.o.alpha) && (r.C6 = l[1])), l = l[0]);
          }
          null !== ZC._n_(a) && null !== ZC._n_(n) && (l = ZC._l_(l, a, n)), r[t] = l;
        }
      }
    }, {
      key: "DB",
      value: function DB() {
        for (var e = this, t = !1, i = 0, a = e.E5.length; i < a; i++) {
          var n = !1;
          try {
            n = new Function("return (" + e.IV(e.E5[i].rule) + ")")();
          } catch (l) {
            n = !1;
          }
          n && (t = !0, e.append(e.E5[i]));
        }
        return t;
      }
    }, {
      key: "A9A",
      value: function A9A(e) {
        for (var t = "", i = 0, a = e.length; i < a; i++) {
          var n = !1;
          try {
            n = new Function("return (" + this.IV(e[i].rule) + ")")();
          } catch (l) {
            n = !1;
          }
          n && (t += "<" + e[i].rule + ">");
        }
        return "" !== t ? [t, ZC.Y5.md5(t)] : null;
      }
    }, {
      key: "IV",
      value: function IV() {
        return !0;
      }
    }, {
      key: "copy",
      value: function copy(e) {
        var t = this;
        ZC._cp_(e.o, t.o), e.ID && (t.ID = t.ID || {}, ZC._cp_(e.ID, t.ID)), e.JG && (t.JG = t.JG || {}, ZC._cp_(e.JG, t.JG)), ZC._cp_(e.E, t.E), ZC._cp_(e.E5, t.E5);
      }
    }]);
    return ACR;
  }(ZCClass);
  var CZ = /*#__PURE__*/function (_ACR) {
    _inherits(CZ, _ACR);
    function CZ(e) {
      var _this2;
      _classCallCheck(this, CZ);
      _this2 = _possibleConstructorReturn(this, _getPrototypeOf(CZ).call(this, e)), _this2.init(e);
      return _this2;
    }
    _createClass(CZ, [{
      key: "init",
      value: function init(e) {
        _get(_getPrototypeOf(CZ.prototype), "init", this).call(this, e);
        var t = this;
        e && e.H && (t.H = e.H), t.K = "", t.DJ = null, t.AN = !0, t.A0 = "-1", t.AE = "-1", t.GV = "", t.HU = "", t.W7 = !0, t.D9 = "", t.MG = "repeat", t.TL = "50% 50%", t.X4 = "", t.L1 = 1, t.NT = "linear", t.NO = 90, t.WP = 0, t.WQ = 0, t.AZ = 0, t.B7 = "#000", t.GH = "", t.EX = 0, t.GD = 0, t.AU = 0, t.BW = "#000", t.C6 = 1, t.O8 = 1, t.TE = "butt", t.A0N = "round", t.MH = !1, t.OS = 45, t.K1 = 2, t.TD = .75, t.SA = "#999", t.PJ = 0, t.CY = !0, t.N9 = !1, t.LD = !1, t.A2V = !1, t.LZ = null, t.BE = "";
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        var e = _get(_getPrototypeOf(CZ.prototype), "getPMap", this).call(this);
        return this.addPMap(e, "visible,backgroundColor1,backgroundColor2,gradientColors,gradientStops,backgroundImage,backgroundRepeat,backgroundPosition,backgroundFit,backgroundScale,fillType,fillAngle,fillOffsetX,fillOffsetY,lineWidth,lineColor,lineStyle,lineSegmentSize,lineGapSize,borderWidth,borderColor,borderAlpha,alpha,lineCap,shadow,shadowAngle,shadowDistance,shadowAlpha,shadowColor,shadowBlur,class,border", "AN,A0,AE,GV,HU,D9,MG,TL,X4,L1,NT,NO,WP,WQ,AZ,B7,GH,EX,GD,AU,BW,O8,C6,TE,MH,OS,K1,TD,SA,PJ,DJ,BE"), e;
      }
    }, {
      key: "copy",
      value: function copy(e) {
        _get(_getPrototypeOf(CZ.prototype), "copy", this).call(this, e);
        for (var t = "AN,A0,AE,GV,HU,D9,W7,MG,TL,X4,L1,NT,NO,WP,WQ,AZ,B7,GH,EX,GD,AU,BW,O8,C6,TE,MH,OS,K1,TD,SA,PJ,CY,LD,DJ,H,BE".split(","), i = 0, a = t.length; i < a; i++) typeof e[t[i]] !== ZC._[31] && (this[t[i]] = e[t[i]]);
      }
    }, {
      key: "A7L",
      value: function A7L() {
        var e,
          t,
          i = this,
          a = !1;
        if ((i.o["class"] || i.o.cls || i.o.id) && null !== i.H && null !== i.H.N) {
          if (e = i.o["class"] || i.o.cls) for (var n = e.split(/(\s+)/), l = 0, r = n.length; l < r; l++) (t = i.H.N["." + n[l]]) && (a = !0, ZC._cp_(t, i.o));
          (e = i.o.id) && (t = i.H.N["#" + e]) && (a = !0, ZC._cp_(t, i.o));
        }
        return null !== i.OP && (t = i.H.N[i.OP]) && (a = !0, ZC._cp_(t, i.o)), a;
      }
    }, {
      key: "KR",
      value: function KR(e) {
        var t,
          i = this;
        switch (null === ZC._n_(e) && (e = i.AZ), i.GH) {
          case "dotted":
            i.EX = ZC.BQ(1, .75 * e), i.GD = 1.75 * e;
            break;
          case "dashed":
            i.EX = 4 * e, i.GD = 3 * e;
            break;
          case "dashdot":
            i.EX = 4 * e, i.GD = 2 * e;
            break;
          default:
            i.EX = 0, i.GD = 0;
        }
        null !== (t = ZC._n_(i.o["line-segment-size"])) && (i.EX = parseInt(t, 10)), null !== (t = ZC._n_(i.o["line-gap-size"])) && (i.GD = parseInt(t, 10));
      }
    }, {
      key: "parse",
      value: function parse() {
        var e, t, i, a, n, l, r, o, s;
        _get(_getPrototypeOf(CZ.prototype), "parse", this).call(this);
        var C = this;
        if (null !== (e = ZC._n_(C.o.override)) && !C.A2V) {
          var A,
            Z,
            c,
            p = -1,
            u = -1;
          for (typeof C.E.plotidx !== ZC._[31] && (p = ZC._i_(C.E.plotidx)), typeof C.E.nodeidx !== ZC._[31] && (u = ZC._i_(C.E.nodeidx)), r = 0, o = e.length; r < o; r++) {
            if (A = -1, Z = -1, e[r].hook) {
              if (null !== (t = ZC._n_(e[r].hook["node-index"]))) {
                if (Z = 0, c = [], "object" == typeof t) c = t;else if ("string" == typeof t) {
                  if (-1 !== t.indexOf(",")) c = t.split(",");else if (-1 !== t.indexOf("-")) for (i = t.split("-"), a = ZC._i_(i[0]); a <= ZC._i_(i[1]); a++) c.push(a);
                } else c = [t];
                -1 !== ZC.AV(c, u) && (Z = 1);
              }
              if (null !== (t = e[r].hook["plot-index"]) && typeof t !== ZC._[31]) {
                if (A = 0, c = [], "object" == typeof t) c = t;else if ("string" == typeof t) {
                  if (-1 !== t.indexOf(",")) c = t.split(",");else if (-1 !== t.indexOf("-")) for (i = t.split("-"), a = ZC._i_(i[0]); a < ZC._i_(i[1]); a++) c.push(a);
                } else c = [t];
                -1 !== ZC.AV(c, p) && (A = 1);
              }
            }
            0 !== A && 0 !== Z && C.append(e[r]);
          }
        }
        if (null !== (e = C.LZ) && C.append(e), e = C.o[ZC._[0]]) {
          if (e = ZC.AQ.Z4(e, this), "rgb(" === String(e).substring(0, 4)) for (n = new RegExp("rgb\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\)"); l = n.exec(e);) e = e.replace(l[0], ZC.AQ.GE(l[0]));
          if ("rgba(" === String(e).substring(0, 5)) for (n = new RegExp("rgba\\((\\d{1,3}),\\s*(\\d{1,3}),\\s*(\\d{1,3})\\,\\s*([0-9.]+)\\)"); l = n.exec(e);) {
            var h = ZC.AQ.GE(l[0], C);
            e = e.replace(l[0], h[0]), C.o.alpha = h[1], C.C6 = h[1], C.E["bg-alpha"] = h[1], null === ZC._n_(C.E["b-alpha"]) && (C.E["b-alpha"] = 1), null === ZC._n_(C.E["l-alpha"]) && (C.E["l-alpha"] = 1);
          }
          var _ = ZC.GY(String(e)).split(/\s+|;|,/);
          C.A0 = ZC.AQ.GE(_[0]), C.AE = 1 === _.length ? C.A0 : ZC.AQ.GE(_[1]);
        }
        if (!(null === ZC._n_(C.o[ZC._[62]]) && null === ZC._n_(C.o[ZC._[61]]) && null === ZC._n_(C.o["line-style"]) || null === ZC._n_(C.o["border-top"]) && null === ZC._n_(C.o["border-right"]) && null === ZC._n_(C.o["border-bottom"]) && null === ZC._n_(C.o["border-left"]) && null === ZC._n_(C.o.border))) {
          var d = ["top", "right", "bottom", "left"],
            f = {
              top: [0, "solid", "#000"],
              right: [0, "solid", "#000"],
              bottom: [0, "solid", "#000"],
              left: [0, "solid", "#000"]
            };
          if (C.ID = C.ID || {}, e = C.ID.border) for (s = e.split(/\s/), r = 0; r < 4; r++) f[d[r]] = [ZC._i_(s[0] || "0"), ZC.GY(s[1] || "solid"), ZC.AQ.GE(s[2] || "#000000")];
          if (null !== ZC._n_(C.ID[ZC._[62]])) for (r = 0; r < 4; r++) f[d[r]][0] = C.ID[ZC._[62]];
          if (null !== ZC._n_(C.ID["line-style"])) for (r = 0; r < 4; r++) f[d[r]][1] = C.ID["line-style"];
          if (null !== ZC._n_(C.ID[ZC._[61]])) for (r = 0; r < 4; r++) f[d[r]][2] = C.ID[ZC._[61]];
          for (r = 0; r < 4; r++) (e = C.ID["border-" + d[r]]) && (s = e.split(/\s/), f[d[r]] = [ZC._i_(s[0] || "0"), ZC.GY(s[1] || "solid"), ZC.AQ.GE(s[2] || "#000000")]);
          if (C.JG = C.JG || {}, e = C.JG.border) for (s = e.split(/\s/), r = 0; r < 4; r++) f[d[r]] = [ZC._i_(s[0] || "0"), ZC.GY(s[1] || "solid"), ZC.AQ.GE(s[2] || "#000000")];
          if (null !== ZC._n_(C.JG[ZC._[62]])) for (r = 0; r < 4; r++) f[d[r]][0] = C.JG[ZC._[62]];
          if (null !== ZC._n_(C.JG["line-style"])) for (r = 0; r < 4; r++) f[d[r]][1] = C.JG["line-style"];
          if (null !== ZC._n_(C.JG[ZC._[61]])) for (r = 0; r < 4; r++) f[d[r]][2] = C.JG[ZC._[61]];
          for (r = 0; r < 4; r++) (e = C.JG["border-" + d[r]]) && (s = e.split(/\s/), f[d[r]] = [ZC._i_(s[0] || "0"), ZC.GY(s[1] || "solid"), ZC.AQ.GE(s[2] || "#000000")]);
          for (r = 0; r < 4; r++) null === ZC._n_(C.o["border-" + d[r]]) && (C.o["border-" + d[r]] = f[d[r]].join(" "));
        }
        C.assign_a([["visible", "AN", "b"], ["background-color-1", "A0", "c"], ["background-color-2", "AE", "c"], ["gradient-colors", "GV"], ["gradient-stops", "HU"], ["pixel-correction", "CY", "b"], ["background-clip", "W7", "b"], ["background-image", "D9"], ["background-repeat", "MG"], ["background-position", "TL"], ["background-fit", "X4"], ["background-scale", "L1", "f"], ["fill-type", "NT"], ["fill-angle", "NO", "i"], ["fill-offset-x", "WP", "f"], ["fill-offset-y", "WQ", "f"], [ZC._[4], "AZ", "i"], ["line-color", "B7", "c"], ["line-style", "GH", ""], ["class", "DJ"], ["cls", "DJ"], ["border", "BE"]]), "none" === C.NT && (C.AE = C.A0, C.NT = "linear"), "" !== C.BE && (s = C.BE.split(/\s/), C.AU = ZC._i_(s[0] || "0"), C.GH = ZC.GY(s[1] || "solid"), C.BW = ZC.AQ.GE(s[2] || "#000000")), C.GV = ZC.AQ.Z4(C.GV, this), C.KR(), C.assign_a([["line-segment-size", "EX", "i"], ["line-gap-size", "GD", "i"], [ZC._[62], "AU", "i"], [ZC._[61], "BW", "c"], ["alpha", "C6", "f", 0, 1], ["shadow", "MH", "b"], ["shadow-angle", "OS", "i", 0, 360], ["shadow-distance", "K1", "i"], ["shadow-alpha", "TD", "f", 0, 1], ["shadow-color", "SA", "c"], ["shadow-blur", "PJ", "i"]]), C.O8 = C.C6, C.assign_a([["border-alpha", "O8", "f", 0, 1]]);
      }
    }]);
    return CZ;
  }(ACR);
  ZC.CQ = {
    contour: function contour(e, t, i) {
      var a, n, l;
      if (e && i && 0 !== i.length) {
        if (!t.E["fast-vector-path"]) for (a = 0, n = i.length; a < n; a++) i[a] && (i[a][0] = parseFloat(Number(i[a][0]).toFixed(2)), i[a][1] = parseFloat(Number(i[a][1]).toFixed(2)));
        var r = !1,
          o = i.length;
        for (a = 0; a < o; a++) null !== ZC._n_(i[a]) && (l = [i[a][0], i[a][1]], null !== ZC._n_(i[a][2]) && l.push(i[a][2], i[a][3]), null !== ZC._n_(i[a][4]) && l.push(i[a][4], i[a][5]), t.N9 && (l[0] = Math.round(l[0]), l[1] = Math.round(l[1]), 4 === l.length && (l[2] = Math.round(l[2]), l[3] = Math.round(l[3]))), t.CY && t.AZ % 2 == 1 && (l[0] -= .5, l[1] -= .5, 4 === l.length && (l[2] -= .5, l[3] -= .5))), 0 === a ? e.moveTo(l[0], l[1]) : i[a] ? (r && (e.moveTo(l[0], l[1]), r = !1), 2 === l.length ? e.lineTo(l[0], l[1]) : 4 === l.length ? e.quadraticCurveTo(l[0], l[1], l[2], l[3]) : 6 === l.length && e.arc(l[0], l[1], l[2], ZC.TK(l[3]), ZC.TK(l[4]), l[5])) : r = !0;
      }
    },
    setup: function setup(e, t) {
      var i = t.H.AA;
      if (1 !== t.C6 && t.LD && (null === ZC._n_(t.o[ZC._[61]]) && (t.BW = t.A0), null === ZC._n_(t.o[ZC._[62]]))) switch (i) {
        case "canvas":
          t.AU = .2;
          break;
        case "svg":
          t.AU = .1;
          break;
        case "vml":
          t.AU = .2, t.E.A96 = t.C6 / 10;
      }
    },
    paint: function paint(e, t, i, a, n, l) {
      if (null === ZC._n_(n) && (n = 2), null === ZC._n_(a) && (a = !1), null === ZC._n_(l) && (l = !1), e && i && 0 !== i.length && t) {
        var r, o, s, C, A, Z;
        !l && i.length > 2 && null !== i[0] && null !== i[i.length - 1] && i[0].join(",") === i[i.length - 1].join(",") && (t.TE = "round");
        var c = t.H.AA;
        if ("canvas" !== c || 0 !== t.AZ && "-1" !== t.B7) {
          if (t.MH && !a) {
            t.C7 = t.C7 || t.Z;
            var p,
              u = ZC.Q._sh_(i, t);
            typeof t.A5J !== ZC._[31] ? p = t.A5J : ((p = new DW(t)).copy(t), p.K = t.K + "-sh", p.MH = !1, p.AZ += p.PJ, p.B7 = p.SA), p.C6 = t.C6 * p.TD, typeof t.ADF === ZC._[31] && (t.A5J = p), p.CY = !1, r = t.C7 ? ZC.Q.E9(t.C7, c) : e, ZC.CQ.setup(r, p), ZC.CQ.paint(r, p, u, !1, 1, l);
          }
          var h = ZC._i_(t.EX || "0"),
            _ = ZC._i_(t.GD || "0");
          "solid" === t.GH && (h = _ = 0);
          var d = i.length;
          typeof t.A9 === ZC._[31] && (t.A9 = 0), "canvas" === c && (e.lineJoin = t.A0N, e.lineCap = t.TE, e.strokeStyle = ZC.AQ.A3D(ZC.AQ.GE(t.B7), a ? t.O8 : t.C6), e.lineWidth = t.AZ, e.beginPath());
          var f = !1;
          if (-1 !== ZC.AV(["svg", "vml"], c)) o = l ? [] : ZC.Q.A3B(i, c, t, a);else {
            var g = !1;
            "dashdot" !== t.GH && (g = e.setLineDash) && e.setLineDash(0 === h || 0 === _ ? [] : [h, _]);
            var B = 0,
              v = [ZC.MAX, ZC.MAX, -ZC.MAX, -ZC.MAX];
            for (Z = 0; Z < d; Z++) if (null !== i[Z]) {
              if (null !== (s = ZC.objmove ? i[Z] : ZC.Q._txp_(i[Z], c, t, a)) && !isNaN(s[0]) && !isNaN(s[1]) && isFinite(s[0]) && isFinite(s[1])) if (d <= 6 && a && (v[0] = ZC.CX(v[0], s[0]), v[1] = ZC.CX(v[1], s[1]), v[2] = ZC.BQ(v[2], s[0]), v[3] = ZC.BQ(v[3], s[1])), 0 === Z) 2 === s.length ? e.moveTo(s[0], s[1]) : 6 === s.length && e.arc(s[0], s[1], s[2], ZC.TK(s[3]), ZC.TK(s[4]), s[5]);else if (f && (e.moveTo(s[0], s[1]), f = !1), g || 0 === h || 0 === _ || 4 === s.length || 6 === s.length || 7 === s.length) 2 === s.length ? e.lineTo(s[0], s[1]) : 4 === s.length ? e.quadraticCurveTo(s[0], s[1], s[2], s[3]) : 6 === s.length ? e.arc(s[0], s[1], s[2], ZC.TK(s[3]), ZC.TK(s[4]), s[5]) : 7 === s.length && e.bezierCurveTo(s[0], s[1], s[2], s[3], s[4], s[5]);else if (null !== i[Z - 1]) {
                var m = ZC.Q._txp_(i[Z - 1], c, t, a),
                  b = m[4 === m.length ? 2 : 0],
                  E = m[4 === m.length ? 3 : 1],
                  K = s[0],
                  D = s[1],
                  F = h + _,
                  I = K - b,
                  x = D - E,
                  y = Math.sqrt(I * I + x * x) + B;
                if (y > h) {
                  var X;
                  B = 0, X = "dashdot" === t.GH ? Math.floor(ZC._a_(y / ((F + t.AZ + _) / 2))) : Math.floor(ZC._a_(y / F));
                  var Y = Math.atan2(x, I),
                    w = Math.cos(Y),
                    L = Math.sin(Y),
                    M = b,
                    H = E,
                    G = h;
                  for (C = 0; C < X; C++) "dashdot" === t.GH && (F = C % 2 ? t.AZ + _ : h + _, G = C % 2 ? t.AZ : h), I = w * F, x = L * F, e.moveTo(M, H), e.lineTo(M + w * G, H + L * G), M += I, H += x;
                  e.moveTo(M, H), (y = Math.sqrt((K - M) * (K - M) + (D - H) * (D - H))) > h ? e.lineTo(M + w * h, H + L * h) : y > 0 && e.lineTo(M + w * y, H + L * y), e.moveTo(K, D);
                } else B = y;
              }
            } else f = !0;
            t.H && d <= 6 && a && (t.H.E[t.K + "-bounds"] = v);
          }
          switch (c) {
            case "canvas":
              e.globalCompositeOperation = t.A1E, e.stroke();
              break;
            case "svg":
            case "vml":
              if (null === ZC._n_(t.o["top-state"]) && t.H.OI && (!a || t.E.areanode)) {
                if (A = t.E.areanode ? t.A0 + "-" + t.AE + "-" + t.D9 + "-" + t.AZ + "-" + t.GH + "-" + t.C6 + "-" + t.BM + "-" + t.BH : t.B7 + "-" + t.AZ + "-" + t.GH + "-" + t.C6 + "-" + t.BM + "-" + t.BH, null === ZC._n_(t.H.OC[n])) {
                  t.H.OC[n] = {
                    uid: A,
                    ctx: e,
                    path: o,
                    style: t,
                    filled: a
                  };
                  break;
                }
                if (t.H.OC[n].uid === A && t.H.OC[n].path.length < 2e3) {
                  C = t.H.OC[n].path, o && o[0] && (C.length > 0 && C[C.length - 1].replace(/[A-Z]+/, "") === o[0].replace(/[A-Z]+/, "") && (o[0] = ""), t.H.OC[n].path = t.H.OC[n].path.concat(o));
                  break;
                }
                "svg" === c ? ZC.CQ.U0(t.H.OC[n].ctx, t.H.OC[n].style, t.H.OC[n].path.join(" "), t.H.OC[n].filled) : ZC.CQ.TZ(t.H.OC[n].ctx, t.H.OC[n].style, t.H.OC[n].path.join(" "), t.H.OC[n].filled), t.H.OC[n] = {
                  uid: A,
                  ctx: e,
                  path: o,
                  style: t,
                  filled: a
                };
                break;
              }
              "svg" === c ? ZC.CQ.U0(e, t, o.join(" "), a, l) : ZC.CQ.TZ(e, t, o.join(" "), a);
          }
          if (null !== ZC._n_(t.o["top-state"]) && !t.YS && !t.E["skip-top"] && !t.WO) {
            var P = new I3(t.A);
            P.copy(t), P.WO = !0, P.MH = !1, P.Z = t.Z, P.append(t.o["top-state"]), P.K = t.K + "-top", P.parse(), "svg" === c ? ZC.CQ.U0(e, P, o.join(" "), a, l) : "vml" === c ? ZC.CQ.TZ(e, P, o.join(" "), a) : ZC.CQ.paint(e, P, i, a, n, l);
          }
        }
      }
    },
    smooth: function smooth(e, t, i) {
      var a, n, l, r;
      ZC._n_(t) && (t = !1), i = i || "h";
      var o = [],
        s = [];
      for (a = 0, n = e.length; a < n; a++) e[a] && ("h" === i ? (s.push(e[a][0]), o.push(e[a][1])) : (s.push(e[a][1]), o.push(e[a][0])), 0 === a && (s.push(s[0]), o.push(o[0])));
      for (s.push(s[s.length - 1]), o.push(o[o.length - 1]), e = [], l = 1, r = o.length; l < r - 1; l++) {
        var C = [o[l - 1], o[l], o[l + 1], o[l + 2]],
          A = ZC._a_(s[l + 1] - s[l]),
          Z = 1 / (A / C.length),
          c = ZC.AR.YY(t, C, A, Z);
        for (a = 0, n = c.length; a < n; a++) null !== ZC._n_(c[a][0]) && null !== ZC._n_(c[a][1]) ? "h" === i ? e.push([s[l] + c[a][0] * A, c[a][1]]) : e.push([c[a][1], s[l] + c[a][0] * A]) : e.push(null);
      }
      return e;
    },
    _append_: function _append_(e, t, i) {
      t.H && t.H.G3 ? (null === ZC._n_(t.H.G3[e.id]) && (t.H.G3[e.id] = document.createDocumentFragment()), t.H.G3[e.id].appendChild(i)) : e.appendChild(i);
    },
    U0: function U0(e, t, i, a, n) {
      if ("" !== i || n) {
        var l, r, o, s, C, A, Z;
        ZC.cache.data["svg-rect"] || (ZC.cache.data["svg-rect"] = ZC.Q.F7("rect", ZC._[36])), l = n ? ZC.cache.data["svg-rect"].cloneNode(!0) : ZC.Q.F7("path", ZC._[36]);
        var c = {};
        if (t.DJ && "" !== t.DJ && (c["class"] = t.DJ), n || (c.d = i), n) {
          t.I < 0 && (t.iX -= t.I, t.I = -t.I), t.F < 0 && (t.iY += t.F, t.F = -t.F);
          var p = 0,
            u = 0,
            h = 1;
          t.CY && (h = 0, p = u = t.AZ / 2, 0 === t.iX && (p = 0), 0 === t.iY && (u = 0)), 0 === h || t.I <= 3 || t.F <= 3 ? (r = Math.floor(t.iX) + p, o = Math.floor(t.iY) + u, s = Math.ceil(t.I) - 2 * p, C = Math.ceil(t.F) - 2 * p, A = t.F6, Z = t.F6) : (r = parseFloat(t.iX.toFixed(h)) + p, o = parseFloat(t.iY.toFixed(h)) + u, s = parseFloat(t.I.toFixed(h)) - 2 * p, C = parseFloat(t.F.toFixed(h)) - 2 * u, A = t.F6, Z = t.F6), c.x = r, c.y = o, c[ZC._[19]] = ZC.BQ(0, s), c[ZC._[20]] = ZC.BQ(0, C), c.rx = A, c.ry = Z, t.H && (t.H.E[t.K + "-bounds"] = [c.x, c.y, c.x + c[ZC._[19]], c.y + c[ZC._[20]]]);
        }
        var _ = "";
        typeof t.K === ZC._[31] || "" === t.K ? typeof t.H !== ZC._[31] && (_ = t.H.GRAPHID + "-path-" + ZC.SEQ, ZC.SEQ++) : _ = t.K + "-path";
        var d,
          f = "";
        if (typeof t.BM !== ZC._[31] && typeof t.BH !== ZC._[31] && (0 === t.BM && 0 === t.BH || (f += "translate(" + t.BM + " " + t.BH + ")")), typeof t.A9 !== ZC._[31] && 0 !== t.A9) {
          var g = t.A9;
          typeof t.E.cx !== ZC._[31] && (g += "," + (ZC._x_(t.E.cx) - .5)), typeof t.E.cy !== ZC._[31] && (g += "," + (ZC._x_(t.E.cy) - .5)), f += " rotate(" + g + ")";
        }
        if (a && -1 !== t.E.fill ? (c.fill = t.E.fill, c["fill-opacity"] = t.C6) : c.fill = "none", c["stroke-linecap"] = t.TE, c["stroke-linejoin"] = t.A0N, t.AZ > 0 && (c.stroke = t.B7, c["stroke-width"] = t.AZ, c["stroke-opacity"] = a ? t.O8 : t.C6, "solid" === t.GH || 0 === t.EX && 0 === t.GD || ("dashdot" === t.GH ? c["stroke-dasharray"] = [t.EX, t.GD, t.AZ, t.GD].join(" ") : c["stroke-dasharray"] = t.EX + "," + t.GD)), l.id = _, "" !== f && (c.transform = f), t.o["fast-line"] && t.AZ > 0 ? (l.setAttribute("stroke", c.stroke), l.setAttribute("stroke-width", c["stroke-width"]), l.setAttribute("stroke-opacity", c["stroke-opacity"]), l.setAttribute("d", i)) : ZC.Q.G4(l, c), ZC.CQ._append_(e, t, l), (!t.E.border || "all" === t.E.border) && typeof t.E.imgfill !== ZC._[31]) if ("string" == typeof t.E.imgfill) ZC.AK(_ + "-imgfill") || (d = n ? ZC.Q.F7("rect", ZC._[36]) : ZC.Q.F7("path", ZC._[36]), ZC.Q.G4(d, {
          id: _ + "-imgfill",
          transform: f,
          fill: t.E.imgfill,
          "fill-opacity": t.C6
        }), n ? ZC.Q.G4(d, {
          x: r,
          y: o,
          width: ZC.BQ(0, s),
          height: ZC.BQ(0, C),
          rx: A,
          ry: Z
        }) : ZC.Q.G4(d, {
          d: i
        }), ZC.CQ._append_(e, t, d));else if (!ZC.AK(_ + "-imgfill")) {
          var B = t.E.imgfill,
            v = ZC.Q.F7("image", ZC._[36]);
          v.setAttributeNS ? "zc." === t.D9.substring(0, 3) ? v.setAttributeNS(ZC._[37], "href", ZC.IMAGES[t.D9]) : v.setAttributeNS(ZC._[37], "href", t.D9) : "zc." === t.D9.substring(0, 3) ? v.setAttribute("src", ZC.IMAGES[t.D9]) : v.setAttribute("src", t.D9), null !== ZC._n_(t.E["clip-path"]) && ZC.Q.G4(v, {
            "clip-path": "url(#" + t.E["clip-path"] + ")"
          }), ZC.Q.G4(v, {
            id: _ + "-imgfill",
            x: B[1],
            y: B[2],
            "fill-opacity": t.C6,
            width: t.E[ZC._[69]],
            height: t.E[ZC._[70]],
            preserveAspectRatio: "none"
          }), ZC.CQ._append_(e, t, v);
        }
      }
    },
    TZ: function TZ(e, t, i, a) {
      var n, l, r, o, s, C;
      a && (i += " x e");
      var A = "";
      typeof t.K === ZC._[31] || "" === t.K ? typeof t.H !== ZC._[31] && (A = t.H.GRAPHID + "-path-" + ZC.SEQ, ZC.SEQ++) : A = t.K + "-path";
      var Z = ZC.Q.F7("zcv:shape");
      Z.style.position = "absolute", Z.style.rotation = t.A9, Z.id = A;
      var c = ZC.Q.F7("zcv:path");
      if (c.v = i, c.setAttribute("VMLv", i), Z.appendChild(c), 0 === t.AZ) Z.stroked = !1;else {
        var p = ZC.Q.F7("zcv:stroke");
        if (o = t.C6, typeof t.E.A96 !== ZC._[31] && (o = t.E.A96), typeof t.E.stroke !== ZC._[31]) l = t.E.stroke.weight, r = t.E.stroke.color, o = t.E.stroke.opacity, s = t.E.stroke.dashstyle;else {
          switch (s = "solid", t.GH) {
            case "solid":
              s = "solid";
              break;
            case "dotted":
              s = "dot";
              break;
            case "dashed":
              s = "dash";
              break;
            default:
              s = t.GH;
          }
          "solid" !== s && "0 0" != (n = ZC.CX(6, t.EX * t.AZ) + " " + ZC.CX(8, t.GD * t.AZ)) && (s = n), l = t.AZ, r = t.B7;
        }
        ZC.Q.G4(p, {
          weight: l + "px",
          color: r,
          opacity: o,
          miterlimit: 10,
          endcap: "flat",
          joinstyle: "round",
          dashstyle: s
        }), Z.appendChild(p);
      }
      a && typeof t.E.fill !== ZC._[31] && -1 !== t.E.fill ? (Z.filled = !0, Z.appendChild(t.E.fill)) : Z.filled = !1, ZC.Q.G4(Z, {
        coordorigin: "0 0",
        coordsize: t.A9 % 360 == 0 ? "100 100" : t.H.I + " " + t.H.F
      });
      var u = 0,
        h = 0;
      if (t.A9 % 360 != 0 && typeof t.E.cx !== ZC._[31] && typeof t.E.cy !== ZC._[31]) {
        var _ = t.H.I / 2 - t.E.cx,
          d = t.H.F / 2 - t.E.cy,
          f = 0 === d ? 0 : ZC.UE(Math.atan(_ / d));
        t.E.cy > t.H.F / 2 && (f += 180);
        var g = Math.sqrt(_ * _ + d * d);
        u = _ - g * ZC.EN(f - t.A9), h = d - g * ZC.EG(f - t.A9);
      }
      var B = 0 - u;
      null !== ZC._n_(t.BM) && (B += t.BM);
      var v = 0 - h;
      if (null !== ZC._n_(t.BH) && (v += t.BH), Z.style.left = B + "px", Z.style.top = v + "px", e.appendChild(Z), t.A9 % 360 == 0 ? (Z.style.width = "10px", Z.style.height = "10px") : (Z.style.width = t.H.I + "px", Z.style.height = t.H.F + "px"), ("all" === t.E.border || typeof t.E.imgfill !== ZC._[31]) && typeof t.E.imgfill !== ZC._[31]) {
        var m = t.E.imgfill;
        1 === m.length ? ((Z = ZC.Q.F7("zcv:shape")).style.position = "absolute", Z.style.rotation = t.A9, (c = ZC.Q.F7("zcv:path")).v = i, Z.appendChild(c), Z.appendChild(m[0]), Z.stroked = !1, ZC.Q.G4(Z, {
          id: A + "-imgfill",
          filled: !0,
          coordorigin: "0 0",
          coordsize: t.A9 % 360 == 0 ? "100 100" : t.H.I + " " + t.H.F
        }), Z.style.left = B + "px", Z.style.top = v + "px", e.appendChild(Z), t.A9 % 360 == 0 ? (Z.style.width = "10px", Z.style.height = "10px") : (Z.style.width = t.H.I + "px", Z.style.height = t.H.F + "px")) : 3 === m.length && ((C = ZC.Q.F7("img")).id = A + "-img", "zc." === t.D9.substring(0, 3) ? C.src = ZC.IMAGES[t.D9] : C.src = t.D9, C.style.position = "absolute", C.style.left = m[1] + "px", C.style.top = m[2] + "px", C.style.width = t.E[ZC._[69]] + "px", C.style.height = t.E[ZC._[70]] + "px", e.appendChild(C));
      }
    }
  };
  var DW = /*#__PURE__*/function (_CZ) {
    _inherits(DW, _CZ);
    function DW(e) {
      var _this3;
      _classCallCheck(this, DW);
      _this3 = _possibleConstructorReturn(this, _getPrototypeOf(DW).call(this, e)), _this3.init(e);
      return _this3;
    }
    _createClass(DW, [{
      key: "init",
      value: function init(e) {
        _get(_getPrototypeOf(DW.prototype), "init", this).call(this, e);
        var t = this;
        t.A = e, t.Z = null, t.C7 = null, t.HB = "", t.iX = -1, t.iY = -1, t.DQ = "poly", t.D = [], t.D0 = [0, 0, 0, 0], t.A9 = 0, t.AI = 0, t.L5 = 0, t.BM = 0, t.BH = 0, t.A9S = 0, t.DS = 0, t.B4 = 0, t.BK = 360, t.CM = 0, t.TX = !1, t.ADD = !1, t.A5Z = 0, t.AB5 = "", t.OI = !1, t.AAC = 1, t.JX = 1, t.E8 = null, t.FF = null, t.J3 = "auto", t.KE = !1, t.A1E = "source-over", t.QY = !1;
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        var e = _get(_getPrototypeOf(DW.prototype), "getPMap", this).call(this);
        return this.addPMap(e, "objectId,x,y,points,bounds,pieAngleStart,pieAngleEnd,pieSlice,url,target,offsetX,offsetY,offsetR,size,size2,angle,shape,flat,cursor", "HB,iX,iY,D,D0,B4,BK,CM,E8,FF,BM,BH,DS,AI,L5,A9,DQ,KE,J3"), e;
      }
    }, {
      key: "build",
      value: function build() {}
    }, {
      key: "copy",
      value: function copy(e) {
        _get(_getPrototypeOf(DW.prototype), "copy", this).call(this, e);
        var t,
          i,
          a = this,
          n = "BM,BH,DS,AI,L5,A9,DQ,KE,J3".split(",");
        for (t = 0, i = n.length; t < i; t++) typeof e[n[t]] !== ZC._[31] && (a[n[t]] = e[n[t]]);
        if (e.D && e.D.length > 0) for (a.D = [], t = 0, i = e.D.length; t < i; t++) a.D.push(e.D[t]);
      }
    }, {
      key: "ll_",
      value: function ll_(e, t) {
        var i = this;
        -1 !== ("" + e).indexOf("lat") && (t = "y"), -1 !== ("" + e).indexOf("lon") && (t = "x"), e = ZC._f_(("" + e).replace("lat", "").replace("lon", ""));
        var a = zingchart.maps.maps[i.A5Z];
        return a && (e = zingchart.maps.lonlat2xy(a._INFO_.x, a._INFO_.y, a._INFO_.width, a._INFO_.height, "x" === t ? [e, 0] : [0, e], a._INFO_.bbox, {
          map: i.A5Z,
          item: i.AB5,
          zoom: a._INFO_.zoom,
          offsetX: a._INFO_.offsetX,
          offsetY: a._INFO_.offsetY
        }, !0)), e = ZC._i_("x" === t ? e[0] : e[1]);
      }
    }, {
      key: "kv_",
      value: function kv_(e, t) {
        var i;
        -1 !== ("" + e).indexOf("val") && (t = "y"), -1 !== ("" + e).indexOf("key") && (t = "x"), e = ZC._f_(("" + e).replace("key", "").replace("val", ""));
        var a = this.H || zingchart.I8[0];
        if (a) {
          var n = this.A || a.AG[0];
          n && ("x" === t ? null !== (i = n.BT("k")[0]) && (e = ZC._i_(i.AM(e))) : null !== (i = n.BT("v")[0]) && (e = ZC._i_(i.AM(e))));
        }
        return ZC._i_(e);
      }
    }, {
      key: "xy_",
      value: function xy_(e, t, i) {
        var a = this;
        t = t || "x";
        var n = "" + e;
        if (-1 !== n.indexOf("lat") || -1 !== n.indexOf("lon")) return a.ll_(e, t);
        if (-1 !== n.indexOf("val") || -1 !== n.indexOf("key")) return a.kv_(e, t);
        if ("" + ZC._f_(e) !== n) return -1 !== (e += "").indexOf("%") ? a.xy_(parseFloat(e.replace("%", "")) / 100, t, !0) : -1 !== e.indexOf("px") ? a.xy_(parseFloat(e.replace("px", "")), t) : a.xy_(parseFloat(e), t);
        var l = typeof a.E["p-x"] !== ZC._[31] ? a.E["p-x"] : a.A.iX,
          r = typeof a.E["p-y"] !== ZC._[31] ? a.E["p-y"] : a.A.iY,
          o = typeof a.E["p-width"] !== ZC._[31] ? a.E["p-width"] : a.A.I,
          s = typeof a.E["p-height"] !== ZC._[31] ? a.E["p-height"] : a.A.F;
        return (e >= 1 || e < 0 || zingchart.DEV.IGNORESUBUNIT) && !i ? "x" === t ? l + parseFloat(e) : r + parseFloat(e) : e >= 0 && e < 1 || i ? "x" === t ? (o = o || 1, Math.round(l + o * e)) : (s = s || 1, Math.round(r + s * e)) : void 0;
      }
    }, {
      key: "locate",
      value: function locate(e) {
        var t,
          i = this;
        if (i.TX) return -1 !== ("" + i.o.x).indexOf("lon") ? i.iX = i.ll_(i.o.x, "x") : i.YU("x", "iX"), -1 !== ("" + i.o.y).indexOf("lat") ? i.iY = i.ll_(i.o.y, "y") : i.YU("y", "iY"), void i.A1I();
        1 === e ? (null !== (t = ZC._n_(i.o.x)) && (i.iX = i.xy_(t, "x")), null !== (t = ZC._n_(i.o.y)) && (i.iY = i.xy_(t, "y")), -1 === i.iX && (i.iX = i.A.iX), -1 === i.iY && (i.iY = i.A.iY)) : 2 === e && (i.A1I(), i.I = i.D0[2] - i.D0[0], i.F = i.D0[3] - i.D0[1]);
      }
    }, {
      key: "A1I",
      value: function A1I() {
        var e,
          t = this,
          i = ZC.MAX,
          a = ZC.MAX,
          n = -ZC.MAX,
          l = -ZC.MAX;
        switch (t.DQ) {
          case "custom":
            i = 0, a = 0, n = 0, l = 0;
            break;
          case "circle":
          case "arc":
          case "pie":
            i = t.iX - t.AI, a = t.iY - t.AI, n = t.iX + t.AI, l = t.iY + t.AI;
            break;
          default:
            for (var r = 0, o = t.D.length; r < o; r++) null !== (e = t.D[r]) && (i = Math.min(i, e[0]), a = Math.min(a, e[1]), n = Math.max(n, e[0]), l = Math.max(l, e[1]));
        }
        t.D0 = [i, a, n, l];
      }
    }, {
      key: "F1",
      value: function F1() {
        var e,
          t = this;
        if ("pie" === t.DQ) {
          var i = 1,
            a = [],
            n = t.B4 + t.A9,
            l = t.BK + t.A9,
            r = t.AI + Math.floor(t.AU / 2),
            o = t.CM - Math.floor(t.AU / 2);
          for (r > 50 && (i = 2), r > 100 && (i = 4), 0 === o ? n % 360 != l % 360 && a.push([t.iX, t.iY]) : a.push(ZC.AR.BN(t.iX, t.iY, o, n), ZC.AR.BN(t.iX, t.iY, (r + o) / 2, n - .25 * t.AU), ZC.AR.BN(t.iX, t.iY, r, n)), e = n; e <= l; e += i) a.push(ZC.AR.BN(t.iX, t.iY, r, e));
          if (a.push(ZC.AR.BN(t.iX, t.iY, r, l)), a.push(ZC.AR.BN(t.iX, t.iY, (r + o) / 2, l + .25 * t.AU)), 0 === o) n % 360 != l % 360 && a.push([t.iX, t.iY]);else {
            for (a.push(ZC.AR.BN(t.iX, t.iY, o, l)), e = l; e >= n; e -= i) a.push(ZC.AR.BN(t.iX, t.iY, o, e));
            a.push(ZC.AR.BN(t.iX, t.iY, o, n));
          }
          return a.push([a[0][0], a[0][1]]), ZC.AR.Q8(a, Math.min(5, r / 5), [t.BM, t.BH]);
        }
        if (0 === t.A9 || "rectangle" !== t.DQ && "rect" !== t.DQ) return ZC.AR.Q8(t.D, Math.min(5, t.AI / 5), [t.BM, t.BH]);
        var s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _ = [];
        for (A = ZC._i_((t.D0[0] + t.D0[2]) / 2), Z = ZC._i_((t.D0[1] + t.D0[3]) / 2), s = 0, C = t.D.length; s < C; s++) null !== t.D[s] && (c = t.D[s][0] - A, p = t.D[s][1] - Z, u = c * ZC.EG(t.A9) - p * ZC.EN(t.A9), h = c * ZC.EN(t.A9) + p * ZC.EG(t.A9), _[s] = [u + A, h + Z]);
        return ZC.AR.Q8(_, Math.min(5, t.AI / 5), [t.BM, t.BH]);
      }
    }, {
      key: "A27",
      value: function A27() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this,
          A = ZC.ie67 ? ZC.MAPTX : 0;
        switch (C.DQ) {
          case "line":
            if (i = [].concat(C.D), 0 !== C.A9) for (a = (C.D0[0] + C.D0[2]) / 2, n = (C.D0[1] + C.D0[3]) / 2, e = 0, t = i.length; e < t; e++) null !== i[e] && (l = i[e][0] - a, r = i[e][1] - n, o = l * ZC.EG(C.A9) - r * ZC.EN(C.A9), s = l * ZC.EN(C.A9) + r * ZC.EG(C.A9), i[e] = [o + a, s + n]);
            var Z = ["poly"];
            for (e = 0, t = i.length; e < t - 1; e++) null !== i[e] && null !== i[e + 1] && Z.push(ZC.AR.Q8(ZC.AR.ZJ([i[e], i[e + 1]]), 4, [C.BM, C.BH]));
            return Z;
          case "cross":
          case "plus":
            return ["circle", ZC._i_(C.iX + A + C.BM) + "," + ZC._i_(C.iY + A + C.BH) + "," + ZC._i_(C.AI)];
          case "circle":
          case "arc":
            return ["circle", ZC._i_(C.iX + A + C.BM) + "," + ZC._i_(C.iY + A + C.BH) + "," + ZC._i_(C.AI + 2)];
          case "pie":
            return ["poly", C.F1()];
          default:
            var c,
              p = ["poly"];
            for (i = [], e = 0, t = C.D.length; e < t; e++) if (null !== C.D[e]) {
              if (6 === C.D[e].length) for (var u = C.D[e][3]; u < C.D[e][4]; u += 1) i.push(ZC.AR.BN(C.D[e][0], C.D[e][1], C.D[e][2], u));else if (4 === C.D[e].length && i[e - 1]) {
                var h = {
                    x: i[i.length - 1][0],
                    y: i[i.length - 1][1]
                  },
                  _ = {
                    x: C.D[e][2],
                    y: C.D[e][3]
                  },
                  d = {
                    x: C.D[e][0],
                    y: C.D[e][1]
                  };
                for (c = 0; c <= 1; c += .1) i.push([(1 - c) * (1 - c) * h.x + 2 * c * (1 - c) * d.x + c * c * _.x, (1 - c) * (1 - c) * h.y + 2 * c * (1 - c) * d.y + c * c * _.y]);
              } else if (7 === C.D[e].length && i[e - 1]) {
                var f = {
                    x: i[i.length - 1][0],
                    y: i[i.length - 1][1]
                  },
                  g = {
                    x: C.D[e][0],
                    y: C.D[e][1]
                  },
                  B = {
                    x: C.D[e][2],
                    y: C.D[e][3]
                  },
                  v = {
                    x: C.D[e][4],
                    y: C.D[e][5]
                  };
                for (c = 0; c <= 1; c += .1) {
                  var m = (1 - c) * (1 - c) * (1 - c),
                    b = 3 * c * (1 - c) * (1 - c),
                    E = 3 * c * c * (1 - c),
                    K = c * c * c;
                  i.push([m * f.x + b * g.x + E * B.x + K * v.x, m * f.y + b * g.y + E * B.y + K * v.y]);
                }
              } else i.push(C.D[e]);
            } else i.length > -1 && p.push(ZC.AR.Q8(i, Math.min(5, C.AI / 5), [C.BM, C.BH])), i = [];
            if (0 !== C.A9) for (a = ZC._i_((C.D0[0] + C.D0[2]) / 2), n = ZC._i_((C.D0[1] + C.D0[3]) / 2), e = 0, t = i.length; e < t; e++) null !== i[e] && (l = i[e][0] - a, r = i[e][1] - n, o = l * ZC.EG(C.A9) - r * ZC.EN(C.A9), s = l * ZC.EN(C.A9) + r * ZC.EG(C.A9), i[e] = [o + a, s + n]);
            return i.length > -1 && p.push(ZC.AR.Q8(i, Math.min(5, C.AI / 5), [C.BM, C.BH])), p;
        }
      }
    }, {
      key: "parse",
      value: function parse(e) {
        var t, i, a, n, l, r, o;
        null === ZC._n_(e) && (e = !1), this.o.tween || e || _get(_getPrototypeOf(DW.prototype), "parse", this).call(this);
        var s = this;
        if (!s.o.tween && !e) {
          s.assign_a([["map", "A5Z"]]), "string" == typeof s.o.item && s.assign_a([["item", "AB5"]]), 0 !== s.A5Z && (null === ZC._n_(s.o["map-item"]) || s.o["map-item"]) && (s.o["map-item"] = !0, s.o["map-skip-z-sort"] = !0);
          var C = ["offset-x", "offset-y"];
          for (i = 0; i < 2; i++) {
            var A = C[i],
              Z = "offset-x" === A ? "lon" : "lat";
            if (null !== (t = s.o[A]) && typeof t !== ZC._[31] && -1 !== (t = "" + t).indexOf(Z)) {
              t = ZC._f_(t.replace(Z, ""));
              var c = zingchart.maps.maps[s.A5Z];
              c && (t = zingchart.maps.translate(A.replace("offset-"), t, s.A.I, s.A.F, c._INFO_.bbox), s.o[A] = t);
            }
          }
          for (s.assign_a([["url", "E8"], ["target", "FF"], ["cursor", "J3"], ["id", "HB"], ["angle", "A9", "i"], ["static", "KE", "b"], ["flat", "KE", "b"], [ZC._[1], "B4", "f"], [ZC._[2], "BK", "f"], [ZC._[8], "CM", "i"], [ZC._[21], "AI", "f"], ["size-2", "L5", "f"], ["fast-vector-path", "QY", "b"], ["type", "DQ"], ["points", "D"], ["offset-x", "BM"], ["offset-y", "BH"], ["offset-z", "A9S", "i"], ["offset-r", "DS", "i"], ["z-sort", "AAC", "i"], ["z-index", "JX", "f"], ["composite", "A1E"]]), s.BM = ZC.IU(s.BM, !0), s.BH = ZC.IU(s.BH, !0), s.BM > -1 && s.BM < 1 && typeof s.E["p-width"] !== ZC._[31] && (s.BM *= s.E["p-width"]), s.BH > -1 && s.BH < 1 && typeof s.E["p-height"] !== ZC._[31] && (s.BH *= s.E["p-height"]), s.AI = ZC.BQ(1, s.AI), s.L5 = ZC.BQ(1, s.L5), null !== s.o["z-sort"] && typeof s.o["z-sort"] !== ZC._[31] || (s.AAC = s.JX), "rectangle" !== s.DQ && "rect" !== s.DQ || s.assign_a([[ZC._[19], "AI", "f"], [ZC._[20], "L5", "f"]]), s.A5N ? (s.D = JSON.parse(JSON.stringify(s.FD)), s.A5N = !1) : s.FD = JSON.parse(JSON.stringify(s.D)), i = 0, a = s.D.length; i < a; i++) if (null !== s.D[i]) for (var p = 0; p < s.D[i].length; p++) -1 === ("" + s.D[i][p]).indexOf("lat") && -1 === ("" + s.D[i][p]).indexOf("lon") || (s.A5N = !0, s.D[i][p] = s.ll_(s.D[i][p], p % 2 == 0 ? "x" : "y")), -1 === ("" + s.D[i][p]).indexOf("key") && -1 === ("" + s.D[i][p]).indexOf("val") || (s.A5N = !0, s.D[i][p] = s.kv_(s.D[i][p], p % 2 == 0 ? "x" : "y"));
        }
        if (s.o.tween = null, s.A9 = s.A9 % 360, s.locate(1), "bar" !== s.DQ) {
          var u = s.AI;
          switch (s.DQ) {
            case "custom":
              break;
            case "triangle":
              u = s.AI;
              var h = .1 * s.AI;
              s.D = [[s.iX - u, s.iY + u - h], [s.iX, s.iY - u - h], [s.iX + u, s.iY + u - h], [s.iX - u, s.iY + u - h]];
              break;
            case "square":
              u = ZC._i_(.9 * s.AI), s.D = [[s.iX - u, s.iY - u], [s.iX - u, s.iY + u], [s.iX + u, s.iY + u], [s.iX + u, s.iY - u], [s.iX - u, s.iY - u]];
              break;
            case "diamond":
              u = ZC._i_(1.2 * s.AI), s.D = [[s.iX - u, s.iY], [s.iX, s.iY + u], [s.iX + u, s.iY], [s.iX, s.iY - u], [s.iX - u, s.iY]];
              break;
            case "trapezoid":
              s.D = [[s.iX - u / 2, s.iY + s.L5], [s.iX + u / 2, s.iY + s.L5], [s.iX + u, s.iY - s.L5], [s.iX - u, s.iY - s.L5], [s.iX - u / 2, s.iY + s.L5]];
              break;
            case "rectangle":
            case "rect":
              s.D = [[s.iX - u / 2, s.iY - s.L5 / 2], [s.iX + u / 2, s.iY - s.L5 / 2], [s.iX + u / 2, s.iY + s.L5 / 2], [s.iX - u / 2, s.iY + s.L5 / 2], [s.iX - u / 2, s.iY - s.L5 / 2]];
              break;
            case "parallelogram":
              s.D = [[s.iX - u / 2, s.iY - s.L5 / 2], [s.iX + 3 * u / 2, s.iY - s.L5 / 2], [s.iX + u, s.iY + s.L5 / 2], [s.iX - u, s.iY + s.L5 / 2], [s.iX - u / 2, s.iY - s.L5 / 2]];
              break;
            case "plus":
              u = s.AI, s.D = [[s.iX, s.iY - u], [s.iX, s.iY + u], null, [s.iX - u, s.iY], [s.iX + u, s.iY]];
              break;
            case "cross":
              u = s.AI, s.D = [[s.iX - u, s.iY - u], [s.iX + u, s.iY + u], null, [s.iX - u, s.iY + u], [s.iX + u, s.iY - u]];
              break;
            case "ic_line":
              u = s.AI / 4, s.D = [[s.iX - 2 * u, s.iY + u], [s.iX - u, s.iY], [s.iX, s.iY + u], [s.iX + u, s.iY - u], [s.iX + 2 * u, s.iY]];
              break;
            case "ic_area":
              u = s.AI / 4, s.D = [[s.iX - 2 * u, s.iY + 2 * u], [s.iX - 2 * u, s.iY + u], [s.iX - u, s.iY], [s.iX, s.iY + u], [s.iX + u, s.iY - u], [s.iX + 2 * u, s.iY], [s.iX + 2 * u, s.iY + 2 * u], [s.iX - 2 * u, s.iY + 2 * u]];
              break;
            case "ic_bars":
              s.CY = !1, u = s.AI / 4, s.D = [[s.iX - 2 * u, s.iY + 2 * u], [s.iX - 2 * u, s.iY - u], [s.iX - u, s.iY - u], [s.iX - u, s.iY + 2 * u], [s.iX - 2 * u, s.iY + 2 * u], [s.iX - 2 * u, s.iY + 2 * u - u], null, [s.iX - u / 2, s.iY + 2 * u], [s.iX - u / 2, s.iY], [s.iX + u / 2, s.iY], [s.iX + u / 2, s.iY + 2 * u], [s.iX - u / 2, s.iY + 2 * u], [s.iX - u / 2, s.iY + 2 * u - u], null, [s.iX + 2 * u, s.iY + 2 * u], [s.iX + 2 * u, s.iY - 2 * u], [s.iX + u, s.iY - 2 * u], [s.iX + u, s.iY + 2 * u], [s.iX + 2 * u, s.iY + 2 * u], [s.iX + 2 * u, s.iY + 2 * u - u]];
              break;
            case "arrow":
              u = 2 * s.AI;
              var _ = s.A9;
              s.A9 = 0;
              var d = ZC.AR.BN(s.iX, s.iY, u, _ - 35),
                f = ZC.AR.BN(s.iX, s.iY, u, _ + 35);
              s.D = [[s.iX, s.iY], d, null, [s.iX, s.iY], f];
              break;
            case "star3":
            case "star4":
            case "star5":
            case "star6":
            case "star7":
            case "star8":
            case "star9":
              for (s.D = [], u = 2 * s.AI, l = 360 / (n = ZC._i_(s.DQ.replace("star", ""))), r = n % 2 == 0 ? 0 : -90, o = u / (n > 4 ? 2 : 7 - n), i = 0 + r; i < 360 + r; i += l) s.D.push(ZC.AR.BN(s.iX, s.iY, .75 * u, i), ZC.AR.BN(s.iX, s.iY, .75 * o, i + l / 2));
              s.D.push([s.D[0][0], s.D[0][1]]);
              break;
            case "rpoly3":
            case "rpoly4":
            case "rpoly5":
            case "rpoly6":
            case "rpoly7":
            case "rpoly8":
            case "rpoly9":
              for (s.D = [], u = s.AI, l = 360 / (n = ZC._i_(s.DQ.replace("rpoly", ""))), r = n % 2 == 0 ? 0 : -90, null !== ZC._n_(s.o["angle-offset"]) && (r = ZC._i_(s.o["angle-offset"])), i = 0 + r; i < 360 + r; i += l) s.D.push(ZC.AR.BN(s.iX, s.iY, u, i));
              s.D.push([s.D[0][0], s.D[0][1]]);
              break;
            case "gear3":
            case "gear4":
            case "gear5":
            case "gear6":
            case "gear7":
            case "gear8":
            case "gear9":
              for (s.D = [], u = 2 * s.AI, l = 360 / (2 * (n = ZC._i_(s.DQ.replace("gear", "")))), o = .75 * u, i = 0 + (r = n % 2 == 0 ? 0 : -90); i < 360 + r; i += 2 * l) {
                var g = i + l / 2;
                s.D.push(ZC.AR.BN(s.iX, s.iY, .75 * u, g), ZC.AR.BN(s.iX, s.iY, .75 * u, g + l), ZC.AR.BN(s.iX, s.iY, .75 * o, g + l + 0 * l), ZC.AR.BN(s.iX, s.iY, .75 * o, g + 2 * l - 0 * l));
              }
              s.D.push([s.D[0][0], s.D[0][1]]);
              break;
            case "hamburger":
              u *= 2;
              var B = s.iX,
                v = s.iY - 10;
              s.D = s.D.concat([[B - u / 2, v - s.L5 / 2], [B + u / 2, v - s.L5 / 2], [B + u / 2, v + s.L5 / 2], [B - u / 2, v + s.L5 / 2], [B - u / 2, v - s.L5 / 2], null]), v += 5, s.D = s.D.concat([[B - u / 2, v - s.L5 / 2], [B + u / 2, v - s.L5 / 2], [B + u / 2, v + s.L5 / 2], [B - u / 2, v + s.L5 / 2], [B - u / 2, v - s.L5 / 2], null]), v += 5, s.D = s.D.concat([[B - u / 2, v - s.L5 / 2], [B + u / 2, v - s.L5 / 2], [B + u / 2, v + s.L5 / 2], [B - u / 2, v + s.L5 / 2], [B - u / 2, v - s.L5 / 2], null]);
              break;
            case "ellipse":
              for (s.CY = !1, s.D = [], i = 0; i <= 360; i += 5) s.D.push([s.iX + s.AI * ZC.EG(i), s.iY + s.L5 * ZC.EN(i)]);
              s.D.push([s.D[0][0], s.D[0][1]]);
              break;
            case "arc":
              s.CY = !1, s.D = [ZC.AR.BN(s.iX, s.iY, s.AI, s.B4), [s.iX, s.iY, s.AI, s.B4, s.BK, 0]];
              break;
            case "pie":
              for (var m = (s.o["pie-transform"] || "").split(/=|,/); s.B4 < 0 || s.BK < 0;) s.B4 += 360, s.BK += 360;
              s.CY = !1;
              var b = !1;
              -1 !== ZC.AV(["svg", "vml"], s.H.AA) && s.B4 % 360 == s.BK % 360 && (s.B4 += .05, s.BK -= .05, b = !0);
              var E,
                K,
                D,
                F,
                I,
                x = s.iX,
                y = s.iY,
                X = ZC._x_(s.B4, 2),
                Y = ZC._x_(s.BK, 2),
                w = ZC._x_((X + Y) / 2, 2),
                L = u,
                M = s.CM,
                H = 0 === M && X % 360 != Y % 360 && !b;
              switch (s.D = [], "circle" !== m[0] && (0 === M ? X % 360 == Y % 360 || b || s.D.push([x, y]) : s.D.push(ZC.AR.BN(x, y, M, X))), m[0]) {
                case "flat":
                case "fold":
                  s.D.push(ZC.AR.BN(x, y, L, X), ZC.AR.BN(x, y, L - ("fold" === m[0] ? ZC._i_(m[1]) : 0), Y)), H || s.D.push(ZC.AR.BN(x, y, M, Y));
                  break;
                case "callout":
                  s.D.push(ZC.AR.BN(x, y, L, X), [x, y, L, X, Y, 0]), H || (E = 1.5 * ZC._i_(m[1]) * 360 / (2 * Math.PI * L), s.D.push(ZC.AR.BN(x, y, L, Y), ZC.AR.BN(x, y, M, Y), [x, y, M, Y, w + E, 1], ZC.AR.BN(x, y, M - ZC._i_(m[1]), w), ZC.AR.BN(x, y, M, w - E), [x, y, M, w - E, X, 1]));
                  break;
                case "flow":
                  E = ZC._i_(m[1]), F = ZC.AR.BN(x, y, (M + L) / 2, X), 99 === E || -99 === E ? s.D.push([F[0], F[1], (L - M) / 2, X + 180, X, 99 === E ? 1 : 0]) : s.D.push(ZC.AR.BN(x, y, (M + L) / 2, X + E)), s.D.push(ZC.AR.BN(x, y, L, X), [x, y, L, X, Y, 0]), I = ZC.AR.BN(x, y, (M + L) / 2, Y), H ? 99 === E || -99 === E ? s.D.push(ZC.AR.BN(x, y, L, Y), [I[0], I[1], (L - M) / 2, Y, Y + 180, 99 === E ? 0 : 1]) : s.D.push(ZC.AR.BN(x, y, (M + L) / 2, Y + E)) : (99 === E || -99 === E ? s.D.push([I[0], I[1], (L - M) / 2, Y, Y + 180, 99 === E ? 0 : 1]) : s.D.push(ZC.AR.BN(x, y, (M + L) / 2, Y + E)), s.D.push(ZC.AR.BN(x, y, M, Y), [x, y, M, Y, X, 1]));
                  break;
                case "circle":
                  var G = ZC._f_(m[1] || "1"),
                    P = (5 + ZC._a_(Y - X) % 360 * 50 / 360) * G;
                  D = Y % 360 == X % 360 || b ? [x, y] : ZC.AR.BN(x, y, (L + M) / 2, (X + Y) / 2), s.D.push(ZC.AR.BN(D[0], D[1], P, 0), [D[0], D[1], P, 0, 360, 0]);
                  break;
                case "bite":
                  E = ZC._i_(m[1]), K = ZC._i_(2 * L * ZC.EN(E / 2)), D = ZC.AR.BN(x, y, L, X), s.D.push(ZC.AR.BN(x, y, L - K, X), [D[0], D[1], K, X + 180, X + 90 + (90 - (180 - E) / 2), 1], [x, y, L, X + E, Y, 0]), H || s.D.push(ZC.AR.BN(x, y, M, Y), [x, y, M, Y, X, 1]);
                  break;
                case "droplet":
                  for (var N = L, O = 1, S = 0; L * O + S >= N;) O = ZC._x_(O - .02, 2), K = ZC._i_(L * O / ZC.EG((Y - X) / 2)), S = ZC._i_(L * O * Math.tan(ZC.TK((Y - X) / 2)));
                  D = ZC.AR.BN(x, y, K, w), s.D.push(ZC.AR.BN(x, y, L * O, X), [D[0], D[1], S, w - (360 - (180 - (Y - X))) / 2, w + (360 - (180 - (Y - X))) / 2, 0]), H || s.D.push(ZC.AR.BN(x, y, M, Y), [x, y, M, Y, X, 1]);
                  break;
                default:
                  s.D.push(ZC.AR.BN(x, y, L, X), [x, y, L, X, Y, 0]), 0 === M ? X % 360 == Y % 360 || b || s.D.push([x, y]) : s.D.push(ZC.AR.BN(x, y, L, Y), ZC.AR.BN(x, y, M, Y), [x, y, M, Y, X, 1]);
              }
              s.D.push([s.D[0][0], s.D[0][1]]);
          }
        }
        s.locate(2);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        if ("none" !== e.DQ && ("custom" === e.DQ || "circle" === e.DQ || "arc" === e.DQ || 0 !== e.D.length)) {
          var t,
            i,
            a = {
              x: "iX",
              y: "iY",
              width: "I",
              height: "F",
              size: "AI"
            };
          if (e.o["bottom-state"] && !e.YS && !e.WO && !e.bIsBottom) {
            var n = new DW(e.A);
            for (t in n.copy(e), n.bIsBottom = !0, n.MH = !1, n.Z = e.Z, n.append({
              x: e.iX - e.A.iX,
              y: e.iY - e.A.iY
            }), n.append(e.o["bottom-state"]), n.K = e.K + "-bottom", n.parse(), i = !1, a) null === ZC._n_(n.o[t]) || -1 === ("" + n.o[t]).indexOf("+") && -1 === ("" + n.o[t]).indexOf("-") || (n.o[t] = n[a[t]] = e[a[t]] + ZC._i_(n.o[t]), i = !0);
            i && n.parse(), n.paint();
          }
          var l = e.H.AA;
          switch (e.MH && e.C7 && e.A2I(), l) {
            case "canvas":
              e.WG();
              break;
            case "svg":
              e.U0();
              break;
            case "vml":
              e.TZ();
          }
          if (e.o["top-state"] && !e.YS && !e.WO && !e.bIsBottom) {
            var r = new DW(e.A);
            for (t in r.copy(e), r.WO = !0, r.MH = !1, r.Z = e.Z, r.append({
              x: e.iX - e.A.iX,
              y: e.iY - e.A.iY
            }), r.append(e.o["top-state"]), r.K = e.K + "-top", r.parse(), i = !1, a) null === ZC._n_(r.o[t]) || -1 === ("" + r.o[t]).indexOf("+") && -1 === ("" + r.o[t]).indexOf("-") || (r.o[t] = r[a[t]] = e[a[t]] + ZC._i_(r.o[t]), i = !0);
            i && r.parse(), r.paint();
          }
        }
      }
    }, {
      key: "A2I",
      value: function A2I() {
        var e,
          t = this,
          i = new DW(t.A);
        i.K = t.K + "-sh", i.copy(t), i.OI = t.OI, i.Z = t.C7, i.MH = !1, i.YS = !0, i.A0 = i.AE = i.SA, i.GV = i.HU = "", i.D9 = "", i.GH = "solid", i.BW = i.SA, i.AZ = 0, i.C6 = i.TD * t.C6, i.K = t.K + "-sh";
        var a = (t.K1 - t.PJ) * ZC.EG(t.OS) + t.PJ,
          n = (t.K1 - t.PJ) * ZC.EN(t.OS) + t.PJ;
        if (i.iX = t.iX + parseInt(a, 10), i.iY = t.iY + parseInt(n, 10), i.AI = t.AI + t.PJ, t.D.length > 0) {
          e = [];
          for (var l = 0, r = t.D.length; l < r; l++) if (null !== t.D[l]) {
            for (var o = [], s = 0; s < t.D[l].length; s++) o[s] = t.D[l][s];
            o[0] = t.D[l][0] + parseInt(a, 10), o[1] = t.D[l][1] + parseInt(n, 10), e.push(o);
          } else e.push(null);
        }
        i.D0 = [t.D0[0] + a, t.D0[1] + n, t.D0[2] + a, t.D0[3] + n], i.D = e, i.paint();
      }
    }, {
      key: "WD",
      value: function WD() {
        var e = this;
        return {
          lc: "-1" === e.B7 ? "rgba(255,255,255,0)" : 1 === e.C6 ? e.B7 : ZC.AQ.A3D(ZC.AQ.GE(e.B7), e.C6),
          bc: "-1" === e.BW ? "rgba(255,255,255,0)" : 1 === e.O8 ? e.BW : ZC.AQ.A3D(ZC.AQ.GE(e.BW), e.O8),
          bgc1: "-1" === e.A0 ? "rgba(255,255,255,0)" : 1 === e.C6 ? e.A0 : ZC.AQ.A3D(ZC.AQ.GE(e.A0), e.C6),
          bgc2: "-1" === e.AE ? "rgba(255,255,255,0)" : 1 === e.C6 ? e.AE : ZC.AQ.A3D(ZC.AQ.GE(e.AE), e.C6)
        };
      }
    }, {
      key: "SF",
      value: function SF(e) {
        var t,
          i,
          a,
          n = this;
        switch (n.DQ) {
          case "circle":
          case "arc":
          case "pie":
            t = n.iX, i = n.iY, a = n.AI;
            break;
          default:
            t = n.D0[0] + (n.D0[2] - n.D0[0]) / 2, i = n.D0[1] + (n.D0[3] - n.D0[1]) / 2, a = ZC._a_(ZC.EG(n.NO) * (n.D0[2] - n.D0[0]) / 2 + ZC.EN(n.NO) * (n.D0[3] - n.D0[1]) / 2);
        }
        ZC.PL(t) || (t = 0), ZC.PL(i) || (i = 0), ZC.PL(a) || (a = 0);
        var l = n.WP,
          r = n.WQ;
        if (ZC._a_(l) <= 1 && (l = l * (n.D0[2] - n.D0[0]) / 2), ZC._a_(r) <= 1 && (r = r * (n.D0[3] - n.D0[1]) / 2), t += l, i += r, "radial" === e) return {
          cx: t,
          cy: i,
          r: ZC._a_(a)
        };
        if ("linear" === e) {
          var o = a * ZC.EG(n.NO),
            s = a * ZC.EN(n.NO),
            C = t - o,
            A = i - s,
            Z = t + o,
            c = i + s;
          return ZC._i_(A) === ZC._i_(c) && ZC._a_(Z - C) < 5 && (c += 1), ZC._i_(C) === ZC._i_(Z) && ZC._a_(c - A) < 5 && (Z += 1), {
            x1: C,
            y1: A,
            x2: Z,
            y2: c
          };
        }
      }
    }, {
      key: "Q4",
      value: function Q4() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o = this;
        switch (ZC.cache.data[o.D9] ? e = ZC.cache.data[o.D9] : ((e = new Image()).src = o.D9, ZC.cache.data[o.D9] = e), 1 !== o.L1 && (e._width_ ? (e.width = e._width_, e.height = e._height_) : (e._width_ = e.width, e._height_ = e.height)), t = e.width * o.L1, i = e.height * o.L1, o.X4) {
          case "x":
            t = o.I;
            break;
          case "y":
            i = o.F;
            break;
          case "xy":
          case "both":
            t = o.I, i = o.F;
        }
        var s = o.TL.split(" "),
          C = s[0] || "",
          A = 0,
          Z = 0;
        switch (C) {
          case "":
          case "left":
            a = 0, A = 0;
            break;
          case "center":
            a = (o.I - t) / 2, A = .5;
            break;
          case "right":
            a = o.I - t, A = 1;
            break;
          default:
            -1 !== C.indexOf("%") ? (A = ZC._i_(C.replace(/[^0-9\-]/g, "")) / 100, a = (o.I - t) * A) : (A = ZC._i_(C.replace(/[^0-9\-]/g, "")) / o.I, a = ZC._i_(C.replace(/[^0-9\-]/g, "")));
        }
        l = a / o.I, typeof o.L2 !== ZC._[31] ? a += o.iX + o.BM : a += o.D0[0] + o.BM;
        var c = s[1] || "";
        switch (c) {
          case "":
          case "top":
            n = 0, Z = 0;
            break;
          case "middle":
            n = (o.F - i) / 2, Z = .5;
            break;
          case "bottom":
            n = o.F - i, Z = 1;
            break;
          default:
            -1 !== c.indexOf("%") ? (Z = ZC._i_(c.replace(/[^0-9\-]/g, "")) / 100, n = (o.F - i) * Z) : (Z = ZC._i_(c.replace(/[^0-9\-]/g, "")) / o.F, n = ZC._i_(c.replace(/[^0-9\-]/g, "")));
        }
        if (r = n / o.F, typeof o.L2 !== ZC._[31] ? n += o.iY + o.BH : n += o.D0[1] + o.BH, "pie" === o.DQ) {
          var p = o.A9 + o.B4 + (o.BK - o.B4) * A,
            u = ZC.AR.BN(o.iX, o.iY, o.CM + (o.AI - o.CM) * Z, p);
          a = u[0] - e.width / 2, n = u[1] - e.height / 2;
        }
        return o.E[ZC._[69]] = t, o.E[ZC._[70]] = i, {
          image: e,
          x: ZC._i_(a) + .5,
          y: ZC._i_(n) + .5,
          cx: ZC._f_(l),
          cy: ZC._f_(r),
          hPos: A,
          vPos: Z
        };
      }
    }, {
      key: "UX",
      value: function UX(e) {
        for (var t = this, i = t.GV.split(/\s+|;/), a = t.HU.split(/\s+|;/), n = 0, l = i.length; n < l; n++) {
          var r = ZC.AQ.GE(i[n], t);
          "object" != typeof r && (r = [r, t.C6]);
          var o = ZC.AQ.A3D(r[0], r[1]),
            s = ZC._f_(a[n] || "1");
          ZC.DR(s, 0, 1) || (s = 1), e.addColorStop(s, o);
        }
      }
    }, {
      key: "WG",
      value: function WG() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s = this,
          C = s.Z.getContext("2d");
        C.save(), "poly" === s.DQ || "line" === s.DQ ? (t = s.D0[0] + (s.D0[2] - s.D0[0]) / 2, i = s.D0[1] + (s.D0[3] - s.D0[1]) / 2) : (t = s.iX, i = s.iY);
        var A = s.WD(),
          Z = A.lc,
          c = A.bc,
          p = A.bgc1,
          u = A.bgc2;
        if (p !== u || "" !== s.GV && "" !== s.HU) {
          var h = s.SF(s.NT);
          "radial" === s.NT ? a = C.createRadialGradient(h.cx, h.cy, 1, h.cx, h.cy, h.r) : "linear" === s.NT && (a = C.createLinearGradient(h.x1, h.y1, h.x2, h.y2)), "" !== s.GV && "" !== s.HU ? s.UX(a) : (a.addColorStop(0, p), a.addColorStop(1, u)), C.fillStyle = a;
        } else "" !== s.D9 && -1 !== ZC.AV(["repeat", "true", !0], s.MG) && "-1" === s.A0 && "-1" === s.AE && (p = "rgba(255,255,255,0)"), C.fillStyle = p;
        switch (s.DQ) {
          case "custom":
            if ((e = s.o.url) && (ZC.cache.data[e] ? n = ZC.cache.data[e] : ((n = new Image()).src = e, ZC.cache.data[e] = n), n.width = s.o[ZC._[19]] ? s.o[ZC._[19]] : n.width, n.height = s.o[ZC._[20]] ? s.o[ZC._[20]] : n.height, C.drawImage(n, s.iX - n.width / 2 + s.BM, s.iY - n.height / 2 + s.BH, n.width, n.height), 0 === p.indexOf("#") && 7 === p.length)) {
              for (var _ = parseInt(p.substring(1, 3), 16), d = parseInt(p.substring(3, 5), 16), f = parseInt(p.substring(5, 7), 16), g = C.getImageData(s.iX - n.width / 2 + s.BM, s.iY - n.height / 2 + s.BH, n.width, n.height), B = 0; B < g.data.length; B += 4) g.data[B] = _ | g.data[B], g.data[B + 1] = d | g.data[B + 1], g.data[B + 2] = f | g.data[B + 2];
              C.putImageData(g, s.iX - n.width / 2 + s.BM, s.iY - n.height / 2 + s.BH);
            }
            break;
          case "plus":
          case "cross":
          case "line":
          case "ic_line":
          case "arc":
            C.strokeStyle = Z, C.lineWidth = s.AZ;
            break;
          default:
            C.strokeStyle = c, C.lineWidth = s.AU;
        }
        0 !== s.A9 && (C.translate(t, i), isNaN(s.A9) || C.rotate(ZC.TK(s.A9)), C.translate(-t, -i));
        var v = -1 === ZC.AV(["cross", "plus", "arc", "line", "ic_line"], s.DQ);
        switch (isNaN(s.BM) || isNaN(s.BH) || 0 === s.BM && 0 === s.BH || !v && "arc" !== s.DQ || C.translate(s.BM, s.BH), C.beginPath(), s.DQ) {
          case "circle":
          case "arc":
            C.setLineDash && "circle" === s.DQ && (s.KR(s.AU), C.setLineDash(0 === s.EX || 0 === s.GD ? [] : [s.EX, s.GD])), C.arc(s.iX, s.iY, s.AI, ZC.TK(s.B4), ZC.TK(s.BK), !1);
            break;
          case "line":
            break;
          default:
            -1 !== ZC.AV(["square", "plus"], s.DQ) && (s.N9 = !0), ZC.CQ.contour(C, s, s.D), -1 !== ZC.AV(["square", "plus"], s.DQ) && (s.N9 = !1);
        }
        if (C.globalCompositeOperation = s.A1E, v) if ("" !== s.D9 && -1 === ZC.AV(ZC.IMG404, s.D9)) {
          var m;
          C.fill(), C.save(), C.clip(), m = C.globalAlpha, C.globalAlpha = s.C6;
          var b = s.Q4();
          switch (n = b.image, s.MG) {
            case "repeat":
            case !0:
            case "true":
              l = s.D0[0] - (n.width - (s.D0[2] - s.D0[0])) / 2, r = s.D0[1] - (n.height - (s.D0[3] - s.D0[1])) / 2, C.translate(l, r), o = C.createPattern(n, "repeat"), C.fillStyle = o, C.fill(), C.translate(-l, -r);
              break;
            case "no-repeat":
            case !1:
            case "false":
              C.drawImage(n, b.x - s.BM, b.y - s.BH, s.E[ZC._[69]], s.E[ZC._[70]]);
          }
          C.globalAlpha = m, C.restore();
        } else C.fill();
        switch (C.closePath(), C.beginPath(), s.DQ) {
          case "circle":
          case "arc":
            C.arc(s.iX, s.iY, s.AI, ZC.TK(s.B4), ZC.TK(s.BK), !1), ("circle" === s.DQ && s.AU > 0 || "arc" === s.DQ && s.AZ > 0) && C.stroke(), C.closePath();
            break;
          case "plus":
          case "cross":
          case "line":
          case "ic_line":
            s.AZ > 0 && (ZC.CQ.setup(C, s), s.o.spline ? (s.CY = !1, s.QY = !0, ZC.CQ.paint(C, s, ZC.CQ.smooth(s.D, !1, s.o.direction || "h"))) : ZC.CQ.paint(C, s, s.D));
            break;
          default:
            if (s.AU > 0) {
              var E = s.B7,
                K = s.AZ;
              s.B7 = s.BW, s.AZ = s.AU, s.KR(), ZC.CQ.setup(C, s), ZC.CQ.paint(C, s, s.D, !0), s.B7 = E, s.AZ = K, s.KR();
            }
            C.closePath();
        }
        C.restore();
      }
    }, {
      key: "XY",
      value: function XY(e) {
        var t = this,
          i = e.info,
          a = i.image,
          n = !0;
        switch (t.MG) {
          default:
            n = !0;
            break;
          case "no-repeat":
          case "false":
          case !1:
            n = !1;
        }
        var l = t.D9;
        0 === a.src.indexOf("data:") && (l = a.src), a.width *= t.L1, a.height *= t.L1;
        var r = "" === t.K ? "pattern-" + ZC.SEQ++ : t.K + "-pattern";
        ZC.Q.EU(r);
        var o = ZC.Q.F7("image", ZC._[36]);
        o.setAttributeNS ? o.setAttributeNS(ZC._[37], "href", l) : o.setAttribute("src", l), ZC.Q.G4(o, {
          id: r + "-image",
          preserveAspectRatio: "none",
          width: t.E[ZC._[69]],
          height: t.E[ZC._[70]]
        });
        var s = a.width,
          C = a.height;
        if (!n) {
          var A, Z;
          s = C = 1, t.I > 0 && t.F > 0 ? (A = t.I, Z = t.F) : (A = t.D0[2] - t.D0[0], Z = t.D0[3] - t.D0[1]);
          var c = ZC._i_(A * i.cx),
            p = ZC._i_(Z * i.cy);
          if ("pie" === t.DQ) {
            s = t.H ? t.H.I : t.A.I, C = t.H ? t.H.F : t.A.F;
            var u = t.A9 + t.B4 + (t.BK - t.B4) * i.hPos,
              h = ZC.AR.BN(t.iX, t.iY, t.CM + (t.AI - t.CM) * i.vPos, u);
            c = h[0] - a.width / 2, p = h[1] - a.height / 2;
          }
          t.E["pattern-image-id"] = r + "-image", t.E["pattern-tx"] = c, t.E["pattern-ty"] = p, ZC.Q.G4(o, {
            transform: "translate(" + c + "," + p + ")"
          });
        }
        var _ = ZC.Q.F7("pattern", ZC._[36]);
        ZC.Q.G4(_, {
          x: n ? e.x : 0,
          y: n ? e.y : 0,
          width: s,
          height: C,
          id: r,
          patternUnits: n || "pie" === t.DQ ? "userSpaceOnUse" : "objectBoundingBox"
        }), t.H.KK.childNodes[0].appendChild(_), _.appendChild(o), t.E.imgfill = "url(#" + r + ")";
      }
    }, {
      key: "TP",
      value: function TP(e) {
        null !== e && typeof e !== ZC._[31] || (e = !1);
        var t,
          i,
          a = this;
        if (a.A0 !== a.AE || "" !== a.GV && "" !== a.HU) {
          var n = "" === a.K ? "gradient-" + ZC.SEQ++ : a.K + "-gradient";
          (a.TX || e && !ZC.AK(n)) && (e = !1), ZC.A5.browser.msie && 9 === ZC._i_(ZC.A5.browser.version) && (e = !1), ZC.AK(n) && !e && ZC.Q.EU(n);
          var l = a.SF(a.NT);
          if ("radial" === a.NT ? (t = e ? ZC.AK(n) : ZC.Q.F7("radialGradient", ZC._[36]), ZC.Q.G4(t, {
            cx: ZC._i_(l.cx),
            cy: ZC._i_(l.cy),
            r: ZC._i_(l.r),
            fx: ZC._i_(l.cx),
            fy: ZC._i_(l.cy)
          })) : "linear" === a.NT && (t = e ? ZC.AK(n) : ZC.Q.F7("linearGradient", ZC._[36]), ZC.Q.G4(t, {
            x1: ZC._i_(l.x1),
            x2: ZC._i_(l.x2),
            y1: ZC._i_(l.y1),
            y2: ZC._i_(l.y2)
          })), !e) {
            if (ZC.Q.G4(t, {
              id: n,
              gradientUnits: "userSpaceOnUse"
            }), a.H.KK.childNodes[0].appendChild(t), "" !== a.GV && "" !== a.HU) for (var r = a.GV.split(/\s+|;/), o = a.HU.split(/\s+|;/), s = 0, C = r.length; s < C; s++) {
              var A = ZC.AQ.GE(r[s], a);
              "object" != typeof A && (A = [A, a.C6]), r[s] = A[0];
              var Z = o[s] || 1;
              ZC.DR(Z, 0, 1) || (Z = 1);
              var c = A[1];
              i = r[s], "-1" === r[s] && (c = 0, i = "rgb(255,255,255)");
              var p = ZC.Q.F7("stop", ZC._[36]);
              ZC.Q.G4(p, {
                offset: Z,
                "stop-color": i,
                "stop-opacity": c
              }), t.appendChild(p);
            } else {
              var u = 1,
                h = a.A0;
              "-1" === a.A0 && (u = 0, h = "rgb(255,255,255)");
              var _ = ZC.Q.F7("stop", ZC._[36]);
              ZC.Q.G4(_, {
                offset: 0,
                "stop-color": h,
                "stop-opacity": u
              });
              var d = 1,
                f = a.AE;
              "-1" === a.AE && (d = 0, f = "rgb(255,255,255)");
              var g = ZC.Q.F7("stop", ZC._[36]);
              ZC.Q.G4(g, {
                offset: 1,
                "stop-color": f,
                "stop-opacity": d
              }), t.appendChild(_), t.appendChild(g);
            }
            a.E.fill = "url(#" + n + ")";
          }
        } else "-1" !== a.A0 && (a.E.fill = a.A0);
      }
    }, {
      key: "ZH",
      value: function ZH() {
        var e = this;
        if ("object" == typeof e.E.imgfill && typeof e.H !== ZC._[31] && e.H) {
          var t = e.A27()[1].split(",");
          if ("circle" === e.DQ) e.H.KK.appendChild(ZC.Q.XU({
            id: e.K + "_image-clip",
            cx: t[0],
            cy: t[1],
            r: t[2]
          })), e.E["clip-path"] = e.K + "_image-clip";else if (t.length > 6) {
            for (var i = "", a = 0, n = t.length; a < n; a += 2) i += ZC._i_(t[a]) + ZC._i_(e.BM) + "," + (ZC._i_(t[a + 1]) + ZC._i_(e.BH)) + " ";
            e.H.KK.appendChild(ZC.Q.XU({
              id: e.K + "_image-clip",
              path: i
            })), e.E["clip-path"] = e.K + "_image-clip";
          }
        }
      }
    }, {
      key: "U0",
      value: function U0() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r = this,
          o = r.Z;
        if ("poly" === r.DQ || "line" === r.DQ ? (t = r.D0[0] + (r.D0[2] - r.D0[0]) / 2, i = r.D0[1] + (r.D0[3] - r.D0[1]) / 2) : (t = r.iX, i = r.iY), r.E.cx = t, r.E.cy = i, r.E.fill = -1, "" !== r.D9) {
          var s = r.Q4();
          r.XY({
            info: s,
            x: t - s.image.width / 2,
            y: i - s.image.height / 2
          });
        }
        switch (r.W7 && r.ZH(), r.TP(), r.DQ) {
          case "custom":
            if (e = r.o.url) {
              var C, A;
              ZC.cache.data[e] ? a = ZC.cache.data[e] : ((a = new Image()).src = e, ZC.cache.data[e] = a), (C = e.indexOf(".svg") > 0 && e.indexOf("#") >= 0) ? (A = ZC.Q.F7("svg", ZC._[36]), ZC.Q.G4(A, {
                viewBox: "0 0 8 8",
                fill: r.E.fill
              }), l = ZC.Q.F7("use", ZC._[36])) : l = ZC.Q.F7("image", ZC._[36]), l.setAttributeNS ? l.setAttributeNS(ZC._[37], "href", e) : l.setAttribute("src", e);
              var Z = r.o[ZC._[19]] ? r.o[ZC._[19]] : a.width,
                c = r.o[ZC._[20]] ? r.o[ZC._[20]] : a.height;
              a.width = Z, a.height = c, C ? ZC.Q.G4(A, {
                id: r.K + "-image",
                x: r.iX - a.width / 2 + r.BM,
                y: r.iY - a.height / 2 + r.BH,
                width: a.width,
                height: a.height
              }) : ZC.Q.G4(l, {
                id: r.K + "-image",
                x: r.iX - a.width / 2 + r.BM,
                y: r.iY - a.height / 2 + r.BH,
                width: a.width,
                height: a.height
              }), C ? (A.appendChild(l), o.appendChild(A)) : o.appendChild(l);
            }
            break;
          case "circle":
            if (!ZC.AK(r.K + "-circle") && (n = ZC.Q.F7("circle", ZC._[36]), -1 !== r.E.fill ? ZC.Q.G4(n, {
              fill: r.E.fill,
              "fill-opacity": r.C6
            }) : ZC.Q.G4(n, {
              fill: "none"
            }), r.DJ && "" !== r.DJ && ZC.Q.G4(n, {
              "class": r.DJ
            }), ZC.Q.G4(n, {
              id: r.K + "-circle",
              cx: r.iX + r.BM,
              cy: r.iY + r.BH,
              r: r.AI
            }), r.AU > 0 && (ZC.Q.G4(n, {
              stroke: r.BW,
              "stroke-width": r.AU,
              "stroke-opacity": r.O8
            }), r.KR(r.AU), "solid" === r.GH || 0 === r.EX && 0 === r.GD || ZC.Q.G4(n, {
              "stroke-dasharray": "dashdot" === r.GH ? [r.EX, r.GD, r.AZ, r.GD].join(" ") : [r.EX, r.GD].join(",")
            })), r.H && r.H.G3 ? (r.H.G3[o.id] || (r.H.G3[o.id] = document.createDocumentFragment()), r.H.G3[o.id].appendChild(n)) : o.appendChild(n), typeof r.E.imgfill !== ZC._[31])) if ("string" == typeof r.E.imgfill) n = ZC.Q.F7("circle", ZC._[36]), ZC.Q.G4(n, {
              id: r.K + "-imgfill",
              fill: r.E.imgfill,
              "fill-opacity": r.C6,
              cx: r.iX + r.BM,
              cy: r.iY + r.BH,
              r: r.AI,
              "stroke-width": 0
            }), r.H && r.H.G3 ? r.H.G3[o.id].appendChild(n) : o.appendChild(n);else {
              var p = r.E.imgfill;
              (l = ZC.Q.F7("image", ZC._[36])).setAttributeNS && l.setAttributeNS(ZC._[37], "href", r.D9), r.E["clip-path"] && ZC.Q.G4(l, {
                "clip-path": "url(#" + r.E["clip-path"] + (ZC.A5.browser.webkit ? "-shape" : "") + ")"
              }), ZC.Q.G4(l, {
                id: r.K + "-imgfill",
                x: p[1],
                y: p[2],
                width: p[0].width,
                height: p[0].height
              }), o.appendChild(l);
            }
            break;
          case "plus":
          case "cross":
          case "line":
          case "ic_line":
          case "arc":
            r.AZ > 0 && (ZC.CQ.setup(o, r), r.o.spline ? (r.CY = !1, r.QY = !0, ZC.CQ.paint(o, r, ZC.CQ.smooth(r.D, !1, r.o.direction || "h"))) : ZC.CQ.paint(o, r, r.D));
            break;
          default:
            var u = r.B7,
              h = r.AZ;
            r.B7 = r.BW, r.AZ = r.AU, r.KR(), ZC.CQ.setup(o, r), ZC.CQ.paint(o, r, r.D, !0, 0), r.B7 = u, r.AZ = h, r.KR();
        }
      }
    }, {
      key: "TO",
      value: function TO(e, t) {
        null !== t && typeof t !== ZC._[31] || (t = !1);
        var i,
          a = this;
        if (a.A0 !== a.AE || "" !== a.GV && "" !== a.HU) {
          var n = "" === a.K ? "gradient-" + ZC.SEQ++ : a.K + "-gradient";
          if (t && !ZC.AK(n) && (t = !1), ZC.AK(n) && !t && ZC.A5(n).remove(), i = t ? ZC.AK(n) : ZC.Q.F7("zcv:fill"), t && (e = ZC.A5("#" + n).attr("focusposition")), "" !== a.GV && "" !== a.HU) {
            for (var l = a.GV.split(/\s+|;/), r = a.HU.split(/\s+|;/), o = "", s = "", C = "", A = 0, Z = l.length; A < Z; A++) {
              l[A] = ZC.AQ.GE(l[A]);
              var c = "-1" === l[A] ? "rgb(255,255,255)" : l[A],
                p = r[A] || 1;
              ZC.DR(p, 0, 1) || (p = 1);
              var u = ZC._i_(100 * p);
              0 === A ? o = c : A === Z - 1 ? s = c : C += u + "% " + ZC.AQ.GE(c) + ",";
            }
            "" !== C && (C = C.substring(0, C.length - 1)), "radial" === a.NT ? ZC.Q.G4(i, {
              id: n,
              type: "gradientradial",
              focusposition: e,
              color: o,
              color2: s,
              colors: C
            }) : "linear" === a.NT && ZC.Q.G4(i, {
              id: n,
              type: "gradient",
              method: "sigma",
              angle: 270 - a.NO - a.A9,
              color: o,
              color2: s,
              colors: C
            });
          } else {
            var h = a.A0;
            "-1" === a.A0 && (h = "rgb(255,255,255)");
            var _ = a.AE;
            "-1" === a.AE && (_ = "rgb(255,255,255)"), "radial" === a.NT ? ZC.Q.G4(i, {
              id: n,
              type: "gradientradial",
              focusposition: e,
              color: _,
              color2: h
            }) : "linear" === a.NT && ZC.Q.G4(i, {
              id: n,
              type: "gradient",
              method: "sigma",
              angle: 270 - a.NO - a.A9,
              color: h,
              color2: _
            });
          }
          var d = typeof a.E.opacity2 !== ZC._[31] ? a.E.opacity2 : a.C6;
          ZC.Q.G4(i, {
            opacity: a.C6,
            "o:opacity2": d
          }), a.E.fill = i;
        } else i = ZC.Q.F7("zcv:fill"), "-1" !== a.A0 && (ZC.Q.G4(i, {
          type: "solid",
          color: a.A0,
          opacity: a.C6
        }), a.E.fill = i);
      }
    }, {
      key: "TZ",
      value: function TZ() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r = this,
          o = r.Z;
        "poly" === r.DQ || "line" === r.DQ ? (t = r.D0[0] + (r.D0[2] - r.D0[0]) / 2, i = r.D0[1] + (r.D0[3] - r.D0[1]) / 2) : (t = r.iX, i = r.iY), r.E.cx = t, r.E.cy = i, r.E.fill = -1;
        var s = -1 === ZC.AV(["cross", "plus", "arc", "line", "ic_line"], r.DQ),
          C = ZC.Q.F7("zcv:fill");
        if ("" !== r.D9) {
          var A = r.Q4();
          switch (a = A.image, r.MG) {
            default:
              C.type = "tile", C.src = r.D9, ZC.Q.G4(C, {
                position: A.cx + "," + A.cy,
                opacity: r.C6,
                "o:opacity2": r.C6
              }), r.E.imgfill = [C];
              break;
            case "no-repeat":
            case "false":
            case !1:
              r.E.imgfill = [a, A.x, A.y];
          }
        }
        r.TO("0,0");
        var Z = ZC.Q.F7("zcv:stroke");
        switch (r.DQ) {
          case "custom":
            (e = r.o.url) && (ZC.cache.data[e] ? a = ZC.cache.data[e] : ((a = new Image()).src = e, ZC.cache.data[e] = a), (l = ZC.Q.F7("img")).id = r.K + "-img", l.src = e, l.style.position = "absolute", 1 !== r.L1 && (l.width *= r.L1, l.height *= r.L1, l.style.width = l.width + "px", l.style.height = l.height + "px"), l.style.left = r.iX - a.width / 2 + r.BM + "px", l.style.top = r.iY - a.height / 2 + r.BH + "px", o.appendChild(l));
            break;
          case "plus":
          case "cross":
          case "line":
          case "ic_line":
          case "arc":
            Z.weight = r.AZ + "px", Z.color = r.B7;
            break;
          default:
            Z.weight = r.AU + "px", Z.color = r.BW;
        }
        switch (Z.opacity = r.O8, r.GH) {
          case "solid":
            Z.dashstyle = "solid";
            break;
          case "dotted":
            Z.dashstyle = "dot";
            break;
          case "dashed":
            Z.dashstyle = "dash";
        }
        switch (-1 === ZC.AV(["plus", "cross", "line", "ic_line"], r.DQ) && (r.E.stroke = Z), r.DQ) {
          case "circle":
          case "arc":
            if (!ZC.AK(r.K + "-circle") && ((n = ZC.Q.F7("circle" === r.DQ ? "zcv:oval" : "zcv:arc")).id = r.K + "-circle", n.style.position = "absolute", -1 !== r.E.fill && s ? n.appendChild(r.E.fill) : n.filled = !1, r.AU > 0 || r.AZ > 0 ? n.appendChild(Z) : n.stroked = !1, n.style.left = r.iX + r.BM - r.AI + "px", n.style.top = r.iY + r.BH - r.AI + "px", n.style.width = 2 * r.AI + "px", n.style.height = 2 * r.AI + "px", "arc" === r.DQ && ZC.Q.G4(n, {
              startangle: r.BK + 90,
              endangle: r.B4 + 90
            }), o.appendChild(n), s && typeof r.E.imgfill !== ZC._[31])) {
              var c = r.E.imgfill;
              1 === c.length ? ((n = ZC.Q.F7("zcv:oval")).id = r.K + "-imgfill", n.style.position = "absolute", o.appendChild(n), n.appendChild(c[0]), n.style.left = r.iX + r.BM - r.AI + "px", n.style.top = r.iY + r.BH - r.AI + "px", n.style.width = 2 * r.AI + "px", n.style.height = 2 * r.AI + "px", n.stroked = !1, "arc" === r.DQ && ZC.Q.G4(n, {
                startangle: r.BK + 90,
                endangle: r.B4 + 90
              })) : 3 === c.length && ((l = ZC.Q.F7("img")).id = r.K + "-img", l.src = r.D9, l.style.position = "absolute", l.style.left = c[1] + "px", l.style.top = c[2] + "px", 1 !== r.L1 && (l.width *= r.L1, l.height *= r.L1, l.style.width = l.width + "px", l.style.height = l.height + "px"), o.appendChild(l));
            }
            break;
          case "plus":
          case "cross":
          case "line":
          case "ic_line":
            r.AZ > 0 && (ZC.CQ.setup(o, r), r.o.spline ? (r.CY = !1, r.QY = !0, ZC.CQ.paint(o, r, ZC.CQ.smooth(r.D, !1, r.o.direction || "h"))) : ZC.CQ.paint(o, r, r.D));
            break;
          default:
            var p = r.B7,
              u = r.AZ;
            r.B7 = r.BW, r.AZ = r.AU, r.KR(), ZC.CQ.setup(o, r), ZC.CQ.paint(o, r, r.D, !0, 0), r.B7 = p, r.AZ = u, r.KR();
        }
      }
    }]);
    return DW;
  }(CZ);
  var I3 = /*#__PURE__*/function (_DW) {
    _inherits(I3, _DW);
    function I3(e) {
      var _this4;
      _classCallCheck(this, I3);
      _this4 = _possibleConstructorReturn(this, _getPrototypeOf(I3).call(this, e)), _this4.init(e);
      return _this4;
    }
    _createClass(I3, [{
      key: "init",
      value: function init(e) {
        _get(_getPrototypeOf(I3.prototype), "init", this).call(this, e);
        var t = this;
        t.DQ = "box", t.I = 0, t.F = 0, t.A95 = "", t.E7 = -1, t.E6 = -1, t.DP = -1, t.DX = -1, t.F6 = 0, t.FT = 0, t.F3 = 0, t.FH = 0, t.A7V = !1, t.L2 = !1, t.EL = "bottom", t.EV = 0, t.MD = 0, t.HC = 8, t.GA = 8, t.Y4 = [1, 1], t.DL = null, t.OX = null, t.QD = !1, t.N9 = !0, t.QF = "", t.OV = "", t.O1 = "", t.PK = "", t.XB = "tl", t.FG = !1;
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        var e = _get(_getPrototypeOf(I3.prototype), "getPMap", this).call(this);
        return this.addPMap(e, "width,height,borderRadiusTopLeft,borderRadiusTopRight,borderRadiusBottomRight,borderRadiusBottomLeft,callout,calloutType,calloutPosition,calloutHook,calloutWidth,calloutHeight,calloutOffset,calloutExtension,position,borderTop,borderRight,borderBottom,borderLeft,rectShortcut", "I,F,F6,FT,F3,FH,L2,EL,DL,HC,GA,EV,MD,A95,QF,OV,O1,PK,FG"), e;
      }
    }, {
      key: "build",
      value: function build() {}
    }, {
      key: "wh_",
      value: function wh_(e, t, i) {
        var a = this;
        if (t = t || "w", ZC._f_(e) + "" != e + "") return -1 !== (e += "").indexOf("%") ? a.wh_(ZC._f_(e.replace("%", "")) / 100, t, !0) : -1 !== e.indexOf("px") ? a.wh_(ZC._f_(e.replace("px", "")), t) : a.wh_(ZC._f_(e), t);
        var n = typeof a.E["p-width"] !== ZC._[31] ? a.E["p-width"] : a.A.I,
          l = typeof a.E["p-height"] !== ZC._[31] ? a.E["p-height"] : a.A.F;
        return (e = ZC._a_(e)) > 1 && !i ? ZC._i_(e) : e <= 1 || i ? "w" === t ? ZC._i_(n * e) : ZC._i_(l * e) : void 0;
      }
    }, {
      key: "m_",
      value: function m_(e, t, i, a, n) {
        var l,
          r,
          o = this;
        if (i = i || 0, a = a || 0, t = t || "all", n = n || "n", "all" === t) {
          var s = String(e).split(/\s+|;|,/);
          return 1 === s.length ? [o.m_(s[0], "tb", i, a, n), o.m_(s[0], "lr", i, a, n), o.m_(s[0], "tb", i, a, n), o.m_(s[0], "lr", i, a, n)] : 2 === s.length ? [o.m_(s[0], "tb", i, a, n), o.m_(s[1], "lr", i, a, n), o.m_(s[0], "tb", i, a, n), o.m_(s[1], "lr", i, a, n)] : 3 === s.length ? [o.m_(s[0], "tb", i, a, n), o.m_(s[1], "lr", i, a, n), o.m_(s[2], "tb", i, a, n), o.m_(s[1], "lr", i, a, n)] : [o.m_(s[0], "tb", i, a, n), o.m_(s[1], "lr", i, a, n), o.m_(s[2], "tb", i, a, n), o.m_(s[3], "lr", i, a, n)];
        }
        return e + "" == "auto" ? -2 : e + "" == "dynamic" && "y" === n ? "dynamic" : ZC._f_(e) + "" != e + "" ? -1 !== (e += "").indexOf("%") ? o.m_(ZC._f_(e.replace("%", "")) / 100, t) : -1 !== e.indexOf("px") ? o.m_(ZC._f_(e.replace("px", "")), t) : o.m_(ZC._f_(e), t) : ((o.A || typeof o.E["p-width"] !== ZC._[31]) && (l = typeof o.E["p-width"] !== ZC._[31] ? o.E["p-width"] : o.A.I), (o.A || typeof o.E["p-height"] !== ZC._[31]) && (r = typeof o.E["p-height"] !== ZC._[31] ? o.E["p-height"] : o.A.F), (e = ZC._a_(e)) >= 1 ? ZC._i_(e) : e < 1 ? "lr" === t ? ZC._i_((o.A ? l : i) * e) : ZC._i_((o.A ? r : a) * e) : void 0);
      }
    }, {
      key: "copy",
      value: function copy(e) {
        _get(_getPrototypeOf(I3.prototype), "copy", this).call(this, e);
        for (var t = "I,F,E7,DP,DX,E6,F6,FT,F3,FH,L2,EL,DL,Y4,HC,GA,EV,MD,A95,QF,OV,O1,PK,FG".split(","), i = 0, a = t.length; i < a; i++) typeof e[t[i]] !== ZC._[31] && (this[t[i]] = e[t[i]]);
      }
    }, {
      key: "locate",
      value: function locate(e) {
        var t,
          i,
          a,
          n,
          l,
          r = this;
        if (2 !== (e = e || 1)) if (r.TX) r.assign_a([["x", "iX"], ["y", "iY"], [ZC._[19], "I"], [ZC._[20], "F"]]);else {
          var o = typeof r.E["p-x"] !== ZC._[31] ? r.E["p-x"] : r.A.iX,
            s = typeof r.E["p-y"] !== ZC._[31] ? r.E["p-y"] : r.A.iY,
            C = typeof r.E["p-width"] !== ZC._[31] ? r.E["p-width"] : r.A.I,
            A = typeof r.E["p-height"] !== ZC._[31] ? r.E["p-height"] : r.A.F;
          if (!r.QD) {
            var Z = 0,
              c = 0,
              p = 0,
              u = 0;
            if (null !== ZC._n_(r.o.margin)) {
              var h = "" + r.o.margin;
              if (-1 !== h.indexOf("dynamic")) {
                var _ = r.m_(h, "all", 0, 0, "y");
                "dynamic" === _[0] && (r.E["d-margin-top"] = r.E["d-margin"] = !0), "dynamic" === _[1] && (r.E["d-margin-right"] = r.E["d-margin"] = !0), "dynamic" === _[2] && (r.E["d-margin-bottom"] = r.E["d-margin"] = !0), "dynamic" === _[3] && (r.E["d-margin-left"] = r.E["d-margin"] = !0), r.o.margin = h.replace(/dynamic/g, "20");
              }
            }
            "dynamic" === r.o.margin && (r.E["d-margin"] = r.E["d-margin-top"] = r.E["d-margin-right"] = r.E["d-margin-bottom"] = r.E["d-margin-left"] = !0, r.o.margin = null), typeof r.E["force-margins"] === ZC._[31] || null !== ZC._n_(r.o["adjust-layout"]) && ZC._b_(r.o["adjust-layout"]) || (null !== ZC._n_(r.o[ZC._[57]]) && null === ZC._n_(r.o[ZC._[59]]) && (r.o[ZC._[59]] = "auto"), null !== ZC._n_(r.o[ZC._[59]]) && null === ZC._n_(r.o[ZC._[57]]) && (r.o[ZC._[57]] = "auto"), null !== ZC._n_(r.o[ZC._[60]]) && null === ZC._n_(r.o[ZC._[58]]) && (r.o[ZC._[58]] = "auto"), null !== ZC._n_(r.o[ZC._[58]]) && null === ZC._n_(r.o[ZC._[60]]) && (r.o[ZC._[60]] = "auto"));
            for (var d = [ZC._[57], ZC._[58], ZC._[59], ZC._[60]], f = 0, g = d.length; f < g; f++) "dynamic" === r.o[d[f]] && (r.E["d-" + d[f]] = r.E["d-margin"] = !0, r.o[d[f]] = null);
            null !== (t = ZC._n_(r.o.margin)) && (i = r.m_(t, "all"), null === ZC._n_(r.o[ZC._[57]]) && (Z = i[0]), null === ZC._n_(r.o[ZC._[58]]) && (c = i[1]), null === ZC._n_(r.o[ZC._[59]]) && (p = i[2]), null === ZC._n_(r.o[ZC._[60]]) && (u = i[3])), null !== (t = ZC._n_(r.o[ZC._[57]])) && (Z = i = r.m_(t, "tb")), null !== (t = ZC._n_(r.o[ZC._[58]])) && (c = i = r.m_(t, "lr")), null !== (t = ZC._n_(r.o[ZC._[59]])) && (p = i = r.m_(t, "tb")), null !== (t = ZC._n_(r.o[ZC._[60]])) && (u = i = r.m_(t, "lr"));
            var B,
              v = [Z, c, p, u];
            if (null !== ZC._n_(r.o.x) && (r.iX = r.xy_(r.o.x, "x")), null !== ZC._n_(r.o.y) && (r.iY = r.xy_(r.o.y, "y")), null !== (t = ZC._n_(r.o[ZC._[19]]))) {
              var m = ZC._p_(t);
              B = -1 !== ("" + t).indexOf("%"), r.I = m > 1 && !B ? ZC._i_(m) : -2 === u && -2 === c ? ZC._i_(C * m) : -2 === u && -2 !== c ? ZC._i_((C - c) * m) : -2 !== u && -2 === c ? ZC._i_((C - u) * m) : ZC._i_((C - u - c) * m), -1 !== r.iX ? (r.DX = r.iX - o, r.E6 = o + C - r.DX - r.I) : -2 === u && -2 === c ? (r.DX = r.E6 = (C - r.I) / 2, r.iX = o + r.DX) : -2 === u && -2 !== c ? (r.E6 = c, r.DX = C - r.E6 - r.I, r.iX = o + r.DX) : (r.DX = u, r.iX = o + r.DX, r.E6 = r instanceof DT ? c : C - r.DX - r.I);
            } else -1 !== r.iX ? (r.DX = r.iX - o, r.E6 = -2 === c ? 0 : c, r.I = C - r.DX - r.E6) : -2 === u && -2 === c ? (r.DX = r.E6 = 0, r.iX = o + r.DX, r.I = C - r.DX - r.E6) : -2 === u && -2 !== c ? (r.E6 = c, r.DX = 0, r.iX = o + r.DX, r.I = C - r.DX - r.E6) : -2 !== u && -2 === c ? (r.DX = u, r.E6 = r instanceof DT ? c : 0, r.iX = o + r.DX, r.I = C - r.DX - r.E6) : (r.DX = u, r.E6 = c, r.iX = o + r.DX, r.I = C - r.DX - r.E6);
            if (null !== (t = ZC._n_(r.o[ZC._[20]]))) {
              var b = ZC._p_(t);
              B = -1 !== ("" + t).indexOf("%"), r.F = b > 1 && !B ? ZC._i_(b) : -2 === Z && -2 === p ? ZC._i_(A * b) : -2 === Z && -2 !== p ? ZC._i_((A - p) * b) : -2 !== Z && -2 === p ? ZC._i_((A - Z) * b) : ZC._i_((A - Z - p) * b), -1 !== r.iY ? (r.E7 = r.iY - s, r.DP = s + A - r.E7 - r.F) : -2 === Z && -2 === p ? (r.E7 = r.DP = (A - r.F) / 2, r.iY = s + r.E7) : -2 === Z && -2 !== p ? (r.DP = p, r.E7 = A - r.DP - r.F, r.iY = s + r.E7) : (r.E7 = Z, r.iY = s + r.E7, r.DP = r instanceof DT ? p : A - r.E7 - r.F);
            } else -1 !== r.iY ? (r.E7 = r.iY - s, r.DP = -2 === p ? 0 : p, r.F = A - r.E7 - r.DP) : -2 === Z && -2 === Z ? (r.E7 = r.E7 = 0, r.iY = s + r.E7, r.F = A - r.E7 - r.DP) : -2 === Z && -2 !== p ? (r.DP = p, r.E7 = 0, r.iY = s + r.E7, r.F = A - r.E7 - r.DP) : -2 === Z && -2 !== p ? (r.E7 = Z, r.DP = r instanceof DT ? p : 0, r.iY = s + r.E7, r.F = A - r.E7 - r.DP) : (r.E7 = Z, r.DP = p, r.iY = s + r.E7, r.F = A - r.E7 - r.DP);
            if (null !== (t = ZC._n_(r.o.position))) {
              if (r.A && typeof r.A.iX !== ZC._[31] && typeof r.A.iY !== ZC._[31] && typeof r.A.I !== ZC._[31] && typeof r.A.F !== ZC._[31]) {
                switch (a = 0, n = 0, (l = String(t).split(/\s+/))[0]) {
                  case "left":
                    a = 0;
                    break;
                  case "right":
                    a = 1;
                    break;
                  case "center":
                    a = .5;
                    break;
                  default:
                    (a = ZC.IU(l[0])) > 1 && (a /= r.A.I);
                }
                switch (l[1]) {
                  case "top":
                    n = 0;
                    break;
                  case "bottom":
                    n = 1;
                    break;
                  case "middle":
                    n = .5;
                    break;
                  default:
                    (n = ZC.IU(l[1])) > 1 && (n /= r.A.F);
                }
              }
              r.E["position-info"] = [a, n], r.iX = r.A.iX + ZC._i_(a * (r.A.I - r.I - v[1] - v[3])) + v[3], r.iY = r.A.iY + ZC._i_(n * (r.A.F - r.F - v[0] - v[2])) + v[0];
            }
            r.D0 = [r.iX, r.iY, r.iX + r.I, r.iY + r.F];
          }
        }
      }
    }, {
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(I3.prototype), "parse", this).call(this);
        var e,
          t = this;
        if (!t.o.tween) {
          if (t.assign_a([["anchor", "XB"], ["rect-shortcut", "FG", "b"], ["center-ref", "A7V", "b"], ["callout", "L2", "b"], ["callout-type", "ACS"], ["callout-position", "EL"], ["callout-hook", "DL"], ["callout-ratio", "Y4"], ["callout-width", "HC", "i"], ["callout-height", "GA", "i"], ["callout-offset", "EV", "i"], ["callout-extension", "MD", "i"], ["border-top", "QF"], ["border-right", "OV"], ["border-bottom", "O1"], ["border-left", "PK"]]), null !== (e = ZC._n_(t.o["border-radius"]))) {
            var i = String(e).split(/\s+|;|,/);
            2 === i.length ? (t.F6 = t.FT = ZC._i_(i[0]), t.F3 = t.FH = ZC._i_(i[1])) : 4 === i.length ? (t.F6 = ZC._i_(i[0]), t.FT = ZC._i_(i[1]), t.F3 = ZC._i_(i[2]), t.FH = ZC._i_(i[3])) : t.F6 = t.FT = t.F3 = t.FH = ZC._i_(i[0]);
          }
          null !== ZC._n_(t.o["callout-tip"]) && (t.OX = new DW(t.A)), t.assign_a([["border-radius-top-left", "F6", "i"], ["border-radius-top-right", "FT", "i"], ["border-radius-bottom-right", "F3", "i"], ["border-radius-bottom-left", "FH", "i"]]);
        }
      }
    }, {
      key: "V2",
      value: function V2(e) {
        var t = e.split(/\s/);
        return t[0] = ZC._i_(t[0]), t[2] = ZC.AQ.GE(t[2]), t;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        if (null !== e.DL && !(e.DL instanceof Array) && "zcgraph" === e.A.OQ) {
          var t = e.A.OL(e.DL);
          e.DL = [t[0], t[1]], e.DL[0] -= e.BM, e.DL[1] -= e.BH;
        }
        if (e.A7V && (e.iX -= e.I / 2, e.iY -= e.F / 2), "-1" !== e.BW && 0 !== e.AU || e.QF + e.OV + e.O1 + e.PK !== "" || "-1" !== e.A0 || "-1" !== e.AE || "" !== e.D9 || "" !== e.GV || "" !== e.HU) {
          var i,
            a = e.H.AA;
          e.MH && e.C7 && e.A2I();
          var n = {
            x: "iX",
            y: "iY",
            width: "I",
            height: "F"
          };
          if (e.o["bottom-state"] && !e.YS && !e.bIsBottom && !e.WO) {
            var l = new I3(e.A);
            for (i in l.copy(e), l.bIsBottom = !0, l.MH = !1, l.Z = e.Z, l.XB = e.XB, l.append({
              x: e.iX - e.A.iX,
              y: e.iY - e.A.iY,
              width: e.I,
              height: e.F
            }), l.append(e.o["bottom-state"]), l.K = e.K + "-bottom", l.parse(), l.setAnchor(), !1, n) null === ZC._n_(l.o[i]) || -1 === ("" + l.o[i]).indexOf("+") && -1 === ("" + l.o[i]).indexOf("-") || (l[n[i]] = e[n[i]] + ZC._i_(l.o[i]), !0);
            l.paint();
          }
          if (e.QF + e.OV + e.O1 + e.PK === "") {
            switch (a) {
              case "canvas":
                e.WG();
                break;
              case "svg":
                e.U0();
                break;
              case "vml":
                e.TZ();
            }
            if (e.L2 && e.OX) {
              var r, o;
              if (e.DL && 2 === e.DL.length ? (r = e.DL[0], o = e.DL[1]) : e.E.cp && (r = e.E.cp[0], o = e.E.cp[1]), e.OX.Z = e.OX.C7 = e.Z, e.OX.copy(e), e.OX.append(e.o["callout-tip"]), e.OX.K = e.K + "-callout-tip", e.OX.o.x = r, e.OX.o.y = o, e.E.cm) {
                var s = e.E.cm[0],
                  C = e.E.cm[1],
                  A = Math.atan2(ZC._i_(C) - ZC._i_(o), ZC._i_(s) - ZC._i_(r));
                isNaN(A) && (A = 0), null === ZC._n_(e.OX.o.angle) && (e.OX.o.angle = ZC.UE(A));
              }
              e.OX.parse(), e.OX.paint();
            }
          } else {
            var Z = e.AU,
              c = e.BW,
              p = e.GH;
            switch (e.AU = 0, a) {
              case "canvas":
                e.WG();
                break;
              case "svg":
                e.U0();
                break;
              case "vml":
                e.TZ();
            }
            e.AU = Z;
            var u = e.A0,
              h = e.AE;
            e.A0 = e.AE = "-1";
            for (var _, d = ["top", "right", "bottom", "left"], f = ["QF", "OV", "O1", "PK"], g = 0; g < d.length; g++) if ("" !== (_ = e[f[g]]) && "none" !== _) {
              var B = e.V2(_);
              switch (e.AU = B[0], e.GH = B[1], e.BW = B[2], a) {
                case "canvas":
                  e.WG(d[g]);
                  break;
                case "svg":
                  e.U0(d[g]);
                  break;
                case "vml":
                  e.TZ(d[g]);
              }
              e.AU = Z, e.BW = c, e.GH = p;
            }
            e.A0 = u, e.AE = h;
          }
          if (e.o["top-state"] && !e.YS && !e.WO && !e.bIsBottom) {
            var v = new I3(e.A);
            for (i in v.copy(e), v.WO = !0, v.MH = !1, v.Z = e.Z, v.XB = e.XB, v.append({
              x: e.iX - e.A.iX,
              y: e.iY - e.A.iY,
              width: e.I,
              height: e.F
            }), v.append(e.o["top-state"]), v.K = e.K + "-top", v.parse(), v.setAnchor(), !1, n) null === ZC._n_(v.o[i]) || -1 === ("" + v.o[i]).indexOf("+") && -1 === ("" + v.o[i]).indexOf("-") || (v[n[i]] = e[n[i]] + ZC._i_(v.o[i]), !0);
            v.paint();
          }
        }
      }
    }, {
      key: "setAnchor",
      value: function setAnchor() {
        var e = this;
        switch (e.XB) {
          case "tl":
            break;
          case "tr":
            e.iX -= e.I;
            break;
          case "bl":
            e.iY -= e.F;
            break;
          case "br":
            e.iX -= e.I, e.iY -= e.F;
            break;
          case "c":
            e.iX -= e.I / 2, e.iY -= e.F / 2;
            break;
          case "t":
            e.iX -= e.I / 2;
            break;
          case "r":
            e.iX -= e.I, e.iY -= e.F / 2;
            break;
          case "b":
            e.iX -= e.I / 2, e.iY -= e.F;
            break;
          case "l":
            e.iY -= e.F / 2;
        }
      }
    }, {
      key: "A2I",
      value: function A2I() {
        var e = this,
          t = new I3(e.A);
        t.K = e.K + "-sh", t.copy(e), t.Z = e.C7, t.MH = !1, t.YS = !0, t.QF = t.OV = t.O1 = t.PK = "", t.A0 = t.AE = t.SA, t.GV = t.HU = "", t.D9 = "", t.GH = "solid", t.BW = t.SA, t.AZ = 0;
        var i = e.K1 * ZC.EG(e.OS),
          a = e.K1 * ZC.EN(e.OS);
        t.I = e.I + ("vml" === e.H.AA ? 0 : .5) - ZC.EG(e.OS) * e.PJ / 2, t.F = e.F + ("vml" === e.H.AA ? 0 : .5) - ZC.EN(e.OS) * e.PJ / 2, t.O8 = t.C6 = t.TD * e.C6, t.K = e.K + "-sh", t.iX = e.iX + ZC._i_(i), t.iY = e.iY + ZC._i_(a), t.paint();
      }
    }, {
      key: "SF",
      value: function SF(e) {
        var t,
          i = this,
          a = i.iX,
          n = i.iY,
          l = a + i.I / 2,
          r = n + i.F / 2,
          o = i.WP,
          s = i.WQ;
        if (ZC._a_(o) <= 1 && (o = o * i.I / 2), ZC._a_(s) <= 1 && (s = s * i.F / 2), l += o, r += s, "radial" === e) {
          var C = ZC._i_((i.I + i.F) / 2),
            A = ZC.CX(i.I, i.F);
          return t = A < C / 4 ? (A + C) / 2 : A, {
            cx: l,
            cy: r,
            r: ZC._a_(t)
          };
        }
        if ("linear" === e) {
          var Z = (t = i.I >= i.F ? ZC._a_(ZC.EN(i.NO)) > .5 ? i.F / 2 : i.I / 2 : ZC._a_(ZC.EG(i.NO)) > .5 ? i.I / 2 : i.F / 2) * ZC.EG(i.NO),
            c = t * ZC.EN(i.NO);
          return {
            x1: l - Z,
            y1: r - c,
            x2: l + Z,
            y2: r + c
          };
        }
      }
    }, {
      key: "U3",
      value: function U3(e) {
        var t,
          i = this;
        typeof e === ZC._[31] && (e = "all");
        var a,
          n,
          l = i.iX,
          r = i.iY;
        i.D = [], a = n = i.AU / 2;
        var o = 1;
        switch (i.H.AA) {
          case "vml":
            o = 2, i.AU % 2 == 1 && (a = ZC._i_((i.AU - 1) / 2), n = ZC._i_((i.AU + 1) / 2));
        }
        var s = null,
          C = ZC._x_(l + a, 2),
          A = ZC._x_(l - n, 2),
          Z = ZC._x_(r + a, 2),
          c = ZC._x_(r - n, 2),
          p = i.DL && 2 === i.DL.length,
          u = ZC._i_(i.EV * (i.I - i.HC) / 100),
          h = ZC._i_(i.EV * (i.F - i.GA) / 100),
          _ = 0 !== i.F6 || 0 !== i.FT || 0 !== i.F3 || 0 !== i.FH,
          d = i.Y4[0],
          f = i.Y4[1];
        switch (i.EL) {
          case "top":
            i.E.cm = [i.iX + i.I / 2 + u, i.iY];
            break;
          case "bottom":
            i.E.cm = [i.iX + i.I / 2 + u, i.iY + i.F];
            break;
          case "left":
            i.E.cm = [i.iX, i.iY + i.F / 2 + h];
            break;
          case "right":
            i.E.cm = [i.iX + i.I, i.iY + i.F / 2 + h];
        }
        if (_) {
          var g,
            B = ZC.CX(i.I / 2, i.F / 2);
          "top" !== e && "all" !== e || (0 !== i.F6 ? (g = i.I / 2 >= i.F6 && i.F / 2 >= i.F6 ? ZC._a_(i.F6) : B, i.D.push([C, Z + g]), i.F6 > 0 && i.D.push([C, Z, C + o * g, Z]), i.D.push([C + g, Z])) : i.D.push([C, Z]), i.L2 && "top" === i.EL && (i.D.push([C + i.I / 2 - d * i.HC / 2 - i.AU / 2 + u, Z]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [C + i.I / 2 - i.AU / 2 + u, Z - i.GA], i.D.push(s)), i.MD > 0 && (t = i.D[i.D.length - 1], i.D.push([t[0], t[1] - i.MD * (i.GA > 0 ? 1 : -1)]), i.D.push([t[0], t[1]])), i.D.push([C + i.I / 2 - i.AU / 2 + f * i.HC / 2 + u, Z])), "top" === e && (0 !== i.FT ? (g = i.I / 2 >= i.FT && i.F / 2 >= i.FT ? ZC._a_(i.FT) : B, i.D.push([A + i.I - g, Z])) : i.D.push([A + i.I, Z]))), "right" !== e && "all" !== e || (0 !== i.FT ? (g = i.I / 2 >= i.FT && i.F / 2 >= i.FT ? ZC._a_(i.FT) : B, i.D.push([A + i.I - g, Z]), i.FT > 0 ? i.D.push([A + i.I, Z, A + i.I, Z + o * g]) : i.D.push([A + i.I, Z + g])) : i.D.push([A + i.I, Z]), i.L2 && "right" === i.EL && (i.D.push([A + i.I, Z + i.F / 2 - d * i.GA / 2 - i.AU / 2 + h]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [A + i.I + i.HC, Z + i.F / 2 - i.AU / 2 + h], i.D.push(s)), i.D.push([A + i.I, Z + i.F / 2 + f * i.GA / 2 - i.AU / 2 + h])), "right" === e && (0 !== i.F3 ? (g = i.I / 2 >= i.F3 && i.F / 2 >= i.F3 ? ZC._a_(i.F3) : B, i.D.push([A + i.I, c + i.F - g])) : i.D.push([A + i.I, c + i.F]))), "bottom" !== e && "all" !== e || (0 !== i.F3 ? (g = i.I / 2 >= i.F3 && i.F / 2 >= i.F3 ? ZC._a_(i.F3) : B, i.D.push([A + i.I, c + i.F - g]), i.F3 > 0 ? i.D.push([A + i.I, c + i.F, A + i.I - o * g, c + i.F]) : i.D.push([A + i.I - g, c + i.F])) : i.D.push([A + i.I, c + i.F]), i.L2 && "bottom" === i.EL && (i.D.push([A + i.I / 2 + d * i.HC / 2 + i.AU / 2 + u, c + i.F]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [A + i.I / 2 + i.AU / 2 + u, c + i.F + i.GA], i.D.push(s)), i.MD > 0 && (t = i.D[i.D.length - 1], i.D.push([t[0], t[1] + i.MD * (i.GA > 0 ? 1 : -1)]), i.D.push([t[0], t[1]])), i.D.push([A + i.I / 2 - f * i.HC / 2 + i.AU / 2 + u, c + i.F])), "bottom" === e && (0 !== i.FH ? (g = i.I / 2 >= i.FH && i.F / 2 >= i.FH ? ZC._a_(i.FH) : B, i.D.push([C + g, c + i.F])) : i.D.push([C, c + i.F]))), "left" !== e && "all" !== e || (0 !== i.FH ? (g = i.I / 2 >= i.FH && i.F / 2 >= i.FH ? ZC._a_(i.FH) : B, i.D.push([C + g, c + i.F]), i.FH > 0 ? i.D.push([C, c + i.F, C, c + i.F - o * g]) : i.D.push([C, c + i.F - g])) : i.D.push([C, c + i.F]), i.L2 && "left" === i.EL && (i.D.push([C, c + i.F / 2 + d * i.GA / 2 + i.AU / 2 + h]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [C - i.HC, c + i.F / 2 + i.AU / 2 + h], i.D.push(s)), i.D.push([C, c + i.F / 2 - f * i.GA / 2 + i.AU / 2 + h])), 0 !== i.F6 ? (g = i.I / 2 >= i.F6 && i.F / 2 >= i.F6 ? ZC._a_(i.F6) : B, i.D.push([C, Z + g])) : (i.D.push([C, Z]), i.D.push([C + .1, Z])));
        } else "top" !== e && "all" !== e || ("top" === e ? i.D.push([C + .5, Z + .5]) : i.D.push([C, Z]), i.L2 && "top" === i.EL && (i.D.push([C + i.I / 2 - d * i.HC / 2 - i.AU / 2 + u, Z]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [C + i.I / 2 - i.AU / 2 + u, Z - i.GA], i.D.push(s)), i.MD > 0 && (t = i.D[i.D.length - 1], i.D.push([t[0], t[1] - i.MD * (i.GA > 0 ? 1 : -1)]), i.D.push([t[0], t[1]])), i.D.push([C + i.I / 2 + f * i.HC / 2 - i.AU / 2 + u, Z])), "top" === e && i.D.push([A + i.I + .5, Z + .5])), "right" !== e && "all" !== e || ("right" === e ? i.D.push([A + i.I + .5, Z + .5]) : i.D.push([A + i.I, Z]), i.L2 && "right" === i.EL && (i.D.push([A + i.I, Z + i.F / 2 - i.AU / 2 - d * i.GA / 2 + h]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [A + i.I + i.HC, Z + i.F / 2 - i.AU / 2 + h], i.D.push(s)), i.D.push([A + i.I, Z + i.F / 2 - i.AU / 2 + f * i.GA / 2 + h])), "right" === e && i.D.push([A + i.I + .5, c + i.F + .5])), "bottom" !== e && "all" !== e || ("bottom" === e ? i.D.push([A + i.I + .5, c + i.F + .5]) : i.D.push([A + i.I, c + i.F]), i.L2 && "bottom" === i.EL && (i.D.push([A + i.I / 2 + d * i.HC / 2 + i.AU / 2 + u, c + i.F]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [A + i.I / 2 + i.AU / 2 + u, c + i.F + i.GA], i.D.push(s)), i.MD > 0 && (t = i.D[i.D.length - 1], i.D.push([t[0], t[1] + i.MD * (i.GA > 0 ? 1 : -1)]), i.D.push([t[0], t[1]])), i.D.push([A + i.I / 2 - f * i.HC / 2 + i.AU / 2 + u, c + i.F])), "bottom" === e && i.D.push([C + .5, c + i.F + .5])), "left" !== e && "all" !== e || ("left" === e ? i.D.push([C + .5, c + i.F + .5]) : i.D.push([C, c + i.F]), i.L2 && "left" === i.EL && (i.D.push([C, c + i.F / 2 + i.AU / 2 + d * i.GA / 2 + h]), p ? i.D.push([i.DL[0], i.DL[1]]) : (s = [C - i.HC, c + i.F / 2 + i.AU / 2 + h], i.D.push(s)), i.D.push([C, c + i.F / 2 + i.AU / 2 - f * i.GA / 2 + h])), "left" === e ? i.D.push([C + .5, Z + .5]) : (i.D.push([C, Z]), i.D.push([C + .1, Z])));
        s && (i.E.cp = s);
      }
    }, {
      key: "WG",
      value: function WG(e) {
        e = e || "all";
        var t,
          i,
          a,
          n = this,
          l = n.Z.getContext("2d");
        l.save(), l.globalCompositeOperation = n.A1E;
        var r = n.iX,
          o = n.iY,
          s = n.WD(),
          C = s.bc,
          A = s.bgc1,
          Z = s.bgc2;
        if ("all" === e) if (A !== Z || "" !== n.GV && "" !== n.HU) {
          var c = n.SF(n.NT);
          "radial" === n.NT ? t = l.createRadialGradient(c.cx, c.cy, 1, c.cx, c.cy, c.r) : "linear" === n.NT && (c.x1 = isNaN(c.x1) ? 0 : c.x1, c.x2 = isNaN(c.x2) ? 0 : c.x2, c.y1 = isNaN(c.y1) ? 0 : c.y1, c.y2 = isNaN(c.y2) ? 0 : c.y2, t = l.createLinearGradient(c.x1, c.y1, c.x2, c.y2)), "" !== n.GV && "" !== n.HU ? n.UX(t) : (t.addColorStop(0, A), t.addColorStop(1, Z)), l.fillStyle = t;
        } else "" !== n.D9 && -1 !== ZC.AV(["repeat", "true", !0], n.MG) && "-1" === n.A0 && "-1" === n.AE && (A = "rgba(255,255,255,0)"), l.fillStyle = A;
        l.strokeStyle = C, l.lineWidth = n.AU, l.translate(n.BM, n.BH), 0 !== n.A9 && (l.translate(r + n.I / 2, o + n.F / 2), l.rotate(ZC.TK(n.A9)), l.translate(-(r + n.I / 2), -(o + n.F / 2))), l.beginPath(), n.U3(e);
        var p = n.F6 + n.FT + n.F3 + n.FH !== 0;
        a = n.AZ, n.AZ = n.AU;
        var u = n.GH;
        if (n.GH = "", n.KR(), ZC.CQ.contour(l, n, n.D), n.AZ = a, n.GH = u, n.KR(), "all" === e) if ("" !== n.D9 && -1 === ZC.AV(ZC.IMG404, n.D9)) {
          l.fill(), l.save(), l.clip();
          var h = l.globalAlpha;
          l.globalAlpha = n.C6;
          var _ = n.Q4(),
            d = _.image;
          switch (n.MG) {
            default:
              l.translate(n.iX, n.iY), i = l.createPattern(d, "repeat"), l.fillStyle = i, l.fill(), l.translate(-_.x, -_.y);
              break;
            case "no-repeat":
            case "false":
            case !1:
              l.drawImage(d, _.x - n.BM, _.y - n.BH, n.E[ZC._[69]], n.E[ZC._[70]]);
          }
          l.globalAlpha = h, l.restore();
        } else l.fill();
        if (n.AU > 0) {
          var f = n.B7;
          a = n.AZ, n.B7 = n.BW, n.AZ = n.AU, n.KR(), ZC.CQ.setup(l, n), n.TE = p ? "round" : "square", n.EX + n.GD > 0 && (n.TE = "butt"), n.A0N = p ? "round" : "miter", n.E["skip-top"] = !0, n.E.border = e, ZC.CQ.paint(l, n, n.D, !0), n.B7 = f, n.AZ = a, n.KR();
        }
        l.closePath(), l.restore();
      }
    }, {
      key: "U0",
      value: function U0(e) {
        e = e || "all";
        var t = this,
          i = t.Z;
        t.E.fill = -1;
        var a = !1;
        if ("all" === e) {
          if ("" !== t.D9 && -1 === ZC.AV(ZC.IMG404, t.D9)) {
            var n = t.Q4();
            t.XY({
              info: n,
              x: t.iX,
              y: t.iY
            }), a = !0;
          }
          t.TP();
        }
        if (t.U3(e), a && "repeat" !== t.MG && t.L2) {
          var l = 0,
            r = 0;
          t.D0[1] < t.iY && (r = t.D0[3] - t.D0[1] - t.F), t.D0[0] < t.iX && (l = t.D0[2] - t.D0[0] - t.I), null === ZC._n_(t.E["pattern-tx"]) ? t.E["pattern-tx"] = l : t.E["pattern-tx"] += l, null === ZC._n_(t.E["pattern-ty"]) ? t.E["pattern-ty"] = r : t.E["pattern-ty"] += r, ZC.Q.G4(ZC.AK(t.E["pattern-image-id"]), {
            transform: "translate(" + t.E["pattern-tx"] + "," + t.E["pattern-ty"] + ")"
          });
        }
        var o = t.F6 + t.FT + t.F3 + t.FH !== 0;
        t.E.cx = t.iX + t.I / 2, t.E.cy = t.iY + t.F / 2, t.W7 && t.ZH();
        var s = t.B7,
          C = t.AZ;
        t.B7 = t.BW, t.AZ = t.AU, t.KR(), ZC.CQ.setup(i, t), t.TE = o ? "round" : "square", t.EX + t.GD > 0 && (t.TE = "butt"), t.A0N = o ? "round" : "miter";
        var A = !1;
        ZC.A5.browser.msie || !t.FG || t.L2 || "" !== t.QF || "" !== t.OV || "" !== t.O1 || "" !== t.PK || 0 !== t.F6 || 0 !== t.FT || 0 !== t.F3 || 0 !== t.FH || (A = !0), t.E["skip-top"] = !0, t.E.border = e, ZC.CQ.paint(i, t, t.D, !0, null, A), t.B7 = s, t.AZ = C, t.KR();
      }
    }, {
      key: "TZ",
      value: function TZ(e) {
        e = e || "all";
        var t = this,
          i = t.Z;
        if ("all" === e) {
          var a = ZC.Q.F7("zcv:fill");
          if ("" !== t.D9 && -1 === ZC.AV(ZC.IMG404, t.D9)) {
            var n = t.Q4(),
              l = n.image;
            switch (t.MG) {
              default:
                a.type = "tile", a.src = t.D9, ZC.Q.G4(a, {
                  position: n.cx + "," + n.cy,
                  opacity: t.C6,
                  "o:opacity2": t.C6
                }), t.E.imgfill = [a];
                break;
              case "no-repeat":
              case "false":
              case !1:
                t.E.imgfill = [l, n.x, n.y];
            }
          }
          t.TO("0.5,0.5");
        }
        var r = ZC.Q.F7("zcv:stroke");
        switch (r.weight = t.AU + "px", r.color = t.BW, r.opacity = t.C6, t.GH) {
          case "solid":
            r.dashstyle = "solid";
            break;
          case "dotted":
            r.dashstyle = "dot";
            break;
          case "dashed":
            r.dashstyle = "dash";
        }
        t.E.stroke = r, t.U3(e);
        var o = t.F6 + t.FT + t.F3 + t.FH !== 0;
        t.E.cx = t.iX + t.I / 2, t.E.cy = t.iY + t.F / 2;
        var s = t.B7,
          C = t.AZ;
        t.B7 = t.BW, t.AZ = t.AU, t.KR(), ZC.CQ.setup(i, t), t.TE = o ? "round" : "square", t.EX + t.GD > 0 && (t.TE = "butt"), t.A0N = o ? "round" : "miter", t.E.border = e, ZC.CQ.paint(i, t, t.D, "all" === e), t.B7 = s, t.AZ = C, t.KR();
      }
    }]);
    return I3;
  }(DW);
  var QZ = /*#__PURE__*/function (_DW2) {
    _inherits(QZ, _DW2);
    function QZ(e) {
      var _this5;
      _classCallCheck(this, QZ);
      _this5 = _possibleConstructorReturn(this, _getPrototypeOf(QZ).call(this, e));
      var t = _assertThisInitialized(_this5);
      t.X3 = null, t.BF = null, t.M = null, t.SX = null, t.A7 = null, t.KE = !1, t.OI = !1, t.L7 = !1, t.A6Y = !1;
      return _this5;
    }
    _createClass(QZ, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        t.BF = zingchart.pool.getInstance("box" === t.X3.type ? "I3" : "DW", t.A, t.K + "-shape", t.X3.tween), t.BF.append(t.X3), t.BF.iX = t.iX, t.BF.iY = t.iY, t.BF.K = t.K + "-gshape", t.BF.OI = t.OI, t.A6Y || null === ZC._n_(e = t.BF.o.points) || (t.BF.o.points = ZC.AQ.A67(e, t.A.iX, t.A.iY), t.A6Y = !0), t.BF.parse(), null !== ZC._n_(e = t.BF.o.label) && null !== ZC._n_(e.text) && "" !== e.text && (typeof e.visible === ZC._[31] || ZC._b_(e.visible)) && (t.M = zingchart.pool.getInstance("DT", t, t.A.K + "-shape-label-" + t.HB, ZC.objmove), ZC.objmove || t.M.append(e)), null !== ZC._n_(e = t.BF.o["static"]) && (t.KE = ZC._b_(e)), null !== ZC._n_(e = t.BF.o.flat) && (t.KE = ZC._b_(e)), null !== ZC._n_(e = t.BF.o.dynamic) && (t.L7 = ZC._b_(e)), null !== ZC._n_(e = t.BF.o.connector) && (t.SX = new DW(t), t.SX.append(e), t.SX.parse());
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        if (t.BF.Z = t.Z, t.BF.C7 = t.C7, t.BF.locate(2), t.BF.WO = !1, "box" === t.BF.o.type && (t.iX -= t.BF.I / 2, t.iY -= t.BF.F / 2, t.BF.iX -= t.BF.I / 2, t.BF.iY -= t.BF.F / 2), t.BF.paint(), t.M) {
          if (t.M.Z = t.M.C7 = t.Z, t.M.IW = ZC.AK(t.A.A.K + "-text"), t.M.K = t.A.K + "-shape-label-" + t.HB, t.M.GO = t.A.K + "-shape-label zc-shape-label", t.M.o.anchor = t.M.o.anchor || "c", !t.X3["map-item"]) switch (t.DQ) {
            default:
              t.M.o.x = t.iX, t.M.o.y = t.iY;
              break;
            case "line":
            case "poly":
            case "rect":
            case "rectangle":
              t.M.o.x = ZC._i_((t.BF.D0[0] + t.BF.D0[2]) / 2), t.M.o.y = ZC._i_((t.BF.D0[1] + t.BF.D0[3]) / 2);
          }
          if (ZC.objmove || t.M.parse(), t.M.iX = t.M.iX + t.BF.BM, t.M.iY = t.M.iY + t.BF.BH, t.M.AN) {
            if (t.SX && t.SX.D.length > 0) {
              if (!ZC.AK(t.A.K + "-objects-front")) {
                var i = t.A.A.I + "/" + t.A.A.F;
                ZC.Q.K5({
                  cls: "zc-abs",
                  wh: i,
                  id: t.A.K + "-objects-front",
                  p: ZC.AK(t.A.A.K + "-objects-front")
                }, t.A.A.AA), ZC.Q.HJ({
                  cls: ZC._[24],
                  id: t.A.K + "-objects-front-c",
                  p: ZC.AK(t.A.K + "-objects-front"),
                  wh: i
                }, t.A.A.AA);
              }
              var a = t.SX.D,
                n = t.SX.o.anchor || "",
                l = a[a.length - 1];
              switch (n) {
                case "l":
                  t.M.iX = l[0] + t.BF.BM, t.M.iY = l[1] - t.M.F / 2 + t.BF.BH;
                  break;
                case "r":
                  t.M.iX = l[0] - t.M.I + t.BF.BM, t.M.iY = l[1] - t.M.F / 2 + t.BF.BH;
                  break;
                case "t":
                  t.M.iX = l[0] - t.M.I / 2 + t.BF.BM, t.M.iY = l[1] + t.BF.BH;
                  break;
                case "b":
                  t.M.iX = l[0] - t.M.I / 2 + t.BF.BM, t.M.iY = l[1] - t.M.F + t.BF.BH;
                  break;
                default:
                  t.M.iX = l[0] - t.M.I / 2 + t.BF.BM, t.M.iY = l[1] - t.M.F / 2 + t.BF.BH;
              }
              e = ZC.Q.E9(ZC.AK(t.A.K + "-objects-front-c"), t.A.H.AA), ZC.CQ.setup(e, t.SX), ZC.CQ.paint(e, t.SX, a);
            }
            if (t.M.WO = !1, t.X3["map-item"] && (t.M.GO = t.A.K + "-mapshape-label zc-mapshape-label", t.M.iX < t.A.iX || t.M.iX + t.M.I > t.A.iX + t.A.I || t.M.iY < t.A.iY || t.M.iY + t.M.F > t.A.iY + t.A.F)) return;
            t.M.paint(), t.E["print-canvas"] ? t.M.ED(ZC.AK(t.E["print-canvas"])) : t.M.ED();
          }
        }
      }
    }]);
    return QZ;
  }(DW);
  var DT = /*#__PURE__*/function (_I) {
    _inherits(DT, _I);
    function DT(e) {
      var _this6;
      _classCallCheck(this, DT);
      _this6 = _possibleConstructorReturn(this, _getPrototypeOf(DT).call(this, e)), _this6.init(e);
      return _this6;
    }
    _createClass(DT, [{
      key: "init",
      value: function init(e) {
        _get(_getPrototypeOf(DT.prototype), "init", this).call(this, e);
        var t = this;
        t.IW = null, t.GO = "", t.AO = null, t.OO = "center", t.K4 = "middle", t.DG = zingchart.FONTSIZE, t.GJ = zingchart.FONTFAMILY, t.C2 = "#000", t.A9Q = !1, t.ND = !1, t.QV = !1, t.KG = "none", t.sFontWeight = "normal", t.YW = 0, t.FO = 2, t.FP = 2, t.FS = 2, t.EP = 2, t.A92 = !1, t.A2O = !1, t.FM = -1, t.KH = 0, t.NZ = 0, t.OZ = ZC.MAX, t.bRTL = !1, t.A2F = !0, t.VL = zingchart.FASTWIDTH, t.A6R = 1.65, t.VM = 1, t.WZ = !1, t.A7 = null, t.VV = !1, t.A57 = !1;
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        var e = _get(_getPrototypeOf(DT.prototype), "getPMap", this).call(this);
        return this.addPMap(e, "textAlign,verticalAlign,fontSize,fontFamily,color,bold,fontWeight,italic,underline,textDecoration,paddingTop,paddingRight,paddingBottom,paddingLeft,text", "OO,K4,DG,GJ,C2,A9Q,sFontWeight,ND,QV,KG,FO,FP,FS,EP,AO"), e;
      }
    }, {
      key: "copy",
      value: function copy(e) {
        _get(_getPrototypeOf(DT.prototype), "copy", this).call(this, e);
        for (var t = "OO,K4,DG,GJ,C2,A9Q,sFontWeight,ND,KG,QV,FO,FP,FS,EP,AO".split(","), i = 0, a = t.length; i < a; i++) typeof e[t[i]] !== ZC._[31] && (this[t[i]] = e[t[i]]);
      }
    }, {
      key: "ES",
      value: function ES(e) {
        return e;
      }
    }, {
      key: "isBold",
      value: function isBold(e) {
        return "bold" === e || "bolder" === e || "500" === e || "600" === e || "700" === e || "800" === e || "900" === e;
      }
    }, {
      key: "cwidth",
      value: function cwidth(e) {
        var t = this;
        if (t.VL) return e.replace(/(<([^>]+)>)/gi, "").length * t.DG / (t.A6R * (t.isBold(t.sFontWeight) ? .87 : 1) * (t.ND ? .95 : 1));
        var i = "";
        return typeof t.o["html-mode"] !== ZC._[31] && ZC._b_(t.o["html-mode"]) && (i = "[HTMLMODE]"), ZC.Q.A4S(this.H.K, i + e, this.GJ, this.DG, this.sFontWeight, this.FM);
      }
    }, {
      key: "parse",
      value: function parse() {
        this.I = this.F = this.NZ = this.KH = 0, _get(_getPrototypeOf(DT.prototype), "parse", this).call(this);
        var e,
          t,
          i,
          a,
          n,
          l = this;
        if (!l.o.tween) {
          if (l.YU("text", "AO"), null !== ZC._n_(l.AO) && (l.AO = "" + l.AO, l.AO = l.ES(l.AO), l.AO = l.AO.replace(/\n/g, "<br>").replace(/\\n/g, "<br>"), "svg" === l.H.AA && (l.AO = l.AO.replace(/&nbsp;/g, " ")), l.AO = l.AO.replace(/<img|<audio|<video|<embed|<object/gi, "")), l.assign_a([["overlap", "A2F", "b"], ["fast-width", "VL", "b"], ["max-width", "OZ", "i"], ["line-height", "FM", "i"], ["width-ratio", "A6R", "f"], ["wrap-text", "A2O", "b"], ["clip-text", "A92", "b"], ["bold", "A9Q", "b"], ["italic", "ND", "b"], ["underline", "QV", "b"], ["text-decoration", "KG"], ["rtl", "bRTL", "b"], ["text-align", "OO"], ["align", "OO"], ["vertical-align", "K4"], ["font-size", "DG", "f"], ["max-chars", "YW", "i"], ["font-family", "GJ"], ["font-angle", "A9", "i"], ["color", "C2", "c"], ["font-color", "C2", "c"], ["text-alpha", "VM", "f", 0, 1], ["lock-rotation", "VV", "b"]]), l.DG = ZC.BQ(1, l.DG), null === ZC._n_(l.o["text-alpha"]) && (l.VM = l.C6), l.A9Q && (l.sFontWeight = "bold"), null !== (e = ZC._n_(l.o["font-weight"])) && (l.sFontWeight = e), null === ZC._n_(l.o["text-decoration"]) && (l.KG = l.QV ? "underline" : "none"), null !== (e = ZC._n_(l.o["font-style"])) && (l.ND = "italic" === e || "oblique" === e), null !== (e = ZC._n_(l.o.padding))) {
            var r = String(e).split(/\s+|;|,/);
            t = 1 === r.length ? [ZC._i_(r[0]), ZC._i_(r[0]), ZC._i_(r[0]), ZC._i_(r[0])] : 2 === r.length ? [ZC._i_(r[0]), ZC._i_(r[1]), ZC._i_(r[0]), ZC._i_(r[1])] : 3 === r.length ? [ZC._i_(r[0]), ZC._i_(r[1]), ZC._i_(r[2]), ZC._i_(r[0])] : [ZC._i_(r[0]), ZC._i_(r[1]), ZC._i_(r[2]), ZC._i_(r[3])], l.FO = t[0], l.FP = t[1], l.FS = t[2], l.EP = t[3];
          }
          if (l.assign_a([["padding-top", "FO", "i"], ["padding-right", "FP", "i"], ["padding-bottom", "FS", "i"], ["padding-left", "EP", "i"]]), l.AO) {
            l.YW > 0 && l.AO.length > l.YW && (l.AO = l.AO.substring(0, l.YW) + "...");
            var o = l.AO.split(/<br>|<br\/>|<br \/>|\n/),
              s = "";
            typeof l.o["html-mode"] !== ZC._[31] && ZC._b_(l.o["html-mode"]) && (o = [l.AO], s = "[HTMLMODE]");
            o.length;
            for (l.VL ? l.KH = 1.65 * this.DG : l.KH = ZC.Q.A4S(this.H.K, s + l.AO, this.GJ, this.DG, this.sFontWeight, this.FM, !0) + l.FO + l.FS, i = 0, a = o.length; i < a; i++) l.NZ = ZC.BQ(l.NZ, l.cwidth(o[i]) + l.EP + l.FP);
          } else l.AO = "", l.NZ = ZC._i_(1.25 * l.DG), l.KH = -1 === l.FM ? ZC._i_(1.25 * l.DG) : l.FM;
          if ((null === ZC._n_(l.o[ZC._[19]]) || isNaN(l.I) || 0 === l.I) && (l.I = l.NZ), (null === ZC._n_(l.o[ZC._[20]]) || isNaN(l.F) || 0 === l.F) && (l.F = l.KH), l.I = ZC.CX(l.I, l.OZ), l.A2O && l.NZ > l.I && !l.E.wrapped && l.I > 2 * l.DG) {
            var C,
              A = "",
              Z = 0,
              c = l.AO.replace(/<br>/gi, " [##] ").split(/\s|<br>/),
              p = [];
            for (i = 0, a = c.length; i < a; i++) if ((C = l.cwidth(c[i])) > .9 * l.I) {
              var u = Math.ceil(C / l.I * .9),
                h = Math.ceil(c[i].length / u);
              for (n = 0; n < u; n++) p.push(c[i].substr(n * h, h));
            } else p.push(c[i]);
            for (i = 0, a = p.length; i < a; i++) "" !== p[i] && ("[##]" === p[i] ? (A += "<br>", Z = 0) : (Z += C = 1 + l.cwidth(p[i] + " ")) > .9 * l.I ? (i > 0 && (A += "<br>"), A += p[i] + " ", Z = C) : A += p[i] + " ");
            A = (A = A.replace(/<br><br>/g, "<br>").replace(/ <br> <br>/g, " <br>")).replace(/(.+?)<br> $/g, "$1");
            var _ = l.o.text;
            l.o.text = A, l.E.wrapped = !0, l.parse(), l.o.text = _, l.E.wrapped = !1;
          }
          if ("canvas" !== l.H.AA && (l.AO = l.AO.replace(/&lt;/g, "<").replace(/&gt;/g, ">")), !(null !== ZC._n_(l.o[ZC._[19]]) && null !== ZC._n_(l.o[ZC._[20]]) || null === ZC._n_(l.o.position) && null === ZC._n_(l.o.margin) && null === ZC._n_(l.o[ZC._[57]]) && null === ZC._n_(l.o[ZC._[58]]) && null === ZC._n_(l.o[ZC._[59]]) && null === ZC._n_(l.o[ZC._[60]]))) {
            l.iX = -1, l.iY = -1;
            var d = l.o[ZC._[19]],
              f = l.o[ZC._[20]];
            null === ZC._n_(d) && (l.o[ZC._[19]] = l.I), null === ZC._n_(f) && (l.o[ZC._[20]] = l.F), l.locate(), l.o[ZC._[19]] = d, l.o[ZC._[20]] = f;
          }
          if (typeof l.o["html-mode"] === ZC._[31] || !l.o["html-mode"]) {
            var g = Math.ceil((l.NZ - l.EP - l.FP) / l.DG);
            g > 0 && (l.AO = l.AO.replace(/<hr>/g, new Array(g).join("\u2014")));
          }
        }
        l.setAnchor();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z = this;
        if (!Z.WZ && !Z.A2F) {
          var c = !0;
          null !== ZC._n_(Z.o.flexible) && (c = ZC._b_(Z.o.flexible));
          var p,
            u,
            h = {
              x: Z.iX + Z.EP - 1,
              y: Z.iY + Z.FO - 1,
              width: Z.I - Z.EP - Z.FP + 2,
              height: Z.F - Z.FO - Z.FS + 2,
              type: Z.E.lbltype || ""
            },
            _ = [[0, 0]];
          for (c && (_ = [[0, 0], [0, 2], [0, -4], [0, 4], [0, -8], [3, 0], [-6, 0], [5, 0], [-10, 0]]), u = 0; u < _.length; u++) {
            for (p = !0, h.x += _[u][0], h.y += _[u][0], n = 0, l = Z.H.T4.length; n < l; n++) ZC.AR.YG(h, Z.H.T4[n], -2) && (p = !1);
            if (p) {
              Z.iX = h.x, Z.iY = h.y;
              break;
            }
          }
          if (!p) return;
          Z.H.T4.push(h);
        }
        var d = Z.H.AA;
        if (e = ZC.Q.E9(Z.Z, d), Z.WZ || _get(_getPrototypeOf(DT.prototype), "paint", this).call(this), !Z.A57 && (Z.o[ZC._[19]] || !(Z.I - Z.EP - Z.FP < 2)) && (Z.o[ZC._[20]] || !(Z.KH - Z.FO - Z.FS < 2))) {
          var f = Z.A9 % 360 == 0 ? "0" : "";
          if ((Z.WZ || zingchart.CANVASTEXT && "canvas" === d) && (f = ""), ZC.vml && "svg" === d && "" === Z.GO && (Z.GO = Z.K + "-class"), !Z.WZ && ZC.AK(Z.K) && (d = "_", ZC.objmove)) return ZC.AK(Z.K).style.top = Z.iY + Z.BH + "px", void (ZC.AK(Z.K).style.left = Z.iX + Z.BM + "px");
          var g = typeof Z.E["html-mode"] !== ZC._[31] && Z.E["html-mode"],
            B = g;
          typeof Z.o["html-mode"] !== ZC._[31] && (g = ZC._b_(Z.o["html-mode"]));
          var v,
            m,
            b,
            E,
            K,
            D,
            F,
            I,
            x,
            y,
            X,
            Y,
            w,
            L,
            M,
            H,
            G,
            P,
            N,
            O,
            S,
            Q,
            k = [Z.AO];
          g || (k = Z.AO.split(/<br>|<br\/>|<br \/>|\n/)), g && !B && "svg" === d && "0" === f && (f = "0html");
          var T = Z.IW ? Z.IW : Z.Z.parentNode;
          switch (d + f) {
            case "canvas0":
            case "vml0":
            case "svg0html":
              if (a = 1, !g) switch (Z.K4) {
                case "middle":
                  a += (Z.F - Z.KH) / 2;
                  break;
                case "bottom":
                  a += Z.F - Z.KH;
              }
              if (r = ZC.Q.I7({
                id: Z.K,
                cls: Z.GO,
                tl: ZC._x_(Z.iY + Z.BH) + "/" + ZC._x_(Z.iX + Z.BM),
                wh: Z.I + "/" + Z.F,
                position: "absolute",
                padding: 0,
                margin: 0,
                overflow: g ? "visible" : "hidden",
                textAlign: Z.OO
              }), g && (B || d + f !== "svg0html" || (T = ZC.AK(Z.H.K + "-top")), T.appendChild(r)), ZC.Q.I7({
                id: Z.K + "-t",
                cls: "" !== Z.GO ? Z.GO + "-t" : "",
                p: r,
                width: Z.I - Z.EP - Z.FP,
                height: g ? null : Z.KH - Z.FO - Z.FS,
                tl: a + "/0",
                html: Z.AO + "",
                position: "absolute",
                whiteSpace: "nowrap",
                opacity: Z.VM,
                color: Z.C2,
                fontWeight: Z.sFontWeight,
                fontStyle: Z.ND ? "oblique" : "normal",
                textDecoration: Z.KG,
                fontSize: Z.DG,
                fontFamily: Z.GJ,
                marginTop: Z.FO,
                marginRight: Z.FP,
                marginBottom: Z.FS,
                marginLeft: Z.EP,
                verticalAlign: Z.K4,
                textAlign: Z.OO,
                lineHeight: -1 === Z.FM ? "125%" : Z.FM + "px",
                rtl: Z.bRTL,
                padding: 0
              }), Z.E["css-display"] && (r.style.display = Z.E["css-display"], Z.E["css-display"] = null), B && Z.H && Z.H.A7 && !Z.o[ZC._[19]] && !Z.o[ZC._[20]]) {
                var z = ZC.A5("#" + Z.K + "-t");
                "canvas" === d && (ZC.AK(Z.H.K + "-tooltip-c").width = z.width() + Z.EP + Z.FP, ZC.AK(Z.H.K + "-tooltip-c").height = z.height() + Z.FO + Z.FS), Z.H.A7.clear(), Z.I = z.width() + Z.EP + Z.FP, Z.F = z.height() + Z.FO + Z.FS, Z.paint();
              }
              break;
            case "canvas":
              var V = !1;
              if (ZC.A5.browser.opera && Z.A9 % 90 == 0 && 0 !== Z.A9 && (Z.A9 += .5, V = !0), e = Z.Z.getContext("2d"), zingchart.DEV.CACHECANVASTEXT && (ZC.CanvasCache || (ZC.CanvasCache = {})), !zingchart.DEV.CACHECANVASTEXT || zingchart.DEV.CACHECANVASTEXT && !ZC.CanvasCache[Z.K]) {
                for (zingchart.DEV.CACHECANVASTEXT && (ZC.CanvasCache[Z.K] = document.createElement("canvas"), ZC.CanvasCache[Z.K].width = Z.NZ, ZC.CanvasCache[Z.K].height = Z.KH), v = -1 === Z.FM ? 0 : ZC._x_(Z.FM - 1.25 * Z.DG) / 2, n = 0, l = k.length; n < l; n++) if ("" !== ZC.GY(k[n])) {
                  switch (t = 1 === l ? Z.NZ : Z.cwidth(k[n]) + Z.FP + Z.EP, b = -1 === (m = k[n]).indexOf("<") ? m : m.replace(/<.+?>/gi, "").replace(/<\/.+?>/gi, ""), i = 0, a = 0, Z.OO) {
                    case "center":
                      i += (Z.I - t) / 2;
                      break;
                    case "right":
                      i += Z.I - t;
                  }
                  switch (Z.K4) {
                    case "middle":
                      a += (Z.F - Z.KH) / 2;
                      break;
                    case "bottom":
                      a += Z.F - Z.KH;
                  }
                  if (E = 0, m !== b) {
                    for (; D = /<(.+?)>(.*?)<\/(.+?)>/.exec(m);) {
                      switch (F = "", I = "", (C = /(.+?)style=(.+?)(\'|")(.*?)/.exec(D[1])) && (I = C[2].replace(/\'|"/g, "")), D[3]) {
                        case "b":
                        case "strong":
                          F = "font-weight:bold";
                          break;
                        case "i":
                        case "em":
                          F = "font-style:italic";
                          break;
                        case "u":
                          F = "text-decoration:underline";
                      }
                      y = '[[span style="' + ("" === F ? "" : F + ";") + I + '"]]' + D[2] + "[[/span]]", m = m.replace(D[0], y);
                    }
                    for (X = !1, N = 0, O = (D = (m = m.replace(/\[\[/g, "<").replace(/\]\]/g, ">").replace(/<span/g, "[[*]]<span").replace(/<\/span>/g, "</span>[[*]]")).split("[[*]]")).length; N < O; N++) if ("" !== D[N]) {
                      if (o = Z.C2, Y = Z.sFontWeight, w = Z.ND, L = Z.QV, M = Z.DG, H = Z.GJ, P = Z.FM, G = Z.KG, K = D[N], A = /<span style=(.+?)>(.+?)<\/(.+?)>/.exec(D[N])) for (K = A[2], S = 0, Q = (x = A[1].replace(/\'|"/g, "").split(/;|:/)).length; S < Q - 1; S += 2) switch (ZC.GY(x[S])) {
                        case "font-size":
                          M = ZC._i_(ZC.GY(x[S + 1]));
                          break;
                        case "font-family":
                          H = ZC.GY(x[S + 1]);
                          break;
                        case "font-weight":
                          Y = ZC.GY(x[S + 1]);
                          break;
                        case "font-style":
                          -1 !== ZC.AV(["italic", "oblique"], ZC.GY(x[S + 1])) && (w = !0);
                          break;
                        case "text-decoration":
                          G = ZC.GY(x[S + 1]);
                          break;
                        case "line-height":
                          P = ZC._i_(ZC.GY(x[S + 1]));
                          break;
                        case "color":
                          o = ZC.AQ.GE(ZC.GY(x[S + 1]));
                      }
                      0 === n && (v = -1 === P ? 0 : ZC._x_(P - 1.25 * M) / 2);
                      var R = {
                        idx: n,
                        ctx: e,
                        i: w,
                        fw: Y,
                        fs: M,
                        lh: P,
                        ff: H,
                        c: o,
                        t: K,
                        dx: i,
                        dy: a
                      };
                      R.dy += ZC._x_(v), R.dy += X || Z.isBold(Y) || L ? 2 : 0, Z.paintCANVASText(R), X = w, E++, i += ZC.Q.A4S(this.H.K, K, H, M, Y, P);
                    }
                    null !== ZC._n_(P) && null !== ZC._n_(M) && (v += -1 === P ? 1.25 * M : P);
                  } else Z.paintCANVASText({
                    idx: n,
                    ctx: e,
                    i: Z.ND,
                    fw: Z.sFontWeight,
                    fs: Z.DG,
                    lh: Z.FM,
                    ff: Z.GJ,
                    c: Z.C2,
                    t: k[n],
                    dx: i,
                    dy: a + v
                  }), v += -1 === Z.FM ? 1.25 * Z.DG : Z.FM;
                }
              } else e.drawImage(ZC.CanvasCache[Z.K], Z.iX + Z.BM, Z.iY + Z.BH);
              V && (Z.A9 -= .5);
              break;
            case "vml":
              switch (a = 0, Z.K4) {
                case "top":
                  a -= (Z.F - Z.KH) / 2;
                  break;
                case "bottom":
                  a += (Z.F - Z.KH) / 2;
              }
              var J = ZC.Q.F7("zcv:line"),
                W = Z.iX + Z.BM + Z.I / 2,
                U = Z.iY + Z.BH + Z.F / 2,
                j = ZC.EG(Z.A9) * (Z.I - Z.EP - Z.FP) / 2,
                q = ZC.EN(Z.A9) * (Z.I - Z.EP - Z.FP) / 2,
                $ = ZC._i_(W - j - ZC.EG(90 - Z.A9) * a),
                ee = ZC._i_(U - q + ZC.EN(90 - Z.A9) * a),
                te = ZC._i_(W + j - ZC.EG(90 - Z.A9) * a),
                ie = ZC._i_(U + q + ZC.EN(90 - Z.A9) * a);
              $ === te && ($ -= .01, te += .01), ee === ie && (ee -= .01, ie += .01), o = Z.C2, 0 !== Z.A9 && Z.C6 < 1 && (o = ZC.AQ.R2(o, 99 * (1 - Z.C6))), ZC.Q.G4(J, {
                id: Z.K + "-line",
                from: $ + "px," + ee + "px",
                to: te + "px," + ie + "px",
                fillcolor: o
              }), J.filled = !0, J.stroked = !1;
              var ae = ZC.Q.F7("zcv:path");
              ae.setAttribute("textpathok", !0), J.appendChild(ae);
              var ne = ZC.Q.F7("zcv:textpath"),
                le = Z.AO.replace(/<br>|<br\/>|<br \/>/gi, "\n").replace(/<.+?>/gi, "").replace(/<\/.+?>/gi, "");
              ZC.Q.G4(ne, {
                on: !0,
                string: le
              }), ZC.Q.PV(ne, {
                color: o,
                fontWeight: Z.sFontWeight,
                fontStyle: Z.ND ? "oblique" : "normal",
                textDecoration: Z.KG,
                fontSize: Z.DG + "px",
                fontFamily: Z.GJ,
                "v-text-align": Z.OO
              }), J.appendChild(ne), e.appendChild(J);
              break;
            case "svg":
            case "svg0":
              var re = Z.iX + Z.EP + Z.BM,
                oe = Z.iY + Z.FO + Z.BH;
              if (r = ZC.Q.F7("text", ZC._[36]), ZC.Q.G4(r, {
                x: ZC._x_(re),
                y: ZC._x_(oe),
                id: Z.K,
                "class": Z.GO,
                opacity: Z.VM
              }), Z.E["css-display"] && (r.style.display = Z.E["css-display"], Z.E["css-display"] = null), Z.bRTL && ZC.Q.G4(r, {
                "text-anchor": ZC.A5.browser.msie ? "" : "end",
                "writing-mode": "rl",
                direction: "rtl",
                "unicode-bidi": "bidi-override"
              }), Z.A92 && (Z.H.KK.appendChild(ZC.Q.XU({
                id: Z.K + "-clip",
                path: [[Z.iX + Z.EP + Z.AU + Z.BM, Z.iY + Z.FO + Z.AU + Z.BH].join(","), [Z.iX + Z.I - Z.FP - Z.AU + Z.BM, Z.iY + Z.FO + Z.AU + Z.BH].join(","), [Z.iX + Z.I - Z.FP - Z.AU + Z.BM, Z.iY + Z.F - Z.FS - Z.AU + Z.BH].join(","), [Z.iX + Z.EP + Z.AU + Z.BM, Z.iY + Z.F - Z.FS - Z.AU + Z.BH].join(","), [Z.iX + Z.EP + Z.AU + Z.BM, Z.iY + Z.FO + Z.AU + Z.BH].join(",")].join(" ")
              })), ZC.Q.G4(r, {
                "clip-path": "url(#" + Z.K + "-clip)"
              })), Z.A9 % 360 != 0 && r.setAttribute("transform", "rotate(" + Z.A9 + " " + (re + (Z.I - Z.EP - Z.FP) / 2) + " " + (oe + (Z.F - Z.FO - Z.FS) / 2) + ")"), g && T.appendChild(r), g) {
                ZC.Q.EU(Z.K + "-float");
                var se = ZC.Q.F7("div");
                ZC.Q.PV(se, {
                  position: "absolute",
                  left: 0,
                  top: 0,
                  width: Z.I - Z.EP - Z.FP + "px",
                  height: Z.F - Z.FO - Z.FS + "px",
                  color: Z.C2,
                  fontSize: Z.DG + "px",
                  fontFamily: Z.GJ,
                  fontWeight: Z.sFontWeight,
                  textDecoration: Z.KG,
                  textAlign: Z.OO,
                  fontStyle: Z.ND ? "italic" : "normal"
                }), se.id = Z.K + "-float", se.className = "zc-style zc-html-mode", se.innerHTML = k[0], 1 === Z.o["z-index"] ? ZC.AK(Z.H.K + "-top").append(se) : ZC.AK(Z.H.K + "-top").insertBefore(se, ZC.AK(Z.H.K + "-img")), B && Z.H && Z.H.A7 && (Z.o[ZC._[19]] || Z.o[ZC._[20]] || (Z.H.A7.clear(), se.style.width = "", se.style.height = "", Z.I = ZC.A5(se).width() + Z.EP + Z.FP, Z.F = ZC.A5(se).height() + Z.FO + Z.FS, Z.paint()));
              } else for (v = -1 === Z.FM ? 0 : ZC._x_(Z.FM - 1.25 * Z.DG) / 2, n = 0, l = k.length; n < l; n++) {
                switch (t = 1 === l ? Z.NZ : Z.cwidth(k[n]) + Z.FP + Z.EP, b = -1 === (m = k[n]).indexOf("<") ? m : m.replace(/<.+?>/gi, "").replace(/<\/.+?>/gi, ""), i = 0, a = Z.DG, Z.OO) {
                  case "center":
                    i = (Z.I - t) / 2;
                    break;
                  case "right":
                    i = Z.I - t;
                }
                switch (Z.K4) {
                  case "middle":
                    a += (Z.F - Z.KH) / 2;
                    break;
                  case "bottom":
                    a += Z.F - Z.KH;
                }
                if (E = 0, m !== b) {
                  for (; D = /<(.+?)>(.*?)<\/(.+?)>/.exec(m);) {
                    switch (F = "", I = "", (C = /(.+?)style=(.+?)(\'|")(.*?)/.exec(D[1])) && (I = C[2].replace(/\'|"/g, "")), D[3]) {
                      case "b":
                      case "strong":
                        F = "font-weight:bold";
                        break;
                      case "i":
                      case "em":
                        F = "font-style:italic";
                        break;
                      case "u":
                        F = "text-decoration:underline";
                    }
                    y = '[[span style="' + ("" === F ? "" : F + ";") + I + '"]]' + D[2] + "[[/span]]", m = m.replace(D[0], y);
                  }
                  for (X = !1, N = 0, O = (D = (m = m.replace(/\[\[/g, "<").replace(/\]\]/g, ">").replace(/<span/g, "[[*]]<span").replace(/<\/span>/g, "</span>[[*]]")).split("[[*]]")).length; N < O; N++) if ("" !== D[N]) {
                    if (o = Z.C2, Y = Z.sFontWeight, w = Z.ND, L = Z.QV, M = Z.DG, H = Z.GJ, G = Z.KG, P = Z.FM, K = D[N], A = /<span style=(.+?)>(.+?)<\/(.+?)>/.exec(D[N])) for (K = A[2], S = 0, Q = (x = A[1].replace(/\'|"/g, "").split(/;|:/)).length; S < Q - 1; S += 2) switch (ZC.GY(x[S])) {
                      case "font-size":
                        M = ZC._i_(ZC.GY(x[S + 1]));
                        break;
                      case "font-family":
                        H = ZC.GY(x[S + 1]);
                        break;
                      case "font-weight":
                        Y = ZC.GY(x[S + 1]);
                        break;
                      case "font-style":
                        -1 !== ZC.AV(["italic", "oblique"], ZC.GY(x[S + 1])) && (w = !0);
                        break;
                      case "text-decoration":
                        G = ZC.GY(x[S + 1]);
                        break;
                      case "line-height":
                        P = ZC._i_(ZC.GY(x[S + 1]));
                        break;
                      case "color":
                        o = ZC.AQ.GE(ZC.GY(x[S + 1]));
                    }
                    a = M, s = ZC.Q.F7("tspan", ZC._[36]), 0 === E ? (ZC.Q.G4(s, {
                      x: ZC._x_(re + i),
                      y: ZC._x_(oe + a),
                      dy: ZC._x_(v)
                    }), v += -1 === P ? 1.25 * M : ZC.BQ(1.5 * M, P)) : ZC.Q.G4(s, {
                      dx: X || Z.isBold(Y) || L ? 2 : 0
                    }), ZC.Q.G4(s, {
                      color: o,
                      fill: o
                    }), ZC.Q.PV(s, {
                      fontWeight: Y,
                      fontStyle: w ? "oblique" : "normal",
                      textDecoration: G,
                      fontSize: M + "px",
                      fontFamily: H,
                      dominantBaseline: "auto"
                    });
                    var Ce = document.createElement("span");
                    -1 !== K.indexOf("<") || -1 !== K.indexOf(">") ? Ce.innerText = K : Ce.innerHTML = K, K = Ce.innerText || Ce.textContent, Ce = null, s.textContent = K, r.appendChild(s), X = w, E++;
                  }
                } else Z.bRTL && ZC.A5.browser.msie && (i += t - Z.EP - Z.FP), s = ZC.Q.F7("tspan", ZC._[36]), ZC.Q.G4(s, {
                  x: ZC._x_(re + i),
                  y: ZC._x_(oe + a),
                  color: Z.C2,
                  fill: Z.C2,
                  dy: ZC._x_(v)
                }), ZC.Q.PV(s, {
                  fontWeight: Z.sFontWeight,
                  fontStyle: Z.ND ? "oblique" : "normal",
                  textDecoration: Z.KG,
                  fontSize: Z.DG + "px",
                  fontFamily: Z.GJ,
                  dominantBaseline: "auto"
                }), s.textContent = b, r.appendChild(s), v += -1 === Z.FM ? 1.25 * Z.DG : Z.FM;
              }
          }
          if (!g) if (!Z.WZ && r && T) if (Z.H.G3) -1 !== ZC.Q.TG(T).indexOf("zc-text") && null === ZC._n_(Z.H.G3[T.id]) && (Z.H.G3[T.id] = document.createDocumentFragment()), Z.H.G3[T.id] ? Z.H.G3[T.id].appendChild(r) : T.appendChild(r);else T.appendChild(r);
        }
      }
    }, {
      key: "paintCANVASText",
      value: function paintCANVASText(e) {
        var t = this,
          i = e.idx,
          a = e.ctx,
          n = e.i,
          l = e.fw,
          r = e.fs,
          o = e.ff,
          s = e.c,
          C = e.dx,
          A = e.dy,
          Z = e.t;
        a.save(), a.globalAlpha = t.VM;
        var c;
        if (c = (n ? "italic" : "normal") + " normal " + l + " " + r + "px " + o, a.font = c, a.fillStyle = s, a.textAlign = "left", a.textBaseline = "alphabetic", a.translate(t.iX + t.BM, t.iY + t.BH), 0 !== t.A9 && (a.translate(t.I / 2, t.F / 2), a.rotate(ZC.TK(t.A9)), a.translate(-t.I / 2, -t.F / 2)), a.translate(t.EP, t.FO + r), a.translate(C, A), a.fillText(Z, 0, 0), zingchart.DEV.CACHECANVASTEXT) {
          var p = ZC.CanvasCache[t.K].getContext("2d");
          p.font = c, p.fillStyle = s, p.textAlign = "left", p.textBaseline = "alphabetic", p.fillText(Z, t.EP, t.FO + r + 1.25 * i * r);
        }
        a.restore();
      }
    }, {
      key: "ED",
      value: function ED(e) {
        var t = this;
        if (ZC.canvas && "canvas" === t.H.AA && (e || (e = ZC.AK(t.H.K + "-textprint-c")), !zingchart.CANVASTEXT && t.A9 % 360 == 0)) {
          var i = t.Z;
          t.Z = e, t.WZ = !0;
          var a = t.H.AA;
          t.H.AA = "canvas", t.paint(), t.WZ = !1, t.H.AA = a, t.Z = i;
        }
      }
    }]);
    return DT;
  }(I3);
  var RU = /*#__PURE__*/function (_I2) {
    _inherits(RU, _I2);
    function RU(e) {
      var _this7;
      _classCallCheck(this, RU);
      _this7 = _possibleConstructorReturn(this, _getPrototypeOf(RU).call(this, e));
      var t = _assertThisInitialized(_this7);
      t.CH = "json", t.O4 = {
        graphset: !0,
        graph: !0,
        "objects-bottom": !0,
        "objects-top": !0,
        maps: !0,
        plotarea: !0,
        plots: !0,
        guide: !0,
        "static": !0,
        "value-box": !0
      }, t.bA11y = !1, t.PC = "", t.A1N = !1, t.A1Q = "en_us", t.RA = null, t.JS = "", t.UV = !1, t.SE = {}, t.NA = "", t.ADJ = {}, t.RC = "", t.EW = "", t.MJ = {}, t.I0 = null, t.AG = [], t.LY = "", t.A7 = null, t.H3 = null, t.D6 = null, t.B8 = new ZC.ABB(t), t.RD = "", t.MY = null, t.OC = [null, null, null, null], t.OI = !1, t.NS = "x", t.KE = !1, t.UF = !1, t.AC1 = !1, t.A4D = !1, t.GQ = !1, t.AAP = {}, t.O6 = null, t.R7 = {}, t.M3 = !1, t.RB = !1, t.AD7 = null, t.T2 = [], t.N = {}, t.N8 = null, t.DE = null, t.VB = 0, t.A2L = 0, t.A5A = 1, t.MP = null, t.SP = "", t.ABG = "F*nStrlng4Cu$tOmLlc9nc9!", t.MK = "", t.A1R = {}, t.A0V = !1, t.AA = "", t.KK = null, t.A09 = !1, t.R1 = ["", ""], t.LG = 0, t.L0 = [], t.A8S = 0, t.A8L = 0, t.A9Y = !1, t.A2A = "", t.A72 = !0, t.IJ = null, t.QW = [], t.OB = 0, t.AB1 = !1, t.SL = {}, t.A2C = !1, t.G3 = zingchart.DEV.DOMFRAGMENTS ? {} : null, t.A2Z = !1, t.T4 = [];
      return _this7;
    }
    _createClass(RU, [{
      key: "clearLabelBoxes",
      value: function clearLabelBoxes(e) {
        var t = this;
        if (e) for (var i = t.T4.length - 1; i >= 0; i--) t.T4[i].type === e && t.T4.splice(i, 1);else t.T4 = [];
      }
    }, {
      key: "usc",
      value: function usc() {
        return -1 !== ZC.AV(this.L0, ZC._[44]);
      }
    }, {
      key: "mc",
      value: function mc(e) {
        return e = e || "", ZC.AK(this.K + "-main-c" + ("" === e ? e : "-" + e));
      }
    }, {
      key: "hideCM",
      value: function hideCM() {
        var e;
        (e = ZC.AK(this.K + "-menu")) && (e.style.display = "none"), this.A9Y = !1;
      }
    }, {
      key: "Y2",
      value: function Y2() {
        for (var e = this, t = e.OC.length, i = 0; i < t; i++) if (null !== ZC._n_(e.OC[i])) {
          switch (e.AA) {
            case "svg":
              ZC.CQ.U0(e.OC[i].ctx, e.OC[i].style, e.OC[i].path.join(" "), e.OC[i].filled);
              break;
            case "vml":
              ZC.CQ.TZ(e.OC[i].ctx, e.OC[i].style, e.OC[i].path.join(" "), e.OC[i].filled);
          }
          e.OC[i] = null;
        }
      }
    }, {
      key: "A4T",
      value: function A4T() {
        var s = this,
          i,
          A6,
          EY,
          A6C;
        ZC.LICENSE = ZC.LICENSE || zingchart.LICENSE || "", ZC.BUILDCODE = ZC.BUILDCODE || zingchart.BUILDCODE || "", ZC.LICENSEKEY = ZC.LICENSEKEY || zingchart.LICENSEKEY || "", A6C = "file:" === document.location.protocol ? ZC.HOSTNAME || "" : document.location.hostname;
        var A21 = [A6C],
          CU = A6C.split(".");
        for ("www" === CU[0] ? A21.push(A6C.replace("www.", "")) : A21.push("www." + A6C), i = 0; i <= CU.length - 2; i++) {
          for (var ABL = "*", j = i; j < CU.length; j++) ABL += "." + CU[j];
          A21.push(ABL);
        }
        function XO(e) {
          if (ZC.NOABOUT && ZC.NOABOUT instanceof Array) {
            var t = ZC.Y5.md5(ZC.AAN(ZC.AA6(e)));
            -1 !== ZC.AV(ZC.NOABOUT, t) && (s.AC1 = !0);
          }
        }
        if (-1 !== ZC.AV(A21, "localhost") || -1 !== ZC.AV(A21, "127.0.0.1")) s.UF = !0, s.A4D = !0, XO("localhost");else {
          var A36 = [["window.AC.Core.zflags", "Q^fhx]XKoJJLnmLPUYiWUuQKAOGnuAIWrSN_ZIj_LYvS`jRkihLOSfysvRQTBtQOUUO^`SdgZUHWKDVQ[xST_SWRLyFKogwOclSB"], ["window.jsNorthNine.AppIdentity", "09Vczmfsf/Q5G8dRWLio+7PVG0KjUnLRqnRSPOeqf6gu/hpxK6BeHRUtuasojuRTPFQYdzNGN57nxLviTf1hV4lwaFjtbv/tA1g0W0k7AKV1g1ouow1nG/+EJLl0khmPDSKBJa8fkP70KLNtrxt5pE2yjx+IvQ40ajd/03rqqtR="]];
          for (i = 0, A6 = A36.length; i < A6; i++) try {
            if (eval(A36[i][0]) === ZC.AA6(A36[i][1])) {
              s.UF = !0;
              break;
            }
          } catch (e) {}
          for (i = 0, A6 = A21.length; i < A6; i++) {
            var A5K = ZC.Y5.md5(ZC.AAN(ZC.AA6(A21[i])));
            ZC.LICENSE instanceof Array && -1 !== ZC.AV(ZC.LICENSE, A5K) && (s.UF = !0, XO(A5K));
          }
          ZC.BUILDCODE instanceof Array && 2 === ZC.BUILDCODE.length && (EY = ZC.AD9(s.ABG), EY = EY.replace("O", "0"), s.SP = ZC.ACM(ZC.BUILDCODE[0], EY), s.SP === ZC.BUILDCODE[1] && (s.UF = !0, s.A4D = !0, XO(ZC.BUILDCODE[0])));
        }
      }
    }, {
      key: "A4X",
      value: function A4X() {
        var e = this;
        if (null !== e.MY) ZC._todash_(e.MY), e.load();else if (null === ZC._n_(ZC.cache.data["defaults-" + e.RD])) {
          var t = ["query-string" === e.NA ? "zcrandom=" + Math.random() : "", zingchart.ZCOUTPUT ? "zcoutput=" + e.AA : ""].join("&");
          ZC.A5.ajax({
            type: "GET",
            url: e.RD,
            dataType: "text",
            beforeSend: function beforeSend(t) {
              e.SE.defaults || "http-headers" !== e.NA || t.setRequestHeader(ZC._[45], "Thu, 01 Jan 1970 00:00:00 GMT");
            },
            data: t,
            error: function error(t, i, a, n) {
              return e.NG({
                name: ZC._[63],
                message: "Resource not found (" + n + ")"
              }, ZC._[64]), !1;
            },
            success: function success(t) {
              var i;
              try {
                i = JSON.parse(t), ZC.cache.data["defaults-" + e.RD] = t;
              } catch (a) {
                return e.NG(a, "JSON parser"), !1;
              }
              e.MY = i, ZC._todash_(e.MY), e.load();
            }
          });
        } else {
          var i;
          try {
            i = JSON.parse(ZC.cache.data["defaults-" + e.RD]);
          } catch (a) {
            return e.NG(a, "JSON parser"), !1;
          }
          e.MY = i, ZC._todash_(e.MY), e.load();
        }
      }
    }, {
      key: "load",
      value: function load(e, t) {
        var i = this;
        if (i.MK = "load", "" !== (t = t || i.RC) && 0 !== t.indexOf("javascript:")) {
          if (null === ZC._n_(ZC.cache.data["data-" + t])) {
            var a = ["query-string" === i.NA ? "zcrandom=" + Math.random() : "", zingchart.ZCOUTPUT ? "zcoutput=" + i.AA : ""].join("&");
            ZC.A5.ajax({
              type: "GET",
              url: t,
              dataType: "text",
              beforeSend: function beforeSend(e) {
                i.SE.data || "http-headers" !== i.NA || e.setRequestHeader(ZC._[45], "Thu, 01 Jan 1970 00:00:00 GMT");
              },
              data: a,
              error: function error(e, t, a, n) {
                return i.NG({
                  name: ZC._[63],
                  message: "Resource not found (" + n + ")"
                }, ZC._[64]), !1;
              },
              success: function success(t) {
                i.data_(e, t);
              }
            });
          } else i.data_(e, ZC.cache.data["data-" + t]), ZC.cache.data["data-" + t] = null;
        } else "" !== i.EW ? i.data_(e, i.EW) : null !== i.MJ && (i.A7M ? i.MJ = JSON.parse(JSON.stringify(i.A7M)) : i.A7M = JSON.parse(JSON.stringify(i.MJ)), i.data_(e, i.MJ));
      }
    }, {
      key: "data_",
      value: function data_(e, t) {
        var i = this;
        ZC.TS[i.K] = new Date().getTime(), ZC.AQ.A8I("dataload", i) ? ZC.AQ.BZ("dataload", i, i.F5(), t, function (t) {
          i.load_(e, t);
        }) : i.load_(e, t);
      }
    }, {
      key: "A1T",
      value: function A1T(e) {
        var t, i;
        if (!zingchart.DEV.RESOURCES) return [];
        e || (e = this.o);
        var a = [];
        if (e.graphset) for (t = 0, i = e.graphset.length; t < i; t++) {
          var n = e.graphset[t].type || "null";
          if (-1 === ZC.AV(ZC.CHARTS, n)) {
            for (var l in "3d" === n.substring(n.length - 2) && (n = n.substring(0, n.length - 2)), ZC.EQUIV) ZC.EQUIV.hasOwnProperty(l) && -1 !== ZC.AV(ZC.EQUIV[l], n) && (n = l);
            zingchart.loadModules(n), a.push(n);
          }
        }
        for (this.AA2(e), t = 0, i = ZC.RZ.length; t < i; t++) "" !== ZC.GY(ZC.RZ[t]) && -1 === ZC.AV(ZC.XE, ZC.GY(ZC.RZ[t])) && a.push(ZC.GY(ZC.RZ[t]));
        return a;
      }
    }, {
      key: "AA2",
      value: function AA2(e) {
        e || (e = this.o);
      }
    }, {
      key: "load_",
      value: function load_(JO, TW) {
        var s = this,
          G;
        s.E.rawsource = zingchart.DEV.KEEPSOURCE ? TW : "N/A";
        var DK = null;
        if ("string" == typeof TW) try {
          DK = JSON.parse(TW);
        } catch (JI) {
          try {
            DK = eval("(" + TW + ")");
          } catch (JI) {
            return s.NG(JI, "JSON parser"), !1;
          }
        } else DK = TW;
        null === ZC._n_(DK[ZC._[16]]) && (DK = {
          graphset: [DK]
        }), s.E.source = "N/A", zingchart.DEV.KEEPSOURCE && (s.E.source = ZC.GY(JSON.stringify(DK))), zingchart.A1S(s, s.A1T(DK), function () {
          DK = ZC.AQ.BZ("dataparse", s, s.F5(), DK), zingchart.A1S(s, s.A1T(DK), function () {
            if (ZC.AQ.BZ("modulesready", s, {
              id: s.K
            }), null === ZC._n_(JO)) s.VX(DK), s.o = DK, s.A1N ? (s.parse(), s.paint()) : s.PQ(function () {
              s.parse(), s.paint();
            });else {
              var e = s.OJ(JO);
              if (null !== e && null !== ZC._n_(G = DK[ZC._[16]])) {
                var t = G.length > 1 ? G[e.L] : G[0];
                t.id || (t.id = e.o.id || ""), s.o[ZC._[16]][e.L] = t, s.PQ(function () {
                  s.parse(JO), s.AG[e.L].paint();
                });
              }
            }
          });
        });
      }
    }, {
      key: "VX",
      value: function VX(DK) {
        var s = this,
          G,
          i,
          A6,
          j,
          JJ;
        for (null === ZC._n_(DK[ZC._[16]]) && (DK = {
          graphset: [DK]
        }), 1 === DK[ZC._[16]].length && null === ZC._n_(DK[ZC._[16]][0]) && (DK[ZC._[16]] = [{
          type: "null"
        }]), i = 0, A6 = DK[ZC._[16]].length; i < A6; i++) if (null !== ZC._n_(DK[ZC._[16]][i])) {
          if (null !== ZC._n_(G = DK[ZC._[16]][i].shapes)) {
            var FJ = [];
            for (DK[ZC._[16]][i][ZC._[10]] = DK[ZC._[16]][i][ZC._[10]] || [], j = 0, JJ = G.length; j < JJ; j++) if (G[j].generated && G[j]["map-item"] || FJ.push(G[j]), null !== ZC._n_(G[j].type) && 0 === G[j].type.indexOf("zingchart.")) try {
              var M9 = G[j].options || {},
                EA = G[j].type + "." + (M9.name || "");
              M9[ZC._[3]] = i;
              var A3V = eval(EA).call(s, M9, DK, G[j]);
              for (var A43 in A3V) A3V.hasOwnProperty(A43) && ("label" === A3V[A43].objtype ? DK[ZC._[16]][i][ZC._[10]].push(A3V[A43]) : FJ.push(A3V[A43]));
            } catch (e) {}
            DK[ZC._[16]][i].shapes = FJ;
          }
          var A79;
          if (null !== ZC._n_(A79 = DK[ZC._[16]][i].widgets)) for (var AB8 = s.A0C(DK, i), k = 0; k < A79.length; k++) {
            var A3E = A79[k];
            if (null !== ZC._n_(A3E.type) && null !== ZC._n_(zingchart.widgets[A3E.type]) && "function" == typeof zingchart.widgets[A3E.type].parse) try {
              var BI = {};
              ZC._cp_(A3E, BI), BI.graph = AB8.graph, BI.loader = {
                id: s.K,
                width: s.I,
                height: s.F
              };
              var o = zingchart.widgets[A3E.type].parse.call(s, BI);
              if (null !== ZC._n_(G = o.graphs)) for (j = 0; j < G.length; j++) DK[ZC._[16]].push({}), ZC._cp_(G[j], DK[ZC._[16]][DK[ZC._[16]].length - 1]);
              if (null !== ZC._n_(G = o[ZC._[10]])) for (null === ZC._n_(DK[ZC._[16]][i][ZC._[10]]) && (DK[ZC._[16]][i][ZC._[10]] = []), j = 0; j < G.length; j++) DK[ZC._[16]][i][ZC._[10]].push(G[j]);
              if (null !== ZC._n_(G = o.shapes)) for (null === ZC._n_(DK[ZC._[16]][i].shapes) && (DK[ZC._[16]][i].shapes = []), j = 0; j < G.length; j++) DK[ZC._[16]][i].shapes.push(G[j]);
            } catch (e) {}
          }
        }
      }
    }, {
      key: "AAZ",
      value: function AAZ(e, t) {
        var i = this;
        switch (e) {
          case "line":
            return new A6Z(i);
          case "area":
            return new A6L(i);
          case "vline":
            return new A9T(i);
          case "varea":
            return new AAB(i);
          case "bar":
          case "vbar":
          case "column":
            return new A30(i);
          case "hbar":
            return new A31(i);
          case "mixed":
          case "hmixed":
          case "mixed3d":
            for (var a = !1, n = i.o[ZC._[16]][t][ZC._[11]], l = 0, r = n.length; l < r; l++) n[l] && n[l].type && -1 !== n[l].type.indexOf("3d") && (a = !0);
            return a ? new A3F(i) : i.o[ZC._[16]][t].plot && i.o[ZC._[16]][t].type && i.o[ZC._[16]][t].plot && i.o[ZC._[16]][t].plot.type && -1 !== i.o[ZC._[16]][t].plot.type.indexOf("3d") ? new A3F(i) : "mixed" === e ? new A5X(i) : new A9D(i);
          case "scatter":
            return new A8N(i);
          case "hscatter":
            return new A80(i);
          case "bubble":
            return new A9B(i);
          case "hbubble":
            return new A8R(i);
          case "ring":
          case "pie":
            return new A4K(i);
          case "nestedpie":
            return new A7G(i);
          case "radar":
          case "polar":
            return new A9V(i);
          case "venn":
            return new AAU(i);
          case "bullet":
          case "vbullet":
            return new A8K(i);
          case "hbullet":
            return new A8P(i);
          case "funnel":
          case "vfunnel":
            return new A8W(i);
          case "hfunnel":
            return new A8T(i);
          case "heatmap":
          case "piano":
            return new AA0(i);
          case "stock":
            return new AAD(i);
          case "range":
            return new AAQ(i);
          case "vrange":
            return new ZCVRangeGraph(i);
          case "gauge":
            return new AAJ(i);
          case "line3d":
            return new A9I(i);
          case "area3d":
            return new A9G(i);
          case "ring3d":
          case "pie3d":
            return new A5I(i);
          case "bar3d":
          case "vbar3d":
            return new A9J(i);
          case "hbar3d":
            return new A9C(i);
          case "null3d":
            return new A99(i);
          default:
            return new AB0(i);
        }
      }
    }, {
      key: "OJ",
      value: function OJ(e) {
        for (var t = this, i = 0, a = t.AG.length; i < a; i++) if (t.AG[i].K === t.K + "-graph-" + e || t.AG[i].K === t.K + "-graph-id" + e || t.AG[i].K === e || i === e) return t.AG[i];
        return null;
      }
    }, {
      key: "A26",
      value: function A26(e, t) {
        var i = this,
          a = ZC.A5("#" + i.K + ("svg" === i.AA ? "-top" : "-main")),
          n = ZC._tx_(i.K);
        e -= a.offset().left, t -= a.offset().top;
        for (var l = null, r = 0, o = i.AG.length; r < o; r++) ZC.DR(e, i.AG[r].iX, i.AG[r].iX + i.AG[r].I * n[0]) && ZC.DR(t, i.AG[r].iY, i.AG[r].iY + i.AG[r].F * n[1]) && (l = i.AG[r]);
        return l;
      }
    }, {
      key: "A61",
      value: function A61(e) {
        var t,
          i = this;
        if (typeof i.E.themesloaded === ZC._[31]) {
          typeof e === ZC._[31] && (e = !1), i.assign_a([["theme", "LY"]]), i.o[ZC._[16]] && 1 === i.o[ZC._[16]].length && null !== ZC._n_(t = i.o[ZC._[16]][0].theme) && (i.LY = t), "" === i.LY && (i.LY = "light"), i.LY = String(i.LY).replace("zingchart", "classic");
          for (var a = i.LY.split(/\s+|;|,/), n = 0, l = a.length; n < l; n++) i.B8.ABD(a[n]);
          i.B8.A4X(i.MY), ZC.mobile && i.B8.ABD("mobile"), e || (i.E.themesloaded = !0);
        }
      }
    }, {
      key: "parse",
      value: function parse(e) {
        var t,
          i,
          a,
          n,
          l,
          r,
          o = this;
        o.NS = "x", o.E.json = ZC.GY(JSON.stringify(o.o)), ZC._cp_(o.o.layers, o.O4), 1 === o.o[ZC._[16]].length && ZC._cp_(o.o[ZC._[16]][0].layers, o.O4);
        var s = o.F5();
        if (null !== ZC._n_(e) && (s[ZC._[3]] = e), ZC.AQ.BZ("dataready", o, s), o.MK = "parse", o.R1[1] = o.R1[0], o.R1[0] = "", o.R1[0] += o.I + ":" + o.F + ":", null !== ZC._n_(t = o.o[ZC._[16]])) for (o.R1[0] += t.length + ":", n = 0; n < t.length; n++) o.R1[0] += (t[n].type || "") + ":", o.R1[0] += (t[n].x || "") + ":" + (t[n].y || "") + ":" + (t[n][ZC._[19]] || "") + ":" + (t[n][ZC._[20]] || "") + ":", null !== ZC._n_(t[n][ZC._[11]]) && (o.R1[0] += t[n][ZC._[11]].length + ":");
        if (ZC.AK(o.K + "-main-c") && o.clear(e, !1), typeof AAG !== ZC._[31] && (o.H3 = new AAG(o)), null === ZC._n_(e)) {
          o.A61(), o.B8.B8["font-family"] && (zingchart.FONTFAMILY = o.B8.B8["font-family"]);
          var C = !!o.o.gui;
          if (o.B8.load(o.o, "loader", !1, !0), o.assign_a([["gui", "DE"], ["globals", "RA"]]), o.o[ZC._[16]] && 1 === o.o[ZC._[16]].length && (i = o.o[ZC._[16]][0], null !== ZC._n_(t = i.gui) && (o.DE = t), null !== ZC._n_(t = i.globals) && (o.RA = t)), ZC._todash_(o.RA), ZC._cp_(o.B8.B8.root.gui, o.DE, !1, !0, !0), o.DE.behaviors) for (n = o.DE.behaviors.length - 1; n >= 0; n--) for (r = 0; r < n; r++) if (o.DE.behaviors[n].id === o.DE.behaviors[r].id) {
            o.DE.behaviors.splice(n, 1);
            break;
          }
          if (C || delete o.o.gui, ZC._todash_(o.DE), o.N = {}, null !== ZC._n_(t = o.o.style)) for (a in t) "url" !== a && (o.N[a] = t[a]);
          if (o.o[ZC._[16]] && 1 === o.o[ZC._[16]].length && (i = o.o[ZC._[16]][0], null !== ZC._n_(t = i.style))) for (a in t) "url" !== a && (o.N[a] = t[a]);
          ZC._todash_(o.N), o.O4[ZC._[16]] && _get(_getPrototypeOf(RU.prototype), "parse", this).call(this), o.assign_a([["locale", "A1Q"], ["set-locale", "A1Q"], ["layout", "NS"], ["h-space", "A8S", "i"], ["v-space", "A8L", "i"], ["flat", "KE", "b"], ["show-progress", "A0V", "b"]]), o.o[ZC._[16]] && 1 === o.o[ZC._[16]].length && (i = o.o[ZC._[16]][0], null !== ZC._n_(t = i.locale) && (o.A1Q = t), null !== ZC._n_(t = i["set-locale"]) && (o.A1Q = t), null !== ZC._n_(t = i.flat) && (o.KE = ZC._b_(t)), null !== ZC._n_(t = i["show-progress"]) && (o.A0V = ZC._b_(t))), null !== ZC._n_(t = zingchart.i18n[o.A1Q]) && (ZC.HQ = t), o.AG = [];
        }
        var A = 0,
          Z = 0,
          c = o.I,
          p = o.F;
        if (null !== ZC._n_(o.o.margin) || null !== ZC._n_(o.o[ZC._[57]]) || null !== ZC._n_(o.o[ZC._[58]]) || null !== ZC._n_(o.o[ZC._[59]]) || null !== ZC._n_(o.o[ZC._[60]])) {
          var u = new I3(o);
          u.append(o.o, !1, !1), u.parse(), A = u.DX, Z = u.E7, c = c - u.DX - u.E6, p = p - u.E7 - u.DP;
        }
        var h,
          _,
          d = o.OJ(e);
        if (null !== ZC._n_(h = o.o[ZC._[16]])) {
          var f = 0;
          for (n = 0, l = h.length; n < l; n++) _ = 0, null !== ZC._n_(t = h[n].page) && (_ = ZC._i_(t)), f += o.LG === _ ? 1 : 0;
          var g = ZC.AR.A2Y(o.NS, f),
            B = ZC._i_(g[0]),
            v = ZC._i_(g[1]),
            m = 0,
            b = 0,
            E = 0;
          for (n = 0, l = h.length; n < l; n++) {
            if (_ = 0, null === d && null !== ZC._n_(t = h[n].page) && (_ = ZC._i_(t)), (null === d || E === d.L) && o.LG === _) {
              if (o.AG[E] = o.AAZ(h[n].type || "null", n), o.AG[E].OP = o.AG[E].AF + "graph", o.B8.load(o.AG[E].o, "graph"), o.B8.load(o.AG[E].o, h[n].type || "null"), o.AG[E].append(o.o.graph), o.AG[E].append(h[n]), o.AG[E].L = E, null === ZC._n_(h[E].id) || "" === h[E].id ? o.AG[E].K = o.K + "-graph-id" + E : o.AG[E].K = o.K + "-graph-" + h[n].id, h.length > 0) {
                for (var K = 0, D = 0, F = ZC._i_((c - (v + 1) * o.A8S) / v), I = ZC._i_((p - (B + 1) * o.A8L) / B), x = ["x", "y", ZC._[19], ZC._[20]], y = 0; y < x.length; y++) null !== ZC._n_(o.E["graph-" + E + "-" + x[y]]) && (delete o.E["graph-" + E + "-" + x[y]], delete o.AG[E].o[x[y]]);
                null === ZC._n_(o.AG[E].o.x) ? o.E["graph-" + E + "-x"] = o.AG[E].o.x = ZC._i_(o.iX + (m + 1) * o.A8S + m * F) + A : (K = ZC.IU(o.AG[E].o.x)) < 1 && (K = ZC._i_(o.I * K)), null === ZC._n_(o.AG[E].o.y) ? o.E["graph-" + E + "-y"] = o.AG[E].o.y = ZC._i_(o.iY + (b + 1) * o.A8L + b * I) + Z : (D = ZC.IU(o.AG[E].o.y)) < 1 && (D = ZC._i_(o.F * D)), null === ZC._n_(o.AG[E].o[ZC._[19]]) && (o.E["graph-" + E + "-width"] = o.AG[E].o[ZC._[19]] = Math.max(F, F - K)), null === ZC._n_(o.AG[E].o[ZC._[20]]) && (o.E["graph-" + E + "-height"] = o.AG[E].o[ZC._[20]] = Math.max(I, I - D));
              }
              o.AG[E].parse();
            }
            o.LG === _ && (E++, ++m === v && (b++, m = 0));
          }
        }
        null === ZC._n_(e) && null !== ZC._n_(t = o.o.refresh) && (o.I0 = {
          type: "full",
          interval: 10
        }, ZC._cp_(t, o.I0));
      }
    }, {
      key: "A0S",
      value: function A0S(e, t) {
        t = t || "";
        var i = [];
        for (var a in e) if ("object" == typeof e[a]) for (var n = this.A0S(e[a], t + "." + a), l = 0, r = n.length; l < r; l++) -1 === ZC.AV(i, n[l]) && i.push(n[l]);else {
          var o = t + "." + a;
          "background-image" !== a && "backgroundImage" !== a || "" === e[a] || "zc." === e[a].substring(0, 3) || (!ZC.ie67 && ZC.PATTERNS && "PATTERN_" === e[a].substring(0, 8) && (e[a] = ZC.PATTERNS[e[a].substring(8)]), "!" === e[a].charAt(0) && (e[a] = e[a].substring(1), this.E["safe-images"] = this.E["safe-images"] || [], this.E["safe-images"].push(e[a])), i.push([e[a], "image"])), "src" === a && "" !== e[a] && "zc." !== e[a].substring(0, 3) && -1 !== o.indexOf(".images.") && (!ZC.ie67 && ZC.PATTERNS && "PATTERN_" === e[a].substring(0, 8) && (e[a] = ZC.PATTERNS[e[a].substring(8)]), "!" === e[a].charAt(0) && (e[a] = e[a].substring(1), this.E["safe-images"] = this.E["safe-images"] || [], this.E["safe-images"].push(e[a])), i.push([e[a], "image"])), ".csv" === o.substr(o.length - 4, 4) && "string" == typeof e[a] && i.push([e[a], "csv"]), "url" === a && (-1 !== o.indexOf(".style.") && i.push([e[a], "css"]), -1 !== o.indexOf(".csv.") && i.push([e[a], "csv"]), -1 !== o.indexOf(".marker.") && i.push([e[a], "image"])), "string" == typeof e[a] && "url" !== a && (0 === e[a].indexOf("url:") && a === ZC._[5] || 0 === e[a].indexOf("javascript:")) && -1 === ZC.AV(["format", "text", "tooltipText"], ZC.EE(a)) && i.push([e[a], "data"]);
        }
        return i;
      }
    }, {
      key: "PQ",
      value: function PQ(JF) {
        var s = this;
        if (zingchart.DEV.RESOURCES) {
          var JA = s.A0S(s.o).concat(s.A0S(s.MY));
          if (0 !== JA.length) {
            var VB = 0,
              LS = {},
              A2B = 0;
            s.E["safe-images"] = s.E["safe-images"] || [];
            var C4 = window.setInterval(function () {
              if (VB >= JA.length) {
                for (var e in window.clearInterval(C4), s.AAO(s.o), LS) if (0 !== e.indexOf("data:") && -1 === ZC.AV(s.E["safe-images"], e)) try {
                  var t = document.createElement("canvas");
                  t.width = LS[e].width, t.height = LS[e].height, t.getContext("2d").drawImage(LS[e], 0, 0);
                  var i = t.toDataURL("image/png");
                  LS[e].onload = null, LS[e].onerror = null, LS[e].src = i, ZC.cache.data[e] = LS[e];
                } catch (a) {}
                window.setTimeout(function () {
                  zingchart.YI[s.K] && JF();
                }, 1);
              } else A38(++A2B);
            }, 20);
            A38(A2B);
          } else zingchart.YI[s.K] && JF();
        } else zingchart.YI[s.K] && JF();
        function A38(i) {
          if (!(i >= JA.length)) {
            var EW,
              MQ,
              KL = JA[i][0],
              A0Y = JA[i][1];
            if ("url:" === KL.substring(0, 4)) {
              var RC = KL.substring(4);
              s.R7["url:" + RC] = "[]";
              try {
                EW = ["query-string" === s.NA ? "zcrandom=" + Math.random() : ""].join("&"), ZC.A5.ajax({
                  type: "GET",
                  url: RC,
                  beforeSend: function beforeSend(e) {
                    s.SE.data || "http-headers" !== s.NA || e.setRequestHeader(ZC._[45], "Thu, 01 Jan 1970 00:00:00 GMT");
                  },
                  data: EW,
                  error: function error(e, t, i, a) {
                    return s.NG({
                      name: ZC._[63],
                      message: "Resource not found (" + a + ")"
                    }, ZC._[64]), !1;
                  },
                  success: function success(e, t, i, a) {
                    s.R7["url:" + a] = e, VB++;
                  }
                });
              } catch (JI) {
                return s.NG(JI, ZC._[64]), !1;
              }
            } else if ("javascript:" === KL.substring(0, 11)) {
              if ("zc.ext.load" === s.R7[KL]) {
                s.R7[KL] = "[]";
                var DU = ZC.AQ.AAT(KL.substring(11)),
                  O = {
                    id: s.K,
                    resource: KL,
                    callback: function callback(e) {
                      s.R7[KL] = e, VB++;
                    }
                  },
                  A0O = DU[0];
                O.arguments = DU[1];
                try {
                  var A3S = eval(A0O).call(s, O);
                  null !== ZC._n_(A3S) && A3S && (s.R7[KL] = A3S, VB++);
                } catch (JI) {
                  return s.NG(JI, "JavaScript data loader"), !1;
                }
              } else VB++;
            } else "image" === A0Y ? (LS[KL] = new Image(), LS[KL].crossOrigin = "anonymous", LS[KL].onload = function () {
              VB++;
            }, LS[KL].onerror = function () {
              var e = ZC._b_(s.o.strict);
              if (ZC.IMG404.push(KL), e) return s.NG({
                name: ZC._[63],
                message: "Resource not found (" + this.src + ")"
              }, "Resource loader (image)"), !1;
              this.src = ZC.BLANK, VB++;
            }, LS[KL].src = KL, ZC.cache.data[KL] = LS[KL]) : "css" === A0Y ? (EW = ["query-string" === s.NA ? "zcrandom=" + Math.random() : ""].join("&"), ZC.A5.ajax({
              type: "GET",
              url: KL,
              beforeSend: function beforeSend(e) {
                s.SE.css || "http-headers" !== s.NA || e.setRequestHeader(ZC._[45], "Thu, 01 Jan 1970 00:00:00 GMT");
              },
              data: EW,
              error: function error(e, t, i) {
                return s.NG(i, "Resource loader"), !1;
              },
              success: function success(e) {
                for (var t = {}, i = e.match(/[a-zA-Z0-9\.\#\-](.+?)\{((.|\s)+?)\}/gi), a = 0, n = i.length; a < n; a++) {
                  MQ = i[a].split("{");
                  var l = ZC.GY(MQ[0]),
                    r = l.split(/\s+/);
                  if (1 === r.length || 2 === r.length && ZC.GY(r[0]) === "#" + s.K) {
                    t[l = ZC.GY(1 === r.length ? r[0] : r[1])] || (t[l] = {});
                    for (var o = 0, C = (MQ = MQ[1].replace("}", "").split(";")).length; o < C; o++) {
                      var A = MQ[o].split(":");
                      2 === A.length && (t[l][ZC.GY(A[0])] = "" + ZC.GY(A[1]));
                    }
                  }
                }
                null !== ZC._n_(s.o.style) ? ZC._cp_(t, s.o.style) : null !== ZC._n_(s.o[ZC._[16]]) && 1 === s.o[ZC._[16]].length && s.o[ZC._[16]][0].style && ZC._cp_(t, s.o[ZC._[16]][0].style), VB++;
              }
            })) : "csv" === A0Y && (EW = ["query-string" === s.NA ? "zcrandom=" + Math.random() : ""].join("&"), ZC.A5.ajax({
              type: "GET",
              url: KL,
              beforeSend: function beforeSend(e) {
                s.SE.csv || "http-headers" !== s.NA || e.setRequestHeader(ZC._[45], "Thu, 01 Jan 1970 00:00:00 GMT");
              },
              data: EW,
              error: function error(e, t, i) {
                return s.NG(i, "Resource loader"), !1;
              },
              success: function success(e, t, i, a) {
                s.AAP[a] = e, VB++;
              }
            }));
          }
        }
      }
    }, {
      key: "AAO",
      value: function AAO(C0) {
        var s = this;
        for (var p in C0) if ("object" == typeof C0[p]) s.AAO(C0[p]);else for (var EW in s.R7) EW === C0[p] && (C0[p] = eval(s.R7[EW]));
      }
    }, {
      key: "resize",
      value: function resize(e) {
        var t,
          i,
          a,
          n,
          l = this;
        if (l.E.resize = !0, l.E.wh = l.I + "/" + l.F, l.o[ZC._[16]]) if (l.A2C) zingchart.exec(l.K, "destroy"), zingchart.render(zingchart.params[l.K]);else {
          for (typeof e === ZC._[31] && (e = !1), i = 0; i < l.AG.length; i++) null !== ZC._n_(l.H3) && l.H3.IY && l.H3.UD(null), null !== ZC._n_(l.AG[i].HZ) && l.AG[i].HZ.IY && l.AG[i].HZ.ME(null), null !== ZC._n_(l.AG[i].HY) && l.AG[i].HY.IY && l.AG[i].HY.ME(null), null !== ZC._n_(l.AG[i].B9) && l.AG[i].B9.A40 && l.AG[i].B9.U1();
          if (ZC.AQ.BZ("resize", l, l.F5()), e = !1) ;else {
            for (i = 0; i < l.AG.length; i++) for (n = 0; n < l.AG[i].AY.A4.length; n++) l.E["g-" + i + "-p-" + n + ".visible"] = l.AG[i].E["plot" + n + ".visible"];
            for (i = 0; i < l.AG.length; i++) l.E["g-" + l.AG[i].L + "-selection"] = JSON.stringify(l.AG[i].C9);
            for (var r = l.o[ZC._[16]], o = [ZC._[10], "shapes"], s = 0, C = r.length; s < C; s++) for (var A = 0; A < o.length; A++) {
              var Z = o[A],
                c = [];
              if (null !== ZC._n_(r[s][Z])) {
                for (i = 0, a = r[s][Z].length; i < a; i++) r[s][Z][i].generated || c.push(r[s][Z][i]);
                r[s][Z] = c;
              }
            }
            if (l.VX(l.o), l.o = ZC.AQ.BZ("dataparse", l, l.F5(), l.o), ZC.A5("#" + l.K + "-top").width(l.I).height(l.F), l.E["from-api"] && (ZC.A5("#" + l.K + "-wrapper").width(l.I).height(l.F), delete l.E["from-api"]), 1 === (t = ZC.A5("#" + l.K + "-img")).length && t.width(l.I).height(l.F).css("clip", "rect(1px," + (l.I - 1) + "px," + (l.F - 1) + "px,1px)"), "svg" === l.AA && (l.KK.setAttribute(ZC._[19], l.I), l.KK.setAttribute(ZC._[20], l.F)), "canvas" === l.AA || "vml" === l.AA) {
              for (ZC.A5("#" + l.K + "-main").width(l.I).height(l.F), i = 0, a = l.AG.length; i < a; i++) ZC.A5("#" + l.AG[i].K + "-hover").remove();
              ZC.A5("#" + l.K + "-main>div").width(l.I).height(l.F);
            }
            for ("canvas" === l.AA && ((t = ZC.AK(l.K + "-main-c")) && (t.width = l.I, t.height = l.F), (t = ZC.AK(l.K + "-main-c-top")) && (t.width = l.I, t.height = l.F), ZC.A5("#" + l.K + "-objects-bottom canvas, #" + l.K + "-objects-top canvas, #" + l.K + "-tools canvas").each(function () {
              this.width = l.I, this.height = l.F;
            })), "vml" === l.AA && ZC.A5("#" + l.K + "-objects-bottom div, #" + l.K + "-objects-top div, #" + l.K + "-tools div").each(function () {
              this.style.width = l.I + "px", this.style.height = l.F + "px";
            }), l.parse(), i = 0, a = l.AG.length; i < a; i++) l.AG[i].UU && l.AG[i].UU(), l.AG[i].HO = !0, l.AG[i].A6O = l.AG[i].GI, l.AG[i].GI = !1;
            for (l.paint(), i = 0; i < l.AG.length; i++) for (n = 0; n < l.AG[i].AY.A4.length; n++) delete l.E["g-" + i + "-p-" + n + ".visible"];
            for (i = 0; i < l.AG.length; i++) l.AG[i].HO = !1, l.AG[i].GI = l.AG[i].A6O, delete l.AG[i].A6O, delete l.E["g-" + l.AG[i].L + "-selection"];
          }
        }
      }
    }, {
      key: "clearGenerated",
      value: function clearGenerated() {
        var e = this.o[ZC._[16]],
          t = [ZC._[10], "shapes"];
        if (e) for (var i = 0, a = e.length; i < a; i++) for (var n = 0; n < t.length; n++) {
          var l = t[n],
            r = [];
          if (null !== ZC._n_(e[i][l])) {
            for (var o = 0, s = e[i][l].length; o < s; o++) e[i][l][o].generated || r.push(e[i][l][o]);
            e[i][l] = r;
          }
        }
      }
    }, {
      key: "clear",
      value: function clear(e, t, i) {
        var a = this;
        for (var n in a.E) -1 !== n.indexOf("-label-") && -1 !== n.indexOf("-bounds") && delete a.E[n];
        if (typeof t === ZC._[31] && (t = !0), ZC.A5("." + a.K + "-history-area").die("click", a.A1B), ZC.A5("." + a.K + "-history-area").remove(), null !== ZC._n_(e)) a.OJ(e).clear();else {
          t && a.clearGenerated(), a._unbind_();
          for (var l = 0, r = a.AG.length; l < r; l++) "vml" === a.AA && i ? a.AG[l].destroy() : a.AG[l].clear();
          var o, s, C;
          null !== (o = ZC.AK(a.K + "-main-c")) && ZC.Q.IT(o, a.AA, a.iX, a.iY, a.I, a.F), null !== (C = ZC.AK(a.K + "-main-c-top")) && ZC.Q.IT(C, a.AA, a.iX, a.iY, a.I, a.F), null !== (s = ZC.AK(a.K + "-trigger-c")) && (ZC.Q.IT(s, a.AA, a.iX, a.iY, a.I, a.F), ZC.A5("#" + a.K + "-menu-area").remove()), a.A7 && a.A7.hide(), ZC.A5("." + a.K + "-menu-item").remove(), ZC.Q.EU([a.K + "-menu-trigger", a.K + "-menu"]), ZC.Q.EU(a.K + "-license-text"), null !== a.IJ && ZC.Q.EU([a.K + "-history-path", a.K + "-history-back-path", a.K + "-history-forw-path", a.K + "-history-gradient", a.K + "-history-back-gradient", a.K + "-history-forw-gradient"]);
        }
      }
    }, {
      key: "A7N",
      value: function A7N() {
        var e,
          t,
          i,
          a = this,
          n = a.I + "/" + a.F,
          l = ZC.Q.I7({
            id: a.K + "-wrapper",
            position: "relative",
            p: ZC.AK(a.K)
          });
        ZC.Q.PV(l, {
          height: "100%" === a.N3 ? a.N3 : a.F + "px",
          width: "100%" === a.G1 ? a.G1 : a.I + "px"
        }), a.bA11y && ZC.Q.G4(l, {
          tabindex: 0,
          "aria-label": "ZingChart " + a.PC
        });
        var r = ZC.Q.I7({
          cls: "zc-rel zc-top",
          wh: n,
          id: a.K + "-top",
          overflow: "hidden",
          position: "absolute",
          p: l
        });
        switch (zingchart.OFFSET && (r.style.left = "-0.5px", r.style.top = "-0.5px"), a.AA) {
          case "svg":
            a.KK = ZC.Q.F7("svg", ZC._[36]), a.KK.setAttributeNS && a.KK.setAttributeNS(null, "xlink", ZC._[37]), ZC.Q.G4(a.KK, {
              version: "1.1",
              id: a.K + "-svg",
              "class": "zc-svg",
              width: a.I,
              height: a.F,
              display: "block"
            }), r.appendChild(a.KK);
            var o = ZC.Q.F7("defs", ZC._[36]);
            if (o.id = a.K + "-defs", a.KK.appendChild(o), ZC.Q.K5({
              cls: "zc-rel zc-main",
              wh: n,
              id: a.K + "-main",
              p: a.KK
            }, a.AA), a.A2R = [], a.o[ZC._[16]]) for (e = 0, t = a.o[ZC._[16]].length; e < t; e++) if ((i = a.o[ZC._[16]][e].resources) && i.length) for (var s = 0; s < i.length; s++) if ("css" === i[s].type && i[s].url) {
              var C = ZC.Q.F7("link", ZC._[36]);
              ZC.Q.G4(C, {
                xmlns: "http://www.w3.org/1999/xhtml",
                href: i[s].url,
                rel: "stylesheet",
                type: "text/css"
              }), a.A2R.push(i[s].url), o.appendChild(C);
            }
            break;
          case "vml":
          case "canvas":
            ZC.Q.I7({
              cls: "zc-rel zc-main",
              wh: n,
              id: a.K + "-main",
              p: r
            });
        }
      }
    }, {
      key: "paintHistory",
      value: function paintHistory() {}
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        e.MK = "paint";
        var t = e.I + "/" + e.F;
        if (e.YB(), null === ZC.AK(e.K + "-top")) {
          e.A7N();
          var i = ZC.AK(e.K + "-main");
          if (e.O4[ZC._[16]] && ZC.Q.HJ({
            cls: "zc-abs",
            id: e.K + "-main-c",
            wh: t,
            p: i
          }, e.AA), e.H.usc()) ZC.Q.HJ({
            cls: "zc-abs",
            id: e.K + "-main-c-top",
            wh: t,
            p: i
          }, e.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: e.K + ZC._[15],
            p: i,
            wh: t,
            display: "none"
          }, e.AA);else {
            ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-objects-bottom",
              p: i
            }, e.AA), zingchart.DEV.MAPSONBOTTOM && ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-objects-maps",
              p: i
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-graphset",
              p: i
            }, e.AA), zingchart.DEV.MAPSONBOTTOM || ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-objects-maps",
              p: i
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-objects-top",
              p: i
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-hover",
              p: i
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-objects-front",
              p: i
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs zc-text",
              wh: t,
              id: e.K + "-text",
              p: i
            }, e.AA);
            var a = "legend",
              n = "tools";
            ("legend" === e.o["top-layer"] || e.o[ZC._[16]] && 1 === e.o[ZC._[16]].length && "legend" === e.o[ZC._[16]][0]["top-layer"]) && (a = "tools", n = "legend"), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-" + a,
              p: i
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-" + n,
              p: i
            }, e.AA);
            var l = ZC.AK(e.K + "-tools");
            e.O4["static"] && ZC.Q.HJ({
              cls: ZC._[24],
              id: e.K + "-static-c",
              wh: t,
              p: l
            }, e.AA), e.O4.guide && ZC.Q.HJ({
              cls: ZC._[24] + " zc-guide-c",
              id: e.K + "-guide-c",
              wh: t,
              p: l
            }, e.AA), (ZC.A5.browser.opera && ZC._i_(ZC.A5.browser.version) <= 9.5 || ZC.mobile || "classic" !== e.LY) && ZC.Q.HJ({
              cls: ZC._[24],
              id: e.K + "-trigger-c",
              wh: t,
              p: l
            }, e.AA), ZC.Q.HJ({
              cls: ZC._[24],
              id: e.K + ZC._[15],
              p: l,
              wh: t,
              display: "none"
            }, e.AA), ZC.Q.HJ({
              cls: ZC._[24],
              id: e.K + "-textprint-c",
              p: l,
              wh: t,
              display: "none"
            }, e.AA), ZC.Q.K5({
              cls: "zc-abs",
              wh: t,
              id: e.K + "-text-top",
              p: i
            }, e.AA);
          }
          if (!zingchart.DEV.SKIPTRACKERS) {
            var r = document.createElement("img");
            if (r.id = e.K + "-img", r.className = "zc-img", r.setAttribute("useMap", "#" + e.K + "-map"), r.setAttribute("alt", "ZingChart " + e.PC), ZC.Q.PV(r, {
              position: "absolute",
              borderWidth: 0,
              width: e.I + 2 * ZC.MAPTX + "px",
              height: e.F + 2 * ZC.MAPTX + "px",
              left: -ZC.MAPTX + "px",
              top: -ZC.MAPTX + "px",
              zIndex: 0,
              opacity: 0,
              filter: "alpha(opacity=0)",
              clip: "rect(" + (ZC.MAPTX + 1) + "px," + (e.I + ZC.MAPTX - 1) + "px," + (e.F + ZC.MAPTX - 1) + "px," + (ZC.MAPTX + 1) + "px)"
            }), r.src = (ZC.ie67 ? "//" : "") + ZC.BLANK, ZC.AK(e.K + "-top").appendChild(r), !e.H.usc()) {
              var o = document.createElement("map");
              o.className = "zc-map", ZC.Q.G4(o, {
                id: e.K + "-map",
                name: e.K + "-map"
              }), ZC.AK(e.K + "-top").appendChild(o);
              for (var s = 0; s < e.AG.length; s++) o.innerHTML += '<area shape="rect" coords="0,0,1,1" id="mark' + s + '">';
            }
          }
        }
        e.Z = ZC.AK(e.K + "-main-c"), _get(_getPrototypeOf(RU.prototype), "paint", this).call(this);
        var C,
          A,
          Z = !1,
          c = !1;
        for (C = 0, A = e.AG.length; C < A; C++) {
          e.AG[C].paint(), (null !== e.AG[C].CW && e.AG[C].CW.AN || null !== e.AG[C].HD && e.AG[C].HD.AN) && (Z = !0);
          for (var p = 0; p < e.AG[C].BO.length; p++) if (e.AG[C].BO[p].GQ) {
            c = !0;
            break;
          }
        }
        if (e.G3) {
          for (var u in e.G3) ZC.AK(u).appendChild(e.G3[u]);
          e.G3 = null;
        }
        if (e.E[ZC._[53]] = null, e.UF || e.UV || (e.ZA ? e.A4P() : e.ZA = window.setInterval(function () {
          e.A4T(), e.UF || e.UV ? (window.clearInterval(e.ZA), ZC.Q.EU(e.K + "-license-text")) : ZC.AK(e.K + "-license-text") || e.A4P();
        }, 2e3)), ZC.A5("." + e.K + "-node-area").live("focus", function (e) {
          var t = e.target.id.split("-");
          "plot" === t[4] && "node" === t[6] && zingchart.exec(t[0], "showtooltip", {
            graphid: t[2],
            plotindex: t[5],
            nodeindex: t[7]
          });
        }), -1 === ZC.AV(e.L0, ZC._[38]) && e.A16(), -1 === ZC.AV(e.L0, ZC._[41]) ? (typeof A94 !== ZC._[31] && (e.A7 = new A94(e)), c && e.H3.bind(), Z && typeof KB !== ZC._[31] && (e.D6 = new KB(e), e.D6.bind()), ZC.mobile && (e.AEZ = function (t) {
          ZC.swipe = {
            xy: ZC.Q.MM(t),
            ts: new Date().getTime()
          }, t.target.id === e.K + "-menu-area" ? (ZC.move = !1, e.A7 && e.A7.hide(), zingchart.Z8(t)) : (null === e.DE || null === ZC._n_(e.DE["page-scroll"]) || e.DE["page-scroll"] || t.preventDefault(), ZC.move = !1, e.hideCM(), e.A7 && e.A7.hide(), e.W8(t));
        }, e.P7 = function () {
          window.clearTimeout(e.ABC), e.A4G = null;
        }, e.AEO = function (t) {
          if (ZC.swipe) {
            var i = ZC.Q.MM(t);
            if (ZC._a_(i[0] - ZC.swipe.xy[0]) > 100 && new Date().getTime() - ZC.swipe.ts < 1e3) {
              var a = e.F5();
              a.direction = i[0] > ZC.swipe.xy[0] ? "right" : "left", ZC.AQ.BZ("swipe", e, a);
            }
            ZC.swipe = null;
          }
          e.A9Y || ZC.move || zingchart.SN(t), e.P7(t);
        }, ZC.A5("#" + e.K + "-img").bind("touchstart", e.AEZ).bind("touchmove", e.P7).bind("touchend", e.AEO), ZC.A5("#" + e.K + "-menu-area").live("touchstart", e.AEZ)), e.zc_loader_mousewheel = function (t) {
          var i = e.F5();
          i.ev = t, ZC.AQ.BZ("mousewheel", e, i);
        }, ZC.A5("#" + e.K + "-img").bind("mousewheel", e.zc_loader_mousewheel), ZC.A5("#" + e.K + "-map").bind("mousewheel", e.zc_loader_mousewheel), "svg" === e.AA && ZC.A5("#" + e.K + "-svg").bind("mousewheel", e.zc_loader_mousewheel), e.A2N = function (t) {
          27 === t.keyCode && e.RB && (e.A8O || e.A9P());
        }, ZC.A5(document).bind("keyup", e.A2N), e.A9P = function () {
          ZC.A5("#" + e.K + ZC._[66]).die("click", e.A9P), ZC.FSSTATUS = null, ZC.Q.EU(e.K + "-data-table"), e.destroy(), zingchart.FSID && ZC.AK(zingchart.FSID) && (ZC.AK(zingchart.FSID).style.display = "none");
        }, ZC.A5("#" + e.K + ZC._[66]).live("click", e.A9P)) : ZC.mobile && (e.zc_loader_touchstart_static = function (e) {
          return e.preventDefault(), zingchart.SN(e), !1;
        }, ZC.A5("#" + e.K + "-img").bind("touchstart", e.zc_loader_touchstart_static)), null !== e.I0) {
          var h = ZC._i_(e.I0.interval);
          h = h >= 50 ? h : 1e3 * h, window.setTimeout(function () {
            e.MU(), e.load();
          }, h);
        }
        e.MK = "", ZC.TS[e.K] = new Date().getTime() - ZC.TS[e.K], e.E["fire-complete"] && (ZC.AQ.BZ("complete", e, e.F5()), e.E["fire-complete"] = null), e.E["fire-load"] && (ZC.AQ.BZ("load", e, e.F5()), e.E["fire-load"] = null);
      }
    }, {
      key: "togglePreviewMasks",
      value: function togglePreviewMasks(e) {
        for (var t = this, i = 0; i < t.AG.length; i++) t.AG[i].B9 && t.AG[i].B9.toggleMasks(e);
      }
    }, {
      key: "createPreviewMasks",
      value: function createPreviewMasks() {
        var e = this,
          t = document.createElement("canvas");
        t.width = e.I, t.height = e.F, t.setAttribute("class", "");
        for (var i = 0; i < e.AG.length; i++) e.AG[i].B9 && e.AG[i].B9.toggleMasks(!0, t);
        return t;
      }
    }, {
      key: "AD1",
      value: function AD1() {
        null === ZC._n_(ZC.showZCAbout) && (ZC.showZCAbout = function (e) {
          zingchart.exec(e.id, "toggleabout");
        }), zingchart.exec(this.K, "addmenuitem", {
          text: "About ZingChart",
          "function": "ZC.showZCAbout()",
          order: 100
        });
      }
    }, {
      key: "A4P",
      value: function A4P() {
        var e,
          t = this,
          i = {},
          a = t.DE.watermark;
        t.B8.load(i, "loader.gui.watermark"), a && ZC._cp_(a, i), 1 === t.o[ZC._[16]].length && t.o[ZC._[16]][0].gui && (e = t.o[ZC._[16]][0].gui.watermark) && ZC._cp_(e, i);
        var n = ZC._l_(ZC._i_(i.type || 1), 1, 2),
          l = i.position || "br";
        -1 === ZC.AV(["tl", "tr", "br", "bl"], l) && (l = "br"), t.ACX = l;
        var r,
          o = 32,
          s = 146,
          C = 0,
          A = 1;
        ZC.ie67 && (o = 30, s = 168, C = 8, A = 1), s = 126, o = 22;
        var Z = {
            light: ["#6D6E71", "#00384A"],
            dark: ["#FFFFFF", "#09A9DA"]
          },
          c = Z.light;
        if (zingchart.THEME && (c = "light" === t.LY || "classic" === t.LY ? Z.light : Z.dark), 1 === t.o[ZC._[16]].length) if (t.o[ZC._[16]][0][ZC._[0]]) {
          var p = ZC.AQ.GE(t.o[ZC._[16]][0][ZC._[0]]);
          7 === p.length && (c = ZC.AQ.AA8(p, Z.dark, Z.light));
        } else if (t.o[ZC._[16]][0].theme) {
          var u = t.o[ZC._[16]][0].theme;
          c = "light" === u || "classic" === u ? Z.light : Z.dark;
        }
        var h,
          _,
          d = typeof window !== ZC._[31] && window.location ? window.location.origin : "",
          f = typeof window !== ZC._[31] && window.location ? window.location.pathname : "";
        switch (r = '<a title="JavaScript Charts by ZingChart" style="color:' + c[0] + ' !important;font-size:11px !important;display:block !important;opacity:1 !important; text-decoration:none;" href="http://www.zingchart.com/?origin=' + d + "&pathname=" + f + '">Powered by <span style="color:' + c[1] + '; font-weight:bold;">ZingChart</span></a>', l) {
          case "br":
            h = t.F - o, _ = t.I - s;
            break;
          case "bl":
            h = t.F - o, _ = 6;
            break;
          case "tr":
            h = 2, _ = t.I - s;
            break;
          case "tl":
            h = 2, _ = 6;
        }
        null !== ZC._n_(e = ZC.AK(t.K + "-top")) && ZC.Q.I7({
          cls: ZC.ie67 ? "-ie67" : "",
          p: e,
          id: t.K + "-license-text",
          tl: h + "/" + _,
          wh: s + "/" + (o - C),
          color: ZC.ie67 ? 1 === n ? "#369" : "#fff" : "",
          padding: C,
          opacity: A,
          position: "absolute",
          cursor: "pointer",
          fontFamily: zingchart.FONTFAMILY,
          html: r
        });
      }
    }, {
      key: "_unbind_",
      value: function _unbind_() {
        var e = this;
        ZC.A5("#" + e.K + "-menu").die(ZC._[47], e.UG), ZC.A5("." + e.K + "-menu-item").die(ZC._[47], e.UG), ZC.A5("." + e.K + "-menu-item").die("click touchend", e.AGC).die("mouseover", e.AG5).die("mouseout", e.AG8), e.E["menu-item-events"] = !1, ZC.A5("." + e.K + "-node-area").die("focus"), null !== e.H3 && e.H3.unbind(), null !== e.D6 && e.D6.unbind(), ZC.mobile && (ZC.A5("#" + e.K + "-img").unbind("touchstart", e.AEZ).unbind("touchmove", e.P7).unbind("touchend", e.AEO), ZC.A5("#" + e.K + "-menu-area").die("touchstart", e.AEZ), ZC.A5("#" + e.K + "-img").unbind("touchstart", e.zc_loader_touchstart_static)), ZC.A5("#" + e.K + "-img").unbind("mousewheel", e.zc_loader_mousewheel), ZC.A5("#" + e.K + "-map").unbind("mousewheel", e.zc_loader_mousewheel), "svg" === e.AA && ZC.A5("#" + e.K + "-svg").unbind("mousewheel", e.zc_loader_mousewheel), ZC.A5(document).unbind("keyup", e.A2N), ZC.A5("#" + e.K + ZC._[66]).die("click", e.A9P);
      }
    }, {
      key: "U2",
      value: function U2(e, t, i) {
        typeof i === ZC._[31] && (i = !1);
        var a = ZC.AK("zc-menu-" + (i ? "sep" : "item") + "-" + e);
        a && (a.style.display = t ? "block" : "none");
      }
    }, {
      key: "A16",
      value: function A16(LR, ev) {
        if (!zingchart.DEV.SKIPCONTEXTMENU) {
          var s = this,
            G,
            i,
            A6,
            j,
            JJ;
          typeof LR === ZC._[31] && (LR = -1);
          var DE = {};
          ZC._cp_(s.DE, DE), -1 !== LR && s.o[ZC._[16]][LR] && ZC._cp_(s.o[ZC._[16]][LR].gui, DE, null, null, !0), ZC.A5("#" + s.K + "-menu").remove();
          var PR = [];
          for (typeof ZC.AP === ZC._[31] && PR.push({
            id: "3D",
            enabled: "none"
          }, {
            id: "SwitchTo3D",
            enabled: "none"
          }, {
            id: "SwitchTo2D",
            enabled: "none"
          }), i = DE.behaviors.length - 1; i > 0; i--) for (var sBId = DE.behaviors[i].id, ii = i - 1; ii >= 0; ii--) DE.behaviors[ii].id === sBId && DE.behaviors.splice(ii, 1);
          if (null !== ZC._n_(G = DE.behaviors)) for (i = 0, A6 = G.length; i < A6; i++) {
            var NH = !1;
            for (j = 0, JJ = PR.length; j < JJ; j++) PR[j].id === G[i].id && (NH = !0);
            NH || PR.push(G[i]);
          }
          var JN = DE["context-menu"],
            OU = DE["context-menu[mobile]"];
          for (i = 0, A6 = PR.length; i < A6; i++) null !== ZC._n_(PR[i]["function"]) && (null === ZC._n_(JN) && (JN = {}), null === ZC._n_(JN["custom-items"]) && (JN["custom-items"] = []), JN["custom-items"].push(PR[i]));
          JN["custom-items"] && JN["custom-items"].sort(function (e, t) {
            return ZC._i_(e.order || "0") > ZC._i_(t.order || "0");
          }), s.N8 = new DT(s);
          var A1M = s.LY.split(/\s+|;|,/),
            DZ,
            LO,
            UR,
            ABR,
            GW;
          for (i = 0, A6 = A1M.length; i < A6; i++) if (s.B8.O9[A1M[i]]) {
            var A1L = s.B8.O9[A1M[i]].root || {};
            A1L && A1L.gui && A1L.gui.contextMenu && ZC._cp_(A1L.gui.contextMenu, s.N8.o);
          }
          if (s.B8.load(s.N8.o, ZC._[65]), JN && s.N8.append(JN), ZC.mobile && (s.B8.load(s.N8.o, ZC._[65] + "[mobile]"), OU && s.N8.append(OU)), s.N8.VL = !0, s.N8.parse(), s.N8.AN || !s.A4D) {
            if (!ZC.AK(s.K + "-menu-area")) {
              var A5R = !!(s.DE && s.DE["context-menu"] && s.DE["context-menu"].button) && ZC._n_(s.DE["context-menu"].button.visible);
              if (A5R || "classic" !== s.LY && A5R) {
                GW = new DT(s), s.B8.load(GW.o, ZC._[65] + ".button"), JN && ZC._n_(null !== (G = JN.button)) && GW.append(G), ZC.mobile && (s.B8.load(GW.o, ZC._[65] + "[mobile].button"), OU && null !== ZC._n_(G = OU.button) && GW.append(G)), ZC._cp_(s.N8.o, JN);
                var A7C = "left" === JN.position || "classic" === s.LY;
                if (GW.K = s.K + "-menu-trigger", GW.IW = ZC.AK(s.K + "-tools"), GW.Z = GW.C7 = ZC.AK(s.K + "-trigger-c"), GW.VL = !0, GW.parse(), GW.AN) {
                  GW.paint();
                  var DC = ZC.A5("#" + s.H.K + "-top");
                  if ("" === GW.AO) {
                    var NB = new DW(s);
                    if (NB.CY = !1, s.B8.load(NB.o, ZC._[65] + ".gear"), JN && null !== ZC._n_(G = JN.gear) && NB.append(G), ZC.mobile && (s.B8.load(NB.o, ZC._[65] + "[mobile].gear"), OU && null !== ZC._n_(G = OU.gear) && NB.append(G)), NB.K = s.K + "-menu-trigger-gear", NB.IW = ZC.AK(s.K + "-tools"), NB.Z = ZC.AK(s.K + "-trigger-c"), NB.iX = A7C ? GW.iX + GW.I / 2 : DC.width() - (GW.iX + GW.I / 2), NB.iY = GW.iY + GW.F / 2, NB.AI = ZC.CX(GW.I, GW.F) / 4.5, NB.parse(), NB.paint(), "hamburger" !== NB.DQ) {
                      var QU = new DW(s);
                      QU.copy(GW), QU.K = s.K + "-menu-trigger-gear-hole", QU.IW = ZC.AK(s.K + "-tools"), QU.Z = ZC.AK(s.K + "-trigger-c"), QU.DQ = "circle", QU.AI = ZC.CX(GW.I, GW.F) / 7, QU.parse(), QU.iX = A7C ? GW.iX + GW.I / 2 : DC.width() - (GW.iX + GW.I / 2), QU.iY = GW.iY + GW.F / 2, QU.paint();
                    }
                  }
                  var _iX = A7C ? GW.iX : DC.width() - (GW.iX + GW.I);
                  ZC.AK(s.K + "-map").innerHTML += ZC.Q.G2("rect") + 'id="' + s.K + "-menu-area" + ZC._[30] + ZC._i_(_iX + ZC.MAPTX) + "," + ZC._i_(GW.iY + ZC.MAPTX) + "," + ZC._i_(_iX + GW.I + ZC.MAPTX) + "," + ZC._i_(GW.iY + GW.F + ZC.MAPTX) + '" />';
                }
              }
            }
            DZ = new DT(s), s.B8.load(DZ.o, ZC._[65] + ".item"), JN && null !== ZC._n_(G = JN.item) && DZ.append(G), ZC.mobile && (s.B8.load(DZ.o, ZC._[65] + "[mobile].item"), OU && null !== ZC._n_(G = OU.item) && DZ.append(G)), DZ.VL = !0, DZ.parse(), LO = new DT(s), LO.copy(DZ), s.B8.load(LO.o, ZC._[65] + ".item.hover-state"), JN && null !== ZC._n_(JN.item) && null !== ZC._n_(G = JN.item[ZC._[71]]) && LO.append(G), ZC.mobile && (s.B8.load(LO.o, ZC._[65] + "[mobile].item.hover-state"), OU && null !== ZC._n_(OU.item) && null !== ZC._n_(G = OU.item[ZC._[71]]) && LO.append(G)), LO.VL = !0, LO.parse(), UR = {}, JN && null !== ZC._n_(JN.separator) && (UR = JN.separator);
            var K0 = [],
              EK = null;
            if (ABR = null !== ZC._n_(s.N8.o.empty) && ZC._b_(s.N8.o.empty), ZC.mobile && (EK = G9("PageScroll"), "none" !== EK.enabled && (null === s.DE || null === ZC._n_(s.DE["page-scroll"]) || s.DE["page-scroll"] ? K0.push(GZ("disablepagescroll", EK.text)) : K0.push(GZ("enablepagescroll", EK.text)), K0.push(JH("pagescroll")))), EK = G9("Reload"), "none" !== EK.enabled && (K0.push(GZ("reload", EK.text)), K0.push(JH("reload"))), typeof ZC.A8U !== ZC._[31]) {
              EK = G9("SaveAsImage"), "none" !== EK.enabled && (EK = G9("SaveAsImagePNG"), "none" !== EK.enabled && K0.push(GZ("viewaspng", EK.text ? EK.text : null)), EK = G9("SaveAsImageJPG"), "none" !== EK.enabled && K0.push(GZ("viewasjpg", EK.text ? EK.text : null)), K0.push(JH("export")));
              var TS = ["DownloadPDF", "DownloadSVG", "DownloadCSV", "DownloadXLS", "ViewDataTable", "ExportData", "Print"],
                A6V = 0,
                A2U = 0;
              for (i = 0; i < TS.length; i++) "ViewDataTable" === TS[i] && ZC.AK(s.K + "-data-table") && (TS[i] = "HideDataTable"), EK = G9(TS[i]), "none" !== EK.enabled && (A6V++, A2U = i, K0.push(GZ(TS[i].toLowerCase(), EK.text)));
              A6V > 0 && K0.push(JH(TS[A2U].toLowerCase()));
            }
            if (-1 !== LR) {
              var GQ = !1;
              for (j = 0, JJ = s.AG[LR].BO.length; j < JJ; j++) s.AG[LR].BO[j].GQ && (GQ = !0);
              if (GQ && typeof AAG !== ZC._[31]) {
                var A1F = !1;
                EK = G9("ZoomIn"), "none" !== EK.enabled && (K0.push(GZ("zoomin", EK.text)), A1F = !0), EK = G9("ZoomOut"), "none" !== EK.enabled && (K0.push(GZ("zoomout", EK.text)), A1F = !0), EK = G9("ViewAll"), "none" !== EK.enabled && (K0.push(GZ("viewall", EK.text)), A1F = !0), A1F && K0.push(JH("zoom"));
              }
            }
            var b2D = !1,
              b3D = !1;
            if (-1 !== LR && (-1 !== ZC.AV(["line", "area", "bar", "vbar", "hbar", "pie", "mixed"], s.AG[LR].AF) && (b2D = !0, s.XP = "2d"), -1 !== ZC.AV(["line3d", "area3d", "bar3d", "vbar3d", "hbar3d", "pie3d", "mixed3d"], s.AG[LR].AF) && (b3D = !0, s.XP = "3d")), (b2D || b3D) && (EK = G9("3D"), "none" !== EK.enabled && (EK = G9(b2D ? "SwitchTo3D" : "SwitchTo2D"), "none" !== EK.enabled && (K0.push(GZ(b2D ? "switchto3d" : "switchto2d", EK.text)), K0.push(JH("dimension"))))), -1 !== LR) {
              var C = s.AG[LR],
                AB7 = !1,
                AC5 = !1;
              for (j = 0; j < C.BO.length; j++) {
                var B = C.BO[j];
                0 === B.BG.indexOf(ZC._[51]) && (AB7 = !0), "log" === B.C1 && (AC5 = !0);
              }
              AB7 && (EK = G9("Progression"), "none" !== EK.enabled && (EK = G9(AC5 ? "LinScale" : "LogScale"), "none" !== EK.enabled && (K0.push(GZ(AC5 ? "switchtolin" : "switchtolog", EK.text)), K0.push(JH("progression"))))), (C.CW || C.HD) && (EK = G9("Guide"), "none" !== EK.enabled && (EK = G9(C.A1V ? "HideGuide" : "ShowGuide"), "none" !== EK.enabled && (K0.push(GZ(C.A1V ? "hideguide" : "showguide", EK.text)), K0.push(JH("guide")))));
            }
            var ABE = 0,
              B6;
            if (typeof ZC.A9E !== ZC._[31] && (EK = G9("ViewSource"), "none" !== EK.enabled && (K0.push(GZ("viewsource", EK.text)), ABE++), EK = G9("BugReport"), "none" !== EK.enabled && (K0.push(GZ("bugreport", EK.text)), ABE++)), ABE > 0 && K0.push(JH("tools")), EK = G9("FullScreen"), "none" === EK.enabled || s.M3 || (s.RB ? (EK = G9("ExitFullScreen"), K0.push(GZ("exitfullscreen", EK.text)), K0.push(JH("exitfullscreen"))) : (K0.push(GZ("fullscreen", EK.text)), K0.push(JH("fullscreen")))), s.IJ && (EK = G9("GoBack"), "none" !== EK.enabled && K0.push(GZ("goback", EK.text)), EK = G9("GoForward"), "none" !== EK.enabled && K0.push(GZ("goforward", EK.text)), K0.push(JH("history"))), K0.length > 0 && -1 !== K0[K0.length - 1].indexOf("zc-menu-sep") && K0.splice(K0.length - 1, 1), s.A1Y = {}, -1 !== LR) if (JN && null !== ZC._n_(B6 = JN["custom-items"])) for (K0.length > 0 && K0.push(JH("custom")), i = 0, A6 = B6.length; i < A6; i++) {
              var A4L = !0;
              if (null !== ZC._n_(B6[i].enabled) && ("none" === B6[i].enabled ? A4L = !1 : "all" !== B6[i].enabled && (A4L = !ev || eval(B6[i].enabled).call(s, zingchart.A0X(ev, s), B6[i].id, ev))), A4L) {
                var AO,
                  K = B6[i].id || "custom-" + i;
                "sep" === B6[i].id || "sep" === B6[i].type ? K0.push(JH(K, !0)) : "header" === B6[i].type ? (AO = B6[i].text || "Custom Menu " + i, K0.push(A3A(K, AO, !0))) : (AO = B6[i].text || "Custom Menu " + i, s.A1Y[K] = {
                  fn: B6[i]["function"] || "",
                  url: B6[i].url || "",
                  target: B6[i].target || ""
                }, K0.push(GZ(K, AO, !0)));
              }
            }
            s.UF || (K0.push(JH("zingchart")), K0.push(GZ("xmiabt", "About ZingChart"))), ZC.Q.I7({
              id: s.K + "-menu",
              p: document.body,
              cls: "zc-menu zc-style",
              top: null === ZC._n_(GW) ? 0 : GW.iY + GW.F / 2,
              left: null === ZC._n_(GW) ? 0 : GW.iX + GW.I / 2,
              borderBottom: s.N8.AU + "px solid " + s.N8.BW,
              background: (-1 === s.N8.A0 ? "transparent" : s.N8.A0) + " " + A22(s.N8.D9),
              paddingTop: s.N8.FO,
              paddingRight: s.N8.FP,
              paddingBottom: s.N8.FS,
              paddingLeft: s.N8.EP,
              html: K0.join("")
            }), s.E["menu-item-events"] || (s.AGC = function (e) {
              var t,
                i = 1 !== e.target.nodeType ? e.target.parentNode.id : e.target.id,
                a = i.substring(0, i.indexOf("-menu-item-")),
                n = zingchart.getLoader(a);
              ZC.mobile && n.P7();
              var l = n.A26(n.T2[0], n.T2[1]);
              n.hideCM(), ZC.mobile && zingchart.SN(e);
              var r = i.replace(n.K + "-menu-item-", "");
              n.A34({
                graphid: l ? l.K : null,
                menuitemid: r,
                ev: ZC.A5.BX(e)
              });
              var o = n.o["export-filename"] || n.o[ZC._[16]][0]["export-filename"] || "";
              switch (r) {
                case "switchto2d":
                case "switchto3d":
                  l && n.A0F(l.K);
                  break;
                case "enablepagescroll":
                  s.DE = s.DE || {}, s.DE["page-scroll"] = !0;
                  break;
                case "disablepagescroll":
                  s.DE = s.DE || {}, s.DE["page-scroll"] = !1;
                  break;
                case "showguide":
                  n.W6(l.K, !0);
                  break;
                case "hideguide":
                  n.W6(l.K, !1);
                  break;
                case "switchtolin":
                  n.WB(l.K, "lin");
                  break;
                case "switchtolog":
                  n.WB(l.K, "log");
                  break;
                case "reload":
                  n.A4Q();
                  break;
                case "viewaspng":
                  n.NL("png");
                  break;
                case "viewasjpg":
                  n.NL("jpeg");
                  break;
                case "downloadpdf":
                  n.NL("pdf", "" === o ? null : {
                    fn: o + ".pdf"
                  });
                  break;
                case "downloadsvg":
                  n.NL("svg", "" === o ? null : {
                    fn: o + ".svg"
                  });
                  break;
                case "exportdata":
                  zingchart.exec(n.K, "exportdata");
                  break;
                case "downloadcsv":
                  zingchart.exec(n.K, "downloadCSV", "" === o ? null : {
                    fn: o
                  });
                  break;
                case "downloadxls":
                  var C = n.o["export-sheetname"] || n.o[ZC._[16]][0]["export-sheetname"] || "ZingChart";
                  (t = G9("DownloadXLS"))["custom-function"] ? n.ZS({
                    graphid: l ? l.K : null,
                    menuitemid: r,
                    filename: o,
                    sheetname: C,
                    "function": t["custom-function"]
                  }) : zingchart.exec(n.K, "downloadXLS", "" === o ? null : {
                    fn: o,
                    sn: C
                  });
                  break;
                case "viewdatatable":
                case "hidedatatable":
                  zingchart.exec(n.K, "viewDataTable", {
                    menuid: r
                  });
                  break;
                case "print":
                  n.A51();
                  break;
                case "viewsource":
                  n.A1A();
                  break;
                case "bugreport":
                  n.A28();
                  break;
                case "fullscreen":
                  n.A18();
                  break;
                case "goback":
                  zingchart.exec(n.K, "goback");
                  break;
                case "goforward":
                  zingchart.exec(n.K, "goforward");
                  break;
                case "zoomin":
                  l && (n.H3.C = l, n.A4U({
                    graphid: l.K,
                    ev: e
                  }));
                  break;
                case "zoomout":
                  l && (n.H3.C = l, n.A3U({
                    graphid: l.K,
                    ev: e
                  }));
                  break;
                case "viewall":
                  l && (n.H3.C = l, n.A3T({
                    graphid: l.K,
                    ev: e
                  }));
                  break;
                case "xmiabt":
                  n.A5B();
                  break;
                default:
                  null !== ZC._n_(G = s.A1Y[r]) && ("" !== G.fn ? n.ZS({
                    graphid: l ? l.K : null,
                    menuitemid: r,
                    "function": G.fn
                  }) : "" !== G.url && l && l.UI(e, G.url, G.target));
              }
            }, s.AG5 = function () {
              this.style.backgroundColor = LO.A0, this.style.color = LO.C2, this.style.borderLeft = this.style.borderRight = LO.AU + "px solid " + LO.BW;
            }, s.AG8 = function () {
              this.style.backgroundColor = DZ.A0, this.style.color = DZ.C2, this.style.borderLeft = this.style.borderRight = DZ.AU + "px solid " + DZ.BW;
            }, s.UG = function (e) {
              return e.preventDefault(), !1;
            }, ZC.A5("#" + s.K + "-menu").live(ZC._[47], s.UG), ZC.A5("." + s.K + "-menu-item").live(ZC._[47], s.UG), ZC.A5("." + s.K + "-menu-item").live("click touchend", s.AGC).live("mouseover", s.AG5).live("mouseout", s.AG8), s.E["menu-item-events"] = !0);
          }
        }
        function A22(e) {
          return "" !== e && e ? "url(" + (0 === e.indexOf("zc.") ? ZC.IMAGES[e] : e) + ")" : "none";
        }
        function JH(e) {
          return '<div id="' + s.K + "-menu-sep-" + e + '" class="zc-menu-sep" style="background-color:' + DZ.A0 + ";background-image:" + A22(DZ.D9) + " repeat-x 50% 0%;border-bottom-width:" + UR[ZC._[4]] + ";border-bottom-color:" + UR["line-color"] + ';">&nbsp;</div>';
        }
        function GZ(e, t, i) {
          t = t || ZC.HQ["menu-" + e];
          var a = typeof i !== ZC._[31] && i ? " zc-custom-menu-item " + s.K + "-custom-menu-item" : "";
          return '<div class="' + s.K + "-menu-item" + a + '" style="width:' + s.N8.o.width + ";color:" + DZ.C2 + ";font-family:" + DZ.GJ + ";font-size:" + DZ.DG + "px;background-color:" + DZ.A0 + ";background-image:" + A22(DZ.D9) + " repeat-x 50% 0%;border-top:" + (ZC.ie67 ? DZ.AU : 1) + "px solid " + DZ.BW + ";border-left:" + DZ.AU + "px solid " + DZ.BW + ";border-right:" + DZ.AU + "px solid " + DZ.BW + ";padding:" + DZ.FO + "px " + DZ.FP + "px " + DZ.FS + "px " + DZ.EP + "px;text-align:" + DZ.OO + ";" + (ZC.HQ.rtl ? "unicode-bidi:bidi-override;direction:rtl;" : "") + '" id="' + s.K + "-menu-item-" + e + '">' + t + "</div>";
        }
        function A3A(e, t, i) {
          var a = typeof i !== ZC._[31] && i ? " zc-custom-menu-header " + s.K + "-custom-menu-header" : "";
          return '<div class="zc-menu-header ' + s.K + "-menu-header" + a + '" style="color:' + DZ.C2 + ";background-color:#666;border-top:" + (ZC.ie67 ? DZ.AU : 1) + "px solid " + DZ.BW + ";border-left:" + DZ.AU + "px solid " + DZ.BW + ";border-right:" + DZ.AU + "px solid " + DZ.BW + ";padding:" + DZ.FO + "px " + DZ.FP + "px " + DZ.FS + "px " + DZ.EP + "px;text-align:" + DZ.OO + ";" + (ZC.HQ.rtl ? "unicode-bidi:bidi-override;direction:rtl;" : "") + '" id="' + s.K + "-menu-item-" + e + '">' + t + "</div>";
        }
        function G9(e) {
          var t = {
            ViewAsImage: "SaveAsImage",
            ViewAsImagePNG: "SaveAsImagePNG",
            ViewAsImageJPG: "SaveAsImageJPG"
          };
          if (ABR) return {
            enabled: "none"
          };
          for (var i = 0, a = PR.length; i < a; i++) {
            if (PR[i].id === e) return PR[i];
            if (t[PR[i].id] && t[PR[i].id] === e) return PR[i];
          }
          return {
            enabled: "all"
          };
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this._unbind_(), zingchart.I8.length -= 1, this.clear(), ZC.A5("#zc-fullscreen").remove(), document.body.style.overflow = "";
      }
    }, {
      key: "MU",
      value: function MU(e, t) {
        var i,
          a = this;
        if (null === ZC._n_(t) && (t = !1), (t || a.A0V) && -1 === ZC.AV(a.L0, ZC._[41])) if (a.A09 = !0, t && ZC.Q.I7({
          id: a.K + "-dummy",
          p: ZC.AK(a.K),
          wh: a.I + "/" + a.F
        }), a.E.hideprogresslogo || zingchart.DEV.SKIPPROGRESS) a.A09 = !1;else {
          var n = ZC.A5("#" + a.K);
          if (!(typeof n.offset() === ZC._[31] || n.width() + n.height() === 0 || a.E.hideprogresslogo && a.UF)) {
            var l = n.offset().left + ZC._i_(n.css("border-left-width")) + (null === e ? a.iX : e.iX),
              r = n.offset().top + ZC._i_(n.css("border-top-width")) + (null === e ? a.iY : e.iY);
            (ZC.ipad || ZC.iphone) && (l -= ZC.A5(window).scrollLeft(), r -= ZC.A5(window).scrollTop());
            var o = null === e ? a.I : e.I,
              s = null === e ? a.F : e.F,
              C = ZC._i_(.8 * a.I),
              A = 30,
              Z = new DT(a);
            a.B8.load(Z.o, "loader.gui.progress"), Z.append(a.E.progress), null !== a.DE && null !== ZC._n_(i = a.DE.progress) && Z.append(i), Z.parse();
            var c,
              p = ZC.HQ["progress-wait-long"];
            if (ZC.ie67) c = Z.A0;else {
              var u = a.E.customprogresslogo || ZC.IMAGES["zc.logo"];
              c = Z.A0 + " url(" + u + ") no-repeat center center";
            }
            (o < 180 || s < 90) && (c = Z.A0, A = -12), o < 120 && o > 60 ? (C = 60, p = ZC.HQ["progress-wait-short"]) : o < 60 && (C = 20, p = ZC.HQ["progress-wait-mini"]), p = a.E.customprogresstext || p;
            var h = ZC.Q.I7({
              id: a.K + "-progress",
              p: document.body,
              tl: r + "/" + l,
              width: o - 2 * Z.AU,
              height: s - 2 * Z.AU,
              position: "absolute",
              opacity: .8,
              border: Z.AU + "px solid " + Z.BW,
              background: c
            });
            ZC.Q.I7({
              id: a.K + "-progress-text",
              p: h,
              width: C,
              html: p,
              textAlign: "center",
              marginLeft: ZC._i_((o - C) / 2),
              marginTop: ZC._i_(s / 2 + A),
              fontFamily: zingchart.FONTFAMILY,
              fontSize: zingchart.FONTSIZE,
              color: Z.C2,
              fontWeight: "bold"
            });
          }
        }
      }
    }, {
      key: "YB",
      value: function YB() {
        var e = this;
        ZC.Q.EU(e.K + "-dummy"), e.E.hideprogresslogo || (e.A09 = !1, ZC.Q.EU([e.K + "-progress-text", e.K + "-progress"]));
      }
    }, {
      key: "A0C",
      value: function A0C(e, t) {
        var i,
          a,
          n = this;
        i = null !== ZC._n_(a = e[ZC._[16]]) ? a : [e];
        var l = e.layout || "",
          r = ZC.AR.A2Y(l, i.length),
          o = i[t],
          s = n.I / r[1],
          C = n.F / r[0],
          A = Math.floor(t / r[1]),
          Z = t % r[1] * s,
          c = A * C;
        o && (null !== ZC._n_(a = o.x) && (Z = ZC._p_(a)) <= 1 && (Z = ZC._i_(Z * n.I)), null !== ZC._n_(a = o.y) && (c = ZC._p_(a)) <= 1 && (c = ZC._i_(c * n.F)), null !== ZC._n_(a = o[ZC._[19]]) && (s = ZC._p_(a)) <= 1 && (s = ZC._i_(s * n.I)), null !== ZC._n_(a = o[ZC._[20]]) && (C = ZC._p_(a)) <= 1 && (C = ZC._i_(C * n.F)));
        var p = [0, 0, 0, 0];
        if (o.plotarea) {
          if (n.B8.load(o.plotarea, ["(" + o.type + ").plotarea"], !1, !0), null !== ZC._n_(o.plotarea.margin)) p = new I3(null).m_(o.plotarea.margin, "all", s, C);
          for (var u = ["top", "right", "bottom", "left"], h = 0; h < 4; h++) if (null !== ZC._n_(o.plotarea["margin-" + u[h]])) {
            var _ = o.plotarea["margin-" + u[h]];
            ZC._i_(_) + "" == _ + "" && (p[h] = ZC._i_(_));
          }
        }
        return {
          graph: {
            x: ZC._i_(Z),
            y: ZC._i_(c),
            width: ZC._i_(s),
            height: ZC._i_(C),
            index: t
          },
          plotarea: {
            x: p[3],
            y: p[0],
            width: s - p[1] - p[3],
            height: C - p[0] - p[2]
          }
        };
      }
    }, {
      key: "JY",
      value: function JY() {
        var e = this;
        null === ZC._n_(e.o[ZC._[16]]) && (e.o = {
          graphset: [e.o]
        }), e.MU(), zingchart.A1S(e, e.A1T(), function () {
          e.o = ZC.AQ.BZ("dataparse", e, e.F5(), e.o), zingchart.YI[e.K] && e.PQ(function () {
            e.parse(), e.paint();
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var e = this;
        !function () {
          function t() {
            "" !== e.RD || null !== e.MY ? e.A4X() : e.load();
          }
          e.UV || e.A4T(), e.MU(null, !0), zingchart.TIMEOUT > 0 ? ZC.ZV(t) : t();
        }();
      }
    }, {
      key: "W8",
      value: function W8(e) {
        var t = this;
        null === ZC._n_(t.A4G) && (t.A4G = new Date().getTime(), t.ABC = window.setTimeout(function () {
          null !== ZC._n_(t.A4G) && (t.A4G = null, zingchart.Z8(e));
        }, 1500));
      }
    }, {
      key: "F5",
      value: function F5() {
        var e,
          t = this,
          i = 0,
          a = 0;
        return i = typeof t.T2[0] !== ZC._[31] ? t.T2[0] - i : 0, a = typeof t.T2[1] !== ZC._[31] ? t.T2[1] - a : 0, e = t.LY ? t.LY : "light", {
          id: t.K,
          width: t.I,
          height: t.F,
          output: t.AA,
          x: i,
          y: a,
          targetid: t.T2[2],
          theme: e
        };
      }
    }, {
      key: "A7T",
      value: function A7T(e) {
        e = e || {}, null !== ZC._n_(e.resource) && (this.R7[e.resource] = e.data || "[]", this.VB++);
      }
    }, {
      key: "A4U",
      value: function A4U() {}
    }, {
      key: "A3U",
      value: function A3U() {}
    }, {
      key: "A3T",
      value: function A3T() {}
    }, {
      key: "PP",
      value: function PP() {}
    }, {
      key: "A5W",
      value: function A5W(e, t) {
        var i = this;
        if (e = e || {}, null !== ZC._n_(e[ZC._[3]])) {
          var a = i.OJ(e[ZC._[3]]);
          null !== a && a.clear();
        } else i.clear(null, null, t);
        KB && KB.GUIDES && (KB.GUIDES[i.K] = null);
      }
    }, {
      key: "A3O",
      value: function A3O(e) {
        e = e || ZC.HQ["sync-wait"];
        var t = this;
        if (null === ZC.AK(t.K + "-blocker")) {
          ZC.Q.I7({
            cls: "zc-abs zc-style zc-blocker",
            id: t.K + "-blocker",
            p: ZC.AK(t.K + "-top"),
            wh: t.I + "/" + t.F,
            opacity: .75
          }), ZC.Q.I7({
            cls: "zc-blocker-msg",
            id: t.K + "-blocker-t",
            p: ZC.AK(t.K + "-blocker"),
            html: e
          });
          var i = ZC.A5("#" + t.K + "-blocker-t");
          i.css("top", t.F / 2 - i.height() / 2 + "px").css("left", t.I / 2 - i.width() / 2 + "px");
        }
      }
    }, {
      key: "A0U",
      value: function A0U() {
        ZC.Q.EU(this.K + "-blocker");
      }
    }, {
      key: "A5B",
      value: function A5B() {
        var e = this;
        ZC.AQ.BZ("about_show", e, e.F5()), ZC.Q.I7({
          cls: "zc-abs",
          id: e.K + "-about-mask",
          p: ZC.AK(e.K + "-top"),
          wh: e.I + "/" + e.F,
          background: "#ccc",
          opacity: .75
        });
        var t = ZC.CX(320, e.I),
          i = ZC.CX(215, e.F),
          a = ZC.BQ(0, (e.I - t) / 2),
          n = ZC.BQ(0, (e.F - i) / 2),
          l = ZC.Q.I7({
            cls: "zc-about zc-style",
            id: e.K + "-about",
            p: ZC.AK(e.K + "-top"),
            tl: n + "/" + a,
            wh: t - (ZC.quirks ? 0 : 10) + "/" + (i - (ZC.quirks ? 0 : 10))
          }),
          r = "";
        "" !== e.SP && (r = "Custom Built for<br />" + e.SP), l.innerHTML = '<div class="zc-about-1"><a href="http://www.zingchart.com" target="_blank">zingchart.com</a></div><div class="zc-about-2">&copy;2009-' + new Date().getFullYear() + '</div><div class="zc-about-3"><div id="' + e.K + '-about-close">' + ZC.HQ["about-close"] + '</div></div><div class="zc-about-4" style="padding:' + (i - 215) + 'px 5px 5px 5px;"><div>&nbsp;<br />Build ' + ZC.VERSION + " [" + e.AA + "]</div>" + r + "</div>", ZC.A5("#" + e.K + "-about-close").bind("click", function () {
          ZC.AQ.BZ("about_hide", e, e.F5()), ZC.Q.EU([e.K + "-about", e.K + "-about-mask"]);
        });
      }
    }, {
      key: "NG",
      value: function NG(e, t) {
        var i = this;
        if (ZC.AQ.A8I("error", i)) ZC.AQ.BZ("error", i, {
          id: i.K,
          error: e,
          section: t,
          json: i.E.json || i.E.rawsource
        });else {
          var a = "";
          a += "object" == typeof e ? e.name + ":" + e.message + "\n\n" : e + "\n\n", null !== ZC._n_(t) && (a += "Section:" + t + "\n\n"), a += "JSON data:\n\n" + i.E.json + "\n\n", i.YB(), null === ZC.AK(i.K + "-top") && i.A7N(), ZC.Q.I7({
            cls: "zc-abs zc-error zc-style",
            id: i.K + "-error",
            p: ZC.AK(i.K + "-top"),
            wh: i.I - (ZC.quirks ? 0 : 10) + "/" + (i.F - (ZC.quirks ? 0 : 10))
          }).innerHTML = '<div class="zc-form-row-label zc-form-s0">' + ZC.HQ["error-header"] + '</div><div class="zc-form-row-label zc-form-s1">' + ZC.HQ["error-message"] + '</div><div class="zc-form-row-element"><textarea id="' + i.K + '-error-message" style="width:' + (i.I - 35) + "px;height:" + (i.F - 135) + 'px;"></textarea></div><div class="zc-form-row-element zc-form-row-last"><input type="button" value="' + ZC.HQ["error-close"] + '" id="' + i.K + '-error-close" /></div>', ZC.A5("#" + i.K + "-error-message").val(ZC.GY(a)), ZC.A5("#" + i.K + "-error-close").bind("click", function () {
            ZC.Q.EU(i.K + "-error");
          });
        }
      }
    }, {
      key: "A1A",
      value: function A1A() {}
    }, {
      key: "A28",
      value: function A28() {}
    }, {
      key: "A18",
      value: function A18() {
        var e = this,
          t = document.createElement("div");
        t.id = "zc-fullscreen", t.style.zIndex = zingchart.FSZINDEX, t.style.overflow = "hidden";
        var i,
          a,
          n = document.body,
          l = !1;
        for (zingchart.FSID && ZC.AK(zingchart.FSID) && (l = !0, (n = ZC.AK(zingchart.FSID)).style.display = "block"), n.appendChild(t), ZC.FSSTATUS = {}, i = 0, a = e.AG.length; i < a; i++) {
          var r = e.AG[i];
          if (null !== r.AY) for (var o = 0, s = r.AY.A4.length; o < s; o++) ZC.FSSTATUS["g-" + r.L + "-p-" + o] = r.E["plot" + o + ".visible"];
        }
        ZC.Q.EU(e.K + "-data-table");
        var C,
          A = JSON.parse(e.E.json),
          Z = A[ZC._[16]];
        for (i = Z.length - 1; i >= 0; i--) if (Z[i].generated) Z.splice(i, 1);else {
          if (null !== ZC._n_(Z[i].shapes)) for (C = Z[i].shapes.length - 1; C >= 0; C--) Z[i].shapes[C].generated && Z[i].shapes.splice(C, 1);
          if (null !== ZC._n_(Z[i][ZC._[10]])) for (C = Z[i][ZC._[10]].length - 1; C >= 0; C--) Z[i][ZC._[10]][C].generated && Z[i][ZC._[10]].splice(C, 1);
        }
        l || window.scroll(0, 0), zingchart.render({
          id: "zc-fullscreen",
          output: e.AA,
          width: ZC.A5(l ? n : window).width(),
          height: ZC.A5(l ? n : window).height(),
          fullscreenmode: !0,
          theme: e.LY,
          modules: e.A2A,
          data: A,
          defaults: e.MY,
          defaultsurl: e.RD
        });
      }
    }, {
      key: "WB",
      value: function WB(e, t) {
        var i,
          a,
          n,
          l = this,
          r = 0,
          o = !1;
        for (i = 0, a = l.AG.length; i < a; i++) if (e === l.AG[i].K) {
          for (r = i, n = 0; n < l.AG[i].AY.A4.length; n++) if (l.AG[i].AY.A4[n].IA) {
            o = !0;
            break;
          }
          var s;
          for (s = l.AG[r].AJ["3d"] || o ? l.o[ZC._[16]][i] : l.AG[i].o, n = 0; n < 10; n++) {
            var C = ZC._[51] + (0 === n ? "" : "-" + n);
            null === ZC._n_(s[C]) && null === ZC._n_(s[ZC.EE(C)]) && null !== l.AG[i].BJ(C) ? s[C] = {
              progression: t
            } : (null !== ZC._n_(s[C]) && (s[C].progression = t), null !== ZC._n_(s[ZC.EE(C)]) && (s[ZC.EE(C)].progression = t));
          }
        }
        delete l.E["graph" + r + ".zoom"], l.AG[r].AJ["3d"] || o ? l.JY() : l.AG[r].JY(!0, !0);
      }
    }, {
      key: "W6",
      value: function W6(e, t) {
        var i = this;
        if (i.D6) {
          for (var a = 0, n = i.AG.length; a < n; a++) e === i.AG[a].K && (i.AG[a].A1V = t, i.AG[a].E["guide-on"] = t);
          if (t) {
            var l = ZC.A5("#" + i.K + "-top"),
              r = {
                _pageX_: ZC.E0[0] - l.offset().left,
                _pageY_: ZC.E0[1] - l.offset().top,
                type: ZC._[48],
                target: {
                  id: i.K + "-img"
                }
              };
            i.D6.QN(r);
          } else KB.clearGuide(i.K);
        }
      }
    }, {
      key: "A0F",
      value: function A0F(e) {
        for (var t = this, i = ["line", "area", "bar", "vbar", "hbar", "pie", "mixed"], a = 0, n = t.AG.length; a < n; a++) if (e === t.AG[a].K) {
          var l = t.o[ZC._[16]][a];
          if ("mixed" === l.type) for (var r = 0, o = l[ZC._[11]].length; r < o; r++) {
            var s = l[ZC._[11]][r];
            s.type = s.type || "line", "3d" === t.XP ? s.type = s.type.replace("3d", "") : -1 !== ZC.AV(i, s.type) && (s.type = s.type + "3d");
          } else "3d" === t.XP ? l.type = l.type.replace("3d", "") : -1 !== ZC.AV(i, l.type) && (l.type = l.type + "3d");
        }
        t.XP = "3d" === t.XP ? "2d" : "3d", t.E.json = ZC.GY(JSON.stringify(t.o)), t.JY();
      }
    }, {
      key: "A4Q",
      value: function A4Q(e) {
        for (var t, i = this, a = 0; a < i.AG.length; a++) delete i.E["g" + a + "-legend-collapsed"];
        if (e = e || {}, ZC.AQ.BZ("reload", i, {
          id: i.K,
          graphid: e[ZC._[3]]
        }), null !== ZC._n_(t = e[ZC._[3]])) {
          var n = i.C8(t);
          null !== n && (i.MU(n), i.load(n.K));
        } else i.QW = [], i.OB = -1, i.MU(), i.clearGenerated(), i.load();
      }
    }, {
      key: "AAR",
      value: function AAR(e) {
        var t,
          i = this;
        if (e = e || {}, null !== ZC._n_(t = e[ZC._[3]])) {
          var a = i.C8(t);
          null !== a && null !== ZC._n_(e.dataurl) && (i.MU(a), i.load(t, e.dataurl));
        } else null !== ZC._n_(t = e.dataurl) && (i.RC = t, i.MU(), i.load());
      }
    }, {
      key: "A51",
      value: function A51() {}
    }, {
      key: "NL",
      value: function NL() {}
    }, {
      key: "W5",
      value: function W5() {}
    }, {
      key: "A34",
      value: function A34(e) {
        ZC._cp_(this.F5(), e), ZC.AQ.BZ("menu_item_click", this, e);
      }
    }, {
      key: "ZS",
      value: function ZS(O) {
        var s = this;
        try {
          var DU = ZC.AQ.AAT(O["function"]);
          O["function"] = DU[0], O.arguments = DU[1], ZC._cp_(s.F5(), O), eval(O["function"]).call(s, O);
        } catch (JI) {
          return s.NG(JI, "JavaScript data loader"), !1;
        }
      }
    }, {
      key: "C8",
      value: function C8(e) {
        var t = this;
        return null !== ZC._n_(e) ? t.OJ(e) : t.AG.length > 0 ? t.AG[0] : null;
      }
    }, {
      key: "bind",
      value: function bind(e, t) {
        zingchart.bind(this.K, e, t);
      }
    }, {
      key: "unbind",
      value: function unbind(e, t) {
        zingchart.unbind(this.K, e, t);
      }
    }, {
      key: "exec",
      value: function exec(e, t) {
        return zingchart.exec(this.K, e, t);
      }
    }, {
      key: "gc",
      value: function gc() {
        for (var e = 0, t = this.AG.length; e < t; e++) this.AG[e].gc();
      }
    }]);
    return RU;
  }(I3);
  RU.prototype.ADB = function (e) {
    var t,
      i,
      a,
      n,
      l,
      r = this;
    if ((e = e || {}).action = "pan", t = null !== ZC._n_(e[ZC._[3]]) ? r.OJ(e[ZC._[3]]) : r.AG[0]) {
      for (i = 0, a = t.BT("k").length; i < a; i++) {
        var o = t.BT("k")[i];
        if (n = 1 === o.L ? "" : "-" + o.L, o.GQ && (null === ZC._n_(e["zoomx" + n]) || e["zoomx" + n])) {
          e["zoomx" + n] = !0;
          var s,
            C = e.xdist || 50;
          l = o.I / ZC.CX(o.I, Math.abs(C));
          var A = o.W,
            Z = o.A1;
          C < 0 ? (s = ZC.CX(o.W - o.DD, ZC._i_((o.A1 - o.W) / l)), A = o.W - s, Z = o.A1 - s) : (s = ZC.CX(o.DV - o.A1, ZC._i_((o.A1 - o.W) / l)), A = o.W + s, Z = o.A1 + s), e["xmin" + n] = A, e["xmax" + n] = Z;
        }
      }
      for (i = 0, a = t.BT("v").length; i < a; i++) {
        var c = t.BT("v")[i];
        if (n = 1 === c.L ? "" : "-" + c.L, c.GQ && (null === ZC._n_(e["zoomy" + n]) || e["zoomy" + n])) {
          e["zoomy" + n] = !0;
          var p,
            u = e.ydist || 50;
          l = c.F / ZC.CX(c.F, Math.abs(u));
          var h = c.B3,
            _ = c.BL;
          C < 0 ? (p = ZC.CX(c.B3 - c.FX, ZC._i_((c.BL - c.B3) / l)), h = c.B3 - p, _ = c.BL - p) : (p = ZC.CX(c.H4 - c.BL, ZC._i_((c.BL - c.B3) / l)), h = c.B3 + p, _ = c.BL + p), c.QE && 1 === c.E3 && (h = Math.round(h), _ = Math.round(_)), e["ymin" + n] = h, e["ymax" + n] = _;
        }
      }
      r.PP(e);
    }
  }, RU.prototype.A4U = function (e) {
    var t,
      i,
      a,
      n,
      l = this;
    if ((e = e || {}).action = "zoomin", t = null !== ZC._n_(e[ZC._[3]]) ? l.OJ(e[ZC._[3]]) : l.AG[0]) {
      for (i = 0, a = t.BT("k").length; i < a; i++) {
        var r = t.BT("k")[i];
        if (n = 1 === r.L ? "" : "-" + r.L, r.GQ && (null === ZC._n_(e["zoomx" + n]) || e["zoomx" + n])) {
          e["zoomx" + n] = !0;
          var o = r.A1 - r.W,
            s = r.W + (o < 2 ? 0 : ZC._i_(o / 4)),
            C = r.A1 - (o < 2 ? 0 : ZC._i_(o / 4));
          s < C ? (e["xmin" + n] = s, e["xmax" + n] = C) : (e["xmin" + n] = r.W, e["xmax" + n] = r.A1);
        }
      }
      for (i = 0, a = t.BT("v").length; i < a; i++) {
        var A = t.BT("v")[i];
        if (n = 1 === A.L ? "" : "-" + A.L, A.GQ && (null === ZC._n_(e["zoomy" + n]) || e["zoomy" + n])) {
          e["zoomy" + n] = !0;
          var Z = A.BL - A.B3,
            c = A.B3 + ZC._f_(Z / 4),
            p = A.BL - ZC._f_(Z / 4);
          A.QE && 1 === A.E3 && (c = Math.round(c), p = Math.round(p)), c < p && (e["ymin" + n] = c, e["ymax" + n] = p);
        }
      }
      l.PP(e);
    }
  }, RU.prototype.A3U = function (e) {
    var t,
      i,
      a,
      n,
      l,
      r,
      o,
      s = this;
    if ((e = e || {}).action = "zoomout", e.previewscale = !0, t = null !== ZC._n_(e[ZC._[3]]) ? s.OJ(e[ZC._[3]]) : s.AG[0]) {
      for (i = 0, a = t.BT("k").length; i < a; i++) {
        var C = t.BT("k")[i];
        if (o = 1 === C.L ? "" : "-" + C.L, C.GQ && (null === ZC._n_(e["zoomx" + o]) || e["zoomx" + o])) if (e["zoomx" + o] = !0, t.B9 && t.B9.LW) {
          var A = ZC._i_(t.B9.NX[C.BG][ZC._[5]].length * t.B9.IL / t.B9.AT.I),
            Z = ZC._i_(t.B9.NX[C.BG][ZC._[5]].length * t.B9.H8 / t.B9.AT.I);
          n = ZC.BQ(2, Z - A), (l = ZC.BQ(0, A - ZC._i_(n / 2))) < (r = ZC.CX(t.B9.NX[C.BG][ZC._[5]].length - 1, Z + ZC._i_(n / 2))) && (e["xmin" + o] = l, e["xmax" + o] = r);
        } else n = ZC.BQ(2, C.A1 - C.W), (l = ZC.BQ(C.DD, C.W - ZC._i_(n / 2))) < (r = ZC.CX(C.DV, C.A1 + ZC._i_(n / 2))) && (e["xmin" + o] = l, e["xmax" + o] = r);
      }
      for (i = 0, a = t.BT("v").length; i < a; i++) {
        var c = t.BT("v")[i];
        if (o = 1 === c.L ? "" : "-" + c.L, c.GQ && (null === ZC._n_(e["zoomy" + o]) || e["zoomy" + o])) {
          e["zoomy" + o] = !0;
          var p = c.BL - c.B3,
            u = ZC.BQ(c.FX, c.B3 - ZC._f_(p / 2)),
            h = ZC.CX(c.H4, c.BL + ZC._f_(p / 2));
          c.QE && 1 === c.E3 && (Math.round(h) - Math.round(u) > 1 ? (u = Math.round(u), h = Math.round(h)) : (u = Math.floor(u), h = Math.ceil(h))), (u = ZC.BQ(c.FX, u)) < (h = ZC.CX(c.H4, h)) && (e["ymin" + o] = u, e["ymax" + o] = h);
        }
      }
      s.PP(e);
    }
  }, RU.prototype.A3T = function (e) {
    var t,
      i,
      a,
      n,
      l,
      r = this;
    for (e = e || {}, i = null !== ZC._n_(e[ZC._[3]]) ? r.OJ(e[ZC._[3]]) : r.AG[0], e.action = "viewall", a = 0, n = i.BT("k").length; a < n; a++) if (e["zoomx" + (l = 1 === (t = i.BT("k")[a]).L ? "" : "-" + t.L)] = !0, e["xmin" + l] = null, e["xmax" + l] = null, i.o[t.BG] && (i.o[t.BG]["zoom-to"] = null, i.o[t.BG]["zoom-to-values"] = null), i.B9 && i.B9.LW) {
      var o = i.B9.NX[t.BG][ZC._[5]];
      e["kmin" + l + "-async"] = o[0], e["kmax" + l + "-async"] = o[o.length - 1];
    }
    for (a = 0, n = i.BT("v").length; a < n; a++) t = i.BT("v")[a], i.o[t.BG] && (i.o[t.BG]["zoom-to"] = null, i.o[t.BG]["zoom-to-values"] = null), t.DM = null !== ZC._n_(t.E[ZC._[12]]) && -1 !== t.E[ZC._[12]] ? t.E[ZC._[12]] : null, l = 1 === t.L ? "" : "-" + t.L, t.KT = null, e["zoomy" + l] = !0, e["ymin" + l] = null, e["ymax" + l] = null;
    r.PP(e);
  }, RU.prototype.PP = function (e) {
    var t,
      i,
      a,
      n,
      l,
      r,
      o,
      s,
      C,
      A,
      Z,
      c,
      p,
      u,
      h,
      _ = this;
    (e = e || {}).id = _.K;
    var d = null !== ZC._n_(e.zoom) && !e.zoom;
    if (i = null !== ZC._n_(e[ZC._[3]]) ? _.OJ(e[ZC._[3]]) : _.AG[0]) {
      d && (_.E["graph." + i.L + ".ignore-zoom"] = !0), _.E["graph." + i.L + ".ignore-zoom"] && (d = !0), typeof e.scroll === ZC._[31] && (ZC.Q.IT(ZC.AK(i.K + "-scroll-x-c"), i.A.AA, i.iX, i.iY, i.I, i.F), ZC.Q.IT(ZC.AK(i.K + "-scroll-y-c"), i.A.AA, i.iX, i.iY, i.I, i.F)), i.B9 && (i.B9.IP = !1);
      var f = _.E["graph" + i.L + ".zoom"] || {};
      for (e.yzoomed = !1, (l = i.BT("v")[0]) && null !== ZC._n_(e.ymin) && null !== ZC._n_(e.ymax) && (e.ymin === l.FX && e.ymax === l.H4 || (e.yzoomed = !0)), s = 0, C = i.BT("k").length; s < C; s++) if (A = 1 === (n = i.BT("k")[s]).L ? "" : "-" + n.L, null !== ZC._n_(e["kmin" + A]) && null !== ZC._n_(e["kmax" + A])) {
        if (e["kmin" + A] === e["kmax" + A]) delete e["kmin" + A], delete e["kmax" + A];else {
          for (var g = !1, B = !1, v = 0, m = n.V.length; v < m && (e["kmin" + A] <= n.V[v] && !g && (e["xmin" + A] = v, g = !0), e["kmax" + A] <= n.V[v] && !B && (e["xmax" + A] = v, B = !0), !g || !B); v++);
          g || (e["xmin" + A] = 0), B || (e["xmax" + A] = n.V.length - 1), e["zoomx" + A] = !0, e.xzoomed = !(g && B);
        }
      } else a = i.B9 && i.B9.LW && e.previewscale ? i.B9.NX[n.BG][ZC._[5]] : n.V, null !== ZC._n_(t = a[e["xmin" + A]]) && (e["kmin" + A] = t), null !== ZC._n_(t = a[e["xmax" + A]]) && (e["kmax" + A] = t), e.xzoomed = !(e["xmin" + A] === n.DD && e["xmax" + A] === n.DV);
      "viewall" === e.action && (e.xzoomed = !1, e.yzoomed = !1);
      var b = ZC.AQ.BZ("zoom", i.A, e, !0);
      if (e.async && !d) return;
      if (i.B9 && i.B9.LW) {
        a = i.B9.NX[n.BG][ZC._[5]];
        var E = ZC.YP(a),
          K = ZC.A1U(a);
        null !== ZC._n_(e.kmin) && typeof e.kmin !== ZC._[31] ? (r = ZC._i_(i.B9.AT.I * (e.kmin - E) / (K - E)), r = ZC.BQ(r, 0)) : r = 0, null !== ZC._n_(e.kmax) && typeof e.kmax !== ZC._[31] ? (o = ZC._i_(i.B9.AT.I * (e.kmax - E) / (K - E)), o = ZC.CX(o, i.B9.AT.I)) : o = i.B9.AT.I, d || i.B9.update(r, o, i.B9.LB, i.B9.HL);
      }
      if (b || typeof b === ZC._[31]) {
        for (s = 0, C = i.BT("k").length; s < C; s++) e["zoomx" + (A = 1 === (n = i.BT("k")[s]).L ? "" : "-" + n.L)] && (d || n.zoomTo(e["xmin" + A], e["xmax" + A]), f["xmin" + A] = e["xmin" + A], f["xmax" + A] = e["xmax" + A]);
        for (s = 0, C = i.BT("v").length; s < C; s++) e["zoomy" + (A = 1 === (l = i.BT("v")[s]).L ? "" : "-" + l.L)] && null !== ZC._n_(l) && (d || l.zoomTo(e["ymin" + A], e["ymax" + A]), f["ymin" + A] = e["ymin" + A], f["ymax" + A] = e["ymax" + A]);
        if (d && (_.H3.C = i), _.H3.parse(), _.H3.A11) for (_.E["graph" + i.L + ".zoom"] = f, u = 0, h = _.AG.length; u < h; u++) i.K !== _.AG[u].K && _.AG[u].H3 && ZC._b_(_.AG[u].H3.o.shared) && (_.E["graph" + _.AG[u].L + ".zoom"] = f);
        if (i.B9 && !e.preview && i.B9.update(e.xmin, e.xmax, e.ymin, e.ymax, !0), d) return;
        i.clear(!0);
        for (var D = i.BT("v"), F = 0; F < D.length; F++) if ((l = i.BT("v")[F]) && (l.aAutoFit[0] || l.aAutoFit[1])) {
          for (var I = l.aAutoFit[0] ? ZC.MAX : l.FX, x = l.aAutoFit[1] ? -ZC.MAX : l.H4, y = 0, X = i.AY.A4.length; y < X; y++) if (i.AY.A4[y].AN && -1 !== ZC.AV(i.AY.A4[y].BO, l.BG)) if (n.EF) {
            for (s = 0, C = i.AY.A4[y].S.length; s < C; s++) if ((p = i.AY.A4[y].S[s]) && ZC.DR(p.BU, n.V[n.W], n.V[n.A1])) for (l.aAutoFit[0] && (I = ZC.CX(I, p.CR)), l.aAutoFit[1] && (x = ZC.BQ(x, p.CR)), Z = 0, c = p.DN.length; Z < c; Z++) l.aAutoFit[0] && (I = ZC.CX(I, p.DN[Z])), l.aAutoFit[1] && (x = ZC.BQ(x, p.DN[Z]));
          } else for (s = n.W; s <= n.A1; s++) if (p = i.AY.A4[y].S[s]) for (l.aAutoFit[0] && (I = ZC.CX(I, p.CR)), l.aAutoFit[1] && (x = ZC.BQ(x, p.CR)), Z = 0, c = p.DN.length; Z < c; Z++) l.aAutoFit[0] && (I = ZC.CX(I, p.DN[Z])), l.aAutoFit[1] && (x = ZC.BQ(x, p.DN[Z]));
          "log" === l.C1 && (I = ZC.G8(I, l.E4), x = ZC.G8(x, l.E4)), l.Q9(I, x, !0), l.H0();
          var Y = i.BT("v");
          for (s = 0; s < Y.length; s++) Y[s].BG !== l.BG && Y[s].sMaster === l.BG && (Y[s].Q9(I, x, !0), Y[s].H0());
        }
        var w = ZC._b_(e.zoomto);
        i.E["skip-preview"] = !0;
        var L = ["top", "right", "bottom", "left"];
        for (s = 0; s < L.length; s++) (i.P.E["d-margin-" + L[s]] || i.E["plotarea.d-margin-" + L[s]] || ZC._b_(i.P.o["adjust-layout"])) && (i.o.plotarea["margin-" + L[s]] = i.P.o["margin-" + L[s]] = "dynamic", i.E["plotarea.d-margin"] = i.E["plotarea.d-margin-" + L[s]] = !0);
        i.setupDynamicPlotArea(), i.paint(!w), _.H3.C = null, ZC.AQ.BZ("postzoom", i.A, e);
      }
    }
  }, zingchart.AC0 = function (e, t, i) {
    var a, n, l, r, o, s, C, A, Z;
    document.getElementById("zc-fullscreen") && (e = "zc-fullscreen"), "string" == typeof (i = i || {}) && (i = JSON.parse(i));
    var c = zingchart.getLoader(e);
    if (null !== ZC._n_(i[ZC._[53]]) && (c.E[ZC._[53]] = ZC._b_(i[ZC._[53]])), c) switch (t) {
      case "getzoom":
        if (r = {}, l = c.C8(i[ZC._[3]])) for (a = 0, n = l.BO.length; a < n; a++) {
          var p = l.BO[a];
          "k" === p.AF ? r[p.BG] = {
            xmin: p.W,
            xmax: p.A1,
            vmin: p.V[p.W],
            vmax: p.V[p.A1]
          } : r[p.BG] = {
            ymin: p.B3,
            ymax: p.BL,
            vmin: p.V[p.W],
            vmax: p.V[p.A1]
          };
        }
        return r;
      case "pan":
        c.ADB(i);
        break;
      case "zoomin":
        c.A4U(i);
        break;
      case "zoomout":
        c.A3U(i);
        break;
      case "zoomto":
        if (l = c.C8(i[ZC._[3]]), null !== ZC._n_(i.xall) && i.xall) for (a = 0, n = l.BT("k").length; a < n; a++) i["xmin" + (C = 1 === (o = l.BT("k")[a]).L ? "" : "-" + o.L)] = i.xmin || null, i["xmax" + C] = i.xmax || null, i["kmin" + C] = i.kmin || null, i["kmax" + C] = i.kmax || null;
        for (a = 0, n = l.BT("k").length; a < n; a++) null === i["xmin" + (C = 1 === (o = l.BT("k")[a]).L ? "" : "-" + o.L)] && null === ZC._n_(i["xmax" + C]) && null === ZC._n_(i["kmin" + C]) && null === ZC._n_(i["kmax" + C]) || (i["zoomx" + C] = !0), "log" === o.C1 && (null !== ZC._n_(i["xmin" + C]) && (i["xmin" + C] = ZC.G8(i["xmin" + C], o.E4)), null !== ZC._n_(i["xmax" + C]) && (i["xmax" + C] = ZC.G8(i["xmax" + C], o.E4)));
        if (null !== ZC._n_(i.yall) && i.yall) for (a = 0, n = l.BT("v").length; a < n; a++) i["ymin" + (C = 1 === (s = l.BT("v")[a]).L ? "" : "-" + s.L)] = i.ymin || null, i["ymax" + C] = i.ymax || null;
        for (a = 0, n = l.BT("v").length; a < n; a++) C = 1 === (s = l.BT("v")[a]).L ? "" : "-" + s.L, null === ZC._n_(i["ymin" + C]) && null === ZC._n_(i["ymax" + C]) || (i["zoomy" + C] = !0), "log" === s.C1 && (null !== ZC._n_(i["ymin" + C]) && (i["ymin" + C] = ZC.G8(i["ymin" + C], s.E4)), null !== ZC._n_(i["ymax" + C]) && (i["ymax" + C] = ZC.G8(i["ymax" + C], s.E4)));
        c.PP(i);
        break;
      case "zoomtovalues":
        if (l = c.C8(i[ZC._[3]]), null !== ZC._n_(i.xall) && i.xall) for (a = 0, n = l.BT("k").length; a < n; a++) i["xmin" + (C = 1 === (o = l.BT("k")[a]).L ? "" : "-" + o.L)] = i.xmin || null, i["xmax" + C] = i.xmax || null;
        for (a = 0, n = l.BT("k").length; a < n; a++) C = 1 === (o = l.BT("k")[a]).L ? "" : "-" + o.L, null === ZC._n_(i["xmin" + C]) && null === ZC._n_(i["xmax" + C]) || (l.B9 && l.B9.LW ? (i.previewscale = !0, i["kmin" + C + "-async"] = i["xmin" + C], i["xmin" + C] = ZC.A9Z(l.B9.NX[o.BG][ZC._[5]], i["xmin" + C])) : -1 !== (A = ZC.AV(o.V, i["xmin" + C])) && (i["xmin" + C] = A), l.B9 && l.B9.LW ? (i.previewscale = !0, i["kmax" + C + "-async"] = i["xmax" + C], i["xmax" + C] = ZC.A9Z(l.B9.NX[o.BG][ZC._[5]], i["xmax" + C])) : -1 !== (Z = ZC.AV(o.V, i["xmax" + C])) && (i["xmax" + C] = Z), i["zoomx" + C] = !0);
        if (null !== ZC._n_(i.yall) && i.yall) for (a = 0, n = l.BT("v").length; a < n; a++) i["ymin" + (C = 1 === (s = l.BT("v")[a]).L ? "" : "-" + s.L)] = i.ymin || null, i["ymax" + C] = i.ymax || null;
        for (a = 0, n = l.BT("v").length; a < n; a++) C = 1 === (s = l.BT("v")[a]).L ? "" : "-" + s.L, null === ZC._n_(i["ymin" + C]) && null === ZC._n_(i["ymax" + C]) || (i["zoomy" + C] = !0);
        c.PP(i);
        break;
      case "viewall":
        c.A3T(i);
    }
    return null;
  }, ZC.A8U = {}, ZC.AQ.A48 = function (e, t, i, a) {
    "jpg" === (a = a || "png") && (a = "jpeg");
    var n = document.createElement("canvas");
    n.width = t, n.height = i, n.style.width = t + "px", n.style.height = i + "px";
    var l,
      r = n.getContext("2d");
    e instanceof Array || (e = [e]);
    for (var o = 0, s = e.length; o < s; o++) if (-1 === e[o].className.indexOf("zc-no-print")) {
      var C = !1;
      try {
        e[o].toDataURL("image/" + a);
      } catch (Z) {
        C = !0;
      }
      if (!C) if (l = e[o].getAttribute("data-clip")) {
        var A = l.split(",");
        r.drawImage(e[o], ZC.BQ(0, A[0]), ZC.BQ(0, A[1]), ZC.CX(A[2], e[o].width), ZC.CX(A[3], e[o].height), ZC.BQ(0, A[0]), ZC.BQ(0, A[1]), ZC.CX(A[2], e[o].width), ZC.CX(A[3], e[o].height));
      } else r.drawImage(e[o], 0, 0, e[o].width, e[o].height, 0, 0, t, i);
    }
    return n.toDataURL("image/" + a);
  }, ZC.AQ.ABX = function (e, t, i, a, n) {
    null === ZC._n_(n) && (n = !1);
    var l = ZC.AQ.A48(e, t, i, a);
    if (n) {
      var r = document.createElement("img");
      return r.src = l, r;
    }
    l = l.replace("image/" + a, "image/octet-stream"), document.location.href = l;
  }, RU.prototype.A51 = function () {
    var e = this,
      t = [];
    if (!e.A8O) {
      e.A8O = !0;
      var i = document.body.childNodes,
        a = ZC.A5(document.body).css(ZC._[0]),
        n = ZC.A5(document.body).css("background-image");
      ZC.A5(document.body).css(ZC._[0], "#fff").css("background-image", "none");
      for (var l = 0, r = i.length; l < r; l++) 1 === i[l].nodeType && (t[l] = i[l].style.display, i[l].style.display = "none");
      document.body.appendChild(ZC.AK(e.K + "-wrapper")), window.setTimeout(function () {
        window.print(), window.setTimeout(function () {
          ZC.A5(document.body).css(ZC._[0], a).css("background-image", n), ZC.AK(e.K + "-wrapper") && ZC.AK(e.K).appendChild(ZC.AK(e.K + "-wrapper"));
          for (var l = 0, r = i.length; l < r; l++) 1 === i[l].nodeType && (i[l].style.display = t[l]);
          e.A8O = !1;
        }, 1e3);
      }, 50);
    }
  }, RU.prototype.NL = function (e, t, i, a) {
    var n = this;
    if (t = t || {}, typeof i === ZC._[31] && (i = !1), !ZC.AK(n.K + "-viewimage")) {
      e = e || "png";
      var l = t.download,
        r = t.fn || "";
      ZC.Q.IT(ZC.AK(n.K + "-guide-c"), n.AA, 0, 0, n.I, n.F), ZC.A5(".zc-guide-label").remove();
      var o,
        s,
        C = ("canvas" === n.AA || zingchart.AJAXEXPORT || zingchart.DEV.LOCALSVGEXPORT) && "pdf" !== e && "svg" !== e;
      if (ZC.mobile || !C || i || l || (o = ZC.Q.I7({
        cls: "zc-abs zc-viewimage zc-style",
        id: n.K + "-viewimage",
        zidx: 5,
        p: ZC.AK(n.K + "-top"),
        wh: n.I + "/" + n.F
      }), s = ZC.Q.I7({
        id: n.K + "-viewimage-close",
        p: o,
        zidx: 10,
        tl: "5/" + (n.I - 15),
        html: ZC.HQ["viewimage-close"]
      }), ZC.A5(s).css("cursor", "pointer").css("left", n.I - 15 - ZC.A5(s).width() + "px"), ZC.A5(s).bind("click", function () {
        ZC.A5(o).remove();
      })), ZC.mobile && (l = !0), !zingchart.DEV.LOCALSVGEXPORT || l || "svg" !== n.AA || "png" !== e && "jpeg" !== e) {
        var A;
        if ("canvas" === n.AA && "pdf" !== e && "svg" !== e) {
          var Z,
            c,
            p = document.createElement("canvas");
          for (p.width = n.I, p.height = n.F, Z = 0, c = n.AG.length; Z < c; Z++) n.AG[Z].BC && n.AG[Z].BC.ED(p);
          var u = [];
          ZC.A5("#" + n.K + " canvas").each(function () {
            -1 === ZC.AV([n.K + "-guide-c", n.K + "-trigger-c"], this.id) && u.push(this);
          }), u.push(p), u.push(n.createPreviewMasks());
          var h = ZC.AQ.ABX(u, n.I, n.F, e, !0);
          h.id = n.K + "-print-" + e, o.appendChild(h);
        } else if (i || n.A3O(ZC.HQ["export-wait"]), "vml" === n.AA || "canvas" === n.AA && ("pdf" === e || "svg" === e)) {
          var _ = document.createElement("div"),
            d = "zc-export-svg-" + n.K;
          _.id = d, _.style.display = "none", document.body.appendChild(_), zingchart.render({
            id: d,
            output: "!svg",
            imggen: !0,
            width: n.I,
            height: n.F,
            data: n.E.json,
            defaults: n.MY,
            theme: n.LY,
            hideprogresslogo: !0,
            events: {
              load: function load() {
                window.setTimeout(function () {
                  var e = zingchart.getLoader(d);
                  if (e.E["dynamic-objects"]) var t = window.setInterval(function () {
                    "ready" === e.E["dynamic-objects"] && (window.clearInterval(t), e.togglePreviewMasks(!0), A = ZC.AK(d + "-top").innerHTML, e.togglePreviewMasks(!1), zingchart.exec(d, "destroy", {
                      skipfs: !0
                    }), f());
                  }, 100);else e.togglePreviewMasks(!0), A = ZC.AK(d + "-top").innerHTML, e.togglePreviewMasks(!1), zingchart.exec(d, "destroy", {
                    skipfs: !0
                  }), f();
                }, 100);
              }
            }
          });
        } else "svg" === n.AA && (n.togglePreviewMasks(!0), A = ZC.AK(n.K + "-top").innerHTML, f(), n.togglePreviewMasks(!1));
        C && !i && (ZC.A5(s).css("cursor", "pointer").css("left", n.I - 15 - ZC.A5(s).width() + "px"), ZC.A5(s).bind("click", function () {
          ZC.A5(o).remove();
        }));
      } else zingchart.exec(n.K, "getimagedata", {
        callback: function callback(l) {
          if (-1 !== l) {
            var r = document.createElement("img");
            r.id = n.K + "-print-" + e, r.src = l, o.appendChild(r);
          } else ZC.Q.EU(n.K + "-viewimage"), zingchart.DEV.LOCALSVGEXPORT = 0, n.NL(e, t, i, a);
        }
      });
    }
    function f() {
      var s,
        C,
        Z = {
          svg: A = (A = A.replace(/<foreignObject(.+?)<\/foreignObject>/g, "")).replace(' xmlns="http://www.w3.org/2000/svg"', ""),
          w: n.I,
          h: n.F,
          t: e,
          fn: r
        };
      if (ZC._cp_(t, Z), zingchart.AJAXEXPORT && "pdf" !== e && "svg" !== e && !l) {
        var c = "base64=1&";
        for (C in Z) c += C + "=" + encodeURIComponent(Z[C]) + "&";
        ZC.A5.ajax({
          type: "post",
          url: zingchart.EXPORTURL,
          data: c,
          success: function success(t, l, r) {
            if (n.A0U(), i) a && a(t, l, r);else {
              var s = document.createElement("img");
              s.src = t, s.id = n.K + "-print-" + e, o.appendChild(s);
            }
          }
        });
      } else {
        ZC.AK(n.K + "-export") && ZC.Q.EU(n.K + "-export");
        var p = ZC.Q.I7({
            cls: "zc-abs zc-style",
            id: n.K + "-export",
            p: ZC.AK(n.K + "-top"),
            display: "none"
          }),
          u = (s = null !== ZC._n_(Z.uid) && null !== ZC._n_(Z.page) ? ZC.Q.ABO(ZC.AK(n.K + "-export")) : document).createElement("FORM");
        for (C in u.action = zingchart.EXPORTURL, u.method = "post", u.enctype = "multipart/form-data", null !== ZC._n_(Z.uid) && null !== ZC._n_(Z.page) ? s.body.appendChild(u) : p.appendChild(u), u.style.display = "none", Z) {
          var h = s.createElement("INPUT");
          h.type = "hidden", h.name = C, h.value = Z[C], u.appendChild(h);
        }
        u.submit(), u = null, null !== ZC._n_(Z.uid) && null !== ZC._n_(Z.page) && window.setTimeout(function () {
          ZC.A5("#" + n.K + "-export").remove();
        }, 6e4), window.setTimeout(function () {
          n.A0U();
        }, 1e3);
      }
    }
  }, RU.prototype.W5 = function (e) {
    var t = this;
    e = e || "png";
    var i,
      a,
      n = [],
      l = document.createElement("canvas");
    for (l.width = t.I, l.height = t.F, i = 0, a = t.AG.length; i < a; i++) t.AG[i].BC && t.AG[i].BC.ED(l);
    return ZC.A5("#" + t.K + " canvas").each(function () {
      -1 === ZC.AV([t.K + "-guide-c", t.K + "-tooltip-c"], this.id) && n.push(this);
    }), n.push(l), n.push(t.createPreviewMasks()), ZC.AQ.A48(n, t.I, t.F, e);
  }, ZC.AQ.downloadFile = function (e, t, i) {
    if (!ZC.ie678) {
      i = i || "application/octet-stream";
      var a = document.createElement("a");
      navigator.msSaveBlob ? navigator.msSaveBlob(new Blob([e], {
        type: i
      }), t) : URL && "download" in a ? (a.href = URL.createObjectURL(new Blob([e], {
        type: i
      })), a.setAttribute("download", t), document.body.appendChild(a), a.click(), document.body.removeChild(a)) : location.href = "data:application/octet-stream," + encodeURIComponent(e);
    }
  }, ZC.AQ.YE = function (e, t) {
    var i,
      a,
      n,
      l,
      r,
      o,
      s,
      C,
      A,
      Z,
      c,
      p,
      u,
      h = [],
      _ = "",
      d = [];
    for ("xls" === (t = t || "csv") && h.push('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">', "<head>", "\x3c!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>[ZC]</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--\x3e", '<style>td{border:none;font-family:Calibri,sans-serif} .number{mso-number-format:"0.00";} .text{mso-number-format:"@";}</style>', "<meta name=ProgId content=Excel.Sheet>", "<meta charset=UTF-8>", "</head>", "<body>"), i = 0, a = e.AG.length; i < a; i++) {
      var f = e.AG[i],
        g = f.AY.A4;
      e.E.fastlinedata && (g = e.E.fastlinedata);
      var B = {},
        v = [],
        m = f.BT("k")[0];
      "html" !== t && "xls" !== t && "raw" !== t || (h.push("<table>"), f.IZ && "" !== f.IZ.AO && (d.push([f.IZ.AO]), h.push("<caption>" + f.IZ.AO + "</caption>")), h.push("<thead>"), h.push("<tr>")), c = [], u = [];
      var b = "Category",
        E = !1;
      for (m && (m.FI && "date" === m.FI.o.type && (b = "Date", E = !0), m.M && m.M.AO && (b = m.M.AO.replace(/\"|\'/g, ""))), "csv" === t ? c.push('"' + b + '"') : "raw" === t ? u.push(b) : "html" !== t && "xls" !== t || c.push("<th>" + b + "</th>"), n = 0, l = g.length; n < l; n++) (null === ZC._n_(g[n].o["export"]) || ZC._b_(g[n].o["export"])) && (p = (p = null !== ZC._n_(g[n].AO) ? g[n].AO + "" : "Series " + n).replace(/\"|\'/g, ""), "csv" === t ? c.push('"' + p + '"') : "raw" === t ? u.push(p) : "html" !== t && "xls" !== t || c.push("<th" + ("xls" === t ? ' scope="col" class="text"' : "") + ">" + p + "</th>"), v.push(""));
      if ("csv" === t ? h.push(c.join(",")) : "raw" === t ? d.push(u) : "html" !== t && "xls" !== t || h.push(c.join("")), "html" !== t && "xls" !== t || (h.push("</tr>"), h.push("</thead>"), h.push("<tbody>")), m) {
        for (s = 0, C = m.V.length; s < C; s++) B[s + ""] = {
          hasData: !1,
          nodes: [].concat(v)
        };
        var K = [];
        for (n = 0, l = g.length; n < l; n++) if (null === ZC._n_(g[n].o["export"]) || ZC._b_(g[n].o["export"])) for (r = 0, o = g[n].S.length; r < o; r++) {
          var D = g[n].S[r];
          D && (B[s = null !== ZC._n_(D.BU) ? "" + D.BU : "" + r] = B[s] || {
            hasData: !0,
            nodes: [].concat(v)
          }, B[s].nodes[n] = D.AD, B[s].hasData = !0, null !== ZC._n_(D.BU) && K.push("" + D.BU));
        }
        var F = [];
        for (s in B) B[s].hasData && F.push([s, B[s].nodes]);
        F.sort(function (e, t) {
          return e[0] - t[0];
        });
        var I = null;
        for (A = 0, Z = F.length; A < Z; A++) {
          if ("html" !== t && "xls" !== t || h.push("<tr>"), "pie" !== f.AF && "pie3d" !== f.AF && "nestedpie" !== f.AF || m.V[F[A][0]] && (F[A][0] = m.V[F[A][0]]), m.BY[F[A][0]] && (F[A][0] = m.BY[F[A][0]]), m.V[F[A][0]] && -1 === ZC.AV(K, F[A][0]) && (F[A][0] = m.V[F[A][0]]), (I = f.A.F5()).row = A, I.col = 0, I[ZC._[9]] = F[A][0], F[A][0] = ZC.AQ.BZ("dataexport", f.A, I, F[A][0], null), ZC._n_(F[A][1])) for (var x = 0; x < F[A][1].length; x++) (I = f.A.F5()).row = A, I.col = x + 1, I[ZC._[9]] = F[A][1][x], F[A][1][x] = ZC.AQ.BZ("dataexport", f.A, I, F[A][1][x], null);
          E && (F[A][0] = ZC.AQ.YX(F[A][0], "%Y-%mm-%dd %H:%i:%s", f.UY, f.NI), "csv" === t && (F[A][0] = '"' + F[A][0] + '"')), "csv" === t ? h.push([].concat(F[A][0]).concat(F[A][1]).join(",")) : "raw" === t ? d.push([].concat(F[A][0]).concat(F[A][1])) : "html" !== t && "xls" !== t || h.push("<td" + ("xls" === t ? ' scope="row"' : "") + ">" + [].concat(F[A][0]).concat(F[A][1]).join("</td><td>") + "</td>"), "html" !== t && "xls" !== t || h.push("</tr>");
        }
      }
      "html" !== t && "xls" !== t || (h.push("</tbody>"), h.push("</table>")), a > 1 && i < a - 1 && ("csv" === t ? h.push("", "", "") : "html" !== t && "xls" !== t || h.push("<p>&nbsp;</p>"));
    }
    return "xls" === t && h.push("</body>", "</html>"), "raw" === t ? d : ("csv" === t ? _ = h.join("\n") : "html" !== t && "xls" !== t || (_ = h.join("")), _);
  }, zingchart.ABM = function (e, t, i) {
    var a,
      n,
      l,
      r,
      o,
      s = "",
      C = "";
    function A(e) {
      ZC.A5.ajax({
        type: "post",
        url: n,
        data: e,
        success: function success(e, t, i) {
          l && l(e, t, i);
        }
      });
    }
    document.getElementById("zc-fullscreen") && (e = "zc-fullscreen"), "string" == typeof (i = i || {}) && (i = JSON.parse(i));
    var Z = zingchart.getLoader(e);
    if (Z) switch (t) {
      case "getimagedata":
        if (r = "png", null !== ZC._n_(a = i.format) && (r = a), null !== ZC._n_(a = i.filetype) && (r = a), "jpg" === r && (r = "jpeg"), zingchart.DEV.LOCALSVGEXPORT && "svg" === Z.AA && ("png" === r || "jpeg" === r)) {
          Z.togglePreviewMasks(!0);
          var c = ZC.AK(Z.K + "-svg").parentNode.innerHTML,
            p = c.indexOf(">"),
            u = c.indexOf("</svg>");
          c = (c = '<svg xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" version="1.1" width="' + Z.I + '" height="' + Z.F + '">[CSS]' + c.substring(p + 1, u + 6)).replace(/<foreignObject(.+?)<\/foreignObject>/g, "");
          var h = function h() {
              var e,
                t = window.URL || window.webkitURL || window;
              e = t.createObjectURL && window.Blob ? t.createObjectURL(new window.Blob([c], {
                type: "image/svg+xml;charset-utf-16"
              })) : "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(c), Z.togglePreviewMasks(!1);
              var a = new window.Image();
              a.crossOrigin = "anonymous", a.src = e, a.onload = function () {
                var t = document.createElement("canvas"),
                  n = t.getContext("2d");
                if (t.width = a.width, t.height = a.height, n.drawImage(a, 0, 0, t.width, t.height), i.callback && "function" == typeof i.callback) try {
                  i.callback(t.toDataURL("image/" + r));
                } catch (l) {
                  i.callback(e);
                }
              };
            },
            _ = 0,
            d = function d() {
              var e = new XMLHttpRequest();
              e.open("get", Z.A2R[_]), e.responseType = "text", e.onloadend = function (e) {
                var t = e.target.response,
                  i = t.match(/https?:\/\/[^ \)]+/g),
                  a = 0;
                i.forEach(function (e) {
                  var n = new XMLHttpRequest();
                  n.open("get", e), n.responseType = "blob", n.onloadend = function (n) {
                    var l = new FileReader();
                    l.onloadend = function (n) {
                      t = t.replace(new RegExp(e), n.target.result), ++a === i.length && (c = c.replace("[CSS]", "[CSS]<style><![CDATA[" + t + "]]></style>"), ++_ === Z.A2R.length ? (c = c.replace("[CSS]", ""), h()) : d());
                    }, l.readAsDataURL(n.target.response);
                  }, n.send();
                });
              }, e.send();
            };
          Z.A2R.length ? d() : (c = c.replace("[CSS]", ""), h());
        }
        if ("canvas" !== Z.AA && !zingchart.AJAXEXPORT) return -1;
        if ("canvas" === Z.AA) {
          if (!i.callback || "function" != typeof i.callback) return Z.W5(r);
          try {
            i.callback(Z.W5(r));
          } catch (v) {
            i.callback(-1);
          }
        } else Z.NL(r, {}, !0, i.callback);
        break;
      case "exportimage":
      case "saveasimage":
        if (!i.download && "canvas" !== Z.AA && !zingchart.AJAXEXPORT) return -1;
        if (r = "png", o = {}, null !== ZC._n_(a = i.options) && (o = a), null !== ZC._n_(a = i.uid) && (o.uid = a), null !== ZC._n_(a = i.page) && (o.page = a), null !== ZC._n_(a = i.format) && (r = a), null !== ZC._n_(a = i.filetype) && (r = a), null !== ZC._n_(a = i.filename) && (s = a), n = Z.E.exportimageurl || "", null !== ZC._n_(a = i.url) && (n = a), l = null, null !== ZC._n_(a = i.callback) && (l = a), "jpg" === r && (r = "jpeg"), i.download && ("canvas" !== Z.AA || "pdf" === r)) return o.download = !0, "" !== s && (o.fn = s), void Z.NL(r, o);
        if ("" !== n) {
          if ("canvas" === Z.AA) return A(Z.W5(r));
          Z.NL(r, o, !0, function (e) {
            return A(e);
          });
        }
        break;
      case "exportdata":
        if (n = Z.E.exportdataurl || "", null !== ZC._n_(a = i.url) && (n = a), C = ZC.AQ.YE(Z, "csv"), "" === n) return C;
        l = null, null !== ZC._n_(a = i.callback) && (l = a), ZC.A5.ajax({
          type: "post",
          url: n,
          data: C,
          success: function success(e, t, i) {
            l && l(e, t, i);
          }
        });
        break;
      case "downloadCSV":
        C = ZC.AQ.YE(Z, "csv"), ZC.AQ.downloadFile(C, (i.fn || Z.K) + ".csv", "text/csv;encoding:utf-8");
        break;
      case "downloadXLS":
        C = ZC.AQ.YE(Z, "xls");
        var f = i.sn || "ZingChart";
        C = C.replace("<x:Name>[ZC]</x:Name>", "<x:Name>" + f + "</x:Name>"), ZC.AQ.downloadFile(C, (i.fn || Z.K) + ".xls", "application/vnd.ms-excel;encoding:utf-8");
        break;
      case "downloadRAW":
        var g = ZC.AQ.YE(Z, "raw");
        if (!i.callback || "function" != typeof i.callback) return g;
        try {
          i.callback(g, i.fn || Z.K);
        } catch (v) {
          i.callback(-1);
        }
        break;
      case "viewDataTable":
        if ("viewdatatable" === i.menuid) {
          if (C = ZC.AQ.YE(Z, "html"), ZC.AK(Z.K + "-data-table")) ZC.AK(Z.K + "-data-table").innerHTML = C;else {
            var B = ZC.Q.I7({
              id: Z.K + "-data-table",
              cls: "zc-data-table " + Z.K + "-data-table"
            });
            ZC.Q.PV(B, {
              width: Z.I + "px",
              "max-height": "400px",
              overflow: "auto"
            }), B.innerHTML = C, ZC.AK(Z.K).parentNode.insertBefore(B, ZC.AK(Z.K).nextSibling);
          }
        } else "hidedatatable" === i.menuid && ZC.Q.EU(Z.K + "-data-table");
    }
    return null;
  }, ZC.A9E = {}, ZC.AQ.XC = function (e) {
    for (var t, i = "", a = !1, n = !1, l = 0, r = "", o = 0, s = (e = e.replace(/\t|\r|\n/g, "")).length; o < s; o++) switch (t = e.substr(o, 1)) {
      case '"':
        a = !a, i += e.substr(o, 1), r = t;
        break;
      case "{":
        i += e.substr(o, 1), a || (i += "\n" + new Array(l + 1).join("    "), l++, r = t);
        break;
      case "}":
        a || (i += "\n" + new Array(l).join("    "), l--, r = t), i += e.substr(o, 1);
        break;
      case "[":
        var C = e.indexOf("]", o),
          A = e.indexOf("}", o);
        A = -1 === A ? 999999 : A;
        var Z = e.indexOf("{", o);
        Z = -1 === Z ? 999999 : Z, C < ZC.CX(A, Z) ? (n = !0, i += e.substr(o, 1)) : (n = !1, i += e.substr(o, 1), i += "\n" + new Array(l + 1).join("    "), l++), r = t;
        break;
      case "]":
        n && (n = !1), "}" === r && (l--, i += "\n" + new Array(l).join("    ")), i += e.substr(o, 1), r = t;
        break;
      case " ":
        a && (i += e.substr(o, 1), r = t);
        break;
      case ",":
        i += e.substr(o, 1), a || n || (i += "\n" + new Array(l).join("    ")), r = t;
        break;
      default:
        i += e.substr(o, 1), r = t;
    }
    return i;
  }, RU.prototype.A1A = function () {
    var e = this;
    ZC.AQ.BZ("source_show", e, e.F5());
    var t = ZC.Q.I7({
      cls: "zc-abs zc-viewsource zc-style",
      id: e.K + "-viewsource",
      p: ZC.AK(e.K + "-top"),
      wh: e.I - (ZC.quirks ? 0 : 10) + "/" + (e.F - (ZC.quirks ? 0 : 10))
    });
    t.style.zIndex = 99, t.innerHTML = ZC._h_('<div class="zc-form-row-label zc-form-s1">&nbsp;<a href="javascript:void(0)" id="' + e.K + '-viewsource-originalsource" class="zc-tab-active">' + ZC.HQ["viewsource-originalsource"] + '</a>&nbsp;<a href="javascript:void(0)" id="' + e.K + '-viewsource-jsonsource" class="zc-tab-inactive">' + ZC.HQ["viewsource-jsonsource"] + '</a></div><div class="zc-form-row-element"><textarea id="' + e.K + '-viewsource-json" style="width:' + (e.I - 35) + "px;height:" + (e.F - 95) + 'px;"></textarea></div><div class="zc-form-row-element zc-form-row-last" id="' + e.K + '-viewsource-actions"><input type="button" value="' + ZC.HQ["viewsource-close"] + '" id="' + e.K + '-viewsource-close" /></div>'), zingchart.EDITSOURCE && (ZC.AK(e.K + "-viewsource-actions").innerHTML += '<input type="button" value="' + ZC.HQ["viewsource-apply"] + '" id="' + e.K + '-viewsource-apply" />'), ZC.A5("#" + e.K + "-viewsource-json").val(ZC.AQ.XC(e.E.source)), ZC.A5("#" + e.K + "-viewsource-jsonsource").bind("click", function () {
      ZC.AK(e.K + "-viewsource-jsonsource").className = "zc-tab-active", ZC.AK(e.K + "-viewsource-originalsource").className = "zc-tab-inactive", ZC.A5("#" + e.K + "-viewsource-json").val(ZC.AQ.XC(e.E.json));
    }), ZC.A5("#" + e.K + "-viewsource-originalsource").bind("click", function () {
      ZC.AK(e.K + "-viewsource-jsonsource").className = "zc-tab-inactive", ZC.AK(e.K + "-viewsource-originalsource").className = "zc-tab-active", ZC.A5("#" + e.K + "-viewsource-json").val(ZC.AQ.XC(e.E.source));
    }), ZC.A5("#" + e.K + "-viewsource-close").bind("click", function () {
      ZC.AQ.BZ("source_hide", e, e.F5()), ZC.Q.EU(e.K + "-viewsource");
    }), zingchart.EDITSOURCE && ZC.A5("#" + e.K + "-viewsource-apply").bind("click", function () {
      ZC.AQ.BZ("source_hide", e, e.F5());
      var t = ZC.A5("#" + e.K + "-viewsource-json").val();
      ZC.Q.EU(e.K + "-viewsource"), zingchart.exec(e.K, "setdata", {
        data: t
      });
    });
  }, RU.prototype.A28 = function () {
    var e = this;
    if (e.I < 300 || e.F < 300) window.open("http://www.zingchart.com/support/", "", "");else {
      var t = ZC.Q.I7({
          cls: "zc-abs zc-bugreport zc-style",
          id: e.K + "-bugreport",
          p: ZC.AK(e.K + "-top"),
          wh: e.I - (ZC.quirks ? 0 : 10) + "/" + (e.F - (ZC.quirks ? 0 : 10))
        }),
        i = "";
      i += '<div class="zc-form-row-label zc-form-s0">' + ZC.HQ["bugreport-header"] + '</div><div class="zc-form-row-label"><input type="checkbox" id="' + e.K + '-chkdata" checked="checked" /><label for="' + e.K + '-chkdata">' + ZC.HQ["bugreport-senddata"] + "</label>", ZC.canvas && (i += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" id="' + e.K + '-chkcapture" checked="checked" /><label for="' + e.K + '-chkcapture">' + ZC.HQ["bugreport-sendcapture"] + "</label>"), i += '</div><div class="zc-form-row-label zc-form-s1">' + ZC.HQ["bugreport-yourcomment"] + '</div><div class="zc-form-row-element"><textarea id="' + e.K + '-bugreport-comment" style="width:' + (e.I - 35) + "px;height:" + ((e.F - 300) / 2 - 10) + 'px;"></textarea></div><div class="zc-form-row-label zc-form-s1">' + ZC.HQ["bugreport-jsondata"] + '</div><div class="zc-form-row-element"><textarea id="' + e.K + '-bugreport-json" style="width:' + (e.I - 35) + "px;height:" + (e.F - 210) / 2 + 'px;"></textarea></div><div class="zc-form-row-label zc-form-s1">' + ZC.HQ["bugreport-youremail"] + (e.I >= 510 ? " <span>(" + ZC.HQ["bugreport-infoemail"] + ")</span>" : "") + '</div><div class="zc-form-row-element"><input type="text" id="' + e.K + '-bugreport-email" style="width:' + (e.I - 35) + 'px;" /></div><div class="zc-form-row-element zc-form-row-last"><input type="button" value="' + ZC.HQ["bugreport-submit"] + '" id="' + e.K + '-bugreport-submit" /><input type="button" value="' + ZC.HQ["bugreport-cancel"] + '" id="' + e.K + '-bugreport-cancel" /></div>', t.innerHTML = ZC._h_(i), ZC.A5("#" + e.K + "-bugreport-json").val("PARSED\n----------\n" + ZC.AQ.XC(e.E.json) + "\n\nORIGINAL\n----------\n" + ZC.AQ.XC(e.E.source)), ZC.A5("#" + e.K + "-bugreport-cancel").bind("click", function () {
        ZC.Q.EU(e.K + "-bugreport");
      }), ZC.A5("#" + e.K + "-bugreport-submit").bind("click", function () {
        var t = ZC.A5("#" + e.K + "-bugreport-email"),
          i = "",
          a = function a() {
            var a = ("Parsed:" + e.E.json + " Original:" + e.E.source).replace(/\r|\n|\t|(\s{2,})/g, ""),
              n = "",
              l = [];
            ZC.A5("#" + e.K + "-chkcapture").attr("checked") && l.push("****IMAGE:", i), ZC.A5("#" + e.K + "-chkdata").attr("checked") && l.push("****JSON:", a), l.push("****COMMENT:", ZC.A5("#" + e.K + "-bugreport-comment").val(), "****EMAIL:", t.val(), "****VERSION:", ZC.VERSION, "****WIDTH:", e.I, "****HEIGHT:", e.F, "****URL:", window.location.href, "****UA:", navigator.userAgent, "****RENDER:", e.AA.toUpperCase(), "****RESOLUTION:", screen.width + "x" + screen.height);
            for (var r = 0; r < l.length - 1; r += 2) n += l[r] + encodeURIComponent(l[r + 1]);
            n += "****END";
            var o = ZC.Q.ABO(ZC.AK(e.K + "-bugreport")),
              s = o.createElement("FORM");
            s.action = document.location.protocol + "//www.zingchart.com/support/submitreportH5.php", s.method = "post", o.body.appendChild(s);
            var C = o.createElement("INPUT");
            C.type = "text", C.name = "data", C.value = n, s.appendChild(C), s.submit(), window.setTimeout(function () {
              alert(ZC.HQ["bugreport-confirm"]), ZC.Q.EU(e.K + "-bugreport");
            }, 1e3);
          };
        "canvas" === e.AA ? (i = zingchart.exec(e.K, "getimagedata", {}), a()) : i = zingchart.exec(e.K, "getimagedata", {
          callback: function callback(e) {
            i = e, a();
          }
        });
      });
    }
  }, RU.prototype.paintHistory = function () {
    var e,
      t,
      i,
      a = this;
    ZC.Q.EU([a.K + "-history-path", a.K + "-history-back-path", a.K + "-history-forw-path", a.K + "-history-gradient", a.K + "-history-back-gradient", a.K + "-history-forw-gradient"]), null !== ZC._n_(e = a.o.history) && (a.IJ = new DT(a), a.B8.load(a.IJ.o, "loader.gui.history"), a.IJ.append(e), a.IJ.parse(), a.IJ.A57 = !0, t = new DW(a), a.B8.load(t.o, "loader.gui.history.item"), t.append(e.item), t.parse(), i = new DW(a), a.B8.load(i.o, "loader.gui.history.item-off"), i.append(e.item), i.append(e["item-off"]), i.parse());
    var n = "";
    if (a.IJ) {
      a.IJ.K = a.K + "-history", a.IJ.Z = a.IJ.C7 = ZC.AK(a.K + "-static-c"), a.IJ.paint();
      var l = a.IJ.iX + a.IJ.EP,
        r = a.IJ.iY + a.IJ.FO,
        o = a.IJ.I - a.IJ.EP - a.IJ.FP,
        s = a.IJ.F - a.IJ.FO - a.IJ.FS,
        C = new DW(a);
      C.K = a.K + "-history-back", C.copy(t), C.CY = !1, 0 === a.OB && C.copy(i), C.D = [[l, r + s / 2], [l + o / 3, r], [l + o / 3, r + s], [l, r + s / 2]], C.IW = ZC.AK(a.A.K + "-text"), C.Z = C.C7 = ZC.AK(a.K + "-static-c"), C.parse(), C.paint(), a.OB > 0 && (n += ZC.Q.G2("rect", !0) + 'class="' + a.K + '-history-area zc-history-area" id="' + a.K + "-history-back-area" + ZC._[30], n += ZC._i_(l + ZC.MAPTX) + "," + ZC._i_(r + ZC.MAPTX) + "," + ZC._i_(l + o / 3 + ZC.MAPTX) + "," + ZC._i_(r + s + ZC.MAPTX), n += '" />');
      var A = new DW(a);
      A.K = a.K + "-history-forw", A.copy(t), A.CY = !1, a.OB !== a.QW.length - 1 && 0 !== a.QW.length || A.copy(i), A.D = [[l + o, r + s / 2], [l + 2 * o / 3, r], [l + 2 * o / 3, r + s], [l + o, r + s / 2]], A.IW = ZC.AK(a.A.K + "-text"), A.Z = A.C7 = ZC.AK(a.K + "-static-c"), A.parse(), A.paint(), a.OB < a.QW.length - 1 && (n += ZC.Q.G2("rect", !0) + 'class="' + a.K + '-history-area zc-history-area" id="' + a.K + "-history-forw-area" + ZC._[30], n += ZC._i_(l + 2 * o / 3 + ZC.MAPTX) + "," + ZC._i_(r + ZC.MAPTX) + "," + ZC._i_(l + o + ZC.MAPTX) + "," + ZC._i_(r + s + ZC.MAPTX), n += '" />'), "" !== n && (ZC.AK(a.K + "-map").innerHTML += n), a.A1B = function (e) {
        e.target.id === a.K + "-history-back-area" ? zingchart.exec(a.K, "goback") : e.target.id === a.K + "-history-forw-area" && zingchart.exec(a.K, "goforward");
      }, ZC.A5("." + a.K + "-history-area").live("click", a.A1B);
    }
  }, ZC.AP = {
    A55: 1,
    E2: 0,
    E1: 0,
    FV: 40
  }, ZC.DH = {
    A3C: function A3C(e, t) {
      var i, a;
      return t.A9 % 180 == 0 ? (i = new CC(e, -e.I / 2, t.iY - e.iY - e.F / 4, 0), a = new CC(e, e.I / 2, t.iY - e.iY - e.F / 4, 0)) : (i = new CC(e, t.iX - e.iX - e.I / 4, -e.F / 2, 0), a = new CC(e, t.iX - e.iX - e.I / 4, e.F / 2, 0)), ZC.UE(Math.atan((a.EC[1] - i.EC[1]) / (a.EC[0] - i.EC[0]))) + (t.A9 % 180 == 0 ? 0 : t.A9 % 360 == 90 ? 90 : -90);
    },
    DA: function DA(e, t, i, a, n, l, r, o, s) {
      s = s || "z";
      var C,
        A,
        Z,
        c,
        p = new A07(e, t);
      switch (s) {
        case "x":
          C = new CC(t, i, n, r), A = new CC(t, a, n, r), Z = new CC(t, a, l, o), c = new CC(t, i, l, o);
          break;
        case "y":
          C = new CC(t, i, n, r), A = new CC(t, i, l, r), Z = new CC(t, a, l, o), c = new CC(t, a, n, o);
          break;
        case "z":
          C = new CC(t, i, n, r), A = new CC(t, i, n, o), Z = new CC(t, a, l, o), c = new CC(t, a, l, r);
      }
      return p.add(C), p.add(A), p.add(Z), p.add(c), p;
    },
    D7: function D7(e, t, i, a) {
      typeof a === ZC._[31] && (a = !1);
      var n,
        l = null,
        r = null;
      i instanceof Array ? l = i : (l = i.points, r = i.mathpoints);
      for (var o = new A07(e, t), s = 0, C = l.length; s < C; s++) null !== ZC._n_(l[s]) && (a ? o.add(l[s], r ? r[s] : null) : o.add(new CC(t, l[s][0], l[s][1], l[s][2]), r ? new CC(t, r[s][0], r[s][1], r[s][2]) : null));
      return (n = e.o["z-modifier"]) && (o.MO = [ZC._i_(n), ZC._i_(n), ZC._i_(n)]), o;
    }
  };
  var CC = /*#__PURE__*/function (_ZCClass2) {
    _inherits(CC, _ZCClass2);
    function CC(e, t, i, a) {
      var _this8;
      _classCallCheck(this, CC);
      _this8 = _possibleConstructorReturn(this, _getPrototypeOf(CC).call(this)), _this8.parse(e, t, i, a);
      return _this8;
    }
    _createClass(CC, [{
      key: "parse",
      value: function parse(e, t, i, a) {
        var n = this;
        n.C = e, n.iX = t, n.iY = i, a -= n.C.EZ.depth / 2, n.iZ = a, n.EJ = 0, n.EO = 0, n.AB4 = 0, n.EC = [];
        var l = n.C.EZ.angle,
          r = n.C.EZ.zoom;
        if (n.C.EZ.true3d) {
          var o = {
              x: t,
              y: i,
              z: a
            },
            s = {
              x: 0,
              y: 0,
              z: 0
            },
            C = {
              x: n.C.EZ[ZC._[27]],
              y: n.C.EZ[ZC._[28]],
              z: n.C.EZ[ZC._[29]]
            },
            A = 2 * Math.PI / 360,
            Z = Math.sin(C.x * A),
            c = Math.sin(C.y * A),
            p = Math.sin(C.z * A),
            u = Math.cos(C.x * A),
            h = Math.cos(C.y * A),
            _ = Math.cos(C.z * A);
          n.EJ = h * (p * (o.y - s.y) + _ * (o.x - s.x)) - c * (o.z - s.z), n.EO = Z * (h * (o.z - s.z) + c * (p * (o.y - s.y) + _ * (o.x - s.x))) + u * (_ * (o.y - s.y) - p * (o.x - s.x)), n.AB4 = u * (h * (o.z - s.z) + c * (p * (o.y - s.y) + _ * (o.x - s.x))) - Z * (_ * (o.y - s.y) - p * (o.x - s.x)), n.EC[0] = ZC.AP.E2 + ZC.AP.A55 / (ZC.AP.A55 + n.AB4) * n.EJ * r, n.EC[1] = ZC.AP.E1 + ZC.AP.A55 / (ZC.AP.A55 + n.AB4) * n.EO * r;
        } else n.EC[0] = ZC.AP.E2 + t + a * ZC.EG(l) * r, n.EC[1] = ZC.AP.E1 + i - a * ZC.EN(l) * r;
      }
    }]);
    return CC;
  }(ZCClass);
  zingchart.getZCPoint3D = function (e, t, i, a) {
    return new CC(e, t, i, a);
  };
  var A07 = /*#__PURE__*/function (_ZCClass3) {
    _inherits(A07, _ZCClass3);
    function A07(e, t) {
      var _this9;
      _classCallCheck(this, A07);
      _this9 = _possibleConstructorReturn(this, _getPrototypeOf(A07).call(this));
      var i = _assertThisInitialized(_this9);
      i.C = t, i.N = e, i.K = "", i.KE = !1, i.MO = [1, 1, 1], i.G0 = -1, i.D = [], i.PN = [], i.SV = -9999, i.A08 = -9999, i.A60 = 9999, i.A63 = 9999, i.AA7 = 9999, i.A4F = 0, i.A2J = 0, i.AC7 = 0;
      return _this9;
    }
    _createClass(A07, [{
      key: "add",
      value: function add(e, t) {
        this.D.push(e), this.PN.push(t || e);
      }
    }, {
      key: "ABU",
      value: function ABU() {
        for (var e = this, t = e.PN.length, i = 0; i < t; i++) {
          var a = e.PN[i];
          e.SV = ZC.BQ(e.SV, a.iZ), ZC._b_(e.C.EZ.true3d) ? (e.A60 = ZC.CX(e.A60, a.iZ), e.A08 = ZC.BQ(e.A08, a.AB4), e.A2J += a.iY) : (e.A63 = ZC.CX(e.A63, a.iX), e.AA7 = ZC.CX(e.AA7, a.iY), e.A4F += a.iX, e.A2J += a.iY, e.AC7 += a.iZ);
        }
        e.A4F /= t, e.A2J /= t, e.AC7 /= t;
      }
    }, {
      key: "F1",
      value: function F1() {
        for (var e = this, t = "", i = 0, a = e.D.length; i < a; i++) t += ZC._i_(e.D[i].EC[0] + ZC.MAPTX) + "," + ZC._i_(e.D[i].EC[1] + ZC.MAPTX) + ",";
        return t = t.substring(0, t.length - 1);
      }
    }]);
    return A07;
  }(ZCClass);
  var VP = /*#__PURE__*/function (_ZCClass4) {
    _inherits(VP, _ZCClass4);
    function VP() {
      var _this10;
      _classCallCheck(this, VP);
      _this10 = _possibleConstructorReturn(this, _getPrototypeOf(VP).call(this));
      var e = _assertThisInitialized(_this10);
      e.A58 = [], e.A70 = {}, e.XA = [], e.SS = {};
      return _this10;
    }
    _createClass(VP, [{
      key: "clear",
      value: function clear() {
        var e = this;
        e.A58 = [], e.XA = [], e.SS = {};
      }
    }, {
      key: "add",
      value: function add(e) {
        this.A58.push(e);
      }
    }, {
      key: "sortFaces",
      value: function sortFaces(e, t) {
        return 1 === zingchart.V3D ? e[0][0] > t[0][0] ? -1 : e[0][0] < t[0][0] ? 1 : e[0][1] > t[0][1] ? 1 : e[0][1] < t[0][1] ? -1 : e[0][2] > t[0][2] ? -1 : e[0][2] < t[0][2] ? 1 : e[0][3] > t[0][3] ? -1 : e[0][3] < t[0][3] ? 1 : 0 : 2 === zingchart.V3D ? -1 !== e[0][3] || -1 !== t[0][3] ? e[0][3] > t[0][3] ? 1 : e[0][3] < t[0][3] ? -1 : 0 : e[0][0] > t[0][0] ? -1 : e[0][0] < t[0][0] ? 1 : e[0][1] > t[0][1] ? 1 : e[0][1] < t[0][1] ? -1 : e[0][2] > t[0][2] ? 1 : e[0][2] < t[0][2] ? -1 : 0 : 3 === zingchart.V3D ? e[0] > t[0] ? -1 : e[0] < t[0] ? 1 : 0 : void 0;
      }
    }]);
    return VP;
  }(ZCClass);
  var A94 = /*#__PURE__*/function (_ZCClass5) {
    _inherits(A94, _ZCClass5);
    function A94(e) {
      var _this11;
      _classCallCheck(this, A94);
      _this11 = _possibleConstructorReturn(this, _getPrototypeOf(A94).call(this, e));
      var t = _assertThisInitialized(_this11);
      t.H = e, t.W2 = !1, t.P3 = 250, t.GK = 0, t.IO = 0, t.H2 = 20, t.BA = "", t.CF = [], t.A7 = null;
      return _this11;
    }
    _createClass(A94, [{
      key: "onmouseout",
      value: function onmouseout() {
        var e = this;
        ZC.mobile || (e.W2 ? (null !== ZC._n_(e.C4) && window.clearInterval(e.C4), e.C4 = window.setInterval(function () {
          var t = e.H.K,
            i = ZC.A5("#" + t + ("svg" === e.H.AA ? "-top" : "-main")),
            a = ZC.E0[0] - i.offset().left,
            n = ZC.E0[1] - i.offset().top;
          ZC.DR(a, e.GK, e.GK + e.A7.I) && ZC.DR(n, e.IO, e.IO + e.A7.F) || (null !== ZC._n_(e.C4) && window.clearInterval(e.C4), e.hide());
        }, e.P3)) : e.hide());
      }
    }, {
      key: "clear",
      value: function clear() {
        var e = this;
        ZC.Q.IT(ZC.AK(e.H.K + "-tooltip-c"), e.H.AA, e.iX, e.iY, e.I, e.F, e.K);
      }
    }, {
      key: "hide",
      value: function hide() {
        if (!ZC.TTLOCK) {
          var e = this.H.K;
          ZC.Q.EU([e + "-tooltip-text", e + "-tooltip", e + "-tooltip-text-float"]), "svg" === this.H.AA && ZC.A5("clipPath").each(function () {
            -1 !== this.id.indexOf("-hover_image-clip") && ZC.Q.EU(this.id);
          });
        }
      }
    }, {
      key: "show",
      value: function show(e) {
        var t,
          i = this;
        null !== ZC._n_(i.C4) && window.clearInterval(i.C4);
        var a = i.H.K;
        if (0 !== ZC.A5("#" + a + "-tooltip-c").length && i.A7) {
          var n = ZC._tx_(i.H.K),
            l = ZC.Q.MM(e),
            r = ZC.A5("#" + a + ("svg" === i.H.AA ? "-top" : "-main")),
            o = null === ZC._n_(e.target) ? i.A7.o.x : l[0] - r.offset().left,
            s = null === ZC._n_(e.target) ? i.A7.o.y : l[1] - r.offset().top,
            C = o - i.A7.I * n[0] / 2,
            A = s - i.A7.F * n[1],
            Z = C,
            c = 1 + 2 * i.A7.K1;
          if (null !== ZC._n_(i.A7.o.x) && ((C = ZC.IU(i.A7.o.x, !0)) > 0 && C < 1 && (C = ZC._i_(i.H.I * C)), i.A7.o.fixed && (C -= i.A7.I / 2)), null !== ZC._n_(i.A7.o.y) && ((A = ZC.IU(i.A7.o.y, !0)) > 0 && A < 1 && (A = ZC._i_(i.H.F * A)), i.A7.o.fixed && (A -= i.A7.F / 2)), C += ZC._i_(i.A7.E["offset-x"]), A += ZC._i_(i.A7.E["offset-y"]), "svg" === i.H.AA || !i.A7.o[ZC._[7]] || i.A7.o.fixed) {
            var p = 0,
              u = !1,
              h = i.A7.EL;
            C / n[0] < c && (p = Z / n[0] - c - i.A7.HC / 2, C = c), C / n[0] + i.A7.I > i.H.I - c && (p = Z / n[0] + i.A7.I - i.H.I + c + i.A7.HC / 2, C = (i.H.I - c - i.A7.I) * n[0]), A / n[1] < c && (i.CF.node || !i.A7.o[ZC._[7]] || i.A7.o.fixed ? (A = c + ZC._i_(i.A7.E["offset-y"]), A = i.CF.node ? A < c ? c : A : A < c ? s - ZC._i_(i.A7.E["offset-y"]) : A, h = "top", u = !0) : A = c + (s - ZC._i_(i.A7.E["offset-y"]))), A / n[1] + i.A7.F > i.H.F - c && (A = i.H.F - c - i.A7.F, (i.CF.node || !i.A7.o[ZC._[7]] || i.A7.o.fixed) && (h = "top", u = !0)), u && (i.A7.EL = h), (0 !== p || u) && i.A7.Z && (i.clear(), u && (i.A7.EL = h), p = ZC.CX(p, i.A7.I / 2 - i.A7.HC / 2), p = 48 * (p = ZC.BQ(p, -i.A7.I / 2 + i.A7.HC / 2)) / (i.A7.I / 2 - i.A7.HC / 2), i.A7.EV = p, i.A7.AN && i.A7.paint());
          }
          switch (i.GK = C, i.IO = A, i.H.AA) {
            case "svg":
              null === ZC._n_(i.A7.o.x) && null === ZC._n_(i.A7.o.y) && ZC.AK(a + "-tooltip").setAttribute("transform", "translate(" + C / n[0] + "," + A / n[1] + ")"), i.A7.E["html-mode"] && ZC.Q.PV(ZC.AK(a + "-tooltip-text-float"), {
                left: ("" === i.BA ? C / n[0] : i.A7.iX) + i.A7.EP + "px",
                top: ("" === i.BA ? A / n[1] : i.A7.iY) + i.A7.FO + "px"
              });
              break;
            case "vml":
              null === ZC._n_(i.A7.o.x) && null === ZC._n_(i.A7.o.y) && ZC.Q.PV(ZC.AK(a + "-tooltip"), {
                left: C + "px",
                top: A + "px"
              });
              break;
            case "canvas":
              null !== ZC._n_(i.CF.x) && (C = i.CF.x), null !== ZC._n_(i.CF.y) && (A = i.CF.y);
              var _ = i.A7.E["html-mode"] ? 0 : 20;
              switch (i.A7.XB) {
                case "tl":
                  break;
                case "tr":
                  C -= i.A7.I;
                  break;
                case "bl":
                  A -= i.A7.F;
                  break;
                case "br":
                  C -= i.A7.I, A -= i.A7.F;
                  break;
                case "c":
                  C -= i.A7.I / 2, A -= i.A7.F / 2;
                  break;
                case "t":
                  C -= i.A7.I / 2;
                  break;
                case "r":
                  C -= i.A7.I, A -= i.A7.F / 2;
                  break;
                case "b":
                  C -= i.A7.I / 2, A -= i.A7.F;
                  break;
                case "l":
                  A -= i.A7.F / 2;
              }
              ZC.Q.PV(ZC.AK(a + "-tooltip-c"), {
                left: C / n[0] - _ + "px",
                top: A / n[1] - _ + "px"
              }), null !== (t = ZC.AK(a + "-tooltip-text")) && (t.style.display = "none", ZC.Q.PV(t, {
                width: i.A7.I + "px",
                height: i.A7.F + "px",
                left: C / n[0] + "px",
                top: A / n[1] + "px"
              }), t.style.display = "block");
          }
        }
      }
    }, {
      key: "onmousemove",
      value: function onmousemove(e) {
        this.show(e);
      }
    }, {
      key: "onmouseover",
      value: function onmouseover(e, t) {
        var i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this,
          A = C.H.K,
          Z = e.targetid || e.target.id,
          c = Z.replace(/--([a-zA-Z0-9]+)/, "").replace("-gshape-area", "-area").replace("-area-path", "").replace("-path", "").replace("-marker-circle", "").replace("-marker", "").split("-").reverse(),
          p = Z.split("--"),
          u = !1,
          h = !1,
          _ = !1;
        if ("node" === c[1] && "plot" === c[3] && "plotset" === c[4] && (u = !0), ZC.Q.EU([A + "-tooltip-text", A + "-tooltip", A + "-tooltip-text-float"]), u) {
          if (!(l = C.H.OJ(c[5]))) return;
          if (r = l.AY.A4[c[2]], o = r.FK(c[0]), "xy" === l.AJ.layout && o.S0(), !o) return;
          ZC.A5("#" + A + "-graph-" + c[5] + "-plot-" + c[2] + "-bg-hover-c").show();
        } else "legend" === c[2] && 0 === c[1].indexOf("item") && (h = !0), 0 !== c[2].indexOf("scale") || 0 !== c[1].indexOf("item") && 0 !== c[1].indexOf("marker") || (_ = !0), l = C.H.OJ(c[3]);
        if (ZC.AK(A + "-tooltip") || (ZC.Q.K5({
          id: A + "-tooltip",
          p: ZC.AK(A + "-main"),
          cls: "zc-abs zc-tooltip",
          wh: C.H.I + "/" + C.H.F,
          overflow: "hidden"
        }, C.H.AA), ZC.Q.HJ({
          id: A + "-tooltip-c",
          p: ZC.AK(A + "-tooltip"),
          cls: "zc-abs",
          tl: "-999/-999",
          width: 140,
          height: 60
        }, C.H.AA)), C.A7 = zingchart.pool.getInstance("DT", C, A + "-tooltip-text"), C.A7.OP = "tooltip", C.A7.A = C.H, l && l.A7 && C.A7.copy(l.A7), u) C.A7.append(r.A7.o), l.C9["p" + r.L] && l.C9["p" + r.L]["n" + o.L] && C.A7.append(r.A7.o[ZC._[73]]), 2 === p.length && C.A7.append(r.A2K(p[1]));else {
          var d = !1;
          if (h && l.BC && null !== ZC._n_(l.BC.o.tooltip) && (C.A7.o.text = "", C.A7.append(l.BC.o.tooltip), d = !0), _) {
            C.A7.append({
              "background-color": "#fff",
              "border-width": 1,
              "border-color": "#999"
            });
            var f = l.BJ(c[2].replace(/\_/g, "-"));
            if (f && null !== ZC._n_(f.o.tooltip) && (C.A7.o.text = "", C.A7.append(f.o.tooltip), d = !0), 0 === c[1].indexOf("item_")) f && (-1 !== c[1].indexOf("_title") && f.o.label && f.o.label.tooltip ? (C.A7.o.text = "", C.A7.append(f.o.label.tooltip), d = !0) : f.o.item && f.o.item.tooltip && (C.A7.o.text = "", C.A7.append(f.o.item.tooltip), d = !0));else if (0 === c[1].indexOf("marker_")) {
              var g = ZC._i_(c[1].replace("marker_", ""));
              f.QI[g] && f.QI[g].o.label && f.QI[g].o.label.tooltip && (C.A7.o.text = "", C.A7.append(f.QI[g].o.label.tooltip), d = !0);
            }
          }
          if ("shape" === c[2]) if (C.A7.append({
            "background-color": "#fff",
            "border-width": 1,
            "border-color": "#999"
          }), e.target.getAttribute("data-lowlevel")) C.A7.append({
            text: e.target.getAttribute("data-tooltip-text")
          }), d = !0;else for (a = 0, n = l.FJ.length; a < n; a++) if (null !== ZC._n_(l.FJ[a])) {
            var B = l.FJ[a] instanceof QZ ? l.FJ[a].BF : l.FJ[a];
            l.K + "-shape-" + c[1] === l.FJ[a].K && null !== ZC._n_(i = B.o.tooltip) && (C.A7.append(i), C.A7.o.fixed && (C.A7.o.x = B.iX, C.A7.o.y = B.iY), d = !0);
          }
          if ("label" === c[2]) for (C.A7.append({
            "background-color": "#fff",
            "border-width": 1,
            "border-color": "#999"
          }), a = 0, n = l.BY.length; a < n; a++) l.K + "-label-" + c[1] === l.BY[a].K && null !== ZC._n_(i = l.BY[a].o.tooltip) && (C.A7.append(i), C.A7.o.fixed && (C.A7.o.x = l.BY[a].iX + l.BY[a].I / 2, C.A7.o.y = l.BY[a].iY + l.BY[a].F / 2), d = !0);
          if ("xy" === c[2] && (C.A7.append({
            "background-color": "#fff",
            "border-width": 1,
            "border-color": "#999"
          }), d = !0), !d) return;
        }
        if (t && C.A7.append(t), C.W2 = !1, C.P3 = 250, null !== ZC._n_(i = C.A7.o.sticky) && (C.W2 = ZC._b_(i)), null !== ZC._n_(i = C.A7.o.timeout) && (C.P3 = ZC._i_(i)), null !== ZC._n_(i = C.A7.o[ZC._[7]]) ? C.BA = i : C.BA = "", null !== ZC._n_(i = C.A7.o.distance) && (C.H2 = ZC._i_(i)), C.A7.iX = 0, C.A7.iY = 0, C.A7.Z = C.A7.C7 = ZC.AK(A + "-tooltip-c"), u) {
          s = o.KD(), o.GN(s), null !== ZC._n_(s["line-color"]) ? C.A7.A0 = C.A7.AE = ZC.AQ.JP(s["line-color"]) : C.A7.A0 = C.A7.AE = ZC.AQ.JP(s[ZC._[0]]), C.A7.BW = s[ZC._[61]], C.A7.C2 = s.color, null !== ZC._n_(r.o.rules) ? (C.A0G || (C.A0G = new IM(r.A), C.A0G.E["quick-parse"] = !0), C.A0G.append(r.o), C.A0G.parse(), C.A0G.IV = function (e) {
            return o.IV(e);
          }, C.A0G.DB() && C.A0G.parse(), C.A7.AO = C.A0G.JD) : C.A7.AO = r.JD;
          var v = ZC.AQ.OE(C.A7.o, r.o);
          C.A7.ES = function (e) {
            return o.ES(e, v);
          }, C.A7.E.plotidx = o.A.L, C.A7.E.nodeidx = o.L;
        } else if (h) {
          for (r = l.AY.A4[c[1].replace("item_", "")], C.A7.append(r.o["legend-tooltip"]), o = null, a = 0, n = r.S.length; a < n; a++) if (null !== r.S[a]) {
            o = r.FK(a);
            break;
          }
          if (o) {
            if ("-1" === (s = o.KD())[ZC._[0]]) return;
            C.A7.A0 = C.A7.AE = ZC.AQ.JP(s[ZC._[0]]), C.A7.C2 = s.color;
          } else C.A7.A0 = C.A7.AE = ZC.AQ.JP(r.BP[1]), C.A7.C2 = r.BP[0];
          C.A7.AO = r.PC, C.A7.ES = function (e) {
            return e = (e = e.replace(/%plot-description/g, r.PC)).replace(/%plot-text|%t/g, r.AO);
          };
        } else if (_) {
          if (0 === c[1].indexOf("item_")) {
            var m = c[1].replace("item_", "").split("_"),
              b = 1 === m.length ? ZC._i_(m[0]) : ZC._i_(m[1]);
            C.A7.ES = function (e) {
              e = e || "%scale-value";
              var t = f.BY[b] || f.V[b];
              if (f.FI) {
                var i = {
                  "transform-date": !0,
                  "transform-date-format": f.FI.o.all || f.FI.o.text || "",
                  utc: l.UY,
                  timezone: l.NI
                };
                t = ZC.AQ.G5(t, i, C.A, !!f.FI && f.FI);
              }
              for (var a in "number" == typeof t && f.J0 && null !== ZC._n_(f.J0[t]) && (t = f.J0[t]), e = (e = e.replace(/%text|%item-text|%scale-value|%v/g, t)).replace(/%tooltip-text/g, f.A65[b] || ""), f.o) f.o.hasOwnProperty(a) && "data-" === a.substring(0, 5) && (e = e.replace("%" + a, f.o[a][b] || "", "g"));
              return e;
            };
          }
        } else C.A7.ES = function (e) {
          return e;
        };
        if (null === ZC._n_(C.A7.o["text-alpha"]) && (C.A7.o["text-alpha"] = 1), C.A7.parse(), !u && "canvas" !== C.H.AA && C.A7.o.fixed && (C.A7.iX = C.A7.iX - C.A7.I / 2 + C.A7.BM, C.A7.iY = C.A7.iY - C.A7.F / 2 + C.A7.BH), C.A7.AN) {
          var E, K;
          if (C.A7.I1 && (u && C.A7.GN(C.A7, C.A7, null, o.LM(e, !1)), C.A7.parse()), C.A7.E["html-mode"] = !1, null !== ZC._n_(i = C.A7.o["html-mode"]) && (C.A7.E["html-mode"] = ZC._b_(i)), u && (C.A7.IV = function (e) {
            return o.IV(e);
          }, C.A7.DB() && C.A7.parse()), "canvas" !== C.H.AA && "vml" !== C.H.AA || 0 === C.A7.A9) E = C.A7.I + C.A7.K1, K = C.A7.F + C.A7.K1, E += 40, K += 40, C.A7.E["offset-x"] = C.A7.BM, C.A7.E["offset-y"] = C.A7.BH;else {
            var D = 1.25 * ZC.BQ(C.A7.I, C.A7.F) + C.A7.K1;
            E = D, K = D, C.A7.iX += (D - C.A7.I) / 2, C.A7.iY += (D - C.A7.F) / 2, C.A7.E["offset-x"] = -(D - C.A7.I) / 2 + C.A7.BM, C.A7.E["offset-y"] = -(D - C.A7.F) / 2 + C.A7.BH;
          }
          if (ZC.A5("#" + A + "-tooltip-c").attr(ZC._[19], E).attr(ZC._[20], K), "vml" === C.H.AA && ZC.Q.PV(ZC.AK(A + "-tooltip-c"), {
            top: 0,
            left: 0
          }), C.A7.QM = C.A7.BM, C.A7.ML = C.A7.BH, C.A7.BM = 0, C.A7.BH = 0, !e.type && u) {
            var F = o.iX,
              I = o.iY;
            if (null !== ZC._n_(o.bCXY)) {
              var x = o.A6B();
              F = x[0], I = x[1];
            }
            "canvas" === C.H.AA ? (null === ZC._n_(C.A7.o.x) && (C.A7.o.x = F - C.A7.I / 2), null === ZC._n_(C.A7.o.y) && (C.A7.o.y = I - C.A7.F)) : (null === ZC._n_(C.A7.o.x) && (C.A7.iX = F - C.A7.I / 2), null === ZC._n_(C.A7.o.y) && (C.A7.iY = I - C.A7.F - 20));
          }
          if (u && (C.CF = C.getPlacementInfo(o), "" !== C.BA && ("canvas" !== C.H.AA ? (C.A7.o.x = C.A7.iX = C.CF.x, C.A7.o.y = C.A7.iY = C.CF.y) : (C.A7.o.x = C.A7.iX = 0, C.A7.o.y = C.A7.iY = 0), C.A7.EL = C.CF.cp, C.A7.EV = C.CF.co)), C.A7.AN && "" !== C.A7.AO && ("canvas" === C.H.AA && (C.A7.E["html-mode"] || (C.A7.iX = 20, C.A7.iY = 20)), C.A7.paint()), (e.type && u || e.update) && (o.XD(), o.C.Q1(!0)), e.type || "canvas" === C.H.AA) C.show(e);else if (C.A7.E["html-mode"]) {
            var y = C.A7.iX + C.A7.EP,
              X = C.A7.iY + C.A7.FO;
            ZC.Q.PV(ZC.AK(A + "-tooltip-text-float"), {
              left: y + "px",
              top: X + "px",
              zIndex: zingchart.ZINDEX
            });
          }
        }
      }
    }, {
      key: "getPlacementInfo",
      value: function getPlacementInfo(e) {
        var t,
          i = this,
          a = {},
          n = i.A7.HC,
          l = i.A7.GA,
          r = i.A7.I,
          o = i.A7.F;
        if (i.A7.E["html-mode"] && ("horizontal" === i.BA || "vertical" === i.BA || "node:" === i.BA.substring(0, 5)) && (i.A7.iX = -9999, i.A7.iY = -9999, i.A7.AN)) {
          i.A7.paint();
          var s = ZC.A5("#" + i.H.K + "-tooltip-text-" + ("canvas" === i.H.AA ? "t" : "float"));
          r = s.width() + i.A7.EP + i.A7.FP, o = s.height() + i.A7.FO + i.A7.FS, null !== ZC._n_(i.A7.o[ZC._[19]]) && (r = ZC._i_(i.A7.o[ZC._[19]])), null !== ZC._n_(i.A7.o[ZC._[20]]) && (o = ZC._i_(i.A7.o[ZC._[20]]));
        }
        if ("horizontal" === i.BA) e.iX + e.I / 2 < e.C.iX + e.C.I / 2 ? (a.x = e.iX + 0 * e.I + i.H2, a.y = e.iY + 0 * e.F / 2 - o / 2, a.cp = "left") : (a.x = e.iX - r - i.H2, a.y = e.iY + 0 * e.F / 2 - o / 2, a.cp = "right"), a.y < 5 && (t = 5 - a.y, a.co = -ZC._i_(100 * t / (o - l)), a.y = 5), a.y + o > i.H.F - 5 && (t = i.H.F - 5 - a.y - o, a.co = -ZC._i_(100 * t / (o - l)), a.y = i.H.F - 5 - o);else if ("vertical" === i.BA) e.iY + e.F / 2 < e.C.iY + e.C.F / 2 ? (a.y = e.iY + 0 * e.F + i.H2, a.x = e.iX + 0 * e.I / 2 - r / 2, a.cp = "top") : (a.y = e.iY - o - i.H2, a.x = e.iX + 0 * e.I / 2 - r / 2, a.cp = "bottom"), a.x < 5 && (t = 5 - a.x, a.co = -ZC._i_(100 * t / (i.A7.I - n)), a.x = 5), a.x + r > i.H.I - 5 && (t = i.H.I - 5 - a.x - r, a.co = -ZC._i_(100 * t / (r - n)), a.x = i.H.I - 5 - r);else if ("node:" === i.BA.substring(0, 5) && e.getTooltipPosition) {
          switch ((a = e.getTooltipPosition(i.A7, i.BA.substring(5))).node = !0, a.side = i.BA.substring(5), a.side) {
            case "left":
              a.x = a.x - r + i.A7.QM, a.y = a.y - o / 2 + i.A7.ML;
              break;
            case "right":
              a.x = a.x + i.A7.QM, a.y = a.y - o / 2 + i.A7.ML;
              break;
            case "top":
              a.x = a.x - r / 2 + i.A7.QM, a.y = a.y - o + i.A7.ML;
              break;
            case "bottom":
              a.x = a.x - r / 2 + i.A7.QM, a.y = a.y + i.A7.ML;
              break;
            case "center":
              a.x = a.x - r / 2 + i.A7.QM, a.y = a.y - o / 2 + i.A7.ML;
          }
          a.cp = i.A7.EL;
        }
        if (a.node) {
          var C = 0;
          a.y + o > i.H.F - 5 && ("top" === a.side || "bottom" === a.side ? (a.y = a.y - o - ("bottom" === a.side ? 0 : i.A7.GA) - i.A7.ML, a.cp = "bottom") : a.y = i.H.F - o - 5), a.y < 5 && ("top" === a.side || "bottom" === a.side ? (a.y = a.y + ("top" === a.side ? 0 : i.A7.GA) + o - i.A7.ML, a.cp = "top") : a.y = 5), a.x + r > i.H.I - 5 && ("left" === a.side || "right" === a.side ? (a.x = a.x - r - i.A7.QM - 5, a.cp = "right") : (C = 48 * (r - i.H.I + a.x + i.A7.HC / 2) / (i.A7.I / 2), a.x = i.H.I - r - i.A7.QM - 5), a.co = C), a.x < 5 && ("left" === a.side || "right" === a.side ? (a.x = a.x + i.A7.I - i.A7.QM + 5, a.cp = "left") : (C = 48 * (a.x - i.A7.HC / 2) / (i.A7.I / 2), a.x = 5), a.co = C);
        }
        return a;
      }
    }]);
    return A94;
  }(ZCClass);
  var AAG = /*#__PURE__*/function (_I3) {
    _inherits(AAG, _I3);
    function AAG(e) {
      var _this12;
      _classCallCheck(this, AAG);
      _this12 = _possibleConstructorReturn(this, _getPrototypeOf(AAG).call(this, e));
      var t = _assertThisInitialized(_this12);
      t.H = e, t.IY = !1, t.C = null, t.Q2 = null, t.UZ = null, t.IE = 0, t.LQ = 0, t.IG = 0, t.LP = 0, t.A8 = null, t.AL = null, t.A00 = !1, t.ABN = 0, t.A11 = !1, t.M = null;
      return _this12;
    }
    _createClass(AAG, [{
      key: "parse",
      value: function parse() {
        var e = this;
        e.C && (e.C.H3 && e.append(e.C.H3.o), _get(_getPrototypeOf(AAG.prototype), "parse", this).call(this), e.YU("preserve-zoom", "A11", "b"), e.M = new DT(e), e.C.A.B8.load(e.M.o, "graph.zoom.label"), e.M.append(e.o.label), e.M.parse(), e.o.label && !1 !== e.o.label.visible && (e.M.AN = !0));
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var e = this;
        zingchart.DEV.SKIPTRACKERS ? ZC.A5(document.body).unbind("mousedown touchstart", e.RG) : ZC.A5("#" + e.H.K + "-img").unbind("mousedown touchstart", e.RG), ZC.A5(".zc-node-area").die("mousedown touchstart", e.RG), ZC.A5(document.body).unbind("mousemove touchmove", e.US), ZC.A5(document.body).unbind("mouseup touchend", e.UD);
      }
    }, {
      key: "bind",
      value: function bind() {
        var e = this,
          t = e.H.K;
        e.RG = function (i) {
          if ((!ZC.mobile || "pinch" !== zingchart.TOUCHZOOM) && !(i.which > 1 || -1 !== ZC.Q.TG(i.target).indexOf("zc-menu-item") || ZC.move) && (i.type !== ZC._[47] || !ZC.TOUCHEVENTS) && -1 === i.target.id.indexOf("-legend-header-area") && (ZC.mobile || i.preventDefault(), e.H.hideCM(), (ZC.mobile || !(i.which > 1)) && ("vml" !== e.H.AA || -1 === i.target.className.indexOf("zc-node-area")))) {
            i.shiftKey && (e.A00 = !0);
            var a = ZC.Q.MM(i),
              n = ZC._tx_(e.H.K),
              l = ZC.A5("#" + t + "-top").offset(),
              r = (a[0] - l.left) / n[0],
              o = (a[1] - l.top) / n[1];
            e.Q2 = r, e.UZ = o, e.A00 && (e.ABN = r);
            for (var s, C = !1, A = 0, Z = e.H.AG.length; A < Z; A++) s = e.H.AG[A].P, ZC.DR(r, s.iX - 5, s.iX + s.I + 5) && ZC.DR(o, s.iY - 5, s.iY + s.F + 5) && (e.C = e.H.AG[A]);
            if (null !== e.C) {
              var c = {
                  id: e.H.K,
                  graphid: e.C.K,
                  ev: i
                },
                p = ZC.AQ.BZ("beforezoom", e.H, c, !0);
              if (typeof p !== ZC._[31] && !p) return;
              if (e.C.H3 && null !== ZC._n_(e.C.H3.o.active) && !ZC._b_(e.C.H3.o.active)) return;
              s = e.C.P, e.C.AY.A4.length > 0 && (e.A8 = e.C.BJ(e.C.AY.A4[0].BT("k")[0]), e.AL = e.C.BJ(e.C.AY.A4[0].BT("v")[0])), null !== e.A8 && null !== e.AL && e.C.AJ["enable-zooming"] && (e.A8.GQ || e.AL.GQ) && (e.IE = e.A8.CO ? o : r, e.IG = e.AL.CO ? r : o, C = !0, e.A8.GQ ? e.A8.CO ? e.IE = ZC._l_(e.IE, s.iY, s.iY + s.F) : e.IE = ZC._l_(e.IE, s.iX, s.iX + s.I) : e.IE = e.A8.CO ? s.iY : s.iX, e.AL.GQ ? e.AL.CO ? e.IG = ZC._l_(e.IG, s.iX, s.iX + s.I) : e.IG = ZC._l_(e.IG, s.iY, s.iY + s.F) : e.IG = e.AL.CO ? s.iX : s.iY);
            }
            return C && (e.LQ = e.IE, e.LP = e.IG, e.IY = !0, ZC.A5(document.body).bind("mousemove touchmove", e.US), ZC.A5(document.body).bind("mouseup touchend", e.UD), e.A00 ? document.body.style.cursor = "pointer" : (e.parse(), e.C.AJ["3d"] || ZC.Q.I7({
              id: t + "-zoom",
              p: ZC.AK(t + "-top"),
              top: -9,
              left: -9,
              wh: "1/1",
              position: "absolute",
              border: e.AU + "px solid " + e.BW,
              background: e.A0,
              opacity: e.C6
            }), e.M.AN && (ZC.Q.I7({
              id: t + "-from",
              p: ZC.AK(t + "-top"),
              top: -9999,
              left: -9999,
              position: "absolute",
              paddingTop: e.M.FO,
              paddingRight: e.M.FP,
              paddingBottom: e.M.FS,
              paddingLeft: e.M.EP,
              border: e.M.AU + "px solid " + e.M.BW,
              background: e.M.A0,
              color: e.M.C2,
              fontFamily: e.M.GJ,
              fontWeight: e.M.sFontWeight,
              fontStyle: e.M.ND ? "oblique" : "normal",
              fontSize: e.M.DG,
              text: ""
            }), ZC.Q.I7({
              id: t + "-to",
              p: ZC.AK(t + "-top"),
              top: -9999,
              left: -9999,
              position: "absolute",
              paddingTop: e.M.FO,
              paddingRight: e.M.FP,
              paddingBottom: e.M.FS,
              paddingLeft: e.M.EP,
              border: e.M.AU + "px solid " + e.M.BW,
              background: e.M.A0,
              color: e.M.C2,
              fontFamily: e.M.GJ,
              fontWeight: e.M.sFontWeight,
              fontStyle: e.M.ND ? "oblique" : "normal",
              fontSize: e.M.DG,
              text: ""
            })), document.body.style.cursor = "crosshair")), !!ZC.mobile && void 0;
          }
        }, e.US = function (i) {
          if (i.type !== ZC._[48] || !ZC.TOUCHEVENTS) {
            var a, n;
            if (ZC.mobile || i.preventDefault(), ZC.move = !0, e.C || (ZC.move = !1, e.IY = !1, ZC.A5(document.body).unbind("mousemove touchmove", e.US), ZC.A5(document.body).unbind("mouseup touchend", e.UD), document.body.style.cursor = "auto", ZC.Q.EU([t + "-zoom", t + "-from", t + "-to"])), e.IY) {
              e.C.A.A7.hide();
              var l = ZC.Q.MM(i),
                r = ZC._tx_(e.H.K),
                o = ZC.A5("#" + t + "-top").offset(),
                s = (l[0] - o.left) / r[0],
                C = (l[1] - o.top) / r[1];
              if (i.ctrlKey) {
                var A = ZC.CX(s - e.Q2, C - e.UZ);
                s = e.Q2 + A, C = e.UZ + A;
              }
              if (e.LQ = e.A8.CO ? C : s, e.LP = e.AL.CO ? s : C, !e.A00) {
                var Z,
                  c,
                  p,
                  u,
                  h = e.C.P;
                a = e.A8.AW ? e.A8.BV : e.A8.AB, n = e.A8.AW ? e.A8.AB : e.A8.BV, e.A8.GQ ? e.A8.CO ? (e.A8.YQ && (e.IE = e.A8.iY + a + e.A8.AC * ZC._i_((e.IE - e.A8.iY - a) / e.A8.AC), e.LQ = e.A8.iY + a + e.A8.AC * ZC._i_((e.LQ - e.A8.iY - a) / e.A8.AC)), e.IE = ZC._l_(e.IE, h.iY + n, h.iY + h.F - a), e.LQ = ZC._l_(e.LQ, h.iY + n, h.iY + h.F - a)) : (e.A8.YQ && (e.IE = e.A8.iX + a + e.A8.AC * ZC._i_((e.IE - e.A8.iX - a) / e.A8.AC), e.LQ = e.A8.iX + a + e.A8.AC * ZC._i_((e.LQ - e.A8.iX - a) / e.A8.AC)), e.IE = ZC._l_(e.IE, h.iX + a, h.iX + h.I - n), e.LQ = ZC._l_(e.LQ, h.iX + a, h.iX + h.I - n)) : (e.IE = e.A8.CO ? h.iY + n : h.iX + a, e.LQ = e.A8.CO ? h.iY + h.F - a : h.iX + h.I - n), a = e.AL.AW ? e.AL.AB : e.AL.BV, n = e.AL.AW ? e.AL.BV : e.AL.AB, e.AL.GQ ? e.AL.CO ? (e.AL.YQ && (e.IG = e.AL.iX + a + e.AL.AC * ZC._i_((e.IG - e.AL.iX - a) / e.AL.AC), e.LP = e.AL.iX + a + e.AL.AC * ZC._i_((e.LP - e.AL.iX - a) / e.AL.AC)), e.IG = ZC._l_(e.IG, h.iX + n, h.iX + h.I - a), e.LP = ZC._l_(e.LP, h.iX + n, h.iX + h.I - a)) : (e.AL.YQ && (e.IG = e.AL.iY + a + e.AL.AC * ZC._i_((e.IG - e.AL.iY - a) / e.AL.AC), e.LP = e.AL.iY + a + e.AL.AC * ZC._i_((e.LP - e.AL.iY - a) / e.AL.AC)), e.IG = ZC._l_(e.IG, h.iY + a, h.iY + h.F - n), e.LP = ZC._l_(e.LP, h.iY + a, h.iY + h.F - n)) : (e.IG = e.AL.CO ? h.iX + n : h.iY + a, e.LP = e.AL.CO ? h.iX + h.I - a : h.iY + h.F - n);
                var _ = ZC.A5.browser.msie ? 0 : 2 * e.AU;
                e.C.AJ["3d"] && (_ = 0);
                var d = ZC.AK(t + "-zoom");
                if (e.A8.CO && e.AL.CO ? (Z = ZC._a_(e.LP - e.IG - _), c = ZC._a_(e.LQ - e.IE - _), p = ZC.CX(e.IG, e.LP), u = ZC.CX(e.IE, e.LQ)) : (Z = ZC._a_(e.LQ - e.IE - _), c = ZC._a_(e.LP - e.IG - _), p = ZC.CX(e.IE, e.LQ), u = ZC.CX(e.IG, e.LP)), e.C.AJ["3d"]) {
                  e.C.NK();
                  var f = ZC.AK(e.H.K + "-guide-c");
                  f && (ZC.Q.IT(f, e.H.AA, e.C.iX, e.C.iY, e.C.I, e.C.F), ZC.A5(".zc-guide-label").remove()), (d = new DW(e)).Z = f, d.A0 = d.AE = e.A0, d.BW = e.BW, d.AU = e.AU, d.C6 = e.C6, d.D = [[p, u], [p + Z, u], [p + Z, u + c], [p, u + c], [p, u]];
                  for (var g = 0; g < d.D.length; g++) {
                    var B = new CC(e.C, d.D[g][0] - ZC.AP.E2, d.D[g][1] - ZC.AP.E1, 0);
                    d.D[g][0] = B.EC[0], d.D[g][1] = B.EC[1];
                  }
                  d.parse(), d.paint();
                } else ZC.Q.PV(d, {
                  width: Z + "px",
                  height: c + "px",
                  left: p + "px",
                  top: u + "px"
                });
                if (e.M.AN) {
                  var v = ZC.CX(e.IE, e.LQ),
                    m = ZC.BQ(e.IE, e.LQ),
                    b = ZC.CX(e.IG, e.LP),
                    E = ZC.BQ(e.IG, e.LP),
                    K = ZC.AK(t + "-from"),
                    D = ZC.AK(t + "-to"),
                    F = {
                      decimals: null === ZC._n_(e.AL.DM) ? 1 : e.AL.DM
                    };
                  K.innerHTML = e.A8.FC(e.A8.N0(v)) + "/" + e.AL.FC(-1, e.AL.KV(b), F), D.innerHTML = e.A8.FC(e.A8.N0(m)) + "/" + e.AL.FC(-1, e.AL.KV(E), F), ZC.Q.PV(K, {
                    left: p - e.AU - ZC._i_(ZC.A5(K).width()) + "px",
                    top: u - e.AU - ZC._i_(ZC.A5(K).height()) + "px"
                  }), ZC.Q.PV(D, {
                    left: p + e.AU + e.M.AU + Z + "px",
                    top: u + e.AU + e.M.AU + c + "px"
                  });
                }
              }
            }
            return !1;
          }
        }, e.UD = function (i) {
          if ((!i || i.type !== ZC._[49] || !ZC.TOUCHEVENTS) && e.C) {
            if (ZC.move = !1, e.IY = !1, document.body.style.cursor = "auto", ZC.Q.EU([t + "-zoom", t + "-from", t + "-to"]), e.C.AJ["3d"]) {
              e.C.NK();
              var a = ZC.AK(e.H.K + "-guide-c");
              a && (ZC.Q.IT(a, e.H.AA, e.C.iX, e.C.iY, e.C.I, e.C.F), ZC.A5(".zc-guide-label").remove());
            }
            if (ZC.A5(document.body).unbind("mousemove touchmove", e.US), ZC.A5(document.body).unbind("mouseup touchend", e.UD), e.A00) e.A00 = !1;else {
              var n,
                l,
                r,
                o,
                s,
                C,
                A,
                Z,
                c,
                p = {
                  graphid: e.C.K,
                  ev: i
                };
              if (ZC._a_(e.IE - e.LQ) > 10 && ZC._a_(e.IG - e.LP) > 10) {
                var u,
                  h,
                  _ = !1,
                  d = !1;
                for (o = 0, s = (r = e.C.BT("k")).length; o < s; o++) (u = r[o]) && r[o].GQ && (C = 1 === u.L ? "" : "-" + u.L, n = u.N0(ZC.CX(e.IE, e.LQ)), l = u.N0(ZC.BQ(e.IE, e.LQ)), ZC._a_(l - n) >= 1 && (p["zoomx" + C] = !0, p["xmin" + C] = ZC.CX(n, l), p["xmax" + C] = ZC.BQ(n, l), "log" === u.C1 && (p["kmin" + C] = u.V[ZC._i_(ZC.G8(p["xmin" + C], u.E4))], p["kmax" + C] = u.V[ZC._i_(ZC.G8(p["xmax" + C], u.E4))], delete p["xmin" + C], delete p["xmax" + C]), _ = !0));
                for (o = 0, s = (r = e.C.BT("v")).length; o < s; o++) (h = r[o]) && r[o].GQ && (C = 1 === h.L ? "" : "-" + h.L, A = h.KV(ZC.BQ(e.IG, e.LP)), Z = h.KV(ZC.CX(e.IG, e.LP)), c = (h.H4 - h.FX) / Math.pow(10, 10), ZC._a_(Z - A) >= c && (p["zoomy" + C] = !0, p["ymin" + C] = ZC.CX(A, Z), p["ymax" + C] = ZC.BQ(A, Z), d = !0));
                _ || d ? (zingchart.SKIP.EVENT = !0, e.C.A.PP(p)) : zingchart.SKIP.EVENT = !0;
              } else (ZC._a_(e.IE - e.LQ) > 5 || ZC._a_(e.IG - e.LP) > 5) && (zingchart.SKIP.EVENT = !0);
              e.C = null;
            }
          }
        }, ZC.mobile && "normal" !== zingchart.TOUCHZOOM || (zingchart.DEV.SKIPTRACKERS ? ZC.A5(document.body).bind("mousedown touchstart", e.RG) : ZC.A5("#" + t + "-img").bind("mousedown touchstart", e.RG), ZC.A5(".zc-node-area").live("mousedown touchstart", e.RG));
      }
    }]);
    return AAG;
  }(I3);
  var A98 = /*#__PURE__*/function (_CZ2) {
    _inherits(A98, _CZ2);
    function A98(e) {
      var _this13;
      _classCallCheck(this, A98);
      _this13 = _possibleConstructorReturn(this, _getPrototypeOf(A98).call(this, e));
      var t = _assertThisInitialized(_this13);
      t.IP = !0, t.ACA = !1, t.C = e, t.H = e.A, t.IY = !1, t.A40 = !1, t.H9 = null, t.AT = null, t.Z = null, t.IL = 0, t.H8 = 0, t.PM = 0, t.A15 = 0, t.LW = !1, t.NX = null, t.bBind = !1, t.BY = null, t.A1Z = !1;
      return _this13;
    }
    _createClass(A98, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        t.K = t.C.K + "-preview", t.assign_a([["live", "ACA", "b"], ["async", "LW", "b"], ["min-distance", "PM", "i"], ["min-distance-x", "PM", "i"], ["min-distance-y", "PM", "i"], ["visible", "AN", "b"]]);
        var i = "(" + t.C.AF + ").preview",
          a = t.H.B8;
        function n(e) {
          return [i + ".handler", i + ".handler-" + e, i + ".handle", i + ".handle-" + e];
        }
        t.AT = new I3(t.C), t.AT.K = t.C.K + "-preview-viewport", a.load(t.AT.o, [i]), t.AT.append(t.o), t.AT.parse(), t.o.label && (t.BY = []), t.o.handle && t.o.handle.label && (t.JB = new DT(t.C), t.JB.append(t.o.handle.label), t.JB.append({
          text: " "
        }), t.JB.parse(), t.JB.AN && (t.A1Z = !0)), t.P5 = new CZ(t.C), a.load(t.P5.o, [i + ".mask"]), null !== ZC._n_(e = t.o.mask) && t.P5.append(e), t.P5.parse(), t.V9 = new CZ(t.C), a.load(t.V9.o, [i + ".active"]), null !== ZC._n_(e = t.o.active) && t.V9.append(e), t.V9.parse(), t.J1 = new I3(t.AT), t.HI = new I3(t.AT), t.JE = new I3(t.AT), t.H7 = new I3(t.AT), a.load(t.J1.o, n("left")), a.load(t.HI.o, n("right")), a.load(t.JE.o, n("top")), a.load(t.H7.o, n("bottom"));
        for (var l = ["handle", "handler"], r = 0; r < l.length; r++) null !== ZC._n_(e = t.o[l[r]]) && (t.J1.append(e), t.HI.append(e), t.JE.append(e), t.H7.append(e)), null !== ZC._n_(e = t.o[l[r] + "-left"]) && t.J1.append(e), null !== ZC._n_(e = t.o[l[r] + "-right"]) && t.HI.append(e), null !== ZC._n_(e = t.o[l[r] + "-top"]) && t.JE.append(e), null !== ZC._n_(e = t.o[l[r] + "-bottom"]) && t.H7.append(e);
        t.J1.parse(), t.HI.parse(), t.JE.parse(), t.H7.parse();
      }
    }, {
      key: "setScalesInfo",
      value: function setScalesInfo() {
        var e = this;
        e.NX = {};
        for (var t, i = e.C.BO, a = 0, n = i.length; a < n; a++) (t = i[a]) && ("k" === t.AF ? e.NX[t.BG] = {
          minindex: t.DD,
          maxindex: t.DV,
          minvalue: t.V[t.DD],
          maxvalue: t.V[t.DV],
          stepsize: t.AC,
          values: [].concat(t.V)
        } : e.NX[t.BG] = {
          minvalue: t.FX,
          maxvalue: t.H4
        });
      }
    }, {
      key: "toggleMasks",
      value: function toggleMasks(e, t) {
        for (var i = this, a = ["x-left", "x-right", "y-top", "y-bottom"], n = 0; n < a.length; n++) if (e) {
          var l = new I3(i.C);
          switch (l.K = i.C.K + "-preview-mask-" + a[n], l.A0 = l.AE = i.P5.A0, l.C6 = i.P5.C6, l.Z = l.C7 = t || ZC.AK(i.C.K + "-preview-c"), a[n]) {
            case "x-left":
              l.iX = i.AT.iX, l.iY = i.AT.iY, l.I = ZC.A5(i.A3X).css(ZC._[19]), l.F = i.AT.F;
              break;
            case "x-right":
              l.iX = i.AT.iX + i.AT.I - ZC.A5(i.XT).css(ZC._[19]), l.iY = i.AT.iY, l.I = ZC.A5(i.XT).css(ZC._[19]), l.F = i.AT.F;
              break;
            case "y-top":
              l.iX = i.AT.iX, l.iY = i.AT.iY, l.I = i.AT.I, l.F = ZC.A5(i.A59).css(ZC._[20]);
              break;
            case "y-bottom":
              l.iX = i.AT.iX, l.iY = i.AT.iY + i.AT.F - ZC.A5(i.WF).css(ZC._[20]), l.I = i.AT.I, l.F = ZC.A5(i.WF).css(ZC._[20]);
          }
          l.paint();
        } else ZC.Q.EU(i.C.K + "-preview-mask-" + a[n] + "-path");
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this;
        if (C.Q6 = ZC.mobile ? 40 : ZC.ie67 ? 0 : 20, C.AN) {
          C.Z = C.AT.Z = C.AT.C7 = ZC.AK(C.C.K + "-preview-c"), C.AT.paint();
          var A = ZC.AK(C.H.K + "-top"),
            Z = C.C.BT("k")[0],
            c = C.C.BT("v")[0];
          if (null === C.NX && C.setScalesInfo(), "svg" !== C.H.AA ? (e = ZC.AK(C.C.K + "-preview")) && ZC.Q.PV(e, {
            clip: C.C.LT(0, "canvas", C.AT)
          }) : (e = ZC.AK(C.C.K + "-clip-preview-shape")) && ZC.Q.G4(e, {
            points: C.C.LT(0, "svg", C.AT)
          }), 0 === C.PM && Z && (C.PM = ZC.BQ(1, ZC._i_(2 * C.AT.I / Z.V.length)), "log" === Z.C1 && (C.PM = ZC.BQ(1, ZC._i_(C.PM / Z.E4)))), C.BY) {
            var p = ZC.ie67 ? ZC.AK(C.H.K) : null;
            ZC.A5("." + C.C.K + "-preview-item", p).remove();
            for (var u = [], h = 0; h < C.BY.length; h++) {
              var _ = (C.BY[h].x - Z.iX) / Z.I,
                d = ZC._i_(C.AT.iX + _ * C.AT.I),
                f = new DT(C.C);
              if (f.append({
                "line-width": 1,
                "line-color": "#999",
                text: C.BY[h].text,
                x: d,
                y: C.AT.iY
              }), f.append(C.o.label), f.parse(), f.Z = C.Z, f.IW = C.H.usc() ? ZC.AK(C.H.K + "-main") : ZC.AK(C.H.K + "-text"), f.GO = C.K + "-item " + C.C.K + "-preview-item zc-preview-item", f.K = C.K + "-item-" + h, f.iX >= C.AT.iX && f.iX + f.I <= C.AT.iX + C.AT.I) {
                for (var g = !1, B = 0; B < u.length; B++) f.iX > u[B].x && f.iX < u[B].x + u[B][ZC._[19]] && (g = !0);
                !g && f.AN && (f.paint(), u.push({
                  x: f.iX,
                  width: f.I
                }));
                var v = [[d, C.AT.iY], [d, C.AT.iY + C.AT.F]];
                a = ZC.Q.E9(C.Z, C.H.AA), ZC.CQ.paint(a, f, v);
              }
            }
          }
          if ((Z.GQ || c.GQ) && (C.KO = ZC.Q.I7({
            cls: "zc-abs zc-preview-handler zc-preview-handler-middle " + C.C.K + "-preview-handler",
            id: C.K + "-handler-middle",
            wh: C.AT.I + "/" + C.AT.F,
            tl: C.AT.iY + "/" + C.AT.iX,
            background: C.V9.A0,
            opacity: C.V9.C6,
            cursor: "pointer",
            p: A
          })), !Z.CO && Z.GQ || c.CO && c.GQ) {
            C.A3X = ZC.Q.I7({
              cls: "zc-abs zc-preview-mask zc-preview-mask-left " + C.C.K + "-preview-mask",
              id: C.K + "-mask-x-left",
              wh: "0/" + C.AT.F,
              tl: C.AT.iY + "/" + C.AT.iX,
              background: C.P5.A0,
              opacity: C.P5.C6,
              p: A
            }), C.XT = ZC.Q.I7({
              cls: "zc-abs zc-preview-mask zc-preview-mask-right " + C.C.K + "-preview-mask",
              id: C.K + "-mask-x-right",
              wh: "0/" + C.AT.F,
              tl: C.AT.iY + "/" + (C.AT.iX + C.AT.I),
              background: C.P5.A0,
              opacity: C.P5.C6,
              p: A
            }), t = C.J1.I, i = C.J1.F, C.KQ = ZC.Q.I7({
              cls: "zc-abs zc-preview-handler zc-preview-handler-left " + C.C.K + "-preview-handler",
              id: C.K + "-handler-x-left",
              wh: ZC.quirks ? null : t + "/" + i,
              tl: ZC._i_(C.AT.iY + (C.AT.F - i) / 4 - C.Q6 / 2) + "/" + ZC._i_(C.AT.iX - t / 2 - C.Q6 / 2),
              lineHeight: "10%",
              cursor: "pointer",
              p: A,
              border: C.Q6 / 2 + "px solid transparent"
            });
            var m = C.KQ;
            if ("svg" === C.H.AA && !ZC.AK(C.K + "-handler-x-left-svg")) {
              var b = ZC.Q.F7("svg", ZC._[36]);
              ZC.Q.G4(b, {
                version: "1.1",
                id: C.K + "-handler-x-left-svg",
                width: t,
                height: i
              }), C.KQ.appendChild(b), m = b;
            }
            if (!ZC.AK(C.K + "-handler-x-left-c")) {
              var E = ZC.Q.HJ({
                cls: "zc-no-print",
                id: C.K + "-handler-x-left-c",
                wh: t + "/" + i,
                p: m
              }, C.H.AA);
              C.J1.Z = E, C.J1.K = C.K + "-handler-x-left-c-preview", C.J1.iX = 0, C.J1.iY = 0, C.J1.paint(), a = ZC.Q.E9(C.H.usc() ? C.H.K + "-main-c" : C.K + "-handler-x-left-c", C.H.AA);
              var K = C.J1.AZ,
                D = C.J1.AU;
              o = ZC._i_(t / 2 - K), r = ZC._i_(t / 2 + K), s = [[o, l = D + 3], [o, n = i - D - 2], null, [r, l], [r, n]], C.J1.CY = !0, ZC.CQ.paint(a, C.J1, s);
            }
            t = C.HI.I, i = C.HI.F, C.K3 = ZC.Q.I7({
              cls: "zc-abs zc-preview-handler zc-preview-handler-right " + C.C.K + "-preview-handler",
              id: C.K + "-handler-x-right",
              wh: ZC.quirks ? null : t + "/" + i,
              tl: ZC._i_(C.AT.iY + C.AT.F - C.HI.F - (C.AT.F - i) / 4 - C.Q6 / 2) + "/" + ZC._i_(C.AT.iX + C.AT.I - C.HI.I / 2 - C.Q6 / 2),
              lineHeight: "10%",
              cursor: "pointer",
              p: A,
              border: C.Q6 / 2 + "px solid transparent"
            });
            var F = C.K3;
            if ("svg" === C.H.AA && !ZC.AK(C.K + "-handler-x-right-svg")) {
              var I = ZC.Q.F7("svg", ZC._[36]);
              ZC.Q.G4(I, {
                version: "1.1",
                id: C.K + "-handler-x-right-svg",
                width: t,
                height: i
              }), C.K3.appendChild(I), F = I;
            }
            if (!ZC.AK(C.K + "-handler-x-right-c")) {
              var x = ZC.Q.HJ({
                cls: "zc-no-print",
                id: C.K + "-handler-x-right-c",
                wh: t + "/" + i,
                p: F
              }, C.H.AA);
              C.HI.Z = x, C.HI.K = C.K + "-handler-x-right-c-preview", C.HI.iX = 0, C.HI.iY = 0, C.HI.paint(), a = ZC.Q.E9(C.H.usc() ? C.H.K + "-main-c" : C.K + "-handler-x-right-c", C.H.AA);
              var y = C.HI.AZ,
                X = C.HI.AU;
              o = ZC._i_(t / 2 - y), r = ZC._i_(t / 2 + y), s = [[o, l = X + 3], [o, n = i - X - 2], null, [r, l], [r, n]], C.HI.CY = !0, ZC.CQ.paint(a, C.HI, s);
            }
          }
          if (!c.CO && c.GQ || Z.CO && Z.GQ) {
            C.A59 = ZC.Q.I7({
              cls: "zc-abs zc-preview-mask zc-preview-mask-top " + C.C.K + "-preview-mask",
              id: C.K + "-mask-x-top",
              wh: C.AT.I + "/0",
              tl: C.AT.iY + "/" + C.AT.iX,
              background: C.P5.A0,
              opacity: C.P5.C6,
              p: A
            }), C.WF = ZC.Q.I7({
              cls: "zc-abs zc-preview-mask zc-preview-mask-bottom " + C.C.K + "-preview-mask",
              id: C.K + "-mask-x-bottom",
              wh: C.AT.I + "/0",
              tl: C.AT.iY + C.AT.F + "/" + C.AT.iX,
              background: C.P5.A0,
              opacity: C.P5.C6,
              p: A
            }), t = C.JE.I, i = C.JE.F, C.LC = ZC.Q.I7({
              cls: "zc-abs zc-preview-handler zc-preview-handler-top " + C.C.K + "-preview-handler",
              id: C.K + "-handler-y-top",
              wh: ZC.quirks ? null : t + "/" + i,
              tl: ZC._i_(C.AT.iY - i / 2 - C.Q6 / 2) + "/" + ZC._i_(C.AT.iX + (C.AT.I - t) / 4 - C.Q6 / 2),
              lineHeight: "10%",
              cursor: "pointer",
              p: A,
              border: C.Q6 / 2 + "px solid transparent"
            });
            var Y = C.LC;
            if ("svg" === C.H.AA && !ZC.AK(C.K + "-handler-y-top-svg")) {
              var w = ZC.Q.F7("svg", ZC._[36]);
              ZC.Q.G4(w, {
                version: "1.1",
                id: C.K + "-handler-y-top-svg",
                width: t,
                height: i
              }), C.LC.appendChild(w), Y = w;
            }
            if (!ZC.AK(C.K + "-handler-y-top-c")) {
              var L = ZC.Q.HJ({
                cls: "zc-no-print",
                id: C.K + "-handler-y-top-c",
                wh: t + "/" + i,
                p: Y
              }, C.H.AA);
              C.JE.Z = L, C.JE.K = C.K + "-handler-y-top-c-preview", C.JE.iX = 0, C.JE.iY = 0, C.JE.paint(), a = ZC.Q.E9(C.H.usc() ? C.H.K + "-main-c" : C.K + "-handler-y-top-c", C.H.AA);
              var M = C.JE.AZ,
                H = C.JE.AU;
              n = ZC._i_(i / 2 - M), s = [[o = t - H - 2, l = ZC._i_(i / 2 + M)], [r = H + 3, l], null, [o, n], [r, n]], C.JE.CY = !0, ZC.CQ.paint(a, C.JE, s);
            }
            t = C.H7.I, i = C.H7.F, C.JM = ZC.Q.I7({
              cls: "zc-abs zc-preview-handler zc-preview-handler-bottom " + C.C.K + "-preview-handler",
              id: C.K + "-handler-y-bottom",
              wh: ZC.quirks ? null : t + "/" + i,
              tl: ZC._i_(C.AT.iY + C.AT.F - C.H7.F / 2 - C.Q6 / 2) + "/" + ZC._i_(C.AT.iX + C.AT.I - C.H7.I - (C.AT.I - t) / 4 - C.Q6 / 2),
              lineHeight: "10%",
              cursor: "pointer",
              p: A,
              border: C.Q6 / 2 + "px solid transparent"
            });
            var G = C.JM;
            if ("svg" === C.H.AA && !ZC.AK(C.K + "-handler-y-bottom-svg")) {
              var P = ZC.Q.F7("svg", ZC._[36]);
              ZC.Q.G4(P, {
                version: "1.1",
                id: C.K + "-handler-y-bottom-svg",
                width: t,
                height: i
              }), C.JM.appendChild(P), G = P;
            }
            if (!ZC.AK(C.K + "-handler-y-bottom-c")) {
              var N = ZC.Q.HJ({
                cls: "zc-no-print",
                id: C.K + "-handler-y-bottom-c",
                wh: t + "/" + i,
                p: G
              }, C.H.AA);
              C.H7.Z = N, C.H7.K = C.K + "-handler-y-bottom-c-preview", C.H7.iX = 0, C.H7.iY = 0, C.H7.paint(), a = ZC.Q.E9(C.H.usc() ? C.H.K + "-main-c" : C.K + "-handler-y-bottom-c", C.H.AA);
              var O = C.H7.AZ,
                S = C.H7.AU;
              n = ZC._i_(i / 2 - O), s = [[o = t - S - 2, l = ZC._i_(i / 2 + O)], [r = S + 3, l], null, [o, n], [r, n]], C.H7.CY = !0, ZC.CQ.paint(a, C.H7, s);
            }
          }
          if (C.IL = 0, C.H8 = C.AT.I, C.LB = 0, C.HL = C.AT.F, Z.GQ && C.A1Z) {
            var Q = Z.W,
              k = Z.A1;
            Z.FI && "date" === Z.FI.o.type && (Q = Z.FC(Z.W, null, null).replace(/<br>/g, " "), k = Z.FC(Z.A1, null, null).replace(/<br>/g, " ")), C.RK = ZC.Q.I7({
              cls: "zc-abs zc-preview-label " + C.C.K + "-preview-label",
              id: C.K + "-min-label",
              background: C.JB.A0,
              opacity: C.JB.C6,
              fontFamily: C.JB.GJ,
              fontSize: C.JB.DG,
              fontWeight: C.JB.sFontWeight,
              color: C.JB.C2,
              padding: 0,
              html: Q + "",
              p: A
            }), C.RK.style.left = C.AT.iX + "px", C.RK.style.top = C.AT.iY + C.AT.F + "px", C.RM = ZC.Q.I7({
              cls: "zc-abs zc-preview-label " + C.C.K + "-preview-label",
              id: C.K + "-max-label",
              background: C.JB.A0,
              opacity: C.JB.C6,
              fontFamily: C.JB.GJ,
              fontSize: C.JB.DG,
              fontWeight: C.JB.sFontWeight,
              color: C.JB.C2,
              padding: 0,
              html: k + "",
              p: A
            }), C.RM.style.left = C.AT.iX + C.AT.I + "px", C.RM.style.top = C.AT.iY + C.AT.F + "px", C.IL > ZC.A5(C.RK).width() ? C.RK.style.left = C.AT.iX + C.IL - ZC.A5(C.RK).width() + "px" : C.RK.style.left = C.AT.iX + "px", C.AT.I - C.H8 > ZC.A5(C.RM).width() ? C.RM.style.left = C.AT.iX + C.H8 + "px" : C.RM.style.left = C.AT.iX + C.H8 - ZC.A5(C.RM).width() + "px";
          }
          C.bind(), C.BY && (C.BY = []);
        }
      }
    }, {
      key: "reset",
      value: function reset() {
        var e = this,
          t = e.C.BT("k")[0],
          i = e.C.BT("v", !0)[0];
        i || (i = e.C.BT("v")[0]), t && i && e.update(t.DD, t.DV, i.FX, i.H4, !0);
      }
    }, {
      key: "update",
      value: function update(e, t, i, a, n) {
        null === ZC._n_(n) && (n = !1);
        var l = this;
        if (n || (e >= t && (e = t - 1), i >= a && (i = a - 1)), l.AN) {
          var r = l.C.BT("k")[0],
            o = l.C.BT("v", !0)[0];
          o || (o = l.C.BT("v")[0]);
          var s = !0;
          if (n) {
            if (r && o) {
              if (r.CO && o.CO) {
                var C = e,
                  A = t;
                e = i, t = a, i = C, a = A;
              }
              r.CO ? (null === ZC._n_(a) && (a = r.A1), null === ZC._n_(i) && (i = r.W)) : (null === ZC._n_(e) && (e = r.W), null === ZC._n_(t) && (t = r.A1)), o.CO ? (null === ZC._n_(e) && (e = o.aAutoFit[0] ? o.FX : o.B3), null === ZC._n_(t) && (t = o.aAutoFit[1] ? o.H4 : o.BL)) : (null === ZC._n_(i) && (i = o.aAutoFit[0] ? o.FX : o.B3), null === ZC._n_(a) && (a = o.aAutoFit[1] ? o.H4 : o.BL)), r.CO || o.CO ? r.AW ? l.update((e - o.FX) * l.AT.I / (o.H4 - o.FX), (t - o.FX) * l.AT.I / (o.H4 - o.FX), (i - r.DD) * l.AT.F / (r.DV - r.DD), (a - r.DD) * l.AT.F / (r.DV - r.DD)) : l.update((e - o.FX) * l.AT.I / (o.H4 - o.FX), (t - o.FX) * l.AT.I / (o.H4 - o.FX), l.AT.F - (a - r.DD) * l.AT.F / (r.DV - r.DD), l.AT.F - (i - r.DD) * l.AT.F / (r.DV - r.DD)) : r.AW ? l.update(l.AT.I - (t - r.DD) * l.AT.I / (r.DV - r.DD), l.AT.I - (e - r.DD) * l.AT.I / (r.DV - r.DD), l.AT.F - (a - o.FX) * l.AT.F / (o.H4 - o.FX), l.AT.F - (i - o.FX) * l.AT.F / (o.H4 - o.FX)) : l.update((e - r.DD) * l.AT.I / (r.DV - r.DD), (t - r.DD) * l.AT.I / (r.DV - r.DD), l.AT.F - (a - o.FX) * l.AT.F / (o.H4 - o.FX), l.AT.F - (i - o.FX) * l.AT.F / (o.H4 - o.FX));
            }
          } else if (t - e < l.PM && (l.H9 === l.K3 ? t = e + l.PM : l.H9 === l.KQ && (e = t - l.PM)), a - i < l.A15 && (l.H9 === l.JM ? a = i + l.A15 : l.H9 === l.LC && (i = a - l.A15)), e > t && (l.H9 === l.KQ ? l.update(t - 1, t, i, a) : l.H9 === l.K3 && l.update(e, e + 1, i, a), s = !1), e < 0 && (l.H9 === l.KQ ? l.update(0, t, i, a) : l.H9 === l.KO && l.update(0, ZC.A5(l.KO).width(), i, a), s = !1), t > l.AT.I && (l.H9 === l.K3 ? l.update(e, l.AT.I, i, a) : l.H9 === l.KO && l.update(l.AT.I - ZC.A5(l.KO).width(), l.AT.I, i, a), s = !1), i > a && (l.H9 === l.LC ? l.update(e, t, i - 1, a) : l.H9 === l.JM && l.update(e, t, i, a + 1), s = !1), i < 0 && (l.H9 === l.LC ? l.update(e, t, 0, a) : l.H9 === l.KO && l.update(e, t, 0, ZC.A5(l.KO).height()), s = !1), a > l.AT.F && (l.H9 === l.JM ? l.update(e, t, i, l.AT.F) : l.H9 === l.KO && l.update(e, t, l.AT.F - ZC.A5(l.KO).height(), l.AT.F), s = !1), s) {
            if (r && r.YQ) {
              var Z = l.AT.I / (r.V.length - (r.DI ? 0 : 1));
              e = Z * Math.round(e / Z), t = ZC.CX(Z * Math.round(t / Z), l.AT.I);
            }
            l.IL = e, l.H8 = t, l.LB = i, l.HL = a, (!r.CO && r.GQ || o.CO && o.GQ) && (l.KQ.style.left = ZC._i_(l.AT.iX + l.IL - l.J1.I / 2 - l.Q6 / 2) + "px", l.A3X.style.width = ZC._i_(l.IL) + "px", l.K3.style.left = ZC._i_(l.AT.iX + l.H8 - l.HI.I / 2 - l.Q6 / 2) + "px", l.XT.style.left = ZC._i_(l.AT.iX + l.H8) + "px", l.XT.style.width = ZC._i_(l.AT.I - l.H8) + "px"), (!o.CO && o.GQ || r.CO && r.GQ) && (l.LC.style.top = ZC._i_(l.AT.iY + l.LB - l.JE.F / 2 - l.Q6 / 2) + "px", l.A59.style.height = ZC._i_(l.LB) + "px", l.JM.style.top = ZC._i_(l.AT.iY + l.HL - l.H7.F / 2 - l.Q6 / 2) + "px", l.WF.style.top = ZC._i_(l.AT.iY + l.HL) + "px", l.WF.style.height = ZC._i_(l.AT.F - l.HL) + "px"), (r.GQ || o.GQ) && (l.KO.style.left = ZC._i_(l.AT.iX + l.IL) + "px", l.KO.style.width = ZC._i_(l.H8 - l.IL) + "px", l.KO.style.top = ZC._i_(l.AT.iY + l.LB) + "px", l.KO.style.height = ZC._i_(l.HL - l.LB) + "px"), l.ACA && l.IY && (l.C.OM = !0, l.zoom(!0)), r.GQ && l.A1Z && (r.FI && "date" === r.FI.o.type ? (l.RK.innerHTML = r.FC(r.W, null, null).replace(/<br>/g, " "), l.RM.innerHTML = r.FC(r.A1, null, null).replace(/<br>/g, " ")) : (l.RK.innerHTML = r.W, l.RM.innerHTML = r.A1), l.IL > ZC.A5(l.RK).width() ? l.RK.style.left = l.AT.iX + l.IL - ZC.A5(l.RK).width() + "px" : l.RK.style.left = l.AT.iX + "px", l.AT.I - l.H8 > ZC.A5(l.RM).width() ? l.RM.style.left = l.AT.iX + l.H8 + "px" : l.RM.style.left = l.AT.iX + l.H8 - ZC.A5(l.RM).width() + "px");
          }
        }
      }
    }, {
      key: "zoom",
      value: function zoom(e) {
        for (var t, i = this, a = {
            graphid: i.C.K,
            preview: 1,
            async: i.LW,
            previewscale: !0,
            zooming: e
          }, n = i.C.BO, l = i.C.BT("k")[0], r = i.C.BT("v")[0], o = 0, s = n.length; o < s; o++) if (t = n[o]) {
          var C = 1 === t.L ? "" : "-" + t.L;
          if ("k" === t.AF) {
            if (l.GQ) {
              var A = i.LW ? i.NX[t.BG].minindex : t.DD,
                Z = i.LW ? i.NX[t.BG].maxindex : t.DV;
              if (a["zoomx" + C] = !0, l.CO ? (a["xmin" + C] = ZC._i_((i.AT.F - i.HL) / i.AT.F * (Z - A)), a["xmax" + C] = ZC._i_((i.AT.F - i.LB) / i.AT.F * (Z - A))) : (a["xmin" + C] = ZC._i_(i.IL / i.AT.I * (Z - A)), a["xmax" + C] = ZC._i_(i.H8 / i.AT.I * (Z - A))), l.AW) {
                a["xmin" + C] = Z - a["xmin" + C], a["xmax" + C] = Z - a["xmax" + C];
                var c = a["xmin" + C];
                a["xmin" + C] = a["xmax" + C], a["xmax" + C] = c;
              }
            }
          } else if (r.GQ) {
            var p = i.LW ? i.NX[t.BG].minvalue : t.FX,
              u = i.LW ? i.NX[t.BG].maxvalue : t.H4;
            a["zoomy" + C] = !0, r.CO ? (a["ymin" + C] = p + i.IL / i.AT.I * (u - p), a["ymax" + C] = p + i.H8 / i.AT.I * (u - p)) : (a["ymin" + C] = p + (i.AT.F - i.HL) / i.AT.F * (u - p), a["ymax" + C] = p + (i.AT.F - i.LB) / i.AT.F * (u - p));
          }
        }
        i.H.PP(a);
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var e = this;
        ZC.A5("." + e.C.K + "-preview-handler").unbind("mousedown touchstart", e.ZM), ZC.A5("." + e.C.K + "-preview-mask").unbind("click", e.AEJ), ZC.A5(document.body).unbind("mousemove touchmove", e.VS), ZC.A5(document.body).unbind("mouseup touchend", e.U1), e.bBind = !1;
      }
    }, {
      key: "bind",
      value: function bind() {
        var e = this;
        if (!e.bBind) {
          var t = e.H.K,
            i = 0,
            a = 0;
          e.AEJ = function (i) {
            if (i.preventDefault(), e.H.H3) {
              e.H.H3.C = e.C, e.H.H3.parse();
              var a = ZC.Q.MM(i),
                n = ZC.A5("#" + t + "-top").offset();
              if (-1 !== i.target.id.indexOf("preview-mask-x-left") || -1 !== i.target.id.indexOf("preview-mask-x-right")) {
                var l = a[0] - n.left - e.AT.iX,
                  r = e.H8 - e.IL;
                l - r / 2 < 0 ? (e.IL = 0, e.H8 = r) : l + r / 2 > e.AT.I ? (e.IL = e.AT.I - r, e.H8 = e.AT.I) : (e.IL = ZC._i_(l - r / 2), e.H8 = ZC._i_(l + r / 2));
              } else {
                var o = a[1] - n.top - e.AT.iY,
                  s = e.HL - e.LB;
                o - s / 2 < 0 ? (e.LB = 0, e.HL = s) : o + s / 2 > e.AT.F ? (e.LB = e.AT.F - s, e.HL = e.AT.F) : (e.LB = ZC._i_(o - s / 2), e.HL = ZC._i_(o + s / 2));
              }
              return e.IY = !1, e.C.OM = !1, e.update(e.IL, e.H8, e.LB, e.HL), e.zoom(!1), !1;
            }
          }, e.ZM = function (n) {
            if (n.preventDefault(), e.H.H3) {
              e.H.H3.C = e.C, e.H.H3.parse();
              for (var l = n.target; l && "BODY" !== l.tagName.toUpperCase();) {
                if (-1 !== ZC.Q.TG(l).indexOf("zc-preview-handler")) break;
                l = l.parentNode;
              }
              if ((ZC.mobile || !(n.which > 1)) && l) {
                var r = ZC.Q.MM(n),
                  o = ZC._tx_(e.H.K),
                  s = ZC.A5("#" + t + "-top").offset(),
                  C = (r[0] - s.left) / o[0] - e.AT.iX,
                  A = (r[1] - s.top) / o[1] - e.AT.iY;
                return -1 !== l.id.indexOf("handler-x-left") ? e.H9 = e.KQ : -1 !== l.id.indexOf("handler-x-right") ? e.H9 = e.K3 : -1 !== l.id.indexOf("handler-y-top") ? e.H9 = e.LC : -1 !== l.id.indexOf("handler-y-bottom") ? e.H9 = e.JM : -1 !== l.id.indexOf("handler-middle") && (e.H9 = e.KO, i = C - e.IL, a = A - e.LB), ZC.A5(document.body).bind("mousemove touchmove", e.VS), ZC.A5(document.body).bind("mouseup touchend", e.U1), e.IY = !0, e.A40 = !1, !1;
              }
            }
          }, e.VS = function (n) {
            if (e.IY) {
              e.A40 = !0, zingchart.exec(e.H.K, "setmode", {
                mode: "static,fast"
              });
              var l = ZC._tx_(e.H.K),
                r = ZC.Q.MM(n),
                o = ZC.A5("#" + t + "-top").offset(),
                s = (r[0] - o.left) / l[0] - e.AT.iX,
                C = (r[1] - o.top) / l[1] - e.AT.iY;
              e.H9 === e.KQ ? e.update(s, e.H8, e.LB, e.HL) : e.H9 === e.K3 ? e.update(e.IL, s, e.LB, e.HL) : e.H9 === e.LC ? e.update(e.IL, e.H8, C, e.HL) : e.H9 === e.JM ? e.update(e.IL, e.H8, e.LB, C) : e.H9 === e.KO && e.update(s - i, s - i + ZC.A5(e.KO).width(), C - a, C - a + ZC.A5(e.KO).height());
            }
            return !1;
          }, e.U1 = function () {
            return zingchart.exec(e.H.K, "setmode", {
              mode: ""
            }), e.IY && (ZC.A5(document.body).unbind("mousemove touchmove", e.VS), ZC.A5(document.body).unbind("mouseup touchend", e.U1), e.IY = !1, e.C.OM = !1, e.A40 && e.zoom(!1), e.A40 = !1), !1;
          }, ZC.A5("." + e.C.K + "-preview-handler").bind("mousedown touchstart", e.ZM), ZC.A5("." + e.C.K + "-preview-mask").bind("click", e.AEJ), e.bBind = !0;
        }
      }
    }, {
      key: "gc",
      value: function gc() {
        ZC.AQ.gc(this, ["Z", "C7", "o", "ID", "JG", "C", "H", "AT", "V9", "KQ", "K3", "LC", "JM", "KO", "JE", "HI", "H7", "J1", "oMask", "P5", "A3X", "XT", "A59", "WF"]);
      }
    }]);
    return A98;
  }(CZ);
  var A4E = /*#__PURE__*/function (_CZ3) {
    _inherits(A4E, _CZ3);
    function A4E(e, t) {
      var _this14;
      _classCallCheck(this, A4E);
      _this14 = _possibleConstructorReturn(this, _getPrototypeOf(A4E).call(this, e));
      var i = _assertThisInitialized(_this14);
      i.C = e, i.H = e.A, i.IY = !1, i.Z = null, i.BM = 0, i.BH = 0, i.A7X = "", i.bYX = "yx" === i.C.AJ.layout, i.AF = i.sTypeE = i.sTypeN = "scroll-" + (t || "x"), i.bYX && (i.AF += "i", i.sTypeE = "scroll-xi" === i.AF ? "scroll-y" : "scroll-x");
      return _this14;
    }
    _createClass(A4E, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        t.K = t.C.K + "-" + t.sTypeE, t.assign_a([["offset-x", "BM"], ["offset-y", "BH"]]);
        var i = "(" + t.C.AF + ").",
          a = t.H.B8;
        t.B0 = new I3(t.C), a.load(t.B0.o, [i + "scroll.bar", i + t.AF + ".bar"]), null !== ZC._n_(e = t.o.bar) && t.B0.append(e), t.B0.parse(), t.B2 = new I3(t.C), a.load(t.B2.o, [i + "scroll.handle", i + t.AF + ".handle"]), null !== ZC._n_(e = t.o.handle) && t.B2.append(e), t.B2.parse();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this,
          t = e.C.BT("k")[0],
          i = e.C.BT("v")[0],
          a = e.C.P;
        if (("scroll-x" === e.AF || "scroll-xi" === e.AF) && t.DD === t.W && t.DV === t.A1 || ("scroll-y" === e.AF || "scroll-yi" === e.AF) && i.FX === i.B3 && i.H4 === i.BL) return e.unbind(), ZC.A5("#" + e.C.K + "-" + e.AF + "-handle").remove(), ZC.A5("#" + e.C.K + "-" + e.AF + "-bar").remove(), void ZC.Q.IT(e.Z, e.H.AA, e.C.iX, e.C.iY, e.C.I, e.C.F);
        e.Z = ZC.AK(e.C.K + "-" + e.sTypeN + "-c");
        var n = ZC.AK(e.H.K + "-top");
        "scroll-x" === e.AF || "scroll-yi" === e.AF ? (e.B0.iX = a.iX + e.BM, e.B0.iY = a.iY + a.F + t.AZ - 1 + e.BH, e.B0.I = a.I, e.bYX ? (e.B2.I = ZC._i_(ZC.BQ(4, e.B0.I * ((i.BL - i.B3) / (i.H4 - i.FX)))), i.FX === i.B3 ? i.AW ? e.B2.iX = e.B0.iX + e.B0.I - e.B2.I : e.B2.iX = e.B0.iX : i.H4 === i.BL ? i.AW ? e.B2.iX = e.B0.iX : e.B2.iX = e.B0.iX + e.B0.I - e.B2.I : i.AW ? e.B2.iX = ZC._i_(e.B0.iX + e.B0.I - e.B2.I - e.B0.I * (i.B3 - i.FX) / (i.H4 - i.FX)) : e.B2.iX = ZC._i_(e.B0.iX + e.B0.I * (i.B3 - i.FX) / (i.H4 - i.FX))) : (e.B2.I = ZC._i_(ZC.BQ(4, e.B0.I * ((t.A1 - t.W) / (t.DV - t.DD)))), t.DD === t.W ? t.AW ? e.B2.iX = e.B0.iX + e.B0.I - e.B2.I : e.B2.iX = e.B0.iX : t.DV === t.A1 ? t.AW ? e.B2.iX = e.B0.iX : e.B2.iX = e.B0.iX + e.B0.I - e.B2.I : t.AW ? e.B2.iX = ZC._i_(e.B0.iX + e.B0.I - e.B2.I - e.B0.I * (t.W - t.DD) / (t.DV - t.DD)) : e.B2.iX = ZC._i_(e.B0.iX + e.B0.I * (t.W - t.DD) / (t.DV - t.DD))), ZC.AK(e.K + "-handle") ? (ZC.A5("#" + e.K + "-bar").css("top", e.B0.iY + "px"), ZC.A5("#" + e.K + "-handle").css("left", e.B2.iX + "px").css("top", e.B0.iY + "px").css(ZC._[19], ZC.BQ(15, e.B2.I) + "px"), e.paint_()) : (e.AAX = ZC.Q.I7({
          cls: "zc-abs zc-scroll zc-scroll-x-bar " + e.C.K + "-scroll-x-bar",
          id: e.K + "-bar",
          wh: e.B0.I + "/" + e.B0.F,
          tl: e.B0.iY + "/" + e.B0.iX,
          opacity: 0,
          p: n
        }), e.A06 = ZC.Q.I7({
          cls: "zc-abs zc-scroll zc-scroll-x-handle " + e.C.K + "-scroll-x-handle",
          id: e.K + "-handle",
          wh: ZC.BQ(15, e.B2.I) + "/" + e.B0.F,
          tl: e.B0.iY + "/" + (e.B2.iX - 2),
          background: "#fff",
          opacity: 0,
          p: n
        }), e.A06.style.cursor = "pointer", e.paint_(), e.IY || e.bind())) : (e.B0.iX = a.iX - e.B0.I - 1 + e.BM, e.B0.iY = a.iY + e.BH, e.B0.F = a.F, e.bYX ? (e.B2.F = ZC._i_(ZC.BQ(4, e.B0.F * ((t.A1 - t.W) / (t.DV - t.DD)))), t.DD === t.W ? t.AW ? e.B2.iY = e.B0.iY : e.B2.iY = e.B0.iY + e.B0.F - e.B2.F : t.DV === t.A1 ? t.AW ? e.B2.iY = e.B0.iY + e.B0.F - e.B2.F : e.B2.iY = e.B0.iY : t.AW ? e.B2.iY = ZC._i_(e.B0.iY + e.B0.F * (t.W - t.DD) / (t.DV - t.DD)) : e.B2.iY = ZC._i_(e.B0.iY + e.B0.F - e.B2.F - e.B0.F * (t.W - t.DD) / (t.DV - t.DD))) : (e.B2.F = ZC._i_(ZC.BQ(4, e.B0.F * ((i.BL - i.B3) / (i.H4 - i.FX)))), i.FX === i.B3 ? i.AW ? e.B2.iY = e.B0.iY : e.B2.iY = e.B0.iY + e.B0.F - e.B2.F : i.H4 === i.BL ? i.AW ? e.B2.iY = e.B0.iY + e.B0.F - e.B2.F : e.B2.iY = e.B0.iY : i.AW ? e.B2.iY = ZC._i_(e.B0.iY + e.B0.F * (i.B3 - i.FX) / (i.H4 - i.FX)) : e.B2.iY = ZC._i_(e.B0.iY + e.B0.F - e.B2.F - e.B0.F * (i.B3 - i.FX) / (i.H4 - i.FX))), ZC.AK(e.K + "-handle") ? (ZC.A5("#" + e.K + "-bar").css("left", e.B0.iX + "px"), ZC.A5("#" + e.K + "-handle").css("top", e.B2.iY + "px").css("left", e.B0.iX + "px").css(ZC._[20], ZC.BQ(15, e.B2.F) + "px"), e.paint_()) : (e.AAW = ZC.Q.I7({
          cls: "zc-abs zc-scroll zc-scroll-y-bar " + e.C.K + "-scroll-y-bar",
          id: e.K + "-bar",
          wh: e.B0.I + "/" + e.B0.F,
          tl: e.B0.iY + "/" + e.B0.iX,
          opacity: 0,
          p: n
        }), e.A05 = ZC.Q.I7({
          cls: "zc-abs zc-scroll zc-scroll-y-handle " + e.C.K + "-scroll-y-handle",
          id: e.K + "-handle",
          wh: e.B0.I + "/" + ZC.BQ(15, e.B2.F),
          tl: e.B2.iY - 2 + "/" + e.B0.iX,
          background: "#fff",
          opacity: 0,
          p: n
        }), e.A05.style.cursor = "pointer", e.paint_(), e.IY || e.bind()));
      }
    }, {
      key: "zoom",
      value: function zoom(e) {
        for (var t, i, a, n = this, l = {
            graphid: n.C.K,
            zooming: e,
            scroll: !0
          }, r = n.C.BO, o = n.C.BT("k")[0], s = n.C.BT("v")[0], C = 0, A = r.length; C < A; C++) if (t = r[C]) {
          var Z = 1 === t.L ? "" : "-" + t.L;
          if (o.GQ && "scroll-x" === n.AF && "k" === t.AF && !n.bYX) {
            var c = t.A1 - t.W;
            l["zoomx" + Z] = !0, i = (n.B2.iX - n.B0.iX) / n.B0.I, a = (n.B2.iX - n.B0.iX + n.B2.I) / n.B0.I, o.AW ? (l["xmin" + Z] = t.DV - ZC._i_(a * (t.DV - t.DD)), l["xmax" + Z] = t.DV - ZC._i_(i * (t.DV - t.DD))) : (l["xmin" + Z] = t.DD + ZC._i_(i * (t.DV - t.DD)), l["xmax" + Z] = t.DD + ZC._i_(a * (t.DV - t.DD))), l["xmax" + Z] - l["xmin" + Z] !== c && (l["xmax" + Z] === t.DV ? l["xmin" + Z] = l["xmax" + Z] - c : l["xmax" + Z] = l["xmin" + Z] + c);
          } else if (s.GQ && "scroll-y" === n.AF && "v" === t.AF && !n.bYX) l["zoomy" + Z] = !0, i = (n.B0.F - (n.B2.iY - n.B0.iY + n.B2.F)) / n.B0.F, a = (n.B0.F - (n.B2.iY - n.B0.iY)) / n.B0.F, s.AW ? (l["ymin" + Z] = t.H4 - ZC._f_(a * (t.H4 - t.FX)), l["ymax" + Z] = t.H4 - ZC._f_(i * (t.H4 - t.FX))) : (l["ymin" + Z] = t.FX + ZC._f_(i * (t.H4 - t.FX)), l["ymax" + Z] = t.FX + ZC._f_(a * (t.H4 - t.FX)));else if (o.GQ && "scroll-xi" === n.AF && "k" === t.AF && n.bYX) {
            c = t.A1 - t.W;
            l["zoomx" + Z] = !0, i = (n.B0.F - n.B2.iY + n.B0.iY - n.B2.F) / n.B0.F, a = (n.B0.F - n.B2.iY + n.B0.iY) / n.B0.F, o.AW ? (l["xmin" + Z] = t.DV - ZC._i_(a * (t.DV - t.DD)), l["xmax" + Z] = t.DV - ZC._i_(i * (t.DV - t.DD))) : (l["xmin" + Z] = t.DD + ZC._i_(i * (t.DV - t.DD)), l["xmax" + Z] = t.DD + ZC._i_(a * (t.DV - t.DD))), l["xmax" + Z] - l["xmin" + Z] !== c && (l["xmax" + Z] === t.DV ? l["xmin" + Z] = l["xmax" + Z] - c : l["xmax" + Z] = l["xmin" + Z] + c);
          } else s.GQ && "scroll-yi" === n.AF && "v" === t.AF && n.bYX && (l["zoomy" + Z] = !0, i = (n.B2.iX - n.B0.iX) / n.B0.I, a = (n.B2.iX - n.B0.iX + n.B2.I) / n.B0.I, s.AW ? (l["ymin" + Z] = t.H4 - ZC._f_(a * (t.H4 - t.FX)), l["ymax" + Z] = t.H4 - ZC._f_(i * (t.H4 - t.FX))) : (l["ymin" + Z] = t.FX + ZC._f_(i * (t.H4 - t.FX)), l["ymax" + Z] = t.FX + ZC._f_(a * (t.H4 - t.FX))));
        }
        n.H.PP(l);
      }
    }, {
      key: "paint_",
      value: function paint_() {
        var e,
          t,
          i = this;
        ZC.Q.IT(i.Z, i.H.AA, i.C.iX, i.C.iY, i.C.I, i.C.F), "scroll-x" === i.AF || "scroll-yi" === i.AF ? ((e = new I3(i)).K = i.C.K + "-scroll-x-bar", e.copy(i.B0), e.Z = e.C7 = i.Z, e.iX = i.B0.iX, e.iY = i.B0.iY, e.I = i.B0.I, e.F = i.B0.F, e.paint(), (t = new I3(i)).K = i.C.K + "-scroll-x-handle", t.copy(i.B2), t.Z = t.C7 = i.Z, t.iX = i.B2.iX, t.iY = i.B0.iY + (i.B0.F - i.B2.F) / 2 - 1, t.I = ZC.BQ(15, i.B2.I), t.iX + t.I > i.C.P.iX + i.C.P.I && (t.iX = i.C.P.iX + i.C.P.I - t.I), t.iX < i.C.P.iX && (t.iX = i.C.P.iX), t.F = i.B2.F, t.paint(), ZC.A5("#" + i.K + "-handle").css("left", t.iX + "px")) : ((e = new I3(i)).K = i.C.K + "-scroll-y-bar", e.copy(i.B0), e.Z = e.C7 = i.Z, e.iX = i.B0.iX, e.iY = i.B0.iY, e.I = i.B0.I, e.F = i.B0.F, e.paint(), (t = new I3(i)).K = i.C.K + "-scroll-y-handle", t.copy(i.B2), t.Z = t.C7 = i.Z, t.iX = i.B0.iX + (i.B0.I - i.B2.I) / 2, t.iY = i.B2.iY, t.I = i.B2.I, t.F = ZC.BQ(15, i.B2.F), t.iY + t.F > i.C.P.iY + i.C.P.F && (t.iY = i.C.P.iY + i.C.P.F - t.F), t.iY < i.C.P.iY && (t.iY = i.C.P.iY), t.paint(), ZC.A5("#" + i.K + "-handle").css("top", t.iY + "px"));
      }
    }, {
      key: "setScrollingFlag",
      value: function setScrollingFlag(e) {
        var t = this;
        if (t.C.OM = e, t.C.H3 && ZC._b_(t.C.H3.o.shared)) for (var i = 0; i < t.H.AG.length; i++) t.H.AG[i].H3 && ZC._b_(t.H.AG[i].H3.o.shared) && (t.H.AG[i].OM = e);
      }
    }, {
      key: "update",
      value: function update(e) {
        var t = this;
        "scroll-x" === t.AF || "scroll-yi" === t.AF ? (t.B2.iX = e, ZC.A5("#" + t.K + "-handle").css("left", e + "px"), t.paint_()) : (t.B2.iY = e, ZC.A5("#" + t.K + "-handle").css("top", e + "px"), t.paint_()), t.IY && (t.setScrollingFlag(!0), t.zoom(!0));
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var e = this;
        ZC.A5("." + e.C.K + "-" + e.AF + "-handle").unbind("mousedown touchstart", e.RP), ZC.A5("." + e.C.K + "-" + e.AF + "-bar").unbind("click", e.RT);
      }
    }, {
      key: "overscroll",
      value: function overscroll(e) {
        var t = this.C.GR();
        t.type = e, ZC.AQ.BZ("overscroll", this.H, t);
      }
    }, {
      key: "bind",
      value: function bind() {
        var e = this,
          t = e.H.K,
          i = 0,
          a = 0;
        e.RP = function (n) {
          if (n.preventDefault(), !(n.button > 1) && (e.A7X = e.H.L0.join(","), e.H.L0.push(ZC._[38], "skip_objects_tracking", ZC._[39], ZC._[40], ZC._[41]), e.H.H3)) {
            e.H.H3.C = e.C, e.H.H3.parse();
            for (var l = n.target; l && "BODY" !== l.tagName.toUpperCase();) {
              if (-1 !== ZC.Q.TG(l).indexOf("zc-" + e.AF + "-handle")) break;
              l = l.parentNode;
            }
            if ((ZC.mobile || !(n.which > 1)) && l) {
              var r = ZC.Q.MM(n),
                o = ZC.A5("#" + t + "-top").offset();
              if ("scroll-x" === e.AF || "scroll-yi" === e.AF) {
                var s = r[0] - o.left;
                i = s - e.B2.iX;
              } else {
                var C = r[1] - o.top;
                a = C - e.B2.iY;
              }
              return ZC.A5(document.body).bind("mousemove touchmove", e.RQ), ZC.A5(document.body).bind("mouseup touchend", e.ME), e.IY = !0, !1;
            }
          }
        }, e.RQ = function (n) {
          if (e.IY) {
            e.setScrollingFlag(!1);
            var l = ZC.Q.MM(n),
              r = ZC.A5("#" + t + "-top").offset();
            if ("scroll-x" === e.AF || "scroll-yi" === e.AF) {
              var o = l[0] - r.left;
              o - i < e.B0.iX && (o < e.B0.iX - 15 && e.overscroll("scroll-x-left"), o = e.B0.iX + i), o - i + e.B2.I > e.B0.iX + e.B0.I && (o > e.B0.iX + e.B0.I + 15 && e.overscroll("scroll-x-right"), o = e.B0.iX + e.B0.I + i - e.B2.I), e.update(o - i);
            } else {
              var s = l[1] - r.top;
              s - a < e.B0.iY && (s < e.B0.iY - 15 && e.overscroll("scroll-y-top"), s = e.B0.iY + a), s - a + e.B2.F > e.B0.iY + e.B0.F && (s > e.B0.iY + e.B0.F + 15 && e.overscroll("scroll-y-bottom"), s = e.B0.iY + e.B0.F + a - e.B2.F), e.update(s - a);
            }
          }
          return !1;
        }, e.ME = function (t) {
          return e.H.L0 = e.A7X.split(","), e.IY && (ZC.A5(document.body).unbind("mousemove touchmove", e.RQ), ZC.A5(document.body).unbind("mouseup touchend", e.ME), e.IY = !1, e.setScrollingFlag(!1), t && e.zoom(!1)), !1;
        }, e.RT = function (i) {
          e.IY = !1, e.setScrollingFlag(!1);
          var a = ZC.Q.MM(i),
            n = ZC.A5("#" + t + "-top").offset();
          "scroll-x" === e.AF || "scroll-yi" === e.AF ? a[0] - n.left > e.B2.iX ? e.update(ZC.CX(e.B0.iX + e.B0.I - e.B2.I - 2 * e.B2.AU, e.B2.iX + (a[0] - n.left - e.B2.iX) / 4)) : e.update(ZC.BQ(e.B0.iX, a[0] - n.left + (e.B2.iX - a[0] + n.left - e.B2.I) / 4)) : a[1] - n.top > e.B2.iY ? e.update(ZC.CX(e.B0.iY + e.B0.F - e.B2.F - 2 * e.B2.AU, e.B2.iY + (a[1] - n.top - e.B2.iY) / 4)) : e.update(ZC.BQ(e.B0.iY, a[1] - n.top + (e.B2.iY - a[1] + n.top - e.B2.F) / 4)), e.zoom(!1);
        }, ZC.A5("." + e.C.K + "-" + e.sTypeE + "-handle").bind("mousedown touchstart", e.RP), ZC.A5("." + e.C.K + "-" + e.sTypeE + "-bar").bind("click", e.RT);
      }
    }]);
    return A4E;
  }(CZ);
  var A3K = /*#__PURE__*/function (_CZ4) {
    _inherits(A3K, _CZ4);
    function A3K(e, t) {
      var _this15;
      _classCallCheck(this, A3K);
      _this15 = _possibleConstructorReturn(this, _getPrototypeOf(A3K).call(this, e));
      var i = _assertThisInitialized(_this15);
      i.BC = e, i.IY = !1, i.Z = null, i.A7X = "", i.KZ = 1, i.H5 = 1, i.AF = "scroll-" + (t || "y");
      return _this15;
    }
    _createClass(A3K, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        t.K = t.BC.K + "-legend-" + t.AF;
        var i = t.BC.A.H.B8,
          a = "(" + t.BC.A.AF + ")";
        t.B0 = new I3(t.BC), i.load(t.B0.o, [a + ".legend.scroll.bar", t.AF + ".bar"]), null !== ZC._n_(e = t.o.bar) && t.B0.append(e), t.B0.parse(), t.B2 = new I3(t.BC), i.load(t.B2.o, [a + ".legend.scroll.handle", t.AF + ".handle"]), null !== ZC._n_(e = t.o.handle) && t.B2.append(e), t.B2.parse();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        if (!t.IY) {
          t.Z = ZC.AK(t.BC.A.K + "-legend-scroll-c");
          var i = ZC.AK(t.H.K + "-top");
          "scroll-y" === t.AF ? (t.B0.iX = t.BC.iX + t.BC.I - t.B0.I - 1, t.B0.iY = t.BC.EO, t.B0.F = t.BC.F - (t.BC.KS ? t.BC.KS.F : 0) - (t.BC.EO - t.BC.iY), e = Math.ceil(t.BC.B6.length / t.H5 - t.BC.EH / t.H5) + 1, t.B2.F = t.B0.F / e, t.B2.iY = t.B0.iY, 0 !== t.BC.D2.min && (t.B2.iY += t.BC.D2.min / t.H5 * t.B2.F), ZC.AK(t.K + "-legend-handle") ? (ZC.A5("#" + t.K + "-legend-handle").css("left", t.B0.iX + "px").css("top", t.B2.iY + "px").css(ZC._[20], t.B2.F - 0 * t.B2.AU + "px"), ZC.A5("#" + t.K + "-legend-bar").css("left", t.B0.iX + "px").css("top", t.B0.iY + "px"), ZC.A5("#" + t.BC.K + "-frame").css("left", t.BC.iX + "px").css("top", t.BC.EO + "px"), t.paint_()) : (t.AAW = ZC.Q.I7({
            cls: "zc-abs zc-scroll zc-scroll-y-bar " + t.BC.K + "-scroll-y-legend-bar",
            id: t.K + "-legend-bar",
            wh: t.B0.I + "/" + t.B0.F,
            tl: t.B0.iY + "/" + t.B0.iX,
            background: "#fff",
            opacity: 0,
            zidx: 1,
            p: i
          }), t.A05 = ZC.Q.I7({
            cls: "zc-abs zc-scroll zc-scroll-y-handle " + t.BC.K + "-scroll-y-legend-handle",
            id: t.K + "-legend-handle",
            wh: t.B0.I - 0 * t.B2.AU + "/" + (t.B2.F - 0 * t.B2.AU),
            tl: t.B2.iY + "/" + t.B0.iX,
            background: "#fff",
            opacity: 0,
            zidx: 1,
            p: i
          }), t.A05.style.cursor = "pointer", t.paint_())) : "scroll-x" === t.AF && (t.B0.iX = t.BC.iX, t.B0.iY = t.BC.iY + t.BC.F - t.B0.F - 1, t.B0.I = t.BC.I, e = Math.ceil(t.BC.B6.length / t.KZ - t.BC.EH / t.KZ) + 1, t.B2.I = t.B0.I / e, t.B2.iX = t.B0.iX, 0 !== t.BC.D2.min && (t.B2.iX += t.BC.D2.min / t.KZ * t.B2.I), ZC.AK(t.K + "-legend-handle") ? (ZC.A5("#" + t.K + "-legend-handle").css("left", t.B2.iX + "px").css("top", t.B0.iY + "px").css(ZC._[19], t.B2.I - 0 * t.B2.AU + "px"), ZC.A5("#" + t.K + "-legend-bar").css("left", t.B0.iX + "px").css("top", t.B0.iY + "px"), ZC.A5("#" + t.BC.K + "-frame").css("left", t.BC.iX + "px").css("top", t.BC.EO + "px"), t.paint_()) : (t.AAX = ZC.Q.I7({
            cls: "zc-abs zc-scroll zc-scroll-x-bar " + t.BC.K + "-scroll-x-legend-bar",
            id: t.K + "-legend-bar",
            wh: t.B0.I + "/" + t.B0.F,
            tl: t.B0.iY + "/" + t.B0.iX,
            background: "#fff",
            opacity: 0,
            zidx: 1,
            p: i
          }), t.A06 = ZC.Q.I7({
            cls: "zc-abs zc-scroll zc-scroll-x-handle " + t.BC.K + "-scroll-x-legend-handle",
            id: t.K + "-legend-handle",
            wh: t.B2.I - 0 * t.B2.AU + "/" + (t.B0.F - 0 * t.B2.AU),
            tl: t.B0.iY + "/" + t.B2.iX,
            background: "#fff",
            opacity: 0,
            zidx: 1,
            p: i
          }), t.A06.style.cursor = "pointer", t.paint_())), ZC.move || t.bind();
        }
      }
    }, {
      key: "paint_",
      value: function paint_() {
        var e,
          t,
          i = this;
        "scroll-y" === i.AF ? ((e = new I3(i)).K = i.BC.K + "-scroll-y-legend-bar", e.copy(i.B0), e.Z = i.Z, e.iX = i.B0.iX, e.iY = i.B0.iY, e.I = i.B0.I, e.F = i.B0.F, e.paint(), (t = new I3(i)).K = i.BC.K + "-scroll-y-legend-handle", t.copy(i.B2), t.Z = i.Z, t.iX = i.B0.iX, t.iY = i.B2.iY, t.I = i.B2.I, t.F = i.B2.F, t.paint()) : "scroll-x" === i.AF && ((e = new I3(i)).K = i.BC.K + "-scroll-x-legend-bar", e.copy(i.B0), e.Z = i.Z, e.iX = i.B0.iX, e.iY = i.B0.iY, e.I = i.B0.I, e.F = i.B0.F, e.paint(), (t = new I3(i)).K = i.BC.K + "-scroll-x-legend-handle", t.copy(i.B2), t.Z = i.Z, t.iX = i.B2.iX, t.iY = i.B0.iY, t.I = i.B2.I, t.F = i.B0.F, t.paint());
      }
    }, {
      key: "update",
      value: function update(e) {
        var t,
          i,
          a,
          n,
          l,
          r,
          o = this,
          s = o.BC;
        if ("scroll-y" === o.AF) {
          if (e < o.B2.iY && !1, e === o.B2.iY) return;
          o.B2.iY = e, ZC.A5("#" + o.K + "-legend-handle").css("top", e + "px"), t = o.B2.iY - o.B0.iY, n = Math.ceil(s.B6.length / o.H5 - s.EH / o.H5) + 1, i = o.B0.F / n, r = o.H5;
        } else if ("scroll-x" === o.AF) {
          if (e > o.B2.iX && !1, e === o.B2.iX) return;
          o.B2.iX = e, ZC.A5("#" + o.K + "-legend-handle").css("left", e + "px"), t = o.B2.iX - o.B0.iX, n = Math.ceil(s.B6.length / o.KZ - s.EH / o.KZ) + 1, i = o.B0.I / n, r = o.KZ;
        }
        a = Math.round(t / i), l = s.B6.length - s.EH, s.B6.length % r && (l += r - s.B6.length % r), s.D2.min = Math.min(a * r, l), s.D2.max = s.D2.min + s.EH, s.VI(), s.clear(!1), s.parse(), s.paint(), o.paint_(), o.bind();
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var e = this;
        ZC.A5("." + e.BC.K + "-" + e.AF + "-legend-handle").unbind("mousedown touchstart", e.RP), ZC.A5("." + e.BC.K + "-" + e.AF + "-legend-bar").unbind("click", e.RT);
      }
    }, {
      key: "bind",
      value: function bind() {
        var e = this,
          t = e.H.K,
          i = 0,
          a = 0;
        e.RP = function (n) {
          if (n.preventDefault(), !(n.button > 1)) {
            for (var l = n.target; l && "BODY" !== l.tagName.toUpperCase();) {
              if (-1 !== ZC.Q.TG(l).indexOf("zc-" + e.AF + "-handle")) break;
              l = l.parentNode;
            }
            if ((ZC.mobile || !(n.which > 1)) && l) {
              var r = ZC.Q.MM(n),
                o = ZC.A5("#" + t + "-top").offset();
              if ("scroll-y" === e.AF) {
                var s = r[1] - o.top;
                a = s - e.B2.iY;
              } else if ("scroll-x" === e.AF) {
                var C = r[0] - o.left;
                i = C - e.B2.iX;
              }
              return ZC.A5(document.body).bind("mousemove touchmove", e.RQ), ZC.A5(document.body).bind("mouseup touchend", e.ME), e.IY = !0, !1;
            }
          }
        }, e.RQ = function (n) {
          if (n.preventDefault(), e.IY) {
            var l = ZC.Q.MM(n),
              r = ZC.A5("#" + t + "-top").offset();
            if ("scroll-y" === e.AF) {
              var o = l[1] - r.top;
              o - a < e.B0.iY && (o = e.B0.iY + a), o - a + e.B2.F > e.B0.iY + e.B0.F && (o = e.B0.iY + e.B0.F + a - e.B2.F), e.update(o - a);
            } else if ("scroll-x" === e.AF) {
              var s = l[0] - r.left;
              s - i < e.B0.iX && (s = e.B0.iX + i), s - i + e.B2.I > e.B0.iX + e.B0.I && (s = e.B0.iX + e.B0.I + i - e.B2.I), e.update(s - i);
            }
          }
          return !1;
        }, e.ME = function () {
          return e.H.L0 = e.A7X.split(","), e.IY && (ZC.A5(document.body).unbind("mousemove touchmove", e.RQ), ZC.A5(document.body).unbind("mouseup touchend", e.ME), e.IY = !1), !1;
        }, e.A44 = function (t) {
          (t.detail ? -120 * t.detail : t.wheelDelta) / 120 > 0 ? e.update(ZC.BQ(e.B0.iY, e.B2.iY - e.B2.F)) : e.update(ZC.CX(e.B0.iY + e.B0.F - e.B2.F, e.B2.iY + e.B2.F));
        }, e.RT = function (i) {
          e.IY = !0;
          var a = ZC.Q.MM(i),
            n = ZC.A5("#" + t + "-top").offset();
          "scroll-y" === e.AF ? a[1] - n.top > e.B2.iY ? e.update(ZC.CX(e.B0.iY + e.B0.F - e.B2.F, e.B2.iY + e.B2.F)) : e.update(ZC.BQ(e.B0.iY, e.B2.iY - e.B2.F)) : "scroll-x" === e.AF && (a[0] - n.left > e.B2.iX ? e.update(ZC.CX(e.B0.iX + e.B0.I - e.B2.I, e.B2.iX + e.B2.I)) : e.update(ZC.BQ(e.B0.iX, e.B2.iX - e.B2.I))), e.IY = !1;
        }, ZC.A5("." + e.BC.K + "-" + e.AF + "-legend-handle").bind("mousedown touchstart", e.RP), ZC.A5("." + e.BC.K + "-" + e.AF + "-legend-bar").bind("click", e.RT);
      }
    }]);
    return A3K;
  }(CZ);
  var A2H = /*#__PURE__*/function (_DT) {
    _inherits(A2H, _DT);
    function A2H(e) {
      var _this16;
      _classCallCheck(this, A2H);
      _this16 = _possibleConstructorReturn(this, _getPrototypeOf(A2H).call(this, e));
      var t = _assertThisInitialized(_this16);
      t.OP = "legend", t.B6 = null, t.QI = null, t.NS = "x1", t.IQ = "hide", t.RH = "", t.Q5 = "", t.VF = !1, t.VQ = !1, t.U7 = "none", t.V5 = "header", t.EH = 9999, t.D1 = null, t.BR = null, t.ZT = null, t.A2 = null, t.NW = null, t.FR = null, t.KS = null, t.QM = 0, t.ML = 0, t.Z1 = !0, t.EO = 0, t.GS = 0, t.sAlign = "", t.K4 = "", t.D2 = {
        enabled: !1,
        min: -1,
        max: -1,
        page: -1,
        pages: -1
      }, t.MA = !1, t.NN = !1, t.NJ = -1, t.Q3 = !1, t.A5C = 1, t.X6 = 0, t.LH = !1, t.Y7 = !1, t.ZE = !1, t.YF = [];
      return _this16;
    }
    _createClass(A2H, [{
      key: "highlightItem",
      value: function highlightItem(e) {
        var t,
          i,
          a = this,
          n = !1,
          l = ZC.move,
          r = a.LH;
        -1 !== e && (r = a.LH || a.A.AY.A4[e].LH), a.o.item && null !== ZC._n_(t = a.o.item["highlight-item"]) && (n = ZC._b_(t), null === ZC._n_(a.o["highlight-legend"]) && null === a.A.AY.A4[e].o["highlight-legend"] && (r = n)), (n || r) && (n && (a.E["highlight-item"] = e), r && (a.E["highlight-legend"] = ZC._i_(e)), i = a.scrollTo(ZC._i_(e)), a.VI(), a.clear(!0, i), a.Z1 = !0, a.parse(), a.fixPlacement(!0), a.paint(), ZC.move = l);
      }
    }, {
      key: "scrollTo",
      value: function scrollTo(e) {
        var t,
          i,
          a = this,
          n = !1;
        return e >= 0 && (e < a.D2.min || e >= a.D2.max) && (n = !0, "scroll" === a.U7 ? (e % (i = "scroll-y" === a.D1.AF ? a.D1.H5 : a.D1.KZ) && (e -= e % i), a.D2.min = e, a.D2.max = e + a.EH, a.D2.max > a.B6.length && (a.D2.min = a.B6.length - a.EH, a.B6.length % i && (a.D2.min = a.D2.min + (i - a.B6.length % i)), a.D2.max = a.B6.length)) : "page" === a.U7 && (t = Math.floor(e / a.EH), a.D2.min = t * a.EH, a.D2.max = a.D2.min + a.EH, a.D2.page = t + 1)), n;
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a,
          n = this;
        if (n.E["force-margins"] = !0, n.QM = 0, n.ML = 0, null !== ZC._n_(e = n.A.A.E["graph-" + n.A.K + "-legend-info"]) && (n.o.x = e.x - n.A.iX, n.o.y = e.y - n.A.iY), ZC.move) n.FR && n.FR.parse(), n.KS && n.KS.parse();else {
          a = n.A.H.B8;
          var l = "(" + n.A.AF + ")";
          _get(_getPrototypeOf(A2H.prototype), "parse", this).call(this), n.assign_a([["collapse", "MA", "b"], ["minimize", "VF", "b"], ["draggable", "VQ", "b"], ["shared", "Q3", "b"], ["overflow", "U7"], ["max-items", "EH", "i"], ["group", "A5C", "i"], ["drag-handler", "V5"], ["highlight-plot", "X6", "b"], ["highlight-legend", "LH", "b"], ["align", "sAlign"], ["vertical-align", "K4"]]), n.MA && !n.VF && (n.MA = !1), zingchart.DEV.MEDIARULES && (n.E["forced-align-position"] || (n.alignPosition({
            align: n.sAlign,
            "vertical-align": n.K4,
            layout: n.NS
          }), n.E["forced-align-position"] = !0)), n.X6 && null === ZC._n_(n.o["highlight-legend"]) && (n.LH = n.X6), n.BR = new DT(n), a.load(n.BR.o, l + ".legend.item"), n.o.item && null === ZC._n_(n.o.item.visible) && (n.o.item.visible = !0), n.BR.append(n.o.item), n.BR.parse(), n.ZT = new DT(n), a.load(n.ZT.o, l + ".legend.item-off"), n.o["item-off"] && null === ZC._n_(n.o["item-off"].visible) && (n.o["item-off"].visible = !0), n.ZT.append(n.o["item-off"]), n.ZT.parse(), n.A2 = new DW(n), a.load(n.A2.o, l + ".legend.marker"), n.o.marker && null === ZC._n_(n.o.marker.visible) && (n.o.marker.visible = !0), n.A2.append(n.o.marker), n.A2.E.type = "default", n.A2.E["show-marker"] = !0, n.A2.E["show-line"] = !1, null !== ZC._n_(e = n.A2.o.type) && (n.A2.E.type = e), null !== ZC._n_(e = n.A2.o["show-line"]) && (n.A2.E["show-line"] = ZC._b_(e)), null !== ZC._n_(e = n.BR.o["marker-style"]) && (n.A2.E.type = e), null !== ZC._n_(e = n.BR.o["show-line"]) && (n.A2.E["show-line"] = ZC._b_(e)), null !== ZC._n_(e = n.BR.o["show-marker"]) && (n.A2.o.visible = ZC._b_(e)), n.A2.parse(), n.NW = new DW(n), a.load(n.NW.o, l + ".legend.marker-off"), n.o["marker-off"] && (n.o["marker-off"].visible = !0), n.NW.append(n.o["marker-off"]), n.NW.E.type = "default", n.NW.E["show-marker"] = !0, n.NW.E["show-line"] = !1, null !== ZC._n_(e = n.NW.o.type) && (n.NW.E.type = e), null !== ZC._n_(e = n.NW.o["show-line"]) && (n.NW.E["show-line"] = ZC._b_(e)), null !== ZC._n_(e = n.BR.o["marker-style"]) && (n.NW.E.type = e), null !== ZC._n_(e = n.BR.o["show-line"]) && (n.NW.E["show-line"] = ZC._b_(e)), null !== ZC._n_(e = n.BR.o["show-marker"]) && (n.NW.o.visible = ZC._b_(e)), n.NW.parse(), (null !== ZC._n_(e = n.o.header) || n.VQ || n.VF) && (n.FR = new DT(n), n.FR.OP = "legendheader", n.FR.GO = "zc-legend-item " + n.K + "-header", n.FR.K = n.K + "-header", a.load(n.FR.o, l + ".legend.header"), n.FR.o.text = n.FR.o.text || " ", n.FR.append(e), n.FR.parse(), n.FR.AN || (n.FR = null)), null !== ZC._n_(e = n.o.footer) && (n.KS = new DT(n), n.KS.OP = "legendfooter", n.KS.GO = "zc-legend-item " + n.K + "-footer", n.KS.K = n.K + "-footer", a.load(n.KS.o, l + ".legend.footer"), n.KS.append(e), n.KS.parse(), n.KS.AN || (n.KS = null));
          var r = n.A.AY.A4;
          null !== ZC._n_(e = n.o.layout) ? n.NS = e : 25 * r.length > n.A.F && (n.NS = "x" + Math.ceil(25 * r.length / n.A.F)), null !== ZC._n_(e = n.o[ZC._[54]]) && (n.IQ = e), n.RH = n.Q5 = n.IQ, null !== ZC._n_(n.o.item) && null !== ZC._n_(e = n.o.item[ZC._[54]]) && (n.RH = e), null !== ZC._n_(n.o.marker) && null !== ZC._n_(e = n.o.marker[ZC._[54]]) && (n.Q5 = e);
          var o = function o(e) {
              if (r[t] && r[t].FK(0)) {
                var i = ZC.AQ.OE(n.BR.o, r[t].o);
                e = r[t].FK(0).ES(e, i);
              }
              return e;
            },
            s = [];
          for (n.B6 = [], t = 0, i = r.length; t < i; t++) {
            var C = n.A.AY.MF[t],
              A = new DT(n);
            A.copy(n.BR), A.append(r[C].o["legend-item"]), null === ZC._n_(A.o.text) && null !== ZC._n_(e = r[C].A6S) && (A.o.text = e), null === ZC._n_(A.o.text) && null !== ZC._n_(e = r[C].AO) && (A.o.text = e), A.AO = null === ZC._n_(A.o.text) ? "Series " + (C + 1) : A.o.text, A.E.order = C, A.E.index = C, null !== ZC._n_(r[C].o["legend-item"]) && null !== ZC._n_(e = r[C].o["legend-item"].order) && (A.E.order = ZC._i_(e)), s.push([t, C, A.E.order]), -1 !== A.AO.indexOf("%") && (A.ES = o), A.parse(), n.B6.push(A);
          }
          for (s.sort(function (e, t) {
            return e[2] - t[2];
          }), t = 0; t < s.length; t++) s[t][2] = t, r[s[t][1]].o["legend-item"] = r[s[t][1]].o["legend-item"] || {}, r[s[t][1]].o["legend-item"].order = s[t][2], n.B6[s[t][0]].E.order = s[t][2];
          (e = n.A.E["legend-info"]) && (n.NN = e.collapsed);
        }
        if (n.B6 && n.A2) {
          "page" === n.U7 ? ((e = n.A.E["legend-info"]) ? (n.D2.min = e.min, n.D2.max = e.max, n.D2.page = e.page) : (n.D2.min = 0, n.D2.max = n.EH, n.D2.page = 1), n.D2.pages = Math.ceil(n.B6.length / n.EH), n.D2.page > n.D2.pages && (n.D2.page = n.D2.pages, n.D2.min = (n.D2.page - 1) * n.EH, n.D2.max = n.D2.page * n.EH - 1), n.D2.page = ZC.CX(n.D2.page, n.D2.pages)) : "scroll" === n.U7 ? (e = n.A.E["legend-info"]) ? (n.D2.min = e.min, n.D2.max = e.max, n.D2.page = e.page) : (n.D2.min = 0, n.D2.max = n.EH, n.D2.page = 1) : (n.D2.min = 0, n.D2.max = "hidden" === n.U7 ? n.EH : n.B6.length, n.D2.page = 1), n.VI(!1), n.B6.sort(function (e, t) {
            return e.E.order - t.E.order;
          }), n.o["reverse-series"] && n.B6.reverse();
          var Z = .9 * n.A.I;
          null !== ZC._n_(n.o[ZC._[19]]) && (Z = n.I);
          var c = 0,
            p = 0,
            u = -ZC.MAX,
            h = -ZC.MAX,
            _ = n.A2.E["show-line"] ? 3 : 2,
            d = 0,
            f = 1,
            g = 1;
          if ("float" === n.NS) {
            for (t = 0, i = n.B6.length; t < i; t++) if (d += n.B6[t].AN ? 1 : 0, !(t < n.D2.min || t >= n.D2.max || n.NN) && n.B6[t].AN) {
              var B = n.B6[t].I + n.B6[t].DX + n.B6[t].E6 + _ * n.B6[t].DG;
              h = ZC.BQ(h, n.B6[t].F + n.B6[t].E7 + n.B6[t].DP), c + B > Z ? (u = ZC.BQ(u, c), p += h, c = B, h = ZC.BQ(h, n.B6[t].F + n.B6[t].E7 + n.B6[t].DP)) : c += B;
            }
            u = ZC.BQ(u, c), h !== -ZC.MAX && (p += h), u !== -ZC.MAX && (c = u);
          } else {
            var v = 0;
            for (t = 0, i = n.B6.length; t < i; t++) d += n.B6[t].AN ? 1 : 0, t < n.D2.min || t >= n.D2.max || n.NN || (v += n.B6[t].AN ? 1 : 0);
            var m = ZC.AR.A2Y(n.NS, v);
            for (f = m[0], g = m[1], t = 0, i = n.B6.length; t < i; t++) (t < n.D2.min || t >= n.D2.max || n.NN) && ("scroll" !== n.U7 || d <= n.EH) || n.B6[t].AN && (u = ZC.BQ(u, n.B6[t].I + n.B6[t].DX + n.B6[t].E6 + _ * n.B6[t].DG), h = ZC.BQ(h, n.B6[t].F + n.B6[t].E7 + n.B6[t].DP), 1 === g && (p += n.B6[t].F + n.B6[t].E7 + n.B6[t].DP));
            c = g * u, p = f * h;
          }
          if ("page" === n.U7 && d > n.EH && (n.D2.enabled = !0), "scroll" === n.U7 && d > n.EH && (n.D1 || (!f || f > g ? (n.D1 = new A3K(n, "y"), a.load(n.D1.o, ".scroll-y")) : (n.D1 = new A3K(n, "x"), a.load(n.D1.o, ".scroll-x")), n.D1.append(n.o.scroll), n.D1.KZ = f, n.D1.H5 = g, n.D1.parse()), n.NN || ("scroll-y" === n.D1.AF ? c += n.D1.B0.I : p += n.D1.B0.F)), n.FR) {
            var b = n.FR.I;
            n.VQ && "icon" === n.V5 ? (b += 15, n.VF && (b += 25)) : n.VF && (b += 15), c = ZC.BQ(c, b);
          }
          n.KS && (c = ZC.BQ(c, n.KS.I));
          var E = !1,
            K = !1;
          if (null === ZC._n_(n.o[ZC._[19]]) && (n.o[ZC._[19]] = c, E = !0), null === ZC._n_(n.o[ZC._[20]]) && (n.o[ZC._[20]] = p, K = !0), n.iX = -1, n.iY = -1, !ZC.move && n.FR && null !== ZC._n_(e = n.A.A.E["legend" + n.A.L + "-xy-ratio"])) {
            n.locate();
            var D = n.I + n.EP + n.FP,
              F = n.F + n.FO + n.FS,
              I = n.Q3 ? n.A.A : n.A;
            n.iX = I.I * e[0], n.iX = ZC.BQ(n.iX, 1.1), n.o.x = n.iX = ZC.CX(n.iX, I.I - D - 2), n.iY = (I.F - n.FR.F) * e[1], n.iY = ZC.BQ(n.iY, 1.1), n.o.y = n.iY = ZC.CX(n.iY, I.F - F - n.FR.F - 2);
          }
          if (n.locate(), null !== ZC._n_(n.o.position) && typeof n.E["position-info"] !== ZC._[31] ? (n.E["position-info"][0] > .5 && (n.QM += n.EP + n.FP), n.E["position-info"][1] > .5 ? n.ML += n.FO + n.FS : (n.FR && (n.ML -= n.FR.F), n.KS && (n.ML -= n.KS.F), n.D2 && n.D2.enabled && (n.ML -= 20))) : ((0 === n.A.iX || n.iX + n.I / 2 > n.A.iX + n.A.I / 2) && (n.QM += n.EP + n.FP), (0 === n.A.iY || n.iY + n.F / 2 > n.A.iY + n.A.F / 2) && (n.ML += n.FO + n.FS)), !ZC.move && (e = n.A.A.E["graph-" + n.A.K + "-legend-info"]) && (e.x && (n.iX = e.x), e.y && (n.iY = e.y)), n.GS = n.F, n.EO = n.iY, n.FR && (n.F += n.FR.F, n.EO += n.FR.F, n.ML += n.FR.F), n.KS && (n.F += n.KS.F, n.ML += n.KS.F), n.D2.enabled && !n.NN) {
            var x = new DT(n);
            x.AO = " ", x.append(n.o["page-status"]), null !== ZC._n_(x.o.text) && "" !== x.o.text || (x.o.text = "#"), x.parse(), n.F += x.F + 4, n.ML += x.F + 4;
          }
          E && (n.o[ZC._[19]] = null), K && (n.o[ZC._[20]] = null), n.NN || (n.I += n.EP + n.FP, n.F += n.FO + n.FS), n.E["default-width"] && (n.I = n.E["default-width"]);
        }
      }
    }, {
      key: "alignPosition",
      value: function alignPosition(e) {
        var t = this;
        if (null !== ZC._n_(e)) {
          var i = t.A.H.B8.B8.graph.legend,
            a = e.align || i.align,
            n = e["vertical-align"] || i["vertical-align"],
            l = e.layout || i.layout;
          (a || n) && ("center" === a ? (null === ZC._n_(t.o.layout) && (l = t.o.layout = "horizontal"), t.o.position = "50% ") : t.o.position = "left" === a ? "0% " : "100% ", t.o.position += "middle" === n ? "50%" : "bottom" === n ? "100%" : "0%", "horizontal" !== l && "middle" !== n || (t.o["adjust-layout"] = !0));
        }
      }
    }, {
      key: "VI",
      value: function VI(e) {
        var t = this;
        typeof e === ZC._[31] && (e = !0), t.A.E["legend-info"] = {
          collapsed: t.NN,
          min: t.D2.min,
          max: t.D2.max,
          page: t.D2.page
        }, e && (t.A.A.E["graph-" + t.A.K + "-legend-info"] = {
          x: t.iX,
          y: t.iY
        });
      }
    }, {
      key: "clear",
      value: function clear(e, t) {
        null === ZC._n_(e) && (e = !1), null === ZC._n_(t) && (t = !1);
        var i = this,
          a = i.A.K + "-legend-",
          n = null;
        ZC.A5("." + a + "item", n).remove(), ZC.A5("." + a + "header", n).remove(), ZC.A5("." + a + "footer", n).remove(), ZC.A5("#" + a + "page-status", n).remove(), e && !t || (ZC.move || i.unbind(), ZC.A5("." + a + "page-area", n).remove(), ZC.A5("." + a + "header-area", n).remove(), ZC.A5("." + a + "item-area", n).remove(), ZC.A5("." + a + "marker-area", n).remove()), ZC.move ? ZC.Q.IT(ZC.AK(a + "c"), i.A.H.AA, i.A.iX, i.A.iY, i.A.I, i.A.F) : ZC.Q.IT(ZC.AK(a + "c"), i.A.H.AA, i.iX - 2 * i.AU - 2 * i.K1, i.iY - 2 * i.AU - 2 * i.K1, i.I + 4 * i.AU + 4 * i.K1, i.F + 4 * i.AU + 4 * i.K1), i.D1 && ZC.Q.IT(ZC.AK(a + "scroll-c"), i.A.H.AA, i.A.iX, i.A.iY, i.A.I, i.A.F);
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var e = this;
        ZC.A5("#" + e.K + "-frame").die(ZC.Q.BX("mouseover"), e.zc_legend_mouseover).die(ZC.Q.BX("mouseout"), e.zc_legend_mouseout), ZC.A5("#" + e.K + "-move-area").die(ZC.Q.BX(ZC._[47]), e.ZQ), ZC.A5("#" + e.K + "-minimize-area").die(ZC.Q.BX("click"), e.YL), ZC.A5("." + e.K + "-page-area").die(ZC.Q.BX("click"), e.ZB), e.D1 && e.D1.unbind(), e.BR && e.BR.o.reorder && ZC.A5("." + e.A.K + "-legend-item-area").die(ZC._[47], e.WU);
      }
    }, {
      key: "fixPlacement",
      value: function fixPlacement(e) {
        var t = this;
        if (t.Z1 && null === ZC._n_(t.o.y) || e) {
          if (!t.o.position && e || (t.iX -= t.QM), t.iX < t.DX && (t.DX < t.E6 || -2 === t.E6) && (t.iX = t.DX), !t.o.position && e || (t.iY -= t.ML, t.EO -= t.ML), t.iY < t.E7 && (t.E7 < t.DP || -2 === t.DP)) {
            var i = t.EO - t.iY;
            t.iY = t.E7, t.EO = t.E7 + i;
          }
          t.Z1 = !1;
        }
      }
    }, {
      key: "ED",
      value: function ED(e) {
        var t = this;
        t.FR && t.FR.ED(e), t.KS && t.KS.ED(e);
        for (var i = 0; i < t.YF.length; i++) t.YF[i].ED(e);
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d = this;
        if (d.AN && (d.E["default-width"] || (d.E["default-width"] = d.I), d.B6)) {
          var f = ZC.AK(d.H.K + "-top"),
            g = d.A.AY.A4,
            B = 0;
          for (r = 0, o = d.B6.length; r < o; r++) r < d.D2.min || r >= d.D2.max || d.NN || (B += d.B6[r].AN ? 1 : 0);
          d.A57 = !0, _get(_getPrototypeOf(A2H.prototype), "paint", this).call(this), d.FR && (d.FR.iX = d.iX, d.FR.iY = d.iY, d.FR.I = d.I, d.FR.Z = d.FR.C7 = d.Z, d.FR.paint(), ZC.move || "canvas" !== d.A.A.AA && d.FR.ED(), d.VQ && "icon" === d.V5 && ((a = new DW(d)).Z = d.Z, a.B7 = "#000", a.AZ = 1, a.DQ = "line", a.append(d.o.icon), n = d.FR.iX + d.FR.I - 10, l = d.FR.iY + d.FR.F / 2, a.D = [[n - 7, l], [n + 7, l], null, [n, l - 7], [n, l + 7], null, [n - 6, l - 1], [n - 6, l + 1], null, [n - 5, l - 2], [n - 5, l + 2], null, [n + 6, l - 1], [n + 6, l + 1], null, [n + 5, l - 2], [n + 5, l + 2], null, [n - 1, l - 6], [n + 1, l - 6], null, [n - 2, l - 5], [n + 2, l - 5], null, [n - 1, l + 6], [n + 1, l + 6], null, [n - 2, l + 5], [n + 2, l + 5]], a.parse(), a.paint()), d.VF && ((i = new DW(d)).Z = d.Z, i.B7 = ZC.AQ.AA8(d.A0, "#fff", "#000"), i.AZ = 1, i.append(d.o.icon), i.DQ = "line", n = d.FR.iX + d.FR.I - 10 - (d.VQ && "icon" === d.V5 ? 20 : 0), l = d.FR.iY + d.FR.F / 2, i.D = [[n - 7, l - 2], [n + 2, l - 2], [n + 2, l + 7], [n - 7, l + 7], [n - 7, l - 2], [n + 2, l - 2], null, [n - 4, l - 5], [n + 5, l - 5], [n + 5, l + 4], [n - 4, l + 4], [n - 4, l - 5], [n + 5, l - 5]], i.parse(), i.paint())), d.KS && (d.KS.iX = d.iX, d.KS.iY = d.iY + d.F - d.KS.F, d.KS.I = d.I, d.KS.Z = d.KS.C7 = d.Z, d.KS.paint(), ZC.move || "canvas" !== d.A.A.AA && d.KS.ED());
          var v = ZC.AR.A2Y(d.NS, B),
            m = v[0],
            b = v[1],
            E = d.I / b,
            K = d.GS / m,
            D = 0,
            F = 0;
          d.QI = [];
          var I,
            x = 0,
            y = -ZC.MAX,
            X = d.A2.E["show-line"] ? 3 : 2,
            Y = null,
            w = function w(t) {
              var i = t;
              if (null === ZC._n_(e) && (e = 0), g[I] && g[I].S[e]) {
                var a = ZC.AQ.OE(d.BR.o, g[I].o);
                t = g[I].FK(e).ES(t, a);
              }
              return d.Y7 = d.Y7 || t !== i, t;
            },
            L = 0;
          for (d.Y7 = !1, r = 0, o = d.B6.length; r < o; r++) if (!(r - L < d.D2.min || r - L >= d.D2.max || d.NN)) {
            var M = new DT(d);
            M.copy(d.B6[r]), d.E["highlight-legend"] === r && (M.append({
              bold: !0
            }), null !== ZC._n_(d.o.item) && M.append(d.o.item["highlight-state"])), I = M.E.index;
            var H = new DT(d);
            H.OP = "legenditem", H.K = d.K + "-item_" + I, H.GO = "zc-legend-item " + d.K + "-item", H.copy(M), d.A.E["plot" + I + ".visible"] && "off" !== g[I].o["legend-status"] || H.append(d.ZT.o), H.append(g[I].o["legend-item"]), H.ES = w, H.parse(), H.AN ? ("float" === d.NS ? (y = ZC.BQ(y, M.F), null === ZC._n_(Y) ? (M.iX = d.iX + d.EP + M.DX + X * M.DG, M.iY = d.EO + d.FO + M.E7, x = d.EO) : (M.iX = Y.iX + Y.I + Y.E6 + M.DX + X * M.DG, ZC._i_(M.iX + M.I + M.E6) > ZC._i_(d.iX + d.I) && (M.iX = d.iX + d.EP + M.DX + X * M.DG, x += y + M.E7 + M.DP, y = -ZC.MAX), M.iY = x + d.FO + M.E7)) : (M.iX = d.iX + (0 === F ? d.EP : 0) + F * E + M.DX + X * M.DG, M.iY = d.EO + d.FO + D * K + M.E7, ++F === b && (F = 0, D++)), Y = M, H.iX = M.iX = ZC._i_(M.iX), H.iY = M.iY = ZC._i_(M.iY), H.Z = H.C7 = d.Z, H.iX += d.BM, H.iY += d.BH, I === d.NJ && (d.E["calculate-y"] && (d.E["calculate-y"] = !1, d.E["dragged-offset-y"] = d.E["dragged-y"] - H.iY), H.iY = d.E["dragged-y"] - d.E["dragged-offset-y"] - H.DG / 4), H.paint(), typeof d.E.showhide !== ZC._[31] && null !== ZC._n_(d.E.showhide) || ZC.move || ("canvas" !== d.A.A.AA ? H.ED() : d.YF.push(H))) : L++;
            var G = d.A2.E.type;
            null !== ZC._n_(t = g[I].o["legend-marker"]) && null !== ZC._n_(t.type) && (G = t.type);
            var P,
              N = !1;
            switch ("match" !== G && "inherit" !== G || (N = !0, G = null !== ZC._n_(t = g[I].A2.o.type) ? t : "default"), -1 !== ZC.AV(["default", "square"], G) ? P = new I3(d) : (P = new DW(d)).DQ = G, P.OP = "legendmarker", P.append(d.A2.o), d.A.E["plot" + I + ".visible"] && "off" !== g[I].o["legend-status"] || P.append(d.NW.o), P.NO = g[I].NO, g[I].AF) {
              case "pie":
              case "pie3d":
              case "nestedpie":
              case "vbar":
              case "vbar3d":
              case "hbar":
              case "hbar3d":
              case "vbullet":
              case "hbullet":
              case "area":
              case "area3d":
              case "gauge":
              case "vfunnel":
              case "hfunnel":
              case "venn":
                P.A0 = g[I].A0, P.AE = g[I].AE, P.GV = g[I].GV, P.HU = g[I].HU;
                break;
              case "scatter":
              case "hscatter":
              case "bubble":
              case "hbubble":
                P.A0 = "-1" !== g[I].A2.A0 ? g[I].A2.A0 : g[I].A0, P.AE = "-1" !== g[I].A2.AE ? g[I].A2.AE : g[I].AE, P.GV = "" !== g[I].A2.GV ? g[I].A2.GV : g[I].GV, P.HU = "" !== g[I].A2.HU ? g[I].A2.HU : g[I].HU;
                break;
              default:
                P.A0 = g[I].B7, P.AE = g[I].B7;
            }
            "line" !== P.DQ && "area" !== P.DQ || (P.B7 = P.A0, P.AZ = 2), N && P.append(g[I].A2.o), P.o["line-style"] = "solid", P.o.type = P.DQ, P.append(g[I].o["legend-marker"]), N && (P.o.type = P.DQ), P.E["show-marker"] = !0, P.E["show-line"] = !1, null !== ZC._n_(t = P.o["show-line"]) && (P.E["show-line"] = ZC._b_(t)), null !== ZC._n_(t = H.o["show-line"]) && (P.E["show-line"] = ZC._b_(t)), null !== ZC._n_(t = H.o["show-marker"]) && (P.o.visible = ZC._b_(t)), -1 !== ZC.AV(["default", "square"], G) && null !== ZC._n_(t = P.o[ZC._[21]]) && (null === ZC._n_(P.o[ZC._[19]]) && (P.o[ZC._[19]] = 2 * ZC._i_(t)), null === ZC._n_(P.o[ZC._[20]]) && (P.o[ZC._[20]] = 2 * ZC._i_(t))), P.K = d.K + "-marker_" + I, P.Z = P.C7 = d.Z, P.iX = H.iX - X * H.DG + (X - 1) * H.DG / 2 + H.DG / 2, P.iY = H.iY + (H.F - H.DG) / 2 + H.DG / 2, P.parse(), d.E["highlight-legend"] === r && (P.append({
              size: P.AI + 1,
              width: P.I + 2,
              height: P.F + 2
            }), g[I] && g[I].S[e] && g[I].S[e].GL && P.append({
              A0: g[I].S[e].GL.A0,
              AE: g[I].S[e].GL.AE
            }), null !== ZC._n_(d.o.marker) && P.append(d.o.marker["highlight-state"]), P.parse()), "line" === P.DQ ? (P.o.points = [[P.iX - 1.75 * P.AI, P.iY], [P.iX + 1.75 * P.AI, P.iY]], P.parse()) : "area" === P.DQ && (P.o.points = [[P.iX - 1.75 * P.AI, P.iY + P.AI], [P.iX + 1.75 * P.AI, P.iY + P.AI], [P.iX + 1 * P.AI, P.iY - P.AI / 2], [P.iX, P.iY], [P.iX - 1.25 * P.AI, P.iY - P.AI], [P.iX - 1.75 * P.AI, P.iY + P.AI]], P.parse());
            var O = P.iX + P.BM,
              S = P.iY + P.BH;
            if (-1 !== ZC.AV(["default", "square"], G) && (P.iX -= P.I / 2, P.iY -= P.F / 2), d.A.E["plot" + I + ".visible"] && "off" !== g[I].o["legend-status"] || (P.C6 /= 4), H.AN && P.E["show-line"]) {
              var Q = ZC.Q.E9(d.Z, d.A.H.AA),
                k = new CZ(d);
              k.Z = d.Z, k.copy(g[I]), k.o["line-style"] = d.A2.GH, k.append(g[I].o), k.append(d.A2.o), k.append(g[I].o["legend-item"]), k.append(g[I].o["legend-marker"]), k.parse(), d.A.E["plot" + I + ".visible"] || (k.C6 = .25);
              var T = [],
                z = P.AN ? 2 : 1;
              s = "box" === P.DQ ? P.I / 2 : P.AI, T.push([O - z * s - (k.AZ > 1 ? 1 : 0), S - (k.AZ > 1 ? .5 : 0)]), T.push([O + z * s, S - (k.AZ > 1 ? .5 : 0)]), k.CY = !0, ZC.CQ.paint(Q, k, T);
            }
            I === d.NJ && (P.iY = d.E["dragged-y"] - d.E["dragged-offset-y"] / 2), P.AN && H.AN && P.paint(), d.QI.push(P);
            var V = !0;
            if (null !== ZC._n_(t = d.BR.o.toggle) && (V = ZC._b_(t)), d.E["item.toggle"] = V, (H.AN || P.AN) && -1 === ZC.AV(d.A.H.L0, ZC._[41])) {
              var R = P.BM + ("box" === P.DQ ? P.iX + P.I / 2 : P.iX),
                J = P.BH + ("box" === P.DQ ? P.iY + P.F / 2 : P.iY);
              s = "box" === P.DQ ? P.I / 2 : P.AI, C = "box" === P.DQ ? P.F / 2 : P.AI;
              var W = (P.E["show-line"] ? 2 : 1) * s;
              ZC.AK(H.K + "-area") || (P.AN && "disabled" !== d.Q5 && "disabled" !== P.o[ZC._[54]] && (ZC.AK(P.K + "-area") || ZC.Q.I7({
                cls: d.K + "-marker-area zc-legend-marker-area zc-abs",
                id: P.K + "-area",
                wh: 2 * W + "/" + 2 * C,
                tl: J - C + "/" + (R - W),
                opacity: 0,
                background: "#fff",
                cursor: P.J3,
                p: f,
                zidx: 1
              })), H.AN && "disabled" !== d.RH && "disabled" !== H.o[ZC._[54]] && (ZC.AK(H.K + "-area") || ZC.Q.I7({
                cls: d.K + "-item-area zc-legend-item-area zc-abs",
                id: H.K + "-area",
                wh: H.I + "/" + H.F,
                tl: H.iY + H.BH + "/" + (H.iX + H.BM),
                opacity: 0,
                background: "#fff",
                cursor: H.J3,
                p: f,
                zidx: 1
              })));
            }
          }
          if (d.D1 && !d.NN && (d.D1.paint(), ZC.AK(d.K + "-scroll-c").style.display = "block"), d.D1 && d.NN && (ZC.AK(d.K + "-scroll-c").style.display = "none"), d.D2.enabled && !d.NN) {
            var U = new DT(d);
            U.Z = U.C7 = d.Z, U.K = d.K + "-page-status", U.AO = ZC.HQ["legend-pagination"].replace("%page%", d.D2.page).replace("%pages%", d.D2.pages), U.append(d.o["page-status"]), U.parse(), d.I < U.I + 48 && (U.AO = d.D2.page + "/" + d.D2.pages, U.parse()), U.iX = d.iX + d.I / 2 - U.I / 2, U.iY = d.iY + d.F - (d.KS ? d.KS.F : 0) - U.F - 4, U.AN && U.paint();
            var j = d.A.H.B8,
              q = "(" + d.A.AF + ")",
              $ = {
                "background-color": "#999"
              },
              ee = {
                "background-color": "#f90"
              };
            j.load($, q + ".legend.page-off"), j.load(ee, q + ".legend.page-on"), (Z = new DW(d)).Z = Z.C7 = d.Z, Z.K = d.K + "-page-prev", Z.A0 = Z.AE = d.D2.page > 1 ? ee[ZC._[0]] : $[ZC._[0]], Z.append(d.D2.page > 1 ? d.o["page-on"] : d.o["page-off"]), A = d.iX + d.I / 2 - U.I / 2 - 6, c = U.iY + U.F / 2, Z.parse(), Z.AI = ZC.BQ(Z.AI, 8), _ = ZC._i_(.75 * Z.AI), Z.D = [[A, c - _], [A, c + _], [A - Z.AI, c], [A, c - _]], Z.parse(), Z.AN && Z.paint(), (u = new DW(d)).Z = u.C7 = d.Z, u.K = d.K + "-page-next", u.A0 = u.AE = d.D2.page < d.D2.pages ? ee[ZC._[0]] : $[ZC._[0]], u.append(d.D2.page < d.D2.pages ? d.o["page-on"] : d.o["page-off"]), p = d.iX + d.I / 2 + U.I / 2 + 6, h = U.iY + U.F / 2, u.parse(), u.AI = ZC.BQ(u.AI, 8), _ = ZC._i_(.75 * u.AI), u.D = [[p, h - _], [p, h + _], [p + u.AI, h], [p, h - _]], u.parse(), u.AN && u.paint();
          }
          if (!ZC.move) {
            var te,
              ie,
              ae = d.F,
              ne = d.iY;
            d.FR && (ae -= d.FR.F, ne += d.FR.F), ZC.AK(d.K + "-frame") ? ZC.A5("#" + d.K + "-frame").css("top", ne + "px").css("left", d.iX + "px").css(ZC._[19], d.I + "px").css(ZC._[20], ae + "px") : ZC.Q.I7({
              cls: "zc-abs zc-legend-frame " + d.K + "-frame",
              id: d.K + "-frame",
              wh: d.I + "/" + ae,
              tl: ne + "/" + d.iX,
              opacity: 0,
              background: "#fff",
              p: f,
              zidx: 0
            }), d.D2.enabled && !d.NN && (d.D2.page > 1 && ZC.Q.I7({
              cls: d.K + "-page-area zc-legend-page-area zc-abs",
              id: d.K + "-page-prev-area",
              wh: Z.AI + "/" + 2 * Z.AI,
              tl: ZC._i_(c + Z.BH - Z.AI) + "/" + ZC._i_(A + Z.BM - Z.AI),
              opacity: 0,
              p: f,
              zidx: 1
            }), d.D2.page < d.D2.pages && ZC.Q.I7({
              cls: d.K + "-page-area zc-legend-page-area zc-abs",
              id: d.K + "-page-next-area",
              wh: u.AI + "/" + 2 * u.AI,
              tl: ZC._i_(h + Z.BH - u.AI) + "/" + ZC._i_(p + u.BM),
              opacity: 0,
              p: f,
              zidx: 1
            })), d.FR && d.VQ && ("icon" === d.V5 ? (ie = ZC._i_(d.FR.iY + ZC.MAPTX + a.BH) + "/" + ZC._i_(d.FR.iX + d.FR.I - 20 + ZC.MAPTX + a.BM), te = "20/" + d.FR.F) : (ie = ZC._i_(d.FR.iY + ZC.MAPTX) + "/" + ZC._i_(d.FR.iX + ZC.MAPTX), te = d.FR.I - (d.VF ? 23 : 0) + "/" + d.FR.F), ZC.Q.I7({
              cls: d.K + "-header-area zc-legend-header-area zc-abs",
              id: d.K + "-move-area",
              wh: te,
              tl: ie,
              opacity: 0,
              p: f,
              zidx: 1
            })), d.VF && (d.VQ && "icon" === d.V5 ? (ie = ZC._i_(d.FR.iY + ZC.MAPTX + i.BH) + "/" + ZC._i_(d.FR.iX + d.FR.I - 41 + ZC.MAPTX + i.BM), te = "20/" + d.FR.F) : (ie = ZC._i_(d.FR.iY + ZC.MAPTX + i.BH) + "/" + ZC._i_(d.FR.iX + d.FR.I - 22 + ZC.MAPTX + i.BM), te = "20/" + d.FR.F), ZC.Q.I7({
              cls: d.K + "-header-area zc-legend-header-area zc-abs",
              id: d.K + "-minimize-area",
              wh: te,
              tl: ie,
              opacity: 0,
              p: f,
              zidx: 1
            })), d.P4 = 0, d.A0I = 0, d.zc_legend_mouseover = function () {
              d.ZE = !0;
            }, d.zc_legend_mouseout = function () {
              d.ZE = !1;
            }, d.ZQ = function (e) {
              if (e.preventDefault(), d.H.hideCM(), ZC.move = !0, ZC.mobile || !(e.which > 1)) {
                d.A.A.E["graph-" + d.A.K + "-legend-info"] = null;
                var t = ZC.Q.MM(e),
                  i = ZC.A5("#" + d.A.A.K + "-top").offset();
                d.P4 = t[0] - i.left - d.FR.iX, d.A0I = t[1] - i.top - d.FR.iY, d.oldcursor = document.body.style.cursor, document.body.style.cursor = "move", ZC.A5(document.body).bind(ZC.Q.BX(ZC._[48]), d.ZR), ZC.A5(document.body).bind(ZC.Q.BX(ZC._[49]), d.A1C);
              }
            }, d.ZR = function (e) {
              var t = ZC.Q.MM(e),
                i = ZC.A5("#" + d.A.A.K + "-top").offset(),
                a = t[0] - i.left - d.P4,
                n = t[1] - i.top - d.A0I;
              if (d.Q3 ? (a = ZC.BQ(a, d.H.iX + 2), a = ZC.CX(a, d.H.iX + d.H.I - d.I - 2), n = ZC.BQ(n, d.H.iY + 2), n = ZC.CX(n, d.H.iY + d.H.F - d.F - 4)) : (a = ZC.BQ(a, d.A.iX + 2), a = ZC.CX(a, d.A.iX + d.A.I - d.I - 2), n = ZC.BQ(n, d.A.iY + 2), n = ZC.CX(n, d.A.iY + d.A.F - d.F - 4)), d.Q3 || (a -= d.A.iX, n -= d.A.iY), d.o.x = a, d.o.y = n, d.o.position = null, d.clear(!0), d.parse(), d.paint(), d.FR) {
                var l = d.Q3 ? d.A.A : d.A;
                d.A.A.E["legend" + d.A.L + "-xy-ratio"] = [a / l.I, n / (l.F - d.FR.F)];
              }
            }, d.A1C = function () {
              ZC.move = !1, document.body.style.cursor = d.oldcursor, delete d.oldcursor, ZC.A5(document.body).unbind(ZC.Q.BX(ZC._[48]), d.ZR), ZC.A5(document.body).unbind(ZC.Q.BX(ZC._[49]), d.A1C), d.YF = [], d.clear(!1), d.parse(), d.paint(), d.VI();
            }, d.ZB = function (e) {
              d.E["default-width"] = null, -1 !== (e.targetid || e.target.id).indexOf("-page-next-area") ? (d.D2.min += d.EH, d.D2.max += d.EH, d.D2.page += 1) : (d.D2.min -= d.EH, d.D2.max -= d.EH, d.D2.page -= 1), (!(t = d.A.A.E["graph-" + d.A.K + "-legend-info"]) || null === ZC._n_(t.x) && null === ZC._n_(t.y)) && (d.iX = null, d.iY = null), d.VI(), d.A.JY();
            }, d.YL = function (e) {
              var t = d.NN ? "legendmaximize" : "legendminimize";
              e && (d.A.A.E["legend-toggling"] = 1), zingchart.exec(d.A.H.K, t, {
                graphid: d.A.L
              }), e && (d.A.A.E["legend-toggling"] = 0), e && (d.A.A.E["g" + d.A.L + "-legend-collapsed"] = "legendminimize" === t);
            }, d.N1 = function (e) {
              ZC.move = !0;
              var t = ZC.Q.MM(e),
                i = ZC.A5("#" + d.A.A.K + "-top").offset(),
                a = t[0] - i.left,
                n = t[1] - i.top;
              d.E["dragged-x"] = a, d.E["dragged-y"] = n, d.VI(), d.clear(!1), d.parse(), d.paint();
            }, d.WU = function (e) {
              if (e.preventDefault(), d.H.hideCM(), d.J3 = document.body.style.cursor, document.body.style.cursor = "move", ZC.mobile || !(e.which > 1)) {
                var t = new RegExp("-legend-item_([0-9]+)-area", "g").exec(e.target.id);
                t && (d.E["dragged-offset-y"] = 0, d.E["calculate-y"] = !0, d.E["dragged-x"] = 0, d.E["dragged-y"] = 0, d.NJ = ZC._i_(t[1]), d.iDragPos = ZC.AV(d.A.AY.MF, d.NJ), ZC.A5(document.body).bind(ZC.Q.BX(ZC._[48]), d.N1), ZC.A5(document.body).bind(ZC.Q.BX(ZC._[49]), d.XZ));
              }
            }, d.XZ = function () {
              var e = d.NJ,
                t = d.iDragPos;
              if (d.NJ = -1, d.iDragPos = -1, d.E["calculate-y"] = !1, document.body.style.cursor = d.J3, ZC.move || (e = -1, t = -1), ZC.A5(document.body).unbind(ZC.Q.BX(ZC._[48]), d.N1), ZC.A5(document.body).unbind(ZC.Q.BX(ZC._[49]), d.XZ), ZC.move && -1 !== e) {
                for (var i = d.A.AY.A4, a = d.A.AY.MF, n = 0, l = i.length; n < l; n++) i[n].o["legend-item"] = i[n].o["legend-item"] || {}, null === ZC._n_(i[n].o["legend-item"].order) && (i[n].o["legend-item"].order = ZC._i_(i[n].o["z-index"] || n + 1));
                for (var r = i[e].o["legend-item"].order, o = -1, s = 0, C = d.QI.length; s < C; s++) d.E["dragged-y"] - d.E["dragged-offset-y"] / 2 > d.QI[s].iY && (o = s);
                for (i[e].o["legend-item"].order = -1 === o ? .5 : i[a[o]].o["legend-item"].order + .5, s = 0, C = d.QI.length; s < C; s++) o > t ? i[s].o["legend-item"].order < i[e].o["legend-item"].order && i[s].o["legend-item"].order > r && i[s].o["legend-item"].order-- : i[s].o["legend-item"].order > i[e].o["legend-item"].order && i[s].o["legend-item"].order < r && i[s].o["legend-item"].order++;
                for (i[e].o["legend-item"].order = o > t ? Math.floor(i[e].o["legend-item"].order) : Math.ceil(i[e].o["legend-item"].order), s = 0, C = d.QI.length; s < C; s++) d.A.o[ZC._[11]][s]["z-index"] = i[s].o["legend-item"].order;
              }
              d.A.AY.E["plot-sort"] = !0, ZC.move = !1, d.clear(!1), d.A.JY();
            }, ZC.A5("#" + d.K + "-frame").live(ZC.Q.BX("mouseover"), d.zc_legend_mouseover).live(ZC.Q.BX("mouseout"), d.zc_legend_mouseout), ZC.A5("#" + d.K + "-move-area").live(ZC.Q.BX(ZC._[47]), d.ZQ), ZC.A5("#" + d.K + "-minimize-area").live(ZC.Q.BX("click"), d.YL), ZC.A5("." + d.K + "-page-area").live(ZC.Q.BX("click"), d.ZB), d.BR.o.reorder && ZC.A5("." + d.A.K + "-legend-item-area").live(ZC._[47], d.WU);
          }
          d.E.showhide = null, 1 === d.A.A.E["legend-toggling"] || ZC.move || (d.MA && null === ZC._n_(d.A.A.E["g" + d.A.L + "-legend-collapsed"]) || d.A.A.E["g" + d.A.L + "-legend-collapsed"] && !d.NN) && (window.setTimeout(function () {
            d.YL(!0);
          }, 0), d.A.A.E["g" + d.A.L + "-legend-collapsed"] = !0);
        }
      }
    }, {
      key: "gc",
      value: function gc() {
        ZC.AQ.gc(this, ["B6", "D", "QI", "Z", "C7", "o", "JG", "ID", "KS", "FR", "BR", "ZT", "H", "A", "A2", "NW", "D2"]);
      }
    }]);
    return A2H;
  }(DT);
  var ACI = /*#__PURE__*/function (_DW3) {
    _inherits(ACI, _DW3);
    function ACI(e) {
      var _this17;
      _classCallCheck(this, ACI);
      _this17 = _possibleConstructorReturn(this, _getPrototypeOf(ACI).call(this, e));
      var t = _assertThisInitialized(_this17);
      t.N7 = null, t.BB = null, t.M = null, t.JX = 0, t.BF = null, t.GF = "bottom", t.L8 = 40, t.A3H = [2, 4];
      return _this17;
    }
    _createClass(ACI, [{
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a = this;
        (a.assign_a([["z-index", "JX", "i"], ["length", "L8", "i"], ["aspect", "A3H"], ["direction", "GF"]]), null === ZC._n_(a.o.from) && null === ZC._n_(a.o.to)) && null !== ZC._n_(a.o.x) && null !== ZC._n_(a.o.y) && null !== ZC._n_(a.o.length) && null !== ZC._n_(a.o.angle) && (t = "string" == typeof a.o.x ? a.A.OL(a.o.x)[0] : ZC._i_(a.o.x), i = "string" == typeof a.o.y ? a.A.OL(a.o.y)[1] : ZC._i_(a.o.y), a.o.from = {
          x: t + a.L8 * ZC.EN(a.A9 + 180),
          y: i + a.L8 * ZC.EG(a.A9 + 180)
        }, a.o.to = {
          x: t + a.L8 * ZC.EN(a.A9),
          y: i + a.L8 * ZC.EG(a.A9)
        });
        null !== ZC._n_(e = a.o.from) && (a.N7 = new DW(a.A), a.N7.append(e), null !== e.hook && (a.N7.E.hook = e.hook), a.N7.parse(), "string" == typeof e && (a.N7.E.hook = e)), null !== ZC._n_(e = a.o.to) && (a.BB = new DW(a.A), a.BB.append(e), null !== e.hook && (a.BB.E.hook = e.hook), a.BB.parse(), "string" == typeof e && (a.BB.E.hook = e)), (null !== ZC._n_(e = a.o.label) || "" !== a.o.text && typeof a.o.text !== ZC._[31]) && (a.M = new DT(a), a.M.append(a.o), a.M.append(e), a.M.parse()), _get(_getPrototypeOf(ACI.prototype), "parse", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i = this;
        if (i.AN && (null !== i.N7 || null !== i.BB)) if (i.AI < 1 && (i.AI = 1), !i.N7 || null === ZC._n_(e = i.N7.E.hook) || (t = i.A.OL(e), i.N7.iX = t[0], i.N7.iY = t[1], i.N7.iX += i.N7.BM, i.N7.iY += i.N7.BH, ZC.DR(i.N7.iX, i.A.P.iX - 2, i.A.P.iX + i.A.P.I + 2) && ZC.DR(i.N7.iY, i.A.P.iY - 2, i.A.P.iY + i.A.P.F + 2))) {
          if (!i.BB || null === ZC._n_(e = i.BB.E.hook) || (t = i.A.OL(e), i.BB.iX = t[0], i.BB.iY = t[1], i.BB.iX += i.BB.BM, i.BB.iY += i.BB.BH, ZC.DR(i.BB.iX, i.A.P.iX - 2, i.A.P.iX + i.A.P.I + 2) && ZC.DR(i.BB.iY, i.A.P.iY - 2, i.A.P.iY + i.A.P.F + 2))) {
            var a, n;
            if (i.N7 && i.BB) a = [i.N7.iX, i.N7.iY], n = [i.BB.iX, i.BB.iY];else if (i.N7 && !i.BB) switch (a = [i.N7.iX, i.N7.iY], i.GF) {
              case "top":
                n = [i.N7.iX, i.N7.iY + i.L8];
                break;
              case "right":
                n = [i.N7.iX + i.L8, i.N7.iY];
                break;
              case "bottom":
                n = [i.N7.iX, i.N7.iY - i.L8];
                break;
              case "left":
                n = [i.N7.iX - i.L8, i.N7.iY];
            } else if (!i.N7 && i.BB) switch (n = [i.BB.iX, i.BB.iY], i.GF) {
              case "top":
                a = [i.BB.iX, i.BB.iY + i.L8];
                break;
              case "right":
                a = [i.BB.iX - i.L8, i.BB.iY];
                break;
              case "bottom":
                a = [i.BB.iX, i.BB.iY - i.L8];
                break;
              case "left":
                a = [i.BB.iX + i.L8, i.BB.iY];
            }
            var l,
              r = n[0] - a[0],
              o = n[1] - a[1],
              s = ZC.UE(Math.atan2(o, r)),
              C = Math.sqrt(r * r + o * o),
              A = [];
            if (A.push(a), l = ZC.AR.BN(a[0], a[1], i.AI / 2, s + 90), A.push(l), l = ZC.AR.BN(l[0], l[1], C - i.A3H[1] * i.AI / 2, s), A.push(l), l = ZC.AR.BN(l[0], l[1], i.A3H[0] * i.AI / 2, s + 90), A.push(l), A.push(n), l = ZC.AR.BN(l[0], l[1], (2 * i.A3H[0] + 2) * i.AI / 2, s - 90), A.push(l), l = ZC.AR.BN(l[0], l[1], i.A3H[0] * i.AI / 2, s + 90), A.push(l), l = ZC.AR.BN(a[0], a[1], i.AI / 2, s - 90), A.push(l), A.push(a), i.BF = new DW(i.A), i.BF.K = i.K, i.BF.Z = i.BF.C7 = i.Z, i.BF.copy(i), i.BF.D = A, i.BF.CY = !1, i.BF.parse(), i.BF.paint(), null !== i.M && i.M.AN) {
              i.M.Z = i.Z, i.M.K = i.A.K + "-arrow-label-" + i.HB, i.M.GO = i.A.K + "-arrow-label zc-arrow-label";
              var Z = ZC.AR.JZ(a[0], a[1], n[0], n[1]);
              i.M.iX = Z[0], i.M.iY = Z[1], i.M.BM -= i.M.I / 2, i.M.BH -= i.M.F / 2, null !== ZC._n_(i.M.o["font-angle"]) && "inherit" === i.M.o["font-angle"] && (i.M.A9 = s), i.M.paint(), i.M.ED();
            }
          } else i.AN = !1;
        } else i.AN = !1;
      }
    }]);
    return ACI;
  }(DW);
  var KB = /*#__PURE__*/function (_ZCClass6) {
    _inherits(KB, _ZCClass6);
    function KB(e) {
      var _this18;
      _classCallCheck(this, KB);
      _this18 = _possibleConstructorReturn(this, _getPrototypeOf(KB).call(this, e));
      var t = _assertThisInitialized(_this18);
      t.H = e, t.SJ = !1, t.C4 = null, t.Z7 = null, t.QN = null, t.zc_guide_touchend = null;
      return _this18;
    }
    _createClass(KB, [{
      key: "unbind",
      value: function unbind() {
        var e = this;
        e.C4 && window.clearInterval(e.C4), e.Z7 && window.clearInterval(e.Z7), ZC.A5(document.body).unbind("mousemove touchstart touchmove", e.QN), ZC.A5(document.body).unbind("touchend", e.zc_guide_touchend);
      }
    }, {
      key: "bind",
      value: function bind() {
        var e,
          t = this,
          i = t.H.K,
          a = ZC.AK(i + "-guide-c"),
          n = ZC.Q.E9(a, t.H.AA),
          l = {},
          r = {},
          o = {},
          s = {},
          C = null,
          A = null,
          Z = null;
        function c() {
          !A && Z && (Z.E["guide-active-plot"] = null), KB.GUIDES && KB.GUIDES[i] && !KB.GUIDES[i].blocked && KB.clearGuide(i), A = null;
        }
        ZC.mobile || null !== ZC._n_(ZC.Z7) || (t.Z7 = window.setInterval(function () {
          for (var e = !0, a = 0, n = zingchart.I8.length; a < n; a++) if (i === zingchart.I8[a].K) if (ZC.AK(zingchart.I8[a].K + "-top")) {
            var l = ZC._tx_(i),
              r = ZC.A5("#" + zingchart.I8[a].K + "-top").offset();
            ZC.E0[0] >= r.left && ZC.E0[0] <= r.left + zingchart.I8[a].I * l[0] && ZC.E0[1] >= r.top && ZC.E0[1] <= r.top + zingchart.I8[a].F * l[1] && (e = !1);
          } else window.clearInterval(t.Z7);
          e && (c(), KB.GUIDES && KB.GUIDES[i] && KB.GUIDES[i].active && (ZC.AQ.BZ("guide_mouseout", t.H, t.H.F5()), KB.GUIDES[i].active = !1));
        }, 500)), t.QN = function (p) {
          if (zingchart.GUIDE_EV = p, !p.target.id || -1 === p.target.id.indexOf("-menu-item-")) {
            var u, h, _, d, f, g, B, v, m, b, E, K, D, F, I, x, y, X, Y, w, L, M, H, G, P, N, O;
            ZC.MAX, ZC.MAX;
            for (u = 0; u < zingchart.I8.length; u++) if (zingchart.I8[u].K !== t.H.K && -1 !== zingchart.I8[u].K.indexOf("-fullscreen")) return;
            if ((ZC.ie67 || p.type !== ZC._[48] || !ZC.TOUCHEVENTS) && -1 !== p.target.id.indexOf(t.H.K + "-") && (!ZC.move || ZC.mobile)) {
              if (t.H.A09 || !ZC.AK(i + "-top")) return !1;
              if (!ZC.Q.AB9(ZC.AK(i + "-top"))) return !1;
              var S = [],
                Q = ZC.Q.MM(p),
                k = Q[0],
                T = Q[1];
              if (null !== ZC._n_(p._pageX_) && (k = p._pageX_), null !== ZC._n_(p._pageY_) && (T = p._pageY_), null === ZC._n_(p._pageX_) && null === ZC._n_(p._pageY_)) {
                var z = ZC.A5("#" + i + "-top").offset();
                _ = k - z.left, d = T - z.top;
              } else _ = k, d = T;
              var V = ZC._tx_(t.H.K);
              for (_ /= V[0], d /= V[1], u = 0, h = t.H.AG.length; u < h; u++) f = t.H.AG[u].P, ZC.DR(_, f.iX - 15, f.iX + f.I + 15) && ZC.DR(d, f.iY - 15, f.iY + f.F + 15) && (A = t.H.AG[u]), ZC.DR(_, t.H.AG[u].iX, t.H.AG[u].iX + t.H.AG[u].I) && ZC.DR(d, t.H.AG[u].iY, t.H.AG[u].iY + t.H.AG[u].F) && (C = t.H.AG[u]);
              var R = null,
                J = !1;
              if (A) {
                if (KB.GUIDES = KB.GUIDES || {}, KB.GUIDES[i] = KB.GUIDES[i] || {}, p.fromAPI || (KB.GUIDES[i].blocked = !1, KB.GUIDES[i].active = !0), Z = A, A.CW && "hover" === A.CW.o.trigger) {
                  null !== ZC._n_(A.E["guide-active-plot"]) && (R = A.E["guide-active-plot"]);
                  var W = /(.+)-plotset-plot-(.+)-node-(.+)/.exec(p.target.id);
                  if (W && W.length && (R = parseInt(W[2], 10), A.E["guide-active-plot"] = R), null === ZC._n_(R)) return;
                }
                if (!A.A1V) return void c();
                for (S.push(A), A && A.CW && (J = null !== ZC._n_(A.CW.o.shared) && ZC._b_(A.CW.o.shared)), u = 0, h = t.H.AG.length; u < h; u++) if (t.H.AG[u] !== A) {
                  f = t.H.AG[u].P;
                  var U = t.H.AG[u].CW,
                    j = t.H.AG[u].HD,
                    q = U && null !== ZC._n_(U.o.shared) && ZC._b_(U.o.shared);
                  q && ("xy" === A.AJ.layout && "xy" === t.H.AG[u].AJ.layout && (U || j) && ZC.DR(_, f.iX - 5, f.iX + f.I + 5) && (ZC.DR(d, f.iY - 5, f.iY + f.F + 5) || J && q) || "yx" === A.AJ.layout && "yx" === t.H.AG[u].AJ.layout && (U || j) && ZC.DR(d, f.iY - 5, f.iY + f.F + 5) && (ZC.DR(_, f.iX - 5, f.iX + f.I + 5) || J && q)) && S.push(t.H.AG[u]);
                }
              } else if (KB.GUIDES) for (var $ in KB.GUIDES) if (KB.GUIDES[$] && KB.GUIDES[$].active) {
                var ee = zingchart.getLoader($);
                P = ee.F5(), ZC.AQ.BZ("guide_mouseout", ee, P), KB.GUIDES[$].active = !1;
              }
              if (0 === S.length && (l = {}, r = {}, o = {}, t.SJ && (null === ZC._n_(p._pageX_) && c(), t.SJ = !1), Z && Z.A.A7 && C && C.K !== Z.K && Z.A.A7.hide()), S.length > 0) {
                t.SJ = !0;
                for (var te = !1, ie = 0, ae = S.length; ie < ae; ie++) {
                  var ne = !1;
                  if (null === ZC._n_(l[ie]) && (l[ie] = {}), null === ZC._n_(r[ie]) && (r[ie] = {}), null === ZC._n_(o[ie]) && (o[ie] = {}), (S[ie].CW || S[ie].HD) && "ready" === S[ie].MK) {
                    var le,
                      re = [],
                      oe = [],
                      se = [],
                      Ce = !1,
                      Ae = "",
                      Ze = [],
                      ce = [],
                      pe = [],
                      ue = [],
                      he = {},
                      _e = {},
                      de = [];
                    f = S[ie].P;
                    var fe = S[ie].CW && null !== ZC._n_(S[ie].CW.o.exact) && ZC._b_(S[ie].CW.o.exact),
                      ge = -1;
                    S[ie].CW && (ge = ZC._i_(ZC._c_(S[ie].CW.o.tolerance || -1))), F = [-1, ZC.MAX], I = [-1, ZC.MAX], ZC.MAX, ZC.MAX;
                    var Be,
                      ve,
                      me = !0,
                      be = [],
                      Ee = "";
                    S[ie].CW && (null !== ZC._n_(S[ie].CW.o["plot-label"]) && ZC._n_(null !== (e = S[ie].CW.o["plot-label"].multiple)) && (me = ZC._b_(e)), null !== ZC._n_(S[ie].CW.o["value-label"]) && ZC._n_(null !== (e = S[ie].CW.o["value-label"].multiple)) && (me = ZC._b_(e)));
                    var Ke = {};
                    for (M = 0, H = S[ie].AY.A4.length; M < H; M++) if (!S[ie].AY.A4[M].M1 && (u = M, S[ie].CW && S[ie].CW.o["reverse-series"] && (u = H - M - 1), S[ie].E["plot" + u + ".visible"])) {
                      if (null !== ZC._n_(R) && u !== R) continue;
                      if (!(Be = S[ie].BJ(S[ie].AY.A4[u].BT("k")[0]))) continue;
                      if (Be.CO) {
                        var De = Be.AW ? Be.iY + Be.BV : Be.iY + Be.AB,
                          Fe = Be.AW ? Be.iY + Be.F - Be.BV : Be.iY + Be.F - Be.AB;
                        d = ZC._l_(d, De, Fe), g = Be.EF && S[ie].AY.A4[u].EF ? Be.N0(d, S[ie].AY.A4[u]) : Be.N0(d);
                      } else {
                        var Ie = Be.AW ? Be.iX + Be.BV : Be.iX + Be.AB,
                          xe = Be.AW ? Be.iX + Be.I - Be.AB : Be.iX + Be.I - Be.BV;
                        _ = ZC._l_(_, Ie, xe), g = Be.EF && S[ie].AY.A4[u].EF ? Be.N0(_, S[ie].AY.A4[u]) : Be.N0(_);
                      }
                      if (null === ZC._n_(g)) continue;
                      var ye,
                        Xe,
                        Ye,
                        we,
                        Le,
                        Me,
                        He,
                        Ge,
                        Pe = [];
                      if (Pe = typeof g.length === ZC._[31] || 0 === g.length ? [g] : g, S[ie].CW) {
                        for (var Ne = 0, Oe = Pe.length; Ne < Oe; Ne++) if (g = Pe[Ne], B = S[ie].AY.A4[u].FK(g)) {
                          le = B, B.setup(), B.N ? (ZC.COLORS = [B.N.C2, B.N.A0, B.N.AE, B.N.BW, B.N.B7], B.NM && ZC.COLORS.push(B.NM.A0, B.NM.AE, B.NM.BW, B.NM.B7)) : ZC.COLORS = [], B.A.IA && typeof B.E.A69 !== ZC._[31] && B.paint(!0), x = B.iX, y = B.iY, typeof B.E.A69 !== ZC._[31] && (x = parseInt(B.E.A69, 10)), typeof B.E.A8V !== ZC._[31] && (y = parseInt(B.E.A8V, 10)), K = x, D = y, he[u] = {
                            index: g,
                            y: y
                          }, S[ie].BC && S[ie].BC.Y7 && (S[ie].BC.clear(!0), S[ie].BC.parse(), S[ie].BC.paint(g)), (v = new DT(Be)).Z = v.C7 = a, v.K = S[ie].K + "-guide-label-" + g + "-" + u, v.GO = S[ie].A.K + "-guide-label " + S[ie].K + "-guide-label zc-guide-label", me && (L = B.A01(), v.AO = B.A.JD), me ? v.append(S[ie].CW.o["plot-label[multiple]"]) : v.append(S[ie].CW.o["plot-label[single]"]), v.append(S[ie].CW.o["plot-label"]), v.append(S[ie].CW.o["value-label"]), v.append(S[ie].AY.A4[u].o["guide-label"]), E = ZC.AQ.OE(v.o, S[ie].AY.A4[u].o), v.ES = function (e) {
                            return B ? B.ES(e, E) : e;
                          }, B.XD();
                          var Se = "auto";
                          if (null !== ZC._n_(e = v.o[ZC._[7]]) && (Se = e), v.E[ZC._[7]] = Se, v.L2 = me, v.E.plotidx = B.A.L, v.E.nodeidx = B.L, v.parse(), G = null !== ZC._n_(v.o.distance) ? ZC._i_(v.o.distance) : 6, v.E5 && v.E5.length && (v.IV = function (e) {
                            return e = B ? B.ES(e, E) : e.replace(/(%i)|(%node-index)/g, g);
                          }, v.DB() && v.parse()), v.I1 && B && (v.GN(v, v, null, B.LM(null, !1), v.MV), v.parse()), ZC.DR(B.iX, f.iX - .5, f.iX + f.I + .5)) {
                            switch (me || (0 === oe.length && (null === ZC._n_(v.o["header-text"]) || Ce || (Ce = !0, Ee += B.ES(v.o["header-text"], E) + "<br>"), null !== ZC._n_(v.o["footer-text"]) && "" === Ae && (Ae = B.ES(v.o["footer-text"], E) + "<br>")), v.AN && "" !== v.AO && (ZC._b_(v.o["single-text"]) ? be.push(B.ES(v.AO, E)) : be.push(B.ES(v.AO, E) + "<br>"))), v.E.pos = oe.length, v.E["node-value"] = B.AD, v.E["marker-x"] = x, v.E["marker-y"] = y, v.E["guide-style"] = B.A01(), Se) {
                              default:
                                null === ZC._n_(v.o.x) ? Be.CO ? B.iY <= f.iY + f.F / 2 ? (v.iY = y - v.F - G, v.EL = "bottom") : (v.iY = y + G, v.EL = "top") : B.iX >= f.iX + f.I / 2 ? (v.iX = x - v.I - G, v.EL = "right") : (v.iX = x + G, v.EL = "left") : v.iX -= f.iX, null === ZC._n_(v.o.y) ? Be.CO ? (v.iX = x - v.I / 2, v.iX < f.iX && (v.iX = f.iX), v.iX + v.I > f.iX + f.I && (v.iX = f.iX + f.I - v.I)) : (v.iY = y - v.F / 2, v.iY < f.iY && (v.iY = f.iY), v.iY + v.F > f.iY + f.F && (v.iY = f.iY + f.F - v.F)) : v.iY -= f.iY, v.DL = [x, y];
                                break;
                              case "left":
                                v.iX = x - v.I - G, v.iY = y - v.F / 2, v.DL = [x, y];
                                break;
                              case "right":
                                v.iX = x + G, v.iY = y - v.F / 2, v.DL = [x, y];
                                break;
                              case "top":
                                Be.CO ? (v.iX = f.iX + f.I - v.I, v.iY = y - v.F / 2, v.EL = "left", v.DL = [f.iX + f.I - v.I - G, y]) : (v.iX = x - v.I / 2, v.iY = f.iY, v.EL = "bottom", v.DL = [x, v.iY + v.F + G]);
                                break;
                              case "node-top":
                                Be.CO ? (v.iX = x + 2 * G, v.iY = y - v.F / 2, v.EL = "left", v.DL = [x + G, y]) : (v.iX = x - v.I / 2, v.iY = y - v.F - 2 * G, v.EL = "bottom", v.DL = [x, y - G]);
                                break;
                              case "bottom":
                                Be.CO ? (v.iX = f.iX, v.iY = y - v.F / 2, v.EL = "right", v.DL = [f.iX + v.I + G, y]) : (v.iX = x - v.I / 2, v.iY = f.iY + f.F - v.F, v.EL = "top", v.DL = [x, v.iY - G]);
                            }
                            re.push({
                              plotindex: B.A.L,
                              nodeindex: B.L,
                              keyvalue: B.BU || Be.V[B.L],
                              value: B.AD,
                              text: v.AO,
                              x: v.iX,
                              y: v.iY,
                              refx: x,
                              refy: y
                            }), -1 === ZC.AV(se, v.AO) && (s[v] = B, se.push(v.AO)), Be.CO ? v.E.diff = fe || -1 !== ge ? ZC._a_(y - d) : -1 : v.E.diff = fe || -1 !== ge ? ZC._a_(x - _) : -1, v.AN && oe.push(v), r[ie][u] = v, ne = !0;
                          }
                        }
                        if (!B) continue;
                      }
                      if (S[ie].CW && ZC.DR(B.iX, f.iX - 1, f.iX + f.I + 1)) {
                        if ((b = new DT(Be)).Z = b.C7 = a, b.K = S[ie].K + "-guide-scale-x-label-" + u, b.GO = S[ie].A.K + "-guide-label " + S[ie].K + "-guide-label zc-guide-label", b.A0 = b.AE = Be.B7, b.C2 = S[ie].AJ["3d"] ? "#999" : "#fff", b.append(S[ie].CW.o["scale-label"]), b.append(S[ie].CW.o[Be.BG + "-label"]), b.append(S[ie].AY.A4[u].o["scale-label"]), b.L2 = !0, b.E.nodeidx = B.L, E = ZC.AQ.OE(b.o), null === ZC._n_(E[ZC._[12]])) {
                          var Qe = Math.floor(ZC.G8(null !== B.BU ? B.BU : B.L, 10));
                          E[ZC._[12]] = Qe < 0 ? 1 - Qe : 0;
                        }
                        if (b.ES = function (e) {
                          e = Be.ES(e, g, Be.EF && S[ie].AY.A4[u].EF ? S[ie].AY.A4[u] : null, E, !0);
                          var t = S[ie].AY.A4[u].KJ;
                          if (B && t) for (var i in t) {
                            var a;
                            a = t[i] instanceof Array ? ZC._c_(t[i][B.L], "") : ZC._c_(t[i], ""), e = e.replace("%data-" + i, a, "g");
                          }
                          return e;
                        }, b.parse(), G = null !== ZC._n_(b.o.distance) ? ZC._i_(b.o.distance) : 6, b.E5 && b.E5.length && (b.IV = function (e) {
                          return e = B ? B.ES(e, E) : e.replace(/(%i)|(%node-index)/g, g);
                        }, b.DB() && b.parse()), b.I1 && B && (b.GN(b, b, null, B.LM(null, !1), b.MV), b.parse()), _e[Be.BG] = b.AO, ye = ZC._b_(b.o["callout-position"]), Xe = b.o.x, Ye = b.o.y, "opposite" !== Be.BA ? Be.CO ? (we = "right", Me = Be.E.iX - b.I - G, Le = [Be.E.iX, D], He = D - b.F / 2) : (we = "top", Me = K - b.I / 2, Le = [K, Be.E.iY], He = Be.E.iY + G) : Be.CO ? (we = "left", Me = Be.E.iX + G, Le = [Be.E.iX, D], He = D - b.F / 2) : (we = "bottom", Me = K - b.I / 2, Le = [K, Be.E.iY], He = Be.E.iY - b.F - G), ye || (b.EL = we), Xe || (b.iX = Me), ye || Xe || Ye || (b.DL = Le), Ye || (b.iY = He), b.AN && Be.AN && "" !== b.AO) {
                          var ke = !1;
                          if (de.length) for (var Te = 0; Te < de.length; Te++) b.AO + "@" + Be.BG === de[Te] && (ke = !0);
                          ke || (de.push(b.AO + "@" + Be.BG), Be.CO ? b.E.diff = fe || -1 !== ge ? ZC._a_(D - d) : -1 : b.E.diff = fe || -1 !== ge ? ZC._a_(K - _) : -1, pe.push(b)), ue.push(Be.BG), o[ie][u] = b, ne = !0;
                        }
                        -1 !== String(S[ie].CW.o[ZC._[4]]).indexOf("%") && (Ge = ZC.IU(S[ie].CW.o[ZC._[4]])) > 0 && Ge <= 1 && (S[ie].CW.AZ = ZC._i_(Ge * Be.AC)), Be.CO ? ((-1 === I[0] || I[1] > ZC._a_(D - d)) && (I = [D, ZC._a_(D - d)]), Ze.push([fe || -1 !== ge ? ZC._a_(D - d) : -1, [null, [Be.E.iX, D], [S[ie].P.iX + ("opposite" === Be.BA ? 0 : S[ie].P.I), D]]])) : ((-1 === F[0] || F[1] > ZC._a_(K - _)) && (F = [K, ZC._a_(K - _)]), Ze.push([fe || -1 !== ge ? ZC._a_(K - _) : -1, [null, [K, Be.E.iY], [K, S[ie].P.iY + ("opposite" === Be.BA ? S[ie].P.F : 0)]]]));
                      }
                      if (ve = S[ie].BJ(S[ie].AY.A4[u].BT("v")[0]), -1 === ZC.AV(ue, ve.BG) && S[ie].HD && ("xy" === S[ie].AJ.layout && ZC.DR(d, ve.iY, ve.iY + ve.F) || "yx" === S[ie].AJ.layout && ZC.DR(d, ve.iX, ve.iX + ve.I))) {
                        var ze = "single";
                        S[ie].HD.o.type && "multiple" === S[ie].HD.o.type && (ze = "multiple"), "multiple" === ze && null !== ZC._n_(he[u]) && (ve.CO ? _ = he[u].x : d = he[u].y), (b = new DT(ve)).Z = b.C7 = a, b.K = S[ie].K + "-guide-scale-y-label-" + u, b.GO = S[ie].A.K + "-guide-label " + S[ie].K + "-guide-label zc-guide-label";
                        var Ve = ve.B7;
                        "multiple" === ze && (Ve = S[ie].AY.A4[u].B7), b.A0 = b.AE = Ve, b.C2 = S[ie].AJ["3d"] && "multiple" !== ze ? "#999" : "#fff", b.append(S[ie].HD.o["scale-label"]), b.append(S[ie].HD.o[ve.BG + "-label"]), b.L2 = !0;
                        var Re = ve.CO ? ve.KV(_, !0) : ve.KV(d, !0),
                          Je = Re;
                        if (E = ve.LV(), ZC._cp_(ZC.AQ.OE(b.o, ve.o), E), null === ZC._n_(E[ZC._[12]])) {
                          Qe = Math.floor(ZC.G8(Re, 10));
                          E[ZC._[12]] = Qe <= 0 ? 1 - Qe : 0;
                        }
                        Re = ve.FC(0, Re, E), b.o.text = Re, b.parse(), G = null !== ZC._n_(b.o.distance) ? ZC._i_(b.o.distance) : 6, b.E5 && b.E5.length && (b.IV = function (e) {
                          return e = e.replace(/(%v)|(%scale-value)/g, Je).replace(/(%t)|(%scale-text)/g, Re).replace(/(%coord)/, ve.CO ? _ : d);
                        }, b.DB() && b.parse()), b.I1 && B && (Ke = {
                          value: Je,
                          text: Re,
                          coord: ve.CO ? _ : d
                        }, b.GN(b, b, null, Ke, b.MV), b.parse()), _e[ve.BG] = b.AO, ye = ZC._b_(b.o["callout-position"]), Xe = b.o.x, Ye = b.o.y, "opposite" !== ve.BA ? ve.CO ? (we = "top", Me = _ - b.I / 2, He = ve.E.iY + G, Le = [_, ve.E.iY]) : (we = "right", Me = ve.E.iX - b.I - G, He = d - b.F / 2, Le = [ve.E.iX, d]) : ve.CO ? (we = "bottom", Me = _ - b.I / 2, He = ve.E.iY - b.F - G, Le = [_, ve.E.iY]) : (we = "left", Me = ve.E.iX + G, He = d - b.F / 2, Le = [ve.E.iX, d]), ye || (b.EL = we), Xe || (b.iX = Me), ye || Xe || Ye || (b.DL = Le), Ye || (b.iY = He), b.AN && ve.AN && (b.E.diff = -1, pe.push(b), "multiple" === ze && null !== ZC._n_(he[u]) || ue.push(ve.BG), o[ie][u] = b, ne = !0), -1 !== String(S[ie].HD.o[ZC._[4]]).indexOf("%") && (Ge = ZC.IU(S[ie].HD.o[ZC._[4]])) > 0 && Ge <= 1 && (S[ie].HD.AZ = ZC._i_(Ge * ve.AC)), ve.CO ? ce.push(null, [_, ve.E.iY], [_, S[ie].P.iY + ("opposite" === ve.BA ? S[ie].P.F : 0)]) : ce.push(null, [ve.E.iX, d], [S[ie].P.iX + ("opposite" === ve.BA ? 0 : S[ie].P.I), d]);
                      }
                    }
                    if (!fe && pe.length > 1) for (var We = pe[pe.length - 1], Ue = ZC._i_((We.FO + We.FS + We.EP + We.FP) / 4), je = pe.length - 1; je >= 0; je--) for (var qe = je; qe >= 0; qe--) je !== qe && ZC.AR._boxoverlap2_(pe[je], pe[qe], -Ue) && (pe[qe].C6 = .3, pe[qe].VM = .1);
                    for (m = ZC.MAX, u = 0, h = oe.length; u < h; u++) oe[u].E.diff >= 0 && (m = ZC.CX(oe[u].E.diff, m));
                    -1 !== ge && (m = ZC.BQ(m, ge));
                    var $e = !1,
                      et = 1,
                      tt = !1;
                    oe[0] && (tt = ZC._b_(oe[0].o["single-text"]), oe[0].o["table-columns"] && ZC._b_(oe[0].o["html-mode"]) && ($e = !0, et = ZC._i_(oe[0].o["table-columns"] || "1"), Ee += '<table class="zc-guide-label-table ' + t.H.K + '-guide-label-table">')), !me && oe.length > 0 && ("asc" !== oe[0].o["sort-by-value"] && "desc" !== oe[0].o["sort-by-value"] || oe.sort(function (e, t) {
                      return (e.E["node-value"] - t.E["node-value"]) * ("asc" === oe[0].o["sort-by-value"] ? 1 : -1);
                    }));
                    var it = 0;
                    for (N = 0, O = oe.length; N < O && (!(-1 === oe[N].E.diff || oe[N].E.diff <= m) || ($e ? (it % et == 0 && (Ee += "<tr>"), Ee += "<td>" + be[N] + "</td>", it % et == et - 1 && (Ee += "</tr>"), it++) : Ee += be[oe[N].E.pos], $e || !tt)); N++);
                    if ($e && (it % et != et - 1 && (Ee += "</tr>"), Ee += "</table>"), "" !== Ae && (Ee += Ae), !me && oe.length > 0 && (fe ? Be.CO ? (_ = x = K, d = y = I[0]) : (_ = x = F[0], d = y = D) : (_ = x = K, d = y = D), "" !== Ee && (oe[0].o.text = $e || tt ? Ee : Ee.substring(0, Ee.length - 4), oe[0].parse()), G = null !== ZC._n_(v.o.distance) ? ZC._i_(v.o.distance) : 6, null === ZC._n_(v.o.x) ? Be.CO ? _ < S[ie].iX + S[ie].I / 2 ? oe[0].iX = _ + G + 14 : oe[0].iX = _ - oe[0].I - G - 14 : le && le.iX >= f.iX + f.I / 2 ? oe[0].iX = x - oe[0].I - G : oe[0].iX = x + G : oe[0].iX -= f.iX, null === ZC._n_(v.o.y) ? Be.CO ? le && le.iY >= f.iY + f.F / 2 ? oe[0].iY = y - oe[0].F - G : oe[0].iY = y + G : d < S[ie].iY + S[ie].F / 2 ? oe[0].iY = d + G + 14 : oe[0].iY = d - oe[0].F - G - 14 : oe[0].iY -= f.iY), ne) {
                      var at = -1,
                        nt = -1;
                      if (te || (null === ZC._n_(p._pageX_) && c(), te = !0), Ze.length > 0) {
                        var lt = [];
                        for (m = ZC.MAX, X = 0, Y = Ze.length; X < Y; X++) Ze[X][0] >= 0 && (m = ZC.CX(Ze[X][0], m));
                        for (-1 !== ge && (m = ZC.BQ(m, ge)), X = 0, Y = Ze.length; X < Y; X++) null !== ZC._n_(Ze[X]) && (-1 === Ze[X][0] || Ze[X][0] <= m) && (S[ie].CW && S[ie].CW.o["single-line"] && ZC._b_(S[ie].CW.o["single-line"]) ? (lt = [].concat(Ze[X][1]), "xy" === S[ie].AJ.layout ? at = ZC._x_(Ze[X][1][1][0]) : "yx" === S[ie].AJ.layout && (nt = ZC._x_(Ze[X][1][1][1]))) : lt = lt.concat(Ze[X][1]));
                        if (S[ie].CW.o.mask) {
                          var rt = -1;
                          lt.length > 1 && lt[1] && (rt = lt[1][0] || -1), S[ie].CW.oMask || (S[ie].CW.oMask = new I3(S[ie]), S[ie].CW.oMask.append({
                            "background-color": "#fff",
                            alpha: .85
                          }), S[ie].CW.oMask.append(S[ie].CW.o.mask), S[ie].CW.oMask.Z = a, S[ie].CW.oMask.parse()), S[ie].CW.oMask.iX = rt, S[ie].CW.oMask.iY = S[ie].P.iY, S[ie].CW.oMask.I = Math.max(2, S[ie].P.iX + S[ie].P.I - rt + 2), S[ie].CW.oMask.F = S[ie].P.F, S[ie].CW.oMask.paint();
                        }
                        if (S[ie].AJ["3d"]) for (S[ie].NK(), X = 0, Y = lt.length; X < Y; X++) lt[X] && (w = new CC(S[ie], lt[X][0] - ZC.AP.E2, lt[X][1] - ZC.AP.E1, 0), lt[X][0] = w.EC[0], lt[X][1] = w.EC[1]);
                        S[ie].CW.K = S[ie].K + "-crosshair-x", S[ie].CW.I1 && B && (S[ie].CW.GN(S[ie].CW, S[ie].CW, null, B.LM(null, !1), S[ie].CW.MV), S[ie].CW.parse()), S[ie].CW.AN && ZC.CQ.paint(n, S[ie].CW, lt);
                      }
                      if (ce.length > 0) {
                        if (S[ie].AJ["3d"]) for (S[ie].NK(), X = 0, Y = ce.length; X < Y; X++) null !== ZC._n_(ce[X]) && (w = new CC(S[ie], ce[X][0] - ZC.AP.E2, ce[X][1] - ZC.AP.E1, 0), ce[X][0] = w.EC[0], ce[X][1] = w.EC[1]);
                        S[ie].HD.I1 && B && (S[ie].HD.GN(S[ie].HD, S[ie].HD, null, Ke, S[ie].HD.MV), S[ie].HD.parse()), S[ie].HD.AN && ZC.CQ.paint(n, S[ie].HD, ce);
                      }
                      if (me) {
                        for (u = oe.length - 1; u >= 0; u--) ZC.DR(oe[u].DL[0], f.iX - 5, f.iX + f.I + 5) && ZC.DR(oe[u].DL[1], f.iY - 5, f.iY + f.F + 5) || oe.splice(u, 1);
                        if (oe.length > 1) for (var ot = !0; ot;) for (ot = !1, u = 0; u < oe.length - 1; u++) if (oe[u].AN && (ve.CO && oe[u].iX > oe[u + 1].iX || !ve.CO && oe[u].iY > oe[u + 1].iY)) {
                          var st = oe[u];
                          oe[u] = oe[u + 1], oe[u + 1] = st, ot = !0;
                        }
                        if (oe.length > 0) {
                          var Ct = [],
                            At = [];
                          for (u = 0; u < oe.length; u++) null !== ZC._n_(oe[u].o.x) && null !== ZC._n_(oe[u].o.y) && At.push(oe[u]);
                          for (var Zt, ct, pt, ut = !0, ht = 0, _t = oe.length * oe.length; ut && ht < _t;) for (ht++, ut = !1, u = 0; u < oe.length - 1; u++) if (oe[u].AN && -1 === ZC.AV(At, oe[u])) if (Be.CO) {
                            if (oe[u + 1].iX < oe[u].iX + oe[u].I) {
                              if (oe[u + 1].iX - oe[u].I - 4 < f.iX && -1 === ZC.AV(Ct, oe[u]) && (Ct.push(oe[u]), oe[u].iX = f.iX), oe[u + 1].iX = oe[u].iX + oe[u].I + 4, oe[u + 1].iX + oe[u + 1].I > f.iX + f.I) for (pt = oe[u + 1].iX - (f.iX + f.I - oe[u + 1].I), Zt = 0, ct = oe.length; Zt < ct; Zt++) oe[Zt].iX - pt >= f.iX ? oe[Zt].iX -= pt : (oe[Zt].iX = f.iX, Zt > 0 && (oe[u + 1].E["marker-y"] < f.iY + f.F / 2 ? oe[Zt].iY = oe[Zt - 1].iY + oe[Zt - 1].F + 4 : oe[Zt].iY = oe[Zt - 1].iY - oe[Zt].F - 4));
                              ut = !0;
                            }
                          } else if (oe[u + 1].iY < oe[u].iY + oe[u].F) {
                            if (oe[u + 1].iY - oe[u].F - 4 < f.iY && -1 === ZC.AV(Ct, oe[u]) && (Ct.push(oe[u]), oe[u].iY = f.iY), oe[u + 1].iY = oe[u].iY + oe[u].F + 4, oe[u + 1].iY + oe[u + 1].F > f.iY + f.F) for (pt = oe[u + 1].iY - (f.iY + f.F - oe[u + 1].F), Zt = 0, ct = oe.length; Zt < ct; Zt++) oe[Zt].iY - pt >= f.iY ? oe[Zt].iY -= pt : (oe[Zt].iY = f.iY, Zt > 0 && (oe[u + 1].E["marker-x"] < f.iX + f.I / 2 ? oe[Zt].iX = oe[Zt - 1].iX + oe[Zt - 1].I + 4 : oe[Zt].iX = oe[Zt - 1].iX - oe[Zt].I - 4));
                            ut = !0;
                          }
                        }
                      }
                      var dt = !1;
                      for (u = 0, h = pe.length; u < h; u++) if (-1 === pe[u].E.diff || pe[u].E.diff <= m) {
                        var ft = pe[u];
                        S[ie].AJ["3d"] && (S[ie].NK(), w = new CC(S[ie], ft.iX + ft.I / 2 - ZC.AP.E2, ft.iY + ft.F / 2 - ZC.AP.E1, 0), ft.iX = w.EC[0] - ft.I / 2, ft.iY = w.EC[1] - ft.F / 2, w = new CC(S[ie], ft.DL[0] - ZC.AP.E2, ft.DL[1] - ZC.AP.E1, 0), ft.DL[0] = w.EC[0], ft.DL[1] = w.EC[1]), S[ie].CW && S[ie].CW.o["single-line"] && ZC._b_(S[ie].CW.o["single-line"]) ? ("xy" === S[ie].AJ.layout && at === ZC._x_(ft.iX + ft.I / 2) || "yx" === S[ie].AJ.layout && nt === ZC._x_(ft.iY + ft.F / 2)) && !dt && (ft.paint(), dt = !0) : ft.paint();
                      }
                      for (m = ZC.MAX, N = 0, O = oe.length; N < O; N++) oe[N].E.diff >= 0 && (m = ZC.CX(oe[N].E.diff, m));
                      for (-1 !== ge && (m = ZC.BQ(m, ge)), M = 0, N = 0, O = oe.length; N < O; N++) if (-1 === oe[N].E.diff || oe[N].E.diff <= m) {
                        var gt = ZC.DR(oe[N].DL[0], f.iX - 5, f.iX + f.I + 5) && ZC.DR(oe[N].DL[1], f.iY - 5, f.iY + f.F + 5);
                        if (!me || gt) {
                          if (oe[N].AN) {
                            switch (oe[N].E[ZC._[7]]) {
                              case "top":
                                Be.CO ? oe[N].DL[0] = oe[N].iX - oe[N].GA : oe[N].DL[1] = oe[N].iY + oe[N].F + oe[N].GA;
                                break;
                              case "bottom":
                                Be.CO ? oe[N].DL[0] = oe[N].iX + oe[N].I + oe[N].GA : oe[N].DL[1] = oe[N].iY - oe[N].GA;
                            }
                            if (-1 !== ZC.AV(["top", "bottom"], oe[N].E[ZC._[7]])) {
                              var Bt = oe[N].iX + oe[N].I / 2;
                              oe[N].iX = ZC.BQ(oe[N].iX, 0), oe[N].iX = ZC.CX(oe[N].iX, t.H.I - oe[N].I), oe[N].iY = ZC.BQ(oe[N].iY, 0), oe[N].iY = ZC.CX(oe[N].iY, t.H.F - oe[N].F), null === ZC._n_(oe[N].o["callout-offset"]) && (oe[N].EV = parseInt(100 * (Bt - oe[N].iX - oe[N].I / 2) / (oe[N].I - oe[N].HC), 10));
                            }
                            if (S[ie].AJ["3d"] && (S[ie].NK(), w = new CC(S[ie], oe[N].iX + oe[N].I / 2 - ZC.AP.E2, oe[N].iY + oe[N].F / 2 - ZC.AP.E1, 0), oe[N].iX = w.EC[0] - oe[N].I / 2, oe[N].iY = w.EC[1] - oe[N].F / 2, w = new CC(S[ie], oe[N].DL[0] - ZC.AP.E2, oe[N].DL[1] - ZC.AP.E1, 0), oe[N].DL[0] = w.EC[0], oe[N].DL[1] = w.EC[1], "left" === oe[N].EL ? oe[N].iX = oe[N].DL[0] + G : oe[N].iX = oe[N].DL[0] - oe[N].I - G), S[ie].AJ["3d"] || me || 0 !== M || (oe[N].iX = ZC.BQ(f.iX - 5, oe[N].iX), oe[N].iY = ZC.BQ(f.iY - 5, oe[N].iY), oe[N].iX = ZC.CX(f.iX + f.I - oe[N].I + 5, oe[N].iX), oe[N].iY = ZC.CX(f.iY + f.F - oe[N].F + 5, oe[N].iY)), me || !me && 0 === M) {
                              var vt = me ? N : 0;
                              (!me || "canvas" === t.H.AA && oe[vt].o["background-image"] && "" !== oe[vt].o["background-image"]) && oe[vt].parse(), 0 !== oe[vt].C6 && oe[vt].paint(), M++;
                            }
                          }
                          if (gt) {
                            var mt = new DW(S[ie]);
                            if (t.H.B8.load(mt.o, "(" + S[ie].AF + ").guide.marker"), mt.K = oe[N].K + "-marker", mt.Z = mt.C7 = a, mt.iX = oe[N].E["marker-x"], mt.iY = oe[N].E["marker-y"], S[ie].AJ["3d"] && (S[ie].NK(), w = new CC(S[ie], mt.iX - ZC.AP.E2, mt.iY - ZC.AP.E1, 0), mt.iX = w.EC[0], mt.iY = w.EC[1]), L = oe[N].E["guide-style"], mt.A0 = mt.AE = ZC.AQ.JP(L[ZC._[0]]), mt.BW = L.color, mt.append(S[ie].CW.o.marker), mt.append(S[ie].AY.A4[oe[N].E.plotidx].o["guide-marker"]), "inherit" === mt.o.type) {
                              var bt = S[ie].AY.A4[oe[N].E.plotidx];
                              bt.A2 && bt.A2.o.type && (mt.o.type = bt.A2.o.type);
                            }
                            mt.parse(), mt.AN && "none" !== mt.DQ && mt.AI > 1 && mt.paint();
                          }
                        }
                      }
                      (P = S[ie].GR()).items = re, P.guide = {
                        x: x,
                        y: y
                      }, P.ev = p, P["scale-label"] = _e, ZC.AQ.BZ("guide_mousemove", t.H, P), S[ie].Q1(!0);
                    } else (P = {}).guide = {
                      x: x,
                      y: y
                    }, P.ev = p, ZC.AQ.BZ("guide_mousemove", t.H, P);
                  }
                }
              }
            }
          }
        }, t.zc_guide_touchend = function () {
          0 !== zingchart.DEV.GUIDETIMEOUT && window.setTimeout(function () {
            c();
          }, ZC._i_(zingchart.DEV.GUIDETIMEOUT));
        }, ZC.A5(document.body).bind("mousemove touchstart touchmove", t.QN), ZC.A5(document.body).bind("touchend", t.zc_guide_touchend);
      }
    }]);
    return KB;
  }(ZCClass);
  KB.clearGuide = function (e) {
    var t = zingchart.getLoader(e);
    if (t) {
      zingchart.GUIDE_EV = null;
      var i = ZC.AK(e + "-guide-c"),
        a = ZC.A5(i).width(),
        n = ZC.A5(i).height();
      ZC.A5("." + e + "-guide-label").remove(), ZC.Q.IT(i, t.AA, 0, 0, a, n), ZC.A5("#" + e + "-defs").children().each(function () {
        this.id && -1 !== this.id.indexOf("-guide-label-") && ZC.Q.EU(this.id);
      });
    }
  }, zingchart.extendAPI("resetguide", function (e, t) {
    "string" == typeof (t = t || {}) && (t = JSON.parse(t)), KB.GUIDES[e] = KB.GUIDES[e] || {}, KB.GUIDES[e].blocked = !1, KB.clearGuide(e);
  }), zingchart.extendAPI("setguide", function (e, t) {
    "string" == typeof (t = t || {}) && (t = JSON.parse(t));
    var i,
      a,
      n = zingchart.getLoader(e),
      l = n.C8(t[ZC._[3]]),
      r = l.BJ(ZC._[50]);
    "xy" === l.AJ.layout ? (i = t.x || r.AM(t.keyvalue), a = l.iY + l.F / 2) : (i = l.iX + l.I / 2, a = t.y || r.AM(t.keyvalue));
    var o = {
      _pageX_: i,
      _pageY_: a,
      type: ZC.mobile ? "touchstart" : ZC._[48],
      target: {
        id: e + "-img"
      }
    };
    KB.GUIDES = KB.GUIDES || {}, KB.GUIDES[e] = KB.GUIDES[e] || {}, KB.GUIDES[e].blocked = !0, KB.clearGuide(e), o.fromAPI = !0, n.D6.QN(o);
  });
  var AAV = /*#__PURE__*/function (_ZCClass7) {
    _inherits(AAV, _ZCClass7);
    function AAV(e, t) {
      var _this19;
      _classCallCheck(this, AAV);
      var i = _assertThisInitialized(_this19);
      i.o = null, i.C = e, i.O6 = t;
      return _possibleConstructorReturn(_this19);
    }
    _createClass(AAV, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        t.o = t.C.o;
        var i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z = t.O6,
          c = "\r\n",
          p = ",",
          u = !1,
          h = null,
          _ = null,
          d = null,
          f = null,
          g = null,
          B = !1,
          v = !1,
          m = null,
          b = {};
        null !== ZC._n_(e = t.o["html5-csv"]) && (b = e), null !== ZC._n_(e = t.o.csv) && (b = e), null !== ZC._n_(e = b.separator) && (p = e), null !== ZC._n_(e = b.mirrored) && (u = ZC._b_(e)), null !== ZC._n_(e = b.title) && (h = ZC._b_(e)), null !== ZC._n_(e = b["string-values"]) && (v = ZC._b_(e)), u ? (null !== ZC._n_(e = b["horizontal-labels"]) && (d = ZC._b_(e)), null !== ZC._n_(e = b["vertical-labels"]) && (_ = ZC._b_(e))) : (null !== ZC._n_(e = b["horizontal-labels"]) && (_ = ZC._b_(e)), null !== ZC._n_(e = b["vertical-labels"]) && (d = ZC._b_(e))), null !== ZC._n_(e = b["smart-scales"]) && (f = ZC._b_(e)), null !== ZC._n_(e = b["separate-scales"]) && (g = ZC._b_(e)), null !== ZC._n_(e = b["keyval-format"]) && (B = ZC._b_(e)), null !== ZC._n_(e = b.columns) && (m = e);
        var E = null;
        null !== ZC._n_(e = b[ZC._[13]]) && (E = e);
        var K = null;
        if (null !== ZC._n_(e = b[ZC._[14]]) && (K = e), null !== E && null === K && (K = "." === E ? "," : "."), null !== K && null === E && (E = "." === K ? "," : "."), null !== ZC._n_(m) && m.length > 0) {
          i = [], null !== ZC._n_(e = b["row-separator"]) ? c = e : Z.split(/\n/).length > 0 ? c = "\n" : Z.split(/\r/).length > 0 && (c = "\r");
          var D = Z.split(c),
            F = 0;
          for (l = 0, r = D.length; l < r; l++) if ("" !== D[l].replace(/\s+/g, "")) {
            i[F] = [];
            for (var I = 0, x = 0; I < D[l].length - 1;) n = D[l].substring(I, I + m[x]), i[F].push(n), I += m[x], x++;
            F++;
          }
        } else {
          i = [[]], a = null !== ZC._n_(e = b["row-separator"]) ? new RegExp("(\\" + p + "|" + e + '|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\' + p + e + "]*))", "gi") : new RegExp("(\\" + p + '|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^"\\' + p + "\\r\\n]*))", "gi");
          for (var y = null; y = a.exec(Z);) {
            var X = y[1];
            X.length && X !== p && i.push([]), n = y[2] ? y[2].replace(new RegExp('""', "g"), '"') : y[3], i[i.length - 1].push(n);
          }
        }
        var Y = [];
        for (l = 0, r = i.length; l < r; l++) 0 !== i[l].join("").replace(/\s+/g, "").length && Y.push(i[l]);
        var w = 0,
          L = 0;
        if ((null === ZC._n_(h) || h) && (Y.length > 1 && 1 === Y[0].length ? (null === ZC._n_(t.o.title) ? t.o.title = {
          text: Y[0][0]
        } : null === ZC._n_(t.o.title.text) && (t.o.title.text = Y[0][0]), h = !0) : h = !1), h && w++, u) {
          for (i = [], h && i.push(Y[0]), o = w, s = Y.length; o < s; o++) for (C = 0, A = Y[o].length; C < A; C++) null === ZC._n_(i[C + w]) && (i[C + w] = []), i[C + w].push(Y[o][C]);
          Y = i;
        }
        if ("function" == typeof zingchart.csvParser) for (o = 0, s = Y.length; o < s; o++) for (C = 0, A = Y[o].length; C < A; C++) Y[o][C] = zingchart.csvParser.call(this, Y[o][C], o, C, t.C.A.K);
        var M = 0;
        for (l = 0, r = Y.length; l < r; l++) M = ZC.BQ(M, Y[l].length);
        var H = [];
        if (null === ZC._n_(_)) {
          var G = Y[w].join("").length;
          _ = Y[w].join("").replace(/[0-9]/g, "").length / G > .75;
        }
        _ && (H = Y[w], w++);
        var P = [];
        if (null === ZC._n_(d)) if (_ && -1 !== H[0].indexOf("\\")) d = !0;else {
          var N = "";
          for (o = w, s = Y.length; o < s; o++) N += Y[o][0];
          var O = N.length;
          d = N.replace(/[0-9]/g, "").length / O > .75;
        }
        if (d) {
          for (o = w, s = Y.length; o < s; o++) B ? P.push(ZC._i_(Y[o][L])) : P.push(Y[o][L]);
          L++;
        }
        var S = [],
          Q = [];
        for (C = L; C < M; C++) {
          Q[C - L] = [];
          var k = E,
            T = K,
            z = 0,
            V = null;
          for (o = w, s = Y.length; o < s; o++) if (null !== ZC._n_(Y[o][C]) && "" !== Y[o][C] && typeof Y[o][C] !== ZC._[31]) {
            if (n = Y[o][C], null !== ZC._n_(V) || v || (V = n.replace(/[0-9\-\,\.\+\e]+/g, "%v")), v || (n = n.replace(/[^0-9\-\,\.\+\e]+/g, "")), null === k || null === T) {
              var R = n.indexOf("."),
                J = n.indexOf(",");
              -1 !== R && -1 !== J ? R < J ? (k = ".", T = ",", z = ZC.BQ(0, n.length - J)) : (k = ",", T = ".", z = ZC.BQ(0, n.length - R)) : -1 === R && -1 !== J ? n.length - J - 1 == 3 ? (k = ",", T = ".") : (k = ".", T = ",", z = ZC.BQ(0, n.length - J)) : -1 !== R && -1 === J && (n.length - R - 1 == 3 ? (k = ".", T = ",") : (k = ",", T = ".", z = ZC.BQ(0, n.length - R)));
            }
            "." === k && (n = n.replace(/\./g, "").replace(/,/g, ".")), "," === k && (n = n.replace(/,/g, "")), Q[C - L].push(v ? n : ZC._f_(n));
          } else Q[C - L].push(null);
          S[C - L] = {}, null !== ZC._n_(V) && (S[C - L].format = V), null !== ZC._n_(k) && (S[C - L][ZC._[13]] = k), null !== ZC._n_(k) && (S[C - L][ZC._[14]] = T), 0 !== z && (S[C - L][ZC._[12]] = z);
        }
        if (B) for (l = 0, r = Q.length; l < r; l++) for (var W = 0; W < Q[l].length; W++) Q[l][W] = [P[W], Q[l][W]];
        var U = [];
        switch (t.C.AF) {
          case "line":
          case "area":
          case "vbar":
          case "hbar":
          case "line3d":
          case "area3d":
          case "vbar3d":
          case "hbar3d":
          case "mixed":
            null === ZC._n_(t.o[ZC._[50]]) && (t.o[ZC._[50]] = {});
            var j = [];
            d && null !== ZC._n_(H[0]) && (j = H[0].split(/\\/)), null !== ZC._n_(j[0]) && (null === ZC._n_(t.o[ZC._[50]].label) && (t.o[ZC._[50]].label = {}), null === ZC._n_(t.o[ZC._[50]].label.text) && (t.o[ZC._[50]].label.text = j[0])), d && (null === ZC._n_(t.o[ZC._[50]][ZC._[5]]) ? t.o[ZC._[50]][ZC._[5]] = P : null === ZC._n_(t.o[ZC._[50]][ZC._[10]]) && (t.o[ZC._[50]][ZC._[10]] = P));
            var q = [];
            if (null !== ZC._n_(g) && g) for (l = 0, r = Q.length; l < r; l++) q[l] = ZC._[51] + (0 === l ? "" : "-" + (l + 1));else if (null !== ZC._n_(f) && f) {
              var $ = {},
                ee = 0,
                te = [];
              for (l = 0, r = Q.length; l < r; l++) {
                for (var ie = 0, ae = 0, ne = Q[l].length; ae < ne; ae++) ie += Q[l][ae];
                ie /= Q[l].length;
                var le = Math.round(ZC.G8(ie) / Math.LN10 / 2);
                null === ZC._n_($[le]) && ($[le] = ZC._[51] + (0 === ee ? "" : "-" + (ee + 1))), -1 === ZC.AV(te, S[l].format) ? (q[l] = ZC._[51] + (0 === ee ? "" : "-" + (ee + 1)), ee++) : (q[l] = $[le], ee++), te.push(S[l].format);
              }
            }
            for (0 === q.length && (q[0] = ZC._[51]), null === ZC._n_(t.o[ZC._[11]]) && (t.o[ZC._[11]] = []), l = 0, r = Q.length; l < r; l++) null === ZC._n_(t.o[ZC._[11]][l]) && (t.o[ZC._[11]][l] = {}), t.o[ZC._[11]][l][ZC._[5]] = Q[l], _ && (null === ZC._n_(t.o[ZC._[11]][l].text) && (t.o[ZC._[11]][l].text = H[l + L], U.push(H[l + L])), null === ZC._n_(t.o[ZC._[11]][l]["legend-text"]) && (t.o[ZC._[11]][l]["legend-text"] = H[l + L], U.push(H[l + L])), null === ZC._n_(t.o[ZC._[11]][l]["tooltip-text"]) && null !== ZC._n_(S[l].format) && (t.o[ZC._[11]][l]["tooltip-text"] = S[l].format)), null !== ZC._n_(q[l]) && (null === ZC._n_(t.o[q[l]]) && (t.o[q[l]] = {}), null !== ZC._n_(j[1]) && (null === ZC._n_(t.o[q[l]].label) && (t.o[q[l]].label = {}), null === ZC._n_(t.o[q[l]].label.text) && (t.o[q[l]].label.text = j[1])), null === ZC._n_(t.o[ZC._[11]][l].scales) && (t.o[ZC._[11]][l].scales = "scale-x," + q[l]), null === ZC._n_(t.o[q[l]][ZC._[12]]) && null !== ZC._n_(S[l][ZC._[12]]) && (t.o[q[l]][ZC._[12]] = S[l][ZC._[12]]), null === ZC._n_(t.o[q[l]][ZC._[13]]) && null !== ZC._n_(S[l][ZC._[13]]) && (t.o[q[l]][ZC._[13]] = S[l][ZC._[13]]), null === ZC._n_(t.o[q[l]][ZC._[14]]) && null !== ZC._n_(S[l][ZC._[14]]) && (t.o[q[l]][ZC._[14]] = S[l][ZC._[14]]), null === ZC._n_(t.o[q[l]].format) && null !== ZC._n_(S[l].format) && (t.o[q[l]].format = S[l].format));
            break;
          case "pie":
          case "pie3d":
          case "gauge":
          case "nestedpie":
            if (null === ZC._n_(t.o.scale) && (t.o.scale = {}), d && null !== ZC._n_(H[0])) {
              var re = H[0].split(/\\/);
              null === ZC._n_(t.o.scale.label) && (t.o.scale.label = {}), null === ZC._n_(t.o.scale.label.text) && (t.o.scale.label.text = re[0]);
            }
            for (d && (null === ZC._n_(t.o.scale[ZC._[5]]) ? t.o.scale[ZC._[5]] = P : null === ZC._n_(t.o.scale[ZC._[10]]) && (t.o.scale[ZC._[10]] = P)), null === ZC._n_(t.o[ZC._[11]]) && (t.o[ZC._[11]] = []), l = 0, r = Q.length; l < r; l++) null === ZC._n_(t.o[ZC._[11]][l]) && (t.o[ZC._[11]][l] = {}), t.o[ZC._[11]][l][ZC._[5]] = Q[l], _ && (null === ZC._n_(t.o[ZC._[11]][l].text) && (t.o[ZC._[11]][l].text = H[l + L], U.push(H[l + L])), null === ZC._n_(t.o[ZC._[11]][l]["legend-text"]) && (t.o[ZC._[11]][l]["legend-text"] = H[l + L], U.push(H[l + L])), null === ZC._n_(t.o[ZC._[11]][l]["tooltip-text"]) && null !== ZC._n_(S[l].format) && (t.o[ZC._[11]][l]["tooltip-text"] = S[l].format)), null === ZC._n_(t.o[ZC._[52]]) && (t.o[ZC._[52]] = {}), null === ZC._n_(t.o[ZC._[52]][ZC._[12]]) && null !== ZC._n_(S[l][ZC._[12]]) && (t.o[ZC._[52]][ZC._[12]] = S[l][ZC._[12]]), null === ZC._n_(t.o[ZC._[52]][ZC._[13]]) && null !== ZC._n_(S[l][ZC._[13]]) && (t.o[ZC._[52]][ZC._[13]] = S[l][ZC._[13]]), null === ZC._n_(t.o[ZC._[52]][ZC._[14]]) && null !== ZC._n_(S[l][ZC._[14]]) && (t.o[ZC._[52]][ZC._[14]] = S[l][ZC._[14]]), null === ZC._n_(t.o[ZC._[52]].format) && null !== ZC._n_(S[l].format) && (t.o[ZC._[52]].format = S[l].format);
        }
        return "" !== U.join("") && null === ZC._n_(t.o.legend) && (t.o.legend = {}), t.o = JSON.parse(JSON.stringify(t.o).replace(/\\\\/g, "\\")), t.o;
      }
    }]);
    return AAV;
  }(ZCClass);
  var K2 = /*#__PURE__*/function (_I4) {
    _inherits(K2, _I4);
    function K2(e) {
      var _this20;
      _classCallCheck(this, K2);
      _this20 = _possibleConstructorReturn(this, _getPrototypeOf(K2).call(this, e));
      var t = _assertThisInitialized(_this20);
      t.OQ = "zcgraph", t.H = e, t.AF = "", t.IZ = null, t.PC = "", t.K6 = null, t.N4 = null, t.SI = null, t.P = null, t.B9 = null, t.HZ = null, t.HY = null, t.A6F = 1, t.W4 = 1, t.A68 = 1, t.L = 0, t.I0 = null, t.MN = [1, 0], t.AA3 = null, t.CB = !1, t.KX = "normal", t.BO = [], t.BY = [], t.Z0 = [], t.FJ = [], t.LS = [], t.AY = new LX(t), t.H3 = null, t.BC = null, t.A7 = null, t.CW = null, t.HD = null, t.A25 = "always", t.ABW = !0, t.MK = "", t.RY = null, t.LW = !1, t.UY = !1, t.NI = 0, t.ZL = !1, t.QH = !1, t.EZ = {
        true3d: 1,
        angle: 45,
        depth: 40,
        "x-angle": 0,
        "y-angle": 0,
        "z-angle": 0,
        zoom: 1
      }, t.AJ = {
        "enable-guide": !1,
        "enable-preview": !1,
        "enable-scroll": !1,
        "enable-zooming": !0,
        "3d": !1,
        clip: !1,
        layout: "",
        "enable-animation": !0,
        "angle-min": 15,
        "angle-max": 75,
        "x-angle-min": -65,
        "x-angle-max": 65,
        "y-angle-min": -65,
        "y-angle-max": 65,
        "z-angle-min": -65,
        "z-angle-max": 65
      }, t.OM = !1, t.A1P = !1, t.AA9 = [], t.A1V = !0, typeof PU !== ZC._[31] && (t.M7 = new PU(t)), t.GI = !1, t.C9 = {}, t.J4 = [], t.KP = !1, t.HO = !1, t.LG = 0, t.BP = [], t.A66 = !0, t.V1 = zingchart.DEV.STACKINGLOGIC, -1 === t.V1 && (t.V1 = 0);
      return _this20;
    }
    _createClass(K2, [{
      key: "a11y",
      value: function a11y() {
        if (this.A.bA11y) {
          return ZC.Q.G2("rect", "", "") + 'class="zc-graph-descriptor" tabindex="0" aria-label="Chart ' + (this.L + 1) + " of " + this.A.AG.length + ", " + ({
            vbar: "column",
            vbar3d: "3d column",
            hbar: "bar",
            hbar3d: "3d bar",
            line3d: "3d line",
            area3d: "3d area",
            pie3d: "3d pie"
          }[this.AF] || this.AF) + " chart. " + (this.IZ ? this.IZ.AO : "Untitled") + ". " + (this.K6 ? this.K6.AO : "") + ". " + this.PC + '" id="' + this.K + '--graph" coords="0,0,0,0" data-z-sort="-200" />';
        }
        return "";
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        var e = _get(_getPrototypeOf(K2.prototype), "getPMap", this).call(this);
        return this.addPMap(e, "index", "L"), e;
      }
    }, {
      key: "getToggleAction",
      value: function getToggleAction() {
        var e,
          t = this,
          i = "hide";
        return t.BC && "" !== t.E["legend-last-trigger"] && typeof t.E["legend-last-trigger"] !== ZC._[31] ? i = "item" === t.E["legend-last-trigger"] ? t.BC.RH : t.BC.Q5 : (t.o.legend && (e = t.o.legend[ZC._[54]]) && (i = e), t.o.legend && t.o.legend.item && (e = t.o.legend.item[ZC._[54]]) && (i = e)), (t.A.KE || t.E["toggle-action-remove"]) && (i = "remove"), i;
      }
    }, {
      key: "BT",
      value: function BT(e, t) {
        typeof t === ZC._[31] && (t = !1);
        for (var i = [], a = this, n = 0, l = a.BO.length; n < l; n++) a.BO[n].AF === e && (!t || t && a.BO[n].V.length > 0) && i.push(a.BO[n]);
        return i;
      }
    }, {
      key: "BJ",
      value: function BJ(e) {
        for (var t = this, i = 0, a = t.BO.length; i < a; i++) if (t.BO[i].BG === e) return t.BO[i];
        return null;
      }
    }, {
      key: "NR",
      value: function NR(e) {
        return e;
      }
    }, {
      key: "A9L",
      value: function A9L(e) {
        return new ZC.AAV(this, e);
      }
    }, {
      key: "O2",
      value: function O2() {
        for (var e = this, t = 0, i = e.BO.length; t < i; t++) {
          var a = e.BO[t],
            n = a.BG;
          e.A.B8.load(a.o, ["(" + e.AF + ").SCALE", "(" + e.AF + ")." + n.replace(/\-[0-9]+/, ""), "(" + e.AF + ")." + n.replace(/\-[0-9]+/, "-n"), "(" + e.AF + ")." + n], !1, !0);
          var l = n.replace(/\-[0-9]+/, "") + "-n";
          e.o[l] && a.append(e.o[l]), e.o[n] && a.append(e.o[n]), e.AJ["3d"] && e.A.B8.load(a.o, ["(" + e.AF + ").SCALE[3d]", "(" + e.AF + ")." + n.replace(/\-[0-9]+/, "") + "[3d]", "(" + e.AF + ")." + n.replace(/\-[0-9]+/, "-n") + "[3d]", "(" + e.AF + ")." + n + "[3d]"], !1, !0), e.AJ["3d"] && a.append(e.o[n + "[3d]"]), a.parse();
        }
      }
    }, {
      key: "UO",
      value: function UO() {
        return null;
      }
    }, {
      key: "A5D",
      value: function A5D(e) {
        var t,
          i,
          a,
          n = this,
          l = 0,
          r = n.AY.A4.length;
        for (t = 0; t < r; t++) l = ZC.BQ(l, n.AY.A4[t].S.length);
        function o(e) {
          return e = (e = (e = e.replace(/(%N|%node-count)/g, l)).replace(/(%P|%plot-count)/g, r)).replace(/(%S|%scale-values-count)/g, a.V.length);
        }
        for (t = 0, i = n.BO.length; t < i; t++) (a = n.BO[t]).HE(e), 2 === e && (a.IV = o, a.DB() && a.parse()), null === ZC._n_(a.o["max-items"]) && null === ZC._n_(a.o["max-labels"]) && a.T9(), null === ZC._n_(a.o["max-ticks"]) && a.ZX();
      }
    }, {
      key: "OL",
      value: function OL() {}
    }, {
      key: "NK",
      value: function NK() {}
    }, {
      key: "AC6",
      value: function AC6() {}
    }, {
      key: "A82",
      value: function A82() {}
    }, {
      key: "setupPlotArea",
      value: function setupPlotArea() {
        var e = this,
          t = e.A.B8,
          i = "(" + e.AF + ")";
        e.P = new I3(e), e.P.OP = "plotarea", e.P.K = e.K + "-plotarea";
        var a = [i + ".plotarea"];
        if (e.B9 && a.push(i + ".plotarea[preview]"), e.AJ["3d"] && a.push(i + ".plotarea[3d]"), t.load(e.P.o, a), e.P.append(e.o.chart), e.P.append(e.o.plotarea), e.B9 && e.P.append(e.o["plotarea[preview]"]), e.AJ["3d"] && e.P.append(e.o["plotarea[3d]"]), "dynamic" === e.P.o[ZC._[57]] || "dynamic" === e.P.o[ZC._[58]] || "dynamic" === e.P.o[ZC._[59]] || "dynamic" === e.P.o[ZC._[60]]) {
          var n = String(e.P.o.margin || "").split(/\s+|;|,/),
            l = n.length > 0 ? n[0] : "",
            r = n.length > 1 ? n[1] : "",
            o = n.length > 0 ? n[2] || n[0] : "",
            s = n.length > 1 ? n[3] || n[1] : "";
          "dynamic" === e.P.o[ZC._[57]] && (l = "dynamic"), "dynamic" === e.P.o[ZC._[58]] && (r = "dynamic"), "dynamic" === e.P.o[ZC._[59]] && (o = "dynamic"), "dynamic" === e.P.o[ZC._[60]] && (s = "dynamic"), e.P.o.margin = [l, r, o, s].join(" ");
        }
        if (e.E["plotarea-margins"] ? e.P.o.margin = e.E["plotarea-margin"] : (e.E["plotarea-margins"] = !0, e.E["plotarea-margin"] = e.P.o.margin, e.E["plotarea-margin-top"] = e.P.o[ZC._[57]], e.E["plotarea-margin-right"] = e.P.o[ZC._[58]], e.E["plotarea-margin-bottom"] = e.P.o[ZC._[59]], e.E["plotarea-margin-left"] = e.P.o[ZC._[60]]), typeof e.E["plotarea-p-x"] !== ZC._[31] && (e.P.E["p-x"] = e.E["plotarea-p-x"], e.P.E["p-y"] = e.E["plotarea-p-y"], e.P.E["p-width"] = e.E["plotarea-p-width"], e.P.E["p-height"] = e.E["plotarea-p-height"]), null !== ZC._n_(e.P.o["adjust-layout"]) && ZC._b_(e.P.o["adjust-layout"]) && (e.P.o.margin = "dynamic"), e.P.parse(), e.AJ["3d"] && !e.EZ.true3d) {
          var C = ZC._a_(ZC._i_(e.EZ.depth * ZC.EN(e.EZ.angle)));
          e.P.iY += C, e.P.F -= C, e.P.I -= ZC._i_(e.EZ.depth * ZC.EG(e.EZ.angle));
        }
        if (typeof e.E["plotarea-p-x"] !== ZC._[31]) for (var A = 0, Z = e.BO.length; A < Z; A++) e.BO[A].X1(), e.BO[A].H0();
      }
    }, {
      key: "setupDynamicPlotArea",
      value: function setupDynamicPlotArea() {
        var e,
          t,
          i,
          a = this,
          n = ["top", "right", "bottom", "left"],
          l = {};
        for (t = 0; t < n.length; t++) l[n[t]] = !1, a.E["plotarea.d-margin-" + n[t]] && (a.o.plotarea["margin-" + n[t]] = null), a.o.plotarea && "dynamic" === a.o.plotarea["margin-" + n[t]] && (l[n[t]] = !0, a.o.plotarea["margin-" + n[t]] = "20");
        var r = !1,
          o = {};
        if ("xy" === a.AJ.layout && (r = !0), ("xy" === a.AJ.layout || "yx" === a.AJ.layout) && (a.P.E["d-margin"] || a.E["plotarea.d-margin"])) {
          for (var s = 0, C = a.BO.length; s < C; s++) {
            var A = 0,
              Z = 0,
              c = "",
              p = a.BO[s];
            if (p.AN && p.TM) {
              "k" === p.AF ? c = p.CO ? "default" === p.BA ? "left" : "right" : "default" === p.BA ? "bottom" : "top" : "v" === p.AF && (c = p.CO ? "default" === p.BA ? "bottom" : "top" : "default" === p.BA ? "left" : "right");
              var u = 0;
              if (a.P.E["d-margin-" + c] || a.E["plotarea.d-margin-" + c]) {
                var h = new DT(p);
                h.copy(p.BR);
                var _ = ZC.BQ(1, ZC._i_((p.A1 - p.W) / p.EH));
                for (t = p.W; t <= p.A1; t += _) if (h.AO = p.FC(t), h.A2O && ("k" === p.AF && !p.CO || "v" === p.AF && p.CO) && (h.o[ZC._[19]] = ZC._i_(.9 * p.AC)), h.parse(), h.AN) if (Z = ZC.BQ(Z, h.A9 % 180 == 0 ? h.F : h.I), A = ZC.BQ(A, h.A9 % 180 == 0 ? h.I : h.F), u = ZC.BQ(u, 1.5 * h.DG * (h.AO || "").split(/<br>|<br\/>|<br \/>|\n/).length), "top" === c || "bottom" === c) {
                  if (u = ZC.BQ(u, .465 * h.DG + 1.025 * ZC._a_(ZC.EN(h.A9)) * ZC.BQ(h.I, h.F)), A = h.I, Z = u, r && "k" === p.AF) {
                    o[p.BG] || (o[p.BG] = []);
                    var d = null === ZC._n_(h.o["auto-align"]) || ZC._b_(h.o["auto-align"]),
                      f = .465 * h.DG + 1.025 * ZC._a_(ZC.EG(h.A9)) * ZC.BQ(h.I, h.F);
                    "default" === p.BA ? (d && (ZC.DR(ZC._ang_(h.A9), 90, 180) || ZC.DR(ZC._ang_(h.A9), 270, 360)) && o[p.BG].push(f), d || o[p.BG].push(f / 2)) : (d && (ZC.DR(ZC._ang_(h.A9), 0, 90) || ZC.DR(ZC._ang_(h.A9), 180, 270)) && o[p.BG].push(f), d || o[p.BG].push(f / 2));
                  }
                } else A = u = ZC.BQ(u, .465 * h.DG + 1.025 * ZC._a_(ZC.EG(h.A9)) * ZC.BQ(h.I, h.F)), Z = h.F;
                var g = new DT(p);
                g.copy(p.M), g.AO = p.M.AO, g.parse(), "" !== g.AO && g.AN && (Z += g.A9 % 180 == 0 ? g.F : g.I, A += g.A9 % 180 == 0 ? g.I : g.F);
              }
              if (a.o.plotarea || (a.o.plotarea = {}), ("dynamic" === a.o.plotarea["margin-" + c] || a.P.E["d-margin-" + c]) && (a.P.E["d-margin-" + c] = !1, l[c] = !0, a.o.plotarea["margin-" + c] = "0"), l[c]) {
                a.o.plotarea["margin-" + c] = ZC._f_(a.o.plotarea["margin-" + c] || "0"), a.E[p.BG + "-distance"] = a.o.plotarea["margin-" + c];
                var B = ("top" === c || "bottom" === c ? ZC._i_(Z) : ZC._i_(A)) + 10 + (a.AJ["3d"] ? 20 : 0);
                if (p.W2 ? a.o.plotarea["margin-" + c] = ZC.BQ(a.o.plotarea["margin-" + c], B) : a.o.plotarea["margin-" + c] += B, null !== ZC._n_(a.o.plotarea["margin-" + c + "-offset"]) && (a.o.plotarea["margin-" + c] += ZC._i_(a.o.plotarea["margin-" + c + "-offset"])), !a.A.UF) {
                  var v = {},
                    m = a.A.DE.watermark;
                  a.A.B8.load(v, "loader.gui.watermark"), m && ZC._cp_(m, v), 1 === a.A.o[ZC._[16]].length && a.A.o[ZC._[16]][0].gui && (e = a.A.o[ZC._[16]][0].gui.watermark) && ZC._cp_(e, v);
                  var b = v.position || "br";
                  -1 === ZC.AV(["tl", "tr", "br", "bl"], b) && (b = "br"), ("bottom" !== c || "bl" !== b && "br" !== b) && ("top" !== c || "tl" !== b && "tr" !== b) || (a.o.plotarea["margin-" + c] += 15);
                }
                "bottom" === c && ("xy" === a.AJ.layout && a.HZ || "yx" === a.AJ.layout && a.HY) && (a.o.plotarea["margin-" + c] += 15), "left" === c && ("xy" === a.AJ.layout && a.HY || "yx" === a.AJ.layout && a.HZ) && (a.o.plotarea["margin-" + c] += 15), a.E["plotarea.d-margin-" + c] = !0;
              }
            }
          }
          if (r && l.left && null !== ZC._n_(a.o.plotarea[ZC._[60]])) for (var E in o) {
            var K = a.BJ(E);
            for (t = 0; t < o[E].length; t++) {
              ZC._i_(a.o.plotarea[ZC._[60]]) + t * K.AC + (K.DI ? K.AC / 2 : 0) - o[E][t] < 0 && (a.o.plotarea[ZC._[60]] = o[E][t] - t * K.AC - (K.DI ? K.AC / 2 : 0));
            }
          }
          ZC.Q.IT(ZC.AK(a.K + "-plotarea-c"), a.H.AA, a.P.iX, a.P.iY, a.P.I, a.P.F, a.K), a.E["plotarea.paint"] = !0, a.setupPlotArea();
          var D = 2,
            F = 6;
          null !== ZC._n_(e = a.P.o["mask-tolerance"]) && (e instanceof Array ? (D = F = ZC._i_(e[0]), e.length > 1 && (F = ZC._i_(e[1]))) : D = F = ZC._i_(e)), a.P.E.tolerance = D, "svg" === a.H.AA ? ((e = ZC.AK(a.K + "-clip-shape")) && e.setAttribute("points", a.LT(D, "svg")), (e = ZC.AK(a.K + "-clip-hover-shape")) && e.setAttribute("points", a.LT(F, "svg"))) : (ZC.A5("#" + a.K + " div").each(function () {
            "" !== this.style.clip && (this.style.clip = a.LT(D));
          }), (e = ZC.AK(a.K + "-hover")) && "" !== e.style.clip && (e.style.clip = a.LT(F)));
        }
        for (t = 0, i = a.BO.length; t < i; t++) a.BO[t].X1(), a.BO[t].H0();
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this,
          A = C.A.B8,
          Z = "(" + C.AF + ")";
        (e = C.A.E["graph-state-" + C.L]) && (C.E = JSON.parse(e), null === ZC._n_(C.E["guide-on"]) || ZC._b_(C.E["guide-on"]) || (C.A1V = !1)), C.E.legend_toggle_action || (C.A.E["graph-" + C.K + "-legend-info"] = null), C.E.legend_toggle_action = null, C.MK = "parse.init", _get(_getPrototypeOf(K2.prototype), "parse", this).call(this), C.AC6(), -1 !== JSON.stringify(C.o).indexOf("zingchart.maps") && (C.o.plotarea = C.o.plotarea || {}, C.o.plotarea.margin = 0);
        var c = null;
        if (!zingchart.SKIP.CSV && ((e = C.o["html5-csv"]) && (C.RY = e["html5-url"]), (e = C.o.csv) && ("object" == typeof e ? e.url ? C.RY = e.url : e["data-string"] && (c = e["data-string"]) : C.RY = e), "" !== C.RY && null !== ZC._n_(C.A.AAP[C.RY]) && (c = C.A.AAP[C.RY]), C.H.O6 && (c = C.H.O6), c)) {
          var p = C.A9L(c);
          C.o = p.parse();
        }
        if (C.LW = zingchart.ASYNC, C.assign_a([["utc", "UY", "b"], ["timezone", "NI", "f"], ["async", "LW", "b"], ["stacked", "CB", "b"], ["stack-type", "KX"], ["animate-type", "A25"], ["url-data", "AA3"], ["page", "LG", "i"], ["palette", "BP"], ["sort-objects", "A66", "b"], ["description", "PC"]]), C.BP.length > 0) for (A.B8.palette = [], a = 0; a < C.BP.length; a++) {
          var u = C.BP[a],
            h = ZC.AQ.JP(C.BP[a], 10),
            _ = ZC.AQ.R2(C.BP[a], 10);
          A.B8.palette.push(["#fff", u, h, _]);
        }
        "pie3d" === C.AF && (C.EZ.true3d = !0), (C.AJ["3d"] || C.A.A1N) && (C.LW = !1), C.A82(), -1 === ZC.AV(C.H.L0, ZC._[41]) && ((null !== ZC._n_(e = C.o.preview) || A.PX("preview", C.AF)) && C.AJ[ZC._[56]] && (C.B9 && !C.E["force-preview-parse"] || typeof A98 === ZC._[31] || (C.E["force-preview-parse"] = !1, C.B9 = new A98(C), C.B9.OP = "preview", A.load(C.B9.o, Z + ".preview"), "yx" === C.AJ.layout && A.load(C.B9.o, Z + ".preview[yx]"), (t = C.o.plotarea) && C.B9.append({
          "background-color": t[ZC._[0]],
          "background-color-1": t["background-color-1"],
          "background-color-2": t["background-color-2"],
          "gradient-stops": t["gradient-stops"],
          "gradient-colors": t["gradient-colors"]
        }), C.B9.append(e), C.B9.parse())), (null !== ZC._n_(e = C.o["scroll-x"]) || A.PX("scroll-x", C.AF)) && C.AJ["enable-scroll"] && (C.HZ || typeof A4E === ZC._[31] || (C.HZ = new A4E(C, "x"), C.HZ.OP = "scrollx", A.load(C.HZ.o, Z + ".scroll-x"), C.HZ.append(e), C.HZ.parse())), (null !== ZC._n_(e = C.o["scroll-y"]) || A.PX("scroll-y", C.AF)) && C.AJ["enable-scroll"] && (C.HY || typeof A4E === ZC._[31] || (C.HY = new A4E(C, "y"), C.HY.OP = "scrolly", A.load(C.HY.o, Z + ".scroll-y"), C.HY.append(e), C.HY.parse()))), C.setupPlotArea(), C.NK(), C.BO = [], C.O2(), C.A5D(1), null !== ZC._n_(e = C.o[ZC._[11]]) && (C.AY.o = e);
        var d = C.AY.o;
        for (a = 0; a < d.length; a++) if (d[a].rel) for (s = 0; s < d.length; s++) d[s].id && d[s].id === d[a].rel && (C.AY.o[a][ZC._[5]] = [].concat(C.AY.o[s][ZC._[5]]));
        if (C.AY.parse(), C.A5D(2), (null !== ZC._n_(e = C.o.title) || A.PX("title", C.AF)) && (C.IZ = new DT(C), C.IZ.OP = "title", A.load(C.IZ.o, Z + ".title"), C.IZ.append(e), C.IZ.K = C.K + "-title", C.IZ.KE = !0, C.IZ.parse(), null === ZC._n_(C.IZ.o.x))) {
          var f = C.iX,
            g = C.I;
          switch ("plotarea" === C.IZ.o["center-point"] && (f = C.P.iX, g = C.P.I), C.IZ.OO) {
            case "left":
              C.IZ.iX = f;
              break;
            case "center":
              C.IZ.iX = f + g / 2 - C.IZ.I / 2;
              break;
            case "right":
              C.IZ.iX = f + g - C.IZ.I;
          }
        }
        (null !== ZC._n_(e = C.o.subtitle) || A.PX("subtitle", C.AF)) && (C.K6 = new DT(C), C.K6.OP = "subtitle", A.load(C.K6.o, Z + ".subtitle"), C.K6.append(e), C.K6.K = C.K + "-subtitle", C.K6.parse()), null !== ZC._n_(e = C.o.source) && (C.N4 = new DT(C), C.N4.OP = "source", A.load(C.N4.o, Z + ".source"), C.N4.append(e), C.N4.K = C.K + "-source", C.N4.parse()), typeof A2H !== ZC._[31] && (null !== ZC._n_(e = C.o.legend) || A.PX("legend", C.AF)) && (C.BC = new A2H(C), C.BC.K = C.K + "-legend", typeof e.alpha !== ZC._[31] && e.alpha < .1 && typeof e[ZC._[62]] === ZC._[31] && typeof e["border-alpha"] === ZC._[31] && (e["border-alpha"] = e.alpha), A.load(C.BC.o, Z + ".legend"), C.BC.alignPosition(e), (null !== ZC._n_(e) && null !== ZC._n_(e.position) || null !== ZC._n_(C.BC.o.position)) && A.load(C.BC.o, Z + ".legend[position]"), C.BC.append(e), ZC._b_(C.BC.o.shared) && (C.BC.E["p-x"] = C.A.iX, C.BC.E["p-y"] = C.A.iY, C.BC.E["p-width"] = C.A.I, C.BC.E["p-height"] = C.A.F), C.BC.alignPosition(e), C.BC.parse());
        var B = !1,
          v = C.iX,
          m = C.iY,
          b = C.I,
          E = C.F,
          K = "";
        if (C.IZ && C.IZ.AN && C.IZ.o["adjust-layout"] && (B = !0, (i = C.IZ.iY + C.IZ.F / 2) < m + E / 2 && (K = "top", E = m + E - C.IZ.F - C.IZ.iY, m = C.IZ.iY + C.IZ.F, C.K6 && C.K6.o["adjust-layout"]))) {
          var D = C.K6.iY + C.K6.F / 2;
          D < m + E / 2 && D > i && (E -= C.K6.F, m += C.K6.F);
        }
        if (C.N4 && C.N4.AN && C.N4.o["adjust-layout"] && (B = !0, (i = C.N4.iY + C.N4.F / 2) > m + E / 2 && (E -= C.N4.F)), C.B9 && C.B9.AN && C.B9.o["adjust-layout"] && (B = !0, "xy" === C.AJ.layout ? (i = C.B9.AT.iY + C.B9.AT.F / 2) > m + E / 2 ? E -= C.B9.AT.F + C.B9.AT.DP : (m = C.B9.AT.iY + C.B9.AT.F, E -= C.B9.AT.F) : (f = C.B9.AT.iX + C.B9.AT.I / 2) < v + b / 2 ? (b -= C.B9.AT.I + C.B9.AT.DX, v += C.B9.AT.I + C.B9.AT.DX) : (v = C.B9.AT.iX + C.B9.AT.I, b -= C.B9.AT.I)), C.BC && C.BC.AN && C.BC.o["adjust-layout"]) {
          B = !0;
          var F = C.BC.D2 && C.BC.D2.enabled ? 15 : 5;
          if ("top" === K && C.BC.iY < C.IZ.iY + C.IZ.F + 5) {
            if (null !== ZC._n_(C.BC.o.position)) {
              var I = ("" + C.BC.o.position).split(" ");
              C.BC.o.position = I[0] + " " + (C.IZ.iY - C.iY + C.IZ.F + C.BC.ML + F);
            } else C.BC.o[ZC._[57]] = C.IZ.iY - C.iY + C.IZ.F + C.BC.ML;
            C.BC.parse();
          }
          C.BC.fixPlacement(), i = C.BC.iY + C.BC.F / 2;
          var x = "",
            y = (ZC.MAX, C.BC.E["position-info"]),
            X = {
              Bottom: C.BC.iY - C.iY,
              Top: C.iY + C.F - C.BC.iY - C.BC.F,
              Right: C.BC.iX - C.iX,
              Left: C.iX + C.I - C.BC.iX - C.BC.I
            },
            Y = "";
          if (C.BC.I / C.BC.F > 2) Y = "v";else if (C.BC.F / C.BC.I > 2) Y = "h";else {
            Y = Math.max(X.Left * C.F, X.Right * C.F) / Math.max(X.Top * C.I, X.Bottom * C.I) > 1 ? "h" : "v";
          }
          if (y) y[0] >= .8 ? x = y[1] <= .2 ? "v" === Y ? "top" : "right" : y[1] >= .8 && "v" === Y ? "bottom" : "right" : y[0] <= .2 ? x = y[1] <= .2 ? "v" === Y ? "top" : "left" : y[1] >= .8 && "v" === Y ? "bottom" : "left" : y[1] <= .2 ? x = "top" : y[1] >= .8 && (x = "bottom");else Math.min(X.Top, X.Bottom) / Math.max(X.Top, X.Bottom) < Math.min(X.Left, X.Right) / Math.max(X.Left, X.Right) ? X.Top > X.Bottom ? (x = "top", C.BC.E7) : (x = "bottom", C.BC.DP) : X.Left > X.Right ? (x = "left", C.BC.DX) : (x = "right", C.BC.E6);
          var w = 0;
          "top" === x && (E = m + E - C.BC.F - C.BC.iY, m = C.BC.iY + C.BC.F), "bottom" === x && (E -= w = E - C.BC.iY + m + C.BC.FO + C.BC.FS), "left" === x && (v += w = C.BC.iX - C.iX + C.BC.I, b -= w), "right" === x && (b -= w = b - (C.BC.iX - C.iX) + C.BC.EP + C.BC.FP);
        } else C.BC && C.BC.fixPlacement();
        B && (C.E["plotarea-p-x"] = v, C.E["plotarea-p-y"] = m, C.E["plotarea-p-width"] = b, C.E["plotarea-p-height"] = E, C.setupPlotArea()), C.setupDynamicPlotArea(), C.AY.parseLayout && C.AY.parseLayout(!0), C.B9 && C.B9.o["adjust-layout"] && ("xy" === C.AJ.layout ? (null === ZC._n_(C.B9.JG.x) && (C.B9.AT.iX = C.P.iX), null === ZC._n_(C.B9.JG[ZC._[19]]) && (C.B9.AT.I = C.P.I)) : (null === ZC._n_(C.B9.JG.y) && (C.B9.AT.iY = C.P.iY), null === ZC._n_(C.B9.JG[ZC._[20]]) && (C.B9.AT.F = C.P.F)));
        var L = 0;
        for (a = 0; a < C.AY.A4.length; a++) L += C.AY.A4[a].S.length;
        null !== ZC._n_(e = C.o["no-data"]) && 0 === L ? (C.SI = new DT(C), C.SI.OP = "nodata", A.load(C.SI.o, Z + ".noData"), C.SI.append({
          x: C.P.iX,
          y: C.P.iY,
          width: C.P.I,
          height: C.P.F
        }), C.SI.append(e), C.SI.K = C.K + "-nodata", C.SI.parse()) : C.SI = null, C.E["plotarea-margins"] && (C.E["plotarea-margins"] = null, C.o.plotarea = C.o.plotarea || {}, C.o.plotarea.margin = C.E["plotarea-margin"], C.o.plotarea[ZC._[57]] = C.E["plotarea-margin-top"], C.o.plotarea[ZC._[58]] = C.E["plotarea-margin-right"], C.o.plotarea[ZC._[59]] = C.E["plotarea-margin-bottom"], C.o.plotarea[ZC._[60]] = C.E["plotarea-margin-left"]);
        var M = ["top", "right", "bottom", "left"];
        for (a = 0; a < M.length; a++) C.E["plotarea.d-margin-" + M[a]] = null;
        if (ZC.Q.EU(C.A.K + "-tooltip"), typeof C.E.datalength !== ZC._[31] && null !== ZC._n_(C.E.datalength) && C.E.datalength.length > 0 && "canvas" !== C.H.AA && C.AY.A4) for (var H = 0, G = C.AY.A4.length; H < G; H++) {
          if (C.AY.A4[H].S.length < C.E.datalength[H]) for (r = C.AY.A4[H].S.length, o = C.E.datalength[H]; r < o; r++) l = C.K + ZC._[35] + H + "-node-" + r, ZC.Q.EU([l + "-path", l + "-area-path", l + "-sh-path"]), -1 !== ZC.AV(["scatter", "bubble"], C.AF) && ZC.Q.EU([l + "-marker-gradient", l + "-marker-path", l + "-marker-sh-path", l + "-marker-circle", l + "-marker-sh-circle"]), C.EM[H + "-" + r] = null;
          if (-1 === ZC.AV(["scatter", "bubble"], C.AF) || ZC.A5.browser.webkit) for (r = 0, o = C.E.datalength[H]; r < o; r++) l = C.K + ZC._[35] + H + "-node-" + r, ZC.Q.EU([l + "-marker-gradient", l + "-marker-path", l + "-marker-sh-path", l + "-marker-circle", l + "-marker-sh-circle"]);
        }
        for (C.E.datalength = null, a = 0, n = C.AY.A4.length; a < n; a++) C.GI = C.GI || C.AY.A4[a].GI;
        (C.HO || typeof PU === ZC._[31]) && (C.GI = !1), C.GI && (C.M7.onStop = function () {
          C.MK = "ready";
        }), -1 === ZC.AV(C.H.L0, ZC._[41]) && (C.H3 = new I3(C), C.H3.K = C.K + "-zoom", A.load(C.H3.o, Z + ".zoom"), C.H3.append(C.o.zoom), C.A7 = new DT(C), C.A7.OP = "tooltip", C.o.tooltip && C.o.tooltip[ZC._[7]] && C.o.tooltip[ZC._[7]].indexOf("node") > -1 ? A.load(C.A7.o, Z + ".tooltip[dynamic]") : A.load(C.A7.o, Z + ".tooltip"), C.A7.append(C.o.tooltip), C.A7.QD = !0, C.A7.parse(), null !== ZC._n_(e = C.o.guide) && (C.o["crosshair-x"] = e), (null !== ZC._n_(e = C.o["crosshair-x"]) || A.PX("guide", C.AF) || A.PX("crosshair-x", C.AF)) && C.AJ[ZC._[23]] && (C.CW = new CZ(C), C.CW.OP = "crosshairx", A.load(C.CW.o, [Z + ".guide", Z + ".crosshair-x"], !0, !0), C.CW.append(e), C.CW.parse(), C.E["guide-on"] = !0), (null !== ZC._n_(e = C.o["crosshair-y"]) || A.PX("crosshair-y", C.AF)) && C.AJ[ZC._[23]] && (C.HD = new CZ(C), C.HD.OP = "crosshairy", A.load(C.HD.o, [Z + ".guide", Z + ".crosshair-y"], !0, !0), C.HD.append(e), C.HD.parse(), C.E["guide-on"] = !0)), C.OA(), ZC.AQ.BZ("gparse", C.A, C.GR()), null !== ZC._n_(e = C.o.refresh) && (C.I0 = {
          type: "full",
          interval: 10,
          transport: "http",
          method: "pull",
          "adjust-scale": !1,
          "max-ticks": 20,
          "reset-timeout": 100,
          "stop-timeout": 0,
          storage: !1,
          "storage-size": 1e3
        }, ZC._cp_(e, C.I0), C.V1 = 1), C.MK = "parse.complete";
      }
    }, {
      key: "OA",
      value: function OA() {}
    }, {
      key: "PH",
      value: function PH() {}
    }, {
      key: "LT",
      value: function LT(e, t, i) {
        var a = this,
          n = (i = i || a.P).iX,
          l = i.iY,
          r = i.I,
          o = i.F;
        if ("svg" === t) {
          if (a.AJ["3d"]) {
            var s,
              C = [];
            e = 1;
            var A,
              Z,
              c,
              p,
              u = [],
              h = n - ZC.AP.E2,
              _ = l - ZC.AP.E1;
            s = new CC(a, h + r / 2 - e, _ - e, ZC.AP.FV), p = ZC._i_(s.EC[1]), s = new CC(a, h + r / 2 - e, _ - e, 0), c = ZC._i_(s.EC[1]), u.push(new CC(a, h - e, _ - e, p < c ? ZC.AP.FV : 0), new CC(a, h + r + e, _ - e, p < c ? ZC.AP.FV : 0)), s = new CC(a, h + r - e, _ + o / 2 - e, ZC.AP.FV), A = ZC._i_(s.EC[0]), s = new CC(a, h + r - e, _ + o / 2 - e, 0), Z = ZC._i_(s.EC[0]), u.push(new CC(a, h + r + e, _ - e, A > Z ? ZC.AP.FV : 0), new CC(a, h + r + e, _ + o + e, A > Z ? ZC.AP.FV : 0)), s = new CC(a, h + r / 2 - e, _ + o + e, ZC.AP.FV), p = ZC._i_(s.EC[1]), s = new CC(a, h + r / 2 - e, _ + o + e, 0), c = ZC._i_(s.EC[1]), u.push(new CC(a, h + r + e, _ + o + e, p > c ? ZC.AP.FV : 0), new CC(a, h - e, _ + o + e, p > c ? ZC.AP.FV : 0)), s = new CC(a, h - e, _ + o / 2 - e, ZC.AP.FV), A = ZC._i_(s.EC[0]), s = new CC(a, h - e, _ + o / 2 - e, 0), Z = ZC._i_(s.EC[0]), u.push(new CC(a, h - e, _ + o + e, A < Z ? ZC.AP.FV : 0), new CC(a, h - e, _ - e, A < Z ? ZC.AP.FV : 0)), u.push(u[0]);
            for (var d = 0; d < u.length; d++) s = u[d], C.push([ZC._i_(s.EC[0]), ZC._i_(s.EC[1])].join(","));
            return C.join(" ");
          }
          return [[n - e, l - e].join(","), [n + r + e, l - e].join(","), [n + r + e, l + o + e].join(","), [n - e, l + o + e].join(","), [n - e, l - e].join(",")].join(" ");
        }
        return "box" === t ? n - e + "," + (l - e) + "," + (r + 2 * e) + "," + (o + 2 * e) : (a.AJ["3d"] && (e += 10), "rect(" + (l - e) + "px," + (n + r + e) + "px," + (l + o + e) + "px," + (n - e) + "px)");
      }
    }, {
      key: "autoFit",
      value: function autoFit() {
        var e,
          t = this;
        if (t.AJ["3d"] && t.EZ["auto-fit"]) {
          var i = !1;
          for (t.EZ.zoom = 1; !i && t.EZ.zoom > .25;) {
            i = !0;
            var a = t.LT(0, "svg").split(" ");
            for (e = 0; e < a.length; e++) {
              var n = a[e].split(",");
              (ZC._i_(n[0]) < t.iX + t.P.DX || ZC._i_(n[0]) > t.iX + t.I - t.P.E6 || ZC._i_(n[1]) < t.iY + t.P.E7 || ZC._i_(n[1]) > t.iY + t.F - t.P.DP) && (i = !1);
            }
            i || (t.EZ.zoom -= .05), i && (t.EZ.zoom -= .025);
          }
        }
      }
    }, {
      key: "build",
      value: function build() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s = this,
          C = s.A.I + "/" + s.A.F,
          A = "0/0";
        if (s.autoFit(), !s.H.usc()) {
          var Z = 2,
            c = 6;
          if (null !== ZC._n_(e = s.P.o["mask-tolerance"]) && (e instanceof Array ? (Z = c = ZC._i_(e[0]), e.length > 1 && (c = ZC._i_(e[1]))) : Z = c = ZC._i_(e)), "svg" === s.A.AA && s.AJ.clip && (ZC.Q.EU([s.K + "-clip", s.K + "-clip-hover", s.K + "-clip-preview"]), s.A.KK.appendChild(ZC.Q.XU({
            id: s.K + "-clip",
            path: s.LT(Z, "svg")
          })), s.A.KK.appendChild(ZC.Q.XU({
            id: s.K + "-clip-hover",
            path: s.LT(c, "svg")
          })), s.B9)) {
            var p = s.AJ["3d"];
            s.AJ["3d"] = !1, s.A.KK.appendChild(ZC.Q.XU({
              id: s.K + "-clip-preview",
              path: s.LT(0, "svg", s.B9.AT)
            })), s.AJ["3d"] = p;
          }
          var u = !s.AJ.clip,
            h = u ? null : s.LT(Z),
            _ = u ? null : "url(#" + s.K + "-clip)",
            d = u ? null : s.LT(c),
            f = u ? null : "url(#" + s.K + "-clip-hover)";
          if (s.B9 && (n = u ? null : s.LT(0, s.A.AA, s.B9.AT), l = u ? null : "url(#" + s.K + "-clip-preview)"), ZC.Q.K5({
            cls: "zc-abs",
            id: s.K,
            p: ZC.AK(s.A.K + "-graphset"),
            tl: A,
            wh: C
          }, s.A.AA), s.A.O4.graph && ZC.Q.HJ({
            cls: ZC._[24] + " zc-persistent",
            id: s.K + "-c",
            p: ZC.AK(s.K),
            wh: C
          }, s.A.AA), ZC.Q.K5({
            id: s.K + "-plotarea",
            p: ZC.AK(s.K),
            tl: A,
            wh: C,
            position: "absolute"
          }, s.A.AA), s.o.plotarea && s.A.O4.plotarea && ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-plotarea-c",
            p: ZC.AK(s.K + "-plotarea"),
            wh: C
          }, s.A.AA), "null" !== s.AF && s.A.O4.plots) {
            for (ZC.Q.K5({
              id: s.K + "-scales-bl",
              p: ZC.AK(s.K),
              tl: A,
              wh: C,
              position: "absolute",
              "clip-path": _,
              clip: h
            }, s.A.AA), t = 0; t < s.A6F; t++) ZC.Q.HJ({
              cls: ZC._[24],
              id: s.K + "-scales-bl-" + t + "-c",
              p: ZC.AK(s.K + "-scales-bl"),
              wh: C
            }, s.A.AA);
            if (s.AY.E["plot-sort"]) {
              for (t = 0, i = s.AY.A4.length; t < i; t++) {
                for (s.AY.A4[t].V8 = {}, a = 0; a < s.AY.A4[t].T1; a++) ZC.Q.EU(s.K + "-plots-bl-" + a);
                for (a = 0; a < s.AY.A4[t].A20; a++) ZC.Q.EU(s.K + "-plots-fl-" + a);
              }
              delete s.AY.E["plot-sort"];
            }
            if (s.A.KE || s.AJ["3d"]) ZC.AK(s.K + "-plots-bl") || ZC.Q.K5({
              id: s.K + "-plots-bl",
              p: ZC.AK(s.K),
              after: ZC.AK(s.K + "-scales-bl"),
              tl: A,
              wh: C,
              position: "absolute",
              "clip-path": _,
              clip: h
            }, s.A.AA), (r = ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-bl",
              id: s.K + "-plots-bl-c",
              p: ZC.AK(s.K + "-plots-bl"),
              wh: C
            }, s.A.AA)).setAttribute("data-clip", s.LT(Z, "box"));else for (t = 0, i = s.AY.A4.length; t < i; t++) for (o = s.AY.MF[t], a = s.AY.A4[t].T1 - 1; a >= 0; a--) ZC.AK(s.K + "-plots-bl-" + a) || ZC.Q.K5({
              id: s.K + "-plots-bl-" + a,
              p: ZC.AK(s.K),
              after: ZC.AK(s.K + "-scales-bl"),
              tl: A,
              wh: C,
              position: "absolute",
              "clip-path": _,
              clip: h
            }, s.A.AA), (r = ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-bl",
              id: s.K + "-plot-" + o + "-bl-" + a + "-c",
              p: ZC.AK(s.K + "-plots-bl-" + a),
              wh: C
            }, s.A.AA)).setAttribute("data-clip", s.LT(Z, "box")), r.style.display = "block";
            for (t = 0; t < s.W4; t++) ZC.Q.HJ({
              cls: ZC._[24],
              id: s.K + "-scales-ml-" + t + "-c",
              p: ZC.AK(s.K),
              wh: C
            }, s.A.AA);
            if (s.A.KE || s.AJ["3d"]) ZC.AK(s.K + "-plots-fl") || ZC.Q.K5({
              id: s.K + "-plots-fl",
              p: ZC.AK(s.K),
              after: ZC.AK(s.K + "-scales-ml-" + (s.W4 - 1) + "-c"),
              tl: A,
              wh: C,
              position: "absolute"
            }, s.A.AA), (r = ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-fl",
              id: s.K + "-plots-fl-c",
              p: ZC.AK(s.K + "-plots-fl"),
              wh: C
            }, s.A.AA)).setAttribute("data-clip", s.LT(c, "box"));else for (t = 0, i = s.AY.A4.length; t < i; t++) for (o = s.AY.MF[t], a = s.AY.A4[t].A20 - 1; a >= 0; a--) ZC.AK(s.K + "-plots-fl-" + a) || ZC.Q.K5({
              id: s.K + "-plots-fl-" + a,
              p: ZC.AK(s.K),
              after: ZC.AK(s.K + "-scales-ml-" + (s.W4 - 1) + "-c"),
              tl: A,
              wh: C,
              position: "absolute"
            }, s.A.AA), (r = ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-fl",
              id: s.K + "-plot-" + o + "-fl-" + a + "-c",
              p: ZC.AK(s.K + "-plots-fl-" + a),
              wh: C
            }, s.A.AA)).setAttribute("data-clip", s.LT(c, "box")), r.style.display = "block";
            for (zingchart.DEV.PLOTSHLAYER && (ZC.Q.K5({
              id: s.K + "-plots-hover",
              p: ZC.AK(s.K),
              tl: A,
              wh: C,
              position: "absolute"
            }, s.A.AA), ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-fl",
              id: s.K + "-plots-hover-c",
              p: ZC.AK(s.K + "-plots-hover"),
              wh: C
            }, s.A.AA)), ZC.Q.K5({
              id: s.K + "-scales-fl",
              p: ZC.AK(s.K),
              tl: A,
              wh: C,
              position: "absolute",
              "clip-path": _,
              clip: h
            }, s.A.AA), t = 0; t < s.A68; t++) ZC.Q.HJ({
              cls: ZC._[24],
              id: s.K + "-scales-fl-" + t + "-c",
              p: ZC.AK(s.K + "-scales-fl"),
              wh: C
            }, s.A.AA);
            if (s.B9 && (ZC.Q.K5({
              id: s.K + "-preview",
              p: ZC.AK(s.A.K + "-tools"),
              tl: A,
              wh: C,
              position: "absolute",
              "clip-path": l,
              clip: n
            }, s.A.AA), ZC.Q.HJ({
              cls: "zc-abs",
              id: s.K + "-preview-c",
              p: ZC.AK(s.K + "-preview"),
              wh: C
            }, s.A.AA)), ZC.Q.K5({
              id: s.K + "-scroll",
              p: ZC.AK(s.K),
              tl: A,
              wh: C,
              position: "absolute"
            }, s.A.AA), s.o["scroll-x"] && ZC.Q.HJ({
              cls: "zc-abs",
              id: s.K + "-scroll-x-c",
              p: ZC.AK(s.K + "-scroll"),
              wh: C
            }, s.A.AA), s.o["scroll-y"] && ZC.Q.HJ({
              cls: "zc-abs",
              id: s.K + "-scroll-y-c",
              p: ZC.AK(s.K + "-scroll"),
              wh: C
            }, s.A.AA), ZC.Q.K5({
              id: s.K + "-plots-vb",
              p: ZC.AK(s.K),
              tl: A,
              wh: C,
              position: "absolute"
            }, s.A.AA), s.A.O4[ZC._[17]]) if (s.A.KE || s.AJ["3d"]) ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-vb",
              id: s.K + "-plots-vb-c",
              p: ZC.AK(s.K + "-plots-vb"),
              wh: C
            }, s.A.AA);else for (t = 0, i = s.AY.A4.length; t < i; t++) ZC.Q.HJ({
              cls: "zc-abs zc-layer zc-vb",
              id: s.K + "-plot-" + t + "-vb-c",
              p: ZC.AK(s.K + "-plots-vb"),
              wh: C
            }, s.A.AA);
          }
          (s.o.title || s.o.subtitle || s.o.source || s.o["no-data"]) && (ZC.Q.K5({
            id: s.K + "-titles",
            p: ZC.AK(s.K),
            tl: A,
            wh: C,
            position: "absolute"
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-titles-c",
            p: ZC.AK(s.K + "-titles"),
            wh: C
          }, s.A.AA)), ZC.Q.K5({
            cls: "zc-abs",
            wh: C,
            id: s.K + "-hover",
            p: ZC.AK(s.A.K + "-hover"),
            "clip-path": f,
            clip: d
          }, s.A.AA), "canvas" === s.A.AA && (ZC.AK(s.K + "-hover").style.clip = d), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + ZC._[22],
            p: ZC.AK(s.K + "-hover"),
            wh: C
          }, s.A.AA), s.A.O4.maps && -1 !== JSON.stringify(s.o).indexOf("zingchart.maps") && (ZC.Q.K5({
            cls: "zc-abs",
            wh: C,
            id: s.K + "-objects-maps",
            p: ZC.AK(s.A.K + "-objects-maps"),
            "clip-path": f,
            clip: d
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-objects-maps-sh-c",
            p: ZC.AK(s.K + "-objects-maps"),
            wh: C
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-objects-maps-c",
            p: ZC.AK(s.K + "-objects-maps"),
            wh: C
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-objects-maps-click-c",
            p: ZC.AK(s.K + "-objects-maps"),
            wh: C
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-objects-maps-hover-c",
            p: ZC.AK(s.K + "-objects-maps"),
            wh: C
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-objects-maps-print-c",
            p: ZC.AK(s.K + "-objects-maps"),
            wh: C,
            display: "none"
          }, s.A.AA)), s.initObjectsLayers(), s.o.legend && (ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-legend-c",
            p: ZC.AK(s.A.K + "-legend"),
            wh: C
          }, s.A.AA), ZC.Q.HJ({
            cls: ZC._[24],
            id: s.K + "-legend-scroll-c",
            p: ZC.AK(s.A.K + "-legend"),
            wh: C
          }, s.A.AA));
        }
        s.Z = s.H.usc() ? s.H.mc() : ZC.AK(s.K + "-c");
      }
    }, {
      key: "initObjectsLayers",
      value: function initObjectsLayers() {
        var e = this,
          t = e.A.I + "/" + e.A.F;
        !ZC.AK(e.K + "-objects-bottom") && e.A.O4["objects-bottom"] && (e.o.shapes || e.o[ZC._[10]] || e.o.arrows || e.o.images) && (ZC.Q.K5({
          cls: "zc-abs",
          wh: t,
          id: e.K + "-objects-bottom",
          p: ZC.AK(e.A.K + "-objects-bottom")
        }, e.A.AA), ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-bottom-sh-c",
          p: ZC.AK(e.K + "-objects-bottom"),
          wh: t
        }, e.A.AA), ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-bottom-c",
          p: ZC.AK(e.K + "-objects-bottom"),
          wh: t
        }, e.A.AA)), !ZC.AK(e.K + "-objects-top") && e.A.O4["objects-top"] && (e.o.shapes || e.o[ZC._[10]] || e.o.arrows || e.o.images) && (ZC.Q.K5({
          cls: "zc-abs",
          wh: t,
          id: e.K + "-objects-top",
          p: ZC.AK(e.A.K + "-objects-top")
        }, e.A.AA), ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-top-sh-c",
          p: ZC.AK(e.K + "-objects-top"),
          wh: t
        }, e.A.AA), ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-top-c",
          p: ZC.AK(e.K + "-objects-top"),
          wh: t
        }, e.A.AA)), (e.A.O4["objects-bottom"] || e.A.O4["objects-top"]) && (e.o.shapes || e.o[ZC._[10]] || e.o.arrows) && ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-print-c",
          p: ZC.AK(e.K + "-objects-top"),
          wh: t,
          display: "none"
        }, e.A.AA), !ZC.AK(e.K + "-objects-click") && (e.A.O4["objects-bottom"] || e.A.O4["objects-top"]) && (e.o.shapes || e.o[ZC._[10]] || e.o.arrows || e.o.images) && (ZC.Q.K5({
          cls: "zc-abs",
          wh: t,
          id: e.K + "-objects-click",
          p: ZC.AK(e.A.K + "-hover")
        }, e.A.AA), ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-click-c",
          p: ZC.AK(e.K + "-objects-click"),
          wh: t
        }, e.A.AA)), !ZC.AK(e.K + "-objects-hover") && (e.A.O4["objects-bottom"] || e.A.O4["objects-top"]) && (e.o.shapes || e.o[ZC._[10]] || e.o.arrows || e.o.images) && (ZC.Q.K5({
          cls: "zc-abs",
          wh: t,
          id: e.K + "-objects-hover",
          p: ZC.AK(e.A.K + "-hover")
        }, e.A.AA), ZC.Q.HJ({
          cls: ZC._[24],
          id: e.K + "-objects-hover-c",
          p: ZC.AK(e.K + "-objects-hover"),
          wh: t
        }, e.A.AA));
      }
    }, {
      key: "Y8",
      value: function Y8() {}
    }, {
      key: "clear_",
      value: function clear_() {}
    }, {
      key: "destroy",
      value: function destroy() {
        var e,
          t = this;
        null !== ZC._n_(e = t.A.SL[t.K]) && "feed" === t.I0.type && (e.send("zingchart.stopfeed"), e.close(), t.A.SL[t.K] = null), t.GI && t.M7.stop(!0), t.MK = "clear.init", t.unbind(), t.BC && t.BC.unbind(), t.B9 && t.B9.unbind(), t.HZ && t.HZ.unbind(), t.HY && t.HY.unbind(), t.MK = "clear.complete";
      }
    }, {
      key: "clear",
      value: function clear(e, t) {
        null === ZC._n_(e) && (e = !1), null === ZC._n_(t) && (t = !1);
        var i,
          a,
          n,
          l,
          r = this;
        r.TT = {}, null === ZC._n_(i = r.A.SL[r.K]) || e || "feed" === r.I0.type && (i.send("zingchart.stopfeed"), i.close(), r.A.SL[r.K] = null), r.GI && r.M7.stop(!0), r.MK = "clear.init", r.unbind(e), r.Y8(!1, !0), r.KW(), r.KW("click"), r.KW("guide", !0), r.KW("print", !0), r.KW("textprint", !0), e || (!r.B9 || r.B9 && !r.B9.LW) && r.KW("static", !0), r.AY.ZN = [], r.A.T4 = [], zingchart.SKIP.LEGEND || r.BC && r.BC.clear(), r.E.datalength = [];
        var o,
          s,
          C,
          A = ZC.ie67 ? ZC.AK(r.A.K) : null;
        if (ZC.mobile || ZC.ie67) ZC.A5("." + r.K + "-node-area", A).remove();else if (ZC.AK(r.A.K + "-img") && ZC.AK(r.A.K + "-map")) {
          ZC.AK(r.A.K + "-img").setAttribute("useMap", "");
          var Z = ZC.AK(r.A.K + "-map").cloneNode(!0);
          for (a = (n = Z.childNodes.length) - 1; a >= 0; a--) -1 !== Z.childNodes[a].className.indexOf(r.K + "-node-area") && Z.removeChild(Z.childNodes[a]);
          ZC.Q.EU(r.A.K + "-map"), ZC.AK(r.A.K + "-top").appendChild(Z), ZC.AK(r.A.K + "-img").setAttribute("useMap", "#" + r.A.K + "-map");
        }
        switch (ZC.Q.EU(r.K + "--graph"), r.AY.HK = [], ZC.A5("." + r.K + "-value-box", A).remove(), ZC.A5("." + r.K + "-scale-marker-label", A).remove(), ZC.A5("." + r.K + "-scale-item", A).remove(), ZC.A5("." + r.K + "-scale-label", A).remove(), ZC.A5("." + r.K + "-guide-label", A).remove(), ZC.A5("." + r.K + "-shape-label", A).remove(), ZC.A5("." + r.K + "-mapshape-label", A).remove(), e || ZC.A5("." + r.K + "-preview-item", A).remove(), r.A.AA) {
          case "svg":
            for (a = 0, n = r.AY.A4.length; a < n; a++) r.AY.A4[a].HN = null;
            ZC.A5("#" + r.A.K + "-defs").children().each(function () {
              "LINK" !== this.tagName.toUpperCase() && (0 !== this.id.indexOf(r.K + "-") && 1 !== r.A.AG.length || (e ? this.id !== r.K + "-gradient" && -1 === this.id.indexOf("-preview-gradient") && -1 === this.id.indexOf("-menu-trigger-gradient") && -1 !== this.id.indexOf(r.K + ZC._[35]) && (t && r.GI || -1 !== this.id.indexOf(r.K + "-legend-") && zingchart.SKIP.LEGEND || ZC.A5(this).remove()) : -1 === this.id.indexOf("zc-menu-") && -1 === this.id.indexOf("-menu-trigger-") && (-1 !== this.id.indexOf(r.K + "-legend-") ? zingchart.SKIP.LEGEND || ZC.A5(this).remove() : r.B9 && r.B9.LW ? -1 === this.id.indexOf("-preview-gradient") && ZC.A5(this).remove() : ZC.A5(this).remove())));
            }), e || ZC.Q.EU([r.K + "-clip", r.K + "-clip-hover", r.K + "-clip-preview"]), ZC.A5("#" + r.A.K + "-svg").children().each(function () {
              var e = r.K + "-";
              "clippath" === this.tagName.toLowerCase() && this.id.substring(0, e.length) === e && this.id !== r.K + "-clip" && this.id !== r.K + "-clip-hover" && this.id !== r.K + "-clip-preview" && ZC.Q.EU(this.id);
            });
        }
        (ZC.Q.EU(r.K + "-nodata"), ZC.Q.EU(r.A.K + "-tooltip-text-float"), e || (ZC.Q.EU([r.K + "-title", r.K + "-subtitle", r.K + "-source", r.K + "-hover"]), zingchart.SKIP.LEGEND || r.BC && (ZC.Q.EU(r.K + "-legend-c"), ZC.Q.EU(r.K + "-legend-scroll-c"), ZC.A5("." + r.K + "-legend-item-area", A).remove(), ZC.A5("." + r.K + "-legend-marker-area", A).remove(), ZC.A5("." + r.K + "-legend-item", A).remove(), ZC.A5("." + r.K + "-legend-header", A).remove(), ZC.A5("." + r.K + "-legend-footer", A).remove(), ZC.A5("." + r.K + "-legend-frame", A).remove(), r.BC.gc(), r.BC = null), r.B9 && (r.B9.LW && !r.A.E.resize || (r.B9.unbind(), ZC.A5("." + r.K + "-preview-handler").remove(), ZC.A5("." + r.K + "-preview-mask").remove(), ZC.A5("#" + r.K + "-preview").remove(), r.B9.gc(), r.B9 = null)), r.HZ && (r.HZ.unbind(), r.HZ = null), ZC.Q.IT(ZC.AK(r.K + "-scroll-x-c"), r.A.AA, r.iX, r.iY, r.I, r.F, r.K), ZC.Q.IT(ZC.AK(r.K + "-scroll-y-c"), r.A.AA, r.iX, r.iY, r.I, r.F, r.K), ZC.A5("#" + r.K + "-scroll-x-handle").remove(), ZC.A5("#" + r.K + "-scroll-x-bar").remove(), r.HY && (r.HY.unbind(), r.HY = null), ZC.A5("#" + r.K + "-scroll-y-handle").remove(), ZC.A5("#" + r.K + "-scroll-y-bar").remove(), ZC.A5("#" + r.K + "-c").empty(), r.H.R1[0] !== r.H.R1[1] && "" !== r.H.R1[1] && ("canvas" === r.H.AA && ZC.A5("#" + r.K + " canvas").each(function () {
          this.width = 1, this.height = 1, ZC.Q.EU(this);
        }), ZC.A5("#" + r.K + " div").each(function () {
          ZC.Q.EU(this);
        }), ZC.Q.EU(r.K))), ZC.A5("#" + r.K + " .zc-layer").each(function () {
          var i = ZC.Q.TG(this);
          if (-1 === i.indexOf("zc-persistent")) {
            if (e && (this.id === r.K + "-plotarea-c" || this.id === r.K + "-titles-c")) return;
            if (-1 === this.id.indexOf(r.K + "-plot-") && -1 === this.id.indexOf(r.K + "-plots-")) ZC.Q.IT(this, r.H.AA, r.iX, r.iY, r.I, r.F, r.K);else if (t && r.GI && !r.HO) {
              if ("canvas" !== r.H.AA) for (var a = 0, n = r.AY.A4.length; a < n; a++) r.E.datalength[a] = r.AY.A4[a].S.length;
              (l = r.A.KE ? new RegExp("-plots-[a-z]+-c", "g").exec(this.id) : new RegExp("-plot-(\\d+)-[a-z]+-\\d+-", "g").exec(this.id)) && (!r.E["plot" + l[1] + ".visible"] && "remove" === r.getToggleAction() || r.A.KE) && ZC.Q.IT(this, r.H.AA, r.iX, r.iY, r.I, r.F, r.K), -1 === i.indexOf("zc-vb") && -1 === i.indexOf("zc-fl") || ZC.Q.IT(this, r.H.AA, r.iX, r.iY, r.I, r.F, r.K);
            } else ZC.Q.IT(this, r.H.AA, r.iX, r.iY, r.I, r.F, r.K);
          }
        }), -1 !== ZC.AV(r.H.L0, ZC._[44])) && ((o = ZC.AK(r.H.K + "-main-c")) && ZC.Q.IT(o, r.H.AA, r.iX, r.iY, r.I, r.F, r.K), (s = ZC.AK(r.H.K + "-main-c-top")) && ZC.Q.IT(s, r.H.AA, r.iX, r.iY, r.I, r.F, r.K), (C = ZC.AK(r.H.K + ZC._[15])) && ZC.Q.IT(C, r.H.AA, r.iX, r.iY, r.I, r.F, r.K));
        r.clear_(), r.A.E.resize = !1, r.MK = "clear.complete";
      }
    }, {
      key: "unbind",
      value: function unbind(e, t) {
        null === ZC._n_(e) && (e = !1);
        var i = this;
        (-1 === ZC.AV(i.H.L0, ZC._[41]) || t) && (ZC.A5("." + i.K + "-node-area").die("mousedown mouseover touchstart", i.XL).die("mouseup mouseout touchend", i.A29).die("mousemove touchmove", i.A1D).die("click", i.TU).die("contextmenu", i.TU).die("dblclick", i.A2D), i.BC && (zingchart.SKIP.LEGEND || (ZC.A5("." + i.K + "-legend-item-area").die("mouseup touchstart", i.SZ).die("DOMMouseScroll", i.zc_legend_mousescroll).die("mousewheel", i.zc_legend_mousescroll), ZC.A5("." + i.K + "-legend-marker-area").die("mouseup touchstart", i.SZ).die("DOMMouseScroll", i.zc_legend_mousescroll).die("mousewheel", i.zc_legend_mousescroll), ZC.A5("#" + i.K + "-legend-frame").die("DOMMouseScroll", i.zc_legend_mousescroll).die("mousewheel", i.zc_legend_mousescroll), ZC.mobile || (ZC.A5("." + i.K + "-legend-item-area").die(ZC.Q.BX("mouseover"), i.QX).die(ZC.Q.BX("mouseout"), i.RN).die(ZC.Q.BX(ZC._[48]), i.PZ), ZC.A5("." + i.K + "-legend-marker-area").die(ZC.Q.BX("mouseover"), i.QX).die(ZC.Q.BX("mouseout"), i.RN).die(ZC.Q.BX(ZC._[48]), i.PZ))))), i.A8M();
      }
    }, {
      key: "A8M",
      value: function A8M() {}
    }, {
      key: "RV",
      value: function RV() {}
    }, {
      key: "Q1",
      value: function Q1() {}
    }, {
      key: "JW",
      value: function JW() {}
    }, {
      key: "RF",
      value: function RF() {}
    }, {
      key: "Q7",
      value: function Q7() {}
    }, {
      key: "KW",
      value: function KW(e, t) {
        var i = this;
        e = e || "hover", null === ZC._n_(t) && (t = !1);
        var a = ZC.AK((t ? i.A.K : i.K) + "-" + e + "-c");
        a && (ZC.Q.IT(a, i.H.AA, i.iX, i.iY, i.I, i.F, i.K, "textprint" === e), ZC.A5("." + i.K + "-label-hover").remove()), "hover" === e && (ZC.Q.IT(ZC.AK(i.K + "-objects-hover-c"), i.H.AA, i.iX, i.iY, i.I, i.F, i.K), ZC.Q.IT(ZC.AK(i.K + "-objects-maps-hover-c"), i.H.AA, i.iX, i.iY, i.I, i.F, i.K), zingchart.DEV.PLOTSHLAYER && ZC.Q.IT(ZC.AK(i.K + "-plots-hover-c"), i.H.AA, i.iX, i.iY, i.I, i.F, i.K)), "click" === e && (ZC.Q.IT(ZC.AK(i.K + "-objects-click-c"), i.H.AA, i.iX, i.iY, i.I, i.F, i.K), ZC.Q.IT(ZC.AK(i.K + "-objects-maps-click-c"), i.H.AA, i.iX, i.iY, i.I, i.F, i.K)), i.hideLayer_(e, t);
      }
    }, {
      key: "hideLayer_",
      value: function hideLayer_() {}
    }, {
      key: "A1X",
      value: function A1X(e, t) {
        var i,
          a = this;
        if (null !== ZC._n_(e) && null !== ZC._n_(t)) {
          var n = a.AY.A4[e].J7,
            l = a.AY.A4[e].S2;
          if ("none" === n) return;
          if (null !== ZC._n_(a.C9["p" + e])) {
            if (null !== ZC._n_(a.C9["p" + e]["n" + t])) {
              if (delete a.C9["p" + e]["n" + t], l) for (i = 0; i < a.AY.A4.length; i++) delete a.C9["p" + i]["n" + t];
            } else if ("graph" === n ? (a.C9 = {}, a.C9["p" + e] = {}) : "plot" === n && (a.C9["p" + e] = {}), a.C9["p" + e]["n" + t] = !0, l) for (i = 0; i < a.AY.A4.length; i++) a.C9["p" + i] = a.C9["p" + i] || {}, a.C9["p" + i]["n" + t] = !0;
          } else if ("graph" === n && (a.C9 = {}), a.C9["p" + e] = {}, a.C9["p" + e]["n" + t] = !0, l) for (i = 0; i < a.AY.A4.length; i++) a.C9["p" + i] = a.C9["p" + i] || {}, a.C9["p" + i]["n" + t] = !0;
        }
        null !== ZC._n_(e) && null !== ZC._n_(t) && (a.HO = !0, a.JY(!0, !0));
      }
    }, {
      key: "paint",
      value: function paint(e) {
        null === ZC._n_(e) && (e = !1);
        var t,
          i,
          a,
          n,
          l,
          r,
          o = this;
        o.A.GRAPHID = o.K, o.VR = e, window.clearTimeout(ZC.ASYNC_TICK[o.K]), o.A.clearLabelBoxes("vb" + o.L);
        var s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h = o.BT("k")[0],
          _ = ZC.MAX,
          d = -ZC.MAX,
          f = {},
          g = o.AY.A4,
          B = 0;
        for (Z = 0; Z < g.length; Z++) if (g[Z].o.rel) for (A = 0; A < g.length; A++) if (g[A].o.id && g[A].o.id === g[Z].o.rel) {
          B++, u = !0;
          var v = [];
          for (l = 0; l < g[A].S.length; l++) (h.EF ? g[A].S[l].BU >= h.B3 && g[A].S[l].BU <= h.BL : g[A].S[l].L >= h.W && g[A].S[l].L <= h.A1) ? (s = g[A].S[l].AD, _ = Math.min(_, s), d = Math.max(d, s), u ? (u = !1, g[A].S[l].BU ? v.push([g[A].S[l].BU, 0]) : v.push(0), p = s) : g[A].S[l].BU ? v.push([g[A].S[l].BU, 100 * (s - p) / p]) : v.push(100 * (s - p) / p)) : g[A].S[l].BU ? v.push([g[A].S[l].BU, 0]) : v.push(0);
          f["p-" + Z] = [].concat(v);
        }
        if (B > 0) {
          for (_ = ZC.MAX, d = -ZC.MAX, Z = 0; Z < g.length; Z++) if (g[Z].o.rel && f["p-" + Z]) for (l = 0; l < g[Z].S.length; l++) 2 === (C = f["p-" + Z][l]).length ? (s = C[1], g[Z].V[l] = C, g[Z].S[l].AD = g[Z].S[l].CR = C[1]) : (s = C, g[Z].V[l] = g[Z].S[l].AD = g[Z].S[l].CR = C), g[Z].FK(l), _ = Math.min(_, s), d = Math.max(d, s);
          var m = o.BT("v")[0];
          m.Q9(_, d, !0), m.H0();
        }
        for (o.A.E["g-" + o.L + "-selection"] && (o.C9 = JSON.parse(o.A.E["g-" + o.L + "-selection"])), o.KP = !1, i = 0, a = o.AY.A4.length; i < a; i++) o.J4[i] = !1;
        for (i in o.C9) if (o.C9.hasOwnProperty(i)) {
          var b = ZC._i_(i.replace("p", ""));
          for (c in o.C9[i]) if (o.C9[i].hasOwnProperty(c)) {
            o.J4[b] = !0, o.KP = !0;
            break;
          }
        }
        function E() {
          if (o.AJ["3d"]) {
            var e = ZC.DH.DA(o.P, o, o.P.iX - ZC.AP.E2, o.P.iX - ZC.AP.E2 + o.P.I, o.P.iY - ZC.AP.E1, o.P.iY - ZC.AP.E1 + o.P.F, ZC.AP.FV + 10, ZC.AP.FV + 10, "y"),
              i = ZC.DH.DA(o.P, o, o.P.iX - ZC.AP.E2, o.P.iX - ZC.AP.E2 + o.P.I, o.P.iY - ZC.AP.E1, o.P.iY - ZC.AP.E1 + o.P.F, ZC.AP.FV, ZC.AP.FV, "y");
            i.K = o.K + "-plotarea", i.PN = e.D, o.CJ.add(i);
          } else {
            o.P.Z = o.P.C7 = o.H.usc() ? o.H.mc() : ZC.AK(o.K + "-plotarea-c");
            var a,
              n = [o.P.iX, o.P.iY, o.P.I, o.P.F],
              l = o.P.AU,
              r = o.P.AU,
              s = o.P.AU,
              C = o.P.AU;
            "" !== (t = o.P.QF) && (a = t.split(/\s/), l = ZC._i_(a[0])), "" !== (t = o.P.OV) && (a = t.split(/\s/), r = ZC._i_(a[0])), "" !== (t = o.P.O1) && (a = t.split(/\s/), s = ZC._i_(a[0])), "" !== (t = o.P.PK) && (a = t.split(/\s/), C = ZC._i_(a[0])), o.P.iX -= C + 1, o.P.iY -= l + 1, o.P.I += C + r + 1, o.P.F += l + s + 1, o.P.paint(), o.P.iX = n[0], o.P.iY = n[1], o.P.I = n[2], o.P.F = n[3];
          }
        }
        if (o.A.YB(), o.NK(), o.VR ? o.E["plotarea.paint"] && (E(), o.E["plotarea.paint"] = null) : (o.build(), o.Z && (o.C7 = o.Z, _get(_getPrototypeOf(K2.prototype), "paint", this).call(this)), E()), "xy" === o.AJ.layout || "yx" === o.AJ.layout) {
          var K = o.BT("v"),
            D = null;
          for (l = 0; l < K.length; l++) (0 === l || K[l].o["ref-zero"]) && K[l].FX <= 0 && K[l].H4 >= 0 && K[l].TM && (D = l);
          if (null !== ZC._n_(D)) {
            var F = K[D].AM(0);
            for (l = 0; l < K.length; l++) if (l !== D && K[l].o["sync-zero"] && K[l].FX <= 0 && K[l].H4 >= 0 && K[l].TM) {
              var I = K[l].AM(0);
              if (ZC._a_(I - F) >= 1) for (var x = !0, y = 0; x;) I > F ? K[l].CO ? K[l].AW ? K[l].AB += 1 : K[l].BV += 1 : K[l].AW ? K[l].BV += 1 : K[l].AB += 1 : K[l].CO ? K[l].AW ? K[l].BV += 1 : K[l].AB += 1 : K[l].AW ? K[l].AB += 1 : K[l].BV += 1, y++, K[l].H0(), K[l].T9(), (y > (K[l].CO ? o.P.I : o.P.F) || ZC._a_(K[l].AM(0) - F) < 1) && (x = !1);
            }
          }
        }
        for (l = 0, r = o.BO.length; l < r; l++) o.BO[l].Z = o.BO[l].C7 = o.H.usc() ? o.H.mc() : ZC.AK(o.K + "-scales-bl-0-c"), o.A.OI = !0, o.BO[l].paint(), o.A.Y2(), o.A.OI = !1;
        var X = typeof o.E["shared-zoom"] !== ZC._[31] && null !== ZC._n_(o.E["shared-zoom"]) && o.E["shared-zoom"];
        if (o.B9 && o.B9.LW ? o.B9.IP && (o.B9.IP = !0, o.B9.paint()) : o.E["skip-preview"] || !o.B9 || o.VR && !o.B9.IP || X || (o.B9.IP = !0, o.B9.paint()), o.E["shared-zoom"] = null, o.E["skip-preview"] = null, o.HZ && o.HZ.paint(), o.HY && o.HY.paint(), o.VR || (n = o.H.usc() ? o.H.mc() : ZC.AK(o.K + "-titles-c"), o.IZ && o.IZ.AN && null !== ZC._n_(o.IZ.AO) && (o.IZ.Z = o.IZ.C7 = n, o.IZ.paint(), !o.IZ.KE && ZC.AK(o.A.K + "-map") && (ZC.AK(o.A.K + "-map").innerHTML += ZC.AQ.OG(o.K, o.IZ))), o.K6 && o.K6.AN && null !== ZC._n_(o.K6.AO) && (o.K6.Z = o.K6.C7 = n, o.K6.paint(), !o.K6.KE && ZC.AK(o.A.K + "-map") && (ZC.AK(o.A.K + "-map").innerHTML += ZC.AQ.OG(o.K, o.K6))), o.N4 && o.N4.AN && null !== ZC._n_(o.N4.AO) && (o.N4.Z = o.N4.C7 = n, o.N4.paint(), !o.N4.KE && ZC.AK(o.A.K + "-map") && (ZC.AK(o.A.K + "-map").innerHTML += ZC.AQ.OG(o.K, o.N4))), o.SI && o.SI.AN && null !== ZC._n_(o.SI.AO) && (o.SI.Z = o.SI.C7 = n, o.SI.paint())), o.IZ && o.IZ.ED(), o.K6 && o.K6.ED(), o.N4 && o.N4.ED(), o.AJ["3d"] || o.TB(), o.A.OI = !o.GI, zingchart.DEV.SKIPTRACKERS && (o.A.OI = !1), o.A.E["graph." + o.K + ".disableanimation"]) for (l = 0, r = o.AY.A4.length; l < r; l++) o.AY.A4[l].GI = !1;
        o.AY.paint(), o.H.paintHistory();
      }
    }, {
      key: "TB",
      value: function TB() {}
    }, {
      key: "clearPreview",
      value: function clearPreview() {
        var e = this;
        e.B9 && (ZC.Q.IT(ZC.AK(e.K + "-preview-c"), e.A.AA, e.iX, e.iY, e.I, e.F, e.K), e.A.H3 && !e.A.H3.A11 && e.B9.reset(), e.B9.IP = !0);
      }
    }, {
      key: "flatten",
      value: function flatten() {}
    }, {
      key: "_end_",
      value: function _end_() {
        var e,
          t,
          i,
          a,
          n = this;
        for (n.E["toggle-action-remove"] = null, n.GI || n.A.Y2(), n.A.OI = !1, (n.LW || !n.GI || n.H.E["graph." + n.K + ".disableanimation"] || !n.AJ[ZC._[55]] || -1 !== ZC.AV(n.H.L0, ZC._[41]) || zingchart.SKIP.ANIMATION) && (n.MK = "ready"), "initial" === n.A25 && (n.ABW = !1, n.H.E["graph." + n.K + ".disableanimation"] = !0), t = 0, i = n.BO.length; t < i; t++) n.BO[t].paint_();
        if (!n.A.E["fire-load"]) {
          var l = ZC.AQ.BZ("objectsinit", n.A, n.GR(), !0);
          if (l) for (var r = [ZC._[10], "shapes", "imges", "arrows"], o = 0; o < r.length; o++) l[r[o]] && (n.o[r[o]] = (n.o[r[o]] || []).concat(l[r[o]]));
        }
        function s(e) {
          var t,
            i,
            a = (e.targetid || e.target.id).replace("-area-path", "").replace("-path", "").replace(/--([a-zA-Z0-9]+)/, "").replace("-marker", "").replace("-circle", "").split("-").reverse();
          return "node" === a[1] && (t = a[2], i = a[0]), [t, i];
        }
        if (n.AJ["3d"] || (n.flatten(), n.PH(), n.JW(), -1 === ZC.AV(n.H.L0, ZC._[41]) && n.Q7()), -1 === ZC.AV(n.H.L0, ZC._[41])) {
          var C = ZC.A5("." + n.K + "-node-area");
          n.XL = function (e) {
            if (!(zingchart.NODE_EV && "mouseover" === zingchart.NODE_EV_TYPE && "mouseover" === e.type || (zingchart.NODE_EV_CHART = n.A.K, zingchart.NODE_EV = e, zingchart.NODE_EV_TYPE = e.type, ZC.move || n.BC && n.BC.ZE || -1 === ZC.Q.TG(e.target).indexOf("zc-node-area") || "ready" !== n.MK))) {
              ZC.mobile && (n.E["node-target-id"] = e.target.id, ZC.move = !1, n.H.hideCM(), null === n.H.DE || null === ZC._n_(n.H.DE["page-scroll"]) || n.H.DE["page-scroll"] || e.preventDefault(), n.A.W8(e));
              var a = s(e);
              if (n.AY.A4[a[0]]) {
                var l = n.AY.A4[a[0]].FK(a[1]);
                if (l && (l.N ? (ZC.COLORS = [l.N.C2, l.N.A0, l.N.AE, l.N.BW, l.N.B7], l.NM && ZC.COLORS.push(l.NM.A0, l.NM.AE, l.NM.BW, l.NM.B7)) : ZC.COLORS = [], n.E["plot" + a[0] + ".visible"])) {
                  var r = ZC.mobile ? "mousedown" : e.xtype || e.type;
                  (ZC.mobile || r !== ZC._[47]) && n.A.A7 && n.A7 && n.A7.AN && n.A.A7.onmouseover(e);
                  var o = n.AY.A4[a[0]];
                  if ("plot" === o.A3Y) for (t = 0, i = o.S.length; t < i; t++) o.S[t] && o.FK(t).HT("hover");else l.HT("hover");
                  if (l.P1(e, r), l.A.UP(e, r), n.BC) {
                    ZC.move = !0;
                    var C = a[0];
                    n.AY.A4[C].o["legend-item"] && null !== ZC._n_(n.AY.A4[C].o["legend-item"].order) && (C = ZC._i_(n.AY.A4[C].o["legend-item"].order)), n.BC.o["reverse-series"] && (C = n.AY.A4.length - 1 - C), n.BC.Q3 ? n.L === n.A.AG.length - 1 && n.BC.highlightItem(C) : n.BC.highlightItem(C), ZC.move = !1;
                  }
                }
              }
            }
          }, C.live("mousedown mouseover touchstart", n.XL), n.A29 = function (e) {
            if (zingchart.NODE_EV = zingchart.NODE_EV_TYPE = null, zingchart.NODE_EV_CHART = null, !(ZC.move || n.BC && n.BC.ZE)) {
              var t = e.target;
              if (ZC.mobile && document.elementFromPoint) {
                var i = ZC.Q.MM(e),
                  a = Math.max(window.pageXOffset, document.documentElement.scrollLeft, document.body.scrollLeft),
                  l = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
                if ((t = document.elementFromPoint(i[0] - a, i[1] - l)) && n.E["node-target-id"] && n.E["node-target-id"] !== t.id) return;
              }
              if (-1 !== ZC.Q.TG(e.target).indexOf("zc-node-area") && "ready" === n.MK) {
                ZC.mobile && n.A.P7(e);
                var r = s(e),
                  o = n.AY.A4[r[0]].FK(r[1]);
                if (o) {
                  if (n.E["plot" + r[0] + ".visible"]) {
                    n.A.A7 && n.A7 && n.A7.AN && n.A.A7.onmouseout(e), n.AY.A4[r[0]].D = [], o.KW(), n.KW();
                    var C = ZC.mobile ? "mouseup" : e.xtype || e.type;
                    o.P1(e, C), o.A.UP(e, C), n.BC && (ZC.move = !0, n.BC.Q3 ? n.L === n.A.AG.length - 1 && n.BC.highlightItem(-1) : n.BC.highlightItem(-1), ZC.move = !1);
                  }
                  !ZC.mobile || n.H.A9Y || ZC.move || "touchend" !== e.type || (zingchart.SN(e), n.TU(e));
                }
              }
            }
          }, C.live("mouseup mouseout touchend", n.A29), n.A1D = function (e) {
            if (zingchart.NODE_EV = e, zingchart.NODE_EV_CHART = n.A.K, zingchart.NODE_EV_TYPE = e.type, -1 !== ZC.Q.TG(e.target).indexOf("zc-node-area") && "ready" === n.MK) {
              ZC.mobile && n.A.P7(e);
              var t = s(e);
              n.E["plot" + t[0] + ".visible"] && n.A.A7 && n.A7 && n.A7.AN && n.A.A7.onmousemove(e);
            }
          }, C.live("mousemove touchmove", n.A1D), n.TU = function (e) {
            if ((e.targetid || -1 !== ZC.Q.TG(e.target).indexOf("zc-node-area")) && "ready" === n.MK) {
              var t = s(e),
                i = n.AY.A4[t[0]].FK(t[1]);
              if (i && ("none" === i.A.J7 || !ZC.mobile && 0 !== e.button || (n.A.E[ZC._[53]] = !0, n.clearPreview(), n.A1X(i.A.L, i.L)), i.P1(e, "click"), i.A.UP(e, "click"), null !== ZC._n_(i.A.E8) && "NULL" !== i.A.E8)) if (i.A.E8 instanceof Array) for (var a = 0; a < i.A.E8.length; a++) {
                var l = i.A.FF;
                i.A.FF instanceof Array && (l = i.A.FF[a] || "graph=" + (n.o.id || "")), a === i.L && n.UI(e, i.ES(i.A.E8[a], null, null, !0), l);
              } else n.UI(e, i.ES(i.A.E8, null, null, !0), i.A.FF || "graph=" + (n.o.id || ""));
            }
          }, n.A2D = function (e) {
            if (-1 !== ZC.Q.TG(e.target).indexOf("zc-node-area") && "ready" === n.MK) {
              var t = s(e),
                i = n.AY.A4[t[0]].FK(t[1]);
              i && (i.P1(e, "doubleclick"), i.A.UP(e, "doubleclick"));
            }
          }, ZC.mobile || C.live("click", n.TU).live("contextmenu", n.TU).live("dblclick", n.A2D);
        }
        if (n.A7Z(), n.A.E["tr-ev-" + n.L] ? (n.A.E["tr-ev-" + n.L] = null, n.A3P()) : n.A3P(), n.A1P) {
          n.A1P = !1;
          var A = {
            graphid: n.K
          };
          for (t = 0, i = n.BT("k").length; t < i; t++) {
            var Z = n.BT("k")[t];
            null !== ZC._n_(e = Z.KT) && (A["zoomx" + (a = 1 === Z.L ? "" : "-" + Z.L)] = !0, A["xmin" + a] = e[0], A["xmax" + a] = e[1]);
          }
          for (t = 0, i = n.BT("v").length; t < i; t++) {
            var c = n.BT("v")[t];
            null !== ZC._n_(e = c.KT) && (A["zoomy" + (a = 1 === c.L ? "" : "-" + c.L)] = !0, A["ymin" + a] = e[0], A["ymax" + a] = e[1]);
          }
          if (A.zoomto = !0, n.A.G3) {
            for (var p in n.A.G3) ZC.AK(p).appendChild(n.A.G3[p]);
            n.A.G3 = null;
          }
          n.A.PP(A);
        }
      }
    }, {
      key: "A7Z",
      value: function A7Z() {}
    }, {
      key: "A3P",
      value: function A3P() {
        var e = this;
        if (e.A.A2L < e.A.AG.length && (e.A.A2L++, ZC.AQ.BZ("gload", e.A, e.GR())), ZC.AQ.BZ("gcomplete", e.A, e.GR()), e.B9 && (e.B9.IP = !1), zingchart.NODE_EV && zingchart.NODE_EV_CHART && zingchart.NODE_EV_CHART === e.A.K) {
          var t = ZC.A5("#" + e.A.K + "-top"),
            i = ZC.E0[0] - t.offset().left,
            a = ZC.E0[1] - t.offset().top,
            n = zingchart.exec(e.A.K, "getxyinfo", {
              x: i,
              y: a
            });
          if (n) for (var l = 0; l < n.length; l++) if ("node" === n[l].infotype && n[l].xydistance < 10) {
            var r = n[l].graphid + ZC._[35] + n[l].plotidx + "-node-" + n[l].nodeidx;
            zingchart.NODE_EV && zingchart.NODE_EV.target && zingchart.NODE_EV.target.id === r && (e.XL(zingchart.NODE_EV), zingchart.NODE_EV = null);
          }
        }
        zingchart.GUIDE_EV && e.A.D6 && e.A.D6.QN(zingchart.GUIDE_EV), e.A.A5A < e.A.AG.length ? e.A.A5A++ : (e.A.A5A = 1, e.A.A2L === e.A.AG.length && (e.A.A2L++, e.A.E["fire-load"] = !0, e.LW && e.AY.A4.length > 1 && (zingchart.SKIP.EVENT || ZC.AQ.BZ("load", e.A, e.A.F5()))), e.A.E["fire-complete"] = !0, (e.E["graph-JY"] || e.LW && e.AY.A4.length > 1) && (zingchart.SKIP.EVENT || ZC.AQ.BZ("complete", e.A, e.A.F5()), e.E["graph-JY"] = null)), 0 !== e.A.QW.length && e.A.QW[e.A.QW.length - 1] === e.A.E.json || (e.A.QW[e.A.OB] !== e.A.E.json && (e.A.QW.length = e.A.OB + 1), e.A.QW[e.A.OB] = e.A.E.json);
      }
    }, {
      key: "JY",
      value: function JY(e, t) {
        var i = this;
        null === ZC._n_(e) && (e = !1), null === ZC._n_(t) && (t = !1), i.A.MU(i), i.E["graph-JY"] = !0, i.clear(e, t), i.parse(), i.UU && i.UU(), i.paint(e), i.B9 && i.B9.setScalesInfo(), i.HO = !1, zingchart.SKIP.CSV = !1;
      }
    }, {
      key: "UI",
      value: function UI(ev, E8, FF) {
        if (2 !== ev.button) {
          var s = this,
            C,
            PI = [""];
          switch (null !== ZC._n_(FF) && (PI = FF.split("=")), PI[0]) {
            case "_blank":
              window.open(E8, "_blank");
              break;
            case "_top":
              window.top.location.href = E8;
              break;
            case "_parent":
              window.parent.location.href = E8;
              break;
            case "window":
              null !== ZC._n_(PI[1]) && "" !== PI[1] && (window.top[PI[1]].location.href = E8);
              break;
            case "graph":
              var YM = null;
              if ("()" === E8.substring(E8.length - 2) || "javascript:" === E8.substring(0, 11)) try {
                var EA = E8.replace("javascript:", "").replace("()", "");
                eval(EA) && (YM = eval(EA).call(s));
              } catch (e) {}
              null !== ZC._n_(PI[1]) && "" !== PI[1] ? "_top" === PI[1] || "_parent" === PI[1] ? (s.A.MU(), YM ? zingchart.exec(s.A.K, "setdata", {
                data: YM
              }) : s.A.load(null, E8)) : (C = s.A.OJ(PI[1]), C && (s.A.MU(C), s.A.E["tr-ev-" + C.L] = !0, s.A.OB++, YM ? zingchart.exec(s.A.K, "setdata", {
                graphid: PI[1],
                data: YM
              }) : s.A.load(PI[1], E8))) : (C = s.A.AG[0], s.A.MU(C), YM ? zingchart.exec(s.A.K, "setdata", {
                graphid: C.K,
                data: YM
              }) : (s.A.E["tr-ev-" + C.L] = !0, s.A.OB++, s.A.load(C.K, E8)));
              break;
            default:
              window.location.href = E8;
          }
        }
      }
    }, {
      key: "HW",
      value: function HW(e, t, i) {
        var a = this;
        if (null === ZC._n_(i) && (i = a.AY.A4.length - 1), null !== ZC._n_(e) && typeof e !== ZC._[31]) return a.AY.A4[e];
        if (null === ZC._n_(t) || typeof t === ZC._[31]) return a.AY.A4[i];
        for (var n = 0, l = a.AY.A4.length; n < l; n++) if (t === a.AY.A4[n].HB) return a.AY.A4[n];
        return null;
      }
    }, {
      key: "Z2",
      value: function Z2(e, t) {
        var i,
          a,
          n = this;
        (e = e || {})[ZC._[54]] = e[ZC._[54]] || n.getToggleAction();
        var l = null;
        if (typeof e.plotindex !== ZC._[31] && (l = ZC._i_(e.plotindex)), -1 === l) for (l = [], i = 0, a = n.AY.A4.length; i < a; i++) l.push(i);
        l instanceof Array || (l = [l]);
        var r = e.plotid || "";
        r instanceof Array || (r = [r]);
        var o = [];
        for (i = 0, a = ZC.BQ(l.length, r.length); i < a; i++) {
          var s = n.HW(l[i], r[i]);
          if (s) {
            var C = {};
            ZC._cp_(e, C);
            var A = s.L;
            C.plotindex = A, C.plotid = s.HB, ("show" === t && !n.E["plot" + A + ".visible"] || "hide" === t && n.E["plot" + A + ".visible"]) && o.push(C);
          }
        }
        for (i = 0, a = o.length; i < a; i++) n.A.o[ZC._[16]][n.L][ZC._[11]][o[i].plotindex].visible = "show" === t, i === a - 1 && (o[i].JY = 1), n.PB(o[i]);
      }
    }, {
      key: "PB",
      value: function PB(e) {
        var t,
          i,
          a,
          n = this;
        n.A.E["graph." + n.K + ".disableanimation"] = !1, e = e || {};
        var l = !1;
        null !== ZC._n_(e.skip) && e.skip && (l = !0), null === ZC._n_(e.update) || e.update || (l = !0);
        var r = !1;
        e[ZC._[54]] = e[ZC._[54]] || n.getToggleAction(), null !== ZC._n_(t = e["ignore-legend"]) && (r = ZC._b_(t));
        var o = n.HW(e.plotindex, e.plotid);
        if (o) {
          var s = o.L;
          switch (e[ZC._[54]]) {
            case "hide":
              if (n.BC && (n.BC.E.showhide = !0), n.E["plot" + s + ".visible"] = !n.E["plot" + s + ".visible"], null !== ZC._n_(n.A.o[ZC._[16]][n.L][ZC._[11]]) && (n.A.o[ZC._[16]][n.L][ZC._[11]][s].visible = n.E["plot" + s + ".visible"]), n.AJ["3d"]) r = !0, l || n.JY();else {
                var C = n.E["plot" + s + ".visible"] ? "block" : "none";
                if (zingchart.DEV.SKIPTRACKERS || ZC.A5("." + n.K + ZC._[35] + s + "-node-area").each(function () {
                  if ("AREA" === this.tagName.toUpperCase()) {
                    var e = ZC.A5(this),
                      t = e.attr("coords"),
                      a = e.attr("shape");
                    "none" === C ? (t = "-" + t.replace(/,/g, ",-"), "rect" === a ? 4 === (i = t.split(",")).length && (t = [i[2], i[3], i[0], i[1]].join(",")) : "circle" === a && 3 === (i = t.split(",")).length && (t = [i[0], i[1], -i[2]].join(","))) : (t = t.replace(/\-/g, ""), "rect" === a && 4 === (i = t.split(",")).length && (t = [i[2], i[3], i[0], i[1]].join(","))), e.attr("coords", t);
                  }
                }), n.A.KE) ZC.AK(n.K + "-plots-bl-c").style.display = C, ZC.AK(n.K + "-plots-fl-c").style.display = C, ZC.AK(n.K + "-plots-vb-c").style.display = C;else {
                  for (a = 0; a < o.T1; a++) (t = ZC.AK(n.K + "-plot-" + s + "-bl-" + a + "-c")) && (t.style.display = C);
                  for (a = 0; a < o.A20; a++) (t = ZC.AK(n.K + "-plot-" + s + "-fl-" + a + "-c")) && (t.style.display = C);
                  (t = ZC.AK(n.K + "-plot-" + s + "-vb-c")) && (t.style.display = C);
                }
                var A = ZC.A5("." + n.K + "-plot-" + s + "-value-box");
                n.E["plot" + s + ".visible"] ? (A.show(), ZC.A5("." + n.K + ZC._[35] + s + "-preview").show()) : (A.hide(), ZC.A5("." + n.K + ZC._[35] + s + "-preview").hide());
              }
              break;
            case "remove":
              n.clearPreview(), r = !0, n.E["toggle-action-remove"] = !0, n.E["plot" + s + ".visible"] = !n.E["plot" + s + ".visible"], e.JY && (l || (n.LJ("on-legend-toggle"), n.JY(!0, !0)));
          }
          n.BC && !r && (n.BC.clear(), n.BC.paint());
        }
      }
    }, {
      key: "LJ",
      value: function LJ(e) {
        var t = this,
          i = !0,
          a = t.o.plot || {};
        null !== ZC._n_(a.animation) && null !== ZC._n_(a.animation[e]) && (i = ZC._b_(a.animation[e])), t.HO = "initial" === t.A25 || !i;
      }
    }, {
      key: "GR",
      value: function GR() {
        return {
          id: this.A.K,
          graphidx: this.L,
          graphid: this.K.replace(this.A.K + "-graph-", ""),
          x: this.iX,
          y: this.iY,
          width: this.I,
          height: this.F,
          loader: this.A.F5()
        };
      }
    }, {
      key: "QS",
      value: function QS() {}
    }, {
      key: "QO",
      value: function QO() {}
    }, {
      key: "gc",
      value: function gc() {
        for (var e = 0; e < this.BO.length; e++) this.BO[e].gc();
        for (var t = 0; t < this.AY.A4.length; t++) this.AY.A4[t].gc();
        ZC.AQ.gc(this.AY, ["A", "C", "H", "F9", "o", "ID", "JG"]), ZC.AQ.gc(this, ["Z", "C7", "AJ", "IZ", "K6", "N4", "EZ"]);
      }
    }]);
    return K2;
  }(I3);
  K2.prototype.PH = function () {
    var e,
      t,
      i,
      a,
      n,
      l,
      r,
      o,
      s = this;
    s.initObjectsLayers(), s.BY = [], s.FJ = [], s.Z0 = [], s.LS = [], s.FE = [], s.XW = {};
    var C,
      A,
      Z,
      c = s.A.B8,
      p = "(" + s.AF + ")";
    if (null !== ZC._n_(C = s.o[ZC._[10]])) for (t = 0, i = C.length; t < i; t++) {
      C[t].id || (C[t].id = "lbl_" + t + "_" + ZC._r_(1e3, 9999)), a = C[t].id || t, n = !1, l = !1, s.E["objects.updates"] && -1 === ZC.AV(s.E["objects.updates"], a) && (n = !0, l = !0), C[t].tween && (n = !0);
      var u = zingchart.pool.getInstance("DT", s, s.K + "-label-" + a, n);
      if (!l || !u._POOL_) {
        if (c.load(u.o, p + ".label"), u.append(C[t]), null !== ZC._n_(e = u.o.parent)) for (var h = 0; h < s.BY.length; h++) if ("" + s.BY[h].HB == "" + e) {
          u.E["p-x"] = s.BY[h].iX, u.E["p-y"] = s.BY[h].iY, u.E["p-width"] = s.BY[h].I, u.E["p-height"] = s.BY[h].F;
          break;
        }
        if (u.HB = a, u.K = s.K + "-label-" + a, u.GO = s.K + "-label zc-label", null !== ZC._n_(e = C[t].hook) && (u.E.hook = e), u.ES = function (t) {
          if (!t || -1 === ("" + t).indexOf("%")) return t;
          t = "" + t;
          var i,
            a = [];
          a.push(["%id", s.A.K]), a.push(["%graphid", s.K.replace(s.A.K + "-graph-", "")]);
          var n = s.E.update;
          for (var l in n) a.push(["%" + l, n[l]]);
          a.sort(ZC.A2G);
          for (var r = 0, o = a.length; r < o; r++) i = new RegExp(a[r][0], "g"), t = t.replace(i, a[r][1]);
          var C,
            A,
            Z,
            c,
            p = u.o["default-value"] || " ";
          for (i = new RegExp("(%plot-([0-9]+?)-value(-*)([0-9]*?))|(%plot-value-([0-9]+?))|(%plot-value)|(%npv)|(%node-percent-value)", "g"), t = t.replace(i, p), i = new RegExp("%plot-([0-9]+?)-data-([a-zA-Z0-9-]+)", "g"), t = t.replace(i, p), i = new RegExp("\\((.+?)\\)\\(([0-9]*)\\)\\(([0-9]*)\\)"); C = i.exec(t);) if ("%node-value" === C[1]) {
            A = "";
            var h = 0,
              _ = 0;
            "" !== (e = C[2]) && (h = ZC._i_(e)), "" !== (e = C[3]) && (_ = ZC._i_(e)), (c = s.AY.A4[h]) && (Z = c.FK(_, 3)) && (A = Z.ES(C[1])), t = t.replace(C[0], A);
          }
          return t;
        }, u.parse(), C[t]["3d"]) {
          var _ = new CC(s, u.iX + u.I / 2 - ZC.AP.E2, u.iY + u.F / 2 - ZC.AP.E1, ZC._i_(C[t].z || "0"));
          u.iX = _.EC[0] - u.I / 2, u.iY = _.EC[1] - u.F / 2;
        }
      }
      s.BY.push(u), s.FE.push({
        type: "label",
        index: t,
        zindex: u.JX
      }), s.XW[a] = {
        shape: "label",
        idx: t
      };
    }
    if (null !== ZC._n_(A = s.o.arrows)) for (t = 0, i = A.length; t < i; t++) {
      var d = new ACI(s);
      c.load(d.o, p + ".arrow"), d.append(A[t]), a = A[t].id || t, d.K = s.K + "-arrow-" + a, d.parse(), s.Z0.push(d), s.FE.push({
        type: "arrow",
        index: t,
        zindex: d.JX
      });
    }
    var f,
      g = 0;
    if (null !== ZC._n_(Z = s.o.shapes)) for (t = 0, i = Z.length; t < i; t++) if (null === ZC._n_(Z[t].type) || 0 !== Z[t].type.indexOf("zingchart.")) {
      var B, v, m;
      if (Z[t].id || (Z[t].id = "shp_" + t + "_" + ZC._r_(1e3, 9999)), a = Z[t].id || t, l = null !== ZC._n_(zingchart.pool[s.K + "-shape-" + a]) && zingchart.SKIP.PARSE3D, n = !1, s.E["objects.updates"] && -1 === ZC.AV(s.E["objects.updates"], a) && (n = !0, l = !0), Z[t].tween && (n = !0), Z[t]["3d"] ? ((r = zingchart.pool.getInstance("DW", s, s.K + "-shape-" + a, !0)).o = Z[t], ("poly" !== Z[t].type || Z[t]["map-item"]) && (l = !1)) : (null !== ZC._n_(Z[t].label) ? (r = zingchart.pool.getInstance("QZ", s, s.K + "-shape-" + a, n)).X3 = Z[t] : ((r = zingchart.pool.getInstance("DW", s, s.K + "-shape-" + a, n)).o = Z[t], r.append({}, !0)), n && r._POOL_ || (l = !1)), l || (r.HB = a, r.K = s.K + "-shape-" + a, r.OI = !0, Z[t]["map-item"] && (r.OI = !1), r.parse()), null !== ZC._n_(e = Z[t].hook) && (r.E.hook = e), Z[t]["3d"]) {
        if (Z[t]["map-item"]) {
          for (B = [], v = 0, m = r.D.length; v < m; v++) null !== r.D[v] ? (o = new CC(s, r.D[v][0] - ZC.AP.E2, r.D[v][1] - ZC.AP.E1, ZC._i_(r.D[v][2] || Z[t].z || "0")), B.push(o.EC)) : B.push(null);
          r.D = B, s.FJ.push(r), s.FE.push({
            type: "shape",
            index: g,
            zindex: r.JX,
            z3d: o.AB4
          }), s.XW[a] = {
            shape: r.DQ,
            idx: g
          };
        } else if ("poly" === Z[t].type) {
          var b = ZC.DH.D7(r, s, Z[t].points, !1);
          s.CJ.add(b), s.FJ.push(null);
        } else {
          if (r.D.length > 0) {
            for (B = [], v = 0, m = r.D.length; v < m; v++) o = new CC(s, r.D[v][0] - ZC.AP.E2, r.D[v][1] - ZC.AP.E1, ZC._i_(r.D[v][2] || Z[t].z || "0")), B.push(o.EC);
            r.D = B;
          } else o = new CC(s, r.iX - ZC.AP.E2, r.iY - ZC.AP.E1, ZC._i_(Z[t].z || "0")), r.iX = ZC._i_(o.EC[0]), r.iY = ZC._i_(o.EC[1]);
          s.FJ.push(r), s.FE.push({
            type: "shape",
            index: g,
            zindex: r.JX,
            z3d: o.AB4
          });
        }
        r.E["3dtx"] = !0, r.E["3d"] = !0;
      } else s.FJ.push(r), r instanceof QZ ? (s.FE.push({
        type: "shape",
        index: g,
        zindex: r.BF.JX
      }), s.XW[a] = {
        shape: r.BF.DQ,
        idx: g
      }) : (s.FE.push({
        type: "shape",
        index: g,
        zindex: r.JX
      }), s.XW[a] = {
        shape: r.DQ,
        idx: g
      });
      g++;
    }
    if (null !== ZC._n_(f = s.o.images)) for (t = 0, i = f.length; t < i; t++) {
      var E = f[t].src;
      if (ZC.cache.data[E]) {
        var K = new I3(s);
        K.append({
          "background-repeat": "no-repeat",
          "background-image": E,
          width: ZC.cache.data[E].width,
          height: ZC.cache.data[E].height
        }), K.append(f[t]), a = f[t].id || t, K.HB = a, K.K = s.K + "-image-" + a, K.L = t, K.parse(), s.LS.push(K), s.FE.push({
          type: "image",
          index: t,
          zindex: K.JX
        });
      }
    }
    s.E["objects.updates"] = null, s.FE = s.FE.sort(function (e, t) {
      return null !== ZC._n_(e.z3d) && null !== ZC._n_(t.z3d) ? e.z3d - t.z3d > 0 ? 1 : -1 : 0;
    }), s.FE = s.FE.sort(function (e, t) {
      return e.zindex - t.zindex == 0 ? e.index - t.index : e.zindex - t.zindex;
    });
  }, K2.prototype.Y8 = function (e, t) {
    typeof e === ZC._[31] && (e = !1), typeof t === ZC._[31] && (t = !1);
    var i,
      a = this,
      n = [a.K + "-objects-bottom-sh-c", a.K + "-objects-bottom-c", a.K + "-objects-top-sh-c", a.K + "-objects-top-c", a.K + "-objects-front-c", a.K + "-objects-print-c"];
    ZC.SKIPMAPS || n.push(a.K + "-objects-maps-sh-c", a.K + "-objects-maps-c");
    for (var l = 0; l < n.length; l++) (i = ZC.AK(n[l])) && ZC.Q.IT(i, a.H.AA, a.iX, a.iY, a.I, a.F, a.K);
    "canvas" === a.A.AA && !zingchart.CANVASTEXT && ZC.objmove || (ZC.A5("." + a.K + "-label").remove(), ZC.A5("." + a.K + "-shape-label").remove(), ZC.A5("." + a.K + "-arrow-label").remove()), e || (ZC.A5("." + a.K + "-label-area").each(function () {
      if (-1 === ZC.AV([a.K + "-title-area", a.K + "-subtitle-area", a.K + "-source-area"], this.id)) {
        var e = new RegExp("scale_(x|y|k|v)-(item_|marker_)([0-9]+)").exec(this.id);
        !t && e && e.length || ZC.Q.EU(this.id);
      }
    }), ZC.A5("." + a.K + "-shape-area").each(function () {
      (!ZC.SKIPMAPS || ZC.SKIPMAPS && "1" !== this.getAttribute("data-map")) && ZC.Q.EU(this.id);
    }), ZC.A5("." + a.K + "-arrow-area").remove()), "svg" === a.A.AA && ZC.A5("#" + a.A.K + "-svg").children().each(function () {
      var e = a.K + "-label-";
      "clippath" === this.tagName.toLowerCase() && this.id.substring(0, e.length) === e && ZC.Q.EU(this.id);
    });
  }, K2.prototype.A8M = function () {
    var e = this;
    (e.H.O4["objects-top"] || e.H.O4["objects-bottom"]) && (ZC.A5("." + e.K + "-label-area").die(ZC.mobile ? "touchstart" : "mousedown mouseover", e.A0J).die(ZC.mobile ? "touchend" : "mouseup mouseout", e.A19).die(ZC.mobile ? "touchmove" : ZC._[48], e.A0K), ZC.mobile || ZC.A5("." + e.K + "-label-area").die("click", e.VC).die("dblclick", e.VC), ZC.A5("." + e.K + "-shape-area").die(ZC.mobile ? "touchstart" : "mousedown mouseover", e.A0M).die(ZC.mobile ? "touchend" : "mouseup mouseout", e.A17).die(ZC.mobile ? "touchmove" : ZC._[48], e.A0P), ZC.mobile || ZC.A5("." + e.K + "-shape-area").die("click", e.V4).die("dblclick", e.V4));
  }, K2.prototype.OA = function () {
    var e,
      t,
      i,
      a,
      n = this;
    if (n.ZL = !1, null !== ZC._n_(i = n.o[ZC._[10]])) for (e = 0, t = i.length; e < t; e++) {
      var l = "" + (i[e].text || "");
      if (-1 !== l.indexOf("%node-") || -1 !== l.indexOf("%plot-") || -1 !== l.indexOf("%npv") || -1 !== l.indexOf("%node-percent-value") || ZC._b_(i[e].dynamic)) {
        n.ZL = !0;
        break;
      }
    }
    if (null !== ZC._n_(a = n.o.shapes)) for (e = 0, t = a.length; e < t; e++) if (ZC._b_(a[e].dynamic)) {
      n.ZL = !0;
      break;
    }
  }, K2.prototype.Q1 = function (e) {
    var t = this;
    t.Y8(e), t.PH(), t.JW(e), ZC.SKIPMAPS = !1;
  }, K2.prototype.JW = function (e) {
    typeof e === ZC._[31] && (e = !1);
    var t,
      i,
      a,
      n = this,
      l = [],
      r = [];
    function o(e) {
      var t = n.Z0[e];
      if (t.AN && (t.Z = t.C7 = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-" + (t.JX < 0 ? "bottom" : "top") + "-c"), t.paint(), t.AN && ZC.AK(n.A.K + "-map"))) {
        var i = t.BF.A27(),
          a = ZC.Q.G2(i[0], t.BF.E8, t.BF.J3) + 'class="' + n.K + '-arrow-area zc-arrow-area" id="' + t.BF.K + '-area" coords="' + i[1] + '" />';
        "top" === t.o[ZC._[7]] ? r.push(a) : l.push(a);
      }
    }
    function s(e) {
      if (n.FJ[e]) {
        var i = n.FJ[e],
          a = i instanceof QZ ? i.BF : i;
        if ((!ZC.SKIPMAPS || !a.o["map-item"]) && a.AN) {
          if (null !== ZC._n_(t = i.E.hook)) {
            var o = n.OL(t);
            -1 !== o[0] && (a.iX = ZC._i_(o[0])), -1 !== o[1] && (a.iY = ZC._i_(o[1]));
          }
          if (!i.E["3d"] || i.E["3dtx"]) {
            i.Z = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-" + (a.JX < 0 ? "bottom" : "top") + "-c"), i.C7 = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-" + (a.JX < 0 ? "bottom" : "top") + "-sh-c"), a.o["map-item"] && (i.Z = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-maps-c"), i.C7 = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-maps-sh-c"));
            var s = "";
            null !== ZC._n_(t = a.o.limit) && ("x" === t ? s = "x" : "y" === t ? s = "y" : "xy" === t && (s = "xy")), ("" === s || "x" === s && ZC.DR(a.iX - a.BM, n.P.iX - 2, n.P.iX + n.P.I + 2) || "y" === s && ZC.DR(a.iY - a.BH, n.P.iY - 2, n.P.iY + n.P.F + 2) || "xy" === s && ZC.DR(a.iX + a.BM, n.P.iX - 2, n.P.iX + n.P.I - 2) && ZC.DR(a.iY + a.BH, n.P.iY - 2, n.P.iY + n.P.F + 2)) && (i.WO = !1, i.E["print-canvas"] = n.K + "-" + (a.o["map-item"] ? "maps" : "objects") + ZC._[15], i.paint());
          }
          if (!i.KE && !n.QH && "normal" === zingchart.OBJECTMODE) {
            var C = a.A27();
            if (ZC.AK(n.A.K + "-map")) for (var A = 1, Z = C.length; A < Z; A++) if ("" !== C[A]) {
              var c = a.o["map-item"] && !a.o["map-skip-z-sort"] ? ' data-map="1"' : "",
                p = ZC.Q.G2(C[0], a.E8, a.J3) + 'class="' + n.K + '-shape-area zc-shape-area" id="' + a.K + "-area" + (A > 1 ? "--" + A : "") + ZC._[30] + C[A] + '" data-z-sort="' + a.AAC + '"' + c + " />";
              "top" === i.o[ZC._[7]] ? r.push(p) : l.push(p);
            }
          }
        }
      }
    }
    function C(e) {
      var t = n.LS[e];
      if (t.AN) if (t.Z = t.C7 = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-" + (t.JX < 0 ? "bottom" : "top") + "-c"), null !== ZC._n_(t.o.repeat) && ZC._b_(t.o.repeat)) {
        var i = ZC._i_(ZC._c_(t.o.items, 0)),
          a = null;
        if (t.o.inactive && ((a = new I3(t.A)).copy(t), a.append(t.o.inactive), a.parse(), a.Z = a.C7 = t.Z), i > 0 || a) {
          var l = ZC._i_(ZC._c_(t.o.rows, -1)),
            r = ZC._i_(ZC._c_(t.o.cols, -1)),
            o = ZC._i_(ZC._c_(t.o["space-x"], 0)),
            s = ZC._i_(ZC._c_(t.o["space-y"], 0)),
            C = ZC._i_(ZC._c_(t.o["offset-row"], 0)),
            A = ZC._i_(ZC._c_(t.o["offset-col"], 0));
          -1 !== l && -1 === r ? r = Math.ceil(i / l) : -1 === l && -1 !== r ? l = Math.ceil(i / r) : -1 === l && -1 === r && (r = Math.ceil(Math.sqrt(i)), l = Math.ceil(i / r));
          for (var Z = t.iX, c = t.iY, p = t.K, u = 0; u < l; u++) for (var h = 0; h < r; h++) t.iX = Z + h * o + u * C, t.iY = c + u * s + h * A, t.K = p + (u * r + h), u * r + h < i ? t.paint() : a && (a.iX = t.iX, a.iY = t.iY, a.K = t.K, a.paint());
        } else t.paint();
      } else t.paint();
    }
    function A(e) {
      var i = n.BY[e];
      if (i.AN) {
        if (i.E.lbltype = "label", null !== ZC._n_(t = i.E.hook)) {
          var a = n.OL(t);
          if (-1 === a[0] && -1 === a[1]) return;
          if (-1 !== a[0] && (i.iX = a[0]), -1 !== a[1] && (i.iY = a[1]), null === ZC._n_(a[2]) || i.o.anchor || null !== ZC._n_(a[2].center) && a[2].center && (i.iX -= i.I / 2, i.iY -= i.F / 2), i.o.anchor && i.setAnchor(), i.o["3d"]) {
            var o = 0;
            a[2] && a[2].z ? o = a[2].z : i.o.z && (o = ZC._i_(i.o.z));
            var s = new CC(n, i.iX + i.I / 2 - ZC.AP.E2, i.iY + i.F / 2 - ZC.AP.E1, o);
            i.iX = s.EC[0] - i.I / 2, i.iY = s.EC[1] - i.F / 2;
          }
        }
        i.iX = ZC._i_(i.iX), i.iY = ZC._i_(i.iY), i.IW = ZC.AK(n.A.K + "-text"), i.Z = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-" + (i.JX < 0 ? "bottom" : "top") + "-c"), i.C7 = n.H.usc() ? n.H.mc("top") : ZC.AK(n.K + "-objects-" + (i.JX < 0 ? "bottom" : "top") + "-sh-c");
        var C = "";
        if (null !== ZC._n_(t = i.o.limit) && ("x" === t ? C = "x" : "y" === t ? C = "y" : "xy" === t && (C = "xy")), ("" === C || "x" === C && ZC.DR(i.iX - i.BM, n.P.iX - i.I / 2 - 2, n.P.iX + n.P.I - i.I / 2 + 2) || "y" === C && ZC.DR(i.iY - i.BH, n.P.iY - i.F / 2 - 2, n.P.iY + n.P.F - i.F / 2 + 2) || "xy" === C && ZC.DR(i.iX + i.BM, n.P.iX - i.I / 2 - 2, n.P.iX + n.P.I - i.I / 2 + 2) && ZC.DR(i.iY + i.BH, n.P.iY - i.F / 2 - 2, n.P.iY + n.P.F - i.F / 2 + 2)) && (i.WO = !1, i.paint(), i.ED(ZC.AK(n.K + "-objects-print-c")), !i.KE && !n.QH && "normal" === zingchart.OBJECTMODE && ZC.AK(n.A.K + "-map"))) {
          var A = ZC.AQ.OG(n.K, i);
          "top" === i.o[ZC._[7]] ? r.push(A) : l.push(A);
        }
      }
    }
    if (n.H.clearLabelBoxes("label"), n.FE) for (i = 0, a = n.FE.length; i < a; i++) {
      var Z = n.FE[i].index;
      switch (n.FE[i].type) {
        case "arrow":
          o(Z);
          break;
        case "shape":
          s(Z);
          break;
        case "image":
          C(Z);
          break;
        case "label":
          A(Z);
      }
    }
    for (i = 0; i < n.AY.A4.length; i++) n.AY.A4[i].RX = null;
    if (!e && "normal" === zingchart.OBJECTMODE && (r.length > 0 || l.length > 0) && ZC.AK(n.A.K + "-map")) {
      if (n.A66) {
        var c = function c(e, t) {
          return -1 !== e.indexOf("data-map") && -1 !== t.indexOf("data-map") ? ZC.AQ.NC(t) - ZC.AQ.NC(e) : ZC.AQ.NC(e) - ZC.AQ.NC(t);
        };
        r.sort(c), l.sort(c);
      }
      zingchart.DEV.MAPSONBOTTOM ? window.setTimeout(function () {
        ZC.AK(n.A.K + "-map").innerHTML = r.join("") + ZC.AK(n.A.K + "-map").innerHTML + l.join("");
      }, 33) : ZC.AK(n.A.K + "-map").innerHTML = r.join("") + ZC.AK(n.A.K + "-map").innerHTML + l.join("");
    }
    n.A.E["fire-load"] || ZC.AQ.BZ("objectsready", n.A, n.GR());
  }, K2.prototype.RF = function (e, t, i, a) {
    var n,
      l,
      r,
      o,
      s = this;
    switch (i = i || "hover", e) {
      case "shape":
        var C = s.FJ[t],
          A = C instanceof QZ ? C.BF : C;
        if (null !== ZC._n_(A.o[i + "-state"])) {
          if (!a && A.o.group) for (r = 0, o = s.FJ.length; r < o; r++) r !== t && (s.FJ[r].o.group === A.o.group || s.FJ[r].BF && s.FJ[r].BF.o.group === A.o.group) && s.RF(e, r, i, !0);
          if ((n = new DW(s)).append(A.o), n.append(A.o[i + "-state"]), l = A.o.id || t, n.HB = l + "-" + i, n.K = s.K + "-shape-" + l + "-" + i, n.parse(), C.E["3d"] && (n.D = A.D, n.iX = C.iX, n.iY = C.iY), n.AN) if (n.Z = n.C7 = ZC.AK(s.K + "-objects-" + i + "-c"), n.o["map-item"] && (n.Z = n.C7 = ZC.AK(s.K + "-objects-maps-" + i + "-c")), n.o["map-item"] && zingchart.maps.LITE && "canvas" !== s.A.AA) {
            if ("svg" === s.A.AA) {
              var Z = ZC.A5("#" + s.K + "-shape-" + n.HB + "-gshape-path");
              s.E["map-shape-info"] = {
                fill: Z.attr("fill"),
                stroke: Z.attr("stroke"),
                "stroke-width": Z.attr("stroke-width")
              }, "poly" === n.DQ ? (Z.attr("fill", n.A0), Z.attr("stroke-width", n.AU), Z.attr("stroke", n.BW)) : "line" === n.DQ && (Z.attr("stroke-width", n.AZ), Z.attr("stroke", n.B7));
            } else if ("vml" === s.A.AA) {
              var c = ZC.AK(s.K + "-shape-" + n.HB + "-gshape-path"),
                p = ZC.A5(c.childNodes[1]),
                u = ZC.A5(c.childNodes[2]);
              s.E["map-shape-info"] = {
                fill: "" + u.attr("color"),
                stroke: "" + p.attr("color"),
                "stroke-width": "" + p.attr("weight")
              }, "poly" === n.DQ ? (u.attr("color", n.A0), p.attr("weight", n.AU), p.attr("color", n.BW)) : "line" === n.DQ && (p.attr("weight", n.AZ), p.attr("color", n.B7));
            }
          } else n.paint(), "canvas" === s.A.AA && zingchart.CANVASTEXT && C.M && (C.M.Z = C.M.C7 = ZC.AK(s.K + "-objects-" + i + "-c"), C.M.paint());
        }
        break;
      case "label":
        var h = s.BY[t];
        if (h && null !== ZC._n_(h.o[i + "-state"])) {
          if (!a && h.o.group) for (r = 0, o = s.BY.length; r < o; r++) r !== t && s.BY[r].o.group === h.o.group && s.RF(e, r, i, !0);
          var _ = zingchart.pool.getInstance("DT", s, s.K + "-label-" + i);
          _.append(h.o), _.append(h.o[i + "-state"]), l = h.id || t, _.HB = l + "-" + i, _.K = s.K + "-label-" + l + "-" + i, _.GO = s.K + "-label " + s.K + "-label-" + i + " zc-label zc-label-" + i, _.IW = ZC.AK(s.A.K + "-text"), _.parse(), _.AN && (_.iX = h.iX, _.iY = h.iY, _.I = h.I, _.F = h.F, _.Z = _.C7 = ZC.AK(s.K + "-objects-" + i + "-c"), ZC.AK(s.K + "-label-" + l) && (ZC.AK(s.K + "-label-" + l).style.display = "none"), _.paint());
        }
    }
  }, K2.prototype.Q7 = function () {
    var e,
      t,
      i,
      a = this;
    (a.H.O4["objects-top"] || a.H.O4["objects-bottom"]) && (a.A0M = function (e) {
      ZC.mobile && (a.KW(), ZC.move = !1, a.H.hideCM(), null === a.H.DE || null === ZC._n_(a.H.DE["page-scroll"]) || a.H.DE["page-scroll"] || e.preventDefault(), a.A.W8(e));
      var t = n(e);
      t.tooltip && a.A7 && a.A.A7 && a.A7.AN && a.A.A7.onmouseover(e);
      var i = ZC.mobile ? "mousedown" : e.xtype || e.type;
      t.lowlevel || a.RF("shape", t.shapeindex), a.QO(i, t);
    }, a.A17 = function (e) {
      ZC.mobile && (a.H.A9Y || ZC.move || (zingchart.SN(e), a.V4(e)), a.A.P7(e)), a.A7 && a.A.A7 && a.A7.AN && a.A.A7.onmouseout(e), ZC.mobile || a.KW();
      var t = ZC.mobile ? "mouseup" : e.xtype || e.type,
        i = n(e);
      if (i.shape && i.shape.mapItem && zingchart.maps.LITE && "canvas" !== a.A.AA) if ("svg" === a.A.AA) {
        var l = ZC.A5("#" + a.K + "-shape-" + i.shape.id + "-gshape-path");
        "poly" === i.shape.type && l.attr("fill", a.E["map-shape-info"].fill), l.attr("stroke", a.E["map-shape-info"].stroke), l.attr("stroke-width", a.E["map-shape-info"]["stroke-width"]);
      } else if ("vml" === a.A.AA) {
        var r = ZC.AK(a.K + "-shape-" + i.shape.id + "-gshape-path"),
          o = r.childNodes[1],
          s = r.childNodes[2],
          C = a.E["map-shape-info"];
        "poly" === i.shape.type && ZC.Q.G4(s, {
          color: C.fill
        }), ZC.Q.G4(o, {
          weight: C["stroke-width"],
          color: C.stroke
        });
      }
      a.QO(t, i);
    }, a.A0P = function (e) {
      var t = n(e);
      t.tooltip && a.A7 && a.A.A7 && a.A7.AN && a.A.A7.onmousemove(e), a.QO(ZC._[48], t);
    }, a.V4 = function (e) {
      var t = n(e);
      if ("dblclick" !== e.type) {
        e.ctrlKey || a.KW("click"), a.TT = a.TT || {}, a.TT["s_" + t.shapeid] ? (a.TT["s_" + t.shapeid] = null, a.KW("click")) : (e.ctrlKey || (a.TT = {}), a.TT["s_" + t.shapeid] = 1, a.RF("shape", t.shapeindex, "click")), a.QO("click", t);
        var i = a.FJ[t.shapeindex].BF || a.FJ[t.shapeindex];
        if (ZC.mobile && (a.E["click-ts"] && new Date().getTime() - a.E["click-ts"] < 500 && a.QO("dblclick", t), a.E["click-ts"] = new Date().getTime()), i && i.E8 && "NULL" !== i.E8) if (i.E8 instanceof Array) for (var l = 0; l < i.E8.length; l++) null !== ZC._n_(i.FF[l]) && a.UI(e, i.E8[l], i.FF[l]);else a.UI(e, i.E8, i.FF);
      } else a.QO("dblclick", t);
    }, ZC.A5("." + a.K + "-shape-area").live(ZC.mobile ? "touchstart" : "mousedown mouseover", a.A0M).live(ZC.mobile ? "touchend" : "mouseup mouseout", a.A17).live(ZC.mobile ? "touchmove" : ZC._[48], a.A0P), ZC.mobile || ZC.A5("." + a.K + "-shape-area").live("click", a.V4).live("dblclick", a.V4), a.A0J = function (e) {
      ZC.mobile && (a.KW(), ZC.move = !1, a.H.hideCM(), null === a.H.DE || null === ZC._n_(a.H.DE["page-scroll"]) || a.H.DE["page-scroll"] || e.preventDefault(), a.A.W8(e));
      var t = l(e);
      if (t.tooltip && a.A7 && a.A.A7 && a.A7.AN && a.A.A7.onmouseover(e), null !== t && "label" === t.type) {
        var i = ZC.mobile ? "mousedown" : e.xtype || e.type;
        t["data-active"] || a.RF("label", t.labelindex), a.QS(i, t);
      }
    }, a.A19 = function (e) {
      ZC.mobile && (a.H.A9Y || ZC.move || (zingchart.SN(e), a.VC(e)), a.A.P7(e)), a.A7 && a.A.A7 && a.A7.AN && a.A.A7.onmouseout(e), ZC.mobile || a.KW();
      var t = l(e);
      if (null !== t) {
        var i = ZC.mobile ? "mouseup" : e.xtype || e.type;
        ZC.AK(a.K + "-label-" + t.label.id) && (ZC.AK(a.K + "-label-" + t.label.id).style.display = "block"), a.QS(i, t);
      }
    }, a.A0K = function (e) {
      var t = l(e);
      t.tooltip && a.A7 && a.A.A7 && a.A7.AN && a.A.A7.onmousemove(e), a.QS(ZC._[48], t);
    }, a.VC = function (e) {
      var t = l(e);
      if ("dblclick" !== e.type) {
        e.ctrlKey || a.KW("click"), a.TT = a.TT || {}, a.TT["l_" + t.labelid] ? (a.TT["l_" + t.labelid] = null, a.KW("click")) : (e.ctrlKey || (a.TT = {}), a.TT["l_" + t.labelid] = 1, a.RF("label", t.labelindex, "click")), a.QS("click", t), ZC.mobile && (a.E["click-ts"] && new Date().getTime() - a.E["click-ts"] < 500 && a.QS("dblclick", t), a.E["click-ts"] = new Date().getTime());
        var i = a.BY[t.labelindex];
        if (!i) switch (t.type) {
          case "graph-title":
            i = {
              E8: a.IZ.E8,
              FF: a.IZ.FF
            };
            break;
          case "graph-subtitle":
            i = {
              E8: a.K6.E8,
              FF: a.K6.FF
            };
            break;
          case "graph-source":
            i = {
              E8: a.N4.E8,
              FF: a.N4.FF
            };
        }
        if (i && i.E8 && "NULL" !== i.E8) if (i.E8 instanceof Array) for (var n = 0; n < i.E8.length; n++) null !== ZC._n_(i.FF[n]) && (i.E8[n] = i.E8[n].replace("%id", a.A.K), i.E8[n] = i.E8[n].replace("%graphid", a.K.replace(a.A.K + "-graph-", "")), a.UI(e, i.E8[n], i.FF[n]));else i.E8 = i.E8.replace("%id", a.A.K), i.E8 = i.E8.replace("%graphid", a.K.replace(a.A.K + "-graph-", "")), a.UI(e, i.E8, i.FF);
      } else a.QS("dblclick", t);
    }, ZC.A5("." + a.K + "-label-area").live(ZC.mobile ? "touchstart" : "mousedown mouseover", a.A0J).live(ZC.mobile ? "touchend" : "mouseup mouseout", a.A19).live(ZC.mobile ? "touchmove" : ZC._[48], a.A0K), ZC.mobile || ZC.A5("." + a.K + "-label-area").live("click", a.VC).live("dblclick", a.VC));
    function n(e) {
      for (var t = (e.targetid || e.target.id).replace(/\-\-\d+/g, "").replace(a.K + "-shape-", "").replace("-gshape-area", "").replace("-area", ""), i = -1, n = null, l = 0, r = a.FJ.length; l < r; l++) if (a.FJ[l] && "" + a.FJ[l].HB == "" + t) {
        i = l, n = a.FJ[l] instanceof QZ ? a.FJ[l].BF : a.FJ[l];
        break;
      }
      if (!n && e.target.getAttribute("data-lowlevel")) return {
        shapeid: e.target.id,
        lowlevel: !0,
        ev: e
      };
      if (-1 === i) return null;
      var o = {
        shapeid: t,
        shapeindex: i,
        tooltip: n.o.tooltip ? 1 : 0,
        shape: {
          id: t,
          index: i,
          cls: n.DJ,
          x: n.iX,
          y: n.iY,
          type: n.DQ,
          mapItem: n.o["map-item"],
          points: n.D,
          width: n.I,
          height: n.F,
          size: n.AI,
          size2: n.L5,
          angle: n.A9,
          zIndex: n.JX
        },
        ev: e
      };
      for (var s in n.o) n.o.hasOwnProperty(s) && "data-" === s.substring(0, 5) && (o[s] = n.o[s]);
      return o;
    }
    function l(n) {
      var l,
        r = n.targetid || n.target.id;
      if (r === a.K + "-title-area" || r === a.K + "-subtitle-area" || r === a.K + "-source-area") {
        var o = null,
          s = -1;
        switch (l = r.replace(a.K + "-", "").replace("-area", "")) {
          case "title":
            o = a.IZ, s = -1;
            break;
          case "subtitle":
            o = a.K6, s = -2;
            break;
          case "source":
            o = a.N4, s = -3;
        }
        return {
          type: "graph-" + l,
          labelid: o.K,
          labelindex: s,
          text: o.AO,
          label: {
            id: o.K,
            index: s,
            text: o.AO
          },
          ev: n
        };
      }
      if (-1 === r.indexOf("-scale") || -1 === r.indexOf("-item") && -1 === r.indexOf("-marker")) {
        if (-1 !== r.indexOf("-value-box-")) {
          e = r.replace(a.K + ZC._[35], "").replace("-value-box-area", ""), t = e.split("-node-");
          var C = a.AY.A4[ZC._i_(t[0])].FK(ZC._i_(t[1]));
          return C ? {
            type: ZC._[17],
            labelid: "vb_" + t.join("_"),
            plotindex: ZC._i_(t[0]),
            nodeindex: ZC._i_(t[1]),
            text: C.AD,
            label: {
              id: "vb_" + t.join("_"),
              text: C.AD
            },
            ev: n
          } : null;
        }
        e = r.replace(a.K + "-label-", "").replace("-area", "");
        for (var A = -1, Z = null, c = 0, p = a.BY.length; c < p; c++) if ("" + a.BY[c].HB == "" + e) {
          A = c, Z = a.BY[c];
          break;
        }
        if (i = -1 === A ? "" : a.BY[A].AO, -1 === A) return null;
        var u = {
          type: "label",
          labelid: e,
          labelindex: A,
          text: i,
          tooltip: Z.o.tooltip ? 1 : 0,
          label: {
            id: e,
            index: A,
            cls: Z.DJ,
            x: Z.iX + Z.BM,
            y: Z.iY + Z.BH,
            width: Z.I,
            height: Z.F,
            text: i
          },
          ev: n
        };
        for (var h in Z.o) Z.o.hasOwnProperty(h) && "data-" === h.substring(0, 5) && (u[h] = Z.o[h]);
        return u;
      }
      e = r.replace(a.K + "-", "").replace("-area", "");
      var _ = (t = e.split("-"))[1].split("_"),
        d = 0;
      2 === _.length ? d = ZC._i_(_[1]) : 3 === _.length && (d = ZC._i_(_[2]));
      var f,
        g = t[0].replace(/_/g, "-"),
        B = a.BJ(g);
      return -1 !== r.indexOf("-item") ? (l = "scale-item", f = "si_" + t[1].replace("item_", ""), i = B.BY[d] || B.V[d], "si_title" === f && (i = B.M.AO)) : (l = "scale-marker", f = "sm_" + t[1].replace("marker_", ""), i = B.E["marker_text_" + d] || ""), {
        type: l,
        labelid: f,
        labelindex: d,
        scale: g,
        text: i,
        tooltip: B.o.tooltip || B.o.item && B.o.item.tooltip ? 1 : 0,
        label: {
          id: f,
          index: d,
          text: i
        },
        ev: n
      };
    }
  }, K2.prototype.QS = function (e, t) {
    ZC._cp_(this.GR(), t), t.ev = ZC.A5.BX(t.ev), ZC.AQ.BZ("label_" + e, this.A, t);
  }, K2.prototype.QO = function (e, t) {
    ZC._cp_(this.GR(), t), t.ev = ZC.A5.BX(t.ev), ZC.AQ.BZ("shape_" + e, this.A, t);
  }, K2.prototype.OL = function (e) {
    var t,
      i,
      a = this;
    if ("string" == typeof e) {
      var n = {},
        l = e.split(":");
      if (2 === l.length) {
        n.type = l[0];
        for (var r = 0, o = (l = l[1].split(/\s|,|;/)).length; r < o; r++) {
          var s = l[r].split("=");
          n[s[0]] = s[1];
        }
      }
      e = n;
    }
    var C = [-1, -1];
    switch (a.E.hooks = !0, e.type) {
      case "scale":
        var A,
          Z,
          c,
          p = "",
          u = -1,
          h = null;
        if (null !== ZC._n_(t = e.name) && (p = t), null !== ZC._n_(t = e.index) && (u = ZC._i_(t)), null !== ZC._n_(t = e[ZC._[9]]) && (h = ZC._i_(t)), i = null, "" === p && (p = ZC._[50]), i = a.BJ(p)) switch (i.H6 && -1 !== u ? c = i.H6(u) : i.AM && (null !== ZC._n_(h) ? c = i.AM(h) : -1 !== u && (c = i.AM(i.V[u]))), a.AJ.layout) {
          case "radar":
          case "gauge":
            A = c[0], Z = c[1];
            break;
          case "xy":
            "k" === i.AF ? (A = c, Z = i.iY, "default" === i.BA && (Z += i.F)) : "v" === i.AF && (Z = c, A = i.iX, "opposite" === i.BA && (A += i.I));
            break;
          case "yx":
            "k" === i.AF ? (Z = c, A = i.iX, "opposite" === i.BA && (A += i.I)) : "v" === i.AF && (A = c, Z = i.iY, "default" === i.BA && (Z += i.F));
        }
        C = [A, Z, {
          center: !0
        }];
        break;
      case "node":
        var _ = -1,
          d = null,
          f = null,
          g = null,
          B = null;
        null !== ZC._n_(t = e.plot) && (g = t), null !== ZC._n_(t = e.plotindex) && (g = t), null !== ZC._n_(t = e.plotid) && (B = t);
        var v = a.HW(g, B);
        null !== ZC._n_(t = e.index) && (_ = ZC._i_(t)), null !== ZC._n_(t = e[ZC._[9]]) && (d = t), null !== ZC._n_(t = e.keyvalue) && (f = t);
        var m = null;
        if (v) {
          if (-1 !== _ && v.S[_]) m = v.FK(_, 3);else if (null !== ZC._n_(d) || null !== ZC._n_(f)) {
            var b, E;
            if (i = v.C.BJ(v.BO[0]), null !== f && null === d && v.S.length > 4096 && i.FI && "date" === i.FI.o.type && null !== (b = ZC._nfind_(f, v, 0, v.S.length - 1)) && (m = v.FK(b, 3)), !m) for (b = 0, E = v.S.length; b < E; b++) v.S[b] && (null !== d && v.S[b].AD == d && (m = v.FK(b, 3)), null !== f && null !== ZC._n_(v.S[b].BU) && v.S[b].BU == f && (m = v.FK(b, 3)));
          }
          m && (m.setup(), C = m.OL(e), !m.JK && ZC.DR(C[0], a.P.iX, a.P.iX + a.P.I) && ZC.DR(C[1], a.P.iY, a.P.iY + a.P.F) && (m.JK = !0), m.JK && m.AN && m.A.AN && m.C.E["plot" + m.A.L + ".visible"] || (C = [-1, -1])), v.E["z-mid"] && (C[2].z = v.E["z-mid"]);
        }
    }
    return null !== ZC._n_(e.x) && (C[0] = ZC._i_(e.x)), null !== ZC._n_(e.y) && (C[1] = ZC._i_(e.y)), null !== ZC._n_(t = e["offset-x"]) && (C[0] += ZC._i_(t)), null !== ZC._n_(t = e["offset-y"]) && (C[1] += ZC._i_(t)), C;
  }, zingchart.ABJ = function (e, t, i) {
    document.getElementById("zc-fullscreen") && (e = "zc-fullscreen"), "string" == typeof (i = i || {}) && (i = JSON.parse(i));
    var a,
      n,
      l,
      r,
      o,
      s,
      C,
      A,
      Z,
      c,
      p,
      u,
      h,
      _,
      d = !(null !== ZC._n_(i.update) && !ZC._b_(i.update)),
      f = !!i.dynamic && ZC._b_(i.dynamic),
      g = zingchart.getLoader(e);
    if (g) switch (t) {
      case "addobject":
        if ((a = g.C8(i[ZC._[3]])) && i.data) {
          if (Z = (A = i.data instanceof Array) ? [] : {}, ZC._cp_(i.data, Z), n = i.type || "label", A) for (o = 0, s = Z.length; o < s; o++) n = i.type || Z[o].objtype || "label", a.o[n + "s"] || (a.o[n + "s"] = []), f && (Z[o]["map-item"] = !1), a.o[n + "s"].push(Z[o]);else a.o[n + "s"] || (a.o[n + "s"] = []), f && (Z["map-item"] = !1), a.o[n + "s"].push(Z);
          d && (a.OA(), a.Q1(f));
        }
        i.callback && "function" == typeof i.callback && i.callback(i);
        break;
      case "removeobject":
        if (a = g.C8(i[ZC._[3]]), i["class"] && (i.cls = i["class"]), a && (i.id || i.cls || i.group)) {
          n = i.type || "label", C = a.o[n + "s"] || [], l = i.id ? "string" == typeof i.id ? [i.id] : i.id : [], r = i.cls ? "string" == typeof i.cls ? [i.cls] : i.cls : [], c = !1;
          var B = [];
          for (o = C.length - 1; o >= 0; o--) (null !== ZC._n_(C[o].id) && -1 !== ZC.AV(l, C[o].id) || null !== ZC._n_(C[o].cls) && -1 !== ZC.AV(r, C[o].cls) || null !== ZC._n_(C[o]["class"]) && -1 !== ZC.AV(r, C[o]["class"]) || i.group && C[o].group === i.group) && (null !== ZC._n_(C[o].id) && B.push(C[o].id), C.splice(o, 1), c = !0);
          for (o = 0; o < B.length; o++) ZC.Q.EU([a.K + "-label-" + B[o] + "-gradient", a.K + "-label-" + B[o] + "-top-gradient", a.K + "-shape-" + B[o] + "-gradient", a.K + "-shape-" + B[o] + "-top-gradient", a.K + "-shape-" + B[o] + "-gshape-gradient", a.K + "-shape-" + B[o] + "-gshape-top-gradient"]);
          c && d && (a.OA(), a.Q1(f));
        }
        i.callback && "function" == typeof i.callback && i.callback(i);
        break;
      case "updateobject":
        if (i["class"] && (i.cls = i["class"]), (a = g.C8(i[ZC._[3]])) && i.data) {
          a.E["objects.updates"] = [], n = i.type || "label", C = a.o[n + "s"] || [], _ = "label" === n ? a.BY : a.FJ, Z = (A = i.data instanceof Array) ? [] : {}, ZC._cp_(i.data, Z), c = !1;
          var v = !0,
            m = function m(e, t) {
              var i,
                l,
                r,
                o = a.XW[e.id || ""],
                s = !1;
              if (o && ("label" === o.shape ? (r = a.BY[o.idx], Object.keys && 3 === Object.keys(e).length && null !== ZC._n_(e.x) && null !== ZC._n_(e.y) && (r.iX = e.x, r.iY = e.y, s = !0)) : ((r = a.FJ[o.idx]).BF && r.BF.o["map-item"] && (v = !1), "circle" === o.shape ? Object.keys && 3 === Object.keys(e).length && null !== ZC._n_(e.x) && null !== ZC._n_(e.y) && (r.BF ? (r.BF.iX = e.x, r.BF.iY = e.y) : (r.iX = e.x, r.iY = e.y), s = !0) : "line" === o.shape && Object.keys && 2 === Object.keys(e).length && null !== ZC._n_(e.points) && (r.BF ? r.BF.D = e.points : r.D = e.points, s = !0))), s || a.E["objects.updates"].push(e.id), ZC._cp_(e, t), null !== ZC._n_(e.animation)) {
                var C = null;
                if ("label" === n) {
                  for (i = 0, l = a.BY.length; i < l; i++) if (a.BY[i].HB === e.id) {
                    C = a.BY[i];
                    break;
                  }
                } else if ("shape" === n) for (i = 0, l = a.FJ.length; i < l; i++) if (a.FJ[i].HB === e.id) {
                  C = a.FJ[i] instanceof QZ ? a.FJ[i].BF : a.FJ[i];
                  break;
                }
                var A = a.M7,
                  Z = {};
                if (ZC._cp_(e, Z), null !== ZC._n_(Z.x) && (Z.x += a.iX), null !== ZC._n_(Z.y) && (Z.y += a.iY), null !== ZC._n_(Z.points)) for (i = 0, l = Z.points.length; i < l; i++) null !== ZC._n_(Z.points[i]) && (Z.points[i][0] += a.iX, Z.points[i][1] += a.iY, null !== ZC._n_(Z.points[i][2]) && (Z.points[i][2] += a.iX), null !== ZC._n_(Z.points[i][3]) && (Z.points[i][3] += a.iY));
                Z.animation = null;
                var p = new EB(C, Z, ZC._i_(e.animation.speed || "300"), ZC._i_(e.animation.delay || "0"), EB.RW[ZC._i_(e.animation.method || "0")], function () {
                  null !== ZC._n_(e.animation.end) && e.animation.end.call();
                });
                a.QH = !0, window.setTimeout(function () {
                  A.add(p);
                }, 33);
              }
              c = !0;
            };
          if (A) {
            var b = !1,
              E = !1;
            for (o = 0, s = Z.length; o < s; o++) {
              if (null !== ZC._n_(Z[o].objtype) && (C = a.o[Z[o].objtype + "s"]), C) for (p = 0, u = C.length; p < u; p++) null !== ZC._n_(Z[o].id) && null !== ZC._n_(C[p].id) && C[p].id === Z[o].id && m(Z[o], C[p]);
              null !== ZC._n_(Z[o].animation) ? b = !0 : E = !0, E && b && (ZC.SKIPMAPS = v, a.PH());
            }
          } else if (i.group) for (p = 0, u = C.length; p < u; p++) C[p].group === i.group && (Z.id = C[p].id, m(Z, C[p]));else if (i.cls) for (p = 0, u = C.length; p < u; p++) C[p].cls === i.cls && (Z.id = C[p].id, m(Z, C[p]));else for (e = Z.id || i.id, p = 0, u = C.length; p < u; p++) null !== ZC._n_(C[p].id) && null !== ZC._n_(e) && C[p].id === e && (Z.id = e, m(Z, C[p]));
          ZC.SKIPMAPS = v, !c || !d && a.QH || a.QH || (a.OA(), a.Q1(f));
        }
        i.callback && "function" == typeof i.callback && i.callback(i);
        break;
      case "repaintobjects":
        (a = g.C8(i[ZC._[3]])) && (a.OA(), a.Q1(f)), i.callback && "function" == typeof i.callback && i.callback(i);
        break;
      case "getallobjects":
        if (l = [], a = g.C8(i[ZC._[3]])) for (n = i.type || "label", o = 0, s = (C = a.o[n + "s"] || []).length; o < s; o++) null !== ZC._n_(C[o].id) && l.push(C[o].id);
        return l;
      case "getobjectsbyclass":
        if (i["class"] && (i.cls = i["class"]), l = [], (a = g.C8(i[ZC._[3]])) && i.cls) {
          n = i.type || "label", C = a.o[n + "s"] || [];
          var K = i.cls instanceof Array ? i.cls : [i.cls];
          for (o = 0, s = C.length; o < s; o++) -1 === ZC.AV(K, C[o].cls) && -1 === ZC.AV(K, C[o]["class"]) || null === ZC._n_(C[o].id) || l.push(C[o].id);
        }
        return l;
      case "getlabelinfo":
      case "getshapeinfo":
        var D = {
          x: "iX",
          y: "iY",
          width: "I",
          height: "F",
          color: "C2",
          lineColor: "B7",
          lineWidth: "AZ",
          borderColor: "BW",
          borderWidth: "AU",
          backgroundColor1: "A0",
          backgroundColor2: "AE",
          size: "AI",
          type: "DQ",
          text: "AO",
          fontSize: "DG",
          callout: "L2",
          calloutPosition: "EL",
          offsetX: "BM",
          offsetY: "BH"
        };
        if (a = g.C8(i[ZC._[3]]), n = i.type || "label", "getlabelinfo" === t && "label" !== n || "getshapeinfo" === t && "shape" !== n) return null;
        if (e = i.id || "", a && "" !== e) {
          _ = [], "label" === n ? _ = a.BY : "shape" === n && (_ = a.FJ);
          var F = null;
          for (o = 0, s = _.length; o < s; o++) _[o].HB === e && (F = _[o]);
          if (F) {
            var I = {};
            if ("shape" === n) {
              if (F.M) for (h in I.label = {}, D) I.label[h] = F.M[D[h]];
              F.BF && (F = F.BF);
            }
            for (h in D) I[h] = F[D[h]];
            return I;
          }
        }
        return null;
      case "setobjectsmode":
        zingchart.OBJECTMODE = "normal", i.mode && "flat" === i.mode && (zingchart.OBJECTMODE = "flat");
        break;
      case "settweenmode":
        ZC.objmove = !1, i.mode && "position" === i.mode && (ZC.objmove = !0);
    }
    return null;
  }, K2.prototype.A3G = function () {
    var e,
      t,
      i = this,
      a = 0;
    for (e = 0, t = i.BO.length; e < t; e++) "k" === i.BO[e].AF && i.o[i.BO[e].BG] && i.o[i.BO[e].BG][ZC._[5]] && (a = ZC.BQ(a, i.o[i.BO[e].BG][ZC._[5]].length));
    for (e = 0, t = i.AY.A4.length; e < t; e++) null !== ZC._n_(i.o[ZC._[11]][e]) && i.o[ZC._[11]][e][ZC._[5]] && (a = ZC.BQ(a, i.o[ZC._[11]][e][ZC._[5]].length));
    return a;
  }, K2.prototype.UU = function () {
    var e,
      t = this;
    if (t.I0) for (var i = t.A3G(), a = 0, n = t.BO.length; a < n; a++) "k" === t.BO[a].AF && (t.BO[a].CO ? (e = (t.BO[a].F - t.BO[a].AB - t.BO[a].BV) / ZC._i_(t.I0["max-ticks"]), t.BO[a].OW = ZC.BQ(0, t.BO[a].F - i * e)) : (e = (t.BO[a].I - t.BO[a].AB - t.BO[a].BV) / ZC._i_(t.I0["max-ticks"]), t.BO[a].OW = ZC.BQ(0, t.BO[a].I - i * e)), ZC._b_(t.I0["adjust-scale"]) && (t.BO[a].OW = 0), t.BO[a].AB = t.BO[a].A4W + t.BO[a].OW, t.A.E[t.BO[a].BG + "-feed-offset-start"] = t.BO[a].AB, t.BO[a].W = ZC.BQ(0, t.BO[a].A1 - t.I0["max-ticks"] + 1), t.BO[a].H0());
  }, K2.prototype.A7Z = function () {
    var s = this,
      G,
      MX,
      ws;
    if (s.E["from-api"] && (window.clearTimeout(ZC.REFRESH_TICK[s.K]), delete s.E["from-api"]), s.I0) {
      var P3 = ZC._i_(s.I0.interval);
      if (P3 = P3 >= 50 ? P3 : 1e3 * P3, "full" === s.I0.type) "http" === s.I0.transport ? ZC.REFRESH_TICK[s.K] = window.setTimeout(function () {
        s.A.MU(s), ZC.ZV(function () {
          s.A.load(s.K, s.AA3);
        });
      }, P3) : "websockets" === s.I0.transport && ZC.websockets && (s.H.SL[s.K] ? "pull" === s.I0.method && (ZC.REFRESH_TICK[s.K] = window.setTimeout(function () {
        s.H.SL[s.K].send("zingchart.getdata");
      }, P3)) : (ws = new WebSocket(s.I0.url, "zingchart"), ws.onopen = function () {
        ws.send("zingchart." + s.I0.type), ws.send("zingchart." + s.I0.method), ws.send("zingchart.getdata");
      }, ws.onmessage = function (e) {
        "ready" === s.MK && (s.A.MU(s), s.MK = "full", ZC.ZV(function () {
          zingchart.exec(s.A.K, "setdata", {
            graphid: s.K,
            data: e.data,
            softclear: !0
          });
        }));
      }, s.H.SL[s.K] = ws));else if ("feed" === s.I0.type && null !== ZC._n_(s.I0.url)) {
        if (null !== ZC._n_(s.I0.curtain)) {
          var OR = s.BT("k");
          if (OR.length > 0 && (ZC.Q.EU(s.K + "-curtain-t"), OR[0].OW > 0)) {
            var M8 = new DT(s);
            s.A.B8.load(M8.o, "(" + s.AF + ").refresh.curtain"), M8.append(s.I0.curtain), M8.parse(), M8.AN && (OR[0].CO && M8.F <= OR[0].OW || !OR[0].CO && M8.I <= OR[0].OW) && (M8.K = s.K + "-curtain-t", M8.IW = ZC.AK(s.A.K + "-text-top"), OR[0].CO ? (M8.F > OR[0].OW && (M8.AO = "", M8.parse()), M8.iX = s.P.iX, M8.iY = OR[0].AW ? s.P.iY : s.P.iY + s.P.F - OR[0].OW, M8.I = s.P.I, M8.F = OR[0].OW) : (M8.I > OR[0].OW && (M8.AO = "", M8.parse()), M8.iX = OR[0].AW ? s.P.iX + s.P.I - OR[0].OW : s.P.iX, M8.iY = s.P.iY, M8.I = OR[0].OW, M8.F = s.P.F), M8.Z = M8.C7 = ZC.AK(s.K + "-scales-ml-0-c"), M8.paint());
          }
        }
        var A1J = s.I0.transport,
          A4V = ZC._i_(s.I0["reset-timeout"]),
          A5E = ZC._i_(s.I0["stop-timeout"]),
          AAL = ZC._b_(s.I0.storage),
          A0T = !0;
        null !== ZC._n_(s.I0["preserve-data"]) && (A0T = ZC._b_(s.I0["preserve-data"]));
        var A5H = function A5H(KN) {
          for (var TW = eval("(" + KN + ")"), i, A6, A91 = TW instanceof Array ? TW : [TW], r = 0, rLen = A91.length; r < rLen; r++) {
            var DK = A91[r];
            for (i = 0, A6 = s.BO.length; i < A6; i++) if ("k" === s.BO[i].AF) {
              var BG = s.BO[i].BG;
              null !== ZC._n_(DK[BG]) && null !== ZC._n_(s.o[BG]) && (null === ZC._n_(s.o[BG][ZC._[5]]) && (s.H.o[ZC._[16]][s.L][BG][ZC._[5]] = [], s.o[BG][ZC._[5]] = []), s.o[BG][ZC._[5]].push(DK[BG]), !A0T && s.o[BG][ZC._[5]].length > ZC._i_(s.I0["max-ticks"]) && s.o[BG][ZC._[5]].splice(0, 1), s.H.o[ZC._[16]][s.L][BG][ZC._[5]].push(DK[BG]), (s.o[BG][ZC._[5]].length > A4V || 1 === s.MN[1]) && (s.H.o[ZC._[16]][s.L][BG][ZC._[5]] = [], s.o[BG][ZC._[5]] = [], s.H.E["graph" + s.L + ".zoom"] && (s.H.E["graph" + s.L + ".zoom"].xmin = null, s.H.E["graph" + s.L + ".zoom"].xmax = null), s.HZ && (s.HZ.unbind(), ZC.Q.IT(ZC.AK(s.K + "-scroll-x-c"), s.A.AA, s.iX, s.iY, s.I, s.F, s.K), ZC.A5("#" + s.K + "-scroll-x-handle").remove(), ZC.A5("#" + s.K + "-scroll-x-bar").remove()), s.HY && (s.HY.unbind(), ZC.Q.IT(ZC.AK(s.K + "-scroll-y-c"), s.A.AA, s.iX, s.iY, s.I, s.F, s.K), ZC.A5("#" + s.K + "-scroll-y-handle").remove(), ZC.A5("#" + s.K + "-scroll-y-bar").remove())), ZC.webstorage && AAL && ZC.AQ.storage.push("zingchart.scale." + s.K + "." + BG, "" + DK[BG]));
            }
            for (i = 0, A6 = s.AY.A4.length; i < A6; i++) if (null !== ZC._n_(s.o[ZC._[11]][i])) {
              var A49 = null;
              null !== ZC._n_(G = DK["plot-" + i]) ? A49 = G : null !== ZC._n_(G = DK["plot" + i]) && (A49 = G), "xy" === s.AJ.layout || "yx" === s.AJ.layout ? (s.H.o[ZC._[16]][s.L][ZC._[11]][i][ZC._[5]].push(A49), !A0T && s.H.o[ZC._[16]][s.L][ZC._[11]][i][ZC._[5]].length > ZC._i_(s.I0["max-ticks"]) && s.H.o[ZC._[16]][s.L][ZC._[11]][i][ZC._[5]].splice(0, 1)) : s.H.o[ZC._[16]][s.L][ZC._[11]][i][ZC._[5]] = [A49], ZC.webstorage && AAL && (G = DK["plot" + i], "object" == typeof G && (G = G.join("###")), ZC.AQ.storage.push("zingchart.plot." + s.K + ".plot" + i, "" + G)), (s.o[ZC._[11]][i][ZC._[5]].length > A4V || 1 === s.MN[1]) && (ZC.AQ.BZ("feed_clear", s.A, s.GR(), DK), s.H.o[ZC._[16]][s.L][ZC._[11]][i][ZC._[5]] = []);
            }
            MX = s.A3G();
          }
          ("ready" === s.MK || s.GI) && (1 === s.MN[1] && (s.MN[1] = 0), (MX <= A5E || 0 === A5E) && (s.MK = "feed", ZC.ZV(function () {
            ZC.AK(s.A.K + "-main") && (ZC.AQ.BZ("feed_step", s.H, s.GR(), s.o), s.parse(), s.clear(!0), s.UU(), s.paint(!0, !0));
          })));
        };
        if ("http" === A1J || "js" === A1J) {
          var E8 = s.I0.url;
          ZC.REFRESH_TICK[s.K] = window.setTimeout(function () {
            if (1 === s.MN[0] || 1 === s.MN[1]) if (s.A.MU(s), "http" === A1J) {
              var EW = ["query-string" === s.A.NA ? "zcrandom=" + Math.random() : "", zingchart.ZCOUTPUT ? "zcoutput=" + s.H.AA : ""].join("&");
              ZC.A5.ajax({
                type: "GET",
                url: E8,
                beforeSend: function beforeSend(e) {
                  s.A.SE.data || "http-headers" !== s.A.NA || e.setRequestHeader(ZC._[45], "Thu, 01 Jan 1970 00:00:00 GMT");
                },
                data: EW,
                dataType: "text",
                error: function error() {},
                success: function success(e) {
                  A5H(e);
                }
              });
            } else if ("()" === E8.substring(E8.length - 2) || "javascript:" === E8.substring(0, 11)) try {
              var EA = E8.replace("javascript:", "").replace("()", "");
              eval(EA) && eval(EA).call(s, function (e) {
                A5H(e);
              }, s.GR());
            } catch (e) {}
          }, P3);
        } else "websockets" === A1J && ZC.websockets && (s.H.SL[s.K] ? "pull" === s.I0.method && (ZC.REFRESH_TICK[s.K] = window.setTimeout(function () {
          s.H.SL[s.K].send("zingchart.getdata");
        }, P3)) : (ws = new WebSocket(s.I0.url, "zingchart"), ws.onopen = function () {
          ws.send("zingchart." + s.I0.type), ws.send("zingchart." + s.I0.method), ws.send("zingchart.startfeed"), "pull" === s.I0.method && ws.send("zingchart.getdata");
        }, ws.onmessage = function (e) {
          1 !== s.MN[0] && 1 !== s.MN[1] || A5H(e.data);
        }, s.H.SL[s.K] = ws));
      }
    }
  }, zingchart.AC4 = function (e, t, i) {
    var a;
    document.getElementById("zc-fullscreen") && (e = "zc-fullscreen"), "string" == typeof (i = i || {}) && (i = JSON.parse(i));
    var n = zingchart.getLoader(e);
    if (n) {
      var l = n.C8(i[ZC._[3]]);
      switch (t) {
        case "clearfeed":
          l.MN[1] = 1, 0 === l.MN[0] && ZC.ZV(function () {
            l.parse(), l.clear(!0), l.UU(), l.paint(!0, !0);
          });
          break;
        case "getinterval":
          return l.I0.interval;
        case "setinterval":
          ZC.AQ.BZ("feed_interval_modify", n, l.GR()), l.o.refresh = l.o.refresh || {}, l.o.refresh.interval = i.interval || 1;
          break;
        case "stopfeed":
          1 === l.MN[0] && (ZC.AQ.BZ("feed_stop", n, l.GR()), l.MN[0] = 0, null !== ZC._n_(a = n.SL[l.K]) && a.send("zingchart.stopfeed"));
          break;
        case "startfeed":
          0 === l.MN[0] && (ZC.AQ.BZ("feed_start", n, l.GR()), l.MN[0] = 1, null !== ZC._n_(a = n.SL[l.K]) && a.send("zingchart.startfeed"), ZC.ZV(function () {
            l.parse(), l.clear(!0), l.UU(), l.paint(!0, !0);
          }));
      }
    }
    return null;
  }, ZC.AQ.A4Z = function (e) {
    for (var t = {}, i = [], a = 0, n = (i = "object" == typeof e ? e : JSON.parse(e)).length; a < n; a++) if (null !== ZC._n_(e = i[a])) {
      t["p" + a] = {};
      var l = [];
      if ("object" == typeof e) l = e;else if ("string" == typeof e && /\d+\-\d+/.test(e)) {
        var r = e.split("-");
        if (2 === r.length) {
          l = [];
          for (var o = ZC._i_(r[0]); o <= ZC._i_(r[1]); o++) l.push(o);
        }
      } else l = [e];
      for (var s = 0, C = l.length; s < C; s++) t["p" + a]["n" + l[s]] = !0;
    }
    return t;
  }, K2.prototype.A82 = function () {
    var e,
      t = this;
    null !== ZC._n_(e = t.o.selection) && (t.C9 = ZC.AQ.A4Z(e), t.o.selection = null);
  }, zingchart.AB6 = function (e, t, i) {
    var a, n, l, r, o, s, C, A, Z;
    document.getElementById("zc-fullscreen") && (e = "zc-fullscreen"), "string" == typeof (i = i || {}) && (i = JSON.parse(i));
    var c = zingchart.getLoader(e);
    if (c) switch (t) {
      case "clearselection":
        if (n = c.C8(i[ZC._[3]])) {
          for (n.C9 = {}, l = 0, r = n.AY.A4.length; l < r; l++) n.J4[l] = !1;
          n.HO = !0, n.clearPreview(), n.JY(!0, !0);
        }
        break;
      case "getselection":
        if (n = c.C8(i[ZC._[3]])) {
          for (s = [], l = 0, r = n.AY.A4.length; l < r; l++) if (s[l] = null, null !== ZC._n_(n.C9["p" + l])) {
            var p = [];
            for (C in n.C9["p" + l]) n.C9["p" + l].hasOwnProperty(C) && n.C9["p" + l][C] && p.push(ZC._i_(C.replace("n", "")));
            s[l] = p;
          }
          return s;
        }
        return {};
      case "setselection":
        var u = {};
        s = [], null !== ZC._n_(a = i.selection) && (u = ZC.AQ.A4Z(a)), (n = c.C8(i[ZC._[3]])) && (n.C9 = u, n.HO = !0, n.clearPreview(), n.JY(!0, !0));
        break;
      case "select":
      case "deselect":
        var h = [],
          _ = function _(e) {
            var i = !1;
            null !== ZC._n_(a = e.toggle) && (i = ZC._b_(a));
            var n = c.C8(e[ZC._[3]]);
            if (n) {
              for (l = 0, r = n.AY.A4.length; l < r; l++) n.J4[l] = !1;
              var s = null,
                p = null;
              if (null !== ZC._n_(a = e.plotindex)) if ("object" == typeof a) s = a;else if ("string" == typeof a && /\d+\-\d+/.test(a)) {
                if (2 === (o = a.split("-")).length) for (s = [], Z = ZC._i_(o[0]); Z <= ZC._i_(o[1]); Z++) s.push(Z);
              } else s = [a];
              if (null !== ZC._n_(a = e.plotid)) {
                var u = [];
                for (u = "object" == typeof a ? a : [a], Z = 0; Z < u.length; Z++) {
                  var _ = n.HW(null, u[Z]);
                  _ && (s || (s = []), s.push(_.L));
                }
              }
              if (null !== ZC._n_(a = e.nodeindex)) if ("object" == typeof a) p = a;else if ("string" == typeof a && /\d+\-\d+/.test(a)) {
                if (2 === (o = a.split("-")).length) for (p = [], Z = ZC._i_(o[0]); Z <= ZC._i_(o[1]); Z++) p.push(Z);
              } else p = [a];
              if (null === ZC._n_(s)) for (s = [], l = 0, r = n.AY.A4.length; l < r; l++) s.push(l);
              for (l = 0, r = s.length; l < r; l++) {
                var d = s[l];
                if (n.AY.A4[d]) if (null === ZC._n_(n.C9["p" + d]) && (n.C9["p" + d] = {}), null === ZC._n_(p)) for (C = 0, A = n.AY.A4[d].S.length; C < A; C++) "select" === t ? i && n.C9["p" + d]["n" + C] ? delete n.C9["p" + d]["n" + C] : n.C9["p" + d]["n" + C] = !0 : "deselect" === t && delete n.C9["p" + d]["n" + C];else for (C = 0, A = p.length; C < A; C++) "select" === t ? i && n.C9["p" + d]["n" + p[C]] ? delete n.C9["p" + d]["n" + p[C]] : n.C9["p" + d]["n" + p[C]] = !0 : "deselect" === t && delete n.C9["p" + d]["n" + p[C]];
              }
              -1 === ZC.AV(h, n) && h.push(n);
            }
          };
        if (i instanceof Array) for (Z = 0; Z < i.length; Z++) _(i[Z]);else _(i);
        for (Z = 0; Z < h.length; Z++) h[Z].HO = !0, h[Z].clearPreview(), h[Z].JY(!0, !0);
    }
    return null;
  }, K2.prototype.NK = function () {
    var e = this;
    e.AJ["3d"] && typeof ZC.AP !== ZC._[31] && (ZC.AP.A55 = 2.5 * ZC.BQ(e.I, e.F), ZC.AP.E2 = e.P.iX + e.P.I / 2, ZC.AP.E1 = e.P.iY + e.P.F / 2, ZC.AP.FV = ZC._i_(e.EZ.depth), ZC.AP.E2 += e.EZ["offset-x"], ZC.AP.E1 += e.EZ["offset-y"]);
  }, K2.prototype.AC6 = function () {
    var e,
      t,
      i = this;
    if (i.AJ["3d"] && typeof ZC.AP !== ZC._[31]) {
      if (i.A.B8.load(i.EZ, "graph.3d-aspect"), i.A.B8.load(i.EZ, i.AF + ".3d-aspect"), null !== ZC._n_(e = i.o[ZC._[26]]) && ZC._cp_(e, i.EZ), "pie3d" === i.AF && i.o.plot && i.o.plot.tilt) {
        var a = ZC._l_(ZC._f_(i.o.plot.tilt), 1, 3);
        i.EZ[ZC._[27]] = 25 + (a - 1) / 2 * (i.AJ["x-angle-max"] - i.AJ["x-angle-min"]);
      }
      var n = ["angle", "depth", ZC._[27], ZC._[28], ZC._[29], "zoom", "offset-x", "offset-y"];
      for (t = 0; t < n.length; t++) i.EZ[n[t]] = ZC._f_(i.EZ[n[t]]);
      var l = ["angle", ZC._[27], ZC._[28], ZC._[29]];
      for (t = 0; t < l.length; t++) ZC.DR(i.EZ[l[t]], i.AJ[l[t] + "-min"], i.AJ[l[t] + "-max"]) || (i.EZ[l[t]] = i.AJ[l[t] + "-min"]);
      i.EZ.true3d = ZC._b_(i.EZ.true3d);
    }
  }, K2.prototype.RV = function () {
    var e,
      t,
      i,
      a,
      n = this;
    3 !== zingchart.V3D && (zingchart.V3D = n.EZ.true3d ? 1 : 2);
    var l = n.CJ.A58.length;
    for (e = 0; e < l; e++) (t = n.CJ.A58[e]).ABU(), n.EZ.true3d ? 3 === zingchart.V3D ? n.CJ.XA[e] = [ZC._f_(t.A08.toFixed(1)) * t.MO[2], e] : n.CJ.XA[e] = [[ZC._f_(t.SV.toFixed(1)) * t.MO[0], ZC._f_(t.A60.toFixed(1)) * t.MO[1], ZC._f_(t.A08.toFixed(1)) * t.MO[2], ZC._f_(t.A2J.toFixed(1))], e] : n.CJ.XA[e] = [[ZC._f_(t.SV.toFixed(1)) * t.MO[0], ZC._f_(t.A63.toFixed(1)) * t.MO[1], ZC._f_(t.A4F.toFixed(1)) * t.MO[2], ZC._i_(t.G0)], e];
    n.CJ.XA.sort(n.CJ.sortFaces);
    var r = new DW(n);
    for (i = n.H.usc() ? n.H.mc() : ZC.AK(n.K + "-plots-bl-c"), a = ZC.Q.E9(i, n.H.AA), e = 0; e < l; e++) {
      var o = [],
        s = n.CJ.XA[e][1],
        C = (t = n.CJ.A58[s]).D.length;
      if (C > 0) {
        for (var A = 0; A < C; A++) o.push(t.D[A].EC);
        o.push(t.D[0].EC), r.init(n), r.K = n.K + "-3dshape-" + ("" !== t.K ? t.K : ZC.SEQ++), r.copy(t.N), r.CY = !1, r.Z = i, r.locate(1), r.D = o, r.DQ = "poly", r.locate(2), r.paint();
      }
    }
    var Z = [];
    for (var c in n.CJ.SS) Z.push([c, n.CJ.SS[c].zIndex]);
    Z.sort(function (e, t) {
      return t[1] - e[1];
    });
    for (var p = 0; p < Z.length; p++) {
      var u = n.CJ.SS[Z[p][0]];
      ZC.CQ.setup(a, u.style), ZC.CQ.paint(a, u.style, u.points);
    }
  }, K2.prototype.TB = function () {
    if (!zingchart.SKIP.LEGEND) {
      var e,
        t = this;
      if (t.BC) {
        if (t.BC.Q3 && t.L !== t.A.AG.length - 1 && !t.BC.o.force) return;
        t.BC.Z = t.BC.C7 = t.H.usc() ? t.H.mc("top") : ZC.AK(t.K + "-legend-c"), t.BC.paint(), -1 === ZC.AV(t.H.L0, ZC._[41]) && (t.QX = function (e) {
          var i, a;
          if (!ZC.move) {
            t.A7 && t.A.A7 && t.A7.AN && t.A.A7.onmouseover(e);
            var n = e.targetid || e.target.id,
              l = ZC._i_(n.replace(t.K, "").replace("-legend-item_", "").replace("-legend-marker_", "").replace("-area", "").replace("-marker", "")),
              r = t.AY.A4[l];
            if (r.FZ && (t.BC.X6 || r.IH) && r.S.length) for (i = 0, a = r.S.length; i < a; i++) if (null !== r.S[i] && r.S[i].JK && (r.FK(i).HT("highlight"), t.BC.Q3)) for (var o = 0; o < t.A.AG.length; o++) if (t.A.AG[o].BC && t.A.AG[o].BC.Q3 && t.A.AG[o].AY.A4[r.L]) {
              var s = t.A.AG[o].AY.A4[r.L];
              s.FK(i) && s.FK(i).HT("highlight");
            }
            ZC.move = !0;
            var C = r.L;
            r.o["legend-item"] && null !== ZC._n_(r.o["legend-item"].order) && (C = ZC._i_(r.o["legend-item"].order)), t.BC.o["reverse-series"] && (C = t.AY.A4.length - 1 - C), t.BC.highlightItem(C), ZC.move = !1;
            var A = t.AY.A4[l].TF(e);
            t.E["legend-action-index"] = l, ZC.AQ.BZ("legend_mouseover", t.A, A);
          }
        }, t.PZ = function (e) {
          ZC.move || t.A7 && t.A.A7 && t.A7.AN && t.A.A7.onmousemove(e);
        }, t.RN = function (e) {
          if (!ZC.move) {
            if (t.A7 && t.A.A7 && t.A7.AN && t.A.A7.onmouseout(e), t.KW(), t.BC.Q3) for (var i = 0; i < t.A.AG.length; i++) t.A.AG[i].BC && t.A.AG[i].BC.Q3 && t.A.AG[i].KW();
            ZC.move = !0, t.BC.highlightItem(-1), ZC.move = !1;
            var a = ZC._c_(t.E["legend-action-index"], 0),
              n = t.AY.A4[a].TF(e);
            ZC.AQ.BZ("legend_mouseout", t.A, n);
          }
        }, t.zc_legend_mousescroll = function (e) {
          t.BC.D1 && "scroll-y" === t.BC.D1.AF && (e.preventDefault(), t.BC.D1.A44(e));
        }, t.SZ = function (i) {
          if (t.E.legend_toggle_action = !0, !(ZC.move || (zingchart.SN(i), i.which > 1))) {
            var a,
              n,
              l,
              r = i.targetid || i.target.id,
              o = ZC._b_(t.BC.BR.o.reorder);
            ZC.mobile && t.H.A7 && t.H.A7.hide();
            var s = "item";
            -1 !== r.indexOf("-legend-marker_") && (s = "marker"), t.KW(), i.preventDefault();
            var C = t.BC.IQ;
            "item" === s ? C = t.BC.RH : "marker" === s && (C = t.BC.Q5), t.A.KE && (C = "remove"), t.E["legend-last-trigger"] = s;
            var A = ZC._i_(r.replace(t.K + "-legend-item_", "").replace(t.K + "-legend-marker_", "").replace("-area", ""));
            if (t.o[ZC._[11]] && t.o[ZC._[11]][A]) {
              if (null !== ZC._n_(e = t.o[ZC._[11]][A]["legend-item"])) {
                var Z = e.url || "",
                  c = e.target || "";
                "" !== Z && t.UI(i, Z, c);
              }
              t.o[ZC._[11]][A].visible = !0;
            }
            var p,
              u,
              h,
              _ = t.AY.A4[A].TF(i);
            switch (_.visible = ZC._b_(t.E["plot" + A + ".visible"]), ZC.AQ.BZ("legend_click", t.A, _), ZC.AQ.BZ("legend_" + s + "_click", t.A, _), C) {
              default:
                break;
              case "hide":
              case "remove":
                if (i.shiftKey) {
                  var d = 0;
                  for (a = 0, n = t.AY.A4.length; a < n; a++) if (a !== A && (l = ++d === n - 1, t.PB({
                    "ignore-legend": o,
                    JY: l,
                    plotindex: a,
                    "toggle-action": C
                  }), t.BC.Q3)) for (p = 0, u = t.H.AG.length; p < u; p++) (h = t.H.AG[p]).BC && h.BC.Q3 && h.BC.A5C === t.BC.A5C && h.K !== t.K && h.PB({
                    "ignore-legend": !0,
                    JY: l,
                    plotindex: a,
                    "toggle-action": C
                  });
                } else if (t.PB({
                  "ignore-legend": o,
                  JY: 1,
                  plotindex: A,
                  "toggle-action": C
                }), t.BC.Q3) for (p = 0, u = t.H.AG.length; p < u; p++) (h = t.H.AG[p]).BC && h.BC.Q3 && h.BC.A5C === t.BC.A5C && h.K !== t.K && h.PB({
                  "ignore-legend": !0,
                  JY: 1,
                  plotindex: A,
                  "toggle-action": C
                });
            }
            "hide" === C && t.E.hooks && (t.OA(), t.Q1());
          }
        }, ZC.A5("." + t.K + "-legend-item-area").live("mouseup touchstart", t.SZ).live("DOMMouseScroll", t.zc_legend_mousescroll).live("mousewheel", t.zc_legend_mousescroll), ZC.A5("." + t.K + "-legend-marker-area").live("mouseup touchstart", t.SZ).live("DOMMouseScroll", t.zc_legend_mousescroll).live("mousewheel", t.zc_legend_mousescroll), ZC.A5("#" + t.K + "-legend-frame").live("DOMMouseScroll", t.zc_legend_mousescroll).live("mousewheel", t.zc_legend_mousescroll), ZC.mobile || (ZC.A5("." + t.K + "-legend-item-area").live(ZC.Q.BX("mouseover"), t.QX).live(ZC.Q.BX("mouseout"), t.RN).live(ZC.Q.BX(ZC._[48]), t.PZ), ZC.A5("." + t.K + "-legend-marker-area").live(ZC.Q.BX("mouseover"), t.QX).live(ZC.Q.BX("mouseout"), t.RN).live(ZC.Q.BX(ZC._[48]), t.PZ)));
      }
    }
  };
  var AB0 = /*#__PURE__*/function (_K) {
    _inherits(AB0, _K);
    function AB0(e) {
      var _this21;
      _classCallCheck(this, AB0);
      _this21 = _possibleConstructorReturn(this, _getPrototypeOf(AB0).call(this, e));
      var t = _assertThisInitialized(_this21);
      t.AF = "null", t.AJ.clip = !0, t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0;
      return _this21;
    }
    return AB0;
  }(K2);
  var A99 = /*#__PURE__*/function (_K2) {
    _inherits(A99, _K2);
    function A99(e) {
      var _this22;
      _classCallCheck(this, A99);
      _this22 = _possibleConstructorReturn(this, _getPrototypeOf(A99).call(this, e));
      var t = _assertThisInitialized(_this22);
      t.AF = "null3d", t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ["x-angle-min"] = -1800, t.AJ["x-angle-max"] = 1800, t.AJ["y-angle-min"] = -1800, t.AJ["y-angle-max"] = 1800, t.AJ["z-angle-min"] = -1800, t.AJ["z-angle-max"] = 1800, zingchart.V3D = 3;
      return _this22;
    }
    _createClass(A99, [{
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(A99.prototype), "clear", this).call(this), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A99.prototype), "paint", this).call(this), e.PH(), e.RV(), e.flatten(), e.JW(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A99;
  }(K2);
  var NU = /*#__PURE__*/function (_K3) {
    _inherits(NU, _K3);
    function NU(e) {
      var _this23;
      _classCallCheck(this, NU);
      _this23 = _possibleConstructorReturn(this, _getPrototypeOf(NU).call(this, e));
      var t = _assertThisInitialized(_this23);
      t.AF = "xy", t.AJ.clip = !0, t.AJ.layout = "xy";
      return _this23;
    }
    _createClass(NU, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            return new TI(this);
          case "y":
            return new TH(this);
        }
      }
    }, {
      key: "O2",
      value: function O2() {
        var e,
          t = this,
          i = t.FA("x", ZC._[50]);
        for (i.BG = ZC._[50], i.K = t.K + "-scale-x", t.BO.push(i), e = 2; e < 50; e++) if (null !== ZC._n_(t.o["scale-x-" + e])) {
          var a = t.FA("x", "scale-x-" + e);
          a.L = e, a.BG = "scale-x-" + e, a.K = t.K + "-scale-x-" + e, t.BO.push(a);
        }
        var n = t.FA("y", ZC._[51]);
        for (n.BG = ZC._[51], n.K = t.K + "-scale-y", t.BO.push(n), e = 2; e < 50; e++) if (null !== ZC._n_(t.o["scale-y-" + e])) {
          var l = t.FA("y", "scale-y-" + e);
          l.L = e, l.BG = "scale-y-" + e, l.K = t.K + "-scale-y-" + e, t.BO.push(l);
        }
        _get(_getPrototypeOf(NU.prototype), "O2", this).call(this);
      }
    }]);
    return NU;
  }(K2);
  var A6Z = /*#__PURE__*/function (_NU) {
    _inherits(A6Z, _NU);
    function A6Z(e) {
      var _this24;
      _classCallCheck(this, A6Z);
      _this24 = _possibleConstructorReturn(this, _getPrototypeOf(A6Z).call(this, e));
      var t = _assertThisInitialized(_this24);
      t.AF = "line", t.AY = new A4R(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this24;
    }
    return A6Z;
  }(NU);
  var A6L = /*#__PURE__*/function (_NU2) {
    _inherits(A6L, _NU2);
    function A6L(e) {
      var _this25;
      _classCallCheck(this, A6L);
      _this25 = _possibleConstructorReturn(this, _getPrototypeOf(A6L).call(this, e));
      var t = _assertThisInitialized(_this25);
      t.AF = "area", t.AY = new A4N(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this25;
    }
    return A6L;
  }(NU);
  var A9T = /*#__PURE__*/function (_NU3) {
    _inherits(A9T, _NU3);
    function A9T(e) {
      var _this26;
      _classCallCheck(this, A9T);
      _this26 = _possibleConstructorReturn(this, _getPrototypeOf(A9T).call(this, e));
      var t = _assertThisInitialized(_this26);
      t.AF = "vline", t.AJ.layout = "yx", t.AY = new A88(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this26;
    }
    _createClass(A9T, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            return new VH(this);
          case "y":
            return new VG(this);
        }
      }
    }]);
    return A9T;
  }(NU);
  var AAB = /*#__PURE__*/function (_NU4) {
    _inherits(AAB, _NU4);
    function AAB(e) {
      var _this27;
      _classCallCheck(this, AAB);
      _this27 = _possibleConstructorReturn(this, _getPrototypeOf(AAB).call(this, e));
      var t = _assertThisInitialized(_this27);
      t.AF = "varea", t.AJ.layout = "yx", t.AY = new A8D(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this27;
    }
    _createClass(AAB, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            return new VH(this);
          case "y":
            return new VG(this);
        }
      }
    }]);
    return AAB;
  }(NU);
  var A30 = /*#__PURE__*/function (_NU5) {
    _inherits(A30, _NU5);
    function A30(e) {
      var _this28;
      _classCallCheck(this, A30);
      _this28 = _possibleConstructorReturn(this, _getPrototypeOf(A30).call(this, e));
      var t = _assertThisInitialized(_this28);
      t.AF = "vbar", t.AY = new A13(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this28;
    }
    _createClass(A30, [{
      key: "FA",
      value: function FA(e, t) {
        switch (e) {
          case "x":
            var i = _get(_getPrototypeOf(A30.prototype), "FA", this).call(this, e, t);
            return i.DI = !0, i;
          case "y":
            return _get(_getPrototypeOf(A30.prototype), "FA", this).call(this, e, t);
        }
      }
    }]);
    return A30;
  }(NU);
  var A31 = /*#__PURE__*/function (_NU6) {
    _inherits(A31, _NU6);
    function A31(e) {
      var _this29;
      _classCallCheck(this, A31);
      _this29 = _possibleConstructorReturn(this, _getPrototypeOf(A31).call(this, e));
      var t = _assertThisInitialized(_this29);
      t.AF = "hbar", t.AJ.layout = "yx", t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0, t.AY = new A0Q(t);
      return _this29;
    }
    _createClass(A31, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            var t = new VH(this);
            return t.DI = !0, t;
          case "y":
            return new VG(this);
        }
      }
    }]);
    return A31;
  }(NU);
  var A5X = /*#__PURE__*/function (_NU7) {
    _inherits(A5X, _NU7);
    function A5X(e) {
      var _this30;
      _classCallCheck(this, A5X);
      _this30 = _possibleConstructorReturn(this, _getPrototypeOf(A5X).call(this, e));
      var t = _assertThisInitialized(_this30);
      t.AF = "mixed", t.AY = new ZZ(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this30;
    }
    _createClass(A5X, [{
      key: "FA",
      value: function FA(e, t) {
        switch (e) {
          case "x":
            var i = !1;
            if (this.o[ZC._[11]]) for (var a = 0; a < this.o[ZC._[11]].length; a++) if (this.o[ZC._[11]][a] && this.o[ZC._[11]][a].type && -1 !== ZC.AV(["bar", "vbar", "bullet", "vbullet", "stock", "vbar3d"], this.o[ZC._[11]][a].type)) {
              var n = (this.o[ZC._[11]][a].scales || "scale-x,scale-y").split(",");
              -1 !== ZC.AV(n, t) && (i = !0);
            }
            var l = _get(_getPrototypeOf(A5X.prototype), "FA", this).call(this, e, t);
            return l.DI = i, l;
          case "y":
            return _get(_getPrototypeOf(A5X.prototype), "FA", this).call(this, e, t);
        }
      }
    }]);
    return A5X;
  }(NU);
  var A9D = /*#__PURE__*/function (_NU8) {
    _inherits(A9D, _NU8);
    function A9D(e) {
      var _this31;
      _classCallCheck(this, A9D);
      _this31 = _possibleConstructorReturn(this, _getPrototypeOf(A9D).call(this, e));
      var t = _assertThisInitialized(_this31);
      t.AF = "hmixed", t.AJ.layout = "yx", t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !1, t.AJ["enable-scroll"] = !0, t.AY = new ZZ(t);
      return _this31;
    }
    _createClass(A9D, [{
      key: "FA",
      value: function FA(e, t) {
        switch (e) {
          case "x":
            var i = new VH(this),
              a = !1;
            if (this.o[ZC._[11]]) for (var n = 0; n < this.o[ZC._[11]].length; n++) if (this.o[ZC._[11]][n] && this.o[ZC._[11]][n].type && -1 !== ZC.AV(["hbar", "hbullet"], this.o[ZC._[11]][n].type)) {
              var l = (this.o[ZC._[11]][n].scales || "scale-x,scale-y").split(",");
              -1 !== ZC.AV(l, t) && (a = !0);
            }
            return i.DI = a, i;
          case "y":
            return new VG(this);
        }
      }
    }]);
    return A9D;
  }(NU);
  var A3F = /*#__PURE__*/function (_A5X) {
    _inherits(A3F, _A5X);
    function A3F(e) {
      var _this32;
      _classCallCheck(this, A3F);
      _this32 = _possibleConstructorReturn(this, _getPrototypeOf(A3F).call(this, e));
      var t = _assertThisInitialized(_this32);
      t.AF = "mixed3d", t.AY = new ZZ(t), t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ[ZC._[56]] = !1, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0;
      return _this32;
    }
    _createClass(A3F, [{
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(A3F.prototype), "clear", this).call(this), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A3F.prototype), "paint", this).call(this), e.RV(), e.flatten(), e.PH(), e.FE.length && (e.CJ.clear(), e.JW(), e.RV()), e.TB(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A3F;
  }(A5X);
  var A8N = /*#__PURE__*/function (_NU9) {
    _inherits(A8N, _NU9);
    function A8N(e) {
      var _this33;
      _classCallCheck(this, A8N);
      _this33 = _possibleConstructorReturn(this, _getPrototypeOf(A8N).call(this, e));
      var t = _assertThisInitialized(_this33);
      t.AF = "scatter", t.AY = new A7H(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this33;
    }
    return A8N;
  }(NU);
  var A80 = /*#__PURE__*/function (_NU10) {
    _inherits(A80, _NU10);
    function A80(e) {
      var _this34;
      _classCallCheck(this, A80);
      _this34 = _possibleConstructorReturn(this, _getPrototypeOf(A80).call(this, e));
      var t = _assertThisInitialized(_this34);
      t.AF = "hscatter", t.AJ.layout = "yx", t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !1, t.AJ["enable-scroll"] = !0, t.AY = new A6J(t);
      return _this34;
    }
    _createClass(A80, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            return new VH(this);
          case "y":
            return new VG(this);
        }
      }
    }]);
    return A80;
  }(NU);
  var A9B = /*#__PURE__*/function (_NU11) {
    _inherits(A9B, _NU11);
    function A9B(e) {
      var _this35;
      _classCallCheck(this, A9B);
      _this35 = _possibleConstructorReturn(this, _getPrototypeOf(A9B).call(this, e));
      var t = _assertThisInitialized(_this35);
      t.AF = "bubble", t.AY = new A7Y(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !0, t.AJ["enable-scroll"] = !0;
      return _this35;
    }
    return A9B;
  }(NU);
  var A8R = /*#__PURE__*/function (_NU12) {
    _inherits(A8R, _NU12);
    function A8R(e) {
      var _this36;
      _classCallCheck(this, A8R);
      _this36 = _possibleConstructorReturn(this, _getPrototypeOf(A8R).call(this, e));
      var t = _assertThisInitialized(_this36);
      t.AF = "hbubble", t.AJ.layout = "yx", t.AJ[ZC._[23]] = !0, t.AJ[ZC._[56]] = !1, t.AJ["enable-scroll"] = !0, t.AY = new A7I(t);
      return _this36;
    }
    _createClass(A8R, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            return new VH(this);
          case "y":
            return new VG(this);
        }
      }
    }]);
    return A8R;
  }(NU);
  var A4K = /*#__PURE__*/function (_K4) {
    _inherits(A4K, _K4);
    function A4K(e) {
      var _this37;
      _classCallCheck(this, A4K);
      _this37 = _possibleConstructorReturn(this, _getPrototypeOf(A4K).call(this, e)), _this37.AF = "pie", _this37.AY = new A53(_assertThisInitialized(_this37));
      return _this37;
    }
    _createClass(A4K, [{
      key: "NR",
      value: function NR() {
        return "";
      }
    }, {
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "m":
            return new YK(this);
          case "v":
            return new ZY(this);
          case "r":
            return new A97(this);
        }
      }
    }, {
      key: "O2",
      value: function O2() {
        var e = this,
          t = e.FA("m", "scale"),
          i = e.FA("v", ZC._[52]),
          a = e.FA("r", "scale-r");
        t.BG = "scale", t.K = e.K + "-scale", e.o[ZC._[11]] && e.o[ZC._[11]].length && e.o[ZC._[11]][0][ZC._[5]] && (t.NS = "1x" + e.o[ZC._[11]][0][ZC._[5]].length), i.BG = ZC._[52], i.K = e.K + "-scale-v", a.BG = "scale-r", a.K = e.K + "-scale-r", e.BO.push(t, i, a), _get(_getPrototypeOf(A4K.prototype), "O2", this).call(this);
      }
    }, {
      key: "clear_",
      value: function clear_() {
        -1 !== ZC.AV(["svg", "vml"], this.H.AA) && ZC.A5("#" + this.K + " .zc-layer").each(function () {
          /\-plot-\d+\-bl\-\d+\-/.test(this.id) && ZC.A5(this).children().each(function () {
            /\-connector\-path/.test(this.id) && ZC.Q.EU(this);
          });
        });
      }
    }]);
    return A4K;
  }(K2);
  var A7G = /*#__PURE__*/function (_K5) {
    _inherits(A7G, _K5);
    function A7G(e) {
      var _this38;
      _classCallCheck(this, A7G);
      _this38 = _possibleConstructorReturn(this, _getPrototypeOf(A7G).call(this, e));
      var t = _assertThisInitialized(_this38);
      t.AF = "nestedpie", t.AY = new A5G(t);
      return _this38;
    }
    _createClass(A7G, [{
      key: "NR",
      value: function NR() {
        return "";
      }
    }, {
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "m":
            return new YK(this);
        }
      }
    }, {
      key: "O2",
      value: function O2() {
        var e = this,
          t = e.FA("m", "scale");
        t.BG = "scale", t.K = e.K + "-scale", e.BO.push(t), _get(_getPrototypeOf(A7G.prototype), "O2", this).call(this);
      }
    }]);
    return A7G;
  }(K2);
  var A9V = /*#__PURE__*/function (_K6) {
    _inherits(A9V, _K6);
    function A9V(e) {
      var _this39;
      _classCallCheck(this, A9V);
      _this39 = _possibleConstructorReturn(this, _getPrototypeOf(A9V).call(this, e));
      var t = _assertThisInitialized(_this39);
      if (t.AF = "radar", t.AJ.layout = "radar", t.AY = new A8H(t), -1 !== ZC.AV(t.A.K, "polar")) {
        for (var i = 1, a = 0; a < t.A.MJ.series.length; a++) i = ZC.BQ(i, t.A.MJ.series[a][ZC._[5]].length);
        i = Math.round(360 / i).toString(), null === ZC._n_(t.A.MJ.plot) ? t.A.MJ.plot = {
          aspect: "area"
        } : ZC._cp_({
          aspect: "area"
        }, t.A.MJ.plot), null === ZC._n_(t.A.MJ["scale-k"]) ? t.A.MJ["scale-k"] = {
          aspect: "circle",
          format: "%v\xb0",
          values: "0:330:" + i
        } : ZC._cp_({
          aspect: "circle",
          format: "%v\xb0",
          values: "0:330:" + i
        }, t.A.MJ["scale-k"], !0);
      }
      return _this39;
    }
    _createClass(A9V, [{
      key: "NR",
      value: function NR() {
        return "";
      }
    }, {
      key: "FA",
      value: function FA(e) {
        var t = this;
        switch (e) {
          case "m":
            return new YK(t);
          case "k":
            return new A87(t);
          case "v":
            return new A8A(t);
        }
      }
    }, {
      key: "O2",
      value: function O2() {
        var e = this,
          t = e.FA("k", "scale-k");
        t.BG = "scale-k", t.K = e.K + "-scale-k", e.BO.push(t);
        var i = e.FA("v", ZC._[52]);
        i.BG = ZC._[52], i.K = e.K + "-scale-v", e.BO.push(i);
        var a = e.FA("m", "scale");
        a.BG = "scale", a.K = e.K + "-scale", e.BO.push(a), _get(_getPrototypeOf(A9V.prototype), "O2", this).call(this);
      }
    }]);
    return A9V;
  }(K2);
  var A8K = /*#__PURE__*/function (_A) {
    _inherits(A8K, _A);
    function A8K(e) {
      var _this40;
      _classCallCheck(this, A8K);
      _this40 = _possibleConstructorReturn(this, _getPrototypeOf(A8K).call(this, e));
      var t = _assertThisInitialized(_this40);
      t.AF = "vbullet", t.AY = new A78(t), t.AJ[ZC._[55]] = !1;
      return _this40;
    }
    return A8K;
  }(A30);
  var A8P = /*#__PURE__*/function (_A2) {
    _inherits(A8P, _A2);
    function A8P(e) {
      var _this41;
      _classCallCheck(this, A8P);
      _this41 = _possibleConstructorReturn(this, _getPrototypeOf(A8P).call(this, e));
      var t = _assertThisInitialized(_this41);
      t.AF = "hbullet", t.AJ.layout = "yx", t.AY = new A71(t), t.AJ[ZC._[55]] = !1;
      return _this41;
    }
    return A8P;
  }(A31);
  var AA0 = /*#__PURE__*/function (_NU13) {
    _inherits(AA0, _NU13);
    function AA0(e) {
      var _this42;
      _classCallCheck(this, AA0);
      _this42 = _possibleConstructorReturn(this, _getPrototypeOf(AA0).call(this, e));
      var t = _assertThisInitialized(_this42);
      t.AF = "piano", t.AY = new A8Y(t), t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0;
      return _this42;
    }
    _createClass(AA0, [{
      key: "UO",
      value: function UO(e) {
        var t = this;
        if ("v" === e) {
          var i = [];
          if (t.o[ZC._[11]] && t.o[ZC._[11]].length) for (var a = 0; a < t.o[ZC._[11]].length; a++) i.push(t.o[ZC._[11]][a].text || "Metric " + (a + 1));
          return i;
        }
      }
    }, {
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            var t = new TI(this);
            return t.DI = !0, t;
          case "y":
            var i = new TH(this);
            return i.DI = !0, i.append({
              step: 1,
              "fixed-step": !0
            }), i;
        }
      }
    }]);
    return AA0;
  }(NU);
  var A8W = /*#__PURE__*/function (_NU14) {
    _inherits(A8W, _NU14);
    function A8W(e) {
      var _this43;
      _classCallCheck(this, A8W);
      _this43 = _possibleConstructorReturn(this, _getPrototypeOf(A8W).call(this, e));
      var t = _assertThisInitialized(_this43);
      t.AF = "vfunnel", t.AY = new A7F(t), t.AJ[ZC._[55]] = !1, t.AJ["enable-zooming"] = !1, t.AJ["enable-scroll"] = !1;
      return _this43;
    }
    _createClass(A8W, [{
      key: "FA",
      value: function FA(e, t) {
        switch (e) {
          case "x":
            var i = _get(_getPrototypeOf(A8W.prototype), "FA", this).call(this, e, t);
            return i.DI = !0, i;
          case "y":
            var a = _get(_getPrototypeOf(A8W.prototype), "FA", this).call(this, e, t);
            return a.DI = !0, a;
        }
      }
    }, {
      key: "UO",
      value: function UO(e) {
        if ("v" === e) {
          for (var t = [], i = 0; i < this.o[ZC._[11]].length; i++) t.push("Step " + (i + 1));
          return t;
        }
      }
    }, {
      key: "paint",
      value: function paint() {
        for (var e = this, t = 0, i = e.BO.length; t < i; t++) "v" === e.BO[t].AF && (e.BO[t].AW = !e.BO[t].AW);
        _get(_getPrototypeOf(A8W.prototype), "paint", this).call(this);
      }
    }]);
    return A8W;
  }(NU);
  var A8T = /*#__PURE__*/function (_NU15) {
    _inherits(A8T, _NU15);
    function A8T(e) {
      var _this44;
      _classCallCheck(this, A8T);
      _this44 = _possibleConstructorReturn(this, _getPrototypeOf(A8T).call(this, e));
      var t = _assertThisInitialized(_this44);
      t.AF = "hfunnel", t.AY = new A7E(t), t.AJ[ZC._[55]] = !1, t.AJ["enable-zooming"] = !1, t.AJ["enable-scroll"] = !1;
      return _this44;
    }
    _createClass(A8T, [{
      key: "UO",
      value: function UO(e) {
        if ("v" === e) {
          for (var t = [], i = 0; i < this.o[ZC._[11]].length; i++) t.push("Step " + (i + 1));
          return t;
        }
      }
    }, {
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            var t = new VH(this);
            return t.DI = !0, t;
          case "y":
            var i = new VG(this);
            return i.DI = !0, i;
        }
      }
    }]);
    return A8T;
  }(NU);
  var AAD = /*#__PURE__*/function (_NU16) {
    _inherits(AAD, _NU16);
    function AAD(e) {
      var _this45;
      _classCallCheck(this, AAD);
      _this45 = _possibleConstructorReturn(this, _getPrototypeOf(AAD).call(this, e));
      var t = _assertThisInitialized(_this45);
      t.AF = "stock", t.AY = new A8J(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0, t.AJ[ZC._[56]] = !0;
      return _this45;
    }
    _createClass(AAD, [{
      key: "FA",
      value: function FA(e, t) {
        switch (e) {
          case "x":
            var i = _get(_getPrototypeOf(AAD.prototype), "FA", this).call(this, e, t);
            return i.DI = !0, i;
          case "y":
            return _get(_getPrototypeOf(AAD.prototype), "FA", this).call(this, e, t);
        }
      }
    }]);
    return AAD;
  }(NU);
  var AAJ = /*#__PURE__*/function (_K7) {
    _inherits(AAJ, _K7);
    function AAJ(e) {
      var _this46;
      _classCallCheck(this, AAJ);
      _this46 = _possibleConstructorReturn(this, _getPrototypeOf(AAJ).call(this, e));
      var t = _assertThisInitialized(_this46);
      t.AF = "gauge", t.AJ.layout = "gauge", t.AY = new A8E(t);
      return _this46;
    }
    _createClass(AAJ, [{
      key: "NR",
      value: function NR() {
        return "";
      }
    }, {
      key: "FA",
      value: function FA(e) {
        var t = this;
        switch (e) {
          case "m":
            return new YK(t);
          case "r":
            return new A8B(t);
          case "v":
            return new ZY(t);
        }
      }
    }, {
      key: "O2",
      value: function O2() {
        var e,
          t = this,
          i = t.FA("m", "scale");
        for (i.BG = "scale", i.K = t.K + "-scale", t.BO.push(i), e = 2; e < 10; e++) if (null !== ZC._n_(t.o["scale-" + e])) {
          var a = t.FA("m", "scale-" + e);
          a.L = e, a.BG = "scale-" + e, a.K = t.K + "-scale-" + e, t.BO.push(a);
        }
        var n = t.FA("r", "scale-r");
        for (n.BG = "scale-r", n.K = t.K + "-scale-r", t.BO.push(n), e = 2; e < 10; e++) if (null !== ZC._n_(t.o["scale-r-" + e])) {
          var l = t.FA("r", "scale-r-" + e);
          l.L = e, l.BG = "scale-r-" + e, l.K = t.K + "-scale-r-" + e, t.BO.push(l);
        }
        _get(_getPrototypeOf(AAJ.prototype), "O2", this).call(this);
      }
    }, {
      key: "hideLayer_",
      value: function hideLayer_() {
        var e = this;
        ZC.A5("#" + e.K + "-plots-bl-2").children().each(function () {
          ZC.Q.IT(this, e.H.AA, e.iX, e.iY, e.I, e.F, e.K);
        });
      }
    }]);
    return AAJ;
  }(K2);
  var AAQ = /*#__PURE__*/function (_NU17) {
    _inherits(AAQ, _NU17);
    function AAQ(e) {
      var _this47;
      _classCallCheck(this, AAQ);
      _this47 = _possibleConstructorReturn(this, _getPrototypeOf(AAQ).call(this, e));
      var t = _assertThisInitialized(_this47);
      t.AF = "range", t.AY = new A8X(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0, t.AJ[ZC._[56]] = !0;
      return _this47;
    }
    return AAQ;
  }(NU);
  var ZCVRangeGraph = /*#__PURE__*/function (_NU18) {
    _inherits(ZCVRangeGraph, _NU18);
    function ZCVRangeGraph(e) {
      var _this48;
      _classCallCheck(this, ZCVRangeGraph);
      _this48 = _possibleConstructorReturn(this, _getPrototypeOf(ZCVRangeGraph).call(this, e));
      var t = _assertThisInitialized(_this48);
      t.AF = "range", t.AJ.layout = "yx", t.AY = new ZCVRangePlotSet(t), t.AJ[ZC._[23]] = !0, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0, t.AJ[ZC._[56]] = !1;
      return _this48;
    }
    _createClass(ZCVRangeGraph, [{
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "x":
            return new VH(this);
          case "y":
            return new VG(this);
        }
      }
    }]);
    return ZCVRangeGraph;
  }(NU);
  var A5I = /*#__PURE__*/function (_A4K) {
    _inherits(A5I, _A4K);
    function A5I(e) {
      var _this49;
      _classCallCheck(this, A5I);
      _this49 = _possibleConstructorReturn(this, _getPrototypeOf(A5I).call(this, e));
      var t = _assertThisInitialized(_this49);
      t.AF = "pie3d", t.AY = new A8Q(t), t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ[ZC._[55]] = !1, t.AJ["x-angle-min"] = 15, t.AJ["x-angle-max"] = 75, t.AJ["y-angle-min"] = 0, t.AJ["y-angle-max"] = 0, t.AJ["z-angle-min"] = 0, t.AJ["z-angle-max"] = 0;
      return _this49;
    }
    _createClass(A5I, [{
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(A5I.prototype), "clear", this).call(this), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A5I.prototype), "paint", this).call(this), e.RV(), e.flatten(), e.PH(), e.FE.length && (e.CJ.clear(), e.JW(), e.RV()), e.TB(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A5I;
  }(A4K);
  var A9C = /*#__PURE__*/function (_A3) {
    _inherits(A9C, _A3);
    function A9C(e) {
      var _this50;
      _classCallCheck(this, A9C);
      _this50 = _possibleConstructorReturn(this, _getPrototypeOf(A9C).call(this, e));
      var t = _assertThisInitialized(_this50);
      t.AF = "hbar3d", t.AY = new A7J(t), t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ[ZC._[56]] = !1, t.AJ[ZC._[55]] = !1, t.AJ["x-angle-min"] = -20, t.AJ["x-angle-max"] = 20, t.AJ["y-angle-min"] = -20, t.AJ["y-angle-max"] = 0;
      return _this50;
    }
    _createClass(A9C, [{
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(A9C.prototype), "clear", this).call(this), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A9C.prototype), "paint", this).call(this), e.RV(), e.flatten(), e.PH(), e.FE.length && (e.CJ.clear(), e.JW(), e.RV()), e.TB(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A9C;
  }(A31);
  var A9J = /*#__PURE__*/function (_A4) {
    _inherits(A9J, _A4);
    function A9J(e) {
      var _this51;
      _classCallCheck(this, A9J);
      _this51 = _possibleConstructorReturn(this, _getPrototypeOf(A9J).call(this, e));
      var t = _assertThisInitialized(_this51);
      t.AF = "vbar3d", t.AY = new A7K(t), t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ[ZC._[56]] = !0, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0;
      return _this51;
    }
    _createClass(A9J, [{
      key: "clear",
      value: function clear(e, t) {
        _get(_getPrototypeOf(A9J.prototype), "clear", this).call(this, e, t), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A9J.prototype), "paint", this).call(this), e.RV(), e.flatten(), e.PH(), e.FE.length && (e.CJ.clear(), e.JW(), e.RV()), e.TB(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A9J;
  }(A30);
  var A9I = /*#__PURE__*/function (_A6Z) {
    _inherits(A9I, _A6Z);
    function A9I(e) {
      var _this52;
      _classCallCheck(this, A9I);
      _this52 = _possibleConstructorReturn(this, _getPrototypeOf(A9I).call(this, e));
      var t = _assertThisInitialized(_this52);
      t.AF = "line3d", t.AY = new A84(t), t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ[ZC._[56]] = !0, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0;
      return _this52;
    }
    _createClass(A9I, [{
      key: "clear",
      value: function clear(e, t) {
        _get(_getPrototypeOf(A9I.prototype), "clear", this).call(this, e, t), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A9I.prototype), "paint", this).call(this), e.RV(), e.flatten(), e.PH(), e.FE.length && (e.CJ.clear(), e.JW(), e.RV()), e.TB(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A9I;
  }(A6Z);
  var A9G = /*#__PURE__*/function (_A6L) {
    _inherits(A9G, _A6L);
    function A9G(e) {
      var _this53;
      _classCallCheck(this, A9G);
      _this53 = _possibleConstructorReturn(this, _getPrototypeOf(A9G).call(this, e));
      var t = _assertThisInitialized(_this53);
      t.AF = "area3d", t.AY = new A83(t), t.CJ = new VP(), t.AJ["3d"] = !0, t.AJ[ZC._[56]] = !0, t.AJ[ZC._[55]] = !1, t.AJ["enable-scroll"] = !0;
      return _this53;
    }
    _createClass(A9G, [{
      key: "clear",
      value: function clear(e, t) {
        _get(_getPrototypeOf(A9G.prototype), "clear", this).call(this, e, t), this.CJ.clear();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A9G.prototype), "paint", this).call(this), e.RV(), e.flatten(), e.PH(), e.FE.length && (e.CJ.clear(), e.JW(), e.RV()), e.TB(), -1 === ZC.AV(e.H.L0, ZC._[41]) && e.Q7();
      }
    }]);
    return A9G;
  }(A6L);
  var AAU = /*#__PURE__*/function (_K8) {
    _inherits(AAU, _K8);
    function AAU(e) {
      var _this54;
      _classCallCheck(this, AAU);
      _this54 = _possibleConstructorReturn(this, _getPrototypeOf(AAU).call(this, e));
      var t = _assertThisInitialized(_this54);
      t.AF = "venn", t.AY = new A9F(t);
      return _this54;
    }
    _createClass(AAU, [{
      key: "NR",
      value: function NR() {
        return "";
      }
    }, {
      key: "FA",
      value: function FA(e) {
        switch (e) {
          case "m":
            return new YK(this);
        }
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        _get(_getPrototypeOf(AAU.prototype), "parse", this).call(this), e.BC && (e.BC.IQ = "remove", e.BC.RH = "remove", e.BC.Q5 = "remove");
      }
    }, {
      key: "O2",
      value: function O2() {
        var e = this,
          t = e.FA("m", "scale");
        t.BG = "scale", t.K = e.K + "-scale", e.BO.push(t), _get(_getPrototypeOf(AAU.prototype), "O2", this).call(this);
      }
    }]);
    return AAU;
  }(K2);
  var LX = /*#__PURE__*/function (_I5) {
    _inherits(LX, _I5);
    function LX(e) {
      var _this55;
      _classCallCheck(this, LX);
      _this55 = _possibleConstructorReturn(this, _getPrototypeOf(LX).call(this, e));
      var t = _assertThisInitialized(_this55);
      t.C = e, t.H = t.C.A, t.A4 = [], t.HK = null, t.KI = [], t.K9 = [], t.QD = !0, t.F9 = null, t.A5U = !0, t.ZN = [];
      return _this55;
    }
    _createClass(LX, [{
      key: "HP",
      value: function HP() {
        return new IM(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a = this;
        for (a.K = a.A.K + "-plotset", a.F9 = null, t = a.o.length - 1; t >= 0; t--) typeof a.o[t] === ZC._[31] && a.o.splice(t, 1);
        if (null === ZC._n_(a.E["plot-sort"]) && (a.E["plot-sort"] = !1), a.o.length > 1) {
          for (t = 0, i = a.o.length; t < i; t++) typeof a.o[t].palette === ZC._[31] && (a.o[t].palette = t);
          var n = [],
            l = [];
          for (t = 0, i = a.o.length; t < i; t++) l[t] = t, n[t] = {
            "z-index": a.o[t]["z-index"] || 0
          };
          for (var r = !1; !r;) for (r = !0, t = 0, i = n.length; t < i - 1; t++) {
            if (n[t]["z-index"] > n[t + 1]["z-index"]) {
              a.E["plot-sort"] = !0;
              var o = n[t];
              n[t] = n[t + 1], n[t + 1] = o;
              var s = l[t];
              l[t] = l[t + 1], l[t + 1] = s, r = !1;
            }
          }
          a.MF = l;
        } else a.MF = [0];
        for (a.A4 = [], t = 0, i = a.o.length; t < i; t++) {
          var C = "";
          a.A.o.plot && null !== ZC._n_(e = a.A.o.plot.type) && (C = e), null !== ZC._n_(e = a.o[t].type) && (C = e);
          var A = a.HP(C, t);
          A.OP = A.AF + "plot", A.L = t, A.JX = t, a.C.A.B8.load(A.o, ["(" + A.AF + ").plot"]), A.sTypeX && a.C.A.B8.load(A.o, ["(" + A.sTypeX + ").plot"]), a.C.A.B8.load(A.o, ["(" + A.AF + ").plot.animation"]), null !== ZC._n_(e = a.A.o.plot) && A.append(e), A.append(a.o[t]), A.CB = a.A.CB, A.parse(), a.A4.push(A);
        }
        var Z = {},
          c = [],
          p = [],
          u = {},
          h = {},
          _ = 0,
          d = 0;
        for (t = 0, i = a.A4.length; t < i; t++) if (null !== ZC._n_(a.A.A.E["g-" + a.A.L + "-p-" + t + ".visible"]) && (a.C.E["plot" + t + ".visible"] = a.A.A.E["g-" + a.A.L + "-p-" + t + ".visible"]), !a.A4[t].HV && (a.C.E["plot" + t + ".visible"] || "hide" === a.C.getToggleAction())) {
          a.A4[t].CB ? (-1 === (d = ZC.AV(p, a.A4[t].DY)) && (p.push(a.A4[t].DY), d = p.length - 1), null === ZC._n_(c[d]) ? c[d] = [t] : c[d].push(t)) : (p.push(-1), d = p.length - 1, null === ZC._n_(c[d]) ? c[d] = [t] : c[d].push(t));
          var f = a.A4[t].AF;
          if (a.A4[t].o.type && f !== a.A4[t].o.type) {
            var g = f.indexOf("3d"),
              B = a.A4[t].o.type.indexOf("3d");
            (-1 === g && -1 !== B || -1 === g && -1 === B) && (f = a.A4[t].o.type);
          }
          -1 !== ZC.AV(["bar", "bar3d", "bullet"], f) && (f = "v" + f), -1 === ZC.AV(["vbar", "hbar", "vbullet", "hbullet", "stock", "vbar3d", "hbar3d"], f) || a.A4[t].HV || (null === ZC._n_(u[f]) && (u[f] = []), null === ZC._n_(h[f]) && (h[f] = []), a.A4[t].CB ? (null === ZC._n_(Z[a.A4[t].DY]) ? Z[a.A4[t].DY] = 1 : Z[a.A4[t].DY]++, -1 === (_ = ZC.AV(h[f], a.A4[t].DY)) && (h[f].push(a.A4[t].DY), _ = h[f].length - 1), null === ZC._n_(u[f][_]) ? u[f][_] = [t] : u[f][_].push(t)) : (h[f].push(-1), _ = h[f].length - 1, null === ZC._n_(u[f][_]) ? u[f][_] = [t] : u[f][_].push(t)));
        }
        if (a.KI = c, a.K9 = u, a.XF) for (var v in a.XF) a.XF[v].sort();
        for (a.A2E = [], t = 0; t < a.KI.length; t++) a.A2E.push(a.KI[t][a.KI[t].length - 1]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        function t(i) {
          var a = e.MF[i];
          (e.A4[a].I1 || e.A4[a].E5.length && e.A.B9 || "none" !== e.A4[a].J7) && (e.H.OI = !1), e.A5U = !0;
          var n = e.C.getToggleAction();
          e.A4[a].o["skip-paint"] || (e.C.AJ["3d"] ? e.C.E["plot" + a + ".visible"] && (e.A4[a].paint(), e.H.Y2()) : (e.C.E["plot" + a + ".visible"] || "hide" === n) && (typeof e.C.E["plot-" + a + "-first-run"] !== ZC._[31] && (e.A4[a].U5 = 0), e.A4[a].paint(), e.A4[a].U5 = 0, e.H.Y2(), e.C.E["plot" + a + ".visible"] || "hide" !== n || (e.C.E["plot" + a + ".visible"] = !0, e.A.PB({
            plotindex: a,
            "ignore-legend": !0
          })))), e.C.E["plot-" + a + "-first-run"] = !1, i < e.A4.length - 1 ? e.C.LW ? ZC.ASYNC_TICK[e.C.K] = window.setTimeout(function () {
            t(i + 1);
          }, 10) : e.A4.length <= 100 && t(i + 1) : (!e.C.LW || e.C.LW && e.A5U) && e._end_();
        }
        if (e.HK = [], e.A4.length > 0) {
          if (e.A4.length > 100 && !e.C.LW) for (var i = 0; i < e.A4.length; i++) t(i);else t(0);
        } else e._end_();
      }
    }, {
      key: "_end_",
      value: function _end_() {
        var e,
          t = this;
        t.SC = null, t.WC = null;
        for (var i = 0; i < t.C.BO.length; i++) t.C.BO[i].ET = null, t.C.BO[i].X8 = null;
        function a(e) {
          var i = 0,
            a = e.indexOf(ZC._[35]),
            n = e.indexOf("-node-", a);
          return -1 !== a && -1 !== n && (i = e.substr(a + 14, n - a - 14)), typeof t.A4[i].E["z-mid"] !== ZC._[31] ? t.A4[i].E["z-mid"] : i;
        }
        if ((e = ZC.AK(t.C.A.K + "-map")) && !t.H.A1N) {
          -1 === ZC.AV(["bubble", "hbubble", "vbullet", "hbullet", "radar", "vbar3d", "hbar3d", "mixed", "mixed3d", "pie3d", "hmixed", "hmixed3d"], t.C.AF) && 1 !== zingchart.SORTTRACKERS || t.HK.sort(function (e, i) {
            return "pie3d" === t.C.AF ? ZC.AQ.NC(e) > ZC.AQ.NC(i) ? 1 : ZC.AQ.NC(e) < ZC.AQ.NC(i) ? -1 : 0 : a(e) > a(i) && t.A.AJ["3d"] ? 1 : a(e) < a(i) && t.A.AJ["3d"] ? -1 : ZC.AQ.NC(e) > ZC.AQ.NC(i) ? 1 : ZC.AQ.NC(e) < ZC.AQ.NC(i) ? -1 : 0;
          });
          var n = '<area shape="rect" coords="0,0,1,1" id="mark' + t.A.L + '">',
            l = t.A.a11y(),
            r = e.innerHTML.indexOf(n);
          zingchart.DEV.DELAYEDTRACKERS ? window.setTimeout(function () {
            -1 !== r ? e.innerHTML = e.innerHTML.substring(0, r + n.length) + l + t.HK.join("") + e.innerHTML.substring(r + n.length) : e.innerHTML += l + t.HK.join("");
          }, 500) : -1 !== r ? e.innerHTML = e.innerHTML.substring(0, r + n.length) + l + t.HK.join("") + e.innerHTML.substring(r + n.length) : e.innerHTML += l + t.HK.join("");
        }
        t.F2 = null, t.D5 = null, t.C.AA9 = [], t.A._end_();
      }
    }]);
    return LX;
  }(I3);
  var A4R = /*#__PURE__*/function (_LX) {
    _inherits(A4R, _LX);
    function A4R() {
      _classCallCheck(this, A4R);
      return _possibleConstructorReturn(this, _getPrototypeOf(A4R).apply(this, arguments));
    }
    _createClass(A4R, [{
      key: "HP",
      value: function HP() {
        return new R4(this);
      }
    }]);
    return A4R;
  }(LX);
  var A4N = /*#__PURE__*/function (_LX2) {
    _inherits(A4N, _LX2);
    function A4N() {
      _classCallCheck(this, A4N);
      return _possibleConstructorReturn(this, _getPrototypeOf(A4N).apply(this, arguments));
    }
    _createClass(A4N, [{
      key: "HP",
      value: function HP() {
        return new R0(this);
      }
    }]);
    return A4N;
  }(LX);
  var A88 = /*#__PURE__*/function (_LX3) {
    _inherits(A88, _LX3);
    function A88() {
      _classCallCheck(this, A88);
      return _possibleConstructorReturn(this, _getPrototypeOf(A88).apply(this, arguments));
    }
    _createClass(A88, [{
      key: "HP",
      value: function HP() {
        var e = new R4(this);
        return e.P2 = !0, e;
      }
    }]);
    return A88;
  }(LX);
  var A8D = /*#__PURE__*/function (_LX4) {
    _inherits(A8D, _LX4);
    function A8D() {
      _classCallCheck(this, A8D);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8D).apply(this, arguments));
    }
    _createClass(A8D, [{
      key: "HP",
      value: function HP() {
        var e = new R0(this);
        return e.P2 = !0, e;
      }
    }]);
    return A8D;
  }(LX);
  var A13 = /*#__PURE__*/function (_LX5) {
    _inherits(A13, _LX5);
    function A13() {
      _classCallCheck(this, A13);
      return _possibleConstructorReturn(this, _getPrototypeOf(A13).apply(this, arguments));
    }
    _createClass(A13, [{
      key: "HP",
      value: function HP() {
        return new R3(this);
      }
    }]);
    return A13;
  }(LX);
  var A0Q = /*#__PURE__*/function (_LX6) {
    _inherits(A0Q, _LX6);
    function A0Q() {
      _classCallCheck(this, A0Q);
      return _possibleConstructorReturn(this, _getPrototypeOf(A0Q).apply(this, arguments));
    }
    _createClass(A0Q, [{
      key: "HP",
      value: function HP() {
        return new R9(this);
      }
    }]);
    return A0Q;
  }(LX);
  var ZZ = /*#__PURE__*/function (_LX7) {
    _inherits(ZZ, _LX7);
    function ZZ() {
      _classCallCheck(this, ZZ);
      return _possibleConstructorReturn(this, _getPrototypeOf(ZZ).apply(this, arguments));
    }
    _createClass(ZZ, [{
      key: "HP",
      value: function HP(e) {
        var t = this;
        switch (e) {
          default:
            return new R4(t);
          case "vline":
            var i = new R4(t);
            return i.P2 = !0, i;
          case "poly":
            var a = new PG(t);
            return a.bPoly = !0, a.sTypeX = "poly", a;
          case "area":
            return new R0(t);
          case "varea":
            var n = new R0(t);
            return n.P2 = !0, n;
          case "bar":
          case "vbar":
            return new R3(t);
          case "hbar":
            return new R9(t);
          case "scatter":
            return new PG(t);
          case "hscatter":
            return new PG(t, "hscatter");
          case "bubble":
            return new S7(t);
          case "hbubble":
            return new S7(t, "hbubble");
          case "stock":
            return new VZ(t);
          case "range":
            return new UJ(t);
          case "line3d":
            return new UW(t);
          case "area3d":
            return new V6(t);
          case "bar3d":
          case "vbar3d":
            return new V3(t);
          case "bullet":
          case "vbullet":
            return new TV(t);
          case "hbullet":
            return new TR(t);
        }
      }
    }]);
    return ZZ;
  }(LX);
  var A7H = /*#__PURE__*/function (_LX8) {
    _inherits(A7H, _LX8);
    function A7H() {
      _classCallCheck(this, A7H);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7H).apply(this, arguments));
    }
    _createClass(A7H, [{
      key: "HP",
      value: function HP() {
        return new PG(this);
      }
    }]);
    return A7H;
  }(LX);
  var ACN = /*#__PURE__*/function (_LX9) {
    _inherits(ACN, _LX9);
    function ACN() {
      _classCallCheck(this, ACN);
      return _possibleConstructorReturn(this, _getPrototypeOf(ACN).apply(this, arguments));
    }
    _createClass(ACN, [{
      key: "HP",
      value: function HP() {
        var e = new PG(this);
        return e.bPoly = !0, e.sTypeX = "poly", e;
      }
    }]);
    return ACN;
  }(LX);
  var A6J = /*#__PURE__*/function (_LX10) {
    _inherits(A6J, _LX10);
    function A6J() {
      _classCallCheck(this, A6J);
      return _possibleConstructorReturn(this, _getPrototypeOf(A6J).apply(this, arguments));
    }
    _createClass(A6J, [{
      key: "HP",
      value: function HP() {
        return new PG(this, "hscatter");
      }
    }]);
    return A6J;
  }(LX);
  var A7Y = /*#__PURE__*/function (_LX11) {
    _inherits(A7Y, _LX11);
    function A7Y() {
      _classCallCheck(this, A7Y);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7Y).apply(this, arguments));
    }
    _createClass(A7Y, [{
      key: "HP",
      value: function HP() {
        return new S7(this);
      }
    }]);
    return A7Y;
  }(LX);
  var A7I = /*#__PURE__*/function (_LX12) {
    _inherits(A7I, _LX12);
    function A7I() {
      _classCallCheck(this, A7I);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7I).apply(this, arguments));
    }
    _createClass(A7I, [{
      key: "HP",
      value: function HP() {
        return new S7(this, "hbubble");
      }
    }]);
    return A7I;
  }(LX);
  var A53 = /*#__PURE__*/function (_LX13) {
    _inherits(A53, _LX13);
    function A53(e) {
      var _this56;
      _classCallCheck(this, A53);
      _this56 = _possibleConstructorReturn(this, _getPrototypeOf(A53).call(this, e));
      var t = _assertThisInitialized(_this56);
      t.KU = [], t.PO = [], t.U6 = [];
      return _this56;
    }
    _createClass(A53, [{
      key: "HP",
      value: function HP() {
        return new WH(this);
      }
    }, {
      key: "parseLayout",
      value: function parseLayout(e) {
        var t,
          i,
          a,
          n,
          l = this;
        e && (l.U6 = [], l.PO = []);
        var r,
          o = l.A.BJ("scale-r"),
          s = l.A.BJ("scale"),
          C = .9,
          A = 1;
        l.A4.length >= 10 && (A = 1), l.A4.length >= 20 && (A = 1.25), l.A4.length >= 30 && (A = 1.5);
        var Z = o.DF;
        for (t = 0, i = l.A4.length; t < i; t++) null !== ZC._n_(l.A4[t].o["ref-angle"]) && (Z = l.A4[t].DF);
        for (t = 0, i = l.A4.length; t < i; t++) if (l.C.E["plot" + t + ".visible"] || "hide" === l.C.getToggleAction()) for (var c = 0, p = l.A4[t].S.length; c < p; c++) if (l.A4[t].S[c]) {
          l.YZ["n" + c] = l.YZ["n" + c] || [];
          var u,
            h,
            _ = l.A4[t].S[c];
          null === ZC._n_(l.PO[c]) && (l.PO[c] = Z), u = null !== ZC._n_(n = l.A4[t].o[ZC._[1]]) ? ZC._f_(n) : l.PO[c], h = l.KU[c], null !== ZC._n_(l.A4[t].o.totals) && null !== ZC._n_(l.A4[t].o.totals[c]) && (h = l.KU[c] = ZC._f_(l.A4[t].o.totals[c])), a = 0 === h ? u + o.EI * (1 / i) : 0 === _.AD && l.A4[t].U8 ? u + o.EI * (.005 * l.KU[c]) / h : u + o.EI * _.AD / h, l.PO[c] = a, _.B4 = u, _.BK = a;
          var d = _.F8(!0);
          if ("out" === d.o[ZC._[7]] && d.AN) {
            var f = ZC._i_((u + a) / 2);
            l.YZ["n" + c][t] = f - Z, r = ZC.CX(s.I / 2 - A * d.I - d.DS - 35, s.F / 2 - A * d.F - d.DS - 15), C = ZC.CX(C, 2 * r / ZC.CX(s.I, s.F));
          }
        }
        if ("pie3d" === l.A.AF && (C *= .75), C = ZC.BQ(.1, ZC.CX(.9, C)), "auto" === s.o["size-factor"] && (s.JV = C), e) for (var g in l.YZ) l.YZ[g] = ZC.AR.ACO(l.YZ[g], Z);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.A.o.plot && "auto" === e.A.o.plot.layout && (null === ZC._n_(e.A.o.plot["ref-angle"]) && (e.A.o.plot["ref-angle"] = -90), e.o.sort(function (e, t) {
          return t[ZC._[5]][0] - e[ZC._[5]][0];
        })), e.U6 = [], e.KU = [], e.PO = [], e.YZ = {}, _get(_getPrototypeOf(A53.prototype), "parse", this).call(this);
        for (var t = 0, i = e.A4.length; t < i; t++) for (var a = 0, n = e.A4[t].S.length; a < n; a++) e.A4[t].S[a] && e.A4[t].S[a] && (e.C.E["plot" + t + ".visible"] || "hide" === e.C.getToggleAction()) && 0 === e.A4[t].S[a].AD && e.A4[t].U8 && (e.KU[a] += .005 * e.KU[a]);
        e.parseLayout();
      }
    }]);
    return A53;
  }(LX);
  var A5G = /*#__PURE__*/function (_LX14) {
    _inherits(A5G, _LX14);
    function A5G(e) {
      var _this57;
      _classCallCheck(this, A5G);
      _this57 = _possibleConstructorReturn(this, _getPrototypeOf(A5G).call(this, e));
      _this57.KU = [], _this57.PO = [];
      return _this57;
    }
    _createClass(A5G, [{
      key: "HP",
      value: function HP() {
        return new UB(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.KU = [], e.PO = [], _get(_getPrototypeOf(A5G.prototype), "parse", this).call(this);
        for (var t, i = e.A.BJ("scale"), a = i.iX + i.I / 2, n = 1, l = 0, r = e.A4.length; l < r; l++) if (e.C.E["plot" + l + ".visible"] || "hide" === e.C.getToggleAction()) for (var o = 0, s = e.A4[l].S.length; o < s; o++) if (e.A4[l].S[o]) {
          var C = e.A4[l].S[o];
          null === ZC._n_(e.PO[o]) && (e.PO[o] = e.A4[l].DF);
          var A = e.PO[o],
            Z = A + 360 * C.AD / e.KU[o];
          e.PO[o] = Z, C.B4 = A, C.BK = Z;
          var c = C.F8(!0);
          if (c && "in" !== c.o[ZC._[7]]) {
            var p = ZC._i_((A + Z) / 2);
            t = ((p >= 0 && p <= 90 || p >= 270 && p <= 360 ? i.iX + i.I - (c.I + 25) : i.iX + (c.I + 25)) - a) / ZC.EG(p), n = ZC.CX(n, 2 * t / i.I), t = i.F / 2 - (c.F / 2 + 10), n = ZC.CX(n, 2 * t / i.F);
          }
        }
        n = ZC.BQ(.15, ZC.CX(.85, n)), "auto" === i.o["size-factor"] && (i.o["size-factor"] = i.JV = n);
      }
    }]);
    return A5G;
  }(LX);
  var A8H = /*#__PURE__*/function (_LX15) {
    _inherits(A8H, _LX15);
    function A8H(e) {
      var _this58;
      _classCallCheck(this, A8H);
      _this58 = _possibleConstructorReturn(this, _getPrototypeOf(A8H).call(this, e)), _this58.A2Q = {};
      return _this58;
    }
    _createClass(A8H, [{
      key: "HP",
      value: function HP() {
        return new XS(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        this.A2Q = {}, _get(_getPrototypeOf(A8H.prototype), "paint", this).call(this);
      }
    }]);
    return A8H;
  }(LX);
  var A78 = /*#__PURE__*/function (_A5) {
    _inherits(A78, _A5);
    function A78() {
      _classCallCheck(this, A78);
      return _possibleConstructorReturn(this, _getPrototypeOf(A78).apply(this, arguments));
    }
    _createClass(A78, [{
      key: "HP",
      value: function HP() {
        return new TV(this);
      }
    }]);
    return A78;
  }(A13);
  var A71 = /*#__PURE__*/function (_A0Q) {
    _inherits(A71, _A0Q);
    function A71() {
      _classCallCheck(this, A71);
      return _possibleConstructorReturn(this, _getPrototypeOf(A71).apply(this, arguments));
    }
    _createClass(A71, [{
      key: "HP",
      value: function HP() {
        return new TR(this);
      }
    }]);
    return A71;
  }(A0Q);
  var A8Y = /*#__PURE__*/function (_LX16) {
    _inherits(A8Y, _LX16);
    function A8Y() {
      _classCallCheck(this, A8Y);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8Y).apply(this, arguments));
    }
    _createClass(A8Y, [{
      key: "HP",
      value: function HP() {
        return new XQ(this);
      }
    }]);
    return A8Y;
  }(LX);
  var A2M = /*#__PURE__*/function (_LX17) {
    _inherits(A2M, _LX17);
    function A2M() {
      _classCallCheck(this, A2M);
      return _possibleConstructorReturn(this, _getPrototypeOf(A2M).apply(this, arguments));
    }
    _createClass(A2M, [{
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a,
          n,
          l = this;
        for (l.B3 = ZC.MAX, l.BL = -ZC.MAX, l.A8G = [], l.SQ = [], _get(_getPrototypeOf(A2M.prototype), "parse", this).call(this), e = 0, t = l.A4.length; e < t; e++) for (i = 0, a = l.A4[e].S.length; i < a; i++) l.A4[e].S[i] && (n = l.A4[e].S[i], null === ZC._n_(l.SQ[i]) && (l.SQ[i] = ZC.MAX), null === ZC._n_(l.A8G[i]) && (l.A8G[i] = -ZC.MAX), l.SQ[i] = ZC.CX(l.SQ[i], n.AD), l.A8G[i] = ZC.BQ(l.A8G[i], n.AD));
        for (e = 0, t = l.A4.length; e < t; e++) for (i = 0, a = l.A4[e].S.length; i < a; i++) l.A4[e].S[i] && (n = l.A4[e].S[i], l.B3 = ZC.CX(l.B3, n.AD), l.BL = ZC.BQ(l.BL, n.AD));
      }
    }]);
    return A2M;
  }(LX);
  var A7F = /*#__PURE__*/function (_A2M) {
    _inherits(A7F, _A2M);
    function A7F() {
      _classCallCheck(this, A7F);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7F).apply(this, arguments));
    }
    _createClass(A7F, [{
      key: "HP",
      value: function HP() {
        return new VY(this);
      }
    }]);
    return A7F;
  }(A2M);
  var A7E = /*#__PURE__*/function (_A2M2) {
    _inherits(A7E, _A2M2);
    function A7E() {
      _classCallCheck(this, A7E);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7E).apply(this, arguments));
    }
    _createClass(A7E, [{
      key: "HP",
      value: function HP() {
        return new VT(this);
      }
    }]);
    return A7E;
  }(A2M);
  var A8J = /*#__PURE__*/function (_LX18) {
    _inherits(A8J, _LX18);
    function A8J() {
      _classCallCheck(this, A8J);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8J).apply(this, arguments));
    }
    _createClass(A8J, [{
      key: "HP",
      value: function HP() {
        return new VZ(this);
      }
    }]);
    return A8J;
  }(LX);
  var A8E = /*#__PURE__*/function (_LX19) {
    _inherits(A8E, _LX19);
    function A8E() {
      _classCallCheck(this, A8E);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8E).apply(this, arguments));
    }
    _createClass(A8E, [{
      key: "HP",
      value: function HP() {
        return new Y3(this);
      }
    }]);
    return A8E;
  }(LX);
  var A8X = /*#__PURE__*/function (_LX20) {
    _inherits(A8X, _LX20);
    function A8X() {
      _classCallCheck(this, A8X);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8X).apply(this, arguments));
    }
    _createClass(A8X, [{
      key: "HP",
      value: function HP() {
        return new UJ(this);
      }
    }]);
    return A8X;
  }(LX);
  var ZCVRangePlotSet = /*#__PURE__*/function (_LX21) {
    _inherits(ZCVRangePlotSet, _LX21);
    function ZCVRangePlotSet() {
      _classCallCheck(this, ZCVRangePlotSet);
      return _possibleConstructorReturn(this, _getPrototypeOf(ZCVRangePlotSet).apply(this, arguments));
    }
    _createClass(ZCVRangePlotSet, [{
      key: "HP",
      value: function HP() {
        var e = new UJ(this);
        return e.P2 = !0, e;
      }
    }]);
    return ZCVRangePlotSet;
  }(LX);
  var A8Q = /*#__PURE__*/function (_A6) {
    _inherits(A8Q, _A6);
    function A8Q() {
      _classCallCheck(this, A8Q);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8Q).apply(this, arguments));
    }
    _createClass(A8Q, [{
      key: "HP",
      value: function HP() {
        return new Y1(this);
      }
    }]);
    return A8Q;
  }(A53);
  var A7K = /*#__PURE__*/function (_A7) {
    _inherits(A7K, _A7);
    function A7K() {
      _classCallCheck(this, A7K);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7K).apply(this, arguments));
    }
    _createClass(A7K, [{
      key: "HP",
      value: function HP() {
        return new V3(this);
      }
    }]);
    return A7K;
  }(A13);
  var A7J = /*#__PURE__*/function (_A0Q2) {
    _inherits(A7J, _A0Q2);
    function A7J() {
      _classCallCheck(this, A7J);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7J).apply(this, arguments));
    }
    _createClass(A7J, [{
      key: "HP",
      value: function HP() {
        return new WS(this);
      }
    }]);
    return A7J;
  }(A0Q);
  var A84 = /*#__PURE__*/function (_A4R) {
    _inherits(A84, _A4R);
    function A84() {
      _classCallCheck(this, A84);
      return _possibleConstructorReturn(this, _getPrototypeOf(A84).apply(this, arguments));
    }
    _createClass(A84, [{
      key: "HP",
      value: function HP() {
        return new UW(this);
      }
    }]);
    return A84;
  }(A4R);
  var A83 = /*#__PURE__*/function (_A4N) {
    _inherits(A83, _A4N);
    function A83() {
      _classCallCheck(this, A83);
      return _possibleConstructorReturn(this, _getPrototypeOf(A83).apply(this, arguments));
    }
    _createClass(A83, [{
      key: "HP",
      value: function HP() {
        return new V6(this);
      }
    }]);
    return A83;
  }(A4N);
  var A9F = /*#__PURE__*/function (_LX22) {
    _inherits(A9F, _LX22);
    function A9F(e) {
      var _this59;
      _classCallCheck(this, A9F);
      _this59 = _possibleConstructorReturn(this, _getPrototypeOf(A9F).call(this, e)), _this59.DU = [], _this59.O7 = [], _this59.XV = [];
      return _this59;
    }
    _createClass(A9F, [{
      key: "HP",
      value: function HP() {
        return new Z3(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A = this,
          Z = A.A.BJ("scale"),
          c = ZC.CX(Z.GG, Z.GM),
          p = -ZC.MAX,
          u = ZC.CX(3, A.A4.length);
        for (e = 0, t = u; e < t; e++) for (C = A.A4[e].S, n = ZC.AQ.OE(A.A4[e].o[ZC._[17]], A.A4[e].o), i = 0, a = C.length; i < a; i++) C[i].setup(), p = ZC.BQ(p, C[i].AD), C[i].XH = ZC.AQ.G5(A.A4[e].ACC[i], n);
        var h = c / (4 * Math.sqrt(p / Math.PI));
        function _(e, t) {
          var i = ZC._a_(e[0] - t[0]),
            a = ZC._a_(e[1] - t[1]);
          return Math.sqrt(i * i + a * a);
        }
        var d,
          f,
          g,
          B = [],
          v = [],
          m = [],
          b = [],
          E = null;
        for (A.O7 = [], e = 0, t = u; e < t; e++) for (B[e] || (B[e] = []), v[e] || (v[e] = [], m[e] = []), A.DU[e] || (A.DU[e] = []), C = A.A4[e].S, b = A.A4[e + 1] && e + 1 < 3 ? A.A4[e + 1].S : A.A4[0].S, i = 0, a = C.length; i < a; i++) {
          A.O7[i] || (A.O7[i] = []), A.XV[i] || (A.XV[i] = {}), C[i].XI = b[i].AD, 0 === e ? (d = h * Math.sqrt(C[i].AD / Math.PI), f = h * Math.sqrt(C[i].XI / Math.PI), B[e][i] = h * ZC.AR.A6M(C[i].AD, C[i].XI, C[i].XH), v[e][i] = C[i].iX - ZC.BQ(d, f) / 2, m[e][i] = C[i].iY + C[i].F / 4) : 1 === e ? (B[e][i] = h * ZC.AR.A6M(C[i].AD, C[i].XI, C[i].XH), v[e][i] = v[0][i] + B[0][i], m[e][i] = m[0][i], 2 === u && (g = (v[0][i] - d - (Z.GM - (v[1][i] + f))) / 2, A.A4[e - 1].S[i].iX -= g, v[1][i] -= g, A.DU[0][i].x -= g, A.O7[i][0][0] -= g, A.A4[e - 1].S[i].iY = Z.iY + Z.GG / 2, m[1][i] = Z.iY + Z.GG / 2, A.DU[0][i].y = Z.iY + Z.GG / 2)) : 2 === e && (B[e][i] = h * ZC.AR.A6M(C[i].AD, C[i].XI, C[i].XH), r = (B[0][i] * B[0][i] - B[1][i] * B[1][i] + B[2][i] * B[2][i]) / (2 * B[0][i]), v[e][i] = v[0][i] + r, o = Math.sqrt(B[2][i] * B[2][i] - r * r), m[e][i] = m[0][i] - o, 3 === u && (g = (v[0][i] - d - (Z.GM - (v[1][i] + f))) / 2, A.A4[0].S[i].iX -= g, A.A4[1].S[i].iX -= g, A.DU[0][i].x -= g, A.DU[1][i].x -= g, A.O7[i][0][0] -= g, v[2][i] -= g)), C[i].iX = v[e][i] + Z.iX, C[i].iY = m[e][i], C[i].I = h * Math.sqrt(C[i].AD / Math.PI), C[i].F = h * Math.sqrt(C[i].AD / Math.PI), C[i].AI = h * Math.sqrt(C[i].AD / Math.PI), null === ZC._n_(E) && (E = C[i].AD / (Math.PI * C[i].AI * C[i].AI));
          var K = h * Math.sqrt(C[i].AD / Math.PI),
            D = h * Math.sqrt(C[i].XI / Math.PI),
            F = K + D - B[e][i],
            I = (2 * F * D - F * F) / (2 * (K + D - F)),
            x = F - I;
          if (A.DU[e][i] = {
            x: v[e][i],
            y: m[e][i],
            sz: C[i].AI,
            r1: K,
            r2: D,
            dx1: x,
            dx2: I
          }, 0 === e ? (o = Math.sqrt(K * K - (K - I) * (K - I)), A.O7[i].push([v[0][i] + K - I, m[0][i] - o])) : 2 === e && (K = A.DU[1][i].r1, D = A.DU[1][i].r2, x = A.DU[1][i].dx1, I = A.DU[1][i].dx2, l = ZC.UE(Math.asin((m[1][i] - m[2][i]) / B[1][i])) - ZC.UE(Math.acos((K - I) / K)), A.O7[i].push([v[1][i] - K * ZC.EG(l) - g, m[1][i] - K * ZC.EN(l)]), K = A.DU[2][i].r1, D = A.DU[2][i].r2, x = A.DU[2][i].dx1, I = A.DU[2][i].dx2, l = ZC.UE(Math.asin((m[0][i] - m[2][i]) / B[2][i])) - ZC.UE(Math.acos((D - x) / D)), A.O7[i].push([v[0][i] + D * ZC.EG(l) - g, m[0][i] - D * ZC.EN(l)])), e === u - 1) if (3 === u) {
            if (null !== ZC._n_(A.A4[0].AAA[i])) A.XV[i].area = A.A4[0].AAA[i];else {
              var y = [-1],
                X = [-1];
              y[1] = _(A.O7[i][0], A.O7[i][2]), y[2] = _(A.O7[i][0], A.O7[i][1]), y[3] = _(A.O7[i][2], A.O7[i][1]), X[1] = A.DU[0][i].sz, X[2] = A.DU[1][i].sz, X[3] = A.DU[2][i].sz;
              var Y = .25 * Math.sqrt((y[1] + y[2] + y[3]) * (y[1] + y[2] - y[3]) * (y[1] + y[3] - y[2]) * (y[2] + y[3] - y[1]));
              for (s = 1; s <= 3; s++) Y += X[s] * X[s] * Math.asin(y[s] / (2 * X[s])) - y[s] / 4 * Math.sqrt(4 * X[s] * X[s] - y[s] * y[s]);
              A.XV[i].area = E * Y;
            }
            A.DU[0][i].intxy = ZC.AR.A64(A.DU[0][i].x, A.DU[0][i].y, A.DU[1][i].x, A.DU[1][i].y, A.DU[0][i].r1 - (A.DU[0][i].dx1 + A.DU[0][i].dx2) / 2), A.DU[1][i].intxy = ZC.AR.A64(A.DU[1][i].x, A.DU[1][i].y, A.DU[2][i].x, A.DU[2][i].y, -(A.DU[1][i].r1 - (A.DU[1][i].dx1 + A.DU[1][i].dx2) / 2)), A.DU[2][i].intxy = ZC.AR.A64(A.DU[2][i].x, A.DU[2][i].y, A.DU[0][i].x, A.DU[0][i].y, -(A.DU[2][i].r1 - (A.DU[2][i].dx1 + A.DU[2][i].dx2) / 2)), A.XV[i].xy = [(A.O7[i][0][0] + A.O7[i][1][0] + A.O7[i][2][0]) / 3, (A.O7[i][0][1] + A.O7[i][1][1] + A.O7[i][2][1]) / 3];
          } else A.DU[0][i].intxy = ZC.AR.A64(A.DU[0][i].x, A.DU[0][i].y, A.DU[1][i].x, A.DU[1][i].y, A.DU[0][i].r1 - (A.DU[0][i].dx1 + A.DU[0][i].dx2) / 2), A.DU[1][i].intxy = [-9999, -9999];
        }
        if (3 === u) for (e = 0, t = u; e < t; e++) for (n = ZC.AQ.OE(A.A4[e].o[ZC._[17]], A.A4[e].o), null !== ZC._n_(n[ZC._[12]]) && -1 !== n[ZC._[12]] || (n[ZC._[12]] = 0), i = 0, a = A.A4[e].S.length; i < a; i++) A.XV[i].area = ZC.AQ.G5(A.XV[i].area, n);
        _get(_getPrototypeOf(A9F.prototype), "paint", this).call(this);
      }
    }]);
    return A9F;
  }(LX);
  var IM = /*#__PURE__*/function (_I6) {
    _inherits(IM, _I6);
    function IM(e) {
      var _this60;
      _classCallCheck(this, IM);
      _this60 = _possibleConstructorReturn(this, _getPrototypeOf(IM).call(this, e));
      var t = _assertThisInitialized(_this60);
      t.C = e.A, t.H = t.C.A, t.A6P = {}, t.HV = !1, t.T1 = 3, t.A20 = 1, t.V = [], t.KJ = {}, t.S = [], t.AF = "", t.sTypeX = null, t.IK = null, t.S2 = !1, t.J7 = "none", t.OF = "plot", t.VE = !0, t.T7 = null, t.TJ = null, t.U4 = {}, t.A2 = null, t.GC = null, t.PY = null, t.PW = null, t.BP = null, t.L = -1, t.BO = [], t.CB = !1, t.KX = "normal", t.DY = 0, t.U = null, t.O5 = null, t.A7 = null, t.JR = null, t.AO = null, t.JD = null, t.A6S = null, t.PC = null, t.DM = -1, t.I9 = -1, t.RO = null, t.S9 = null, t.A0E = !1, t.SU = 2, t.A3L = !1, t.UC = "", t.A0D = "standard", t.CV = null, t.A1G = null, t.N2 = null, t.S8 = null, t.YN = !0, t.YC = null, t.YV = 1, t.QL = !1, t.R8 = !0, t.JX = 0, t.YO = null, t.T8 = null, t.QD = !0, t.K8 = null, t.AAY = 1, t.A35 = 1, t.SG = [], t.JI = null, t.EF = !1, t.T5 = [], t.A7B = -1, t.GI = !1, t.LL = 0, t.JL = .6, t.LI = 0, t.ACD = 0, t.ACB = null, t.U5 = 0, t.FW = null, t.IA = !1, t.Z6 = !0, t.A7Q = !1, t.YH = 1, t.ZK = 0, t.IH = !1, t.LH = !1, t.A3Y = "node", t.M1 = !1, t.RI = -1, t.S4 = 0, t.QJ = !1, t.GU = [null, null, null, null], t.PA = "line";
      return _this60;
    }
    _createClass(IM, [{
      key: "applyRGBA",
      value: function applyRGBA() {
        var e,
          t = this;
        null !== ZC._n_(e = t.E["l-alpha"]) && null === ZC._n_(t.JG.alpha) && (t.C6 = e), null !== ZC._n_(e = t.E["bg-alpha"]) && null === ZC._n_(t.JG["alpha-area"]) && (t.o["alpha-area"] = e);
      }
    }, {
      key: "FK",
      value: function FK(e, t, i) {
        var a = this;
        return typeof i === ZC._[31] && (i = !1), (typeof t === ZC._[31] || !a.GU[t] && a.GU[1]) && (t = 1), e = parseInt(e, 10), !a.IA || "xy" !== a.C.AJ.layout && "yx" !== a.C.AJ.layout ? a.S[e] : a.S[e] && a.GU[t] ? (a.GU[t].K = a.K + "-node-" + e, a.GU[t].o = {
          value: a.V[e]
        }, "string" == typeof a.V[e] && (a.GU[t].A2P = !0), a.GU[t].L = e, "line" !== a.AF && "area" !== a.AF && "vline" !== a.AF && "varea" !== a.AF || a.U ? a.GU[t].parse() : (i || null !== a.S[e].BU || typeof a.C.E["plot-" + a.L + "-first-run"] !== ZC._[31]) && a.GU[t].parse(), "line" === a.AF || "area" === a.AF || "vline" === a.AF || "varea" === a.AF ? "xy" === a.C.AJ.layout ? (null !== a.S[e].BU ? a.GU[t].iX = a.S[e].iX = a.B1.AM(a.S[e].BU) : a.GU[t].iX = a.S[e].iX = a.B1.H6(e), a.CB && "100%" === a.KX ? a.GU[t].iY = a.S[e].iY = a.CL.AM(100 * a.S[e].CR / a.A.F9[e]["%total-" + a.DY]) : a.GU[t].iY = a.S[e].iY = a.CL.AM(a.S[e].CR)) : (null !== a.S[e].BU ? a.GU[t].iY = a.S[e].iY = a.B1.AM(a.S[e].BU) : a.GU[t].iY = a.S[e].iY = a.B1.H6(e), a.CB && "100%" === a.KX ? a.GU[t].iX = a.S[e].iX = a.CL.AM(100 * a.S[e].CR / a.A.F9[e]["%total-" + a.DY]) : a.GU[t].iX = a.S[e].iX = a.CL.AM(a.S[e].CR)) : a.GU[t].S0(), a.GU[t].JK = a.S[e].JK, a.GU[t]) : null;
      }
    }, {
      key: "TA",
      value: function TA(e, t) {
        var i = this;
        i.K8[e] || (i.K8[e] = []), (!i.IA || i.IA && -1 === ZC.AV(i.K8[e], t)) && i.K8[e].push(t);
      }
    }, {
      key: "FY",
      value: function FY() {
        return new MI(this);
      }
    }, {
      key: "A2K",
      value: function A2K() {
        return {};
      }
    }, {
      key: "NQ",
      value: function NQ() {
        return this.YU("palette", "A7B", "i"), this.C.A.B8.AA5(-1 !== this.A7B ? this.A7B : this.L, this.C.AF);
      }
    }, {
      key: "NE",
      value: function NE() {
        var e = this;
        if (e.BP[4]) {
          var t,
            i = {};
          for (var a in e.BP[4]) -1 === (t = a.indexOf(".")) ? null === ZC._n_(e.o[a]) && (i[a] = !0, e.o[a] = e.BP[4][a]) : a.substring(0, t) === e.AF && (null === ZC._n_(e.o[a.substring(t + 1)]) || i[a.substring(t + 1)]) && (e.o[a.substring(t + 1)] = e.BP[4][a]);
        }
      }
    }, {
      key: "I5",
      value: function I5(e, t) {
        var i,
          a,
          n = this,
          l = !1,
          r = "";
        if ("none" !== n.J7 && (n.C.J4[n.L] || n.C.KP)) {
          var o = !(e.E[ZC._[73]] || e.E[ZC._[72]]);
          n.C.C9["p" + n.L] && n.C.C9["p" + n.L]["n" + e.L] ? zingchart.DEV.CACHESELECTION && o && n.U4[ZC._[73]] ? (a = n.U4[ZC._[73]], l = !0) : (r = ZC._[73], (a = new DT(n)).copy(t), e.E[ZC._[73]] ? a.LZ = e.E[ZC._[73]] : a.LZ = n.T7 ? n.T7.o : {}) : "none" !== n.OF && ("plot" === n.OF && n.C.J4[n.L] || "graph" === n.OF && n.C.KP) && (zingchart.DEV.CACHESELECTION && o && n.U4[ZC._[72]] ? (a = n.U4[ZC._[72]], l = !0) : (r = ZC._[72], (a = new DT(n)).copy(t), e.E[ZC._[72]] ? a.LZ = e.E[ZC._[72]] : a.LZ = n.TJ ? n.TJ.o : {})), l || (a ? (a.QD = !0, a.parse()) : (a = new DT(n)).copy(t), zingchart.DEV.CACHESELECTION && o && "" !== r && (n.U4[r] = a));
        } else (a = new DT(n)).copy(t);
        return null !== ZC._n_(i = n.T5[e.L]) && (0 === e.A.E5.length && (e.A.E5 = [{}]), "string" == typeof n.T5[e.L] ? a.append({
          "background-color": ZC.AQ.JP(i, 20) + " " + i,
          "line-color": i,
          "border-color": ZC.AQ.JP(i, 20)
        }) : a.append(n.T5[e.L]), a.parse()), a.Z = t.Z, a.C7 = t.C7, a;
      }
    }, {
      key: "BT",
      value: function BT(e) {
        var t = this,
          i = [];
        if (null !== ZC._n_(e)) for (var a = 0, n = t.BO.length; a < n; a++) {
          var l = t.C.BJ(t.BO[a]);
          l && l.AF === e && i.push(t.BO[a]);
        } else i = t.BO;
        return i;
      }
    }, {
      key: "LV",
      value: function LV() {
        var e = this;
        return {
          negation: e.A0D,
          "thousands-separator": e.RO,
          "decimals-separator": e.S9,
          decimals: e.DM,
          "max-decimals": e.I9,
          short: e.A3L,
          "short-unit": e.UC,
          exponent: e.A0E,
          "exponent-decimals": e.SU
        };
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a = this;
        if (a.V8 = {}, _get(_getPrototypeOf(IM.prototype), "parse", this).call(this), a.K8 = {}, null !== ZC._n_(e = a.o.scales)) for (a.BO = e.split(/,|;|\s/), u = 0; u < a.BO.length; u++) a.BO[u] = ZC.VA(ZC.GY(a.BO[u]));
        if (a.C.o.legend && a.C.o.legend["highlight-plot"] && (a.IH = !0), null !== ZC._n_(a.o.multiplier) && null === ZC._n_(a.o.short) && (a.o.short = a.o.multiplier), null !== ZC._n_(a.o["click-marker"]) && null === ZC._n_(a.o["selection-mode"]) && null === ZC._n_(a.o["selected-marker"]) && (a.o["selection-mode"] = "multiple", a.o["selected-marker"] = {}, ZC._cp_(a.o["click-marker"], a.o["selected-marker"])), a.KX = a.C.KX, a.assign_a([["ignore", "HV", "b"], ["exponent", "A0E", "b"], [ZC._[25], "SU", "ia"], [ZC._[12], "DM", "ia"], ["max-decimals", "I9", "i"], ["preview", "R8", "b"], ["stacked", "CB", "b"], ["stack-type", "KX"], ["exact", "QL", "b"], ["text", "AO"], ["tooltip-text", "JD"], ["legend-text", "A6S"], ["description", "PC"], ["stack", "DY", "i"], ["z-index", "JX", "i"], ["aspect", "CV"], ["mode", "A1G"], ["density", "YH", "f"], ["max-nodes", "N2"], ["max-trackers", "S8"], ["segment-trackers", "YN", "b"], ["sampling-step", "YC", "i"], ["scroll-step-multiplier", "YV", "i"], ["url", "E8"], ["target", "FF"], [ZC._[14], "S9"], [ZC._[13], "RO"], ["short", "A3L", "b"], ["negation", "A0D"], ["short-unit", "UC"], ["fast-rules", "A7Q", "b"], ["errors", "SG"], ["styles", "T5"], ["monotone", "QJ", "b"], ["highlight", "IH", "b"], ["highlight-legend", "LH", "b"], ["hover-mode", "A3Y"], ["mid-point", "VE", "b"], ["clustered", "M1", "b"], ["cluster-index", "RI", "i"], ["cluster-offset", "S4", "i"], ["animate", "GI", "b"], ["effect", "LL", "i"], ["speed", "JL", "f"], ["selection-mode", "J7"], ["group-selections", "S2", "b"], ["background-mode", "OF"], ["extra-values", "ZK", "ia"]]), a.AB2 = a.QL, !a.E["quick-parse"]) {
          var n;
          if (ZC._todash_(a.T5), a.IH && (null === ZC._n_(a.C.o.legend) || null === ZC._n_(a.C.o.legend["highlight-legend"])) && ZC._n_(null === a.o["highlight-legend"]) && (a.LH = a.IH), null !== ZC._n_(e = a.o.animation)) a.GI = !0, null !== ZC._n_(t = e.effect) && (0 === (t + "").indexOf("ANIMATION_") && null !== ZC._n_(n = ZC.ANIMATION[(t + "").substring(10)]) && (t = n), a.LL = ZC._i_(t), 0 === a.LL && (a.GI = !1)), null !== ZC._n_(t = e.speed) && (0 === (t + "").indexOf("ANIMATION_") && null !== ZC._n_(n = ZC.ANIMATION[(t + "").substring(10)]) && (t = n), a.JL = ZC._f_(t)), null !== ZC._n_(t = e.delay) && (a.LE = ZC._f_(t)), null !== ZC._n_(t = e.method) && (0 === (t + "").indexOf("ANIMATION_") && null !== ZC._n_(n = ZC.ANIMATION[(t + "").substring(10)]) && (t = n), a.LI = ZC._i_(t)), null !== ZC._n_(t = e.sequence) && (0 === (t + "").indexOf("ANIMATION_") && null !== ZC._n_(n = ZC.ANIMATION[(t + "").substring(10)]) && (t = n), a.U5 = ZC._i_(t)), null !== ZC._n_(t = e.attributes) && (a.FW = t);
          for (var l in a.JL < 10 && (a.JL *= 1e3), a.LE < 10 && (a.LE *= 1e3), typeof PU !== ZC._[31] && (a.JL = ZC.BQ(PU.UM, a.JL)), ("fast" === a.A1G || typeof PU === ZC._[31] || zingchart.SKIP.ANIMATION) && (a.GI = !1), a.H.A1N && (a.GI = !1), -1 !== ZC.AV(["line", "area", "vbar", "hbar", "stock", "scatter", "bubble", "radar", "piano"], a.AF) && ("fast" === a.A1G ? a.IA = !0 : "normal" === a.A1G || a.GI || -1 !== JSON.stringify(a.o).indexOf('"rules"') || -1 !== JSON.stringify(a.o).indexOf('"js-rule"') || 0 !== a.T5.length || -1 !== a.H.E.json.indexOf('"override"') || -1 !== a.H.E.json.indexOf('"errors"') || "none" !== a.J7 ? a.IA = !1 : a.IA = !0), a.o) if ("data-" === l.substring(0, 5)) {
            var r = l.substring(5);
            a.KJ[r] = a.o[l];
          }
          var o = a.H.B8;
          if (a.IK = new CZ(a), a.IK.append(a.o), o.load(a.IK.o, m(ZC._[71])), a.IK.append(a.o[ZC._[71]]), null !== ZC._n_(a.o[ZC._[71]]) || "line" !== a.AF && "area" !== a.AF || (a.IK.AN = !1), a.IH && (a.SK = new CZ(a), o.load(a.SK.o, m("highlight-state")), a.SK.append(a.o), null !== ZC._n_(e = a.o["highlight-state"]) && a.SK.append(e), null === ZC._n_(a.SK.o.shadow) && (a.SK.o.shadow = !0)), null !== ZC._n_(e = a.o[ZC._[73]]) && (a.T7 = new CZ(a), o.load(a.T7.o, m(ZC._[73])), a.T7.append(e)), null !== ZC._n_(e = a.o[ZC._[72]]) && (a.TJ = new CZ(a), o.load(a.TJ.o, m(ZC._[72])), a.TJ.append(e)), a.A2 = new CZ(a), o.load(a.A2.o, m("marker")), o.load(a.A2.o, m("marker[" + a.CV + "]")), a.A2.append(a.o.marker), "auto" === a.A2.o.type) {
            var s = ["circle", "square", "diamond", "triangle", "star5"];
            a.A2.o.type = s[a.L % s.length];
          }
          if (a.A2.parse(), (a.A2.E5.length > 0 || a.T5.length > 0 || a.A2.o["top-state"]) && (a.Z6 = !1), a.GC = new CZ(a), o.load(a.GC.o, m("hover-marker")), a.GC.append(a.o.marker), a.GC.append(a.o["hover-marker"]), null !== ZC._n_(e = a.o["selected-marker"]) && (a.PY = new CZ(a), o.load(a.PY.o, m("selected-marker")), a.PY.append(e)), null !== ZC._n_(e = a.o["background-marker"]) && (a.PW = new CZ(a), o.load(a.PW.o, m("background-marker")), a.PW.append(e)), a.IH && (a.VO = new CZ(a), a.VO.append(a.o.marker), null !== ZC._n_(e = a.o["highlight-marker"]) && (o.load(a.VO.o, m("highlight-marker")), a.VO.append(e))), "normal" !== a.A1G && (a.T7 || a.PY) && (a.IA = !1), "fast" === a.A1G && (a.IA = !0), a.A7 = new DT(a), a.o.tooltip && a.o.tooltip.placement && a.o.tooltip.placement.indexOf("node") > -1 ? o.load(a.A7.o, "(" + a.AF + ").tooltip[dynamic]") : o.load(a.A7.o, a.AF + ".tooltip"), a.A7.append(a.o.tooltip), null !== ZC._n_(e = a.o.error) && (a.JI = new DW(a), o.load(a.JI.o, m("error")), a.JI.append(e), null === ZC._n_(a.JI.o[ZC._[21]]) && (a.JI.o[ZC._[21]] = 4)), null !== ZC._n_(e = a.o[ZC._[17]])) {
            if (e instanceof Array) for (a.U = new CZ(a), o.load(a.U.o, m(ZC._[17])), null !== ZC._n_(t = a.C.o.plot) && a.U.append(t[ZC._[17]]), a.U.append(e[0]), e.length > 1 && (a.O5 = []), u = 1; u < e.length; u++) a.O5[u - 1] = new CZ(a), o.load(a.O5[u - 1].o, m(ZC._[17])), null !== ZC._n_(t = a.C.o.plot) && a.O5[u - 1].append(t[ZC._[17]]), a.O5[u - 1].append(e[u]);else a.U = new CZ(a), o.load(a.U.o, m(ZC._[17])), null !== ZC._n_(t = a.C.o.plot) && a.U.append(t[ZC._[17]]), a.U.append(e);
            a.U.parse();
          }
          a.H.RB && (a.AN = ZC.FSSTATUS["g-" + a.C.L + "-p-" + a.L]);
          var C = !1;
          for (typeof a.C.E["plot" + a.L + ".visible"] === ZC._[31] && (C = !0), C ? a.C.E["plot" + a.L + ".visible"] = !0 : a.AN = a.C.E["plot" + a.L + ".visible"], a.AN || C && (a.C.E["plot" + a.L + ".visible"] = !1), u = 0, i = a.C.BO.length; u < i; u++) null !== ZC._n_(a.C.BO[u].o[ZC._[5]]) ? a.C.BO[u].TM = !0 : -1 !== ZC.AV(a.BO, a.C.BO[u].BG) && ("remove" === a.C.getToggleAction() || a.C.A.KE ? a.AN && a.C.E["plot" + a.L + ".visible"] && (a.C.BO[u].TM = !0) : a.C.BO[u].TM = !0);
          var A,
            Z = null;
          if (a.K = a.A.K + "-plot-" + a.L, a.S = [], a.A.F9 || (a.A.F9 = {}), -1 !== a.AF.indexOf("area") && -1 === a.AF.indexOf("3d") && a.CB) {
            a.A.XF || (a.A.XF = {}), a.A.XF["s" + a.DY] || (a.A.XF["s" + a.DY] = []);
            var c = !1;
            if (null !== ZC._n_(a.o[ZC._[5]])) for (u = 0, i = a.o[ZC._[5]].length; u < i; u++) if ("object" == typeof a.o[ZC._[5]][u] && null !== ZC._n_(a.o[ZC._[5]][u])) {
              c = !0;
              break;
            }
            c && (a.GI = !1, a.I1 || 0 !== a.E5.length || (a.IA = !0, -1 === zingchart.DEV.STACKINGLOGIC && (a.C.V1 = 1)));
          }
          if (a.B1 = a.C.BJ(a.BT("k")[0]), a.CL = a.C.BJ(a.BT("v")[0]), null !== ZC._n_(a.o[ZC._[5]]) && "" !== a.AF) {
            if (a.V = a.o[ZC._[5]], a.IA && "area" === a.AF && "spline" === a.CV) {
              for (var p = !1, u = 0; u < a.V.length; u++) if (null === ZC._n_(a.V[u])) {
                p = !0;
                break;
              }
              p && (a.IA = !1);
            }
            var h = null;
            a.QG = [ZC.MAX, -ZC.MAX];
            var _ = [],
              d = [],
              f = 0;
            for (u = 0, i = a.V.length; u < i; u++) {
              var g = !1;
              if (a.o["hint-ts"] || (null !== ZC._n_(a.V[u]) && "object" == typeof a.V[u] && a.V[u].length > 1 ? (null === ZC._n_(a.V[u][1]) || "string" == typeof a.V[u][1] && "NULL" === a.V[u][1].toUpperCase()) && (g = !0) : (null === ZC._n_(a.V[u]) || "string" == typeof a.V[u] && "NULL" === a.V[u].toUpperCase()) && (g = !0), "piano" === a.C.AF && (g = !1)), g) a.S.push(null);else {
                !a.IA || "xy" !== a.C.AJ.layout && "yx" !== a.C.AJ.layout ? Z = a.FY() : a.GU[1] || ("bubble" === a.AF || "scatter" === a.AF ? a.GU[1] = Z = a.FY() : (a.GU[0] = a.FY(), a.GU[1] = Z = a.FY(), a.GU[2] = a.FY(), a.GU[3] = a.FY())), Z.K = a.K + "-node-" + u, "string" == typeof a.V[u] && zingchart.QUOTEDVALUES && (a.V[u] = ZC._f_(a.V[u])), Z.o = {
                  value: a.V[u]
                }, "string" == typeof a.V[u] && (Z.A2P = !0), Z.L = u, a.o["hint-ts"] ? (Z.E.plotidx = a.L, Z.E.nodeidx = Z.L, Z.K = a.K + "-node-" + Z.L, Z.BU = a.V[u][0], Z.AD = a.V[u][1]) : Z.parse(), (i < 256 || zingchart.DEV.CHECKDECIMALS) && null !== ZC._n_(Z.AD) && 2 === (A = Z.AD.toString().split(".")).length && (f = ZC.BQ(f, A[1].length)), Z.BU && (null !== h && ZC._a_(Z.BU - h) > 0 && _.push(ZC._a_(Z.BU - h)), h = Z.BU), a.A.XF = a.A.XF || {};
                var B = a.A.XF["s" + a.DY];
                if (B && (null !== h ? -1 === ZC.AV(B, Z.BU) && B.push(Z.BU) : -1 === ZC.AV(B, u) && B.push(u)), !a.IA || "xy" !== a.C.AJ.layout && "yx" !== a.C.AJ.layout) a.S.push(Z);else {
                  var v = {
                    iX: Z.iX,
                    iY: Z.iY,
                    L: Z.L,
                    BU: Z.BU,
                    AD: Z.AD,
                    CR: Z.AD,
                    DN: Z.DN,
                    JK: Z.JK
                  };
                  "bubble" === a.AF && (v.T0 = Z.T0), a.S.push(v);
                }
                null !== Z.BU && (a.QG[0] = Math.min(a.QG[0], Z.BU), a.QG[1] = Math.max(a.QG[1], Z.BU)), a.C.E["plot" + a.L + ".visible"] && (zingchart.DEV.PLOTSTATS || "100%" === a.KX) && a.CB && (null === ZC._n_(a.A.F9[u]) ? (a.A.F9[u] = {}, a.A.F9[u]["%total-" + a.DY] = Z.AD) : null === ZC._n_(a.A.F9[u]["%total-" + a.DY]) ? a.A.F9[u]["%total-" + a.DY] = Z.AD : a.A.F9[u]["%total-" + a.DY] += Z.AD), zingchart.DEV.PLOTSTATS && (d.push(Z.AD), a.JR ? (a.JR["%plot-max-index"] = u, a.JR["%plot-sum"] += Z.AD, i < 256 && (a.JR["%plot-values"] += "," + Z.AD)) : a.JR = {
                  "%plot-min-index": u,
                  "%plot-max-index": u,
                  "%plot-sum": Z.AD,
                  "%plot-values": Z.AD
                }, a.A.F9 || (a.A.F9 = {}), a.AN && (null === ZC._n_(a.A.F9["%pstack-" + u + "-" + a.DY + "-sum"]) ? (a.A.F9["%pstack-" + u + "-" + a.DY + "-sum"] = Z.AD, a.A.F9["%pstack-" + u + "-" + a.DY + "-stack-length"] = 1) : (a.A.F9["%pstack-" + u + "-" + a.DY + "-sum"] += Z.AD, a.A.F9["%pstack-" + u + "-" + a.DY + "-stack-length"] += 1)));
              }
            }
            (a.V.length < 256 || zingchart.DEV.CHECKDECIMALS) && a.JR && null !== ZC._n_(a.JR["%plot-sum"]) && 2 === (A = a.JR["%plot-sum"].toString().split(".")).length && ZC._i_(A[1]) > f && (a.JR["%plot-sum"] = ZC._f_(a.JR["%plot-sum"].toFixed(ZC.CX(20, f)))), zingchart.DEV.PLOTSTATS ? (a.JR && (a.JR["%plot-average"] = a.JR["%plot-sum"] / a.V.length, a.JR["%plot-average"] = ZC._f_(a.JR["%plot-average"].toFixed(ZC.CX(20, f + 2)))), d.length > 0 && (a.JR["%plot-min-value"] = ZC.YP(d), a.JR["%plot-max-value"] = ZC.A1U(d))) : a.JR = {
              "%plot-min-index": 0,
              "%plot-max-index": a.V.length,
              "%plot-sum": -1,
              "%plot-values": "",
              "%plot-average": -1,
              "%plot-min-value": -1,
              "%plot-max-value": -1
            }, h && _.length > 0 && (a.AAY = ZC.YP(_), a.A35 = ZC.A1U(_));
          }
        }
        function m(e) {
          var t = ["(" + a.AF + ").plot." + e];
          return a.sTypeX && t.push("(" + a.sTypeX + ").plot." + e), t;
        }
      }
    }, {
      key: "mapPointsToPreview",
      value: function mapPointsToPreview(e, t) {
        for (var i = this, a = i.C.P, n = i.C.B9.AT, l = [], r = 0, o = e.length; r < o; r++) if (e[r]) {
          "vml" === i.H.AA && t && (e[r][0] = e[r][0] / 10, e[r][1] = e[r][1] / 10);
          var s = (e[r][0] - a.iX) / a.I,
            C = (e[r][1] - a.iY) / a.F,
            A = n.iX + n.AU + s * (n.I - 2 * n.AU),
            Z = n.iY + n.AU + C * (n.F - 2 * n.AU);
          l.push([A, Z]);
        } else l.push(null);
        return l;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this,
          t = e.C.P.I;
        switch (e.C.AF) {
          case "scatter":
          case "bubble":
            t = 1e6;
            break;
          case "hbar":
          case "hbar3d":
            t = e.C.P.F;
        }
        null === ZC._n_(e.N2) && (e.N2 = ZC._i_(t / 4)), null === ZC._n_(e.S8) && (e.S8 = ZC._i_(t / 4)), e.Z6 && (e.HH = null, e.HN = null, e.RS = null, e.QK = null);
      }
    }, {
      key: "VW",
      value: function VW(e) {
        var t,
          i,
          a,
          n = this;
        for (t = 0, i = n.S.length; t < i; t++) n.S[t] && (n.S[t].JK = !1);
        var l = n.C.P;
        if (n.RL = !1, n.FZ = !0, n.UT = !1, a = 0, n.C.OM || typeof n.AB2 !== ZC._[31] && (n.QL = n.AB2), e) n.RL = !0, n.S8 < n.S.length && (n.FZ = !1);else {
          if (n.B1.EF && n.EF) {
            for (t = 0, i = n.S.length; t < i; t++) n.S[t] && (n.B1.J0.length > 0 || ZC.DR(n.S[t].BU, n.B1.V[n.B1.W], n.B1.V[n.B1.A1])) && a++;
            n.S8 < a && (n.FZ = !1), a * n.YH > l.I && (n.UT = !0), n.N2 >= a && (n.RL = !0);
          } else n.N2 > n.B1.A1 - n.B1.W && (n.RL = !0);
          n.Y = 1, n.B1.EF && n.EF || (a = n.B1.A1 - n.B1.W, n.S8 < a && (n.FZ = !1), a * n.YH > l.I && (n.UT = !0), !n.QL && a * n.YH > l.I && (n.Y = ZC.BQ(1, ZC._i_(a * n.YH / l.I)))), n.B1.EF && n.EF && (n.QL || a * n.YH > l.I && (n.Y = ZC.BQ(1, ZC._i_(a * n.YH / l.I)))), n.C.OM && (n.QL = !1, n.Y *= n.YV);
        }
        null !== ZC._n_(n.YC) && n.Y > n.YC && (n.Y = n.YC);
      }
    }, {
      key: "OH",
      value: function OH(e) {
        var t,
          i,
          a,
          n = this;
        null !== ZC._n_(e) && e || (e = !1), n.B1 && "log" === n.B1.C1 && (e = !0), n.VW(e);
        var l = null;
        if (e || n.M1) n.A.A5U = !1, function u(e, t) {
          for (var i = e; i < ZC.CX(e + t, n.S.length); i++) n.S[i] ? ((l = n.FK(i)).Z = n.KM, l.paint(), l.JK = !0, n.S[i].JK = !0) : "radar" === n.C.AF && (i === n.S.length - 1 ? "line" !== n.CV && "area" !== n.CV && "range" !== n.CV || ZC.CQ.paint(n.QQ, n, n.D) : n.D.push(null));
          e + t < n.S.length ? n.C.LW ? window.setTimeout(function () {
            u(e + t, t);
          }, 10) : u(e + t, t) : n.C.LW && n.L === n.A.A4.length - 1 && n.A._end_();
        }(0, ZC.ie678 || ZC.mobile ? 200 : 2e3);else {
          var r = "vbar" !== n.AF && "hbar" !== n.AF;
          if (n.B1.EF && n.EF) {
            a = n.GB = n.HM = n.Y;
            var o = !0,
              s = 0,
              C = 0;
            for (t = 0, i = n.S.length; t < i; t += a) r && (i - t == 1 ? (n.GB = a, n.HM = 1) : i - t < n.Y && (n.GB = n.Y, n.HM = i - t - 1, a = i - t - 1)), n.S[t] && (n.B1.J0.length > 0 || ZC.DR(n.S[t].BU, n.B1.V[n.B1.W], n.B1.V[n.B1.A1]) || r && o && n.S[t + a] && n.S[t + a].BU >= n.B1.V[n.B1.W]) && (r && o && n.S[t - a] && ((l = n.FK(t - a)).Z = n.KM, l.paint(), l.JK = !0, o = !1, C++), (l = n.FK(t)).Z = n.KM, l.paint(), l.JK = !0, C++, o = !1, s = t);
            r && C > 0 && n.S[s + a] && ((l = n.FK(s + a)).Z = n.KM, l.paint(), l.JK = !0);
          } else {
            a = n.GB = n.HM = n.Y;
            var A = 0,
              Z = 1,
              c = null;
            if (!r) {
              var p = "vbar" === n.AF ? n.C.P.I : n.C.P.F;
              A = 4 / ("vbar" === n.AF ? n.C.P.F : n.C.P.I) * (n.CL.BL - n.CL.B3), Z = 1 + ZC._i_((n.B1.A1 - n.B1.W) / (2 * p)), a = 1;
            }
            for (t = n.B1.W; t <= n.B1.A1; t += a) (n.B1.A1 - n.B1.W) % n.Y != 0 && r && (n.B1.A1 - t == 0 ? (n.GB = a, n.HM = 1) : n.B1.A1 - t <= n.Y && (n.GB = n.Y, n.HM = n.B1.A1 - t, a = n.B1.A1 - t)), n.S[t] ? (l = n.FK(t), (r || n.QL || !r && null === c || ZC._a_(l.AD - c) > A || t % Z == 0) && (l.Z = n.KM, l.paint(), l.JK = !0, n.S[t].JK = !0), c = l.AD) : n.CB && -1 !== ZC.AV(["vbar", "hbar", "vbar3d", "hbar3d"], n.AF) && n.R5();
          }
        }
      }
    }, {
      key: "CN",
      value: function CN(e, t) {
        var i = this;
        if (i.V8[e + t]) return i.V8[e + t];
        var a = null;
        return a = i.H.usc() ? ZC.AK(i.H.K + "-main-c" + ("fl" === e ? "-top" : "")) : i.H.KE || i.C.AJ["3d"] ? ZC.AK(i.C.K + "-plots-" + e + "-c") : ZC.AK(i.C.K + "-plot-" + i.L + "-" + e + "-" + t + "-c"), i.V8[e + t] || (i.V8[e + t] = a), a;
      }
    }, {
      key: "TF",
      value: function TF(e) {
        var t = this;
        return {
          id: t.H.K,
          graphid: t.C.K,
          graphidx: t.C.L,
          plotid: t.HB,
          plotindex: t.L,
          plottext: t.AO,
          ev: e ? ZC.A5.BX(e) : null,
          xdata: t.KJ
        };
      }
    }, {
      key: "UP",
      value: function UP(e, t) {
        ZC.AQ.BZ("plot_" + t, this.H, this.TF(e));
      }
    }, {
      key: "applyJsRuleSvg",
      value: function applyJsRuleSvg(e, t, i) {
        var a;
        if (a = e.o["js-rule-svg"]) {
          var n = ZC.AK(t),
            l = ZC.evalFn(a.replace("javascript:", "").replace("()", ""), window);
          if (n && l) try {
            var r = l.call(this, i);
            for (var o in r) n.setAttribute(o, r[o]);
          } catch (s) {}
        }
      }
    }, {
      key: "sharedZScale",
      value: function sharedZScale() {
        var e = this,
          t = e.C,
          i = t.P;
        if (t.o["scale-z"] && t.E["plot" + e.L + ".visible"]) {
          var a, n, l, r, o;
          if (a = new CC(t, i.iX + i.I - ZC.AP.E2 + 10, i.iY + i.F - ZC.AP.E1, e.E["z-mid"]), (n = new DT(e)).GO = t.K + "-scale-z-item " + t.K + "-scale-item zc-scale-item", n.K = t.K + "-scale-z-item_" + e.L, n.AO = t.o["scale-z"][ZC._[5]][e.L], n.Z = n.C7 = e.H.usc() ? e.H.mc() : ZC.AK(t.K + "-scales-ml-0-c"), o = ZC.Q.E9(n.Z, e.H.AA), n.IW = e.H.usc() ? ZC.AK(e.H.K + "-main") : ZC.AK(e.H.K + "-text"), n.append(t.o["scale-z"].item), n.parse(), n.A9 += n.VV ? 0 : ZC.DH.A3C(t, n), n.iX = a.EC[0], n.iY = a.EC[1], n.o["auto-align"] && n.VV && (n.iY -= n.F / 2), n.paint(), null === ZC._n_(e.E["scale-z-item-max-width"]) && (e.E["scale-z-item-max-width"] = 0), e.E["scale-z-item-max-width"] = ZC.BQ(e.E["scale-z-item-max-width"], n.I), e.E["z-cnt"] === e.E["z-plots"] - 1 && t.o["scale-z"].label) {
            var s, C;
            a = new CC(t, i.iX + i.I - ZC.AP.E2 + 20 + e.E["scale-z-item-max-width"], i.iY + i.F - ZC.AP.E1, ZC.AP.FV / 2), (n = new DT(e)).GO = t.K + "-scale-z-label " + t.K + "-scale-label zc-scale-label", n.K = t.K + "-scale-z-label", n.Z = n.C7 = e.H.usc() ? e.H.mc() : ZC.AK(t.K + "-scales-ml-0-c"), o = ZC.Q.E9(n.Z, e.H.AA), n.IW = e.H.usc() ? ZC.AK(e.H.K + "-main") : ZC.AK(e.H.K + "-text"), n.append(t.o["scale-z"].label), n.parse(), s = new CC(t, i.iX + i.I - ZC.AP.E2, i.iY + i.F - ZC.AP.E1, 0), C = new CC(t, i.iX + i.I - ZC.AP.E2, i.iY + i.F - ZC.AP.E1, ZC.AP.FV);
            var A = ZC.UE(Math.atan((C.EC[1] - s.EC[1]) / (C.EC[0] - s.EC[0])));
            n.A9 += n.VV ? 0 : A, n.iX = a.EC[0], n.iY = a.EC[1], n.paint();
          }
          if (t.o["scale-z"].tick && ((r = new DW(e)).B7 = "#cccccc", r.AZ = 1, r.AI = 6, r.append(t.o["scale-z"].tick), r.parse(), r.AN && r.AZ > 0)) {
            r.K = t.K + "-scale-z-tick-" + e.L;
            for (var Z = [], c = [[i.iX + i.I, i.iY + i.F], [i.iX + i.I + r.AI, i.iY + i.F]], p = 0; p < c.length; p++) a = new CC(t, c[p][0] - ZC.AP.E2, c[p][1] - ZC.AP.E1, e.E["z-mid"]), Z.push([a.EC[0], a.EC[1]]);
            ZC.CQ.paint(o, r, Z);
          }
          if (0 === e.E["z-cnt"] && ((r = new CZ(e)).B7 = "#cccccc", r.AZ = 1, r.append(t.o["scale-z"].axis), r.parse(), r.AZ > 0 && r.AN && (r.A0 = r.AE = r.B7, (l = ZC.DH.DA(r, t, i.iX + i.I - ZC.AP.E2 - r.AZ, i.iX + i.I - ZC.AP.E2, i.iY + i.F - ZC.AP.E1, i.iY + i.F - ZC.AP.E1, 0, ZC.AP.FV, "x")).K = t.K + "-scale-z-axis", t.CJ.add(l))), e.E["z-cnt"] > 0 && t.o["scale-z"].guide && ((r = new CZ(e)).B7 = "#cccccc", r.AZ = 1, r.append(t.o["scale-z"].guide), r.parse(), r.AZ > 0 && r.AN && (r.A0 = r.AE = r.B7, (l = ZC.DH.DA(r, t, i.iX - ZC.AP.E2, i.iX + i.I - ZC.AP.E2, i.iY + i.F - ZC.AP.E1, i.iY + i.F - ZC.AP.E1 + r.AZ, e.E["z-cnt"] * e.E["z-depth"], e.E["z-cnt"] * e.E["z-depth"], "y")).K = t.K + "-scale-z-guideh-" + e.L, t.CJ.add(l), (l = ZC.DH.DA(r, t, i.iX - ZC.AP.E2, i.iX - ZC.AP.E2, i.iY - ZC.AP.E1, i.iY + i.F - ZC.AP.E1, e.E["z-cnt"] * e.E["z-depth"], e.E["z-cnt"] * e.E["z-depth"] + r.AZ, "y")).K = t.K + "-scale-z-guidev-" + e.L, t.CJ.add(l))), t.o["scale-z"].items && t.o["scale-z"].items.length) {
            (r = new CZ(e)).A0 = r.AE = "#ff9900", r.C6 = .25;
            var u = e.E["z-cnt"] % t.o["scale-z"].items.length;
            r.append(t.o["scale-z"].items[u]), r.parse(), (l = ZC.DH.DA(r, t, i.iX - ZC.AP.E2, i.iX + i.I - ZC.AP.E2, i.iY + i.F - ZC.AP.E1, i.iY + i.F - ZC.AP.E1, e.E["z-cnt"] * e.E["z-depth"], e.E["z-cnt"] * e.E["z-depth"] + e.E["z-depth"], "z")).K = e.K + "-item-", t.CJ.add(l);
          }
        }
      }
    }, {
      key: "gc",
      value: function gc() {
        if (this.S) for (var e = 0; e < this.S.length; e++) this.S[e] && this.S[e].A && ZC.AQ.gc(this.S[e], ["Z", "C7", "o", "JG", "ID", "A", "C", "H", "N", "NM"]);
        ZC.AQ.gc(this, ["V", "S", "GU", "K8", "VN", "A7", "Z", "C7", "V8", "A2", "UA", "HH", "GC", "IK", "KM", "QQ", "B1", "CL", "S", "GU", "K8", "JR", "o", "JG", "ID", "A", "C", "H"]);
      }
    }]);
    return IM;
  }(I3);
  var WK = /*#__PURE__*/function (_IM) {
    _inherits(WK, _IM);
    function WK(e) {
      var _this61;
      _classCallCheck(this, WK);
      _this61 = _possibleConstructorReturn(this, _getPrototypeOf(WK).call(this, e));
      var t = _assertThisInitialized(_this61);
      t.bXY = !0, t.AF = "xy", t.BO = [ZC._[50], ZC._[51]];
      return _this61;
    }
    _createClass(WK, [{
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(WK.prototype), "paint", this).call(this);
      }
    }]);
    return WK;
  }(IM);
  var R4 = /*#__PURE__*/function (_WK) {
    _inherits(R4, _WK);
    function R4(e) {
      var _this62;
      _classCallCheck(this, R4);
      _this62 = _possibleConstructorReturn(this, _getPrototypeOf(R4).call(this, e));
      var t = _assertThisInitialized(_this62);
      t.AF = "line", t.CV = "segmented", t.Y = 1, t.SY = "middle", t.VN = [], t.NF = !0, t.P2 = !1;
      return _this62;
    }
    _createClass(R4, [{
      key: "FY",
      value: function FY() {
        return new A3I(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.B7 = e.BP[1], e.NE(), _get(_getPrototypeOf(R4.prototype), "parse", this).call(this), e.assign_a([["step-start", "SY"], ["smart-sampling", "NF", "b"]]), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o = this;
        _get(_getPrototypeOf(R4.prototype), "paint", this).call(this), o.VN = [];
        var s = o.P2;
        if (o.KM = o.CN("bl", 0), o.QQ = ZC.Q.E9(o.CN("bl", 1), o.H.AA), !o.IA || o.C.AJ["3d"]) o.OH(), o.D = null;else {
          o.VW(), o.C7 = o.CN("bl", 0);
          var C = !0;
          (null !== ZC._n_(o.A2.o.visible) && !ZC._b_(o.A2.o.visible) || null !== ZC._n_(o.A.o.type) && "none" === o.A2.o.type) && (C = !1);
          var A = [],
            Z = [],
            c = [],
            p = !0,
            u = 0,
            h = null;
          a = 0;
          var _ = -1,
            d = -1,
            f = o.A.A4[0].SG && o.A.A4[0].SG.length,
            g = o.Y,
            B = o.CV;
          if (o.Y > 1 && "spline" === B && (B = "segmented"), o.B1.EF && o.EF) {
            for (i = o.Y, o.NF && (i = 1), e = 0, t = o.S.length; e < t; e += i) d - e <= o.Y && (i = ZC.BQ(1, d - e)), o.S[e] && (o.B1.J0.length > 0 || ZC.DR(o.S[e].BU, o.B1.V[o.B1.W], o.B1.V[o.B1.A1]) || p && o.S[e + i] && o.S[e + i].BU >= o.B1.V[o.B1.W]) && (p && o.S[e - i] && (-1 === _ && (_ = e - i), d = e - i, p = !1, u++), -1 === _ && (_ = e), d = e, u++, p = !1, a = e);
            u > 0 && o.S[a + i] && (-1 === _ && (_ = a + i), d = a + i, o.S[a + i].JK = !0);
          } else _ = o.B1.W, d = o.M1 || "log" === o.B1.C1 ? o.S.length : o.B1.A1;
          o.Y = g;
          var v = -1;
          i = o.Y, o.NF && (i = 1);
          var m = null,
            b = null,
            E = 0,
            K = 1;
          a = _, s ? d - _ > o.C.P.F && (E = 4 / o.C.P.I * (o.CL.BL - o.CL.B3), K = ZC._f_((d - _) / (4 * o.C.P.F))) : d - _ > o.C.P.I && (E = 4 / o.C.P.F * (o.CL.BL - o.CL.B3), K = ZC._f_((d - _) / (4 * o.C.P.I))), o.o["sampling-threshold"] && (E *= Math.max(1, (d - _) / ZC._i_(o.o["sampling-threshold"])), K *= Math.max(1, (d - _) / ZC._i_(o.o["sampling-threshold"])));
          for (o.D = [], e = _; e <= d; e += i) {
            var D = !1;
            if (((d - _) % o.Y != 0 || o.B1.EF && o.EF) && d - e <= o.Y && (i = ZC.BQ(1, d - e), D = !0), o.NF && !D && o.S[e]) if (null === ZC._n_(m)) m = o.S[e].CR, a = e, b = 0;else {
              if (Math.abs(o.S[e].CR - m) < E && e - a < K && (!o.EF || o.S[e].BU - b < 4 * o.B1.SR)) continue;
              m = o.S[e].CR, b = o.S[e].BU, a = e;
            }
            if (0, h = o.FK(e)) {
              switch (o.S[e].JK = !0, (o.FZ || o.M1) && h.paint(!0), -1 === v && (v = h.iX), B) {
                default:
                  A.push([h.iX, h.iY]);
                  break;
                case "spline":
                  s ? (Z.push(h.iX), c.push(h.iY), 1 === Z.length && (Z.push(h.iX), c.push(h.iY))) : (Z.push(h.iY), c.push(h.iX), 1 === Z.length && (Z.push(h.iY), c.push(h.iX)));
                  break;
                case "stepped":
                  switch (o.SY) {
                    default:
                      (l = o.FK(e - i, 0)) && (l.setup(), n = ZC.AR.JZ(o.S[e - i].iX, o.S[e - i].iY, h.iX, h.iY), A.push(s ? [h.iX, n[1]] : [n[0], h.iY])), A.push([h.iX, h.iY]), (r = o.FK(e + i, 0)) && (r.setup(), n = ZC.AR.JZ(h.iX, h.iY, o.S[e + i].iX, o.S[e + i].iY), A.push(s ? [h.iX, n[1]] : [n[0], h.iY]));
                      break;
                    case "before":
                      (l = o.FK(e - i, 0)) && (l.setup(), A.push([o.S[e - i].iX, o.S[e - i].iY], [o.S[e - i].iX, h.iY])), A.push([h.iX, h.iY]);
                      break;
                    case "after":
                      A.push([h.iX, h.iY]), (r = o.FK(e + i, 0)) && (r.setup(), A.push([o.S[e + i].iX, h.iY], [o.S[e + i].iX, o.S[e + i].iY]));
                  }
                  break;
                case "jumped":
                  (l = o.FK(e - i, 0)) ? (l.setup(), n = ZC.AR.JZ(o.S[e - i].iX, o.S[e - i].iY, h.iX, h.iY), A.push(s ? [h.iX, n[1]] : [n[0], h.iY])) : A.push(s ? [h.iX, h.iY - o.B1.AC / 2] : [h.iX - o.B1.AC / 2, h.iY]), A.push([h.iX, h.iY]), (r = o.FK(e + i, 0)) ? (r.setup(), n = ZC.AR.JZ(h.iX, h.iY, o.S[e + i].iX, o.S[e + i].iY), A.push(s ? [h.iX, n[1]] : [n[0], h.iY])) : A.push(s ? [h.iX, h.iY + o.B1.AC / 2] : [h.iX + o.B1.AC / 2, h.iY]), A.push(null);
              }
              f && h.MR(ZC.Q.E9(o.CN("fl", 0), o.H.AA)), (o.RL && C || o.FZ || o.U) && h.OT(), h.JK = !0;
            } else null !== ZC._n_(o.o["connect-nulls"]) && ZC._b_(o.o["connect-nulls"]) || (A.push(null), Z.push(null), c.push(null));
          }
          if ("spline" === B) {
            Z.push(Z[Z.length - 1]), c.push(c[c.length - 1]), A = [];
            for (var F = 1; F < Z.length - 1; F++) {
              var I = [Z[F - 1], Z[F], Z[F + 1], Z[F + 2]],
                x = ZC._a_(c[F + 1] - c[F]);
              x = Math.min(x, Math.max(o.C.I, o.C.F));
              var y = ZC.AR.YY(o.QJ, I, x);
              for (e = 0; e < y.length; e++) null !== ZC._n_(y[e][0]) && null !== ZC._n_(y[e][1]) ? s ? A.push([y[e][1], c[F] + (o.B1.AW ? 1 : -1) * y[e][0] * x]) : A.push([c[F] + (o.B1.AW ? -1 : 1) * y[e][0] * x, y[e][1]]) : A.push(null);
            }
          }
          o.CY = !1;
          var X = o.H.OI;
          if (o.H.OI = !1, o.E["fast-vector-path"] = !0, ZC.CQ.setup(o.QQ, o), ZC.CQ.paint(o.QQ, o, A), o.H.OI = X, o.C.B9 && o.C.B9.IP && o.R8) {
            var Y = o.mapPointsToPreview(A, !0),
              w = ZC.Q.E9(o.C.B9.Z, o.H.AA),
              L = new CZ(o);
            L.copy(o), L.K = o.K + "-preview", L.DJ = o.K + "-preview", L.AZ = 1;
            var M = o.o["preview-state"];
            M && (L.append(M), L.parse()), ZC.CQ.paint(w, L, Y, null, 3);
          }
        }
      }
    }]);
    return R4;
  }(WK);
  var R0 = /*#__PURE__*/function (_WK2) {
    _inherits(R0, _WK2);
    function R0(e) {
      var _this63;
      _classCallCheck(this, R0);
      _this63 = _possibleConstructorReturn(this, _getPrototypeOf(R0).call(this, e));
      var t = _assertThisInitialized(_this63);
      t.AF = "area", t.Y = 1, t.CV = "segmented", t.T1 = 3, t.I6 = t.C.AJ["3d"] ? 1 : .5, t.SY = "middle", t.A4O = !0, t.VN = [], t.NF = !0, t.Y0 = !1, t.P2 = !1;
      return _this63;
    }
    _createClass(R0, [{
      key: "FY",
      value: function FY() {
        return new A3J(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.B7 = e.BP[1], e.C.AJ["3d"] || "solid" === e.o["background-color-style"] ? e.A0 = e.AE = e.BP[1] : (e.A0 = e.BP[0], e.AE = e.BP[1]), e.NE(), _get(_getPrototypeOf(R0.prototype), "parse", this).call(this), e.applyRGBA(), e.assign_a([["alpha-area", "I6", "f", 0, 1], ["step-start", "SY"], ["active-area", "Y0", "b"], ["contour-on-top", "A4O", "b"], ["smart-sampling", "NF", "b"]]), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z = this;
        _get(_getPrototypeOf(R0.prototype), "paint", this).call(this), Z.VN = [];
        var c = Z.P2;
        if (-1 === ZC.AV(["segmented", "spline", "stepped"], Z.CV) && (Z.CV = "segmented"), Z.KM = Z.CN("bl", 0), Z.A50 = ZC.Q.E9(Z.CN("bl", 1), Z.H.AA), Z.QQ = ZC.Q.E9(Z.CN("bl", Z.A4O ? 2 : 1), Z.H.AA), C = Z.C.P, !Z.IA || Z.C.AJ["3d"]) {
          var p = ZC.MAX,
            u = -ZC.MAX;
          for (e = 0, t = Z.S.length; e < t; e++) Z.S[e] && (p = ZC.CX(p, Z.S[e].CR), u = ZC.BQ(u, Z.S[e].CR));
          var h = Z.CL.AM(p),
            _ = Z.CL.AM(u),
            d = Z.CL.AM(Z.CL.HA);
          if (ZC.DR(d, h, _) && (Z.CL.AW ? d < h && (h = d) : d > _ && (_ = d)), Z.E["min-y"] = Math.min(h, _), Z.E["max-y"] = Math.max(h, _), Z.CB && Z.A.F2) {
            var f = ZC.MAX,
              g = -ZC.MAX;
            for (e = 0, t = Z.A.F2.length; e < t; e++) if (Z.A.F2[e]) for (var B = 0, v = Z.A.F2[e].length; B < v; B++) f = ZC.CX(f, Z.A.F2[e][B][1]), g = ZC.BQ(g, Z.A.F2[e][B][1]);
            Z.CL.AW ? Z.E["min-y"] = f : Z.E["max-y"] = g;
          }
          Z.E["max-y"] - Z.E["min-y"] < 100 && (Z.E["max-y"] += 50, Z.E["min-y"] -= 50), Z.OH(), Z.D = null, Z.D5 = null, Z.AH = null;
        } else {
          Z.VW(), Z.C7 = Z.CN("bl", 0);
          var m = !0;
          (null !== ZC._n_(Z.A2.o.visible) && !ZC._b_(Z.A2.o.visible) || null !== ZC._n_(Z.A.o.type) && "none" === Z.A2.o.type) && (m = !1);
          var b = Z.CB && 0 === Z.C.V1,
            E = [],
            K = [],
            D = [],
            F = [],
            I = [],
            x = Z.CL.HA;
          Z.o["ref-value"] && (x = ZC._f_(Z.o["ref-value"]));
          var y = Z.CL.AM(x);
          c ? "xy" === Z.C.AJ.layout ? (y = Z.B1.AM(x), y = ZC._l_(y, Z.B1.iX, Z.B1.iX + Z.B1.I)) : y = ZC._l_(y, Z.CL.iX, Z.CL.iX + Z.CL.I) : "yx" === Z.C.AJ.layout ? (y = Z.B1.AM(x), y = ZC._l_(y, Z.B1.iY, Z.B1.iY + Z.B1.F)) : y = ZC._l_(y, Z.CL.iY, Z.CL.iY + Z.CL.F);
          var X = !0,
            Y = 0,
            w = null;
          i = 0;
          var L = -1,
            M = -1,
            H = Z.A.A4[0].SG && Z.A.A4[0].SG.length,
            G = Z.Y,
            P = Z.CV;
          if (Z.Y > 1 && "spline" === P && (P = "segmented"), Z.B1.EF && Z.EF) {
            for (a = Z.Y, Z.NF && (a = 1), e = 0, t = Z.S.length; e < t; e += a) M - e <= Z.Y && (a = ZC.BQ(1, M - e)), Z.S[e] && (Z.B1.J0.length > 0 || ZC.DR(Z.S[e].BU, Z.B1.V[Z.B1.W], Z.B1.V[Z.B1.A1]) || X && Z.S[e + a] && Z.S[e + a].BU >= Z.B1.V[Z.B1.W]) && (X && Z.S[e - a] && (-1 === L && (L = e - a), M = e - a, X = !1, Y++), -1 === L && (L = e), M = e, Y++, X = !1, i = e);
            Y > 0 && Z.S[i + a] && (-1 === L && (L = i + a), M = i + a, Z.S[i + a].JK = !0);
          } else L = Z.B1.W, M = Z.M1 || "log" === Z.B1.C1 ? Z.S.length : Z.B1.A1;
          Z.Y = G, b || Z.A.D5 && (K = Z.A.D5.reverse());
          var N = null,
            O = null,
            S = 0,
            Q = 1;
          i = L, c ? M - L > Z.C.P.F && (S = 4 / Z.C.P.I * (Z.CL.BL - Z.CL.B3), Q = ZC._f_((M - L) / (4 * Z.C.P.F))) : M - L > Z.C.P.I && (S = 4 / Z.C.P.F * (Z.CL.BL - Z.CL.B3), Q = ZC._f_((M - L) / (4 * Z.C.P.I)));
          var k = !1,
            T = !1,
            z = -1;
          a = Z.Y, Z.NF && (a = 1), k = !0, !Z.A.SC && b && (Z.A.SC = {}, Z.A.WC = {});
          var V = null,
            R = null;
          if (Z.A.SC && !Z.A.SC["s" + Z.DY] && b) {
            Z.A.SC["s" + Z.DY] = {}, Z.A.WC["s" + Z.DY] = {};
            var J = Z.A.XF["s" + Z.DY];
            for (e = 0; e <= J.length; e++) null !== ZC._n_(J[e]) && (n = Z.B1.EF ? ZC._i_(Z.B1.AM(J[e])) : ZC._i_(Z.B1.H6(J[e])), Z.A.SC["s" + Z.DY][n] = y, Z.A.WC["s" + Z.DY][n] = y);
          }
          for (b && (V = Z.A.SC["s" + Z.DY], R = Z.A.WC["s" + Z.DY]), e = L; e <= M; e += a) {
            var W = !1;
            if (((M - L) % Z.Y != 0 || Z.B1.EF && Z.EF) && M - e <= Z.Y && (a = ZC.BQ(1, M - e), W = !0), Z.NF && !W && Z.S[e]) if (null === ZC._n_(N)) N = Z.S[e].CR, i = e, O = 0;else {
              if (Math.abs(Z.S[e].CR - N) < S && e - i < Q && (!Z.EF || Z.S[e].BU - O < 4 * Z.B1.SR)) continue;
              N = Z.S[e].CR, O = Z.S[e].BU, i = e;
            }
            if (w = Z.FK(e)) {
              switch (Z.S[e].JK = !0, (Z.FZ || Z.M1) && w.paint(!0), (T || ("segmented" === P || "stepped" === P) && e === L && 0 === K.length) && (b || (K.push(c ? [y, w.iY] : [w.iX, y]), T && D.push(c ? [y, w.iY] : [w.iX, y]))), T = !1, -1 === z && (z = w.iX), P) {
                default:
                  b || k && (c ? w.iY > Z.B1.iY && (D.push([y, Z.B1.iY]), D.push([y, w.iY]), K.push([y, w.iY])) : w.iX > Z.B1.iX && (D.push([Z.B1.iX, y]), D.push([w.iX, y]), K.push([w.iX, y])), k = !1), E.push([w.iX, w.iY]), b ? c ? R[ZC._i_(w.iY)] = w.iX : R[ZC._i_(w.iX)] = w.iY : (D.push([w.iX, w.iY]), K.push([w.iX, w.iY]));
                  break;
                case "spline":
                  c ? (F.push(w.iX), I.push(w.iY), 1 === F.length && (F.push(w.iX), I.push(w.iY))) : (F.push(w.iY), I.push(w.iX), 1 === F.length && (F.push(w.iY), I.push(w.iX)));
                  break;
                case "stepped":
                  var U = Z.B1.AW ? -1 : 1;
                  switch (Z.SY) {
                    default:
                      (r = Z.FK(e - a, 0)) && (r.setup(), l = ZC.AR.JZ(Z.S[e - a].iX, Z.S[e - a].iY, w.iX, w.iY), E.push(c ? [w.iX, l[1]] : [l[0], w.iY]), b ? c ? R[ZC._i_(l[1]) - U] = w.iX : R[ZC._i_(l[0]) + U] = w.iY : (D.push(c ? [w.iX, l[1]] : [l[0], w.iY]), K.push(c ? [w.iX, l[1]] : [l[0], w.iY]))), E.push([w.iX, w.iY]), b ? c ? R[ZC._i_(w.iY)] = w.iX : R[ZC._i_(w.iX)] = w.iY : (D.push([w.iX, w.iY]), K.push([w.iX, w.iY])), (o = Z.FK(e + a, 0)) && (o.setup(), l = ZC.AR.JZ(w.iX, w.iY, Z.S[e + a].iX, Z.S[e + a].iY), E.push(c ? [w.iX, l[1]] : [l[0], w.iY]), b ? c ? R[ZC._i_(l[1]) + U] = w.iX : R[ZC._i_(l[0]) - U] = w.iY : (D.push(c ? [w.iX, l[1]] : [l[0], w.iY]), K.push(c ? [w.iX, l[1]] : [l[0], w.iY])));
                      break;
                    case "before":
                      (r = Z.FK(e - a, 0)) && (r.setup(), E.push([Z.S[e - a].iX, Z.S[e - a].iY], [Z.S[e - a].iX, w.iY]), b ? c ? (R[ZC._i_(w.iY) + U] = Z.S[e - a].iX, R[ZC._i_(w.iY)] = Z.S[e - a].iX) : (R[ZC._i_(Z.S[e - a].iX)] = Z.S[e - a].iY, R[ZC._i_(Z.S[e - a].iX) + U] = w.iY) : (D.push([Z.S[e - a].iX, Z.S[e - a].iY], [Z.S[e - a].iX, w.iY]), K.push([Z.S[e - a].iX, Z.S[e - a].iY], [Z.S[e - a].iX, w.iY]))), E.push([w.iX, w.iY]), b ? c ? R[ZC._i_(w.iY)] = w.iX : R[ZC._i_(w.iX)] = w.iY : (D.push([w.iX, w.iY]), K.push([w.iX, w.iY]));
                      break;
                    case "after":
                      E.push([w.iX, w.iY]), b ? c ? R[ZC._i_(w.iY)] = w.iX : R[ZC._i_(w.iX)] = w.iY : (D.push([w.iX, w.iY]), K.push([w.iX, w.iY])), (o = Z.FK(e + a, 0)) && (o.setup(), E.push([Z.S[e + a].iX, w.iY], [Z.S[e + a].iX, Z.S[e + a].iY]), b ? c ? (R[ZC._i_(w.iY) - U] = Z.S[e + a].iX, R[ZC._i_(Z.S[e + a].iY)] = Z.S[e + a].iX) : (R[ZC._i_(Z.S[e + a].iX) - U] = w.iY, R[ZC._i_(Z.S[e + a].iX)] = Z.S[e + a].iY) : (D.push([Z.S[e + a].iX, w.iY], [Z.S[e + a].iX, Z.S[e + a].iY]), K.push([Z.S[e + a].iX, w.iY], [Z.S[e + a].iX, Z.S[e + a].iY])));
                  }
              }
              H && w.MR(ZC.Q.E9(Z.CN("fl", 0), Z.H.AA)), (Z.RL && m || Z.FZ || Z.U) && w.OT(), w.JK = !0;
            } else null !== ZC._n_(Z.o["connect-nulls"]) && ZC._b_(Z.o["connect-nulls"]) || (E.push(null), F.push(null), I.push(null), b || (K.length - 1 >= 0 && K.push(c ? [y, K[K.length - 1][1]] : [K[K.length - 1][0], y]), D.length - 1 >= 0 && D.push(c ? [y, K[K.length - 1][1]] : [K[K.length - 1][0], y]), T = !0));
          }
          if ("segmented" !== P && "stepped" !== P || b || K.length - 1 >= 0 && (c ? K.push([y, K[K.length - 1][1]]) : K.push([K[K.length - 1][0], y])), "spline" === P) {
            F.push(F[F.length - 1]), I.push(I[I.length - 1]), E = [], b || K.push(c ? [y, I[0]] : [I[0], y]);
            for (var j = 1; j < F.length - 1; j++) {
              var q = [F[j - 1], F[j], F[j + 1], F[j + 2]],
                $ = ZC._a_(I[j + 1] - I[j]);
              $ = Math.min($, Math.max(Z.C.I, Z.C.F));
              var ee = ZC.AR.YY(Z.QJ, q, $);
              for (e = 0; e < ee.length; e++) null !== ZC._n_(ee[e][0]) && null !== ZC._n_(ee[e][1]) ? (s = c ? [ee[e][1], I[j] + (Z.B1.AW ? 1 : -1) * ee[e][0] * $] : [I[j] + (Z.B1.AW ? -1 : 1) * ee[e][0] * $, ee[e][1]], E.push(s), b ? c ? R[ZC._i_(s[1])] = s[0] : R[ZC._i_(s[0])] = s[1] : (K.push(s), D.push(s))) : E.push(null);
            }
            b || K.push(c ? [y, K[K.length - 1][1]] : [K[K.length - 1][0], y]);
          }
          if (!b && D.length > 0) {
            var te = D[D.length - 1];
            c || te[0] < Z.B1.iX + Z.B1.I && (D.push(c ? [y, te[1]] : [te[0], y]), D.push(c ? [y, Z.B1.iY] : [Z.B1.iX + Z.B1.I, y]));
          }
          if (b) {
            var ie = [],
              ae = [],
              ne = [],
              le = [];
            for (A in R) ne.push([A, R[A]]);
            for (A in ne.sort(function (e, t) {
              return e[0] - t[0];
            }), V) le.push([A, V[A]]);
            for (le.sort(function (e, t) {
              return e[0] - t[0];
            }), e = 0; e < ne.length; e++) c ? ie.push([ne[e][1], ne[e][0]]) : ie.push([ne[e][0], ne[e][1]]);
            for (e = 0; e < le.length; e++) c ? ae.push([le[e][1], le[e][0]]) : ae.push([le[e][0], le[e][1]]);
            for (A in (K = ie.concat(ae.reverse()))[0] && K.push(K[0]), V = Z.A.SC["s" + Z.DY] = {}, R) V[A] = R[A];
          }
          var re = new DW(Z);
          if (re.copy(Z), re.CY = !0, re.LD = !0, re.AZ = 0, re.AU = 0, re.EX = 0, re.GD = 0, re.NO = Z.P2 ? 180 : 90, re.parse(), re.C6 = Z.I6, re.Z = Z.CN("bl", Z.C.CB ? 0 : 1), re.D = K, re.A1I(), re.K = Z.K + "-area", re.paint(), Z.CY = !1, ZC.CQ.setup(Z.QQ, Z), ZC.CQ.paint(Z.QQ, Z, E), Z.C.B9 && Z.C.B9.IP && Z.R8) {
            var oe,
              se = Z.C.B9,
              Ce = Z.mapPointsToPreview(K),
              Ae = new DW(Z.A);
            Ae.copy(Z), Ae.CY = !0, Ae.LD = !0, Ae.AZ = 0, Ae.AU = 0, Ae.EX = 0, Ae.GD = 0, Ae.C6 = Z.I6, Ae.D0 = [C.iX, C.iY, C.iX + C.I, C.iY + C.F], Ae.K = Z.K + "-area-preview", Ae.DJ = Z.K + "-preview", Ae.Z = se.Z;
            var Ze = Z.o["preview-state"];
            Ze && (null !== ZC._n_(Ze["alpha-area"]) ? (oe = Ze.alpha, Ze.alpha = Z.o["preview-state"]["alpha-area"]) : Ze.alpha = Ae.C6, Ae.append(Ze), Ae.parse(), null !== ZC._n_(oe) ? Ze.alpha = oe : delete Ze.alpha), Ae.D = Ce, Ae.paint();
            var ce = Z.mapPointsToPreview(E),
              pe = ZC.Q.E9(se.Z, Z.H.AA),
              ue = new CZ(Z);
            ue.copy(Z), ue.CY = !0, ue.LD = !0, ue.K = Z.K + "-line-preview", ue.DJ = Z.K + "-preview", ue.AZ = 1, Ze && (ue.append(Ze), ue.parse()), ZC.CQ.paint(pe, ue, ce, null, 3);
          }
          Z.CB && (Z.A.D5 = D);
        }
      }
    }]);
    return R0;
  }(WK);
  var A2S = /*#__PURE__*/function (_WK3) {
    _inherits(A2S, _WK3);
    function A2S(e) {
      var _this64;
      _classCallCheck(this, A2S);
      _this64 = _possibleConstructorReturn(this, _getPrototypeOf(A2S).call(this, e));
      var t = _assertThisInitialized(_this64);
      t.AF = "bar", t.sMetaType = "bar", t.F4 = .1, t.D3 = 0, t.bKeyWidth = !1, t.ZP = -1, t.CD = .1, t.CS = .1, t.F0 = 0, t.U8 = !1, t.M5 = [], t.PA = "bg", t.A42 = !0, t.NF = !1;
      return _this64;
    }
    _createClass(A2S, [{
      key: "parse",
      value: function parse() {
        var e = this;
        if (e.BP = e.NQ(), e.C2 = e.BP[0], e.B7 = e.BP[1], e.BW = e.BP[1], e.A0 = e.BP[1], e.AE = e.BP[2], e.NE(), _get(_getPrototypeOf(A2S.prototype), "parse", this).call(this), "histogram" === e.CV && (e.F4 = e.CD = e.CS = 0), e.assign_a([["group-bars", "A42", "b"], ["show-zero", "U8", "b"], ["offset-values", "M5"], ["bar-space", "F4", "fp"], ["bar-width", "D3", "fp"], ["key-width", "bKeyWidth", "b"], ["bar-max-width", "ZP", "fp"], ["bars-space-left", "CD", "fp"], ["bars-space-right", "CS", "fp"], ["bars-overlap", "F0", "fp"], ["smart-sampling", "NF", "b"]]), e.A42 || (e.F0 = 1), 0 === e.F4 && 0 === e.CD && 0 === e.CS && (e.FG = !1), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]), null !== ZC._n_(e.o.column)) {
          var t = e.o.column.split("/");
          if (2 === t.length) {
            var i = ZC._i_(t[0]),
              a = ZC._i_(t[1]),
              n = e.CD;
            e.CD >= 1 && (n = e.CD / e.B1.AC);
            var l = e.CS;
            e.CS >= 1 && (l = e.CS / e.B1.AC);
            var r = 1 - n - l,
              o = ZC._x_(r / (3 * a + 1));
            e.CD = n + o + 3 * (i - 1) * o, e.CS = 1 - e.CD - 2 * o;
          }
        }
      }
    }, {
      key: "R5",
      value: function R5() {
        var e,
          t = this;
        if (t.RX) return t.RX;
        if (t.o["fast-dimensions"] && t.A.A4[0].RX) return t.A.A4[0].RX;
        t.bKeyWidth && (t.assign_a([["bar-width", "D3", "fp"]]), t.D3 = ((t.B1.CO ? t.B1.F : t.B1.I) - t.B1.AB - t.B1.BV) * (t.D3 / (t.B1.BL - t.B1.B3)));
        var i,
          a = t.B1.AC * t.Y,
          n = 0;
        for (t.A.K9[t.AF] = t.A.K9[t.AF] || [], e = 0; e < t.A.K9[t.AF].length; e++) {
          var l = t.A.K9[t.AF][e][0];
          t.A.A4[l].BO[0] === t.BO[0] && n++;
        }
        if (t.M1) for (n = 0, e = 0; e < t.A.A4.length; e++) "bar" === t.A.A4[e].sMetaType && (n = ZC.BQ(n, t.A.A4[e].S.length));
        if (null === ZC._n_(t.B1.ET) && (t.B1.ET = 0, t.B1.X8 = {}), t.CB && null !== ZC._n_(t.B1.X8["stack-" + t.DY])) i = t.B1.X8["stack-" + t.DY];else {
          for (i = t.B1.ET, e = 0; e < t.L; e++) if ((t.A.A4[e].AN || "hide" === t.C.getToggleAction()) && t.BO[0] === t.A.A4[e].BO[0] && t.A.A4[e].AF === t.AF && (!t.CB || t.A.A4[e].DY !== t.DY) && !t.A.A4[e].HV) {
            i++;
            break;
          }
          t.B1.ET = i, t.B1.X8["stack-" + t.DY] = i;
        }
        for (var r = !0, o = 0, s = [], C = 0; C < t.A.A4.length; C++) t.A.A4[C].D3 <= 1 ? r = !1 : null !== ZC._n_(t.A.A4[C].D3) && (t.A.A4[C].CB && -1 !== ZC.AV(s, t.A.A4[C].DY) || (s.push(t.A.A4[C].DY), o += t.A.A4[C].D3));
        var A = t.CD;
        A <= 1 && (A *= a);
        var Z,
          c = t.CS;
        c <= 1 && (c *= a), A = ZC._i_(A), c = ZC._i_(c);
        var p,
          u,
          h,
          _,
          d = t.F0;
        return r ? (Z = o, 0 === t.F0 || n <= 1 ? ((p = t.F4) <= 1 && (p *= Z / n), c = (h = a - Z - (p = ZC.BQ(0, p)) * (n - 1)) - (A = h * (_ = 0 === c ? 1 : A / c) / (1 + _)), A < 1 && (A = c = 0, p = a - Z, n > 1 && (p /= n - 1), p < 0 && (Z = a - A - c - (p = 0) * (n - 1))), u = (Z = ZC.BQ(Z, 1 * n)) / n) : n > 1 && (p = 0, u = Z / n, d <= 1 && (d *= u), c = (h = a - (Z = n * (u - (d = ZC.CX(d, u))) + d) - p * (n - 1)) - (A = h * (_ = 0 === c ? 1 : A / c) / (1 + _)), A < 1 && (Z -= 1 - A))) : (Z = a - A - c, 0 === t.F0 || n <= 1 ? ((p = t.F4) <= 1 && (p *= Z / n), c = (h = a - Z - (p = ZC.BQ(0, p)) * (n - 1)) - (A = h * (_ = 0 === c ? 1 : A / c) / (1 + _)), A < 1 && (A = c = 0, p = a - Z, n > 1 && (p /= n - 1), p < 0 && (Z = a - A - c - (p = 0) * (n - 1))), u = (Z = ZC.BQ(Z, 1 * n)) / n) : n > 1 && (p = 0, u = Z / n, d > 1 && (d = u / d), d *= u = Z / (n - n * d + d), c = (h = a - Z - p * (n - 1)) - (A = h * (_ = 0 === c ? 1 : A / c) / (1 + _)), A < 1 && (Z -= 1 - A))), -1 !== t.ZP && u > t.ZP && !t.E.bw && (t.D3 = t.ZP), t.RX = {
          AC: a,
          ET: i,
          CD: A,
          CS: c,
          F4: p,
          D3: u,
          F0: d
        }, {
          AC: a,
          ET: i,
          CD: A,
          CS: c,
          F4: p,
          D3: u,
          F0: d
        };
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A2S.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0);
        var t = e.FG;
        e.A37 = !1, e.SO = null;
        var i = 1;
        e.B1.EF && (i = e.S.length / (e.B1.DV - e.B1.DD)), 0 !== e.E5.length || e.I1 || e.C.KP || "svg" !== e.H.AA || !(e.B1.A1 - e.B1.W > 2048 || e.B1.EF && i * (e.B1.A1 - e.B1.W) > 2048) || (e.A37 = !0, null === ZC._n_(e.o["rect-shortcut"]) && (e.FG = !0)), e.FG || (e.A37 = !1), e.OH(), e.FG = t, e.RefNode = null, e.WR = null;
      }
    }]);
    return A2S;
  }(WK);
  var R3 = /*#__PURE__*/function (_A2S) {
    _inherits(R3, _A2S);
    function R3(e) {
      var _this65;
      _classCallCheck(this, R3);
      _this65 = _possibleConstructorReturn(this, _getPrototypeOf(R3).call(this, e)), _this65.AF = "vbar";
      return _this65;
    }
    _createClass(R3, [{
      key: "FY",
      value: function FY() {
        return new ZU(this);
      }
    }]);
    return R3;
  }(A2S);
  var R9 = /*#__PURE__*/function (_A2S2) {
    _inherits(R9, _A2S2);
    function R9(e) {
      var _this66;
      _classCallCheck(this, R9);
      _this66 = _possibleConstructorReturn(this, _getPrototypeOf(R9).call(this, e)), _this66.AF = "hbar";
      return _this66;
    }
    _createClass(R9, [{
      key: "FY",
      value: function FY() {
        return new A03(this);
      }
    }]);
    return R9;
  }(A2S);
  var PG = /*#__PURE__*/function (_WK4) {
    _inherits(PG, _WK4);
    function PG(e, t) {
      var _this67;
      _classCallCheck(this, PG);
      _this67 = _possibleConstructorReturn(this, _getPrototypeOf(PG).call(this, e)), _this67.AF = t || "scatter", _this67.PA = "markerbg", _this67.bPoly = !1, _this67.I6 = .5;
      return _this67;
    }
    _createClass(PG, [{
      key: "FY",
      value: function FY() {
        return new A6H(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.A0 = e.BP[1], e.AE = e.BP[1], e.B7 = e.BP[2], e.BW = e.BP[2], e.NE(), _get(_getPrototypeOf(PG.prototype), "parse", this).call(this), e.assign_a([["alpha-area", "I6", "f", 0, 1]]), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a = this;
        if (_get(_getPrototypeOf(PG.prototype), "paint", this).call(this), a.KM = a.CN("bl", 0), a._oCtxNode = ZC.Q.E9(a.CN("bl", 0), a.H.AA), !a.IA || a.C.AJ["3d"] || "fast" !== a.A1G || 0 !== a.S8) a.OH(!0);else {
          var n = null,
            l = a.B1,
            r = a.CL;
          a.VW(!0);
          var o = new DW(a.A);
          for (o.Z = a.CN("bl", 1), o.C7 = a.CN("bl", 0), o.B7 = a.BP[3], o.BW = a.BP[3], o.A0 = a.BP[2], "bubble" === a.AF || "hbubble" === a.AF ? o.AE = a.BP[1] : o.AE = a.BP[2], o.append(a.A2.o), o.parse(), t = 0; t <= a.S.length; t++) if (n = a.FK(t)) {
            var s = !1;
            l.CO ? ZC.DR(n.iX, r.iX + (r.AW ? r.BV : r.AB) - 1, r.iX + r.I - (r.AW ? r.AB : r.BV) + 1) && ZC.DR(n.iY, l.iY + (l.AW ? l.BV : l.AB) - 1, l.iY + l.F - (l.AW ? l.AB : l.BV) + 1) && (s = !0) : ZC.DR(n.iX, l.iX + (l.AW ? l.BV : l.AB) - 1, l.iX + l.I - (l.AW ? l.AB : l.BV) + 1) && ZC.DR(n.iY, r.iY + (r.AW ? r.AB : r.BV) - 1, r.iY + r.F - (r.AW ? r.BV : r.AB) + 1) && (s = !0), s && (n.JK = !0, a.S[t].JK = !0, o.K = n.K + "-marker", o.iX = n.iX, o.iY = n.iY, "circle" !== o.DQ && o.parse(), "none" !== a.J7 && (a.C.J4[a.L] || a.C.KP) && (o.o = {}, o.LZ = {}, a.C.C9["p" + a.L] && a.C.C9["p" + a.L]["n" + t] ? o.LZ = a.PY ? a.PY.o : {} : "none" !== a.OF && ("plot" === a.OF && a.C.J4[t] || "graph" === a.OF && a.C.KP) && (o.LZ = a.PW ? a.PW.o : {}), o.B7 = a.BP[3], o.BW = a.BP[3], o.A0 = a.BP[2], "bubble" === a.AF || "hbubble" === a.AF ? o.AE = a.BP[1] : o.AE = a.BP[2], o.append(a.A2.o), o.parse()), o.paint());
          }
        }
        if (a.bPoly) {
          for (e = [], t = 0, i = a.S.length; t < i; t++) e.push([a.S[t].iX, a.S[t].iY]);
          e.length && e.push(e[0]);
          var C = new DW(a);
          C.copy(a), C.C6 = a.I6, C.CY = !0, C.LD = !0, C.AZ = 0, C.AU = 0, C.EX = 0, C.GD = 0, C.Z = a.KM, C.D = e, C.A1I(), C.K = a.K + "-area", C.paint(), a.CY = !1, ZC.CQ.setup(a._oCtxNode, a), ZC.CQ.paint(a._oCtxNode, a, e);
        }
      }
    }]);
    return PG;
  }(WK);
  var S7 = /*#__PURE__*/function (_WK5) {
    _inherits(S7, _WK5);
    function S7(e, t) {
      var _this68;
      _classCallCheck(this, S7);
      _this68 = _possibleConstructorReturn(this, _getPrototypeOf(S7).call(this, e)), _this68.AF = t || "bubble", _this68.X2 = null, _this68.WX = null, _this68.A23 = 1, _this68.JV = 1, _this68.AA4 = "area", _this68.PA = "markerbg";
      return _this68;
    }
    _createClass(S7, [{
      key: "FY",
      value: function FY() {
        return new A7D(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.A0 = e.BP[2], e.AE = e.BP[1], e.B7 = e.BP[2], e.BW = e.BP[2], e.NE(), _get(_getPrototypeOf(S7.prototype), "parse", this).call(this), e.assign_a([["min-size", "X2", "i"], ["max-size", "WX", "i"], ["scaling", "AA4"], ["sizing-group", "A23", "i"], ["size-factor", "JV", "f"]]), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]), null === ZC._n_(e.X2) && (e.X2 = 15), null === ZC._n_(e.WX) && (e.WX = .75 * Math.min(e.B1.AB, e.B1.BV, e.CL.AB, e.CL.BV), e.WX = ZC.BQ(25, ZC.CX(50, e.WX)));
      }
    }, {
      key: "getSize",
      value: function getSize(e) {
        var t,
          i = this,
          a = null;
        switch (e = ZC.BQ(e, i.S3), t = i.X7 === i.S3 ? e - i.S3 : (e - i.S3) / (i.X7 - i.S3), i.AA4) {
          case "radius":
            a = i.X2 + i.JV * (i.WX - i.X2) * t;
            break;
          case "area":
          case "sqrt":
            a = i.X2 + i.JV * (i.WX - i.X2) * Math.sqrt(t);
        }
        return ZC.BQ(i.X2, a);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        if (_get(_getPrototypeOf(S7.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), null !== ZC._n_(e.WX)) {
          e.X7 = -ZC.MAX, e.S3 = ZC.MAX;
          for (var t = e.A.A4, i = 0, a = t.length; i < a; i++) if (t[i].A23 === e.A23) for (var n = 0, l = t[i].S.length; n < l; n++) e.X7 = ZC.BQ(e.X7, ZC._a_(t[i].S[n].T0)), e.S3 = ZC.CX(e.S3, ZC._a_(t[i].S[n].T0));
        }
        e.OH(!0);
      }
    }]);
    return S7;
  }(WK);
  var WH = /*#__PURE__*/function (_IM2) {
    _inherits(WH, _IM2);
    function WH(e) {
      var _this69;
      _classCallCheck(this, WH);
      _this69 = _possibleConstructorReturn(this, _getPrototypeOf(WH).call(this, e));
      var t = _assertThisInitialized(_this69);
      t.AF = "pie", t.BO = ["scale", ZC._[52], "scale-r"], t.QA = 0, t.DF = 0, t.U8 = !1, t.A8C = !0, t.C3 = null, t.PA = "bg";
      return _this69;
    }
    _createClass(WH, [{
      key: "FY",
      value: function FY() {
        return new A9H(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t,
          i = this;
        null === ZC._n_(i.o[ZC._[17]]) && (i.o[ZC._[17]] = {}), "ring" !== i.A.A.o.type && "ring3d" !== i.A.A.o.type || (i.QA = .35), i.BP = i.NQ(), i.C2 = i.BP[0], i.A0 = i.BP[1], i.AE = i.BP[2], i.BW = i.BP[0], i.B7 = i.BP[0], i.NE(), _get(_getPrototypeOf(WH.prototype), "parse", this).call(this), i.C3 = new CZ(i), i.C.A.B8.load(i.C3.o, ["graph.plot.value-box.connector", i.AF + ".plot.value-box.connector"]), null !== ZC._n_(e = i.C.o.plot) && null !== ZC._n_(e[ZC._[17]]) && null !== ZC._n_(t = e[ZC._[17]].connector) && i.C3.append(t), i.C3.append(i.o[ZC._[17]].connector), i.assign_a([["offset", "DS", "fp"], [ZC._[8], "QA", "fp"], ["show-zero", "U8", "b"], ["detach", "A8C", "b"], ["ref-angle", "DF", "i"]]), i.DF %= 360;
        for (var a = 0, n = i.S.length; a < n; a++) i.S[a] && (i.S[a].CM = i.QA, i.S[a] && (i.C.E["plot" + i.L + ".visible"] || "hide" === i.C.getToggleAction()) && (null === ZC._n_(i.A.KU[a]) && (i.A.KU[a] = 0), i.A.KU[a] += ZC._f_(i.S[a].AD)));
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(WH.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.OH(!0);
      }
    }]);
    return WH;
  }(IM);
  var UB = /*#__PURE__*/function (_IM3) {
    _inherits(UB, _IM3);
    function UB(e) {
      var _this70;
      _classCallCheck(this, UB);
      _this70 = _possibleConstructorReturn(this, _getPrototypeOf(UB).call(this, e));
      var t = _assertThisInitialized(_this70);
      t.AF = "nestedpie", t.BO = ["scale"], t.UK = 0, t.SW = 0, t.DF = 0, t.C3 = null, t.PA = "bg", t.aBandWidths = null;
      return _this70;
    }
    _createClass(UB, [{
      key: "FY",
      value: function FY() {
        return new A4Y(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t,
          i = this;
        i.BP = i.NQ(), i.C2 = i.BP[0], i.A0 = i.BP[1], i.AE = i.BP[2], i.BW = i.BP[0], i.B7 = i.BP[0], i.NE(), _get(_getPrototypeOf(UB.prototype), "parse", this).call(this), i.U && (i.C3 = new CZ(i), i.C.A.B8.load(i.C3.o, ["graph.plot.value-box.connector", i.AF + ".plot.value-box.connector"]), null !== ZC._n_(e = i.C.o.plot) && null !== ZC._n_(e[ZC._[17]]) && null !== ZC._n_(t = e[ZC._[17]].connector) && i.C3.append(t), i.C3.append(i.o[ZC._[17]].connector)), i.assign_a([["slice-start", "UK", "fp"], ["offset", "UK", "fp"], [ZC._[8], "UK", "fp"], ["band-space", "SW", "fp"], ["ref-angle", "DF", "i"], ["band-widths", "aBandWidths"]]), i.DF %= 360;
        for (var a = 0, n = i.S.length; a < n; a++) i.S[a] && (i.C.E["plot" + i.L + ".visible"] || "hide" === i.C.getToggleAction()) && (null === ZC._n_(i.A.KU[a]) && (i.A.KU[a] = 0), i.A.KU[a] += ZC._f_(i.S[a].AD));
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(UB.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.OH(!0);
      }
    }]);
    return UB;
  }(IM);
  var XS = /*#__PURE__*/function (_IM4) {
    _inherits(XS, _IM4);
    function XS(e) {
      var _this71;
      _classCallCheck(this, XS);
      _this71 = _possibleConstructorReturn(this, _getPrototypeOf(XS).call(this, e));
      var t = _assertThisInitialized(_this71);
      t.AF = "radar", t.T1 = 3, t.BO = ["scale-k", ZC._[52], "scale"], t.I6 = .5, t.CV = "line", t.A6Q = null, t.Y0 = !1, t.D = [], t.AH = [];
      return _this71;
    }
    _createClass(XS, [{
      key: "FY",
      value: function FY() {
        return new A7R(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.B7 = e.BP[1], e.A0 = e.BP[3], e.AE = e.BP[3], e.NE(), _get(_getPrototypeOf(XS.prototype), "parse", this).call(this), e.applyRGBA(), e.assign_a([["active-area", "Y0", "b"], ["alpha-area", "I6", "f", 0, 1], ["angle-space", "A6Q", "f"]]), e.B1 = e.C.BJ("scale-k"), e.CL = e.C.BJ(ZC._[52]), "range" === e.CV && (e.A1G = "normal", e.IA = !1);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(XS.prototype), "paint", this).call(this), e.B1.V.length === e.V.length && -1 === ZC.AV(e.V, null) || (e.A1G = "normal", e.IA = !1), e.KM = ZC.AK(e.C.K + "-plot-" + e.L + "-bl-0-c"), e.A50 = ZC.Q.E9(e.CN("bl", 0), e.H.AA), e.QQ = ZC.Q.E9(e.CN("bl", 2), e.H.AA), e.OH(!0);
      }
    }]);
    return XS;
  }(IM);
  var A5Y = /*#__PURE__*/function (_A2S3) {
    _inherits(A5Y, _A2S3);
    function A5Y(e) {
      var _this72;
      _classCallCheck(this, A5Y);
      _this72 = _possibleConstructorReturn(this, _getPrototypeOf(A5Y).call(this, e));
      var t = _assertThisInitialized(_this72);
      t.F4 = .2, t.CD = .28, t.CS = .28, t.F0 = 0, t.FL = null, t.A3N = [], t.QB = [], t.AAH = !0, t.PA = "bg";
      return _this72;
    }
    _createClass(A5Y, [{
      key: "A2K",
      value: function A2K(e) {
        var t;
        if ("goal" === e) {
          if (null !== ZC._n_(t = this.FL.o.tooltip)) return t;
          if (null !== ZC._n_(t = this.FL.o["tooltip-text"])) return {
            text: t
          };
        }
        return {};
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        if (t.BP = t.NQ(), _get(_getPrototypeOf(A5Y.prototype), "parse", this).call(this), null !== ZC._n_(t.A3N = t.o.goals)) for (var i = 0, a = t.A3N.length; i < a; i++) null !== ZC._n_(t.A3N[i]) ? "string" == typeof t.A3N[i] ? t.QB[i] = ZC.AV(t.CL.JQ, t.A3N[i]) : t.QB[i] = ZC._f_(t.A3N[i]) : t.QB[i] = null;
        t.FL = new I3(t), t.FL.copy(t), t.FL.append({
          "background-color": t.BP[3]
        }), t.FL.o["tooltip-text"] = "%node-goal-value", t.H.B8.load(t.FL.o, ["(" + t.AF + ").plot.goal"], !0, !0), null !== ZC._n_(e = t.o.goal) && t.FL.append(e), t.FL.parse();
      }
    }]);
    return A5Y;
  }(A2S);
  var TV = /*#__PURE__*/function (_A5Y) {
    _inherits(TV, _A5Y);
    function TV(e) {
      var _this73;
      _classCallCheck(this, TV);
      _this73 = _possibleConstructorReturn(this, _getPrototypeOf(TV).call(this, e)), _this73.AF = "vbullet";
      return _this73;
    }
    _createClass(TV, [{
      key: "FY",
      value: function FY() {
        return new A6I(this);
      }
    }]);
    return TV;
  }(A5Y);
  var TR = /*#__PURE__*/function (_A5Y2) {
    _inherits(TR, _A5Y2);
    function TR(e) {
      var _this74;
      _classCallCheck(this, TR);
      _this74 = _possibleConstructorReturn(this, _getPrototypeOf(TR).call(this, e)), _this74.AF = "hbullet";
      return _this74;
    }
    _createClass(TR, [{
      key: "FY",
      value: function FY() {
        return new A6K(this);
      }
    }]);
    return TR;
  }(A5Y);
  var XQ = /*#__PURE__*/function (_WK6) {
    _inherits(XQ, _WK6);
    function XQ(e) {
      var _this75;
      _classCallCheck(this, XQ);
      _this75 = _possibleConstructorReturn(this, _getPrototypeOf(XQ).call(this, e));
      var t = _assertThisInitialized(_this75);
      t.AF = "piano", t.CV = "alpha", t.A85 = "plot-max", t.QT = .2, t.VD = 1, t.PA = "bg";
      return _this75;
    }
    _createClass(XQ, [{
      key: "FY",
      value: function FY() {
        return new A86(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.B7 = e.BP[1], e.BW = e.BP[1], e.A0 = e.BP[2], e.AE = e.BP[1], e.NE(), _get(_getPrototypeOf(XQ.prototype), "parse", this).call(this), e.assign_a([["min-ratio", "QT", "f", 0, 1], ["max-ratio", "VD", "f", 0, 1], ["reference", "A85", ""]]), e.QT >= e.VD && (e.QT = .2, e.VD = 1), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(XQ.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.A5F = e.A45 = -ZC.MAX, e.YT = e.X5 = ZC.MAX, e.A6T = e.A5P = 0;
        for (var t = 0, i = e.A.A4.length; t < i; t++) for (var a = e.A.A4[t], n = 0, l = a.S.length; n < l; n++) if (a.S[n]) {
          var r = ZC._f_(a.S[n].AD);
          a.L === e.L && (e.A5F = ZC.BQ(e.A5F, r), e.YT = ZC.CX(e.YT, r), e.A6T += r), e.A45 = ZC.BQ(e.A45, r), e.X5 = ZC.CX(e.X5, r), e.A5P += r;
        }
        e.OH();
      }
    }]);
    return XQ;
  }(WK);
  var WI = /*#__PURE__*/function (_WK7) {
    _inherits(WI, _WK7);
    function WI(e) {
      var _this76;
      _classCallCheck(this, WI);
      _this76 = _possibleConstructorReturn(this, _getPrototypeOf(WI).call(this, e));
      var t = _assertThisInitialized(_this76);
      t.LA = .1, t.ON = .1, t.M6 = 0, t.A33 = "dynamic", t.P8 = [], t.WA = [], t.PA = "bg";
      return _this76;
    }
    _createClass(WI, [{
      key: "parse",
      value: function parse() {
        var e,
          t,
          i,
          a,
          n = this;
        if (n.BP = n.NQ(), n.C2 = n.BP[0], n.B7 = n.BP[1], n.BW = n.BP[1], n.A0 = n.BP[2], n.AE = n.BP[1], n.NE(), _get(_getPrototypeOf(WI.prototype), "parse", this).call(this), n.assign_a([["start-width", "A33"], ["min-exit", "M6", "fp"], ["space-entry", "LA", "fp"], ["offset", "LA", "fp"], ["offset", "ON", "fp"]]), null !== ZC._n_(i = n.o.entry)) for (i instanceof Array || (i = [i]), e = 0, t = i.length; e < t; e++) {
          var l = new DW(n);
          l.o = i[e], l.parse(), n.P8.push(l);
        }
        if (null !== ZC._n_(a = n.o.exit)) for (a instanceof Array || (a = [a]), e = 0, t = a.length; e < t; e++) {
          var r = new DW(n);
          r.o = a[e], r.parse(), n.WA.push(r);
        }
        n.B1 = n.C.BJ(n.BT("k")[0]), n.CL = n.C.BJ(n.BT("v")[0]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(WI.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.OH();
      }
    }]);
    return WI;
  }(WK);
  var VY = /*#__PURE__*/function (_WI) {
    _inherits(VY, _WI);
    function VY(e) {
      var _this77;
      _classCallCheck(this, VY);
      _this77 = _possibleConstructorReturn(this, _getPrototypeOf(VY).call(this, e)), _this77.AF = "vfunnel";
      return _this77;
    }
    _createClass(VY, [{
      key: "FY",
      value: function FY() {
        return new A6G(this);
      }
    }]);
    return VY;
  }(WI);
  var VT = /*#__PURE__*/function (_WI2) {
    _inherits(VT, _WI2);
    function VT(e) {
      var _this78;
      _classCallCheck(this, VT);
      _this78 = _possibleConstructorReturn(this, _getPrototypeOf(VT).call(this, e)), _this78.AF = "hfunnel";
      return _this78;
    }
    _createClass(VT, [{
      key: "FY",
      value: function FY() {
        return new A6D(this);
      }
    }]);
    return VT;
  }(WI);
  var VZ = /*#__PURE__*/function (_A2S4) {
    _inherits(VZ, _A2S4);
    function VZ(e) {
      var _this79;
      _classCallCheck(this, VZ);
      _this79 = _possibleConstructorReturn(this, _getPrototypeOf(VZ).call(this, e));
      var t = _assertThisInitialized(_this79);
      t.AF = "stock", t.CV = "candlestick", t.N6 = {
        size: 0
      }, t.PA = "bg";
      return _this79;
    }
    _createClass(VZ, [{
      key: "FY",
      value: function FY() {
        return new A7W(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(VZ.prototype), "parse", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(VZ.prototype), "paint", this).call(this), this.paintPreview();
      }
    }, {
      key: "paintPreview",
      value: function paintPreview() {
        var e = this,
          t = e.C.BJ(e.BT("v")[0]),
          i = t.AM(t.HA);
        if (e.C.B9 && e.C.B9.IP && e.R8) {
          for (var a = e.C.P, n = e.C.B9, l = [], r = [], o = !0, s = 0, C = e.S.length; s < C; s++) if (null !== ZC._n_(e.S[s]) && null !== ZC._n_(e.S[s].DN[2])) {
            var A = t.AM(e.S[s].DN[2]);
            o && (r.push([e.S[s].iX, i]), o = !1), l.push([e.S[s].iX, A]), r.push([e.S[s].iX, A]);
          }
          r.length && r.push([r[r.length - 1][0], i]);
          var Z = e.mapPointsToPreview(r),
            c = e.o.preview || {};
          if ("area" === (c.type || "area")) {
            var p = new DW(e.A);
            p.copy(e), p.append({
              "background-color": e.BW,
              "alpha-area": .2
            }), p.append(c), p.parse(), p.CY = !0, p.LD = !0, p.AZ = 0, p.AU = 0, p.EX = 0, p.GD = 0, p.C6 = ZC._f_(p.o["alpha-area"]), p.D0 = [a.iX, a.iY, a.iX + a.I, a.iY + a.F], p.K = e.K + "-area-preview", p.Z = n.Z, p.D = Z, p.paint();
          }
          var u = e.mapPointsToPreview(l),
            h = ZC.Q.E9(n.Z, e.H.AA),
            _ = new CZ(e);
          _.copy(e), _.append({
            "line-color": e.BW,
            "line-width": 1
          }), _.append(c), _.parse(), ZC.CQ.paint(h, _, u, null, 3);
        }
      }
    }]);
    return VZ;
  }(A2S);
  var Y3 = /*#__PURE__*/function (_IM5) {
    _inherits(Y3, _IM5);
    function Y3(e) {
      var _this80;
      _classCallCheck(this, Y3);
      _this80 = _possibleConstructorReturn(this, _getPrototypeOf(Y3).call(this, e));
      var t = _assertThisInitialized(_this80);
      t.AF = "gauge", t.T1 = 3, t.BO = ["scale-r", ZC._[52], "scale"], t.I6 = .5, t.I4 = [10, 0, 0, 0, 0], t.PA = "bg";
      return _this80;
    }
    _createClass(Y3, [{
      key: "FY",
      value: function FY() {
        return new A7S(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        t.BP = t.NQ(), t.C2 = t.BP[0], t.B7 = t.BP[1], t.A0 = t.BP[3], t.AE = t.BP[3], t.NE(), _get(_getPrototypeOf(Y3.prototype), "parse", this).call(this), t.assign_a([["alpha-area", "I6", "f", 0, 1], ["indicator", "I4"]]), null !== ZC._n_(e = t.o.csize) && (t.I4[0] = ZC._i_(e)), t.I4 = [ZC._f_(t.I4[0] || "10"), ZC._f_(t.I4[1] || "0"), ZC._f_(t.I4[2] || "0"), ZC._f_(t.I4[3] || "0"), ZC._f_(t.I4[4] || "0")];
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(Y3.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.OH(!0);
      }
    }]);
    return Y3;
  }(IM);
  var UJ = /*#__PURE__*/function (_WK8) {
    _inherits(UJ, _WK8);
    function UJ(e) {
      var _this81;
      _classCallCheck(this, UJ);
      _this81 = _possibleConstructorReturn(this, _getPrototypeOf(UJ).call(this, e));
      var t = _assertThisInitialized(_this81);
      t.AF = "range", t.Y = 1, t.CV = "segmented", t.T1 = 3, t.I6 = .5;
      return _this81;
    }
    _createClass(UJ, [{
      key: "FY",
      value: function FY() {
        return new A7O(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.B7 = e.BP[1], e.A0 = e.BP[0], e.AE = e.BP[1], e.NE(), _get(_getPrototypeOf(UJ.prototype), "parse", this).call(this), e.applyRGBA(), e.YU("alpha-area", "I6", "f", 0, 1), e.B1 = e.C.BJ(e.BT("k")[0]), e.CL = e.C.BJ(e.BT("v")[0]);
      }
    }, {
      key: "OH",
      value: function OH() {
        var e,
          t,
          i = this,
          a = i.P2;
        i.VW(!1);
        var n = i.C.P;
        i.Y = 1;
        var l = a ? n.F : n.I;
        i.B1.EF || !i.QL && 5 * (i.B1.A1 - i.B1.W) > l && (i.Y = ZC._i_(5 * (i.B1.A1 - i.B1.W) / l));
        var r = i.B1.EF;
        if (r && i.QG[0] === ZC.MAX && i.QG[1] === -ZC.MAX && (r = !1), r) for (e = 0, t = i.S.length; e < t; e++) i.S[e] && ZC.DR(i.S[e].BU, i.B1.V[i.B1.W], i.B1.V[i.B1.A1]) && (i.S[e].Z = i.KM, i.S[e].MZ = "min", i.S[e].paint(), i.S[e].MZ = "max", i.S[e].paint(), delete i.S[e].E["intersect.index"]);else for (e = i.B1.W; e <= i.B1.A1; e += i.Y) i.S[e] && (i.S[e].MZ = "min", i.S[e].paint(), i.S[e].MZ = "max", i.S[e].paint(), delete i.S[e].E["intersect.index"]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(UJ.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.A50 = ZC.Q.E9(e.CN("bl", 1), e.H.AA), e.QQ = ZC.Q.E9(e.CN("bl", 2), e.H.AA), e.OH(), e.D = null, e.D5 = null, e.A0B = null, e.SH = null;
      }
    }]);
    return UJ;
  }(WK);
  var Y1 = /*#__PURE__*/function (_WH) {
    _inherits(Y1, _WH);
    function Y1(e) {
      var _this82;
      _classCallCheck(this, Y1);
      _this82 = _possibleConstructorReturn(this, _getPrototypeOf(Y1).call(this, e));
      _this82.AF = "pie3d", _this82.NY = -1;
      return _this82;
    }
    _createClass(Y1, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(Y1.prototype), "parse", this).call(this), this.assign_a([["thickness", "NY", "ia"]]);
      }
    }, {
      key: "FY",
      value: function FY() {
        return new A81(this);
      }
    }]);
    return Y1;
  }(WH);
  var V3 = /*#__PURE__*/function (_R) {
    _inherits(V3, _R);
    function V3(e) {
      var _this83;
      _classCallCheck(this, V3);
      _this83 = _possibleConstructorReturn(this, _getPrototypeOf(V3).call(this, e)), _this83.AF = "vbar3d";
      return _this83;
    }
    _createClass(V3, [{
      key: "FY",
      value: function FY() {
        return new A76(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        _get(_getPrototypeOf(V3.prototype), "parse", this).call(this), null === ZC._n_(e.o[ZC._[61]]) && (e.BW = e.BP[0]), null === ZC._n_(e.o["line-color"]) && (e.B7 = e.BP[0]);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(V3.prototype), "paint", this).call(this), this.sharedZScale();
      }
    }]);
    return V3;
  }(R3);
  var WS = /*#__PURE__*/function (_R2) {
    _inherits(WS, _R2);
    function WS(e) {
      var _this84;
      _classCallCheck(this, WS);
      _this84 = _possibleConstructorReturn(this, _getPrototypeOf(WS).call(this, e)), _this84.AF = "hbar3d";
      return _this84;
    }
    _createClass(WS, [{
      key: "FY",
      value: function FY() {
        return new A75(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        _get(_getPrototypeOf(WS.prototype), "parse", this).call(this), null === ZC._n_(e.o[ZC._[61]]) && (e.BW = e.BP[0]), null === ZC._n_(e.o["line-color"]) && (e.B7 = e.BP[0]);
      }
    }]);
    return WS;
  }(R9);
  var UW = /*#__PURE__*/function (_R3) {
    _inherits(UW, _R3);
    function UW(e) {
      var _this85;
      _classCallCheck(this, UW);
      _this85 = _possibleConstructorReturn(this, _getPrototypeOf(UW).call(this, e)), _this85.AF = "line3d";
      return _this85;
    }
    _createClass(UW, [{
      key: "FY",
      value: function FY() {
        return new A74(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        _get(_getPrototypeOf(UW.prototype), "parse", this).call(this), null === ZC._n_(e.o[ZC._[61]]) && (e.BW = e.BP[1]);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(UW.prototype), "paint", this).call(this), this.sharedZScale();
      }
    }]);
    return UW;
  }(R4);
  var V6 = /*#__PURE__*/function (_R4) {
    _inherits(V6, _R4);
    function V6(e) {
      var _this86;
      _classCallCheck(this, V6);
      _this86 = _possibleConstructorReturn(this, _getPrototypeOf(V6).call(this, e)), _this86.AF = "area3d";
      return _this86;
    }
    _createClass(V6, [{
      key: "FY",
      value: function FY() {
        return new A73(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        _get(_getPrototypeOf(V6.prototype), "parse", this).call(this), null === ZC._n_(e.o[ZC._[61]]) && (e.BW = e.BP[1]);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(V6.prototype), "paint", this).call(this), this.sharedZScale();
      }
    }]);
    return V6;
  }(R0);
  var Z3 = /*#__PURE__*/function (_IM6) {
    _inherits(Z3, _IM6);
    function Z3(e) {
      var _this87;
      _classCallCheck(this, Z3);
      _this87 = _possibleConstructorReturn(this, _getPrototypeOf(Z3).call(this, e));
      var t = _assertThisInitialized(_this87);
      t.AF = "venn", t.ACC = [], t.AAA = [], t.BO = ["scale"], t.PA = "bg";
      return _this87;
    }
    _createClass(Z3, [{
      key: "FY",
      value: function FY() {
        return new A8F(this);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.BP = e.NQ(), e.C2 = e.BP[0], e.BW = e.BP[1], e.A0 = e.BP[3], e.AE = e.BP[3], e.NE(), _get(_getPrototypeOf(Z3.prototype), "parse", this).call(this), e.assign_a([["join", "ACC"], ["share", "AAA"]]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(Z3.prototype), "paint", this).call(this), e.KM = e.CN("bl", 0), e.OH(!0);
      }
    }]);
    return Z3;
  }(IM);
  var MI = /*#__PURE__*/function (_DT2) {
    _inherits(MI, _DT2);
    function MI(e) {
      var _this88;
      _classCallCheck(this, MI);
      _this88 = _possibleConstructorReturn(this, _getPrototypeOf(MI).call(this, e));
      var t = _assertThisInitialized(_this88);
      t.C = e.A.A, t.H = t.C.A, t.L = -1, t.AD = null, t.DN = [], t.CR = null, t.BU = null, t.CI = null, t.JT = [], t.IP = !1, t.QD = !0, t.N = t, t.JK = !1, t.A2P = !1;
      return _this88;
    }
    _createClass(MI, [{
      key: "GN",
      value: function GN(e, t) {
        _get(_getPrototypeOf(MI.prototype), "GN", this).call(this, this.A, e, t, this.LM(null, !1), this.A.MV);
      }
    }, {
      key: "OL",
      value: function OL() {
        return [this.iX, this.iY, {
          reference: this,
          center: !0
        }];
      }
    }, {
      key: "A6B",
      value: function A6B() {
        return [this.iX, this.iY];
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition(e, t, i) {
        var a,
          n,
          l,
          r,
          o = this;
        switch (o.paint(!0), a = o.iX, n = o.iY, l = o.I, r = o.F, t) {
          case "center":
            a = o.iX + l / 2, n = o.iY + r / 2;
            break;
          case "top":
            a = o.iX + l / 2, n = o.iY, n = i ? n - i : n;
            break;
          case "bottom":
            a = o.iX + l / 2, n = o.iY + r, n = i ? n + i : n;
            break;
          case "left":
            a = o.iX, n = o.iY + r / 2, a = i ? a - i : a;
            break;
          case "right":
            a = o.iX + l, n = o.iY + r / 2, a = i ? a + i : a;
            break;
          default:
            a += o.BM, n += o.BH;
        }
        return {
          x: a,
          y: n
        };
      }
    }, {
      key: "setNodeData",
      value: function setNodeData(e) {
        var t = this;
        for (var i in e) e.hasOwnProperty(i) && (t.A.IA ? t.A.S[t.L][i] = e[i] : t.E[i] = e[i]);
      }
    }, {
      key: "getNodeData",
      value: function getNodeData(e) {
        return this.A.IA ? this.A.S[this.L][e] : this.E[e];
      }
    }, {
      key: "XD",
      value: function XD() {
        var e,
          t,
          i = this,
          a = i.C.E,
          n = i.A.L;
        null === ZC._n_(a.update) && (a.update = {});
        var l = a.update,
          r = "" + i.AD,
          o = i.A.LV();
        for (ZC.PL(r) && ZC._f_(r) < 0 && "currency" === o.negation && (r = ZC._a_(ZC._f_(r))), o.utc = i.C.UY, o.timezone = i.C.NI, r = ZC.AQ.G5(r, o, i.A), l["plot-" + n + "-value"] = r, l["plot-" + n + "-value-0"] = r, e = 0, t = i.DN.length; e < t; e++) l["plot-" + n + "-value-" + (e + 1)] = i.DN[e];
        for (l["plot-value"] = l["plot-value-0"] = r, e = 0, t = i.DN.length; e < t; e++) l["plot-value-" + (e + 1)] = i.DN[e];
        for (var s in i.A.KJ) {
          var C = null;
          C = "object" == typeof i.A.KJ[s] && i.A.KJ[s].length ? i.A.KJ[s][i.L] : i.A.KJ[s], l["plot-" + n + "-data-" + s] = C;
        }
      }
    }, {
      key: "S0",
      value: function S0() {
        var e,
          t,
          i = this,
          a = i.A.B1,
          n = i.A.CL,
          l = [a.W, a.A1, n.W, n.A1];
        if (i.A.IA && (i.CR = i.A.S[i.L].CR), i.JT !== l) {
          a.CO ? (null !== i.BU ? i.iY = a.AM(i.BU) : i.iY = a.H6(i.L), i.A.CB && "100%" === i.A.KX ? i.A.A.F9[i.L]["%total-" + i.A.DY] > 0 ? i.iX = n.AM(100 * i.CR / i.A.A.F9[i.L]["%total-" + i.A.DY]) : i.iX = n.AM(100 * i.CR) : i.iX = n.AM(i.CR + 0)) : (null !== i.BU ? i.iX = a.AM(i.BU) : i.A.M1 ? "bar" === i.A.sMetaType ? i.iX = a.H6(i.A.RI) : i.iX = a.H6(i.A.RI) + i.A.S4 + i.L * (a.AC - 2 * i.A.S4) / (i.A.S.length - 1) - a.AC / 2 : "log" === a.C1 ? i.iX = a.AM(i.L) : i.iX = a.H6(i.L), i.A.CB && "100%" === i.A.KX ? i.A.A.F9[i.L]["%total-" + i.A.DY] > 0 ? i.iY = n.AM(100 * i.CR / i.A.A.F9[i.L]["%total-" + i.A.DY]) : i.iY = n.AM(100 * i.CR) : i.iY = n.AM(i.CR + 0)), i.A.IA && (i.A.S[i.L].iX = i.iX, i.A.S[i.L].iY = i.iY), i.JT = l;
        }
        i.IP || (0 !== i.A.E5.length || -1 === ZC.AV(["line", "area", "vbar", "hbar", "line3d", "area3d", "vbar3d", "hbar3d"], i.A.AF) || i.A.o.override ? ZC.A5.browser.mozilla ? (i.copy(i.A), i.E5 = i.A.E5, i.DB(), i.parse(!1), i.N = i) : i.A.o.override ? (i.copy(i.A), i.E5 = i.A.E5, i.DB(), i.parse(!1), i.N = i) : (e = i.A9A(i.A.E5), null === ZC._n_(t = i.A.A6P[e]) ? (i.copy(i.A), i.E5 = i.A.E5, i.DB(), i.parse(!1), i.N = i, i.A.A6P[e] = i) : i.N = t) : i.N = i.A, i.A.o.override && (i.N.E.plotidx = i.A.L, i.N.E.nodeidx = i.L, i.N.parse(!1)), i.IP = !0);
      }
    }, {
      key: "a11y",
      value: function a11y() {
        var e = this,
          t = "";
        if (e.H.bA11y) {
          if (e.A.IA) {
            var i = this.A.FK(e.L, 1, !0);
            i && (t = i.ES(this.C.A7.o.text || this.A.A7.o.text || this.A.JD));
          } else t = e.ES(this.C.A7.o.text || this.A.A7.o.text || this.A.JD);
          return e.A.AO && -1 === t.indexOf(e.A.AO) && (t = e.A.AO + ":" + t), t = t.replace(/<.+?>/gi, " "), 'tabindex="0" aria-label="Series ' + (this.A.L + 1) + " of " + this.A.A.A4.length + ", point " + (this.L + 1) + " of " + this.A.S.length + ". " + t + '"';
        }
        return "";
      }
    }, {
      key: "HE",
      value: function HE() {
        var e,
          t = this;
        if (t.o[ZC._[9]] instanceof Array && (t.CI = t.o[ZC._[9]].join(" "), "string" == typeof t.o[ZC._[9]][0] ? -1 !== (e = ZC.AV(t.A.B1.J0, t.o[ZC._[9]][0])) ? t.BU = e : (t.A.B1.J0.push(t.o[ZC._[9]][0]), t.BU = t.A.B1.J0.length - 1) : t.BU = parseFloat(t.o[ZC._[9]][0]), "string" == typeof t.o[ZC._[9]][1] ? -1 !== (e = ZC.AV(t.A.CL.JQ, t.o[ZC._[9]][1])) ? t.AD = e : (t.A.CL.JQ.push(t.o[ZC._[9]][1]), t.AD = t.A.CL.JQ.length - 1) : t.AD = parseFloat(t.o[ZC._[9]][1]), null !== t.BU && t.A.TA(t.BU, t.L), t.A.ZK > 0 && t.o[ZC._[9]].length > t.A.ZK)) for (var i = t.o[ZC._[9]].length - t.A.ZK; i < t.o[ZC._[9]].length; i++) t.DN.push(t.o[ZC._[9]][i]);
      }
    }, {
      key: "parse",
      value: function parse(e) {
        var t = this;
        if (t.E.plotidx = t.A.L, t.E.nodeidx = t.L, t.K = t.A.K + "-node-" + t.L, null === ZC._n_(e) && (e = !0), e) {
          if (t.o[ZC._[9]] instanceof Array || t.A.AAH) t.HE();else if (t.CI = t.o[ZC._[9]], "string" == typeof t.o[ZC._[9]]) {
            var i = ZC.AV(t.A.CL.JQ, t.o[ZC._[9]]);
            -1 !== i ? t.AD = i : (t.A.CL.JQ.push(t.o[ZC._[9]]), t.AD = t.A.CL.JQ.length - 1);
          } else t.AD = t.o[ZC._[9]];
          null === t.CR && (t.CR = t.AD);
        } else _get(_getPrototypeOf(MI.prototype), "parse", this).call(this);
      }
    }, {
      key: "IV",
      value: function IV(e) {
        return this.ES(e, {});
      }
    }, {
      key: "getFormatValue",
      value: function getFormatValue() {
        return this.AD;
      }
    }, {
      key: "ES",
      value: function ES(AO, EQ, M0, bUrl) {
        var s = this,
          G,
          CI,
          BD,
          i,
          A6,
          D4,
          oRE;
        typeof M0 === ZC._[31] && (M0 = !1);
        var oPPI = s.A.JR,
          oPS = s.A.A,
          EY,
          PS;
        if (!bUrl && "javascript:" === AO.substring(0, 11)) try {
          var EA = AO.replace("javascript:", "").replace("()", "");
          eval(EA) && (G = 0 === s.DN.length ? s.AD : [s.AD].concat(s.DN), AO = eval(EA).call(s, G, {
            nodeindex: s.L,
            plotindex: s.A.L,
            plotid: s.A.HB,
            nodeinfo: s.LM(null, !1),
            plotinfo: s.A.TF()
          }) || AO);
        } catch (e) {}
        if (AO += "", s.A.A7Q) {
          for (EY in CI = s.getFormatValue(), null !== ZC._n_(s.A.CL.JQ[CI]) && s.A2P && (CI = s.A.CL.JQ[CI]), AO = AO.replace(/%node-numeric-value/g, s.AD).replace(/%node-value/g, CI).replace(/%previous-node-value/g, s.A.S[s.L - 1] ? s.A.S[s.L - 1].AD : null).replace(/%next-node-value/g, s.A.S[s.L + 1] ? s.A.S[s.L + 1].AD : null).replace(/%node-index/g, s.L).replace(/%plot-text/g, s.A.AO).replace(/%plot-index/g, s.A.L).replace(/%plot-count/g, oPS.A4.length).replace(/%p/g, s.A.L).replace(/%P/g, oPS.A4.length).replace(/%v/g, CI).replace(/%V/g, s.AD).replace(/%i/g, s.L).replace(/%n/g, s.L), s.A.KJ) PS = "", PS = s.A.KJ[EY] instanceof Array ? null !== s.A.KJ[EY][s.L] ? s.A.KJ[EY][s.L] : "" : null !== s.A.KJ[EY] ? s.A.KJ[EY] : "", oRE = new RegExp("%data-" + EY, "g"), AO = AO.replace(oRE, PS);
          return AO;
        }
        var Q0 = "",
          SD = "",
          S1 = "",
          WY = "",
          R = s.C.BJ(s.A.BT("k")[0]),
          X = s.C.BJ(s.A.BT("v")[0]);
        R && (null !== s.BU ? Q0 = SD = S1 = s.BU : (null !== ZC._n_(R.V[s.L]) && (Q0 = SD = S1 = R.V[s.L]), null !== ZC._n_(R.BY[s.L]) && (S1 = SD = R.BY[s.L]))), null !== ZC._n_(G = s.A.B1.J0[Q0]) && "number" == typeof Q0 && (Q0 = G), null !== ZC._n_(G = s.A.B1.J0[SD]) && "number" == typeof SD && (SD = G), null !== ZC._n_(G = s.A.B1.J0[S1]) && "number" == typeof S1 && (S1 = G), WY = null !== ZC._n_(s.A.AO) ? s.A.AO : "Series " + (s.A.L + 1), s.A.M1 && s.A.A.A4[s.L] && (WY = s.A.A.A4[s.L].AO || "Series " + s.L);
        var UH = (WY + "").split(/\s+/),
          A6N = Q0;
        R && (BD = R.LV(), EQ && EQ[ZC._[68]] && ZC._cp_({
          "transform-date": !0,
          "transform-date-format": EQ[ZC._[67]]
        }, BD), BD.utc = s.C.UY, BD.timezone = s.C.NI, S1 = SD = ZC.AQ.G5(Q0, BD, R, !0), null === s.BU && (null === ZC._n_(R.BY[s.BU]) && null === ZC._n_(R.BY[s.L]) || (SD = S1 = R.BY[s.BU] || R.BY[s.L])), BD[ZC._[68]] && (S1 = ZC.AQ.G5(S1, BD, R, !0)));
        var A5V = (SD + "").split(/\s+/),
          A7A = (S1 + "").split(/\s+/),
          WT = (Q0 + "").split(/\s+/);
        CI = s.getFormatValue(), s.A.CL && null !== ZC._n_(s.A.CL.JQ[CI]) && s.A2P && (CI = s.A.CL.JQ[CI]);
        var OY = ZC.PL(CI) && ZC._f_(CI) < 0;
        if (BD = s.A.LV(), ZC._cp_(EQ, BD), OY && "currency" === BD.negation && (CI = ZC._a_(ZC._f_(CI))), BD.utc = s.C.UY, BD.timezone = s.C.NI, CI = ZC.AQ.G5(CI, BD, s.A, !(!X || !X.FI) && X.FI), "%v" === AO && "%vv" !== AO || "%node-value" === AO) return CI;
        if ("%t" === AO || "%plot-text" === AO) return WY;
        var CU = s.CU || [],
          oNode_,
          Z5,
          A6X,
          oPlot_,
          p,
          pLen;
        if (X && X.KV) {
          var ZD = X.LV();
          null === ZC._n_(ZD[ZC._[12]]) && (ZD[ZC._[12]] = 0);
          var ABA = X.CO ? X.KV(this.iX, !0, "piano" === s.A.AF) : X.KV(this.iY, !0, "piano" === s.A.AF),
            XG = X.FC(0, ABA, ZD);
          CU.push(["%scale-value-value", XG], ["%vv", XG]), null !== ZC._n_(G = X.BY[s.L]) ? CU.push(["%scale-value-label", G], ["%vl", G]) : CU.push(["%scale-value-label", XG], ["%vl", XG]);
        }
        if (X && (-1 !== AO.indexOf("%scale-value-text") || -1 !== AO.indexOf("%vt"))) for (-1 !== (G = ZC.AV(X.V, s.AD)) && null !== ZC._n_(X.BY) && null !== ZC._n_(X.BY[G]) ? CU.push(["%scale-value-text", X.BY[G]], ["%vt", X.BY[G]]) : CU.push(["%scale-value-text", s.AD], ["%vt", s.AD]), oRE = -1 !== AO.indexOf("%vt(") ? new RegExp("(%vt)\\(([0-9]*)\\)") : new RegExp("(%scale-value-text)\\(([0-9]*)\\)"); D4 = oRE.exec(AO);) Z5 = "", "" !== (G = D4[2]) && (A6X = ZC._i_(G), null !== ZC._n_(oPlot_ = s.A.A.A4[A6X]) && (oNode_ = oPlot_.FK(s.L), null !== oNode_ && (Z5 = oNode_.ES(D4[1])))), AO = AO.replace(D4[0], Z5), "" !== Z5 && CU.push([D4[0], Z5]);
        for (EY in null !== ZC._n_(s.A.M5) && null !== ZC._n_(s.A.M5[s.L]) && CU.push(["%offset-values", s.A.M5[s.L]]), s.A.A.A2E && CU.push(["%stack-top", -1 !== ZC.AV(s.A.A.A2E, s.A.L) ? 1 : 0]), s.A.KJ) PS = "", PS = s.A.KJ[EY] instanceof Array ? null !== s.A.KJ[EY][s.L] ? s.A.KJ[EY][s.L] : "" : null !== s.A.KJ[EY] ? s.A.KJ[EY] : "", "number" == typeof PS && (PS = ZC.AQ.G5(PS, BD, s.A, !(!X || !X.FI) && X.FI)), CU.push(["%data-" + EY, PS]);
        for (i = 0; i < A5V.length; i++) CU.push(["%scale-key-label-" + i, A5V[i]], ["%kl" + i, A5V[i]]);
        for (i = 0; i < A7A.length; i++) CU.push(["%scale-key-text-" + i, A7A[i]], ["%kt" + i, A7A[i]]);
        for (i = 0; i < WT.length; i++) CU.push(["%scale-key-value-" + i, WT[i]], ["%kv" + i, WT[i]], ["%k" + i, WT[i]]);
        for (p = 0, pLen = oPS.A4.length; p < pLen; p++) null !== ZC._n_(oPS.A4[p].S[s.L]) && CU.push(["%plot-" + p + "-value", oPS.A4[p].S[s.L].AD]);
        CU.push(["%scale-key-label", SD], ["%scale-key-text", S1], ["%scale-key-value", Q0], ["%scale-key-value-ts", A6N], ["%kvts", A6N], ["%kt", S1], ["%kl", SD], ["%kv", Q0], ["%k", Q0], ["%node-value", CI], ["%v", CI], ["%node-numeric-value", s.AD], ["%previous-node-value", s.A.S[s.L - 1] ? s.A.S[s.L - 1].AD : null], ["%next-node-value", s.A.S[s.L + 1] ? s.A.S[s.L + 1].AD : null], ["%V", s.AD], ["%node-index", s.L], ["%node-x", s.iX], ["%node-y", s.iY], ["%chart-width", s.H.I], ["%chart-height", s.H.F], ["%i", s.L], ["%n", s.L], ["%node-count", s.A.S.length], ["%N", s.A.S.length]);
        var ABZ = oPPI["%plot-sum"],
          A4I = ABZ + "",
          ABY = oPPI["%plot-average"],
          A4H = ABY + "",
          A93 = ZC._f_(oPS.F9["%pstack-" + s.L + "-" + s.A.DY + "-sum"] || "0"),
          A56 = A93 + "",
          ABT = ZC._f_(A93 / oPS.F9["%pstack-" + s.L + "-" + s.A.DY + "-stack-length"]),
          A52 = String(ABT),
          AAM = String(oPS.F9["%pstack-" + s.L + "-" + s.A.DY + "-stack-length"]),
          A7P = 0;
        null !== ZC._n_(oPS.F9) && null !== ZC._n_(oPS.F9[s.L]) && (A7P = ZC._f_(oPS.F9[s.L]["%total-" + s.A.DY] || "0"));
        var A4C = A7P + "";
        A4I = ZC.AQ.G5(A4I, BD), A4H = ZC.AQ.G5(A4H, BD), A4C = ZC.AQ.G5(A4C, BD), A56 = ZC.AQ.G5(A56, BD), A52 = ZC.AQ.G5(A52, BD), CU.push(["%node-error-plus", s.E["node-error-plus"]], ["%node-error-minus", s.E["node-error-minus"]], ["%stack-total", A56], ["%stack-average", A52], ["%stack-length", AAM], ["%total", A4C], ["%plot-min-index", oPPI["%plot-min-index"]], ["%pmi", oPPI["%plot-min-index"]], ["%plot-max-index", oPPI["%plot-max-index"]], ["%pxi", oPPI["%plot-max-index"]], ["%plot-min-value", oPPI["%plot-min-value"]], ["%pmv", oPPI["%plot-min-value"]], ["%plot-max-value", oPPI["%plot-max-value"]], ["%pxv", oPPI["%plot-max-value"]], ["%plot-sum", A4I], ["%psum", A4I], ["%plot-average", A4H], ["%pavg", A4H], ["%plot-values", oPPI["%plot-values"]], ["%pv", oPPI["%plot-values"]]);
        var A9R = 100 * s.AD / oPPI["%plot-sum"],
          ZI = A9R + "";
        null !== ZC._n_(BD[ZC._[12]]) && (ZI = ZC.AQ.G5(ZI, BD)), CU.push(["%plot-percent", ZI], ["%pper", ZI]);
        var bNpv = !1,
          WN,
          AX,
          J,
          C0;
        for (i = 0, A6 = CU.length; i < A6; i++) if ("%npv" === CU[i][0]) {
          bNpv = !0;
          break;
        }
        if (!bNpv && null !== ZC._n_(s.A.A.F9) && null !== ZC._n_(s.A.A.F9[s.L])) {
          var JU = 100 * s.AD / s.A.A.F9[s.L]["%total-" + s.A.DY],
            HX = JU + "";
          null !== ZC._n_(BD[ZC._[12]]) && (HX = ZC.AQ.G5(HX, BD)), CU.push(["%node-percent-value", HX], ["%npv", HX]);
        }
        for (i = 0; i < UH.length; i++) CU.push(["%plot-text-" + i, UH[i]], ["%t" + i, UH[i]]);
        for (CU.push(["%plot-text", WY], ["%t", WY], ["%plot-description", s.A.PC], ["%plot-index", s.A.L], ["%p", s.A.L], ["%plot-count", oPS.A4.length], ["%P", oPS.A4.length], ["%id", s.H.K], ["%graphid", s.C.K.replace(s.H.K + "-graph-", "")]), -1 !== AO.indexOf("%negation") && (OY && "currency" === BD.negation ? (CU.push(["%negation", "-"]), OY = !1) : CU.push(["%negation", ""])), CU.push(["%node-x", s.iX], ["%node-y", s.iY], ["%node-width", s.I], ["%node-height", s.F], ["%node-size", s.E["marker.size"] || 1]), zingchart.DEV.SORTTOKENS && CU.sort(ZC.A2G), oRE = new RegExp("\\(([^(]+?)\\)\\(([0-9]*)\\)(\\(*)([0-9]*)(\\)*)"); D4 = oRE.exec(AO);) {
          WN = "";
          var CP = s.A.L,
            D8 = s.L;
          "" !== (G = D4[2]) && (CP = ZC._i_(G)), "" !== (G = D4[4]) && (D8 = ZC._i_(G)), null !== (J = oPS.A4[CP]) && (AX = J.FK(D8, 3), null !== AX && (WN = AX.ES(D4[1], EQ))), AO = AO.replace(D4[0], WN);
        }
        if (-1 !== AO.indexOf("%prop-")) {
          oRE = new RegExp("%prop-([a-zA-Z0-9-]+)");
          for (var oMap = s.getPMap(); D4 = oRE.exec(AO);) null !== ZC._n_(oMap[D4[1]]) && null !== ZC._n_(s[oMap[D4[1]]]) && (AO = AO.replace(D4[0], s[oMap[D4[1]]]));
        }
        if (-1 !== AO.indexOf("%linecolor")) for (oRE = new RegExp("%linecolor([0-9]*)"); D4 = oRE.exec(AO);) "" === D4[1] ? (C0 = s.N || s, C0.B7 || (C0 = s.A)) : C0 = oPS.A4[D4[1]], AO = AO.replace(D4[0], C0 && C0.B7 || "#000");
        if (-1 !== AO.indexOf("%backgroundcolor")) for (oRE = new RegExp("%backgroundcolor([0-9]*)"); D4 = oRE.exec(AO);) "" === D4[1] ? (C0 = s.N || s, C0.B7 || (C0 = s.A)) : C0 = oPS.A4[D4[1]], AO = "markerbg" === s.A.PA ? AO.replace(D4[0], C0 && C0.A2 && C0.A2.A0 || "#000") : AO.replace(D4[0], C0 && C0.A0 || "#000");
        if (-1 !== AO.indexOf("%color")) for (oRE = new RegExp("%color([0-9]*)"); D4 = oRE.exec(AO);) "" === D4[1] ? (C0 = s.N || s, C0.B7 && "line" !== s.A.PA || (C0 = s.A)) : C0 = oPS.A4[D4[1]], AO = "line" === s.A.PA ? AO.replace(D4[0], C0 && C0.B7 || "#000") : "markerbg" === s.A.PA ? AO.replace(D4[0], C0 && C0.A2 && C0.A2.A0 || "#000") : AO.replace(D4[0], C0 && C0.A0 || "#000");
        for (AO = ZC.AQ.Z4(AO, this), i = 0, A6 = CU.length; i < A6; i++) oRE = new RegExp(CU[i][0], "g"), AO = typeof CU[i][1] === ZC._[31] ? AO.replace(oRE, "") : M0 ? AO.replace(oRE, encodeURIComponent(CU[i][1])) : AO.replace(oRE, CU[i][1]);
        return AO = AO.replace(new RegExp("%data-([a-zA-Z0-9]+)", "g"), ""), OY && "currency" === BD.negation && (AO = "-" + AO), AO;
      }
    }, {
      key: "paint",
      value: function paint() {}
    }, {
      key: "paint_",
      value: function paint_() {}
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.N.A0
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "border-color": this.N.A0,
          "background-color": this.N.AE,
          color: this.N.C2
        };
      }
    }, {
      key: "A01",
      value: function A01() {
        return this.KD();
      }
    }, {
      key: "F8",
      value: function F8(e, t) {
        var i,
          a,
          n,
          l = this;
        if (t || (t = 1), l.A.O5 && l.A.O5.length > 0 && l.A.O5.length > t - 1 && l.F8(e, t + 1), l.AN || "pie" === l.A.AF || "pie3d" === l.A.AF) {
          var r,
            o = 1 === t ? l.A.U : l.A.O5[t - 2];
          if (o) {
            if (l.A.A7U) (r = l.A.A7U).K = l.K + "-value-box-" + t, r.Z = r.C7 = l.H.usc() ? l.H.mc("top") : l.C.AJ["3d"] || l.H.KE ? ZC.AK(l.C.K + "-plots-vb-c") : ZC.AK(l.C.K + "-plot-" + l.A.L + "-vb-c"), r.IW = l.H.usc() ? ZC.AK(l.C.A.K + "-top") : ZC.AK(l.C.A.K + "-text"), r.E.plotidx = l.A.L, r.E.nodeidx = l.L, n = ZC.AQ.OE(r.o, l.A.o), r.ES = function (e) {
              return l.ES(e, n);
            }, r.parse();else {
              r = new DT(l.A), o.o.rules || l.A.U.I1 || (a = "all", null !== ZC._n_(i = o.o.type) && (a = i), "pie" === l.C.AF || "nestedpie" === l.C.AF || "pie3d" === l.C.AF || "all" !== a || l.A.O5 && 0 !== l.A.O5.length || (l.A.A7U = r)), r.append(o.o), l.appendToValueBox && !e && (r.parse(), r.append(l.appendToValueBox(r))), r.GO = l.C.K + "-value-box " + l.C.K + "-plot-" + l.A.L + "-value-box zc-value-box", r.K = l.K + "-value-box-" + t, r.Z = r.C7 = l.H.usc() ? l.H.mc("top") : l.C.AJ["3d"] || l.H.KE ? ZC.AK(l.C.K + "-plots-vb-c") : ZC.AK(l.C.K + "-plot-" + l.A.L + "-vb-c"), r.IW = l.H.usc() ? ZC.AK(l.C.A.K + "-top") : ZC.AK(l.C.A.K + "-text"), n = ZC.AQ.OE(r.o, l.A.o), r.ES = function (e) {
                return l.ES(e, n);
              };
              var s = l.JC(r);
              if (null !== ZC._n_(i = s.color) && (r.C2 = i), null !== ZC._n_(i = s[ZC._[0]]) && (r.A0 = r.AE = i), r.E.plotidx = l.A.L, r.E.nodeidx = l.L, l.A.U.I1 && (l.A.U.GN(l.A.U, r, null, l.LM(null, !1)), r.parse()), r.parse(), r.IV = function (e) {
                return l.IV(e);
              }, r.DB() && r.parse(), !l.A.Z9) {
                var C = new DT(l.A);
                C.copy(r), l.A.Z9 = C;
              }
              if (a = "all", null !== ZC._n_(i = o.o.type) && (a = i), r.AN) {
                r.AN = !1;
                var A = l.A.o[ZC._[17]].text || "";
                if ("values(" === a.substring(0, 7)) {
                  var Z = a.substring(7, a.length).replace(")", "").split(",");
                  -1 !== ZC.AV(Z, l.AD) && (r.AN = !0);
                } else {
                  var c = a.split(","),
                    p = {
                      min: "%plot-min-value",
                      max: "%plot-max-value",
                      first: "%plot-min-index",
                      last: "%plot-max-index"
                    };
                  for (var u in p) -1 !== ZC.AV(c, u) && (("first" !== u && "last" !== u || l.L !== l.A.JR[p[u]]) && ("min" !== u && "max" !== u || l.AD !== l.A.JR[p[u]]) || ("object" == typeof A && null !== ZC._n_(A[u]) && (r.o.text = A[u], r.parse()), r.AN = !0));
                  -1 !== ZC.AV(c, "all") && (r.AN = !0);
                }
              }
            }
            if (l.C.E["plot" + l.A.L + ".visible"] || (r.E["css-display"] = "none"), e) return r;
            if (r.AN && null !== ZC._n_(r.AO) && "" !== r.AO) {
              var h = l.HG(r);
              r.E.positioninfo = h, r.iX = h[0], r.iY = h[1];
              var _ = {};
              if (-1 !== r.iX && -1 !== r.iY) {
                var d = !1;
                if (null !== ZC._n_(r.o.overlap) && !ZC._b_(r.o.overlap)) {
                  _ = {
                    x: r.iX,
                    y: r.iY,
                    width: r.I,
                    height: r.F
                  };
                  for (var f = 0, g = l.A.A.ZN.length; f < g; f++) if (ZC.AR.YG(_, l.A.A.ZN[f])) {
                    d = !0;
                    break;
                  }
                }
                d || (l.C.E["plot" + l.A.L + ".visible"] || (r.E["css-display"] = "none"), r.E.lbltype = "vb" + l.C.L, r.paint(), r.ED(), l.A.A.ZN.push(_), !r.KE && ZC.AK(l.H.K + "-map") && l.A.A.HK.push(ZC.AQ.OG(l.C.K, r)));
              }
            }
            return r;
          }
        }
      }
    }, {
      key: "setupValueBoxWH",
      value: function setupValueBoxWH(e) {
        if (null !== ZC._n_(e.o[ZC._[19]])) {
          var t = ZC.IU(e.o[ZC._[19]]);
          t <= 1 && (t = this.I * t), e.I = t;
        }
        if (null !== ZC._n_(e.o[ZC._[20]])) {
          var i = ZC.IU(e.o[ZC._[20]]);
          i <= 1 && (i = this.I * i), e.F = i;
        }
        return e;
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = i.C.BJ(i.A.BT("v")[0]),
          n = i.AD >= a.LK && !a.AW || i.AD < a.LK && a.AW ? -1 : 1,
          l = "auto";
        if (null !== ZC._n_(t = e.o[ZC._[7]]) && (l = t), "auto" === l) {
          var r = null !== ZC._n_(i.A.S[i.L - 1]) ? i.A.S[i.L - 1].AD : i.AD,
            o = null !== ZC._n_(i.A.S[i.L + 1]) ? i.A.S[i.L + 1].AD : i.AD;
          r >= i.AD && i.AD <= o ? l = "bottom" : r <= i.AD && i.AD >= o ? l = "top" : r >= i.AD && i.AD >= o ? l = r / i.AD > i.AD / o ? "bottom" : "top" : r <= i.AD && i.AD <= o && (l = i.AD / r > o / i.AD ? "top" : "bottom");
        }
        var s = e.I,
          C = e.F,
          A = i.iX - s / 2,
          Z = i.iY - C / 2;
        switch (l) {
          case "top":
            Z -= n * (C / 2 + 4);
            break;
          case "bottom":
            Z += n * (C / 2 + 4);
            break;
          case "left":
            A -= s / 2 + 4;
            break;
          case "right":
            A += s / 2 + 4;
        }
        return i.C.AJ["3d"] || (A = ZC.BQ(i.C.P.iX - s / 2, A), A = ZC.CX(i.C.P.iX + i.C.P.I - s / 2, A), Z = ZC.BQ(i.C.P.iY - C, Z), Z = ZC.CX(i.C.P.iY + i.C.P.F, Z)), null !== ZC._n_(e.o.x) && (A = e.iX), null !== ZC._n_(e.o.y) && (Z = e.iY), [ZC._i_(A), ZC._i_(Z)];
      }
    }, {
      key: "OT",
      value: function OT(e, t) {
        var i,
          a,
          n,
          l,
          r,
          o = this;
        if (typeof o.A.bBS === ZC._[31] && (o.A.bBS = -1 === ZC.AV(["bubble", "hbubble", "scatter", "hscatter"], o.A.AF)), null !== ZC._n_(o.A.o["markers-on-top"]) && (o.A.bBS = ZC._b_(o.A.o["markers-on-top"])), !o.C.OM || !o.A.bBS) {
          null === ZC._n_(e) && (e = !1), null === ZC._n_(t) && (t = !1);
          var s = o.C.P.E.tolerance || 2;
          if (ZC.DR(o.iX, o.C.P.iX - s, o.C.P.iX + o.C.P.I + s) && ZC.DR(o.iY, o.C.P.iY - s, o.C.P.iY + o.C.P.F + s)) {
            var C = o.C.K + ZC._[34] + o.C.K + ZC._[35] + o.A.L + ZC._[6];
            if (-1 === ZC.AV(o.H.L0, ZC._[39]) && o.A.FZ) {
              if (o.A.YN && !zingchart.DEV.SKIPTRACKERS) {
                var A = o.getNodeData("points");
                -1 !== ZC.AV(o.H.L0, ZC._[42]) && -1 !== ZC.AV(["line", "area"], o.A.AF) && typeof A === ZC._[31] && o.paint(!0), "" !== (n = typeof o.E.polypoints === ZC._[31] ? ZC.AR.Q8(ZC.AR.ZJ(A, ZC.BQ(6, o.A.AZ / 2)), 4) : ZC.AR.Q8(A, 4)) && o.A.A.HK.push(ZC.Q.G2("poly", o.A.E8, o.N.J3) + 'class="' + C + '" id="' + o.K + ZC._[30] + n + '" />');
              }
              if (("area" === o.A.AF || "area3d" === o.A.AF || "radar" === o.A.AF && ("area" === o.A.CV || "range" === o.A.CV)) && o.A.Y0) {
                var Z = o.getNodeData("pointsarea");
                "" !== (n = ZC.AR.Q8(Z, 4)) && o.A.A.HK.push(ZC.Q.G2("poly", o.A.E8, o.A.J3) + 'class="' + C + '" id="' + o.K + '--area" coords="' + n + '" />');
              }
            }
            if (o.A.U || !o.A.IA || !o.A.A2.o || "none" !== o.A.A2.o.type && (null === ZC._n_(o.A.A2.o.visible) || ZC._b_(o.A.A2.o.visible))) {
              if (t || o.A.RL) {
                if (o.A.HH) l = o.A.HH, "svg" !== o.H.AA && (e ? (r = new CC(o.C, o.iX - ZC.AP.E2, o.iY - ZC.AP.E1, o.A.E["z-start"] || 0), l.iX = ZC._x_(r.EC[0]), l.iY = ZC._x_(r.EC[1]), o.E["3dxy"] = [l.iX, l.iY]) : (l.iX = ZC._x_(o.iX), l.iY = ZC._x_(o.iY)), l.E.plotidx = o.A.L, l.E.nodeidx = o.L, l.K = o.K + "-marker", l.parse(!0));else {
                  if (o.IA ? o.A._oMarker ? l = o.A._oMarker : o.A._oMarker = l = new DW(o.A) : l = new DW(o.A), l.K = o.K + "-marker", l.E["p-width"] = o.A.B1.AC, l.E["p-height"] = o.A.CL.AC, o.A.bBS) l.Z = o.A.CN("fl", 0), l.C7 = o.A.CN("fl", 0);else if (l.Z = o.A.CN("bl", 1), l.C7 = o.A.CN("bl", 0), Object && Object.keys && Object.keys(o.C.C9).length > 0) {
                    var c = o.C.C9["p" + o.A.L];
                    "none" !== o.A.J7 && c && c["n" + o.L] && (l.Z = o.A.CN("bl", 2));
                  }
                  if (e ? (r = new CC(o.C, o.iX - ZC.AP.E2, o.iY - ZC.AP.E1, o.A.E["z-start"] || 0), l.iX = ZC._x_(r.EC[0]), l.iY = ZC._x_(r.EC[1]), o.E["3dxy"] = [l.iX, l.iY]) : (l.iX = ZC._x_(o.iX), l.iY = ZC._x_(o.iY)), l.B7 = o.A.BP[3], l.BW = o.A.BP[3], l.A0 = o.A.BP[2], "bubble" === o.A.AF || "hbubble" === o.A.AF ? l.AE = o.A.BP[1] : l.AE = o.A.BP[2], l.append(o.A.A2.o), null !== ZC._n_(o.E["marker.size"]) && (l.AI = o.E["marker.size"]), l.E.plotidx = o.A.L, l.E.nodeidx = o.L, "none" !== o.A.J7 && (o.C.J4[o.A.L] || o.C.KP)) if (o.C.C9["p" + o.A.L] && o.C.C9["p" + o.A.L]["n" + o.L]) {
                    if (l.LZ = {}, o.A.PY && ZC._cp_(o.A.PY.o, l.LZ), l.LZ.rules) {
                      var p = new DW(o.A);
                      p.o = l.LZ, p.parse(), p.IV = function (e) {
                        return o.IV(e);
                      }, p.DB() && (l.LZ = p.o);
                    }
                  } else "none" !== o.A.OF && ("plot" === o.A.OF && o.C.J4[o.A.L] || "graph" === o.A.OF && o.C.KP) && (l.LZ = o.A.PW ? o.A.PW.o : {});
                  null !== ZC._n_(i = o.A.o.marker) && null !== ZC._n_(i.styles) && null !== ZC._n_(a = i.styles[o.L]) && ("string" == typeof a ? l.append({
                    "background-color": ZC.AQ.R2(a, 20),
                    "line-color": ZC.AQ.JP(a, 20),
                    "border-color": ZC.AQ.JP(a, 20)
                  }) : l.append(a)), l.parse(), l.IV = function (e) {
                    return o.IV(e);
                  }, l.DB() && l.parse();
                }
                if (o.E["marker.size"] = ZC.BQ(2.02, o.E["marker.size"] || l.AI), l.DJ = C, !(e || ZC.DR(l.iX, o.C.P.iX - 2, o.C.P.iX + o.C.P.I + 2) && ZC.DR(l.iY, o.C.P.iY - 2, o.C.P.iY + o.C.P.F + 2))) return;
                if (l.I1 && (o.A.Z6 = !1, l.GN(l, l, null, o.LM(null, !1)), l.parse()), o.NM = l, l.AN && "none" !== l.AF) {
                  var u = function u() {
                      if (o.A.bBS || o.MR(ZC.Q.E9(o.A.CN("bl", 0), o.H.AA)), o.E["marker.type"] = l.DQ, o.A.FZ && -1 === ZC.AV(o.H.L0, ZC._[40]) && !zingchart.DEV.SKIPTRACKERS) {
                        var e = o.E["3dxy"] ? o.E["3dxy"][0] : o.iX,
                          t = o.E["3dxy"] ? o.E["3dxy"][1] : o.iY,
                          i = parseInt(e + l.BM + ZC.MAPTX, 10),
                          a = parseInt(t + l.BH + ZC.MAPTX, 10),
                          n = parseInt(ZC.BQ(ZC.mobile ? 6 : 3, o.E["marker.size"] + 1) * (ZC.mobile ? 1.25 : 1.05), 10),
                          r = !0;
                        if (typeof o.A.aLastMarkerXY !== ZC._[31]) Math.sqrt((i - o.A.aLastMarkerXY[0]) * (i - o.A.aLastMarkerXY[0]) + (a - o.A.aLastMarkerXY[1]) * (a - o.A.aLastMarkerXY[1])) < zingchart.DEV.MINTRACKERDIFF && (r = !1);else o.A.aLastMarkerXY = [i, a];
                        r && (o.A.aLastMarkerXY = [i, a], -1 !== ZC.AV(["pie", "square", "rect", "rectangle"], l.DQ) ? o.A.A.HK.push(ZC.Q.G2("poly", o.A.E8, o.A.J3) + 'class="' + C + '" id="' + o.K + "--marker" + ZC._[30] + l.F1() + '" />') : o.A.A.HK.push(ZC.Q.G2("circle", o.A.E8, o.A.J3) + 'class="' + C + '" ' + o.a11y() + ' id="' + o.K + "--marker" + ZC._[30] + i + "," + a + "," + n + '" />'));
                      }
                      if (o.A.U && (o.A.E.vboxid = o.K, o.F8()), !o.A.bBS && o.C.B9 && o.C.B9.IP && o.A.R8 && o.C.B9.AN) {
                        var s = o.C.P,
                          A = o.C.B9,
                          Z = A.AT,
                          c = o.A.HH || l,
                          p = new DW(o.A);
                        p.copy(c);
                        var u = (o.iX - s.iX) / s.I,
                          h = (o.iY - s.iY) / s.F,
                          _ = Math.min(Z.F / s.F, Z.I / s.I);
                        p.iX = Z.iX + Z.AU + u * (Z.I - 2 * Z.AU), p.iY = Z.iY + Z.AU + h * (Z.F - 2 * Z.AU), p.K = o.K + "-marker-preview", p.DJ = o.A.K + "-preview";
                        var d = c.AI;
                        null !== ZC._n_(o.E["marker.size"]) && (d = o.E["marker.size"]), p.AI = ZC.BQ(2.02, .9 * _ * d), p.Z = p.C7 = A.Z, p.parse(), p.paint();
                      }
                    },
                    h = !1;
                  if ((!o.A.bBS || "radar" === o.A.AF && "dots" === o.A.CV) && (h = !0), o.A.GI && h && !o.C.HO) {
                    var _ = l,
                      d = {},
                      f = l.C6,
                      g = l.AI,
                      B = l.iX,
                      v = l.iY;
                    _.iX = B, _.iY = v, d.x = B, d.y = v;
                    var m,
                      b = o.A.LL,
                      E = o.C.P;
                    for (m in _.C6 = 0, d.alpha = f, 3 === b ? (_.AI = 2, d.size = g) : 8 === b ? (_.iX = B - E.iX, d.x = B) : 9 === b ? (_.iX = B + E.iX, d.x = B) : 10 === b ? (_.iY = v - E.iY, d.y = v) : 11 === b && (_.iY = v + E.iY, d.y = v), o.A.FW) _[EB.GP[ZC.EE(m)]] = o.A.FW[m], d[ZC.EE(m)] = o.N[EB.GP[ZC.EE(m)]];
                    if (null === ZC._n_(o.C.EM) && (o.C.EM = {}), null !== ZC._n_(o.C.EM[o.A.L + "-" + o.L])) for (m in o.C.EM[o.A.L + "-" + o.L]) _[EB.GP[ZC.EE(m)]] = o.C.EM[o.A.L + "-" + o.L][m];
                    o.C.EM[o.A.L + "-" + o.L] = {}, ZC._cp_(d, o.C.EM[o.A.L + "-" + o.L]);
                    var K = new EB(_, d, o.A.JL, o.A.LE, EB.RW[o.A.LI], function () {
                      u();
                    });
                    K.AX = o, K.OK = function () {
                      o.MR(ZC.Q.E9(o.A.CN("bl", 0), o.H.AA));
                    }, o.L9(K);
                  } else {
                    var D = "circle" === l.DQ ? "circle" : "path";
                    if (o.A.HN) {
                      var F = function F(t, i) {
                        var a = t.cloneNode(!1),
                          n = o.iX,
                          r = o.iY;
                        if (e) {
                          var s = new CC(o.C, n - ZC.AP.E2, r - ZC.AP.E1, o.A.E["z-start"] || 0);
                          n = ZC._x_(s.EC[0]), r = ZC._x_(s.EC[1]), o.E["3dxy"] = [n, r];
                        }
                        a.setAttribute("transform", "translate(" + ZC._i_(n - l.iX) + "," + ZC._i_(r - l.iY) + ") " + (a.getAttribute("transform") || "")), a.setAttribute("id", i), "bubble" !== o.A.AF && "hbubble" !== o.A.AF || a.setAttribute("r", o.E["marker.size"]), t.parentNode.appendChild(a);
                      };
                      l.MH && F(o.A.RS, o.K + "-marker-sh-" + D), F(o.A.HN, o.K + "-marker-" + D), l.D9 && F(o.A.QK, o.K + "-marker-imgfill");
                    } else {
                      l.paint();
                      var I = l.A0 !== l.AE;
                      if (!o.C.J4[o.A.L] && o.A.Z6 && !I) if ("svg" === o.H.AA) {
                        if (-1 === ZC.AV(["pie", "square", "rect", "rectangle", "cross", "plus", "custom"], l.DQ)) if (o.A.HH = l, zingchart.DEV.DOMFRAGMENTS && document.querySelector) {
                          for (var x in o.H.G3) o.A.HN || (o.A.HN = o.H.G3[x].querySelector("#" + o.K + "-marker-" + D)), l.MH && !o.A.RS && (o.A.RS = o.H.G3[x].querySelector("#" + o.K + "-marker-sh-" + D)), l.D9 && !o.A.QK && (o.A.QK = o.H.G3[x].querySelector("#" + o.K + "-marker-imgfill") || o.H.G3[x].querySelector("#" + o.K + "-marker-path-imgfill"));
                          o.A.HN || (o.A.HN = ZC.AK(o.K + "-marker-" + D), l.MH && (o.A.RS = ZC.AK(o.K + "-marker-sh-" + D)), l.D9 && (o.A.QK = ZC.AK(o.K + "-marker-imgfill")));
                        } else o.A.HN = ZC.AK(o.K + "-marker-" + D), l.MH && (o.A.RS = ZC.AK(o.K + "-marker-sh-" + D)), l.D9 && (o.A.QK = ZC.AK(o.K + "-marker-imgfill") || ZC.AK(o.K + "-marker-path-imgfill"));
                      } else "bubble" !== o.A.AF && "hbubble" !== o.A.AF && (e || (o.A.HH = l));
                    }
                    "svg" === o.H.AA && o.A.applyJsRuleSvg(o.A.A2, o.K + "-marker-" + D, o.LM()), u();
                  }
                } else o.A.U && o.F8();
              } else o.A.U && o.F8();
            }
          }
        }
      }
    }, {
      key: "L9",
      value: function L9(e, t) {
        var i,
          a = this,
          n = a.C.M7,
          l = n.PT,
          r = a.A.U5;
        switch (r) {
          default:
            t && n.add(t), n.add(e);
            break;
          case 1:
          case 2:
          case 3:
            if (t) {
              var o = "all";
              if (1 === r ? o = "plots-group-" + a.L + "-area" : 2 === r && (o = "nodes-group-" + a.A.L + "-area"), null === ZC._n_(l[o])) {
                var s = new A2X(o);
                n.A5T(s, t.XR);
              }
              l[o].add(t);
            }
            if (i = "all", 1 === r ? i = "plots-group-" + a.L : 2 === r && (i = "nodes-group-" + a.A.L), null === ZC._n_(l[i])) {
              var C = new A2X(i);
              n.A5T(C, e.XR);
            }
            l[i].add(e);
        }
      }
    }, {
      key: "SB",
      value: function SB(e) {
        var t = this;
        t.A.IA && t.A.bXY && (t.S0(), e && ("scatter" !== t.A.AF && "hscatter" !== t.A.AF && "bubble" !== t.A.AF && "hbubble" !== t.A.AF || t.paint(!0)));
        var i = t.A.BP;
        t.LN({
          layer: e,
          type: "shape",
          id: "marker",
          marker: !0,
          initcb: function initcb() {
            this.DQ = t.E["marker.type"], this.iX = t.iX, this.iY = t.iY, "bubble" === t.A.AF || "hbubble" === t.A.AF ? (this.AE = i[3], this.A0 = i[2]) : (this.B7 = i[3], this.BW = i[3], this.A0 = i[2], this.AE = i[1]), this.AI = t.E["marker.size"];
          }
        });
      }
    }, {
      key: "YJ",
      value: function YJ(e) {
        var t = this;
        t.LN({
          layer: e,
          type: "line",
          id: "line",
          initcb: function initcb() {
            this.B7 = t.A.BP[3];
          }
        });
      }
    }, {
      key: "LN",
      value: function LN(e) {
        if (!ZC.move) {
          var t,
            i,
            a,
            n,
            l,
            r,
            o = this,
            s = e.layer || "hover",
            C = e.id || "",
            A = !1;
          switch (o.GL = null, null !== ZC._n_(t = e.marker) && (A = ZC._b_(t)), s) {
            case "hover":
              null !== ZC._n_(o.C.C9["p" + o.A.L]) && null !== ZC._n_(o.C.C9["p" + o.A.L]["n" + o.L]) || (a = A ? o.A.GC : o.A.IK, n = "hover");
              break;
            case "highlight":
              a = A ? o.A.VO : o.A.SK, n = "hover";
          }
          if (null !== ZC._n_(e.state) && (a = e.state), a && o.C.E["plot" + o.A.L + ".visible"] && a.AN) {
            switch (e.type) {
              case "box":
                (r = new I3(o.A)).QD = !0;
                break;
              case "line":
                r = new DW(o.A), l = ZC.Q.E9(o.C.K + "-" + n + "-c", o.H.AA), r.CY = !1;
                break;
              case "shape":
                r = new DW(o.A);
                break;
              case "area":
                r = new DW(o.A), l = ZC.Q.E9(o.C.K + "-" + n + "-c", o.H.AA);
            }
            if (A && (r.E["p-width"] = o.A.B1.AC, r.E["p-height"] = o.A.CL.AC), zingchart.DEV.PLOTSHLAYER && "hover" === n ? r.Z = r.C7 = ZC.AK(o.C.K + "-plots-hover-c") : r.Z = r.C7 = ZC.AK(o.C.K + "-" + n + "-c"), r.K = o.K + "-" + ("" !== C ? C + "-" : "") + s, r.E.plotidx = o.A.L, r.E.nodeidx = o.L, "hover" !== s && (r.A2V = !0), e.initcb && e.initcb.call(r), r.append(a.o), e.parsecb && e.parsecb.call(r), "hover" === s && null !== ZC._n_(t = o.A.o) && null !== ZC._n_(t.styles) && null !== ZC._n_(i = t.styles[o.L]) && ("string" == typeof i ? r.append({
              "background-color": i,
              "line-color": i,
              "border-color": i
            }) : r.append(i)), null !== ZC._n_(t = o.A.o[s + "-state"]) && null !== ZC._n_(t.styles) && null !== ZC._n_(i = t.styles[o.L]) && ("string" == typeof i ? r.append({
              "background-color": i,
              "line-color": i,
              "border-color": i
            }) : r.append(i)), o.A.I1 && o.GN(r, s), "hover" === s && o.A.A2 && o.A.A2.I1 && (o.A.A2.GN(o.A.A2, r, null, o.LM(null, !1)), r.parse()), r.parse(), r.IV = function (e) {
              return o.IV(e);
            }, r.DB() && r.parse(), r.AN) {
              switch (e.setupcb && e.setupcb.call(r), e.type) {
                case "box":
                case "shape":
                  r.locate(2), r.paint();
                  break;
                case "line":
                  ZC.CQ.setup(l, r), "plot" === o.A.A3Y ? ZC.CQ.paint(l, r, o.A.VN) : ZC.CQ.paint(l, r, o.getNodeData("points"));
                  break;
                case "area":
                  "spline" !== o.A.CV && (null !== ZC._n_(t = a.o["alpha-area"]) && (r.C6 = ZC._f_(t)), ZC.CQ.setup(l, r), r.paint());
              }
              o.GL = r;
            }
          }
        }
      }
    }, {
      key: "MR",
      value: function MR() {}
    }, {
      key: "setup",
      value: function setup() {}
    }, {
      key: "HT",
      value: function HT() {}
    }, {
      key: "KW",
      value: function KW() {
        var e = this;
        ZC.Q.EU([e.K + "-hover-gradient", e.K + "-marker-hover-gradient", e.H.K + "-tooltip-text-gradient", e.H.K + "-tooltip-text-sh-gradient"]);
      }
    }, {
      key: "LM",
      value: function LM(e, t) {
        var i = this;
        typeof t === ZC._[31] && (t = !0);
        var a = !1;
        "none" !== i.A.J7 && i.C.C9 && i.C.C9["p" + i.A.L] && i.C.C9["p" + i.A.L]["n" + i.L] && (a = !0);
        var n = {
          id: i.C.A.K,
          graphid: i.C.K,
          graphindex: i.C.L,
          plotid: i.A.HB,
          plotindex: i.A.L,
          nodeindex: i.L,
          key: null === i.BU ? i.L : i.BU,
          scaleval: i.A.B1 ? i.A.B1.V[null === i.BU ? i.L : i.BU] : null,
          scaletext: i.A.B1 ? i.A.B1.FC(i.L, null === i.BU ? null : i.A) : null,
          value: i.AD,
          text: t ? i.ES(i.A.JD) : i.A.JD,
          ev: e ? ZC.A5.BX(e) : null,
          x: i.iX,
          y: i.iY,
          width: i.I,
          height: i.F,
          size: i.E["marker.size"] || 1,
          selected: a
        };
        for (var l in i.A.KJ) i.A.KJ[l] instanceof Array ? null !== ZC._n_(i.A.KJ[l][i.L]) && (n["data-" + l] = i.A.KJ[l][i.L]) : n["data-" + l] = i.A.KJ[l];
        return n;
      }
    }, {
      key: "P1",
      value: function P1(e, t) {
        ZC.AQ.BZ("node_" + t, this.H, this.LM(e));
      }
    }]);
    return MI;
  }(DT);
  var A3I = /*#__PURE__*/function (_MI) {
    _inherits(A3I, _MI);
    function A3I() {
      _classCallCheck(this, A3I);
      return _possibleConstructorReturn(this, _getPrototypeOf(A3I).apply(this, arguments));
    }
    _createClass(A3I, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.A.IA ? this.A.B7 : this.N.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.N.B7,
          "border-color": this.N.B7,
          color: this.N.C2
        };
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition(e, t) {
        _get(_getPrototypeOf(A3I.prototype), "getTooltipPosition", this).call(this, e, t, this.NM.AI);
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t = this;
        typeof e === ZC._[31] && (e = !1), _get(_getPrototypeOf(A3I.prototype), "paint", this).call(this);
        var i = t.A.P2,
          a = t.A.QQ,
          n = t.A.B1,
          l = t.A.S;
        if (t.setup(), !t.A.IA || t.C.AJ["3d"] || t.A.FZ) {
          t.N.CY = t.CY = !1, t.N.C7 = t.A.CN("bl", 0);
          var r = [],
            o = t.A.CV;
          (t.C.OM || t.A.UT) && "spline" === t.A.CV && (o = "segmented");
          var s = typeof t.A.GB !== ZC._[31] ? t.A.GB : t.A.Y,
            C = typeof t.A.HM !== ZC._[31] ? t.A.HM : t.A.Y,
            A = !0,
            Z = !0;
          (null === ZC._n_(l[t.L - s]) || "log" !== n.C1 && !n.EF && t.L <= n.W) && (A = !1);
          var c,
            p,
            u,
            h,
            _ = t.A.M1 ? t.A.S.length : n.A1;
          switch ((null === ZC._n_(l[t.L + C]) || "log" !== n.C1 && !n.EF && t.L >= _) && (Z = !1), o) {
            default:
              A && (t.A.FK(t.L - s, 0).setup(), t.A.VE && (c = ZC.AR.JZ(t.A.S[t.L - s].iX, t.A.S[t.L - s].iY, t.A.S[t.L].iX, t.A.S[t.L].iY), r.push(c))), r.push([t.iX, t.iY]), Z && (t.A.FK(t.L + C, 2).setup(), c = t.A.VE ? ZC.AR.JZ(t.A.S[t.L].iX, t.A.S[t.L].iY, t.A.S[t.L + C].iX, t.A.S[t.L + C].iY, t.N.C6) : [l[t.L + C].iX, l[t.L + C].iY], r.push(c));
              break;
            case "spline":
              if (t.A.D && (r = t.A.D), t.A.D = [], l[t.L + 1]) {
                var d = [],
                  f = [];
                for (p = -1; p < 3; p++) l[t.L + p] ? (t.A.FK(t.L + p, 2).setup(), i ? (d.push(l[t.L + p].iX), f.push(l[t.L + p].iY)) : (d.push(l[t.L + p].iY), f.push(l[t.L + p].iX))) : 0 === d.length ? i ? (f.push(t.iY), d.push(t.iX)) : (f.push(t.iX), d.push(t.iY)) : (d.push(d[d.length - 1]), f.push(f[f.length - 1]));
                var g = ZC._a_(f[2] - f[1]);
                g = Math.min(g, Math.max(t.C.I, t.C.F));
                var B = ZC.AR.YY(t.A.QJ, d, g);
                if (t.A.VE) {
                  for (p = 0; p < ZC._i_(B.length / 2) + (1 === t.N.C6 ? 1 : 0); p++) B[p] && (i ? r.push([B[p][1], t.iY + (n.AW ? 1 : -1) * B[p][0] * g]) : r.push([t.iX + (n.AW ? -1 : 1) * B[p][0] * g, B[p][1]]));
                  for (p = ZC._i_(B.length / 2) - 1, u = B.length; p < u; p++) B[p] && (i ? t.A.D.push([B[p][1], t.iY + (n.AW ? 1 : -1) * B[p][0] * g]) : t.A.D.push([t.iX + (n.AW ? -1 : 1) * B[p][0] * g, B[p][1]]));
                } else for (p = 0; p < ZC._i_(B.length); p++) i ? r.push([B[p][1], t.iY + (n.AW ? 1 : -1) * B[p][0] * g]) : r.push([t.iX + (n.AW ? -1 : 1) * B[p][0] * g, B[p][1]]);
              }
              break;
            case "stepped":
              if (A) switch (t.A.FK(t.L - s, 0).setup(), c = ZC.AR.JZ(t.A.S[t.L - s].iX, t.A.S[t.L - s].iY, t.A.S[t.L].iX, t.A.S[t.L].iY), t.A.SY) {
                default:
                  i ? r.push([l[t.L - s].iX, c[1]], [t.iX, c[1]]) : r.push([c[0], l[t.L - s].iY], [c[0], t.iY]);
                  break;
                case "before":
                  r.push([t.A.S[t.L - s].iX, l[t.L - s].iY], [t.A.S[t.L - s].iX, t.iY]);
                  break;
                case "after":
              }
              if (r.push([t.iX, t.iY]), Z) switch (t.A.FK(t.L + C, 0).setup(), c = ZC.AR.JZ(t.A.S[t.L + s].iX, t.A.S[t.L + s].iY, t.A.S[t.L].iX, t.A.S[t.L].iY), t.A.SY) {
                default:
                  r.push(i ? [t.iX, c[1]] : [c[0], t.iY]);
                  break;
                case "before":
                  break;
                case "after":
                  r.push([t.A.S[t.L + s].iX, t.iY], [t.A.S[t.L + s].iX, l[t.L + C].iY]);
              }
              break;
            case "jumped":
              A ? (t.A.FK(t.L - s, 0).setup(), c = ZC.AR.JZ(t.A.S[t.L - s].iX, t.A.S[t.L - s].iY, t.A.S[t.L].iX, t.A.S[t.L].iY), r.push(i ? [t.iX, c[1]] : [c[0], t.iY])) : r.push(i ? [t.iX, t.iY - n.AC / 2] : [t.iX - n.AC / 2, t.iY]), r.push([t.iX, t.iY]), Z ? (t.A.FK(t.L + C, 0).setup(), c = ZC.AR.JZ(t.A.S[t.L + s].iX, t.A.S[t.L + s].iY, t.A.S[t.L].iX, t.A.S[t.L].iY), r.push(i ? [t.iX, c[1]] : [c[0], t.iY])) : r.push(i ? [t.iX, t.iY + n.AC / 2] : [t.iX + n.AC / 2, t.iY]);
          }
          if (t.setNodeData({
            points: r
          }), "ready" !== t.C.MK && (t.A.VN = t.A.VN.concat(r)), !e && !t.C.AJ["3d"]) {
            var v = t.N = t.A.I5(t, t.N),
              m = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6];
            if (v.DJ = m, v.K = t.K, t.A.I1 && t.GN(v), ZC.CQ.setup(a, v), t.paintPreview(v, r), t.A.GI && !t.C.HO) {
              var b = new DW(t),
                E = {};
              b.copy(v), b.K = t.K, b.Z = t.A.CN("bl", 1), b.C7 = t.A.CN("bl", 0), b.D = r, E.points = r;
              var K = [],
                D = t.A.LL,
                F = t.C.P;
              for (b.C6 = 0, E.alpha = v.C6, p = 0; p < r.length; p++) 2 === D ? K[p] = [r[p][0], F.iY + F.F / 2] : 3 === D ? K[p] = [r[p][0], F.iY - 5] : 4 === D ? K[p] = [r[p][0], F.iY + F.F + 5] : 5 === D ? K[p] = [F.iX - 5, r[p][1]] : 6 === D ? K[p] = [F.iX + F.I + 5, r[p][1]] : 7 === D ? K[p] = [F.iX + F.I / 2, r[p][1]] : 8 === D ? K[p] = [r[p][0] - F.I, r[p][1]] : 9 === D ? K[p] = [r[p][0] + F.I, r[p][1]] : 10 === D ? K[p] = [r[p][0], r[p][1] - F.F] : 11 === D ? K[p] = [r[p][0], r[p][1] + F.F] : 12 === D ? K[p] = [(r[0][0] + r[r.length - 1][0]) / 2, r[0][1]] : 13 === D && (K[p] = [r[0][0], (r[0][1] + r[r.length - 1][1]) / 2]), D > 1 && (b.D = K, E.points = r);
              for (h in t.A.FW) b[EB.GP[ZC.EE(h)]] = t.A.FW[h], E[ZC.EE(h)] = v[EB.GP[ZC.EE(h)]];
              if (t.C.EM || (t.C.EM = {}), null !== ZC._n_(t.C.EM[t.A.L + "-" + t.L])) for (h in t.C.EM[t.A.L + "-" + t.L]) b[EB.GP[ZC.EE(h)]] = t.C.EM[t.A.L + "-" + t.L][h];
              t.C.EM[t.A.L + "-" + t.L] = {}, ZC._cp_(E, t.C.EM[t.A.L + "-" + t.L]);
              var I = new EB(b, E, t.A.JL, t.A.LE, EB.RW[t.A.LI], function () {
                x();
              });
              I.AX = t, I.OK = function () {
                t.MR(ZC.Q.E9(t.A.CN("bl", 1), t.H.AA));
              }, I.IR = a, t.L9(I);
            } else ZC.CQ.paint(a, v, r), x();
          }
        }
        function x() {
          !t.C.OM && ZC.DR(t.iX, n.iX - 1, n.iX + n.I + 1) && ZC.DR(t.iY, n.iY - 1, n.iY + n.F + 1) && (t.OT(), t.MR(ZC.Q.E9(t.A.CN("bl", 1), t.H.AA)), t.A.U && t.A.U.AN && t.A.E.vboxid !== t.K && t.F8());
        }
      }
    }, {
      key: "paintPreview",
      value: function paintPreview(e, t) {
        var i = this;
        if (i.C.B9 && i.C.B9.IP && i.A.R8) {
          var a,
            n = i.A.mapPointsToPreview(t);
          i.A.WL ? a = i.A.WL : (a = new CZ(i), i.A.WL = a), a.copy(e), a.K = i.K + "-line-preview", a.DJ = i.A.K + "-preview";
          var l = ZC.Q.E9(i.C.B9.Z, i.H.AA);
          a.AZ = 1;
          var r = i.o["preview-state"];
          r && (a.append(r), a.parse()), ZC.CQ.paint(l, a, n, null, 3);
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || (t.YJ(e), t.A.RL && t.SB(e));
      }
    }]);
    return A3I;
  }(MI);
  var A3J = /*#__PURE__*/function (_MI2) {
    _inherits(A3J, _MI2);
    function A3J() {
      _classCallCheck(this, A3J);
      return _possibleConstructorReturn(this, _getPrototypeOf(A3J).apply(this, arguments));
    }
    _createClass(A3J, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.A.IA ? this.A.B7 : this.N.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.N.B7,
          "border-color": this.N.B7,
          color: this.N.C2
        };
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition(e, t) {
        return _get(_getPrototypeOf(A3J.prototype), "getTooltipPosition", this).call(this, e, t, this.NM.AI);
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this;
        typeof e === ZC._[31] && (e = !1), _get(_getPrototypeOf(A3J.prototype), "paint", this).call(this);
        var A = C.A.P2,
          Z = C.A.QQ,
          c = C.A.B1,
          p = C.A.CL,
          u = C.A.S;
        if (C.setup(), !C.A.IA || C.C.AJ["3d"] || C.A.FZ) {
          C.N.CY = C.CY = !1, C.N.C7 = C.A.CN("bl", 1);
          var h = p.HA,
            _ = p.AM(h);
          _ = A ? ZC._l_(_, p.iX, p.iY + p.I) : ZC._l_(_, p.iY, p.iY + p.F);
          var d = c.DI ? c.AC / 2 : 0,
            f = [],
            g = [],
            B = [],
            v = null;
          null !== ZC._n_(C.A.A.F2) && null !== ZC._n_(C.A.A.F2[C.L]) && (v = C.A.A.F2[C.L]);
          var m = C.A.CV;
          (C.C.OM || C.A.UT) && "spline" === C.A.CV && (m = "segmented"), i = C.N.AZ / 2 - 1, a = "svg" === C.H.AA && ZC.mobile ? C.N.I6 / 4 : 0, "vml" === C.H.AA && C.A.GI && (a = .5), C.C.AJ["3d"] && (1 === C.A.I6 ? a = 1 : (a = C.A.I6 / 3, "canvas" === C.H.AA && (ZC.A5.browser.msie || ZC.A5.browser.opera) && (a = .5)), c.AW && (a = -a));
          var b,
            E = typeof C.A.GB !== ZC._[31] ? C.A.GB : C.A.Y,
            K = typeof C.A.HM !== ZC._[31] ? C.A.HM : C.A.Y,
            D = !0,
            F = !0;
          (!u[C.L - E] || "log" !== c.C1 && !c.EF && C.L <= c.W) && (D = !1);
          var I = C.A.M1 ? C.A.S.length : c.A1;
          switch ((!u[C.L + K] || "log" !== c.C1 && !c.EF && C.L >= I) && (F = !1), m) {
            default:
              if (D) C.A.FK(C.L - E, 0).setup(), C.A.VE ? (l = ZC.AR.JZ(u[C.L - E].iX, u[C.L - E].iY, u[C.L].iX, u[C.L].iY), B.push([ZC._i_(l[0]) - a, l[1] - i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(l[0]) - a, _]), g.push([ZC._i_(l[0]) - a, l[1] + i]), f.push([l[0], l[1]])) : g.push([ZC._i_(C.iX), _]);else if (c.EF || C.L !== c.W) C.A.CB && null !== ZC._n_(v) ? (b = C.A.A.A4[C.A.L - 1]) && b.S[C.L] && g.push([ZC._i_(C.iX), b.S[C.L].iY + i]) : (g.push([ZC._i_(C.iX), _]), B.push([ZC._i_(C.iX - c.AC / 2), _]), B.push([ZC._i_(C.iX), _]));else if (c.AW) C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.I - c.BV - d), _]), g.push([ZC._i_(c.iX + c.I - c.BV - d), C.iY + i]);else {
                var x = ZC._i_(c.iX + c.AB + d);
                C.A.M1 && (x = c.H6(C.A.RI) - c.AC / 2), C.A.CB && null !== ZC._n_(v) || g.push([x, _]), g.push([x, C.iY + i]);
              }
              B.push([ZC._i_(C.iX), C.iY - i]), g.push([ZC._i_(C.iX), C.iY + i]), f.push([C.iX, C.iY]), F ? (C.A.FK(C.L + K, 2).setup(), n = C.A.VE ? ZC.AR.JZ(u[C.L].iX, u[C.L].iY, u[C.L + K].iX, u[C.L + K].iY) : [u[C.L + K].iX, u[C.L + K].iY], B.push([ZC._i_(n[0]), n[1] - i]), g.push([ZC._i_(n[0]), n[1] + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(n[0]), _]), l = C.A.VE ? ZC.AR.JZ(u[C.L].iX, u[C.L].iY, u[C.L + K].iX, u[C.L + K].iY, C.N.C6) : [u[C.L + K].iX, u[C.L + K].iY], f.push([l[0], l[1]])) : C.L === c.A1 ? c.AW ? (g.push([c.iX + c.AB - d, C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.AB - d), _])) : (g.push([c.iX + c.I - c.BV - d, C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.I - c.BV - d), _])) : C.A.CB && null !== ZC._n_(v) ? (b = C.A.A.A4[C.A.L - 1]) && b.S[C.L] && g.push([ZC._i_(C.iX), b.S[C.L].iY + i]) : (g.push([ZC._i_(C.iX), _]), B.push([ZC._i_(C.iX), _]), B.push([ZC._i_(C.iX + c.AC / 2), _]));
              break;
            case "spline":
              if (null !== ZC._n_(C.A.D5) && (B = C.A.D5), null !== ZC._n_(C.A.AH) && (g = C.A.AH), C.A.D5 = [], C.A.AH = [], null !== ZC._n_(C.A.D) && (f = C.A.D), C.A.D = [], u[C.L + 1]) {
                var y = [],
                  X = [];
                for (r = -1; r < 3; r++) u[C.L + r] ? (C.A.FK(C.L + r, 2).setup(), A ? (y.push(u[C.L + r].iX), X.push(u[C.L + r].iY)) : (y.push(u[C.L + r].iY), X.push(u[C.L + r].iX))) : 0 === y.length ? A ? (X.push(C.iY), y.push(C.iX)) : (X.push(C.iX), y.push(C.iY)) : (y.push(y[y.length - 1]), X.push(X[X.length - 1]));
                var Y = ZC._a_(X[2] - X[1]);
                Y = Math.min(Y, Math.max(C.C.I, C.C.F));
                var w = ZC.AR.YY(C.A.QJ, y, Y);
                if (C.A.VE) {
                  for (0 === g.length && (C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[0][0] * Y), _])), r = 0; r < ZC._i_(w.length / 2) + (1 === C.N.C6 ? 1 : 0); r++) w[r] && (A ? f.push([w[r][1], C.iY + (c.AW ? 1 : -1) * w[r][0] * Y]) : f.push([C.iX + (c.AW ? -1 : 1) * w[r][0] * Y, w[r][1]]));
                  for (r = 0; r < ZC._i_(w.length / 2) + (1 === C.N.I6 ? 1 : 0); r++) B.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1] - i]), g.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1]]);
                  for (C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(g[g.length - 1][0]), _]), s = 1 === C.I6 ? ZC.CX(2, ZC._i_(w.length / 2)) : 1, r = ZC._i_(w.length / 2) - 1, o = w.length; r < o; r++) w[r] && (A ? C.A.D.push([w[r][1], C.iY + (c.AW ? 1 : -1) * w[r][0] * Y]) : C.A.D.push([C.iX + (c.AW ? -1 : 1) * w[r][0] * Y, w[r][1]]));
                  for (r = ZC._i_(w.length / 2) - s, o = w.length; r < o; r++) 0 === C.A.AH.length && (C.A.CB && null !== ZC._n_(v) || C.A.AH.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), _])), C.A.AH.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1]]), C.A.D5.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1] - i]);
                } else {
                  for (0 === g.length && (C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[0][0] * Y), _])), r = 0; r < w.length; r++) A ? f.push([w[r][1], C.iY + (c.AW ? 1 : -1) * w[r][0] * Y]) : f.push([C.iX + (c.AW ? -1 : 1) * w[r][0] * Y, w[r][1]]);
                  for (r = 0; r < w.length; r++) B.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1] - i]), g.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1]]);
                  for (C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(g[g.length - 1][0]), _]), s = 1 === C.I6 ? ZC.CX(2, ZC._i_(w.length / 2)) : 1, r = w.length, o = w.length; r < o; r++) A ? C.A.D.push([w[r][1], C.iY + (c.AW ? 1 : -1) * w[r][0] * Y]) : C.A.D.push([C.iX + (c.AW ? -1 : 1) * w[r][0] * Y, w[r][1]]);
                  for (r = w.length - s, o = w.length; r < o; r++) 0 === C.A.AH.length && (C.A.CB && null !== ZC._n_(v) || C.A.AH.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), _])), C.A.AH.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1]]), C.A.D5.push([ZC._i_(C.iX + (c.AW ? -1 : 1) * w[r][0] * Y), w[r][1] - i]);
                }
              } else g.length > 0 && g.push([g[g.length - 1][0], _]);
              break;
            case "stepped":
              if (D) switch (C.A.FK(C.L - E, 0).setup(), l = ZC.AR.JZ(u[C.L - E].iX, u[C.L - E].iY, u[C.L].iX, u[C.L].iY), C.A.SY) {
                default:
                  B.push([ZC._i_(l[0]) - a, C.iY - i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(l[0]) - a, _]), g.push([ZC._i_(l[0]) - a, C.iY + i]), f.push(A ? [u[C.L - E].iX, l[1]] : [l[0], u[C.L - E].iY]), f.push(A ? [C.iX, l[1]] : [l[0], C.iY]);
                  break;
                case "before":
                  B.push([ZC._i_(u[C.L - E].iX) - a, C.iY - i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(u[C.L - E].iX) - a, _]), g.push([ZC._i_(u[C.L - E].iX) - a, C.iY + i]), f.push([u[C.L - E].iX, u[C.L - E].iY]), f.push([u[C.L - E].iX, C.iY]);
                  break;
                case "after":
                  B.push([ZC._i_(C.iX) - a, C.iY - i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(C.iX) - a, _]), g.push([ZC._i_(C.iX) - a, C.iY + i]);
              } else c.EF || C.L !== c.W ? C.A.CB && null !== ZC._n_(v) ? (b = C.A.A.A4[C.A.L - 1]) && b.S[C.L] && g.push([ZC._i_(C.iX), b.S[C.L].iY + i]) : (g.push([ZC._i_(C.iX), _]), B.push([ZC._i_(C.iX - c.AC / 2), _]), B.push([ZC._i_(C.iX), _])) : c.AW ? (C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.I - c.BV - d), _]), g.push([ZC._i_(c.iX + c.I - c.BV - d), C.iY + i])) : (C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.AB + d), _]), g.push([ZC._i_(c.iX + c.AB + d), C.iY + i]));
              if (B.push([ZC._i_(C.iX), C.iY - i]), g.push([ZC._i_(C.iX), C.iY + i]), f.push([C.iX, C.iY]), F) switch (C.A.FK(C.L + K, 2).setup(), l = ZC.AR.JZ(u[C.L].iX, u[C.L].iY, u[C.L + K].iX, u[C.L + K].iY, C.N.C6), C.A.SY) {
                default:
                  B.push([ZC._i_(l[0]), C.iY - i]), g.push([ZC._i_(l[0]), C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(l[0]), _]), f.push(A ? [C.iX, l[1]] : [l[0], C.iY]);
                  break;
                case "before":
                  B.push([ZC._i_(C.iX), C.iY - i]), g.push([ZC._i_(C.iX), C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(C.iX), _]);
                  break;
                case "after":
                  B.push([ZC._i_(u[C.L + K].iX), C.iY - i]), g.push([ZC._i_(u[C.L + K].iX), C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(u[C.L + K].iX), _]), f.push([u[C.L + K].iX, C.iY]), f.push([u[C.L + K].iX, u[C.L + K].iY]);
              } else C.L === c.A1 ? c.AW ? (g.push([c.iX + c.AB - d, C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.AB - d), _])) : (g.push([c.iX + c.I - c.BV - d, C.iY + i]), C.A.CB && null !== ZC._n_(v) || g.push([ZC._i_(c.iX + c.I - c.BV - d), _])) : C.A.CB && null !== ZC._n_(v) ? (b = C.A.A.A4[C.A.L - 1]) && b.S[C.L] && g.push([ZC._i_(C.iX), b.S[C.L].iY + i]) : (g.push([ZC._i_(C.iX), _]), B.push([ZC._i_(C.iX), _]), B.push([ZC._i_(C.iX + c.AC / 2), _]));
          }
          if (C.A.CB && null !== ZC._n_(v)) for (r = v.length - 1; r >= 0; r--) g.push(v[r]);
          if (C.setNodeData({
            points: f,
            pointsarea: g
          }), "ready" !== C.C.MK && (C.A.VN = C.A.VN.concat(f)), null === ZC._n_(C.A.A.F2) && (C.A.A.F2 = []), C.A.A.F2[C.L] = B, !e && !C.C.AJ["3d"]) {
            var L = C.N = C.A.I5(C, C.N),
              M = C.C.K + ZC._[34] + C.C.K + ZC._[35] + C.A.L + ZC._[6];
            L.DJ = M, L.K = C.K, C.A.I1 && C.GN(L);
            var H,
              G = C.C.P;
            if (0 !== C.A.E5.length || C.A.I1 || typeof C.A.A9W === ZC._[31] || C.N.o.override || C.C.KP ? ((H = new DW(C.A)).copy(L), H.C6 = C.A.I6) : H = C.A.A9W, C.GN(H), H.C6 = ZC._f_(H.o["alpha-area"] || "1"), H.CY = !1, H.LD = !0, H.AZ = 0, H.AU = 0, H.EX = 0, H.GD = 0, H.Z = C.A.CN("bl", C.C.CB ? 0 : 1), H.D = g, H.D0 = [G.iX, G.iY, G.iX + G.I, G.iY + G.F], null !== ZC._n_(t = C.A.E["min-y"]) && (H.E["bound-1"] = t, H.D0[1] = t), null !== ZC._n_(t = C.A.E["max-y"]) && (H.E["bound-3"] = t, H.D0[3] = t), H.K = C.K + "-area", C.A.GI || (H.E.areanode = !0), ZC.CQ.setup(Z, L), C.paintPreview(L, f, g), C.A.GI && !C.C.HO) {
              var P = new DW(C),
                N = {};
              P.copy(L), P.K = C.K, P.Z = C.A.CN("bl", 2), P.C7 = C.A.CN("bl", 1), P.D = f;
              var O = H,
                S = {},
                Q = [],
                k = [];
              P.D = f, N.points = f, O.D = g, S.points = g;
              var T = C.A.LL,
                z = C.C.P;
              P.C6 = 0, N.alpha = L.C6, O.C6 = 0, S.alpha = C.A.I6;
              var V,
                R = function R(e) {
                  for (var t = e ? g : f, i = e ? k : Q, a = 0; a < t.length; a++) 2 === T ? i[a] = [t[a][0], z.iY + C.C.P.F / 2] : 3 === T ? i[a] = [t[a][0], z.iY - 5] : 4 === T ? i[a] = [t[a][0], z.iY + z.F + 5] : 5 === T ? i[a] = [z.iX - 5, t[a][1]] : 6 === T ? i[a] = [z.iX + z.I + 5, t[a][1]] : 7 === T ? i[a] = [z.iX + z.I / 2, t[a][1]] : 8 === T ? i[a] = [t[a][0] - z.I, t[a][1]] : 9 === T ? i[a] = [t[a][0] + z.I, t[a][1]] : 10 === T ? i[a] = [t[a][0], t[a][1] - z.F] : 11 === T ? i[a] = [t[a][0], t[a][1] + z.F] : 12 === T ? i[a] = [(t[0][0] + t[t.length - 1][0]) / 2, t[0][1]] : 13 === T && (i[a] = [t[0][0], (t[0][1] + t[t.length - 1][1]) / 2]), T > 1 && (e ? (O.D = k, S.points = g) : (P.D = Q, N.points = f));
                };
              for (V in R(), R(!0), C.A.FW) P[EB.GP[ZC.EE(V)]] = C.A.FW[V], N[ZC.EE(V)] = L[EB.GP[ZC.EE(V)]], O[EB.GP[ZC.EE(V)]] = C.A.FW[V], S[ZC.EE(V)] = L[EB.GP[ZC.EE(V)]];
              if (null === ZC._n_(C.C.EM) && (C.C.EM = {}), null === ZC._n_(C.C.T3) && (C.C.T3 = {}), null !== ZC._n_(C.C.EM[C.A.L + "-" + C.L])) {
                for (V in C.C.EM[C.A.L + "-" + C.L]) P[EB.GP[ZC.EE(V)]] = C.C.EM[C.A.L + "-" + C.L][V];
                for (V in C.C.T3[C.A.L + "-" + C.L]) O[EB.GP[ZC.EE(V)]] = C.C.T3[C.A.L + "-" + C.L][V];
              }
              C.C.EM[C.A.L + "-" + C.L] = {}, ZC._cp_(N, C.C.EM[C.A.L + "-" + C.L]), C.C.T3[C.A.L + "-" + C.L] = {}, ZC._cp_(S, C.C.T3[C.A.L + "-" + C.L]);
              var J = new EB(P, N, C.A.JL, C.A.LE, EB.RW[C.A.LI], function () {
                U();
              });
              J.AX = C, J.OK = function () {
                C.MR(ZC.Q.E9(C.A.CN("bl", 1), C.H.AA));
              }, J.IR = Z;
              var W = new EB(O, S, C.A.JL, C.A.LE, EB.RW[C.A.LI], function () {});
              W.AX = C, C.L9(J, W);
            } else H.paint(), 0 !== C.A.E5.length || typeof C.A.A9W !== ZC._[31] || C.N.o.override || C.C.KP || C.C.HO || (C.A.A9W = H), ZC.CQ.paint(Z, L, f), U();
          }
        }
        function U() {
          !C.C.OM && ZC.DR(C.iX, c.iX - 1, c.iX + c.I + 1) && ZC.DR(C.iY, c.iY - 1, c.iY + c.F + 1) && (C.OT(), C.MR(ZC.Q.E9(C.A.CN("bl", 1), C.H.AA)), C.A.U && C.A.U.AN && C.A.E.vboxid !== C.K && C.F8());
        }
      }
    }, {
      key: "paintPreview",
      value: function paintPreview(e, t, i) {
        var a = this;
        if (a.C.B9 && a.C.B9.IP && a.A.R8) {
          var n,
            l = a.C.P,
            r = a.C.B9,
            o = a.A.mapPointsToPreview(i),
            s = new DW(a.A);
          s.copy(e), s.CY = !0, s.LD = !0, s.AZ = 0, s.AU = 0, s.EX = 0, s.GD = 0, s.C6 = a.A.I6, s.D0 = [l.iX, l.iY, l.iX + l.I, l.iY + l.F], s.K = a.K + "-area-preview", s.DJ = a.A.K + "-preview", s.Z = r.Z;
          var C,
            A = a.A.o["preview-state"];
          A && (null !== ZC._n_(A["alpha-area"]) ? (n = A.alpha, A.alpha = A["alpha-area"]) : A.alpha = s.C6, s.append(A), s.parse(), null !== ZC._n_(n) ? A.alpha = n : delete A.alpha), s.D = o, s.paint();
          var Z = a.A.mapPointsToPreview(t);
          a.A.WL ? C = a.A.WL : (C = new CZ(a), a.A.WL = C), C.copy(e), C.K = a.K + "-line-preview", C.DJ = a.A.K + "-preview";
          var c = ZC.Q.E9(r.Z, a.H.AA);
          C.AZ = 1, A && (C.append(A), C.parse()), ZC.CQ.paint(c, C, Z, null, 3);
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || (t.A.P2 || t.LN({
          layer: e,
          type: "area",
          initcb: function initcb() {
            this.A0 = t.A.BP[2], this.AE = t.A.BP[2], this.D = t.getNodeData("pointsarea") || [];
          },
          setupcb: function setupcb() {
            this.AZ = 0, this.AU = 0, this.C6 = t.A.I6;
            var e = t.C.P;
            this.D0 = [e.iX, e.iY, e.iX + e.I, e.iY + e.F];
          }
        }), t.YJ(e), t.A.RL && t.SB(e));
      }
    }]);
    return A3J;
  }(MI);
  var ZU = /*#__PURE__*/function (_MI3) {
    _inherits(ZU, _MI3);
    function ZU() {
      _classCallCheck(this, ZU);
      return _possibleConstructorReturn(this, _getPrototypeOf(ZU).apply(this, arguments));
    }
    _createClass(ZU, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "OL",
      value: function OL() {
        var e = this;
        e.paint(!0);
        var t = e.C.BJ(e.A.BT("v")[0]);
        return [e.iX + e.I / 2, e.iY + (t.AW ? e.F : 0), {
          reference: e,
          center: !0
        }];
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this,
          i = "top-out",
          a = t.C.BJ(t.A.BT("v")[0]),
          n = t.AD >= a.HA && !a.AW || t.AD < a.HA && a.AW ? 1 : -1;
        e = t.setupValueBoxWH(e), null !== ZC._n_(e.o[ZC._[7]]) && (i = e.o[ZC._[7]]);
        var l = e.I,
          r = e.F,
          o = t.iX + t.I / 2 - l / 2,
          s = t.iYVal - r / 2,
          C = e.A9 % 180 == 90,
          A = C ? l / 2 : r / 2,
          Z = C ? l / 2 - r / 2 : 0;
        switch (i) {
          case "top-out":
          case "top":
            s -= n * (A + 5);
            break;
          case "top-in":
            s += n * (A + 5);
            break;
          case "middle":
            s += n * (t.F / 2);
            break;
          case "bottom-in":
            s += n * (t.F - A - 5);
            break;
          case "bottom-out":
          case "bottom":
            s += n * (t.F + r / 2 + 5);
        }
        if (null !== ZC._n_(e.o.x) || null !== ZC._n_(e.o.y)) null !== ZC._n_(e.o.x) && (o = e.iX), null !== ZC._n_(e.o.y) && (s = e.iY);else {
          var c = ZC._c_(t.A.o.tolerance, 5);
          if (!ZC.AR._boxoverlap2_(t, t.C.P, c)) return [-1, -1];
        }
        var p = e.o.tolerance || [t.C.P.E7, t.C.P.E6, t.C.P.DP, t.C.P.DX];
        return t.C.AJ["3d"] || (o = ZC.BQ(t.C.P.iX + 0 - p[3], o), o = ZC.CX(t.C.P.iX + t.C.P.I - l - 0 + p[1], o), s - Z < t.C.P.iY + 5 - p[0] && (s = t.C.P.iY + 5 - p[0] + Z), s + Z > t.C.P.iY + t.C.P.F - r - 5 + p[2] && (s = t.C.P.iY + t.C.P.F - r - 5 + p[2] - Z)), [ZC._i_(o), ZC._i_(s)];
      }
    }, {
      key: "getPMap",
      value: function getPMap() {
        var e = _get(_getPrototypeOf(ZU.prototype), "getPMap", this).call(this);
        return this.addPMap(e, "barWidth", "I"), e;
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t,
          i = this;
        if (_get(_getPrototypeOf(ZU.prototype), "paint", this).call(this), !i.C.AJ["3d"]) {
          typeof e === ZC._[31] && (e = !1);
          var a = i.A.B1,
            n = i.A.CL;
          i.setup();
          var l,
            r,
            o,
            s,
            C,
            A = n.HA,
            Z = n.AM(A),
            c = i.A.R5(),
            p = c.AC,
            u = c.ET,
            h = c.CD,
            _ = c.CS,
            d = c.F4,
            f = c.D3,
            g = c.F0;
          if (e ? u = i.A.E["node-" + i.L + "-bar-index"] : i.A.E["node-" + i.L + "-bar-index"] = c.ET, i.A.CB) {
            l = 0;
            for (var B = i.A.A.KI[u], v = 0; v < B.length; v++) {
              var m = i.A.A.A4[B[v]].S[i.L];
              m && (l += m.AD);
            }
          }
          var b = 1,
            E = 1;
          if (i.A.CB && (i.CR !== i.AD && (b = (l - i.CR + i.AD) / l), E = (l - i.CR) / l), n.AW) {
            var K = b;
            b = E, E = K;
          }
          i.A.M1 && (u = i.L);
          var D = i.iX - p / 2 + h + u * (f + d) - u * g;
          if (D = ZC._l_(D, i.iX - p / 2 + h, i.iX + p / 2 - _), i.A.D3 > 0) {
            var F = f;
            (f = i.A.D3) <= 1 && (f *= F), D += (F - f) / 2;
          }
          var I = f,
            x = i.iY,
            y = null !== ZC._n_(i.A.M5[i.L]) ? i.A.M5[i.L] : 0;
          if (x = i.A.CB && "100%" === i.A.KX ? n.AM(100 * (i.CR + y) / i.A.A.F9[i.L]["%total-" + i.A.DY]) : n.AM(i.CR + y), i.A.CB) {
            r = "100%" === i.A.KX ? n.AM(100 * (i.CR - i.AD + y) / i.A.A.F9[i.L]["%total-" + i.A.DY]) : n.AM(i.CR - i.AD + y), x = ZC._i_(x), r = ZC._i_(r);
            var X = !n.AW && i.AD >= 0 || n.AW && i.AD <= 0 ? -1 : 1,
              Y = 0,
              w = 0;
            "" !== i.A.QF ? (Y = i.V2(i.A.QF)[0], w = 0) : Y = i.A.AU, "" !== i.A.O1 ? (w = i.V2(i.A.O1)[0], Y = 0) : w = i.A.AU, Y !== w && (X = 0), o = x - r + X * Y, i.AD < 0 && (x = r), n.AW ? o > 0 && (o = ZC._a_(o), x = r) : o < 0 && (o = ZC._a_(o), x = r - o), n.AW && i.AD < 0 && (o += w);
          } else r = n.AM(y), (o = x - r) < 0 ? (o = ZC._a_(o), x = r - o) : x = r;
          if (i.A.U8 && i.A.CB && i.A.L > 0 && i.A.A.A4[i.A.L - 1].S[i.L] && 0 === i.A.A.A4[i.A.L - 1].S[i.L].AD && (o -= 1, x += n.AW ? 1 : -1), o < 2 && (i.AD > 0 || i.A.U8) && (o = 1, n.AW ? i.A.CB && i.A.L > 0 && (x -= 1) : i.A.CB ? 0 === i.A.L && (x -= 1) : x = y ? r - 1 : Z - 2), i.I = I, i.F = o, i.iX = D, i.iY = x, n.AW ? i.AD >= n.HA ? i.iYVal = x + i.F : i.iYVal = x : i.AD >= n.HA ? i.iYVal = x : i.iYVal = x + i.F, i.C.CW) {
            var L = "middle";
            i.C.CW.o.marker && null !== ZC._n_(t = i.C.CW.o.marker.alignment) && (L = t), null !== ZC._n_(i.A.o["guide-marker"]) && null !== ZC._n_(t = i.A.o["guide-marker"].alignment) && (L = t), "node" === L && (i.E.A69 = i.iX + i.I / 2);
          }
          if (!e) {
            var M;
            i.setNodeData({
              x: D,
              y: x,
              w: I,
              h: o
            });
            var H = !0;
            if ("none" !== i.A.J7 || i.C.J4[i.A.L] || i.C.KP || i.A.T5 && i.A.T5[i.L] ? (M = i.N = i.A.I5(i, i.N), H = !1) : M = i.N, (0 !== i.A.E5.length || i.A.I1 || i.N.o.override || i.C.KP) && (H = !1), i.AN) {
              var G;
              switch (i.A.CV) {
                default:
                  0 !== i.A.E5.length || i.A.I1 || typeof i.A.TY === ZC._[31] || i.N.o.override || i.C.KP ? (G = new I3(i.A)).copy(M) : G = i.A.TY, i.A.I1 && (i.GN(G), G.parse()), G.FG = i.A.FG, G.K = i.K, G.iX = D, G.iY = x, G.I = i.I, G.F = i.F, a.AC < 5 && G.I < 5 ? (G.I = ZC.BQ(1, G.I) + 1, G.N9 = !1, G.CY = !1) : G.N9 = !0, G.I < 5 && a.A1 !== a.W && i.C.P.I / (a.A1 - a.W) < 1 && (G.QY = !0);
                  break;
                case "pyramid":
                case "cone":
                  0 !== i.A.E5.length || i.A.I1 || typeof i.A.TY === ZC._[31] || i.N.o.override || i.C.KP ? (G = new DW(i.A)).copy(M) : G = i.A.TY, i.A.I1 && (i.GN(G), G.parse()), G.K = i.K, n.AW && !i.A.CB ? (C = i.AD >= 0 ? 0 : i.F, s = i.AD >= 0 ? i.F : 0) : (C = i.AD >= 0 ? i.F : 0, s = i.AD >= 0 ? 0 : i.F), G.D = [], G.D.push([D + i.I / 2 - b * i.I / 2, x + C], [D + i.I / 2 + b * i.I / 2, x + C]), i.A.CB && 0 !== E ? G.D.push([D + i.I / 2 + E * i.I / 2, x + s], [D + i.I / 2 - E * i.I / 2, x + s]) : G.D.push([D + i.I / 2, x + s]), G.D.push([G.D[0][0], G.D[0][1]]), i.setNodeData({
                    points: G.D
                  }), G.iX = D, G.iY = x, G.locate(2);
              }
              G.Z = i.A.CN("bl", 1), G.C7 = i.A.CN("bl", 0), i.paintPreview(M, H);
              var P = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6];
              G.DJ = P;
              var N = ZC._c_(i.A.o.tolerance, 5),
                O = function O() {
                  if (typeof i.paint_ !== ZC._[31] && i.paint_(), i.MR(ZC.Q.E9(G.Z, i.H.AA)), ZC.AR._boxoverlap2_(i, i.C.P, N) && i.A.FZ && -1 === ZC.AV(i.H.L0, ZC._[39])) {
                    var e = I < 5 ? .5 : -.5,
                      t = o < 3 ? .5 : -.5,
                      a = ZC.Q.G2("rect", i.A.E8, G.J3) + 'class="' + P + '" ' + i.a11y() + ' id="' + i.K + ZC._[30] + ZC._i_(D + i.A.BM + ZC.MAPTX - e) + "," + ZC._i_(x + i.A.BH + ZC.MAPTX - t) + "," + ZC._i_(D + i.A.BM + I + ZC.MAPTX + e) + "," + ZC._i_(x + i.A.BH + o + ZC.MAPTX + t) + '" />';
                    i.A.A.HK.push(a);
                  }
                  i.A.U && i.A.U.AN && i.F8();
                };
              if (i.A.GI && !i.C.HO) {
                var S = G,
                  Q = {};
                S.iX = D, S.iY = x, S.I = I, S.F = o, Q.x = D, Q.y = x, Q.width = I, Q.height = o;
                var k,
                  T = i.A.LL,
                  z = i.C.P;
                for (k in S.C6 = 0, Q.alpha = M.C6, 2 === T ? (S.iY = z.iY + z.F / 2, S.F = 1, Q.height = i.F, Q.y = x) : 3 === T ? (S.iY = z.iY, S.F = 1, Q.height = i.F, Q.y = x) : 4 === T ? (S.iY = z.iY + z.F, S.F = 1, Q.height = i.F, Q.y = x) : 5 === T ? (S.iX = z.iX, S.I = 1, Q.width = i.I, Q.x = D) : 6 === T ? (S.iX = z.iX + z.I, S.I = 1, Q.width = i.I, Q.x = D) : 7 === T ? (S.iX = z.iX + z.I / 2, S.I = 1, Q.width = i.I, Q.x = D) : 8 === T ? (S.iX = D - z.I, Q.x = D) : 9 === T ? (S.iX = D + z.I, Q.x = D) : 10 === T ? (S.iY = x - z.F, Q.y = x) : 11 === T ? (S.iY = x + z.F, Q.y = x) : 12 === T ? (S.I = 1, Q.width = i.I) : 13 === T && (S.F = 1, Q.height = i.F), i.A.FW) S[EB.GP[ZC.EE(k)]] = i.A.FW[k], Q[ZC.EE(k)] = M[EB.GP[ZC.EE(k)]];
                if (null === ZC._n_(i.C.EM) && (i.C.EM = {}), null !== ZC._n_(i.C.EM[i.A.L + "-" + i.L])) for (k in i.C.EM[i.A.L + "-" + i.L]) S[EB.GP[ZC.EE(k)]] = i.C.EM[i.A.L + "-" + i.L][k];
                if (i.C.EM[i.A.L + "-" + i.L] = {}, ZC._cp_(Q, i.C.EM[i.A.L + "-" + i.L]), ZC.AR._boxoverlap2_(i, i.C.P, N)) {
                  var V = new EB(S, Q, i.A.JL, i.A.LE, EB.RW[i.A.LI], function () {
                    O();
                  });
                  V.AX = i, V.OK = function () {
                    i.MR(ZC.Q.E9(G.Z, i.H.AA));
                  }, i.L9(V);
                }
              } else {
                if (G.AN || 0 === i.A.E5.length && !i.A.I1) if (i.A.WR || (i.A.WR = {
                  iX: G.iX,
                  iY: G.iY,
                  F: G.F
                }), i.A.A37) {
                  if (i.A.SO) {
                    if (i.A.SO.el && "RECT" === i.A.SO.el.tagName.toUpperCase()) {
                      var R = !1;
                      if (i.A.NF && i.A.WR && ZC._a_(G.iX - i.A.WR.iX) < .75 && ZC._a_(G.iY - i.A.WR.iY) < 1.5 && ZC._a_(G.F - i.A.WR.F) < 1.5 && (R = !0), !R) {
                        i.A.WR = {
                          iX: G.iX,
                          iY: G.iY,
                          F: G.F
                        };
                        var J = i.A.SO.el.cloneNode(!1);
                        J.setAttribute("id", i.K), J.setAttribute("x", i.iX), J.setAttribute("y", i.iY), J.setAttribute(ZC._[20], i.F), i.A.SO.df ? i.H.G3[G.Z.id].appendChild(J) : i.A.SO.el.parentNode.appendChild(J);
                      }
                    } else G.paint();
                  } else G.paint(), i.A.SO = {
                    id: G.K + "-path"
                  }, zingchart.DEV.DOMFRAGMENTS && document.querySelector && i.H.G3 && i.H.G3[G.Z.id] ? (i.A.SO.df = !0, i.A.SO.el = i.H.G3[G.Z.id].querySelector("#" + G.K + "-path")) : (i.A.SO.df = !1, i.A.SO.el = ZC.AK(i.A.SO.id));
                } else ZC.AR._boxoverlap2_(i, i.C.P, N) && G.paint();
                G.AN && O();
              }
              "svg" === i.H.AA && i.A.applyJsRuleSvg(i.A, i.K + "-path", i.LM()), 0 !== i.A.E5.length || i.A.I1 || typeof i.A.TY !== ZC._[31] || i.N.o.override || i.C.KP || i.A.GI || (i.A.TY = G);
            }
          }
        }
      }
    }, {
      key: "paintPreview",
      value: function paintPreview(e, t) {
        var i,
          a,
          n = this;
        if (n.C.B9 && n.C.B9.IP && n.A.R8) {
          var l = n.C.P,
            r = n.C.B9,
            o = r.AT,
            s = (n.iX - l.iX) / l.I,
            C = (n.iY - l.iY) / l.F;
          n.A.WM ? i = n.A.WM : (i = new I3(n.A), n.A.WM = i, i.copy(e), (a = n.A.o["preview-state"]) && (i.append(a), i.parse())), t || (i.copy(e), (a = n.A.o["preview-state"]) && (i.append(a), i.parse())), i.K = n.K + "-preview", i.DJ = n.A.K + "-preview", i.iX = o.iX + o.AU + s * (o.I - 2 * o.AU), i.iY = o.iY + o.AU + C * (o.F - 2 * o.AU), i.I = n.I / l.I * (o.I - 2 * o.AU), i.F = n.F / l.F * (o.F - 2 * o.AU), o.I / n.A.S.length < 10 ? (i.I = i.I + .5, i.N9 = !1, i.CY = !1) : (i.N9 = !0, i.CY = !0), i.Z = i.C7 = r.Z, i.paint();
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        if (e = e || "hover", !ZC.move) {
          var i = "";
          switch (t.A.CV) {
            default:
              i = "box";
              break;
            case "pyramid":
              i = "shape";
          }
          t.LN({
            layer: e,
            type: i,
            initcb: function initcb() {
              this.A0 = t.A.BP[3], this.B7 = t.A.BP[1], this.BW = t.A.BP[1], this.AE = t.A.BP[2];
            },
            setupcb: function setupcb() {
              switch (t.A.CV) {
                default:
                  this.iX = t.getNodeData("x"), this.iY = t.getNodeData("y"), this.I = t.getNodeData("w"), this.F = t.getNodeData("h");
                  var e = t.C.P;
                  this.iY < e.iY && (this.F = this.F - (e.iY - this.iY), this.iY = e.iY), this.iY + this.F > e.iY + e.F && (this.F = e.iY + e.F - this.iY);
                  break;
                case "pyramid":
                case "cone":
                  this.D = t.getNodeData("points");
              }
            }
          }), t.MR(ZC.Q.E9(t.C.K + ZC._[22], t.H.AA), !0), t.A.RX = null;
        }
      }
    }]);
    return ZU;
  }(MI);
  var A03 = /*#__PURE__*/function (_MI4) {
    _inherits(A03, _MI4);
    function A03() {
      _classCallCheck(this, A03);
      return _possibleConstructorReturn(this, _getPrototypeOf(A03).apply(this, arguments));
    }
    _createClass(A03, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "OL",
      value: function OL() {
        var e = this;
        e.paint(!0);
        var t = e.C.BJ(e.A.BT("v")[0]);
        return [e.iX + (t.AW ? 0 : e.I), e.iY + e.F / 2, {
          reference: e,
          center: !0
        }];
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this,
          i = "top-out",
          a = t.C.BJ(t.A.BT("v")[0]),
          n = t.AD >= a.HA && !a.AW || t.AD < a.HA && a.AW ? -1 : 1;
        null !== ZC._n_(e.o[ZC._[7]]) && (i = e.o[ZC._[7]]);
        var l = e.I,
          r = e.F,
          o = t.iXVal - l / 2,
          s = t.iY + t.F / 2 - r / 2,
          C = e.A9 % 180 == 90 ? r / 2 : l / 2;
        switch (i) {
          case "top-out":
          case "top":
            o -= n * (C + 5);
            break;
          case "top-in":
            o += n * (C + 5);
            break;
          case "middle":
            o += n * (t.I / 2);
            break;
          case "bottom-in":
            o += n * (t.I - C - 5);
            break;
          case "bottom-out":
          case "bottom":
            o += n * (t.I + C + 5);
        }
        if (null !== ZC._n_(e.o.x) || null !== ZC._n_(e.o.y)) null !== ZC._n_(e.o.x) && (o = e.iX), null !== ZC._n_(e.o.y) && (s = e.iY);else {
          var A = ZC._c_(t.A.o.tolerance, 5);
          if (!ZC.AR._boxoverlap2_(t, t.C.P, A)) return [-1, -1];
        }
        var Z = e.o.tolerance || [t.C.P.E7, t.C.P.E6, t.C.P.DP, t.C.P.DX];
        return t.C.AJ["3d"] || (o = ZC.BQ(t.C.P.iX + 5 - Z[3], o), o = ZC.CX(t.C.P.iX + t.C.P.I - l - 5 + Z[1], o), s = ZC.BQ(t.C.P.iY + 0 - Z[0], s), s = ZC.CX(t.C.P.iY + t.C.P.F - r / 2 - 0 + Z[2], s)), [ZC._i_(o), ZC._i_(s)];
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t = this;
        if (_get(_getPrototypeOf(A03.prototype), "paint", this).call(this), !t.C.AJ["3d"]) {
          typeof e === ZC._[31] && (e = !1);
          var i = t.A.B1,
            a = t.A.CL;
          t.setup();
          var n,
            l,
            r,
            o,
            s,
            C = t.A.R5(),
            A = C.AC,
            Z = C.ET,
            c = C.CD,
            p = C.CS,
            u = C.F4,
            h = C.D3,
            _ = C.F0;
          if (e ? Z = t.A.E["node-" + t.L + "-bar-index"] : t.A.E["node-" + t.L + "-bar-index"] = C.ET, t.A.CB) {
            n = 0;
            for (var d = t.A.A.KI[Z], f = 0; f < d.length; f++) {
              var g = t.A.A.A4[d[f]].S[t.L];
              g && (n += g.AD);
            }
          }
          var B = 1,
            v = 1;
          if (t.A.CB && (t.CR !== t.AD && (B = (n - t.CR + t.AD) / n), v = (n - t.CR) / n), a.AW) {
            var m = B;
            B = v, v = m;
          }
          t.A.M1 && (Z = t.L);
          var b = t.iY - A / 2 + c + Z * (h + u) - Z * _;
          if (b = ZC._l_(b, t.iY - A / 2 + c, t.iY + A / 2 - p), t.A.D3 > 0) {
            var E = h;
            (h = t.A.D3) <= 1 && (h *= E), b += (E - h) / 2;
          }
          var K = h,
            D = t.iX,
            F = null !== ZC._n_(t.A.M5[t.L]) ? t.A.M5[t.L] : 0;
          if (D = t.A.CB && "100%" === t.A.KX ? a.AM(100 * (t.CR + F) / t.A.A.F9[t.L]["%total-" + t.A.DY]) : a.AM(t.CR + F), t.A.CB) {
            l = "100%" === t.A.KX ? a.AM(100 * (t.CR - t.AD + F) / t.A.A.F9[t.L]["%total-" + t.A.DY]) : a.AM(t.CR - t.AD + F), D = ZC._i_(D), l = ZC._i_(l);
            var I = !a.AW && t.AD >= 0 || a.AW && t.AD <= 0 ? 1 : -1,
              x = 0,
              y = 0;
            "" !== t.A.OV ? (x = t.V2(t.A.OV)[0], y = 0) : x = t.A.AU, "" !== t.A.PK ? (y = t.V2(t.A.PK)[0], x = 0) : y = t.A.AU, x !== y && (I = 0), r = D - l + I * x, t.AD > 0 ? D = l : r = ZC._a_(r), a.AW ? r > 0 ? (r = ZC._a_(r), D = l) : (r = ZC._a_(r), D -= r) : r < 0 && (r = ZC._a_(r), D = l - r);
          } else l = a.AM(F), (r = D - l) < 0 ? (r = ZC._a_(r), D = l - r) : D = l;
          if (t.A.U8 && t.A.CB && t.A.L > 0 && t.A.A.A4[t.A.L - 1].S[t.L] && 0 === t.A.A.A4[t.A.L - 1].S[t.L].AD && (r -= 1, D += a.AW ? -1 : 1), r < 1 && (t.AD > 0 || t.A.U8) && (r = 1, a.AW ? t.A.CB ? 0 === t.A.L && (D -= 1) : D -= 2 : t.A.L > 0 && t.A.CB && (D -= 1)), t.I = r, t.F = K, t.iX = D, t.iY = b, a.AW ? t.AD >= a.HA ? t.iXVal = D : t.iXVal = D + t.I : t.AD >= a.HA ? t.iXVal = D + t.I : t.iXVal = D, !e) {
            var X;
            t.setNodeData({
              x: D,
              y: b,
              w: r,
              h: K
            });
            var Y = !0;
            if ("none" !== t.A.J7 || t.C.J4[t.A.L] || t.C.KP || t.A.T5 && t.A.T5[t.L] ? (X = t.N = t.A.I5(t, t.N), Y = !1) : X = t.N, (0 !== t.A.E5.length || t.A.I1 || t.N.o.override || t.C.KP) && (Y = !1), t.AN) {
              var w;
              switch (t.A.CV) {
                default:
                  0 !== t.A.E5.length || t.A.I1 || typeof t.A.TY === ZC._[31] || t.N.o.override || t.C.KP ? (w = new I3(t.A)).copy(X) : w = t.A.TY, t.A.I1 && (t.GN(w), w.parse()), w.FG = t.A.FG, w.K = t.K, w.iX = D, w.iY = b, w.I = t.I, w.F = t.F, i.AC < 5 && w.F < 5 ? (w.F = ZC.BQ(1, w.F) + 1, w.N9 = !1, w.CY = !1) : w.N9 = !0, w.F < 5 && i.A1 !== i.W && t.C.P.F / (i.A1 - i.W) < 1 && (w.QY = !0);
                  break;
                case "pyramid":
                case "cone":
                  0 !== t.A.E5.length || t.A.I1 || typeof t.A.TY === ZC._[31] || t.N.o.override || t.C.KP ? (w = new DW(t.A)).copy(X) : w = t.A.TY, t.A.I1 && (t.GN(w), w.parse()), w.K = t.K, a.AW && !t.A.CB ? (s = t.AD >= 0 ? t.I : 0, o = t.AD >= 0 ? 0 : t.I) : (s = t.AD >= 0 ? 0 : t.I, o = t.AD >= 0 ? t.I : 0), w.D = [], w.D.push([D + s, b + t.F / 2 - B * t.F / 2], [D + s, b + t.F / 2 + B * t.F / 2]), t.A.CB && 0 !== v ? w.D.push([D + o, b + t.F / 2 + v * t.F / 2], [D + o, b + t.F / 2 - v * t.F / 2]) : w.D.push([D + o, b + t.F / 2]), w.D.push([w.D[0][0], w.D[0][1]]), t.E.points = w.D, w.iX = D, w.iY = b, w.locate(2);
              }
              w.Z = t.A.CN("bl", 1), w.C7 = t.A.CN("bl", 0), t.paintPreview(X, Y);
              var L = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6];
              w.DJ = L;
              var M = ZC._c_(t.A.o.tolerance, 5),
                H = function H() {
                  if (typeof t.paint_ !== ZC._[31] && t.paint_(), t.MR(ZC.Q.E9(w.Z, t.H.AA)), ZC.AR._boxoverlap2_(t, t.C.P, M) && t.A.FZ && -1 === ZC.AV(t.H.L0, ZC._[39])) {
                    var e = r < 3 ? .5 : -.5,
                      i = K < 5 ? .5 : -.5,
                      a = ZC.Q.G2("rect", t.A.E8, w.J3) + 'class="' + L + '" ' + t.a11y() + ' id="' + t.K + ZC._[30] + ZC._i_(D + t.A.BM + ZC.MAPTX - e) + "," + ZC._i_(b + t.A.BH + ZC.MAPTX - i) + "," + ZC._i_(D + t.A.BM + r + ZC.MAPTX + e) + "," + ZC._i_(b + t.A.BH + K + ZC.MAPTX + i) + '" />';
                    t.A.A.HK.push(a);
                  }
                  t.A.U && t.A.U.AN && t.F8();
                };
              if (t.A.GI && !t.C.HO) {
                var G = w,
                  P = {};
                G.iX = D, G.iY = b, G.I = r, G.F = K, P.x = D, P.y = b, P.width = r, P.height = K;
                var N,
                  O = t.A.LL,
                  S = t.C.P;
                for (N in G.C6 = 0, P.alpha = X.C6, 2 === O ? (G.iX = S.iX + S.I / 2, G.I = 1, P.width = t.I, P.x = D) : 3 === O ? (G.iX = S.iX + S.I, G.I = 1, P.width = t.I, P.x = D) : 4 === O ? (G.iX = S.iX, G.I = 1, P.width = t.I, P.x = D) : 5 === O ? (G.iY = S.iY + S.F, G.F = 1, P.height = t.F, P.y = b) : 6 === O ? (G.iY = S.iY, G.F = 1, P.height = t.F, P.y = b) : 7 === O ? (G.iY = S.iY + S.F / 2, G.F = 1, P.height = t.F, P.y = b) : 8 === O ? (G.iY = b + S.F, P.y = b) : 9 === O ? (G.iY = b - S.F, P.y = b) : 10 === O ? (G.iX = D + S.I, P.x = D) : 11 === O ? (G.iX = D - S.I, P.x = D) : 12 === O ? (G.F = 1, P.height = t.F) : 13 === O && (G.I = 1, P.width = t.I), t.A.FW) G[EB.GP[ZC.EE(N)]] = t.A.FW[N], P[ZC.EE(N)] = t.N[EB.GP[ZC.EE(N)]];
                if (null === ZC._n_(t.C.EM) && (t.C.EM = {}), null !== ZC._n_(t.C.EM[t.A.L + "-" + t.L])) for (N in t.C.EM[t.A.L + "-" + t.L]) G[EB.GP[ZC.EE(N)]] = t.C.EM[t.A.L + "-" + t.L][N];
                if (t.C.EM[t.A.L + "-" + t.L] = {}, ZC._cp_(P, t.C.EM[t.A.L + "-" + t.L]), ZC.AR._boxoverlap2_(t, t.C.P, M)) {
                  var Q = new EB(G, P, t.A.JL, t.A.LE, EB.RW[t.A.LI], function () {
                    H();
                  });
                  Q.AX = t, Q.OK = function () {
                    t.MR(ZC.Q.E9(w.Z, t.H.AA));
                  }, t.L9(Q);
                }
              } else (w.AN || 0 === t.A.E5.length && !t.A.I1) && ZC.AR._boxoverlap2_(t, t.C.P, M) && w.paint(), w.AN && H();
              "svg" === t.H.AA && t.A.applyJsRuleSvg(t.A, t.K + "-path", t.LM()), 0 !== t.A.E5.length || t.A.I1 || typeof t.A.TY !== ZC._[31] || t.N.o.override || t.C.KP || t.A.GI || (t.A.TY = w);
            }
          }
        }
      }
    }, {
      key: "paintPreview",
      value: function paintPreview(e, t) {
        var i,
          a,
          n = this;
        if (n.C.B9 && n.C.B9.IP && n.A.R8) {
          var l = n.C.P,
            r = n.C.B9,
            o = r.AT,
            s = (n.iX - l.iX) / l.I,
            C = (n.iY - l.iY) / l.F;
          n.A.WM ? i = n.A.WM : (i = new I3(n.A), n.A.WM = i, i.copy(e), (a = n.A.o["preview-state"]) && (i.append(a), i.parse())), t || (i.copy(e), (a = n.A.o["preview-state"]) && (i.append(a), i.parse())), i.K = n.K + "-preview", i.DJ = n.A.K + "-preview", i.iX = o.iX + o.AU + s * (o.I - 2 * o.AU), i.iY = o.iY + o.AU + C * (o.F - 2 * o.AU), i.I = n.I / l.I * (o.I - 2 * o.AU), i.F = n.F / l.F * (o.F - 2 * o.AU), o.I / n.A.S.length < 10 ? (i.I = i.I + .5, i.N9 = !1, i.CY = !1) : (i.N9 = !0, i.CY = !0), i.Z = i.C7 = r.Z, i.paint();
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        if (!ZC.move) {
          var i = "";
          switch (t.A.CV) {
            default:
              i = "box";
              break;
            case "pyramid":
              i = "shape";
          }
          t.LN({
            layer: e,
            type: i,
            initcb: function initcb() {
              this.B7 = t.A.BP[1], this.BW = t.A.BP[1], this.A0 = t.A.BP[3], this.AE = t.A.BP[2];
            },
            setupcb: function setupcb() {
              switch (t.A.CV) {
                default:
                  this.iX = t.getNodeData("x"), this.iY = t.getNodeData("y"), this.I = t.getNodeData("w"), this.F = t.getNodeData("h");
                  var e = t.C.P;
                  this.iX < e.iX && (this.I = this.I - (e.iX - this.iX), this.iX = e.iX), this.iX + this.I > e.iX + e.I && (this.I = e.iX + e.I - this.iX);
                  break;
                case "pyramid":
                case "cone":
                  this.D = t.getNodeData("points");
              }
            }
          }), t.MR(ZC.Q.E9(t.C.K + ZC._[22], t.H.AA), !0), t.A.RX = null;
        }
      }
    }]);
    return A03;
  }(MI);
  var A6H = /*#__PURE__*/function (_MI5) {
    _inherits(A6H, _MI5);
    function A6H() {
      _classCallCheck(this, A6H);
      return _possibleConstructorReturn(this, _getPrototypeOf(A6H).apply(this, arguments));
    }
    _createClass(A6H, [{
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        if (e.JT !== a) {
          if ("scatter" === e.A.AF) {
            if (e.A.M1 && e.A.QG) {
              var n = ZC.AR.WV(e.A.QG[0], e.A.QG[1]),
                l = (e.BU - n[0]) / (n[1] - n[0]);
              e.iX = t.H6(e.A.RI) - t.AC / 2 + e.A.S4 + l * (t.AC - 2 * e.A.S4);
            } else e.iX = t.AM(e.BU);
            e.iY = i.AM(e.AD);
          } else e.iY = t.AM(e.BU), e.iX = i.AM(e.AD);
          e.JT = a;
        }
        e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A6H.prototype), "parse", this).call(this), this.o[ZC._[9]] instanceof Array || (this.BU = this.L);
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: "-1" === this.A.A2.A0 ? this.N.A0 : this.A.A2.A0
        };
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition(e, t) {
        return _get(_getPrototypeOf(A6H.prototype), "getTooltipPosition", this).call(this, e, t, this.NM.AI);
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": "-1" === this.A.A2.AE ? this.N.AE : this.A.A2.AE,
          "border-color": "-1" === this.A.A2.AE ? this.N.AE : this.A.A2.AE,
          color: this.N.C2
        };
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t = this;
        _get(_getPrototypeOf(A6H.prototype), "paint", this).call(this);
        var i = t.A.B1,
          a = t.A.CL;
        t.setup(), e || (i.CO ? ZC.DR(t.iX, a.iX + (a.AW ? a.BV : a.AB) - 1, a.iX + a.I - (a.AW ? a.AB : a.BV) + 1) && ZC.DR(t.iY, i.iY + (i.AW ? i.BV : i.AB) - 1, i.iY + i.F - (i.AW ? i.AB : i.BV) + 1) && t.OT(!1, !0) : ZC.DR(t.iX, i.iX + (i.AW ? i.BV : i.AB) - 1, i.iX + i.I - (i.AW ? i.AB : i.BV) + 1) && ZC.DR(t.iY, a.iY + (a.AW ? a.AB : a.BV) - 1, a.iY + a.F - (a.AW ? a.BV : a.AB) + 1) && t.OT(!1, !0));
      }
    }, {
      key: "HT",
      value: function HT(e) {
        ZC.move || this.SB(e);
      }
    }]);
    return A6H;
  }(MI);
  var A7D = /*#__PURE__*/function (_MI6) {
    _inherits(A7D, _MI6);
    function A7D(e) {
      var _this89;
      _classCallCheck(this, A7D);
      _this89 = _possibleConstructorReturn(this, _getPrototypeOf(A7D).call(this, e)), _this89.T0 = null;
      return _this89;
    }
    _createClass(A7D, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A7D.prototype), "parse", this).call(this), this.o[ZC._[9]] instanceof Array || (this.BU = this.L), this.o[ZC._[9]] instanceof Array && null !== ZC._n_(this.o[ZC._[9]][2]) ? this.T0 = ZC._f_(this.o[ZC._[9]][2]) : this.T0 = 2;
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: "-1" === this.A.A2.A0 ? this.N.A0 : this.A.A2.A0
        };
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition(e, t) {
        var i = this.A.getSize(ZC._a_(this.T0));
        return _get(_getPrototypeOf(A7D.prototype), "getTooltipPosition", this).call(this, e, t, i);
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": "-1" === this.A.A2.AE ? this.N.AE : this.A.A2.AE,
          "border-color": "-1" === this.A.A2.AE ? this.N.AE : this.A.A2.AE,
          color: this.N.C2
        };
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        ZC._cp_(t, l);
        var r = ZC.AQ.G5(n.T0, l);
        return n.CU = [["%v0", n.BU], ["%v1", n.AD], ["%v2", r], ["%node-size-value", r]], e = _get(_getPrototypeOf(A7D.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        if (e.JT !== a) {
          if ("bubble" === e.A.AF) {
            if (e.A.M1 && e.A.QG) {
              var n = ZC.AR.WV(e.A.QG[0], e.A.QG[1]),
                l = (e.BU - n[0]) / (n[1] - n[0]);
              e.iX = t.H6(e.A.RI) - t.AC / 2 + e.A.S4 + l * (t.AC - 2 * e.A.S4);
            } else e.iX = t.AM(e.BU);
            e.iY = i.AM(e.AD);
          } else e.iY = t.AM(e.BU), e.iX = i.AM(e.AD);
          e.JT = a;
        }
        e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = "auto";
        null !== ZC._n_(t = e.o[ZC._[7]]) && (a = t);
        var n = e.I,
          l = e.F,
          r = i.E["marker.size"],
          o = i.iX - n / 2,
          s = i.iY - l / 2,
          C = 0,
          A = 0;
        switch (a) {
          case "top":
            s -= l / 2 + r, A = i.iY - i.C.P.iY + r;
            break;
          case "bottom":
            s += l / 2 + r, A = i.C.P.iY + i.C.P.F - i.iY + r;
            break;
          case "left":
            o -= n / 2 + r, C = i.iX - i.C.P.iX + r;
            break;
          case "right":
            o += n / 2 + r, C = i.C.P.iX + i.C.P.I - i.iX + r;
        }
        return null !== ZC._n_(e.o.x) && (o = e.iX), null !== ZC._n_(e.o.y) && (s = e.iY), o < i.C.P.iX && (o = i.C.P.iX + C), o + n > i.C.P.iX + i.C.P.I && (o = i.C.P.iX + i.C.P.I - n - C), s < i.C.P.iY && (s = i.C.P.iY + A), s + l > i.C.P.iY + i.C.P.F && (s = i.C.P.iY + i.C.P.F - l - A), [ZC._i_(o), ZC._i_(s)];
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t = this;
        typeof e === ZC._[31] && (e = !1), _get(_getPrototypeOf(A7D.prototype), "paint", this).call(this);
        var i = t.A.B1,
          a = t.A.CL;
        t.setup(), t.E["marker.size"] = t.A.getSize(ZC._a_(t.T0)), e || (i.CO ? ZC.DR(t.iX, a.iX + (a.AW ? a.BV : a.AB) - 1, a.iX + a.I - (a.AW ? a.AB : a.BV) + 1) && ZC.DR(t.iY, i.iY + (i.AW ? i.BV : i.AB) - 1, i.iY + i.F - (i.AW ? i.AB : i.BV) + 1) && t.OT(!1, !0) : ZC.DR(t.iX, i.iX + (i.AW ? i.BV : i.AB) - 1, i.iX + i.I - (i.AW ? i.AB : i.BV) + 1) && ZC.DR(t.iY, a.iY + (a.AW ? a.AB : a.BV) - 1, a.iY + a.F - (a.AW ? a.BV : a.AB) + 1) && t.OT(!1, !0));
      }
    }, {
      key: "HT",
      value: function HT(e) {
        ZC.move || this.SB(e);
      }
    }]);
    return A7D;
  }(MI);
  var A9H = /*#__PURE__*/function (_MI7) {
    _inherits(A9H, _MI7);
    function A9H(e) {
      var _this90;
      _classCallCheck(this, A9H);
      _this90 = _possibleConstructorReturn(this, _getPrototypeOf(A9H).call(this, e)), _this90.bCXY = !0, _this90.U = null;
      return _this90;
    }
    _createClass(A9H, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A9H.prototype), "parse", this).call(this);
      }
    }, {
      key: "XD",
      value: function XD() {
        _get(_getPrototypeOf(A9H.prototype), "XD", this).call(this);
        var e = this.C.E;
        e.update.npv = e.update["node-percent-value"] = this.ES("%npv");
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        ZC._cp_(t, l), -1 === e.indexOf("%npv") && -1 === e.indexOf("%node-percent-value") || null !== ZC._n_(l[ZC._[12]]) && -1 !== l[ZC._[12]] || (l[ZC._[12]] = 1);
        var r = 0,
          o = "0";
        if (n.A.A.KU[n.L] > 0 && (o = "" + (r = 100 * n.AD / n.A.A.KU[n.L])), n.A.A.A4.length > 1 && n.A.L === n.A.A.A4.length - 1) {
          var s = 0;
          if (null === ZC._n_(n.A.o.totals)) {
            for (var C = 0; C < n.A.A.A4.length - 1; C++) if (n.A.A.A4[C].AN && null !== ZC._n_(n.A.A.A4[C].S[n.L])) {
              var A = 0,
                Z = "0";
              n.A.A.KU[n.L] > 0 && (Z = "" + (A = 100 * n.A.A.A4[C].S[n.L].AD / n.A.A.KU[n.L])), null !== ZC._n_(l[ZC._[12]]) && (Z = A.toFixed(ZC.BQ(0, ZC._i_(l[ZC._[12]])))), s += ZC._f_(Z);
            }
            o = "" + (r = Math.max(0, 100 - s));
          }
        }
        null !== ZC._n_(l[ZC._[12]]) && (o = r.toFixed(ZC.BQ(0, ZC._i_(l[ZC._[12]]))));
        var c,
          p = ZC._f_(n.A.A.KU[n.L] || "0");
        return c = ZC.AQ.G5(p, l, n.A), n.CU = [["%node-percent-value", o], ["%npv", o], ["%pie-total-value", c]], e = _get(_getPrototypeOf(A9H.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "getTooltipPosition",
      value: function getTooltipPosition(e, t) {
        var i,
          a,
          n,
          l = this,
          r = (l.B4 + l.BK) / 2 % 360;
        switch (t) {
          case "out":
            a = (i = ZC.AR.BN(l.iX, l.iY, l.AI + l.DS + e.DS, r))[0] + l.BM, n = i[1] + l.BH, r > 270 && r <= 360 ? n -= e.F : r > 90 && r <= 180 ? a -= e.I : r > 180 && r <= 270 && (a -= e.I, n -= e.F);
            break;
          case "center":
            a = (i = ZC.AR.BN(l.iX, l.iY, l.CM + .5 * (l.AI - l.CM) + l.DS, r))[0] + l.BM, n = i[1] + l.BH;
            break;
          default:
            a = l.iX + l.BM, n = l.iY + l.BH;
        }
        return {
          x: a,
          y: n
        };
      }
    }, {
      key: "OL",
      value: function OL(e) {
        var t,
          i = this,
          a = (i.B4 + i.BK) / 2 % 360,
          n = 0;
        null !== ZC._n_(t = e["offset-r"]) && (n = ZC._f_(ZC._p_(t))), n < 1 && (n *= i.AI);
        var l = ZC.AR.BN(i.iX, i.iY, i.CM + .6 * (i.AI - i.CM) + i.DS + n, a);
        return [l[0], l[1], {
          reference: i,
          center: !0
        }];
      }
    }, {
      key: "A6B",
      value: function A6B() {
        var e = this,
          t = (e.B4 + e.BK) / 2 % 360,
          i = ZC.AR.BN(e.iX, e.iY, e.CM + .5 * (e.AI - e.CM) + e.DS, t);
        return [i[0], i[1]];
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.C.BJ(e.A.BT("k")[0]),
          i = e.L % t.H5,
          a = Math.floor(e.L / t.H5);
        e.iX = t.iX + i * t.GM + t.GM / 2 + t.BM, e.iY = t.iY + a * t.GG + t.GG / 2 + t.BH, e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "JC",
      value: function JC(e) {
        var t,
          i = {},
          a = "out";
        return null !== ZC._n_(t = e.o[ZC._[7]]) && (a = t), i.color = "out" === a ? this.A0 : this.C2, i;
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = "out";
        null !== ZC._n_(t = e.o[ZC._[7]]) && (a = t);
        var n,
          l,
          r,
          o,
          s,
          C = e.I,
          A = e.F,
          Z = (i.B4 + i.BK) / 2 % 360,
          c = Z;
        if ("out" === a) {
          Z = c = i.A.A.YZ["n" + i.L][i.A.L];
          var p = function p(t, a) {
              a < 0 && (a = 360 + a), a %= 360;
              var n = (s = ZC.AR.BN(i.iX, i.iY, t + i.DS + e.DS + 20, a))[0] + e.BM - C / 2,
                l = s[1] + e.BH - A / 2;
              return a >= 0 && a <= 90 || a >= 270 && a <= 360 ? n += C / 2 + 10 : n -= C / 2 + 10, [n, l];
            },
            u = p(i.AI, c);
          n = u[0], l = u[1], i.U = e;
          var h = {
              x: n,
              y: l,
              width: C,
              height: A
            },
            _ = zingchart.DEV.SPREADTYPE;
          o = !0;
          for (var d = 0, f = 0, g = -1, B = 0, v = 0; o && v < 1024;) {
            o = !1;
            for (var m = 0, b = i.A.A.U6.length; m < b; m++) r = i.A.A.U6[m], (ZC.AR.YG(h, r) || h.x + e.I > i.C.P.iX + i.C.P.I || h.x < i.C.P.iX || h.y + e.F > i.C.P.iY + i.C.P.F || h.y < i.C.P.iY) && (o = !0, 0 === _ ? (d += .4, g *= -1) : 1 === _ && (f += 2), u = p(i.AI + f, c + d * g), h.x = u[0], h.y = u[1], v++, ++B > 100 && (B = 0, 0 === _ ? (d = 0, f += 2) : 1 === _ && (f = 0, d += .4, g *= -1)));
          }
          n = h.x, l = h.y, Z = c + d, r = {
            text: i.A.AO,
            x: h.x,
            y: h.y,
            width: C,
            height: A,
            plotindex: i.A.L,
            nodeindex: i.L
          }, i.A.A.U6.push(r);
        } else if ("in" === a || "radial" === a) {
          var E = i.CM < 30 ? .65 : .5;
          n = (s = i.B4 % 360 == i.BK % 360 ? 0 === i.CM ? [i.iX, i.iY] : ZC.AR.BN(i.iX, i.iY, i.CM + .3 * (i.AI - i.CM) + i.DS + e.DS, 270) : ZC.AR.BN(i.iX, i.iY, i.CM + E * (i.AI - i.CM) + i.DS + e.DS, Z))[0] - C / 2 + i.BM, l = s[1] - A / 2 + i.BH;
        } else if (-1 !== a.indexOf("fixed=")) {
          var K = a.split(/=|;|,/),
            D = (i.AI + i.CM) / 2,
            F = Z;
          K[1] && (D = (D = ZC.IU(K[1], !0)) >= -1 && D <= 1 || -1 !== K[1].indexOf("%") ? i.CM + i.DS + D * (i.AI - i.CM) : i.CM + i.DS + D), K[2] && (F = (F = ZC.IU(K[2], !0)) >= -1 && F <= 1 || -1 !== K[2].indexOf("%") ? i.B4 + F * (i.BK - i.B4) : i.B4 + F), K[3] && ("+" === K[3].charAt(0) || "-" === K[3].charAt(0) ? (F %= 360, e.A9 = F + ZC._f_(K[3]), e.A9 > 90 && e.A9 < 270 && (e.A9 += 180)) : e.A9 = ZC._f_(K[3])), n = (s = ZC.AR.BN(i.iX, i.iY, D, F))[0] - C / 2, l = s[1] - A / 2;
        } else "center" === a && (n = i.iX - C / 2 + i.BM, l = i.iY - A / 2 + i.BH);
        return o && (n = -9999, l = -9999, e.AN = !1), null !== ZC._n_(e.o.x) && (n = e.iX), null !== ZC._n_(e.o.y) && (l = e.iY), n >= -2 && (n = ZC._a_(n)), l >= -2 && (l = ZC._a_(l)), [ZC._i_(n), ZC._i_(l), Z];
      }
    }, {
      key: "appendToValueBox",
      value: function appendToValueBox(e) {
        var t = this,
          i = {};
        if ("radial" === e.o[ZC._[7]]) {
          var a = .9 * ZC._a_(t.AI - t.CM),
            n = Math.PI * (t.AI + t.CM) * .9 * ZC._a_(t.BK - t.B4) / 360,
            l = ZC._i_(Math.max(a, n) / (.75 * e.DG));
          if (null === ZC._n_(e.o.visible) ? i.visible = 1 === t.A.A.A4.length || n > 1.25 * e.DG : i.visible = e.JG.visible, null === ZC._n_(e.o["max-chars"]) && (i["max-chars"] = l), null === ZC._n_(e.o.angle)) {
            var r = (t.B4 + t.BK) / 2 % 360;
            t.A.A.A4.length > 1 ? n > a ? r > 0 && r < 180 ? r -= 90 : r += 90 : r > 90 && r < 270 && (r += 180) : r = 0, i.angle = r;
          }
        }
        return i;
      }
    }, {
      key: "F8",
      value: function F8(e, t) {
        var i,
          a = this,
          n = _get(_getPrototypeOf(A9H.prototype), "F8", this).call(this, e, t);
        if (e) return n;
        if (a.AN && n.AN && null !== ZC._n_(n.AO) && "" !== n.AO) {
          var l = "out";
          if (null !== ZC._n_(i = n.o[ZC._[7]]) && (l = i), "out" === l) {
            var r = !0;
            if (null !== ZC._n_(i = n.o.connected) && (r = ZC._b_(i)), r) {
              var o = new DW(a.A);
              o.Z = o.C7 = a.A.CN("bl", 0), o.append(a.A.C3.o), o.K = a.K + "-connector", o.B7 = a.A0, o.DQ = "line", o.D = [];
              var s = n.E.positioninfo,
                C = (a.B4 + a.BK) / 2 % 360,
                A = ZC.AR.BN(a.iX, a.iY, a.AI + a.DS, C);
              A[0] += a.BM, A[1] += a.BH, o.D.push(A);
              var Z = ZC.AR.BN(a.iX, a.iY, a.AI + a.DS + 10, C);
              Z[0] += a.BM, Z[1] += a.BH, n.iX >= a.iX ? "vml" === a.H.AA ? o.D.push([s[0], s[1] + n.F / 2]) : o.D.push([Z[0], Z[1], s[0], s[1] + n.F / 2]) : "vml" === a.H.AA ? o.D.push([s[0] + n.I + 2, s[1] + n.F / 2]) : o.D.push([Z[0], Z[1], s[0] + n.I + 2, s[1] + n.F / 2]), o.parse(), o.IV = function (e) {
                return a.IV(e);
              }, o.DB() && o.parse(), o.AN && o.paint();
            }
          }
        }
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        if (_get(_getPrototypeOf(A9H.prototype), "paint", this).call(this), !(t.AD < 0)) {
          var i = t.C.BJ(t.A.BT("k")[0]);
          t.setup();
          var a = "pie-sel-" + t.A.L + "-" + t.L;
          if (t.o.detached && typeof t.C.E[a] === ZC._[31] && (t.C.E[a] = !0), t.AI = ZC.CX(i.GG, i.GM) / 2, null !== ZC._n_(t.A.o[ZC._[21]])) {
            var n = ZC.IU(t.A.o[ZC._[21]], !1);
            t.AI = n <= 1 ? t.AI * n : n;
          } else t.AI = i.JV * t.AI;
          t.CM <= 1 && (t.CM *= t.AI), t.CM = Math.max(0, t.CM), t.o[ZC._[8]] = t.CM, t.DS <= 1 && (t.DS *= t.AI), t.o["offset-r"] = t.DS, t.C.E[a] && (t.DS += ZC._i_(.15 * t.AI));
          var l = t.N = t.A.I5(t, t);
          if (t.GN(l), t.AD >= 0 || 0 === t.A.A.KU[t.L]) {
            var r = new DW(t.A);
            r.K = t.K, r.Z = t.A.CN("bl", 1), r.C7 = t.A.CN("bl", 0), r.copy(l);
            var o = t.iX,
              s = t.iY;
            t.DS > 0 && (o = (e = ZC.AR.BN(t.iX, t.iY, t.DS, (t.B4 + t.BK) / 2))[0], s = e[1]), r.iX = o, r.iY = s, r.AI = t.AI, r.o[ZC._[21]] = t.AI, r.DQ = "pie", r.B4 = ZC._f_(t.B4), r.BK = ZC._f_(t.BK), r.CM = t.CM, r.E.plotidx = t.A.L, r.E.nodeidx = t.L, r.parse(), t.G7 = r;
            var C = function C() {
              if (!t.A.KE && t.AN) {
                var e = r.F1(),
                  i = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6],
                  a = ZC.Q.G2("poly", t.A.E8, t.A.J3) + 'class="' + i + '" ' + t.a11y() + ' id="' + t.K + ZC._[30] + e + '" />';
                t.A.A.HK.push(a);
              }
              t.A.U && t.F8();
            };
            if (t.AN) if (t.A.GI && !t.C.HO) {
              var A = r,
                Z = {};
              A.iX = o, A.iY = s, A.B4 = t.B4, A.BK = t.BK, Z.angleStart = t.B4, Z.angleEnd = t.BK, Z.x = o, Z.y = s;
              var c,
                p = t.A.LL;
              for (c in A.C6 = 0, Z.alpha = l.C6, 2 === p ? (A.BK = t.B4, Z.angleEnd = t.BK) : 3 === p ? (A.AI = t.CM, Z.size = t.AI) : 4 === p ? (e = ZC.AR.BN(t.iX, t.iY, 1.2 * t.AI, (t.B4 + t.BK) / 2), A.iX = e[0], A.iY = e[1], Z.x = o, Z.y = s) : 5 === p && (A.B4 = A.BK = (t.B4 + t.BK) / 2, Z.angleStart = t.B4, Z.angleEnd = t.BK), t.A.FW) A[EB.GP[ZC.EE(c)]] = t.A.FW[c], Z[ZC.EE(c)] = l[EB.GP[ZC.EE(c)]];
              if (null === ZC._n_(t.C.EM) && (t.C.EM = {}), null !== ZC._n_(t.C.EM[t.A.L + "-" + t.L])) for (c in t.C.EM[t.A.L + "-" + t.L]) A[EB.GP[ZC.EE(c)]] = t.C.EM[t.A.L + "-" + t.L][c];
              t.C.EM[t.A.L + "-" + t.L] = {}, ZC._cp_(Z, t.C.EM[t.A.L + "-" + t.L]);
              var u = new EB(A, Z, t.A.JL, t.A.LE, EB.RW[t.A.LI], function () {
                C();
              });
              u.AX = t, t.L9(u);
            } else r.paint(), C();
          } else t.A.U && t.F8();
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || t.LN({
          layer: e,
          type: "shape",
          initcb: function initcb() {
            if (this.copy(t), this.iX = t.iX, this.iY = t.iY, t.DS > 0) {
              var e = ZC.AR.BN(t.iX, t.iY, t.DS, (t.B4 + t.BK) / 2);
              this.iX = e[0], this.iY = e[1];
            }
            this.AI = t.AI, this.DQ = "pie", this.A0 = t.A.BP[3], this.AE = t.A.BP[2], this.B4 = ZC._f_(t.B4), this.BK = ZC._f_(t.BK), this.CM = t.CM;
          },
          parsecb: function parsecb() {
            this.o[ZC._[21]] = t.AI, this.o[ZC._[8]] = t.CM, this.o["offset-r"] = t.DS;
          }
        });
      }
    }, {
      key: "P1",
      value: function P1(e, t) {
        var i = this;
        if (_get(_getPrototypeOf(A9H.prototype), "P1", this).call(this, e, t), "click" === t && e.which <= 1 && i.A.A8C) {
          zingchart.SKIP.ANIMATION = !0, zingchart.SKIP.EVENT = !0;
          var a = "pie-sel-" + i.A.L + "-" + i.L;
          i.C.E[a] = typeof i.C.E[a] === ZC._[31] || !i.C.E[a], i.C.JY(), zingchart.SKIP.EVENT = !1, zingchart.SKIP.ANIMATION = !1;
        }
      }
    }]);
    return A9H;
  }(MI);
  var A4Y = /*#__PURE__*/function (_MI8) {
    _inherits(A4Y, _MI8);
    function A4Y(e) {
      var _this91;
      _classCallCheck(this, A4Y);
      _this91 = _possibleConstructorReturn(this, _getPrototypeOf(A4Y).call(this, e)), _this91.bCXY = !0;
      return _this91;
    }
    _createClass(A4Y, [{
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.C.BJ(e.A.BT("k")[0]);
        e.iX = t.iX + t.I / 2 + t.BM, e.iY = t.iY + t.F / 2 + t.BH, e.IP || (e.copy(e.A), e.o[ZC._[8]] = null, e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "A6B",
      value: function A6B() {
        var e = this,
          t = (e.B4 + e.BK) / 2 % 360,
          i = ZC.AR.BN(e.iX, e.iY, e.CM + e.E.bandwidth / 2 + e.DS, t);
        return [i[0], i[1]];
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        ZC._cp_(t, l);
        var r = 100 * n.AD / n.A.A.KU[n.L],
          o = "" + r;
        return null !== ZC._n_(l[ZC._[12]]) && (o = r.toFixed(ZC.BQ(0, ZC._i_(l[ZC._[12]])))), n.CU = [["%node-percent-value", o], ["%npv", o]], e = _get(_getPrototypeOf(A4Y.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "JC",
      value: function JC(e) {
        var t = {},
          i = "in";
        return null !== ZC._n_(e.o[ZC._[7]]) && (i = e.o[ZC._[7]]), t.color = "out" === i ? this.A0 : this.C2, t;
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this,
          i = "in";
        null !== ZC._n_(e.o[ZC._[7]]) && (i = e.o[ZC._[7]]);
        var a,
          n,
          l,
          r = e.I,
          o = e.F,
          s = (t.B4 + t.BK) / 2 % 360;
        return "out" === i ? t.L === t.A.S.length - 1 ? (l = ZC.AR.BN(t.iX, t.iY, t.A.UK + t.A.S.length * (t.E.bandwidth + t.E.bandspace) + 15 + e.DS, s), a = s >= 0 && s < 90 || s >= 270 && s < 360 ? l[0] + 10 + t.BM : l[0] - r - 10 + t.BM, n = l[1] - o / 2 + t.BH) : (a = -1, n = -1) : (a = (l = ZC.AR.BN(t.iX, t.iY, t.CM + t.E.bandwidth / 2 + e.DS, s))[0] - r / 2 + t.BM, n = l[1] - o / 2 + t.BH), null !== ZC._n_(e.o.x) && (a = e.iX), null !== ZC._n_(e.o.y) && (n = e.iY), [ZC._i_(a), ZC._i_(n), s];
      }
    }, {
      key: "F8",
      value: function F8(e) {
        var t = this,
          i = _get(_getPrototypeOf(A4Y.prototype), "F8", this).call(this, e);
        if (e) return i;
        if (i.AN && null !== ZC._n_(i.AO) && "" !== i.AO) {
          var a = "in";
          if (null !== ZC._n_(i.o[ZC._[7]]) && (a = i.o[ZC._[7]]), "out" === a && t.L === t.A.S.length - 1) {
            var n = new DW(t.A);
            n.Z = n.C7 = t.H.usc() ? t.H.mc("top") : t.C.AJ["3d"] || t.H.KE ? ZC.AK(t.C.K + "-plots-vb-c") : ZC.AK(t.C.K + "-plot-" + t.A.L + "-vb-c"), n.append(t.A.C3.o), n.B7 = t.A0, n.DQ = "line", n.D = [];
            var l = (t.B4 + t.BK) / 2 % 360,
              r = ZC.AR.BN(t.iX, t.iY, t.CM + t.E.bandwidth + i.DS, l),
              o = ZC.AR.BN(t.iX, t.iY, t.A.UK + t.A.S.length * (t.E.bandwidth + t.E.bandspace) + 15 + i.DS, l);
            r[0] += t.BM, o[0] += t.BM, r[1] += t.BH, o[1] += t.BH, n.D.push(r), l >= 0 && l < 90 || l >= 270 && l < 360 ? n.D.push([o[0], o[1], o[0] + 10, o[1]]) : n.D.push([o[0], o[1], o[0] - 10, o[1]]), n.parse(), n.IV = function (e) {
              return t.IV(e);
            }, n.DB() && n.parse(), n.AN && n.paint();
          }
        }
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        _get(_getPrototypeOf(A4Y.prototype), "paint", this).call(this);
        var i = t.C.BJ(t.A.BT("k")[0]);
        t.setup(), t.AI = ZC.CX(i.I, i.F) / 2, t.AI = i.JV * t.AI, t.CM = t.A.UK, t.CM < 1 && (t.CM = t.A.UK * t.AI);
        var a = t.A.SW;
        a < 1 && (a = t.A.SW * t.AI);
        var n = 2,
          l = t.AI - t.CM;
        if (null !== ZC._n_(t.A.aBandWidths) && null !== ZC._n_(t.A.aBandWidths[t.L])) {
          (n = ZC._f_(t.A.aBandWidths[t.L])) > 1 && (n /= 100), n = ZC._i_(l * n), n = ZC.BQ(n, 2);
          for (var r = 0, o = 0; o < t.L; o++) r += ZC._f_(t.A.aBandWidths[o]);
          r > 1 && (r /= 100), r = ZC._i_(l * r), t.CM += r, t.AI = t.CM + n;
        } else n = (l - (t.A.S.length - 1) * a) / t.A.S.length, n = ZC.BQ(n, 2), t.CM += t.L * (n + a), t.AI = t.CM + n;
        var s = t.N = t.A.I5(t, t);
        t.GN(s);
        var C = new DW(t.A);
        C.K = t.K, C.Z = t.A.CN("bl", 1), C.C7 = t.A.CN("bl", 0), C.copy(s), C.iX = t.iX, C.iY = t.iY, C.DQ = "pie", C.B4 = t.B4, C.BK = t.BK, C.CM = t.CM, C.AI = t.AI, C.parse();
        var A = C.CM;
        function Z() {
          var e = C.F1(),
            i = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6],
            a = ZC.Q.G2("poly", t.A.E8, t.A.J3) + 'class="' + i + '" ' + t.a11y() + ' id="' + t.K + ZC._[30] + e + '" />';
          t.A.A.HK.push(a), t.A.U && t.A.U.AN && t.F8();
        }
        if (t.E.bandwidth = n, t.E.bandspace = a, t.A.GI && !t.C.HO) {
          var c = C,
            p = {};
          c.B4 = t.B4, c.BK = t.BK, p.angleStart = t.B4, p.angleEnd = t.BK;
          var u = t.A.LL;
          if (c.C6 = 0, p.alpha = s.C6, 2 === u) c.BK = t.B4, p.angleEnd = t.BK;else if (3 === u) c.CM = A + t.E.bandwidth, p.slice = A;else if (4 === u) {
            var h = ZC.AR.BN(t.iX, t.iY, t.AI, (t.B4 + t.BK) / 2);
            c.iX = h[0], c.iY = h[1], p.x = t.iX, p.y = t.iY;
          } else 5 === u && (c.B4 = c.BK = (t.B4 + t.BK) / 2, p.angleStart = t.B4, p.angleEnd = t.BK);
          for (e in t.A.FW) c[EB.GP[ZC.EE(e)]] = t.A.FW[e], p[ZC.EE(e)] = s[EB.GP[ZC.EE(e)]];
          if (t.C.EM || (t.C.EM = {}), null !== ZC._n_(t.C.EM[t.A.L + "-" + t.L])) for (e in t.C.EM[t.A.L + "-" + t.L]) c[EB.GP[ZC.EE(e)]] = t.C.EM[t.A.L + "-" + t.L][e];
          t.C.EM[t.A.L + "-" + t.L] = {}, ZC._cp_(p, t.C.EM[t.A.L + "-" + t.L]);
          var _ = new EB(c, p, t.A.JL, t.A.LE, EB.RW[t.A.LI], function () {
            Z();
          });
          _.AX = t, t.L9(_);
        } else C.paint(), Z();
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || t.LN({
          layer: e,
          type: "shape",
          initcb: function initcb() {
            this.copy(t), this.iX = t.iX, this.iY = t.iY, this.DQ = "pie", this.A0 = t.A.BP[3], this.AE = t.A.BP[2], this.B4 = t.B4, this.BK = t.BK, this.CM = t.CM, this.AI = t.AI;
          },
          parsecb: function parsecb() {
            this.o[ZC._[8]] = null;
          }
        });
      }
    }]);
    return A4Y;
  }(MI);
  var A7R = /*#__PURE__*/function (_MI9) {
    _inherits(A7R, _MI9);
    function A7R(e) {
      var _this92;
      _classCallCheck(this, A7R);
      _this92 = _possibleConstructorReturn(this, _getPrototypeOf(A7R).call(this, e));
      var t = _assertThisInitialized(_this92);
      t.CE = null, t.CK = null, t.MZ = "max";
      return _this92;
    }
    _createClass(A7R, [{
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this;
        return "range" === n.A.CV && (n.CU = [["%node-min-value", n.CE], ["%node-max-value", n.CK]]), e = _get(_getPrototypeOf(A7R.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "HE",
      value: function HE() {
        var e = this;
        if ("range" === e.A.CV && e.o[ZC._[9]] instanceof Array) {
          var t = e.o[ZC._[9]].length;
          t > 2 && (e.BU = ZC._f_(e.o[ZC._[9]][0])), e.CE = ZC._f_(e.o[ZC._[9]][t - 2]), e.CK = ZC._f_(e.o[ZC._[9]][t - 1]), e.AD = e.CR = e.CK, e.DN.push(e.CE);
        } else _get(_getPrototypeOf(A7R.prototype), "HE", this).call(this);
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        if (e.JT !== a) {
          var n;
          n = "range" === e.A.CV ? i.ST("min" === e.MZ ? e.CE : e.CK) : i.ST(e.CR);
          var l = null !== ZC._n_(e.BU),
            r = t.A4M(l ? e.BU : e.L, n, l);
          e.iX = r[0], e.iY = r[1], e.JT = a;
        }
        e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = i.A.B1,
          n = i.A.CL,
          l = i.C.BJ("scale"),
          r = l.iX + l.I / 2,
          o = l.iY + l.F / 2,
          s = e.I,
          C = e.F,
          A = "out";
        null !== ZC._n_(e.o[ZC._[7]]) && (A = e.o[ZC._[7]]);
        var Z = 1.15;
        switch (A) {
          case "out":
            Z = 1.15;
            break;
          case "over":
            Z = 1;
            break;
          case "in":
            Z = .85;
            break;
          case "middle":
            Z = .5;
        }
        var c,
          p,
          u = a.EI / (a.V.length - (360 === a.EI || a.DI ? 0 : 1)),
          h = n.ST(i.CR);
        switch (i.A.CV) {
          case "matrix":
          case "piano":
            var _ = (ZC.CX(l.I / 2, l.F / 2) * l.JV - n.AB) / i.A.A.A4.length;
            c = n.AB + i.A.L * _, p = n.AB + (i.A.L + 1) * _, t = ZC.AR.BN(r, o, (c + p) / 2 * Z + e.DS, a.DF + (a.DI ? u / 2 : 0) + i.L * u);
            break;
          default:
            if (null !== ZC._n_(i.BU)) {
              var d = a.DF + a.EI * (i.BU - a.B3) / (a.BL - a.B3);
              t = ZC.AR.BN(r, o, n.AB + h * Z + e.DS, d);
            } else t = ZC.AR.BN(r, o, n.AB + h * Z + e.DS, a.DF + (a.DI ? u / 2 : 0) + i.L * u);
        }
        return t[0] -= s / 2, t[1] -= C / 2, null !== ZC._n_(e.o.x) && (t[0] = e.iX), null !== ZC._n_(e.o.y) && (t[1] = e.iY), [ZC._i_(t[0]), ZC._i_(t[1])];
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: "rose" === this.A.CV ? this.A0 : this.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": "rose" === this.A.CV ? this.A0 : this.B7,
          "border-color": "rose" === this.A.CV ? this.A0 : this.B7,
          color: this.C2
        };
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i = this;
        _get(_getPrototypeOf(A7R.prototype), "paint", this).call(this);
        var a,
          n,
          l = i.A.QQ,
          r = i.A.A50,
          o = i.A.B1,
          s = i.A.CL,
          C = i.A.S;
        i.setup(), i.CY = !1, i.C7 = i.A.CN("bl", 0);
        var A,
          Z = [],
          c = [],
          p = [],
          u = [],
          h = "range" === i.A.CV;
        function _() {
          if (i.A.S8 >= i.A.S.length && i.A.YN) {
            var e = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6],
              t = "",
              n = "";
            -1 !== ZC.AV(["line", "area", "range"], i.A.CV) ? "" !== (n = "range" !== i.A.CV || i.A.Y0 ? ZC.AR.Q8(ZC.AR.ZJ(i.E.points), 4) : ZC.AR.Q8(c, 4)) && (t = ZC.Q.G2("poly", i.A.E8, i.A.J3) + 'class="' + e + '" ' + i.a11y() + ' id="' + i.K + ZC._[30] + n + '" />') : -1 !== ZC.AV(["rose", "column", "bar", "matrix", "piano"], i.A.CV) && (n = a.F1(), t = ZC.Q.G2("poly", i.A.E8, i.A.J3) + 'class="' + e + '" ' + i.a11y() + ' id="' + i.K + ZC._[30] + n + '" data-z-sort="' + (i.A.A.A4.length - i.A.L) + '" />'), i.A.A.HK.push(t);
          }
          i.A.U && i.A.E.vboxid !== i.K && i.F8();
        }
        var d,
          f,
          g,
          B,
          v,
          m = i.N = i.A.I5(i, i);
        if (i.A.I1 && i.GN(m), -1 !== ZC.AV(["line", "area", "range"], i.A.CV)) {
          Z = [], c = [], p = [], u = [];
          var b = i.iX,
            E = i.iY,
            K = i.iX,
            D = i.iY;
          h && (i.MZ = "max", i.setup(), b = i.iX, E = i.iY, i.MZ = "min", i.setup(), K = i.iX, D = i.iY), i.A.IA && (i.A.D.push([b, E]), i.A.AH.push([b, E])), i.L > 0 ? (A = C[i.L - 1]) && (A.MZ = "max", A.setup(), n = ZC.AR.JZ(A.iX, A.iY, b, E), Z.push(n), c.push(n), h && (A.MZ = "min", A.setup(), n = ZC.AR.JZ(A.iX, A.iY, K, D), p.push(n), u.push(n))) : (A = C[i.A.S.length - 1]) && (A.MZ = "max", A.setup(), n = ZC.AR.JZ(A.iX, A.iY, b, E), Z.push(n), c.push(n), h && (A.MZ = "min", A.setup(), n = ZC.AR.JZ(A.iX, A.iY, K, D), p.push(n), u.push(n))), Z.push([b, E]), c.push([b, E]), h && (p.push([K, D]), u.push([K, D])), i.L < i.A.S.length - 1 ? (A = C[i.L + 1]) && (A.MZ = "max", A.setup(), n = ZC.AR.JZ(b, E, A.iX, A.iY), Z.push(n), c.push(n), h && (A.MZ = "min", A.setup(), n = ZC.AR.JZ(K, D, A.iX, A.iY), p.push(n), u.push(n))) : (A = C[0]) && (A.MZ = "max", A.setup(), n = ZC.AR.JZ(b, E, A.iX, A.iY), Z.push(n), c.push(n), h && (A.MZ = "min", A.setup(), n = ZC.AR.JZ(K, D, A.iX, A.iY), p.push(n), u.push(n))), ZC.CQ.setup(l, m);
        }
        h && (Z.push(null), Z = Z.concat(p.reverse()), c = c.concat(u.reverse()));
        var F,
          I,
          x,
          y,
          X,
          Y,
          w,
          L,
          M,
          H,
          G,
          P = i.C.P;
        if (d = i.C.BJ("scale"), "area" !== i.A.CV && "range" !== i.A.CV || (f = d.iX + d.I / 2, g = d.iY + d.F / 2, B = 360 / o.V.length, "area" === i.A.CV && c.push([f, g]), i.A.IA || ((v = new DW(i.A)).K = i.K + "-area", v.Z = i.A.CN("bl", 0), v.copy(m), v.LD = !0, v.D = c, v.parse(), v.C6 = i.A.I6, 1 === v.C6 && 0 === v.AU && (v.A0 = ZC.AQ.R2(ZC.AQ.GE(v.A0), 20), v.AE = ZC.AQ.R2(ZC.AQ.GE(v.AE), 20), v.AU = 2, v.BW = v.A0), v.D0 = [P.iX, P.iY, P.iX + P.I, P.iY + P.F], ZC.CQ.setup(r, v))), i.E.points = Z, i.E.pointsarea = c, i.setNodeData({
          points: Z,
          pointsarea: c
        }), i.A.IA && i.L === o.A1 && ("area" === i.A.CV && ((v = new DW(i.A)).K = i.K + "-area", v.Z = i.A.CN("bl", 0), v.copy(i.A), v.LD = !0, v.D = i.A.AH, v.parse(), v.C6 = i.A.I6, v.D0 = [P.iX, P.iY, P.iX + P.I, P.iY + P.F], v.paint()), "line" !== i.A.CV && "area" !== i.A.CV && "range" !== i.A.CV || (i.A.D[0] && i.A.D.push([i.A.D[0][0], i.A.D[0][1]]), ZC.CQ.paint(l, m, i.A.D))), -1 !== ZC.AV(["dots", "scatter", "area", "line"], i.A.CV)) i.OT(!1, !0);else if (-1 !== ZC.AV(["rose", "column", "bar", "piano", "matrix"], i.A.CV)) {
          (a = new DW(i.A)).K = i.K + "-pie", a.copy(m), a.Z = i.A.CN("bl", 1), a.C7 = i.A.CN("bl", 0), f = (d = i.C.BJ("scale")).iX + d.I / 2, g = d.iY + d.F / 2;
          var N = .1 * (B = o.EI / (o.V.length - (360 === o.EI || o.DI ? 0 : 1)));
          i.A.CB || (N = .1 * B + .4 * B * i.A.L / i.A.A.A4.length), null !== ZC._n_(e = i.A.A6Q) && (N = e < 1 ? B * e : e), Y = s.AB;
          var O = i.A.A;
          i.A.CB && null !== ZC._n_(O.A2Q["stack" + i.L]) && (Y += O.A2Q["stack" + i.L]);
          var S = ZC._i_(s.ST(i.CR));
          if (i.A.CB && (O.A2Q["stack" + i.L] = S), null === ZC._n_(i.BU)) x = o.DF + i.L * B - B / 2 + N + (o.DI ? B / 2 : 0), y = o.DF + (i.L + 1) * B - B / 2 - N + (o.DI ? B / 2 : 0);else {
            var Q = o.DF + o.EI * (i.BU - o.B3) / (o.BL - o.B3);
            x = Q - B / 2 + N, y = Q + B / 2 - N;
          }
          if (X = S + s.AB, "piano" === i.A.CV || "matrix" === i.A.CV) {
            var k = (ZC.CX(d.I / 2, d.F / 2) * d.JV - s.AB) / i.A.A.A4.length;
            X = s.AB + i.A.L * k, Y = s.AB + (i.A.L + 1) * k;
          }
          i.setNodeData({
            x: f,
            y: g,
            sz: X,
            sl: Y,
            as: x,
            ae: y
          }), a.iX = f, a.iY = g, a.DQ = "pie", a.B4 = x, a.BK = y, a.AI = X, a.CM = Y, a.parse(), a.IV = function (e) {
            return i.IV(e);
          }, a.DB() && a.parse();
        }
        if (i.A.GI && -1 !== ZC.AV(["line", "area", "rose", "column", "bar", "matrix", "piano"], i.A.CV)) {
          switch (i.A.CV) {
            case "line":
            case "area":
              I = {}, (F = new DW(i)).copy(m), F.K = i.K, F.Z = i.A.CN("bl", 1), F.C7 = i.A.CN("bl", 0), F.D = Z, F.C6 = 0, I.alpha = m.C6, I.points = Z;
              var T = [];
              "area" === i.A.CV && (M = {}, w = [], (L = v).D = c, L.C6 = 0, M.points = c, M.alpha = i.A.I6);
              break;
            case "rose":
            case "column":
            case "bar":
            case "matrix":
            case "piano":
              I = {}, (F = a).iX = f, F.iY = g, F.B4 = x, F.BK = y, F.C6 = 0, I.angleStart = x, I.angleEnd = y, I.x = f, I.y = g, I.size = X, I.alpha = m.C6;
          }
          var z,
            V = i.A.LL,
            R = i.C.P;
          switch (V) {
            case 1:
              break;
            case 7:
              switch (i.A.CV) {
                case "line":
                case "area":
                  for (t = 0; t < Z.length; t++) T[t] = [Z[t][0], R.iY + R.F / 2];
                  if (F.D = T, I.points = Z, "area" === i.A.CV) {
                    for (t = 0; t < c.length; t++) w[t] = [c[t][0], R.iY + R.F / 2];
                    L.D = w, M.points = c;
                  }
              }
              break;
            case 2:
              switch (i.A.CV) {
                case "line":
                case "area":
                  for (t = 0; t < Z.length; t++) T[t] = [R.iX + R.I / 2, Z[t][1]];
                  if (F.D = T, I.points = Z, "area" === i.A.CV) {
                    for (t = 0; t < c.length; t++) w[t] = [R.iX + R.I / 2, c[t][1]];
                    L.D = w, M.points = c;
                  }
                  break;
                case "rose":
                case "column":
                case "bar":
                case "matrix":
                case "piano":
                  F.BK = x, I.angleEnd = y;
              }
              break;
            case 3:
              switch (i.A.CV) {
                case "line":
                case "area":
                  for (t = 0; t < Z.length; t++) T[t] = [R.iX + R.I / 2, R.iY + R.F / 2];
                  if (F.D = T, I.points = Z, "area" === i.A.CV) {
                    for (t = 0; t < c.length; t++) w[t] = [R.iX + R.I / 2, R.iY + R.F / 2];
                    L.D = w, M.points = c;
                  }
                  break;
                case "rose":
                case "column":
                case "bar":
                case "matrix":
                case "piano":
                  F.AI = s.AB, I.size = X;
              }
              break;
            case 4:
              switch (i.A.CV) {
                case "line":
                case "area":
                  for (t = 0; t < Z.length; t++) H = R.iX + R.I / 2 - Z[t][0], G = R.iY + R.F / 2 - Z[t][1], T[t] = [R.iX + R.I / 2 - 2.5 * H, R.iY + R.F / 2 - 2.5 * G];
                  if (F.D = T, I.points = Z, "area" === i.A.CV) {
                    for (t = 0; t < c.length; t++) H = R.iX + R.I / 2 - c[t][0], G = R.iY + R.F / 2 - c[t][1], w[t] = [R.iX + R.I / 2 - 2.5 * H, R.iY + R.F / 2 - 2.5 * G];
                    L.D = w, M.points = c;
                  }
                  break;
                case "rose":
                case "column":
                case "bar":
                case "matrix":
                case "piano":
                  F.AI = 2 * X, I.size = X;
              }
              break;
            case 5:
              switch (i.A.CV) {
                case "rose":
                case "column":
                case "bar":
                case "matrix":
                case "piano":
                  F.B4 = F.BK = (x + y) / 2, I.angleStart = x, I.angleEnd = y;
              }
          }
          for (z in i.A.FW) F[EB.GP[ZC.EE(z)]] = i.A.FW[z], I[ZC.EE(z)] = m[EB.GP[ZC.EE(z)]];
          if (null === ZC._n_(i.C.EM) && (i.C.EM = {}, "area" === i.A.CV && (i.C.T3 = {})), null !== ZC._n_(i.C.EM[i.A.L + "-" + i.L])) {
            for (z in i.C.EM[i.A.L + "-" + i.L]) F[EB.GP[ZC.EE(z)]] = i.C.EM[i.A.L + "-" + i.L][z];
            if ("area" === i.A.CV) for (z in i.C.T3[i.A.L + "-" + i.L]) L[EB.GP[ZC.EE(z)]] = i.C.T3[i.A.L + "-" + i.L][z];
          }
          i.C.EM[i.A.L + "-" + i.L] = {}, ZC._cp_(I, i.C.EM[i.A.L + "-" + i.L]), "area" === i.A.CV && (i.C.T3[i.A.L + "-" + i.L] = {}, ZC._cp_(M, i.C.T3[i.A.L + "-" + i.L]));
          var J = new EB(F, I, i.A.JL, i.A.LE, EB.RW[i.A.LI], function () {
            _();
          });
          J.AX = i, -1 !== ZC.AV(["line", "area"], i.A.CV) && (J.IR = l);
          var W = null;
          "area" === i.A.CV && ((W = new EB(L, M, i.A.JL, i.A.LE, EB.RW[i.A.LI], function () {})).AX = i), i.L9(J, W);
        } else {
          switch (i.A.CV) {
            case "line":
            case "area":
            case "range":
              i.A.IA || (ZC.CQ.paint(l, m, Z), "area" !== i.A.CV && "range" !== i.A.CV || v.paint());
              break;
            case "rose":
            case "column":
            case "bar":
            case "matrix":
            case "piano":
              a.paint();
          }
          _();
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || (t.A.IK && t.A.AN && (-1 !== ZC.AV(["line", "area", "range"], t.A.CV) ? (t.YJ(e), "area" !== t.A.CV && "range" !== t.A.CV || t.LN({
          layer: e,
          type: "area",
          initcb: function initcb() {
            this.D = t.E.pointsarea;
          },
          setupcb: function setupcb() {
            this.AZ = 0, this.AU = 0, this.C6 = t.A.I6;
            var e = t.C.P;
            this.D0 = [e.iX, e.iY, e.iX + e.I, e.iY + e.F];
          }
        })) : -1 !== ZC.AV(["rose", "column", "bar", "matrix", "piano"], t.A.CV) && t.LN({
          layer: e,
          type: "shape",
          initcb: function initcb() {
            this.copy(t), this.B7 = t.A.BP[1], this.BW = t.A.BP[1], this.A0 = t.A.BP[3], this.AE = t.A.BP[2], this.iX = t.getNodeData("x"), this.iY = t.getNodeData("y"), this.CM = t.getNodeData("sl"), this.B4 = t.getNodeData("as"), this.BK = t.getNodeData("ae"), this.DQ = "pie", this.AI = t.getNodeData("sz");
          }
        })), -1 !== ZC.AV(["dots", "scatter", "line"], t.A.CV) && t.SB(e));
      }
    }]);
    return A7R;
  }(MI);
  var A6I = /*#__PURE__*/function (_ZU) {
    _inherits(A6I, _ZU);
    function A6I(e) {
      var _this93;
      _classCallCheck(this, A6I);
      _this93 = _possibleConstructorReturn(this, _getPrototypeOf(A6I).call(this, e)), _this93.FL = null;
      return _this93;
    }
    _createClass(A6I, [{
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        ZC._cp_(t, l);
        var r = ZC.AQ.G5(n.A.QB[n.L], l);
        return n.CU = [["%node-goal-value", r], ["%g", r]], e = _get(_getPrototypeOf(A6I.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this;
        return "goal" === ZC._n_(e.o[ZC._[7]]) ? [t.FL.iX + t.FL.I / 2 - e.I / 2, t.FL.iY - e.F] : _get(_getPrototypeOf(A6I.prototype), "HG", this).call(this, e);
      }
    }, {
      key: "HE",
      value: function HE() {
        var e,
          t = this;
        if (t.DN = [], t.CI = t.o[ZC._[9]], "string" == typeof t.o[ZC._[9]]) {
          var i = ZC.AV(t.A.CL.JQ, t.o[ZC._[9]]);
          -1 !== i ? t.AD = i : (t.A.CL.JQ.push(t.o[ZC._[9]]), t.AD = t.A.CL.JQ.length - 1);
        } else t.AD = ZC._f_(t.o[ZC._[9]]);
        t.A.o.goals && null !== ZC._n_(e = t.A.o.goals[t.L]) && t.DN.push(ZC._f_(e));
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(A6I.prototype), "paint", this).call(this);
      }
    }, {
      key: "paint_",
      value: function paint_() {
        var e,
          t,
          i = this;
        if (null !== ZC._n_(i.A.QB[i.L]) && i.AN) {
          var a = i.A.CL.AM(i.A.QB[i.L]);
          i.FL = new I3(i.A), i.FL.K = i.K + "-goal", i.FL.copy(i.A.FL), i.FL.Z = i.A.CN("fl", 0), i.FL.C7 = i.A.CN("fl", 0), i.FL.IV = function (e) {
            return i.IV(e);
          }, i.FL.DB() && i.FL.parse(), null !== ZC._n_(e = i.FL.o) && null !== ZC._n_(e.styles) && null !== ZC._n_(t = e.styles[i.L]) && ("string" == typeof t ? i.FL.append({
            "background-color": t
          }) : i.FL.append(t), i.FL.parse());
          var n = .2;
          if (null !== ZC._n_(e = i.FL.o.extension) && (n = ZC._f_(e)), i.FL.iX = i.getNodeData("x") - i.I * n, i.FL.I = i.I * (1 + 2 * n), null === ZC._n_(i.A.FL.o[ZC._[20]]) && (i.FL.F = ZC.CX(5, i.C.P.F / 30)), i.FL.iY = a - i.FL.F / 2, i.FL.AN) {
            i.FL.paint();
            var l = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6];
            i.A.A.HK.push(ZC.Q.G2("rect", i.A.E8, i.A.J3) + 'class="' + l + '" id="' + i.K + "--goal" + ZC._[30] + ZC._i_(i.FL.iX + i.A.BM + ZC.MAPTX) + "," + ZC._i_(i.FL.iY + i.A.BH + ZC.MAPTX) + "," + ZC._i_(i.FL.iX + i.A.BM + i.FL.I + ZC.MAPTX) + "," + ZC._i_(i.FL.iY + i.A.BH + i.FL.F + ZC.MAPTX) + '" />');
          }
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        if (!ZC.move && (_get(_getPrototypeOf(A6I.prototype), "HT", this).call(this, e), t.FL && t.FL.AN)) {
          var i = new I3(t.A);
          i.copy(t.FL), i.Z = ZC.AK(t.C.K + ZC._[22]), i.MH = !1, i.iX = t.FL.iX, i.iY = t.FL.iY, i.paint();
        }
      }
    }]);
    return A6I;
  }(ZU);
  var A6K = /*#__PURE__*/function (_A8) {
    _inherits(A6K, _A8);
    function A6K(e) {
      var _this94;
      _classCallCheck(this, A6K);
      _this94 = _possibleConstructorReturn(this, _getPrototypeOf(A6K).call(this, e)), _this94.FL = null;
      return _this94;
    }
    _createClass(A6K, [{
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        ZC._cp_(t, l);
        var r = ZC.AQ.G5(n.A.QB[n.L], l);
        return n.CU = [["%node-goal-value", r], ["%g", r]], e = _get(_getPrototypeOf(A6K.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this;
        return "goal" === ZC._n_(e.o[ZC._[7]]) ? [t.FL.iX + t.FL.I, t.FL.iY + t.FL.F / 2 - e.F / 2] : _get(_getPrototypeOf(A6K.prototype), "HG", this).call(this, e);
      }
    }, {
      key: "HE",
      value: function HE() {
        var e,
          t = this;
        if (t.DN = [], t.CI = t.o[ZC._[9]], "string" == typeof t.o[ZC._[9]]) {
          var i = ZC.AV(t.A.CL.JQ, t.o[ZC._[9]]);
          -1 !== i ? t.AD = i : (t.A.CL.JQ.push(t.o[ZC._[9]]), t.AD = t.A.CL.JQ.length - 1);
        } else t.AD = ZC._f_(t.o[ZC._[9]]);
        t.A.o.goals && null !== ZC._n_(e = t.A.o.goals[t.L]) && t.DN.push(ZC._f_(e));
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(A6K.prototype), "paint", this).call(this);
      }
    }, {
      key: "paint_",
      value: function paint_() {
        var e,
          t,
          i = this;
        if (null !== ZC._n_(i.A.QB[i.L]) && i.AN) {
          var a = i.A.CL.AM(i.A.QB[i.L]);
          i.FL = new I3(i.A), i.FL.K = i.K + "-goal", i.FL.copy(i.A.FL), i.FL.Z = i.A.CN("fl", 0), i.FL.C7 = i.A.CN("fl", 0), i.FL.IV = function (e) {
            return i.IV(e);
          }, i.FL.DB() && i.FL.parse(), null !== ZC._n_(e = i.FL.o) && null !== ZC._n_(e.styles) && null !== ZC._n_(t = e.styles[i.L]) && ("string" == typeof t ? i.FL.append({
            "background-color": t
          }) : i.FL.append(t), i.FL.parse());
          var n = .2;
          if (null !== ZC._n_(e = i.FL.o.extension) && (n = ZC._f_(e)), i.FL.iY = i.getNodeData("y") - i.F * n, i.FL.F = i.F * (1 + 2 * n), null === ZC._n_(i.A.FL.o[ZC._[19]]) && (i.FL.I = ZC.CX(5, i.C.P.I / 30)), i.FL.iX = a - i.FL.I / 2, i.FL.AN) {
            i.FL.paint();
            var l = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6];
            i.A.A.HK.push(ZC.Q.G2("rect", i.A.E8, i.A.J3) + 'class="' + l + '" id="' + i.K + "--goal" + ZC._[30] + ZC._i_(i.FL.iX + i.A.BM + ZC.MAPTX) + "," + ZC._i_(i.FL.iY + i.A.BH + ZC.MAPTX) + "," + ZC._i_(i.FL.iX + i.A.BM + i.FL.I + ZC.MAPTX) + "," + ZC._i_(i.FL.iY + i.A.BH + i.FL.F + ZC.MAPTX) + '" />');
          }
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        if (!ZC.move && (_get(_getPrototypeOf(A6K.prototype), "HT", this).call(this, e), t.FL && t.FL.AN)) {
          var i = new I3(t.A);
          i.copy(t.FL), i.Z = ZC.AK(t.C.K + ZC._[22]), i.MH = !1, i.iX = t.FL.iX, i.iY = t.FL.iY, i.paint();
        }
      }
    }]);
    return A6K;
  }(A03);
  var A86 = /*#__PURE__*/function (_MI10) {
    _inherits(A86, _MI10);
    function A86() {
      _classCallCheck(this, A86);
      return _possibleConstructorReturn(this, _getPrototypeOf(A86).apply(this, arguments));
    }
    _createClass(A86, [{
      key: "HE",
      value: function HE() {
        var e,
          t = this;
        t.o[ZC._[9]] instanceof Array && null !== ZC._n_(t.o[ZC._[9]][1]) && (t.CI = t.o[ZC._[9]][1], "string" == typeof t.o[ZC._[9]][0] ? -1 !== (e = ZC.AV(t.A.B1.J0, t.o[ZC._[9]][0])) ? t.BU = e : (t.A.B1.J0.push(t.o[ZC._[9]][0]), t.BU = t.A.B1.J0.length - 1) : t.BU = ZC._f_(t.o[ZC._[9]][0]), "string" == typeof t.o[ZC._[9]][1] ? -1 !== (e = ZC.AV(t.A.CL.JQ, t.o[ZC._[9]][1])) ? t.AD = e : (t.A.CL.JQ.push(t.o[ZC._[9]][1]), t.AD = t.A.CL.JQ.length - 1) : t.AD = ZC._f_(t.o[ZC._[9]][1]), null !== t.BU && t.A.TA(t.BU, t.L));
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        e.JT !== a && (t.AW ? e.iX = t.iX + t.I - t.AB - (e.L - t.W + 1) * t.AC : e.iX = t.iX + t.AB + (e.L - t.W) * t.AC, i.AW ? e.iY = i.iY + i.AB + (e.A.L - i.B3) * i.AC : e.iY = i.iY + i.F - i.AB - (e.A.L - i.B3 + 1) * i.AC, e.JT = a), e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0), e.GN(e);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this,
          i = "over";
        null !== ZC._n_(e.o[ZC._[7]]) && (i = e.o[ZC._[7]]);
        var a = e.I,
          n = e.F,
          l = t.iX + t.I / 2 - a / 2,
          r = t.iY + t.F / 2 - n / 2;
        switch (i) {
          case "top":
            r -= t.F / 2 + n / 2 + 2;
            break;
          case "left":
            l -= t.I / 2 + a / 2 + 2;
            break;
          case "bottom":
            r += t.F / 2 + n / 2 + 2;
            break;
          case "right":
            l += t.I / 2 + a / 2 + 2;
        }
        return null !== ZC._n_(e.o.x) && (l = e.iX), null !== ZC._n_(e.o.y) && (r = e.iY), [ZC._i_(l), ZC._i_(r)];
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: "#000"
        };
      }
    }, {
      key: "getFormatValue",
      value: function getFormatValue() {
        return this.CI;
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n,
          l = this,
          r = l.A.CL,
          o = l.A.L;
        return n = null !== ZC._n_(r.BY[o]) ? r.BY[o] : r.V[o], l.CU = [["%y", n], ["%scale-value-label", n]], e = _get(_getPrototypeOf(A86.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "S0",
      value: function S0() {
        var e = this;
        e.setup();
        var t,
          i = e.A.B1,
          a = e.A.CL;
        switch (e.A.A85) {
          case "plot-max":
            t = (ZC._f_(e.AD) - e.A.YT) / (e.A.A5F - e.A.YT);
            break;
          case "plot-total":
            t = (ZC._f_(e.AD) - e.A.YT) / (e.A.A6T - e.A.YT);
            break;
          case "chart-max":
            t = (ZC._f_(e.AD) - e.A.X5) / (e.A.A45 - e.A.X5);
            break;
          case "chart-total":
            t = (ZC._f_(e.AD) - e.A.X5) / (e.A.A5P - e.A.X5);
        }
        switch (ZC.PL(t) || (t = .5), e.I = i.AC, e.F = a.AC, e.A.CV) {
          case "alpha":
          case "brightness":
            e.C6 = e.A.QT + t * (e.A.VD - e.A.QT);
            break;
          case "horizontal":
            e.I = 1.01 + e.A.QT * i.AC + t * i.AC * (e.A.VD - e.A.QT), i.AW && (e.iX = e.iX + i.AC - e.I);
            break;
          case "vertical":
            e.F = 1.01 + e.A.QT * a.AC + t * a.AC * (e.A.VD - e.A.QT), a.AW || (e.iY = e.iY + a.AC - e.F);
            break;
          case "size":
            e.I = 1.01 + e.A.QT * i.AC + t * i.AC * (e.A.VD - e.A.QT), e.F = 1.01 + e.A.QT * a.AC + t * a.AC * (e.A.VD - e.A.QT), e.iX += (i.AC - e.I) / 2, e.iY += (a.AC - e.F) / 2;
        }
        e.iX -= e.AU / 2, e.iY -= e.AU / 2, e.I += e.AU, e.F += e.AU;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        _get(_getPrototypeOf(A86.prototype), "paint", this).call(this), e.S0();
        var t = e.C.P;
        if (!(e.iY + 5 < t.iY || e.iY + 5 >= t.iY + t.F)) {
          if (e.AN) {
            var i = zingchart.pool.getInstance("I3", e, e.A.K + "-piano-box");
            if (i.K = e.K, i.copy(e), ("none" !== e.A.J7 || e.C.J4[e.A.L] || e.C.KP || e.A.T5 && e.A.T5[e.L]) && i.copy(e.A.I5(e, i)), i.iX = e.iX, i.iY = e.iY, i.I = e.I, i.F = e.F, i.Z = e.A.CN("bl", 1), i.C7 = e.A.CN("bl", 0), (-1 !== i.BW && i.AU > 0 || i.QF + i.OV + i.O1 + i.PK !== "" || -1 !== i.A0 || -1 !== i.AE || "" !== i.D9 || "" !== i.GV || "" !== i.HU) && (i.paint(), !i.KE)) {
              var a = e.C.K + ZC._[34] + e.C.K + ZC._[35] + e.A.L + ZC._[6];
              e.A.A.HK.push(ZC.Q.G2("rect", e.A.E8, e.A.J3) + 'class="' + a + '" ' + e.a11y() + ' id="' + e.K + ZC._[30] + ZC._i_(e.iX + ZC.MAPTX) + "," + ZC._i_(e.iY + ZC.MAPTX) + "," + ZC._i_(e.iX + e.I + ZC.MAPTX) + "," + ZC._i_(e.iY + e.F + ZC.MAPTX) + '" />');
            }
          }
          e.A.U && e.A.U.AN && e.F8();
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || t.LN({
          layer: e,
          type: "box",
          initcb: function initcb() {
            this.AE = t.A.BP[3], this.B7 = t.A.BP[1], this.BW = t.A.BP[1], this.A0 = t.A.BP[2];
          },
          setupcb: function setupcb() {
            this.iX = t.iX, this.iY = t.iY, this.I = t.I, this.F = t.F;
          }
        });
      }
    }]);
    return A86;
  }(MI);
  var A6G = /*#__PURE__*/function (_MI11) {
    _inherits(A6G, _MI11);
    function A6G() {
      _classCallCheck(this, A6G);
      return _possibleConstructorReturn(this, _getPrototypeOf(A6G).apply(this, arguments));
    }
    _createClass(A6G, [{
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        e.JT !== a && (t.AW ? e.iX = t.iX + t.I - t.AB - (e.L + 1) * t.AC : e.iX = t.iX + t.AB + e.L * t.AC, i.AW ? e.iY = i.iY + i.AB + e.A.L * i.AC : e.iY = i.iY + i.F - i.AB - (e.A.L + 1) * i.AC, e.JT = a), e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n,
          l,
          r = this,
          o = ZC._f_(r.A.A.F9["%pstack-" + r.L + "-0-sum"] || "0"),
          s = r.A.LV();
        if (ZC._cp_(t, s), r.CU = [], r.A.L > 0 && r.A.A.A4[r.A.L - 1] && r.A.A.A4[r.A.L - 1].S[r.L] ? l = "" + (n = 100 * r.AD / r.A.A.A4[r.A.L - 1].S[r.L].AD) : (n = 100, l = "100"), null !== ZC._n_(s[ZC._[12]]) && (l = n.toFixed(ZC.BQ(0, ZC._i_(s[ZC._[12]])))), r.CU.push(["%output-percent-value", l]), o > 0) {
          var C = 100 * r.AD / o,
            A = "" + C;
          null !== ZC._n_(s[ZC._[12]]) && (A = C.toFixed(ZC.BQ(0, ZC._i_(s[ZC._[12]])))), r.CU.push(["%node-percent-value", A]), r.CU.push(["%npv", A]);
        }
        return e = _get(_getPrototypeOf(A6G.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p = this;
        _get(_getPrototypeOf(A6G.prototype), "paint", this).call(this);
        var u = p.A.B1,
          h = p.A.CL;
        p.setup(), "static" === p.A.A33 ? (p.C.AY.SQ[p.L], e = p.C.AY.A8G[p.L]) : (p.C.AY.B3, e = p.C.AY.BL);
        var _ = p.A.LA;
        _ <= 1 && (_ *= u.AC);
        var d = p.A.ON;
        d <= 1 && (d *= u.AC);
        var f = p.A.M6;
        f <= 1 && (f *= u.AC);
        var g = u.AC - _ - d - f,
          B = f + g * (p.AD / e),
          v = 0;
        p.A.L + 1 < p.A.A.A4.length && p.A.A.A4[p.A.L + 1].S[p.L] && (v = p.A.A.A4[p.A.L + 1].S[p.L].AD);
        var m = f + g * (v / e);
        p.E["entry-exit"] = [B, m];
        var b = p.iX + (u.AW ? d : _) + g / 2 + f / 2;
        if (a = [], h.AW ? a.push([b - B / 2, p.iY], [b + B / 2, p.iY], [b + m / 2, p.iY + h.AC], [b - m / 2, p.iY + h.AC], [b - B / 2, p.iY]) : a.push([b - B / 2, p.iY + h.AC], [b + B / 2, p.iY + h.AC], [b + m / 2, p.iY], [b - m / 2, p.iY], [b - B / 2, p.iY + h.AC]), p.E.points = a, p.AN) {
          var E = new DW(p.A);
          E.K = p.K + "-trapeze", E.copy(p), E.D = a, E.parse(), E.Z = p.A.CN("bl", 1), E.C7 = p.A.CN("bl", 0), E.paint();
          var K = E.F1(),
            D = p.C.K + ZC._[34] + p.C.K + ZC._[35] + p.A.L + ZC._[6];
          p.A.A.HK.push(ZC.Q.G2("poly", p.A.E8, p.A.J3) + 'class="' + D + '" id="' + p.K + ZC._[30] + K + '" />');
        }
        for (t = 0, i = p.A.P8.length; t < i; t++) {
          var F = p.A.P8[t];
          F && null !== ZC._n_(F.o[ZC._[5]]) && null !== ZC._n_(F.o[ZC._[5]][p.L]) && (null === ZC._n_(F.o[ZC._[19]]) && null === ZC._n_(F.o[ZC._[20]]) || ((n = new I3(p.A)).append(F.o), n.parse()), l = 0, r = 0, null !== ZC._n_(F.o[ZC._[19]]) && (l = n.I), null !== ZC._n_(F.o[ZC._[20]]) && (r = n.F), 0 === l && (l = ZC.BQ(20, u.AC / 10)), 0 === r && (r = ZC.BQ(16, h.AC / 10)), (o = new DW(p.A)).K = p.K + "-arrow-entry", o.copy(p), o.append(F.o), o.parse(), a = [], 1 === p.A.P8.length ? C = p.iY + h.AC / 2 : (A = h.AC / (p.A.P8.length + 1), C = p.iY + A + t * A), u.AW ? (s = p.iX + u.AC + l - _ - g / 2 + (B + m) / 4 - f / 2 + 2, a.push([s, C - 2 * r / 6], [s - 2 * l / 3, C - r / 6], [s - 2 * l / 3, C - 3 * r / 6], [s - l, C], [s - 2 * l / 3, C + 3 * r / 6], [s - 2 * l / 3, C + r / 6], [s, C + 2 * r / 6], [s, C - 2 * r / 6])) : (s = p.iX + _ - l + g / 2 - (B + m) / 4 + f / 2 - 2, a.push([s, C - 2 * r / 6], [s + 2 * l / 3, C - r / 6], [s + 2 * l / 3, C - 3 * r / 6], [s + l, C], [s + 2 * l / 3, C + 3 * r / 6], [s + 2 * l / 3, C + r / 6], [s, C + 2 * r / 6], [s, C - 2 * r / 6])), o.D = a, o.parse(), o.Z = p.A.CN("bl", 1), o.C7 = p.A.CN("bl", 0), o.paint(), null !== ZC._n_(F.o[ZC._[10]]) && null !== ZC._n_(F.o[ZC._[10]][p.L]) && "" !== F.o[ZC._[10]][p.L] && (Z = F.o[ZC._[10]][p.L], (c = new DT(p.A)).K = p.K + "-entry-label-" + t, c.GO = p.K + "-entry-label " + p.A.K + "-entry-label zc-entry-label", c.copy(p), c.o.text = Z, c.append(F.o), null !== ZC._n_(F.o.label) && c.append(F.o.label), c.Z = p.A.CN("fl", 0), c.parse(), u.AW ? c.iX = s + 2 : c.iX = s - c.I - 2, c.iY = C - c.F / 2, c.paint(), c.ED()));
        }
        for (t = 0, i = p.A.WA.length; t < i; t++) {
          var I = p.A.WA[t];
          I && null !== ZC._n_(I.o[ZC._[5]]) && null !== ZC._n_(I.o[ZC._[5]][p.L]) && (null === ZC._n_(I.o[ZC._[19]]) && null === ZC._n_(I.o[ZC._[20]]) || ((n = new I3(p.A)).append(I.o), n.parse()), l = 0, r = 0, null !== ZC._n_(I.o[ZC._[19]]) && (l = n.I), null !== ZC._n_(I.o[ZC._[20]]) && (r = n.F), 0 === l && (l = ZC.BQ(20, u.AC / 10)), 0 === r && (r = ZC.BQ(16, h.AC / 10)), (o = new DW(p.A)).K = p.K + "-arrow-exit", o.copy(p), o.append(I.o), o.parse(), a = [], 1 === p.A.WA.length ? C = p.iY + h.AC / 2 : (A = h.AC / (p.A.WA.length + 1), C = p.iY + A + t * A), u.AW ? (s = p.iX + d + g / 2 - (B + m) / 4 + f / 2 - 2, a.push([s, C - 2 * r / 6], [s - 2 * l / 3, C - r / 6], [s - 2 * l / 3, C - 3 * r / 6], [s - l, C], [s - 2 * l / 3, C + 3 * r / 6], [s - 2 * l / 3, C + r / 6], [s, C + 2 * r / 6], [s, C - 2 * r / 6])) : (s = p.iX + u.AC - d - g / 2 + (B + m) / 4 - f / 2 + 2, a.push([s, C - 2 * r / 6], [s + 2 * l / 3, C - r / 6], [s + 2 * l / 3, C - 3 * r / 6], [s + l, C], [s + 2 * l / 3, C + 3 * r / 6], [s + 2 * l / 3, C + r / 6], [s, C + 2 * r / 6], [s, C - 2 * r / 6])), o.D = a, o.parse(), o.Z = p.A.CN("bl", 1), o.C7 = p.A.CN("bl", 0), o.paint(), null !== ZC._n_(I.o[ZC._[10]]) && null !== ZC._n_(I.o[ZC._[10]][p.L]) && "" !== I.o[ZC._[10]][p.L] && (Z = I.o[ZC._[10]][p.L], (c = new DT(p.A)).K = p.K + "-exit-label-" + t, c.GO = p.K + "-exit-label " + p.A.K + "-exit-label zc-exit-label", c.copy(p), c.o.text = Z, c.append(I.o), null !== ZC._n_(I.o.label) && c.append(I.o.label), c.parse(), c.Z = p.A.CN("fl", 0), u.AW ? c.iX = s - l - c.I - 2 : c.iX = s + l + 2, c.iY = C - c.F / 2, c.paint(), c.ED()));
        }
        p.A.U && p.F8();
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = i.A.B1,
          n = i.A.CL;
        null !== ZC._n_(e.o[ZC._[7]]) && (t = e.o[ZC._[7]]);
        var l = i.iX + a.AC / 2 - e.I / 2,
          r = i.iY + n.AC / 2 - e.F / 2,
          o = i.E["entry-exit"],
          s = (o[0] + o[1]) / 2;
        switch (t) {
          case "in":
          case "auto":
            break;
          case "top":
            r = i.iY + 5;
            break;
          case "bottom":
            r = i.iY + n.AC - e.F - 5;
            break;
          case "left":
            l = i.iX + a.AC / 2 - s / 2 + 5;
            break;
          case "left-out":
            l = i.iX + a.AC / 2 - s / 2 - e.I - 5;
            break;
          case "right":
            l = i.iX + a.AC / 2 + s / 2 - e.I - 5;
            break;
          case "right-out":
            l = i.iX + a.AC / 2 + s / 2 + 5;
        }
        return null !== ZC._n_(e.o.x) && (l = e.iX), null !== ZC._n_(e.o.y) && (r = e.iY), [ZC._i_(l), ZC._i_(r)];
      }
    }, {
      key: "HT",
      value: function HT() {
        var e = this;
        if (!ZC.move && e.A.IK && e.A.AN) {
          _get(_getPrototypeOf(A6G.prototype), "HT", this).call(this);
          var t = new DW(e.A);
          t.K = e.K + "-trapeze-hover", t.Z = ZC.AK(e.C.K + ZC._[22]), t.D = e.E.points, t.parse(), t.B7 = e.A.BP[1], t.BW = e.A.BP[1], t.A0 = e.A.BP[2], t.AE = e.A.BP[3], t.append(e.A.IK.o), t.parse(), t.IV = function (t) {
            return e.IV(t);
          }, t.DB() && t.parse(), t.AN && t.paint();
        }
      }
    }]);
    return A6G;
  }(MI);
  var A6D = /*#__PURE__*/function (_MI12) {
    _inherits(A6D, _MI12);
    function A6D() {
      _classCallCheck(this, A6D);
      return _possibleConstructorReturn(this, _getPrototypeOf(A6D).apply(this, arguments));
    }
    _createClass(A6D, [{
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        e.JT !== a && (t.AW ? e.iY = t.iY + t.AB + e.L * t.AC : e.iY = t.iY + t.F - t.AB - (e.L + 1) * t.AC, i.AW ? e.iX = i.iX + i.I - i.AB - (e.A.L + 1) * i.AC : e.iX = i.iX + i.AB + e.A.L * i.AC, e.JT = a), e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n,
          l,
          r = this,
          o = ZC._f_(r.A.A.F9["%pstack-" + r.L + "-0-sum"] || "0"),
          s = r.A.LV();
        if (ZC._cp_(t, s), r.CU = [], r.A.L > 0 && r.A.A.A4[r.A.L - 1] && r.A.A.A4[r.A.L - 1].S[r.L] ? l = "" + (n = 100 * r.AD / r.A.A.A4[r.A.L - 1].S[r.L].AD) : (n = 100, l = "100"), null !== ZC._n_(s[ZC._[12]]) && (l = n.toFixed(ZC.BQ(0, ZC._i_(s[ZC._[12]])))), r.CU.push(["%output-percent-value", l]), o > 0) {
          var C = 100 * r.AD / o,
            A = "" + C;
          null !== ZC._n_(s[ZC._[12]]) && (A = C.toFixed(ZC.BQ(0, ZC._i_(s[ZC._[12]])))), r.CU.push(["%node-percent-value", A]), r.CU.push(["%npv", A]);
        }
        return e = _get(_getPrototypeOf(A6D.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = i.A.B1,
          n = i.A.CL;
        null !== ZC._n_(e.o[ZC._[7]]) && (t = e.o[ZC._[7]]);
        var l = i.iX + n.AC / 2 - e.I / 2,
          r = i.iY + a.AC / 2 - e.F / 2,
          o = i.E["entry-exit"],
          s = (o[0] + o[1]) / 2;
        switch (t) {
          case "in":
          case "auto":
            break;
          case "top":
            l = i.iX + n.AC - e.I - 5;
            break;
          case "bottom":
            l = i.iX + 5;
            break;
          case "left":
            r = i.iY + a.AC / 2 - s / 2 + 5;
            break;
          case "left-out":
            r = i.iY + a.AC / 2 - s / 2 - e.F - 5;
            break;
          case "right":
            r = i.iY + a.AC / 2 + s / 2 - e.F - 5;
            break;
          case "right-out":
            r = i.iY + a.AC / 2 + s / 2 + 5;
        }
        return null !== ZC._n_(e.o.x) && (l = e.iX), null !== ZC._n_(e.o.y) && (r = e.iY), [ZC._i_(l), ZC._i_(r)];
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p = this;
        _get(_getPrototypeOf(A6D.prototype), "paint", this).call(this);
        var u = p.A.B1,
          h = p.A.CL;
        p.setup(), "static" === p.A.A33 ? (p.C.AY.SQ[p.L], e = p.C.AY.A8G[p.L]) : (p.C.AY.B3, e = p.C.AY.BL);
        var _ = p.A.LA;
        _ <= 1 && (_ *= u.AC);
        var d = p.A.ON;
        d <= 1 && (d *= u.AC);
        var f = p.A.M6;
        f <= 1 && (f *= u.AC);
        var g = u.AC - _ - d - f,
          B = f + g * (p.AD / e),
          v = 0;
        p.A.L + 1 < p.A.A.A4.length && p.A.A.A4[p.A.L + 1].S[p.L] && (v = p.A.A.A4[p.A.L + 1].S[p.L].AD);
        var m = f + g * (v / e);
        p.E["entry-exit"] = [B, m];
        var b = p.iY + (u.AW ? _ : d) + g / 2 + f / 2;
        if (r = [], h.AW ? r.push([p.iX + h.AC, b - B / 2], [p.iX + h.AC, b + B / 2], [p.iX, b + m / 2], [p.iX, b - m / 2], [p.iX + h.AC, b - B / 2]) : r.push([p.iX, b - B / 2], [p.iX, b + B / 2], [p.iX + h.AC, b + m / 2], [p.iX + h.AC, b - m / 2], [p.iX, b - B / 2]), p.E.points = r, p.AN) {
          var E = new DW(p.A);
          E.K = p.K + "-trapeze", E.copy(p), E.D = r, E.parse(), E.Z = p.A.CN("bl", 1), E.C7 = p.A.CN("bl", 0), E.paint();
          var K = E.F1(),
            D = p.C.K + ZC._[34] + p.C.K + ZC._[35] + p.A.L + ZC._[6];
          p.A.A.HK.push(ZC.Q.G2("poly", p.A.E8, p.A.J3) + 'class="' + D + '" id="' + p.K + ZC._[30] + K + '" />');
        }
        for (t = 0, i = p.A.P8.length; t < i; t++) {
          var F = p.A.P8[t];
          F && null !== ZC._n_(F.o[ZC._[5]]) && null !== ZC._n_(F.o[ZC._[5]][p.L]) && (null === ZC._n_(F.o[ZC._[19]]) && null === ZC._n_(F.o[ZC._[20]]) || ((l = new I3(p.A)).append(F.o), l.parse()), a = 0, n = 0, null !== ZC._n_(F.o[ZC._[19]]) && (a = l.I), null !== ZC._n_(F.o[ZC._[20]]) && (n = l.F), 0 === n && (n = ZC.BQ(20, u.AC / 10)), 0 === a && (a = ZC.BQ(16, h.AC / 10)), (o = new DW(p.A)).K = p.K + "-arrow-entry", o.copy(p), o.append(F.o), o.parse(), r = [], 1 === p.A.P8.length ? s = p.iX + h.AC / 2 : (A = h.AC / (p.A.P8.length + 1), s = p.iX + A + t * A), u.AW ? (C = p.iY + _ - n + g / 2 - (B + m) / 4 + f / 2 - 2, r.push([s - 2 * a / 6, C], [s + 2 * a / 6, C], [s + a / 6, C + 2 * n / 3], [s + 3 * a / 6, C + 2 * n / 3], [s, C + n], [s - 3 * a / 6, C + 2 * n / 3], [s - a / 6, C + 2 * n / 3])) : (C = p.iY + u.AC + n - _ - g / 2 + (B + m) / 4 - f / 2 + 2, r.push([s - 2 * a / 6, C], [s + 2 * a / 6, C], [s + a / 6, C - 2 * n / 3], [s + 3 * a / 6, C - 2 * n / 3], [s, C - n], [s - 3 * a / 6, C - 2 * n / 3], [s - a / 6, C - 2 * n / 3])), o.D = r, o.parse(), o.Z = p.A.CN("bl", 1), o.C7 = p.A.CN("bl", 0), o.paint(), null !== ZC._n_(F.o[ZC._[10]]) && null !== ZC._n_(F.o[ZC._[10]][p.L]) && "" !== F.o[ZC._[10]][p.L] && (Z = F.o[ZC._[10]][p.L], (c = new DT(p.A)).K = p.K + "-entry-label-" + t, c.GO = p.K + "-entry-label " + p.A.K + "-entry-label zc-entry-label", c.copy(p), c.o.text = Z, c.append(F.o), null !== ZC._n_(F.o.label) && c.append(F.o.label), c.AO = Z, c.Z = p.A.CN("fl", 0), c.parse(), c.iX = s - c.I / 2, u.AW ? c.iY = C - c.F - 2 : c.iY = C + 2, c.paint(), c.ED()));
        }
        for (t = 0, i = p.A.WA.length; t < i; t++) {
          var I = p.A.WA[t];
          I && null !== ZC._n_(I.o[ZC._[5]]) && null !== ZC._n_(I.o[ZC._[5]][p.L]) && (null === ZC._n_(I.o[ZC._[19]]) && null === ZC._n_(I.o[ZC._[20]]) || ((l = new I3(p.A)).append(I.o), l.parse()), a = 0, n = 0, null !== ZC._n_(I.o[ZC._[19]]) && (a = l.I), null !== ZC._n_(I.o[ZC._[20]]) && (n = l.F), 0 === n && (n = ZC.BQ(20, u.AC / 10)), 0 === a && (a = ZC.BQ(16, h.AC / 10)), (o = new DW(p.A)).K = p.K + "-arrow-exit", o.copy(p), o.append(I.o), o.parse(), r = [], 1 === p.A.P8.length ? s = p.iX + h.AC / 2 : (A = h.AC / (p.A.P8.length + 1), s = p.iX + A + t * A), u.AW ? (C = p.iY + _ + g / 2 + (B + m) / 4 + f / 2 + 2, r.push([s - 2 * a / 6, C], [s + 2 * a / 6, C], [s + a / 6, C + 2 * n / 3], [s + 3 * a / 6, C + 2 * n / 3], [s, C + n], [s - 3 * a / 6, C + 2 * n / 3], [s - a / 6, C + 2 * n / 3])) : (C = p.iY + u.AC - _ - g / 2 - (B + m) / 4 - f / 2 - 2, r.push([s - 2 * a / 6, C], [s + 2 * a / 6, C], [s + a / 6, C - 2 * n / 3], [s + 3 * a / 6, C - 2 * n / 3], [s, C - n], [s - 3 * a / 6, C - 2 * n / 3], [s - a / 6, C - 2 * n / 3])), o.D = r, o.parse(), o.Z = p.A.CN("bl", 1), o.C7 = p.A.CN("bl", 0), o.paint(), null !== ZC._n_(I.o[ZC._[10]]) && null !== ZC._n_(I.o[ZC._[10]][p.L]) && "" !== I.o[ZC._[10]][p.L] && (Z = I.o[ZC._[10]][p.L], (c = new DT(p.A)).K = p.K + "-exit-label-" + t, c.GO = p.K + "-exit-label " + p.A.K + "-exit-label zc-exit-label", c.copy(p), c.o.text = Z, c.append(I.o), null !== ZC._n_(I.o.label) && c.append(I.o.label), c.AO = Z, c.Z = p.A.CN("fl", 0), c.parse(), c.iX = s - c.I / 2, u.AW ? c.iY = C + n + 2 : c.iY = C - n - c.F - 2, c.paint(), c.ED()));
        }
        p.A.U && p.F8();
      }
    }, {
      key: "HT",
      value: function HT() {
        var e = this;
        if (!ZC.move && e.A.IK && e.A.AN) {
          _get(_getPrototypeOf(A6D.prototype), "HT", this).call(this);
          var t = new DW(e.A);
          t.K = e.K + "-trapeze-hover", t.Z = ZC.AK(e.C.K + ZC._[22]), t.D = e.E.points, t.parse(), t.B7 = e.A.BP[1], t.BW = e.A.BP[1], t.A0 = e.A.BP[2], t.AE = e.A.BP[3], t.append(e.A.IK.o), t.parse(), t.IV = function (t) {
            return e.IV(t);
          }, t.DB() && t.parse(), t.AN && t.paint();
        }
      }
    }]);
    return A6D;
  }(MI);
  var A7W = /*#__PURE__*/function (_MI13) {
    _inherits(A7W, _MI13);
    function A7W(e) {
      var _this95;
      _classCallCheck(this, A7W);
      _this95 = _possibleConstructorReturn(this, _getPrototypeOf(A7W).call(this, e)), _this95.J8 = null;
      return _this95;
    }
    _createClass(A7W, [{
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.B1,
          i = e.A.CL,
          a = [t.W, t.A1, i.W, i.A1];
        if (e.JT !== a && (null !== e.BU ? e.iX = t.AM(e.BU) : e.iX = t.H6(e.L), e.iY = i.AM(e.AD), e.E.XX = i.AM(e.AD), e.E.AAI = i.AM(e.DN[0]), e.E.ABH = i.AM(e.DN[1]), e.E.W1 = i.AM(e.DN[2]), e.JT = a), (!e.IP || e.A.IA && e.A.N6[ZC._[21]] < 3) && (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.J8 = new DT(e.A), e.J8.copy(e), e.DN[2] < e.AD && (e.J8.A0 = e.J8.AE = e.C2, e.J8.BW = e.B7), e.DN[2] < e.AD ? (e.A.o["trend-down"] && (e.J8.append(e.A.o["trend-down"]), e.J8.parse()), e.A.N6.down || (e.A.N6.down = new DT(e.A), e.A.N6.down.copy(e.J8), e.A.N6[ZC._[21]]++)) : e.DN[2] > e.AD ? (e.A.o["trend-up"] && (e.J8.append(e.A.o["trend-up"]), e.J8.parse()), e.A.N6.up || (e.A.N6.up = new DT(e.A), e.A.N6.up.copy(e.J8), e.A.N6[ZC._[21]]++)) : (e.A.o["trend-equal"] && (e.J8.append(e.A.o["trend-equal"]), e.J8.parse()), e.A.N6.equal || (e.A.N6.equal = new DT(e.A), e.A.N6.equal.copy(e.J8), e.A.N6[ZC._[21]]++)), e.IP = !0), e.A.IA) {
          e.DN[2] < e.AD ? e.J8 = e.A.N6.down : e.DN[2] > e.AD ? e.J8 = e.A.N6.up : e.J8 = e.A.N6.equal;
          var n = ZC.CX(e.E.XX, e.E.W1),
            l = ZC.BQ(e.E.XX, e.E.W1) - ZC.CX(e.E.XX, e.E.W1);
          l < 2 && (l = 2), e.E.A8V = n + l / 2;
        }
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        function r(e) {
          return ZC.AQ.G5(e, l);
        }
        return ZC._cp_(t, l), n.CU = [["%node-value-stock-open", r(n.AD)], ["%open", r(n.AD)], ["%v0", r(n.AD)], ["%node-value-stock-high", r(n.DN[0])], ["%high", r(n.DN[0])], ["%v1", r(n.DN[0])], ["%node-value-stock-low", r(n.DN[1])], ["%low", r(n.DN[1])], ["%v2", r(n.DN[1])], ["%node-value-stock-close", r(n.DN[2])], ["%close", r(n.DN[2])], ["%v3", r(n.DN[2])]], e = _get(_getPrototypeOf(A7W.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "HE",
      value: function HE() {
        var e,
          t,
          i = this;
        if (i.DN = [], i.o[ZC._[9]] instanceof Array && 5 === i.o[ZC._[9]].length) i.BU = ZC._f_(i.o[ZC._[9]][0]), null !== i.BU && (null !== ZC._n_(i.A.K8[i.BU]) && -1 !== ZC.AV(i.A.K8[i.BU], i.L) || i.A.TA(i.BU, i.L)), t = [i.o[ZC._[9]][1], i.o[ZC._[9]][2], i.o[ZC._[9]][3], i.o[ZC._[9]][4]];else if (i.o[ZC._[9]][1] instanceof Array) {
          if ("string" == typeof i.o[ZC._[9]][0]) {
            var a = ZC.AV(i.A.B1.J0, i.o[ZC._[9]][0]);
            -1 !== a ? i.BU = a : (i.A.B1.J0.push(i.o[ZC._[9]][0]), i.BU = i.A.B1.J0.length - 1);
          } else i.BU = ZC._f_(i.o[ZC._[9]][0]);
          null !== i.BU && (null !== ZC._n_(i.A.K8[i.BU]) && -1 !== ZC.AV(i.A.K8[i.BU], i.L) || i.A.TA(i.BU, i.L)), t = i.o[ZC._[9]][1];
        } else t = i.o[ZC._[9]];
        i.CI = t.join(" "), i.AD = ZC._f_(t[0]), null !== ZC._n_(e = t[1]) && i.DN.push(ZC._f_(e)), null !== ZC._n_(e = t[2]) && i.DN.push(ZC._f_(e)), null !== ZC._n_(e = t[3]) && i.DN.push(ZC._f_(e));
      }
    }, {
      key: "JC",
      value: function JC() {
        var e = this,
          t = {};
        return e.DN[2] < e.AD ? t[ZC._[0]] = e.J8.B7 : t[ZC._[0]] = e.J8.A0, t.color = e.J8.C2, t;
      }
    }, {
      key: "KD",
      value: function KD() {
        var e = this,
          t = {};
        return e.DN[2] < e.AD ? t[ZC._[0]] = e.J8.B7 : t[ZC._[0]] = e.J8.A0, t[ZC._[61]] = t[ZC._[0]], t.color = e.J8.C2, t;
      }
    }, {
      key: "A01",
      value: function A01() {
        return this.KD();
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        _get(_getPrototypeOf(A7W.prototype), "paint", this).call(this);
        var i = t.A.B1;
        t.setup();
        for (var a = i.AC * t.A.Y, n = t.A.L, l = 0, r = 0; r < t.A.A.K9.stock.length; r++) l++, -1 !== ZC.AV(t.A.A.K9[t.A.AF][r], t.A.L) && (n = r);
        var o = t.A.CD;
        o <= 1 && (o *= a);
        var s = t.A.CS;
        s <= 1 && (s *= a);
        var C = a - o - s,
          A = t.A.F4;
        A <= 1 && (A *= C), C < 1 && (C = .8 * a, o = .1 * a, s = .1 * a);
        var Z = C,
          c = t.A.F0;
        0 !== c && (A = 0), l > 1 && (c > 1 ? Z = (C - (l - 1) * A + (l - 1) * c) / l : c *= Z = (C - (l - 1) * A) / (l - (l - 1) * c)), Z = ZC._l_(Z, 1, C);
        var p = t.iX - a / 2 + o + n * (Z + A) - n * c;
        p = ZC._l_(p, t.iX - a / 2 + o, t.iX + a / 2 - s);
        var u,
          h = Z,
          _ = ZC.CX(t.E.XX, t.E.W1),
          d = ZC.BQ(t.E.XX, t.E.W1) - ZC.CX(t.E.XX, t.E.W1);
        if (d < 2 && (d = 2), o + s === 0 && (p -= .5, h += 1), t.I = h, t.F = d, t.iX = p, t.E.A8V = _ + d / 2, t.setNodeData({
          x: p,
          y: _,
          w: h,
          h: d
        }), t.AN) {
          u = ZC.Q.E9(t.H.usc() ? t.H.K + "-main-c" : t.H.KE ? t.C.K + "-plots-bl-c" : t.C.K + "-plot-" + t.A.L + "-bl-1-c", t.H.AA);
          var f,
            g = t.iX + t.I / 2;
          t.DN[2] < t.AD && (e = t.A.o["trend-down"]) ? (t.E[ZC._[73]] = e[ZC._[73]], t.E[ZC._[72]] = e[ZC._[72]]) : t.DN[2] > t.AD && (e = t.A.o["trend-up"]) ? (t.E[ZC._[73]] = e[ZC._[73]], t.E[ZC._[72]] = e[ZC._[72]]) : t.DN[2] === t.AD && (e = t.A.o["trend-equal"]) && (t.E[ZC._[73]] = e[ZC._[73]], t.E[ZC._[72]] = e[ZC._[72]]);
          var B = t.A.I5(t, t.J8);
          switch (t.A.CV) {
            default:
              var v, m;
              (f = []).push([g, t.E.AAI], [g, ZC.CX(t.E.XX, t.E.W1)], null, [g, t.E.ABH], [g, ZC.BQ(t.E.XX, t.E.W1)]), ZC.CQ.paint(u, B, f), m = t.DN[2] < t.AD ? t.A.AC2 : t.DN[2] > t.AD ? t.A.ACQ : t.A.ABS, 0 !== t.A.E5.length || typeof m === ZC._[31] || t.N.o.override || t.C.KP ? (v = new I3(t.A)).copy(B) : v = m, t.GN(v), v.Z = t.A.CN("bl", 1), v.C7 = t.A.CN("bl", 0), v.K = t.K, v.iX = p, v.iY = _, v.I = t.I, v.F = t.F, v.paint(), 0 !== t.A.E5.length || typeof m !== ZC._[31] || t.N.o.override || t.C.KP || (t.DN[2] < t.AD ? t.A.AC2 = v : t.DN[2] > t.AD ? t.A.ACQ = v : t.A.ABS = v);
              break;
            case "whisker":
            case "ohlc":
              f = [];
              var b = Math.max(t.I / 4, 4);
              f.push([g, t.E.AAI], [g, t.E.ABH], null, [g - b, t.E.XX], [g, t.E.XX], null, [g + b, t.E.W1], [g, t.E.W1]), t.GN(B), ZC.CQ.paint(u, B, f);
          }
          if (t.A.FZ) {
            var E = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6];
            t.A.A.HK.push(ZC.Q.G2("rect", t.A.E8, t.A.J3) + 'class="' + E + '" id="' + t.K + ZC._[30] + ZC._i_(p + ZC.MAPTX) + "," + ZC._i_(t.E.AAI + ZC.MAPTX) + "," + ZC._i_(p + h + ZC.MAPTX) + "," + ZC._i_(t.E.ABH + ZC.MAPTX) + '" />');
          }
          t.A.U && t.A.U.AN && t.F8();
        }
      }
    }, {
      key: "HT",
      value: function HT() {
        var e = this;
        if (!ZC.move && e.A.IK && e.A.AN) switch (_get(_getPrototypeOf(A7W.prototype), "HT", this).call(this), e.A.CV) {
          case "candlestick":
            var t = new I3(e.A);
            t.K = e.K + "-hover", t.Z = ZC.AK(e.C.K + ZC._[22]), t.C2 = e.A.BP[0], t.AE = e.A.BP[3], t.B7 = e.A.BP[1], t.BW = e.A.BP[1], t.A0 = e.A.BP[2], t.append(e.A.IK.o), t.QD = !0, t.parse(), t.IV = function (t) {
              return e.IV(t);
            }, t.DB() && t.parse(), e.DN[2] < e.AD && (t.A0 = t.AE = t.C2, t.BW = t.B7), e.DN[2] < e.AD && e.A.o["trend-down"] ? (t.append(e.A.o["trend-down"]), t.append(e.A.o[ZC._[71]]), e.A.o["trend-down"][ZC._[71]] && t.append(e.A.o["trend-down"][ZC._[71]]), t.parse()) : e.DN[2] > e.AD && e.A.o["trend-up"] ? (t.append(e.A.o["trend-up"]), t.append(e.A.o[ZC._[71]]), e.A.o["trend-up"][ZC._[71]] && t.append(e.A.o["trend-up"][ZC._[71]]), t.parse()) : e.DN[2] === e.AD && e.A.o["trend-equal"] && (t.append(e.A.o["trend-equal"]), t.append(e.A.o[ZC._[71]]), e.A.o["trend-equal"][ZC._[71]] && t.append(e.A.o["trend-equal"][ZC._[71]]), t.parse()), t.iX = e.getNodeData("x"), t.iY = e.getNodeData("y"), t.I = e.getNodeData("w"), t.F = e.getNodeData("h");
            var i = e.C.P;
            t.iY < i.iY && (t.F = t.F - (i.iY - t.iY), t.iY = i.iY), t.iY + t.F > i.iY + i.F && (t.F = i.iY + i.F - t.iY), t.AN && t.paint();
        }
      }
    }]);
    return A7W;
  }(MI);
  var A7S = /*#__PURE__*/function (_MI14) {
    _inherits(A7S, _MI14);
    function A7S() {
      _classCallCheck(this, A7S);
      return _possibleConstructorReturn(this, _getPrototypeOf(A7S).apply(this, arguments));
    }
    _createClass(A7S, [{
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.C.BJ(e.A.BT("k")[0]),
          i = e.C.BJ(e.A.BT("v")[0]),
          a = e.L % t.H5,
          n = Math.floor(e.L / t.H5),
          l = i.EI / (i.BL - i.B3);
        e.iX = t.iX + a * t.GM + t.GM / 2, e.iY = t.iY + n * t.GG + t.GG / 2, e.E.angle = i.DF - i.EI / 2 + l * (e.AD - i.B3), i.AW && (e.E.angle = i.DF + i.EI / 2 - l * (e.AD - i.B3)), e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0);
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i,
          a,
          n = e.I,
          l = e.F,
          r = this,
          o = r.C.BJ(r.A.BT("k")[0]),
          s = ZC.CX(o.GM / 2, o.GG / 2) * o.JV,
          C = r.L % o.H5,
          A = Math.floor(r.L / o.H5),
          Z = o.iX + C * o.GM + o.GM / 2 + o.BM,
          c = o.iY + A * o.GG + o.GG / 2 + o.BH;
        switch (e.o[ZC._[7]]) {
          case "center":
            i = Z - n / 2 + r.BM, a = c - l / 2 + r.BH;
            break;
          case "edge":
            i = (t = ZC.AR.BN(Z, c, s + e.DS, r.E.angle))[0] - n / 2 + r.BM, a = t[1] - l / 2 + r.BH;
            break;
          case "tip":
            i = (t = ZC.AR.BN(Z, c, r.E[ZC._[21]] + e.DS, r.E.angle))[0] - n / 2 + r.BM, a = t[1] - l / 2 + r.BH;
            break;
          default:
            i = (t = ZC.AR.BN(Z, c, s / 2 + e.DS, r.E.angle))[0] - n / 2 + r.BM, a = t[1] - l / 2 + r.BH;
        }
        return null !== ZC._n_(e.o.x) && (i = e.iX), null !== ZC._n_(e.o.y) && (a = e.iY), [ZC._i_(i), ZC._i_(a)];
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.A0
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.A0,
          "border-color": this.B7,
          color: this.C2
        };
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        _get(_getPrototypeOf(A7S.prototype), "paint", this).call(this), t.setup(), t.CY = !1;
        var i = t.C.BJ(t.A.BT("k")[0]),
          a = ZC.CX(i.GM / 2, i.GG / 2) * i.JV,
          n = t.L % i.H5,
          l = Math.floor(t.L / i.H5),
          r = i.iX + n * i.GM + i.GM / 2 + i.BM,
          o = i.iY + l * i.GG + i.GG / 2 + i.BH,
          s = ZC.IU(t.A.o[ZC._[21]] || "0.9", !1);
        s > 0 && s <= 1 && (s *= a), t.E[ZC._[21]] = s;
        var C = t.N = t.A.I5(t, t),
          A = new DW(t.A);
        function Z(i) {
          var n = [],
            l = t.A.I4;
          l[4] > -1 && l[4] < 1 && (l[4] = ZC._i_(l[4] * a));
          var C = ZC.AR.BN(r, o, l[4], i);
          if (l[0] >= 0) for (e = -l[2]; e <= 180 + l[2]; e += 5) n.push(ZC.AR.BN(C[0], C[1], l[0], i + 270 - e));else n.push(ZC.AR.BN(C[0], C[1], ZC._a_(l[0]), i - 90)), n.push(ZC.AR.BN(C[0], C[1], ZC._a_(l[0]), i + 90));
          if (0 === l[1]) n.push(ZC.AR.BN(r, o, s > 0 ? s : .9 * a, i));else if (l[1] > 0) for (C = ZC.AR.BN(r, o, s > 0 ? s : .9 * a, i), e = -l[3]; e <= 180 + l[3]; e += 5) n.push(ZC.AR.BN(C[0], C[1], l[1], i - 270 - e));else C = ZC.AR.BN(r, o, (s > 0 ? s : .9 * a) + l[1], i), n.push(ZC.AR.BN(C[0], C[1], ZC._a_(l[1] / (90 / l[3])), i + 90), ZC.AR.BN(C[0], C[1], ZC._a_(l[1]), i + 90), ZC.AR.BN(r, o, s > 0 ? s : .9 * a, i), ZC.AR.BN(C[0], C[1], ZC._a_(l[1]), i + 270), ZC.AR.BN(C[0], C[1], ZC._a_(l[1] / (90 / l[3])), i + 270));
          return n.push([n[0][0], n[0][1]]), n;
        }
        function c() {
          var e = A.F1(),
            i = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6],
            a = ZC.Q.G2("poly", t.A.E8, t.A.J3) + 'class="' + i + '" id="' + t.K + ZC._[30] + e + '" />';
          t.A.A.HK.push(a);
        }
        A.copy(C), A.Z = t.A.CN("bl", 1), A.C7 = t.A.CN("bl", 0), A.K = t.K + "-arrow";
        var p = t.C.BJ(t.A.BT("v")[0]),
          u = p.DF - p.EI / 2,
          h = Z(t.E.angle);
        if (t.E.points = h, A.DQ = "poly", A.D = h, A.parse(), A.IV = function (e) {
          return t.IV(e);
        }, A.DB() && A.parse(), t.A.GI && !t.C.HO) {
          var _,
            d = A,
            f = {},
            g = t.A.LL;
          for (_ in d.C6 = 0, f.alpha = C.C6, 2 === g && (d.A32 = u, f.A32 = t.E.angle), t.A.FW) d[EB.GP[ZC.EE(_)]] = t.A.FW[_], f[ZC.EE(_)] = C[EB.GP[ZC.EE(_)]];
          if (t.C.EM || (t.C.EM = {}), null !== ZC._n_(t.C.EM[t.A.L + "-" + t.L])) for (_ in t.C.EM[t.A.L + "-" + t.L]) {
            var B = EB.GP[ZC.EE(_)];
            null === ZC._n_(B) && (B = _), d[B] = t.C.EM[t.A.L + "-" + t.L][_];
          }
          t.C.EM[t.A.L + "-" + t.L] = {}, ZC._cp_(f, t.C.EM[t.A.L + "-" + t.L]);
          var v = new EB(d, f, t.A.JL, t.A.LE, EB.RW[t.A.LI], function () {
            c();
          });
          v.AX = t, v.A0Z = function (e, t) {
            null !== ZC._n_(t.A32) && (e.D = Z(t.A32));
          }, t.L9(v), t.A.U && t.F8();
        } else A.paint(), t.A.U && t.F8(), c();
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || t.LN({
          layer: e,
          type: "shape",
          initcb: function initcb() {
            this.copy(t), this.B7 = t.A.BP[1], this.BW = t.A.BP[1], this.A0 = t.A.BP[3], this.AE = t.A.BP[2], this.D = t.E.points, this.Z = this.C7 = t.A.CN("bl", 2);
          }
        });
      }
    }]);
    return A7S;
  }(MI);
  var A7O = /*#__PURE__*/function (_MI15) {
    _inherits(A7O, _MI15);
    function A7O(e) {
      var _this96;
      _classCallCheck(this, A7O);
      _this96 = _possibleConstructorReturn(this, _getPrototypeOf(A7O).call(this, e));
      var t = _assertThisInitialized(_this96);
      t.CE = null, t.CK = null, t.MZ = "min";
      return _this96;
    }
    _createClass(A7O, [{
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this;
        return n.CU = [["%range-set", n.MZ], ["%node-min-value", n.CE], ["%node-max-value", n.CK]], e = _get(_getPrototypeOf(A7O.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "HE",
      value: function HE() {
        var e,
          t,
          i = this;
        i.o[ZC._[9]][1] instanceof Array ? ("string" == typeof i.o[ZC._[9]][0] ? -1 !== (t = ZC.AV(i.A.B1.J0, i.o[ZC._[9]][0])) ? i.BU = t : (i.A.B1.J0.push(i.o[ZC._[9]][0]), i.BU = i.A.B1.J0.length - 1) : i.BU = ZC._f_(i.o[ZC._[9]][0]), null !== i.BU && (null !== ZC._n_(i.A.K8[i.BU]) && -1 !== ZC.AV(i.A.K8[i.BU], i.L) || i.A.TA(i.BU, i.L)), e = i.o[ZC._[9]][1]) : e = i.o[ZC._[9]], "string" == typeof e[0] ? -1 !== (t = ZC.AV(i.A.CL.JQ, e[0])) ? i.CE = t : (i.A.CL.JQ.push(e[0]), i.CE = i.A.CL.JQ.length - 1) : i.CE = ZC._f_(e[0]), i.DN.push(i.CE), "string" == typeof e[1] ? -1 !== (t = ZC.AV(i.A.CL.JQ, e[1])) ? i.CK = t : (i.A.CL.JQ.push(e[1]), i.CK = i.A.CL.JQ.length - 1) : i.CK = ZC._f_(e[1]), i.CI = e.join(" "), i.AD = i.CK;
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.A.P2,
          i = e.A.B1,
          a = e.A.CL,
          n = [i.W, i.A1, a.W, a.A1, e.MZ];
        null === ZC._n_(e.AH) && (e.AH = []), e.JT !== n && (t ? (null !== e.BU ? e.iY = i.AM(e.BU) : e.iY = i.H6(e.L), e.iX = a.AM("min" === e.MZ ? e.CE : e.CK)) : (null !== e.BU ? e.iX = i.AM(e.BU) : e.iX = i.H6(e.L), e.iY = a.AM("min" === e.MZ ? e.CE : e.CK)), e.JT = n), e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse()), e.E.NP = a.AM(e.CE), e.E.RJ = a.AM(e.CK), e.IP = !0;
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.B7,
          "border-color": this.B7,
          color: this.C2
        };
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        _get(_getPrototypeOf(A7O.prototype), "paint", this).call(this);
        var i = t.A.B1,
          a = t.A.QQ,
          n = t.A.P2,
          l = t.A.S;
        t.setup(), null !== ZC._n_(t.A.o[t.MZ + "-line"]) && (t.append(t.A.o[t.MZ + "-line"]), t.parse()), t.CY = !1, t.C7 = t.A.CN("bl", 1);
        var r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d,
          f,
          g = [],
          B = [];
        switch (t.A.CV) {
          default:
            var v = !0;
            !i.EF && t.L <= i.W && (v = !1), l[t.L - t.A.Y] || (v = !1), v && (l[t.L - t.A.Y].MZ = t.MZ, l[t.L - t.A.Y].setup(), n ? (o = [t.E.NP, t.iY], s = [l[t.L - t.A.Y].E.NP, l[t.L - t.A.Y].iY], C = [t.E.RJ, t.iY], A = [l[t.L - t.A.Y].E.RJ, l[t.L - t.A.Y].iY], Z = ZC.AR.A62(o, s, C, A), r = ZC.DR(Z[1], l[t.L - t.A.Y].iY, t.iY) ? Z : ZC.AR.JZ(l[t.L - t.A.Y].iX, l[t.L - t.A.Y].iY, l[t.L].iX, l[t.L].iY), B.push([r[0], ZC._i_(r[1])]), g.push([r[0], r[1]])) : (o = [t.iX, t.E.NP], s = [l[t.L - t.A.Y].iX, l[t.L - t.A.Y].E.NP], C = [t.iX, t.E.RJ], A = [l[t.L - t.A.Y].iX, l[t.L - t.A.Y].E.RJ], Z = ZC.AR.A62(o, s, C, A), r = ZC.DR(Z[0], l[t.L - t.A.Y].iX, t.iX) ? Z : ZC.AR.JZ(l[t.L - t.A.Y].iX, l[t.L - t.A.Y].iY, l[t.L].iX, l[t.L].iY), B.push([ZC._i_(r[0]), r[1]]), g.push([r[0], r[1]]))), n ? B.push([t.iX, ZC._i_(t.iY)]) : B.push([ZC._i_(t.iX), t.iY]), g.push([t.iX, t.iY]);
            var m = !0;
            !i.EF && t.L >= i.A1 && (m = !1), l[t.L + t.A.Y] || (m = !1), m && (l[t.L + t.A.Y].MZ = t.MZ, l[t.L + t.A.Y].setup(), n ? (o = [t.E.NP, t.iY], s = [l[t.L + t.A.Y].E.NP, l[t.L + t.A.Y].iY], C = [t.E.RJ, t.iY], A = [l[t.L + t.A.Y].E.RJ, l[t.L + t.A.Y].iY], Z = ZC.AR.A62(o, s, C, A), r = ZC.DR(Z[1], l[t.L + t.A.Y].iY, t.iY) ? Z : ZC.AR.JZ(l[t.L].iX, l[t.L].iY, l[t.L + t.A.Y].iX, l[t.L + t.A.Y].iY), B.push([r[0], ZC._i_(r[1])]), g.push([r[0], r[1]])) : (o = [t.iX, t.E.NP], s = [l[t.L + t.A.Y].iX, l[t.L + t.A.Y].E.NP], C = [t.iX, t.E.RJ], A = [l[t.L + t.A.Y].iX, l[t.L + t.A.Y].E.RJ], Z = ZC.AR.A62(o, s, C, A), r = ZC.DR(Z[0], l[t.L + t.A.Y].iX, t.iX) ? Z : ZC.AR.JZ(l[t.L].iX, l[t.L].iY, l[t.L + t.A.Y].iX, l[t.L + t.A.Y].iY), B.push([ZC._i_(r[0]), r[1]]), g.push([r[0], r[1]])));
            break;
          case "spline":
            if (typeof t.E["intersect.index"] === ZC._[31] && (t.E["intersect.index"] = -1, l[t.L + t.A.Y])) {
              var b = [],
                E = [],
                K = [];
              for (c = -1; c < 3; c++) l[t.L + c] ? (l[t.L + c].setup(), b.push(l[t.L + c].E.NP), K.push(l[t.L + c].E.RJ), n ? E.push(l[t.L + c].iY) : E.push(l[t.L + c].iX)) : (b.push(t.E.NP), K.push(t.E.RJ), n ? E.push(t.iY) : E.push(t.iX));
              u = ZC._a_(E[2] - E[1]);
              var D = ZC.AR.YY(t.A.QJ, b, ZC._i_(u)),
                F = ZC.AR.YY(t.A.QJ, K, ZC._i_(u));
              if (l[t.L + t.A.Y].CE === l[t.L + t.A.Y].CK) t.E["intersect.index"] = D.length;else {
                var I = D[0][1] - F[0][1];
                for (c = 1, p = D.length; c < p; c++) if (Math.round(I * (D[c][1] - F[c][1]), 2) <= 0) {
                  t.E["intersect.index"] = c + 1;
                  break;
                }
              }
              t.E["spline.points.min"] = D, t.E["spline.points.max"] = F, t.E["spline.xdiff"] = u;
            }
            u = t.E["spline.xdiff"] || i.AC, null === ZC._n_(t.A.A0B) && (t.A.A0B = {}), null === ZC._n_(t.A.SH) && (t.A.SH = {});
            var x = [],
              y = [];
            if ("min" === t.MZ) {
              if (null !== ZC._n_(e = t.A.SH.max)) for (c = e.length - 1; c >= 0; c--) t.AH.push(t.A.SH.max[c]);
              if (null !== ZC._n_(e = t.A.SH.min)) for (c = 0, p = e.length; c < p; c++) t.AH.push(e[c]);
            }
            if (null !== ZC._n_(e = t.A.A0B[t.MZ])) for (g = [], c = 0, p = e.length; c < p; c++) g.push(e[c]);
            if (l[t.L + t.A.Y] && t.L < i.A1) {
              "min" === t.MZ ? h = t.E["spline.points.min"] : "max" === t.MZ && (h = t.E["spline.points.max"]), _ = -1 === t.E["intersect.index"] ? ZC._i_(h.length / 2) : t.E["intersect.index"];
              var X = n ? i.AW ? 1 : -1 : i.AW ? -1 : 1;
              for (c = 0; c < _; c++) n ? (g.push([h[c][1], t.iY + X * h[c][0] * u]), B.push([h[c][1], ZC._i_(t.iY + X * h[c][0] * u)])) : (g.push([t.iX + X * h[c][0] * u, h[c][1]]), B.push([ZC._i_(t.iX + X * h[c][0] * u), h[c][1]]));
              var Y = 1 === t.I6 ? ZC.CX(2, _) : 1;
              for (c = _ - 1, p = h.length; c < p; c++) n ? x.push([h[c][1], t.iY + X * h[c][0] * u]) : x.push([t.iX + X * h[c][0] * u, h[c][1]]);
              for (c = _ - Y, p = h.length; c < p; c++) n ? y.push([h[c][1], ZC._i_(t.iY + X * h[c][0] * u)]) : y.push([ZC._i_(t.iX + X * h[c][0] * u), h[c][1]]);
            } else g.push([l[t.L].iX, l[t.L].iY]), n ? (x.push([l[t.L].iX, ZC._i_(l[t.L].iY)]), B.push([l[t.L].iX, ZC._i_(l[t.L].iY)]), y.push([l[t.L].iX, ZC._i_(l[t.L].iY)])) : (x.push([ZC._i_(l[t.L].iX), l[t.L].iY]), B.push([ZC._i_(l[t.L].iX), l[t.L].iY]), y.push([ZC._i_(l[t.L].iX), l[t.L].iY]));
            t.A.A0B[t.MZ] = x, t.A.SH[t.MZ] = y;
        }
        if ("min" === t.MZ) for (c = 0, p = B.length; c < p; c++) t.AH.push(B[c]);else for (c = B.length - 1; c >= 0; c--) t.AH.push(B[c]);
        if ("max" === t.MZ) {
          var w = new DW(t.A);
          w.K = t.K + "-area", w.Z = t.A.CN("bl", 0), w.copy(t), w.AZ = 0, w.AU = 0, w.EX = 0, w.GD = 0, w.parse(), w.D = t.AH, w.C6 = t.A.I6;
          var L = t.C.P;
          for (w.D0 = [L.iX, L.iY, L.iX + L.I, L.iY + L.F], w.paint(), t.E.pointsarea = [], c = 0, p = t.AH.length; c < p; c++) t.E.pointsarea.push(t.AH[c]);
          t.AH = [], t.A.FZ && (f = w.F1(), d = t.C.K + ZC._[34] + t.C.K + "-plot-" + t.A.L + ZC._[6], t.A.A.HK.push(ZC.Q.G2("poly", t.A.E8, t.A.J3) + 'class="' + d + '" id="' + t.K + "--area" + ZC._[30] + f + '" />'));
        }
        "min" === t.MZ ? t.E.points = g : (t.E.points.push(null), t.E.points = t.E.points.concat(g));
        var M = new CZ(t);
        M.copy(t), M.append(t.A.o[t.MZ + "-line"]), M.parse(), ZC.CQ.setup(a, M), ZC.CQ.paint(a, M, g), "max" === t.MZ && t.paintPreview(t, t.E.points, t.E.pointsarea);
        if (n ? ZC.DR(t.iY, i.iY - 1, i.iY + i.F + 1) && ZC.DR(t.iX, i.iX - 1, i.iX + i.I + 1) : ZC.DR(t.iX, i.iX - 1, i.iX + i.I + 1) && ZC.DR(t.iY, i.iY - 1, i.iY + i.F + 1)) {
          var H = new DW(t.A);
          H.K = t.K + "-marker-" + t.MZ, H.Z = H.C7 = t.A.CN("fl", 0), H.iX = t.iX, H.iY = t.iY, H.B7 = t.A.BP[3], H.BW = t.A.BP[3], H.A0 = t.A.BP[2], H.AE = t.A.BP[2], H.append(t.A.A2.o), t.A.o[t.MZ + "-marker"] && H.append(t.A.o[t.MZ + "-marker"]), H.parse(), H.IV = function (e) {
            return t.IV(e);
          }, H.DB() && H.parse(), H.AN && "none" !== H.AF && (t.A.N2 > i.A1 - i.W && H.paint(), t.E["marker.type"] = H.DQ, d = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6], i.AW && g.reverse(), t.A.FZ && ("" !== (f = ZC.AR.Q8(ZC.AR.ZJ(t.E.points), 4)) ? t.A.A.HK.push(ZC.Q.G2("poly", t.A.E8, t.A.J3) + 'class="' + d + '" ' + t.a11y() + ' id="' + t.K + "--" + t.MZ + ZC._[30] + f + '" />') : t.A.A.HK.push(ZC.Q.G2("circle", t.A.E8, t.A.J3) + 'class="' + d + '" ' + t.a11y() + ' id="' + t.K + "--" + t.MZ + ZC._[30] + ZC._i_(H.iX + ZC.MAPTX) + "," + ZC._i_(H.iY + ZC.MAPTX) + "," + ZC._i_(1.5 * ZC.BQ(3, H.AI)) + '" />'))), t.A.U && t.A.U.AN && t.F8();
        }
      }
    }, {
      key: "paintPreview",
      value: function paintPreview(e, t, i) {
        var a = this;
        if (a.C.B9 && a.C.B9.IP && a.A.R8) {
          var n,
            l = a.C.P,
            r = a.C.B9,
            o = a.A.mapPointsToPreview(i),
            s = new DW(a.A);
          s.copy(e), s.CY = !0, s.LD = !0, s.AZ = 0, s.AU = 0, s.EX = 0, s.GD = 0, s.C6 = a.A.I6, s.D0 = [l.iX, l.iY, l.iX + l.I, l.iY + l.F], s.K = a.K + "-area-preview", s.Z = r.Z, s.D = o, s.paint();
          var C = a.A.mapPointsToPreview(t);
          a.A.WL ? n = a.A.WL : (n = new CZ(a), a.A.WL = n), n.copy(e);
          var A = ZC.Q.E9(r.Z, a.H.AA);
          n.AZ = 1, ZC.CQ.paint(A, n, C, null, 3);
        }
      }
    }, {
      key: "HT",
      value: function HT() {
        var e = this,
          t = e.A.P2;
        if (!ZC.move) {
          var i = e.A.B1;
          if (e.A.GC && e.A.AN) {
            var a = ZC.Q.E9(e.C.K + ZC._[22], e.H.AA),
              n = new DW(e.A);
            if (n.K = e.K + "-area-hover", n.Z = ZC.AK(e.C.K + ZC._[22]), n.LD = !0, n.copy(e), n.append(e.A.IK.o), n.D = e.E.pointsarea, n.parse(), n.AN) {
              n.C6 = e.A.I6;
              var l = e.C.P;
              n.D0 = [l.iX, l.iY, l.iX + l.I, l.iY + l.F], ZC.CQ.setup(a, n), n.paint();
            }
            var r = ZC.Q.E9(e.C.K + ZC._[22], e.H.AA),
              o = new CZ(e.A);
            o.K = e.K + "-line-hover", o.CY = !1, o.B7 = e.A.BP[3], o.append(e.A.IK.o), o.parse(), o.IV = function (t) {
              return e.IV(t);
            }, o.DB() && o.parse(), o.AN && (ZC.CQ.setup(r, o), ZC.CQ.paint(r, o, e.E.points));
          }
          if (e.A.N2 > i.A1 - i.W && e.A.GC && e.A.AN) {
            _get(_getPrototypeOf(A7O.prototype), "HT", this).call(this);
            var s = new DW(e.A);
            s.K = e.K + "-marker-max-hover", s.Z = ZC.AK(e.C.K + ZC._[22]), s.DQ = e.E["marker.type"], t ? (s.iY = e.iY, s.iX = e.E.RJ) : (s.iX = e.iX, s.iY = e.E.RJ), s.B7 = e.A.BP[3], s.BW = e.A.BP[3], s.A0 = e.A.BP[2], s.AE = e.A.BP[2], s.append(e.A.GC.o), s.parse(), s.IV = function (t) {
              return e.IV(t);
            }, s.DB() && s.parse(), s.AN && "none" !== s.AF && s.paint(), s.K = e.K + "-marker-min-hover", t ? s.iX = e.E.NP : s.iY = e.E.NP, s.AN && "none" !== s.AF && s.paint();
          }
        }
      }
    }]);
    return A7O;
  }(MI);
  var A81 = /*#__PURE__*/function (_MI16) {
    _inherits(A81, _MI16);
    function A81(e) {
      var _this97;
      _classCallCheck(this, A81);
      _this97 = _possibleConstructorReturn(this, _getPrototypeOf(A81).call(this, e)), _this97.bCXY = !0, _this97.U = null;
      return _this97;
    }
    _createClass(A81, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A81.prototype), "parse", this).call(this);
      }
    }, {
      key: "XD",
      value: function XD() {
        _get(_getPrototypeOf(A81.prototype), "XD", this).call(this);
        var e = this.C.E;
        e.update.npv = e.update["node-percent-value"] = this.ES("%npv");
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = n.A.LV();
        ZC._cp_(t, l), -1 === e.indexOf("%npv") && -1 === e.indexOf("%node-percent-value") || null !== ZC._n_(l[ZC._[12]]) && -1 !== l[ZC._[12]] || (l[ZC._[12]] = 1);
        var r = 0,
          o = "0";
        if (n.A.A.KU[n.L] > 0 && (o = "" + (r = 100 * n.AD / n.A.A.KU[n.L])), n.A.A.A4.length > 1 && n.A.L === n.A.A.A4.length - 1) {
          var s = 0;
          if (null === ZC._n_(n.A.o.totals)) {
            for (var C = 0; C < n.A.A.A4.length - 1; C++) if (n.A.A.A4[C].AN && null !== ZC._n_(n.A.A.A4[C].S[n.L])) {
              var A = 0,
                Z = "0";
              n.A.A.KU[n.L] > 0 && (Z = "" + (A = 100 * n.A.A.A4[C].S[n.L].AD / n.A.A.KU[n.L])), null !== ZC._n_(l[ZC._[12]]) && (Z = A.toFixed(ZC.BQ(0, ZC._i_(l[ZC._[12]])))), s += ZC._f_(Z);
            }
            o = "" + (r = Math.max(0, 100 - s));
          }
        }
        null !== ZC._n_(l[ZC._[12]]) && (o = r.toFixed(ZC.BQ(0, ZC._i_(l[ZC._[12]]))));
        var c,
          p = ZC._f_(n.A.A.KU[n.L] || "0");
        return c = ZC.AQ.G5(p, l, n.A), n.CU = [["%node-percent-value", o], ["%npv", o], ["%pie-total-value", c]], e = _get(_getPrototypeOf(A81.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "OL",
      value: function OL(e) {
        var t,
          i = this,
          a = (i.B4 + i.BK) / 2 % 360,
          n = 0;
        null !== ZC._n_(t = e["offset-r"]) && (n = ZC._f_(ZC._p_(t))), n < 1 && (n *= i.AI);
        var l = new CC(i.C, (i.CM + .5 * (i.AI - i.CM) + i.DS + n) * ZC.EG(a), (i.CM + .5 * (i.AI - i.CM) + i.DS + n) * ZC.EN(a), 0).EC;
        return [l[0], l[1], {
          reference: i,
          center: !0
        }];
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.C.BJ(e.A.BT("k")[0]),
          i = e.L % t.H5,
          a = Math.floor(e.L / t.H5);
        e.iX = t.iX + i * t.GM + t.GM / 2 + t.BM, e.iY = t.iY + a * t.GG + t.GG / 2 + t.BH, e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(), e.IP = !0);
      }
    }, {
      key: "JC",
      value: function JC(e) {
        var t = {},
          i = "out";
        return null !== ZC._n_(e.o[ZC._[7]]) && (i = e.o[ZC._[7]]), t.color = "out" === i ? this.A0 : this.C2, t;
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t,
          i = this,
          a = "out";
        null !== ZC._n_(t = e.o[ZC._[7]]) && (a = t);
        var n,
          l,
          r,
          o,
          s,
          C = e.I,
          A = e.F,
          Z = (i.B4 + i.BK) / 2 % 360,
          c = Z;
        if ("out" === a) {
          Z = c = i.A.A.YZ["n" + i.L][i.A.L];
          var p = function p(t, a) {
              a < 0 && (a = 360 + a), a %= 360;
              var n = ZC.AR.BN(i.iX, i.iY, t + i.DS + e.DS + 20, a),
                l = i.C.EZ[ZC._[27]];
              l > 45 && i.A.A.A4.length > 10 && (i.C.EZ[ZC._[27]] = 45 + (l - 45) / 3), s = new CC(i.C, n[0] - ZC.AP.E2, n[1] - ZC.AP.E1, 0), i.C.EZ[ZC._[27]] = l, n[0] = s.EC[0], n[1] = s.EC[1];
              var r = n[0] + e.BM - C / 2,
                o = n[1] + e.BH - A / 2;
              return a >= 0 && a <= 90 || a >= 270 && a <= 360 ? r += C / 2 + 10 : r -= C / 2 + 10, [r, o];
            },
            u = p(i.AI, c);
          n = u[0], l = u[1], i.U = e;
          var h = {
              x: n,
              y: l,
              width: C,
              height: A
            },
            _ = zingchart.DEV.SPREADTYPE;
          o = !0;
          for (var d = 0, f = 0, g = -1, B = 0, v = 0; o && v < 1024;) {
            o = !1;
            for (var m = 0, b = i.A.A.U6.length; m < b; m++) r = i.A.A.U6[m], (ZC.AR.YG(h, r, i.A.A.A4.length > 10 ? -8 : -2) || h.x + e.I > i.C.P.iX + i.C.P.I || h.x < i.C.P.iX || h.y + e.F > i.C.P.iY + i.C.P.F || h.y < i.C.P.iY) && (o = !0, 0 === _ ? (d += .4, g *= -1) : 1 === _ && (f += 1), u = p(i.AI + f, c + d * g), h.x = u[0], h.y = u[1], v++, ++B > 100 && (B = 0, 0 === _ ? (d = 0, f += 4) : 1 === _ && (f = 0, d += 1, g *= -1)));
          }
          n = h.x, l = h.y, Z = c + d, r = {
            text: i.A.AO,
            x: h.x,
            y: h.y,
            width: C,
            height: A,
            plotindex: i.A.L,
            nodeindex: i.L
          }, i.A.A.U6.push(r);
        } else if ("in" === a) {
          var E = i.CM < 30 ? .65 : .5,
            K = ZC.AR.BN(i.iX, i.iY, i.CM + E * (i.AI - i.CM) + i.DS + e.DS, Z);
          s = new CC(i.C, K[0] - ZC.AP.E2, K[1] - ZC.AP.E1, 0), K[0] = s.EC[0], K[1] = s.EC[1], n = K[0] + e.BM - C / 2, l = K[1] + e.BH - A / 2;
        } else "center" === a && (n = (s = new CC(i.C, i.iX - ZC.AP.E2, i.iY - ZC.AP.E1, 0)).EC[0] + e.BM - C / 2, l = s.EC[1] + e.BH - A / 2);
        return o && (n = -9999, l = -9999, e.AN = !1), null !== ZC._n_(e.o.x) && (n = e.iX), null !== ZC._n_(e.o.y) && (l = e.iY), n >= -2 && (n = ZC._a_(n)), l >= -2 && (l = ZC._a_(l)), [ZC._i_(n), ZC._i_(l), Z];
      }
    }, {
      key: "F8",
      value: function F8(e, t) {
        var i,
          a = this,
          n = _get(_getPrototypeOf(A81.prototype), "F8", this).call(this, e, t);
        if (e) return n;
        if (a.AN && n.AN && null !== ZC._n_(n.AO) && "" !== n.AO) {
          var l = "out";
          if (null !== ZC._n_(n.o[ZC._[7]]) && (l = n.o[ZC._[7]]), "out" === l) {
            var r = !0;
            if (null !== ZC._n_(i = n.o.connected) && (r = ZC._b_(i)), r) {
              var o = new DW(a.A);
              o.Z = o.C7 = a.A.CN("bl", 0), o.append(a.A.C3.o), o.B7 = a.A0, o.DQ = "line", o.D = [];
              var s = n.E.positioninfo,
                C = (a.B4 + a.BK) / 2 % 360,
                A = 0;
              C >= 0 && C <= 180 && (A = a.E.thickness / 2);
              var Z = ZC.AR.BN(a.iX, a.iY, a.AI + a.DS + n.DS, C);
              (Z = new CC(a.C, Z[0] - ZC.AP.E2, Z[1] - ZC.AP.E1, A).EC)[0] += a.BM, Z[1] += a.BH, o.D.push(Z);
              var c = ZC.AR.BN(a.iX, a.iY, a.AI + a.DS + n.DS + 20, C);
              (c = new CC(a.C, c[0] - ZC.AP.E2, c[1] - ZC.AP.E1, A).EC)[0] += a.BM, c[1] += a.BH, n.iX >= a.iX ? o.D.push([c[0], c[1], s[0], s[1] + n.F / 2]) : o.D.push([c[0], c[1], s[0] + n.I + 2, s[1] + n.F / 2]), o.parse(), o.IV = function (e) {
                return a.IV(e);
              }, o.DB() && o.parse(), o.AN && o.paint();
            }
          }
        }
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this,
          A = C.C.CJ,
          Z = C.C.BJ(C.A.BT("k")[0]),
          c = C.C.EZ[ZC._[27]],
          p = C.C.EZ[ZC._[28]];
        C.setup();
        var u = "pie-sel-" + C.A.L + "-" + C.L;
        if (C.o.detached && typeof C.C.E[u] === ZC._[31] && (C.C.E[u] = !0), !(C.AD < 0)) {
          var h = ZC.BQ(.7, ZC.EG(c));
          C.AI = ZC.CX(Z.GG / h, Z.GM) / 2, null !== ZC._n_(C.A.o[ZC._[21]]) ? C.AI = C.A.AI : C.AI = Z.JV * C.AI, C.CM < 1 && (C.CM *= C.AI), C.CM = Math.max(0, C.CM), C.o[ZC._[8]] = C.CM, C.DS < 1 && (C.DS *= C.AI), C.o["offset-r"] = C.DS;
          var _ = C.A.NY;
          -1 === _ && (_ = C.AI / 5), C.E.thickness = _;
          var d = C.iX - ZC.AP.E2,
            f = C.iY - ZC.AP.E1;
          C.B4 = ZC._i_(C.B4), C.BK = ZC._i_(C.BK);
          var g = (C.B4 + C.BK) / 2;
          C.C.E[u] && (C.DS += ZC._i_(.15 * C.AI)), C.DS > 0 && (d += C.DS * ZC.EG(g), f += C.DS * ZC.EN(g));
          var B = C.N = C.A.I5(C, C);
          B.DJ = C.K + "-3dfacet";
          var v = new CZ(C);
          if (v.copy(B), v.A0 = ZC.AQ.JP(ZC.AQ.GE(v.A0)), v.AE = ZC.AQ.JP(ZC.AQ.GE(v.AE)), C.AD >= 0 || 0 === C.A.A.KU[C.L]) {
            for (r = [], e = C.B4, r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), 0]), e = C.B4; e <= C.BK; e += 1) r.push([d + C.AI * ZC.EG(e), f + C.AI * ZC.EN(e), 0]);
            for (e = C.BK, r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), 0]), e = C.BK; e >= C.B4; e -= 1) r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), 0]);
            if ((t = ZC.DH.D7(B, C.C, r)).K = C.K + "-facet1", A.add(t), i = null, C.B4 % 360 >= 0 + p && C.B4 % 360 < 180 + p || C.BK % 360 > 0 + p) {
              o = C.B4, s = C.BK;
              var m = function m(e, t, a) {
                var n,
                  l = [];
                for (n = e, l.push([d + C.AI * ZC.EG(n), f + C.AI * ZC.EN(n), 0]), n = e; n <= t; n += 1) l.push([d + C.AI * ZC.EG(n), f + C.AI * ZC.EN(n), 0]);
                for (n = t, l.push([d + C.AI * ZC.EG(n), f + C.AI * ZC.EN(n), _]), n = t; n >= e; n -= 1) l.push([d + C.AI * ZC.EG(n), f + C.AI * ZC.EN(n), _]);
                (i = ZC.DH.D7(v, C.C, l)).MO = [.01, 1, 1, 1], i.K = C.K + "-facet2" + a, A.add(i);
              };
              o < 180 && s > 360 ? (m(o = o < 0 ? o + 360 : o, 180, 1), m(360, s, 2)) : (o = ZC.BQ(o, s > 360 ? 365 : 5), (s = ZC.CX(s, s > 360 ? 535 : 175)) > o && m(o, s, 1));
            }
            if (l = null, C.CM > 0 + p && C.BK > 180 + p) {
              for (r = [], e = C.B4, o = C.B4, C.B4 < 180 + p && C.BK > 180 + p && (e = 180 + p, o = 180 + p), r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), 0]), e = o; e <= C.BK; e += 1) r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), 0]);
              for (e = C.BK, r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), _]), e = C.BK; e >= o; e -= 1) r.push([d + C.CM * ZC.EG(e), f + C.CM * ZC.EN(e), _]);
              (l = ZC.DH.D7(v, C.C, r)).K = C.K + "-facet3", A.add(l);
            }
            var b = function b(e, t, i) {
              return [[d + e * ZC.EG(i), f + e * ZC.EN(i), 0], [d + e * ZC.EG(i), f + e * ZC.EN(i), _], [d + t * ZC.EG(i), f + t * ZC.EN(i), _], [d + t * ZC.EG(i), f + t * ZC.EN(i), 0]];
            };
            (a = ZC.DH.D7(v, C.C, {
              points: b(C.CM, C.AI, C.B4),
              mathpoints: b(C.CM + 1, C.AI + 1, C.B4 - 1)
            })).K = C.K + "-facet4", A.add(a), (n = ZC.DH.D7(v, C.C, {
              points: b(C.CM, C.AI, C.BK),
              mathpoints: b(C.CM + 1, C.AI + 1, C.BK + 1)
            })).K = C.K + "-facet5", A.add(n);
            var E = C.C.K + ZC._[34] + C.C.K + ZC._[35] + C.A.L + ZC._[6],
              K = ZC.Q.G2("poly", C.A.E8) + 'class="' + E + '" id="' + C.K,
              D = C.A.A.HK;
            D.push(K + '--top" ' + C.a11y() + ' data-z-sort="1" coords="' + t.F1() + '" />'), i && D.push(K + '--outer" data-z-sort="1" coords="' + i.F1() + '" />'), (C.CM > 0 || C.DS > 0) && (l && D.push(K + '--inner" data-z-sort="2" coords="' + l.F1() + '" />'), D.push(K + '--start" data-z-sort="2" coords="' + a.F1() + '" />', K + '--end" data-z-sort="2" coords="' + n.F1() + '" />'));
          }
          C.A.U && C.F8();
        }
      }
    }, {
      key: "P1",
      value: function P1(e, t) {
        var i = this;
        if (_get(_getPrototypeOf(A81.prototype), "P1", this).call(this, e, t), "click" === t && e.which <= 1 && i.A.A8C) {
          var a = "pie-sel-" + i.A.L + "-" + i.L;
          i.C.E[a] = typeof i.C.E[a] === ZC._[31] || !i.C.E[a], i.C.JY();
        }
      }
    }]);
    return A81;
  }(MI);
  var A76 = /*#__PURE__*/function (_ZU2) {
    _inherits(A76, _ZU2);
    function A76() {
      _classCallCheck(this, A76);
      return _possibleConstructorReturn(this, _getPrototypeOf(A76).apply(this, arguments));
    }
    _createClass(A76, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "OL",
      value: function OL() {
        var e = this;
        e.paint(!0);
        var t = e.C.BJ(e.A.BT("v")[0]),
          i = e.iX + e.I / 2,
          a = e.iY + (t.AW ? e.F : 0),
          n = new CC(e.C, i - ZC.AP.E2, a - ZC.AP.E1, e.A.E["z-start"]);
        return [ZC._i_(n.EC[0]), ZC._i_(n.EC[1]), {
          reference: e,
          center: !0
        }];
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = _get(_getPrototypeOf(A76.prototype), "HG", this).call(this, e);
        if ("-1/-1" !== t.join("/")) {
          var i = new CC(this.C, t[0] + e.I / 2 - ZC.AP.E2, t[1] + e.F / 2 - ZC.AP.E1, this.A.E["z-mid"]);
          return [ZC._i_(i.EC[0]) - e.I / 2, ZC._i_(i.EC[1]) - e.F / 2];
        }
        return t;
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t,
          i = this;
        _get(_getPrototypeOf(A76.prototype), "paint", this).call(this), typeof e === ZC._[31] && (e = !1);
        var a = i.C.CJ,
          n = i.A.B1,
          l = i.A.CL;
        i.setup();
        var r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d,
          f,
          g,
          B,
          v,
          m = i.A.R5(),
          b = m.AC,
          E = m.ET,
          K = m.CD,
          D = m.CS,
          F = m.F4,
          I = m.D3,
          x = m.F0;
        if (e ? E = i.A.E["node-" + i.L + "-bar-index"] : i.A.E["node-" + i.L + "-bar-index"] = m.ET, i.A.CB) {
          s = 0;
          var y = i.A.A.KI[E];
          for (r = 0; r < y.length; r++) {
            var X = i.A.A.A4[y[r]].S[i.L];
            X && (s += X.AD);
          }
        }
        var Y = 1,
          w = 1;
        if (i.A.CB && s > 0 && (i.CR !== i.AD && (Y = (s - i.CR + i.AD) / s), w = (s - i.CR) / s), l.AW) {
          var L = Y;
          Y = w, w = L;
        }
        i.A.M1 && (E = i.L);
        var M = i.iX - b / 2 + K + E * (I + F) - E * x;
        if (M = ZC._l_(M, i.iX - b / 2 + K, i.iX + b / 2 - D), i.A.D3 > 0) {
          var H = I;
          (I = i.A.D3) <= 1 && (I *= H), M += (H - I) / 2;
        }
        var G = I,
          P = i.iY,
          N = null !== ZC._n_(i.A.M5[i.L]) ? i.A.M5[i.L] : 0;
        if (P = i.A.CB && "100%" === i.A.KX ? l.AM(100 * (i.CR + N) / i.A.A.F9[i.L]["%total-" + i.A.DY]) : l.AM(i.CR + N), i.A.CB ? (A = P - (C = "100%" === i.A.KX ? l.AM(100 * (i.CR - i.AD + N) / i.A.A.F9[i.L]["%total-" + i.A.DY]) : l.AM(i.CR - i.AD + N)), i.AD < 0 && (P = C), l.AW ? A > 0 && (A = ZC._a_(A), P = C) : A < 0 && (P = C - (A = ZC._a_(A)))) : P = (A = P - (C = l.AM(N))) < 0 ? C - (A = ZC._a_(A)) : C, K + D === 0 && (M -= .5, G += 1), i.I = G, i.F = A, i.iX = M, i.iY = P, l.AW ? i.AD >= l.HA ? i.iYVal = P + i.F : i.iYVal = P : i.AD >= l.HA ? i.iYVal = P : i.iYVal = P + i.F, i.C.CW) {
          var O = "middle";
          i.C.CW.o.marker && null !== ZC._n_(t = i.C.CW.o.marker.alignment) && (O = t), null !== ZC._n_(i.A.o["guide-marker"]) && null !== ZC._n_(t = i.A.o["guide-marker"].alignment) && (O = t), "node" === O && (i.E.A69 = i.iX + i.I / 2);
        }
        if (!e) {
          var S,
            Q,
            k,
            T = M - ZC.AP.E2,
            z = P - ZC.AP.E1,
            V = 0,
            R = ZC.AP.FV,
            J = 0,
            W = R;
          if (i.A.A42) {
            if (Q = V, "mixed3d" === i.C.AF || "mixed" === i.C.AF) {
              for (S = 1, r = 0, o = i.A.A.A4.length; r < o; r++) "vbar3d" !== i.A.A.A4[r].AF && S++;
              Q = (S - 1) * (ZC.AP.FV / S), R = ZC._i_(.9 * R / S);
            }
            k = Q + R;
          } else {
            if (S = 0, J = -1, W = ZC.AP.FV, "hide" === i.C.getToggleAction()) S = i.A.A.A4.length, J = i.A.L, W /= S;else if (i.A.CB) J = 0;else {
              for (r = 0; r < i.A.A.A4.length; r++) i.C.E["plot" + r + ".visible"] && J++;
              for (r = 0; r < i.A.A.A4.length; r++) i.C.E["plot" + r + ".visible"] && (S++, i.A.L > r && J--);
              W /= S, J = S - J - 1;
            }
            Q = J * W + .2 * W, k = (J + 1) * W - .2 * W;
          }
          if (null !== ZC._n_(i.A.o["z-start"]) && (Q = ZC._i_(i.A.o["z-start"])), null !== ZC._n_(i.A.o["z-end"]) && (k = ZC._i_(i.A.o["z-end"])), null !== ZC._n_(i.A.o.depth)) {
            var U = ZC._i_(i.A.o.depth);
            Q = J * W + W / 2 - U, k = J * W + W / 2 + U;
          }
          V = Q, R = k - Q, i.A.E["z-plots"] = S, i.A.E["z-cnt"] = J, i.A.E["z-depth"] = W, i.A.E["z-start"] = Q, i.A.E["z-mid"] = (Q + k) / 2;
          var j = i.N = i.A.I5(i, i.N);
          if (j.DJ = i.K + "-3dfacet", i.A.I1 && (i.GN(j), j.parse()), j.AN) {
            var q = new CZ(i);
            q.copy(j), q.A0 = ZC.AQ.JP(ZC.AQ.GE(q.A0)), q.AE = ZC.AQ.JP(ZC.AQ.GE(q.AE)), q.BW = ZC.AQ.JP(ZC.AQ.GE(q.BW));
            var $ = new CZ(i);
            $.copy(j), $.A0 = ZC.AQ.JP(ZC.AQ.GE($.A0), 15), $.AE = ZC.AQ.JP(ZC.AQ.GE($.AE), 15), $.BW = ZC.AQ.JP(ZC.AQ.GE($.BW), 15);
            var ee = new CZ(i);
            ee.copy(j);
            var te = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6],
              ie = ZC.Q.G2("poly", i.A.E8, i.N.J3) + 'class="' + te + '" id="' + i.K,
              ae = i.C.EZ.true3d,
              ne = i.I / 2,
              le = R / 2,
              re = Y * ne,
              oe = w * ne,
              se = w * le,
              Ce = Y * le;
            l.AW && !i.A.CB ? (Z = i.AD >= 0 ? 0 : i.F, c = i.AD >= 0 ? i.F : 0) : (Z = i.AD >= 0 ? i.F : 0, c = i.AD >= 0 ? 0 : i.F);
            var Ae = i.A.A.HK,
              Ze = ZC.CX(le, ne),
              ce = i.C.EZ[ZC._[28]],
              pe = i.C.EZ.angle,
              ue = ZC.EG(pe) * le,
              he = ZC.EN(pe) * le;
            ae || (Ze = ZC.CX(2 * ue, ne));
            var _e = function _e(e) {
                var t = 0,
                  a = i.A.L,
                  r = i.L,
                  o = i.A.A.A4.length,
                  s = i.A.S.length;
                switch ((i.A.CB ? "s" : "") + (n.AW ? "k" : "") + (l.AW ? "v" : "")) {
                  case "":
                  case "v":
                    t = 10 * a + 1e4 * r + e;
                    break;
                  case "sv":
                    t = 10 * (o - a) + 1e4 * r + e;
                    break;
                  case "k":
                    t = 10 * a + 1e4 * (s - r) + e;
                    break;
                  case "skv":
                    t = 10 * (o - a) + 1e4 * (s - r) + e;
                    break;
                  case "kv":
                    t = 10 * a + 1e4 * (s - r) + e;
                    break;
                  case "s":
                    t = 10 * a + 1e4 * r + e;
                    break;
                  case "sk":
                    t = 10 * a + 1e4 * (s - r) + e;
                }
                return t;
              },
              de = ZC.MAX,
              fe = -ZC.MAX,
              ge = ZC.MAX,
              Be = -ZC.MAX,
              ve = ZC.MAX,
              me = -ZC.MAX,
              be = ZC.MAX,
              Ee = -ZC.MAX;
            if ("cylinder" === i.A.CV) for (v = 0; v <= 360; v += 4) (u = new CC(i.C, T + ZC.EN(v) * Ze + ne, z, V + ZC.EG(v) * Ze + le)).EC[0] < ge && (ge = u.EC[0], de = v), u.EC[0] > Be && (Be = u.EC[0], fe = v), (u = new CC(i.C, T + ZC.EN(v) * Ze + ne, z + i.F, V + ZC.EG(v) * Ze + le)).EC[0] < be && (be = u.EC[0], ve = v), u.EC[0] > Ee && (Ee = u.EC[0], me = v);
            var Ke = i.A.o.facets || {};
            switch (i.A.CV) {
              default:
                Ke.bottom ? ((p = new CZ(i)).copy(q), p.append(Ke.bottom), p.parse(), f = ZC.DH.DA(p, i.C, T + .1, T + i.I - .1, z + i.F - .1, z + i.F - .1, V + .1, V + R - .1, "x")) : f = ZC.DH.DA(q, i.C, T + .1, T + i.I - .1, z + i.F - .1, z + i.F - .1, V + .1, V + R - .1, "x"), f.K = i.K + "-facet1", f.G0 = _e(1), a.add(f), Ke.top ? ((p = new CZ(i)).copy(q), p.append(Ke.top), p.parse(), d = ZC.DH.DA(p, i.C, T + .1, T + i.I - .1, z + .1, z + .1, V + .1, V + R - .1, "x")) : d = ZC.DH.DA(q, i.C, T + .1, T + i.I - .1, z + .1, z + .1, V + .1, V + R - .1, "x"), d.K = i.K + "-facet2", d.G0 = _e(3), a.add(d), Ke.left ? ((p = new CZ(i)).copy($), p.append(Ke.left), p.parse(), g = ZC.DH.DA(p, i.C, T + .1, T + .1, z + .1, z + i.F - .1, V + .1, V + R - .1, "z")) : g = ZC.DH.DA($, i.C, T + .1, T + .1, z + .1, z + i.F - .1, V + .1, V + R - .1, "z"), g.K = i.K + "-facet3", g.G0 = _e(2), a.add(g), Ke.right ? ((p = new CZ(i)).copy($), p.append(Ke.right), p.parse(), B = ZC.DH.DA(p, i.C, T + i.I - .1, T + i.I - .1, z + .1, z + i.F - .1, V + .1, V + R - .1, "z")) : B = ZC.DH.DA($, i.C, T + i.I - .1, T + i.I - .1, z + .1, z + i.F - .1, V + .1, V + R - .1, "z"), B.K = i.K + "-facet4", B.G0 = _e(4), a.add(B), Ke.front ? ((p = new CZ(i)).copy(ee), p.append(Ke.front), p.parse(), _ = ZC.DH.DA(p, i.C, T + .1, T + i.I - .1, z + .1, z + i.F - .1, V + .1, V + .1, "y")) : _ = ZC.DH.DA(ee, i.C, T + .1, T + i.I - .1, z + .1, z + i.F - .1, V + .1, V + .1, "y"), _.K = i.K + "-facet5", _.G0 = _e(5), a.add(_), i.A.FZ && (1 === w && Ae.push(ie + "--top" + ZC._[30] + d.F1() + '" />'), Ae.push(ie + "--left" + ZC._[30] + g.F1() + '" />', ie + "--right" + ZC._[30] + B.F1() + '" />', ie + "--front" + ZC._[30] + _.F1() + '" ' + i.a11y() + ' data-z-sort="-100" />'));
                break;
              case "pyramid":
                Ke.bottom ? ((p = new CZ(i)).copy(q), p.append(Ke.bottom), p.parse(), f = ZC.DH.DA(p, i.C, T + ne - re, T + ne + re, z + Z, z + Z, V + le - Ce, V + le + Ce, "x")) : f = ZC.DH.DA(q, i.C, T + ne - re, T + ne + re, z + Z, z + Z, V + le - Ce, V + le + Ce, "x"), f.K = i.K + "-facet1", f.G0 = _e(l.AW && !i.A.CB ? 6 : 1), a.add(f), h = [[T + ne - re, z + Z, V + le - Ce], [T + ne + re, z + Z, V + le - Ce]], i.A.CB && 0 !== w ? h.push([T + ne + oe, z + c, V + le - se], [T + ne - oe, z + c, V + le - se]) : h.push([T + ne, z + c, V + le]), Ke.front ? ((p = new CZ(i)).copy(j), p.append(Ke.front), p.parse(), _ = ZC.DH.D7(p, i.C, h)) : _ = ZC.DH.D7(j, i.C, h), _.K = i.K + "-facet2", _.G0 = _e(3), a.add(_), h = [[T + ne - re, z + Z, V + le - Ce], [T + ne - re, z + Z, V + le + Ce]], i.A.CB && 0 !== w ? h.push([T + ne - oe, z + c, V + le + se], [T + ne - oe, z + c, V + le - se]) : h.push([T + ne, z + c, V + le]), Ke.left ? ((p = new CZ(i)).copy($), p.append(Ke.left), p.parse(), g = ZC.DH.D7(p, i.C, h)) : g = ZC.DH.D7($, i.C, h), g.K = i.K + "-facet3", g.G0 = _e(2), a.add(g), h = [[T + ne + re, z + Z, V + le - Ce], [T + ne + re, z + Z, V + le + Ce]], i.A.CB && 0 !== w ? h.push([T + ne + oe, z + c, V + le + se], [T + ne + oe, z + c, V + le - se]) : h.push([T + ne, z + c, V + le]), Ke.right ? ((p = new CZ(i)).copy($), p.append(Ke.right), p.parse(), B = ZC.DH.D7(p, i.C, h)) : B = ZC.DH.D7($, i.C, h), B.K = i.K + "-facet4", B.G0 = _e(4), a.add(B), i.A.CB && 0 !== w && (h = [[T + ne - oe, z + c, V + le - se], [T + ne - oe, z + c, V + le + se], [T + ne + oe, z + c, V + le + se], [T + ne + oe, z + c, V + le - se]], Ke.top ? ((p = new CZ(i)).copy(q), p.append(Ke.top), p.parse(), d = ZC.DH.D7(p, i.C, h)) : d = ZC.DH.D7(q, i.C, h), d.K = i.K + "-facet5", d.G0 = _e(5), a.add(d)), i.A.FZ && Ae.push(ie + "--left" + ZC._[30] + g.F1() + '" />', ie + "--right" + ZC._[30] + B.F1() + '" />', ie + "--front" + ZC._[30] + _.F1() + '" ' + i.a11y() + ' data-z-sort="-100" />');
                break;
              case "cylinder":
                if (h = [], ae) for (v = 0; v <= 360; v += 5) h.push([T + ZC.EN(v) * Ze + ne, z + i.F, V + ZC.EG(v) * Ze + le]);else for (v = 0; v <= 360; v += 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze + ne + ue, P + i.F + ZC.EN(v) * (Ze / 2) - he], h.push(u);
                if (Ke.bottom ? ((p = new CZ(i)).copy(q), p.append(Ke.bottom), p.parse(), f = ZC.DH.D7(p, i.C, h, !ae)) : f = ZC.DH.D7(q, i.C, h, !ae), f.K = i.K + "-facet1", f.G0 = _e(1), a.add(f), h = [], ae) for (v = 0; v <= 360; v += 5) h.push([T + ZC.EN(v) * Ze + ne, z, V + ZC.EG(v) * Ze + le]);else for (v = 0; v <= 360; v += 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze + ne + ue, P + ZC.EN(v) * (Ze / 2) - he], h.push(u);
                if (Ke.top ? ((p = new CZ(i)).copy(q), p.append(Ke.top), p.parse(), d = ZC.DH.D7(p, i.C, h, !ae)) : d = ZC.DH.D7(q, i.C, h, !ae), d.K = i.K + "-facet2", d.G0 = _e(3), a.add(d), h = [], ae) {
                  for (v = ZC.CX(de, fe); v <= ZC.BQ(de, fe); v += 1) h.push([T + ZC.EN(v) * Ze + ne, z, V + ZC.EG(v) * Ze + le]);
                  for (h.push([T + ZC.EN(v) * Ze + ne, z + i.F, V + ZC.EG(v) * Ze + le]), v = ZC.BQ(ve, me); v >= ZC.CX(ve, me); v -= 1) h.push([T + ZC.EN(v) * Ze + ne, z + i.F, V + ZC.EG(v) * Ze + le]);
                } else {
                  for (v = 0; v <= 180; v += 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze + ne + ue, P + i.F + ZC.EN(v) * (Ze / 2) - he], h.push(u);
                  for (v = 180; v >= 0; v -= 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze + ne + ue, P + ZC.EN(v) * (Ze / 2) - he], h.push(u);
                }
                Ke.front ? ((p = new CZ(i)).copy(j), p.append(Ke.front), p.parse(), _ = ZC.DH.D7(p, i.C, h, !ae)) : _ = ZC.DH.D7(j, i.C, h, !ae), _.K = i.K + "-facet3", _.G0 = _e(2), a.add(_), i.A.FZ && Ae.push(ie + "--front" + ZC._[30] + _.F1() + '" ' + i.a11y() + ' data-z-sort="-100" />', ie + "--top" + ZC._[30] + d.F1() + '" />');
                break;
              case "cone":
                if (h = [], ae) for (v = 0; v <= 360; v += 5) h.push([T + ZC.EN(v) * Ze * Y + ne, z + Z, V + ZC.EG(v) * Ze * Y + le]);else for (v = 0; v <= 360; v += 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze * Y + ne + ue, P + Z + ZC.EN(v) * (Ze / 2) * Y - he], h.push(u);
                if (Ke.bottom ? ((p = new CZ(i)).copy(q), p.append(Ke.bottom), p.parse(), f = ZC.DH.D7(p, i.C, h, !ae)) : f = ZC.DH.D7(q, i.C, h, !ae), f.K = i.K + "-facet1", f.G0 = _e(1), a.add(f), h = [], ae) {
                  for (v = 90 + ce; v <= 270 + ce; v += 5) h.push([T + ZC.EN(v) * Ze * Y + ne, z + Z, V + ZC.EG(v) * Ze * Y + le]);
                  if (i.A.CB && 0 !== w) for (v = 270 + ce; v >= 90 + ce; v -= 5) h.push([T + ZC.EN(v) * Ze * w + ne, z + c, V + ZC.EG(v) * Ze * w + le]);else h.push([T + ne, z + c, V + le]);
                } else {
                  for (v = 0; v <= 180; v += 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze * Y + ne + ue, P + Z + ZC.EN(v) * (Ze / 2) * Y - he], h.push(u);
                  if (i.A.CB && 0 !== w) for (v = 180; v >= 0; v -= 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze * w + ne + ue, P + c + ZC.EN(v) * (Ze / 2) * w - he], h.push(u);else (u = new CC(i.C, 0, 0, 0)).EC = [M + ne + ue, P + c - he], h.push(u);
                }
                if (Ke.front ? ((p = new CZ(i)).copy(j), p.append(Ke.front), p.parse(), _ = ZC.DH.D7(p, i.C, h, !ae)) : _ = ZC.DH.D7(j, i.C, h, !ae), _.K = i.K + "-facet2", _.G0 = _e(2), a.add(_), i.A.CB && 0 !== w) {
                  if (h = [], ae) for (v = 0; v <= 360; v += 5) h.push([T + ZC.EN(v) * Ze * w + ne, z + c, V + ZC.EG(v) * Ze * w + le]);else for (v = 0; v <= 360; v += 5) (u = new CC(i.C, 0, 0, 0)).EC = [M + ZC.EG(v) * Ze * w + ne + ue, P + c + ZC.EN(v) * (Ze / 2) * w - he], h.push(u);
                  Ke.top ? ((p = new CZ(i)).copy(q), p.append(Ke.top), p.parse(), d = ZC.DH.D7(p, i.C, h, !ae)) : d = ZC.DH.D7(q, i.C, h, !ae), d.K = i.K + "-facet3", a.add(d), d.G0 = _e(3);
                }
                i.A.FZ && Ae.push(ie + "--front" + ZC._[30] + _.F1() + '" data-z-sort="-100" />');
            }
            i.A.U && i.A.U.AN && i.F8();
          }
          i.paintPreview(j);
        }
      }
    }, {
      key: "HT",
      value: function HT() {}
    }]);
    return A76;
  }(ZU);
  var A75 = /*#__PURE__*/function (_A9) {
    _inherits(A75, _A9);
    function A75() {
      _classCallCheck(this, A75);
      return _possibleConstructorReturn(this, _getPrototypeOf(A75).apply(this, arguments));
    }
    _createClass(A75, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "OL",
      value: function OL() {
        var e = this;
        e.paint(!0);
        var t = e.C.BJ(e.A.BT("v")[0]),
          i = e.iX + (t.AW ? 0 : e.I),
          a = e.iY + e.F / 2,
          n = new CC(e.C, i - ZC.AP.E2, a - ZC.AP.E1, e.A.E["z-start"]);
        return [ZC._i_(n.EC[0]), ZC._i_(n.EC[1]), {
          reference: e,
          center: !0
        }];
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = _get(_getPrototypeOf(A75.prototype), "HG", this).call(this, e);
        if ("-1/-1" !== t.join("/")) {
          var i = new CC(this.C, t[0] - ZC.AP.E2, t[1] - ZC.AP.E1, this.A.E["z-start"]);
          return [ZC._i_(i.EC[0]), ZC._i_(i.EC[1])];
        }
        return t;
      }
    }, {
      key: "paint",
      value: function paint(e) {
        var t = this;
        _get(_getPrototypeOf(A75.prototype), "paint", this).call(this), typeof e === ZC._[31] && (e = !1);
        var i = t.C.CJ,
          a = t.A.B1,
          n = t.A.CL;
        t.setup();
        var l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d,
          f,
          g = t.A.R5(),
          B = g.AC,
          v = g.ET,
          m = g.CD,
          b = g.CS,
          E = g.F4,
          K = g.D3,
          D = g.F0;
        if (e ? v = t.A.E["node-" + t.L + "-bar-index"] : t.A.E["node-" + t.L + "-bar-index"] = g.ET, t.A.CB) {
          l = 0;
          for (var F = t.A.A.KI[v], I = 0; I < F.length; I++) {
            var x = t.A.A.A4[F[I]].S[t.L];
            x && (l += x.AD);
          }
        }
        var y = 1,
          X = 1;
        if (t.A.CB && (t.CR !== t.AD && (y = (l - t.CR + t.AD) / l), X = (l - t.CR) / l), n.AW) {
          var Y = y;
          y = X, X = Y;
        }
        t.A.M1 && (v = t.L);
        var w = t.iY - B / 2 + m + v * (K + E) - v * D;
        if (w = ZC._l_(w, t.iY - B / 2 + m, t.iY + B / 2 - b), t.A.D3 > 0) {
          var L = K;
          (K = t.A.D3) <= 1 && (K *= L), w += (L - K) / 2;
        }
        var M = K,
          H = t.iX,
          G = null !== ZC._n_(t.A.M5[t.L]) ? t.A.M5[t.L] : 0;
        if (H = t.A.CB && "100%" === t.A.KX ? n.AM(100 * (t.CR + G) / t.A.A.F9[t.L]["%total-" + t.A.DY]) : n.AM(t.CR + G), t.A.CB ? (o = H - (r = "100%" === t.A.KX ? n.AM(100 * (t.CR - t.AD + G) / t.A.A.F9[t.L]["%total-" + t.A.DY]) : n.AM(t.CR - t.AD + G)), t.AD > 0 ? H = r : o = ZC._a_(o), n.AW ? o > 0 ? (o = ZC._a_(o), H = r) : H -= o = ZC._a_(o) : o < 0 && (H = r - (o = ZC._a_(o)))) : H = (o = H - (r = n.AM(G))) < 0 ? r - (o = ZC._a_(o)) : r, m + b === 0 && (w -= .5, M += 1), t.I = o, t.F = M, t.iX = H, t.iY = w, n.AW ? t.AD >= n.HA ? t.iXVal = H : t.iXVal = H + t.I : t.AD >= n.HA ? t.iXVal = H + t.I : t.iXVal = H, !e) {
          var P = H + o - ZC.AP.E2,
            N = w - ZC.AP.E1,
            O = 0,
            S = ZC.AP.FV;
          null !== ZC._n_(t.A.o["z-start"]) && (O = ZC._i_(t.A.o["z-start"])), null !== ZC._n_(t.A.o["z-end"]) && (S = ZC._i_(t.A.o["z-end"]) - O), t.A.E["z-start"] = O, t.A.E["z-mid"] = O + S / 2;
          var Q = t.N = t.A.I5(t, t.N);
          if (Q.DJ = t.K + "-3dfacet", t.A.I1 && (t.GN(Q), Q.parse()), Q.AN) {
            var k = new CZ(t);
            k.copy(Q), k.A0 = ZC.AQ.JP(ZC.AQ.GE(k.A0)), k.AE = ZC.AQ.JP(ZC.AQ.GE(k.AE)), k.BW = ZC.AQ.JP(ZC.AQ.GE(k.BW));
            var T = new CZ(t);
            T.copy(Q), T.A0 = ZC.AQ.JP(ZC.AQ.GE(T.A0), 15), T.AE = ZC.AQ.JP(ZC.AQ.GE(T.AE), 15), T.BW = ZC.AQ.JP(ZC.AQ.GE(T.BW), 15);
            var z = new CZ(t);
            z.copy(Q);
            var V = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6],
              R = ZC.Q.G2("poly", t.A.E8, t.N.J3) + 'class="' + V + '" id="' + t.K,
              J = t.C.EZ.true3d,
              W = t.F / 2,
              U = S / 2,
              j = y * W,
              q = X * W,
              $ = X * U,
              ee = y * U;
            n.AW && !t.A.CB ? (C = t.AD >= 0 ? 0 : t.I, s = t.AD >= 0 ? t.I : 0) : (C = t.AD >= 0 ? t.I : 0, s = t.AD >= 0 ? 0 : t.I);
            var te = t.A.A.HK,
              ie = ZC.CX(U, W),
              ae = t.C.EZ[ZC._[27]],
              ne = t.C.EZ.angle,
              le = ZC.EG(ne) * U,
              re = ZC.EN(ne) * U;
            J || (ie = ZC.CX(2 * re, W));
            var oe = function oe(e) {
                var i = -1,
                  l = t.A.L,
                  r = t.L,
                  o = t.A.A.A4.length,
                  s = t.A.S.length;
                switch ((t.A.CB ? "s" : "") + (a.AW ? "k" : "") + (n.AW ? "v" : "")) {
                  case "":
                  case "v":
                  case "sv":
                    i = 10 * (o - l) + 1e4 * r + e;
                    break;
                  case "k":
                  case "skv":
                  case "kv":
                    i = 10 * (o - l) + 1e4 * (s - r) + e;
                    break;
                  case "s":
                    i = 10 * l + 1e4 * r + e;
                    break;
                  case "sk":
                    i = 10 * l + 1e4 * (s - r) + e;
                }
                return ZC._i_(i);
              },
              se = t.A.o.facets || {};
            switch (t.A.CV) {
              default:
                se.left ? ((A = new CZ(t)).copy(T), A.append(se.left), A.parse(), Z = ZC.DH.DA(A, t.C, P - t.I + .1, P - .1, N + .1, N + .1, O + .1, O + S - .1, "x")) : Z = ZC.DH.DA(T, t.C, P - t.I + .1, P - .1, N + .1, N + .1, O + .1, O + S - .1, "x"), Z.K = t.K + "-facet1", Z.G0 = oe(5), i.add(Z), se.right ? ((A = new CZ(t)).copy(T), A.append(se.right), A.parse(), h = ZC.DH.DA(A, t.C, P - t.I + .1, P - .1, N + t.F - .1, N + t.F - .1, O + .1, O + S - .1, "x")) : h = ZC.DH.DA(T, t.C, P - t.I + .1, P - .1, N + t.F - .1, N + t.F - .1, O + .1, O + S - .1, "x"), h.K = t.K + "-facet2", h.G0 = oe(1), i.add(h), se.bottom ? ((A = new CZ(t)).copy(k), A.append(se.bottom), A.parse(), c = ZC.DH.DA(A, t.C, P - t.I + .1, P - t.I + .1, N + t.F - .1, N + .1, O + .1, O + S - .1, "z")) : c = ZC.DH.DA(k, t.C, P - t.I + .1, P - t.I + .1, N + t.F - .1, N + .1, O + .1, O + S - .1, "z"), c.K = t.K + "-facet3", c.G0 = oe(2), i.add(c), se.top ? ((A = new CZ(t)).copy(k), A.append(se.top), A.parse(), p = ZC.DH.DA(A, t.C, P - .1, P - .1, N + t.F - .1, N + .1, O + .1, O + S - .1, "z")) : p = ZC.DH.DA(k, t.C, P - .1, P - .1, N + t.F - .1, N + .1, O + .1, O + S - .1, "z"), p.K = t.K + "-facet4", p.G0 = oe(3), i.add(p), se.front ? ((A = new CZ(t)).copy(z), A.append(se.front), A.parse(), u = ZC.DH.DA(A, t.C, P - t.I + .1, P - .1, N + t.F - .1, N + .1, O + .1, O + .1, "y")) : u = ZC.DH.DA(z, t.C, P - t.I + .1, P - .1, N + t.F - .1, N + .1, O + .1, O + .1, "y"), u.K = t.K + "-facet5", u.G0 = oe(4), i.add(u), t.A.FZ && (t.A.CB || te.push(R + "--top" + ZC._[30] + p.F1() + '" />'), te.push(R + "--left" + ZC._[30] + Z.F1() + '" />', R + "--right" + ZC._[30] + h.F1() + '" />', R + "--front" + ZC._[30] + u.F1() + '" ' + t.a11y() + ' data-z-sort="-100" />'));
                break;
              case "pyramid":
                se.bottom ? ((A = new CZ(t)).copy(k), A.append(se.bottom), A.parse(), c = ZC.DH.DA(A, t.C, P - C, P - C, N + W - j, N + W + j, U - ee, U + ee, "z")) : c = ZC.DH.DA(k, t.C, P - C, P - C, N + W - j, N + W + j, U - ee, U + ee, "z"), c.K = t.K + "-facet1", c.G0 = oe(n.AW && !t.A.CB ? 6 : 1), i.add(c), f = [[P - C, N + W - j, U - ee], [P - C, N + W + j, U - ee]], t.A.CB && 0 !== X ? f.push([P - s, N + W + q, U - $], [P - s, N + W - q, U - $]) : f.push([P - s, N + W, S / 2]), se.front ? ((A = new CZ(t)).copy(Q), A.append(se.front), A.parse(), u = ZC.DH.D7(A, t.C, f)) : u = ZC.DH.D7(Q, t.C, f), u.K = t.K + "-facet2", u.G0 = oe(3), i.add(u), f = [[P - C, N + W - j, U - ee], [P - C, N + W - j, U + ee]], t.A.CB && 0 !== X ? f.push([P - s, N + W - q, U + $], [P - s, N + W - q, U - $]) : f.push([P - s, N + t.F / 2, S / 2]), se.left ? ((A = new CZ(t)).copy(T), A.append(se.left), A.parse(), Z = ZC.DH.D7(A, t.C, f)) : Z = ZC.DH.D7(T, t.C, f), Z.K = t.K + "-facet3", Z.G0 = oe(4), i.add(Z), f = [[P - C, N + W + j, U - ee], [P - C, N + W + j, U + ee]], t.A.CB && 0 !== X ? f.push([P - s, N + W + q, U + $], [P - s, N + W + q, U - $]) : f.push([P - s, N + W, S / 2]), se.right ? ((A = new CZ(t)).copy(T), A.append(se.right), A.parse(), h = ZC.DH.D7(A, t.C, f)) : h = ZC.DH.D7(T, t.C, f), h.K = t.K + "-facet4", h.G0 = oe(2), i.add(h), t.A.CB && 0 !== X && (se.top ? ((A = new CZ(t)).copy(k), A.append(se.top), A.parse(), p = ZC.DH.DA(A, t.C, P - s, P - s, N + W - q, N + W + q, U - $, U + $, "z")) : p = ZC.DH.DA(k, t.C, P - s, P - s, N + W - q, N + W + q, U - $, U + $, "z"), p.K = t.K + "-facet5", p.G0 = oe(5), i.add(p)), t.A.FZ && te.push(R + "--left" + ZC._[30] + Z.F1() + '" />', R + "--right" + ZC._[30] + h.F1() + '" />', R + "--front" + ZC._[30] + u.F1() + '" ' + t.a11y() + ' data-z-sort="-100" />');
                break;
              case "cylinder":
                if (f = [], J) for (_ = 0; _ <= 360; _ += 5) f.push([P - t.I, N + ZC.EN(_) * ie + W, O + ZC.EG(_) * ie + U]);else for (_ = 0; _ <= 360; _ += 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + ZC.EG(_) * (ie / 2) + le, w + W + ZC.EN(_) * ie - re], f.push(d);
                if (se.bottom ? ((A = new CZ(t)).copy(k), A.append(se.bottom), A.parse(), c = ZC.DH.D7(A, t.C, f, !J)) : c = ZC.DH.D7(k, t.C, f, !J), c.K = t.K + "-facet1", c.G0 = oe(1), i.add(c), f = [], J) {
                  for (_ = 90 - ae; _ <= 270 - ae; _ += 5) f.push([P - t.I, N + ZC.EN(_) * ie + W, O + ZC.EG(_) * ie + U]);
                  for (f.push([P, N + ZC.EN(_) * ie + W, O + ZC.EG(_) * ie + U]), _ = 270 - ae; _ >= 90 - ae; _ -= 5) f.push([P, N + ZC.EN(_) * ie + W, O + ZC.EG(_) * ie + U]);
                } else {
                  for (_ = 90; _ <= 270; _ += 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + ZC.EG(_) * (ie / 2) + le, w + W + ZC.EN(_) * ie - re], f.push(d);
                  for (_ = 270; _ >= 90; _ -= 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + ZC.EG(_) * (ie / 2) + t.I + le, w + W + ZC.EN(_) * ie - re], f.push(d);
                }
                if (se.front ? ((A = new CZ(t)).copy(Q), A.append(se.front), A.parse(), u = ZC.DH.D7(A, t.C, f, !J)) : u = ZC.DH.D7(Q, t.C, f, !J), u.K = t.K + "-facet2", u.G0 = oe(2), i.add(u), f = [], J) for (_ = 0; _ <= 360; _ += 5) f.push([P, N + ZC.EN(_) * ie + W, O + ZC.EG(_) * ie + U]);else for (_ = 0; _ <= 360; _ += 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + ZC.EG(_) * (ie / 2) + t.I + le, w + W + ZC.EN(_) * ie - re], f.push(d);
                se.top ? ((A = new CZ(t)).copy(k), A.append(se.top), A.parse(), p = ZC.DH.D7(A, t.C, f, !J)) : p = ZC.DH.D7(k, t.C, f, !J), p.K = t.K + "-facet3", p.G0 = oe(3), i.add(p), t.A.FZ && te.push(R + "--front" + ZC._[30] + u.F1() + '" ' + t.a11y() + ' data-z-sort="-100" />', R + "--top" + ZC._[30] + p.F1() + '" />');
                break;
              case "cone":
                if (f = [], J) for (_ = 0; _ <= 360; _ += 5) f.push([P - C, N + ZC.EN(_) * ie * y + W, ZC.EG(_) * ie * y + U]);else for (_ = 0; _ <= 360; _ += 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + s + ZC.EG(_) * (ie / 2) * y + le, w + W + ZC.EN(_) * ie * y - re], f.push(d);
                if (se.bottom ? ((A = new CZ(t)).copy(k), A.append(se.bottom), A.parse(), c = ZC.DH.D7(A, t.C, f, !J)) : c = ZC.DH.D7(k, t.C, f, !J), c.K = t.K + "-facet1", c.G0 = oe(1), i.add(c), f = [], J) {
                  for (_ = 90 - ae; _ <= 270 - ae; _ += 5) f.push([P - C, N + ZC.EN(_) * ie * y + W, ZC.EG(_) * ie * y + U]);
                  if (t.A.CB && 0 !== X) for (_ = 270 - ae; _ >= 90 - ae; _ -= 5) f.push([P - s, N + ZC.EN(_) * ie * X + W, ZC.EG(_) * ie * X + U]);else f.push([P - s, N + W, ie]);
                } else {
                  for (_ = 90; _ <= 270; _ += 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + s + ZC.EG(_) * (ie / 2) * y + le, w + W + ZC.EN(_) * ie * y - re], f.push(d);
                  if (t.A.CB && 0 !== X) for (_ = 270; _ >= 90; _ -= 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + C + ZC.EG(_) * (ie / 2) * X + le, w + W + ZC.EN(_) * ie * X - re], f.push(d);else (d = new CC(t.C, 0, 0, 0)).EC = [H + C + le, w + W - re], f.push(d);
                }
                if (se.front ? ((A = new CZ(t)).copy(Q), A.append(se.front), A.parse(), u = ZC.DH.D7(A, t.C, f, !J)) : u = ZC.DH.D7(Q, t.C, f, !J), u.K = t.K + "-facet2", u.G0 = oe(2), i.add(u), t.A.CB && 0 !== X) {
                  if (f = [], J) for (_ = 0; _ <= 360; _ += 5) f.push([P - s, N + ZC.EN(_) * ie * X + W, ZC.EG(_) * ie * X + U]);else for (_ = 0; _ <= 360; _ += 5) (d = new CC(t.C, 0, 0, 0)).EC = [H + C + ZC.EG(_) * (ie / 2) * X + le, w + W + ZC.EN(_) * ie * X - re], f.push(d);
                  se.top ? ((A = new CZ(t)).copy(k), A.append(se.top), A.parse(), p = ZC.DH.D7(A, t.C, f, !J)) : p = ZC.DH.D7(k, t.C, f, !J), p.K = t.K + "-facet3", p.G0 = oe(3), i.add(p);
                }
                t.A.FZ && te.push(R + "--front" + ZC._[30] + u.F1() + '" data-z-sort="-100" />');
            }
          }
          t.A.U && t.A.U.AN && t.F8();
        }
      }
    }, {
      key: "HT",
      value: function HT() {}
    }]);
    return A75;
  }(A03);
  var A74 = /*#__PURE__*/function (_A3I) {
    _inherits(A74, _A3I);
    function A74() {
      _classCallCheck(this, A74);
      return _possibleConstructorReturn(this, _getPrototypeOf(A74).apply(this, arguments));
    }
    _createClass(A74, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.N.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.N.B7,
          "border-color": this.N.B7,
          color: this.N.C2
        };
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = _get(_getPrototypeOf(A74.prototype), "HG", this).call(this, e);
        return new CC(this.C, t[0] - ZC.AP.E2, t[1] - ZC.AP.E1, this.A.E["z-start"]).EC;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i = this;
        _get(_getPrototypeOf(A74.prototype), "paint", this).call(this);
        var a,
          n = i.E.points;
        (a = "none" !== i.A.J7 ? i.N = i.A.I5(i, i.N) : i.N).DJ = i.K + "-3dfacet", i.A.I1 && i.GN(a);
        var l = 0,
          r = -1,
          o = ZC.AP.FV;
        if ("hide" === i.C.getToggleAction()) i.A.CB ? r = 0 : (l = i.A.A.A4.length, r = i.A.L, o /= l);else if (i.A.CB) r = 0;else {
          for (e = 0; e < i.A.A.A4.length; e++) i.C.E["plot" + e + ".visible"] && r++;
          for (e = 0; e < i.A.A.A4.length; e++) i.C.E["plot" + e + ".visible"] && (l++, i.A.L > e && r--);
          o /= l, r = l - r - 1;
        }
        a.A0 = a.AE = a.B7, "spline" === i.A.CV && (a.BW = a.B7);
        var s = i.A.A.HK,
          C = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6],
          A = ZC.Q.G2("poly", i.A.E8, i.N.J3) + 'class="' + C + '" id="' + i.K,
          Z = r * o,
          c = (r + 1) * o;
        if (null !== ZC._n_(i.A.o["z-start"]) && (Z = ZC._i_(i.A.o["z-start"])), null !== ZC._n_(i.A.o["z-end"]) && (c = ZC._i_(i.A.o["z-end"])), null !== ZC._n_(i.A.o.depth)) {
          var p = ZC._i_(i.A.o.depth);
          Z = r * o + o / 2 - p, c = r * o + o / 2 + p;
        }
        i.A.E["z-plots"] = l, i.A.E["z-cnt"] = r, i.A.E["z-depth"] = o, i.A.E["z-start"] = Z, i.A.E["z-mid"] = (Z + c) / 2;
        var u,
          h,
          _,
          d = [],
          f = [],
          g = a;
        ZC._a_(Z - c) <= 2 && (i.C.CJ.SS[i.A.K] || (i.C.CJ.SS[i.A.K] = {
          zIndex: i.A.L,
          style: a,
          points: []
        }, i.C.CJ.SS[i.A.K].style.MH = !1, i.C.CJ.SS[i.A.K].style.AZ = ZC.BQ(1, ZC._i_(ZC._a_(Z - c) / 1))));
        for (var B = 0; B < n.length - 1; B++) {
          if (ZC._a_(Z - c) > 2) {
            var v = -ZC._i_(ZC.UE(Math.atan((n[B + 1][1] - n[B][1]) / (n[B + 1][0] - n[B][0]))));
            (g = new CZ(i)).copy(a), g.A0 = ZC.AQ.JP(ZC.AQ.GE(g.A0), v), g.AE = ZC.AQ.JP(ZC.AQ.GE(g.AE), v), g.BW = ZC.AQ.JP(ZC.AQ.GE(g.BW), v);
          }
          var m, b, E, K;
          if (i.A.oP0 && ZC._a_(Z - c) <= 2 ? ((m = i.A.oP0).parse(i.C, n[B][0] - ZC.AP.E2, n[B][1] - ZC.AP.E1, Z), (b = i.A.oP1).parse(i.C, n[B + 1][0] - ZC.AP.E2, n[B + 1][1] - ZC.AP.E1, Z), (E = i.A.oP2).parse(i.C, n[B + 1][0] - ZC.AP.E2, n[B + 1][1] - ZC.AP.E1, c - 1), (K = i.A.oP3).parse(i.C, n[B][0] - ZC.AP.E2, n[B][1] - ZC.AP.E1, c - 1)) : (m = i.A.oP0 = new CC(i.C, n[B][0] - ZC.AP.E2, n[B][1] - ZC.AP.E1, Z), b = i.A.oP1 = new CC(i.C, n[B + 1][0] - ZC.AP.E2, n[B + 1][1] - ZC.AP.E1, Z), E = i.A.oP2 = new CC(i.C, n[B + 1][0] - ZC.AP.E2, n[B + 1][1] - ZC.AP.E1, c - 1), K = i.A.oP3 = new CC(i.C, n[B][0] - ZC.AP.E2, n[B][1] - ZC.AP.E1, c - 1)), ZC._a_(Z - c) > 2 ? ((u = new A07(g, i.C)).K = i.K + "-facet" + B, u.add(m), u.add(b), u.add(E), u.add(K), i.C.CJ.add(u)) : (i.C.CJ.SS[i.A.K].points.push(m.EC), B === n.length - 2 && i.C.CJ.SS[i.A.K].points.push(b.EC), "spline" === i.A.CV && (m = new CC(i.C, n[B][0] - ZC.AP.E2, n[B][1] - ZC.AP.E1, Z - 10), K = new CC(i.C, n[B][0] - ZC.AP.E2, n[B][1] - ZC.AP.E1, c - 1 + 10))), d.push(m.EC), f.push(K.EC), i.A.FZ && "spline" !== i.A.CV) if (ZC._a_(Z - c) > 2) t = u.F1();else {
            for (h = ZC.AR.ZJ([m.EC, b.EC], 4), _ = 0; _ < h.length; _++) h[_][0] = Math.round(h[_][0]), h[_][1] = Math.round(h[_][1]);
            t = h.join(",");
          }
          "spline" !== i.A.CV && i.A.FZ && s.push(A + "--face" + B + '" ' + i.a11y() + ' coords="' + t + '" />');
        }
        "spline" === i.A.CV ? (i.E.polypoints = !0, i.E.points = d.concat(f.reverse())) : i.E.points = null, i.A.A2.o && ("spline" === i.A.CV || "none" === i.A.A2.o.type || null !== ZC._n_(i.A.A2.o.visible) && !ZC._b_(i.A.A2.o.visible)) && "spline" !== i.A.CV || i.OT(!0), i.A.U && i.A.U.AN && i.F8(), i.paintPreview(a, n);
      }
    }, {
      key: "HT",
      value: function HT() {}
    }]);
    return A74;
  }(A3I);
  var A73 = /*#__PURE__*/function (_A3J) {
    _inherits(A73, _A3J);
    function A73() {
      _classCallCheck(this, A73);
      return _possibleConstructorReturn(this, _getPrototypeOf(A73).apply(this, arguments));
    }
    _createClass(A73, [{
      key: "setup",
      value: function setup() {
        this.S0();
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.N.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.N.B7,
          "border-color": this.N.B7,
          color: this.N.C2
        };
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = _get(_getPrototypeOf(A73.prototype), "HG", this).call(this, e);
        return new CC(this.C, t[0] - ZC.AP.E2, t[1] - ZC.AP.E1, this.A.E["z-start"]).EC;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i = this;
        _get(_getPrototypeOf(A73.prototype), "paint", this).call(this);
        var a = i.A.CL,
          n = a.HA,
          l = a.AM(n);
        l = ZC._l_(l, a.iY, a.iY + a.F);
        var r,
          o = i.E.points,
          s = i.E.pointsarea;
        (r = "none" !== i.A.J7 ? i.N = i.A.I5(i, i.N) : i.N).DJ = i.K + "-3dfacet", i.A.I1 && i.GN(r);
        var C = 0,
          A = -1,
          Z = ZC.AP.FV;
        if ("hide" === i.C.getToggleAction()) i.A.CB ? A = 0 : (C = i.A.A.A4.length, A = i.A.L, Z /= C);else if (i.A.CB) A = 0;else {
          for (e = 0; e < i.A.A.A4.length; e++) i.C.E["plot" + e + ".visible"] && A++;
          for (e = 0; e < i.A.A.A4.length; e++) i.C.E["plot" + e + ".visible"] && (C++, i.A.L > e && A--);
          Z /= C, A = C - A - 1;
        }
        var c = new CZ(i);
        c.copy(r), c.A0 = c.AE = r.B7, "spline" === i.A.CV && (c.BW = r.B7);
        var p = new CZ(i);
        p.copy(r), p.LD = !0, p.AU = 0, p.C6 = i.A.I6, p.A0 = ZC.AQ.R2(ZC.AQ.GE(p.A0), 30), p.AE = ZC.AQ.R2(ZC.AQ.GE(p.AE), 30);
        var u,
          h,
          _ = i.A.A.HK,
          d = i.C.K + ZC._[34] + i.C.K + ZC._[35] + i.A.L + ZC._[6],
          f = ZC.Q.G2("poly", i.A.E8, i.N.J3) + 'class="' + d + '" id="' + i.K,
          g = [],
          B = [],
          v = A * Z,
          m = (A + 1) * Z;
        if (null !== ZC._n_(i.A.o["z-start"]) && (v = ZC._i_(i.A.o["z-start"])), null !== ZC._n_(i.A.o["z-end"]) && (m = ZC._i_(i.A.o["z-end"])), null !== ZC._n_(i.A.o.depth)) {
          var b = ZC._i_(i.A.o.depth);
          v = A * Z + Z / 2 - b, m = A * Z + Z / 2 + b;
        }
        i.A.E["z-plots"] = C, i.A.E["z-cnt"] = A, i.A.E["z-depth"] = Z, i.A.E["z-start"] = v, i.A.E["z-mid"] = (v + m) / 2;
        var E = new A07(p, i.C);
        for (u = 0, h = s.length; u < h; u++) {
          var K = new CC(i.C, s[u][0] - ZC.AP.E2, s[u][1] - ZC.AP.E1, v);
          E.add(K);
        }
        i.C.CJ.add(E), i.E.pointsarea = s, i.L === i.A.S.length - 1 && ((E = new A07(p, i.C)).add(new CC(i.C, i.iX - .5 - ZC.AP.E2, i.iY - ZC.AP.E1, v)), E.add(new CC(i.C, i.iX - .5 - ZC.AP.E2, l - ZC.AP.E1, v)), E.add(new CC(i.C, i.iX - .5 - ZC.AP.E2, l - ZC.AP.E1, m - 1)), E.add(new CC(i.C, i.iX - .5 - ZC.AP.E2, i.iY - ZC.AP.E1, m - 1)), E.K = i.K + "-facet99", i.C.CJ.add(E));
        var D = r;
        for (ZC._a_(v - m) <= 2 && (i.C.CJ.SS[i.A.K] || (i.C.CJ.SS[i.A.K] = {
          zIndex: i.A.L,
          style: r,
          points: []
        }, i.C.CJ.SS[i.A.K].style.MH = !1, i.C.CJ.SS[i.A.K].style.AZ = ZC.BQ(1, ZC._i_(ZC._a_(v - m) / 1)))), u = 0; u < o.length - 1; u++) {
          if (ZC._a_(v - m) > 2) {
            var F = -ZC._i_(ZC.UE(Math.atan((o[u + 1][1] - o[u][1]) / (o[u + 1][0] - o[u][0]))));
            (D = new CZ(i)).copy(c), D.A0 = ZC.AQ.JP(ZC.AQ.GE(D.A0), F), D.AE = ZC.AQ.JP(ZC.AQ.GE(D.AE), F), D.BW = ZC.AQ.JP(ZC.AQ.GE(D.BW), F);
          }
          var I = new CC(i.C, o[u][0] - ZC.AP.E2, o[u][1] - ZC.AP.E1, v),
            x = new CC(i.C, o[u + 1][0] - ZC.AP.E2, o[u + 1][1] - ZC.AP.E1, v),
            y = new CC(i.C, o[u + 1][0] - ZC.AP.E2, o[u + 1][1] - ZC.AP.E1, m - 1),
            X = new CC(i.C, o[u][0] - ZC.AP.E2, o[u][1] - ZC.AP.E1, m - 1);
          if (ZC._a_(v - m) > 2 ? ((E = new A07(D, i.C)).K = i.K + "-facet" + u, E.add(I), E.add(x), E.add(y), E.add(X), i.C.CJ.add(E)) : (i.C.CJ.SS[i.A.K].points.push(I.EC), u === o.length - 2 && i.C.CJ.SS[i.A.K].points.push(x.EC), "spline" === i.A.CV && (I = new CC(i.C, o[u][0] - ZC.AP.E2, o[u][1] - ZC.AP.E1, v - 10), X = new CC(i.C, o[u][0] - ZC.AP.E2, o[u][1] - ZC.AP.E1, m - 1 + 10))), g.push(I.EC), B.push(X.EC), i.A.FZ && "spline" !== i.A.CV) if (ZC._a_(v - m) > 2) t = E.F1();else {
            for (var Y = ZC.AR.ZJ([E.D[0].EC, E.D[1].EC], 4), w = 0; w < Y.length; w++) Y[w][0] = Math.round(Y[w][0]), Y[w][1] = Math.round(Y[w][1]);
            t = Y.join(",");
          }
          "spline" !== i.A.CV && i.A.FZ && _.push(f + "--face" + u + ZC._[30] + t + '" />');
        }
        "spline" === i.A.CV ? (i.E.polypoints = !0, i.E.points = g.concat(B.reverse())) : i.E.points = null, i.A.A2.o && ("none" === i.A.A2.o.type || null !== ZC._n_(i.A.A2.o.visible) && !ZC._b_(i.A.A2.o.visible)) && "spline" !== i.A.CV || i.OT(!0), i.A.U && i.A.U.AN && i.F8(), i.paintPreview(r, o, s);
      }
    }, {
      key: "HT",
      value: function HT() {}
    }]);
    return A73;
  }(A3J);
  var A8F = /*#__PURE__*/function (_MI17) {
    _inherits(A8F, _MI17);
    function A8F(e) {
      var _this98;
      _classCallCheck(this, A8F);
      _this98 = _possibleConstructorReturn(this, _getPrototypeOf(A8F).call(this, e)), _this98.XI = 0, _this98.XH = 0;
      return _this98;
    }
    _createClass(A8F, [{
      key: "ES",
      value: function ES(e, t, i, a) {
        var n = this,
          l = null;
        return l = n.A.L < n.A.A.A4.length - 1 ? n.A.A.A4[n.A.L + 1] : n.A.A.A4[0], n.CU = [["%paired-plot-text", l.AO], ["%paired-node-value", l.S[n.L].AD], ["%joined-value", n.XH], ["%shared-value", null === ZC._n_(n.A.A.XV[n.L]) ? 0 : n.A.A.XV[n.L].area]], e = _get(_getPrototypeOf(A8F.prototype), "ES", this).call(this, e, t, i, a);
      }
    }, {
      key: "setup",
      value: function setup() {
        var e = this,
          t = e.C.BJ("scale"),
          i = e.L % t.H5,
          a = Math.floor(e.L / t.H5);
        e.iX = t.iX + i * t.GM + t.GM / 2 + t.BM, e.iY = t.iY + a * t.GG + t.GG / 2 + t.BH, e.IP || (e.copy(e.A), e.E5 = e.A.E5, e.DB() && e.parse(!1), e.IP = !0), e.I = t.GM / 2, e.F = t.GG / 2;
      }
    }, {
      key: "HG",
      value: function HG(e) {
        var t = this,
          i = e.I,
          a = e.F,
          n = t.iX - i / 2,
          l = t.iY - a / 2;
        if (3 === t.A.A.A4.length) switch (t.A.L) {
          case 0:
            n -= t.AI / 4, l += t.AI / 8;
            break;
          case 1:
            n += t.AI / 4, l += t.AI / 8;
            break;
          case 2:
            l -= t.AI / 4;
        } else switch (t.A.L) {
          case 0:
            n -= t.AI / 4;
            break;
          case 1:
            n += t.AI / 4;
        }
        return null !== ZC._n_(e.o.x) && (n = e.iX), null !== ZC._n_(e.o.y) && (l = e.iY), n += e.BM, l += e.BH, [ZC._i_(n), ZC._i_(l)];
      }
    }, {
      key: "F8",
      value: function F8() {
        var e,
          t,
          i = this,
          a = _get(_getPrototypeOf(A8F.prototype), "F8", this).call(this),
          n = i.C.K + "-value-box " + i.C.K + "-plot-" + i.A.L + "-value-box zc-value-box",
          l = i.H.usc() ? i.H.mc("top") : i.C.AJ["3d"] || i.H.KE ? ZC.AK(i.C.K + "-plots-vb-c") : ZC.AK(i.C.K + "-plot-" + i.A.L + "-vb-c"),
          r = i.H.usc() ? ZC.AK(i.C.A.K + "-top") : ZC.AK(i.C.A.K + "-text");
        if (null !== ZC._n_(a.o.joined)) {
          if (0 === i.A.L && !i.C.E["plot1.visible"] || 1 === i.A.L && !i.C.E["plot2.visible"] || 2 === i.A.L && !i.C.E["plot0.visible"]) return;
          i.A.L < i.A.A.A4.length - 1 ? i.A.A.A4[i.A.L + 1] : i.A.A.A4[0], e = i.A.A.DU[i.A.L][i.L].intxy, (t = new DT(i)).copy(a), t.o.text = "" + i.XH, t.append(a.o.joined), t.ES = function (e) {
            return i.ES(e, {});
          }, t.parse(), t.GO = n, t.K = i.K + "-value-box-join", t.Z = a.C7 = l, t.IW = r, t.iX = e[0] - t.I / 2, t.iY = e[1] - t.F / 2, t.AN && (t.paint(), t.ED());
        }
        if (null !== ZC._n_(a.o.shared) && 2 === i.A.L) {
          if (!i.C.E["plot0.visible"] || !i.C.E["plot1.visible"] || !i.C.E["plot2.visible"]) return;
          e = i.A.A.XV[i.L].xy, (t = new DT(i)).copy(a), t.o.text = "" + i.A.A.HK[i.A.L], t.append(a.o.shared), t.ES = function (e) {
            return i.ES(e, {});
          }, t.parse(), t.GO = n, t.K = i.K + "-value-box-shared", t.Z = a.C7 = l, t.IW = r, t.iX = e[0] - t.I / 2, t.iY = e[1] - t.F / 2, t.AN && (t.paint(), t.ED());
        }
      }
    }, {
      key: "JC",
      value: function JC() {
        return {
          color: this.B7
        };
      }
    }, {
      key: "KD",
      value: function KD() {
        return {
          "background-color": this.BW,
          "border-color": this.BW,
          color: this.C2
        };
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t = this;
        if (t.A.L >= 3) t.A.U && t.F8();else {
          _get(_getPrototypeOf(A8F.prototype), "paint", this).call(this);
          var i = t.N = t.A.I5(t, t),
            a = new DW(t.A);
          a.K = t.K, a.Z = t.A.CN("bl", 1), a.C7 = t.A.CN("bl", 0), a.copy(i);
          var n = t.iX,
            l = t.iY;
          if (a.iX = n, a.iY = l, a.AI = t.AI, a.DQ = "circle", a.E.plotidx = t.A.L, a.E.nodeidx = t.L, a.parse(), t.FQ = a, t.A.GI && !t.C.HO) {
            var r = a,
              o = {};
            r.iX = n, r.iY = l, o.x = n, o.y = l;
            var s = t.A.LL;
            if (r.C6 = 0, o.alpha = i.C6, 3 === s) r.AI = 2, o.size = t.AI;else if (4 === s) {
              switch (t.A.L) {
                case 0:
                  r.iX = n - 3 * t.AI, r.iY = l;
                  break;
                case 1:
                  r.iX = n + 3 * t.AI, r.iY = l;
                  break;
                case 2:
                  r.iX = n, r.iY = l - 3 * t.AI;
              }
              o.x = n, o.y = l;
            }
            for (e in t.A.FW) r[EB.GP[ZC.EE(e)]] = t.A.FW[e], o[ZC.EE(e)] = i[EB.GP[ZC.EE(e)]];
            if (t.C.EM || (t.C.EM = {}), null !== ZC._n_(t.C.EM[t.A.L + "-" + t.L])) for (e in t.C.EM[t.A.L + "-" + t.L]) r[EB.GP[ZC.EE(e)]] = t.C.EM[t.A.L + "-" + t.L][e];
            t.C.EM[t.A.L + "-" + t.L] = {}, ZC._cp_(o, t.C.EM[t.A.L + "-" + t.L]);
            var C = new EB(r, o, t.A.JL, t.A.LE, EB.RW[t.A.LI], function () {
              A();
            });
            C.AX = t, t.L9(C);
          } else a.paint(), A();
        }
        function A() {
          var e = t.C.K + ZC._[34] + t.C.K + ZC._[35] + t.A.L + ZC._[6],
            i = ZC.Q.G2("circle", t.A.E8, t.A.J3) + 'class="' + e + '" ' + t.a11y() + ' id="' + t.K + ZC._[30] + ZC._i_(t.iX + ZC.MAPTX) + "," + ZC._i_(t.iY + ZC.MAPTX) + "," + ZC._i_(ZC.BQ(ZC.mobile ? 6 : 3, t.AI) * (ZC.mobile ? 2 : 1.2)) + '" />';
          t.A.A.HK.push(i), t.A.U && t.F8();
        }
      }
    }, {
      key: "HT",
      value: function HT(e) {
        var t = this;
        ZC.move || t.LN({
          layer: e,
          type: "shape",
          initcb: function initcb() {
            this.DQ = "circle", this.A0 = t.A.BP[3], this.AE = t.A.BP[3];
          },
          setupcb: function setupcb() {
            this.iX = t.iX, this.iY = t.iY, this.AI = t.AI;
          }
        });
      }
    }]);
    return A8F;
  }(MI);
  MI.prototype.MR = function (e, t) {
    var i,
      a,
      n = this;
    if (typeof t === ZC._[31] && (t = !1), t) typeof n.E.pointserror !== ZC._[31] && ((i = new CZ(n)).copy(n.A), n.A.JI && (i.copy(n.A.JI), i.append(n.A.JI.o[ZC._[71]])), i.parse(), i.K = n.K + "--error-hover", i.AN && ZC.CQ.paint(e, i, n.E.pointserror));else {
      var l = n.A.CL,
        r = n.A.B1;
      if (0 !== n.A.SG.length) {
        var o = null,
          s = null,
          C = !0;
        n.A.SG.length <= 2 ? (null !== ZC._n_(n.A.SG[0]) && n.A.SG[0] instanceof Array && (C = !1), null !== ZC._n_(n.A.SG[1]) && n.A.SG[1] instanceof Array && (C = !1)) : C = !1, C ? (o = n.A.SG[0], s = n.A.SG[1]) : null !== ZC._n_(a = n.A.SG[n.L]) && a instanceof Array && (o = s = a[0], 2 === a.length && (s = a[1])), n.E["node-error-plus"] = o, n.E["node-error-minus"] = s, -1 !== (o + "").indexOf("%") && (o = ZC.IU(o)) <= 1 && (o *= n.AD), -1 !== (s + "").indexOf("%") && (s = ZC.IU(s)) <= 1 && (s *= n.AD);
        var A = [],
          Z = ZC.IU(n.A.JI && n.A.JI.o[ZC._[21]] || .5);
        Z <= 1 && (Z = "vbar" === n.A.AF ? ZC._i_(Z * n.I) : "hbar" === n.A.AF ? ZC._i_(Z * n.F) : ZC._i_(Z * r.AC));
        var c,
          p = 0;
        if (p = r.CO ? n.F : n.I, null !== ZC._n_(o)) {
          var u = l.AM(n.CR + o);
          r.CO ? (c = l.AW ? n.AD < 0 ? n.iX + n.I : n.iX : n.AD > 0 ? n.iX + n.I : n.iX, A.push([u, n.iY + p / 2 - Z / 2], [u, n.iY + p / 2 + Z / 2], null, [u, n.iY + p / 2], [c, n.iY + p / 2])) : (c = l.AW ? n.AD > 0 ? n.iY + n.F : n.iY : n.AD < 0 ? n.iY + n.F : n.iY, A.push([n.iX + p / 2 - Z / 2, u], [n.iX + p / 2 + Z / 2, u], null, [n.iX + p / 2, u], [n.iX + p / 2, c]));
        }
        if (null !== ZC._n_(s)) {
          var h = l.AM(n.CR - s);
          r.CO ? (c = l.AW ? n.AD < 0 ? n.iX + n.I : n.iX : n.AD > 0 ? n.iX + n.I : n.iX, A.push(null, [h, n.iY + p / 2 - Z / 2], [h, n.iY + p / 2 + Z / 2], null, [h, n.iY + p / 2], [c, n.iY + p / 2])) : (c = l.AW ? n.AD > 0 ? n.iY + n.F : n.iY : n.AD < 0 ? n.iY + n.F : n.iY, A.push(null, [n.iX + p / 2 - Z / 2, h], [n.iX + p / 2 + Z / 2, h], null, [n.iX + p / 2, h], [n.iX + p / 2, c]));
        }
        (i = new CZ(n)).copy(n.A), n.A.JI && i.copy(n.A.JI), i.parse(), i.K = n.K + "--error", i.CY = !1, ZC.CQ.paint(e, i, A), n.E.pointserror = A;
      }
    }
  };
  var HF = /*#__PURE__*/function (_I7) {
    _inherits(HF, _I7);
    function HF(e) {
      var _this99;
      _classCallCheck(this, HF);
      _this99 = _possibleConstructorReturn(this, _getPrototypeOf(HF).call(this, e));
      var t = _assertThisInitialized(_this99);
      t.H = t.A.A, t.BG = "", t.V = [], t.BY = [], t.A65 = [], t.DI = !1, t.M = null, t.BR = null, t.J2 = null, t.D6 = null, t.FU = 0, t.II = null, t.G6 = null, t.HA = 0, t.PF = null, t.L = 1, t.AB = 0, t.A4W = 0, t.BV = 0, t.AW = !1, t.CO = !1, t.AC = 0, t.iStepMultiplier = 1, t.DM = -1, t.RO = ZC.HQ[ZC._[13]] || "", t.S9 = ZC.HQ[ZC._[14]] || ".", t.A0E = !1, t.SU = 2, t.A3L = !1, t.UC = "", t.A0D = "standard", t.CH = null, t.AF = "", t.EH = ZC.MAX, t.MB = ZC.MAX, t.GQ = !1, t.YQ = !1, t.KT = null, t.O0 = null, t.QI = [], t.E3 = 1, t.B3 = -1, t.BL = -1, t.SR = -1, t.FX = -1, t.H4 = -1, t.C1 = "lin", t.E4 = 10, t.FI = null, t.PE = 1, t.QD = !0, t.A12 = !1, t.aAutoFit = [!1, !1], t.M4 = null, t.X9 = null, t.TM = !1, t.I9 = -1, t.ZO = !1, t.BA = "default", t.QE = !1, t.W2 = !1, t.RE = 1, t.sMaster = "", t.bNormalize = !0, t.bAllowDuplicates = !1;
      return _this99;
    }
    _createClass(HF, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(HF.prototype), "parse", this).call(this);
        var e,
          t = this;
        if (null !== ZC._n_(e = t.o.step)) if (ZC.PL(e)) t.E3 = ZC._f_(e);else {
          var i = e.replace(/[0-9]/gi, ""),
            a = parseInt(e.replace(/[^0-9]/gi, ""), 10);
          switch (a = a || 1, i) {
            case "second":
              t.E3 = 1e3 * a;
              break;
            case "minute":
              t.E3 = 1e3 * a * 60;
              break;
            case "hour":
              t.E3 = 1e3 * a * 60 * 60;
              break;
            case "day":
              t.E3 = 1e3 * a * 60 * 60 * 24;
              break;
            case "week":
              t.E3 = 1e3 * a * 60 * 60 * 24 * 7;
              break;
            case "month":
              t.E3 = 2629743e3 * a;
              break;
            case "year":
              t.E3 = 31556926e3 * a;
          }
        }
        if (null !== ZC._n_(t.o.multiplier) && null === ZC._n_(t.o.short) && (t.o.short = t.o.multiplier), t.assign_a([[ZC._[10], "BY"], ["tooltip-text", "A65"], ["format", "CH"], ["offset-start", "AB", "i"], ["offset-start", "A4W", "i"], ["offset-end", "BV", "i"], ["minor-ticks", "FU", "i"], ["step-multiplier", "iStepMultiplier", "i"], ["index", "L", "i"], ["mirrored", "AW", "b"], ["zooming", "GQ", "b"], ["zoom-snap", "YQ", "b"], ["fixed-step", "QE", "b"], ["zoom-to", "KT"], ["force-view", "ZO", "b"], ["zoom-to-values", "O0"], ["items-overlap", "A12", "b"], ["used", "TM", "b"], ["max-labels", "EH", "i"], ["max-items", "EH", "i"], ["ref-value", "HA", "f"], [ZC._[12], "DM", "ia"], [ZC._[14], "S9"], [ZC._[13], "RO"], ["short", "A3L", "b"], ["short-unit", "UC"], ["negation", "A0D"], ["exponent", "A0E", "b"], [ZC._[25], "SU", "ia"], ["progression", "C1"], ["log-base", "E4", "fa"], ["scale-factor", "PE", "fa"], ["show-labels", "M4"], ["max-decimals", "I9", "i"], [ZC._[7], "BA"], ["factor", "RE", "f"], ["master", "sMaster"], ["blended", "W2", "b"], ["ranged", "DI", "b"], ["normalize", "bNormalize", "b"], ["allow-duplicates", "bAllowDuplicates", "b"]]), "log" === t.C1 && (null === ZC._n_(t.o["minor-ticks"]) && (t.FU = Math.max(0, t.E4 - 2)), null !== ZC._n_(t.KT) && "v" === t.AF && (t.KT[0] = ZC.G8(t.KT[0], t.E4), t.KT[1] = ZC.G8(t.KT[1], t.E4))), null !== ZC._n_(e = t.o["auto-fit"]) && (e.length ? (t.aAutoFit[0] = ZC._b_(e[0]), t.aAutoFit[1] = ZC._b_(e[e.length - 1])) : t.aAutoFit[0] = t.aAutoFit[1] = ZC._b_(e)), "string" == typeof t.BY) {
          var n = t.BY.split(":"),
            l = 1;
          3 === n.length && (l = ZC._f_(n[2])), t.BY = [];
          for (var r = ZC._f_(n[0]); r < ZC._f_(n[1]); r += l) t.BY.push("" + r);
          t.BY.push("" + n[1]);
        }
        null !== ZC._n_(t.o["fixed-items"]) && (t.EH = ZC.MAX), t.EH = ZC.BQ(t.EH, 2), null !== ZC._n_(e = t.o.offset) && (t.AB = t.BV = ZC._i_(e), 0 !== ZC._i_(e) || "mixed" !== t.A.AF && "mixed3d" !== t.A.AF || (t.DI = !1)), null !== ZC._n_(e = t.o["max-ticks"]) ? t.MB = ZC._i_(e) : t.MB = t.EH, t.MB = ZC.BQ(2, t.MB), null !== ZC._n_(e = t.o.transform) && (t.FI = new CZ(), t.FI.append(e));
        var o = t.A.A.B8,
          s = "(" + t.A.AF + ")",
          C = t.BG.replace(/\-[0-9]/, ""),
          A = t.BG.replace(/\-[0-9]/, "-n");
        function Z(e) {
          var i = [s + ".SCALE." + e, s + "." + t.BG + "." + e, s + "." + C + "." + e, s + "." + C + "[" + t.BA + "]." + e, s + "." + A + "." + e];
          return t.A.AJ["3d"] && (i = i.concat([s + ".SCALE[3d]." + e, s + "." + t.BG + "[3d]." + e, s + "." + C + "[3d]." + e, s + "." + A + "[3d]." + e])), i;
        }
        if (null === ZC._n_(t.o[ZC._[7]]) && t.L > 1 && (t.BA = "opposite"), null !== ZC._n_(e = t.o.markers)) for (var c = 0, p = e.length; c < p; c++) {
          var u = new A9K(t);
          u.L = c, u.K = t.K + "-marker-" + c, o.load(u.o, Z("marker")), u.append(e[c]), u.parse(), t.QI.push(u);
        }
        t.PF = new CZ(t), o.load(t.PF.o, Z("ref-line")), t.PF.append(t.o["ref-line"]), "k" === t.AF && (t.PF.AN = !1), t.PF.parse(), t.M = new DT(t), o.load(t.M.o, Z("label")), t.M.append(t.o.label), t.M.K = t.K + "-label", t.M.parse(), t.BR = new DT(t), o.load(t.BR.o, Z("item")), t.BR.append(t.o.item), t.BR.K = t.K + "-item", t.BR.parse(), t.J2 = new CZ(t), o.load(t.J2.o, Z("tick")), t.J2.append(t.o.tick), t.J2.parse(), t.D6 = new CZ(t), o.load(t.D6.o, Z("guide")), t.D6.append(t.o.guide), t.D6.parse(), null === ZC._n_(t.D6.o.items) && "-1" !== t.D6.A0 && "-1" !== t.D6.AE && t.D6.A0 !== t.D6.AE && (t.D6.o.items = [{
          alpha: t.D6.C6,
          "background-color": t.D6.A0
        }, {
          alpha: t.D6.C6,
          "background-color": t.D6.AE
        }]), t.II = new CZ(t), o.load(t.II.o, Z("minor-tick")), t.II.append(t.o["minor-tick"]), t.II.parse(), t.G6 = new CZ(t), o.load(t.G6.o, Z("minor-guide")), t.G6.append(t.o["minor-guide"]), t.G6.parse(), t.X1();
      }
    }, {
      key: "X1",
      value: function X1() {
        var e,
          t = this,
          i = {
            x: "iX",
            y: "iY",
            width: "I",
            height: "F"
          };
        for (var a in i) {
          var n = t.A.P[i[a]];
          null !== ZC._n_(t.o[a]) && (n = ZC.IU(t.o[a])) >= 0 && n <= 1 && (n = "x" === a || "y" === a ? t.A.P["x" === a ? "iX" : "iY"] + ZC._i_(n * t.A.P["x" === a ? "I" : "F"]) : ZC._i_(n * t.A.P[i[a]])), t[i[a]] = n;
        }
        null !== ZC._n_(e = t.o.offset) && (t.AB = t.BV = ZC._f_(ZC._p_(e))), null !== ZC._n_(e = t.o["offset-start"]) && (t.AB = ZC._f_(ZC._p_(e))), null !== ZC._n_(e = t.o["offset-end"]) && (t.BV = ZC._f_(ZC._p_(e)));
        var l = "k" === t.AF && !t.CO || "v" === t.AF && t.CO ? t.I : t.F;
        t.AB < 1 && (t.AB *= l), t.BV < 1 && (t.BV *= l);
      }
    }, {
      key: "W9",
      value: function W9(e) {
        var t = this;
        null !== ZC._n_(t.o.rules) && (t.X9 || (t.X9 = new HF(t.A)), t.X9.append(t.o), t.X9.parse(), t.X9.IV = e, t.X9.DB() && (t.X9.parse(), t.DM = t.X9.DM, t.CH = t.X9.CH));
      }
    }, {
      key: "H0",
      value: function H0() {}
    }, {
      key: "T9",
      value: function T9() {}
    }, {
      key: "ZX",
      value: function ZX() {}
    }, {
      key: "HE",
      value: function HE() {}
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {}
    }, {
      key: "LV",
      value: function LV() {
        var e,
          t = this,
          i = {
            negation: t.A0D,
            "thousands-separator": t.RO,
            "decimals-separator": t.S9,
            decimals: t.DM,
            "max-decimals": t.I9,
            short: t.A3L,
            "short-unit": t.UC,
            exponent: t.A0E,
            "exponent-decimals": t.SU
          };
        if (t.FI) switch (t.FI.o.type) {
          case "date":
            i[ZC._[68]] = !0, null !== ZC._n_(e = t.FI.o.text) && (t.FI.o.all = e);
            var a = t.V[t.A1] - t.V[t.W],
              n = "",
              l = "",
              r = {},
              o = ["msecond", "second", "minute", "hour", "day", "month", "year"];
            for (var s in o) r[o[s]] = ZC.HQ["date-formats"][o[s]];
            l = 0 <= a && a <= 1e3 ? "msecond" : 1e3 < a && a <= 36e5 ? "second" : 36e5 < a && a <= 864e5 ? "minute" : 864e5 < a && a <= 26784e5 ? "hour" : 26784e5 < a && a <= 316224e5 ? "day" : 316224e5 < a && a <= 632448e6 ? "month" : "year", n = null !== ZC._n_(t.FI.o[l]) ? t.FI.o[l] : null !== ZC._n_(t.FI.o.all) ? t.FI.o.all : r[l], t.E.dateformat = n, i[ZC._[67]] = t.E.dateformat;
        }
        return i;
      }
    }, {
      key: "YA",
      value: function YA() {
        for (var e = this, t = e.A.AY.A4, i = -1, a = 0, n = t.length; a < n; a++) {
          var l = t[a].BT(e.AF);
          if (-1 !== ZC.AV(l, e.BG)) {
            switch (t[a].AF) {
              case "pie":
              case "pie3d":
              case "nestedpie":
              case "vbar":
              case "vbar3d":
              case "hbar":
              case "hbar3d":
              case "vbullet":
              case "hbullet":
              case "area":
              case "area3d":
              case "gauge":
              case "vfunnel":
              case "hfunnel":
              case "venn":
                i = t[a].A0;
                break;
              case "scatter":
              case "bubble":
                i = -1 !== t[a].A2.A0 ? t[a].A2.A0 : t[a].A0;
                break;
              default:
                i = t[a].B7;
            }
            break;
          }
        }
        return i;
      }
    }, {
      key: "paint",
      value: function paint() {
        this.build(), this.A.AJ["3d"] || _get(_getPrototypeOf(HF.prototype), "paint", this).call(this);
      }
    }, {
      key: "MC",
      value: function MC(e, t, i, a) {
        var n = this;
        if (null === ZC._n_(a) && (a = 5), n.A.AJ["3d"]) {
          var l = new CC(n.A, e.iX + e.I / 2 - ZC.AP.E2, e.iY + e.F / 2 - ZC.AP.E1, 0 + e.A9S);
          e.iX = l.EC[0] - e.I / 2 + ("v" === i ? "default" === n.BA ? -a : a : 0), e.iY = l.EC[1] - e.F / 2 + ("h" === i ? "default" === n.BA ? a : -a : 0);
          var r = ZC.DH.A3C(n.A, e);
          null === ZC._n_(t) && (t = e.A9, e.A9 % 90 == 0 && (t += e.VV ? 0 : r)), e.A9 = t;
        }
        return t;
      }
    }, {
      key: "UN",
      value: function UN(e, t, i) {
        var a = this,
          n = (i.items, i.lcoords),
          l = i.lstep,
          r = i.tdim,
          o = i.mdim,
          s = i.dim,
          C = i.html,
          A = [e.iX + e.BM, e.iY + e.BH, e.I, e.F],
          Z = ZC._a_(e.A9 % 180),
          c = !1;
        Z % 360 != 0 && (c = !0), c && (A = [e.iX + e.BM + e.I / 2 - e.F / 2, e.iY + e.BH + e.F / 2 - e.I / 2, e.F, e.I]);
        var p = !0;
        if (e.AN) {
          if (!a.A12) if ("log" === a.C1 || t !== a.W && t !== a.A1) {
            t % l == 0 && (p = !0);
            for (var u = 0, h = n.length; u < h; u++) if (ZC.AR.YG({
              x: A[0],
              y: A[1],
              width: A[2],
              height: A[3]
            }, {
              x: n[u][0],
              y: n[u][1],
              width: n[u][2],
              height: n[u][3]
            })) {
              p = !1;
              break;
            }
          } else p = !0;
          p && (n.push(A), e.paint(), 0, o = ZC.BQ(o, 1.5 * e.DG * (e.AO || "").split("<br>").length), "h" === s ? (r += e.F, o = ZC.BQ(o, ZC._a_(ZC.EN(Z)) * ZC.BQ(e.I, e.F))) : "w" === s && (r += e.I, o = ZC.BQ(o, ZC._a_(ZC.EG(Z)) * ZC.BQ(e.I, e.F))), e.ED(), null === ZC._n_(a.o.tooltip) && e.KE || (null !== ZC._n_(a.o.tooltip) && (a.o.tooltip.text = a.o.tooltip.text || "%scale-value"), C.push(ZC.AQ.OG(a.A.K, e))));
        }
        return {
          tdim: r,
          mdim: o,
          overlaps: !p
        };
      }
    }, {
      key: "TN",
      value: function TN(e, t) {
        var i = this;
        if ("v" === i.AF && (i.HA !== i.B3 && i.HA !== i.BL || (null === ZC._n_(i.o["ref-line"]) || null !== ZC._n_(i.o["ref-line"]) && null === ZC._n_(i.o["ref-line"].visible)) && (i.PF.AN = !1)), i.PF.K = i.K + "-ref-line", i.V.length > 0 && i.PF.AN && !i.A.AJ["3d"] && i.PF.AZ > 0) {
          "inherit" === i.PF.o["line-color"] && -1 !== t && (i.PF.B7 = t);
          var a = i.HA;
          if ("k" === i.AF && !i.CO || "v" === i.AF && i.CO) {
            var n = i.AM(a);
            n >= i.iX && n <= i.iX + i.I && ZC.CQ.paint(e, i.PF, [[n, i.iY], [n, i.iY + i.F]]);
          } else {
            var l = i.AM(a);
            l >= i.iY && l <= i.iY + i.F && ZC.CQ.paint(e, i.PF, [[i.iX, l], [i.iX + i.I, l]]);
          }
        }
      }
    }, {
      key: "paint_",
      value: function paint_() {}
    }, {
      key: "VU",
      value: function VU() {
        for (var e = this, t = 0, i = e.QI.length; t < i; t++) e.V.length > 0 && e.QI[t].paint();
      }
    }, {
      key: "gc",
      value: function gc() {
        ZC.AQ.gc(this, ["V", "BY", "Z", "C7", "D6", "BR", "M", "G6", "II", "PF", "J2", "IV", "o", "ID", "JG", "A", "H"]);
      }
    }]);
    return HF;
  }(I3);
  var A3Z = /*#__PURE__*/function (_HF) {
    _inherits(A3Z, _HF);
    function A3Z(e) {
      var _this100;
      _classCallCheck(this, A3Z);
      _this100 = _possibleConstructorReturn(this, _getPrototypeOf(A3Z).call(this, e));
      var t = _assertThisInitialized(_this100);
      t.EF = !1, t.AF = "k", t.DD = -1, t.DV = -1, t.W = -1, t.A1 = -1, t.VK = 1, t.DM = null, t.OW = 0, t.A5M = !1, t.O3 = !1, t.UQ = {}, t.J0 = [], t.iMinOffset = 0;
      return _this100;
    }
    _createClass(A3Z, [{
      key: "zoomTo",
      value: function zoomTo(e, t) {
        var i = this;
        if (i.GQ) {
          null !== ZC._n_(e) ? i.W = e : i.W = i.DD, null !== ZC._n_(t) ? i.A1 = t : i.A1 = i.DV;
          var a = i.J0;
          if (a.length > 0 ? (i.B3 = ZC.AV(a, i.V[i.W]), i.BL = ZC.AV(a, i.V[i.A1])) : (i.B3 = i.V[i.W], i.BL = i.V[i.A1]), i.H.H3.C || (i.H.H3.C = i.A), i.A.H3 && null !== ZC._n_(i.A.H3.o.shared) && ZC._b_(i.A.H3.o.shared) && i.A.K === i.H.H3.C.K) for (var n = 0, l = i.H.AG.length; n < l; n++) {
            var r = i.H.AG[n];
            if (r.K !== i.A.K && null !== ZC._n_(r.H3.o.shared) && ZC._b_(r.H3.o.shared)) {
              var o = r.BJ(i.BG);
              o && o.GQ && (e = Math.max(o.DD, Math.min(o.DV, i.W)), t = Math.max(o.DD, Math.min(o.DV, i.A1)), o.zoomTo(e, t), ZC.AK(r.K) && (r.clear(!0), r.E["shared-zoom"] = !0, r.paint(), r.B9 && r.B9.update(e, t, null, null, !0)));
            }
          }
          i.H0();
        }
      }
    }, {
      key: "zoomToV",
      value: function zoomToV(e, t) {
        var i = this;
        null !== ZC._n_(e) ? i.B3 = e : i.B3 = i.FX, null !== ZC._n_(t) ? i.BL = t : i.BL = i.H4, i.Q9(i.B3, i.BL, null === ZC._n_(e) && null === ZC._n_(t));
      }
    }, {
      key: "FC",
      value: function FC(L, J, EQ, bKeep, AD) {
        var s = this,
          CT = "";
        J ? (CT = J.S[L].BU, s.FI && "date" === s.FI.o.type || "number" == typeof CT || (null !== ZC._n_(s.BY[CT]) ? CT = s.BY[CT] : null !== ZC._n_(s.V[CT]) && (CT = s.V[CT]))) : CT = "log" === s.C1 && bKeep ? L + 1 : null !== ZC._n_(s.BY[L]) ? s.BY[L] : s.V[L], "number" == typeof CT && null !== ZC._n_(s.J0[CT]) && (CT = s.J0[CT]), null !== ZC._n_(AD) && (CT = AD);
        var OY = ZC.PL(CT) && ZC._f_(CT) < 0,
          BD = s.LV();
        if (ZC._cp_(EQ, BD), OY && "currency" === BD.negation && (CT = ZC._a_(ZC._f_(CT))), BD.utc = s.A.UY, BD.timezone = s.A.NI, CT = ZC.AQ.G5(CT, BD, s, !0), s.CH) if ("()" === s.CH.substring(s.CH.length - 2) || "javascript:" === s.CH.substring(0, 11)) try {
          var EA = s.CH.replace("javascript:", "").replace("()", "");
          eval(EA) && (CT = eval(EA).call(s, CT));
        } catch (e) {} else CT = OY && "currency" === BD.negation ? "-" + s.CH.replace(/%v|%scale-value/g, CT) : s.CH.replace(/%v|%scale-value/g, CT);
        return CT;
      }
    }, {
      key: "ES",
      value: function ES(e, t, i, a, n) {
        var l = this,
          r = l.FC(t, i, a, n),
          o = [];
        o.push(["%scale-label", r], ["%scale-index", t], ["%scale-position", t]), l.FI && "date" === l.FI.o.type ? o.push(["%scale-value", r], ["%v", r]) : "log" === l.C1 && n ? o.push(["%scale-value", Math.pow(l.E4, t)], ["%v", Math.pow(l.E4, t)]) : o.push(["%scale-value", ZC._c_(l.V[t], "")], ["%v", ZC._c_(l.V[t], "")]), o.push(["%l", r], ["%t", r], ["%i", t], ["%c", t]), o.sort(ZC.A2G);
        for (var s = 0, C = o.length; s < C; s++) {
          var A = new RegExp(o[s][0], "g");
          e = e.replace(A, o[s][1]);
        }
        return e;
      }
    }, {
      key: "T9",
      value: function T9() {
        var e = this,
          t = ZC.BQ(e.V.length, e.BY.length),
          i = 0;
        if (t > 0 && e.BR.A9 % 180 == 0) {
          for (var a = ZC.BQ(1, ZC._i_(t / 20)), n = 0, l = 0; l < t; l += a) {
            for (var r = ((e.BY[l] || e.V[l]) + "").split(/<br>|<br\/>|<br \/>|\n/), o = 0, s = 0, C = r.length; s < C; s++) o = ZC.BQ(o, 11 * r[s].replace(/<.+?>/gi, "").replace(/<\/.+?>/gi, "").length);
            i += o, n++;
          }
          i = .75 * i / Math.max(1, n);
        } else i = 15;
        e.CO ? e.EH = ZC._i_((e.F - e.AB - e.BV) / 15) : e.EH = ZC._i_((e.I - e.AB - e.BV) / i), e.EH = ZC.CX(e.EH, 20), (e.BL - e.B3) / e.E3 + 1 < e.EH ? e.EH = ZC.BQ(e.EH, ZC._i_((e.BL - e.B3) / e.E3) + 1) : (e.BL - e.B3) / (2 * e.E3) + 1 < e.EH && (e.EH = ZC.BQ(e.EH, ZC._i_((e.BL - e.B3) / (2 * e.E3)) + 1)), e.EH = ZC.BQ(2, e.EH);
      }
    }, {
      key: "ZX",
      value: function ZX() {
        var e = this;
        null === ZC._n_(e.o["max-ticks"]) && (e.MB = e.EH);
      }
    }, {
      key: "HE",
      value: function HE(e) {
        var t,
          i,
          a,
          n,
          l,
          r = this;
        if (1 === e && r.o.transform && "date" === r.o.transform.type && (null === ZC._n_(r.o.transform.uniform) || ZC._b_(r.o.transform.uniform) || (r.O3 = !0)), 1 === e && null !== ZC._n_(r.o[ZC._[5]])) if (r.V = [], "object" == typeof r.o[ZC._[5]]) for (r.V = r.o[ZC._[5]], 0 === r.BY.length && (r.BY = r.V), a = 0, n = r.V.length; a < n; a++) "string" == typeof r.V[a] && (r.A5M = !0, r.J0.push(r.V[a]));else {
          var o = r.o[ZC._[5]].split(":"),
            s = r.E3;
          if (3 === o.length && (s = ZC._f_(o[2])), r.E3 = r.SR = s, ZC._f_(o[0]) > ZC._f_(o[1])) {
            var C = o[0];
            o[0] = o[1], o[1] = C;
          }
          if (s <= 0 && (s = 1), o.length > 1) {
            for (var A = 0, Z = 0, c = 0, p = ("" + s).split("."), u = ZC._f_(o[0]); u <= ZC._f_(o[1]); u += s) {
              var h = ("" + u).split(".");
              p.length > 1 && h.length > 1 && p[1].length > 0 && h[1].length >= 9 && ZC._a_(h[1].length - p[1].length) > 2 ? (A += p[1].length, Z = ZC.BQ(Z, p[1].length), c++, null !== (l = ZC._n_(r.o[ZC._[12]])) ? r.V.push(ZC._f_(Number(u).toFixed(ZC._i_(l)))) : r.V.push(ZC._f_(ZC._fixed_(Number(u), p[1].length))), u = ZC._f_(ZC._fixed_(Number(u), p[1].length))) : (A += h[1] ? h[1].length : 0, Z = ZC.BQ(Z, h[1] ? h[1].length : 0), c++, null !== (l = ZC._n_(r.o[ZC._[12]])) ? r.V.push(ZC._f_(Number(u).toFixed(ZC._i_(l)))) : r.V.push(u));
            }
            null === ZC._n_(r.o[ZC._[12]]) && (A = Math.ceil(A / c), r.DM = ZC._a_(Z - A) <= 1 ? Z : A);
          }
        }
        if (2 === e) {
          var _ = 0,
            d = [];
          0 === r.V.length ? (t = ZC.MAX, i = -ZC.MAX) : (t = r.V[0], i = r.V[r.V.length - 1]);
          var f,
            g,
            B = r.A.AY.A4,
            v = !1;
          for (a = 0, n = B.length; a < n; a++) {
            var m = B[a].BT();
            if (-1 !== ZC.AV(m, r.BG)) {
              for (var b = 0 === d.length, E = 0, K = B[a].S.length; E < K; E++) if (B[a].S[E]) {
                if (null !== B[a].S[E].BU) {
                  var D = B[a].S[E].BU;
                  t = ZC.CX(t, D), i = ZC.BQ(i, D), r.O3 && b && d.push(D), r.EF = !0, B[a].EF = !0;
                } else v = !0;
              } else r.O3 && b && d.push("");
              B[a].EF || (_ = ZC.BQ(_, B[a].S.length));
            }
          }
          if (null !== ZC._n_(r.o[ZC._[5]])) for (a = 0; a < r.V.length; a++) null === r.V[a] && (r.V[a] = "");
          if (null !== ZC._n_(r.o[ZC._[10]])) for (a = 0; a < r.BY.length; a++) null === r.BY[a] && (r.BY[a] = "");
          if (_ > r.V.length && r.V.length > 0 && !r.EF) for (a = r.V.length; a < _; a++);
          var F = 0;
          for (a = 0; a < B.length; a++) B[a].M1 && (-1 === B[a].RI && (B[a].RI = F), F++, r.DI = !0);
          if (0 === r.V.length) for (a = 0; a < F; a++) r.V.push(a), r.BY.push(a);
          if (0 === r.V.length) if (r.EF) v && t > 0 && (t = 0), v && i < _ - 1 && (i = _ - 1), null !== ZC._n_(r.o["min-value"]) && (t = ZC._f_(r.o["min-value"])), null !== ZC._n_(r.o["max-value"]) && (i = ZC._f_(r.o["max-value"])), i - t < r.E3 && i - t > 0 && (r.E3 = Math.pow(10, Math.floor(ZC.G8(i - t) / Math.LN10))), r.O3 || r.Q9(t, i, !0), 0 === t && 0 === i && "0,1" === r.V.join(",") && (r.V = [0]);else if (null !== ZC._n_(r.o["max-value"])) {
            f = 0, g = 0, null !== ZC._n_(r.o["min-value"]) && (f = ZC._f_(r.o["min-value"])), g = ZC._f_(r.o["max-value"]), a = 0;
            var I = f;
            if (r.FI && null !== ZC._n_(r.FI.o.type)) switch (r.FI.o.type) {
              case "date":
                r.E3 = r.XJ(f, g);
            } else (g - f) / r.E3 > 1e4 && (r.E3 = Math.pow(10, ZC.BQ(1, ZC._i_(ZC.G8(ZC._a_(g - f), 10) - 4))));
            for (; I < g;) I = r.A.NR(a * r.E3 + f), null === ZC._n_(r.V[a]) && (r.V[a] = I), a++;
          } else if (g = (f = null !== ZC._n_(r.o["min-value"]) ? ZC._f_(r.o["min-value"]) : 0) + (_ - 1) * r.E3, "log" === r.C1) r.Q9(f, g, !0);else for (a = 0; a < _; a++) null === ZC._n_(r.V[a]) && (r.V[a] = r.A.NR(a * r.E3 + f));
          r.O3 && r.EF && (r.V = [].concat(d), r.BY = [].concat(d));
        }
        if (r.O3) for (r.UQ = {}, a = 0, n = r.BY.length; a < n; a++) r.UQ[r.BY[a]] = a;
        if (r.W = 0, r.A1 = r.V.length - 1, r.DD = 0, r.DV = r.V.length - 1, r.J0.length > 0 ? (r.B3 = r.W, r.BL = r.A1) : (r.B3 = ZC._f_(r.V[r.W]), r.BL = ZC._f_(r.V[r.A1])), r.O0) {
          -1 === ZC.AV(r.V, r.O0[0]) && ZC.PL(r.O0[0]) && null !== ZC._n_(r.V[0]) && -1 !== r.SR && (r.O0[0] = r.V[0] + r.SR * Math.floor((r.O0[0] - r.V[0]) / r.SR)), -1 === ZC.AV(r.V, r.O0[1]) && ZC.PL(r.O0[1]) && null !== ZC._n_(r.V[0]) && -1 !== r.SR && (r.O0[1] = r.V[0] + r.SR * Math.ceil((r.O0[1] - r.V[0]) / r.SR));
          var x = ZC.AV(r.V, r.O0[0]),
            y = ZC.AV(r.V, r.O0[1]);
          r.KT = [-1 === x ? 0 : x, -1 === y ? r.V.length - 1 : y];
        }
        r.KT && -1 !== r.W && -1 !== r.A1 && ((r.KT[0] > r.A1 || r.KT[0] < r.W) && (r.KT[0] = r.W), (r.KT[1] > r.A1 || r.KT[1] < r.W) && (r.KT[1] = r.A1));
        var X = r.H.E["graph" + r.A.L + ".zoom"];
        if (null === ZC._n_(r.H.E[ZC._[53]]) || r.H.E[ZC._[53]]) {
          var Y = 1 === r.L ? "" : "-" + r.L;
          typeof X !== ZC._[31] && null !== ZC._n_(X["xmin" + Y]) && null !== ZC._n_(X["xmax" + Y]) && (r.KT = [X["xmin" + Y], X["xmax" + Y]]);
        } else r.H.E["graph" + r.A.L + ".zoom"] = {};
        r.KT && (r.A.A1P = !0);
      }
    }, {
      key: "Q9",
      value: function Q9(e, t, i) {
        var a,
          n,
          l,
          r,
          o = this,
          s = !1,
          C = null !== ZC._n_(o.o.step) && -1 !== ("" + o.o.step).indexOf("month");
        if (o.FI && null !== ZC._n_(o.FI.o.type)) switch (o.FI.o.type) {
          case "date":
            var A = o.XJ(e, t);
            (t - e) % A != 0 && (C || (t += A - (t - e) % A)), a = [e, t, A, 1, A], s = !0;
        } else if ("log" === o.C1) a = [e, t, 1, 1, 1];else {
          var Z = null !== ZC._n_(o.o.step) || null !== ZC._n_(o.o["min-value"]) || null !== ZC._n_(o.o["max-value"]);
          a = e !== t ? ZC.AR.WV(e, t, o.E3, o.PE, Z) : [e, t, o.E3, 1, o.E3];
        }
        -1 === o.SR && (o.SR = a[4]);
        var c = a[0],
          p = a[1];
        r = a[2], i && "log" === o.C1 && (c = Math.floor(ZC.G8(c, o.E4)), p = Math.ceil(ZC.G8(p, o.E4))), null === ZC._n_(o.o.step) && (p - c) / r > 1e4 && (r = (p - c) / 1e4, l = Math.ceil(ZC.G8(r) / Math.LN10), r = Math.pow(10, l)), null === ZC._n_(o.o["min-value"]) && c !== p && (s && C || (c -= c % r)), null === ZC._n_(o.o["max-value"]) && c !== p && (s && C || (p = p - p % r + (p % r == 0 ? 0 : r))), l = Math.floor(ZC.G8(r) / Math.LN10);
        var u,
          h = a[3];
        if (l < h && l < 0 && (h = l), "log" === o.C1 && (h = ZC.BQ(1, h)), o.V = [], s && C) {
          var _ = ZC.AQ.YX(c, "%Y-%n-%d-%H-%i-%s", !1, 0).split("-"),
            d = new Date(c).getTimezoneOffset(),
            f = !0,
            g = ZC._i_(("" + o.o.step).replace("month", ""));
          0 === g && (g = 1);
          var B = ZC._i_(_[1]),
            v = ZC._i_(_[0]);
          for (o.V.push(c); f && c !== p;) {
            f = !1;
            var m = ZC._i_(_[2]);
            B + g >= 12 && v++, B = (B + g) % 12, (31 === m && (3 === B || 5 === B || 8 === B || 10 === B) || m > 28 && 1 === B) && (m = 1 === B ? v % 4 == 0 && v % 100 != 0 || v % 400 == 0 ? 29 : 28 : 30);
            var b = new Date(v, B, m, ZC._i_(_[3]), ZC._i_(_[4]), ZC._i_(_[5])),
              E = b.getTimezoneOffset(),
              K = b.getTime() + 6e4 * (d - E);
            o.V.push(K), K < p && K <= t && (f = !0);
          }
        } else if (i) {
          o.FX = e, o.H4 = t, o.VK = ZC._i_((p - c) / r);
          var D = ("" + r).split("."),
            F = new String(D[1] || "0").length;
          for ((p - c) % r != 0 && (p -= (p - c) % r) < t && (p = p - (p - c) % r + r), n = c; n <= p + 1e-4; n += r) {
            var I, x;
            u = n;
            var y = o.DM;
            if ("log" === o.C1) for (var X = !0; X;) X = !1, x = I = Math.pow(o.E4, u), I = ZC._f_(ZC._fixed_(I, y)), x < 1 && x !== I && ZC.BQ(x, I) / ZC.CX(x, I) > 1.005 && (X = !0, ++y > ZC.CX(20, -1 === o.I9 ? 99 : o.I9) && (X = !1));else I = null !== y ? ZC._f_(ZC._fixed_(u, Math.max(y, F))) : ZC._f_(ZC._fixed_(u, F));
            o.V.push(I);
          }
        } else for (r = ZC._f_((t - e) / o.VK), n = 0; n <= o.VK; n++) u = e + r * n, h < 0 && (u = ZC._f_(u.toFixed(-h))), o.V.push(u);
        o.W = 0, o.A1 = o.V.length - 1, o.DD = 0, o.DV = o.V.length - 1, o.B3 = ZC._f_(o.V[o.W]), o.BL = ZC._f_(o.V[o.A1]);
      }
    }, {
      key: "XJ",
      value: function XJ(e, t, i) {
        typeof i === ZC._[31] && (i = !1);
        var a = t - e,
          n = Math.floor(ZC.G8(a) / Math.LN10);
        return null === ZC._n_(this.o.step) || i ? n <= 3 ? 1 : 4 === n ? 1e3 : 5 === n ? 1e4 : 6 === n ? 2e4 : 7 === n ? 3e4 : 8 === n ? 6e4 : 9 === n ? 6e5 : 10 === n ? 12e5 : 11 === n ? 18e5 : 36e5 : this.E3;
      }
    }, {
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A3Z.prototype), "parse", this).call(this);
      }
    }, {
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(A3Z.prototype), "clear", this).call(this);
      }
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(A3Z.prototype), "build", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(A3Z.prototype), "paint", this).call(this), null !== ZC._n_(this.o[ZC._[5]]) && (this.TM = !0);
      }
    }]);
    return A3Z;
  }(HF);
  var ZY = /*#__PURE__*/function (_HF2) {
    _inherits(ZY, _HF2);
    function ZY(e) {
      var _this101;
      _classCallCheck(this, ZY);
      _this101 = _possibleConstructorReturn(this, _getPrototypeOf(ZY).call(this, e));
      var t = _assertThisInitialized(_this101);
      t.AF = "v", t.W = -1, t.A1 = -1, t.VK = 0, t.DM = null, t.KX = "normal", t.JQ = [];
      return _this101;
    }
    _createClass(ZY, [{
      key: "zoomTo",
      value: function zoomTo(e, t) {
        var i,
          a,
          n = this;
        if (n.GQ) {
          null !== ZC._n_(e) ? n.B3 = e : n.B3 = n.FX, null !== ZC._n_(t) ? n.BL = t : n.BL = n.H4, ("piano" === n.A.AF || n.QE) && (n.B3 = ZC._i_(n.B3), n.BL = ZC._i_(n.BL)), n.Q9(n.B3, n.BL, !1);
          var l = n.A.BT("v");
          for (i = 0; i < l.length; i++) l[i].BG !== n.BG && l[i].sMaster === n.BG && l[i].zoomTo(e, t);
          if ("" === n.sMaster) {
            if (n.H.H3.C || (n.H.H3.C = n.A), n.A.H3 && null !== ZC._n_(n.A.H3.o.shared) && ZC._b_(n.A.H3.o.shared) && n.A.K === n.H.H3.C.K) for (i = 0, a = n.H.AG.length; i < a; i++) {
              var r = n.H.AG[i];
              if (r.K !== n.A.K && null !== ZC._n_(r.H3.o.shared) && ZC._b_(r.H3.o.shared)) {
                var o = r.BJ(n.BG);
                o && o.GQ && (e = Math.max(o.FX, Math.min(o.H4, n.B3)), t = Math.max(o.FX, Math.min(o.H4, n.BL)), o.zoomTo(e, t), ZC.AK(r.K) && (r.clear(!0), r.E["shared-zoom"] = !0, r.paint(), r.B9 && r.B9.update(null, null, e, t, !0)));
              }
            }
            n.H0();
          }
        }
      }
    }, {
      key: "FC",
      value: function FC(L, CT, EQ) {
        var s = this;
        typeof CT === ZC._[31] && (CT = "", CT = null !== ZC._n_(s.BY[L]) ? s.BY[L] : s.V[L]), "number" == typeof CT && null !== ZC._n_(s.JQ[CT]) && (CT = s.JQ[CT]);
        var OY = ZC.PL(CT) && ZC._f_(CT) < 0,
          BD = s.LV();
        if (ZC._cp_(EQ, BD), null !== ZC._n_(s.E["max-power"]) && (BD["max-power"] = s.E["max-power"]), OY && "currency" === BD.negation && (CT = ZC._a_(ZC._f_(CT))), BD.utc = s.A.UY, BD.timezone = s.A.NI, CT = ZC.AQ.G5(CT, BD, s, !0), s.CH) if ("()" === s.CH.substring(s.CH.length - 2) || "javascript:" === s.CH.substring(0, 11)) try {
          var EA = s.CH.replace("javascript:", "").replace("()", "");
          eval(EA) && (CT = eval(EA).call(s, CT));
        } catch (e) {} else CT = OY && "currency" === BD.negation ? "-" + s.CH.replace(/%v|%scale-value/g, CT) : s.CH.replace(/%v|%scale-value/g, CT);
        return CT;
      }
    }, {
      key: "T9",
      value: function T9() {
        var e = this,
          t = ZC.BQ(e.V.length, e.BY.length);
        if (0 === t && (t = 10), "log" === e.C1) e.EH = 999;else {
          var i = Math.max(15, 10 * ZC.BQ(e.V.join("").length, e.BY.join("").length) / t);
          e.CO ? e.EH = ZC._i_((e.I - e.AB - e.BV) / i) : e.EH = ZC._i_((e.F - e.AB - e.BV) / 10), e.EH = ZC.CX(e.EH, 10), e.EH = ZC.BQ(2, e.EH);
        }
      }
    }, {
      key: "ZX",
      value: function ZX() {
        var e = this;
        null === ZC._n_(e.o["max-ticks"]) && (e.MB = e.EH);
      }
    }, {
      key: "HE",
      value: function HE(e) {
        var t,
          i,
          a,
          n,
          l,
          r,
          o,
          s = this;
        if ("" !== s.sMaster && 2 === e) {
          var C = s.A.BJ(s.sMaster);
          if (C) return s.B3 = C.B3, s.FX = C.FX, s.BL = C.BL, s.H4 = C.H4, s.E3 = C.E3, s.SR = C.SR, s.W = C.W, s.A1 = C.A1, s.DD = C.DD, s.DV = C.DV, s.V = [].concat(C.V), void (s.BY = [].concat(C.BY));
        }
        1 === e && null === ZC._n_(s.o[ZC._[5]]) && null !== ZC._n_(t = s.A.UO("v")) && (s.o[ZC._[5]] = t);
        var A,
          Z = 0,
          c = s.JQ;
        if (1 === e && null !== ZC._n_(s.o[ZC._[5]])) {
          if (s.V = [], "object" == typeof s.o[ZC._[5]]) {
            var p = s.o[ZC._[5]],
              u = ZC.YP(p),
              h = ZC.A1U(p),
              _ = !0;
            for (i = 0, a = p.length - 2; i < a; i++) if ("number" == typeof p[i + 2] && "number" == typeof p[i + 1] && "number" == typeof p[i] && ZC._f_(p[i + 2]) - ZC._f_(p[i + 1]) != ZC._f_(p[i + 1]) - ZC._f_(p[i])) {
              _ = !1;
              break;
            }
            if (!_ && (s.o[ZC._[5]] = u + ":" + h, !s.M4)) for (s.M4 = [], i = 0, a = p.length; i < a; i++) s.M4.push("" + p[i]);
          }
          if ("object" == typeof s.o[ZC._[5]]) {
            for (ZC._cpa_(s.o[ZC._[5]], s.V), 0 === s.BY.length && ZC._cpa_(s.BY, s.V), i = 0, a = s.V.length; i < a; i++) if ("string" == typeof s.V[i]) {
              var d = s.V[i],
                f = ZC.AV(c, s.V[i]);
              -1 === f || s.bAllowDuplicates ? (c.push(s.V[i]), s.V[i] = c.length - 1) : s.V[i] = f, null === ZC._n_(s.BY[i]) && (s.BY[i] = d);
            }
          } else {
            var g = s.o[ZC._[5]].split(":");
            if (o = 1, 3 === g.length && (o = ZC._f_(g[2])), ZC._f_(g[0]) > ZC._f_(g[1])) {
              var B = g[0];
              g[0] = g[1], g[1] = B;
            }
            if (o <= 0 && (o = 1), null !== ZC._n_(s.o["fixed-items"]) && (o = (ZC._f_(g[1]) - ZC._f_(g[0])) / ZC.BQ(1, ZC._i_(s.o["fixed-items"]) - 1), s.VK = ZC.BQ(1, ZC._i_(s.o["fixed-items"]) - 1)), g.length > 1) {
              for (var v = 0, m = 0, b = 0, E = ("" + o).split("."), K = ZC._f_(g[0]); K <= ZC._f_(g[1]); K += o) n = ("" + K).split("."), E.length > 1 && n.length > 1 && E[1].length > 0 && n[1].length >= 9 && ZC._a_(n[1].length - E[1].length) > 2 ? (v += E[1].length, m = ZC.BQ(m, E[1].length), b++, s.V.push(ZC._f_(ZC._fixed_(Number(K), E[1].length)))) : (v += ZC._i_(n[1] ? n[1].length : 0), m = ZC.BQ(m, n[1] ? n[1].length : 0), b++, s.V.push(K));
              K - ZC._f_(g[1]) != 0 && ZC._a_(K - ZC._f_(g[1])) / o < 1e-8 && s.V.push(ZC._f_(g[1])), null === ZC._n_(s.o[ZC._[12]]) && (v = (n = ("" + o).split("."))[1] ? n[1].length : Math.ceil(v / b), s.DM = ZC._a_(m - v) <= 1 ? m : v);
            }
          }
          s.W = 0, s.A1 = s.V.length - 1, s.E3 = o, c.length > 1 ? (Z = ZC.YP(s.V, !0), s.B3 = ZC.YP(s.V), s.BL = ZC.A1U(s.V)) : (s.B3 = s.V[0], s.BL = s.V[s.V.length - 1]), "log" === s.C1 && (0 === s.B3 && (A = Math.floor(ZC.G8(Z, s.E4)), s.B3 = Math.pow(s.E4, Math.min(-1, A))), s.Q9(ZC.G8(s.B3, s.E4), ZC.G8(s.BL, s.E4), !1));
        }
        if (2 === e) {
          var D = {};
          null === ZC._n_(s.o[ZC._[5]]) && (s.V = [], l = ZC.MAX, r = -ZC.MAX);
          var F = [],
            I = s.A.AY.A4;
          for (i = 0, a = I.length; i < a; i++) if (s.A.E["plot" + i + ".visible"] || "hide" === s.A.getToggleAction()) {
            var x = I[i].BT();
            if (-1 !== ZC.AV(x, s.BG)) for (var y = -1 !== ZC.AV(["vbar", "hbar", "vbar3d", "hbar3d"], I[i].AF), X = [], Y = 0, w = I[i].V.length; Y < w; Y++) if (I[i].S[Y]) {
              var L = null === I[i].S[Y].BU ? Y : I[i].S[Y].BU;
              if (I[i].CB && -1 !== ZC.AV(X, L)) continue;
              X.push(L);
              var M = I[i].M5 && null !== ZC._n_(I[i].M5[Y]) ? ZC._f_(I[i].M5[Y]) : 0;
              if (I[i].CB) null === ZC._n_(D[I[i].DY]) && (D[I[i].DY] = []), null === ZC._n_(D[I[i].DY][L]) ? I[i].S[Y].AD >= 0 || !y ? D[I[i].DY][L] = [I[i].S[Y].AD, 0] : D[I[i].DY][L] = [0, I[i].S[Y].AD] : I[i].S[Y].AD >= 0 || !y ? D[I[i].DY][L][0] += I[i].S[Y].AD : D[I[i].DY][L][1] += I[i].S[Y].AD, I[i].S[Y].AD >= 0 || !y ? I[i].S[Y].CR = D[I[i].DY][L][0] : I[i].S[Y].CR = D[I[i].DY][L][1], null === ZC._n_(s.o[ZC._[5]]) && F.push(D[I[i].DY][L][0] + M, D[I[i].DY][L][1] + M);else if (null === ZC._n_(s.o[ZC._[5]])) {
                F.push(I[i].S[Y].AD + M), 0 !== M && F.push(M);
                for (var H = 0, G = I[i].S[Y].DN.length; H < G; H++) F.push(I[i].S[Y].DN[H] + M);
              }
            }
          }
          F.length > 0 && (Z = ZC.YP(F, !0), l = ZC.YP(F), r = ZC.A1U(F)), 0 !== s.V.length || l !== Number.MAX_VALUE && r !== Number.MIN_VALUE || (s.V = [0, 1], l = 0, r = 1), null === ZC._n_(s.o[ZC._[5]]) && (null !== ZC._n_(s.o["min-value"]) && "auto" !== s.o["min-value"] ? l = ZC._f_(s.o["min-value"]) : l > 0 && "auto" !== s.o["min-value"] && "log" !== s.C1 && (l = 0), null !== ZC._n_(s.o["max-value"]) && (r = ZC._f_(s.o["max-value"])), l === ZC.MAX && r === -ZC.MAX ? (s.W = 0, s.A1 = 0, s.B3 = 0, s.BL = 0) : "log" === s.C1 ? (0 === l && (A = Math.floor(ZC.G8(Z, s.E4)), l = Math.pow(s.E4, Math.min(-1, A))), s.Q9(ZC.G8(l, s.E4), ZC.G8(r, s.E4), !1)) : s.Q9(l, r, !0));
        }
        2 === e && (-1 === s.FX && -1 === s.H4 && (s.FX = s.B3, s.H4 = s.BL), -1 === s.SR && (s.SR = s.E3)), "auto" === s.o["min-value"] && null === ZC._n_(s.o["ref-value"]) && (s.HA = s.B3), 0 === s.VK && (s.VK = ZC._i_((s.BL - s.B3) / s.E3));
        var P = s.H.E["graph" + s.A.L + ".zoom"];
        if (null === ZC._n_(s.H.E[ZC._[53]]) || s.H.E[ZC._[53]]) {
          var N = 1 === s.L ? "" : "-" + s.L;
          2 === e && typeof P !== ZC._[31] && null !== ZC._n_(P["ymin" + N]) && null !== ZC._n_(P["ymax" + N]) && (ZC.DR(P["ymin" + N], s.B3, s.BL) || (P["ymin" + N] = s.B3), ZC.DR(P["ymax" + N], s.B3, s.BL) || (P["ymax" + N] = s.BL), s.KT = [P["ymin" + N], P["ymax" + N]]);
        } else s.H.E["graph" + s.A.L + ".zoom"] = {};
        s.KT && (s.A.A1P = !0);
      }
    }, {
      key: "Q9",
      value: function Q9(e, t, i) {
        var a,
          n,
          l,
          r,
          o = this;
        "piano" !== o.A.AF && !o.QE && o.JQ.length > 1 && (e = 0), o.UC.length && null === ZC._n_(o.o["scale-factor"]) && (l = Math.floor(ZC.G8(ZC._a_(t), ZC._f_(o.UC[0]))), o.PE = Math.pow(ZC._f_(o.UC[0]), l) / Math.pow(1e3, l), o.E["max-power"] = l);
        var s = (r = o.FI && "date" === o.FI.o.type ? ZC.AR.WV(e, t, "lin" === o.C1 ? o.E3 : null, o.PE, o.bNormalize, o.EH) : ZC.AR.WV(e, t, "lin" === o.C1 ? o.o.step : null, o.PE, o.bNormalize, o.EH))[0],
          C = r[1],
          A = !1;
        n = Math.floor(r[0]), "log" === o.C1 && (l = Math.ceil(r[1]), r[1] - r[0] >= .5 ? A = !0 : r = ZC.AR.WV(Math.pow(o.E4, r[0]), Math.pow(o.E4, r[1]), null, o.PE, o.bNormalize));
        var Z,
          c,
          p = r[0],
          u = r[1],
          h = r[2];
        if (null !== ZC._n_(o.o["fixed-items"]) && (h = (u - p) / ZC.BQ(1, ZC._i_(o.o["fixed-items"]) - 1)), o.QE && t === e && (t + h <= o.BL ? t += h : e -= h), 1 !== o.RE && (p *= o.RE, u *= o.RE, h *= o.RE), null !== ZC._n_(o.E["o-decimals"]) ? o.DM = o.E["o-decimals"] : o.E["o-decimals"] = o.DM, null === ZC._n_(o.o[ZC._[12]])) if ("log" === o.C1 && A) o.DM = n < 0 ? null : 0;else if (o.bNormalize) o.A3L || (o.DM = 0);else {
          var _ = ZC.G8(t - e, 10);
          o.DM = r[3], o.DM > 9 && (_ >= 1 ? o.DM = 1 : _ > 0 && _ < 1 && (o.DM = 2));
        }
        var d,
          f,
          g,
          B = !0;
        if (A) {
          var v, m;
          n = Math.floor(p), l = Math.ceil(u), d = Math.pow(o.E4, e), f = Math.pow(o.E4, t), o.V = [];
          var b = [0, 2, 5];
          for (m = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], a = n; a <= l; a++) {
            var E = r[3];
            if (E = a < 0 ? Math.max(ZC._a_(a), E) : 0, a === l) for (v = 0; v < b.length; v++) g = Math.pow(o.E4, a) + b[v] * Math.pow(o.E4, a - 1), g = ZC._f_(g.toFixed(E)), -1 === ZC.AV(o.V, g) && o.V.push(g);
            for (v = 0; v < m.length; v++) g = m[v] * Math.pow(o.E4, a), g = ZC._f_(g.toFixed(E)), -1 === ZC.AV(o.V, g) && o.V.push(g);
          }
          o.V.sort(function (e, t) {
            return e - t;
          });
          for (var K = -1, D = -1, F = 0; F < o.V.length - 1; F++) o.V[F] <= d && d <= o.V[F + 1] && (K = F), o.V[F] === f ? D = F : o.V[F] <= f && f <= o.V[F + 1] && (D = F + 1);
          o.V = o.V.slice(K, D + 1), 0 === o.V[0] && o.V.shift(), s = ZC.G8(o.V[0], o.E4), C = ZC.G8(o.V[o.V.length - 1], o.E4);
        } else {
          for ("log" === o.C1 && (d = Math.pow(o.E4, e), f = Math.pow(o.E4, t)); B;) {
            B = !1, o.V = [], Z = c = p;
            do {
              c = Z, c = ZC._f_(c.toFixed(o.DM)), -1 !== ZC.AV(o.V, c) && (B = !0), "log" === o.C1 ? c >= p && c <= u && o.V.push(c) : o.V.push(c), Z += h, Z = ZC._f_(Z.toFixed(r[3]));
            } while (Z <= u);
            B && (o.DM += 1);
          }
          "log" === o.C1 && (s = ZC.G8(p, o.E4), C = ZC.G8(u, o.E4), o.V.push(p), o.V.push(u), o.V.sort(function (e, t) {
            return e - t;
          }));
        }
        o.E3 = h, o.W = 0, o.A1 = o.V.length - 1, i ? (o.B3 = s, o.BL = C) : (o.B3 = e, o.BL = t);
      }
    }, {
      key: "parse",
      value: function parse() {
        var e = this;
        e.assign_a([["stack-type", "KX"]]), (e.A.CB && "100%" === e.A.KX || "100%" === e.KX) && null === ZC._n_(e.o[ZC._[5]]) && (e.o[ZC._[5]] = "0:100:20", e.o.format = "%v%"), _get(_getPrototypeOf(ZY.prototype), "parse", this).call(this);
      }
    }, {
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(ZY.prototype), "clear", this).call(this);
      }
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(ZY.prototype), "build", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(ZY.prototype), "paint", this).call(this), null === ZC._n_(this.E[ZC._[12]]) && (this.E[ZC._[12]] = null !== ZC._n_(this.DM) ? this.DM : -1), null !== ZC._n_(this.o[ZC._[5]]) && (this.TM = !0);
      }
    }]);
    return ZY;
  }(HF);
  var TI = /*#__PURE__*/function (_A3Z) {
    _inherits(TI, _A3Z);
    function TI(e) {
      _classCallCheck(this, TI);
      return _possibleConstructorReturn(this, _getPrototypeOf(TI).call(this, e));
    }
    _createClass(TI, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(TI.prototype), "parse", this).call(this);
      }
    }, {
      key: "H0",
      value: function H0() {
        var e = this;
        e.A1 === e.W ? e.AC = e.I - e.AB - e.BV : e.AC = (e.I - e.AB - e.BV) / (e.A1 - e.W + (e.DI ? 1 : 0));
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(TI.prototype), "HE", this).call(this, e), this.H0();
      }
    }, {
      key: "zoomTo",
      value: function zoomTo(e, t) {
        _get(_getPrototypeOf(TI.prototype), "zoomTo", this).call(this, e, t);
        this.H0();
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(TI.prototype), "build", this).call(this);
      }
    }, {
      key: "KV",
      value: function KV(e) {
        var t,
          i = this;
        return t = i.AW ? (i.iX + i.I - i.AB - e) / (i.I - i.AB - i.BV) : (e - i.iX - i.AB) / (i.I - i.AB - i.BV), i.B3 + ZC._f_((i.BL - i.B3) * t);
      }
    }, {
      key: "N0",
      value: function N0(e, t, i) {
        var a,
          n,
          l,
          r = this;
        typeof i === ZC._[31] && (i = !1);
        var o = r.DI ? r.AC : 0;
        l = r.AW ? (r.iX + r.I - e - r.AB - o / 2) / (r.I - r.AB - r.BV - o) : (e - r.iX - r.AB - o / 2) / (r.I - r.AB - r.BV - o);
        var s,
          C = !1;
        if (t) for (s in t.K8) {
          C = !0;
          break;
        }
        if (t && !r.O3 && C) {
          var A = r.V[r.W];
          "string" == typeof A && (A = ZC.AV(r.J0, A)), "log" === r.C1 && (A = ZC.G8(A, r.E4));
          var Z = r.V[r.A1];
          "string" == typeof Z && (Z = ZC.AV(r.J0, Z)), "log" === r.C1 && (Z = ZC.G8(Z, r.E4));
          var c = A + ZC._f_((Z - A) * l);
          "log" === r.C1 && (c = Math.pow(r.E4, c));
          var p = ZC.MAX;
          for (s in n = null, t.K8) (a = Math.abs(s - c)) < p && (p = a, n = t.K8[s]);
          if (null === ZC._n_(n) && (n = c), p > t.A35) {
            var u = Math.ceil((Z - A) / (r.I - r.AB - r.BV));
            if (t.V.length < 2 && (u *= 100), p > u) return null;
          }
          return n;
        }
        var h = r.W,
          _ = r.A1;
        return r.EF && (null !== ZC._n_(a = r.V[h]) && (h = a), null !== ZC._n_(a = r.V[_]) && (_ = a)), "log" === r.C1 && (h = ZC.G8(h, r.E4), _ = ZC.G8(_, r.E4)), n = i ? r.DI ? h + (_ - h + 1) * l : h + (_ - h) * l : r.DI ? r.W + (r.A1 - r.W + 1) * l : r.W + (r.A1 - r.W) * l, "log" === r.C1 ? (n = Math.pow(r.E4, n), n = Math.floor(n) - 1) : (n = r.DI ? Math.floor(n) : ZC._i_(n), n = ZC.BQ(0, n), n = ZC.CX(r.DV, n)), n;
      }
    }, {
      key: "H6",
      value: function H6(e) {
        var t = this;
        t.W, t.A1;
        return t.EF && !t.O3 && (t.B3, t.BL), "log" === t.C1 && (e = ZC.G8(e + 1, t.E4)), t.AW ? t.iX + t.I - t.AB - (e - t.W + (t.DI ? 1 : 0)) * t.AC + (t.DI ? t.AC / 2 : 0) : t.iX + t.AB + (e - t.W) * t.AC + (t.DI ? t.AC / 2 : 0);
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t,
          i,
          a,
          n,
          l,
          r = this;
        if ("log" === r.C1 && (0 === e && (e = r.B3), e = ZC.G8(e, r.E4)), r.O3) {
          var o = r.UQ[e];
          return r.H6(o);
        }
        if (-1 !== (t = ZC.AV(r.J0, e))) return r.H6(t);
        if (!r.A5M && (r.EF || r.FI && "date" === r.FI.o.type)) {
          n = r.V[r.W], l = r.V[r.A1];
          var s = r.I;
          return "log" === r.C1 && (n = ZC.G8(n, r.E4), l = ZC.G8(l, r.E4), r.W === r.DD && r.A1 === r.DV && (s = (r.A1 - r.W) * r.AC)), l === n ? i = 0 : (a = l - n, i = (s - r.AB - r.BV - (r.DI ? r.AC : 0)) / a), r.AW ? r.iX + r.I - r.AB - (e - n) * i - (r.DI ? r.AC / 2 : 0) + r.iMinOffset : r.iX + r.AB + (e - n) * i + (r.DI ? r.AC / 2 : 0) - r.iMinOffset;
        }
        return n = r.B3, l = r.BL, "log" === r.C1 && (n = ZC.G8(n, r.E4), l = ZC.G8(l, r.E4)), l === n ? i = 0 : (a = l - n + (r.DI ? 1 : 0), i = (r.I - r.AB - r.BV) / a), r.AW ? r.iX + r.I - r.AB - (e - n) * i - (r.DI ? r.AC / 2 : 0) : r.iX + r.AB + (e - n) * i + (r.DI ? r.AC / 2 : 0);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d = this;
        _get(_getPrototypeOf(TI.prototype), "paint", this).call(this), null !== ZC._n_(d.A.A.E[d.BG + "-feed-offset-start"]) && (d.AB = d.A.A.E[d.BG + "-feed-offset-start"]), "bubble" !== d.A.AF && "scatter" !== d.A.AF || (-1 === d.AB && -1 === d.BV || 1 === d.V.length) && (d.AB = d.BV = d.I / (d.V.length + 1), d.H0());
        var f = d.BL,
          g = d.B3;
        if ("log" === d.C1 && (null !== ZC._n_(d.o["max-value"]) && (f = ZC._f_(d.o["max-value"])), null !== ZC._n_(d.o["min-value"]) && (g = ZC._f_(d.o["min-value"])), (f !== d.BL || g !== d.B3) && d.W === d.DD && d.A1 === d.DV)) {
          var B = d.AC;
          d.AC = (d.I - d.AB - d.BV) / (ZC.G8(f, d.E4) - ZC.G8(g, d.E4)) - .1;
          var v = ZC.G8(g, d.E4) - ZC.G8(d.B3, d.E4),
            m = ZC.G8(d.BL, d.E4) - ZC.G8(f, d.E4);
          d.iMinOffset = v * (d.AC - B) * (d.V.length - 1) / (m + v);
        }
        var b = d.YA(),
          E = 0,
          K = 1,
          D = 1,
          F = {};
        for (t = 0, i = d.A.BO.length; t < i; t++) d.A.BO[t].BG.substring(0, 7) === ZC._[50] && d.A.BO[t].BA === d.BA && E++, d.A.BO[t].BG.substring(0, 7) === ZC._[50] && ("default" === d.A.BO[t].BA ? (F[d.A.BO[t].BG] = K, K++) : (F[d.A.BO[t].BG] = D, D++));
        var I = F[d.BG],
          x = "default" === d.BA,
          y = null,
          X = null;
        for (t = 0, i = d.A.AY.A4.length; t < i; t++) {
          var Y = d.A.AY.A4[t],
            w = Y.BT();
          if (-1 !== ZC.AV(w, d.BG)) {
            var L = d.A.BJ(Y.BT("v")[0]);
            y = L.AM(L.HA), X = Y;
            break;
          }
        }
        var M = 8;
        null !== ZC._n_(d.J2.o[ZC._[21]]) && (M = ZC._i_(d.J2.o[ZC._[21]]));
        var H = 4;
        null !== ZC._n_(d.II.o[ZC._[21]]) && (H = ZC._i_(d.II.o[ZC._[21]]));
        var G = ZC._i_(d.A.E[d.BG + "-distance"] || -1);
        d.W2 && (G = 0), "default" === d.BA ? (C = ZC._i_(d.A.P.DP / E), n = d.iY + d.F + (I - 1) * C, -1 !== G && (n = d.iY + d.F + G)) : (C = ZC._i_(d.A.P.E7 / E), n = d.iY - (I - 1) * C, -1 !== G && (n = d.iY - G));
        var P = n;
        if (d.A.HZ && (d.A.HZ.AN = !0, d.DD === d.W && d.DV === d.A1 && (d.A.HZ.AN = !1), d.A.HZ.AN && 0 === d.A.HZ.B0.BH && "default" === d.BA && (n += d.A.HZ.B0.F + d.AZ / 2)), d.E.iY = n, d.AN && d.TM) {
          null !== ZC._n_(d.o["fixed-items"]) && (d.MB = d.EH = ZC._i_(d.o["fixed-items"]));
          var N = ZC.BQ(1, Math.ceil((d.A1 - d.W) / (d.MB - 1))),
            O = ZC.BQ(1, Math.ceil((d.A1 - d.W) / (d.EH - 1)));
          null === ZC._n_(d.o["fixed-items"]) && ZC._b_(d.o.normalize) && (N = ZC.AR.A10(N), O = ZC.AR.A10(O));
          for (var S = d.iStepMultiplier, Q = 3; Q > 0; Q--) d.iStepMultiplier > Q && d.A1 - d.W <= Q * d.iStepMultiplier && (S = Q);
          N *= S, O *= S;
          var k,
            T,
            z,
            V = 0,
            R = d.AC * N / (d.FU + 1),
            J = d.AW ? d.iX + d.BV : d.iX + d.AB,
            W = d.AW ? d.iX + d.I - d.AB : d.iX + d.I - d.BV;
          if (null === ZC._n_(y) && (y = n), l = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-ml-0-c"), o = ZC.Q.E9(l, d.H.AA), r = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-bl-0-c"), s = ZC.Q.E9(r, d.H.AA), "inherit" === d.o["line-color"] && -1 !== b && (d.B7 = b), d.A.AJ["3d"]) {
            if ((u = ZC.DH.DA(d, d.A, d.iX - ZC.AP.E2, d.iX - ZC.AP.E2 + d.I, n - ZC.AP.E1, n - ZC.AP.E1, -1, ZC.AP.FV + 1, "x")).K = d.K + "-line", d.A.EZ.true3d && (d.A.EZ[ZC._[27]] > 0 ? u.MO = [1 === d.L ? -100 : 100, 1, 1] : u.MO = [1 === d.L ? 100 : -100, 1, 1]), d.A.CJ.add(u), null !== ZC._n_(d.o.axis)) {
              var U = new CZ(d);
              U.append(d.o.axis), U.parse(), U.A0 = U.AE = U.B7, (u = ZC.DH.DA(U, d.A, d.iX - ZC.AP.E2, d.iX - ZC.AP.E2 + d.I, n - ZC.AP.E1, n - ZC.AP.E1, -U.AZ / 2, U.AZ / 2, "x")).K = d.K + "-axis", d.A.CJ.add(u);
            }
          } else {
            A = [[d.iX - 1, P], [d.iX + d.I + 1, P]];
            var j = d.K;
            d.K += "-line", ZC.CQ.paint(o, d, A), d.K = j;
          }
          if (d.V.length > 0 && d.D6.AN) {
            var q = null === ZC._n_(d.D6.o["offset-start"]) ? 0 : ZC._i_(d.D6.o["offset-start"]),
              $ = null === ZC._n_(d.D6.o["offset-end"]) ? 0 : ZC._i_(d.D6.o["offset-end"]);
            if (d.D6.o.items && d.D6.o.items.length > 0 && !d.A.AJ["3d"]) for (h = new I3(d), t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) Z = t - d.W, _ = t % d.D6.o.items.length, h.append(d.D6.o.items[_]), h.K = d.K + "-guide-" + t, h.Z = r, h.parse(), d.AW ? h.iX = d.iX + d.I - d.AB - Z * d.AC - d.AC : h.iX = d.iX + d.AB + Z * d.AC, h.iY = d.iY + q, h.I = d.AC, h.F = d.F - q - $, h.paint();
            if (d.D6.AZ > 0) for (d.GX = 0, t = d.W; t <= d.A1 + (d.DI ? 1 : 0); t++) if (d.KA = t, t === d.W || t === d.A1 + (d.DI ? 1 : 0) || (t - d.W) % N == 0) {
              (d.D6.E5.length > 0 || t === d.W) && ((p = new CZ(d)).Z = p.C7 = r, p.copy(d.D6), p.IV = we, p.DB() && p.parse()), A = [], Z = t - d.W, c = "log" === d.C1 ? d.AM(d.V[t]) : d.AW ? d.iX + d.I - d.AB - Z * d.AC : d.iX + d.AB + Z * d.AC;
              var ee = d.iY + q,
                te = d.F - q - $;
              if (p.AN) if (d.A.AJ["3d"]) {
                var ie = new CZ(d);
                ie.copy(p), null !== ZC._n_(d.o["scale-z"]) && null !== ZC._n_(e = d.o["scale-z"].guide) && (ie.append(e), ie.parse()), ie.A0 = ie.AE = ie.B7, u = ZC.DH.DA(ie, d.A, c - ZC.AP.E2 - ie.AZ / 2, c - ZC.AP.E2 + ie.AZ / 2, n - ZC.AP.E1, n - ZC.AP.E1, 0, ZC.AP.FV, "z"), d.A.CJ.add(u), p.A0 = p.AE = p.B7, (u = ZC.DH.DA(p, d.A, c - ZC.AP.E2 - p.AZ / 2, c - ZC.AP.E2 + p.AZ / 2, ee - ZC.AP.E1, ee + te - ZC.AP.E1, ZC.AP.FV + 2, ZC.AP.FV + 2, "y")).K = d.K + "-guide-" + t, d.A.CJ.add(u);
              } else A.push([c, ee], [c, ee + te]), p.K = d.K + "-guide-" + t, ZC.CQ.paint(s, p, A);
              d.GX++;
            }
          }
          if (d.V.length > 0 && d.G6.AN && !d.A.AJ["3d"] && d.G6.o.items && d.G6.o.items.length > 0) for (h = new I3(d), t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) for (d.KA = t, Z = t - d.W, d.GX = 0, a = 1; a <= d.FU; a++) _ = d.GX % d.G6.o.items.length, h.append(d.G6.o.items[_]), h.K = d.K + "-guide-" + t + "-" + a, h.Z = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-bl-0-c"), h.parse(), d.AW ? h.iX = d.iX + d.I - d.AB - Z * d.AC - (a + 1) * R : h.iX = d.iX + d.AB + Z * d.AC + a * R, h.iY = d.iY, h.I = R, h.F = d.F, h.paint(), d.GX++;
          if (d.G6.AZ > 0) for (t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) if (d.KA = t, t % N == 0) for (Z = t - d.W, d.GX = 0, a = 1; a <= d.FU; a++) A = [], (p = new CZ(d)).copy(d.G6), p.IV = we, p.DB() && p.parse(), c = "log" === d.C1 ? d.AM(d.V[t] + a * (d.V[t + 1] - d.V[t]) / (d.FU + 1)) : d.AW ? d.iX + d.I - d.AB - Z * d.AC - a * R : d.iX + d.AB + Z * d.AC + a * R, ZC.DR(c, J, W) && (A.push([c, d.iY], [c, d.iY + d.F]), p.AN && (p.K = d.K + "-minor-guide-" + a, ZC.CQ.paint(s, p, A))), d.GX++;
          if (d.TN(s, b), d.V.length > 0 && d.J2.AN) {
            switch (d.J2.o[ZC._[7]]) {
              case "inner":
                break;
              case "outer":
                V += M;
                break;
              default:
                V += M / 2;
            }
            if (!zingchart.DEV.SMARTDATELABELS || !d.FI || "date" !== d.FI.o.type) for (d.GX = 0, t = d.W; t <= d.A1 + (d.DI ? 1 : 0); t++) if (t === d.W || t === d.A1 + (d.DI ? 1 : 0) || (t - d.W) % N == 0) {
              d.KA = t;
              var ae = M;
              if (A = [], Z = t - d.W, (d.J2.E5.length > 0 || t === d.W) && ((p = new DW(d)).copy(d.J2), "inherit" === d.J2.o["line-color"] && -1 !== b && (p.B7 = b), p.IV = we, p.DB() && p.parse(), p.AI > 1 && (ae = p.AI)), c = "log" === d.C1 ? d.AM(d.V[t]) : d.AW ? d.iX + d.I - d.AB - Z * d.AC : d.iX + d.AB + Z * d.AC, ZC.DR(c, J, W)) {
                switch (p.o[ZC._[7]]) {
                  case "ref-auto":
                    A.push([c, y + ae / 2], [c, y - ae / 2]);
                    break;
                  case "ref-top":
                    A.push([c, y - ae], [c, y]);
                    break;
                  case "ref-bottom":
                    A.push([c, y + ae], [c, y]);
                    break;
                  case "inner":
                    A.push([c, n - (x ? ae : -ae)], [c, n]);
                    break;
                  case "outer":
                    A.push([c, n], [c, n + (x ? ae : -ae)]);
                    break;
                  default:
                    A.push([c, n + ae / 2], [c, n - ae / 2]);
                }
                if (p.AN) {
                  for (T = ZC._i_(p.o["offset-x"] || "0"), z = ZC._i_(p.o["offset-y"] || "0"), k = 0; k < A.length; k++) A[k][0] += T, A[k][1] += z;
                  if (p.K = d.K + "-tick-" + t, d.A.AJ["3d"] && d.A.EZ.true3d) {
                    var ne,
                      le = [];
                    for (k = 0; k < A.length; k++) ne = new CC(d.A, A[k][0] - ZC.AP.E2, A[k][1] - ZC.AP.E1, 0), le.push([ne.EC[0], ne.EC[1]]);
                    ZC.CQ.paint(o, p, le);
                  } else ZC.CQ.paint(o, p, A);
                }
              }
              d.GX++;
            }
          }
          var re = [];
          if (d.V.length > 0 && d.FU > 0 && d.II.AN && !d.A.AJ["3d"]) for (t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) if (d.KA = t, t % N == 0) for (Z = t - d.W, d.GX = 0, a = 1; a <= d.FU; a++) {
            if (A = [], (p = new CZ(d)).copy(d.II), "inherit" === d.II.o["line-color"] && -1 !== b && (p.B7 = b), p.IV = we, p.DB() && p.parse(), "log" === d.C1) {
              var oe = Math.round(ZC.G8(d.V[t], d.E4)),
                se = d.V[t] + a * (d.V[t + 1] - d.V[t]) / (d.FU + 1);
              se = oe < 0 ? ZC._f_(se.toFixed(-oe)) : ZC._f_(se.toFixed(oe)), re.push(se), c = d.AM(se);
            } else c = d.AW ? d.iX + d.I - d.AB - Z * d.AC - a * R : d.iX + d.AB + Z * d.AC + a * R;
            if (ZC.DR(c, J, W)) {
              switch (p.o[ZC._[7]]) {
                case "ref-auto":
                  A.push([c, y + H / 2], [c, y - H / 2]);
                  break;
                case "ref-top":
                  A.push([c, y], [c, y - H]);
                  break;
                case "ref-bottom":
                  A.push([c, y], [c, y + H]);
                  break;
                case "inner":
                  A.push([c, n - (x ? H : -H)], [c, n]);
                  break;
                case "outer":
                  A.push([c, n], [c, n + (x ? H : -H)]);
                  break;
                default:
                  A.push([c, n + H / 2], [c, n - H / 2]);
              }
              if (p.AN) {
                for (T = ZC._i_(p.o["offset-x"] || "0"), z = ZC._i_(p.o["offset-y"] || "0"), k = 0; k < A.length; k++) A[k][0] += T, A[k][1] += z;
                p.K = d.K + "-minor-tick-" + t, ZC.CQ.paint(o, p, A);
              }
            }
            d.GX++;
          }
          d.VU();
          var Ce = null,
            Ae = null,
            Ze = d.CH,
            ce = d.DM,
            pe = [],
            ue = new DW(d);
          ue.copy(d.J2);
          var he,
            _e = 0,
            de = 0,
            fe = 0,
            ge = [],
            Be = [];
          if (d.o["custom-items"]) for (t = 0; t < d.o["custom-items"].length; t++) Le(d.o["custom-items"][t][0], !1, !0, d.o["custom-items"][t][1]);
          if (d.V.length > 0 && d.BR.AN) if (zingchart.DEV.SMARTDATELABELS && d.FI && "date" === d.FI.o.type) {
            var ve = d.getOptimalDateInterval(d.V[d.A1] - d.V[d.W]),
              me = ve[0];
            he = ve[1];
            var be = ve[2],
              Ee = ve[3];
            fe = ve[4];
            var Ke = be * Math.ceil(d.V[d.W] / be),
              De = be * Math.floor(d.V[d.A1] / be),
              Fe = "";
            d.GX = 0;
            var Ie = !0;
            for (t = Ke; t <= De; t += be) {
              Ie = !0;
              var xe = ZC.AQ.YX(t, me, d.A.UY, d.A.NI);
              if (xe !== Fe) {
                switch (Ee) {
                  case "yr":
                    fe > 15 && (Ie = ZC._i_(xe) % 2 == 0);
                    break;
                  case "mon":
                    fe > 15 && (Ie = ZC._i_(xe) % 3 == 0);
                    break;
                  case "day":
                    fe > 45 ? Ie = 1 === ZC._i_(xe) || 15 === ZC._i_(xe) : fe > 30 ? Ie = 1 === ZC._i_(xe) || 10 === ZC._i_(xe) || 20 === ZC._i_(xe) : fe > 15 && (Ie = 1 === ZC._i_(xe) || 10 === ZC._i_(xe) || 15 === ZC._i_(xe) || 20 === ZC._i_(xe) || 25 === ZC._i_(xe));
                    break;
                  case "hr":
                    fe > 45 ? Ie = ZC._i_(xe) % 12 == 0 : fe > 30 ? Ie = ZC._i_(xe) % 6 == 0 : fe > 15 && (Ie = ZC._i_(xe) % 3 == 0);
                    break;
                  case "min":
                  case "sec":
                    fe > 45 ? Ie = ZC._i_(xe) % 30 == 0 : fe > 30 ? Ie = ZC._i_(xe) % 10 == 0 : fe > 15 && (Ie = ZC._i_(xe) % 5 == 0);
                }
                Ie && (Le(t, !0), Fe = xe);
              }
            }
            ue.AN && (ue.K = d.K + "-ticks", ZC.CQ.paint(o, ue, pe));
          } else for (d.GX = 0, Le(d.W), d.GX = d.A1 - d.W, Le(d.A1), d.GX = 1, t = d.W + 1; t < d.A1; t++) (t - d.W) % O == 0 && Le(t);
          for (t = 0; t < re.length; t++) {
            var ye = d.FC(t, null, null, !1, re[t]);
            Le(ye, !1, !0, ye);
          }
          if (d.M.AN && d.M.AO && "" !== d.M.AO) {
            (Ce = new DT(d)).copy(d.M), Ce.K = d.A.K + "-" + d.BG.replace(/\-/g, "_") + "-item_title", Ce.GO = d.K + "-label " + d.A.K + "-scale-label zc-scale-label", Ce.AO = d.M.AO, Ce.Z = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-ml-0-c"), Ce.IW = d.H.usc() ? ZC.AK(d.H.K + "-main") : ZC.AK(d.H.K + "-text"), Ce.parse(), "inherit" !== d.M.o["font-color"] && "inherit" !== d.M.o.color || -1 === b || (Ce.C2 = b);
            var Xe = d.iX + (d.AW ? d.BV : d.AB),
              Ye = d.I - d.AB - d.BV;
            switch ("chart" === Ce.o["center-point"] && (Xe = d.A.iX, Ye = d.A.I), Ce.OO) {
              case "left":
                Ce.iX = Xe;
                break;
              case "center":
                Ce.iX = Xe + Ye / 2 - Ce.I / 2;
                break;
              case "right":
                Ce.iX = Xe + Ye - Ce.I;
            }
            Ce.iY = x ? n + V + de : n - Ce.F - V - de, d.M.iX = Ce.iX, d.M.iY = Ce.iY, Ce.AN && (d.MC(Ce, null, "h"), Ce.paint(), Ce.ED(), null === ZC._n_(Ce.o.tooltip) && Ce.KE || Be.push(ZC.AQ.OG(d.A.K, Ce)));
          }
          Be.length > 0 && ZC.AK(d.A.A.K + "-map") && (ZC.AK(d.A.A.K + "-map").innerHTML += Be.join("")), null !== ZC._n_(d.o.transform) && "date" === d.o.transform.type && d.paintTransformDate();
        }
        function we(e) {
          return e = (e = (e = (e = (e = (e = e.replace(/%scale-last-position/g, d.A1 - d.W)).replace(/(%c)|(%scale-position)/g, d.GX)).replace(/(%i)|(%scale-index)/g, d.KA)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(d.V[d.KA]) ? d.V[d.KA] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(d.BY[d.KA]) ? d.BY[d.KA] : "")).replace(/%scale-day-of-week/g, ZC.AQ.YX(d.V[d.KA], "%w", d.A.UY, d.A.NI));
        }
        function Le(e, t, i, a) {
          var l;
          if (d.KA = e, Z = e - d.W, (d.BR.E5.length > 0 || e === d.W || !Ce || d.BR.I1 || i) && (Ce = new DT(d)), Ce.copy(d.BR), Ce.GO = d.K + "-item " + d.A.K + "-scale-item zc-scale-item", Ce.K = d.A.K + "-" + d.BG.replace(/\-/g, "_") + "-item_" + (a ? "c" + a : e), Ce.E["p-width"] = d.AC, d.CH = Ze, d.DM = ce, i || d.W9(we), l = t ? ZC.AQ.YX(e, he, d.A.UY, d.A.NI) : a || d.FC(e, null, null), !i && d.BR.I1) {
            var r = d.A.GR();
            ZC._cp_({
              index: e,
              cnt: Z,
              text: l
            }, r), d.GN(d.BR, Ce, null, r, d.BR.MV);
          }
          if (!(null !== ZC._n_(d.M4) && -1 === ZC.AV(d.M4, l) || (Ce.AO = l, Ce.Z = Ce.C7 = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-ml-0-c"), Ce.IW = d.H.usc() ? ZC.AK(d.H.K + "-main") : ZC.AK(d.H.K + "-text"), Ce.E.nodeidx = e, Ce.parse(), d.BR.A2O && d.BR.A9 % 180 == 0 && (Ce.o[ZC._[19]] = ZC._i_(.9 * d.AC), Ce.parse()), "inherit" !== d.BR.o["font-color"] && "inherit" !== d.BR.o.color || -1 === b || (Ce.C2 = b), i || (Ce.IV = we, Ce.DB() && Ce.parse()), Ce.o["auto-fit"] && (Ce.I = ZC._i_(d.AC)), t ? (c = d.AM(e), Ce.iX = c - Ce.I / 2 - (d.DI ? d.AC / 2 : 0)) : i ? (c = d.AM(e), Ce.iX = c - Ce.I / 2) : "log" === d.C1 ? (c = d.AM(d.V[e]), Ce.iX = c - Ce.I / 2 + (d.DI ? d.AC / 2 : 0) * (d.AW ? -1 : 1)) : d.AW ? (c = d.iX + d.I - d.AB - Z * d.AC, Ce.iX = c - Ce.I / 2 - (d.DI ? d.AC / 2 : 0)) : (c = d.iX + d.AB + Z * d.AC, Ce.iX = c - Ce.I / 2 + (d.DI ? d.AC / 2 : 0)), c < d.iX - 1 || c > d.iX + d.I + 1))) {
            if (d.A.B9 && d.A.B9.BY && d.A.B9.IP) {
              for (var o = !1, s = 0; s < d.A.B9.BY.length; s++) d.A.B9.BY[s].text === Ce.AO && (o = !0);
              o || d.A.B9.BY.push({
                x: ZC._i_(c),
                text: Ce.AO
              });
            }
            switch (Ce.o[ZC._[7]]) {
              case "inner":
                Ce.iY = x ? n - Ce.F - M : n + M;
                break;
              case "ref-top":
                Ce.iY = y - Ce.F - M;
                break;
              case "ref-bottom":
                Ce.iY = y + M;
                break;
              case "ref-auto":
                X && X.S[e] ? (X.FK(e).setup(), X.FK(e).iY < y ? Ce.iY = y + M : Ce.iY = y - Ce.F - M) : Ce.iY = y + M;
                break;
              default:
                Ce.iY = x ? n + M : n - Ce.F - M;
            }
            if (Ae = d.MC(Ce, Ae, "h", 0), d.BR.o["auto-align"] && d.BR.A9 % 180 != 0) {
              var C = ZC.DR(d.BR.A9, 0, 180) ? x ? 1 : -1 : x ? -1 : 1;
              Ce.iX += C * Ce.I * ZC.EG(d.BR.A9) / 2, Ce.iY += C * (Ce.I * ZC.EN(d.BR.A9) / 2 - Ce.F * ZC.EN(d.BR.A9) / 2);
            }
            var A = d.UN(Ce, e, {
              items: fe,
              lcoords: ge,
              lstep: O,
              tdim: _e,
              mdim: de,
              dim: "h",
              html: Be
            });
            if (_e = A.tdim, de = A.mdim, !A.overlaps && t && d.J2.AN) switch (ue.o[ZC._[7]]) {
              case "ref-auto":
                pe.push([c, y + M / 2], [c, y - M / 2], null);
                break;
              case "ref-top":
                pe.push([c, y - M], [c, y], null);
                break;
              case "ref-bottom":
                pe.push([c, y + M], [c, y], null);
                break;
              case "inner":
                pe.push([c, n - (x ? M : -M)], [c, n], null);
                break;
              case "outer":
                pe.push([c, n], [c, n + (x ? M : -M)], null);
                break;
              default:
                pe.push([c, n + M / 2], [c, n - M / 2], null);
            }
            d.GX++;
          }
        }
      }
    }, {
      key: "getOptimalDateInterval",
      value: function getOptimalDateInterval(e) {
        var t, i, a, n, l;
        return 0 <= e && e <= 3 * ZC.SEC ? (t = "%q", i = "%q ms", a = 10, n = "ms", l = ZC._i_(e / 10)) : 3 * ZC.SEC < e && e <= 3 * ZC.MIN ? (t = "%s", i = "%h:%i:%s %A", a = ZC.SEC, n = "sec", l = ZC._i_(e / ZC.SEC)) : 3 * ZC.MIN < e && e <= 3 * ZC.HR ? (t = "%i", i = "%h:%i %A", a = ZC.MIN, n = "min", l = ZC._i_(e / ZC.MIN)) : 3 * ZC.HR < e && e <= 3 * ZC.DAY ? (t = "%h:%i", i = "%M %d, %h %A", a = ZC.HR, n = "hr", l = ZC._i_(e / ZC.HR)) : 3 * ZC.DAY < e && e <= 3 * ZC.MON ? (t = "%d", i = "%M %d", a = ZC.DAY, n = "day", l = ZC._i_(e / ZC.DAY)) : 3 * ZC.MON < e && e <= 3 * ZC.YR ? (t = "%m", i = "%M %Y", a = ZC.DAY, n = "mon", l = ZC._i_(e / ZC.MON)) : (t = "%Y", i = "%Y", a = ZC.DAY, n = "yr", l = ZC._i_(e / ZC.YR)), [t, i, a, n, l];
      }
    }, {
      key: "paintTransformDate",
      value: function paintTransformDate() {
        var e,
          t,
          i,
          a,
          n = this;
        t = ZC.Q.E9(n.H.usc() ? n.H.K + "-main-c" : n.A.K + "-scales-bl-0-c", n.H.AA);
        var l = [],
          r = 1;
        function o(e, t) {
          typeof t === ZC._[31] && (t = !1), 0 <= e && e <= 2 * ZC.SEC ? (i = "%q", a = "%q ms", t && o(60 * e)) : 2 * ZC.SEC < e && e <= 2 * ZC.MIN ? (i = "%s", a = "%h:%i:%s %A", t && o(60 * e), e > 10 * ZC.SEC && (r = 2), e > 30 * ZC.SEC && (r = 5), e > 60 * ZC.SEC && (r = 10)) : 2 * ZC.MIN < e && e <= 2 * ZC.HR ? (i = "%i", a = "%h:%i %A", t && o(24 * e), e > 10 * ZC.MIN && (r = 2), e > 30 * ZC.MIN && (r = 5), e > 60 * ZC.MIN && (r = 10)) : 2 * ZC.HR < e && e <= 2 * ZC.DAY ? (i = "%h", a = "%M %d, %h %A", t && o(30 * e), e > 6 * ZC.HR && (r = 2), e > 12 * ZC.HR && (r = 4), e > 24 * ZC.HR && (r = 6)) : 2 * ZC.DAY < e && e <= 2 * ZC.MON ? (i = "%d", a = "%M %d", t && o(366 * e), e > 12 * ZC.DAY && (l = [1, 5, 9, 13, 17, 21, 25, 29]), e > 24 * ZC.DAY && (l = [1, 6, 11, 16, 21, 26])) : 2 * ZC.MON < e && e <= 2 * ZC.YR ? (i = "%m", a = "%M %Y", t && o(10 * e), e > 9 * ZC.MON && (l = [1, 4, 7, 10])) : (i = "%Y", a = "%Y", e > 9 * ZC.YR && (r = 3), e > 16 * ZC.YR && (r = 4), e > 25 * ZC.YR && (r = 5));
        }
        o(n.V[n.A1] - n.V[n.W]);
        var s = null,
          C = null,
          A = [],
          Z = !1,
          c = !1;
        function p(e) {
          var c, p;
          if (null !== ZC._n_(n.V[e]) && "" !== n.V[e]) {
            if (n.O3 && e !== n.W && e !== n.A1 && null !== ZC._n_(n.V[e - 1]) && "" !== n.V[e - 1] && null !== ZC._n_(n.V[e]) && "" !== n.V[e]) {
              var u = n.V[e] - n.V[e - 1];
              null !== ZC._n_(C) && C !== u && o(C, !0), C = u;
            }
            var h = ZC.AQ.YX(n.V[e], i, n.A.UY, n.A.NI);
            if (h !== s && ZC._i_(h) % r == 0 && (0 === l.length || -1 !== ZC.AV(l, ZC._i_(h)))) {
              var _,
                d = !0,
                f = e - n.W;
              c = n.AW ? n.iX + n.I - n.AB - f * n.AC : n.iX + n.AB + f * n.AC + (n.DI ? n.AC / 2 : 0);
              var g = new DT(n);
              n.H.B8.load(g.o, "graph.SCALE.transform[date].item"), null !== ZC._n_(_ = n.o.transform.item) && g.append(_), g.GO = n.K + "-item " + n.A.K + "-scale-item zc-scale-item", g.K = n.K + "-date-item-" + e;
              var B = ZC.AQ.YX(n.V[e], a, n.A.UY, n.A.NI);
              g.AO = B, g.Z = g.C7 = n.H.usc() ? n.H.mc() : ZC.AK(n.A.K + "-scales-ml-0-c"), g.IW = n.H.usc() ? ZC.AK(n.H.K + "-main") : ZC.AK(n.H.K + "-text"), g.parse(), n.AW ? g.iX = c - g.I / 2 - (n.DI ? n.AC / 2 : 0) : g.iX = c, g.iY = n.iY, n.A.AJ["3d"] && (n.A.NK(), p = new CC(n.A, g.iX + g.I / 2 - ZC.AP.E2, g.iY + g.F / 2 - ZC.AP.E1, 0), g.iX = p.EC[0] - g.I / 2, g.iY = p.EC[1] - g.F / 2);
              var v = [g.iX + g.BM, g.iY + g.BH, g.I, g.F];
              if (g.A9 % 180 == 90 && (v = [g.iX + g.BM + g.I / 2 - g.F / 2, g.iY + g.BH + g.F / 2 - g.I / 2, g.F, g.I]), n.A.B9 && n.A.B9.IP) {
                for (var m = !1, b = 0; b < n.A.B9.BY.length; b++) n.A.B9.BY[b].text === g.AO && (m = !0);
                m || g.iX >= n.iX && g.iX + g.I <= n.iX + n.I && n.A.B9.BY.push({
                  x: ZC._i_(g.iX),
                  text: g.AO
                });
              }
              if (g.AN && Z) {
                if (d = !0, !n.A12) {
                  if (e === n.W || e === n.A1) d = !0;else for (var E = 0, K = A.length; E < K; E++) if (ZC.DR(v[0], A[E][0], A[E][0] + A[E][2]) || ZC.DR(v[0] + v[2], A[E][0], A[E][0] + A[E][2])) {
                    d = !1;
                    break;
                  }
                  g.iX + g.BM + g.I > n.iX + n.BM + n.I && (d = !1);
                }
                if (d) {
                  A.push(v), g.paint(), g.ED();
                  var D = new CZ(n);
                  null !== ZC._n_(_ = n.o.transform.guide) && D.append(_), D.AZ = 1, D.B7 = "#ccc", D.parse();
                  var F = [];
                  if (F.push([c, n.iY], [c, n.iY + n.F]), n.A.AJ["3d"]) {
                    n.A.NK();
                    for (var I = 0, x = F.length; I < x; I++) p = new CC(n.A, F[I][0] - ZC.AP.E2, F[I][1] - ZC.AP.E1, 0), F[I][0] = p.EC[0], F[I][1] = p.EC[1];
                  }
                  D.AN && ZC.CQ.paint(t, D, F);
                }
              }
              0;
            }
            s = h;
          }
        }
        if (n.A.B9 && n.A.B9.IP && (n.A.B9.BY = []), n.V.length > 0 && (Z = !1, null !== ZC._n_(e = n.o.transform.item) && (Z = !(null !== ZC._n_(e.visible) && !ZC._b_(e.visible))), c = !1, n.A.B9 && n.A.B9.BY && (c = !0), Z || c)) {
          p(n.W), p(n.A1);
          for (var u = n.W + 1; u < n.A1; u++) p(u);
        }
      }
    }]);
    return TI;
  }(A3Z);
  var TH = /*#__PURE__*/function (_ZY) {
    _inherits(TH, _ZY);
    function TH(e) {
      _classCallCheck(this, TH);
      return _possibleConstructorReturn(this, _getPrototypeOf(TH).call(this, e));
    }
    _createClass(TH, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(TH.prototype), "parse", this).call(this);
      }
    }, {
      key: "H0",
      value: function H0() {
        var e = this;
        e.A1 === e.W ? e.AC = e.F - e.AB - e.BV : e.AC = (e.F - e.AB - e.BV) / (e.A1 - e.W + (e.DI ? 1 : 0));
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(TH.prototype), "HE", this).call(this, e), this.H0();
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(TH.prototype), "build", this).call(this);
      }
    }, {
      key: "zoomTo",
      value: function zoomTo(e, t) {
        _get(_getPrototypeOf(TH.prototype), "zoomTo", this).call(this, e, t), this.H0();
      }
    }, {
      key: "KV",
      value: function KV(e, t, i) {
        var a,
          n = this;
        a = n.AW ? (e - n.iY - n.AB) / (n.F - n.AB - n.BV) : (n.iY + n.F - n.AB - e) / (n.F - n.AB - n.BV);
        var l = n.B3 + ZC._f_((n.BL - n.B3) * a);
        return i && (l = ZC._a_(n.AW ? Math.ceil(l) : Math.floor(l))), "log" === n.C1 && t && (l = Math.pow(n.E4, l)), l;
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t = this,
          i = t.BL - t.B3,
          a = 0 === i ? 0 : (t.F - t.AB - t.BV - (t.DI ? t.AC : 0)) / i;
        return "log" === t.C1 && (e = 0 === e ? t.FX : ZC.G8(e, t.E4)), t.AW ? t.iY + t.AB + (e - t.B3) * a : t.iY + t.F - t.AB - (e - t.B3) * a;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d,
          f,
          g = this;
        _get(_getPrototypeOf(TH.prototype), "paint", this).call(this), "bubble" !== g.A.AF && "scatter" !== g.A.AF || 1 !== g.V.length || (g.AB = g.F / 2);
        var B = g.YA(),
          v = 0,
          m = 1,
          b = 1,
          E = {};
        for (t = 0, i = g.A.BO.length; t < i; t++) g.A.BO[t].AN && g.A.BO[t].TM && (g.A.BO[t].BG.substring(0, 7) === ZC._[51] && g.A.BO[t].BA === g.BA && v++, g.A.BO[t].BG.substring(0, 7) === ZC._[51] && ("default" === g.A.BO[t].BA ? (E[g.A.BO[t].BG] = m, m++) : (E[g.A.BO[t].BG] = b, b++)));
        var K = E[g.BG],
          D = "default" === g.BA,
          F = null,
          I = null;
        for (t = 0, i = g.A.AY.A4.length; t < i; t++) {
          var x = g.A.AY.A4[t],
            y = x.BT();
          if (-1 !== ZC.AV(y, g.BG)) {
            var X = g.A.BJ(x.BT("k")[0]);
            F = X.AM(X.HA), I = x;
            break;
          }
        }
        var Y = 8;
        null !== ZC._n_(g.J2.o[ZC._[21]]) && (Y = ZC._i_(g.J2.o[ZC._[21]]));
        var w = 4;
        null !== ZC._n_(g.II.o[ZC._[21]]) && (w = ZC._i_(g.II.o[ZC._[21]]));
        var L = ZC._i_(g.A.E[g.BG + "-distance"] || -1);
        g.W2 && (L = 0), "default" === g.BA ? (f = ZC._i_(g.A.P.DX / v), a = g.iX - (K - 1) * f, -1 !== L && (a = g.iX - L)) : (f = ZC._i_(g.A.P.E6 / v), a = g.iX + g.I + (K - 1) * f, -1 !== L && (a = g.iX + g.I + L));
        var M = a;
        if (g.A.HY && g.BG === ZC._[51] && (g.A.HY.AN = !0, g.FX === g.B3 && g.H4 === g.BL && (g.A.HY.AN = !1), g.A.HY.AN && 0 === g.A.HY.B0.BM && "default" === g.BA && (a -= g.A.HY.B0.I + g.AZ / 2)), g.E.iX = a, g.AN && g.TM) {
          for (var H = Math.ceil((g.A1 - g.W) / (g.EH - 1)), G = Math.ceil((g.A1 - g.W) / (g.MB - 1)), P = g.iStepMultiplier, N = 3; N > 0; N--) g.iStepMultiplier > N && g.A1 - g.W <= N * g.iStepMultiplier && (P = N);
          G *= P, H *= P;
          var O = 0,
            S = g.AC * G / (g.FU + 1);
          if (n = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-ml-0-c"), l = ZC.Q.E9(n, g.H.AA), r = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-bl-0-c"), o = ZC.Q.E9(r, g.H.AA), g.TM || g.ZO || null !== ZC._n_(g.A.o[g.BG])) {
            if ("inherit" === g.o["line-color"] && -1 !== B && (g.B7 = B), g.A.AJ["3d"]) {
              if ((c = ZC.DH.DA(g, g.A, a - ZC.AP.E2, a - ZC.AP.E2, g.iY - ZC.AP.E1, g.iY - ZC.AP.E1 + g.F, -1, ZC.AP.FV + 1, "y")).K = g.K + "-line", g.A.EZ.true3d && (g.A.EZ[ZC._[28]] > 0 ? c.MO = [1 === g.L ? -100 : 100, 1, 1] : c.MO = [1 === g.L ? 100 : -100, 1, 1]), g.A.CJ.add(c), null !== ZC._n_(g.o.axis)) {
                var Q = new CZ(g);
                Q.append(g.o.axis), Q.parse(), Q.A0 = Q.AE = Q.B7, (c = ZC.DH.DA(Q, g.A, a - ZC.AP.E2, a - ZC.AP.E2, g.iY - ZC.AP.E1, g.iY - ZC.AP.E1 + g.F, -Q.AZ / 2, Q.AZ / 2, "y")).K = g.K + "-axis", g.A.CJ.add(c);
              }
            } else {
              C = [[M, g.iY + g.F], [M, g.iY]];
              var k = g.K;
              g.K += "-line", ZC.CQ.paint(l, g, C), g.K = k;
            }
            var T = 0,
              z = 0,
              V = [],
              R = [];
            if (g.TM || g.ZO) {
              if (g.V.length > 0 && g.D6.AN) {
                var J = null === ZC._n_(g.D6.o["offset-start"]) ? 0 : ZC._i_(g.D6.o["offset-start"]),
                  W = null === ZC._n_(g.D6.o["offset-end"]) ? 0 : ZC._i_(g.D6.o["offset-end"]);
                if (g.D6.o.items && g.D6.o.items.length > 0 && !g.A.AJ["3d"]) for (g.GX = 0, p = new I3(g), t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) g.KA = t, t % G == 0 && (A = t - g.W, u = g.GX % g.D6.o.items.length, p.append(g.D6.o.items[u]), p.K = g.K + "-guide-" + t, p.Z = r, p.parse(), p.iX = g.iX + J, s = "log" === g.C1 ? g.AM(g.V[t]) : g.AM(g.V[t]) - (g.AW ? 0 : g.AC * G), p.iY = s, p.I = g.I - J - W, p.F = g.AC * G, p.paint(), g.GX++);
                if (g.D6.AZ > 0) for (g.GX = 0, t = g.W; t <= g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t === g.W || t === g.A1 || t % G == 0) {
                  (g.D6.E5.length > 0 || t === g.W || "log" === g.C1) && ((Z = new CZ(g)).Z = Z.C7 = r, "log" === g.C1 ? ZC.AR._int_(ZC.G8(g.V[t], g.E4)) ? Z.copy(g.D6) : Z.copy(g.G6) : Z.copy(g.D6), Z.IV = ce, Z.DB() && Z.parse()), C = [], A = t - g.W;
                  var U = g.iX + J,
                    j = g.I - J - W;
                  if (s = (g.C1, g.AM(g.V[t])), Z.AN) if (g.A.AJ["3d"]) {
                    var q = new CZ(g);
                    q.copy(Z), null !== ZC._n_(g.o["scale-z"]) && null !== ZC._n_(e = g.o["scale-z"].guide) && (q.append(e), q.parse()), q.A0 = q.AE = q.B7, c = ZC.DH.DA(q, g.A, a - ZC.AP.E2, a - ZC.AP.E2, s - ZC.AP.E1 - q.AZ / 2, s - ZC.AP.E1 + q.AZ / 2, 0, ZC.AP.FV, "y"), g.A.CJ.add(c), Z.A0 = Z.AE = Z.B7, (c = ZC.DH.DA(Z, g.A, U - ZC.AP.E2, U - ZC.AP.E2 + j, s - ZC.AP.E1 - Z.AZ / 2, s - ZC.AP.E1 + Z.AZ / 2, ZC.AP.FV + 2, ZC.AP.FV + 2, "x")).K = g.K + "-guide-" + t, g.A.CJ.add(c);
                  } else C.push([U, s], [U + j, s]), Z.K = g.K + "-guide-" + t, ZC.CQ.paint(o, Z, C);
                  g.GX++;
                }
              }
              if (g.V.length > 0 && g.G6.AN && S > 2 && !g.A.AJ["3d"]) {
                if (g.G6.o.items && g.G6.o.items.length > 0) for (p = new I3(g), t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t % G == 0) for (A = t - g.W, g.GX = 0, h = 1; h <= g.FU; h++) u = g.GX % g.G6.o.items.length, p.append(g.G6.o.items[u]), p.K = g.K + "-guide-" + t + "-" + h, p.Z = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-bl-0-c"), p.parse(), p.iX = g.iX, s = g.AW ? g.iY + g.AB + A * g.AC + h * S : g.iY + g.F - g.AB - A * g.AC - (h + 1) * S, p.iY = s, p.I = g.I, p.F = S, p.paint(), g.GX++;
                if (g.G6.AZ > 0 && "log" !== g.C1) for (t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t === g.W || t === g.A1 || t % G == 0) for (A = t - g.W, g.GX = 0, h = 1; h <= g.FU; h++) C = [], (Z = new CZ(g)).copy(g.G6), Z.IV = ce, Z.DB() && Z.parse(), s = "log" === g.C1 ? g.AM(g.V[t] + h * (g.V[t + 1] - g.V[t]) / (g.FU + 1)) : g.AM(g.V[t] + h * H * (g.V[t + 1] - g.V[t]) / (g.FU + 1)), ZC.DR(s, g.iY, g.iY + g.F) && (C.push([g.iX, s], [g.iX + g.I, s]), Z.AN && (Z.K = g.K + "-minor-guide-" + h, ZC.CQ.paint(o, Z, C))), g.GX++;
              }
              var $, ee, te;
              if (g.TN(o, B), g.V.length > 0 && g.J2.AN) {
                switch (g.J2.o[ZC._[7]]) {
                  case "inner":
                    break;
                  case "outer":
                    O += Y;
                    break;
                  default:
                    O += Y / 2;
                }
                for (g.GX = 0, _ = ZC.AV(g.V, 0), t = g.W; t <= g.A1 + (g.DI ? 1 : 0); t++) {
                  g.KA = t;
                  var ie = -1;
                  if ((t === g.W || t === g.A1 || t % G == 0 || ZC._b_(g.o["show-zero"]) && t === _) && (C = [], A = t - g.W, (g.J2.E5.length > 0 || t === g.W || "log" === g.C1) && (Z = new CZ(g), "log" === g.C1 ? ZC.AR._int_(ZC.G8(g.V[t], g.E4)) ? Z.copy(g.J2) : (Z.copy(g.II), ie = Y, Y = w) : Z.copy(g.J2), "inherit" === g.J2.o["line-color"] && -1 !== B && (Z.B7 = B), Z.IV = ce, Z.DB() && Z.parse()), s = (g.C1, g.AM(g.V[t])), ZC.DR(s, g.A.P.iY, g.A.P.iY + g.A.P.F))) {
                    switch (Z.o[ZC._[7]]) {
                      case "ref-right":
                        C.push([F, s], [F + Y, s]);
                        break;
                      case "ref-left":
                        C.push([F, s], [F - Y, s]);
                        break;
                      case "ref-auto":
                        C.push([F - Y / 2, s], [F + Y / 2, s]);
                        break;
                      case "inner":
                        C.push([a, s], [a + (D ? Y : -Y), s]);
                        break;
                      case "outer":
                        C.push([a, s], [a - (D ? Y : -Y), s]);
                        break;
                      default:
                        C.push([a + Y / 2, s], [a - Y / 2, s]);
                    }
                    if (-1 !== ie && (Y = ie, ie = -1), Z.AN) {
                      for (ee = ZC._i_(Z.o["offset-x"] || "0"), te = ZC._i_(Z.o["offset-y"] || "0"), $ = 0; $ < C.length; $++) C[$][0] += ee, C[$][1] += te;
                      if (Z.K = g.K + "-tick-" + t, g.A.AJ["3d"] && g.A.EZ.true3d) {
                        var ae,
                          ne = [];
                        for ($ = 0; $ < C.length; $++) ae = new CC(g.A, C[$][0] - ZC.AP.E2, C[$][1] - ZC.AP.E1, 0), ne.push([ae.EC[0], ae.EC[1]]);
                        ZC.CQ.paint(l, Z, ne);
                      } else ZC.CQ.paint(l, Z, C);
                    }
                    g.GX++;
                  }
                }
              }
              if (g.V.length > 0 && g.II.AN && g.FU > 0 && S > 5 && !g.A.AJ["3d"] && "log" !== g.C1) for (t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t === g.W || t === g.A1 || t % G == 0) for (A = t - g.W, g.GX = 0, h = 1; h <= g.FU; h++) {
                if (C = [], (Z = new CZ(g)).copy(g.II), "inherit" === g.II.o["line-color"] && -1 !== B && (Z.B7 = B), Z.IV = ce, Z.DB() && Z.parse(), s = "log" === g.C1 ? g.AM(g.V[t] + h * (g.V[t + 1] - g.V[t]) / (g.FU + 1)) : g.AM(g.V[t] + h * H * (g.V[t + 1] - g.V[t]) / (g.FU + 1)), ZC.DR(s, g.iY, g.iY + g.F)) {
                  switch (Z.o[ZC._[7]]) {
                    case "ref-right":
                      C.push([F, s], [F + w, s]);
                      break;
                    case "ref-left":
                      C.push([F, s], [F - w, s]);
                      break;
                    case "ref-auto":
                      C.push([F - w / 2, s], [F + w / 2, s]);
                      break;
                    case "inner":
                      C.push([a, s], [a + (D ? w : -w), s]);
                      break;
                    default:
                      C.push([a, s], [a - (D ? w : -w), s]);
                      break;
                    case "cross":
                      C.push([a + w / 2, s], [a - w / 2, s]);
                  }
                  if (Z.AN) {
                    for (ee = ZC._i_(Z.o["offset-x"] || "0"), te = ZC._i_(Z.o["offset-y"] || "0"), $ = 0; $ < C.length; $++) C[$][0] += ee, C[$][1] += te;
                    Z.K = g.K + "-minor-tick-" + t, ZC.CQ.paint(l, Z, C);
                  }
                }
                g.GX++;
              }
              g.VU();
              var le = null,
                re = g.CH,
                oe = g.DM,
                se = function se(e) {
                  var t;
                  if (g.KA = e, A = e - g.W, (g.BR.E5.length > 0 || e === g.W || !d || g.BR.I1) && (d = new DT(g)), d.copy(g.BR), d.GO = g.K + "-item " + g.A.K + "-scale-item zc-scale-item", d.K = g.A.K + "-" + g.BG.replace(/\-/g, "_") + "-item_" + e, g.CH = re, g.DM = oe, g.W9(ce), t = ("piano" === g.A.AF || g.QE) && g.BY.length ? g.FC(e + g.B3) : g.FC(e), g.BR.I1) {
                    var i = g.A.GR();
                    ZC._cp_({
                      index: e,
                      cnt: A,
                      text: t
                    }, i), g.GN(g.BR, d, null, i, g.BR.MV);
                  }
                  if (null === ZC._n_(g.M4) || -1 !== ZC.AV(g.M4, t)) {
                    switch (d.AO = t, d.Z = d.C7 = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-ml-0-c"), d.IW = g.H.usc() ? ZC.AK(g.H.K + "-main") : ZC.AK(g.H.K + "-text"), d.parse(), "inherit" !== g.BR.o["font-color"] && "inherit" !== g.BR.o.color || -1 === B || (d.C2 = B), d.IV = ce, d.DB() && d.parse(), d.o[ZC._[7]]) {
                      case "ref-left":
                        d.iX = F - d.I - Y;
                        break;
                      case "ref-right":
                        d.iX = F + Y;
                        break;
                      case "ref-auto":
                        I && I.S[e] ? (I.FK(e).setup(), I.FK(e).iX < F ? d.iX = F + Y : d.iX = F - d.I - Y) : d.iX = F + Y;
                        break;
                      case "middle":
                        d.iX = a - d.I / 2;
                        break;
                      case "inner":
                        d.iX = D ? a + Y : a - d.I - Y;
                        break;
                      default:
                        d.iX = D ? a - d.I - Y : a + Y;
                    }
                    if ("log" === g.C1 ? d.iY = g.AM(g.V[e]) - d.F / 2 : d.iY = g.AM(g.V[e]) - d.F / 2 + (g.AW ? 1 : -1) * (g.DI ? g.AC / 2 : 0), le = g.MC(d, le, "v"), g.BR.o["auto-align"] && g.BR.A9 % 180 != 0) {
                      var n = D ? 1 : -1;
                      90 === g.BR.A9 || 270 === g.BR.A9 ? d.iX += n * (d.I / 2 - d.F / 2) : ZC.DR(g.BR.A9, 0, 90) || ZC.DR(g.BR.A9, 270, 360) ? (d.iX += n * (d.I - d.I * ZC.EG(g.BR.A9)) / 2, d.iY -= n * d.I * ZC.EN(g.BR.A9) / 2) : ZC.DR(g.BR.A9, 90, 270) && (d.iX += n * (d.I + d.I * ZC.EG(g.BR.A9)) / 2, d.iY += n * d.I * ZC.EN(g.BR.A9) / 2);
                    }
                    if (ZC.DR(d.iY + d.F / 2, g.A.P.iY, g.A.P.iY + g.A.P.F)) {
                      var l = g.UN(d, e, {
                        items: 0,
                        lcoords: V,
                        lstep: H,
                        tdim: T,
                        mdim: z,
                        dim: "w",
                        html: R
                      });
                      T = l.tdim, z = l.mdim, g.GX++;
                    }
                  }
                };
              if (g.V.length > 0 && g.BR.AN) if ("log" === g.C1) {
                var Ce = [];
                for (t = g.W; t <= g.A1; t++) ZC.AR._int_(ZC.G8(g.V[t], g.E4)) && (g.GX = t, se(t), Ce.push(t));
                for (t = g.W; t <= g.A1; t++) -1 === ZC.AV(Ce, t) && (g.GX = t, se(t));
              } else for (g.GX = 0, se(g.W), g.GX = g.A1 - g.W, se(g.A1), -1 !== (_ = ZC.AV(g.V, 0)) && ZC._b_(g.o["show-zero"]) && (g.GX = _, se(_)), g.GX = 1, t = g.W + 1; t < g.A1; t++) t % H == 0 && se(t);
            }
            if (g.M.AN && g.M.AO && "" !== g.M.AO) {
              (d = new DT(g)).copy(g.M), d.K = g.A.K + "-" + g.BG.replace(/\-/g, "_") + "-item_title", d.GO = g.K + "-label " + g.A.K + "-scale-label zc-scale-label", d.AO = g.M.AO, d.Z = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-ml-0-c"), d.IW = g.H.usc() ? ZC.AK(g.H.K + "-main") : ZC.AK(g.H.K + "-text"), d.parse(), "inherit" !== g.M.o["font-color"] && "inherit" !== g.M.o.color || -1 === B || (d.C2 = B);
              var Ae = g.iY + (g.AW ? g.AB : g.BV),
                Ze = g.F - g.BV - g.AB;
              switch ("chart" === d.o["center-point"] && (Ae = g.A.iY, Ze = g.A.F), d.K4) {
                case "top":
                  d.iY = Ae + d.I / 2 - d.F / 2;
                  break;
                case "middle":
                  d.iY = Ae + Ze / 2 - d.F / 2;
                  break;
                case "bottom":
                  d.iY = Ae + Ze - d.I / 2 - d.F / 2;
              }
              d.iX = D ? a - d.I / 2 - d.F / 2 - O - z : a + z + d.F / 2 + O - d.I / 2, g.M.iX = d.iX, g.M.iY = d.iY, d.AN && (g.MC(d, null, "v", 10), d.paint(), d.ED(), null === ZC._n_(d.o.tooltip) && d.KE || R.push(ZC.AQ.OG(g.A.K, d)));
            }
            R.length > 0 && ZC.AK(g.A.A.K + "-map") && (ZC.AK(g.A.A.K + "-map").innerHTML += R.join(""));
          }
        }
        function ce(e) {
          return e = (e = (e = (e = (e = e.replace(/%scale-last-position/g, g.A1 - g.W)).replace(/(%c)|(%scale-position)/g, g.GX)).replace(/(%i)|(%scale-index)/g, g.KA)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(g.V[g.KA]) ? g.V[g.KA] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(g.BY[g.KA]) ? g.BY[g.KA] : "");
        }
      }
    }]);
    return TH;
  }(ZY);
  var VH = /*#__PURE__*/function (_A3Z2) {
    _inherits(VH, _A3Z2);
    function VH(e) {
      var _this102;
      _classCallCheck(this, VH);
      _this102 = _possibleConstructorReturn(this, _getPrototypeOf(VH).call(this, e)), _this102.CO = !0;
      return _this102;
    }
    _createClass(VH, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(VH.prototype), "parse", this).call(this);
      }
    }, {
      key: "H0",
      value: function H0() {
        var e = this;
        e.A1 === e.W ? e.AC = e.F - e.AB - e.BV : e.AC = (e.F - e.AB - e.BV) / (e.A1 - e.W + (e.DI ? 1 : 0));
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(VH.prototype), "HE", this).call(this, e), this.H0();
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(VH.prototype), "build", this).call(this);
      }
    }, {
      key: "zoomTo",
      value: function zoomTo(e, t) {
        _get(_getPrototypeOf(VH.prototype), "zoomTo", this).call(this, e, t), this.H0();
      }
    }, {
      key: "KV",
      value: function KV(e) {
        var t,
          i = this;
        return t = i.AW ? (e - i.iY - i.AB) / (i.F - i.AB - i.BV) : (i.iY + i.F - i.AB - e) / (i.F - i.AB - i.BV), i.B3 + ZC._f_((i.BL - i.B3) * t);
      }
    }, {
      key: "N0",
      value: function N0(e, t, i) {
        var a,
          n,
          l,
          r,
          o = this;
        typeof i === ZC._[31] && (i = !1);
        var s = o.DI ? o.AC : 0;
        l = o.AW ? (e - o.iY - o.AB - s / 2) / (o.F - o.AB - o.BV - s) : (o.iY + o.F - e - o.AB - s / 2) / (o.F - o.AB - o.BV - s);
        var C = !1;
        if (t) for (r in t.K8) {
          C = !0;
          break;
        }
        if (t && !o.O3 && C) {
          var A = o.V[o.W];
          "string" == typeof A && (A = ZC.AV(o.J0, A)), "log" === o.C1 && (A = ZC.G8(A, o.E4));
          var Z = o.V[o.A1];
          "string" == typeof Z && (Z = ZC.AV(o.J0, Z)), "log" === o.C1 && (Z = ZC.G8(Z, o.E4));
          var c = A + ZC._f_((Z - A) * l);
          "log" === o.C1 && (c = Math.pow(o.E4, c));
          var p = ZC.MAX;
          for (r in n = null, t.K8) (a = Math.abs(r - c)) < p && (p = a, n = t.K8[r]);
          if (null === ZC._n_(n) && (n = c), p > t.A35) {
            var u = Math.ceil((Z - A) / (o.I - o.AB - o.BV));
            if (t.V.length < 2 && (u *= 100), p > u) return null;
          }
          return n;
        }
        var h = o.W,
          _ = o.A1;
        return o.EF && (null !== ZC._n_(a = o.V[h]) && (h = a), null !== ZC._n_(a = o.V[_]) && (_ = a)), "log" === o.C1 && (h = ZC.G8(h, o.E4), _ = ZC.G8(_, o.E4)), n = i ? o.DI ? h + (_ - h + 1) * l : h + (_ - h) * l : o.DI ? o.W + (o.A1 - o.W + 1) * l : o.W + (o.A1 - o.W) * l, "log" === o.C1 ? (n = Math.pow(o.E4, n), n = Math.floor(n) - 1) : (n = o.DI ? Math.floor(n) : ZC._i_(n), n = ZC.BQ(0, n), n = ZC.CX(o.DV, n)), n;
      }
    }, {
      key: "H6",
      value: function H6(e) {
        var t = this;
        t.W, t.A1;
        return t.EF && !t.O3 && (t.B3, t.BL), "log" === t.C1 && (e = ZC.G8(e + 1, t.E4)), t.AW ? t.iY + t.AB + (e - t.W) * t.AC + (t.DI ? t.AC / 2 : 0) : t.iY + t.F - t.AB - (e - t.W) * t.AC - (t.DI ? t.AC / 2 : 0);
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t,
          i,
          a,
          n,
          l,
          r = this;
        if ("log" === r.C1 && (0 === e && (e = r.B3), e = ZC.G8(e, r.E4)), r.O3) {
          var o = r.UQ[e];
          return r.H6(o);
        }
        return -1 !== (t = ZC.AV(r.J0, e)) ? r.H6(t) : !r.A5M && (r.EF || r.FI && "date" === r.FI.o.type) ? (n = r.V[r.W], l = r.V[r.A1], "log" === r.C1 && (n = ZC.G8(n, r.E4), l = ZC.G8(l, r.E4)), l === n ? a = 0 : (i = l - n, a = (r.F - r.AB - r.BV - (r.DI ? r.AC : 0)) / i), r.AW ? r.iY + r.AB + (e - n) * a + (r.DI ? r.AC / 2 : 0) : r.iY + r.F - r.AB - (e - n) * a - (r.DI ? r.AC / 2 : 0)) : (n = r.B3, l = r.BL, "log" === r.C1 && (n = ZC.G8(n, r.E4), l = ZC.G8(l, r.E4)), l === n ? a = 0 : (i = l - n + (r.DI ? 1 : 0), a = (r.F - r.AB - r.BV) / i), r.AW ? r.iY + r.AB + (e - n) * a + (r.DI ? r.AC / 2 : 0) : r.iY + r.F - r.AB - (e - n) * a - (r.DI ? r.AC / 2 : 0));
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d = this;
        if (d.AN) {
          _get(_getPrototypeOf(VH.prototype), "paint", this).call(this), null !== ZC._n_(d.A.A.E[d.BG + "-feed-offset-start"]) && (d.AB = d.A.A.E[d.BG + "-feed-offset-start"]), "hbubble" !== d.A.AF && "hscatter" !== d.A.AF || (-1 === d.AB && -1 === d.BV || 1 === d.V.length) && (d.AB = d.BV = d.F / (d.V.length + 1), d.H0());
          var f = d.YA(),
            g = 0,
            B = 1,
            v = 1,
            m = {};
          for (t = 0, i = d.A.BO.length; t < i; t++) d.A.BO[t].BG.substring(0, 7) === ZC._[50] && d.A.BO[t].BA === d.BA && g++, d.A.BO[t].BG.substring(0, 7) === ZC._[50] && ("default" === d.A.BO[t].BA ? (m[d.A.BO[t].BG] = B, B++) : (m[d.A.BO[t].BG] = v, v++));
          var b = m[d.BG],
            E = "default" === d.BA,
            K = null,
            D = null;
          for (t = 0, i = d.A.AY.A4.length; t < i; t++) {
            var F = d.A.AY.A4[t],
              I = F.BT();
            if (-1 !== ZC.AV(I, d.BG)) {
              var x = d.A.BJ(F.BT("v")[0]);
              K = x.AM(x.HA), D = F;
              break;
            }
          }
          var y = 8;
          null !== ZC._n_(d.J2.o[ZC._[21]]) && (y = ZC._i_(d.J2.o[ZC._[21]]));
          var X = 4;
          null !== ZC._n_(d.II.o[ZC._[21]]) && (X = ZC._i_(d.II.o[ZC._[21]]));
          var Y = ZC._i_(d.A.E[d.BG + "-distance"] || -1);
          d.W2 && (Y = 0), "default" === d.BA ? (a = ZC._i_(d.A.P.DX / g), n = d.iX - (b - 1) * a, -1 !== Y && (n = d.iX - Y)) : (a = ZC._i_(d.A.P.E6 / g), n = d.iX + d.I + (b - 1) * a, -1 !== Y && (n = d.iX + d.I + Y));
          var w = n;
          if (d.A.HZ && d.BG === ZC._[50] && (d.A.HZ.AN = !0, d.DD === d.W && d.DV === d.A1 && (d.A.HZ.AN = !1), d.A.HZ.AN && 0 === d.A.HZ.B0.BM && "default" === d.BA && (n -= d.A.HZ.B0.I + d.AZ / 2)), d.E.iX = n, d.AN && d.TM) {
            null !== ZC._n_(d.o["fixed-items"]) && (d.MB = d.EH = ZC._i_(d.o["fixed-items"]));
            var L = Math.ceil((d.A1 - d.W) / (d.MB - 1)),
              M = Math.ceil((d.A1 - d.W) / (d.EH - 1));
            null === ZC._n_(d.o["fixed-items"]) && ZC._b_(d.o.normalize) && (L = ZC.AR.A10(L), M = ZC.AR.A10(M));
            for (var H = d.iStepMultiplier, G = 3; G > 0; G--) d.iStepMultiplier > G && d.A1 - d.W <= G * d.iStepMultiplier && (H = G);
            L *= H, M *= H;
            var P,
              N,
              O,
              S = 0,
              Q = d.AC * L / (d.FU + 1);
            if (null === ZC._n_(K) && (K = n), l = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-ml-0-c"), r = ZC.Q.E9(l, d.H.AA), o = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-bl-0-c"), s = ZC.Q.E9(o, d.H.AA), "inherit" === d.o["line-color"] && -1 !== f && (d.B7 = f), d.A.AJ["3d"]) (p = ZC.DH.DA(d, d.A, n - ZC.AP.E2, n - ZC.AP.E2, d.iY - ZC.AP.E1, d.iY - ZC.AP.E1 + d.F, -1, ZC.AP.FV + 1, "y")).K = d.K + "-line", d.A.EZ.true3d && (d.A.EZ[ZC._[27]] > 0 ? p.MO = [1 === d.L ? -100 : 100, 1, 1] : p.MO = [1 === d.L ? 100 : -100, 1, 1]), d.A.CJ.add(p);else {
              A = [[w, d.iY + d.F], [w, d.iY]];
              var k = d.K;
              d.K += "-line", ZC.CQ.paint(r, d, A), d.K = k;
            }
            if (d.V.length > 0 && d.D6.AN) {
              var T = null === ZC._n_(d.D6.o["offset-start"]) ? 0 : ZC._i_(d.D6.o["offset-start"]),
                z = null === ZC._n_(d.D6.o["offset-end"]) ? 0 : ZC._i_(d.D6.o["offset-end"]);
              if (d.D6.o.items && d.D6.o.items.length > 0 && !d.A.AJ["3d"]) for (u = new I3(d), t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) C = t - d.W, _ = t % d.D6.o.items.length, u.append(d.D6.o.items[_]), u.K = d.K + "-guide-" + t, u.Z = o, u.parse(), u.iX = d.iX + T, d.AW ? u.iY = d.iY + d.AB + C * d.AC : u.iY = d.iY + d.F - d.AB - (C + 1) * d.AC, u.I = d.I - T - z, u.F = d.AC, u.paint();
              if (d.D6.AZ > 0) for (d.GX = 0, t = d.W; t <= d.A1 + (d.DI ? 1 : 0); t++) if (d.KA = t, t === d.W || t === d.A1 + (d.DI ? 1 : 0) || (t - d.W) % L == 0) {
                (d.D6.E5.length > 0 || t === d.W) && ((c = new CZ(d)).Z = c.C7 = o, c.copy(d.D6), c.IV = Ae, c.DB() && c.parse()), C = t - d.W, A = [], Z = d.AW ? d.iY + d.AB + C * d.AC : d.iY + d.F - d.AB - C * d.AC;
                var V = d.iX + T,
                  R = d.I - T - z;
                if (c.AN) if (d.A.AJ["3d"]) {
                  var J = new CZ(d);
                  J.copy(c), null !== ZC._n_(d.o["scale-z"]) && null !== ZC._n_(e = d.o["scale-z"].guide) && (J.append(e), J.parse()), J.A0 = J.AE = J.B7, p = ZC.DH.DA(J, d.A, n - ZC.AP.E2, n - ZC.AP.E2, Z - ZC.AP.E1 - J.AZ / 2, Z - ZC.AP.E1 + J.AZ / 2, 0, ZC.AP.FV, "z"), d.A.CJ.add(p), c.A0 = c.AE = c.B7, (p = ZC.DH.DA(c, d.A, V - ZC.AP.E2, V - ZC.AP.E2 + R, Z - ZC.AP.E1 - J.AZ / 2, Z - ZC.AP.E1 + J.AZ / 2, ZC.AP.FV + 2, ZC.AP.FV + 2, "x")).K = d.K + "-guide-" + t, d.A.CJ.add(p);
                } else A.push([V, Z], [V + R, Z]), c.K = d.K + "-guide-" + t, ZC.CQ.paint(s, c, A);
                d.GX++;
              }
            }
            if (d.V.length > 0 && d.G6.AN && !d.A.AJ["3d"]) {
              if (d.G6.o.items && d.G6.o.items.length > 0) for (u = new I3(d), t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) for (d.KA = t, C = t - d.W, d.GX = 0, h = 1; h <= d.FU; h++) _ = d.GX % d.G6.o.items.length, u.append(d.G6.o.items[_]), u.K = d.K + "-guide-" + t + "-" + h, u.Z = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-bl-0-c"), u.parse(), u.iX = d.iX, d.AW ? u.iY = d.iY + d.AB + (C + 1) * d.AC - (h + 1) * Q : u.iY = d.iY + d.F - d.AB - (C + 1) * d.AC + h * Q, u.I = d.I, u.F = Q, u.paint(), d.GX++;
              if (d.G6.AZ > 0) for (t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) if (d.KA = t, t % L == 0) for (C = t - d.W, d.GX = 0, h = 1; h <= d.FU; h++) A = [], (c = new CZ(d)).copy(d.G6), c.IV = Ae, c.DB() && c.parse(), Z = "log" === d.C1 ? d.AM(d.V[t] + h * (d.V[t + 1] - d.V[t]) / (d.FU + 1)) : d.AW ? d.iY + d.AB + C * d.AC + h * Q : d.iY + d.F - d.AB - C * d.AC - h * Q, ZC.DR(Z, d.iY, d.iY + d.F) && (A.push([d.iX, Z], [d.iX + d.I, Z]), c.AN && (c.K = d.K + "-minor-guide-" + h, ZC.CQ.paint(s, c, A))), d.GX++;
            }
            if (d.TN(s, f), d.V.length > 0 && d.J2.AN && (!d.A.AJ["3d"] || !d.A.EZ.true3d)) {
              switch (d.J2.o[ZC._[7]]) {
                case "inner":
                  break;
                case "outer":
                  S += y;
                  break;
                default:
                  S += y / 2;
              }
              for (d.GX = 0, t = d.W; t <= d.A1 + (d.DI ? 1 : 0); t++) if (d.KA = t, t === d.W || t === d.A1 + (d.DI ? 1 : 0) || (t - d.W) % L == 0) {
                switch (A = [], C = t - d.W, (d.J2.E5.length > 0 || t === d.W) && ((c = new CZ(d)).copy(d.J2), "inherit" === d.J2.o["line-color"] && -1 !== f && (c.B7 = f), c.IV = Ae, c.DB() && c.parse()), Z = d.AW ? d.iY + d.AB + C * d.AC : d.iY + d.F - d.AB - C * d.AC, c.o[ZC._[7]]) {
                  case "ref-auto":
                    A.push([K - y / 2, Z], [K + y / 2, Z]);
                    break;
                  case "ref-left":
                    A.push([K - y, Z], [K, Z]);
                    break;
                  case "ref-right":
                    A.push([K + y, Z], [K, Z]);
                    break;
                  case "inner":
                    A.push([n, Z], [n + (E ? y : -y), Z]);
                    break;
                  case "outer":
                    A.push([n, Z], [n - (E ? y : -y), Z]);
                    break;
                  default:
                    A.push([n + y / 2, Z], [n - y / 2, Z]);
                }
                if (c.AN) {
                  for (N = ZC._i_(c.o["offset-x"] || "0"), O = ZC._i_(c.o["offset-y"] || "0"), P = 0; P < A.length; P++) A[P][0] += N, A[P][1] += O;
                  c.K = d.K + "-tick-" + t, ZC.CQ.paint(r, c, A);
                }
                d.GX++;
              }
            }
            var W,
              U = [];
            if (d.V.length > 0 && d.FU > 0 && d.II.AN && !d.A.AJ["3d"]) for (t = d.W; t < d.A1 + (d.DI ? 1 : 0); t++) if (t === d.W || t === d.A1 + (d.DI ? 1 : 0) || t % L == 0) for (C = t - d.W, h = 1; h <= d.FU; h++) {
              if (A = [], (c = new CZ(d)).copy(d.II), "inherit" === d.II.o["line-color"] && -1 !== f && (c.B7 = f), c.IV = Ae, c.DB() && c.parse(), "log" === d.C1) {
                Z = d.AM(d.V[t] + h * (d.V[t + 1] - d.V[t]) / (d.FU + 1));
                var j = Math.round(ZC.G8(d.V[t], d.E4)),
                  q = d.V[t] + h * (d.V[t + 1] - d.V[t]) / (d.FU + 1);
                q = j < 0 ? ZC._f_(q.toFixed(-j)) : ZC._f_(q.toFixed(j)), U.push(q), Z = d.AM(q);
              } else Z = d.AW ? d.iY + d.AB + C * d.AC + h * Q : d.iY + d.F - d.AB - C * d.AC - h * Q;
              if (ZC.DR(Z, d.iY, d.iY + d.F)) {
                switch (c.o[ZC._[7]]) {
                  case "ref-auto":
                    A.push([K - X / 2, Z], [K + X / 2, Z]);
                    break;
                  case "ref-left":
                    A.push([K - X, Z], [K, Z]);
                    break;
                  case "ref-right":
                    A.push([K + X, Z], [K, Z]);
                    break;
                  case "inner":
                    A.push([n, Z], [n + (E ? X : -X), Z]);
                    break;
                  case "outer":
                    A.push([n, Z], [n - (E ? X : -X), Z]);
                    break;
                  default:
                    A.push([n + X / 2, Z], [n - X / 2, Z]);
                }
                if (c.AN) {
                  for (N = ZC._i_(c.o["offset-x"] || "0"), O = ZC._i_(c.o["offset-y"] || "0"), P = 0; P < A.length; P++) A[P][0] += N, A[P][1] += O;
                  c.K = d.K + "-minor-tick-" + t, ZC.CQ.paint(r, c, A);
                }
              }
              d.GX++;
            }
            d.VU();
            var $ = null,
              ee = d.CH,
              te = d.DM,
              ie = 0,
              ae = 0,
              ne = 0,
              le = [],
              re = [];
            if (1 === d.V.length && d.BR.AN) d.GX = 0, Ze(d.W);else if (d.V.length > 1 && d.BR.AN) for (d.GX = 0, Ze(d.W), d.GX = d.A1 - d.W, Ze(d.A1), d.GX = 1, t = d.W + 1; t < d.A1; t++) (t - d.W) % M == 0 && Ze(t);
            for (t = 0; t < U.length; t++) {
              var oe = d.FC(t, null, null, !1, U[t]);
              Ze(oe, !0, oe);
            }
            if (d.M.AN && d.M.AO && "" !== d.M.AO) {
              (W = new DT(d)).copy(d.M), W.K = d.A.K + "-" + d.BG.replace(/\-/g, "_") + "-item_title", W.GO = d.K + "-label " + d.A.K + "-scale-label zc-scale-label", W.AO = d.M.AO, W.Z = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-ml-0-c"), W.IW = d.H.usc() ? ZC.AK(d.H.K + "-main") : ZC.AK(d.H.K + "-text"), W.parse(), "inherit" !== d.M.o["font-color"] && "inherit" !== d.M.o.color || -1 === f || (W.C2 = f);
              var se = d.iY + (d.AW ? d.AB : d.BV),
                Ce = d.F - d.AB - d.BV;
              switch ("chart" === W.o["center-point"] && (se = d.A.iY, Ce = d.A.F), W.K4) {
                case "top":
                  W.iY = se + W.I / 2 - W.F / 2;
                  break;
                case "middle":
                  W.iY = se + Ce / 2 - W.F / 2;
                  break;
                case "bottom":
                  W.iY = se + Ce - W.I / 2 - W.F / 2;
              }
              W.iX = E ? n - W.I / 2 - W.F / 2 - S - ae : n + W.F / 2 + ae + S - W.I / 2, d.M.iX = W.iX, d.M.iY = W.iY, W.AN && (d.MC(W, null, "v"), W.paint(), W.ED(), null === ZC._n_(W.o.tooltip) && W.KE || re.push(ZC.AQ.OG(d.A.K, W)));
            }
            re.length > 0 && ZC.AK(d.A.A.K + "-map") && (ZC.AK(d.A.A.K + "-map").innerHTML += re.join(""));
          }
        }
        function Ae(e) {
          return e = (e = (e = (e = (e = e.replace(/%scale-last-position/g, d.A1 - d.W)).replace(/(%c)|(%scale-position)/g, d.GX)).replace(/(%i)|(%scale-index)/g, d.KA)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(d.V[d.KA]) ? d.V[d.KA] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(d.BY[d.KA]) ? d.BY[d.KA] : "");
        }
        function Ze(e, t, i) {
          d.KA = e, C = e - d.W, (d.BR.E5.length > 0 || e === d.W || !W || d.BR.I1) && (W = new DT(d)), W.copy(d.BR), W.K = d.A.K + "-" + d.BG.replace(/\-/g, "_") + "-item_" + (i ? "c" + i : e), W.GO = d.K + "-item " + d.A.K + "-scale-item zc-scale-item", W.E["p-height"] = d.AC, d.CH = ee, d.DM = te, d.W9(Ae);
          var a = "";
          if (a = i || d.FC(e), d.BR.I1) {
            var l = d.A.GR();
            ZC._cp_({
              index: e,
              cnt: C,
              text: a
            }, l), d.GN(d.BR, W, null, l, d.BR.MV);
          }
          if (null === ZC._n_(d.M4) || -1 !== ZC.AV(d.M4, a)) {
            switch (W.AO = a, W.Z = W.C7 = d.H.usc() ? d.H.mc() : ZC.AK(d.A.K + "-scales-ml-0-c"), W.IW = d.H.usc() ? ZC.AK(d.H.K + "-main") : ZC.AK(d.H.K + "-text"), W.E.nodeidx = e, W.parse(), "inherit" !== d.BR.o["font-color"] && "inherit" !== d.BR.o.color || -1 === f || (W.C2 = f), W.IV = Ae, W.DB() && W.parse(), W.o["auto-fit"] && (W.F = ZC._i_(d.AC)), W.o[ZC._[7]]) {
              case "inner":
                W.iX = E ? n + y : n - W.I - y;
                break;
              case "ref-left":
                W.iX = K - W.I - y;
                break;
              case "ref-right":
                W.iX = K + y;
                break;
              case "ref-auto":
                D && D.S[e] ? (D.S[e].setup(), D.S[e].iX < K ? W.iX = K + y : W.iX = K - W.I - y) : W.iX = K + y;
                break;
              default:
                W.iX = E ? n - W.I - y : n + y;
            }
            if (t ? (Z = d.AM(e), W.iY = Z - W.F / 2 - (d.DI ? d.AC / 2 : 0)) : d.AW ? W.iY = d.iY + d.AB + C * d.AC - W.F / 2 + (d.DI ? d.AC / 2 : 0) : W.iY = d.iY + d.F - d.AB - C * d.AC - W.F / 2 - (d.DI ? d.AC / 2 : 0), $ = d.MC(W, $, "v"), d.BR.o["auto-align"] && d.BR.A9 % 180 != 0) {
              var r = E ? 1 : -1;
              90 === d.BR.A9 || 270 === d.BR.A9 ? W.iX += r * (W.I / 2 - W.F / 2) : ZC.DR(d.BR.A9, 0, 90) || ZC.DR(d.BR.A9, 270, 360) ? (W.iX += r * (W.I - W.I * ZC.EG(d.BR.A9)) / 2, W.iY -= r * W.I * ZC.EN(d.BR.A9) / 2) : ZC.DR(d.BR.A9, 90, 270) && (W.iX += r * (W.I + W.I * ZC.EG(d.BR.A9)) / 2, W.iY += r * W.I * ZC.EN(d.BR.A9) / 2);
            }
            var o = d.UN(W, e, {
              items: ne,
              lcoords: le,
              lstep: M,
              tdim: ie,
              mdim: ae,
              dim: "w",
              html: re
            });
            ie = o.tdim, ae = o.mdim, d.GX++;
          }
        }
      }
    }]);
    return VH;
  }(A3Z);
  var VG = /*#__PURE__*/function (_ZY2) {
    _inherits(VG, _ZY2);
    function VG(e) {
      var _this103;
      _classCallCheck(this, VG);
      _this103 = _possibleConstructorReturn(this, _getPrototypeOf(VG).call(this, e)), _this103.CO = !0;
      return _this103;
    }
    _createClass(VG, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(VG.prototype), "parse", this).call(this);
      }
    }, {
      key: "H0",
      value: function H0() {
        var e = this;
        e.A1 === e.W ? e.AC = e.I - e.AB - e.BV : e.AC = (e.I - e.AB - e.BV) / (e.A1 - e.W + (e.DI ? 1 : 0));
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(VG.prototype), "HE", this).call(this, e), this.H0();
      }
    }, {
      key: "zoomTo",
      value: function zoomTo(e, t) {
        _get(_getPrototypeOf(VG.prototype), "zoomTo", this).call(this, e, t), this.H0();
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(VG.prototype), "build", this).call(this);
      }
    }, {
      key: "KV",
      value: function KV(e, t) {
        var i,
          a = this;
        i = a.AW ? (a.iX + a.I - a.AB - e) / (a.I - a.AB - a.BV) : (e - a.iX - a.AB) / (a.I - a.AB - a.BV);
        var n = a.B3 + ZC._f_((a.BL - a.B3) * i);
        return "log" === a.C1 && t && (n = Math.pow(a.E4, n)), n;
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t = this,
          i = t.BL - t.B3,
          a = 0 === i ? 0 : (t.I - t.AB - t.BV - (t.DI ? t.AC : 0)) / i;
        return "log" === t.C1 && (e = 0 === e ? t.FX : ZC.G8(e, t.E4)), t.AW ? t.iX + t.I - t.AB - (e - t.B3) * a : t.iX + t.AB + (e - t.B3) * a;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C,
          A,
          Z,
          c,
          p,
          u,
          h,
          _,
          d,
          f,
          g = this;
        if (g.AN && 0 !== g.V.length) {
          _get(_getPrototypeOf(VG.prototype), "paint", this).call(this), "hbubble" !== g.A.AF && "hscatter" !== g.A.AF || 1 !== g.V.length || (g.AB = g.I / 2);
          var B = g.YA(),
            v = 0,
            m = 1,
            b = 1,
            E = {};
          for (t = 0, i = g.A.BO.length; t < i; t++) g.A.BO[t].BG.substring(0, 7) === ZC._[51] && g.A.BO[t].BA === g.BA && v++, g.A.BO[t].BG.substring(0, 7) === ZC._[51] && ("default" === g.A.BO[t].BA ? (E[g.A.BO[t].BG] = m, m++) : (E[g.A.BO[t].BG] = b, b++));
          var K = E[g.BG],
            D = "default" === g.BA;
          for (t = 0, i = g.A.AY.A4.length; t < i; t++) {
            var F = g.A.AY.A4[t],
              I = F.BT();
            if (-1 !== ZC.AV(I, g.BG)) {
              var x = g.A.BJ(F.BT("k")[0]);
              x.AM(x.HA), F;
              break;
            }
          }
          var y = 8;
          null !== ZC._n_(g.J2.o[ZC._[21]]) && (y = ZC._i_(g.J2.o[ZC._[21]]));
          var X = 4;
          null !== ZC._n_(g.II.o[ZC._[21]]) && (X = ZC._i_(g.II.o[ZC._[21]]));
          var Y = ZC._i_(g.A.E[g.BG + "-distance"] || -1);
          g.W2 && (Y = 0), "default" === g.BA ? (u = ZC._i_(g.A.P.DP / v), a = g.iY + g.F + (K - 1) * u, -1 !== Y && (a = g.iY + g.F + Y)) : (u = ZC._i_(g.A.P.E7 / v), a = g.iY - (K - 1) * u, -1 !== Y && (a = g.iY - Y));
          var w = a;
          if (g.A.HY && (g.A.HY.AN = !0, g.FX === g.B3 && g.H4 === g.BL && (g.A.HY.AN = !1), g.A.HY.AN && 0 === g.A.HY.B0.BH && "default" === g.BA && (a += g.A.HY.B0.F + g.AZ / 2)), g.E.iY = a, g.AN && g.TM) {
            for (var L = Math.ceil((g.A1 - g.W) / (g.EH - 1)), M = Math.ceil((g.A1 - g.W) / (g.MB - 1)), H = g.iStepMultiplier, G = 3; G > 0; G--) g.iStepMultiplier > G && g.A1 - g.W <= G * g.iStepMultiplier && (H = G);
            M *= H, L *= H;
            var P = 0,
              N = g.AC * M / (g.FU + 1);
            if (n = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-ml-0-c"), l = ZC.Q.E9(n, g.H.AA), r = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-bl-0-c"), o = ZC.Q.E9(r, g.H.AA), g.TM || g.ZO || null !== ZC._n_(g.A.o[g.BG])) {
              if ("inherit" === g.o["line-color"] && -1 !== B && (g.B7 = B), g.A.AJ["3d"]) (c = ZC.DH.DA(g, g.A, g.iX - ZC.AP.E2, g.iX - ZC.AP.E2 + g.I, a - ZC.AP.E1, a - ZC.AP.E1, -1, ZC.AP.FV + 1, "x")).K = g.K + "-line", g.A.EZ.true3d && (g.A.EZ[ZC._[28]] > 0 ? c.MO = [1 === g.L ? -100 : 100, 1, 1] : c.MO = [1 === g.L ? 100 : -100, 1, 1]), g.A.CJ.add(c);else {
                s = [[g.iX, w], [g.iX + g.I, w]];
                var O = g.K;
                g.K += "-line", ZC.CQ.paint(l, g, s), g.K = O;
              }
              var S = [],
                Q = 0,
                k = 0,
                T = [];
              if (g.TM || g.ZO) {
                if (g.V.length > 0 && g.D6.AN) {
                  var z = null === ZC._n_(g.D6.o["offset-start"]) ? 0 : ZC._i_(g.D6.o["offset-start"]),
                    V = null === ZC._n_(g.D6.o["offset-end"]) ? 0 : ZC._i_(g.D6.o["offset-end"]);
                  if (g.D6.o.items && g.D6.o.items.length > 0 && !g.A.AJ["3d"]) for (g.GX = 0, _ = new I3(g), t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) g.KA = t, t % M == 0 && (C = t - g.W, h = g.GX % g.D6.o.items.length, _.append(g.D6.o.items[h]), _.K = g.K + "-guide-" + t, _.Z = r, _.parse(), A = "log" === g.C1 ? g.AM(g.V[t]) : g.AM(g.V[t]) - (g.AW ? g.AC * M : 0), _.iX = A, _.iY = g.iY + z, _.I = g.AC * M, _.F = g.F - z - V, _.paint(), g.GX++);
                  if (g.D6.AZ > 0) for (g.GX = 0, t = g.W; t <= g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t === g.W || t === g.A1 || t % M == 0) {
                    (g.D6.E5.length > 0 || t === g.W || "log" === g.C1) && ((Z = new CZ(g)).Z = Z.C7 = r, "log" === g.C1 ? ZC.AR._int_(ZC.G8(g.V[t], g.E4)) ? Z.copy(g.D6) : Z.copy(g.G6) : Z.copy(g.D6), Z.IV = oe, Z.DB() && Z.parse()), s = [], C = t - g.W;
                    var R = g.iY + z,
                      J = g.F - z - V;
                    if (A = (g.C1, g.AM(g.V[t])), Z.AN) if (g.A.AJ["3d"]) {
                      var W = new CZ(g);
                      W.copy(Z), null !== ZC._n_(g.o["scale-z"]) && null !== ZC._n_(e = g.o["scale-z"].guide) && (W.append(e), W.parse()), W.A0 = W.AE = W.B7, c = ZC.DH.DA(W, g.A, A - ZC.AP.E2 - W.AZ / 2, A - ZC.AP.E2 + W.AZ / 2, a - ZC.AP.E1, a - ZC.AP.E1, 0, ZC.AP.FV, "z"), g.A.CJ.add(c), Z.A0 = Z.AE = Z.B7, (c = ZC.DH.DA(Z, g.A, A - ZC.AP.E2 - Z.AZ / 2, A - ZC.AP.E2 + Z.AZ / 2, R - ZC.AP.E1, R - ZC.AP.E1 + J, ZC.AP.FV + 2, ZC.AP.FV + 2, "y")).K = g.K + "-guide-" + t, g.A.CJ.add(c);
                    } else s.push([A, R], [A, R + J]), Z.K = g.K + "-guide-" + t, ZC.CQ.paint(o, Z, s);
                    g.GX++;
                  }
                }
                if (g.V.length > 0 && g.G6.AN && N > 2 && !g.A.AJ["3d"]) {
                  if (g.G6.o.items && g.G6.o.items.length > 0) for (_ = new I3(g), t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t % M == 0) for (C = t - g.W, g.GX = 0, p = 0; p <= g.FU; p++) h = g.GX % g.G6.o.items.length, _.append(g.G6.o.items[h]), _.K = g.K + "-guide-" + t + "-" + p, _.Z = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-bl-0-c"), _.parse(), A = g.AW ? g.iX + g.I - g.AB - C * g.AC - (p + 1) * N : g.iX + g.AB + C * g.AC + p * N, _.iX = A, _.iY = g.iY, _.I = N, _.F = g.F, _.paint(), g.GX++;
                  if (g.G6.AZ > 0 && "log" !== g.C1) for (t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t === g.W || t === g.A1 || t % M == 0) for (C = t - g.W, g.GX = 0, p = 1; p <= g.FU; p++) s = [], (Z = new CZ(g)).copy(g.G6), Z.IV = oe, Z.DB() && Z.parse(), A = "log" === g.C1 ? g.AM(g.V[t] + p * (g.V[t + 1] - g.V[t]) / (g.FU + 1)) : g.AM(g.V[t] + p * L * (g.V[t + 1] - g.V[t]) / (g.FU + 1)), ZC.DR(A, g.iX, g.iX + g.I) && (s.push([A, g.iY], [A, g.iY + g.F]), Z.AN && (Z.K = g.K + "-minor-guide-" + p, ZC.CQ.paint(o, Z, s))), g.GX++;
                }
                var U, j, q;
                if (g.TN(o, B), g.V.length > 0 && g.J2.AN && (!g.A.AJ["3d"] || !g.A.EZ.true3d)) {
                  switch (g.J2.o[ZC._[7]]) {
                    case "inner":
                      break;
                    case "outer":
                      P += y;
                      break;
                    default:
                      P += y / 2;
                  }
                  for (g.GX = 0, d = ZC.AV(g.V, 0), t = g.W; t <= g.A1 + (g.DI ? 1 : 0); t++) {
                    g.KA = t;
                    var $ = -1;
                    if ((t === g.W || t === g.A1 || t % M == 0 || ZC._b_(g.o["show-zero"]) && t === d) && (s = [], C = t - g.W, (g.J2.E5.length > 0 || t === g.W || "log" === g.C1) && (Z = new CZ(g), "log" === g.C1 ? ZC.AR._int_(ZC.G8(g.V[t], g.E4)) ? Z.copy(g.J2) : (Z.copy(g.II), $ = y, y = X) : Z.copy(g.J2), "inherit" === g.J2.o["line-color"] && -1 !== B && (Z.B7 = B), Z.IV = oe, Z.DB() && Z.parse()), A = (g.C1, g.AM(g.V[t])), ZC.DR(A, g.A.P.iX, g.A.P.iX + g.A.P.I))) {
                      switch (Z.o[ZC._[7]]) {
                        case "inner":
                          s.push([A, a - (D ? y : -y)], [A, a]);
                          break;
                        case "outer":
                          s.push([A, a], [A, a + (D ? y : -y)]);
                          break;
                        default:
                          s.push([A, a + y / 2], [A, a - y / 2]);
                      }
                      if (-1 !== $ && (y = $, $ = -1), Z.AN) {
                        for (j = ZC._i_(Z.o["offset-x"] || "0"), q = ZC._i_(Z.o["offset-y"] || "0"), U = 0; U < s.length; U++) s[U][0] += j, s[U][1] += q;
                        Z.K = g.K + "-tick-" + t, ZC.CQ.paint(l, Z, s);
                      }
                      g.GX++;
                    }
                  }
                }
                if (g.V.length > 0 && g.II.AN && g.FU > 0 && N > 5 && !g.A.AJ["3d"] && "log" !== g.C1) for (t = g.W; t < g.A1 + (g.DI ? 1 : 0); t++) if (g.KA = t, t === g.W || t === g.A1 || t % M == 0) for (C = t - g.W, g.GX = 0, p = 1; p <= g.FU; p++) {
                  if (s = [], (Z = new CZ(g)).copy(g.II), "inherit" === g.II.o["line-color"] && -1 !== B && (Z.B7 = B), Z.IV = oe, Z.DB() && Z.parse(), A = "log" === g.C1 ? g.AM(g.V[t] + p * (g.V[t + 1] - g.V[t]) / (g.FU + 1)) : g.AM(g.V[t] + p * L * (g.V[t + 1] - g.V[t]) / (g.FU + 1)), ZC.DR(A, g.iX, g.iX + g.I)) {
                    switch (Z.o[ZC._[7]]) {
                      case "inner":
                        s.push([A, a - (D ? X : -X)], [A, a]);
                        break;
                      default:
                        s.push([A, a], [A, a + (D ? X : -X)]);
                        break;
                      case "cross":
                        s.push([A, a + X / 2], [A, a - X / 2]);
                    }
                    if (Z.AN) {
                      for (j = ZC._i_(Z.o["offset-x"] || "0"), q = ZC._i_(Z.o["offset-y"] || "0"), U = 0; U < s.length; U++) s[U][0] += j, s[U][1] += q;
                      Z.K = g.K + "-minor-tick-" + t, ZC.CQ.paint(l, Z, s);
                    }
                  }
                  g.GX++;
                }
                g.VU();
                var ee = null,
                  te = g.CH,
                  ie = g.DM,
                  ae = function ae(e) {
                    var t;
                    if (g.KA = e, C = e - g.W, (g.BR.E5.length > 0 || e === g.W || !f || g.BR.I1) && (f = new DT(g)), f.copy(g.BR), f.GO = g.K + "-item " + g.A.K + "-scale-item zc-scale-item", f.K = g.A.K + "-" + g.BG.replace(/\-/g, "_") + "-item_" + e, g.CH = te, g.DM = ie, g.W9(oe), t = ("piano" === g.A.AF || g.QE) && g.BY.length ? g.FC(e + g.B3) : g.FC(e), g.BR.I1) {
                      var i = g.A.GR();
                      ZC._cp_({
                        index: e,
                        cnt: C,
                        text: t
                      }, i), g.GN(g.BR, f, null, i, g.BR.MV);
                    }
                    if (null === ZC._n_(g.M4) || -1 !== ZC.AV(g.M4, t)) {
                      switch (f.AO = t, f.Z = f.C7 = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-ml-0-c"), f.IW = g.H.usc() ? ZC.AK(g.H.K + "-main") : ZC.AK(g.H.K + "-text"), f.parse(), "inherit" !== g.BR.o["font-color"] && "inherit" !== g.BR.o.color || -1 === B || (f.C2 = B), f.IV = oe, f.E5 = g.BR.E5, f.DB() && f.parse(), f.o[ZC._[7]]) {
                        case "inner":
                          f.iY = D ? a - f.KH - y : a + y;
                          break;
                        default:
                          f.iY = D ? a + y : a - f.KH - y;
                      }
                      if ("log" === g.C1 ? f.iX = g.AM(g.V[e]) - f.I / 2 : f.iX = g.AM(g.V[e]) - f.I / 2 - (g.AW ? 1 : -1) * (g.DI ? g.AC / 2 : 0), ee = g.MC(f, ee, "h"), g.BR.o["auto-align"] && g.BR.A9 % 180 != 0) {
                        var n = ZC.DR(g.BR.A9, 0, 180) ? D ? 1 : -1 : 1 === D ? -1 : 1;
                        f.iX += n * f.I * ZC.EG(g.BR.A9) / 2, f.iY += n * (f.I * ZC.EN(g.BR.A9) / 2 - f.F * ZC.EN(g.BR.A9) / 2);
                      }
                      if (ZC.DR(f.iX + f.I / 2, g.A.P.iX, g.A.P.iX + g.A.P.I)) {
                        var l = g.UN(f, e, {
                          items: 0,
                          lcoords: S,
                          lstep: L,
                          tdim: Q,
                          mdim: k,
                          dim: "h",
                          html: T
                        });
                        Q = l.tdim, k = l.mdim, g.GX++;
                      }
                    }
                  };
                if (g.V.length > 0 && g.BR.AN) if ("log" === g.C1) {
                  var ne = [];
                  for (t = g.W; t <= g.A1; t++) ZC.AR._int_(ZC.G8(g.V[t], g.E4)) && (g.GX = t, ae(t), ne.push(t));
                  for (t = g.W; t <= g.A1; t++) -1 === ZC.AV(ne, t) && (g.GX = t, ae(t));
                } else for (g.GX = 0, ae(g.W), g.GX = g.A1 - g.W, ae(g.A1), -1 !== (d = ZC.AV(g.V, 0)) && ZC._b_(g.o["show-zero"]) && (g.GX = d, ae(d)), g.GX = 1, t = g.W + 1; t < g.A1; t++) t % L == 0 && ae(t);
              }
              if (g.M.AN && g.M.AO && "" !== g.M.AO) {
                (f = new DT(g)).copy(g.M), f.K = g.A.K + "-" + g.BG.replace(/\-/g, "_") + "-item_title", f.GO = g.K + "-label " + g.A.K + "-scale-label zc-scale-label", f.AO = g.M.AO, f.Z = g.H.usc() ? g.H.mc() : ZC.AK(g.A.K + "-scales-ml-0-c"), f.IW = g.H.usc() ? ZC.AK(g.H.K + "-main") : ZC.AK(g.H.K + "-text"), f.parse(), "inherit" !== g.M.o["font-color"] && "inherit" !== g.M.o.color || -1 === B || (f.C2 = B);
                var le = g.iX + (g.AW ? g.BV : g.AB),
                  re = g.I - g.AB - g.BV;
                switch ("chart" === f.o["center-point"] && (le = g.A.iX, re = g.A.I), f.OO) {
                  case "left":
                    f.iX = le;
                    break;
                  case "center":
                    f.iX = le + re / 2 - f.I / 2;
                    break;
                  case "right":
                    f.iX = le + re - f.I;
                }
                f.iY = D ? a + P + k : a - k - f.F - P, g.M.iX = f.iX, g.M.iY = f.iY, f.AN && (g.MC(f, null, "h"), f.paint(), f.ED(), null === ZC._n_(f.o.tooltip) && f.KE || T.push(ZC.AQ.OG(g.A.K, f)));
              }
              T.length > 0 && ZC.AK(g.A.A.K + "-map") && (ZC.AK(g.A.A.K + "-map").innerHTML += T.join(""));
            }
          }
        }
        function oe(e) {
          return e = (e = (e = (e = (e = e.replace(/%scale-last-position/g, g.A1 - g.W)).replace(/(%c)|(%scale-position)/g, g.GX)).replace(/(%i)|(%scale-index)/g, g.KA)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(g.V[g.KA]) ? g.V[g.KA] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(g.BY[g.KA]) ? g.BY[g.KA] : "");
        }
      }
    }]);
    return VG;
  }(ZY);
  var YK = /*#__PURE__*/function (_A3Z3) {
    _inherits(YK, _A3Z3);
    function YK(e) {
      var _this104;
      _classCallCheck(this, YK);
      _this104 = _possibleConstructorReturn(this, _getPrototypeOf(YK).call(this, e));
      var t = _assertThisInitialized(_this104);
      t.NS = "", t.KZ = 1, t.H5 = 1, t.GM = 0, t.GG = 0, t.JV = .6;
      return _this104;
    }
    _createClass(YK, [{
      key: "parse",
      value: function parse() {
        var e = this;
        _get(_getPrototypeOf(YK.prototype), "parse", this).call(this), e.iX += e.DX, e.iY += e.E7, e.I -= e.DX + e.E6, e.F -= e.E7 + e.DP, e.YU("layout", "NS"), null !== ZC._n_(e.o["size-factor"]) && (e.JV = ZC._f_(ZC._p_(e.o["size-factor"])));
      }
    }, {
      key: "HE",
      value: function HE(e) {
        var t = this;
        _get(_getPrototypeOf(YK.prototype), "HE", this).call(this, e), 0 === t.V.length && (t.V = [""]);
        var i = ZC.AR.A2Y(t.NS, t.V.length, !1);
        t.KZ = i[0], t.H5 = i[1], t.GM = t.I / t.H5, t.GG = t.F / t.KZ;
      }
    }, {
      key: "X1",
      value: function X1() {
        var e = this;
        _get(_getPrototypeOf(YK.prototype), "X1", this).call(this), e.GM = e.I / e.H5, e.GG = e.F / e.KZ;
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(YK.prototype), "build", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l = this;
        if (l.AN) {
          if (_get(_getPrototypeOf(YK.prototype), "paint", this).call(this), e = ZC.Q.E9(l.H.usc() ? l.H.K + "-main-c" : l.A.K + "-scales-ml-0-c", l.H.AA), t = ZC.Q.E9(l.H.usc() ? l.H.K + "-main-c" : l.A.K + "-scales-bl-0-c", l.H.AA), (i = []).push([l.iX, l.iY], [l.iX + l.I, l.iY], [l.iX + l.I, l.iY + l.F], [l.iX, l.iY + l.F], [l.iX, l.iY]), ZC.CQ.paint(e, l, i), l.D6.AN) {
            if (l.D6.o.items && l.D6.o.items.length > 0) for (a = 0, n = l.V.length; a < n; a++) {
              var r = a % l.H5,
                o = Math.floor(a / l.H5),
                s = new I3(l),
                C = a % l.D6.o.items.length;
              s.o = l.D6.o.items[C], s.K = l.K + "-guide-" + a, s.Z = l.H.usc() ? l.H.mc() : ZC.AK(l.A.K + "-scales-bl-0-c"), s.parse(), s.iX = l.iX + r * l.GM, s.iY = l.iY + o * l.GG, s.I = l.GM, s.F = l.GG, s.paint();
            }
            if (l.D6.AZ > 0) {
              for (i = [], a = 0; a <= l.H5; a++) i.push([l.iX + a * l.GM, l.iY], [l.iX + a * l.GM, l.iY + l.F], null);
              for (a = 0; a <= l.KZ; a++) i.push([l.iX, l.iY + a * l.GG], [l.iX + l.I, l.iY + a * l.GG], null);
              ZC.CQ.paint(t, l.D6, i);
            }
          }
          var A,
            Z = [];
          if (l.BR.AN) {
            for (a = 0, n = l.V.length; a < n; a++) c(a);
            Z.length > 0 && ZC.AK(l.A.A.K + "-map") && (ZC.AK(l.A.A.K + "-map").innerHTML += Z.join(""));
          }
        }
        function c(e) {
          (l.BR.E5.length > 0 || 0 === e) && (A = new DT(l)), A.copy(l.BR);
          var t = e % l.H5,
            i = Math.floor(e / l.H5);
          A.GO = l.K + "-item " + l.A.K + "-scale-item zc-scale-item", A.K = l.A.K + "-" + l.BG.replace(/\-/g, "_") + "-item_" + e;
          var a = l.FC(e);
          if ((null === ZC._n_(l.M4) || -1 !== ZC.AV(l.M4, a)) && (A.AO = a, A.Z = l.H.usc() ? l.H.mc() : ZC.AK(l.A.K + "-scales-ml-0-c"), A.parse(), A.IV = function (t) {
            return t = (t = (t = t.replace(/%i/g, e)).replace(/%v/g, null !== ZC._n_(l.V[e]) ? l.V[e] : "")).replace(/%l/g, null !== ZC._n_(l.BY[e]) ? l.BY[e] : "");
          }, A.E5 = l.BR.E5, A.DB() && A.parse(), A.AN)) {
            var n = "bottom";
            null !== ZC._n_(l.BR.o[ZC._[7]]) && (n = l.BR.o[ZC._[7]]);
            var r = l.iX + t * l.GM,
              o = l.iY + i * l.GG;
            switch (n) {
              case "top-left":
                A.iX = r, A.iY = o;
                break;
              case "top-right":
                A.iX = r + l.GM - A.I, A.iY = o;
                break;
              case "bottom-left":
                A.iX = r, A.iY = o + l.GG - A.F;
                break;
              case "bottom-right":
                A.iX = r + l.GM - A.I, A.iY = o + l.GG - A.F;
                break;
              case "top":
                A.iX = r + l.GM / 2 - A.I / 2, A.iY = o;
                break;
              case "right":
                A.iX = r + l.GM - A.I, A.iY = o + l.GG / 2 - A.F / 2;
                break;
              case "left":
                A.iX = r, A.iY = o + l.GG / 2 - A.F / 2;
                break;
              default:
                A.iX = r + l.GM / 2 - A.I / 2, A.iY = o + l.GG - A.F;
            }
            A.paint(), A.ED(), null === ZC._n_(l.o.tooltip) && A.KE || Z.push(ZC.AQ.OG(l.A.K, A));
          }
        }
      }
    }]);
    return YK;
  }(A3Z);
  var A97 = /*#__PURE__*/function (_A3Z4) {
    _inherits(A97, _A3Z4);
    function A97(e) {
      var _this105;
      _classCallCheck(this, A97);
      _this105 = _possibleConstructorReturn(this, _getPrototypeOf(A97).call(this, e));
      _this105.DF = 0, _this105.EI = 360;
      return _this105;
    }
    _createClass(A97, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        _get(_getPrototypeOf(A97.prototype), "parse", this).call(this), null !== ZC._n_(e = t.o["ref-angle"]) && (t.DF = ZC._i_(e) % 360), null !== ZC._n_(e = t.o.aperture) && (t.EI = ZC._i_(e) % 360, 0 === t.EI && (t.EI = 360));
      }
    }]);
    return A97;
  }(A3Z);
  var ABK = /*#__PURE__*/function (_ZY3) {
    _inherits(ABK, _ZY3);
    function ABK(e) {
      _classCallCheck(this, ABK);
      return _possibleConstructorReturn(this, _getPrototypeOf(ABK).call(this, e));
    }
    _createClass(ABK, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(ABK.prototype), "parse", this).call(this);
      }
    }, {
      key: "H0",
      value: function H0() {}
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(ABK.prototype), "HE", this).call(this, e), this.H0();
      }
    }, {
      key: "clear",
      value: function clear() {
        _get(_getPrototypeOf(ABK.prototype), "clear", this).call(this);
      }
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(ABK.prototype), "build", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        _get(_getPrototypeOf(ABK.prototype), "paint", this).call(this);
      }
    }]);
    return ABK;
  }(ZY);
  var A8B = /*#__PURE__*/function (_ABK) {
    _inherits(A8B, _ABK);
    function A8B(e) {
      var _this106;
      _classCallCheck(this, A8B);
      _this106 = _possibleConstructorReturn(this, _getPrototypeOf(A8B).call(this, e));
      var t = _assertThisInitialized(_this106);
      t.DF = -90, t.EI = 180, t.QP = null, t.J5 = null, t.CV = "circle";
      return _this106;
    }
    _createClass(A8B, [{
      key: "parse",
      value: function parse() {
        var e,
          t = this;
        _get(_getPrototypeOf(A8B.prototype), "parse", this).call(this), null !== ZC._n_(e = t.o["ref-angle"]) && (t.DF = ZC._i_(e) % 360), null !== ZC._n_(e = t.o.aperture) && (t.EI = ZC._i_(e)), null !== ZC._n_(e = t.o.center) && (t.QP = new DW(t), t.QP.append(e), t.QP.parse()), null !== ZC._n_(e = t.o.ring) && (t.J5 = new DW(t), t.H.B8.load(t.J5.o, [t.A.AF + "." + t.BG + ".ring"]), t.J5.append(e), t.J5.parse());
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(A8B.prototype), "HE", this).call(this, e);
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(A8B.prototype), "build", this).call(this);
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t = this,
          i = t.A.BJ("scale"),
          a = i.iX + i.I / 2,
          n = i.iY + i.F / 2,
          l = t.A.BJ("scale-" + t.L);
        l || (l = t.A.BJ("scale"));
        var r = ZC.CX(l.GM / 2, l.GG / 2) * l.JV,
          o = t.BL - t.B3,
          s = t.EI / o;
        return ZC.AR.BN(a, n, r, t.DF - t.EI / 2 + s * (e - t.B3));
      }
    }, {
      key: "H6",
      value: function H6(e) {
        return this.AM(this.V[e]);
      }
    }, {
      key: "paintMarker",
      value: function paintMarker(e) {
        var t,
          i = this;
        if (e.FB) {
          var a,
            n = i.A.BJ("scale-" + i.L);
          if (n || (n = i.A.BJ("scale")), e.AN) {
            var l = i.A.K + "-scales-" + ("top" === e.BA ? "f" : "b") + "l-0-c";
            e.Z = e.C7 = ZC.AK(i.H.usc() ? n.H.K + "-main-c" : l), a = ZC.Q.E9(e.Z, i.H.AA);
            var r = ZC.CX(n.GM / 2, n.GG / 2) * n.JV,
              o = ZC.IU(e.o["offset-start"] || "0");
            o > 0 && o < 1 && (o *= r);
            var s = ZC.IU(e.o["offset-end"] || "0");
            s > 0 && s < 1 && (s *= r), e.M && (e.M.Z = i.H.usc() ? i.H.mc() : ZC.AK(i.A.K + "-scales-ml-0-c"), e.M.K = e.A.A.K + "-" + e.A.BG.replace(/\-/g, "_") + "-marker_" + e.L, e.M.GO = e.A.K + "-marker-label " + e.A.A.K + "-scale-marker-label zc-scale-marker-label");
            for (var C = 0; C < n.V.length; C++) {
              var A,
                Z = C % n.H5,
                c = Math.floor(C / n.H5),
                p = n.iX + Z * n.GM + n.GM / 2 + n.BM,
                u = n.iY + c * n.GG + n.GG / 2 + n.BH;
              switch (e.AF) {
                case "line":
                  if (e.FB.length > 0) {
                    var h = i.DF - i.EI / 2 + i.EI * (e.FB[0] - i.B3) / (i.BL - i.B3);
                    A = h;
                    var _ = [];
                    _.push(ZC.AR.BN(p, u, o, h)), _.push(ZC.AR.BN(p, u, r - s, h)), 2 === _.length && (ZC.CQ.setup(a, e), ZC.CQ.paint(a, e, _));
                  }
                  break;
                case "area":
                  if (e.FB.length > 1) {
                    var d = i.DF - i.EI / 2 + i.EI * (e.FB[0] - i.B3) / (i.BL - i.B3),
                      f = i.DF - i.EI / 2 + i.EI * (e.FB[1] - i.B3) / (i.BL - i.B3);
                    A = (d + f) / 2;
                    var g = new DW(e);
                    g.Z = e.Z, g.append(e.o), g.append({
                      size: r - s,
                      slice: o,
                      type: "pie",
                      "angle-start": d,
                      "angle-end": f
                    }), g.K = n.K + "-marker-" + e.L, g.iX = p, g.iY = u, g.parse(), g.paint();
                  }
              }
              if (e.M) {
                var B;
                null !== ZC._n_(t = e.M.o["offset-r"]) ? B = ZC._f_(ZC._p_(t)) : B < 1 ? B *= r - s - o : B = 0;
                var v = ZC.AR.BN(p, u, (r - s - o) / 2 + B, A);
                e.M.iX = v[0] - e.M.I / 2, e.M.iY = v[1] - e.M.F / 2, e.M.paint();
              }
            }
          }
        }
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s,
          C = this;
        if (C.AN && 0 !== C.V.length) {
          C.AW && C.V.reverse(), e = ZC.Q.E9(C.H.usc() ? C.H.K + "-main-c" : C.A.K + "-scales-bl-0-c", C.H.AA);
          var A = ZC._i_(C.J2.o[ZC._[21]] || 8),
            Z = ZC._i_(C.II.o[ZC._[21]] || 4),
            c = 0,
            p = ZC.BQ(1, Math.ceil((C.A1 - C.W) / (C.MB - 1))),
            u = ZC.BQ(1, Math.ceil((C.A1 - C.W) / (C.EH - 1))),
            h = C.A.BJ("scale-" + C.L);
          h || (h = C.A.BJ("scale"));
          for (var _, d, f, g = ZC.CX(h.GM / 2, h.GG / 2) * h.JV, B = C.EI / (C.V.length - 1), v = 0; v < h.V.length; v++) {
            var m = v % h.H5,
              b = Math.floor(v / h.H5),
              E = h.iX + m * h.GM + h.GM / 2 + h.BM,
              K = h.iY + b * h.GG + h.GG / 2 + h.BH,
              D = new DW(C);
            if (D.Z = C.H.usc() ? C.H.mc() : ZC.AK(C.A.K + "-scales-bl-0-c"), D.copy(C), D.K = C.K + "-" + v, D.iX = E, D.iY = K, D.AI = g - .5, D.DQ = 360 === C.EI ? "circle" : "pie", D.B4 = C.DF - C.EI / 2 + 360, D.BK = C.DF + C.EI / 2 + 360, D.CM = 0, D.parse(), D.paint(), C.D6.AN) {
              if (C.D6.o.items && C.D6.o.items.length > 0) for (t = 0; t < C.V.length - 1; t++) D = new DW(C), r = t % C.D6.o.items.length, D.append(C.D6.o.items[r]), D.Z = C.H.usc() ? C.H.mc() : ZC.AK(C.A.K + "-scales-bl-0-c"), D.iX = E, D.iY = K, D.K = C.K + "-pie-" + t, D.o.type = "pie", D.o[ZC._[21]] = g - C.BV, D.CM = C.AB, D.B4 = C.DF - C.EI / 2 + t * B + 360, D.BK = C.DF - C.EI / 2 + (t + 1) * B + 360, D.parse(), D.paint();
              if (C.D6.AZ > 0) for (t = 0, i = C.V.length; t < i; t++) (_ = new CZ(C)).copy(C.D6), _.IV = Y, _.E5 = C.D6.E5, _.DB() && _.parse(), (l = []).push(ZC.AR.BN(E, K, g - C.BV, C.DF - C.EI / 2 + t * B)), l.push(ZC.AR.BN(E, K, C.AB, C.DF - C.EI / 2 + t * B)), ZC.CQ.paint(e, _, l);
            }
            if (C.G6.AN && C.G6.AZ > 0 && C.FU > 0) for (t = 0, i = C.V.length; t < i - 1; t++) for (o = C.DF - C.EI / 2 + t * B, d = B / (C.FU + 1), f = 1; f <= C.FU; f++) (_ = new CZ(C)).copy(C.G6), _.IV = Y, _.E5 = C.G6.E5, _.DB() && _.parse(), (l = []).push(ZC.AR.BN(E, K, g - C.BV, C.DF - C.EI / 2 + t * B + f * d)), l.push(ZC.AR.BN(E, K, C.AB, C.DF - C.EI / 2 + t * B + f * d)), ZC.CQ.paint(e, _, l);
            if (C.VU(), C.H.Y2(), C.J5 && ((n = new DW(C)).append(C.J5.o), n.Z = C.H.usc() ? C.H.mc() : ZC.AK(C.A.K + "-scales-bl-0-c"), n.K = C.K + "-ring", n.iX = E, n.iY = K, 360 !== C.EI ? (n.o.type = "pie", a = ZC._i_(n.o[ZC._[21]]), a = ZC.BQ(1, ZC.CX(a, g)), n.CM = g - a, n.o[ZC._[21]] = g, n.B4 = C.DF - C.EI / 2 + 360, n.BK = C.DF + C.EI / 2 + 360) : (n.o.type = "circle", a = ZC._i_(n.o[ZC._[21]]), a = ZC.BQ(1, ZC.CX(a, g)), n.o[ZC._[21]] = g), n.parse(), n.AN && a + n.AU > 0 && (n.paint(), 360 === C.EI && (n.K = C.K + "-ring-inner", n.o[ZC._[21]] = g - a, n.parse(), n.paint())), C.J5.o.items && C.J5.o.items.length > 0 || C.J5.o.rules)) for (t = 0; t < C.V.length - 1; t++) (n = new DW(C)).append(C.J5.o), C.J5.o.items && (r = t % C.J5.o.items.length, n.append(C.J5.o.items[r])), n.Z = C.H.usc() ? C.H.mc() : ZC.AK(C.A.K + "-scales-bl-0-c"), n.K = C.K + "-ring-" + t, n.iX = E, n.iY = K, n.o.type = "pie", a = ZC._i_(n.o[ZC._[21]]), a = ZC.BQ(0, ZC.CX(a, g)), n.CM = g - a, n.o[ZC._[21]] = g, n.B4 = C.DF - C.EI / 2 + t * B + 360, n.BK = C.DF - C.EI / 2 + (t + 1) * B + 360 + .25, n.parse(), n.IV = Y, n.E5 = C.J5.E5, n.DB() && n.parse(), n.AN && a + n.AU > 0 && n.paint();
            if (C.J2.AN) {
              switch (C.J2.o[ZC._[7]]) {
                case "outer":
                  c += A;
                  break;
                default:
                  c += A / 2;
              }
              for (l = [], t = 0, i = C.V.length; t < i; t++) if (t === C.W || t === C.A1 || t % p == 0) {
                switch (o = C.DF - C.EI / 2 + t * B, s = [0, 0], C.J2.o[ZC._[7]]) {
                  case "inner":
                    s = [-A, 0];
                    break;
                  case "outer":
                    s = [0, A];
                    break;
                  default:
                    s = [-A / 2, A / 2];
                }
                l.push(ZC.AR.BN(E, K, g + s[0], o), ZC.AR.BN(E, K, g + s[1], o), null);
              }
              ZC.CQ.paint(e, C.J2, l);
            }
            if (C.II.AN && C.FU > 0) {
              for (l = [], t = 0, i = C.V.length; t < i - 1; t++) for (o = C.DF - C.EI / 2 + t * B, d = B / (C.FU + 1), f = 1; f <= C.FU; f++) {
                switch (s = [0, 0], C.II.o[ZC._[7]]) {
                  case "inner":
                    s = [-Z, 0];
                    break;
                  case "outer":
                    s = [0, Z];
                    break;
                  default:
                    s = [-Z / 2, Z / 2];
                }
                l.push(ZC.AR.BN(E, K, g + s[0], o + f * d), ZC.AR.BN(E, K, g + s[1], o + f * d), null);
              }
              ZC.CQ.paint(e, C.II, l);
            }
            if (C.BR.AN) {
              var F = [];
              for (t = 0, i = C.V.length; t < i; t++) if (t === C.W || t === C.A1 || t % u == 0) {
                var I = new DT(C);
                I.append(C.BR.o), I.GO = C.K + "-item " + C.A.K + "-scale-item zc-scale-item", I.K = C.A.K + "-" + C.BG.replace(/\-/g, "_") + "-item_" + v + "_" + t;
                var x = C.FC(t);
                if (I.AO = x, I.Z = I.C7 = C.H.usc() ? C.H.mc() : ZC.AK(C.A.K + "-scales-ml-0-c"), I.parse(), "auto" === I.o.angle && (I.A9 = C.DF - C.EI / 2 + t * B + 90), I.IV = Y, I.E5 = C.BR.E5, I.DB() && I.parse(), I.AN) {
                  I.F = I.KH;
                  var y,
                    X = 1.15 * Math.sqrt(I.I * I.I / 4 + I.F * I.F / 4);
                  switch (C.BR.o[ZC._[7]]) {
                    case "inner":
                      y = ZC.AR.BN(E, K, g + C.BR.DS - X - 5 + c, C.DF - C.EI / 2 + t * B);
                      break;
                    default:
                      y = ZC.AR.BN(E, K, g + C.BR.DS + X + c, C.DF - C.EI / 2 + t * B);
                  }
                  I.iX = y[0] - I.I / 2, I.iY = y[1] - I.F / 2, I.paint(), I.ED(), null === ZC._n_(C.o.tooltip) && I.KE || (null !== ZC._n_(C.o.tooltip) && (C.o.tooltip.text = C.o.tooltip.text || "%scale-value"), F.push(ZC.AQ.OG(C.A.K, I)));
                }
              }
              F.length > 0 && ZC.AK(C.A.A.K + "-map") && (ZC.AK(C.A.A.K + "-map").innerHTML += F.join(""));
            }
          }
        }
        function Y(e) {
          return e = (e = (e = (e = e.replace(/%i/g, t)).replace(/%k/g, t)).replace(/%v/g, null !== ZC._n_(C.V[t]) ? C.V[t] : "")).replace(/%l/g, null !== ZC._n_(C.BY[t]) ? C.BY[t] : "");
        }
      }
    }, {
      key: "paint_",
      value: function paint_() {
        var e = this,
          t = e.A.BJ("scale-" + e.L);
        t || (t = e.A.BJ("scale"));
        for (var i = 0; i < t.V.length; i++) {
          var a = i % t.H5,
            n = Math.floor(i / t.H5),
            l = t.iX + a * t.GM + t.GM / 2 + t.BM,
            r = t.iY + n * t.GG + t.GG / 2 + t.BH;
          if (e.QP) {
            var o = new DW(e);
            o.append(e.QP.o), o.Z = o.C7 = e.H.usc() ? e.H.mc("top") : ZC.AK(e.A.K + "-scales-ml-0-c"), o.K = e.K + "-" + i + "-center", o.iX = l, o.iY = r, o.o.type = o.o.type || "circle", o.parse(), o.AN && o.paint();
          }
        }
      }
    }]);
    return A8B;
  }(ABK);
  var A87 = /*#__PURE__*/function (_A10) {
    _inherits(A87, _A10);
    function A87(e) {
      var _this107;
      _classCallCheck(this, A87);
      _this107 = _possibleConstructorReturn(this, _getPrototypeOf(A87).call(this, e));
      var t = _assertThisInitialized(_this107);
      t.DF = 0, t.CV = "star", t.DI = !1;
      return _this107;
    }
    _createClass(A87, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A87.prototype), "parse", this).call(this), this.assign_a([["aspect", "CV"], ["ref-angle", "DF", "i"], ["ranged", "DI", "b"]]);
      }
    }, {
      key: "T9",
      value: function T9() {
        var e = this,
          t = ZC.BQ(e.V.length, e.BY.length);
        e.EH = ZC.CX(30, t);
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(A87.prototype), "HE", this).call(this, e);
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(A87.prototype), "build", this).call(this);
      }
    }, {
      key: "A4M",
      value: function A4M(e, t, i) {
        var a = this,
          n = a.A.BJ("scale"),
          l = n.iX + n.I / 2,
          r = n.iY + n.F / 2,
          o = a.A.BJ(ZC._[52]);
        if (i) {
          var s = a.DF + a.EI * (e - a.B3) / (a.BL - a.B3);
          return ZC.AR.BN(l, r, t + o.AB, s);
        }
        var C = a.EI / (a.V.length - (360 === a.EI || a.DI ? 0 : 1));
        return ZC.AR.BN(l, r, t + o.AB, a.DF + e * C);
      }
    }, {
      key: "H6",
      value: function H6(e) {
        var t = this.A.BJ("scale"),
          i = ZC.CX(t.I / 2, t.F / 2) * t.JV;
        return this.A4M(e, i);
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t = this,
          i = ZC.AV(t.V, e);
        -1 === i && (i = 0);
        var a = t.A.BJ("scale"),
          n = ZC.CX(a.I / 2, a.F / 2) * a.JV;
        return t.A4M(i, n);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o,
          s = this;
        if (s.AN && 0 !== s.V.length) {
          _get(_getPrototypeOf(A87.prototype), "paint", this).call(this);
          var C = ZC.BQ(1, Math.floor((s.A1 - s.W) / (s.MB - 1))),
            A = ZC.BQ(1, Math.floor((s.A1 - s.W) / (s.EH - 1)));
          e = ZC.Q.E9(s.H.usc() ? s.H.K + "-main-c" : s.A.K + "-scales-ml-0-c", s.H.AA), t = ZC.Q.E9(s.H.usc() ? s.H.K + "-main-c" : s.A.K + "-scales-bl-0-c", s.H.AA);
          var Z,
            c = ZC._i_(s.J2.o[ZC._[21]] || 8),
            p = 0,
            u = s.A.BJ("scale"),
            h = ZC.CX(u.I / 2, u.F / 2) * u.JV,
            _ = s.A.BJ(ZC._[52]),
            d = u.iX + u.I / 2,
            f = u.iY + u.F / 2,
            g = s.EI / (s.V.length - (360 === s.EI || s.DI ? 0 : 1));
          if (s.D6.AN) {
            if (s.D6.o.items && s.D6.o.items.length > 0) {
              var B = 0;
              for (i = 0, a = s.V.length - (360 === s.EI || s.DI ? 0 : 1); i < a; i += C) {
                if (o = s.DF + i * g, "circle" === s.CV) {
                  var v = new DW(s);
                  n = B % s.D6.o.items.length, v.append(s.D6.o.items[n]), v.Z = s.H.usc() ? s.H.mc() : ZC.AK(s.A.K + "-scales-bl-0-c"), v.iX = d, v.iY = f, v.o.type = "pie", v.o[ZC._[21]] = h, v.CM = _.AB, v.B4 = o, v.BK = o + C * g, v.parse(), v.paint();
                } else {
                  var m = new DW(s);
                  n = B % s.D6.o.items.length, m.o = s.D6.o.items[n], m.Z = s.H.usc() ? s.H.mc() : ZC.AK(s.A.K + "-scales-bl-0-c"), m.AZ = 0, m.AU = 0, m.EX = 0, m.GD = 0, (l = []).push(ZC.AR.BN(d, f, _.AB, o), ZC.AR.BN(d, f, h, o), ZC.AR.BN(d, f, h, o + C * g), ZC.AR.BN(d, f, _.AB, o + C * g)), m.D = l, m.parse();
                  var b = s.A.P;
                  m.D0 = [b.iX, b.iY, b.iX + b.I, b.iY + b.F], m.paint();
                }
                B++;
              }
            }
            if (s.D6.AZ > 0) for (i = 0, a = s.V.length + (s.DI ? 1 : 0); i < a; i += C) o = s.DF + i * g, (r = new CZ(s)).copy(s.D6), r.K = s.K + "-guide-" + i, r.IV = x, r.E5 = s.D6.E5, r.DB() && r.parse(), (l = []).push(ZC.AR.BN(d, f, h, o), ZC.AR.BN(d, f, _.AB, o)), ZC.CQ.paint(t, r, l);
          }
          if (s.J2.AN) {
            switch (s.J2.o[ZC._[7]]) {
              case "inner":
                break;
              case "outer":
                p += c;
                break;
              default:
                p += c / 2;
            }
            for (l = [], i = 0, a = s.V.length + (s.DI ? 1 : 0); i < a; i += C) {
              switch (o = s.DF + i * g, (r = new CZ(s)).copy(s.J2), r.o[ZC._[7]]) {
                case "inner":
                  l = [ZC.AR.BN(d, f, h - c, o), ZC.AR.BN(d, f, h, o)];
                  break;
                case "outer":
                  l = [ZC.AR.BN(d, f, h, o), ZC.AR.BN(d, f, h + c, o)];
                  break;
                default:
                  l = [ZC.AR.BN(d, f, h - c / 2, o), ZC.AR.BN(d, f, h + c / 2, o)];
              }
              for (var E = ZC._i_(r.o["offset-x"] || "0"), K = ZC._i_(r.o["offset-y"] || "0"), D = 0; D < l.length; D++) l[D] && (l[D][0] += E, l[D][1] += K);
              r.K = s.K + "-tick-" + i, ZC.CQ.paint(e, r, l);
            }
          }
          var F,
            I = [];
          if (s.BR.AN) {
            for (i = 0, a = s.V.length; i < a; i += A) y(i);
            I.length > 0 && ZC.AK(s.A.A.K + "-map") && (ZC.AK(s.A.A.K + "-map").innerHTML += I.join(""));
          }
        }
        function x(e) {
          return e = (e = (e = e.replace(/(%i)|(%scale-index)/g, i)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(s.V[i]) ? s.V[i] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(s.BY[i]) ? s.BY[i] : "");
        }
        function y(e) {
          (s.BR.E5.length > 0 || 0 === e) && (Z = new DT(s)), Z.copy(s.BR), Z.GO = s.K + "-item " + s.A.K + "-scale-item zc-scale-item", Z.K = s.A.K + "-" + s.BG.replace(/\-/g, "_") + "-item_" + e;
          var t = s.FC(e);
          if (null === ZC._n_(s.M4) || -1 !== ZC.AV(s.M4, t)) {
            Z.AO = t, Z.Z = Z.C7 = s.H.usc() ? s.H.mc() : ZC.AK(s.A.K + "-scales-ml-0-c"), Z.parse(), Z.IV = function (t) {
              return t = (t = (t = t.replace(/(%i)|(%scale-index)/g, e)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(s.V[e]) ? s.V[e] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(s.BY[e]) ? s.BY[e] : "");
            }, Z.E5 = s.BR.E5, Z.DB() && Z.parse();
            var i = ZC.IU(Z.DS, !0);
            if (i > -1 && i < 1 && (i *= h), o = s.DF + e * g + (s.DI ? g / 2 : 0), s.BR.o["auto-align"]) {
              var a = 1.25;
              1 - ZC._a_(ZC.EG(o)) > .7 && (a = 2.5 * (1 - ZC._a_(ZC.EG(o))));
              var n = (1 - ZC._a_(ZC.EG(o))) * Z.DG * a;
              F = ZC.AR.BN(d, f, h + i + p + n, o), ZC.EG(o) > 0 ? (Z.iX = F[0], Z.iY = F[1] - Z.F / 2) : (Z.iX = F[0] - Z.I, Z.iY = F[1] - Z.F / 2);
            } else s.BR.o["auto-rotate"] ? (F = ZC.AR.BN(d, f, h + i + p + Z.F / 2, o), Z.iX = F[0] - Z.I / 2, Z.iY = F[1] - Z.F / 2, Z.A9 = o + 90) : (F = ZC.AR.BN(d, f, h + i + p + ZC._a_(10 * ZC.EN(o)) + ZC._a_(Z.I / 2 * ZC.EG(o)), o), Z.iX = F[0] - Z.I / 2, Z.iY = F[1] - Z.F / 2);
            Z.AN && (Z.paint(), Z.ED(), null === ZC._n_(s.o.tooltip) && Z.KE || (null !== ZC._n_(s.o.tooltip) && (s.o.tooltip.text = s.o.tooltip.text || "%scale-value"), I.push(ZC.AQ.OG(s.A.K, Z))));
          }
        }
      }
    }]);
    return A87;
  }(A97);
  var A8A = /*#__PURE__*/function (_ZY4) {
    _inherits(A8A, _ZY4);
    function A8A(e) {
      _classCallCheck(this, A8A);
      return _possibleConstructorReturn(this, _getPrototypeOf(A8A).call(this, e));
    }
    _createClass(A8A, [{
      key: "HT",
      value: function HT(e) {
        _get(_getPrototypeOf(A8A.prototype), "parse", this).call(this);
      }
    }, {
      key: "H0",
      value: function H0() {
        var e = this,
          t = e.A.BJ("scale"),
          i = ZC.CX(t.I / 2, t.F / 2) * t.JV;
        e.AC = (i - e.AB - e.BV) / (e.A1 - e.W);
      }
    }, {
      key: "HE",
      value: function HE(e) {
        _get(_getPrototypeOf(A8A.prototype), "HE", this).call(this, e), this.H0();
      }
    }, {
      key: "T9",
      value: function T9() {
        var e = this,
          t = e.A.BJ("scale"),
          i = ZC.CX(t.I / 2, t.F / 2) * t.JV;
        e.EH = ZC.BQ(2, ZC._i_((i - e.AB - e.BV) / 20));
      }
    }, {
      key: "ST",
      value: function ST(e) {
        var t = this,
          i = t.A.BJ("scale"),
          a = ZC.CX(i.I / 2, i.F / 2) * i.JV,
          n = t.BL - t.B3,
          l = (a - t.AB - t.BV) / n;
        return (e - t.B3) * l;
      }
    }, {
      key: "AM",
      value: function AM(e) {
        var t = this,
          i = t.ST(e),
          a = t.A.BJ("scale-k"),
          n = t.A.BJ("scale"),
          l = n.iX + n.I / 2 + n.BM,
          r = n.iY + n.F / 2 + n.BH;
        return ZC.AR.BN(l, r, i, a.DF);
      }
    }, {
      key: "clear",
      value: function clear() {}
    }, {
      key: "build",
      value: function build() {
        _get(_getPrototypeOf(A8A.prototype), "build", this).call(this);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o = this;
        if (o.AN && 0 !== o.V.length) {
          _get(_getPrototypeOf(A8A.prototype), "paint", this).call(this), e = ZC.Q.E9(o.H.usc() ? o.H.K + "-main-c" : o.A.K + "-scales-ml-0-c", o.H.AA), t = ZC.Q.E9(o.H.usc() ? o.H.K + "-main-c" : o.A.K + "-scales-bl-0-c", o.H.AA);
          var s,
            C,
            A = o.A.BJ("scale-k"),
            Z = ZC._i_(o.J2.o[ZC._[21]] || 8),
            c = Math.ceil((o.A1 - o.W) / (o.EH - 1)),
            p = Math.ceil((o.A1 - o.W) / (o.MB - 1)),
            u = o.A.BJ("scale"),
            h = ZC.CX(u.I / 2, u.F / 2) * u.JV,
            _ = u.iX + u.I / 2 + u.BM,
            d = u.iY + u.F / 2 + u.BH,
            f = A.EI / (A.V.length - (360 === A.EI || A.DI ? 0 : 1));
          if (o.D6.AN) {
            if (o.D6.o.items && o.D6.o.items.length > 0) for (i = 0, a = o.V.length; i < a - 1; i++) {
              var g = i % o.D6.o.items.length;
              if ("circle" === A.CV) {
                var B = new DW(o);
                B.Z = o.H.usc() ? o.H.mc() : ZC.AK(o.A.K + "-scales-bl-0-c"), B.append(o.D6.o.items[g]), B.o.type = "pie", B.o[ZC._[21]] = o.AB + (i + 1) * o.AC, B.iX = _, B.iY = d, B.CM = o.AB + i * o.AC, 360 === A.EI ? (B.B4 = 0, B.BK = 360) : (B.B4 = A.DF, B.BK = A.DF + A.EI), B.parse(), B.paint();
              } else {
                var v = new DW(o);
                for (v.append(o.D6.o.items[g]), v.Z = o.H.usc() ? o.H.mc() : ZC.AK(o.A.K + "-scales-bl-0-c"), r = [], n = 0, l = A.V.length; n < l; n++) r.push(ZC.AR.BN(_, d, o.AB + i * o.AC, A.DF + n * f));
                for (360 === A.EI && r.push(ZC.AR.BN(_, d, o.AB + i * o.AC, A.DF), ZC.AR.BN(_, d, o.AB + (i + 1) * o.AC, A.DF)), n = A.V.length - 1; n >= 0; n--) r.push(ZC.AR.BN(_, d, o.AB + (i + 1) * o.AC, A.DF + n * f));
                v.D = r, v.parse(), v.AZ = 0, v.AU = 0, v.EX = 0, v.GD = 0;
                var m = o.A.P;
                v.D0 = [m.iX, m.iY, m.iX + m.I, m.iY + m.F], v.paint();
              }
            }
            if (o.D6.AZ > 0) for (i = 0, a = o.V.length; i < a; i++) if (i === o.W || i === o.A1 || i % p == 0) if ("circle" === A.CV) {
              var b = new DW(o);
              b.Z = o.H.usc() ? o.H.mc() : ZC.AK(o.A.K + "-scales-bl-0-c"), b.append(o.D6.o);
              var E = A.EI;
              360 === E && (E = 359), b.append({
                type: "arc",
                size: o.AB + i * o.AC,
                angleStart: A.DF - .25,
                angleEnd: A.DF + E + .25
              }), b.K = o.K + "-guide-" + i, b.iX = _, b.iY = d, b.parse(), b.IV = y, b.E5 = o.D6.E5, b.DB() && b.parse(), b.paint();
            } else {
              var K = new CZ(o);
              for (K.copy(o.D6), K.K = o.K + "-guide-" + i, K.IV = y, K.E5 = o.D6.E5, K.DB() && K.parse(), r = [], n = 0, l = A.V.length - (360 === A.EI || A.DI ? 0 : 1); n < l; n++) r.push(ZC.AR.BN(_, d, o.AB + i * o.AC, A.DF + n * f), ZC.AR.BN(_, d, o.AB + i * o.AC, A.DF + (n + 1) * f));
              ZC.CQ.paint(t, K, r);
            }
          }
          if (o.PF.AN && o.PF.AZ > 0 && ((r = []).push(ZC.AR.BN(_, d, o.AB, A.DF), ZC.AR.BN(_, d, h - o.BV, A.DF)), ZC.CQ.paint(e, o.PF, r)), o.J2.AN) {
            switch (o.J2.o[ZC._[7]]) {
              case "inner":
                break;
              case "outer":
                Z;
                break;
              default:
                Z / 2;
            }
            for (r = [], i = 0, a = o.V.length; i < a; i++) if (i === o.W || i === o.A1 || i % p == 0) {
              var D = ZC.AR.BN(_, d, o.AB + i * o.AC, A.DF);
              switch (o.J2.o[ZC._[7]]) {
                case "inner":
                  r.push([D[0], D[1]]), A.DF % 180 == 0 ? r.push([D[0], D[1] - Z]) : r.push([D[0] - Z, D[1]]), r.push(null);
                  break;
                case "outer":
                  r.push([D[0], D[1]]), A.DF % 180 == 0 ? r.push([D[0], D[1] + Z]) : r.push([D[0] + Z, D[1]]), r.push(null);
                  break;
                default:
                  A.DF % 180 == 0 ? r.push([D[0], D[1] - Z / 2], [D[0], D[1] + Z / 2]) : r.push([D[0] - Z / 2, D[1]], [D[0] + Z / 2, D[1]]), r.push(null);
              }
            }
            for (var F = ZC._i_(o.J2.o["offset-x"] || "0"), I = ZC._i_(o.J2.o["offset-y"] || "0"), x = 0; x < r.length; x++) r[x] && (r[x][0] += F, r[x][1] += I);
            ZC.CQ.paint(e, o.J2, r);
          }
          if (C = [], o.V.length > 0 && o.BR.AN) for (o.GX = 0, Y(o.W), o.GX = o.A1 - o.W, Y(o.A1), o.GX = 1, i = o.W + 1; i < o.A1; i++) i % c == 0 && Y(i);
          C.length > 0 && ZC.AK(o.A.A.K + "-map") && (ZC.AK(o.A.A.K + "-map").innerHTML += C.join(""));
        }
        function y(e) {
          return e = (e = (e = e.replace(/(%i)|(%scale-index)/g, i)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(o.V[i]) ? o.V[i] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(o.BY[i]) ? o.BY[i] : "");
        }
        function X(e) {
          return e = (e = (e = (e = e.replace(/(%c)|(%scale-position)/g, o.GX)).replace(/(%i)|(%scale-index)/g, o.KA)).replace(/(%v)|(%scale-value)/g, null !== ZC._n_(o.V[o.KA]) ? o.V[o.KA] : "")).replace(/(%l)|(%scale-label)/g, null !== ZC._n_(o.BY[o.KA]) ? o.BY[o.KA] : "");
        }
        function Y(e) {
          o.KA = e, (s = new DT(o)).copy(o.BR), s.K = o.A.K + "-" + o.BG.replace(/\-/g, "_") + "-item_" + e, s.GO = o.K + "-item " + o.A.K + "-scale-item zc-scale-item";
          var t = o.FC(e);
          if (s.AO = t, null === ZC._n_(o.M4) || -1 !== ZC.AV(o.M4, t)) {
            s.Z = s.C7 = o.H.usc() ? o.H.mc() : ZC.AK(o.A.K + "-scales-fl-0-c"), s.parse(), s.IV = X, s.DB() && s.parse();
            var i = ZC.AR.BN(_, d, o.AB + e * o.AC, A.DF);
            switch (s.F = s.KH, s.I = s.NZ, A.DF % 180 == 0 ? (s.iX = i[0] - s.I / 2, s.iY = i[1]) : (s.iX = i[0], s.iY = i[1] - s.F / 2), o.J2.o[ZC._[7]]) {
              case "inner":
                break;
              case "outer":
                A.DF % 180 == 0 ? s.iY += Z : s.iX += Z;
                break;
              default:
                A.DF % 180 == 0 ? s.iY += Z / 2 : s.iX += Z / 2;
            }
            s.AN && (s.paint(), s.ED(), null === ZC._n_(o.o.tooltip) && s.KE || (null !== ZC._n_(o.o.tooltip) && (o.o.tooltip.text = o.o.tooltip.text || "%scale-value"), C.push(ZC.AQ.OG(o.A.K, s))));
          }
        }
      }
    }]);
    return A8A;
  }(ZY);
  var A9K = /*#__PURE__*/function (_DW4) {
    _inherits(A9K, _DW4);
    function A9K(e) {
      var _this108;
      _classCallCheck(this, A9K);
      _this108 = _possibleConstructorReturn(this, _getPrototypeOf(A9K).call(this, e));
      var t = _assertThisInitialized(_this108);
      t.C6 = .95, t.L = 0, t.AF = null, t.M = null, t.FB = null, t.A6U = !1, t.BA = "bottom", t.AB = 0, t.BV = 0, t.MT = "normal", t.OD = "normal", t.KF = [5, 5], t.A0W = [0, 0], t.ZF = "";
      return _this108;
    }
    _createClass(A9K, [{
      key: "parse",
      value: function parse() {
        _get(_getPrototypeOf(A9K.prototype), "parse", this).call(this);
        var e,
          t = this;
        t.assign_a([["type", "AF"], ["value-range", "A6U", "b"], ["offset-start", "AB", "i"], ["offset-end", "BV", "i"], [ZC._[7], "BA"], ["pair-scale", "ZF"], ["label-placement", "MT"], ["label-alignment", "OD"], ["range", "FB"]]), null === ZC._n_(t.o.alpha) && (t.o.alpha = "area" === t.AF ? .25 : .95), null !== ZC._n_(e = t.o["label-tolerance"]) && ("object" == typeof e && e.length ? (t.KF[0] = ZC._i_(e[0] || "5"), t.KF[1] = ZC._i_(e[1] || "5")) : t.KF[0] = t.KF[1] = ZC._i_(e || "5")), t.assign_a([["alpha", "C6", "f", 0, 1]]), null === ZC._n_(e = t.o.label) && null === ZC._n_(t.o.text) || (t.M = new DT(t), t.A.A.A.B8.load(t.M.o, ["(" + t.A.AF + ").SCALE.marker.label"]), null !== ZC._n_(t.o.text) && t.M.append({
          text: t.o.text
        }), t.M.append(e), t.M.parse(), t.A0W = [t.M.BM, t.M.BH]);
      }
    }, {
      key: "paint",
      value: function paint() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r,
          o = this;
        if (o.FB) if (-1 === o.A.BG.indexOf("scale-r")) {
          if (o.AN) {
            var s,
              C,
              A,
              Z,
              c = o.A,
              p = o.A.A.P.AU,
              u = c.A.K + "-scales-" + ("top" === o.BA ? "f" : "b") + "l-0-c";
            o.Z = o.C7 = ZC.AK(c.H.usc() ? c.H.K + "-main-c" : u), e = ZC.Q.E9(o.Z, c.H.AA), n = [];
            var h,
              _ = 0,
              d = 0;
            o.BM > -1 && o.BM < 1 && (o.BM = Math.ceil(o.BM * c.AC)), o.BH > -1 && o.BH < 1 && (o.BH = Math.ceil(o.BH * c.AC)), o.M && (o.M.Z = c.H.usc() ? c.H.mc() : ZC.AK(c.A.K + "-scales-ml-0-c"), o.M.K = o.A.A.K + "-" + o.A.BG.replace(/\-/g, "_") + "-marker_" + o.L, o.M.GO = o.A.K + "-marker-label " + o.A.A.K + "-scale-marker-label zc-scale-marker-label");
            var f = o.A.A,
              g = function g(e, t) {
                var i;
                return -1 !== (t + "").indexOf("%") ? (i = ZC._f_(t.replace("%", "")), i = "k" === e.AF ? ZC._i_(i * (e.DV - e.DD) / 100) : i * (e.H4 - e.FX) / 100) : i = t, o.A6U || "v" === e.AF ? e.AM(i) : e.H6(i);
              };
            if ("poly" === o.AF) {
              var B, v, m, b;
              for (f = o.A.A, "k" === c.AF ? (B = c, v = "" === o.ZF ? f.BT("v")[0] : f.BJ(o.ZF) || f.BT("v")[0]) : "v" === c.AF && (v = c, B = "" === o.ZF ? f.BT("k")[0] : f.BJ(o.ZF) || f.BT("k")[0]), l = 0, r = o.FB.length; l < r; l++) m = g(B, o.FB[l][0]), b = v.AM(o.FB[l][1]), n.push([m, b]), _ += m, d += b;
              if (_ /= n.length, d /= n.length, n.length >= 3) {
                if (n[0].join("/") !== n[n.length - 1].join("/") && n.push([n[0][0], n[0][1]]), c.A.AJ["3d"]) for (c.A.NK(), t = 0, i = n.length; t < i; t++) a = new CC(c.A, n[t][0] - ZC.AP.E2, n[t][1] - ZC.AP.E1, ZC.AP.FV), n[t][0] = a.EC[0], n[t][1] = a.EC[1];
                (h = new DW(o.A)).K = c.K + "-marker-" + o.L, h.Z = h.C7 = c.H.usc() ? c.H.mc() : ZC.AK(u), h.copy(o), h.AZ = 0, h.AU = 0, h.EX = 0, h.GD = 0, h.D = n, h.parse(), h.paint();
              }
            } else if ("line" === o.AF) {
              if (-1 !== c.BG.indexOf(ZC._[50]) ? 1 === o.FB.length ? s = C = g(c, o.FB[0]) : 2 === o.FB.length && (s = g(c, o.FB[0]), C = g(c, o.FB[1])) : -1 !== c.BG.indexOf(ZC._[51]) && (1 === o.FB.length ? s = C = g(c, o.FB[0]) : 2 === o.FB.length && (s = g(c, o.FB[0]), C = g(c, o.FB[1]))), -1 !== c.BG.indexOf(ZC._[50]) && c.CO || -1 !== c.BG.indexOf(ZC._[51]) && !c.CO ? (n.push([c.iX + o.AB, s], [c.iX + c.I - o.BV, C]), o.o && o.o.tooltip && (f.o[ZC._[10]] = f.o[ZC._[10]] || [], f.o[ZC._[10]].push({
                x: c.iX,
                y: s - o.AZ,
                width: c.I,
                height: 2 * o.AZ,
                alpha: 0,
                tooltip: o.o.tooltip
              })), o.M && ("opposite" === o.MT ? o.M.iX = c.iX + c.I - o.M.I - o.BV : o.M.iX = c.iX + o.AB, "opposite" === o.MT ? o.M.iY = C - (c.AW ? 0 : o.M.F) : o.M.iY = s - (c.AW ? 0 : o.M.F))) : (n.push([s, c.iY + c.F - o.AB], [C, c.iY + o.BV]), o.o && o.o.tooltip && (f.o[ZC._[10]] = f.o[ZC._[10]] || [], f.o[ZC._[10]].push({
                x: s - o.AZ,
                y: c.iY,
                width: 2 * o.AZ,
                height: c.F,
                alpha: 0,
                tooltip: o.o.tooltip
              })), o.M && ("opposite" === o.MT ? o.M.iX = C - (c.AW ? o.M.I : 0) : o.M.iX = s - (c.AW ? o.M.I : 0), "opposite" === o.MT ? o.M.iY = c.iY + o.M.I - o.M.F + o.BV : o.M.iY = c.iY + c.F - o.M.F - o.AB)), c.A.AJ["3d"]) for (c.A.NK(), t = 0, i = n.length; t < i; t++) a = new CC(c.A, n[t][0] - ZC.AP.E2, n[t][1] - ZC.AP.E1, ZC.AP.FV), n[t][0] = a.EC[0], n[t][1] = a.EC[1];
              2 === n.length && (ZC.CQ.setup(e, o), ZC.CQ.paint(e, o, n));
            } else if ("area" === o.AF && (-1 !== c.BG.indexOf(ZC._[50]) ? 2 === o.FB.length ? (s = A = g(c, o.FB[0]), C = Z = g(c, o.FB[1])) : 4 === o.FB.length && (s = g(c, o.FB[0]), C = g(c, o.FB[1]), A = g(c, o.FB[2]), Z = g(c, o.FB[3])) : -1 !== c.BG.indexOf(ZC._[51]) && (2 === o.FB.length ? (s = A = c.AM(o.FB[0]), C = Z = c.AM(o.FB[1])) : 4 === o.FB.length && (s = c.AM(o.FB[0]), C = c.AM(o.FB[1]), A = c.AM(o.FB[2]), Z = c.AM(o.FB[3]))), C = s === C ? C + 1 : C, Z = A === Z ? Z + 1 : Z, -1 !== c.BG.indexOf(ZC._[50]) && c.CO || -1 !== c.BG.indexOf(ZC._[51]) && !c.CO ? (n.push([c.iX + p, s], [c.iX + c.I - p, A], [c.iX + c.I - p, Z], [c.iX + p, C], [c.iX + p, s]), o.M && ("opposite" === o.MT ? o.M.iX = c.iX + c.I - o.M.I - o.BV : o.M.iX = c.iX + o.AB, "opposite" === o.MT ? o.M.iY = C - (c.AW ? 0 : o.M.F) : o.M.iY = s - (c.AW ? 0 : o.M.F))) : (n.push([s, c.iY + c.F - p], [A, c.iY + p], [Z, c.iY + p], [C, c.iY + c.F - p], [s, c.iY + c.F - p]), o.M && ("opposite" === o.MT ? o.M.iX = C - (c.AW ? o.M.I : 0) : o.M.iX = s - (c.AW ? o.M.I : 0), "opposite" === o.MT ? o.M.iY = c.iY + o.M.I - o.M.F + o.BV : o.M.iY = c.iY + c.F - o.M.F - o.AB)), n.length >= 4)) {
              if (c.A.AJ["3d"]) for (c.A.NK(), t = 0, i = n.length; t < i; t++) a = new CC(c.A, n[t][0] - ZC.AP.E2, n[t][1] - ZC.AP.E1, ZC.AP.FV), n[t][0] = a.EC[0], n[t][1] = a.EC[1];
              (h = new DW(o.A)).K = c.K + "-marker-" + o.L, h.Z = h.C7 = c.H.usc() ? c.H.mc() : ZC.AK(u), h.copy(o), h.AZ = 0, h.AU = 0, h.EX = 0, h.GD = 0, h.D = n, h.parse(), h.BM = o.BM, h.BH = o.BH, h.paint();
            }
            var E = !0,
              K = c.A.P;
            2 === n.length && (-1 !== c.BG.indexOf(ZC._[50]) && c.CO || -1 !== c.BG.indexOf(ZC._[51]) && !c.CO ? ZC.DR(n[0][1], K.iY - o.KF[1], K.iY + K.F + o.KF[1]) && ZC.DR(n[1][1], K.iY - o.KF[1], K.iY + K.F + o.KF[1]) || (E = !1) : ZC.DR(n[0][0], K.iX - o.KF[0], K.iX + K.I + o.KF[0]) && ZC.DR(n[1][0], K.iX - o.KF[0], K.iX + K.I + o.KF[0]) || (E = !1));
            var D = o.OD;
            if (o.M && E && ("poly" === o.AF ? (o.M.iX = ZC._i_(_ - o.M.I / 2), o.M.iY = ZC._i_(d - o.M.F / 2)) : ("auto" === o.OD && (D = -1 !== c.BG.indexOf(ZC._[50]) && !c.CO || -1 !== c.BG.indexOf(ZC._[51]) && c.CO ? s < c.iX + c.I / 2 ? "normal" : "opposite" : s > c.iY + c.F / 2 ? "normal" : "opposite"), o.M.BM = o.M.BH = 0, (-1 !== c.BG.indexOf(ZC._[50]) && !c.CO || -1 !== c.BG.indexOf(ZC._[51]) && c.CO) && null === ZC._n_(o.M.o.angle) && (o.M.A9 = 270), -1 !== c.BG.indexOf(ZC._[50]) && !c.CO || -1 !== c.BG.indexOf(ZC._[51]) && c.CO ? (o.M.A9 % 180 == 90 && (o.M.BM -= (c.AW ? -1 : 1) * (o.M.I / 2 - o.M.F / 2), o.M.BH -= o.M.I / 2 - o.M.F / 2, "opposite" === o.MT && (o.M.BH = -o.M.I / 2 + o.M.F / 2), "opposite" === D && (o.M.BM -= o.M.F)), o.M.A9 % 180 == 0 && ("opposite" === o.MT && (o.M.BH = -o.M.I + o.M.F), "opposite" === D && (o.M.BM -= o.M.I))) : (o.M.A9 % 180 == 90 && (o.M.BM -= o.M.I / 2 - o.M.F / 2, o.M.BH -= (c.AW ? -1 : 1) * (o.M.I / 2 - o.M.F / 2), "opposite" === o.MT && (o.M.BM = o.M.I / 2 - o.M.F / 2), "opposite" === D && (o.M.BH += o.M.I)), o.M.A9 % 180 == 0 && "opposite" === D && (o.M.BH += o.M.F)), o.M.BM += o.A0W[0] + o.BM, o.M.BH += o.A0W[1] + o.BH), c.A.AJ["3d"] && (a = new CC(c.A, o.M.iX - ZC.AP.E2, o.M.iY - ZC.AP.E1, ZC.AP.FV), o.M.iX = a.EC[0], o.M.iY = a.EC[1]), ZC.DR(o.M.iX + o.M.BM + (o.M.A9 % 180 == 0 ? o.M.I / 2 : o.M.F / 2), o.A.A.P.iX - o.KF[0], o.A.A.P.iX + o.A.A.P.I + o.KF[0]) && ZC.DR(o.M.iY + o.M.BH + (o.M.A9 % 180 == 0 ? o.M.F / 2 : o.M.I / 2), o.A.A.P.iY - o.KF[1], o.A.A.P.iY + o.A.A.P.F + o.KF[1]) && (o.M.paint(), o.M.ED(), !o.M.KE && "normal" === zingchart.OBJECTMODE && (c.E["marker_text_" + o.L] = o.M.AO, ZC.AK(f.A.K + "-map"))))) {
              var F = ZC.AQ.OG(f.K, o.M);
              ZC.AK(f.A.K + "-map").innerHTML = ZC.AK(f.A.K + "-map").innerHTML + F;
            }
          }
        } else o.A.paintMarker(o);
      }
    }]);
    return A9K;
  }(DW);
  var A2X = /*#__PURE__*/function (_ZCClass8) {
    _inherits(A2X, _ZCClass8);
    function A2X(e) {
      var _this109;
      _classCallCheck(this, A2X);
      _this109 = _possibleConstructorReturn(this, _getPrototypeOf(A2X).call(this));
      var t = _assertThisInitialized(_this109);
      t.M7 = null, t.A54 = 0, t.P9 = [], t.BG = e, t.A46 = !0;
      return _this109;
    }
    _createClass(A2X, [{
      key: "add",
      value: function add(e) {
        var t = this;
        t.P9.push(e), e.K7 = t, e.M7 = t.M7, e.C0.TX = !0, e.XN = t.P9.length - 1, t.A46 = !1;
      }
    }]);
    return A2X;
  }(ZCClass);
  var EB = /*#__PURE__*/function (_ZCClass9) {
    _inherits(EB, _ZCClass9);
    function EB(e, t, i, a, n, l) {
      var _this110;
      _classCallCheck(this, EB);
      _this110 = _possibleConstructorReturn(this, _getPrototypeOf(EB).call(this));
      var r = _assertThisInitialized(_this110);
      for (var o in r.M7 = null, r.C0 = e, r.AX = null, r.A5L = 0, r.IR = null, r.O = t || {}, r.A5Q = i || 500, r.XR = a || -1, r.A0Z = null, r.TC = null, r.OK = null, null !== ZC._n_(l) && (r.TC = l), r.A5S = EB.linear, null !== ZC._n_(n) && "" !== n && (r.A5S = n), r.ADI = {}, r.C5 = {}, r.ACP = [], r.RR = ZC._i_(r.A5Q / PU.UM), r.RR > 100 && (r.RR = 100), (ZC.vml || ZC.mobile) && (r.RR = ZC._i_(r.RR / 4)), r.RR < 5 && (r.RR = 5), r.O) null !== ZC._n_(EB.GP[o]) ? r.C5[o] = r.C0[EB.GP[o]] : r.C5[o] = r.C0[o];
      r.Y = 0, r.K7 = null, r.XN = -1;
      return _this110;
    }
    _createClass(EB, [{
      key: "status",
      value: function status() {
        return this.Y + 1 > this.RR ? 0 : 1;
      }
    }, {
      key: "step",
      value: function step() {
        var e,
          t,
          i,
          a,
          n,
          l,
          r = this,
          o = 1,
          s = r.M7.C.H.AA;
        if (r.Y++, r.Y > r.RR && (r.Y === r.RR + 1 && -1 !== r.XN && (r.K7.A54++, r.K7.A54 === r.K7.P9.length && (r.K7.A46 = !0)), o = 0), o) {
          var C = {};
          if (r.Y === r.RR) C = r.O, r.A5L = 1;else for (var A in r.A5L = r.A5S(r.Y, 0, 1, r.RR), r.O) switch (A) {
            case "points":
              var Z = [];
              for (n = 0, l = r.O[A].length; n < l; n++) if (null !== ZC._n_(r.C5[A][n])) {
                Z[n] = [];
                for (var c = 0, p = r.O[A][n].length; c < p; c++) Z[n][c] = r.A5S(r.Y, r.C5[A][n][c], r.O[A][n][c] - r.C5[A][n][c], r.RR);
              }
              C[A] = Z;
              break;
            case "lineColor":
            case "borderColor":
            case "backgroundColor1":
            case "backgroundColor2":
              var u = r.C5[A].replace("#", ""),
                h = ZC.AQ.GE(r.O[A]).replace("#", ""),
                _ = ZC.R6(u.slice(0, 2)),
                d = ZC.R6(u.slice(2, 4)),
                f = ZC.R6(u.slice(4, 6)),
                g = ZC.R6(h.slice(0, 2)),
                B = ZC.R6(h.slice(2, 4)),
                v = ZC.R6(h.slice(4, 6)),
                m = ZC.P6(ZC._i_(r.A5S(r.Y, _, g - _, r.RR)));
              1 === m.length && (m = "0" + m);
              var b = ZC.P6(ZC._i_(r.A5S(r.Y, d, B - d, r.RR)));
              1 === b.length && (b = "0" + b);
              var E = ZC.P6(ZC._i_(r.A5S(r.Y, f, v - f, r.RR)));
              1 === E.length && (E = "0" + E), C[A] = "#" + m + b + E;
              break;
            default:
              C[A] = r.A5S(r.Y, r.C5[A], r.O[A] - r.C5[A], r.RR);
          }
          if (r.C0.append(C), r.C0.TX = !0, r.C0.parse(), r.AX && (null !== ZC._n_(e = r.C0.E["bound-1"]) && (r.C0.D0[1] = e), null !== ZC._n_(e = r.C0.E["bound-3"]) && (r.C0.D0[3] = e), "vml" === s && 1 === r.Y && (typeof r.AX.A.I6 !== ZC._[31] ? r.C0.E.opacity2 = r.AX.A.I6 : r.C0.E.opacity2 = r.AX.A.C6), r.AX.H && (r.AX.H.E[r.AX.K + "-bounds"] = [r.AX.iX, r.AX.iY, r.AX.iX + r.AX.I, r.AX.iY + r.AX.F])), r.A0Z) try {
            r.A0Z(r.C0, C);
          } catch (w) {}
          if (r.AX) {
            var K = {
              id: r.AX.H.K,
              graphid: r.AX.C.K,
              plotindex: r.AX.A.L,
              nodeindex: r.AX.L,
              stage: r.A5L,
              value: r.AX.AD * r.A5L
            };
            ZC.AQ.BZ("animation_step", r.AX.H, K);
          }
        }
        if (r.AX) {
          if (1 === r.Y || "canvas" === s) -1 !== ZC.AV(["svg", "vml"], s) ? 0 === ZC.A5("#" + r.C0.K + "-path").length && r.paint() : r.paint();else if (r.Y <= r.RR) {
            switch (s) {
              case "svg":
                r.C0.TP(!0);
                break;
              case "vml":
                r.C0.TO(null, !0);
            }
            r.C0.U3 && r.C0.U3(), "vml" === s && /\-plotset\-plot-\d+\-node\-\d+\-area/.test(r.C0.K) && (r.C0.AZ = 0), t = null, typeof r.C0.DQ !== ZC._[31] && "box" === r.C0.DQ && (t = r.C0.AZ, r.C0.AZ = r.C0.AU);
            var D = !1;
            if ("svg" === s && ZC.AK(r.C0.K + "-path") && "rect" === ZC.AK(r.C0.K + "-path").tagName && (D = !0), D) i = [], a = [];else if (i = ZC.Q.A3B(r.C0.D, s, r.C0, !1, !0), r.C0.MH) {
              var F = ZC.Q._sh_(r.C0.D, r.C0);
              a = ZC.Q.A3B(F, s, r.C0, !1, !0);
            }
            null !== ZC._n_(t) && (r.C0.AZ = t);
            var I = r.C0.C6,
              x = r.C0.O8,
              y = r.C0.TD,
              X = r.C0.K1,
              Y = r.C0.AI;
            switch (s) {
              case "svg":
                ZC.A5("#" + r.C0.K + "-path").attr("d", i.join(" ")).attr("stroke-opacity", x).attr("fill-opacity", I), r.C0.MH && ZC.A5("#" + r.C0.K + "-sh-path").attr("d", a.join(" ")).attr("stroke-opacity", x * y).attr("fill-opacity", I * y), D && (ZC.A5("#" + r.C0.K + "-path").attr("x", r.C0.iX).attr("y", r.C0.iY).attr(ZC._[19], ZC.BQ(0, r.C0.I)).attr(ZC._[20], ZC.BQ(0, r.C0.F)), r.C0.MH && ZC.A5("#" + r.C0.K + "-sh-path").attr("x", r.C0.iX + X * ZC.EG(r.C0.OS)).attr("y", r.C0.iY + X * ZC.EN(r.C0.OS)).attr(ZC._[19], ZC.BQ(0, r.C0.I)).attr(ZC._[20], ZC.BQ(0, r.C0.F))), ZC.A5("#" + r.C0.K + "-circle").attr("stroke-opacity", x).attr("cx", r.C0.iX).attr("cy", r.C0.iY).attr("r", Y).attr("fill-opacity", I), r.C0.MH && ZC.A5("#" + r.C0.K + "-sh-circle").attr("stroke-opacity", x * y).attr("cx", r.C0.iX + X).attr("r", Y).attr("cy", r.C0.iY + X).attr("fill-opacity", I * y), "" !== r.C0.D9 && ZC.A5("#" + r.C0.K + "-path-imgfill").attr("stroke-opacity", x).attr("fill-opacity", I), ZC.A5("#" + r.C0.K + "-goal-path").remove();
                break;
              case "vml":
                ZC.A5("#" + r.C0.K + "-path").children().each(function () {
                  this.v = i.join(" "), this.opacity = I;
                }), r.C0.MH && ZC.A5("#" + r.C0.K + "-sh-path").children().each(function () {
                  this.v = a.join(" "), this.opacity = I * y;
                }), ZC.A5("#" + r.C0.K + "-circle").children().each(function () {
                  this.opacity = I;
                }), ZC.A5("#" + r.C0.K + "-circle").each(function () {
                  this.style.left = r.C0.iX - Y + "px", this.style.top = r.C0.iY - Y + "px", this.style.width = 2 * Y + "px", this.style.height = 2 * Y + "px";
                }), r.C0.MH && (ZC.A5("#" + r.C0.K + "-sh-circle").children().each(function () {
                  this.opacity = I * y;
                }), ZC.A5("#" + r.C0.K + "-sh-circle").each(function () {
                  this.style.left = r.C0.iX - Y + X + "px", this.style.top = r.C0.iY - Y + X + "px", this.style.width = 2 * Y + "px", this.style.height = 2 * Y + "px";
                })), ZC.A5("#" + r.C0.K + "-goal-path").remove();
            }
          }
        } else r.M7.C.QH = !0, r.M7.C.Y8(), r.M7.C.JW();
        return r.Y === r.RR + 1 && null !== ZC._n_(r.TC) && r.TC(), o;
      }
    }, {
      key: "paint",
      value: function paint() {
        var e = this;
        if (null !== ZC._n_(e.IR) ? ZC.CQ.paint(e.IR, e.C0, e.C0.D) : e.C0.paint(), e.OK) try {
          1 === e.A5L && e.OK();
        } catch (t) {}
      }
    }]);
    return EB;
  }(ZCClass);
  EB.GP = {
    angleStart: "B4",
    angleEnd: "BK",
    slice: "CM",
    size: "AI",
    x: "iX",
    y: "iY",
    width: "I",
    height: "F",
    alpha: "C6",
    angle: "A9",
    fillAngle: "NO",
    points: "D",
    lineWidth: "AZ",
    lineColor: "B7",
    borderWidth: "AU",
    borderColor: "BW",
    backgroundColor1: "A0",
    backgroundColor2: "AE"
  }, EB.linear = function (e, t, i, a) {
    return i * e / a + t;
  }, EB.backEaseOut = function (e, t, i, a) {
    var n = (e /= a) * e;
    return t + i * (4 * (n * e) + -9 * n + 6 * e);
  }, EB.elasticEaseOut = function (e, t, i, a) {
    var n = (e /= a) * e,
      l = n * e;
    return t + i * (37.045 * l * n + -116.2825 * n * n + 134.08 * l + -68.59 * n + 14.7475 * e);
  }, EB.bounceEaseOut = function (e, t, i, a) {
    return (e /= a) < 1 / 2.75 ? i * (7.5625 * e * e) + t : e < 2 / 2.75 ? i * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + t : e < 2.5 / 2.75 ? i * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + t : i * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + t;
  }, EB.regularEaseOut = function (e, t, i, a) {
    var n = (e /= a) * e;
    return t + i * (n * e + -3 * n + 3 * e);
  }, EB.strongEaseOut = function (e, t, i, a) {
    var n = (e /= a) * e,
      l = n * e;
    return t + i * (l * n + -5 * n * n + 10 * l + -10 * n + 5 * e);
  }, EB.RW = [EB.linear, EB.backEaseOut, EB.elasticEaseOut, EB.bounceEaseOut, EB.strongEaseOut, EB.regularEaseOut], ZC.ANIMATION = {
    SLOW: 4e3,
    FAST: 1e3,
    LINEAR: 0,
    BACK_EASE_OUT: 1,
    ELASTIC_EASE_OUT: 2,
    BOUNCE_EASE_OUT: 3,
    STRONG_EASE_OUT: 4,
    REGULAR_EASE_OUT: 5,
    NO_SEQUENCE: 0,
    BY_PLOT: 1,
    BY_NODE: 2,
    BY_PLOT_AND_NODE: 3,
    FADE_IN: 1,
    EXPAND_VERTICAL: 2,
    EXPAND_TOP: 3,
    EXPAND_BOTTOM: 4,
    EXPAND_LEFT: 5,
    EXPAND_RIGHT: 6,
    EXPAND_HORIZONTAL: 7,
    SLIDE_LEFT: 8,
    SLIDE_RIGHT: 9,
    SLIDE_TOP: 10,
    SLIDE_BOTTOM: 11,
    UNFOLD_HORIZONTAL: 12,
    UNFOLD_VERTICAL: 13,
    EXPAND: 2,
    GROW: 3,
    FLY_IN: 4,
    UNFOLD: 5
  };
  var PU = /*#__PURE__*/function (_ZCClass10) {
    _inherits(PU, _ZCClass10);
    function PU(e) {
      var _this111;
      _classCallCheck(this, PU);
      _this111 = _possibleConstructorReturn(this, _getPrototypeOf(PU).call(this));
      var t = _assertThisInitialized(_this111);
      t.C = e, t.S5 = !1, t.C4 = null, t.P9 = [], t.PT = {}, t.onStop = null;
      return _this111;
    }
    _createClass(PU, [{
      key: "A5T",
      value: function A5T(e, t) {
        var i = this;
        null === ZC._n_(i.PT[e.BG]) && (i.PT[e.BG] = e, e.M7 = i, i.S5 || (null !== ZC._n_(t) && t > 0 ? window.setTimeout(function () {
          i.start();
        }, t + 1) : i.start()));
      }
    }, {
      key: "add",
      value: function add(e) {
        var t = this;
        e.M7 = t, e.XR > 0 ? (t.P9.push(e), window.setTimeout(function () {
          e.C0.TX = !0, t.S5 || t.start();
        }, e.XR + 1)) : (e.C0.TX = !0, t.P9.push(e), t.S5 || t.start());
      }
    }, {
      key: "start",
      value: function start() {
        var e = this;
        e.S5 = !0, ZC.AQ.BZ("animation_start", e.C.A, {
          id: e.C.A.K,
          graphid: e.C.K
        });
        var t = !0;
        !function i() {
          t || e.step(), t = !1, e.S5 && (e.C4 = window.requestAnimFrame(i));
        }();
      }
    }, {
      key: "step",
      value: function step() {
        var e,
          t = this,
          i = 0;
        if (t.S5) {
          for (var a = 0, n = t.P9.length; a < n; a++) i += t.P9[a].status();
          if ("canvas" === t.C.H.AA) if (t.C.H.KE) null !== ZC._n_(e = ZC.AK(t.C.K + "-plots-bl-c")) && e.getContext("2d").clearRect(t.C.iX, t.C.iY, t.C.I, t.C.F);else for (a = 0, n = t.C.AY.A4.length; a < n; a++) for (var l = 0; l < t.C.AY.A4[a].T1; l++) null !== ZC._n_(e = ZC.AK(t.C.K + "-plot-" + a + "-bl-" + l + "-c")) && e.getContext("2d").clearRect(t.C.iX, t.C.iY, t.C.I, t.C.F);
          for (a = 0, n = t.P9.length; a < n; a++) 0 === t.P9[a].step() && (t.P9[a].C0.TX = !1);
          for (var r in t.PT) for (t.PT[r].A46 || (i += 1), a = 0, n = t.PT[r].P9.length; a < n; a++) t.PT[r].P9[a].XN === t.PT[r].A54 ? 0 === t.PT[r].P9[a].step() && (t.PT[r].P9[a].C0.TX = !1) : "canvas" === t.C.H.AA && t.PT[r].P9[a].paint();
          0 === i && (t.PT = {}, t.P9 = [], t.stop());
        }
      }
    }, {
      key: "stop",
      value: function stop(e) {
        null === ZC._n_(e) && (e = !1);
        var t,
          i = this;
        if (e && (i.bDead = !0), window.clearAnimFrame(i.C4), i.C.Y8(), i.C.QH = !1, ZC.AK(i.C.H.K)) {
          i.C.JW(), window.setTimeout(function () {
            if ((t = ZC.AK(i.C.A.K + "-map")) && i.C.AY.HK) {
              -1 === ZC.AV(["bubble", "mixed", "vbullet", "hbullet", "radar"], i.C.AF) && 1 !== zingchart.SORTTRACKERS || i.C.AY.HK.sort(function (e, t) {
                return ZC.AQ.NC(e) > ZC.AQ.NC(t) ? 1 : -1;
              });
              var e = '<area shape="rect" coords="0,0,1,1" id="mark' + i.C.L + '">',
                a = t.innerHTML.indexOf(e);
              -1 !== a ? t.innerHTML = t.innerHTML.substring(0, a + e.length) + i.C.a11y() + i.C.AY.HK.join("") + t.innerHTML.substring(a + e.length) : t.innerHTML += i.C.a11y() + i.C.AY.HK.join("");
            }
          }, 33), i.C.A1X(), i.S5 = !1;
          for (var a = 0, n = i.P9.length; a < n; a++) i.P9[a].TC = null;
          if (i.P9 = [], i.PT = {}, e || ZC.AQ.BZ("animation_end", i.C.A, {
            id: i.C.A.K,
            graphid: i.C.K
          }), null !== ZC._n_(i.onStop)) try {
            i.onStop();
          } catch (l) {}
        }
      }
    }]);
    return PU;
  }(ZCClass);
  PU.UM = 33, function () {
    for (var e = ["ms", "moz", "webkit", "o"], t = 0, i = e.length; t < i && !window.requestAnimFrame; ++t) window.requestAnimFrame = window.requestAnimationFrame || window[e[t] + "RequestAnimationFrame"], window.cancelAnimFrame = window.cancelAnimationFrame || window[e[t] + "CancelAnimationFrame"] || window[e[t] + "CancelRequestAnimationFrame"];
    window.requestAnimFrame || (window.requestAnimFrame = function (e) {
      return window.setTimeout(e, PU.UM);
    }), window.clearAnimFrame || (window.clearAnimFrame = function (e) {
      window.clearTimeout(e);
    });
  }(), zingchart.bind(null, "dataparse", function (e, t) {
    for (var i, a, n = 0, l = t[ZC._[16]].length; n < l; n++) if (t[ZC._[16]][n].type && -1 !== ZC.AV(["pie", "line", "vline", "area", "varea", "bar", "vbar", "hbar", "line3d", "area3d", "bar3d", "vbar3d", "hbar3d"], t[ZC._[16]][n].type) && t[ZC._[16]][n].nav) {
      var r = t[ZC._[16]][n];
      ZC._todash_(r);
      var o = r.nav || {};
      ZC._todash_(o);
      var s,
        C,
        A,
        Z = ZC.IU(o.threshold || "10%"),
        c = o.others || {
          text: "Others"
        },
        p = o.back || {},
        u = o[ZC._[8]] || "0.3",
        h = r[ZC._[11]] || [],
        _ = [];
      if ("pie" === t[ZC._[16]][n].type) {
        var d = 0;
        for (i = 0; i < h.length; i++) h[i][ZC._[5]] && null !== ZC._n_(h[i][ZC._[5]][0]) && (d += h[i][ZC._[5]][0]);
        Z > 0 && Z < 1 && (Z *= d), s = [].concat(h);
        var f = 0,
          g = "";
        for (C = 1, i = h.length - 1; i >= 0; i--) h[i][ZC._[5]] && null !== ZC._n_(h[i][ZC._[5]][0]) && h[i][ZC._[5]][0] < Z && (f += h[i][ZC._[5]][0], g += (h[i].text || "Item no." + C) + ":" + h[i][ZC._[5]][0] + "<br>", h[i][ZC._[8]] = u, _.push(h[i]), h.splice(i, 1), C++);
        f > 0 && (C > 2 ? (A = {
          values: [f],
          detach: !1,
          "data-group": [1],
          "tooltip-text": g = g.substring(0, g.length - 4)
        }, ZC._cp_(c, A), h.push(A), zingchart.bind(e.id, "plot_click", function (t) {
          if (t.xdata.group) {
            var i = zingchart.getLoader(t.id);
            if (!i) return;
            var a = zingchart.getGraph(i, t.graphid);
            for (var n in a.getAttributes()) "pie-sel-" === n.substring(0, 8) && a.setAttribute(n, null);
            zingchart.exec(e.id, "setseriesdata", {
              data: _
            }), window.setTimeout(function () {
              var t = zingchart.exec(e.id, "getobjectinfo", {
                  object: "node",
                  plotindex: 0,
                  nodeindex: 0
                }),
                i = {
                  id: "navpie_btnback",
                  x: t.x,
                  y: t.y,
                  text: "< Back",
                  anchor: "c",
                  cursor: "hand"
                };
              ZC._cp_(p, i), zingchart.exec(e.id, "addobject", {
                type: "label",
                data: i
              });
            }, 1);
          }
        }), zingchart.bind(e.id, "label_click", function (t) {
          if ("navpie_btnback" === t.label.id) {
            var i = zingchart.getLoader(t.id);
            if (!i) return;
            var a = zingchart.getGraph(i, t.graphid);
            for (var n in a.getAttributes()) "pie-sel-" === n.substring(0, 8) && a.setAttribute(n, null);
            zingchart.exec(e.id, "removeobject", {
              type: "label",
              id: "navpie_btnback"
            }), zingchart.exec(e.id, "setseriesdata", {
              data: h
            });
          }
        })) : r[ZC._[11]] = [].concat(s));
      } else {
        var B = 0,
          v = [];
        for (i = 0; i < h.length; i++) {
          if (v[i] = 0, h[i][ZC._[5]] && h[i][ZC._[5]].length) for (a = 0; a < h[i][ZC._[5]].length; a++) v[i] += ZC._a_(h[i][ZC._[5]][a]);
          B = ZC.BQ(B, v[i]);
        }
        Z > 0 && Z < 1 && (Z *= B), s = [].concat(h);
        var m = [],
          b = [];
        for (C = 1, i = h.length - 1; i >= 0; i--) if (v[i] < Z) {
          if (h[i][ZC._[5]] && h[i][ZC._[5]].length) for (a = 0; a < h[i][ZC._[5]].length; a++) m[a] = ZC._f_(m[a] || "0"), m[a] += h[i][ZC._[5]][a], b[a] = b[a] || "", b[a] += (h[i].text || "Item no." + C) + ":" + h[i][ZC._[5]][a] + "<br>";
          _.push(h[i]), h.splice(i, 1), C++;
        }
        if (m.length) if (C > 2) {
          for (a = 0; a < b.length; a++) b[a] = b[a].substring(0, b[a].length - 4);
          A = {
            values: m,
            detach: !1,
            "data-group": [1],
            "data-tt-text": b,
            "tooltip-text": "%data-tt-text"
          }, ZC._cp_(c, A), h.push(A), zingchart.bind(e.id, "plot_click", function (t) {
            if (t.xdata.group) {
              if (!zingchart.getLoader(t.id)) return;
              zingchart.exec(e.id, "setseriesdata", {
                data: _
              }), window.setTimeout(function () {
                var t = zingchart.exec(e.id, "getobjectinfo", {
                    object: "plotarea"
                  }),
                  i = {
                    id: "navxy_btnback",
                    x: t.x + t.width / 2,
                    y: t.y,
                    text: "< Back",
                    anchor: "c",
                    cursor: "hand"
                  };
                ZC._cp_(p, i), zingchart.exec(e.id, "addobject", {
                  type: "label",
                  data: i
                });
              }, 1);
            }
          }), zingchart.bind(e.id, "label_click", function (t) {
            if ("navxy_btnback" === t.label.id) {
              if (!zingchart.getLoader(t.id)) return;
              zingchart.exec(e.id, "removeobject", {
                type: "label",
                id: "navxy_btnback"
              }), zingchart.exec(e.id, "setseriesdata", {
                data: h
              });
            }
          });
        } else r[ZC._[11]] = [].concat(s);
      }
    }
    return t;
  });
}
export default zingchart;